
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefdae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefdae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
'use strict';

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $b9040d2deeb360f4$export$3ba232387fd5d6dd; }, function (v) { return $b9040d2deeb360f4$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$3ba232387fd5d6dd;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
'use strict';
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
function $b9040d2deeb360f4$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$3ba232387fd5d6dd = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $33s19.unstable_cancelCallback, $4d82739dd229d539$var$cc = $33s19.unstable_shouldYield, $4d82739dd229d539$var$dc = $33s19.unstable_requestPaint, $4d82739dd229d539$var$B = $33s19.unstable_now, $4d82739dd229d539$var$ec = $33s19.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $33s19.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $33s19.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $33s19.unstable_NormalPriority, $4d82739dd229d539$var$ic = $33s19.unstable_LowPriority, $4d82739dd229d539$var$jc = $33s19.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$Lg(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$Lg(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$Sg(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Tg(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Ug = $4d82739dd229d539$var$Og(!0), $4d82739dd229d539$var$Vg = $4d82739dd229d539$var$Og(!1), $4d82739dd229d539$var$Wg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Xg = null, $4d82739dd229d539$var$Yg = null, $4d82739dd229d539$var$Zg = null;
function $4d82739dd229d539$var$$g() {
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Xg = null;
}
function $4d82739dd229d539$var$ah(a) {
    var b = $4d82739dd229d539$var$Wg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$ch(a, b) {
    $4d82739dd229d539$var$Xg = a;
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$dh = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$eh(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Yg) {
            if (null === $4d82739dd229d539$var$Xg) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Yg = a;
            $4d82739dd229d539$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Yg.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$fh = null;
function $4d82739dd229d539$var$gh(a) {
    null === $4d82739dd229d539$var$fh ? $4d82739dd229d539$var$fh = [
        a
    ] : $4d82739dd229d539$var$fh.push(a);
}
function $4d82739dd229d539$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$ih(a, d);
}
function $4d82739dd229d539$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$jh = !1;
function $4d82739dd229d539$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$ih(a, c);
}
function $4d82739dd229d539$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$th = {}, $4d82739dd229d539$var$uh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$vh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$wh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th);
function $4d82739dd229d539$var$xh(a) {
    if (a === $4d82739dd229d539$var$th) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$yh(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$wh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, $4d82739dd229d539$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, b);
}
function $4d82739dd229d539$var$zh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$vh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$wh);
}
function $4d82739dd229d539$var$Ah(a) {
    $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
    var b = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, c));
}
function $4d82739dd229d539$var$Bh(a) {
    $4d82739dd229d539$var$vh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$uh), $4d82739dd229d539$var$E($4d82739dd229d539$var$vh));
}
var $4d82739dd229d539$var$L = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Dh = [];
function $4d82739dd229d539$var$Eh() {
    for(var a = 0; a < $4d82739dd229d539$var$Dh.length; a++)$4d82739dd229d539$var$Dh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Dh.length = 0;
}
var $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Hh = 0, $4d82739dd229d539$var$M = null, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$Ih = !1, $4d82739dd229d539$var$Jh = !1, $4d82739dd229d539$var$Kh = 0, $4d82739dd229d539$var$Lh = 0;
function $4d82739dd229d539$var$P() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Nh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Hh = f;
    $4d82739dd229d539$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Fh.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Oh : $4d82739dd229d539$var$Ph;
    a = c(d, e);
    if ($4d82739dd229d539$var$Jh) {
        f = 0;
        do {
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Qh;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Jh);
    }
    $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
    b = null !== $4d82739dd229d539$var$N && null !== $4d82739dd229d539$var$N.next;
    $4d82739dd229d539$var$Hh = 0;
    $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
    $4d82739dd229d539$var$Ih = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$Sh() {
    var a = 0 !== $4d82739dd229d539$var$Kh;
    $4d82739dd229d539$var$Kh = 0;
    return a;
}
function $4d82739dd229d539$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Uh() {
    if (null === $4d82739dd229d539$var$N) {
        var a = $4d82739dd229d539$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$N.next;
    var b = null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState : $4d82739dd229d539$var$O.next;
    if (null !== b) $4d82739dd229d539$var$O = b, $4d82739dd229d539$var$N = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$N = a;
        a = {
            memoizedState: $4d82739dd229d539$var$N.memoizedState,
            baseState: $4d82739dd229d539$var$N.baseState,
            baseQueue: $4d82739dd229d539$var$N.baseQueue,
            queue: $4d82739dd229d539$var$N.queue,
            next: null
        };
        null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    }
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$Wh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$M.lanes |= m;
                $4d82739dd229d539$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$M.lanes |= f, $4d82739dd229d539$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$Xh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$Yh() {}
function $4d82739dd229d539$var$Zh(a, b) {
    var c = $4d82739dd229d539$var$M, d = $4d82739dd229d539$var$Uh(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$dh = !0);
    d = d.queue;
    $4d82739dd229d539$var$$h($4d82739dd229d539$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$O && $4d82739dd229d539$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
}
function $4d82739dd229d539$var$ai(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
    });
}
function $4d82739dd229d539$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$ih(a, 1);
    null !== b && $4d82739dd229d539$var$gi(b, a, 1, -1);
}
function $4d82739dd229d539$var$hi(a) {
    var b = $4d82739dd229d539$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ii.bind(null, $4d82739dd229d539$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$ji() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$ki(a, b, c, d) {
    var e = $4d82739dd229d539$var$Th();
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    var e = $4d82739dd229d539$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$N) {
        var g = $4d82739dd229d539$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Mh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$bi(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, f, d);
}
function $4d82739dd229d539$var$mi(a, b) {
    return $4d82739dd229d539$var$ki(8390656, 8, a, b);
}
function $4d82739dd229d539$var$$h(a, b) {
    return $4d82739dd229d539$var$li(2048, 8, a, b);
}
function $4d82739dd229d539$var$ni(a, b) {
    return $4d82739dd229d539$var$li(4, 2, a, b);
}
function $4d82739dd229d539$var$oi(a, b) {
    return $4d82739dd229d539$var$li(4, 4, a, b);
}
function $4d82739dd229d539$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$li(4, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$ri() {}
function $4d82739dd229d539$var$si(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ti(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ui(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Hh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$dh = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$M.lanes |= c, $4d82739dd229d539$var$rh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$vi(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Gh.transition;
    $4d82739dd229d539$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Gh.transition = d;
    }
}
function $4d82739dd229d539$var$wi() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$xi(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, c);
    else if (c = $4d82739dd229d539$var$hh(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$R();
        $4d82739dd229d539$var$gi(c, a, d, e);
        $4d82739dd229d539$var$Bi(c, b, d);
    }
}
function $4d82739dd229d539$var$ii(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$hh(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$R(), $4d82739dd229d539$var$gi(c, a, d, e), $4d82739dd229d539$var$Bi(c, b, d));
    }
}
function $4d82739dd229d539$var$zi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$M || null !== b && b === $4d82739dd229d539$var$M;
}
function $4d82739dd229d539$var$Ai(a, b) {
    $4d82739dd229d539$var$Jh = $4d82739dd229d539$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$Rh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$P,
    useContext: $4d82739dd229d539$var$P,
    useEffect: $4d82739dd229d539$var$P,
    useImperativeHandle: $4d82739dd229d539$var$P,
    useInsertionEffect: $4d82739dd229d539$var$P,
    useLayoutEffect: $4d82739dd229d539$var$P,
    useMemo: $4d82739dd229d539$var$P,
    useReducer: $4d82739dd229d539$var$P,
    useRef: $4d82739dd229d539$var$P,
    useState: $4d82739dd229d539$var$P,
    useDebugValue: $4d82739dd229d539$var$P,
    useDeferredValue: $4d82739dd229d539$var$P,
    useTransition: $4d82739dd229d539$var$P,
    useMutableSource: $4d82739dd229d539$var$P,
    useSyncExternalStore: $4d82739dd229d539$var$P,
    useId: $4d82739dd229d539$var$P,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Oh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ki(4194308, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$xi.bind(null, $4d82739dd229d539$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$hi,
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$hi(!1), b = a[0];
        a = $4d82739dd229d539$var$vi.bind(null, a[1]);
        $4d82739dd229d539$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$M, e = $4d82739dd229d539$var$Th();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$mi($4d82739dd229d539$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$Th(), b = $4d82739dd229d539$var$Q.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Ph = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Wh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Qh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Xh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return null === $4d82739dd229d539$var$N ? b.memoizedState = a : $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $4d82739dd229d539$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$R(), d = $4d82739dd229d539$var$yi(a), e = $4d82739dd229d539$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$nh(a, e, d);
        null !== b && ($4d82739dd229d539$var$gi(b, a, d, c), $4d82739dd229d539$var$oh(b, a, d));
    }
};
function $4d82739dd229d539$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$eh(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $4d82739dd229d539$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$eh(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$Ei.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Ni(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Oi || ($4d82739dd229d539$var$Oi = !0, $4d82739dd229d539$var$Pi = d);
        $4d82739dd229d539$var$Li(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Qi(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Li(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Ri ? $4d82739dd229d539$var$Ri = new Set([
            this
        ]) : $4d82739dd229d539$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$mh(-1, 1), b.tag = 2, $4d82739dd229d539$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Wi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$dh = !1;
function $4d82739dd229d539$var$Xi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Vg(b, null, c, d) : $4d82739dd229d539$var$Ug(b, a.child, c, d);
}
function $4d82739dd229d539$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$ch(b, e);
    d = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$bj(a, b, f, d, e);
        a = $4d82739dd229d539$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$dh = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$Zi(a, b, e);
        }
    }
    return $4d82739dd229d539$var$cj(a, b, c, d, e);
}
function $4d82739dd229d539$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj);
            $4d82739dd229d539$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= d;
    $4d82739dd229d539$var$Xi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$ch(b, e);
    c = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$ch(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$ij(a, b), $4d82739dd229d539$var$Gi(b, c, d), $4d82739dd229d539$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$eh(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$Hi(b, g, d, l);
        $4d82739dd229d539$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof m && ($4d82739dd229d539$var$Di(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$eh(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$Hi(b, g, d, k);
        $4d82739dd229d539$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof y && ($4d82739dd229d539$var$Di(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$jj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$jj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$Zi(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Ug(b, a.child, null, f), b.child = $4d82739dd229d539$var$Ug(b, null, h, f)) : $4d82739dd229d539$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$yh(a, b.containerInfo);
}
function $4d82739dd229d539$var$lj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Xi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$oj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$pj(g, d, 0, null), a = $4d82739dd229d539$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$nj(c), b.memoizedState = $4d82739dd229d539$var$mj, a) : $4d82739dd229d539$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$Pg(h, f) : (f = $4d82739dd229d539$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$qj(a, b) {
    b = $4d82739dd229d539$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$sj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Ug(b, a.child, null, c);
    a = $4d82739dd229d539$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$nj(g);
        b.memoizedState = $4d82739dd229d539$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Ki(f, d, void 0);
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$dh || h) {
        d = $4d82739dd229d539$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$ih(a, e), $4d82739dd229d539$var$gi(d, a, e, -1));
        }
        $4d82739dd229d539$var$tj();
        d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$bh(a.return, b, c);
}
function $4d82739dd229d539$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Xi(a, b, d.children, c);
    d = $4d82739dd229d539$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$vj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$kj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Ah(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$oj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
                a = $4d82739dd229d539$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$dj(a, b, c);
    }
    return $4d82739dd229d539$var$Zi(a, b, c);
}
var $4d82739dd229d539$var$zj, $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj;
$4d82739dd229d539$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Aj = function() {};
$4d82739dd229d539$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Dj(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$zh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Aj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Bh(b);
            var e = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
                $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$L.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$Aj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Dj(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Gj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$L.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$fj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Ij(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Bh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$L), null;
        case 4:
            return $4d82739dd229d539$var$zh(), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Jj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Nj = !1;
function $4d82739dd229d539$var$Oj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Nj;
    $4d82739dd229d539$var$Nj = !1;
    return n;
}
function $4d82739dd229d539$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Vj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Vj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Xj = !1;
function $4d82739dd229d539$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$Zj(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$Zj(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Lj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Xj = !0;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Mj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Yj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Yj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Yj(a, b, c);
    }
}
function $4d82739dd229d539$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Kj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Xj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$Zj(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$dk(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Pj(3, a, a.return), $4d82739dd229d539$var$Qj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Pj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            break;
        case 13:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$fk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$ek(a);
    }
}
function $4d82739dd229d539$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$hk(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$ik(a, b, c);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Jj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Jj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$jk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$jk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$ik(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Jj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$kk(a, b, c);
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Rj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$gk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$jk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Qj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$lk = Math.ceil, $4d82739dd229d539$var$mk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$fj = 0, $4d82739dd229d539$var$ej = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$pk = null, $4d82739dd229d539$var$rh = 0, $4d82739dd229d539$var$qk = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = null, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$fk = 0, $4d82739dd229d539$var$Gj = Infinity, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Oi = !1, $4d82739dd229d539$var$Pi = null, $4d82739dd229d539$var$Ri = null, $4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = null, $4d82739dd229d539$var$xk = 0, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, $4d82739dd229d539$var$Ak = -1, $4d82739dd229d539$var$Bk = 0;
function $4d82739dd229d539$var$R() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$Ak : $4d82739dd229d539$var$Ak = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Bk && ($4d82739dd229d539$var$Bk = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Bk;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$gi(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$yk) throw $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$Q) a === $4d82739dd229d539$var$Q && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$qk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Ck(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Dk(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Dk(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Ek.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Ek.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Fk(c, $4d82739dd229d539$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Gk(a, b) {
    $4d82739dd229d539$var$Ak = -1;
    $4d82739dd229d539$var$Bk = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Hk() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Ik(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Jk();
        if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Kk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Lk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Mk(a, h);
        }
        $4d82739dd229d539$var$$g();
        $4d82739dd229d539$var$mk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Nk(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Ok(e) && (b = $4d82739dd229d539$var$Ik(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Nk(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$fk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Gk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Nk(a, b) {
    var c = $4d82739dd229d539$var$sk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Kk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Ik(a, b);
    2 !== a && (b = $4d82739dd229d539$var$tk, $4d82739dd229d539$var$tk = c, null !== b && $4d82739dd229d539$var$Fj(b));
    return a;
}
function $4d82739dd229d539$var$Fj(a) {
    null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = a : $4d82739dd229d539$var$tk.push.apply($4d82739dd229d539$var$tk, a);
}
function $4d82739dd229d539$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Ck(a, b) {
    b &= ~$4d82739dd229d539$var$rk;
    b &= ~$4d82739dd229d539$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Ek(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Nk(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, b), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Qk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Rk(a) {
    null !== $4d82739dd229d539$var$wk && 0 === $4d82739dd229d539$var$wk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$ok.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$ok.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Hj() {
    $4d82739dd229d539$var$fj = $4d82739dd229d539$var$ej.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$ej);
}
function $4d82739dd229d539$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$zh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Eh();
                break;
            case 5:
                $4d82739dd229d539$var$Bh(d);
                break;
            case 4:
                $4d82739dd229d539$var$zh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 10:
                $4d82739dd229d539$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Hj();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$Q = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$Pg(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$fj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$pk = null;
    $4d82739dd229d539$var$rk = $4d82739dd229d539$var$qk = $4d82739dd229d539$var$rh = 0;
    $4d82739dd229d539$var$tk = $4d82739dd229d539$var$sk = null;
    if (null !== $4d82739dd229d539$var$fh) {
        for(b = 0; b < $4d82739dd229d539$var$fh.length; b++)if (c = $4d82739dd229d539$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$fh = null;
    }
    return a;
}
function $4d82739dd229d539$var$Mk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$$g();
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
            if ($4d82739dd229d539$var$Ih) {
                for(var d = $4d82739dd229d539$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Ih = !1;
            }
            $4d82739dd229d539$var$Hh = 0;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            $4d82739dd229d539$var$nk.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$pk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Si(f, l, b);
                            $4d82739dd229d539$var$tj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Vi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ji(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$sk ? $4d82739dd229d539$var$sk = [
                    f
                ] : $4d82739dd229d539$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Ni(f, k, b);
                            $4d82739dd229d539$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Qi(f, h, b);
                                $4d82739dd229d539$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Sk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Jk() {
    var a = $4d82739dd229d539$var$mk.current;
    $4d82739dd229d539$var$mk.current = $4d82739dd229d539$var$Rh;
    return null === a ? $4d82739dd229d539$var$Rh : a;
}
function $4d82739dd229d539$var$tj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$Q || 0 === ($4d82739dd229d539$var$rh & 268435455) && 0 === ($4d82739dd229d539$var$qk & 268435455) || $4d82739dd229d539$var$Ck($4d82739dd229d539$var$Q, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Ik(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Jk();
    if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Kk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Tk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Mk(a, e);
    }
    $4d82739dd229d539$var$$g();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$mk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$Q = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Tk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Lk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Uk(a) {
    var b = $4d82739dd229d539$var$Vk(a.alternate, a, $4d82739dd229d539$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Sk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$nk.current = null;
}
function $4d82739dd229d539$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Ej(c, b, $4d82739dd229d539$var$fj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Pk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$ok.transition;
    try {
        $4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Wk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$ok.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Wk(a, b, c, d) {
    do $4d82739dd229d539$var$Hk();
    while (null !== $4d82739dd229d539$var$wk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$Q && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$vk || ($4d82739dd229d539$var$vk = !0, $4d82739dd229d539$var$Fk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$ok.transition;
        $4d82739dd229d539$var$ok.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$nk.current = null;
        $4d82739dd229d539$var$Oj(a, c);
        $4d82739dd229d539$var$dk(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$hk(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$ok.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$vk && ($4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = a, $4d82739dd229d539$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Ri = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Oi) throw $4d82739dd229d539$var$Oi = !1, a = $4d82739dd229d539$var$Pi, $4d82739dd229d539$var$Pi = null, a;
    0 !== ($4d82739dd229d539$var$xk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$zk ? $4d82739dd229d539$var$yk++ : ($4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = a) : $4d82739dd229d539$var$yk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Hk() {
    if (null !== $4d82739dd229d539$var$wk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$xk), b = $4d82739dd229d539$var$ok.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$ok.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$wk) var d = !1;
            else {
                a = $4d82739dd229d539$var$wk;
                $4d82739dd229d539$var$wk = null;
                $4d82739dd229d539$var$xk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Sj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Qj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$ok.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Xk(a, b, c) {
    b = $4d82739dd229d539$var$Ji(c, b);
    b = $4d82739dd229d539$var$Ni(a, b, 1);
    a = $4d82739dd229d539$var$nh(a, b, 1);
    b = $4d82739dd229d539$var$R();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Dk(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(d))) {
                a = $4d82739dd229d539$var$Ji(c, a);
                a = $4d82739dd229d539$var$Qi(b, a, 1);
                b = $4d82739dd229d539$var$nh(b, a, 1);
                a = $4d82739dd229d539$var$R();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$Q === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$fk ? $4d82739dd229d539$var$Kk(a, 0) : $4d82739dd229d539$var$rk |= c);
    $4d82739dd229d539$var$Dk(a, b);
}
function $4d82739dd229d539$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$R();
    a = $4d82739dd229d539$var$ih(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Dk(a, c));
}
function $4d82739dd229d539$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Yk(a, c);
}
function $4d82739dd229d539$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Yk(a, c);
}
var $4d82739dd229d539$var$Vk;
$4d82739dd229d539$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$yj(a, b, c);
            $4d82739dd229d539$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$ij(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$ch(b, c);
            e = $4d82739dd229d539$var$Nh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$kh(b), e.updater = $4d82739dd229d539$var$Ei, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$Ii(b, d, a, c), b = $4d82739dd229d539$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$Zk(d);
                a = $4d82739dd229d539$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$$i(null, b, d, $4d82739dd229d539$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$kj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$lh(a, b);
                $4d82739dd229d539$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$Zi(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Ah(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$gj(a, b), $4d82739dd229d539$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$oj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Ug(b, null, d, c) : $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$Yi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$ch(b, c), e = $4d82739dd229d539$var$eh(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Ci(d, b.pendingProps), e = $4d82739dd229d539$var$Ci(d.type, e), $4d82739dd229d539$var$$i(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$ij(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$ch(b, c), $4d82739dd229d539$var$Gi(b, d, e), $4d82739dd229d539$var$Ii(b, d, e, c), $4d82739dd229d539$var$jj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$xj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$dj(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Fk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$$k(a, b, c, d);
}
function $4d82739dd229d539$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$Zk(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Tg(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Tg(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$pj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$Qg(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$kh(f);
    return a;
}
function $4d82739dd229d539$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$dl(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$el(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$dl(null);
    c = a.current;
    d = $4d82739dd229d539$var$R();
    e = $4d82739dd229d539$var$yi(c);
    f = $4d82739dd229d539$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$nh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Dk(a, d);
    return a;
}
function $4d82739dd229d539$var$fl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$R(), g = $4d82739dd229d539$var$yi(e);
    c = $4d82739dd229d539$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$nh(e, b, g);
    null !== a && ($4d82739dd229d539$var$gi(a, e, g, f), $4d82739dd229d539$var$oh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    $4d82739dd229d539$var$hl(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$hl(a, b);
}
function $4d82739dd229d539$var$jl() {
    return null;
}
var $4d82739dd229d539$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ll(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.render = $4d82739dd229d539$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$fl(a, b, null, null);
};
$4d82739dd229d539$var$ml.prototype.unmount = $4d82739dd229d539$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Rk(function() {
            $4d82739dd229d539$var$fl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$pl() {}
function $4d82739dd229d539$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$gl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$el(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$pl);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$gl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$bl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$pl);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$fl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$gl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$fl(b, g, a, e);
    } else g = $4d82739dd229d539$var$ql(c, b, a, e, d);
    return $4d82739dd229d539$var$gl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Dk(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Rk(function() {
                var b = $4d82739dd229d539$var$ih(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$R();
                    $4d82739dd229d539$var$gi(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$il(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$ih(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$il(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$yi(a), c = $4d82739dd229d539$var$ih(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(c, a, b, d);
        }
        $4d82739dd229d539$var$il(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Rk;
var $4d82739dd229d539$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Qk
    ]
}, $4d82739dd229d539$var$tl = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$ul = {
    bundleType: $4d82739dd229d539$var$tl.bundleType,
    version: $4d82739dd229d539$var$tl.version,
    rendererPackageName: $4d82739dd229d539$var$tl.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$tl.findFiberByHostInstance || $4d82739dd229d539$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$vl.isDisabled && $4d82739dd229d539$var$vl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$vl.inject($4d82739dd229d539$var$ul), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$vl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$sl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$nl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$cl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ll(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Rk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$ol(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$rl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$cf845f2c119da08a;
'use strict';
function $749777fefd570b40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $749777fefd570b40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $749777fefd570b40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $749777fefd570b40$var$g(C, c)) n < e && 0 > $749777fefd570b40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $749777fefd570b40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $749777fefd570b40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
var $749777fefd570b40$var$r = [], $749777fefd570b40$var$t = [], $749777fefd570b40$var$u = 1, $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = 3, $749777fefd570b40$var$z = !1, $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = !1, $749777fefd570b40$var$D = "function" === typeof setTimeout ? setTimeout : null, $749777fefd570b40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $749777fefd570b40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $749777fefd570b40$var$G(a) {
    for(var b = $749777fefd570b40$var$h($749777fefd570b40$var$t); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$k($749777fefd570b40$var$t);
        else if (b.startTime <= a) $749777fefd570b40$var$k($749777fefd570b40$var$t), b.sortIndex = b.expirationTime, $749777fefd570b40$var$f($749777fefd570b40$var$r, b);
        else break;
        b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
    }
}
function $749777fefd570b40$var$H(a) {
    $749777fefd570b40$var$B = !1;
    $749777fefd570b40$var$G(a);
    if (!$749777fefd570b40$var$A) {
        if (null !== $749777fefd570b40$var$h($749777fefd570b40$var$r)) $749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J);
        else {
            var b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== b && $749777fefd570b40$var$K($749777fefd570b40$var$H, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$J(a, b) {
    $749777fefd570b40$var$A = !1;
    $749777fefd570b40$var$B && ($749777fefd570b40$var$B = !1, $749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1);
    $749777fefd570b40$var$z = !0;
    var c = $749777fefd570b40$var$y;
    try {
        $749777fefd570b40$var$G(b);
        for($749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r); null !== $749777fefd570b40$var$v && (!($749777fefd570b40$var$v.expirationTime > b) || a && !$749777fefd570b40$var$M());){
            var d = $749777fefd570b40$var$v.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$v.callback = null;
                $749777fefd570b40$var$y = $749777fefd570b40$var$v.priorityLevel;
                var e = d($749777fefd570b40$var$v.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$v.callback = e : $749777fefd570b40$var$v === $749777fefd570b40$var$h($749777fefd570b40$var$r) && $749777fefd570b40$var$k($749777fefd570b40$var$r);
                $749777fefd570b40$var$G(b);
            } else $749777fefd570b40$var$k($749777fefd570b40$var$r);
            $749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r);
        }
        if (null !== $749777fefd570b40$var$v) var w = !0;
        else {
            var m = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== m && $749777fefd570b40$var$K($749777fefd570b40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = c, $749777fefd570b40$var$z = !1;
    }
}
var $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$L = -1, $749777fefd570b40$var$P = 5, $749777fefd570b40$var$Q = -1;
function $749777fefd570b40$var$M() {
    return $749777fefd570b40$export$c4744153514ff05d() - $749777fefd570b40$var$Q < $749777fefd570b40$var$P ? !1 : !0;
}
function $749777fefd570b40$var$R() {
    if (null !== $749777fefd570b40$var$O) {
        var a = $749777fefd570b40$export$c4744153514ff05d();
        $749777fefd570b40$var$Q = a;
        var b = !0;
        try {
            b = $749777fefd570b40$var$O(!0, a);
        } finally{
            b ? $749777fefd570b40$var$S() : ($749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null);
        }
    } else $749777fefd570b40$var$N = !1;
}
var $749777fefd570b40$var$S;
if ("function" === typeof $749777fefd570b40$var$F) $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$F($749777fefd570b40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = $749777fefd570b40$var$R;
    $749777fefd570b40$var$S = function() {
        $749777fefd570b40$var$U.postMessage(null);
    };
} else $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$D($749777fefd570b40$var$R, 0);
};
function $749777fefd570b40$var$I(a) {
    $749777fefd570b40$var$O = a;
    $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$S());
}
function $749777fefd570b40$var$K(a, b) {
    $749777fefd570b40$var$L = $749777fefd570b40$var$D(function() {
        a($749777fefd570b40$export$c4744153514ff05d());
    }, b);
}
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J));
};
$749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$y;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$h($749777fefd570b40$var$r);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$y;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = function() {};
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$f($749777fefd570b40$var$t, a), null === $749777fefd570b40$var$h($749777fefd570b40$var$r) && a === $749777fefd570b40$var$h($749777fefd570b40$var$t) && ($749777fefd570b40$var$B ? ($749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1) : $749777fefd570b40$var$B = !0, $749777fefd570b40$var$K($749777fefd570b40$var$H, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$f($749777fefd570b40$var$r, a), $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J)));
    return a;
};
$749777fefd570b40$export$b5836b71941fa3ed = $749777fefd570b40$var$M;
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$y;
    return function() {
        var c = $749777fefd570b40$var$y;
        $749777fefd570b40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$y = c;
        }
    };
};

});



parcelRegister("i5uoL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $d2b0461a7763531f$export$bf730a2d8bf68b42; }, function (v) { return $d2b0461a7763531f$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2b0461a7763531f$export$bf730a2d8bf68b42;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
function $d2b0461a7763531f$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2b0461a7763531f$var$objectIs = "function" === typeof Object.is ? Object.is : $d2b0461a7763531f$var$is, $d2b0461a7763531f$var$useSyncExternalStore = $7fPBF.useSyncExternalStore, $d2b0461a7763531f$var$useRef = $7fPBF.useRef, $d2b0461a7763531f$var$useEffect = $7fPBF.useEffect, $d2b0461a7763531f$var$useMemo = $7fPBF.useMemo, $d2b0461a7763531f$var$useDebugValue = $7fPBF.useDebugValue;
$d2b0461a7763531f$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2b0461a7763531f$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2b0461a7763531f$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2b0461a7763531f$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2b0461a7763531f$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2b0461a7763531f$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2b0461a7763531f$var$useDebugValue(value);
    return value;
};

});

parcelRegister("4qQ7b", function(module, exports) {
'use strict';
var $33a204135f6b8445$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $f2BFz = parcelRequire("f2BFz");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $33a204135f6b8445$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $33a204135f6b8445$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $f2BFz();
};

});
parcelRegister("f2BFz", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("8MJe2", function(module, exports) {

var $jHo6y = parcelRequire("jHo6y");
function $6655e33f0d2c88e7$var$_defineProperty(e, r, t) {
    return (r = $jHo6y(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $6655e33f0d2c88e7$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jHo6y", function(module, exports) {

var $bRUy3 = parcelRequire("bRUy3");
var $e574bb2d4ac0a9b8$var$_typeof = $bRUy3.default;

var $9GPcj = parcelRequire("9GPcj");
function $e574bb2d4ac0a9b8$var$toPropertyKey(t) {
    var i = $9GPcj(t, "string");
    return "symbol" == $e574bb2d4ac0a9b8$var$_typeof(i) ? i : i + "";
}
module.exports = $e574bb2d4ac0a9b8$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bRUy3", function(module, exports) {
function $8a40824683152bd6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $8a40824683152bd6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8a40824683152bd6$var$_typeof(o);
}
module.exports = $8a40824683152bd6$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9GPcj", function(module, exports) {

var $bRUy3 = parcelRequire("bRUy3");
var $70dfc0196094649e$var$_typeof = $bRUy3.default;
function $70dfc0196094649e$var$toPrimitive(t, r) {
    if ("object" != $70dfc0196094649e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $70dfc0196094649e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $70dfc0196094649e$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("dxrob", function(module, exports) {
function $9db39a503775575c$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $9db39a503775575c$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6CtYH", function(module, exports) {

var $jHo6y = parcelRequire("jHo6y");
function $4d1d8bace1bc5f55$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $jHo6y(o.key), o);
    }
}
function $4d1d8bace1bc5f55$var$_createClass(e, r, t) {
    return r && $4d1d8bace1bc5f55$var$_defineProperties(e.prototype, r), t && $4d1d8bace1bc5f55$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $4d1d8bace1bc5f55$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iKdEz", function(module, exports) {

var $hJ0zT = parcelRequire("hJ0zT");

var $2Pbyd = parcelRequire("2Pbyd");

var $5ng8R = parcelRequire("5ng8R");

var $gPUQJ = parcelRequire("gPUQJ");
function $da571d235d718dda$var$_slicedToArray(r, e) {
    return $hJ0zT(r) || $2Pbyd(r, e) || $5ng8R(r, e) || $gPUQJ();
}
module.exports = $da571d235d718dda$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hJ0zT", function(module, exports) {
function $ce77166c8438e964$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $ce77166c8438e964$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2Pbyd", function(module, exports) {
function $20e94df54b7e2c18$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $20e94df54b7e2c18$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5ng8R", function(module, exports) {

var $hOZt4 = parcelRequire("hOZt4");
function $3e9b9f2b208dfc3f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $hOZt4(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $hOZt4(r, a) : void 0;
    }
}
module.exports = $3e9b9f2b208dfc3f$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hOZt4", function(module, exports) {
function $cf96c9667eae972c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $cf96c9667eae972c$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gPUQJ", function(module, exports) {
function $c41d81e3d1c59d7f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $c41d81e3d1c59d7f$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("f8tK9", function(module, exports) {

var $bRUy3 = parcelRequire("bRUy3");
var $b04eaccc43f5c61c$var$_typeof = $bRUy3.default;
function $b04eaccc43f5c61c$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ 
    module.exports = $b04eaccc43f5c61c$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return r;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
    function c(t, r, e, n) {
        return Object.defineProperty(t, r, {
            value: e,
            enumerable: !n,
            configurable: !n,
            writable: !n
        });
    }
    try {
        c({}, "");
    } catch (t) {
        c = function c(t, r, e) {
            return t[r] = e;
        };
    }
    function h(r, e, n, o) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype);
        return c(a, "_invoke", function(r, e, n) {
            var o = 1;
            return function(i, a) {
                if (3 === o) throw Error("Generator is already running");
                if (4 === o) {
                    if ("throw" === i) throw a;
                    return {
                        value: t,
                        done: !0
                    };
                }
                for(n.method = i, n.arg = a;;){
                    var u = n.delegate;
                    if (u) {
                        var c = d(u, n);
                        if (c) {
                            if (c === f) continue;
                            return c;
                        }
                    }
                    if ("next" === n.method) n.sent = n._sent = n.arg;
                    else if ("throw" === n.method) {
                        if (1 === o) throw o = 4, n.arg;
                        n.dispatchException(n.arg);
                    } else "return" === n.method && n.abrupt("return", n.arg);
                    o = 3;
                    var h = s(r, e, n);
                    if ("normal" === h.type) {
                        if (o = n.done ? 4 : 2, h.arg === f) continue;
                        return {
                            value: h.arg,
                            done: n.done
                        };
                    }
                    "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg);
                }
            };
        }(r, n, new Context(o || [])), !0), a;
    }
    function s(t, r, e) {
        try {
            return {
                type: "normal",
                arg: t.call(r, e)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    r.wrap = h;
    var f = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var l = {};
    c(l, i, function() {
        return this;
    });
    var p = Object.getPrototypeOf, y = p && p(p(x([])));
    y && y !== e && n.call(y, i) && (l = y);
    var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l);
    function g(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(r) {
            c(t, r, function(t) {
                return this._invoke(r, t);
            });
        });
    }
    function AsyncIterator(t, r) {
        function e(o, i, a, u) {
            var c = s(t[o], t, i);
            if ("throw" !== c.type) {
                var h = c.arg, f = h.value;
                return f && "object" == $b04eaccc43f5c61c$var$_typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function(t) {
                    e("next", t, a, u);
                }, function(t) {
                    e("throw", t, a, u);
                }) : r.resolve(f).then(function(t) {
                    h.value = t, a(h);
                }, function(t) {
                    return e("throw", t, a, u);
                });
            }
            u(c.arg);
        }
        var o;
        c(this, "_invoke", function(t, n) {
            function i() {
                return new r(function(r, o) {
                    e(t, n, r, o);
                });
            }
            return o = o ? o.then(i, i) : i();
        }, !0);
    }
    function d(r, e) {
        var n = e.method, o = r.i[n];
        if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f;
        var i = s(o, r.i, e.arg);
        if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f;
        var a = i.arg;
        return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
    }
    function w(t) {
        this.tryEntries.push(t);
    }
    function m(r) {
        var e = r[4] || {};
        e.type = "normal", e.arg = t, r[4] = e;
    }
    function Context(t) {
        this.tryEntries = [
            [
                -1
            ]
        ], t.forEach(w, this), this.reset(!0);
    }
    function x(r) {
        if (null != r) {
            var e = r[i];
            if (e) return e.call(r);
            if ("function" == typeof r.next) return r;
            if (!isNaN(r.length)) {
                var o = -1, a = function e() {
                    for(; ++o < r.length;)if (n.call(r, o)) return e.value = r[o], e.done = !1, e;
                    return e.value = t, e.done = !0, e;
                };
                return a.next = a;
            }
        }
        throw new TypeError($b04eaccc43f5c61c$var$_typeof(r) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function(t) {
        var r = "function" == typeof t && t.constructor;
        return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name));
    }, r.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t;
    }, r.awrap = function(t) {
        return {
            __await: t
        };
    }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function() {
        return this;
    }), r.AsyncIterator = AsyncIterator, r.async = function(t, e, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(h(t, e, n, o), i);
        return r.isGeneratorFunction(e) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, g(v), c(v, u, "Generator"), c(v, i, function() {
        return this;
    }), c(v, "toString", function() {
        return "[object Generator]";
    }), r.keys = function(t) {
        var r = Object(t), e = [];
        for(var n in r)e.unshift(n);
        return function t() {
            for(; e.length;)if ((n = e.pop()) in r) return t.value = n, t.done = !1, t;
            return t.done = !0, t;
        };
    }, r.values = x, Context.prototype = {
        constructor: Context,
        reset: function reset(r) {
            if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for(var e in this)"t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0][4];
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(r) {
            if (this.done) throw r;
            var e = this;
            function n(t) {
                a.type = "throw", a.arg = r, e.next = t;
            }
            for(var o = e.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2];
                if (-1 === i[0]) return n("end"), !1;
                if (!c && !h) throw Error("try statement without catch or finally");
                if (null != i[0] && i[0] <= u) {
                    if (u < c) return this.method = "next", this.arg = t, n(c), !0;
                    if (u < h) return n(h), !1;
                }
            }
        },
        abrupt: function abrupt(t, r) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var n = this.tryEntries[e];
                if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) {
                    var o = n;
                    break;
                }
            }
            o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null);
            var i = o ? o[4] : {};
            return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i);
        },
        complete: function complete(t, r) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f;
        },
        finish: function finish(t) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var e = this.tryEntries[r];
                if (e[2] === t) return this.complete(e[4], e[3]), m(e), f;
            }
        },
        "catch": function _catch(t) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var e = this.tryEntries[r];
                if (e[0] === t) {
                    var n = e[4];
                    if ("throw" === n.type) {
                        var o = n.arg;
                        m(e);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(r, e, n) {
            return this.delegate = {
                i: x(r),
                r: e,
                n: n
            }, "next" === this.method && (this.arg = t), f;
        }
    }, r;
}
module.exports = $b04eaccc43f5c61c$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2CTsY", function(module, exports) {
"use strict";
var $1e9a27dc53c779dd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1e9a27dc53c779dd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1e9a27dc53c779dd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("kDWyI")).Diagnostics;
    }
});

var $lo1Ts = parcelRequire("lo1Ts");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $lo1Ts.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("1OvFT")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("hlXcM")).Storage;
    }
});

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("bYNP6")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("bQcYR")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("np6uq")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("FZpp0")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("kDWyI")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("QszgO")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("amoop")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("fPBrb")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("ay03q")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("75X6G")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("dKupR")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("1OvFT")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("3atRr")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("dK79n")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("fieiX")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("3MDN6")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("XhJBy")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("jXGyN")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("7OAfu")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("TtqbT")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("c3GX9")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("gW65n")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("3kqeB")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("hVWUO")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("gh2LQ")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("b2JnU")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("hZDgH")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("esLeu")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("2KqEX")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("kI8Ae")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("dYlmk")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("hlXcM")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("jhVkG")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("7QLuf")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("SiHEi")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("9zTSD")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("cHtSK")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("2PmEk")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("cKd83")), module.exports);
Object.assign((0, (parcelRequire("bYNP6"))._getStatsigGlobal)(), {
    Log: (parcelRequire("1OvFT")).Log,
    SDK_VERSION: (parcelRequire("b2JnU")).SDK_VERSION
});

});
parcelRegister("bYNP6", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $8b8bf22bae3e1f18$var$_a, $8b8bf22bae3e1f18$var$_b, $8b8bf22bae3e1f18$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $1OvFT = parcelRequire("1OvFT");
const $8b8bf22bae3e1f18$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $8b8bf22bae3e1f18$var$statsigGlobal;
    } catch (e) {
        return $8b8bf22bae3e1f18$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $8b8bf22bae3e1f18$var$_getStatsigGlobal;
const $8b8bf22bae3e1f18$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $8b8bf22bae3e1f18$var$_getStatsigGlobalFlag;
const $8b8bf22bae3e1f18$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $1OvFT.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $8b8bf22bae3e1f18$var$_getInstance;
const $8b8bf22bae3e1f18$var$GLOBAL_KEY = '__STATSIG__';
const $8b8bf22bae3e1f18$var$_window = typeof window !== 'undefined' ? window : {};
const $8b8bf22bae3e1f18$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $8b8bf22bae3e1f18$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $8b8bf22bae3e1f18$var$statsigGlobal = ($8b8bf22bae3e1f18$var$_c = ($8b8bf22bae3e1f18$var$_b = ($8b8bf22bae3e1f18$var$_a = $8b8bf22bae3e1f18$var$_window[$8b8bf22bae3e1f18$var$GLOBAL_KEY]) !== null && $8b8bf22bae3e1f18$var$_a !== void 0 ? $8b8bf22bae3e1f18$var$_a : $8b8bf22bae3e1f18$var$_global[$8b8bf22bae3e1f18$var$GLOBAL_KEY]) !== null && $8b8bf22bae3e1f18$var$_b !== void 0 ? $8b8bf22bae3e1f18$var$_b : $8b8bf22bae3e1f18$var$_globalThis[$8b8bf22bae3e1f18$var$GLOBAL_KEY]) !== null && $8b8bf22bae3e1f18$var$_c !== void 0 ? $8b8bf22bae3e1f18$var$_c : {
    instance: module.exports._getInstance
};
$8b8bf22bae3e1f18$var$_window[$8b8bf22bae3e1f18$var$GLOBAL_KEY] = $8b8bf22bae3e1f18$var$statsigGlobal;
$8b8bf22bae3e1f18$var$_global[$8b8bf22bae3e1f18$var$GLOBAL_KEY] = $8b8bf22bae3e1f18$var$statsigGlobal;
$8b8bf22bae3e1f18$var$_globalThis[$8b8bf22bae3e1f18$var$GLOBAL_KEY] = $8b8bf22bae3e1f18$var$statsigGlobal;

});
parcelRegister("1OvFT", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $152307e8a0269a9a$var$DEBUG = ' DEBUG ';
const $152307e8a0269a9a$var$_INFO = '  INFO ';
const $152307e8a0269a9a$var$_WARN = '  WARN ';
const $152307e8a0269a9a$var$ERROR = ' ERROR ';
function $152307e8a0269a9a$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $152307e8a0269a9a$var$Log {
    static info(...args) {
        if ($152307e8a0269a9a$var$Log.level >= module.exports.LogLevel.Info) console.info($152307e8a0269a9a$var$_INFO, ...$152307e8a0269a9a$var$addTag(args));
    }
    static debug(...args) {
        if ($152307e8a0269a9a$var$Log.level >= module.exports.LogLevel.Debug) console.debug($152307e8a0269a9a$var$DEBUG, ...$152307e8a0269a9a$var$addTag(args));
    }
    static warn(...args) {
        if ($152307e8a0269a9a$var$Log.level >= module.exports.LogLevel.Warn) console.warn($152307e8a0269a9a$var$_WARN, ...$152307e8a0269a9a$var$addTag(args));
    }
    static error(...args) {
        if ($152307e8a0269a9a$var$Log.level >= module.exports.LogLevel.Error) console.error($152307e8a0269a9a$var$ERROR, ...$152307e8a0269a9a$var$addTag(args));
    }
}
module.exports.Log = $152307e8a0269a9a$var$Log;
$152307e8a0269a9a$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("kDWyI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $f074dfbc2a7232ad$var$MARKER_MAP = new Map();
const $f074dfbc2a7232ad$var$ACT_START = 'start';
const $f074dfbc2a7232ad$var$ACT_END = 'end';
const $f074dfbc2a7232ad$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $f074dfbc2a7232ad$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $f074dfbc2a7232ad$var$_addMarker(sdkKey, $f074dfbc2a7232ad$var$_createMarker({}, $f074dfbc2a7232ad$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $f074dfbc2a7232ad$var$_addMarker(sdkKey, $f074dfbc2a7232ad$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $f074dfbc2a7232ad$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $f074dfbc2a7232ad$var$_addMarker(sdkKey, $f074dfbc2a7232ad$var$_createMarker(data, $f074dfbc2a7232ad$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $f074dfbc2a7232ad$var$_addMarker(sdkKey, $f074dfbc2a7232ad$var$_createMarker(data, $f074dfbc2a7232ad$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $f074dfbc2a7232ad$var$_addMarker(sdkKey, $f074dfbc2a7232ad$var$_createMarker({}, $f074dfbc2a7232ad$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $f074dfbc2a7232ad$var$_addMarker(sdkKey, $f074dfbc2a7232ad$var$_createMarker(data, $f074dfbc2a7232ad$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $f074dfbc2a7232ad$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $f074dfbc2a7232ad$var$_safeGetField(e, 'code'),
            name: $f074dfbc2a7232ad$var$_safeGetField(e, 'name'),
            message: $f074dfbc2a7232ad$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $f074dfbc2a7232ad$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $f074dfbc2a7232ad$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $f074dfbc2a7232ad$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $f074dfbc2a7232ad$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $f074dfbc2a7232ad$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $f074dfbc2a7232ad$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $f074dfbc2a7232ad$var$MARKER_MAP.set(sdkKey, markers);
}
function $f074dfbc2a7232ad$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("lo1Ts", function(module, exports) {
"use strict";
var $f91d4ee291257fe0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $bQcYR = parcelRequire("bQcYR");

var $75X6G = parcelRequire("75X6G");

var $1OvFT = parcelRequire("1OvFT");

var $dK79n = parcelRequire("dK79n");

var $jXGyN = parcelRequire("jXGyN");

var $gh2LQ = parcelRequire("gh2LQ");

var $hZDgH = parcelRequire("hZDgH");

var $hlXcM = parcelRequire("hlXcM");

var $SiHEi = parcelRequire("SiHEi");

var $cHtSK = parcelRequire("cHtSK");
const $f91d4ee291257fe0$var$DEFAULT_QUEUE_SIZE = 100;
const $f91d4ee291257fe0$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $f91d4ee291257fe0$var$MAX_DEDUPER_KEYS = 1000;
const $f91d4ee291257fe0$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $f91d4ee291257fe0$var$MAX_FAILED_LOGS = 500;
const $f91d4ee291257fe0$var$QUICK_FLUSH_WINDOW_MS = 200;
const $f91d4ee291257fe0$var$EVENT_LOGGER_MAP = {};
const $f91d4ee291257fe0$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $f91d4ee291257fe0$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $f91d4ee291257fe0$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $f91d4ee291257fe0$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($f91d4ee291257fe0$var$RetryFailedLogsTrigger.GainedFocus);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $f91d4ee291257fe0$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $jXGyN._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $f91d4ee291257fe0$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $cHtSK._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $f91d4ee291257fe0$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $f91d4ee291257fe0$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($f91d4ee291257fe0$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $f91d4ee291257fe0$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $f91d4ee291257fe0$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $f91d4ee291257fe0$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $f91d4ee291257fe0$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$f91d4ee291257fe0$var$EventLogger._safeFlushAndForget(this._sdkKey), $f91d4ee291257fe0$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $jXGyN._isServerEnv)()) return false;
        if (!(0, $gh2LQ._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $bQcYR._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $f91d4ee291257fe0$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $f91d4ee291257fe0$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        var _a, _b;
        return $f91d4ee291257fe0$var$__awaiter(this, void 0, void 0, function*() {
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $cHtSK._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? yield this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $1OvFT.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $1OvFT.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        var _a;
        return $f91d4ee291257fe0$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return $f91d4ee291257fe0$var$__awaiter(this, void 0, void 0, function*() {
            return {
                success: yield this._network.beacon(this._getRequestData(events))
            };
        });
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$dK79n.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $f91d4ee291257fe0$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $hlXcM._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $1OvFT.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$f91d4ee291257fe0$var$__awaiter(this, void 0, void 0, function*() {
                if (!$hlXcM.Storage.isReady()) yield $hlXcM.Storage.isReadyResolver();
                const events = (0, $hlXcM._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $f91d4ee291257fe0$var$RetryFailedLogsTrigger.Startup) $hlXcM.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $f91d4ee291257fe0$var$RetryFailedLogsTrigger.GainedFocus) $hlXcM.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $1OvFT.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $75X6G._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $1OvFT.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $jXGyN._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $f91d4ee291257fe0$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $f91d4ee291257fe0$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $f91d4ee291257fe0$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $hZDgH.LoggingEnabledOption.disabled : $hZDgH.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $1OvFT.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $f91d4ee291257fe0$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $SiHEi.UrlConfiguration($dK79n.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
}
module.exports.EventLogger = $f91d4ee291257fe0$var$EventLogger;

});
parcelRegister("bQcYR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $75X6G = parcelRequire("75X6G");
function $89ee9eb9961b9bb9$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $75X6G._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $89ee9eb9961b9bb9$var$_getUserStorageKey;
function $89ee9eb9961b9bb9$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $89ee9eb9961b9bb9$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $75X6G._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $89ee9eb9961b9bb9$var$_getStorageKey;

});
parcelRegister("75X6G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $7QLuf = parcelRequire("7QLuf");
const $52a6d96be12757a8$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $52a6d96be12757a8$var$_DJB2;
const $52a6d96be12757a8$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $52a6d96be12757a8$var$_DJB2Object;
const $52a6d96be12757a8$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $7QLuf._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $52a6d96be12757a8$var$_getSortedObject;

});
parcelRegister("7QLuf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $5b7239a209235b83$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $5b7239a209235b83$var$_typeOf;
function $5b7239a209235b83$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $5b7239a209235b83$var$_isTypeMatch;

});



parcelRegister("dK79n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("jXGyN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $e8848a9660c3489a$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $e8848a9660c3489a$var$_getWindowSafe;
const $e8848a9660c3489a$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $e8848a9660c3489a$var$_getDocumentSafe;
const $e8848a9660c3489a$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = false;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $e8848a9660c3489a$var$_isServerEnv;
const $e8848a9660c3489a$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $e8848a9660c3489a$var$_addWindowEventListenerSafe;
const $e8848a9660c3489a$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $e8848a9660c3489a$var$_addDocumentEventListenerSafe;
const $e8848a9660c3489a$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $e8848a9660c3489a$var$_getCurrentPageUrlSafe;
const $e8848a9660c3489a$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $e8848a9660c3489a$var$_getUnloadEvent;

});

parcelRegister("gh2LQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $bd9062167caf580c$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $bd9062167caf580c$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $bd9062167caf580c$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $bd9062167caf580c$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $bd9062167caf580c$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $bd9062167caf580c$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $bd9062167caf580c$var$GATE_EXPOSURE_NAME || eventName === $bd9062167caf580c$var$CONFIG_EXPOSURE_NAME || eventName === $bd9062167caf580c$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $bd9062167caf580c$var$_isExposureEvent;
const $bd9062167caf580c$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $bd9062167caf580c$var$_createExposure($bd9062167caf580c$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $bd9062167caf580c$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $bd9062167caf580c$var$_createGateExposure;
function $bd9062167caf580c$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $bd9062167caf580c$var$_mapExposures;
const $bd9062167caf580c$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $bd9062167caf580c$var$_createExposure($bd9062167caf580c$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $bd9062167caf580c$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $bd9062167caf580c$var$_createConfigExposure;
const $bd9062167caf580c$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = evaluation.secondary_exposures;
    }
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_d = layer.__evaluation) === null || _d === void 0 ? void 0 : _d.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $bd9062167caf580c$var$_createExposure($bd9062167caf580c$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $bd9062167caf580c$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $bd9062167caf580c$var$_createLayerParameterExposure;
const $bd9062167caf580c$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("hZDgH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("hlXcM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $1OvFT = parcelRequire("1OvFT");

var $jXGyN = parcelRequire("jXGyN");
const $ca2252bd2bc73b06$var$inMemoryStore = {};
const $ca2252bd2bc73b06$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$ca2252bd2bc73b06$var$inMemoryStore[key] ? $ca2252bd2bc73b06$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $ca2252bd2bc73b06$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $ca2252bd2bc73b06$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($ca2252bd2bc73b06$var$inMemoryStore)
};
let $ca2252bd2bc73b06$var$_localStorageProvider = null;
try {
    const win = (0, $jXGyN._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $ca2252bd2bc73b06$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $1OvFT.Log.warn('Failed to setup localStorageProvider.');
}
let $ca2252bd2bc73b06$var$_main = $ca2252bd2bc73b06$var$_localStorageProvider !== null && $ca2252bd2bc73b06$var$_localStorageProvider !== void 0 ? $ca2252bd2bc73b06$var$_localStorageProvider : $ca2252bd2bc73b06$var$_inMemoryProvider;
let $ca2252bd2bc73b06$var$_current = $ca2252bd2bc73b06$var$_main;
function $ca2252bd2bc73b06$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($ca2252bd2bc73b06$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === 'QuotaExceededError') {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith('statsig.'));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$ca2252bd2bc73b06$var$_current.isReady(),
    isReadyResolver: ()=>$ca2252bd2bc73b06$var$_current.isReadyResolver(),
    getProviderName: ()=>$ca2252bd2bc73b06$var$_current.getProviderName(),
    getItem: (key)=>$ca2252bd2bc73b06$var$_inMemoryBreaker(()=>$ca2252bd2bc73b06$var$_current.getItem(key)),
    setItem: (key, value)=>$ca2252bd2bc73b06$var$_inMemoryBreaker(()=>$ca2252bd2bc73b06$var$_current.setItem(key, value)),
    removeItem: (key)=>$ca2252bd2bc73b06$var$_current.removeItem(key),
    getAllKeys: ()=>$ca2252bd2bc73b06$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $ca2252bd2bc73b06$var$_main = newProvider;
        $ca2252bd2bc73b06$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $ca2252bd2bc73b06$var$_current = $ca2252bd2bc73b06$var$_inMemoryProvider;
        else $ca2252bd2bc73b06$var$_current = $ca2252bd2bc73b06$var$_main;
    }
};
function $ca2252bd2bc73b06$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $ca2252bd2bc73b06$var$_getObjectFromStorage;
function $ca2252bd2bc73b06$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $ca2252bd2bc73b06$var$_setObjectInStorage;

});

parcelRegister("SiHEi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $75X6G = parcelRequire("75X6G");

var $dK79n = parcelRequire("dK79n");
const $0a338d4a154d8f98$var$ENDPOINT_DNS_KEY_MAP = {
    [$dK79n.Endpoint._initialize]: 'i',
    [$dK79n.Endpoint._rgstr]: 'e',
    [$dK79n.Endpoint._download_config_specs]: 'd'
};
class $0a338d4a154d8f98$var$UrlConfiguration {
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $75X6G._DJB2)(this.customUrl + fallbacks);
    }
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $0a338d4a154d8f98$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $dK79n.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
}
module.exports.UrlConfiguration = $0a338d4a154d8f98$var$UrlConfiguration;

});

parcelRegister("cHtSK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $jXGyN = parcelRequire("jXGyN");
const $93f0ae29560cf15c$var$FOREGROUND = 'foreground';
const $93f0ae29560cf15c$var$BACKGROUND = 'background';
const $93f0ae29560cf15c$var$LISTENERS = [];
let $93f0ae29560cf15c$var$current = $93f0ae29560cf15c$var$FOREGROUND;
let $93f0ae29560cf15c$var$isUnloading = false;
const $93f0ae29560cf15c$var$_isCurrentlyVisible = ()=>{
    return $93f0ae29560cf15c$var$current === $93f0ae29560cf15c$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $93f0ae29560cf15c$var$_isCurrentlyVisible;
const $93f0ae29560cf15c$var$_isUnloading = ()=>$93f0ae29560cf15c$var$isUnloading;
module.exports._isUnloading = $93f0ae29560cf15c$var$_isUnloading;
const $93f0ae29560cf15c$var$_subscribeToVisiblityChanged = (listener)=>{
    $93f0ae29560cf15c$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $93f0ae29560cf15c$var$_subscribeToVisiblityChanged;
const $93f0ae29560cf15c$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $93f0ae29560cf15c$var$current) return;
    $93f0ae29560cf15c$var$current = visibility;
    $93f0ae29560cf15c$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $93f0ae29560cf15c$var$_notifyVisibilityChanged;
(0, $jXGyN._addWindowEventListenerSafe)('focus', ()=>{
    $93f0ae29560cf15c$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($93f0ae29560cf15c$var$FOREGROUND);
});
(0, $jXGyN._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($93f0ae29560cf15c$var$BACKGROUND));
(0, $jXGyN._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $93f0ae29560cf15c$var$FOREGROUND : $93f0ae29560cf15c$var$BACKGROUND);
});
(0, $jXGyN._addWindowEventListenerSafe)((0, $jXGyN._getUnloadEvent)(), ()=>{
    $93f0ae29560cf15c$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($93f0ae29560cf15c$var$BACKGROUND);
});

});


parcelRegister("b2JnU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.16.0';
let $80a3160d3002f017$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$80a3160d3002f017$var$metadata,
    add: (additions)=>{
        $80a3160d3002f017$var$metadata = Object.assign(Object.assign({}, $80a3160d3002f017$var$metadata), additions);
    }
};

});

parcelRegister("np6uq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("FZpp0", function(module, exports) {
"use strict";
var $07e376f1092d39cc$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $1OvFT = parcelRequire("1OvFT");

var $c3GX9 = parcelRequire("c3GX9");

var $dYlmk = parcelRequire("dYlmk");

var $hlXcM = parcelRequire("hlXcM");

var $jhVkG = parcelRequire("jhVkG");
const $07e376f1092d39cc$var$CACHE_LIMIT = 10;
class $07e376f1092d39cc$var$DataAdapterCore {
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $dYlmk._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $dYlmk._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $07e376f1092d39cc$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getDataAsyncImpl(current, user, options) {
        return $07e376f1092d39cc$var$__awaiter(this, void 0, void 0, function*() {
            if (!$hlXcM.Storage.isReady()) yield $hlXcM.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $1OvFT.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $07e376f1092d39cc$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $dYlmk._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        var _a;
        return $07e376f1092d39cc$var$__awaiter(this, void 0, void 0, function*() {
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $1OvFT.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $jhVkG._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $c3GX9.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $07e376f1092d39cc$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $07e376f1092d39cc$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $1OvFT.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $hlXcM.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($hlXcM.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $jhVkG._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $hlXcM.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $hlXcM._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $07e376f1092d39cc$var$_getEvictableKey(lastModifiedTimeMap, $07e376f1092d39cc$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $hlXcM.Storage.removeItem(evictable);
        }
        (0, $hlXcM._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $07e376f1092d39cc$var$InMemoryCache();
    }
}
module.exports.DataAdapterCore = $07e376f1092d39cc$var$DataAdapterCore;
function $07e376f1092d39cc$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $dYlmk._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $07e376f1092d39cc$var$_makeDataAdapterResult;
class $07e376f1092d39cc$var$InMemoryCache {
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $1OvFT.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $07e376f1092d39cc$var$_getEvictableKey(this._data, $07e376f1092d39cc$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
    constructor(){
        this._data = {};
    }
}
function $07e376f1092d39cc$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("c3GX9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $bQcYR = parcelRequire("bQcYR");

var $1OvFT = parcelRequire("1OvFT");

var $jXGyN = parcelRequire("jXGyN");

var $hlXcM = parcelRequire("hlXcM");

var $9zTSD = parcelRequire("9zTSD");
const $8c7715724816d66f$var$PROMISE_MAP = {};
const $8c7715724816d66f$var$COOKIE_ENABLED_MAP = {};
const $8c7715724816d66f$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($8c7715724816d66f$var$DISABLED_MAP[sdkKey]) return null;
        if ($8c7715724816d66f$var$PROMISE_MAP[sdkKey] != null) return $8c7715724816d66f$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $8c7715724816d66f$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $8c7715724816d66f$var$PROMISE_MAP[sdkKey] = stableID;
            $8c7715724816d66f$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $8c7715724816d66f$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $9zTSD.getUUID)();
        $8c7715724816d66f$var$_persistToStorage(stableID, sdkKey);
        $8c7715724816d66f$var$_persistToCookie(stableID, sdkKey);
        $8c7715724816d66f$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $8c7715724816d66f$var$PROMISE_MAP[sdkKey] = override;
        $8c7715724816d66f$var$_persistToStorage(override, sdkKey);
        $8c7715724816d66f$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $8c7715724816d66f$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $8c7715724816d66f$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $8c7715724816d66f$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $bQcYR._getStorageKey)(sdkKey)}`;
}
function $8c7715724816d66f$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $8c7715724816d66f$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $hlXcM._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $1OvFT.Log.warn('Failed to save StableID to storage');
    }
}
function $8c7715724816d66f$var$_loadFromStorage(sdkKey) {
    const storageKey = $8c7715724816d66f$var$_getStableIDStorageKey(sdkKey);
    return (0, $hlXcM._getObjectFromStorage)(storageKey);
}
function $8c7715724816d66f$var$_loadFromCookie(sdkKey) {
    if (!$8c7715724816d66f$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $jXGyN._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $8c7715724816d66f$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $8c7715724816d66f$var$_persistToCookie(stableID, sdkKey) {
    if (!$8c7715724816d66f$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$8c7715724816d66f$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $8c7715724816d66f$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $bQcYR._getStorageKey)(sdkKey)}`;
}

});
parcelRegister("9zTSD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $6f92ba9afaef8dd4$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $6f92ba9afaef8dd4$var$getUUID;

});


parcelRegister("dYlmk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $75X6G = parcelRequire("75X6G");

var $1OvFT = parcelRequire("1OvFT");
function $a2c172725b492c22$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $1OvFT.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $a2c172725b492c22$var$_normalizeUser;
function $a2c172725b492c22$var$_getFullUserHash(user) {
    return user ? (0, $75X6G._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $a2c172725b492c22$var$_getFullUserHash;

});

parcelRegister("jhVkG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $1OvFT = parcelRequire("1OvFT");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $e0ac13ee1b2be972$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $1OvFT.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $e0ac13ee1b2be972$var$_typedJsonParse;

});


parcelRegister("QszgO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("amoop", function(module, exports) {
"use strict";
var $78aee154b27f1674$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $1OvFT = parcelRequire("1OvFT");

var $7OAfu = parcelRequire("7OAfu");

var $b2JnU = parcelRequire("b2JnU");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $78aee154b27f1674$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $78aee154b27f1674$var$ErrorBoundary {
    wrap(instance) {
        try {
            const obj = instance;
            $78aee154b27f1674$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $78aee154b27f1674$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $1OvFT.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$78aee154b27f1674$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($78aee154b27f1674$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $78aee154b27f1674$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $7OAfu.SDKType._get(this._sdkKey);
                    const statsigMetadata = $b2JnU.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $78aee154b27f1674$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $78aee154b27f1674$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
}
module.exports.ErrorBoundary = $78aee154b27f1674$var$ErrorBoundary;
function $78aee154b27f1674$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $78aee154b27f1674$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $78aee154b27f1674$var$UNKNOWN_ERROR;
    }
}
function $78aee154b27f1674$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $78aee154b27f1674$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("7OAfu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $5b09522bea129122$var$SDK_CLIENT = {};
let $5b09522bea129122$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $5b09522bea129122$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($5b09522bea129122$var$suffix !== null && $5b09522bea129122$var$suffix !== void 0 ? $5b09522bea129122$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $5b09522bea129122$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$5b09522bea129122$var$suffix || $5b09522bea129122$var$suffix === '-react') $5b09522bea129122$var$suffix = '-' + binding;
    }
};

});


parcelRegister("fPBrb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ay03q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dKupR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3atRr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _layer: 'l',
    _paramStore: 'p'
};
const $24e978092142d83c$var$EXIST_KEYS = new Set([]);
const $24e978092142d83c$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $24e978092142d83c$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($24e978092142d83c$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($24e978092142d83c$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $24e978092142d83c$var$createMemoKey;

});

parcelRegister("fieiX", function(module, exports) {
"use strict";
var $b223a2192225ed06$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $bYNP6 = parcelRequire("bYNP6");

var $bYNP6 = parcelRequire("bYNP6");

var $kDWyI = parcelRequire("kDWyI");

var $1OvFT = parcelRequire("1OvFT");

var $dK79n = parcelRequire("dK79n");

var $17upD = parcelRequire("17upD");

var $cKd83 = parcelRequire("cKd83");

var $7OAfu = parcelRequire("7OAfu");

var $jXGyN = parcelRequire("jXGyN");

var $TtqbT = parcelRequire("TtqbT");

var $c3GX9 = parcelRequire("c3GX9");

var $3kqeB = parcelRequire("3kqeB");

var $b2JnU = parcelRequire("b2JnU");

var $hZDgH = parcelRequire("hZDgH");

var $cHtSK = parcelRequire("cHtSK");
const $b223a2192225ed06$var$DEFAULT_TIMEOUT_MS = 10000;
const $b223a2192225ed06$var$BACKOFF_BASE_MS = 500;
const $b223a2192225ed06$var$BACKOFF_MAX_MS = 30000;
const $b223a2192225ed06$var$RATE_LIMIT_WINDOW_MS = 1000;
const $b223a2192225ed06$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $b223a2192225ed06$var$LEAK_RATE = $b223a2192225ed06$var$RATE_LIMIT_MAX_REQ_COUNT / $b223a2192225ed06$var$RATE_LIMIT_WINDOW_MS;
const $b223a2192225ed06$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $b223a2192225ed06$var$NetworkCore {
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        return $b223a2192225ed06$var$__awaiter(this, void 0, void 0, function*() {
            if (!$b223a2192225ed06$var$_ensureValidSdkKey(args)) return false;
            const argsInternal = this._getInternalRequestArgs('POST', args);
            yield this._tryToCompressBody(argsInternal);
            const url = yield this._getPopulatedURL(argsInternal);
            const nav = navigator;
            return nav.sendBeacon.bind(nav)(url, argsInternal.body);
        });
    }
    post(args) {
        return $b223a2192225ed06$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        var _a, _b, _c, _d;
        return $b223a2192225ed06$var$__awaiter(this, void 0, void 0, function*() {
            if (!$b223a2192225ed06$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $1OvFT.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = yield this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $cHtSK._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $b223a2192225ed06$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $b223a2192225ed06$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $b223a2192225ed06$var$_getErrorMessage(abortController, error);
                const timedOut = $b223a2192225ed06$var$_didTimeout(abortController);
                $b223a2192225ed06$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$b223a2192225ed06$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $3kqeB.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $1OvFT.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $b223a2192225ed06$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $hZDgH.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $hZDgH.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $b223a2192225ed06$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $b223a2192225ed06$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        return $b223a2192225ed06$var$__awaiter(this, void 0, void 0, function*() {
            const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
            if (args.urlConfig.endpoint === $dK79n.Endpoint._initialize || args.urlConfig.endpoint === $dK79n.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
            const params = Object.assign({
                [$dK79n.NetworkParam.SdkKey]: args.sdkKey,
                [$dK79n.NetworkParam.SdkType]: $7OAfu.SDKType._get(args.sdkKey),
                [$dK79n.NetworkParam.SdkVersion]: $b2JnU.SDK_VERSION,
                [$dK79n.NetworkParam.Time]: String(Date.now()),
                [$dK79n.NetworkParam.SessionID]: $TtqbT.SessionID.get(args.sdkKey)
            }, args.params);
            const query = Object.keys(params).map((key)=>{
                return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
            }).join('&');
            return `${url}${query ? `?${query}` : ''}`;
        });
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $jXGyN._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $bYNP6._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$dK79n.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $1OvFT.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        var _a;
        return $b223a2192225ed06$var$__awaiter(this, void 0, void 0, function*() {
            const body = args.body;
            if (typeof body !== 'string' || !$b223a2192225ed06$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($1OvFT.Log.error);
                writer.close().catch($1OvFT.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$dK79n.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $1OvFT.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $b223a2192225ed06$var$_populateRequestBody(result, args.data);
        return result;
    }
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $b223a2192225ed06$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $17upD.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
}
module.exports.NetworkCore = $b223a2192225ed06$var$NetworkCore;
const $b223a2192225ed06$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $1OvFT.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $b223a2192225ed06$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $c3GX9.StableID.get(sdkKey);
    const sessionID = $TtqbT.SessionID.get(sdkKey);
    const sdkType = $7OAfu.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $b2JnU.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $b223a2192225ed06$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $bYNP6._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $cKd83.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $hZDgH.LogEventCompressionMode.Disabled:
            return false;
        case $hZDgH.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $hZDgH.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $b223a2192225ed06$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $b223a2192225ed06$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $b223a2192225ed06$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $dK79n.Endpoint._initialize) return;
    $kDWyI.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $b223a2192225ed06$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $dK79n.Endpoint._initialize) return;
    $kDWyI.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $kDWyI.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $b223a2192225ed06$var$_exponentialBackoff(attempt) {
    return $b223a2192225ed06$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($b223a2192225ed06$var$BACKOFF_BASE_MS * (attempt * attempt), $b223a2192225ed06$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("17upD", function(module, exports) {
"use strict";
var $0d0e09308cd1da6f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $coFmx = parcelRequire("coFmx");

var $75X6G = parcelRequire("75X6G");

var $1OvFT = parcelRequire("1OvFT");

var $hlXcM = parcelRequire("hlXcM");
const $0d0e09308cd1da6f$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $0d0e09308cd1da6f$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $0d0e09308cd1da6f$var$NetworkFallbackResolver {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $0d0e09308cd1da6f$var$DEFAULT_TTL_MS;
        $0d0e09308cd1da6f$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $0d0e09308cd1da6f$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $0d0e09308cd1da6f$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        var _a, _b;
        return $0d0e09308cd1da6f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                if (!$0d0e09308cd1da6f$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $0d0e09308cd1da6f$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $0d0e09308cd1da6f$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        var _a;
        return $0d0e09308cd1da6f$var$__awaiter(this, void 0, void 0, function*() {
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $0d0e09308cd1da6f$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $coFmx._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $0d0e09308cd1da6f$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
}
module.exports.NetworkFallbackResolver = $0d0e09308cd1da6f$var$NetworkFallbackResolver;
function $0d0e09308cd1da6f$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $0d0e09308cd1da6f$var$_isDomainFailure;
function $0d0e09308cd1da6f$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $75X6G._DJB2)(sdkKey)}`;
}
function $0d0e09308cd1da6f$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $0d0e09308cd1da6f$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $hlXcM.Storage.removeItem(hashKey);
        return;
    }
    $hlXcM.Storage.setItem(hashKey, JSON.stringify(info));
}
function $0d0e09308cd1da6f$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $0d0e09308cd1da6f$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $hlXcM.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $1OvFT.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $0d0e09308cd1da6f$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("coFmx", function(module, exports) {
"use strict";
var $9067cfaa3d092275$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $9067cfaa3d092275$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $9067cfaa3d092275$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $9067cfaa3d092275$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $9067cfaa3d092275$var$MAX_START_LOOKUP = 200;
function $9067cfaa3d092275$var$_fetchTxtRecords(networkFunc) {
    return $9067cfaa3d092275$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($9067cfaa3d092275$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $9067cfaa3d092275$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $9067cfaa3d092275$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $9067cfaa3d092275$var$_fetchTxtRecords;
function $9067cfaa3d092275$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $9067cfaa3d092275$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $9067cfaa3d092275$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("cKd83", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $9473f709616eba59$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $9473f709616eba59$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $9473f709616eba59$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("TtqbT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $bYNP6 = parcelRequire("bYNP6");

var $bQcYR = parcelRequire("bQcYR");

var $1OvFT = parcelRequire("1OvFT");

var $hlXcM = parcelRequire("hlXcM");

var $9zTSD = parcelRequire("9zTSD");
const $0a6bf5a700218675$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $0a6bf5a700218675$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $0a6bf5a700218675$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($0a6bf5a700218675$var$PROMISE_MAP[sdkKey] == null) $0a6bf5a700218675$var$PROMISE_MAP[sdkKey] = $0a6bf5a700218675$var$_loadSession(sdkKey);
        const session = $0a6bf5a700218675$var$PROMISE_MAP[sdkKey];
        return $0a6bf5a700218675$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $0a6bf5a700218675$var$PROMISE_MAP[sdkKey] = $0a6bf5a700218675$var$_overrideSessionId(override, sdkKey);
    }
};
function $0a6bf5a700218675$var$_loadSession(sdkKey) {
    let data = $0a6bf5a700218675$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $9zTSD.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $0a6bf5a700218675$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $0a6bf5a700218675$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($0a6bf5a700218675$var$_isIdle(data) || $0a6bf5a700218675$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $9zTSD.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $0a6bf5a700218675$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $0a6bf5a700218675$var$_createSessionTimeout(sdkKey, $0a6bf5a700218675$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $0a6bf5a700218675$var$_createSessionTimeout(sdkKey, $0a6bf5a700218675$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $0a6bf5a700218675$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $bYNP6._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $0a6bf5a700218675$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $0a6bf5a700218675$var$MAX_SESSION_IDLE_TIME;
}
function $0a6bf5a700218675$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $0a6bf5a700218675$var$MAX_SESSION_AGE;
}
function $0a6bf5a700218675$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $bQcYR._getStorageKey)(sdkKey)}`;
}
function $0a6bf5a700218675$var$_persistToStorage(session, sdkKey) {
    const storageKey = $0a6bf5a700218675$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $hlXcM._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $1OvFT.Log.warn('Failed to save SessionID');
    }
}
function $0a6bf5a700218675$var$_loadFromStorage(sdkKey) {
    const storageKey = $0a6bf5a700218675$var$_getSessionIDStorageKey(sdkKey);
    return (0, $hlXcM._getObjectFromStorage)(storageKey);
}

});

parcelRegister("3kqeB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("3MDN6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("XhJBy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gW65n", function(module, exports) {
"use strict";
var $c546c89f66c5a164$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $bYNP6 = parcelRequire("bYNP6");

var $bYNP6 = parcelRequire("bYNP6");

var $amoop = parcelRequire("amoop");

var $lo1Ts = parcelRequire("lo1Ts");

var $1OvFT = parcelRequire("1OvFT");

var $3atRr = parcelRequire("3atRr");

var $jXGyN = parcelRequire("jXGyN");

var $TtqbT = parcelRequire("TtqbT");

var $c3GX9 = parcelRequire("c3GX9");

var $hZDgH = parcelRequire("hZDgH");

var $hlXcM = parcelRequire("hlXcM");
const $c546c89f66c5a164$var$MAX_MEMO_CACHE_SIZE = 3000;
class $c546c89f66c5a164$var$StatsigClientBase {
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $hlXcM.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $c3GX9.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($hZDgH.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $c546c89f66c5a164$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $1OvFT.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $3atRr.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $c546c89f66c5a164$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($1OvFT.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $hlXcM.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $TtqbT.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $hlXcM.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $c3GX9.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $c3GX9.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $lo1Ts.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $amoop.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $hlXcM.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $c546c89f66c5a164$var$_assignGlobalInstance(sdkKey, this);
    }
}
module.exports.StatsigClientBase = $c546c89f66c5a164$var$StatsigClientBase;
function $c546c89f66c5a164$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $jXGyN._isServerEnv)()) return;
    const statsigGlobal = (0, $bYNP6._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $1OvFT.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("hVWUO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("esLeu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2KqEX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $1OvFT = parcelRequire("1OvFT");

var $7QLuf = parcelRequire("7QLuf");
const $20048eaf2046d967$var$DEFAULT_RULE = 'default';
function $20048eaf2046d967$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : $20048eaf2046d967$var$DEFAULT_RULE,
        __evaluation: evaluation,
        value: value
    };
}
function $20048eaf2046d967$var$_makeFeatureGate(name, details, evaluation) {
    return $20048eaf2046d967$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true);
}
module.exports._makeFeatureGate = $20048eaf2046d967$var$_makeFeatureGate;
function $20048eaf2046d967$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $20048eaf2046d967$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $20048eaf2046d967$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $20048eaf2046d967$var$_makeDynamicConfig;
function $20048eaf2046d967$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $20048eaf2046d967$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $20048eaf2046d967$var$_makeExperiment;
function $20048eaf2046d967$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $20048eaf2046d967$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $20048eaf2046d967$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $20048eaf2046d967$var$_makeLayer;
function $20048eaf2046d967$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $20048eaf2046d967$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $20048eaf2046d967$var$_mergeOverride;
function $20048eaf2046d967$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $7QLuf._isTypeMatch)(found, fallback)) {
            $1OvFT.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $20048eaf2046d967$var$_makeTypedGet;

});

parcelRegister("kI8Ae", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2PmEk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $20f1e9e2fea8e3df$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $20f1e9e2fea8e3df$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("j9spr", function(module, exports) {

var $jE5aI = parcelRequire("jE5aI");

var $4Qso2 = parcelRequire("4Qso2");

var $5ng8R = parcelRequire("5ng8R");

var $lF2K2 = parcelRequire("lF2K2");
function $df14e51c7c25c788$var$_toConsumableArray(r) {
    return $jE5aI(r) || $4Qso2(r) || $5ng8R(r) || $lF2K2();
}
module.exports = $df14e51c7c25c788$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jE5aI", function(module, exports) {

var $hOZt4 = parcelRequire("hOZt4");
function $e4d5c3c2aaa74da7$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $hOZt4(r);
}
module.exports = $e4d5c3c2aaa74da7$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4Qso2", function(module, exports) {
function $387209bfaa84eb03$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $387209bfaa84eb03$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lF2K2", function(module, exports) {
function $fc4f8dbd031a00db$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $fc4f8dbd031a00db$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});


parcelRegister("7DmNu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58eddbfe7ba123a9$var$_react = $58eddbfe7ba123a9$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $58eddbfe7ba123a9$var$_baseNew = $58eddbfe7ba123a9$var$_interopRequireDefault((parcelRequire("aUDbt")));
function $58eddbfe7ba123a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $58eddbfe7ba123a9$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $58eddbfe7ba123a9$var$_react.default.createElement($58eddbfe7ba123a9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$58eddbfe7ba123a9$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $58eddbfe7ba123a9$var$_default = module.exports.default = $58eddbfe7ba123a9$var$ChevronDownIcon;

});
parcelRegister("aUDbt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("gCO79")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("gCO79")).Icon; });

var $gCO79 = parcelRequire("gCO79");

});
parcelRegister("gCO79", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $c1a7119776c80d6a$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $c1a7119776c80d6a$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

var $137Lh = parcelRequire("137Lh");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $c1a7119776c80d6a$var$svgStyles = null;
var $c1a7119776c80d6a$var$iconStyles = null;
var $c1a7119776c80d6a$var$utilityIconStyles = null;
var $c1a7119776c80d6a$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $c1a7119776c80d6a$var$baseHcmStyles = null;
var $c1a7119776c80d6a$var$scaleSize = null;
var $c1a7119776c80d6a$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c1a7119776c80d6a$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c1a7119776c80d6a$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c1a7119776c80d6a$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $c1a7119776c80d6a$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $c1a7119776c80d6a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $137Lh.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $7fPBF.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'size' in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === 'small' || props.size === 'medium') ? props.size : 'medium';
    var baseSize = $c1a7119776c80d6a$var$baseSizeMap[type];
    var viewBoxPadding = $c1a7119776c80d6a$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $fjFkG.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $fjFkG.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $c1a7119776c80d6a$var$utilSizes[spacing] : size === 'small' ? $c1a7119776c80d6a$var$coreSizeSmall[spacing] : $c1a7119776c80d6a$var$coreSizeMedium[spacing]
        ])
    }));
});
var $c1a7119776c80d6a$export$2e2bcd8739ae039 = $c1a7119776c80d6a$export$f04a61298a47a40f;

});
parcelRegister("fjFkG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b268b12df0727654$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $b268b12df0727654$var$ATOMIC_GROUP_LENGTH = 5;
function $b268b12df0727654$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $b268b12df0727654$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("137Lh", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $0c3c1789006e2563$export$b40ec24ac8275656; });

var $NJYzu = parcelRequire("NJYzu");
function $0c3c1789006e2563$export$ba05d765b8392e5e(flagResolver) {
    (0, $NJYzu.setBooleanResolver)(flagResolver);
}
function $0c3c1789006e2563$export$470e5c2be1411c89(name) {
    return (0, $NJYzu.resolveBooleanFlag)(name);
}
function $0c3c1789006e2563$export$b40ec24ac8275656(name) {
    return (0, $NJYzu.resolveBooleanFlag)(name);
}

});
parcelRegister("NJYzu", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $09583d95e063b91a$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $09583d95e063b91a$export$6333b6aff9fc6275; });

var $6gsEP = parcelRequire("6gsEP");

var $8w2cM = parcelRequire("8w2cM");
var $09583d95e063b91a$var$pkgName = '@atlaskit/platform-feature-flags';
var $09583d95e063b91a$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $09583d95e063b91a$var$hasProcessEnv = false;
// FF global overrides can be configured by test runners or Storybook
var $09583d95e063b91a$var$ENV_ENABLE_PLATFORM_FF = $09583d95e063b91a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $09583d95e063b91a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $09583d95e063b91a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $09583d95e063b91a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $09583d95e063b91a$var$ENV_ENABLE_PLATFORM_FF || $09583d95e063b91a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $09583d95e063b91a$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $09583d95e063b91a$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$09583d95e063b91a$var$globalVar[$09583d95e063b91a$export$7e41b1b2bdee3f98] = $09583d95e063b91a$var$globalVar[$09583d95e063b91a$export$7e41b1b2bdee3f98] || $09583d95e063b91a$var$DEFAULT_PFF_GLOBAL;
function $09583d95e063b91a$export$f2b591175b3e424c(resolver) {
    $09583d95e063b91a$var$globalVar[$09583d95e063b91a$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $09583d95e063b91a$export$6333b6aff9fc6275(flagKey) {
    if ($09583d95e063b91a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $8w2cM.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $09583d95e063b91a$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $09583d95e063b91a$var$globalVar[$09583d95e063b91a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $09583d95e063b91a$var$globalVar[$09583d95e063b91a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $6gsEP.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $09583d95e063b91a$var$globalVar[$09583d95e063b91a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("6gsEP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48fa778320c3ddc4$export$2e2bcd8739ae039; });

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");

var $7mn8t = parcelRequire("7mn8t");

var $cS3lQ = parcelRequire("cS3lQ");



var $48fa778320c3ddc4$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $48fa778320c3ddc4$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$48fa778320c3ddc4$var$_FeatureGates = $48fa778320c3ddc4$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "client", new (0, $7mn8t.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$48fa778320c3ddc4$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $48fa778320c3ddc4$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $48fa778320c3ddc4$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$48fa778320c3ddc4$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $48fa778320c3ddc4$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $48fa778320c3ddc4$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "initializeCalled", $48fa778320c3ddc4$var$_FeatureGates.client.initializeCalled.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "initializeCompleted", $48fa778320c3ddc4$var$_FeatureGates.client.initializeCompleted.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "initialize", $48fa778320c3ddc4$var$_FeatureGates.client.initialize.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "initializeWithProvider", $48fa778320c3ddc4$var$_FeatureGates.client.initializeWithProvider.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "initializeFromValues", $48fa778320c3ddc4$var$_FeatureGates.client.initializeFromValues.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "manuallyLogGateExposure", $48fa778320c3ddc4$var$_FeatureGates.client.manuallyLogGateExposure.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "getExperiment", $48fa778320c3ddc4$var$_FeatureGates.client.getExperiment.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "manuallyLogExperimentExposure", $48fa778320c3ddc4$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "manuallyLogLayerExposure", $48fa778320c3ddc4$var$_FeatureGates.client.manuallyLogLayerExposure.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "shutdownStatsig", $48fa778320c3ddc4$var$_FeatureGates.client.shutdownStatsig.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "overrideGate", $48fa778320c3ddc4$var$_FeatureGates.client.overrideGate.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "clearGateOverride", $48fa778320c3ddc4$var$_FeatureGates.client.clearGateOverride.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "overrideConfig", $48fa778320c3ddc4$var$_FeatureGates.client.overrideConfig.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "clearConfigOverride", $48fa778320c3ddc4$var$_FeatureGates.client.clearConfigOverride.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "setOverrides", $48fa778320c3ddc4$var$_FeatureGates.client.setOverrides.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "getOverrides", $48fa778320c3ddc4$var$_FeatureGates.client.getOverrides.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "clearAllOverrides", $48fa778320c3ddc4$var$_FeatureGates.client.clearAllOverrides.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "isCurrentUser", $48fa778320c3ddc4$var$_FeatureGates.client.isCurrentUser.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "onGateUpdated", $48fa778320c3ddc4$var$_FeatureGates.client.onGateUpdated.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "onExperimentValueUpdated", $48fa778320c3ddc4$var$_FeatureGates.client.onExperimentValueUpdated.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "onAnyUpdated", $48fa778320c3ddc4$var$_FeatureGates.client.onAnyUpdated.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "updateUser", $48fa778320c3ddc4$var$_FeatureGates.client.updateUser.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "updateUserWithProvider", $48fa778320c3ddc4$var$_FeatureGates.client.updateUserWithProvider.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "updateUserWithValues", $48fa778320c3ddc4$var$_FeatureGates.client.updateUserWithValues.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "getPackageVersion", $48fa778320c3ddc4$var$_FeatureGates.client.getPackageVersion.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "getLayer", $48fa778320c3ddc4$var$_FeatureGates.client.getLayer.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "getLayerValue", $48fa778320c3ddc4$var$_FeatureGates.client.getLayerValue.bind($48fa778320c3ddc4$var$_FeatureGates.client));
var $48fa778320c3ddc4$var$boundFGJS = $48fa778320c3ddc4$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $48fa778320c3ddc4$var$FeatureGates;
    else {
        var $48fa778320c3ddc4$var$_boundFGJS, $48fa778320c3ddc4$var$_boundFGJS$getPackage;
        $48fa778320c3ddc4$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $48fa778320c3ddc4$var$boundVersion = (($48fa778320c3ddc4$var$_boundFGJS = $48fa778320c3ddc4$var$boundFGJS) === null || $48fa778320c3ddc4$var$_boundFGJS === void 0 || ($48fa778320c3ddc4$var$_boundFGJS$getPackage = $48fa778320c3ddc4$var$_boundFGJS.getPackageVersion) === null || $48fa778320c3ddc4$var$_boundFGJS$getPackage === void 0 ? void 0 : $48fa778320c3ddc4$var$_boundFGJS$getPackage.call($48fa778320c3ddc4$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($48fa778320c3ddc4$var$boundVersion !== (0, $cS3lQ.CLIENT_VERSION)) {
            var $48fa778320c3ddc4$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($48fa778320c3ddc4$var$boundVersion, " when module version ").concat((0, $cS3lQ.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($48fa778320c3ddc4$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $48fa778320c3ddc4$export$2e2bcd8739ae039 = $48fa778320c3ddc4$var$boundFGJS;

});
parcelRegister("7mn8t", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $55bc88bc5929681a$export$1f2bb630327ac4b6; });

var $emuQy = parcelRequire("emuQy");

var $iKdEz = parcelRequire("iKdEz");

var $1uJLd = parcelRequire("1uJLd");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");

var $iQsIh = parcelRequire("iQsIh");

var $79kyO = parcelRequire("79kyO");

var $jiToV = parcelRequire("jiToV");

var $dj9zK = parcelRequire("dj9zK");

var $h6BJU = parcelRequire("h6BJU");

var $cTgM0 = parcelRequire("cTgM0");

var $78a3d = parcelRequire("78a3d");

var $1Jw6w = parcelRequire("1Jw6w");

var $24YjW = parcelRequire("24YjW");

var $brodC = parcelRequire("brodC");

var $dsuun = parcelRequire("dsuun");

var $cS3lQ = parcelRequire("cS3lQ");
var $55bc88bc5929681a$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $55bc88bc5929681a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $55bc88bc5929681a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $55bc88bc5929681a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $55bc88bc5929681a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $55bc88bc5929681a$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $55bc88bc5929681a$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $55bc88bc5929681a$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $24YjW.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "subscriptions", new (0, $jiToV.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "dataAdapter", new (0, $1Jw6w.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $24YjW.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $dsuun.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $dsuun.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $dsuun.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $dsuun.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $cS3lQ.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $55bc88bc5929681a$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $cS3lQ.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $brodC.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $dsuun.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $dsuun.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x10) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $dsuun.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $78a3d.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x11, _x12, _x13) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x14, _x15) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x16, _x17) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $dj9zK.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $dj9zK.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $cTgM0.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $dsuun.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $dsuun.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $55bc88bc5929681a$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $78a3d.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $78a3d.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x18, _x19, _x20) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $55bc88bc5929681a$var$_objectSpread($55bc88bc5929681a$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x21, _x22, _x23, _x24) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $dsuun.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $55bc88bc5929681a$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $55bc88bc5929681a$var$_objectSpread($55bc88bc5929681a$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $55bc88bc5929681a$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $brodC.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(newClientOptions, $55bc88bc5929681a$var$_excluded);
                                this.sdkKey = sdkKey;
                                this.user = (0, $dsuun.toStatsigUser)(identifiers, customAttributes, this.sdkKey);
                                statsigOptions = $55bc88bc5929681a$var$_objectSpread($55bc88bc5929681a$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter
                                });
                                _context9.prev = 12;
                                this.statsigClient = new (0, $79kyO.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $79kyO.StatsigClient)($55bc88bc5929681a$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x25, _x26, _x27) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee11(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context11.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context11.next = 5;
                                    break;
                                }
                                return _context11.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context11.prev = 6;
                                _context11.next = 9;
                                return this.initPromise;
                            case 9:
                                _context11.next = 13;
                                break;
                            case 11:
                                _context11.prev = 11;
                                _context11.t0 = _context11["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee10() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee10$(_context10) {
                                        while(true)switch(_context10.prev = _context10.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context10.next = 4;
                                                    break;
                                                }
                                                _context10.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context10.stop();
                                        }
                                    }, _callee10);
                                })));
                                return _context11.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x28, _x29, _x30) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee12(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context12.prev = 1;
                                _context12.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context12.sent;
                                user = (0, $dsuun.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch, this.sdkKey);
                                _context12.next = 13;
                                break;
                            case 8:
                                _context12.prev = 8;
                                _context12.t0 = _context12["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context12.t0 instanceof Error ? _context12.t0.message : JSON.stringify(_context12.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context12.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context12.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                _context12.next = 20;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 20:
                                _context12.next = 26;
                                break;
                            case 22:
                                _context12.prev = 22;
                                _context12.t1 = _context12["catch"](15);
                                success = false;
                                errorMessage = String(_context12.t1);
                            case 26:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context12.next = 33;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context12.next = 34;
                                break;
                            case 33:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 34:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            22
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x31, _x32, _x33) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $cS3lQ.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $h6BJU.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $h6BJU.Layer).fromLayer((0, $79kyO._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("emuQy", function(module, exports) {

var $1ifJj = parcelRequire("1ifJj");
function $a74b0c43386c0a1b$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $1ifJj(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $a74b0c43386c0a1b$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1ifJj", function(module, exports) {
function $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1uJLd", function(module, exports) {
function $116c16e6836eccc9$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $116c16e6836eccc9$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $116c16e6836eccc9$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $116c16e6836eccc9$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $116c16e6836eccc9$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iQsIh", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $db835b247d6fea1a$var$runtime = (parcelRequire("f8tK9"))();
module.exports = $db835b247d6fea1a$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $db835b247d6fea1a$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $db835b247d6fea1a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($db835b247d6fea1a$var$runtime);
}

});

parcelRegister("79kyO", function(module, exports) {
"use strict";
var $5349529342b72503$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5349529342b72503$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5349529342b72503$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $keux7 = parcelRequire("keux7");
module.exports.StatsigClient = $keux7.default;

$5349529342b72503$var$__exportStar((parcelRequire("2CTsY")), module.exports);
const $5349529342b72503$var$__STATSIG__ = Object.assign((0, (parcelRequire("2CTsY"))._getStatsigGlobal)(), {
    StatsigClient: $keux7.default
});
module.exports.default = $5349529342b72503$var$__STATSIG__;

});
parcelRegister("keux7", function(module, exports) {
"use strict";
var $ebacccb03eb5d368$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2CTsY = parcelRequire("2CTsY");

var $3Evxa = parcelRequire("3Evxa");

var $i90BU = parcelRequire("i90BU");

var $f5O9f = parcelRequire("f5O9f");

var $5Djoj = parcelRequire("5Djoj");
class $ebacccb03eb5d368$var$StatsigClient extends $2CTsY.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient|undefined} Returns the StatsigClient instance associated with the given SDK key, or undefined if no instance is associated with the key or if no key is provided and no instances exist.
     */ static instance(sdkKey) {
        const instance = (0, $2CTsY._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $ebacccb03eb5d368$var$StatsigClient) return instance;
        $2CTsY.Log.warn((0, $2CTsY._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $ebacccb03eb5d368$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $2CTsY.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $ebacccb03eb5d368$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        var _a;
        const startTime = performance.now();
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $2CTsY.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $2CTsY.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $ebacccb03eb5d368$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $2CTsY.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $2CTsY.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $2CTsY.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $2CTsY.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($2CTsY.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $2CTsY.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $2CTsY.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $2CTsY.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $2CTsY.StatsigSession.get(this._sdkKey),
            stableID: $2CTsY.StableID.get(this._sdkKey)
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $ebacccb03eb5d368$var$__awaiter(this, void 0, void 0, function*() {
            if (!$2CTsY.Storage.isReady()) yield $2CTsY.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $2CTsY.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $2CTsY._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $2CTsY.StableID.setOverride(stableIdOverride, this._sdkKey);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $2CTsY._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $2CTsY._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $2CTsY._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $2CTsY._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $2CTsY._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $2CTsY._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $2CTsY._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $2CTsY._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $2CTsY._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $2CTsY._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $f5O9f._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $f5O9f._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $2CTsY.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $i90BU.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $5Djoj.StatsigEvaluationsDataAdapter(), network, options);
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($2CTsY.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($2CTsY.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($2CTsY.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($2CTsY.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($2CTsY.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $3Evxa.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
}
module.exports.default = $ebacccb03eb5d368$var$StatsigClient;

});
parcelRegister("3Evxa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2CTsY = parcelRequire("2CTsY");
class $2a8d91827c0480f1$var$EvaluationStore {
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $2CTsY._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $2CTsY._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $2CTsY.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $2CTsY._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $2CTsY.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            if ((0, $2CTsY._getFullUserHash)(user) !== (0, $2CTsY._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
}
module.exports.default = $2a8d91827c0480f1$var$EvaluationStore;

});

parcelRegister("i90BU", function(module, exports) {
"use strict";
var $d3598a7d6f7c2d52$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2CTsY = parcelRequire("2CTsY");

var $bklDq = parcelRequire("bklDq");
class $d3598a7d6f7c2d52$var$StatsigNetwork extends $2CTsY.NetworkCore {
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        var _a, _b, _c, _d, _e, _f;
        return $d3598a7d6f7c2d52$var$__awaiter(this, void 0, void 0, function*() {
            const cache = current ? (0, $2CTsY._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        var _a, _b;
        return $d3598a7d6f7c2d52$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $bklDq._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $2CTsY.UrlConfiguration($2CTsY.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
}
module.exports.default = $d3598a7d6f7c2d52$var$StatsigNetwork;

});
parcelRegister("bklDq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $2CTsY = parcelRequire("2CTsY");
const $83f258321079dcd8$var$MAX_DELTAS_SORT_DEPTH = 2;
function $83f258321079dcd8$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $2CTsY._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $83f258321079dcd8$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $83f258321079dcd8$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $2CTsY._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $83f258321079dcd8$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $83f258321079dcd8$var$_resolveDeltasResponse;
function $83f258321079dcd8$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $83f258321079dcd8$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $83f258321079dcd8$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $83f258321079dcd8$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $83f258321079dcd8$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $83f258321079dcd8$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("f5O9f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $2CTsY = parcelRequire("2CTsY");
const $afce39015f83999d$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $afce39015f83999d$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $afce39015f83999d$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $2CTsY._isTypeMatch)(value, fallback);
}
function $afce39015f83999d$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $afce39015f83999d$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $afce39015f83999d$var$_shouldLogExposure(options) ? undefined : $afce39015f83999d$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $afce39015f83999d$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $afce39015f83999d$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($afce39015f83999d$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($afce39015f83999d$var$_shouldLogExposure(options)) client.getDynamicConfig(param.config_name);
    return value;
}
function $afce39015f83999d$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $afce39015f83999d$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($afce39015f83999d$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($afce39015f83999d$var$_shouldLogExposure(options)) client.getExperiment(param.experiment_name);
    return value;
}
function $afce39015f83999d$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $afce39015f83999d$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($afce39015f83999d$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($afce39015f83999d$var$_shouldLogExposure(options)) client.getLayer(param.layer_name).get(param.param_name);
    return value;
}
function $afce39015f83999d$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $2CTsY._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $afce39015f83999d$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $afce39015f83999d$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $afce39015f83999d$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $afce39015f83999d$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $afce39015f83999d$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $afce39015f83999d$var$_makeParamStoreGetter;

});

parcelRegister("5Djoj", function(module, exports) {
"use strict";
var $419fa2f05f424de6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $2CTsY = parcelRequire("2CTsY");

var $i90BU = parcelRequire("i90BU");
class $419fa2f05f424de6$var$StatsigEvaluationsDataAdapter extends $2CTsY.DataAdapterCore {
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $i90BU.default) this._network = network;
        else this._network = new $i90BU.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $2CTsY._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $2CTsY._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $2CTsY.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        var _a;
        return $419fa2f05f424de6$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $2CTsY._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$2CTsY.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $2CTsY._getFullUserHash)(user);
    }
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
}
module.exports.StatsigEvaluationsDataAdapter = $419fa2f05f424de6$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("jiToV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0daac4091141472$export$2e2bcd8739ae039; });

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");

var $5RCmr = parcelRequire("5RCmr");
function $e0daac4091141472$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e0daac4091141472$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e0daac4091141472$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e0daac4091141472$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e0daac4091141472$export$a66cbd9b2289cd78 = '@all-features';
var $e0daac4091141472$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "eventToValue", new Map());
        this.emitter = new (0, $5RCmr.EventEmitter2)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $e0daac4091141472$var$_objectSpread($e0daac4091141472$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $e0daac4091141472$var$_objectSpread($e0daac4091141472$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $e0daac4091141472$var$_objectSpread($e0daac4091141472$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $e0daac4091141472$var$_objectSpread($e0daac4091141472$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($e0daac4091141472$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($e0daac4091141472$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($e0daac4091141472$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $e0daac4091141472$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("5RCmr", function(module, exports) {
/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */ !function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        var e;
        console.error(errorMsg);
        if (console.trace) console.trace();
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});


parcelRegister("dj9zK", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", function () { return $9b047a34791fcd89$export$6dc24881a3d96325; });

var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $dsuun = parcelRequire("dsuun");
var $9b047a34791fcd89$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $dsuun.migrateEvaluationDetails)(experiment.details), (_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures, (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("dsuun", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $9cc58a5b02dabe28$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $9cc58a5b02dabe28$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $9cc58a5b02dabe28$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $9cc58a5b02dabe28$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $9cc58a5b02dabe28$export$18ad168d3dbac899; });

var $emuQy = parcelRequire("emuQy");

var $iKdEz = parcelRequire("iKdEz");

var $8MJe2 = parcelRequire("8MJe2");

var $79kyO = parcelRequire("79kyO");

var $3W4Zz = parcelRequire("3W4Zz");

var $cTgM0 = parcelRequire("cTgM0");

var $brodC = parcelRequire("brodC");
var $9cc58a5b02dabe28$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $9cc58a5b02dabe28$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9cc58a5b02dabe28$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9cc58a5b02dabe28$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9cc58a5b02dabe28$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9cc58a5b02dabe28$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $9cc58a5b02dabe28$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $3W4Zz.isFedRamp)() ? (0, $brodC.PerimeterType).FEDRAMP_MODERATE : (0, $brodC.PerimeterType).COMMERCIAL
    }, options);
};
var $9cc58a5b02dabe28$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $9cc58a5b02dabe28$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes, sdkKey) {
    var user = {
        customIDs: !(customAttributes !== null && customAttributes !== void 0 && customAttributes.stableID) && sdkKey ? $9cc58a5b02dabe28$var$_objectSpread({
            stableID: (0, $79kyO.StableID).get(sdkKey)
        }, identifiers) : identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $9cc58a5b02dabe28$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(options, $9cc58a5b02dabe28$var$_excluded);
    return $9cc58a5b02dabe28$var$_objectSpread($9cc58a5b02dabe28$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $9cc58a5b02dabe28$var$evaluationReasonMappings = Object.entries((0, $cTgM0.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $9cc58a5b02dabe28$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $9cc58a5b02dabe28$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $cTgM0.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("3W4Zz", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $2ddaa92e960ad312$export$64d6499adf9b2e51; });

var $iMwX0 = parcelRequire("iMwX0");
function $2ddaa92e960ad312$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $iMwX0.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("iMwX0", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $dac64503d92b351f$export$ce553301d55c2fd8; });
var $dac64503d92b351f$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $dac64503d92b351f$export$f005e2e9f707cb5f = 'commercial';
var $dac64503d92b351f$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $dac64503d92b351f$export$a739cd5aac835909 = 'stg';
var $dac64503d92b351f$export$42dd0cdd351a4a9 = 'prod';
var $dac64503d92b351f$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("cTgM0", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", function () { return $9627a1edabe8e16f$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $9627a1edabe8e16f$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("brodC", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $854500a24eab0ab1$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $854500a24eab0ab1$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $854500a24eab0ab1$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $854500a24eab0ab1$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $854500a24eab0ab1$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("h6BJU", function(module, exports) {

$parcel$export(module.exports, "Layer", function () { return $c740457648a6c813$export$936d0764594b6eb3; });

var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $dsuun = parcelRequire("dsuun");
var $c740457648a6c813$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $dsuun.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures, (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures, (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("78a3d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $531113a0d47384e3$export$2e2bcd8739ae039; });

var $8MJe2 = parcelRequire("8MJe2");

var $1uJLd = parcelRequire("1uJLd");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $iQsIh = parcelRequire("iQsIh");

var $brodC = parcelRequire("brodC");

var $cS3lQ = parcelRequire("cS3lQ");

var $6ojtq = parcelRequire("6ojtq");
function $531113a0d47384e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $531113a0d47384e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $531113a0d47384e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $531113a0d47384e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $531113a0d47384e3$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $531113a0d47384e3$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $531113a0d47384e3$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $531113a0d47384e3$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $531113a0d47384e3$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $531113a0d47384e3$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $531113a0d47384e3$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $531113a0d47384e3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $6ojtq.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $6ojtq.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                if (useGatewayUrl) return $531113a0d47384e3$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $brodC.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $brodC.FeatureGateEnvironment).Production:
                        return $531113a0d47384e3$export$18c93900db9358a4;
                    case (0, $brodC.FeatureGateEnvironment).Staging:
                        return $531113a0d47384e3$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $brodC.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $brodC.FeatureGateEnvironment).Development:
                        return $531113a0d47384e3$export$f058dbf75c3bc647;
                    case (0, $brodC.FeatureGateEnvironment).Staging:
                        return $531113a0d47384e3$export$942ba04389b0d5a2;
                    default:
                        return $531113a0d47384e3$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $531113a0d47384e3$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $531113a0d47384e3$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $cS3lQ.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
}();

});
parcelRegister("cS3lQ", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $95ed20aa5df8b120$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $95ed20aa5df8b120$export$a59f8d67326bd1cb = "5.2.0";

});

parcelRegister("6ojtq", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $4a741704c151d266$export$286baf652d0b1206; });

var $6CtYH = parcelRequire("6CtYH");

var $dxrob = parcelRequire("dxrob");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $l8Sa3 = parcelRequire("l8Sa3");

var $3NMuS = parcelRequire("3NMuS");
function $4a741704c151d266$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $4a741704c151d266$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $4a741704c151d266$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4a741704c151d266$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $4a741704c151d266$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, ResponseError);
        return $4a741704c151d266$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3NMuS)))(Error));

});
parcelRegister("eihxX", function(module, exports) {

var $bRUy3 = parcelRequire("bRUy3");
var $a6805b89f289256d$var$_typeof = $bRUy3.default;

var $hCCJ0 = parcelRequire("hCCJ0");
function $a6805b89f289256d$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $a6805b89f289256d$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $hCCJ0(t);
}
module.exports = $a6805b89f289256d$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hCCJ0", function(module, exports) {
function $034f8c7ceea7c4ac$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $034f8c7ceea7c4ac$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("eaTmW", function(module, exports) {
function $a51cf303e6548bcf$var$_getPrototypeOf(t) {
    return module.exports = $a51cf303e6548bcf$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a51cf303e6548bcf$var$_getPrototypeOf(t);
}
module.exports = $a51cf303e6548bcf$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("l8Sa3", function(module, exports) {

var $1BLAE = parcelRequire("1BLAE");
function $f6445b9e0be2a3e5$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $1BLAE(t, e);
}
module.exports = $f6445b9e0be2a3e5$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1BLAE", function(module, exports) {
function $12be2991dd9be400$var$_setPrototypeOf(t, e) {
    return module.exports = $12be2991dd9be400$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $12be2991dd9be400$var$_setPrototypeOf(t, e);
}
module.exports = $12be2991dd9be400$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3NMuS", function(module, exports) {

var $eaTmW = parcelRequire("eaTmW");

var $1BLAE = parcelRequire("1BLAE");

var $dtSoV = parcelRequire("dtSoV");

var $64jOT = parcelRequire("64jOT");
function $2c4b91374c35f541$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $2c4b91374c35f541$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$dtSoV(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $64jOT(t, arguments, $eaTmW(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $1BLAE(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2c4b91374c35f541$var$_wrapNativeSuper(t);
}
module.exports = $2c4b91374c35f541$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dtSoV", function(module, exports) {
function $9d082eb55f744d3a$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $9d082eb55f744d3a$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("64jOT", function(module, exports) {

var $baAKx = parcelRequire("baAKx");

var $1BLAE = parcelRequire("1BLAE");
function $46b27d95ae138841$var$_construct(t, e, r) {
    if ($baAKx()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $1BLAE(p, r.prototype), p;
}
module.exports = $46b27d95ae138841$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("baAKx", function(module, exports) {
function $821d2291835fd002$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $821d2291835fd002$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $821d2291835fd002$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("1Jw6w", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $1432e59e8a1d318e$export$55fffef3474104af; });

var $1uJLd = parcelRequire("1uJLd");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $eKeTJ = parcelRequire("eKeTJ");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $iQsIh = parcelRequire("iQsIh");

var $79kyO = parcelRequire("79kyO");
function $1432e59e8a1d318e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1432e59e8a1d318e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1432e59e8a1d318e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1432e59e8a1d318e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1432e59e8a1d318e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $1432e59e8a1d318e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $1432e59e8a1d318e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1432e59e8a1d318e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1432e59e8a1d318e$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($eKeTJ)))((0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1432e59e8a1d318e$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, NoFetchDataAdapter);
        _this = $1432e59e8a1d318e$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $79kyO.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $1432e59e8a1d318e$var$_objectSpread($1432e59e8a1d318e$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $79kyO._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $1432e59e8a1d318e$var$_objectSpread($1432e59e8a1d318e$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $79kyO._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $79kyO._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $79kyO.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $1432e59e8a1d318e$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $1432e59e8a1d318e$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $79kyO.DataAdapterCore));

});
parcelRegister("eKeTJ", function(module, exports) {

var $fx6ZM = parcelRequire("fx6ZM");
function $abc0eaf9d4faa9e2$var$_get() {
    return module.exports = $abc0eaf9d4faa9e2$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $fx6ZM(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $abc0eaf9d4faa9e2$var$_get.apply(null, arguments);
}
module.exports = $abc0eaf9d4faa9e2$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fx6ZM", function(module, exports) {

var $eaTmW = parcelRequire("eaTmW");
function $b4ef5d3a8759730e$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $eaTmW(t)););
    return t;
}
module.exports = $b4ef5d3a8759730e$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("24YjW", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $183abeeb76faa1e2$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $183abeeb76faa1e2$export$bcb28fbac1def494; });

var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $2CTsY = parcelRequire("2CTsY");
function $183abeeb76faa1e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $183abeeb76faa1e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $183abeeb76faa1e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $183abeeb76faa1e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $183abeeb76faa1e2$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $183abeeb76faa1e2$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $183abeeb76faa1e2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $183abeeb76faa1e2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $183abeeb76faa1e2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $183abeeb76faa1e2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $183abeeb76faa1e2$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $183abeeb76faa1e2$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $183abeeb76faa1e2$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $183abeeb76faa1e2$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $183abeeb76faa1e2$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $183abeeb76faa1e2$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, PersistentOverrideAdapter);
        this._overrides = $183abeeb76faa1e2$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $183abeeb76faa1e2$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $183abeeb76faa1e2$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $183abeeb76faa1e2$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($183abeeb76faa1e2$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($183abeeb76faa1e2$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $183abeeb76faa1e2$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $2CTsY._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, $183abeeb76faa1e2$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($183abeeb76faa1e2$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, current.details), {}, {
                        reason: $183abeeb76faa1e2$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $183abeeb76faa1e2$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($183abeeb76faa1e2$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $2CTsY._makeTypedGet)(current.name, overridden),
                    details: $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, current.details), {}, {
                        reason: $183abeeb76faa1e2$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($183abeeb76faa1e2$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $2CTsY._makeTypedGet)(current.name, overridden),
                    details: $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, current.details), {}, {
                        reason: $183abeeb76faa1e2$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("8w2cM", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $633305cb5e1737cb$export$1c9f709888824e05; });
var $633305cb5e1737cb$var$_process, $633305cb5e1737cb$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $633305cb5e1737cb$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($633305cb5e1737cb$var$_process = globalThis.process) === null || $633305cb5e1737cb$var$_process === void 0 || ($633305cb5e1737cb$var$_process = $633305cb5e1737cb$var$_process.env) === null || $633305cb5e1737cb$var$_process === void 0 ? void 0 : $633305cb5e1737cb$var$_process.JEST_WORKER_ID) !== undefined;
var $633305cb5e1737cb$var$DEBUG_MODE = !$633305cb5e1737cb$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($633305cb5e1737cb$var$_process2 = globalThis.process) === null || $633305cb5e1737cb$var$_process2 === void 0 || ($633305cb5e1737cb$var$_process2 = $633305cb5e1737cb$var$_process2.env) === null || $633305cb5e1737cb$var$_process2 === void 0 ? void 0 : $633305cb5e1737cb$var$_process2.NODE_ENV) !== 'production';
var $633305cb5e1737cb$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$633305cb5e1737cb$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("eqAsb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a80fc555fff80865$var$_react = $a80fc555fff80865$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $fExrr = parcelRequire("fExrr");

var $a80fc555fff80865$var$_chevronDown = $a80fc555fff80865$var$_interopRequireDefault((parcelRequire("7DmNu")));
function $a80fc555fff80865$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a80fc555fff80865$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $a80fc555fff80865$var$_react.default.createElement($fExrr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $a80fc555fff80865$var$_chevronDown.default
    }));
$a80fc555fff80865$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $a80fc555fff80865$var$_default = module.exports.default = $a80fc555fff80865$var$ChevronDownIcon;

});
parcelRegister("fExrr", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $b654884211effdff$export$3cfb73f70dfca966; });

var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

var $g6xTB = parcelRequire("g6xTB");
var $b654884211effdff$var$_excluded = [
    "dangerouslySetGlyph",
    "size"
];
var $b654884211effdff$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $b654884211effdff$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $7fPBF.memo)(function IconFacade(_ref) {
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $b654884211effdff$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var iconSize = size !== null && size !== void 0 ? size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $137Lh.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (iconSize === 'small' || iconSize === 'medium') && !(0, $137Lh.fg)('platform-visual-refresh-icons-facade-removal')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
                spacing: (0, $137Lh.fg)('platform-visual-refresh-icons-facade-button-fix') ? $b654884211effdff$var$sizeSpacingMap['utility'][iconSize] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
                size: iconSize,
                spacing: $b654884211effdff$var$sizeSpacingMap['core'][iconSize],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $g6xTB.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size
    }, props));
});

});
parcelRegister("cvBp9", function(module, exports) {
function $91b5651481cc9d5c$var$_extends() {
    return module.exports = $91b5651481cc9d5c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $91b5651481cc9d5c$var$_extends.apply(null, arguments);
}
module.exports = $91b5651481cc9d5c$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("g6xTB", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $bb977fe39a4e8498$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");
function $bb977fe39a4e8498$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bb977fe39a4e8498$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bb977fe39a4e8498$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bb977fe39a4e8498$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $bb977fe39a4e8498$var$iconStyles = null;
var $bb977fe39a4e8498$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $bb977fe39a4e8498$var$baseHcmStyles = null;
var $bb977fe39a4e8498$var$primaryEqualsSecondaryHcmStyles = null;
var $bb977fe39a4e8498$var$secondaryTransparentHcmStyles = null;
var $bb977fe39a4e8498$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $7fPBF.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $bb977fe39a4e8498$var$_objectSpread($bb977fe39a4e8498$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $fjFkG.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $bb977fe39a4e8498$var$sizeStyles[size]
        ])
    }));
});
var $bb977fe39a4e8498$export$2e2bcd8739ae039 = $bb977fe39a4e8498$export$f04a61298a47a40f;

});



parcelRegister("bWpDC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70e4741cbfa8f6087ac64902b38a7366>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b18ffa52acfaefc$var$_react = $8b18ffa52acfaefc$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $8b18ffa52acfaefc$var$_baseNew = $8b18ffa52acfaefc$var$_interopRequireDefault((parcelRequire("aUDbt")));
function $8b18ffa52acfaefc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b18ffa52acfaefc$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $8b18ffa52acfaefc$var$_react.default.createElement($8b18ffa52acfaefc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$8b18ffa52acfaefc$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $8b18ffa52acfaefc$var$_default = module.exports.default = $8b18ffa52acfaefc$var$CrossCircleIcon;

});

parcelRegister("dWyuK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a26b731c29e4f4e3$var$_react = $a26b731c29e4f4e3$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $fExrr = parcelRequire("fExrr");

var $a26b731c29e4f4e3$var$_crossCircle = $a26b731c29e4f4e3$var$_interopRequireDefault((parcelRequire("bWpDC")));
function $a26b731c29e4f4e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a26b731c29e4f4e3$var$SelectClearIcon = (props)=>/*#__PURE__*/ $a26b731c29e4f4e3$var$_react.default.createElement($fExrr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $a26b731c29e4f4e3$var$_crossCircle.default
    }));
$a26b731c29e4f4e3$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $a26b731c29e4f4e3$var$_default = module.exports.default = $a26b731c29e4f4e3$var$SelectClearIcon;

});

parcelRegister("8lLl9", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $614501a942df47fa$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $614501a942df47fa$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $614501a942df47fa$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $614501a942df47fa$export$352e418ed5b6193a; });
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", function () { return $614501a942df47fa$export$dddac1532e822863; });
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $614501a942df47fa$export$9d7b58831ae93caa; });
var $614501a942df47fa$export$4ef52930e33717cd = 'data-theme';
var $614501a942df47fa$export$a00eac3f8684bcd0 = 'data-color-mode';
var $614501a942df47fa$export$2112803007239c61 = 'data-contrast-mode';
var $614501a942df47fa$export$352e418ed5b6193a = 'data-custom-theme';
var $614501a942df47fa$export$6f0c6fb8c80fcc92 = 'ds';
var $614501a942df47fa$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $614501a942df47fa$export$dddac1532e822863 = "--".concat($614501a942df47fa$export$6f0c6fb8c80fcc92, "-token-not-found");
var $614501a942df47fa$export$9d7b58831ae93caa = "--".concat($614501a942df47fa$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("45MkT", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $2fad1f91101d4119$export$2b8d127b894957b9; }, function (v) { return $2fad1f91101d4119$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $2fad1f91101d4119$export$cea3a54a6425200c; }, function (v) { return $2fad1f91101d4119$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $2fad1f91101d4119$export$a7c73072b1a182ae; }, function (v) { return $2fad1f91101d4119$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2fad1f91101d4119$export$9f27bc3417b4524d; }, function (v) { return $2fad1f91101d4119$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2fad1f91101d4119$export$db77ccec0bb4ccac; }, function (v) { return $2fad1f91101d4119$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2fad1f91101d4119$export$8392c0c9d3dcbd35; }, function (v) { return $2fad1f91101d4119$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2fad1f91101d4119$export$ffb0004e005737fa; }, function (v) { return $2fad1f91101d4119$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2fad1f91101d4119$export$b624eff549462981; }, function (v) { return $2fad1f91101d4119$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2fad1f91101d4119$export$7897aa7841a5380c; }, function (v) { return $2fad1f91101d4119$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2fad1f91101d4119$export$602eac185826482c; }, function (v) { return $2fad1f91101d4119$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2fad1f91101d4119$export$e2c29f18771995cb; }, function (v) { return $2fad1f91101d4119$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2fad1f91101d4119$export$5f8d39834fd61797; }, function (v) { return $2fad1f91101d4119$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2fad1f91101d4119$export$74bf444e3cd11ea5; }, function (v) { return $2fad1f91101d4119$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2fad1f91101d4119$export$92387174baf9b227; }, function (v) { return $2fad1f91101d4119$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2fad1f91101d4119$export$ec112efeb987d9c6; }, function (v) { return $2fad1f91101d4119$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2fad1f91101d4119$export$b706b080d889d2c9; }, function (v) { return $2fad1f91101d4119$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2fad1f91101d4119$export$5be5a87408f70ddc; }, function (v) { return $2fad1f91101d4119$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2fad1f91101d4119$export$45a5e7f76e0caa8d; }, function (v) { return $2fad1f91101d4119$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2fad1f91101d4119$export$455c2e768291efa6; }, function (v) { return $2fad1f91101d4119$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2fad1f91101d4119$export$9522e17588c12572; }, function (v) { return $2fad1f91101d4119$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2fad1f91101d4119$export$2110ac352bb060b9; }, function (v) { return $2fad1f91101d4119$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2fad1f91101d4119$export$56885ab8b9c456ab; }, function (v) { return $2fad1f91101d4119$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2fad1f91101d4119$export$d927fcb6adf8f9de; }, function (v) { return $2fad1f91101d4119$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2fad1f91101d4119$export$b82d16f27459e05a; }, function (v) { return $2fad1f91101d4119$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2fad1f91101d4119$export$522c17b4f5e123e8; }, function (v) { return $2fad1f91101d4119$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2fad1f91101d4119$export$1aabd8a0274ecfd6; }, function (v) { return $2fad1f91101d4119$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2fad1f91101d4119$export$9b621391a187a31a; }, function (v) { return $2fad1f91101d4119$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2fad1f91101d4119$export$f5bbd400c2f4426f; }, function (v) { return $2fad1f91101d4119$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2fad1f91101d4119$export$2b8d127b894957b9;
var $2fad1f91101d4119$export$cea3a54a6425200c;
var $2fad1f91101d4119$export$a7c73072b1a182ae;
var $2fad1f91101d4119$export$9f27bc3417b4524d;
var $2fad1f91101d4119$export$db77ccec0bb4ccac;
var $2fad1f91101d4119$export$8392c0c9d3dcbd35;
var $2fad1f91101d4119$export$ffb0004e005737fa;
var $2fad1f91101d4119$export$b624eff549462981;
var $2fad1f91101d4119$export$7897aa7841a5380c;
var $2fad1f91101d4119$export$602eac185826482c;
var $2fad1f91101d4119$export$e2c29f18771995cb;
var $2fad1f91101d4119$export$5f8d39834fd61797;
var $2fad1f91101d4119$export$74bf444e3cd11ea5;
var $2fad1f91101d4119$export$92387174baf9b227;
var $2fad1f91101d4119$export$ec112efeb987d9c6;
var $2fad1f91101d4119$export$b706b080d889d2c9;
var $2fad1f91101d4119$export$5be5a87408f70ddc;
var $2fad1f91101d4119$export$45a5e7f76e0caa8d;
var $2fad1f91101d4119$export$455c2e768291efa6;
var $2fad1f91101d4119$export$9522e17588c12572;
var $2fad1f91101d4119$export$2110ac352bb060b9;
var $2fad1f91101d4119$export$56885ab8b9c456ab;
var $2fad1f91101d4119$export$d927fcb6adf8f9de;
var $2fad1f91101d4119$export$b82d16f27459e05a;
var $2fad1f91101d4119$export$522c17b4f5e123e8;
var $2fad1f91101d4119$export$1aabd8a0274ecfd6;
var $2fad1f91101d4119$export$9b621391a187a31a;
var $2fad1f91101d4119$export$f5bbd400c2f4426f;
'use strict';
var $2fad1f91101d4119$var$b = "function" === typeof Symbol && Symbol.for, $2fad1f91101d4119$var$c = $2fad1f91101d4119$var$b ? Symbol.for("react.element") : 60103, $2fad1f91101d4119$var$d = $2fad1f91101d4119$var$b ? Symbol.for("react.portal") : 60106, $2fad1f91101d4119$var$e = $2fad1f91101d4119$var$b ? Symbol.for("react.fragment") : 60107, $2fad1f91101d4119$var$f = $2fad1f91101d4119$var$b ? Symbol.for("react.strict_mode") : 60108, $2fad1f91101d4119$var$g = $2fad1f91101d4119$var$b ? Symbol.for("react.profiler") : 60114, $2fad1f91101d4119$var$h = $2fad1f91101d4119$var$b ? Symbol.for("react.provider") : 60109, $2fad1f91101d4119$var$k = $2fad1f91101d4119$var$b ? Symbol.for("react.context") : 60110, $2fad1f91101d4119$var$l = $2fad1f91101d4119$var$b ? Symbol.for("react.async_mode") : 60111, $2fad1f91101d4119$var$m = $2fad1f91101d4119$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2fad1f91101d4119$var$n = $2fad1f91101d4119$var$b ? Symbol.for("react.forward_ref") : 60112, $2fad1f91101d4119$var$p = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense") : 60113, $2fad1f91101d4119$var$q = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense_list") : 60120, $2fad1f91101d4119$var$r = $2fad1f91101d4119$var$b ? Symbol.for("react.memo") : 60115, $2fad1f91101d4119$var$t = $2fad1f91101d4119$var$b ? Symbol.for("react.lazy") : 60116, $2fad1f91101d4119$var$v = $2fad1f91101d4119$var$b ? Symbol.for("react.block") : 60121, $2fad1f91101d4119$var$w = $2fad1f91101d4119$var$b ? Symbol.for("react.fundamental") : 60117, $2fad1f91101d4119$var$x = $2fad1f91101d4119$var$b ? Symbol.for("react.responder") : 60118, $2fad1f91101d4119$var$y = $2fad1f91101d4119$var$b ? Symbol.for("react.scope") : 60119;
function $2fad1f91101d4119$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2fad1f91101d4119$var$c:
                switch(a = a.type, a){
                    case $2fad1f91101d4119$var$l:
                    case $2fad1f91101d4119$var$m:
                    case $2fad1f91101d4119$var$e:
                    case $2fad1f91101d4119$var$g:
                    case $2fad1f91101d4119$var$f:
                    case $2fad1f91101d4119$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2fad1f91101d4119$var$k:
                            case $2fad1f91101d4119$var$n:
                            case $2fad1f91101d4119$var$t:
                            case $2fad1f91101d4119$var$r:
                            case $2fad1f91101d4119$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2fad1f91101d4119$var$d:
                return u;
        }
    }
}
function $2fad1f91101d4119$var$A(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$m;
}
$2fad1f91101d4119$export$2b8d127b894957b9 = $2fad1f91101d4119$var$l;
$2fad1f91101d4119$export$cea3a54a6425200c = $2fad1f91101d4119$var$m;
$2fad1f91101d4119$export$a7c73072b1a182ae = $2fad1f91101d4119$var$k;
$2fad1f91101d4119$export$9f27bc3417b4524d = $2fad1f91101d4119$var$h;
$2fad1f91101d4119$export$db77ccec0bb4ccac = $2fad1f91101d4119$var$c;
$2fad1f91101d4119$export$8392c0c9d3dcbd35 = $2fad1f91101d4119$var$n;
$2fad1f91101d4119$export$ffb0004e005737fa = $2fad1f91101d4119$var$e;
$2fad1f91101d4119$export$b624eff549462981 = $2fad1f91101d4119$var$t;
$2fad1f91101d4119$export$7897aa7841a5380c = $2fad1f91101d4119$var$r;
$2fad1f91101d4119$export$602eac185826482c = $2fad1f91101d4119$var$d;
$2fad1f91101d4119$export$e2c29f18771995cb = $2fad1f91101d4119$var$g;
$2fad1f91101d4119$export$5f8d39834fd61797 = $2fad1f91101d4119$var$f;
$2fad1f91101d4119$export$74bf444e3cd11ea5 = $2fad1f91101d4119$var$p;
$2fad1f91101d4119$export$92387174baf9b227 = function(a) {
    return $2fad1f91101d4119$var$A(a) || $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$l;
};
$2fad1f91101d4119$export$ec112efeb987d9c6 = $2fad1f91101d4119$var$A;
$2fad1f91101d4119$export$b706b080d889d2c9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$k;
};
$2fad1f91101d4119$export$5be5a87408f70ddc = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$h;
};
$2fad1f91101d4119$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2fad1f91101d4119$var$c;
};
$2fad1f91101d4119$export$455c2e768291efa6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$n;
};
$2fad1f91101d4119$export$9522e17588c12572 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$e;
};
$2fad1f91101d4119$export$2110ac352bb060b9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$t;
};
$2fad1f91101d4119$export$56885ab8b9c456ab = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$r;
};
$2fad1f91101d4119$export$d927fcb6adf8f9de = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$d;
};
$2fad1f91101d4119$export$b82d16f27459e05a = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$g;
};
$2fad1f91101d4119$export$522c17b4f5e123e8 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$f;
};
$2fad1f91101d4119$export$1aabd8a0274ecfd6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$p;
};
$2fad1f91101d4119$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2fad1f91101d4119$var$e || a === $2fad1f91101d4119$var$m || a === $2fad1f91101d4119$var$g || a === $2fad1f91101d4119$var$f || a === $2fad1f91101d4119$var$p || a === $2fad1f91101d4119$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2fad1f91101d4119$var$t || a.$$typeof === $2fad1f91101d4119$var$r || a.$$typeof === $2fad1f91101d4119$var$h || a.$$typeof === $2fad1f91101d4119$var$k || a.$$typeof === $2fad1f91101d4119$var$n || a.$$typeof === $2fad1f91101d4119$var$w || a.$$typeof === $2fad1f91101d4119$var$x || a.$$typeof === $2fad1f91101d4119$var$y || a.$$typeof === $2fad1f91101d4119$var$v);
};
$2fad1f91101d4119$export$f5bbd400c2f4426f = $2fad1f91101d4119$var$z;

});

parcelRegister("4X8HT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1a026656028c05157ac730015f665601>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $39b36d1d1aee5f81$var$_react = $39b36d1d1aee5f81$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $39b36d1d1aee5f81$var$_baseNew = $39b36d1d1aee5f81$var$_interopRequireDefault((parcelRequire("ep5sO")));
function $39b36d1d1aee5f81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $39b36d1d1aee5f81$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $39b36d1d1aee5f81$var$_react.default.createElement($39b36d1d1aee5f81$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.03 3.97 6 7.94l3.97-3.97 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$39b36d1d1aee5f81$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $39b36d1d1aee5f81$var$_default = module.exports.default = $39b36d1d1aee5f81$var$ChevronDownIcon;

});
parcelRegister("ep5sO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("7GJe1")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("7GJe1")).Icon; });

var $7GJe1 = parcelRequire("7GJe1");

});
parcelRegister("7GJe1", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $598f896800024c3e$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $598f896800024c3e$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7c0nF = parcelRequire("7c0nF");

var $137Lh = parcelRequire("137Lh");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $598f896800024c3e$var$svgStyles = null;
var $598f896800024c3e$var$iconStyles = null;
var $598f896800024c3e$var$utilityIconStyles = null;
var $598f896800024c3e$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $598f896800024c3e$var$baseHcmStyles = null;
var $598f896800024c3e$var$scaleSize = null;
var $598f896800024c3e$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $598f896800024c3e$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $598f896800024c3e$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $598f896800024c3e$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $598f896800024c3e$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $598f896800024c3e$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $137Lh.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $7fPBF.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'size' in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === 'small' || props.size === 'medium') ? props.size : 'medium';
    var baseSize = $598f896800024c3e$var$baseSizeMap[type];
    var viewBoxPadding = $598f896800024c3e$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $7c0nF.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $7c0nF.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $598f896800024c3e$var$utilSizes[spacing] : size === 'small' ? $598f896800024c3e$var$coreSizeSmall[spacing] : $598f896800024c3e$var$coreSizeMedium[spacing]
        ])
    }));
});
var $598f896800024c3e$export$2e2bcd8739ae039 = $598f896800024c3e$export$f04a61298a47a40f;

});
parcelRegister("7c0nF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53c9f3002085b935$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $53c9f3002085b935$var$ATOMIC_GROUP_LENGTH = 5;
function $53c9f3002085b935$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $53c9f3002085b935$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("2Ef5E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1edb05c3c700028a$var$_react = $1edb05c3c700028a$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $lu09g = parcelRequire("lu09g");

var $1edb05c3c700028a$var$_chevronDown = $1edb05c3c700028a$var$_interopRequireDefault((parcelRequire("bC5rg")));
function $1edb05c3c700028a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1edb05c3c700028a$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $1edb05c3c700028a$var$_react.default.createElement($lu09g.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $1edb05c3c700028a$var$_chevronDown.default
    }));
$1edb05c3c700028a$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $1edb05c3c700028a$var$_default = module.exports.default = $1edb05c3c700028a$var$ChevronDownIcon;

});
parcelRegister("lu09g", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $fa3c83cb3a044844$export$3cfb73f70dfca966; });

var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

var $iCZQU = parcelRequire("iCZQU");
var $fa3c83cb3a044844$var$_excluded = [
    "dangerouslySetGlyph",
    "size"
];
var $fa3c83cb3a044844$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $fa3c83cb3a044844$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $7fPBF.memo)(function IconFacade(_ref) {
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $fa3c83cb3a044844$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var iconSize = size !== null && size !== void 0 ? size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $137Lh.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (iconSize === 'small' || iconSize === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
                spacing: (0, $137Lh.fg)('platform-visual-refresh-icons-facade-button-fix') ? $fa3c83cb3a044844$var$sizeSpacingMap['utility'][iconSize] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
                size: iconSize,
                spacing: $fa3c83cb3a044844$var$sizeSpacingMap['core'][iconSize],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $iCZQU.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size
    }, props));
});

});
parcelRegister("iCZQU", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $d8fbc12d0c2bc201$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

var $7c0nF = parcelRequire("7c0nF");
function $d8fbc12d0c2bc201$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d8fbc12d0c2bc201$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d8fbc12d0c2bc201$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d8fbc12d0c2bc201$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $d8fbc12d0c2bc201$var$iconStyles = null;
var $d8fbc12d0c2bc201$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $d8fbc12d0c2bc201$var$baseHcmStyles = null;
var $d8fbc12d0c2bc201$var$primaryEqualsSecondaryHcmStyles = null;
var $d8fbc12d0c2bc201$var$secondaryTransparentHcmStyles = null;
var $d8fbc12d0c2bc201$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $7fPBF.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $d8fbc12d0c2bc201$var$_objectSpread($d8fbc12d0c2bc201$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $7c0nF.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $d8fbc12d0c2bc201$var$sizeStyles[size]
        ])
    }));
});
var $d8fbc12d0c2bc201$export$2e2bcd8739ae039 = $d8fbc12d0c2bc201$export$f04a61298a47a40f;

});


parcelRegister("bC5rg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::05a4941b07732842dd47a8ac581e394b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $022e926cdc9ff4be$var$_react = $022e926cdc9ff4be$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $022e926cdc9ff4be$var$_baseNew = $022e926cdc9ff4be$var$_interopRequireDefault((parcelRequire("ep5sO")));
function $022e926cdc9ff4be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $022e926cdc9ff4be$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $022e926cdc9ff4be$var$_react.default.createElement($022e926cdc9ff4be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$022e926cdc9ff4be$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $022e926cdc9ff4be$var$_default = module.exports.default = $022e926cdc9ff4be$var$ChevronDownIcon;

});


parcelRegister("5hU4u", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $3d9a08e3b6c15e3c$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $3d9a08e3b6c15e3c$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $3d9a08e3b6c15e3c$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $3d9a08e3b6c15e3c$export$2e2bcd8739ae039; });

var $137Lh = parcelRequire("137Lh");
var $3d9a08e3b6c15e3c$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $3d9a08e3b6c15e3c$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $3d9a08e3b6c15e3c$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $3d9a08e3b6c15e3c$var$themeOverrideIds = [];
var $3d9a08e3b6c15e3c$export$92ba366331403db2 = [].concat($3d9a08e3b6c15e3c$export$7d43e72a58e3283f, $3d9a08e3b6c15e3c$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $3d9a08e3b6c15e3c$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Atlassian Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
var $3d9a08e3b6c15e3c$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: function typography() {
        if ((0, $137Lh.fg)('platform-disable-default-typography')) return undefined;
        return 'typography';
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $3d9a08e3b6c15e3c$export$2e2bcd8739ae039 = $3d9a08e3b6c15e3c$var$themeConfig;

});

parcelRegister("llyT9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8a69f4ab751b6b7$var$_react = $f8a69f4ab751b6b7$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $f8a69f4ab751b6b7$var$_baseNew = $f8a69f4ab751b6b7$var$_interopRequireDefault((parcelRequire("gxWof")));
function $f8a69f4ab751b6b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8a69f4ab751b6b7$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f8a69f4ab751b6b7$var$_react.default.createElement($f8a69f4ab751b6b7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$f8a69f4ab751b6b7$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $f8a69f4ab751b6b7$var$_default = module.exports.default = $f8a69f4ab751b6b7$var$ChevronDownIcon;

});
parcelRegister("gxWof", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hgZDh")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("hgZDh")).Icon; });

var $hgZDh = parcelRequire("hgZDh");

});
parcelRegister("hgZDh", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $c933bd3fba31e2cc$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $c933bd3fba31e2cc$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $6Lozc = parcelRequire("6Lozc");

var $137Lh = parcelRequire("137Lh");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $c933bd3fba31e2cc$var$svgStyles = null;
var $c933bd3fba31e2cc$var$iconStyles = null;
var $c933bd3fba31e2cc$var$utilityIconStyles = null;
var $c933bd3fba31e2cc$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $c933bd3fba31e2cc$var$baseHcmStyles = null;
var $c933bd3fba31e2cc$var$scaleSize = null;
var $c933bd3fba31e2cc$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c933bd3fba31e2cc$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c933bd3fba31e2cc$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c933bd3fba31e2cc$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $c933bd3fba31e2cc$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $c933bd3fba31e2cc$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $137Lh.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $7fPBF.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'size' in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === 'small' || props.size === 'medium') ? props.size : 'medium';
    var baseSize = $c933bd3fba31e2cc$var$baseSizeMap[type];
    var viewBoxPadding = $c933bd3fba31e2cc$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $6Lozc.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $6Lozc.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $c933bd3fba31e2cc$var$utilSizes[spacing] : size === 'small' ? $c933bd3fba31e2cc$var$coreSizeSmall[spacing] : $c933bd3fba31e2cc$var$coreSizeMedium[spacing]
        ])
    }));
});
var $c933bd3fba31e2cc$export$2e2bcd8739ae039 = $c933bd3fba31e2cc$export$f04a61298a47a40f;

});
parcelRegister("6Lozc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4eca304bc1ee46bd$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $4eca304bc1ee46bd$var$ATOMIC_GROUP_LENGTH = 5;
function $4eca304bc1ee46bd$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $4eca304bc1ee46bd$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("4K7uO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $374145dc722743c8$var$_react = $374145dc722743c8$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $69FjU = parcelRequire("69FjU");

var $374145dc722743c8$var$_chevronDown = $374145dc722743c8$var$_interopRequireDefault((parcelRequire("llyT9")));
function $374145dc722743c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $374145dc722743c8$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $374145dc722743c8$var$_react.default.createElement($69FjU.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $374145dc722743c8$var$_chevronDown.default
    }));
$374145dc722743c8$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $374145dc722743c8$var$_default = module.exports.default = $374145dc722743c8$var$ChevronDownIcon;

});
parcelRegister("69FjU", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $47b3a2a61c17286c$export$3cfb73f70dfca966; });

var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

var $3lIEn = parcelRequire("3lIEn");
var $47b3a2a61c17286c$var$_excluded = [
    "dangerouslySetGlyph",
    "size"
];
var $47b3a2a61c17286c$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $47b3a2a61c17286c$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $7fPBF.memo)(function IconFacade(_ref) {
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $47b3a2a61c17286c$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var iconSize = size !== null && size !== void 0 ? size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $137Lh.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (iconSize === 'small' || iconSize === 'medium') && !(0, $137Lh.fg)('platform-visual-refresh-icons-facade-removal')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
                spacing: (0, $137Lh.fg)('platform-visual-refresh-icons-facade-button-fix') ? $47b3a2a61c17286c$var$sizeSpacingMap['utility'][iconSize] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
                size: iconSize,
                spacing: $47b3a2a61c17286c$var$sizeSpacingMap['core'][iconSize],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3lIEn.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size
    }, props));
});

});
parcelRegister("3lIEn", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $2705f7dee5c0b5ef$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

var $6Lozc = parcelRequire("6Lozc");
function $2705f7dee5c0b5ef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2705f7dee5c0b5ef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2705f7dee5c0b5ef$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2705f7dee5c0b5ef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $2705f7dee5c0b5ef$var$iconStyles = null;
var $2705f7dee5c0b5ef$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $2705f7dee5c0b5ef$var$baseHcmStyles = null;
var $2705f7dee5c0b5ef$var$primaryEqualsSecondaryHcmStyles = null;
var $2705f7dee5c0b5ef$var$secondaryTransparentHcmStyles = null;
var $2705f7dee5c0b5ef$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $7fPBF.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $2705f7dee5c0b5ef$var$_objectSpread($2705f7dee5c0b5ef$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $6Lozc.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $2705f7dee5c0b5ef$var$sizeStyles[size]
        ])
    }));
});
var $2705f7dee5c0b5ef$export$2e2bcd8739ae039 = $2705f7dee5c0b5ef$export$f04a61298a47a40f;

});



parcelRegister("264Or", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f99ea99a006a4f29d6a537b27790dcf5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $186fdff88c3afb61$var$_react = $186fdff88c3afb61$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $186fdff88c3afb61$var$_baseNew = $186fdff88c3afb61$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $186fdff88c3afb61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $186fdff88c3afb61$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $186fdff88c3afb61$var$_react.default.createElement($186fdff88c3afb61$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$186fdff88c3afb61$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $186fdff88c3afb61$var$_default = module.exports.default = $186fdff88c3afb61$var$StatusErrorIcon;

});
parcelRegister("f6lOK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("fZxDR")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("fZxDR")).Icon; });

var $fZxDR = parcelRequire("fZxDR");

});
parcelRegister("fZxDR", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $ba46a615b0544762$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $ba46a615b0544762$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $heZxp = parcelRequire("heZxp");

var $137Lh = parcelRequire("137Lh");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $ba46a615b0544762$var$svgStyles = null;
var $ba46a615b0544762$var$iconStyles = null;
var $ba46a615b0544762$var$utilityIconStyles = null;
var $ba46a615b0544762$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $ba46a615b0544762$var$baseHcmStyles = null;
var $ba46a615b0544762$var$scaleSize = null;
var $ba46a615b0544762$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $ba46a615b0544762$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $ba46a615b0544762$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $ba46a615b0544762$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $ba46a615b0544762$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $ba46a615b0544762$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $137Lh.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $7fPBF.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'size' in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === 'small' || props.size === 'medium') ? props.size : 'medium';
    var baseSize = $ba46a615b0544762$var$baseSizeMap[type];
    var viewBoxPadding = $ba46a615b0544762$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $heZxp.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $heZxp.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $ba46a615b0544762$var$utilSizes[spacing] : size === 'small' ? $ba46a615b0544762$var$coreSizeSmall[spacing] : $ba46a615b0544762$var$coreSizeMedium[spacing]
        ])
    }));
});
var $ba46a615b0544762$export$2e2bcd8739ae039 = $ba46a615b0544762$export$f04a61298a47a40f;

});
parcelRegister("heZxp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8d37a9a26aaefb0$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c8d37a9a26aaefb0$var$ATOMIC_GROUP_LENGTH = 5;
function $c8d37a9a26aaefb0$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $c8d37a9a26aaefb0$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("2cGKh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $19addc1a38efda41$var$_react = $19addc1a38efda41$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $4FBec = parcelRequire("4FBec");

var $19addc1a38efda41$var$_statusError = $19addc1a38efda41$var$_interopRequireDefault((parcelRequire("264Or")));
function $19addc1a38efda41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $19addc1a38efda41$var$ErrorIcon = (props)=>/*#__PURE__*/ $19addc1a38efda41$var$_react.default.createElement($4FBec.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $19addc1a38efda41$var$_statusError.default
    }));
$19addc1a38efda41$var$ErrorIcon.displayName = 'ErrorIcon';
var $19addc1a38efda41$var$_default = module.exports.default = $19addc1a38efda41$var$ErrorIcon;

});
parcelRegister("4FBec", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $3667de7de94d8553$export$3cfb73f70dfca966; });

var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

var $gEeYX = parcelRequire("gEeYX");
var $3667de7de94d8553$var$_excluded = [
    "dangerouslySetGlyph",
    "size"
];
var $3667de7de94d8553$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $3667de7de94d8553$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $7fPBF.memo)(function IconFacade(_ref) {
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $3667de7de94d8553$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var iconSize = size !== null && size !== void 0 ? size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $137Lh.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (iconSize === 'small' || iconSize === 'medium') && !(0, $137Lh.fg)('platform-visual-refresh-icons-facade-removal')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
                spacing: (0, $137Lh.fg)('platform-visual-refresh-icons-facade-button-fix') ? $3667de7de94d8553$var$sizeSpacingMap['utility'][iconSize] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
                size: iconSize,
                spacing: $3667de7de94d8553$var$sizeSpacingMap['core'][iconSize],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $gEeYX.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size
    }, props));
});

});
parcelRegister("gEeYX", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $c1ec00eab56ec1e7$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

var $heZxp = parcelRequire("heZxp");
function $c1ec00eab56ec1e7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c1ec00eab56ec1e7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c1ec00eab56ec1e7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c1ec00eab56ec1e7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $c1ec00eab56ec1e7$var$iconStyles = null;
var $c1ec00eab56ec1e7$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $c1ec00eab56ec1e7$var$baseHcmStyles = null;
var $c1ec00eab56ec1e7$var$primaryEqualsSecondaryHcmStyles = null;
var $c1ec00eab56ec1e7$var$secondaryTransparentHcmStyles = null;
var $c1ec00eab56ec1e7$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $7fPBF.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $c1ec00eab56ec1e7$var$_objectSpread($c1ec00eab56ec1e7$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $heZxp.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $c1ec00eab56ec1e7$var$sizeStyles[size]
        ])
    }));
});
var $c1ec00eab56ec1e7$export$2e2bcd8739ae039 = $c1ec00eab56ec1e7$export$f04a61298a47a40f;

});



parcelRegister("luGLu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0749aecb688ec01c0962b8f7fb609ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa5d928e9c6324b1$var$_react = $fa5d928e9c6324b1$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $fa5d928e9c6324b1$var$_baseNew = $fa5d928e9c6324b1$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $fa5d928e9c6324b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa5d928e9c6324b1$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $fa5d928e9c6324b1$var$_react.default.createElement($fa5d928e9c6324b1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$fa5d928e9c6324b1$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $fa5d928e9c6324b1$var$_default = module.exports.default = $fa5d928e9c6324b1$var$StatusInformationIcon;

});

parcelRegister("hPfJq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfa36712d1fc1a46$var$_react = $cfa36712d1fc1a46$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $4FBec = parcelRequire("4FBec");

var $cfa36712d1fc1a46$var$_statusInformation = $cfa36712d1fc1a46$var$_interopRequireDefault((parcelRequire("luGLu")));
function $cfa36712d1fc1a46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cfa36712d1fc1a46$var$InfoIcon = (props)=>/*#__PURE__*/ $cfa36712d1fc1a46$var$_react.default.createElement($4FBec.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $cfa36712d1fc1a46$var$_statusInformation.default
    }));
$cfa36712d1fc1a46$var$InfoIcon.displayName = 'InfoIcon';
var $cfa36712d1fc1a46$var$_default = module.exports.default = $cfa36712d1fc1a46$var$InfoIcon;

});

parcelRegister("8tDnM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8cc756abdbbefcea85e2842ee2eda39e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62bf94bdf62f31e4$var$_react = $62bf94bdf62f31e4$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $62bf94bdf62f31e4$var$_baseNew = $62bf94bdf62f31e4$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $62bf94bdf62f31e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62bf94bdf62f31e4$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $62bf94bdf62f31e4$var$_react.default.createElement($62bf94bdf62f31e4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$62bf94bdf62f31e4$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $62bf94bdf62f31e4$var$_default = module.exports.default = $62bf94bdf62f31e4$var$StatusSuccessIcon;

});

parcelRegister("7hr2m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $54cf17f5790b8384$var$_react = $54cf17f5790b8384$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $4FBec = parcelRequire("4FBec");

var $54cf17f5790b8384$var$_statusSuccess = $54cf17f5790b8384$var$_interopRequireDefault((parcelRequire("8tDnM")));
function $54cf17f5790b8384$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $54cf17f5790b8384$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $54cf17f5790b8384$var$_react.default.createElement($4FBec.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $54cf17f5790b8384$var$_statusSuccess.default
    }));
$54cf17f5790b8384$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $54cf17f5790b8384$var$_default = module.exports.default = $54cf17f5790b8384$var$CheckCircleIcon;

});

parcelRegister("gU0Nr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::435e803a057e79e21a0d31c5b12f3f81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4e27e7a081af661$var$_react = $c4e27e7a081af661$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $c4e27e7a081af661$var$_baseNew = $c4e27e7a081af661$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $c4e27e7a081af661$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4e27e7a081af661$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $c4e27e7a081af661$var$_react.default.createElement($c4e27e7a081af661$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$c4e27e7a081af661$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $c4e27e7a081af661$var$_default = module.exports.default = $c4e27e7a081af661$var$StatusWarningIcon;

});

parcelRegister("4QU9n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $388792feba9ba23d$var$_react = $388792feba9ba23d$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $4FBec = parcelRequire("4FBec");

var $388792feba9ba23d$var$_statusWarning = $388792feba9ba23d$var$_interopRequireDefault((parcelRequire("gU0Nr")));
function $388792feba9ba23d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $388792feba9ba23d$var$WarningIcon = (props)=>/*#__PURE__*/ $388792feba9ba23d$var$_react.default.createElement($4FBec.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $388792feba9ba23d$var$_statusWarning.default
    }));
$388792feba9ba23d$var$WarningIcon.displayName = 'WarningIcon';
var $388792feba9ba23d$var$_default = module.exports.default = $388792feba9ba23d$var$WarningIcon;

});

parcelRegister("hu3zC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cba802a82a24161e$var$_react = $cba802a82a24161e$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $cba802a82a24161e$var$_baseNew = $cba802a82a24161e$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $cba802a82a24161e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cba802a82a24161e$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $cba802a82a24161e$var$_react.default.createElement($cba802a82a24161e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$cba802a82a24161e$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $cba802a82a24161e$var$_default = module.exports.default = $cba802a82a24161e$var$ChevronDownIcon;

});

parcelRegister("8KEcT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65f1cedfd01a8ae1$var$_react = $65f1cedfd01a8ae1$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $4FBec = parcelRequire("4FBec");

var $65f1cedfd01a8ae1$var$_chevronDown = $65f1cedfd01a8ae1$var$_interopRequireDefault((parcelRequire("hu3zC")));
function $65f1cedfd01a8ae1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $65f1cedfd01a8ae1$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $65f1cedfd01a8ae1$var$_react.default.createElement($4FBec.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $65f1cedfd01a8ae1$var$_chevronDown.default
    }));
$65f1cedfd01a8ae1$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $65f1cedfd01a8ae1$var$_default = module.exports.default = $65f1cedfd01a8ae1$var$HipchatChevronDownIcon;

});

parcelRegister("3hgRg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::186cfd732e4641b5fdb3f2d7a456f10c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2630094b350cbf69$var$_react = $2630094b350cbf69$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $2630094b350cbf69$var$_baseNew = $2630094b350cbf69$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $2630094b350cbf69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2630094b350cbf69$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $2630094b350cbf69$var$_react.default.createElement($2630094b350cbf69$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$2630094b350cbf69$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $2630094b350cbf69$var$_default = module.exports.default = $2630094b350cbf69$var$ChevronUpIcon;

});

parcelRegister("cJGmK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $945a8cfe58449573$var$_react = $945a8cfe58449573$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $4FBec = parcelRequire("4FBec");

var $945a8cfe58449573$var$_chevronUp = $945a8cfe58449573$var$_interopRequireDefault((parcelRequire("3hgRg")));
function $945a8cfe58449573$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $945a8cfe58449573$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $945a8cfe58449573$var$_react.default.createElement($4FBec.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $945a8cfe58449573$var$_chevronUp.default
    }));
$945a8cfe58449573$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $945a8cfe58449573$var$_default = module.exports.default = $945a8cfe58449573$var$HipchatChevronUpIcon;

});

parcelRegister("lXchJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::85cb292de644104b34b7dd23f5bdf435>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ffb8a32ff5060866$var$_react = $ffb8a32ff5060866$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $ffb8a32ff5060866$var$_baseNew = $ffb8a32ff5060866$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $ffb8a32ff5060866$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ffb8a32ff5060866$var$CrossIcon = (props)=>/*#__PURE__*/ $ffb8a32ff5060866$var$_react.default.createElement($ffb8a32ff5060866$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$ffb8a32ff5060866$var$CrossIcon.displayName = 'CrossIcon';
var $ffb8a32ff5060866$var$_default = module.exports.default = $ffb8a32ff5060866$var$CrossIcon;

});

parcelRegister("emdez", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a73d62c785d65561$var$_react = $a73d62c785d65561$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $4FBec = parcelRequire("4FBec");

var $a73d62c785d65561$var$_cross = $a73d62c785d65561$var$_interopRequireDefault((parcelRequire("lXchJ")));
function $a73d62c785d65561$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a73d62c785d65561$var$CrossIcon = (props)=>/*#__PURE__*/ $a73d62c785d65561$var$_react.default.createElement($4FBec.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $a73d62c785d65561$var$_cross.default
    }));
$a73d62c785d65561$var$CrossIcon.displayName = 'CrossIcon';
var $a73d62c785d65561$var$_default = module.exports.default = $a73d62c785d65561$var$CrossIcon;

});

parcelRegister("3B4Ta", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::85cb292de644104b34b7dd23f5bdf435>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29e89e9de0ccad8a$var$_react = $29e89e9de0ccad8a$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $29e89e9de0ccad8a$var$_baseNew = $29e89e9de0ccad8a$var$_interopRequireDefault((parcelRequire("b0TAn")));
function $29e89e9de0ccad8a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29e89e9de0ccad8a$var$CrossIcon = (props)=>/*#__PURE__*/ $29e89e9de0ccad8a$var$_react.default.createElement($29e89e9de0ccad8a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$29e89e9de0ccad8a$var$CrossIcon.displayName = 'CrossIcon';
var $29e89e9de0ccad8a$var$_default = module.exports.default = $29e89e9de0ccad8a$var$CrossIcon;

});
parcelRegister("b0TAn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("cFKeb")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("cFKeb")).Icon; });

var $cFKeb = parcelRequire("cFKeb");

});
parcelRegister("cFKeb", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $939d2c37ca117576$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $939d2c37ca117576$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $euWUS = parcelRequire("euWUS");

var $137Lh = parcelRequire("137Lh");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $939d2c37ca117576$var$svgStyles = null;
var $939d2c37ca117576$var$iconStyles = null;
var $939d2c37ca117576$var$utilityIconStyles = null;
var $939d2c37ca117576$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $939d2c37ca117576$var$baseHcmStyles = null;
var $939d2c37ca117576$var$scaleSize = null;
var $939d2c37ca117576$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $939d2c37ca117576$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $939d2c37ca117576$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $939d2c37ca117576$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $939d2c37ca117576$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $939d2c37ca117576$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $137Lh.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $7fPBF.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'size' in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === 'small' || props.size === 'medium') ? props.size : 'medium';
    var baseSize = $939d2c37ca117576$var$baseSizeMap[type];
    var viewBoxPadding = $939d2c37ca117576$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $euWUS.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $euWUS.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $939d2c37ca117576$var$utilSizes[spacing] : size === 'small' ? $939d2c37ca117576$var$coreSizeSmall[spacing] : $939d2c37ca117576$var$coreSizeMedium[spacing]
        ])
    }));
});
var $939d2c37ca117576$export$2e2bcd8739ae039 = $939d2c37ca117576$export$f04a61298a47a40f;

});
parcelRegister("euWUS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8e19196a072296f$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $a8e19196a072296f$var$ATOMIC_GROUP_LENGTH = 5;
function $a8e19196a072296f$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $a8e19196a072296f$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("fHEud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6ea46ec95e62a7d$var$_react = $b6ea46ec95e62a7d$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $hqn7I = parcelRequire("hqn7I");

var $b6ea46ec95e62a7d$var$_cross = $b6ea46ec95e62a7d$var$_interopRequireDefault((parcelRequire("3B4Ta")));
function $b6ea46ec95e62a7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b6ea46ec95e62a7d$var$CrossIcon = (props)=>/*#__PURE__*/ $b6ea46ec95e62a7d$var$_react.default.createElement($hqn7I.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $b6ea46ec95e62a7d$var$_cross.default
    }));
$b6ea46ec95e62a7d$var$CrossIcon.displayName = 'CrossIcon';
var $b6ea46ec95e62a7d$var$_default = module.exports.default = $b6ea46ec95e62a7d$var$CrossIcon;

});
parcelRegister("hqn7I", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $caf6cd348c7c9a2c$export$3cfb73f70dfca966; });

var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

var $hZl6Y = parcelRequire("hZl6Y");
var $caf6cd348c7c9a2c$var$_excluded = [
    "dangerouslySetGlyph",
    "size"
];
var $caf6cd348c7c9a2c$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $caf6cd348c7c9a2c$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $7fPBF.memo)(function IconFacade(_ref) {
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $caf6cd348c7c9a2c$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var iconSize = size !== null && size !== void 0 ? size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $137Lh.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (iconSize === 'small' || iconSize === 'medium') && !(0, $137Lh.fg)('platform-visual-refresh-icons-facade-removal')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
                spacing: (0, $137Lh.fg)('platform-visual-refresh-icons-facade-button-fix') ? $caf6cd348c7c9a2c$var$sizeSpacingMap['utility'][iconSize] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
                size: iconSize,
                spacing: $caf6cd348c7c9a2c$var$sizeSpacingMap['core'][iconSize],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $hZl6Y.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size
    }, props));
});

});
parcelRegister("hZl6Y", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $d1888279aeb3d646$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

var $euWUS = parcelRequire("euWUS");
function $d1888279aeb3d646$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d1888279aeb3d646$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d1888279aeb3d646$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d1888279aeb3d646$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $d1888279aeb3d646$var$iconStyles = null;
var $d1888279aeb3d646$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $d1888279aeb3d646$var$baseHcmStyles = null;
var $d1888279aeb3d646$var$primaryEqualsSecondaryHcmStyles = null;
var $d1888279aeb3d646$var$secondaryTransparentHcmStyles = null;
var $d1888279aeb3d646$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $7fPBF.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $d1888279aeb3d646$var$_objectSpread($d1888279aeb3d646$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $euWUS.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $d1888279aeb3d646$var$sizeStyles[size]
        ])
    }));
});
var $d1888279aeb3d646$export$2e2bcd8739ae039 = $d1888279aeb3d646$export$f04a61298a47a40f;

});



parcelRegister("6nN1q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffbdc778869407ee1ee67d41c1920845>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a5aeac98925e3b7$var$_react = $4a5aeac98925e3b7$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $4a5aeac98925e3b7$var$_baseNew = $4a5aeac98925e3b7$var$_interopRequireDefault((parcelRequire("b0TAn")));
function $4a5aeac98925e3b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a5aeac98925e3b7$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $4a5aeac98925e3b7$var$_react.default.createElement($4a5aeac98925e3b7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$4a5aeac98925e3b7$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $4a5aeac98925e3b7$var$_default = module.exports.default = $4a5aeac98925e3b7$var$DiscoveryIcon;

});

parcelRegister("cUujz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96623ade984bfe54$var$_react = $96623ade984bfe54$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $hqn7I = parcelRequire("hqn7I");

var $96623ade984bfe54$var$_discovery = $96623ade984bfe54$var$_interopRequireDefault((parcelRequire("6nN1q")));
function $96623ade984bfe54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $96623ade984bfe54$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $96623ade984bfe54$var$_react.default.createElement($hqn7I.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        newIcon: $96623ade984bfe54$var$_discovery.default
    }));
$96623ade984bfe54$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $96623ade984bfe54$var$_default = module.exports.default = $96623ade984bfe54$var$EditorNoteIcon;

});

parcelRegister("iT7j6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63dc429f33c9470dc156b62d0ec66db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc03081abda3e4da$var$_react = $dc03081abda3e4da$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $dc03081abda3e4da$var$_baseNew = $dc03081abda3e4da$var$_interopRequireDefault((parcelRequire("b0TAn")));
function $dc03081abda3e4da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc03081abda3e4da$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $dc03081abda3e4da$var$_react.default.createElement($dc03081abda3e4da$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$dc03081abda3e4da$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $dc03081abda3e4da$var$_default = module.exports.default = $dc03081abda3e4da$var$QuestionCircleIcon;

});

parcelRegister("1IZVR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1419f0ef12e243bd$var$_react = $1419f0ef12e243bd$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $hqn7I = parcelRequire("hqn7I");

var $1419f0ef12e243bd$var$_questionCircle = $1419f0ef12e243bd$var$_interopRequireDefault((parcelRequire("iT7j6")));
function $1419f0ef12e243bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1419f0ef12e243bd$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $1419f0ef12e243bd$var$_react.default.createElement($hqn7I.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $1419f0ef12e243bd$var$_questionCircle.default
    }));
$1419f0ef12e243bd$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $1419f0ef12e243bd$var$_default = module.exports.default = $1419f0ef12e243bd$var$QuestionCircleIcon;

});

parcelRegister("ealUj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f99ea99a006a4f29d6a537b27790dcf5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a502fe2da2f2733f$var$_react = $a502fe2da2f2733f$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $a502fe2da2f2733f$var$_baseNew = $a502fe2da2f2733f$var$_interopRequireDefault((parcelRequire("b0TAn")));
function $a502fe2da2f2733f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a502fe2da2f2733f$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $a502fe2da2f2733f$var$_react.default.createElement($a502fe2da2f2733f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$a502fe2da2f2733f$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $a502fe2da2f2733f$var$_default = module.exports.default = $a502fe2da2f2733f$var$StatusErrorIcon;

});

parcelRegister("kTrDZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f35e633cc061ee7e$var$_react = $f35e633cc061ee7e$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $hqn7I = parcelRequire("hqn7I");

var $f35e633cc061ee7e$var$_statusError = $f35e633cc061ee7e$var$_interopRequireDefault((parcelRequire("ealUj")));
function $f35e633cc061ee7e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f35e633cc061ee7e$var$ErrorIcon = (props)=>/*#__PURE__*/ $f35e633cc061ee7e$var$_react.default.createElement($hqn7I.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $f35e633cc061ee7e$var$_statusError.default
    }));
$f35e633cc061ee7e$var$ErrorIcon.displayName = 'ErrorIcon';
var $f35e633cc061ee7e$var$_default = module.exports.default = $f35e633cc061ee7e$var$ErrorIcon;

});

parcelRegister("a6Ah9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0749aecb688ec01c0962b8f7fb609ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75b69a83cb8865ce$var$_react = $75b69a83cb8865ce$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $75b69a83cb8865ce$var$_baseNew = $75b69a83cb8865ce$var$_interopRequireDefault((parcelRequire("b0TAn")));
function $75b69a83cb8865ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75b69a83cb8865ce$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $75b69a83cb8865ce$var$_react.default.createElement($75b69a83cb8865ce$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$75b69a83cb8865ce$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $75b69a83cb8865ce$var$_default = module.exports.default = $75b69a83cb8865ce$var$StatusInformationIcon;

});

parcelRegister("iLRpF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $daa60c787599e21d$var$_react = $daa60c787599e21d$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $hqn7I = parcelRequire("hqn7I");

var $daa60c787599e21d$var$_statusInformation = $daa60c787599e21d$var$_interopRequireDefault((parcelRequire("a6Ah9")));
function $daa60c787599e21d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $daa60c787599e21d$var$InfoIcon = (props)=>/*#__PURE__*/ $daa60c787599e21d$var$_react.default.createElement($hqn7I.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $daa60c787599e21d$var$_statusInformation.default
    }));
$daa60c787599e21d$var$InfoIcon.displayName = 'InfoIcon';
var $daa60c787599e21d$var$_default = module.exports.default = $daa60c787599e21d$var$InfoIcon;

});

parcelRegister("2RIHD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8cc756abdbbefcea85e2842ee2eda39e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21633511c8e1b93e$var$_react = $21633511c8e1b93e$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $21633511c8e1b93e$var$_baseNew = $21633511c8e1b93e$var$_interopRequireDefault((parcelRequire("b0TAn")));
function $21633511c8e1b93e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21633511c8e1b93e$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $21633511c8e1b93e$var$_react.default.createElement($21633511c8e1b93e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$21633511c8e1b93e$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $21633511c8e1b93e$var$_default = module.exports.default = $21633511c8e1b93e$var$StatusSuccessIcon;

});

parcelRegister("eGV7J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab214c82769e4dee$var$_react = $ab214c82769e4dee$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $hqn7I = parcelRequire("hqn7I");

var $ab214c82769e4dee$var$_statusSuccess = $ab214c82769e4dee$var$_interopRequireDefault((parcelRequire("2RIHD")));
function $ab214c82769e4dee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ab214c82769e4dee$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $ab214c82769e4dee$var$_react.default.createElement($hqn7I.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $ab214c82769e4dee$var$_statusSuccess.default
    }));
$ab214c82769e4dee$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $ab214c82769e4dee$var$_default = module.exports.default = $ab214c82769e4dee$var$CheckCircleIcon;

});

parcelRegister("esxeA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::435e803a057e79e21a0d31c5b12f3f81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a86d75d381b64e7e$var$_react = $a86d75d381b64e7e$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $a86d75d381b64e7e$var$_baseNew = $a86d75d381b64e7e$var$_interopRequireDefault((parcelRequire("b0TAn")));
function $a86d75d381b64e7e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a86d75d381b64e7e$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $a86d75d381b64e7e$var$_react.default.createElement($a86d75d381b64e7e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$a86d75d381b64e7e$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $a86d75d381b64e7e$var$_default = module.exports.default = $a86d75d381b64e7e$var$StatusWarningIcon;

});

parcelRegister("24VLH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1838c41493cd4f5b$var$_react = $1838c41493cd4f5b$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $hqn7I = parcelRequire("hqn7I");

var $1838c41493cd4f5b$var$_statusWarning = $1838c41493cd4f5b$var$_interopRequireDefault((parcelRequire("esxeA")));
function $1838c41493cd4f5b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1838c41493cd4f5b$var$WarningIcon = (props)=>/*#__PURE__*/ $1838c41493cd4f5b$var$_react.default.createElement($hqn7I.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $1838c41493cd4f5b$var$_statusWarning.default
    }));
$1838c41493cd4f5b$var$WarningIcon.displayName = 'WarningIcon';
var $1838c41493cd4f5b$var$_default = module.exports.default = $1838c41493cd4f5b$var$WarningIcon;

});

parcelRegister("18Jal", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::85cb292de644104b34b7dd23f5bdf435>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d4992c8c1557c6e$var$_react = $0d4992c8c1557c6e$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $0d4992c8c1557c6e$var$_baseNew = $0d4992c8c1557c6e$var$_interopRequireDefault((parcelRequire("kHIu0")));
function $0d4992c8c1557c6e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0d4992c8c1557c6e$var$CrossIcon = (props)=>/*#__PURE__*/ $0d4992c8c1557c6e$var$_react.default.createElement($0d4992c8c1557c6e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$0d4992c8c1557c6e$var$CrossIcon.displayName = 'CrossIcon';
var $0d4992c8c1557c6e$var$_default = module.exports.default = $0d4992c8c1557c6e$var$CrossIcon;

});
parcelRegister("kHIu0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("2mZcx")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("2mZcx")).Icon; });

var $2mZcx = parcelRequire("2mZcx");

});
parcelRegister("2mZcx", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $1b9d1c1d17fb303b$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $1b9d1c1d17fb303b$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");

var $137Lh = parcelRequire("137Lh");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $1b9d1c1d17fb303b$var$svgStyles = null;
var $1b9d1c1d17fb303b$var$iconStyles = null;
var $1b9d1c1d17fb303b$var$utilityIconStyles = null;
var $1b9d1c1d17fb303b$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $1b9d1c1d17fb303b$var$baseHcmStyles = null;
var $1b9d1c1d17fb303b$var$scaleSize = null;
var $1b9d1c1d17fb303b$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $1b9d1c1d17fb303b$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $1b9d1c1d17fb303b$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $1b9d1c1d17fb303b$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $1b9d1c1d17fb303b$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $1b9d1c1d17fb303b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $137Lh.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $7fPBF.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'size' in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === 'small' || props.size === 'medium') ? props.size : 'medium';
    var baseSize = $1b9d1c1d17fb303b$var$baseSizeMap[type];
    var viewBoxPadding = $1b9d1c1d17fb303b$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $iRmtv.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $iRmtv.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $1b9d1c1d17fb303b$var$utilSizes[spacing] : size === 'small' ? $1b9d1c1d17fb303b$var$coreSizeSmall[spacing] : $1b9d1c1d17fb303b$var$coreSizeMedium[spacing]
        ])
    }));
});
var $1b9d1c1d17fb303b$export$2e2bcd8739ae039 = $1b9d1c1d17fb303b$export$f04a61298a47a40f;

});
parcelRegister("iRmtv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbae9c46c22067c0$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $dbae9c46c22067c0$var$ATOMIC_GROUP_LENGTH = 5;
function $dbae9c46c22067c0$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $dbae9c46c22067c0$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("c0dBm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bd0091e0ab76e56$var$_react = $8bd0091e0ab76e56$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $a962l = parcelRequire("a962l");

var $8bd0091e0ab76e56$var$_cross = $8bd0091e0ab76e56$var$_interopRequireDefault((parcelRequire("18Jal")));
function $8bd0091e0ab76e56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8bd0091e0ab76e56$var$CrossIcon = (props)=>/*#__PURE__*/ $8bd0091e0ab76e56$var$_react.default.createElement($a962l.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $8bd0091e0ab76e56$var$_cross.default
    }));
$8bd0091e0ab76e56$var$CrossIcon.displayName = 'CrossIcon';
var $8bd0091e0ab76e56$var$_default = module.exports.default = $8bd0091e0ab76e56$var$CrossIcon;

});
parcelRegister("a962l", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $762f6d6d7a59550b$export$3cfb73f70dfca966; });

var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

var $dQ1qH = parcelRequire("dQ1qH");
var $762f6d6d7a59550b$var$_excluded = [
    "dangerouslySetGlyph",
    "size"
];
var $762f6d6d7a59550b$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $762f6d6d7a59550b$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $7fPBF.memo)(function IconFacade(_ref) {
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $762f6d6d7a59550b$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var iconSize = size !== null && size !== void 0 ? size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $137Lh.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (iconSize === 'small' || iconSize === 'medium') && !(0, $137Lh.fg)('platform-visual-refresh-icons-facade-removal')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
                spacing: (0, $137Lh.fg)('platform-visual-refresh-icons-facade-button-fix') ? $762f6d6d7a59550b$var$sizeSpacingMap['utility'][iconSize] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
                size: iconSize,
                spacing: $762f6d6d7a59550b$var$sizeSpacingMap['core'][iconSize],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $dQ1qH.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size
    }, props));
});

});
parcelRegister("dQ1qH", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $a1313d923d0730f2$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");
function $a1313d923d0730f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a1313d923d0730f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a1313d923d0730f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a1313d923d0730f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $a1313d923d0730f2$var$iconStyles = null;
var $a1313d923d0730f2$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $a1313d923d0730f2$var$baseHcmStyles = null;
var $a1313d923d0730f2$var$primaryEqualsSecondaryHcmStyles = null;
var $a1313d923d0730f2$var$secondaryTransparentHcmStyles = null;
var $a1313d923d0730f2$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $7fPBF.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $a1313d923d0730f2$var$_objectSpread($a1313d923d0730f2$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $iRmtv.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $a1313d923d0730f2$var$sizeStyles[size]
        ])
    }));
});
var $a1313d923d0730f2$export$2e2bcd8739ae039 = $a1313d923d0730f2$export$f04a61298a47a40f;

});



parcelRegister("ctZOH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f99ea99a006a4f29d6a537b27790dcf5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $916824fcac3dc8a3$var$_react = $916824fcac3dc8a3$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $916824fcac3dc8a3$var$_baseNew = $916824fcac3dc8a3$var$_interopRequireDefault((parcelRequire("kHIu0")));
function $916824fcac3dc8a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $916824fcac3dc8a3$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $916824fcac3dc8a3$var$_react.default.createElement($916824fcac3dc8a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$916824fcac3dc8a3$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $916824fcac3dc8a3$var$_default = module.exports.default = $916824fcac3dc8a3$var$StatusErrorIcon;

});

parcelRegister("7aNfw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $538fab72d04509db$var$_react = $538fab72d04509db$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $a962l = parcelRequire("a962l");

var $538fab72d04509db$var$_statusError = $538fab72d04509db$var$_interopRequireDefault((parcelRequire("ctZOH")));
function $538fab72d04509db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $538fab72d04509db$var$ErrorIcon = (props)=>/*#__PURE__*/ $538fab72d04509db$var$_react.default.createElement($a962l.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $538fab72d04509db$var$_statusError.default
    }));
$538fab72d04509db$var$ErrorIcon.displayName = 'ErrorIcon';
var $538fab72d04509db$var$_default = module.exports.default = $538fab72d04509db$var$ErrorIcon;

});

parcelRegister("3i1H6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::435e803a057e79e21a0d31c5b12f3f81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26545dff2c625c5f$var$_react = $26545dff2c625c5f$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $26545dff2c625c5f$var$_baseNew = $26545dff2c625c5f$var$_interopRequireDefault((parcelRequire("kHIu0")));
function $26545dff2c625c5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26545dff2c625c5f$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $26545dff2c625c5f$var$_react.default.createElement($26545dff2c625c5f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$26545dff2c625c5f$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $26545dff2c625c5f$var$_default = module.exports.default = $26545dff2c625c5f$var$StatusWarningIcon;

});

parcelRegister("47SDm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $301232094c29fd8c$var$_react = $301232094c29fd8c$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $a962l = parcelRequire("a962l");

var $301232094c29fd8c$var$_statusWarning = $301232094c29fd8c$var$_interopRequireDefault((parcelRequire("3i1H6")));
function $301232094c29fd8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $301232094c29fd8c$var$WarningIcon = (props)=>/*#__PURE__*/ $301232094c29fd8c$var$_react.default.createElement($a962l.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $301232094c29fd8c$var$_statusWarning.default
    }));
$301232094c29fd8c$var$WarningIcon.displayName = 'WarningIcon';
var $301232094c29fd8c$var$_default = module.exports.default = $301232094c29fd8c$var$WarningIcon;

});

parcelRegister("jOXxA", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", function () { return $e6e0df60acd8cc9b$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $e6e0df60acd8cc9b$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $e6e0df60acd8cc9b$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $e6e0df60acd8cc9b$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $e6e0df60acd8cc9b$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $e6e0df60acd8cc9b$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $e6e0df60acd8cc9b$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $e6e0df60acd8cc9b$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $e6e0df60acd8cc9b$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $e6e0df60acd8cc9b$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $e6e0df60acd8cc9b$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $e6e0df60acd8cc9b$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $e6e0df60acd8cc9b$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $e6e0df60acd8cc9b$export$b36dbdb4f463f05c(hex) {
    if (!$e6e0df60acd8cc9b$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $e6e0df60acd8cc9b$export$1212645cf40ebf71(hex)
    ];
}
function $e6e0df60acd8cc9b$export$5a544e13ad4e1fa5(hex) {
    if (!$e6e0df60acd8cc9b$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $e6e0df60acd8cc9b$export$47ea145a83f50dc0(hex) {
    if (!$e6e0df60acd8cc9b$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $e6e0df60acd8cc9b$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $e6e0df60acd8cc9b$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $e6e0df60acd8cc9b$export$d061e26956a60b0a(foreground, background) {
    if (!$e6e0df60acd8cc9b$var$isValidHex(foreground) || !$e6e0df60acd8cc9b$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $e6e0df60acd8cc9b$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $e6e0df60acd8cc9b$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $e6e0df60acd8cc9b$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $e6e0df60acd8cc9b$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $e6e0df60acd8cc9b$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $e6e0df60acd8cc9b$var$rgbToLab(rgbA);
    var labB = $e6e0df60acd8cc9b$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $e6e0df60acd8cc9b$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("aKhos", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $7d2bb13f8f5eb3cb$export$d6af199866bfb566; });
var $7d2bb13f8f5eb3cb$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("bz8Ps", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("9rEnE")).then(()=>parcelRequire('7FPgW'));

});
parcelRegister("1iyJ7", function(module, exports) {
"use strict";

var $e0V30 = parcelRequire("e0V30");
module.exports = $e0V30(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("e0V30", function(module, exports) {
"use strict";
var $a33d51355b1da95d$var$cachedBundles = {};
var $a33d51355b1da95d$var$cachedPreloads = {};
var $a33d51355b1da95d$var$cachedPrefetches = {};
function $a33d51355b1da95d$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a33d51355b1da95d$var$cachedPreloads;
        case 'prefetch':
            return $a33d51355b1da95d$var$cachedPrefetches;
        default:
            return $a33d51355b1da95d$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a33d51355b1da95d$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("eGQ21", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("9nrl5")).then(()=>parcelRequire('2SARw'));

});

parcelRegister("gU9qf", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("kKEq1")).then(()=>parcelRequire('660uU'));

});

parcelRegister("tYGmt", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("4BkNt")).then(()=>parcelRequire('5ylOV'));

});

parcelRegister("5odVw", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("l2NFd")).then(()=>parcelRequire('81LMM'));

});

parcelRegister("lEc7H", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("7U7jT")).then(()=>parcelRequire('lMFiT'));

});

parcelRegister("7jEDe", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("jNjGP")).then(()=>parcelRequire('g14Gk'));

});

parcelRegister("iwfb1", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("1GWQl")).then(()=>parcelRequire('2VB0s'));

});

parcelRegister("l25Vt", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("ePrS2")).then(()=>parcelRequire('61QGK'));

});

parcelRegister("5pkn0", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("3QeHF")).then(()=>parcelRequire('5A80C'));

});

parcelRegister("a0cHd", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("k5c9G")).then(()=>parcelRequire('aWENk'));

});

parcelRegister("cxyww", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("6fTiS")).then(()=>parcelRequire('6QEEp'));

});

parcelRegister("3QI2a", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("7KzkM")).then(()=>parcelRequire('eEpqQ'));

});

parcelRegister("OArPy", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("1tKDH")).then(()=>parcelRequire('hPpqW'));

});

parcelRegister("5qswd", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("8Pkd7")).then(()=>parcelRequire('lbsbf'));

});

parcelRegister("6ELYd", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("jRfUw")).then(()=>parcelRequire('d5IMH'));

});

parcelRegister("kkUFX", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $ece1a38bcbc2763e$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $ece1a38bcbc2763e$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $ece1a38bcbc2763e$export$e673f367da2ff23e; });

var $iKdEz = parcelRequire("iKdEz");

var $j9spr = parcelRequire("j9spr");

var $mc37r = parcelRequire("mc37r");

var $8lLl9 = parcelRequire("8lLl9");

var $aKhos = parcelRequire("aKhos");
function $ece1a38bcbc2763e$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $aKhos.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $8lLl9.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $8lLl9.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $ece1a38bcbc2763e$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(Array.from(document.head.querySelectorAll("style[".concat((0, $8lLl9.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $8lLl9.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $ece1a38bcbc2763e$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $mc37r.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

});
parcelRegister("mc37r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $042b66ee07ee2364$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e39d81369b0c277ebeac5d0b02ae5cb>>
 * @codegenCommand yarn build tokens
 */ var $042b66ee07ee2364$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body'
};
var $042b66ee07ee2364$export$2e2bcd8739ae039 = $042b66ee07ee2364$var$tokens;

});


parcelRegister("4EwZ6", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("9ujxL")).then(()=>parcelRequire('2ZqZM'));

});

var $553ef412ccd351b3$exports = {};
$parcel$extendImportMap({
    "9rEnE": "atlassian-light.1fb9e9a4.js",
    "9nrl5": "atlassian-light-future.cad338b4.js",
    "kKEq1": "atlassian-light-increased-contrast.0bc2762b.js",
    "4BkNt": "atlassian-dark.784dea3f.js",
    "l2NFd": "atlassian-dark-future.5ba7e2b3.js",
    "7U7jT": "atlassian-dark-increased-contrast.c9369d01.js",
    "jNjGP": "atlassian-legacy-light.7cffb73d.js",
    "1GWQl": "atlassian-legacy-dark.f31d1770.js",
    "ePrS2": "atlassian-spacing.8a4b5280.js",
    "3QeHF": "atlassian-typography.3967f4b3.js",
    "k5c9G": "atlassian-typography-adg3.dc58f56c.js",
    "6fTiS": "atlassian-shape.fcbce33c.js",
    "7KzkM": "atlassian-typography-modernized.03ca79bb.js",
    "1tKDH": "atlassian-typography-refreshed.001d650b.js",
    "8Pkd7": "atlassian-light-brand-refresh.821dea88.js",
    "jRfUw": "atlassian-dark-brand-refresh.c9bbee6e.js",
    "9ujxL": "custom-theme.51df7207.js"
});

var $824c049f32d4395d$exports = {};
'use strict';

$824c049f32d4395d$exports = (parcelRequire("2nzLi"));


parcelRequire("7fPBF");
var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
'use strict';
var $b4ba1c853f6e1116$exports = {};
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

$b4ba1c853f6e1116$exports = (parcelRequire("6EA3T"));


var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $b4ba1c853f6e1116$exports.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $b4ba1c853f6e1116$exports.hydrateRoot;



var $7fPBF = parcelRequire("7fPBF");
var $c1c6d595ff42d79c$exports = {};
'use strict';

$c1c6d595ff42d79c$exports = (parcelRequire("i5uoL"));


var $f30b917334351296$var$__defProp = Object.defineProperty;
var $f30b917334351296$var$__defProps = Object.defineProperties;
var $f30b917334351296$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f30b917334351296$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f30b917334351296$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f30b917334351296$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f30b917334351296$var$__defNormalProp = (obj, key, value)=>key in obj ? $f30b917334351296$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f30b917334351296$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f30b917334351296$var$__hasOwnProp.call(b, prop)) $f30b917334351296$var$__defNormalProp(a, prop, b[prop]);
    if ($f30b917334351296$var$__getOwnPropSymbols) {
        for (var prop of $f30b917334351296$var$__getOwnPropSymbols(b))if ($f30b917334351296$var$__propIsEnum.call(b, prop)) $f30b917334351296$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f30b917334351296$var$__spreadProps = (a, b)=>$f30b917334351296$var$__defProps(a, $f30b917334351296$var$__getOwnPropDescs(b));
var $f30b917334351296$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f30b917334351296$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f30b917334351296$var$__getOwnPropSymbols) {
        for (var prop of $f30b917334351296$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f30b917334351296$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $f30b917334351296$var$IS_REACT_19 = /* @__PURE__ */ $7fPBF.version.startsWith("19");
var $f30b917334351296$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($f30b917334351296$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $f30b917334351296$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $f30b917334351296$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $f30b917334351296$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $f30b917334351296$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $f30b917334351296$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $f30b917334351296$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $f30b917334351296$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $f30b917334351296$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $f30b917334351296$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $f30b917334351296$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $f30b917334351296$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $f30b917334351296$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $f30b917334351296$var$ForwardRef = $f30b917334351296$var$REACT_FORWARD_REF_TYPE;
var $f30b917334351296$var$Memo = $f30b917334351296$var$REACT_MEMO_TYPE;
function $f30b917334351296$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $f30b917334351296$var$REACT_FRAGMENT_TYPE || type === $f30b917334351296$var$REACT_PROFILER_TYPE || type === $f30b917334351296$var$REACT_STRICT_MODE_TYPE || type === $f30b917334351296$var$REACT_SUSPENSE_TYPE || type === $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE || type === $f30b917334351296$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $f30b917334351296$var$REACT_LAZY_TYPE || type.$$typeof === $f30b917334351296$var$REACT_MEMO_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CONTEXT_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CONSUMER_TYPE || type.$$typeof === $f30b917334351296$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $f30b917334351296$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $f30b917334351296$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $f30b917334351296$var$REACT_FRAGMENT_TYPE:
                    case $f30b917334351296$var$REACT_PROFILER_TYPE:
                    case $f30b917334351296$var$REACT_STRICT_MODE_TYPE:
                    case $f30b917334351296$var$REACT_SUSPENSE_TYPE:
                    case $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $f30b917334351296$var$REACT_CONTEXT_TYPE:
                            case $f30b917334351296$var$REACT_FORWARD_REF_TYPE:
                            case $f30b917334351296$var$REACT_LAZY_TYPE:
                            case $f30b917334351296$var$REACT_MEMO_TYPE:
                                return object;
                            case $f30b917334351296$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $f30b917334351296$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $f30b917334351296$var$isContextConsumer(object) {
    return $f30b917334351296$var$IS_REACT_19 ? $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_CONSUMER_TYPE : $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_CONTEXT_TYPE;
}
function $f30b917334351296$var$isMemo(object) {
    return $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $f30b917334351296$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $f30b917334351296$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $f30b917334351296$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $f30b917334351296$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $f30b917334351296$var$verify(mapStateToProps, "mapStateToProps");
    $f30b917334351296$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $f30b917334351296$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $f30b917334351296$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $f30b917334351296$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $f30b917334351296$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $f30b917334351296$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $f30b917334351296$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $f30b917334351296$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $f30b917334351296$var$verifyPlainObject(value, displayName, methodName) {
    if (!$f30b917334351296$var$isPlainObject(value)) $f30b917334351296$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $f30b917334351296$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $f30b917334351296$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $f30b917334351296$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $f30b917334351296$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $f30b917334351296$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $f30b917334351296$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $f30b917334351296$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $f30b917334351296$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $f30b917334351296$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $f30b917334351296$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $f30b917334351296$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $f30b917334351296$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $f30b917334351296$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $f30b917334351296$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $f30b917334351296$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $f30b917334351296$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $f30b917334351296$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $f30b917334351296$var$__spreadValues($f30b917334351296$var$__spreadValues($f30b917334351296$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $f30b917334351296$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $f30b917334351296$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$f30b917334351296$var$defaultMergeProps : typeof mergeProps === "function" ? $f30b917334351296$var$wrapMergePropsFunc(mergeProps) : $f30b917334351296$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $f30b917334351296$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $f30b917334351296$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $f30b917334351296$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $f30b917334351296$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $f30b917334351296$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $f30b917334351296$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $f30b917334351296$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $f30b917334351296$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $f30b917334351296$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $f30b917334351296$var$isDOM = /* @__PURE__ */ $f30b917334351296$var$canUseDOM();
var $f30b917334351296$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $f30b917334351296$var$isReactNative = /* @__PURE__ */ $f30b917334351296$var$isRunningInReactNative();
var $f30b917334351296$var$getUseIsomorphicLayoutEffect = ()=>$f30b917334351296$var$isDOM || $f30b917334351296$var$isReactNative ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $f30b917334351296$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $f30b917334351296$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $f30b917334351296$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $f30b917334351296$export$d36bdfa510afb180(objA, objB) {
    if ($f30b917334351296$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$f30b917334351296$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $f30b917334351296$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f30b917334351296$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f30b917334351296$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f30b917334351296$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f30b917334351296$var$TYPE_STATICS = {
    [$f30b917334351296$var$ForwardRef]: $f30b917334351296$var$FORWARD_REF_STATICS,
    [$f30b917334351296$var$Memo]: $f30b917334351296$var$MEMO_STATICS
};
function $f30b917334351296$var$getStatics(component) {
    if ($f30b917334351296$var$isMemo(component)) return $f30b917334351296$var$MEMO_STATICS;
    return $f30b917334351296$var$TYPE_STATICS[component["$$typeof"]] || $f30b917334351296$var$REACT_STATICS;
}
var $f30b917334351296$var$defineProperty = Object.defineProperty;
var $f30b917334351296$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f30b917334351296$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f30b917334351296$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f30b917334351296$var$getPrototypeOf = Object.getPrototypeOf;
var $f30b917334351296$var$objectPrototype = Object.prototype;
function $f30b917334351296$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($f30b917334351296$var$objectPrototype) {
            const inheritedComponent = $f30b917334351296$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f30b917334351296$var$objectPrototype) $f30b917334351296$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $f30b917334351296$var$getOwnPropertyNames(sourceComponent);
        if ($f30b917334351296$var$getOwnPropertySymbols) keys = keys.concat($f30b917334351296$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $f30b917334351296$var$getStatics(targetComponent);
        const sourceStatics = $f30b917334351296$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$f30b917334351296$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $f30b917334351296$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $f30b917334351296$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $f30b917334351296$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $f30b917334351296$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $f30b917334351296$var$getContext() {
    var _a;
    if (!$7fPBF.createContext) return {};
    const contextMap = (_a = $f30b917334351296$var$gT[$f30b917334351296$var$ContextKey]) != null ? _a : $f30b917334351296$var$gT[$f30b917334351296$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($7fPBF.createContext);
    if (!realContext) {
        realContext = $7fPBF.createContext(null);
        contextMap.set($7fPBF.createContext, realContext);
    }
    return realContext;
}
var $f30b917334351296$export$cc80c08dc91f1c00 = /* @__PURE__ */ $f30b917334351296$var$getContext();
// src/components/connect.tsx
var $f30b917334351296$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $f30b917334351296$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $f30b917334351296$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $f30b917334351296$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $f30b917334351296$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $f30b917334351296$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $f30b917334351296$var$strictEqual(a, b) {
    return a === b;
}
var $f30b917334351296$var$hasWarnedAboutDeprecatedPureOption = false;
function $f30b917334351296$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $f30b917334351296$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $f30b917334351296$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $f30b917334351296$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $f30b917334351296$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $f30b917334351296$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $f30b917334351296$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $f30b917334351296$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $f30b917334351296$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $7fPBF.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $f30b917334351296$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $7fPBF.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $7fPBF.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $7fPBF.useMemo(()=>{
                return $f30b917334351296$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $7fPBF.useMemo(()=>{
                if (!shouldHandleStateChanges) return $f30b917334351296$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $f30b917334351296$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $7fPBF.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $7fPBF.useRef(void 0);
            const lastWrapperProps = $7fPBF.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $7fPBF.useRef(void 0);
            const renderIsScheduled = $7fPBF.useRef(false);
            const isMounted = $7fPBF.useRef(false);
            const latestSubscriptionCallbackError = $7fPBF.useRef(void 0);
            $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $7fPBF.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $7fPBF.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $f30b917334351296$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $f30b917334351296$var$useIsomorphicLayoutEffectWithArgs($f30b917334351296$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $7fPBF.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $7fPBF.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $7fPBF.createElement(WrappedComponent, $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $7fPBF.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $7fPBF.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $7fPBF.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $7fPBF.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $7fPBF.createElement(Connect, $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $f30b917334351296$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $f30b917334351296$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $f30b917334351296$export$64605811ab45167f = $f30b917334351296$var$connect;
// src/components/Provider.tsx
function $f30b917334351296$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $7fPBF.useMemo(()=>{
        const subscription = $f30b917334351296$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $7fPBF.useMemo(()=>store.getState(), [
        store
    ]);
    $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $f30b917334351296$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $7fPBF.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $f30b917334351296$export$2881499e37b75b9a = $f30b917334351296$var$Provider;
// src/hooks/useReduxContext.ts
function $f30b917334351296$var$createReduxContextHook(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $7fPBF.useContext(context);
        return contextValue;
    };
}
var $f30b917334351296$var$useReduxContext = /* @__PURE__ */ $f30b917334351296$var$createReduxContextHook();
// src/hooks/useStore.ts
function $f30b917334351296$export$671dba69185d0304(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$var$useReduxContext : // @ts-ignore
    $f30b917334351296$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $f30b917334351296$export$6ccbb43953eebf8 = /* @__PURE__ */ $f30b917334351296$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $f30b917334351296$export$bc9b55530897c558(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useStore2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$export$6ccbb43953eebf8 : $f30b917334351296$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $f30b917334351296$export$8ad76b76a4c905f8 = /* @__PURE__ */ $f30b917334351296$export$bc9b55530897c558();
var $f30b917334351296$var$refEquality = (a, b)=>a === b;
function $f30b917334351296$export$2b53f90d2bd1cbfb(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$var$useReduxContext : $f30b917334351296$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $f30b917334351296$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $7fPBF.useRef(true);
        const wrappedSelector = $7fPBF.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $c1c6d595ff42d79c$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $7fPBF.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $f30b917334351296$export$2105062e25df4afe = /* @__PURE__ */ $f30b917334351296$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $f30b917334351296$export$712ea50be43a7858 = $f30b917334351296$var$defaultNoopBatch;


/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $55100129ab36ed65$var$_extends() {
    $55100129ab36ed65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55100129ab36ed65$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $55100129ab36ed65$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($55100129ab36ed65$export$e19cd5f9376f8cee || ($55100129ab36ed65$export$e19cd5f9376f8cee = {}));
const $55100129ab36ed65$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $55100129ab36ed65$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $55100129ab36ed65$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $55100129ab36ed65$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $55100129ab36ed65$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $55100129ab36ed65$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $55100129ab36ed65$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $55100129ab36ed65$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $55100129ab36ed65$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $55100129ab36ed65$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $55100129ab36ed65$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $55100129ab36ed65$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $55100129ab36ed65$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $55100129ab36ed65$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $55100129ab36ed65$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $55100129ab36ed65$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($55100129ab36ed65$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $55100129ab36ed65$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $55100129ab36ed65$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($55100129ab36ed65$var$ResultType || ($55100129ab36ed65$var$ResultType = {}));
const $55100129ab36ed65$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $55100129ab36ed65$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $55100129ab36ed65$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $55100129ab36ed65$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($55100129ab36ed65$var$isIndexRoute(route)) {
            let indexRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $55100129ab36ed65$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $55100129ab36ed65$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $55100129ab36ed65$var$flattenRoutes(routes);
    $55100129ab36ed65$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $55100129ab36ed65$export$30d21fd6d7295f52(pathname);
        matches = $55100129ab36ed65$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $55100129ab36ed65$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $55100129ab36ed65$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $55100129ab36ed65$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $55100129ab36ed65$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $55100129ab36ed65$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $55100129ab36ed65$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $55100129ab36ed65$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $55100129ab36ed65$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $55100129ab36ed65$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $55100129ab36ed65$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $55100129ab36ed65$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $55100129ab36ed65$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $55100129ab36ed65$var$paramRe = /^:[\w-]+$/;
const $55100129ab36ed65$var$dynamicSegmentValue = 3;
const $55100129ab36ed65$var$indexRouteValue = 2;
const $55100129ab36ed65$var$emptySegmentValue = 1;
const $55100129ab36ed65$var$staticSegmentValue = 10;
const $55100129ab36ed65$var$splatPenalty = -2;
const $55100129ab36ed65$var$isSplat = (s)=>s === "*";
function $55100129ab36ed65$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($55100129ab36ed65$var$isSplat)) initialScore += $55100129ab36ed65$var$splatPenalty;
    if (index) initialScore += $55100129ab36ed65$var$indexRouteValue;
    return segments.filter((s)=>!$55100129ab36ed65$var$isSplat(s)).reduce((score, segment)=>score + ($55100129ab36ed65$var$paramRe.test(segment) ? $55100129ab36ed65$var$dynamicSegmentValue : segment === "" ? $55100129ab36ed65$var$emptySegmentValue : $55100129ab36ed65$var$staticSegmentValue), initialScore);
}
function $55100129ab36ed65$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $55100129ab36ed65$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $55100129ab36ed65$export$a5c6d149b50c1d86($55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $55100129ab36ed65$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $55100129ab36ed65$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $55100129ab36ed65$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $55100129ab36ed65$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $55100129ab36ed65$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $55100129ab36ed65$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $55100129ab36ed65$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $55100129ab36ed65$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $55100129ab36ed65$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $55100129ab36ed65$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $55100129ab36ed65$var$normalizeSearch(search),
        hash: $55100129ab36ed65$var$normalizeHash(hash)
    };
}
function $55100129ab36ed65$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $55100129ab36ed65$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $55100129ab36ed65$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $55100129ab36ed65$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $55100129ab36ed65$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $55100129ab36ed65$export$8ccf933b0513f8d0(toArg);
    else {
        to = $55100129ab36ed65$var$_extends({}, toArg);
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $55100129ab36ed65$var$getInvalidPathError("?", "pathname", "search", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "pathname", "hash", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $55100129ab36ed65$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $55100129ab36ed65$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $55100129ab36ed65$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $55100129ab36ed65$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $55100129ab36ed65$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $55100129ab36ed65$export$4051a07651545597(data, init) {
    return new $55100129ab36ed65$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $55100129ab36ed65$export$42a99a7a4bc0e76a extends Error {
}
class $55100129ab36ed65$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $55100129ab36ed65$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $55100129ab36ed65$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $55100129ab36ed65$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $55100129ab36ed65$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $55100129ab36ed65$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $55100129ab36ed65$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $55100129ab36ed65$var$unwrapTrackedPromise(value) {
    if (!$55100129ab36ed65$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $55100129ab36ed65$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $55100129ab36ed65$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $55100129ab36ed65$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $55100129ab36ed65$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $55100129ab36ed65$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $55100129ab36ed65$var$validMutationMethods = new Set($55100129ab36ed65$var$validMutationMethodsArr);
const $55100129ab36ed65$var$validRequestMethodsArr = [
    "get",
    ...$55100129ab36ed65$var$validMutationMethodsArr
];
const $55100129ab36ed65$var$validRequestMethods = new Set($55100129ab36ed65$var$validRequestMethodsArr);
const $55100129ab36ed65$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $55100129ab36ed65$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $55100129ab36ed65$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $55100129ab36ed65$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $55100129ab36ed65$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $55100129ab36ed65$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $55100129ab36ed65$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $55100129ab36ed65$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$55100129ab36ed65$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($55100129ab36ed65$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $55100129ab36ed65$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $55100129ab36ed65$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $55100129ab36ed65$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($55100129ab36ed65$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $55100129ab36ed65$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $55100129ab36ed65$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $55100129ab36ed65$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $55100129ab36ed65$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $55100129ab36ed65$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $55100129ab36ed65$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $55100129ab36ed65$var$findNearestBoundary(matches).route.id,
            {
                type: $55100129ab36ed65$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($55100129ab36ed65$var$isErrorResult(result) && $55100129ab36ed65$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $55100129ab36ed65$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $55100129ab36ed65$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $55100129ab36ed65$var$_extends({
            matches: updatedMatches || matches
        }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $55100129ab36ed65$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $55100129ab36ed65$var$ResultType.error,
            error: $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $55100129ab36ed65$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isDeferredResult(result)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $55100129ab36ed65$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $55100129ab36ed65$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($55100129ab36ed65$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $55100129ab36ed65$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $55100129ab36ed65$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $55100129ab36ed65$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $55100129ab36ed65$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult) || $55100129ab36ed65$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($55100129ab36ed65$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($55100129ab36ed65$var$isDeferredResult(actionResult)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $55100129ab36ed65$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $55100129ab36ed65$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $55100129ab36ed65$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $55100129ab36ed65$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($55100129ab36ed65$var$isDeferredResult(result)) result = await $55100129ab36ed65$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $55100129ab36ed65$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $55100129ab36ed65$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $55100129ab36ed65$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $55100129ab36ed65$export$e19cd5f9376f8cee.Replace : $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $55100129ab36ed65$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($55100129ab36ed65$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $55100129ab36ed65$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $55100129ab36ed65$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $55100129ab36ed65$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $55100129ab36ed65$var$ResultType.redirect,
                response: $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $55100129ab36ed65$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: $55100129ab36ed65$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $55100129ab36ed65$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $55100129ab36ed65$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $55100129ab36ed65$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $55100129ab36ed65$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$55100129ab36ed65$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $55100129ab36ed65$export$4d0306f8f6a4585b = Symbol("deferred");
function $55100129ab36ed65$export$3336b097a6fbc59a(routes, opts) {
    $55100129ab36ed65$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD") {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $55100129ab36ed65$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $55100129ab36ed65$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $55100129ab36ed65$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$55100129ab36ed65$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $55100129ab36ed65$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($55100129ab36ed65$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $55100129ab36ed65$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $55100129ab36ed65$var$isResponse(result) ? result : $55100129ab36ed65$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($55100129ab36ed65$var$isDataStrategyResult(e) && $55100129ab36ed65$var$isResponse(e.result)) {
                if (e.type === $55100129ab36ed65$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($55100129ab36ed65$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            let error = $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($55100129ab36ed65$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $55100129ab36ed65$var$_extends({}, context, {
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $55100129ab36ed65$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $55100129ab36ed65$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategy || $55100129ab36ed65$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($55100129ab36ed65$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $55100129ab36ed65$export$fec11da027c70692(routes, context, error) {
    let newContext = $55100129ab36ed65$var$_extends({}, context, {
        statusCode: $55100129ab36ed65$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $55100129ab36ed65$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $55100129ab36ed65$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $55100129ab36ed65$export$cae722b0cc860f13(to ? to : ".", $55100129ab36ed65$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $55100129ab36ed65$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $55100129ab36ed65$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $55100129ab36ed65$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $55100129ab36ed65$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$55100129ab36ed65$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$55100129ab36ed65$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $55100129ab36ed65$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $55100129ab36ed65$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $55100129ab36ed65$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($55100129ab36ed65$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $55100129ab36ed65$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $55100129ab36ed65$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $55100129ab36ed65$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $55100129ab36ed65$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($55100129ab36ed65$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $55100129ab36ed65$var$shouldRevalidateLoader(match, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $55100129ab36ed65$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $55100129ab36ed65$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $55100129ab36ed65$var$shouldRevalidateLoader(fetcherMatch, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $55100129ab36ed65$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $55100129ab36ed65$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $55100129ab36ed65$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$55100129ab36ed65$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $55100129ab36ed65$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$55100129ab36ed65$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $55100129ab36ed65$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $55100129ab36ed65$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $55100129ab36ed65$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$55100129ab36ed65$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $55100129ab36ed65$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $55100129ab36ed65$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $55100129ab36ed65$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $55100129ab36ed65$var$ResultType.data,
                result: undefined
            });
        };
        return $55100129ab36ed65$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $55100129ab36ed65$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $55100129ab36ed65$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $55100129ab36ed65$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $55100129ab36ed65$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($55100129ab36ed65$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: e
            };
        }
        if (type === $55100129ab36ed65$var$ResultType.error) return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: new $55100129ab36ed65$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $55100129ab36ed65$var$ResultType.error) {
        if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: new $55100129ab36ed65$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: result,
            statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($55100129ab36ed65$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $55100129ab36ed65$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $55100129ab36ed65$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $55100129ab36ed65$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $55100129ab36ed65$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $55100129ab36ed65$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($55100129ab36ed65$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $55100129ab36ed65$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $55100129ab36ed65$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($55100129ab36ed65$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $55100129ab36ed65$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $55100129ab36ed65$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($55100129ab36ed65$var$isErrorResult(result)) {
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $55100129ab36ed65$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($55100129ab36ed65$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($55100129ab36ed65$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $55100129ab36ed65$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $55100129ab36ed65$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $55100129ab36ed65$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $55100129ab36ed65$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $55100129ab36ed65$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $55100129ab36ed65$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $55100129ab36ed65$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($55100129ab36ed65$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $55100129ab36ed65$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(path) : path;
    return $55100129ab36ed65$export$fe53371bee54353d($55100129ab36ed65$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $55100129ab36ed65$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $55100129ab36ed65$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $55100129ab36ed65$var$ResultType.data || result.type === $55100129ab36ed65$var$ResultType.error);
}
function $55100129ab36ed65$var$isRedirectDataStrategyResultResult(result) {
    return $55100129ab36ed65$var$isResponse(result.result) && $55100129ab36ed65$var$redirectStatusCodes.has(result.result.status);
}
function $55100129ab36ed65$var$isDeferredResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.deferred;
}
function $55100129ab36ed65$var$isErrorResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.error;
}
function $55100129ab36ed65$var$isRedirectResult(result) {
    return (result && result.type) === $55100129ab36ed65$var$ResultType.redirect;
}
function $55100129ab36ed65$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $55100129ab36ed65$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $55100129ab36ed65$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $55100129ab36ed65$var$isRedirectResponse(result) {
    if (!$55100129ab36ed65$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $55100129ab36ed65$var$isValidMethod(method) {
    return $55100129ab36ed65$var$validRequestMethods.has(method.toLowerCase());
}
function $55100129ab36ed65$var$isMutationMethod(method) {
    return $55100129ab36ed65$var$validMutationMethods.has(method.toLowerCase());
}
async function $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($55100129ab36ed65$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $55100129ab36ed65$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $55100129ab36ed65$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $55100129ab36ed65$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $55100129ab36ed65$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $55100129ab36ed65$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $55100129ab36ed65$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $55100129ab36ed65$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $55100129ab36ed65$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $55100129ab36ed65$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $55100129ab36ed65$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $55100129ab36ed65$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $55100129ab36ed65$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $55100129ab36ed65$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $55100129ab36ed65$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $55100129ab36ed65$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

function $d9fd026bfea79ab9$var$_extends() {
    $d9fd026bfea79ab9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9fd026bfea79ab9$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $d9fd026bfea79ab9$export$3add0d5dce533e2e = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$145dfa71566a64dc = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$var$AwaitContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $d9fd026bfea79ab9$export$26749e8557646306 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$c7914228fb69b0f5 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$9072aa6dd1f93057 = /*#__PURE__*/ $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $d9fd026bfea79ab9$var$RouteErrorContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $d9fd026bfea79ab9$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $d9fd026bfea79ab9$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $d9fd026bfea79ab9$export$45d76561a5302f2b() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $d9fd026bfea79ab9$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $d9fd026bfea79ab9$export$6c330e8992e8a295(pattern) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$81336c211d5ff295)(pattern, (0, $55100129ab36ed65$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $d9fd026bfea79ab9$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fPBF.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $d9fd026bfea79ab9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $d9fd026bfea79ab9$var$useNavigateStable() : $d9fd026bfea79ab9$var$useNavigateUnstable();
}
function $d9fd026bfea79ab9$var$useNavigateUnstable() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$OutletContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $d9fd026bfea79ab9$export$4138103a3ae699cc() {
    return $7fPBF.useContext($d9fd026bfea79ab9$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $d9fd026bfea79ab9$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $d9fd026bfea79ab9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $d9fd026bfea79ab9$export$5d3fca4a98652595(routes, locationArg) {
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { navigator: navigator, static: isStatic } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: parentMatches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $55100129ab36ed65$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $d9fd026bfea79ab9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $d9fd026bfea79ab9$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d9fd026bfea79ab9$var$DefaultErrorComponent() {
    let error = $d9fd026bfea79ab9$export$ed527bf60f6e05f2();
    let message = (0, $55100129ab36ed65$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $d9fd026bfea79ab9$var$defaultErrorElement = /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DefaultErrorComponent, null);
class $d9fd026bfea79ab9$var$RenderErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $d9fd026bfea79ab9$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $d9fd026bfea79ab9$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $d9fd026bfea79ab9$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $d9fd026bfea79ab9$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $d9fd026bfea79ab9$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($d9fd026bfea79ab9$var$DataRouterHook || {});
var $d9fd026bfea79ab9$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($d9fd026bfea79ab9$var$DataRouterStateHook || {});
function $d9fd026bfea79ab9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $d9fd026bfea79ab9$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d9fd026bfea79ab9$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($d9fd026bfea79ab9$export$145dfa71566a64dc);
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
function $d9fd026bfea79ab9$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $d9fd026bfea79ab9$var$useCurrentRouteId(hookName) {
    let route = $d9fd026bfea79ab9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $d9fd026bfea79ab9$export$5fc8298006ad9e58() {
    return $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $d9fd026bfea79ab9$export$d0fd4b7106de2769() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $d9fd026bfea79ab9$export$600dc272ed516c15() {
    let dataRouterContext = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseRevalidator);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRevalidator);
    return $7fPBF.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $d9fd026bfea79ab9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseMatches);
    return $7fPBF.useMemo(()=>matches.map((m)=>(0, $55100129ab36ed65$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $d9fd026bfea79ab9$export$1448a5050d252c4d() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $d9fd026bfea79ab9$export$fd5d37484eab868d(routeId) {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $d9fd026bfea79ab9$export$fdc00f3f26066d5e() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseActionData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $d9fd026bfea79ab9$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7fPBF.useContext($d9fd026bfea79ab9$var$RouteErrorContext);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$17f53340677d5831() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $d9fd026bfea79ab9$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $d9fd026bfea79ab9$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseBlocker);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $d9fd026bfea79ab9$var$_extends({}, currentLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $d9fd026bfea79ab9$var$_extends({}, nextLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7fPBF.useEffect(()=>{
        let key = String(++$d9fd026bfea79ab9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $55100129ab36ed65$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $d9fd026bfea79ab9$var$useNavigateStable() {
    let { router: router } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseNavigateStable);
    let id = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $d9fd026bfea79ab9$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$alreadyWarned$1 = {};
function $d9fd026bfea79ab9$var$warningOnce(key, cond, message) {
    if (!cond && !$d9fd026bfea79ab9$var$alreadyWarned$1[key]) $d9fd026bfea79ab9$var$alreadyWarned$1[key] = true;
}
const $d9fd026bfea79ab9$var$alreadyWarned = {};
function $d9fd026bfea79ab9$var$warnOnce(key, message) {}
const $d9fd026bfea79ab9$var$logDeprecation = (flag, msg, link)=>$d9fd026bfea79ab9$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $d9fd026bfea79ab9$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $d9fd026bfea79ab9$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d9fd026bfea79ab9$var$START_TRANSITION = "startTransition";
const $d9fd026bfea79ab9$var$startTransitionImpl = $7fPBF[$d9fd026bfea79ab9$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9fd026bfea79ab9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        if (v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl) $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $d9fd026bfea79ab9$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $d9fd026bfea79ab9$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl ? $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $d9fd026bfea79ab9$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let navigate = $d9fd026bfea79ab9$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, (0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $d9fd026bfea79ab9$export$910ae8079b2c2852(props) {
    return $d9fd026bfea79ab9$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $d9fd026bfea79ab9$export$e7b0ac011bb776c6(_props) {
    (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $d9fd026bfea79ab9$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $d9fd026bfea79ab9$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $d9fd026bfea79ab9$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $d9fd026bfea79ab9$export$5d3fca4a98652595($d9fd026bfea79ab9$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $d9fd026bfea79ab9$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$ResolveAwait, null, children));
}
var $d9fd026bfea79ab9$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($d9fd026bfea79ab9$var$AwaitRenderStatus || {});
const $d9fd026bfea79ab9$var$neverSettledPromise = new Promise(()=>{});
class $d9fd026bfea79ab9$var$AwaitErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.error : "_data" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.success : $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && promise._error instanceof (0, $55100129ab36ed65$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $d9fd026bfea79ab9$var$neverSettledPromise;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $d9fd026bfea79ab9$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $d9fd026bfea79ab9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $d9fd026bfea79ab9$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $d9fd026bfea79ab9$export$e7b0ac011bb776c6) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $d9fd026bfea79ab9$export$daf73786167a7f72(matches) {
    return $d9fd026bfea79ab9$var$_renderMatches(matches);
}
function $d9fd026bfea79ab9$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7fPBF.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $7fPBF.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7fPBF.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $d9fd026bfea79ab9$export$f30f7e456d254e83(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9fd026bfea79ab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $d9fd026bfea79ab9$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $a0cf24fd73ae067c$var$_extends() {
    $a0cf24fd73ae067c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0cf24fd73ae067c$var$_extends.apply(this, arguments);
}
function $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a0cf24fd73ae067c$var$defaultMethod = "get";
const $a0cf24fd73ae067c$var$defaultEncType = "application/x-www-form-urlencoded";
function $a0cf24fd73ae067c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a0cf24fd73ae067c$var$isButtonElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a0cf24fd73ae067c$var$isFormElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a0cf24fd73ae067c$var$isInputElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a0cf24fd73ae067c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a0cf24fd73ae067c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a0cf24fd73ae067c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = null;
function $a0cf24fd73ae067c$var$isFormDataSubmitterSupported() {
    if ($a0cf24fd73ae067c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = true;
    }
    return $a0cf24fd73ae067c$var$_formDataSupportsSubmitter;
}
const $a0cf24fd73ae067c$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a0cf24fd73ae067c$var$getFormEncType(encType) {
    if (encType != null && !$a0cf24fd73ae067c$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a0cf24fd73ae067c$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a0cf24fd73ae067c$var$isButtonElement(target) || $a0cf24fd73ae067c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("formenctype")) || $a0cf24fd73ae067c$var$getFormEncType(form.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a0cf24fd73ae067c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a0cf24fd73ae067c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a0cf24fd73ae067c$var$defaultMethod;
        action = null;
        encType = $a0cf24fd73ae067c$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a0cf24fd73ae067c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $a0cf24fd73ae067c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $a0cf24fd73ae067c$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $a0cf24fd73ae067c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a0cf24fd73ae067c$var$_extends({}, state, {
        errors: $a0cf24fd73ae067c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a0cf24fd73ae067c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $55100129ab36ed65$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $a0cf24fd73ae067c$export$7ad602f0e94e62d1 = /*#__PURE__*/ $7fPBF.createContext({
    isTransitioning: false
});
const $a0cf24fd73ae067c$export$148fd98d095596d4 = /*#__PURE__*/ $7fPBF.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a0cf24fd73ae067c$var$START_TRANSITION = "startTransition";
const $a0cf24fd73ae067c$var$startTransitionImpl = $7fPBF[$a0cf24fd73ae067c$var$START_TRANSITION];
const $a0cf24fd73ae067c$var$FLUSH_SYNC = "flushSync";
const $a0cf24fd73ae067c$var$flushSyncImpl = $b4ba1c853f6e1116$exports[$a0cf24fd73ae067c$var$FLUSH_SYNC];
const $a0cf24fd73ae067c$var$USE_ID = "useId";
const $a0cf24fd73ae067c$var$useIdImpl = $7fPBF[$a0cf24fd73ae067c$var$USE_ID];
function $a0cf24fd73ae067c$var$startTransitionSafe(cb) {
    if ($a0cf24fd73ae067c$var$startTransitionImpl) $a0cf24fd73ae067c$var$startTransitionImpl(cb);
    else cb();
}
function $a0cf24fd73ae067c$var$flushSyncSafe(cb) {
    if ($a0cf24fd73ae067c$var$flushSyncImpl) $a0cf24fd73ae067c$var$flushSyncImpl(cb);
    else cb();
}
class $a0cf24fd73ae067c$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a0cf24fd73ae067c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $7fPBF.useCallback((cb)=>{
        if (v7_startTransition) $a0cf24fd73ae067c$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $7fPBF.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $a0cf24fd73ae067c$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $7fPBF.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $a0cf24fd73ae067c$var$MemoizedDataRoutes = /*#__PURE__*/ $7fPBF.memo($a0cf24fd73ae067c$var$DataRoutes);
function $a0cf24fd73ae067c$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $d9fd026bfea79ab9$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a0cf24fd73ae067c$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a0cf24fd73ae067c$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $a0cf24fd73ae067c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $a0cf24fd73ae067c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7fPBF.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref7, $a0cf24fd73ae067c$var$_excluded);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a0cf24fd73ae067c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $d9fd026bfea79ab9$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a0cf24fd73ae067c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7fPBF.createElement("a", $a0cf24fd73ae067c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $a0cf24fd73ae067c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7fPBF.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref8, $a0cf24fd73ae067c$var$_excluded2);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let routerState = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $a0cf24fd73ae067c$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a6c7ac8248d6e38a, $a0cf24fd73ae067c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a0cf24fd73ae067c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7fPBF.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $a0cf24fd73ae067c$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref9, $a0cf24fd73ae067c$var$_excluded3);
    let submit = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let formAction = $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $7fPBF.createElement("form", $a0cf24fd73ae067c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a0cf24fd73ae067c$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $a0cf24fd73ae067c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a0cf24fd73ae067c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($a0cf24fd73ae067c$var$DataRouterHook || ($a0cf24fd73ae067c$var$DataRouterHook = {}));
var $a0cf24fd73ae067c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a0cf24fd73ae067c$var$DataRouterStateHook || ($a0cf24fd73ae067c$var$DataRouterStateHook = {}));
// Internal hooks
function $a0cf24fd73ae067c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $a0cf24fd73ae067c$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e));
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a0cf24fd73ae067c$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a0cf24fd73ae067c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $55100129ab36ed65$export$fe53371bee54353d)(location) === (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a0cf24fd73ae067c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7fPBF.useRef($a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a0cf24fd73ae067c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a0cf24fd73ae067c$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $a0cf24fd73ae067c$var$fetcherId = 0;
let $a0cf24fd73ae067c$var$getUniqueFetcherId = ()=>"__" + String(++$a0cf24fd73ae067c$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a0cf24fd73ae067c$export$47c85c6e3a081d3() {
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let currentRouteId = (0, $d9fd026bfea79ab9$export$5fc8298006ad9e58)();
    return $7fPBF.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a0cf24fd73ae067c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $a0cf24fd73ae067c$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let routeContext = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    !routeContext && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a0cf24fd73ae067c$var$_extends({}, (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a0cf24fd73ae067c$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseFetcher);
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $7fPBF.useContext($a0cf24fd73ae067c$export$148fd98d095596d4);
    let route = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $a0cf24fd73ae067c$var$useIdImpl ? $a0cf24fd73ae067c$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($a0cf24fd73ae067c$var$getUniqueFetcherId());
    // Registration/cleanup
    $7fPBF.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $7fPBF.useCallback((href, opts)=>{
        !routeId && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback((target, opts)=>{
        submitImpl(target, $a0cf24fd73ae067c$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a7fed597f4b8afd8, $a0cf24fd73ae067c$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $55100129ab36ed65$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>$a0cf24fd73ae067c$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a0cf24fd73ae067c$export$fa996778a3a31087() {
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $a0cf24fd73ae067c$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a0cf24fd73ae067c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a0cf24fd73ae067c$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let matches = (0, $d9fd026bfea79ab9$export$2378eb7f5ff86053)();
    let navigation = (0, $d9fd026bfea79ab9$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a0cf24fd73ae067c$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a0cf24fd73ae067c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a0cf24fd73ae067c$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a0cf24fd73ae067c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a0cf24fd73ae067c$var$_extends({}, location, {
                    pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a0cf24fd73ae067c$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a0cf24fd73ae067c$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $d9fd026bfea79ab9$export$b273b3273281a049)(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $a0cf24fd73ae067c$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $7fPBF.useContext($a0cf24fd73ae067c$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.useViewTransitionState);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $7fPBF = parcelRequire("7fPBF");

/* Consent.tsx generated by @compiled/babel-plugin v0.38.1 */ 
const $bfde69414e76f2a7$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $bfde69414e76f2a7$var$ATOMIC_GROUP_LENGTH = 5;
function $bfde69414e76f2a7$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $bfde69414e76f2a7$var$UNDERSCORE_UNICODE ? $bfde69414e76f2a7$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

parcelRequire("7fPBF");
/**
 * Returns `true` when caching should be disabled, else `false`.
 *
 * Any code within this check will be removed in the output bundles:
 *
 * ```js
 * if (isCacheDisabled()) {
 *   // This code will be removed from the output bundles
 * }
 * ```
 */ const $a13499268a19582a$export$3afd524f1aee0f44 = ()=>{
    return false;
};



/**
 * Cache to hold already used styles.
 * React Context on the server - singleton object on the client.
 */ const $e954cdbfe522d5cb$var$Cache = {};
if (typeof document !== 'undefined') {
    /**
     * Iterates through all found style elements generated when server side rendering.
     *
     * @param cb
     */ const ssrStyles = document.querySelectorAll('style[data-cmpld]');
    for(let i = 0; i < ssrStyles.length; i++)// Move all found server-side rendered style elements to the head before React hydration happens.
    document.head.appendChild(ssrStyles[i]);
}
const $e954cdbfe522d5cb$export$c6e89b6bb9436bc0 = ()=>{
    if ((0, $a13499268a19582a$export$3afd524f1aee0f44)()) return {};
    // On the client we use the object singleton.
    return $e954cdbfe522d5cb$var$Cache;
};
/**
 * On the server this ensures the minimal amount of styles will be rendered
 * safely using React Context.
 *
 * On the browser this turns into a fragment with no React Context.
 */ const $e954cdbfe522d5cb$var$StyleCacheProvider = (props)=>{
    return props.children;
};
var $e954cdbfe522d5cb$export$2e2bcd8739ae039 = $e954cdbfe522d5cb$var$StyleCacheProvider;

parcelRequire("7fPBF");



// Copied from packages/utils/src/shorthand.ts so that we avoid
// inflating the bundle size of @compiled/react/runtime with the contents
// of @compiled/utils
//
// Keep this `shorthandBuckets` in sync with the `shorthandBuckets` defined in
// packages/utils/src/shorthand.ts
const $f7031165668ab2fb$var$shorthandBuckets = {
    all: 0,
    animation: 1,
    'animation-range': 1,
    background: 1,
    border: 1,
    'border-color': 2,
    'border-style': 2,
    'border-width': 2,
    'border-block': 3,
    'border-inline': 3,
    'border-top': 4,
    'border-right': 4,
    'border-bottom': 4,
    'border-left': 4,
    'border-block-start': 5,
    'border-block-end': 5,
    'border-inline-start': 5,
    'border-inline-end': 5,
    'border-image': 1,
    'border-radius': 1,
    'column-rule': 1,
    columns: 1,
    'contain-intrinsic-size': 1,
    container: 1,
    flex: 1,
    'flex-flow': 1,
    font: 1,
    'font-synthesis': 1,
    'font-variant': 2,
    gap: 1,
    grid: 1,
    'grid-area': 1,
    'grid-column': 2,
    'grid-row': 2,
    'grid-template': 2,
    inset: 1,
    'inset-block': 2,
    'inset-inline': 2,
    'list-style': 1,
    margin: 1,
    'margin-block': 2,
    'margin-inline': 2,
    mask: 1,
    'mask-border': 1,
    offset: 1,
    outline: 1,
    overflow: 1,
    'overscroll-behavior': 1,
    padding: 1,
    'padding-block': 2,
    'padding-inline': 2,
    'place-content': 1,
    'place-items': 1,
    'place-self': 1,
    'position-try': 1,
    'scroll-margin': 1,
    'scroll-margin-block': 2,
    'scroll-margin-inline': 2,
    'scroll-padding': 1,
    'scroll-padding-block': 2,
    'scroll-padding-inline': 2,
    'scroll-timeline': 1,
    'text-decoration': 1,
    'text-emphasis': 1,
    'text-wrap': 1,
    transition: 1,
    'view-timeline': 1
};
const $f7031165668ab2fb$export$b08836c779543dbf = (shorthand)=>{
    var _a;
    return (_a = $f7031165668ab2fb$var$shorthandBuckets[shorthand]) !== null && _a !== void 0 ? _a : null;
};


const $189a6334ccf0e9ac$export$8394bdfbee416ca4 = [
    // shorthand properties
    's-0',
    's-1',
    's-2',
    's-3',
    's-4',
    's-5',
    // catch-all
    '',
    // link
    'l',
    // visited
    'v',
    // focus-within
    'w',
    // focus
    'f',
    // focus-visible
    'i',
    // hover
    'h',
    // active
    'a',
    // at-rules
    'm'
];
/**
 * Holds all style buckets in memory that have been added to the head.
 */ const $189a6334ccf0e9ac$var$styleBucketsInHead = {};
/**
 * Maps the long pseudo name to the short pseudo name.
 * Pseudos that match here will be ordered,
 * everything else will make their way to the catch all style bucket.
 * We reduce the pseudo name to save bundlesize.
 * Thankfully there aren't any overlaps, see: https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes.
 */ const $189a6334ccf0e9ac$var$pseudosMap = {
    // link
    k: 'l',
    // visited
    ited: 'v',
    // focus-within
    'us-within': 'w',
    // focus
    us: 'f',
    // focus-visible
    'us-visible': 'i',
    // hover
    er: 'h',
    // active
    ive: 'a'
};
/**
 * Lazily adds a `<style>` bucket to the `<head>`.
 * This will ensure that the style buckets are ordered.
 *
 * @param bucket Bucket to insert in the head.
 */ function $189a6334ccf0e9ac$var$lazyAddStyleBucketToHead(bucketName, opts) {
    if (!$189a6334ccf0e9ac$var$styleBucketsInHead[bucketName]) {
        let currentBucketIndex = $189a6334ccf0e9ac$export$8394bdfbee416ca4.indexOf(bucketName) + 1;
        let nextBucketFromCache = null;
        // Find the next bucket which we will add our new style bucket before.
        for(; currentBucketIndex < $189a6334ccf0e9ac$export$8394bdfbee416ca4.length; currentBucketIndex++){
            const nextBucket = $189a6334ccf0e9ac$var$styleBucketsInHead[$189a6334ccf0e9ac$export$8394bdfbee416ca4[currentBucketIndex]];
            if (nextBucket) {
                nextBucketFromCache = nextBucket;
                break;
            }
        }
        const tag = document.createElement('style');
        opts.nonce && tag.setAttribute('nonce', opts.nonce);
        tag.appendChild(document.createTextNode(''));
        document.head.insertBefore(tag, nextBucketFromCache);
        if ((0, $a13499268a19582a$export$3afd524f1aee0f44)()) return tag;
        $189a6334ccf0e9ac$var$styleBucketsInHead[bucketName] = tag;
    }
    return $189a6334ccf0e9ac$var$styleBucketsInHead[bucketName];
}
const $189a6334ccf0e9ac$export$d90f6836ea1aee93 = (sheet)=>{
    // We are grouping all the at-rules like @media, @supports etc under `m` bucket.
    if (sheet.charCodeAt(0) === 64 /* "@" */ ) return 'm';
    const firstBracket = sheet.indexOf('{');
    /**
     * We assume that classname will always be 9 character long,
     * using this the 10th characters could be a pseudo declaration.
     */ if (sheet.charCodeAt(10) === 58 /* ":" */ ) {
        // We send through a subset of the string instead of the full pseudo name.
        // For example `"focus-visible"` name would instead of `"us-visible"`.
        // Return a mapped pseudo else the default catch all bucket.
        const mapped = $189a6334ccf0e9ac$var$pseudosMap[sheet.slice(14, firstBracket)];
        if (mapped) return mapped;
    }
    const property = sheet.slice(firstBracket + 1, sheet.indexOf(':', firstBracket)).trim();
    const shorthandDepth = (0, $f7031165668ab2fb$export$b08836c779543dbf)(property);
    if (typeof shorthandDepth === 'number') return `s-${shorthandDepth}`;
    // Return default catch all bucket
    return '';
};
function $189a6334ccf0e9ac$export$2e2bcd8739ae039(css, opts) {
    const bucketName = $189a6334ccf0e9ac$export$d90f6836ea1aee93(css);
    const style = $189a6334ccf0e9ac$var$lazyAddStyleBucketToHead(bucketName, opts);
    {
        const sheet = style.sheet;
        // Used to avoid unhandled exceptions across browsers with prefixed selectors such as -moz-placeholder.
        try {
            sheet.insertRule(css, sheet.cssRules.length);
        } catch (_a) {}
    }
}



function $45806fc118e88e4e$export$2e2bcd8739ae039(props) {
    const inserted = (0, $e954cdbfe522d5cb$export$c6e89b6bb9436bc0)();
    if (props.children.length) {
        var bucket;
        for(let i = 0; i < props.children.length; i++){
            const sheet = props.children[i];
            if (inserted[sheet]) continue;
            inserted[sheet] = true;
            (0, $189a6334ccf0e9ac$export$2e2bcd8739ae039)(sheet, props);
        }
    }
    return null;
}



var $7fPBF = parcelRequire("7fPBF");

parcelRequire("7fPBF");
/* Footer.tsx generated by @compiled/babel-plugin v0.38.1 */ 
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $151b1d922dd4b2cf$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}



var $7fPBF = parcelRequire("7fPBF");
var $447ba15143f7eed7$exports = {};

$parcel$export($447ba15143f7eed7$exports, "GOTO_PREFERENCES_CENTER_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$397c69071c7b1ce2; });
$parcel$export($447ba15143f7eed7$exports, "GOTO_ATLASSIAN_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$a032c0358daca74b; });
$parcel$export($447ba15143f7eed7$exports, "PRIVACY_POLICY_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$bd3a35dde4ef175c; });
$parcel$export($447ba15143f7eed7$exports, "TERM_OF_USE_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$5ec2f4d972df7fd3; });
$parcel$export($447ba15143f7eed7$exports, "TRADEMARK_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$5c56b9e715e65435; });
$parcel$export($447ba15143f7eed7$exports, "USER_NOT_FOUND_MESSAGE", function () { return $447ba15143f7eed7$export$45923b899016cb93; });
$parcel$export($447ba15143f7eed7$exports, "EMPTY_USER_SUBSCRIPTIONS_MESSAGE", function () { return $447ba15143f7eed7$export$91435b4781e5f50d; });
$parcel$export($447ba15143f7eed7$exports, "ALL_LANGUAGES_MESSAGE", function () { return $447ba15143f7eed7$export$d3cd07d395a9ed0a; });
$parcel$export($447ba15143f7eed7$exports, "PROPOSED_LANGUAGE_MESSAGE", function () { return $447ba15143f7eed7$export$188c68aa312fbf1c; });
$parcel$export($447ba15143f7eed7$exports, "UNSUBSCRIBE_ALL_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$3d386fa5ce2bb50f; });
$parcel$export($447ba15143f7eed7$exports, "UNSUBSCRIBE_ALL_TOOLTIP_LABEL", function () { return $447ba15143f7eed7$export$e76fe16bca5a05f; });
$parcel$export($447ba15143f7eed7$exports, "UPDATE_SUBSCRIPTIONS_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$bb457a99f02ee8df; });
$parcel$export($447ba15143f7eed7$exports, "GMOI_REQUEST_ERROR_MESSAGE", function () { return $447ba15143f7eed7$export$1042bd74142919d3; });
$parcel$export($447ba15143f7eed7$exports, "SELECT_LABEL", function () { return $447ba15143f7eed7$export$8282e8208b45c51a; });
$parcel$export($447ba15143f7eed7$exports, "SELECT_ALL_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$986068f8bec214ca; });
$parcel$export($447ba15143f7eed7$exports, "SELECT_NONE_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$b79e4a941028ca1f; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_ERROR_MESSAGE_TITLE", function () { return $447ba15143f7eed7$export$ddb748859563ce79; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_ERROR_MESSAGE_DESCRIPTION", function () { return $447ba15143f7eed7$export$c79abf3d845a1fdd; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_NOTE_MESSAGE", function () { return $447ba15143f7eed7$export$866e88663611df05; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_GLOBAL_UNSUBSCRIBE_MESSAGE_TITLE", function () { return $447ba15143f7eed7$export$5093956da3c8db1c; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_PRODUCT_INVITATIONS_WARNING_TITLE", function () { return $447ba15143f7eed7$export$781d5fa1055ae86a; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_PRODUCT_INVITATIONS_WARNING_BODY_PRIMARY", function () { return $447ba15143f7eed7$export$956f2ec48e0de951; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_PRODUCT_INVITATIONS_WARNING_BODY_SECONDARY", function () { return $447ba15143f7eed7$export$e3a826721228e8e2; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_SUBSCRIBE_MESSAGE_TITLE", function () { return $447ba15143f7eed7$export$54dcd5dee646311c; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_PRIMARY", function () { return $447ba15143f7eed7$export$455b805d86ac6cee; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_SECONDARY", function () { return $447ba15143f7eed7$export$803298324e8194ae; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_TERTIARY", function () { return $447ba15143f7eed7$export$f4911f869cc01000; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UNSUBSCRIBE_MESSAGE_TITLE", function () { return $447ba15143f7eed7$export$70371af9f5fd8981; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_PRIMARY", function () { return $447ba15143f7eed7$export$e95889acedebb0b; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_SECONDARY", function () { return $447ba15143f7eed7$export$e52a7b9718929cd4; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_TERTIARY", function () { return $447ba15143f7eed7$export$ac6196eb73ad054e; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UPDATE_SUCCESS_MESSAGE_TITLE", function () { return $447ba15143f7eed7$export$6710290bec50a2d9; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UPDATE_SUCCESS_MESSAGE_DESCRIPTION", function () { return $447ba15143f7eed7$export$6c795c0503e7a19a; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UPDATE_CONSENT_DOUBLE_OPT_IN_MESSAGE", function () { return $447ba15143f7eed7$export$298d0327b5b79594; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_LEARN_MORE_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$cef752f911adf0f9; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_DISMISS_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$7bdbef670c907c38; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_SUBSCRIBE_TO_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$54a1be12708d2f5; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DIALOG_LABEL", function () { return $447ba15143f7eed7$export$6cdfffd461a59281; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DIALOG_ACCEPT_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$d1eeb2bc07f4f58b; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DIALOG_DECLINE_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$fd792269277ee593; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DIALOG_GMOI_MESSAGE", function () { return $447ba15143f7eed7$export$4aeb433178e4246b; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DECLINE_PR_DIALOG_LABEL", function () { return $447ba15143f7eed7$export$1d83912f2291ee3c; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DECLINE_PR_DIALOG_MESSAGE", function () { return $447ba15143f7eed7$export$f871df89b6210c46; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DECLINE_PR_ACCEPT_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$6fa38d28a45687c1; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DECLINE_PR_CANCEL_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$1840364bf6f6fbfe; });
$parcel$export($447ba15143f7eed7$exports, "GLOBAL_UNSUBSCRIBE_DIALOG_LABEL", function () { return $447ba15143f7eed7$export$edd3a3232f802b5f; });
$parcel$export($447ba15143f7eed7$exports, "GLOBAL_UNSUBSCRIBE_DIALOG_MESSAGE", function () { return $447ba15143f7eed7$export$995b366aaf4ad5bf; });
$parcel$export($447ba15143f7eed7$exports, "GLOBAL_UNSUBSCRIBE_DIALOG_ACCEPT_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$6b585b2c49802e53; });
$parcel$export($447ba15143f7eed7$exports, "GLOBAL_UNSUBSCRIBE_DIALOG_DECLINE_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$42d9402f99ba57a; });
$parcel$export($447ba15143f7eed7$exports, "DOUBLE_OPT_IN_DIALOG_LABEL", function () { return $447ba15143f7eed7$export$5005c05e9a6da27b; });
$parcel$export($447ba15143f7eed7$exports, "DOUBLE_OPT_IN_DIALOG_MESSAGE", function () { return $447ba15143f7eed7$export$e5a61277c372c8c4; });
$parcel$export($447ba15143f7eed7$exports, "DOUBLE_OPT_IN_DIALOG_ACCEPT_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$8496d3c16cb9aaae; });
const $447ba15143f7eed7$export$397c69071c7b1ce2 = 'goto_preferences_center.button.label';
const $447ba15143f7eed7$export$a032c0358daca74b = 'goto_atlassian.button.label';
const $447ba15143f7eed7$export$bd3a35dde4ef175c = 'privacy_policy.button.label';
const $447ba15143f7eed7$export$5ec2f4d972df7fd3 = 'term_of_use.button.label';
const $447ba15143f7eed7$export$5c56b9e715e65435 = 'trademark.button.label';
const $447ba15143f7eed7$export$45923b899016cb93 = 'user_not_found.message';
const $447ba15143f7eed7$export$91435b4781e5f50d = 'empty_user_subscriptions.message';
const $447ba15143f7eed7$export$d3cd07d395a9ed0a = 'all_languages.message';
const $447ba15143f7eed7$export$188c68aa312fbf1c = 'proposed_language.message';
const $447ba15143f7eed7$export$3d386fa5ce2bb50f = 'unsubscribe_all.button.label';
const $447ba15143f7eed7$export$e76fe16bca5a05f = 'unsubscribe_all.tooltip.label';
const $447ba15143f7eed7$export$bb457a99f02ee8df = 'update_subscriptions.button.label';
const $447ba15143f7eed7$export$1042bd74142919d3 = 'gmoi_request.error.message';
const $447ba15143f7eed7$export$8282e8208b45c51a = 'select.label';
const $447ba15143f7eed7$export$986068f8bec214ca = 'select_all.button.label';
const $447ba15143f7eed7$export$b79e4a941028ca1f = 'select_none.button.label';
const $447ba15143f7eed7$export$ddb748859563ce79 = 'notification.error.message.title';
const $447ba15143f7eed7$export$c79abf3d845a1fdd = 'notification.error.message.description';
const $447ba15143f7eed7$export$866e88663611df05 = 'notification.note.message';
const $447ba15143f7eed7$export$5093956da3c8db1c = 'notification.global_unsubscribe.message.title';
const $447ba15143f7eed7$export$781d5fa1055ae86a = 'notification.product_invitations.warning.title';
const $447ba15143f7eed7$export$956f2ec48e0de951 = 'notification.product_invitations.warning.body.primary';
const $447ba15143f7eed7$export$e3a826721228e8e2 = 'notification.product_invitations.warning.body.secondary';
const $447ba15143f7eed7$export$54dcd5dee646311c = 'notification.subscribe.message.title';
const $447ba15143f7eed7$export$455b805d86ac6cee = 'notification.subscribe.message.body.primary';
const $447ba15143f7eed7$export$803298324e8194ae = 'notification.subscribe.message.body.secondary';
const $447ba15143f7eed7$export$f4911f869cc01000 = 'notification.subscribe.message.body.tertiary';
const $447ba15143f7eed7$export$70371af9f5fd8981 = 'notification.unsubscribe.message.title';
const $447ba15143f7eed7$export$e95889acedebb0b = 'notification.unsubscribe.message.body.primary';
const $447ba15143f7eed7$export$e52a7b9718929cd4 = 'notification.unsubscribe.message.body.secondary';
const $447ba15143f7eed7$export$ac6196eb73ad054e = 'notification.unsubscribe.message.body.tertiary';
const $447ba15143f7eed7$export$6710290bec50a2d9 = 'notification.update_subscriptions.message.title';
const $447ba15143f7eed7$export$6c795c0503e7a19a = 'notification.update_subscriptions.message.description';
const $447ba15143f7eed7$export$298d0327b5b79594 = 'notification.update_consent.double_opt_in.message';
const $447ba15143f7eed7$export$cef752f911adf0f9 = 'notification.learn_more.button.label';
const $447ba15143f7eed7$export$7bdbef670c907c38 = 'notification.dismiss.button.label';
const $447ba15143f7eed7$export$54a1be12708d2f5 = 'notification.subscribe_to.button.label';
const $447ba15143f7eed7$export$6cdfffd461a59281 = 'consent_dialog.label';
const $447ba15143f7eed7$export$d1eeb2bc07f4f58b = 'consent_dialog.accept.button.label';
const $447ba15143f7eed7$export$fd792269277ee593 = 'consent_dialog.decline.button.label';
const $447ba15143f7eed7$export$4aeb433178e4246b = 'consent_dialog.gmoi.message';
const $447ba15143f7eed7$export$1d83912f2291ee3c = 'consent_decline_pr.dialog.label';
const $447ba15143f7eed7$export$f871df89b6210c46 = 'consent_decline_pr.dialog.message';
const $447ba15143f7eed7$export$6fa38d28a45687c1 = 'consent_decline_pr.accept.button.label';
const $447ba15143f7eed7$export$1840364bf6f6fbfe = 'consent_decline_pr.decline.button.label';
const $447ba15143f7eed7$export$edd3a3232f802b5f = 'global_unsubscribe_dialog.label';
const $447ba15143f7eed7$export$995b366aaf4ad5bf = 'global_unsubscribe_dialog.message';
const $447ba15143f7eed7$export$6b585b2c49802e53 = 'global_unsubscribe_dialog.accept.button.label';
const $447ba15143f7eed7$export$42d9402f99ba57a = 'global_unsubscribe_dialog.decline.button.label';
const $447ba15143f7eed7$export$5005c05e9a6da27b = 'double_opt_in_dialog.label';
const $447ba15143f7eed7$export$e5a61277c372c8c4 = 'double_opt_in_dialog.message';
const $447ba15143f7eed7$export$8496d3c16cb9aaae = 'double_opt_in_dialog.accept.button.label';


function $919ebf39980bf8f3$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $6e5b65c9cbae0db9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $919ebf39980bf8f3$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $1c481e73824c6361$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c481e73824c6361$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c481e73824c6361$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


// src/utils/formatProdErrorMessage.ts


function $78916fc80cd27125$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $78916fc80cd27125$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $78916fc80cd27125$var$symbol_observable_default = $78916fc80cd27125$var$$$observable;
// src/utils/actionTypes.ts
var $78916fc80cd27125$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $78916fc80cd27125$var$ActionTypes = {
    INIT: `@@redux/INIT${$78916fc80cd27125$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$78916fc80cd27125$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$78916fc80cd27125$var$randomString()}`
};
var $78916fc80cd27125$export$4219e499db7ca678 = $78916fc80cd27125$var$ActionTypes;
// src/utils/isPlainObject.ts
function $78916fc80cd27125$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $78916fc80cd27125$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($78916fc80cd27125$var$isDate(val)) return "date";
    if ($78916fc80cd27125$var$isError(val)) return "error";
    const constructorName = $78916fc80cd27125$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $78916fc80cd27125$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $78916fc80cd27125$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $78916fc80cd27125$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $78916fc80cd27125$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $78916fc80cd27125$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(1));
        return enhancer($78916fc80cd27125$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$78916fc80cd27125$export$53b83ca8eaab0383(action)) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $78916fc80cd27125$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$78916fc80cd27125$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $78916fc80cd27125$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$78916fc80cd27125$var$symbol_observable_default]: observable
    };
    return store;
}
function $78916fc80cd27125$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $78916fc80cd27125$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $78916fc80cd27125$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $78916fc80cd27125$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $78916fc80cd27125$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$78916fc80cd27125$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$78916fc80cd27125$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $78916fc80cd27125$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $78916fc80cd27125$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $78916fc80cd27125$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $78916fc80cd27125$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(13));
    });
}
function $78916fc80cd27125$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $78916fc80cd27125$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($78916fc80cd27125$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $78916fc80cd27125$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $78916fc80cd27125$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $78916fc80cd27125$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $78916fc80cd27125$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $78916fc80cd27125$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $78916fc80cd27125$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($78916fc80cd27125$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $78916fc80cd27125$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, store), {
                dispatch: dispatch
            });
        };
}
// src/utils/isAction.ts
function $78916fc80cd27125$export$b956e38827fca970(action) {
    return $78916fc80cd27125$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $7d97e02cb028d0b8$var$__defProp = Object.defineProperty;
var $7d97e02cb028d0b8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7d97e02cb028d0b8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7d97e02cb028d0b8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7d97e02cb028d0b8$var$__defNormalProp = (obj, key, value)=>key in obj ? $7d97e02cb028d0b8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7d97e02cb028d0b8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7d97e02cb028d0b8$var$__hasOwnProp.call(b, prop)) $7d97e02cb028d0b8$var$__defNormalProp(a, prop, b[prop]);
    if ($7d97e02cb028d0b8$var$__getOwnPropSymbols) {
        for (var prop of $7d97e02cb028d0b8$var$__getOwnPropSymbols(b))if ($7d97e02cb028d0b8$var$__propIsEnum.call(b, prop)) $7d97e02cb028d0b8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $7d97e02cb028d0b8$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $7d97e02cb028d0b8$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $7d97e02cb028d0b8$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $7d97e02cb028d0b8$var$errors = [];
function $7d97e02cb028d0b8$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $7d97e02cb028d0b8$var$getPrototypeOf = Object.getPrototypeOf;
function $7d97e02cb028d0b8$export$541ac630993a4c84(value) {
    return !!value && !!value[$7d97e02cb028d0b8$var$DRAFT_STATE];
}
function $7d97e02cb028d0b8$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $7d97e02cb028d0b8$var$isPlainObject(value) || Array.isArray(value) || !!value[$7d97e02cb028d0b8$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$7d97e02cb028d0b8$export$6ee2082928bcb0ee]) || $7d97e02cb028d0b8$var$isMap(value) || $7d97e02cb028d0b8$var$isSet(value);
}
var $7d97e02cb028d0b8$var$objectCtorString = Object.prototype.constructor.toString();
function $7d97e02cb028d0b8$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $7d97e02cb028d0b8$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $7d97e02cb028d0b8$var$objectCtorString;
}
function $7d97e02cb028d0b8$export$22e8af3f75a010e3(value) {
    if (!$7d97e02cb028d0b8$export$541ac630993a4c84(value)) $7d97e02cb028d0b8$var$die(15, value);
    return value[$7d97e02cb028d0b8$var$DRAFT_STATE].base_;
}
function $7d97e02cb028d0b8$var$each(obj, iter) {
    if ($7d97e02cb028d0b8$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $7d97e02cb028d0b8$var$getArchtype(thing) {
    const state = thing[$7d97e02cb028d0b8$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $7d97e02cb028d0b8$var$isMap(thing) ? 2 /* Map */  : $7d97e02cb028d0b8$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $7d97e02cb028d0b8$var$has(thing, prop) {
    return $7d97e02cb028d0b8$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $7d97e02cb028d0b8$var$get(thing, prop) {
    return $7d97e02cb028d0b8$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $7d97e02cb028d0b8$var$set(thing, propOrOldValue, value) {
    const t = $7d97e02cb028d0b8$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $7d97e02cb028d0b8$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $7d97e02cb028d0b8$var$isMap(target) {
    return target instanceof Map;
}
function $7d97e02cb028d0b8$var$isSet(target) {
    return target instanceof Set;
}
function $7d97e02cb028d0b8$var$latest(state) {
    return state.copy_ || state.base_;
}
function $7d97e02cb028d0b8$var$shallowCopy(base, strict) {
    if ($7d97e02cb028d0b8$var$isMap(base)) return new Map(base);
    if ($7d97e02cb028d0b8$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $7d97e02cb028d0b8$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$7d97e02cb028d0b8$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($7d97e02cb028d0b8$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $7d97e02cb028d0b8$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $7d97e02cb028d0b8$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $7d97e02cb028d0b8$export$792f3d81ea979f55(obj, deep = false) {
    if ($7d97e02cb028d0b8$var$isFrozen(obj) || $7d97e02cb028d0b8$export$541ac630993a4c84(obj) || !$7d97e02cb028d0b8$export$16e3aed3edb85946(obj)) return obj;
    if ($7d97e02cb028d0b8$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $7d97e02cb028d0b8$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$7d97e02cb028d0b8$export$792f3d81ea979f55(value, true));
    return obj;
}
function $7d97e02cb028d0b8$var$dontMutateFrozenCollections() {
    $7d97e02cb028d0b8$var$die(2);
}
function $7d97e02cb028d0b8$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $7d97e02cb028d0b8$var$plugins = {};
function $7d97e02cb028d0b8$var$getPlugin(pluginKey) {
    const plugin = $7d97e02cb028d0b8$var$plugins[pluginKey];
    if (!plugin) $7d97e02cb028d0b8$var$die(0, pluginKey);
    return plugin;
}
function $7d97e02cb028d0b8$var$loadPlugin(pluginKey, implementation) {
    if (!$7d97e02cb028d0b8$var$plugins[pluginKey]) $7d97e02cb028d0b8$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $7d97e02cb028d0b8$var$currentScope;
function $7d97e02cb028d0b8$var$getCurrentScope() {
    return $7d97e02cb028d0b8$var$currentScope;
}
function $7d97e02cb028d0b8$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $7d97e02cb028d0b8$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $7d97e02cb028d0b8$var$revokeScope(scope) {
    $7d97e02cb028d0b8$var$leaveScope(scope);
    scope.drafts_.forEach($7d97e02cb028d0b8$var$revokeDraft);
    scope.drafts_ = null;
}
function $7d97e02cb028d0b8$var$leaveScope(scope) {
    if (scope === $7d97e02cb028d0b8$var$currentScope) $7d97e02cb028d0b8$var$currentScope = scope.parent_;
}
function $7d97e02cb028d0b8$var$enterScope(immer2) {
    return $7d97e02cb028d0b8$var$currentScope = $7d97e02cb028d0b8$var$createScope($7d97e02cb028d0b8$var$currentScope, immer2);
}
function $7d97e02cb028d0b8$var$revokeDraft(draft) {
    const state = draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $7d97e02cb028d0b8$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$7d97e02cb028d0b8$var$DRAFT_STATE].modified_) {
            $7d97e02cb028d0b8$var$revokeScope(scope);
            $7d97e02cb028d0b8$var$die(4);
        }
        if ($7d97e02cb028d0b8$export$16e3aed3edb85946(result)) {
            result = $7d97e02cb028d0b8$var$finalize(scope, result);
            if (!scope.parent_) $7d97e02cb028d0b8$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $7d97e02cb028d0b8$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$7d97e02cb028d0b8$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $7d97e02cb028d0b8$var$finalize(scope, baseDraft, []);
    $7d97e02cb028d0b8$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $7d97e02cb028d0b8$export$45b790e32b2810ee ? result : void 0;
}
function $7d97e02cb028d0b8$var$finalize(rootScope, value, path) {
    if ($7d97e02cb028d0b8$var$isFrozen(value)) return value;
    const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
    if (!state) {
        $7d97e02cb028d0b8$var$each(value, (key, childValue)=>$7d97e02cb028d0b8$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $7d97e02cb028d0b8$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $7d97e02cb028d0b8$var$each(resultEach, (key, childValue)=>$7d97e02cb028d0b8$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $7d97e02cb028d0b8$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $7d97e02cb028d0b8$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $7d97e02cb028d0b8$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($7d97e02cb028d0b8$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$7d97e02cb028d0b8$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $7d97e02cb028d0b8$var$finalize(rootScope, childValue, path);
        $7d97e02cb028d0b8$var$set(targetObject, prop, res);
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($7d97e02cb028d0b8$export$16e3aed3edb85946(childValue) && !$7d97e02cb028d0b8$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $7d97e02cb028d0b8$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $7d97e02cb028d0b8$var$maybeFreeze(rootScope, childValue);
    }
}
function $7d97e02cb028d0b8$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $7d97e02cb028d0b8$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $7d97e02cb028d0b8$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $7d97e02cb028d0b8$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $7d97e02cb028d0b8$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $7d97e02cb028d0b8$var$objectTraps = {
    get (state, prop) {
        if (prop === $7d97e02cb028d0b8$var$DRAFT_STATE) return state;
        const source = $7d97e02cb028d0b8$var$latest(state);
        if (!$7d97e02cb028d0b8$var$has(source, prop)) return $7d97e02cb028d0b8$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$7d97e02cb028d0b8$export$16e3aed3edb85946(value)) return value;
        if (value === $7d97e02cb028d0b8$var$peek(state.base_, prop)) {
            $7d97e02cb028d0b8$var$prepareCopy(state);
            return state.copy_[prop] = $7d97e02cb028d0b8$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $7d97e02cb028d0b8$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($7d97e02cb028d0b8$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $7d97e02cb028d0b8$var$getDescriptorFromProto($7d97e02cb028d0b8$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $7d97e02cb028d0b8$var$peek($7d97e02cb028d0b8$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$7d97e02cb028d0b8$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($7d97e02cb028d0b8$var$is(value, current2) && (value !== void 0 || $7d97e02cb028d0b8$var$has(state.base_, prop))) return true;
            $7d97e02cb028d0b8$var$prepareCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($7d97e02cb028d0b8$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $7d97e02cb028d0b8$var$prepareCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $7d97e02cb028d0b8$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $7d97e02cb028d0b8$var$die(11);
    },
    getPrototypeOf (state) {
        return $7d97e02cb028d0b8$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $7d97e02cb028d0b8$var$die(12);
    }
};
var $7d97e02cb028d0b8$var$arrayTraps = {};
$7d97e02cb028d0b8$var$each($7d97e02cb028d0b8$var$objectTraps, (key, fn)=>{
    $7d97e02cb028d0b8$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$7d97e02cb028d0b8$var$arrayTraps.deleteProperty = function(state, prop) {
    return $7d97e02cb028d0b8$var$arrayTraps.set.call(this, state, prop, void 0);
};
$7d97e02cb028d0b8$var$arrayTraps.set = function(state, prop, value) {
    return $7d97e02cb028d0b8$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $7d97e02cb028d0b8$var$peek(draft, prop) {
    const state = draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
    const source = state ? $7d97e02cb028d0b8$var$latest(state) : draft;
    return source[prop];
}
function $7d97e02cb028d0b8$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $7d97e02cb028d0b8$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $7d97e02cb028d0b8$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $7d97e02cb028d0b8$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $7d97e02cb028d0b8$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $7d97e02cb028d0b8$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $7d97e02cb028d0b8$var$markChanged(state.parent_);
    }
}
function $7d97e02cb028d0b8$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $7d97e02cb028d0b8$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $7d97e02cb028d0b8$export$aaadc6ff0f822719 = class {
    createDraft(base) {
        if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(base)) $7d97e02cb028d0b8$var$die(8);
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(base)) base = $7d97e02cb028d0b8$export$97aac956da55dae9(base);
        const scope = $7d97e02cb028d0b8$var$enterScope(this);
        const proxy = $7d97e02cb028d0b8$var$createProxy(base, void 0);
        proxy[$7d97e02cb028d0b8$var$DRAFT_STATE].isManual_ = true;
        $7d97e02cb028d0b8$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
        if (!state || !state.isManual_) $7d97e02cb028d0b8$var$die(9);
        const { scope_: scope } = state;
        $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener);
        return $7d97e02cb028d0b8$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $7d97e02cb028d0b8$var$getPlugin("Patches").applyPatches_;
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $7d97e02cb028d0b8$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $7d97e02cb028d0b8$var$die(7);
            let result;
            if ($7d97e02cb028d0b8$export$16e3aed3edb85946(base)) {
                const scope = $7d97e02cb028d0b8$var$enterScope(this);
                const proxy = $7d97e02cb028d0b8$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $7d97e02cb028d0b8$var$revokeScope(scope);
                    else $7d97e02cb028d0b8$var$leaveScope(scope);
                }
                $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener);
                return $7d97e02cb028d0b8$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $7d97e02cb028d0b8$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $7d97e02cb028d0b8$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $7d97e02cb028d0b8$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $7d97e02cb028d0b8$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
};
function $7d97e02cb028d0b8$var$createProxy(value, parent) {
    const draft = $7d97e02cb028d0b8$var$isMap(value) ? $7d97e02cb028d0b8$var$getPlugin("MapSet").proxyMap_(value, parent) : $7d97e02cb028d0b8$var$isSet(value) ? $7d97e02cb028d0b8$var$getPlugin("MapSet").proxySet_(value, parent) : $7d97e02cb028d0b8$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $7d97e02cb028d0b8$export$97aac956da55dae9(value) {
    if (!$7d97e02cb028d0b8$export$541ac630993a4c84(value)) $7d97e02cb028d0b8$var$die(10, value);
    return $7d97e02cb028d0b8$var$currentImpl(value);
}
function $7d97e02cb028d0b8$var$currentImpl(value) {
    if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(value) || $7d97e02cb028d0b8$var$isFrozen(value)) return value;
    const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $7d97e02cb028d0b8$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $7d97e02cb028d0b8$var$shallowCopy(value, true);
    $7d97e02cb028d0b8$var$each(copy, (key, childValue)=>{
        $7d97e02cb028d0b8$var$set(copy, key, $7d97e02cb028d0b8$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $7d97e02cb028d0b8$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $7d97e02cb028d0b8$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $7d97e02cb028d0b8$var$get(base_, key);
            const value = $7d97e02cb028d0b8$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $7d97e02cb028d0b8$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $7d97e02cb028d0b8$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $7d97e02cb028d0b8$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $7d97e02cb028d0b8$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $7d97e02cb028d0b8$var$die(errorOffset + 3);
                base = $7d97e02cb028d0b8$var$get(base, p);
                if (typeof base !== "object") $7d97e02cb028d0b8$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $7d97e02cb028d0b8$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $7d97e02cb028d0b8$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $7d97e02cb028d0b8$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($7d97e02cb028d0b8$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($7d97e02cb028d0b8$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($7d97e02cb028d0b8$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($7d97e02cb028d0b8$var$has(obj, $7d97e02cb028d0b8$export$6ee2082928bcb0ee)) cloned[$7d97e02cb028d0b8$export$6ee2082928bcb0ee] = obj[$7d97e02cb028d0b8$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $7d97e02cb028d0b8$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $7d97e02cb028d0b8$export$7d9f65390203b435() {
    class DraftMap extends Map {
        get size() {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$7d97e02cb028d0b8$var$latest(state).has(key) || $7d97e02cb028d0b8$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7d97e02cb028d0b8$var$latest(state).size) {
                prepareMapCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $7d97e02cb028d0b8$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            $7d97e02cb028d0b8$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $7d97e02cb028d0b8$var$latest(state).get(key);
            if (state.finalized_ || !$7d97e02cb028d0b8$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $7d97e02cb028d0b8$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($7d97e02cb028d0b8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
        constructor(target, parent){
            super();
            this[$7d97e02cb028d0b8$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        get size() {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7d97e02cb028d0b8$var$latest(state).size) {
                prepareSetCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($7d97e02cb028d0b8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
        constructor(target, parent){
            super();
            this[$7d97e02cb028d0b8$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($7d97e02cb028d0b8$export$16e3aed3edb85946(value)) {
                    const draft = $7d97e02cb028d0b8$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $7d97e02cb028d0b8$var$die(3, JSON.stringify($7d97e02cb028d0b8$var$latest(state)));
    }
    $7d97e02cb028d0b8$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $7d97e02cb028d0b8$var$immer = new $7d97e02cb028d0b8$export$aaadc6ff0f822719();
var $7d97e02cb028d0b8$export$b46cabe22e78bc00 = $7d97e02cb028d0b8$var$immer.produce;
var $7d97e02cb028d0b8$export$4da66d41c9492c78 = $7d97e02cb028d0b8$var$immer.produceWithPatches.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$573f26f60825c493 = $7d97e02cb028d0b8$var$immer.setAutoFreeze.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$333ce65961cbe047 = $7d97e02cb028d0b8$var$immer.setUseStrictShallowCopy.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$a8b8e03e6bbe5473 = $7d97e02cb028d0b8$var$immer.applyPatches.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$3c3214997190395f = $7d97e02cb028d0b8$var$immer.createDraft.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$c60f5e69c521b528 = $7d97e02cb028d0b8$var$immer.finishDraft.bind($7d97e02cb028d0b8$var$immer);
function $7d97e02cb028d0b8$export$c05b21e3257751e5(value) {
    return value;
}
function $7d97e02cb028d0b8$export$20f911b3f8cf0b74(value) {
    return value;
}


var $8098b29b64296697$var$__defProp = Object.defineProperty;
var $8098b29b64296697$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8098b29b64296697$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8098b29b64296697$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8098b29b64296697$var$__defNormalProp = (obj, key, value)=>key in obj ? $8098b29b64296697$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8098b29b64296697$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8098b29b64296697$var$__hasOwnProp.call(b, prop)) $8098b29b64296697$var$__defNormalProp(a, prop, b[prop]);
    if ($8098b29b64296697$var$__getOwnPropSymbols) {
        for (var prop of $8098b29b64296697$var$__getOwnPropSymbols(b))if ($8098b29b64296697$var$__propIsEnum.call(b, prop)) $8098b29b64296697$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8098b29b64296697$var$__publicField = (obj, key, value)=>{
    $8098b29b64296697$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $8098b29b64296697$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $8098b29b64296697$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $8098b29b64296697$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $8098b29b64296697$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($8098b29b64296697$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $8098b29b64296697$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $8098b29b64296697$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $8098b29b64296697$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $8098b29b64296697$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $8098b29b64296697$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $8098b29b64296697$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $8098b29b64296697$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $8098b29b64296697$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $8098b29b64296697$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $8098b29b64296697$var$__spreadValues($8098b29b64296697$var$__spreadValues({}, $8098b29b64296697$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $8098b29b64296697$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $8098b29b64296697$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $8098b29b64296697$var$$REVISION = 0;
var $8098b29b64296697$var$CURRENT_TRACKER = null;
var $8098b29b64296697$var$Cell = class {
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $8098b29b64296697$var$CURRENT_TRACKER == null || $8098b29b64296697$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$8098b29b64296697$var$$REVISION;
    }
    constructor(initialValue, isEqual = $8098b29b64296697$var$tripleEq){
        $8098b29b64296697$var$__publicField(this, "revision", $8098b29b64296697$var$$REVISION);
        $8098b29b64296697$var$__publicField(this, "_value");
        $8098b29b64296697$var$__publicField(this, "_lastValue");
        $8098b29b64296697$var$__publicField(this, "_isEqual", $8098b29b64296697$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
};
function $8098b29b64296697$var$tripleEq(a, b) {
    return a === b;
}
var $8098b29b64296697$var$TrackingCache = class {
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $8098b29b64296697$var$CURRENT_TRACKER;
            $8098b29b64296697$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $8098b29b64296697$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $8098b29b64296697$var$CURRENT_TRACKER == null || $8098b29b64296697$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
    constructor(fn){
        $8098b29b64296697$var$__publicField(this, "_cachedValue");
        $8098b29b64296697$var$__publicField(this, "_cachedRevision", -1);
        $8098b29b64296697$var$__publicField(this, "_deps", []);
        $8098b29b64296697$var$__publicField(this, "hits", 0);
        $8098b29b64296697$var$__publicField(this, "fn");
        this.fn = fn;
    }
};
function $8098b29b64296697$var$getValue(cell) {
    if (!(cell instanceof $8098b29b64296697$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $8098b29b64296697$var$setValue(storage, value) {
    if (!(storage instanceof $8098b29b64296697$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $8098b29b64296697$var$createCell(initialValue, isEqual = $8098b29b64296697$var$tripleEq) {
    return new $8098b29b64296697$var$Cell(initialValue, isEqual);
}
function $8098b29b64296697$var$createCache(fn) {
    $8098b29b64296697$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $8098b29b64296697$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $8098b29b64296697$var$neverEq = (a, b)=>false;
function $8098b29b64296697$var$createTag() {
    return $8098b29b64296697$var$createCell(null, $8098b29b64296697$var$neverEq);
}
function $8098b29b64296697$var$dirtyTag(tag, value) {
    $8098b29b64296697$var$setValue(tag, value);
}
var $8098b29b64296697$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $8098b29b64296697$var$createTag();
    $8098b29b64296697$var$getValue(tag);
};
var $8098b29b64296697$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $8098b29b64296697$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $8098b29b64296697$var$REDUX_PROXY_LABEL = Symbol();
var $8098b29b64296697$var$nextId = 0;
var $8098b29b64296697$var$proto = Object.getPrototypeOf({});
var $8098b29b64296697$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $8098b29b64296697$var$__publicField(this, "proxy", new Proxy(this, $8098b29b64296697$var$objectProxyHandler));
        $8098b29b64296697$var$__publicField(this, "tag", $8098b29b64296697$var$createTag());
        $8098b29b64296697$var$__publicField(this, "tags", {});
        $8098b29b64296697$var$__publicField(this, "children", {});
        $8098b29b64296697$var$__publicField(this, "collectionTag", null);
        $8098b29b64296697$var$__publicField(this, "id", $8098b29b64296697$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $8098b29b64296697$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $8098b29b64296697$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $8098b29b64296697$var$createNode(childValue);
                if (childNode.tag) $8098b29b64296697$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $8098b29b64296697$var$createTag();
                    tag.value = childValue;
                }
                $8098b29b64296697$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $8098b29b64296697$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $8098b29b64296697$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $8098b29b64296697$var$__publicField(this, "proxy", new Proxy([
            this
        ], $8098b29b64296697$var$arrayProxyHandler));
        $8098b29b64296697$var$__publicField(this, "tag", $8098b29b64296697$var$createTag());
        $8098b29b64296697$var$__publicField(this, "tags", {});
        $8098b29b64296697$var$__publicField(this, "children", {});
        $8098b29b64296697$var$__publicField(this, "collectionTag", null);
        $8098b29b64296697$var$__publicField(this, "id", $8098b29b64296697$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $8098b29b64296697$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $8098b29b64296697$var$consumeCollection(node);
        return $8098b29b64296697$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $8098b29b64296697$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $8098b29b64296697$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $8098b29b64296697$var$objectProxyHandler.has(node, prop);
    }
};
function $8098b29b64296697$var$createNode(value) {
    if (Array.isArray(value)) return new $8098b29b64296697$var$ArrayTreeNode(value);
    return new $8098b29b64296697$var$ObjectTreeNode(value);
}
function $8098b29b64296697$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $8098b29b64296697$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $8098b29b64296697$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $8098b29b64296697$var$dirtyCollection(node);
            $8098b29b64296697$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $8098b29b64296697$var$updateNode(childNode, newChildValue);
        else {
            $8098b29b64296697$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $8098b29b64296697$var$deleteNode(node) {
    if (node.tag) $8098b29b64296697$var$dirtyTag(node.tag, null);
    $8098b29b64296697$var$dirtyCollection(node);
    for(const key in node.tags)$8098b29b64296697$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$8098b29b64296697$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $8098b29b64296697$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $8098b29b64296697$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $8098b29b64296697$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $8098b29b64296697$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $8098b29b64296697$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $8098b29b64296697$export$3f025202a230c6dd = (a, b)=>a === b;
function $8098b29b64296697$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $8098b29b64296697$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $8098b29b64296697$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $8098b29b64296697$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $8098b29b64296697$var$createSingletonCache(comparator) : $8098b29b64296697$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $8098b29b64296697$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $8098b29b64296697$export$c8f9cf88d9fdee55(func) {
    const node = $8098b29b64296697$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $8098b29b64296697$var$createCacheKeyComparator($8098b29b64296697$export$3f025202a230c6dd);
    const cache = $8098b29b64296697$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $8098b29b64296697$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $8098b29b64296697$var$StrongRef = class {
    deref() {
        return this.value;
    }
    constructor(value){
        this.value = value;
    }
};
var $8098b29b64296697$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $8098b29b64296697$var$StrongRef;
var $8098b29b64296697$var$UNTERMINATED = 0;
var $8098b29b64296697$var$TERMINATED = 1;
function $8098b29b64296697$var$createCacheNode() {
    return {
        s: $8098b29b64296697$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $8098b29b64296697$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $8098b29b64296697$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $8098b29b64296697$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $8098b29b64296697$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $8098b29b64296697$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $8098b29b64296697$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $8098b29b64296697$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $8098b29b64296697$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $8098b29b64296697$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $8098b29b64296697$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $8098b29b64296697$var$__spreadValues($8098b29b64296697$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $8098b29b64296697$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $8098b29b64296697$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $8098b29b64296697$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $8098b29b64296697$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $8098b29b64296697$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $8098b29b64296697$export$595d22ed68ca2841 = /* @__PURE__ */ $8098b29b64296697$export$5943f4447f6ef248($8098b29b64296697$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $8098b29b64296697$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $8098b29b64296697$export$595d22ed68ca2841)=>{
    $8098b29b64296697$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$8098b29b64296697$export$75979cfcd91bf38f
});


// src/index.ts
function $a08349f8b4900e5d$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $a08349f8b4900e5d$export$dd164f5517779f15 = $a08349f8b4900e5d$var$createThunkMiddleware();
var $a08349f8b4900e5d$export$16d06542a1949d9e = $a08349f8b4900e5d$var$createThunkMiddleware;


var $15d924278321bdfd$var$__defProp = Object.defineProperty;
var $15d924278321bdfd$var$__defProps = Object.defineProperties;
var $15d924278321bdfd$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $15d924278321bdfd$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $15d924278321bdfd$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $15d924278321bdfd$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $15d924278321bdfd$var$__defNormalProp = (obj, key, value)=>key in obj ? $15d924278321bdfd$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $15d924278321bdfd$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($15d924278321bdfd$var$__hasOwnProp.call(b, prop)) $15d924278321bdfd$var$__defNormalProp(a, prop, b[prop]);
    if ($15d924278321bdfd$var$__getOwnPropSymbols) {
        for (var prop of $15d924278321bdfd$var$__getOwnPropSymbols(b))if ($15d924278321bdfd$var$__propIsEnum.call(b, prop)) $15d924278321bdfd$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $15d924278321bdfd$var$__spreadProps = (a, b)=>$15d924278321bdfd$var$__defProps(a, $15d924278321bdfd$var$__getOwnPropDescs(b));
var $15d924278321bdfd$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($15d924278321bdfd$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $15d924278321bdfd$var$__getOwnPropSymbols) {
        for (var prop of $15d924278321bdfd$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $15d924278321bdfd$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $15d924278321bdfd$var$__publicField = (obj, key, value)=>$15d924278321bdfd$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $15d924278321bdfd$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $8098b29b64296697$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $7d97e02cb028d0b8$export$541ac630993a4c84)(value) ? (0, $7d97e02cb028d0b8$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $15d924278321bdfd$export$a5d3c27355e35910 = /* @__PURE__ */ $15d924278321bdfd$export$aab6de9e3dbb1473((0, $8098b29b64296697$export$8402dc26d96f6902));
var $15d924278321bdfd$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $78916fc80cd27125$export$f672e0b6f7222cd7;
    return (0, $78916fc80cd27125$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $15d924278321bdfd$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $15d924278321bdfd$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $15d924278321bdfd$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($15d924278321bdfd$export$378fa86b259c0280(0));
            return $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $78916fc80cd27125$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $15d924278321bdfd$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $15d924278321bdfd$var$hasMatchFunction(action);
}
function $15d924278321bdfd$export$ebd532f9034651f3(action) {
    return (0, $78916fc80cd27125$export$b956e38827fca970)(action) && Object.keys(action).every($15d924278321bdfd$var$isValidKey);
}
function $15d924278321bdfd$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $15d924278321bdfd$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $15d924278321bdfd$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $15d924278321bdfd$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $15d924278321bdfd$export$1908877435b1d5e9 = class _Tuple extends Array {
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
};
function $15d924278321bdfd$var$freezeDraftable(val) {
    return (0, $7d97e02cb028d0b8$export$16e3aed3edb85946)(val) ? (0, $7d97e02cb028d0b8$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $15d924278321bdfd$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $15d924278321bdfd$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $15d924278321bdfd$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $15d924278321bdfd$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $15d924278321bdfd$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $15d924278321bdfd$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $15d924278321bdfd$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $15d924278321bdfd$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $15d924278321bdfd$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $15d924278321bdfd$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $15d924278321bdfd$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $78916fc80cd27125$export$53b83ca8eaab0383)(val);
}
function $15d924278321bdfd$export$ada5dca0b571bc7(value, path = "", isSerializable = $15d924278321bdfd$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $15d924278321bdfd$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $15d924278321bdfd$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $15d924278321bdfd$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$15d924278321bdfd$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $15d924278321bdfd$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $15d924278321bdfd$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $15d924278321bdfd$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $15d924278321bdfd$export$1908877435b1d5e9();
        if (thunk) {
            if ($15d924278321bdfd$var$isBoolean(thunk)) middlewareArray.push((0, $a08349f8b4900e5d$export$dd164f5517779f15));
            else middlewareArray.push((0, $a08349f8b4900e5d$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $15d924278321bdfd$export$8fb31c0f05df007b = "RTK_autoBatch";
var $15d924278321bdfd$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$15d924278321bdfd$export$8fb31c0f05df007b]: true
            }
        });
var $15d924278321bdfd$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $15d924278321bdfd$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $15d924278321bdfd$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $15d924278321bdfd$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$15d924278321bdfd$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $15d924278321bdfd$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $15d924278321bdfd$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($15d924278321bdfd$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $15d924278321bdfd$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $15d924278321bdfd$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $78916fc80cd27125$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $78916fc80cd27125$export$66e4520cdb265d18)(reducer);
    else throw new Error($15d924278321bdfd$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $78916fc80cd27125$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $15d924278321bdfd$var$composeWithDevTools($15d924278321bdfd$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $78916fc80cd27125$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $15d924278321bdfd$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $78916fc80cd27125$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $15d924278321bdfd$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($15d924278321bdfd$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($15d924278321bdfd$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $15d924278321bdfd$var$isStateFunction(x) {
    return typeof x === "function";
}
function $15d924278321bdfd$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $15d924278321bdfd$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($15d924278321bdfd$var$isStateFunction(initialState)) getInitialState = ()=>$15d924278321bdfd$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $15d924278321bdfd$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $7d97e02cb028d0b8$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $7d97e02cb028d0b8$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $7d97e02cb028d0b8$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $15d924278321bdfd$var$matches = (matcher, action)=>{
    if ($15d924278321bdfd$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $15d924278321bdfd$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$15d924278321bdfd$var$matches(matcher, action));
    };
}
function $15d924278321bdfd$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$15d924278321bdfd$var$matches(matcher, action));
    };
}
function $15d924278321bdfd$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $15d924278321bdfd$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $15d924278321bdfd$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$872dec21e9a69476()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $15d924278321bdfd$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $15d924278321bdfd$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $15d924278321bdfd$export$9dd1fb32974da385($15d924278321bdfd$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$fcc3388fb56de601()(asyncThunks[0]);
    return $15d924278321bdfd$export$9dd1fb32974da385($15d924278321bdfd$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $15d924278321bdfd$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$1da80a6ef1307441()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $15d924278321bdfd$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $15d924278321bdfd$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $15d924278321bdfd$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $15d924278321bdfd$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $15d924278321bdfd$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $15d924278321bdfd$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $15d924278321bdfd$var$__publicField(this, "_type");
    }
};
var $15d924278321bdfd$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $15d924278321bdfd$var$__publicField(this, "_type");
    }
};
var $15d924278321bdfd$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $15d924278321bdfd$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $15d924278321bdfd$var$externalAbortMessage = "External signal was aborted";
var $15d924278321bdfd$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $15d924278321bdfd$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $15d924278321bdfd$var$__spreadProps($15d924278321bdfd$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $15d924278321bdfd$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $15d924278321bdfd$var$__spreadProps($15d924278321bdfd$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $15d924278321bdfd$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $15d924278321bdfd$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $15d924278321bdfd$var$__spreadProps($15d924278321bdfd$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $15d924278321bdfd$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($15d924278321bdfd$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($15d924278321bdfd$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($15d924278321bdfd$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $15d924278321bdfd$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $15d924278321bdfd$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $15d924278321bdfd$var$RejectWithValue) throw result;
                                if (result instanceof $15d924278321bdfd$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $15d924278321bdfd$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($15d924278321bdfd$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $15d924278321bdfd$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $15d924278321bdfd$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $15d924278321bdfd$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $15d924278321bdfd$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $15d924278321bdfd$export$343355ed40c51c46 = {
    [$15d924278321bdfd$var$asyncThunkSymbol]: $15d924278321bdfd$export$6abd22dc03e5063f
};
var $15d924278321bdfd$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($15d924278321bdfd$export$23a094319a4b586 || {});
function $15d924278321bdfd$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $15d924278321bdfd$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$15d924278321bdfd$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($15d924278321bdfd$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($15d924278321bdfd$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($15d924278321bdfd$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($15d924278321bdfd$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $15d924278321bdfd$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($15d924278321bdfd$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $15d924278321bdfd$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $15d924278321bdfd$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $15d924278321bdfd$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $15d924278321bdfd$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $15d924278321bdfd$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $15d924278321bdfd$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $15d924278321bdfd$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $15d924278321bdfd$var$wrapSelector(selector, selectState, ()=>$15d924278321bdfd$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $15d924278321bdfd$var$__spreadProps($15d924278321bdfd$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $15d924278321bdfd$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $15d924278321bdfd$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $15d924278321bdfd$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $15d924278321bdfd$export$affdea4146de9cf5();
function $15d924278321bdfd$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $15d924278321bdfd$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $15d924278321bdfd$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$15d924278321bdfd$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($15d924278321bdfd$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $15d924278321bdfd$export$309c7a02b0b0bc62(type, prepareCallback) : $15d924278321bdfd$export$309c7a02b0b0bc62(type));
}
function $15d924278321bdfd$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $15d924278321bdfd$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $15d924278321bdfd$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($15d924278321bdfd$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $15d924278321bdfd$var$noop,
        pending: pending || $15d924278321bdfd$var$noop,
        rejected: rejected || $15d924278321bdfd$var$noop,
        settled: settled || $15d924278321bdfd$var$noop
    });
}
function $15d924278321bdfd$var$noop() {}
// src/entities/entity_state.ts
function $15d924278321bdfd$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $15d924278321bdfd$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($15d924278321bdfd$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $15d924278321bdfd$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $15d924278321bdfd$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $15d924278321bdfd$var$isDraftTyped = (0, $7d97e02cb028d0b8$export$541ac630993a4c84);
function $15d924278321bdfd$var$createSingleArgumentStateOperator(mutator) {
    const operator = $15d924278321bdfd$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $15d924278321bdfd$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $15d924278321bdfd$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($15d924278321bdfd$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $7d97e02cb028d0b8$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $15d924278321bdfd$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $15d924278321bdfd$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $15d924278321bdfd$var$getCurrent(value) {
    return (0, $7d97e02cb028d0b8$export$541ac630993a4c84)(value) ? (0, $7d97e02cb028d0b8$export$97aac956da55dae9)(value) : value;
}
function $15d924278321bdfd$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $15d924278321bdfd$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $15d924278321bdfd$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $15d924278321bdfd$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $15d924278321bdfd$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $15d924278321bdfd$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $15d924278321bdfd$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$15d924278321bdfd$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $15d924278321bdfd$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $15d924278321bdfd$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $15d924278321bdfd$var$createStateOperator(addOneMutably),
        addMany: $15d924278321bdfd$var$createStateOperator(addManyMutably),
        setOne: $15d924278321bdfd$var$createStateOperator(setOneMutably),
        setMany: $15d924278321bdfd$var$createStateOperator(setManyMutably),
        setAll: $15d924278321bdfd$var$createStateOperator(setAllMutably),
        updateOne: $15d924278321bdfd$var$createStateOperator(updateOneMutably),
        updateMany: $15d924278321bdfd$var$createStateOperator(updateManyMutably),
        upsertOne: $15d924278321bdfd$var$createStateOperator(upsertOneMutably),
        upsertMany: $15d924278321bdfd$var$createStateOperator(upsertManyMutably),
        removeOne: $15d924278321bdfd$var$createStateOperator(removeOneMutably),
        removeMany: $15d924278321bdfd$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $15d924278321bdfd$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $15d924278321bdfd$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $15d924278321bdfd$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $15d924278321bdfd$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $15d924278321bdfd$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $15d924278321bdfd$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($15d924278321bdfd$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $15d924278321bdfd$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $15d924278321bdfd$var$getCurrent(state.entities);
        const currentIds = $15d924278321bdfd$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $15d924278321bdfd$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $15d924278321bdfd$var$createStateOperator(addOneMutably),
        updateOne: $15d924278321bdfd$var$createStateOperator(updateOneMutably),
        upsertOne: $15d924278321bdfd$var$createStateOperator(upsertOneMutably),
        setOne: $15d924278321bdfd$var$createStateOperator(setOneMutably),
        setMany: $15d924278321bdfd$var$createStateOperator(setManyMutably),
        setAll: $15d924278321bdfd$var$createStateOperator(setAllMutably),
        addMany: $15d924278321bdfd$var$createStateOperator(addManyMutably),
        updateMany: $15d924278321bdfd$var$createStateOperator(updateManyMutably),
        upsertMany: $15d924278321bdfd$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $15d924278321bdfd$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $15d924278321bdfd$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $15d924278321bdfd$var$createSortedStateAdapter(selectId, sortComparer) : $15d924278321bdfd$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $15d924278321bdfd$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $15d924278321bdfd$var$createSelectorsFactory();
    return $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $15d924278321bdfd$var$task = "task";
var $15d924278321bdfd$var$listener = "listener";
var $15d924278321bdfd$var$completed = "completed";
var $15d924278321bdfd$var$cancelled = "cancelled";
var $15d924278321bdfd$var$taskCancelled = `task-${$15d924278321bdfd$var$cancelled}`;
var $15d924278321bdfd$var$taskCompleted = `task-${$15d924278321bdfd$var$completed}`;
var $15d924278321bdfd$var$listenerCancelled = `${$15d924278321bdfd$var$listener}-${$15d924278321bdfd$var$cancelled}`;
var $15d924278321bdfd$var$listenerCompleted = `${$15d924278321bdfd$var$listener}-${$15d924278321bdfd$var$completed}`;
var $15d924278321bdfd$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $15d924278321bdfd$var$__publicField(this, "name", "TaskAbortError");
        $15d924278321bdfd$var$__publicField(this, "message");
        this.message = `${$15d924278321bdfd$var$task} ${$15d924278321bdfd$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $15d924278321bdfd$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($15d924278321bdfd$export$378fa86b259c0280(32));
};
var $15d924278321bdfd$var$noop2 = ()=>{};
var $15d924278321bdfd$var$catchRejection = (promise, onError = $15d924278321bdfd$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $15d924278321bdfd$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $15d924278321bdfd$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $15d924278321bdfd$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $15d924278321bdfd$export$cb1bdac908fed7f(reason);
    }
};
function $15d924278321bdfd$var$raceWithSignal(signal, promise) {
    let cleanup = $15d924278321bdfd$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $15d924278321bdfd$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $15d924278321bdfd$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $15d924278321bdfd$var$noop2;
    });
}
var $15d924278321bdfd$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $15d924278321bdfd$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $15d924278321bdfd$var$createPause = (signal)=>{
    return (promise)=>{
        return $15d924278321bdfd$var$catchRejection($15d924278321bdfd$var$raceWithSignal(signal, promise).then((output)=>{
            $15d924278321bdfd$var$validateActive(signal);
            return output;
        }));
    };
};
var $15d924278321bdfd$var$createDelay = (signal)=>{
    const pause = $15d924278321bdfd$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $15d924278321bdfd$var$assign } = Object;
var $15d924278321bdfd$var$INTERNAL_NIL_TOKEN = {};
var $15d924278321bdfd$var$alm = "listenerMiddleware";
var $15d924278321bdfd$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$15d924278321bdfd$var$addAbortSignalListener(parentAbortSignal, ()=>$15d924278321bdfd$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $15d924278321bdfd$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $15d924278321bdfd$var$runTask(async ()=>{
            $15d924278321bdfd$var$validateActive(parentAbortSignal);
            $15d924278321bdfd$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $15d924278321bdfd$var$createPause(childAbortController.signal),
                delay: $15d924278321bdfd$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $15d924278321bdfd$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$15d924278321bdfd$var$abortControllerWithReason(childAbortController, $15d924278321bdfd$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($15d924278321bdfd$var$noop2));
        return {
            result: $15d924278321bdfd$var$createPause(parentAbortSignal)(result),
            cancel () {
                $15d924278321bdfd$var$abortControllerWithReason(childAbortController, $15d924278321bdfd$var$taskCancelled);
            }
        };
    };
};
var $15d924278321bdfd$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $15d924278321bdfd$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $15d924278321bdfd$var$raceWithSignal(signal, Promise.race(promises));
            $15d924278321bdfd$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$15d924278321bdfd$var$catchRejection(take(predicate, timeout));
};
var $15d924278321bdfd$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $15d924278321bdfd$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($15d924278321bdfd$export$378fa86b259c0280(21));
    $15d924278321bdfd$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $15d924278321bdfd$var$createListenerEntry = /* @__PURE__ */ $15d924278321bdfd$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $15d924278321bdfd$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $15d924278321bdfd$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($15d924278321bdfd$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$15d924278321bdfd$var$createListenerEntry
});
var $15d924278321bdfd$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $15d924278321bdfd$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $15d924278321bdfd$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $15d924278321bdfd$var$abortControllerWithReason(controller, $15d924278321bdfd$var$listenerCancelled);
    });
};
var $15d924278321bdfd$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($15d924278321bdfd$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $15d924278321bdfd$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $15d924278321bdfd$export$f03a6b845d3fb58b = /* @__PURE__ */ $15d924278321bdfd$var$assign(/* @__PURE__ */ $15d924278321bdfd$export$309c7a02b0b0bc62(`${$15d924278321bdfd$var$alm}/add`), {
    withTypes: ()=>$15d924278321bdfd$export$f03a6b845d3fb58b
});
var $15d924278321bdfd$export$b1b8022855fb2b71 = /* @__PURE__ */ $15d924278321bdfd$export$309c7a02b0b0bc62(`${$15d924278321bdfd$var$alm}/removeAll`);
var $15d924278321bdfd$export$b03e9483f936dccb = /* @__PURE__ */ $15d924278321bdfd$var$assign(/* @__PURE__ */ $15d924278321bdfd$export$309c7a02b0b0bc62(`${$15d924278321bdfd$var$alm}/remove`), {
    withTypes: ()=>$15d924278321bdfd$export$b03e9483f936dccb
});
var $15d924278321bdfd$var$defaultErrorHandler = (...args)=>{
    console.error(`${$15d924278321bdfd$var$alm}/error`, ...args);
};
var $15d924278321bdfd$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $15d924278321bdfd$var$defaultErrorHandler } = middlewareOptions;
    $15d924278321bdfd$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $15d924278321bdfd$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $15d924278321bdfd$var$findListenerEntry(listenerMap, options)) != null ? _a : $15d924278321bdfd$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $15d924278321bdfd$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $15d924278321bdfd$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $15d924278321bdfd$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $15d924278321bdfd$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $15d924278321bdfd$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $15d924278321bdfd$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $15d924278321bdfd$var$createDelay(internalTaskController.signal),
                pause: $15d924278321bdfd$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $15d924278321bdfd$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $15d924278321bdfd$var$abortControllerWithReason(controller, $15d924278321bdfd$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $15d924278321bdfd$var$abortControllerWithReason(internalTaskController, $15d924278321bdfd$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $15d924278321bdfd$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $15d924278321bdfd$export$cb1bdac908fed7f)) $15d924278321bdfd$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $15d924278321bdfd$var$abortControllerWithReason(internalTaskController, $15d924278321bdfd$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $15d924278321bdfd$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $78916fc80cd27125$export$b956e38827fca970)(action)) return next(action);
                if ($15d924278321bdfd$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($15d924278321bdfd$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($15d924278321bdfd$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $15d924278321bdfd$var$INTERNAL_NIL_TOKEN) throw new Error($15d924278321bdfd$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $15d924278321bdfd$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $15d924278321bdfd$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $15d924278321bdfd$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $15d924278321bdfd$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $15d924278321bdfd$export$4bb1606a79445586 = ()=>{
    const instanceId = $15d924278321bdfd$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($15d924278321bdfd$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $15d924278321bdfd$var$getOrInsertComputed(middlewareMap, middleware2, $15d924278321bdfd$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$15d924278321bdfd$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $78916fc80cd27125$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $15d924278321bdfd$export$9dd1fb32974da385(withMiddleware, $15d924278321bdfd$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $15d924278321bdfd$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $15d924278321bdfd$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$15d924278321bdfd$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $15d924278321bdfd$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $15d924278321bdfd$var$isStateProxy = (value)=>!!value && !!value[$15d924278321bdfd$var$ORIGINAL_STATE];
var $15d924278321bdfd$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $15d924278321bdfd$var$createStateProxy = (state, reducerMap, initialStateCache)=>$15d924278321bdfd$var$getOrInsertComputed($15d924278321bdfd$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $15d924278321bdfd$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $15d924278321bdfd$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($15d924278321bdfd$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $15d924278321bdfd$var$original = (state)=>{
    if (!$15d924278321bdfd$var$isStateProxy(state)) throw new Error($15d924278321bdfd$export$378fa86b259c0280(25));
    return state[$15d924278321bdfd$var$ORIGINAL_STATE];
};
var $15d924278321bdfd$var$emptyObject = {};
var $15d924278321bdfd$var$noopReducer = (state = $15d924278321bdfd$var$emptyObject)=>state;
function $15d924278321bdfd$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($15d924278321bdfd$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $78916fc80cd27125$export$66e4520cdb265d18)(reducerMap) : $15d924278321bdfd$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($15d924278321bdfd$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $15d924278321bdfd$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $15d924278321bdfd$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


'use strict';
function $4c852d2f6a5a0387$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $77146a31cb578292$var$toString } = Object.prototype;
const { getPrototypeOf: $77146a31cb578292$var$getPrototypeOf } = Object;
const { iterator: $77146a31cb578292$var$iterator, toStringTag: $77146a31cb578292$var$toStringTag } = Symbol;
const $77146a31cb578292$var$kindOf = ((cache)=>(thing)=>{
        const str = $77146a31cb578292$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $77146a31cb578292$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$77146a31cb578292$var$kindOf(thing) === type;
};
const $77146a31cb578292$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $77146a31cb578292$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $77146a31cb578292$var$isUndefined = $77146a31cb578292$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && $77146a31cb578292$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $77146a31cb578292$var$isArrayBuffer = $77146a31cb578292$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $77146a31cb578292$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $77146a31cb578292$var$isString = $77146a31cb578292$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $77146a31cb578292$var$isFunction = $77146a31cb578292$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $77146a31cb578292$var$isNumber = $77146a31cb578292$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $77146a31cb578292$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $77146a31cb578292$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $77146a31cb578292$var$isPlainObject = (val)=>{
    if ($77146a31cb578292$var$kindOf(val) !== 'object') return false;
    const prototype = $77146a31cb578292$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($77146a31cb578292$var$toStringTag in val) && !($77146a31cb578292$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $77146a31cb578292$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$77146a31cb578292$var$isObject(val) || $77146a31cb578292$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $77146a31cb578292$var$isDate = $77146a31cb578292$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFile = $77146a31cb578292$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $77146a31cb578292$var$isBlob = $77146a31cb578292$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFileList = $77146a31cb578292$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $77146a31cb578292$var$isStream = (val)=>$77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $77146a31cb578292$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $77146a31cb578292$var$isFunction(thing.append) && ((kind = $77146a31cb578292$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $77146a31cb578292$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $77146a31cb578292$var$isURLSearchParams = $77146a31cb578292$var$kindOfTest('URLSearchParams');
const [$77146a31cb578292$var$isReadableStream, $77146a31cb578292$var$isRequest, $77146a31cb578292$var$isResponse, $77146a31cb578292$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($77146a31cb578292$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $77146a31cb578292$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $77146a31cb578292$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($77146a31cb578292$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $77146a31cb578292$var$findKey(obj, key) {
    if ($77146a31cb578292$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $77146a31cb578292$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $77146a31cb578292$var$isContextDefined = (context)=>!$77146a31cb578292$var$isUndefined(context) && context !== $77146a31cb578292$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $77146a31cb578292$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $77146a31cb578292$var$findKey(result, key) || key;
        if ($77146a31cb578292$var$isPlainObject(result[targetKey]) && $77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge(result[targetKey], val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$77146a31cb578292$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $77146a31cb578292$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $77146a31cb578292$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $77146a31cb578292$var$forEach(b, (val, key)=>{
        if (thisArg && $77146a31cb578292$var$isFunction(val)) a[key] = (0, $4c852d2f6a5a0387$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $77146a31cb578292$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $77146a31cb578292$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $77146a31cb578292$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $77146a31cb578292$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $77146a31cb578292$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $77146a31cb578292$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($77146a31cb578292$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$77146a31cb578292$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $77146a31cb578292$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $77146a31cb578292$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $77146a31cb578292$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$77146a31cb578292$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $77146a31cb578292$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $77146a31cb578292$var$isHTMLForm = $77146a31cb578292$var$kindOfTest('HTMLFormElement');
const $77146a31cb578292$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $77146a31cb578292$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $77146a31cb578292$var$isRegExp = $77146a31cb578292$var$kindOfTest('RegExp');
const $77146a31cb578292$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $77146a31cb578292$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $77146a31cb578292$var$freezeMethods = (obj)=>{
    $77146a31cb578292$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($77146a31cb578292$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$77146a31cb578292$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $77146a31cb578292$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $77146a31cb578292$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $77146a31cb578292$var$noop = ()=>{};
const $77146a31cb578292$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $77146a31cb578292$var$isSpecCompliantForm(thing) {
    return !!(thing && $77146a31cb578292$var$isFunction(thing.append) && thing[$77146a31cb578292$var$toStringTag] === 'FormData' && thing[$77146a31cb578292$var$iterator]);
}
const $77146a31cb578292$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($77146a31cb578292$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($77146a31cb578292$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $77146a31cb578292$var$isArray(source) ? [] : {};
                $77146a31cb578292$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$77146a31cb578292$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $77146a31cb578292$var$isAsyncFn = $77146a31cb578292$var$kindOfTest('AsyncFunction');
const $77146a31cb578292$var$isThenable = (thing)=>thing && ($77146a31cb578292$var$isObject(thing) || $77146a31cb578292$var$isFunction(thing)) && $77146a31cb578292$var$isFunction(thing.then) && $77146a31cb578292$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $77146a31cb578292$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $77146a31cb578292$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $77146a31cb578292$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $77146a31cb578292$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $77146a31cb578292$var$isFunction($77146a31cb578292$var$_global.postMessage));
const $77146a31cb578292$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($77146a31cb578292$var$_global) : $77146a31cb578292$var$_setImmediate;
// *********************
const $77146a31cb578292$var$isIterable = (thing)=>thing != null && $77146a31cb578292$var$isFunction(thing[$77146a31cb578292$var$iterator]);
var $77146a31cb578292$export$2e2bcd8739ae039 = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isBoolean: $77146a31cb578292$var$isBoolean,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isEmptyObject: $77146a31cb578292$var$isEmptyObject,
    isReadableStream: $77146a31cb578292$var$isReadableStream,
    isRequest: $77146a31cb578292$var$isRequest,
    isResponse: $77146a31cb578292$var$isResponse,
    isHeaders: $77146a31cb578292$var$isHeaders,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isBlob: $77146a31cb578292$var$isBlob,
    isRegExp: $77146a31cb578292$var$isRegExp,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isTypedArray: $77146a31cb578292$var$isTypedArray,
    isFileList: $77146a31cb578292$var$isFileList,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM,
    inherits: $77146a31cb578292$var$inherits,
    toFlatObject: $77146a31cb578292$var$toFlatObject,
    kindOf: $77146a31cb578292$var$kindOf,
    kindOfTest: $77146a31cb578292$var$kindOfTest,
    endsWith: $77146a31cb578292$var$endsWith,
    toArray: $77146a31cb578292$var$toArray,
    forEachEntry: $77146a31cb578292$var$forEachEntry,
    matchAll: $77146a31cb578292$var$matchAll,
    isHTMLForm: $77146a31cb578292$var$isHTMLForm,
    hasOwnProperty: $77146a31cb578292$var$hasOwnProperty,
    hasOwnProp: $77146a31cb578292$var$hasOwnProperty,
    reduceDescriptors: $77146a31cb578292$var$reduceDescriptors,
    freezeMethods: $77146a31cb578292$var$freezeMethods,
    toObjectSet: $77146a31cb578292$var$toObjectSet,
    toCamelCase: $77146a31cb578292$var$toCamelCase,
    noop: $77146a31cb578292$var$noop,
    toFiniteNumber: $77146a31cb578292$var$toFiniteNumber,
    findKey: $77146a31cb578292$var$findKey,
    global: $77146a31cb578292$var$_global,
    isContextDefined: $77146a31cb578292$var$isContextDefined,
    isSpecCompliantForm: $77146a31cb578292$var$isSpecCompliantForm,
    toJSONObject: $77146a31cb578292$var$toJSONObject,
    isAsyncFn: $77146a31cb578292$var$isAsyncFn,
    isThenable: $77146a31cb578292$var$isThenable,
    setImmediate: $77146a31cb578292$var$_setImmediate,
    asap: $77146a31cb578292$var$asap,
    isIterable: $77146a31cb578292$var$isIterable
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $b9cc6960093b095e$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $77146a31cb578292$export$2e2bcd8739ae039).inherits($b9cc6960093b095e$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $77146a31cb578292$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $b9cc6960093b095e$var$prototype = $b9cc6960093b095e$var$AxiosError.prototype;
const $b9cc6960093b095e$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $b9cc6960093b095e$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($b9cc6960093b095e$var$AxiosError, $b9cc6960093b095e$var$descriptors);
Object.defineProperty($b9cc6960093b095e$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$b9cc6960093b095e$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($b9cc6960093b095e$var$prototype);
    (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    const msg = error && error.message ? error.message : 'Error';
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    const errCode = code == null && error ? error.code : code;
    $b9cc6960093b095e$var$AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, 'cause', {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || 'Error';
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $b9cc6960093b095e$export$2e2bcd8739ae039 = $b9cc6960093b095e$var$AxiosError;


// eslint-disable-next-line strict
var $31df7fcb8acaa73a$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $82a04c4ec6982288$export$a143d493d941bafc;
var $82a04c4ec6982288$export$e4cf37d7f6fb9e0a;
var $82a04c4ec6982288$export$f99ded8fe4b79145;
var $82a04c4ec6982288$export$599f31c3813fae4d;
'use strict';
var $27564b8a0078aa3d$export$a48f0734ac7c2329;
var $27564b8a0078aa3d$export$d622b2ad8d90c771;
var $27564b8a0078aa3d$export$6100ba28696e12de;
'use strict';
$27564b8a0078aa3d$export$a48f0734ac7c2329 = $27564b8a0078aa3d$var$byteLength;
$27564b8a0078aa3d$export$d622b2ad8d90c771 = $27564b8a0078aa3d$var$toByteArray;
$27564b8a0078aa3d$export$6100ba28696e12de = $27564b8a0078aa3d$var$fromByteArray;
var $27564b8a0078aa3d$var$lookup = [];
var $27564b8a0078aa3d$var$revLookup = [];
var $27564b8a0078aa3d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $27564b8a0078aa3d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $27564b8a0078aa3d$var$i = 0, $27564b8a0078aa3d$var$len = $27564b8a0078aa3d$var$code.length; $27564b8a0078aa3d$var$i < $27564b8a0078aa3d$var$len; ++$27564b8a0078aa3d$var$i){
    $27564b8a0078aa3d$var$lookup[$27564b8a0078aa3d$var$i] = $27564b8a0078aa3d$var$code[$27564b8a0078aa3d$var$i];
    $27564b8a0078aa3d$var$revLookup[$27564b8a0078aa3d$var$code.charCodeAt($27564b8a0078aa3d$var$i)] = $27564b8a0078aa3d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$27564b8a0078aa3d$var$revLookup['-'.charCodeAt(0)] = 62;
$27564b8a0078aa3d$var$revLookup['_'.charCodeAt(0)] = 63;
function $27564b8a0078aa3d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $27564b8a0078aa3d$var$byteLength(b64) {
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$toByteArray(b64) {
    var tmp;
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $27564b8a0078aa3d$var$Arr($27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 18 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 2 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 10 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $27564b8a0078aa3d$var$tripletToBase64(num) {
    return $27564b8a0078aa3d$var$lookup[num >> 18 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 12 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 6 & 0x3F] + $27564b8a0078aa3d$var$lookup[num & 0x3F];
}
function $27564b8a0078aa3d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($27564b8a0078aa3d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $27564b8a0078aa3d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($27564b8a0078aa3d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 2] + $27564b8a0078aa3d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 10] + $27564b8a0078aa3d$var$lookup[tmp >> 4 & 0x3F] + $27564b8a0078aa3d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c4e917b4c37bfab7$export$aafa59e2e03f2942;
var $c4e917b4c37bfab7$export$68d8715fc104d294;
$c4e917b4c37bfab7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c4e917b4c37bfab7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $82a04c4ec6982288$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$82a04c4ec6982288$export$a143d493d941bafc = $82a04c4ec6982288$var$Buffer;
$82a04c4ec6982288$export$e4cf37d7f6fb9e0a = $82a04c4ec6982288$var$SlowBuffer;
$82a04c4ec6982288$export$f99ded8fe4b79145 = 50;
const $82a04c4ec6982288$var$K_MAX_LENGTH = 0x7fffffff;
$82a04c4ec6982288$export$599f31c3813fae4d = $82a04c4ec6982288$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT = $82a04c4ec6982288$var$typedArraySupport();
if (!$82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82a04c4ec6982288$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82a04c4ec6982288$var$createBuffer(length) {
    if (length > $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82a04c4ec6982288$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82a04c4ec6982288$var$allocUnsafe(arg);
    }
    return $82a04c4ec6982288$var$from(arg, encodingOrOffset, length);
}
$82a04c4ec6982288$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82a04c4ec6982288$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $82a04c4ec6982288$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82a04c4ec6982288$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($82a04c4ec6982288$var$isInstance(value, ArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, ArrayBuffer)) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($82a04c4ec6982288$var$isInstance(value, SharedArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, SharedArrayBuffer))) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82a04c4ec6982288$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $82a04c4ec6982288$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $82a04c4ec6982288$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82a04c4ec6982288$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82a04c4ec6982288$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer, Uint8Array);
function $82a04c4ec6982288$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82a04c4ec6982288$var$alloc(size, fill, encoding) {
    $82a04c4ec6982288$var$assertSize(size);
    if (size <= 0) return $82a04c4ec6982288$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $82a04c4ec6982288$var$createBuffer(size).fill(fill, encoding) : $82a04c4ec6982288$var$createBuffer(size).fill(fill);
    return $82a04c4ec6982288$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82a04c4ec6982288$var$Buffer.alloc = function(size, fill, encoding) {
    return $82a04c4ec6982288$var$alloc(size, fill, encoding);
};
function $82a04c4ec6982288$var$allocUnsafe(size) {
    $82a04c4ec6982288$var$assertSize(size);
    return $82a04c4ec6982288$var$createBuffer(size < 0 ? 0 : $82a04c4ec6982288$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82a04c4ec6982288$var$Buffer.allocUnsafe = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82a04c4ec6982288$var$Buffer.allocUnsafeSlow = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
function $82a04c4ec6982288$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $82a04c4ec6982288$var$byteLength(string, encoding) | 0;
    let buf = $82a04c4ec6982288$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82a04c4ec6982288$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $82a04c4ec6982288$var$checked(array.length) | 0;
    const buf = $82a04c4ec6982288$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82a04c4ec6982288$var$fromArrayView(arrayView) {
    if ($82a04c4ec6982288$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $82a04c4ec6982288$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82a04c4ec6982288$var$fromArrayLike(arrayView);
}
function $82a04c4ec6982288$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
function $82a04c4ec6982288$var$fromObject(obj) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(obj)) {
        const len = $82a04c4ec6982288$var$checked(obj.length) | 0;
        const buf = $82a04c4ec6982288$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $82a04c4ec6982288$var$numberIsNaN(obj.length)) return $82a04c4ec6982288$var$createBuffer(0);
        return $82a04c4ec6982288$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $82a04c4ec6982288$var$fromArrayLike(obj.data);
}
function $82a04c4ec6982288$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82a04c4ec6982288$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $82a04c4ec6982288$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82a04c4ec6982288$var$Buffer.alloc(+length);
}
$82a04c4ec6982288$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82a04c4ec6982288$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82a04c4ec6982288$var$Buffer.compare = function compare(a, b) {
    if ($82a04c4ec6982288$var$isInstance(a, Uint8Array)) a = $82a04c4ec6982288$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82a04c4ec6982288$var$isInstance(b, Uint8Array)) b = $82a04c4ec6982288$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(a) || !$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82a04c4ec6982288$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$82a04c4ec6982288$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82a04c4ec6982288$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $82a04c4ec6982288$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($82a04c4ec6982288$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) buf = $82a04c4ec6982288$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82a04c4ec6982288$var$byteLength(string, encoding) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82a04c4ec6982288$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $82a04c4ec6982288$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82a04c4ec6982288$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82a04c4ec6982288$var$Buffer.byteLength = $82a04c4ec6982288$var$byteLength;
function $82a04c4ec6982288$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Slice(this, start, end);
        case 'ascii':
            return $82a04c4ec6982288$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$latin1Slice(this, start, end);
        case 'base64':
            return $82a04c4ec6982288$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82a04c4ec6982288$var$Buffer.prototype._isBuffer = true;
function $82a04c4ec6982288$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82a04c4ec6982288$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$82a04c4ec6982288$var$swap(this, i, i + 1);
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $82a04c4ec6982288$var$swap(this, i, i + 3);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $82a04c4ec6982288$var$swap(this, i, i + 7);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 6);
        $82a04c4ec6982288$var$swap(this, i + 2, i + 5);
        $82a04c4ec6982288$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $82a04c4ec6982288$var$utf8Slice(this, 0, length);
    return $82a04c4ec6982288$var$slowToString.apply(this, arguments);
};
$82a04c4ec6982288$var$Buffer.prototype.toLocaleString = $82a04c4ec6982288$var$Buffer.prototype.toString;
$82a04c4ec6982288$var$Buffer.prototype.equals = function equals(b) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $82a04c4ec6982288$var$Buffer.compare(this, b) === 0;
};
$82a04c4ec6982288$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $82a04c4ec6982288$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($82a04c4ec6982288$var$customInspectSymbol) $82a04c4ec6982288$var$Buffer.prototype[$82a04c4ec6982288$var$customInspectSymbol] = $82a04c4ec6982288$var$Buffer.prototype.inspect;
$82a04c4ec6982288$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82a04c4ec6982288$var$isInstance(target, Uint8Array)) target = $82a04c4ec6982288$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82a04c4ec6982288$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82a04c4ec6982288$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $82a04c4ec6982288$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82a04c4ec6982288$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $82a04c4ec6982288$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82a04c4ec6982288$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82a04c4ec6982288$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82a04c4ec6982288$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82a04c4ec6982288$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82a04c4ec6982288$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82a04c4ec6982288$var$utf8Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82a04c4ec6982288$var$asciiWrite(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$asciiToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$base64Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$base64ToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$ucs2Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82a04c4ec6982288$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $82a04c4ec6982288$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82a04c4ec6982288$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82a04c4ec6982288$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $27564b8a0078aa3d$export$6100ba28696e12de(buf);
    else return $27564b8a0078aa3d$export$6100ba28696e12de(buf.slice(start, end));
}
function $82a04c4ec6982288$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82a04c4ec6982288$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82a04c4ec6982288$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82a04c4ec6982288$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82a04c4ec6982288$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82a04c4ec6982288$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $82a04c4ec6982288$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82a04c4ec6982288$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82a04c4ec6982288$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82a04c4ec6982288$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82a04c4ec6982288$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$82a04c4ec6982288$var$Buffer.prototype.readUintLE = $82a04c4ec6982288$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUintBE = $82a04c4ec6982288$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint8 = $82a04c4ec6982288$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$82a04c4ec6982288$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$82a04c4ec6982288$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $82a04c4ec6982288$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$82a04c4ec6982288$var$Buffer.prototype.writeUintLE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUintBE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint8 = $82a04c4ec6982288$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82a04c4ec6982288$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $82a04c4ec6982288$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $82a04c4ec6982288$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $c4e917b4c37bfab7$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82a04c4ec6982288$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, false, noAssert);
};
function $82a04c4ec6982288$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $c4e917b4c37bfab7$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82a04c4ec6982288$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82a04c4ec6982288$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $82a04c4ec6982288$var$Buffer.isBuffer(val) ? val : $82a04c4ec6982288$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $82a04c4ec6982288$var$errors = {};
function $82a04c4ec6982288$var$E(sym, getMessage, Base) {
    $82a04c4ec6982288$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$82a04c4ec6982288$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$82a04c4ec6982288$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$82a04c4ec6982288$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $82a04c4ec6982288$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $82a04c4ec6982288$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $82a04c4ec6982288$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength) {
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $82a04c4ec6982288$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength);
}
function $82a04c4ec6982288$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $82a04c4ec6982288$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $82a04c4ec6982288$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $82a04c4ec6982288$var$validateNumber(value, type);
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $82a04c4ec6982288$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $82a04c4ec6982288$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82a04c4ec6982288$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82a04c4ec6982288$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $82a04c4ec6982288$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $82a04c4ec6982288$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82a04c4ec6982288$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82a04c4ec6982288$var$base64ToBytes(str) {
    return $27564b8a0078aa3d$export$d622b2ad8d90c771($82a04c4ec6982288$var$base64clean(str));
}
function $82a04c4ec6982288$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82a04c4ec6982288$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82a04c4ec6982288$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $82a04c4ec6982288$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $82a04c4ec6982288$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $82a04c4ec6982288$var$BufferBigIntNotDefined : fn;
}
function $82a04c4ec6982288$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $19044a9fa7281693$require$Buffer = $82a04c4ec6982288$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isVisitable(thing) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $19044a9fa7281693$var$removeBrackets(key) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $19044a9fa7281693$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $19044a9fa7281693$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isFlatArray(arr) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(arr) && !arr.some($19044a9fa7281693$var$isVisitable);
}
const $19044a9fa7281693$var$predicates = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject((0, $77146a31cb578292$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $19044a9fa7281693$var$toFormData(obj, formData, options) {
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $31df7fcb8acaa73a$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $77146a31cb578292$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $19044a9fa7281693$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) && $19044a9fa7281693$var$isFlatArray(value) || ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFileList(value) || (0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $77146a31cb578292$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $19044a9fa7281693$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $19044a9fa7281693$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($19044a9fa7281693$var$isVisitable(value)) return true;
        formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($19044a9fa7281693$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $19044a9fa7281693$var$isVisitable
    });
    function build(value, path) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $19044a9fa7281693$export$2e2bcd8739ae039 = $19044a9fa7281693$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $a2774d1dd3bec636$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $a2774d1dd3bec636$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $19044a9fa7281693$export$2e2bcd8739ae039)(params, this, options);
}
const $a2774d1dd3bec636$var$prototype = $a2774d1dd3bec636$var$AxiosURLSearchParams.prototype;
$a2774d1dd3bec636$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$a2774d1dd3bec636$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $a2774d1dd3bec636$var$encode);
    } : $a2774d1dd3bec636$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $a2774d1dd3bec636$export$2e2bcd8739ae039 = $a2774d1dd3bec636$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $4a4d655613ae826e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $4a4d655613ae826e$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $4a4d655613ae826e$var$encode;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $a2774d1dd3bec636$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $ec4d8e24b0699790$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $ec4d8e24b0699790$export$2e2bcd8739ae039 = $ec4d8e24b0699790$var$InterceptorManager;





'use strict';
var $7e146da7bba06216$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};








'use strict';
var $9a13f762833a66d0$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $a2774d1dd3bec636$export$2e2bcd8739ae039);


'use strict';
var $16325b87e107b4bc$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $650c3d387ae3fbd4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $e4489594588108ef$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9a13f762833a66d0$export$2e2bcd8739ae039,
        FormData: $16325b87e107b4bc$export$2e2bcd8739ae039,
        Blob: $650c3d387ae3fbd4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $1bbd8fa0325c4f9a$exports = {};

$parcel$export($1bbd8fa0325c4f9a$exports, "hasBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf; });
$parcel$export($1bbd8fa0325c4f9a$exports, "navigator", function () { return $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae; });
$parcel$export($1bbd8fa0325c4f9a$exports, "hasStandardBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c0bcc9250309d66; });
$parcel$export($1bbd8fa0325c4f9a$exports, "hasStandardBrowserWebWorkerEnv", function () { return $1bbd8fa0325c4f9a$export$c81692cf5af97dac; });
$parcel$export($1bbd8fa0325c4f9a$exports, "origin", function () { return $1bbd8fa0325c4f9a$export$f710a83a91838a36; });
const $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $1bbd8fa0325c4f9a$export$c0bcc9250309d66 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && (!$1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $1bbd8fa0325c4f9a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $1bbd8fa0325c4f9a$export$f710a83a91838a36 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $f9f874191f496b63$export$2e2bcd8739ae039 = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $1bbd8fa0325c4f9a$exports, (0, $e4489594588108ef$export$2e2bcd8739ae039));


'use strict';
function $f1a69cd24a140b61$export$2e2bcd8739ae039(data, options) {
    return (0, $19044a9fa7281693$export$2e2bcd8739ae039)(data, new (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.URLSearchParams(), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        visitor: function(value, key, path, helpers) {
            if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).isNode && (0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $24febbb5d340c733$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $24febbb5d340c733$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $24febbb5d340c733$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $24febbb5d340c733$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(formData) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($24febbb5d340c733$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $24febbb5d340c733$export$2e2bcd8739ae039 = $24febbb5d340c733$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $a5e696f232d0dc12$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $77146a31cb578292$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $a5e696f232d0dc12$var$defaults = {
    transitional: (0, $7e146da7bba06216$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $77146a31cb578292$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $24febbb5d340c733$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isStream(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isFile(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f1a69cd24a140b61$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $19044a9fa7281693$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $a5e696f232d0dc12$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $a5e696f232d0dc12$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isResponse(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(e, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $a5e696f232d0dc12$var$defaults.headers[method] = {};
});
var $a5e696f232d0dc12$export$2e2bcd8739ae039 = $a5e696f232d0dc12$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $cf2275aca40d6d88$var$ignoreDuplicateOf = (0, $77146a31cb578292$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cf2275aca40d6d88$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $cf2275aca40d6d88$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $c7e8ef3e2bb241a6$var$$internals = Symbol('internals');
function $c7e8ef3e2bb241a6$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c7e8ef3e2bb241a6$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value.map($c7e8ef3e2bb241a6$var$normalizeValue) : String(value);
}
function $c7e8ef3e2bb241a6$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c7e8ef3e2bb241a6$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c7e8ef3e2bb241a6$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c7e8ef3e2bb241a6$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c7e8ef3e2bb241a6$var$buildAccessors(obj, header) {
    const accessorName = (0, $77146a31cb578292$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c7e8ef3e2bb241a6$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c7e8ef3e2bb241a6$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c7e8ef3e2bb241a6$var$isValidHeaderName(header)) setHeaders((0, $cf2275aca40d6d88$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(header) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c7e8ef3e2bb241a6$var$parseTokens(value);
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c7e8ef3e2bb241a6$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c7e8ef3e2bb241a6$var$$internals] = this[$c7e8ef3e2bb241a6$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c7e8ef3e2bb241a6$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$c7e8ef3e2bb241a6$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $77146a31cb578292$export$2e2bcd8739ae039).reduceDescriptors($c7e8ef3e2bb241a6$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $77146a31cb578292$export$2e2bcd8739ae039).freezeMethods($c7e8ef3e2bb241a6$var$AxiosHeaders);
var $c7e8ef3e2bb241a6$export$2e2bcd8739ae039 = $c7e8ef3e2bb241a6$var$AxiosHeaders;


'use strict';
function $0cb2ce7608ace114$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $a5e696f232d0dc12$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $36f1aa490c1da053$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $f6ac833a4b31e3dc$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $b9cc6960093b095e$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $77146a31cb578292$export$2e2bcd8739ae039).inherits($f6ac833a4b31e3dc$var$CanceledError, (0, $b9cc6960093b095e$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $f6ac833a4b31e3dc$export$2e2bcd8739ae039 = $f6ac833a4b31e3dc$var$CanceledError;







'use strict';
function $2c92173995cdc070$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $2ecf5cf4c0202afd$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $d592abf0a04957f1$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $d592abf0a04957f1$export$2e2bcd8739ae039 = $d592abf0a04957f1$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $5603d643a9d93c92$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $5603d643a9d93c92$export$2e2bcd8739ae039 = $5603d643a9d93c92$var$throttle;



const $de65761df8a598af$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $d592abf0a04957f1$export$2e2bcd8739ae039)(50, 250);
    return (0, $5603d643a9d93c92$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $de65761df8a598af$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $de65761df8a598af$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $82d74b1a5a0a01da$export$2e2bcd8739ae039 = (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $f9f874191f496b63$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin), (0, $f9f874191f496b63$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $f9f874191f496b63$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $534b3794da5c002d$export$2e2bcd8739ae039 = (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $12188e34b7070552$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $f55e71b6c54c4376$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $2ec1d7b86495f966$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $12188e34b7070552$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $f55e71b6c54c4376$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}





'use strict';
const $3d132bbf7812485b$var$headersToObject = (thing)=>thing instanceof (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039) ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, thing) : thing;
function $3d132bbf7812485b$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(target) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $77146a31cb578292$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $77146a31cb578292$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($3d132bbf7812485b$var$headersToObject(a), $3d132bbf7812485b$var$headersToObject(b), prop, true)
    };
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(Object.keys((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $b00a7ead3edff84a$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $4a4d655613ae826e$export$2e2bcd8739ae039)((0, $2ec1d7b86495f966$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $82d74b1a5a0a01da$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $534b3794da5c002d$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $2cabe869ce51dbf6$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $2cabe869ce51dbf6$export$2e2bcd8739ae039 = $2cabe869ce51dbf6$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $b00a7ead3edff84a$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $2c92173995cdc070$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Request aborted', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(msg, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $7e146da7bba06216$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ETIMEDOUT : (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $de65761df8a598af$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $de65761df8a598af$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $2ecf5cf4c0202afd$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $f9f874191f496b63$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};










const $62bdf0498e608a4a$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $b9cc6960093b095e$export$2e2bcd8739ae039) ? err : new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $77146a31cb578292$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $62bdf0498e608a4a$export$2e2bcd8739ae039 = $62bdf0498e608a4a$var$composeSignals;


const $c626b6acbc30fe14$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c626b6acbc30fe14$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c626b6acbc30fe14$var$readStream(iterable))yield* $c626b6acbc30fe14$export$71b051935044bd5d(chunk, chunkSize);
};
const $c626b6acbc30fe14$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c626b6acbc30fe14$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c626b6acbc30fe14$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $c2191f87f9ef3849$var$isFunction } = (0, $77146a31cb578292$export$2e2bcd8739ae039);
const $c2191f87f9ef3849$var$globalFetchAPI = (({ fetch: fetch, Request: Request, Response: Response })=>({
        fetch: fetch,
        Request: Request,
        Response: Response
    }))((0, $77146a31cb578292$export$2e2bcd8739ae039).global);
const { ReadableStream: $c2191f87f9ef3849$var$ReadableStream, TextEncoder: $c2191f87f9ef3849$var$TextEncoder } = (0, $77146a31cb578292$export$2e2bcd8739ae039).global;
const $c2191f87f9ef3849$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $c2191f87f9ef3849$var$factory = (env)=>{
    const { fetch: fetch, Request: Request, Response: Response } = Object.assign({}, $c2191f87f9ef3849$var$globalFetchAPI, env);
    const isFetchSupported = $c2191f87f9ef3849$var$isFunction(fetch);
    const isRequestSupported = $c2191f87f9ef3849$var$isFunction(Request);
    const isResponseSupported = $c2191f87f9ef3849$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $c2191f87f9ef3849$var$isFunction($c2191f87f9ef3849$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $c2191f87f9ef3849$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $c2191f87f9ef3849$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin, {
            body: new $c2191f87f9ef3849$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>(0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $b00a7ead3edff84a$export$2e2bcd8739ae039)(config);
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $62bdf0498e608a4a$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $de65761df8a598af$export$d9fadd12586c18d6)(requestContentLength, (0, $de65761df8a598af$export$c1b28109d46c3592)((0, $de65761df8a598af$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $c626b6acbc30fe14$export$b0119225647bd83)(_request.body, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, fetchOptions), {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? fetch(request, fetchOptions) : fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $de65761df8a598af$export$d9fadd12586c18d6)(responseContentLength, (0, $de65761df8a598af$export$c1b28109d46c3592)((0, $de65761df8a598af$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $c626b6acbc30fe14$export$b0119225647bd83)(response.body, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $2c92173995cdc070$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Network Error', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
                cause: err.cause || err
            });
            throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
        }
    };
};
const $c2191f87f9ef3849$var$seedCache = new Map();
const $c2191f87f9ef3849$export$3105c6651375d4fa = (config)=>{
    let env = (0, $77146a31cb578292$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $c2191f87f9ef3849$var$globalFetchAPI, config ? config.env : null);
    const { fetch: fetch, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch
    ];
    let len = seeds.length, i = len, seed, target, map = $c2191f87f9ef3849$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $c2191f87f9ef3849$var$factory(env));
        map = target;
    }
    return target;
};
const $c2191f87f9ef3849$var$adapter = $c2191f87f9ef3849$export$3105c6651375d4fa();
var $c2191f87f9ef3849$export$2e2bcd8739ae039 = $c2191f87f9ef3849$var$adapter;



const $c036c406f3928265$var$knownAdapters = {
    http: (0, $31df7fcb8acaa73a$export$2e2bcd8739ae039),
    xhr: (0, $2cabe869ce51dbf6$export$2e2bcd8739ae039),
    fetch: {
        get: $c2191f87f9ef3849$export$3105c6651375d4fa
    }
};
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach($c036c406f3928265$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $c036c406f3928265$var$renderReason = (reason)=>`- ${reason}`;
const $c036c406f3928265$var$isResolvedHandle = (adapter)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $c036c406f3928265$export$2e2bcd8739ae039 = {
    getAdapter: (adapters, config)=>{
        adapters = (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$c036c406f3928265$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $c036c406f3928265$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter && ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($c036c406f3928265$var$renderReason).join('\n') : ' ' + $c036c406f3928265$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $c036c406f3928265$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(null, config);
}
function $a98a53c8a75f9db0$export$2e2bcd8739ae039(config) {
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    config.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $c036c406f3928265$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $a5e696f232d0dc12$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $36f1aa490c1da053$export$2e2bcd8739ae039)(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $95be4ecd446de127$export$a4ad2735b021c132 = "1.12.1";



'use strict';
const $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $1ad671c27810423e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $95be4ecd446de127$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$1ad671c27810423e$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('options must be an object', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $1ad671c27810423e$export$2e2bcd8739ae039 = {
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};



'use strict';
const $66f2b8a41463d1e8$var$validators = (0, $1ad671c27810423e$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $66f2b8a41463d1e8$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $66f2b8a41463d1e8$var$validators.function,
                serialize: $66f2b8a41463d1e8$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $66f2b8a41463d1e8$var$validators.spelling('baseURL'),
            withXsrfToken: $66f2b8a41463d1e8$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $77146a31cb578292$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $2ec1d7b86495f966$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $4a4d655613ae826e$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $ec4d8e24b0699790$export$2e2bcd8739ae039)(),
            response: new (0, $ec4d8e24b0699790$export$2e2bcd8739ae039)()
        };
    }
}
// Provide aliases for supported request methods
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $66f2b8a41463d1e8$var$Axios.prototype[method] = generateHTTPMethod();
    $66f2b8a41463d1e8$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $66f2b8a41463d1e8$export$2e2bcd8739ae039 = $66f2b8a41463d1e8$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $f4994f37c883aea2$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $f4994f37c883aea2$export$2e2bcd8739ae039 = $f4994f37c883aea2$var$CancelToken;






'use strict';
function $8145c4b68bfee186$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $ec03acb464b74212$export$2e2bcd8739ae039(payload) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $a9353565c2e0947e$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($a9353565c2e0947e$var$HttpStatusCode).forEach(([key, value])=>{
    $a9353565c2e0947e$var$HttpStatusCode[value] = key;
});
var $a9353565c2e0947e$export$2e2bcd8739ae039 = $a9353565c2e0947e$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    const context = new (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $4c852d2f6a5a0387$export$2e2bcd8739ae039)((0, $66f2b8a41463d1e8$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $77146a31cb578292$export$2e2bcd8739ae039).extend(instance, (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $77146a31cb578292$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $747d656b899e6115$var$createInstance((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance((0, $a5e696f232d0dc12$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.CanceledError = (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.CancelToken = (0, $f4994f37c883aea2$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.isCancel = (0, $36f1aa490c1da053$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.VERSION = (0, $95be4ecd446de127$export$a4ad2735b021c132);
$747d656b899e6115$var$axios.toFormData = (0, $19044a9fa7281693$export$2e2bcd8739ae039);
// Expose AxiosError class
$747d656b899e6115$var$axios.AxiosError = (0, $b9cc6960093b095e$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$747d656b899e6115$var$axios.Cancel = $747d656b899e6115$var$axios.CanceledError;
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$747d656b899e6115$var$axios.spread = (0, $8145c4b68bfee186$export$2e2bcd8739ae039);
// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (0, $ec03acb464b74212$export$2e2bcd8739ae039);
// Expose mergeConfig
$747d656b899e6115$var$axios.mergeConfig = (0, $3d132bbf7812485b$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.AxiosHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.formToJSON = (thing)=>(0, $24febbb5d340c733$export$2e2bcd8739ae039)((0, $77146a31cb578292$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$747d656b899e6115$var$axios.getAdapter = (0, $c036c406f3928265$export$2e2bcd8739ae039).getAdapter;
$747d656b899e6115$var$axios.HttpStatusCode = (0, $a9353565c2e0947e$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.default = $747d656b899e6115$var$axios;
var // this module should only have a default export
$747d656b899e6115$export$2e2bcd8739ae039 = $747d656b899e6115$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c6ba0193c6fadd6f$export$1c00760e9e5a4e95, AxiosError: $c6ba0193c6fadd6f$export$c1fbed17c2f6a328, CanceledError: $c6ba0193c6fadd6f$export$1ab0c6b20d94fa14, isCancel: $c6ba0193c6fadd6f$export$3b22524397b493c6, CancelToken: $c6ba0193c6fadd6f$export$fd08e3cb425f0d61, VERSION: $c6ba0193c6fadd6f$export$a4ad2735b021c132, all: $c6ba0193c6fadd6f$export$84bf76cd7afc7469, Cancel: $c6ba0193c6fadd6f$export$848c9b7ead0df967, isAxiosError: $c6ba0193c6fadd6f$export$fbafdbe06a5b5a9a, spread: $c6ba0193c6fadd6f$export$3ae0fd4797ed47c8, toFormData: $c6ba0193c6fadd6f$export$10ae0d317ea97f8b, AxiosHeaders: $c6ba0193c6fadd6f$export$4e7d6ff0f3e6520, HttpStatusCode: $c6ba0193c6fadd6f$export$a972f69c851492b3, formToJSON: $c6ba0193c6fadd6f$export$86d7c59254d6a2c9, getAdapter: $c6ba0193c6fadd6f$export$17ddc20a97d669e2, mergeConfig: $c6ba0193c6fadd6f$export$7ec1ebcfa9d8bd6a } = (0, $747d656b899e6115$export$2e2bcd8739ae039);


var $3cc271bb186f0140$exports = {};
'use strict';
var $fdae59e8868608a5$exports = {};
'use strict';
var $160fe4adf6e4e82c$exports = {};
'use strict';
var $456db8ea475d5b38$exports = {};
'use strict';
/** @type {import('./type')} */ $456db8ea475d5b38$exports = TypeError;


var $4c38295599b865d4$exports = {};
var $4c38295599b865d4$var$hasMap = typeof Map === 'function' && Map.prototype;
var $4c38295599b865d4$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $4c38295599b865d4$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $4c38295599b865d4$var$mapSize = $4c38295599b865d4$var$hasMap && $4c38295599b865d4$var$mapSizeDescriptor && typeof $4c38295599b865d4$var$mapSizeDescriptor.get === 'function' ? $4c38295599b865d4$var$mapSizeDescriptor.get : null;
var $4c38295599b865d4$var$mapForEach = $4c38295599b865d4$var$hasMap && Map.prototype.forEach;
var $4c38295599b865d4$var$hasSet = typeof Set === 'function' && Set.prototype;
var $4c38295599b865d4$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $4c38295599b865d4$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $4c38295599b865d4$var$setSize = $4c38295599b865d4$var$hasSet && $4c38295599b865d4$var$setSizeDescriptor && typeof $4c38295599b865d4$var$setSizeDescriptor.get === 'function' ? $4c38295599b865d4$var$setSizeDescriptor.get : null;
var $4c38295599b865d4$var$setForEach = $4c38295599b865d4$var$hasSet && Set.prototype.forEach;
var $4c38295599b865d4$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $4c38295599b865d4$var$weakMapHas = $4c38295599b865d4$var$hasWeakMap ? WeakMap.prototype.has : null;
var $4c38295599b865d4$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $4c38295599b865d4$var$weakSetHas = $4c38295599b865d4$var$hasWeakSet ? WeakSet.prototype.has : null;
var $4c38295599b865d4$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $4c38295599b865d4$var$weakRefDeref = $4c38295599b865d4$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $4c38295599b865d4$var$booleanValueOf = Boolean.prototype.valueOf;
var $4c38295599b865d4$var$objectToString = Object.prototype.toString;
var $4c38295599b865d4$var$functionToString = Function.prototype.toString;
var $4c38295599b865d4$var$$match = String.prototype.match;
var $4c38295599b865d4$var$$slice = String.prototype.slice;
var $4c38295599b865d4$var$$replace = String.prototype.replace;
var $4c38295599b865d4$var$$toUpperCase = String.prototype.toUpperCase;
var $4c38295599b865d4$var$$toLowerCase = String.prototype.toLowerCase;
var $4c38295599b865d4$var$$test = RegExp.prototype.test;
var $4c38295599b865d4$var$$concat = Array.prototype.concat;
var $4c38295599b865d4$var$$join = Array.prototype.join;
var $4c38295599b865d4$var$$arrSlice = Array.prototype.slice;
var $4c38295599b865d4$var$$floor = Math.floor;
var $4c38295599b865d4$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $4c38295599b865d4$var$gOPS = Object.getOwnPropertySymbols;
var $4c38295599b865d4$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $4c38295599b865d4$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $4c38295599b865d4$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $4c38295599b865d4$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $4c38295599b865d4$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $4c38295599b865d4$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $4c38295599b865d4$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $4c38295599b865d4$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$4c38295599b865d4$var$$floor(-num) : $4c38295599b865d4$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $4c38295599b865d4$var$$slice.call(str, intStr.length + 1);
            return $4c38295599b865d4$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $4c38295599b865d4$var$$replace.call($4c38295599b865d4$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $4c38295599b865d4$var$$replace.call(str, sepRegex, '$&_');
}
var $d482898a2941eea9$exports = {};
"use strict";


var $4c38295599b865d4$var$inspectCustom = $d482898a2941eea9$exports.custom;
var $4c38295599b865d4$var$inspectSymbol = $4c38295599b865d4$var$isSymbol($4c38295599b865d4$var$inspectCustom) ? $4c38295599b865d4$var$inspectCustom : null;
var $4c38295599b865d4$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $4c38295599b865d4$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
$4c38295599b865d4$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($4c38295599b865d4$var$has(opts, 'quoteStyle') && !$4c38295599b865d4$var$has($4c38295599b865d4$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($4c38295599b865d4$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $4c38295599b865d4$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($4c38295599b865d4$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($4c38295599b865d4$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $4c38295599b865d4$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $4c38295599b865d4$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $4c38295599b865d4$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $4c38295599b865d4$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $4c38295599b865d4$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($4c38295599b865d4$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $4c38295599b865d4$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($4c38295599b865d4$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$4c38295599b865d4$var$isRegExp(obj)) {
        var name = $4c38295599b865d4$var$nameOf(obj);
        var keys = $4c38295599b865d4$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $4c38295599b865d4$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($4c38295599b865d4$var$isSymbol(obj)) {
        var symString = $4c38295599b865d4$var$hasShammedSymbols ? $4c38295599b865d4$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $4c38295599b865d4$var$symToString.call(obj);
        return typeof obj === 'object' && !$4c38295599b865d4$var$hasShammedSymbols ? $4c38295599b865d4$var$markBoxed(symString) : symString;
    }
    if ($4c38295599b865d4$var$isElement(obj)) {
        var s = '<' + $4c38295599b865d4$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $4c38295599b865d4$var$wrapQuotes($4c38295599b865d4$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $4c38295599b865d4$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($4c38295599b865d4$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $4c38295599b865d4$var$arrObjKeys(obj, inspect);
        if (indent && !$4c38295599b865d4$var$singleLineValues(xs)) return '[' + $4c38295599b865d4$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $4c38295599b865d4$var$$join.call(xs, ', ') + ' ]';
    }
    if ($4c38295599b865d4$var$isError(obj)) {
        var parts = $4c38295599b865d4$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$4c38295599b865d4$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $4c38295599b865d4$var$$join.call($4c38295599b865d4$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $4c38295599b865d4$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($4c38295599b865d4$var$inspectSymbol && typeof obj[$4c38295599b865d4$var$inspectSymbol] === 'function' && $d482898a2941eea9$exports) return $d482898a2941eea9$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($4c38295599b865d4$var$isMap(obj)) {
        var mapParts = [];
        if ($4c38295599b865d4$var$mapForEach) $4c38295599b865d4$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $4c38295599b865d4$var$collectionOf('Map', $4c38295599b865d4$var$mapSize.call(obj), mapParts, indent);
    }
    if ($4c38295599b865d4$var$isSet(obj)) {
        var setParts = [];
        if ($4c38295599b865d4$var$setForEach) $4c38295599b865d4$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $4c38295599b865d4$var$collectionOf('Set', $4c38295599b865d4$var$setSize.call(obj), setParts, indent);
    }
    if ($4c38295599b865d4$var$isWeakMap(obj)) return $4c38295599b865d4$var$weakCollectionOf('WeakMap');
    if ($4c38295599b865d4$var$isWeakSet(obj)) return $4c38295599b865d4$var$weakCollectionOf('WeakSet');
    if ($4c38295599b865d4$var$isWeakRef(obj)) return $4c38295599b865d4$var$weakCollectionOf('WeakRef');
    if ($4c38295599b865d4$var$isNumber(obj)) return $4c38295599b865d4$var$markBoxed(inspect(Number(obj)));
    if ($4c38295599b865d4$var$isBigInt(obj)) return $4c38295599b865d4$var$markBoxed(inspect($4c38295599b865d4$var$bigIntValueOf.call(obj)));
    if ($4c38295599b865d4$var$isBoolean(obj)) return $4c38295599b865d4$var$markBoxed($4c38295599b865d4$var$booleanValueOf.call(obj));
    if ($4c38295599b865d4$var$isString(obj)) return $4c38295599b865d4$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$4c38295599b865d4$var$isDate(obj) && !$4c38295599b865d4$var$isRegExp(obj)) {
        var ys = $4c38295599b865d4$var$arrObjKeys(obj, inspect);
        var isPlainObject = $4c38295599b865d4$var$gPO ? $4c38295599b865d4$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $4c38295599b865d4$var$toStringTag && Object(obj) === obj && $4c38295599b865d4$var$toStringTag in obj ? $4c38295599b865d4$var$$slice.call($4c38295599b865d4$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $4c38295599b865d4$var$$join.call($4c38295599b865d4$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $4c38295599b865d4$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $4c38295599b865d4$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $4c38295599b865d4$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $4c38295599b865d4$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $4c38295599b865d4$var$quote(s) {
    return $4c38295599b865d4$var$$replace.call(String(s), /"/g, '&quot;');
}
function $4c38295599b865d4$var$canTrustToString(obj) {
    return !$4c38295599b865d4$var$toStringTag || !(typeof obj === 'object' && ($4c38295599b865d4$var$toStringTag in obj || typeof obj[$4c38295599b865d4$var$toStringTag] !== 'undefined'));
}
function $4c38295599b865d4$var$isArray(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Array]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isDate(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Date]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isRegExp(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object RegExp]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isError(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Error]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isString(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object String]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isNumber(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Number]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isBoolean(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Boolean]' && $4c38295599b865d4$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $4c38295599b865d4$var$isSymbol(obj) {
    if ($4c38295599b865d4$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$4c38295599b865d4$var$symToString) return false;
    try {
        $4c38295599b865d4$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$4c38295599b865d4$var$bigIntValueOf) return false;
    try {
        $4c38295599b865d4$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $4c38295599b865d4$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $4c38295599b865d4$var$has(obj, key) {
    return $4c38295599b865d4$var$hasOwn.call(obj, key);
}
function $4c38295599b865d4$var$toStr(obj) {
    return $4c38295599b865d4$var$objectToString.call(obj);
}
function $4c38295599b865d4$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $4c38295599b865d4$var$$match.call($4c38295599b865d4$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $4c38295599b865d4$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $4c38295599b865d4$var$isMap(x) {
    if (!$4c38295599b865d4$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$mapSize.call(x);
        try {
            $4c38295599b865d4$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isWeakMap(x) {
    if (!$4c38295599b865d4$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$weakMapHas.call(x, $4c38295599b865d4$var$weakMapHas);
        try {
            $4c38295599b865d4$var$weakSetHas.call(x, $4c38295599b865d4$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isWeakRef(x) {
    if (!$4c38295599b865d4$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isSet(x) {
    if (!$4c38295599b865d4$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$setSize.call(x);
        try {
            $4c38295599b865d4$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isWeakSet(x) {
    if (!$4c38295599b865d4$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$weakSetHas.call(x, $4c38295599b865d4$var$weakSetHas);
        try {
            $4c38295599b865d4$var$weakMapHas.call(x, $4c38295599b865d4$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $4c38295599b865d4$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $4c38295599b865d4$var$inspectString($4c38295599b865d4$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $4c38295599b865d4$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $4c38295599b865d4$var$$replace.call($4c38295599b865d4$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $4c38295599b865d4$var$lowbyte);
    return $4c38295599b865d4$var$wrapQuotes(s, 'single', opts);
}
function $4c38295599b865d4$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $4c38295599b865d4$var$$toUpperCase.call(n.toString(16));
}
function $4c38295599b865d4$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $4c38295599b865d4$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $4c38295599b865d4$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $4c38295599b865d4$var$indentedJoin(entries, indent) : $4c38295599b865d4$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $4c38295599b865d4$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($4c38295599b865d4$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $4c38295599b865d4$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $4c38295599b865d4$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $4c38295599b865d4$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $4c38295599b865d4$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $4c38295599b865d4$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $4c38295599b865d4$var$arrObjKeys(obj, inspect) {
    var isArr = $4c38295599b865d4$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $4c38295599b865d4$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $4c38295599b865d4$var$gOPS === 'function' ? $4c38295599b865d4$var$gOPS(obj) : [];
    var symMap;
    if ($4c38295599b865d4$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$4c38295599b865d4$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($4c38295599b865d4$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($4c38295599b865d4$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $4c38295599b865d4$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($4c38295599b865d4$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}


var $63ca8da40d4c4dfe$exports = {};
'use strict';


/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $63ca8da40d4c4dfe$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $63ca8da40d4c4dfe$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $63ca8da40d4c4dfe$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $63ca8da40d4c4dfe$var$listSet = function(objects, key, value) {
    var node = $63ca8da40d4c4dfe$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $63ca8da40d4c4dfe$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$63ca8da40d4c4dfe$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $63ca8da40d4c4dfe$var$listDelete = function(objects, key) {
    if (objects) return $63ca8da40d4c4dfe$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ $63ca8da40d4c4dfe$exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $456db8ea475d5b38$exports('Side channel does not contain ' + $4c38295599b865d4$exports(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $63ca8da40d4c4dfe$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $63ca8da40d4c4dfe$var$listGet($o, key);
        },
        has: function(key) {
            return $63ca8da40d4c4dfe$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $63ca8da40d4c4dfe$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $7a4b2f671249ac2e$exports = {};
'use strict';
var $c9eac16840c8f75d$exports = {};
'use strict';
var $c9eac16840c8f75d$var$undefined1;
var $7c1951c4b2f3c17d$exports = {};
'use strict';
/** @type {import('.')} */ $7c1951c4b2f3c17d$exports = Object;


var $4c289fff3dbfe702$exports = {};
'use strict';
/** @type {import('.')} */ $4c289fff3dbfe702$exports = Error;


var $0a4964b05b1da8ca$exports = {};
'use strict';
/** @type {import('./eval')} */ $0a4964b05b1da8ca$exports = EvalError;


var $4964a75e50e99def$exports = {};
'use strict';
/** @type {import('./range')} */ $4964a75e50e99def$exports = RangeError;


var $dd6d636093909a48$exports = {};
'use strict';
/** @type {import('./ref')} */ $dd6d636093909a48$exports = ReferenceError;


var $8629a6899cc471af$exports = {};
'use strict';
/** @type {import('./syntax')} */ $8629a6899cc471af$exports = SyntaxError;



var $4665c77f41985b28$exports = {};
'use strict';
/** @type {import('./uri')} */ $4665c77f41985b28$exports = URIError;


var $d77946e494e1a15b$exports = {};
'use strict';
/** @type {import('./abs')} */ $d77946e494e1a15b$exports = Math.abs;


var $3ba51078a8473c97$exports = {};
'use strict';
/** @type {import('./floor')} */ $3ba51078a8473c97$exports = Math.floor;


var $65f5c63815a4ddf6$exports = {};
'use strict';
/** @type {import('./max')} */ $65f5c63815a4ddf6$exports = Math.max;


var $8ffac5907fd8a96b$exports = {};
'use strict';
/** @type {import('./min')} */ $8ffac5907fd8a96b$exports = Math.min;


var $a515e4e1bc435e87$exports = {};
'use strict';
/** @type {import('./pow')} */ $a515e4e1bc435e87$exports = Math.pow;


var $0c63b5a7ad425301$exports = {};
'use strict';
/** @type {import('./round')} */ $0c63b5a7ad425301$exports = Math.round;


var $bac1fb4df5a4e010$exports = {};
'use strict';
var $6069165344808e6b$exports = {};
'use strict';
/** @type {import('./isNaN')} */ $6069165344808e6b$exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};


/** @type {import('./sign')} */ $bac1fb4df5a4e010$exports = function sign(number) {
    if ($6069165344808e6b$exports(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};


var $c9eac16840c8f75d$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $c9eac16840c8f75d$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $c9eac16840c8f75d$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $c3b59e512f612c17$exports = {};
'use strict';
var $5e95c0005cc82bbe$exports = {};
'use strict';
/** @type {import('./gOPD')} */ $5e95c0005cc82bbe$exports = Object.getOwnPropertyDescriptor;


var $c3b59e512f612c17$require$$gOPD = $5e95c0005cc82bbe$exports;
if ($c3b59e512f612c17$require$$gOPD) try {
    $c3b59e512f612c17$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $c3b59e512f612c17$require$$gOPD = null;
}
$c3b59e512f612c17$exports = $c3b59e512f612c17$require$$gOPD;


var $88f2749ea03868eb$exports = {};
'use strict';
/** @type {import('.')} */ var $88f2749ea03868eb$var$$defineProperty = Object.defineProperty || false;
if ($88f2749ea03868eb$var$$defineProperty) try {
    $88f2749ea03868eb$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $88f2749ea03868eb$var$$defineProperty = false;
}
$88f2749ea03868eb$exports = $88f2749ea03868eb$var$$defineProperty;


var $c9eac16840c8f75d$var$throwTypeError = function() {
    throw new $456db8ea475d5b38$exports();
};
var $c9eac16840c8f75d$var$ThrowTypeError = $c3b59e512f612c17$exports ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $c9eac16840c8f75d$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $c3b59e512f612c17$exports(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $c9eac16840c8f75d$var$throwTypeError;
        }
    }
}() : $c9eac16840c8f75d$var$throwTypeError;

var $c9eac16840c8f75d$var$hasSymbols = (parcelRequire("4qQ7b"))();
var $8187c11d1adeed98$exports = {};
'use strict';
var $139c9bd688b984c3$exports = {};
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ $139c9bd688b984c3$exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;


var $32842c400960be12$exports = {};
'use strict';

/** @type {import('./Object.getPrototypeOf')} */ $32842c400960be12$exports = $7c1951c4b2f3c17d$exports.getPrototypeOf || null;


var $1b87f3939656d8ea$exports = {};
'use strict';
var $3bf04cffe190ee6b$exports = {};
'use strict';
var $acdbd3c294de9ddc$exports = {};
'use strict';
var $bd52800b6fae4c57$exports = {};
'use strict';
/* eslint no-invalid-this: 1 */ var $bd52800b6fae4c57$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $bd52800b6fae4c57$var$toStr = Object.prototype.toString;
var $bd52800b6fae4c57$var$max = Math.max;
var $bd52800b6fae4c57$var$funcType = '[object Function]';
var $bd52800b6fae4c57$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $bd52800b6fae4c57$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $bd52800b6fae4c57$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
$bd52800b6fae4c57$exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $bd52800b6fae4c57$var$toStr.apply(target) !== $bd52800b6fae4c57$var$funcType) throw new TypeError($bd52800b6fae4c57$var$ERROR_MESSAGE + target);
    var args = $bd52800b6fae4c57$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $bd52800b6fae4c57$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $bd52800b6fae4c57$var$concatty(args, arguments));
    };
    var boundLength = $bd52800b6fae4c57$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $bd52800b6fae4c57$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};


$acdbd3c294de9ddc$exports = Function.prototype.bind || $bd52800b6fae4c57$exports;



var $8a642d9521ce95b0$exports = {};
'use strict';
/** @type {import('./functionCall')} */ $8a642d9521ce95b0$exports = Function.prototype.call;


var $00d73abda794e5f4$exports = {};
'use strict';

var $7fdad5d228268c18$exports = {};
'use strict';
/** @type {import('./functionApply')} */ $7fdad5d228268c18$exports = Function.prototype.apply;



var $ba0bd9e0f090f4ee$exports = {};
'use strict';
/** @type {import('./reflectApply')} */ $ba0bd9e0f090f4ee$exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/** @type {import('./actualApply')} */ $00d73abda794e5f4$exports = $ba0bd9e0f090f4ee$exports || $acdbd3c294de9ddc$exports.call($8a642d9521ce95b0$exports, $7fdad5d228268c18$exports);


/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ $3bf04cffe190ee6b$exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $456db8ea475d5b38$exports('a function is required');
    return $00d73abda794e5f4$exports($acdbd3c294de9ddc$exports, $8a642d9521ce95b0$exports, args);
};



var $1b87f3939656d8ea$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $1b87f3939656d8ea$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $1b87f3939656d8ea$var$desc = !!$1b87f3939656d8ea$var$hasProtoAccessor && $c3b59e512f612c17$exports && $c3b59e512f612c17$exports(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $1b87f3939656d8ea$var$$Object = Object;
var $1b87f3939656d8ea$var$$getPrototypeOf = $1b87f3939656d8ea$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ $1b87f3939656d8ea$exports = $1b87f3939656d8ea$var$desc && typeof $1b87f3939656d8ea$var$desc.get === 'function' ? $3bf04cffe190ee6b$exports([
    $1b87f3939656d8ea$var$desc.get
]) : typeof $1b87f3939656d8ea$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $1b87f3939656d8ea$var$$getPrototypeOf(value == null ? value : $1b87f3939656d8ea$var$$Object(value));
} : false;


/** @type {import('.')} */ $8187c11d1adeed98$exports = $139c9bd688b984c3$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $139c9bd688b984c3$exports(O);
} : $32842c400960be12$exports ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $32842c400960be12$exports(O);
} : $1b87f3939656d8ea$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $1b87f3939656d8ea$exports(O);
} : null;






var $c9eac16840c8f75d$var$needsEval = {};
var $c9eac16840c8f75d$var$TypedArray = typeof Uint8Array === 'undefined' || !$8187c11d1adeed98$exports ? undefined : $8187c11d1adeed98$exports(Uint8Array);
var $c9eac16840c8f75d$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $8187c11d1adeed98$exports ? $8187c11d1adeed98$exports([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncGenerator%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncGeneratorFunction%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncIteratorPrototype%': $c9eac16840c8f75d$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $4c289fff3dbfe702$exports,
    '%eval%': eval,
    '%EvalError%': $0a4964b05b1da8ca$exports,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $c9eac16840c8f75d$var$$Function,
    '%GeneratorFunction%': $c9eac16840c8f75d$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $8187c11d1adeed98$exports ? $8187c11d1adeed98$exports($8187c11d1adeed98$exports([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$c9eac16840c8f75d$var$hasSymbols || !$8187c11d1adeed98$exports ? undefined : $8187c11d1adeed98$exports(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $7c1951c4b2f3c17d$exports,
    '%Object.getOwnPropertyDescriptor%': $c3b59e512f612c17$exports,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $4964a75e50e99def$exports,
    '%ReferenceError%': $dd6d636093909a48$exports,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$c9eac16840c8f75d$var$hasSymbols || !$8187c11d1adeed98$exports ? undefined : $8187c11d1adeed98$exports(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $8187c11d1adeed98$exports ? $8187c11d1adeed98$exports(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $c9eac16840c8f75d$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $8629a6899cc471af$exports,
    '%ThrowTypeError%': $c9eac16840c8f75d$var$ThrowTypeError,
    '%TypedArray%': $c9eac16840c8f75d$var$TypedArray,
    '%TypeError%': $456db8ea475d5b38$exports,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $4665c77f41985b28$exports,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $8a642d9521ce95b0$exports,
    '%Function.prototype.apply%': $7fdad5d228268c18$exports,
    '%Object.defineProperty%': $88f2749ea03868eb$exports,
    '%Object.getPrototypeOf%': $32842c400960be12$exports,
    '%Math.abs%': $d77946e494e1a15b$exports,
    '%Math.floor%': $3ba51078a8473c97$exports,
    '%Math.max%': $65f5c63815a4ddf6$exports,
    '%Math.min%': $8ffac5907fd8a96b$exports,
    '%Math.pow%': $a515e4e1bc435e87$exports,
    '%Math.round%': $0c63b5a7ad425301$exports,
    '%Math.sign%': $bac1fb4df5a4e010$exports,
    '%Reflect.getPrototypeOf%': $139c9bd688b984c3$exports
};
if ($8187c11d1adeed98$exports) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $c9eac16840c8f75d$var$errorProto = $8187c11d1adeed98$exports($8187c11d1adeed98$exports(e));
    $c9eac16840c8f75d$var$INTRINSICS['%Error.prototype%'] = $c9eac16840c8f75d$var$errorProto;
}
var $c9eac16840c8f75d$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $8187c11d1adeed98$exports) value = $8187c11d1adeed98$exports(gen.prototype);
    }
    $c9eac16840c8f75d$var$INTRINSICS[name] = value;
    return value;
};
var $c9eac16840c8f75d$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $5f5a0fe320c1ef2a$exports = {};
'use strict';
var $5f5a0fe320c1ef2a$var$call = Function.prototype.call;
var $5f5a0fe320c1ef2a$var$$hasOwn = Object.prototype.hasOwnProperty;

/** @type {import('.')} */ $5f5a0fe320c1ef2a$exports = $acdbd3c294de9ddc$exports.call($5f5a0fe320c1ef2a$var$call, $5f5a0fe320c1ef2a$var$$hasOwn);


var $c9eac16840c8f75d$var$$concat = $acdbd3c294de9ddc$exports.call($8a642d9521ce95b0$exports, Array.prototype.concat);
var $c9eac16840c8f75d$var$$spliceApply = $acdbd3c294de9ddc$exports.call($7fdad5d228268c18$exports, Array.prototype.splice);
var $c9eac16840c8f75d$var$$replace = $acdbd3c294de9ddc$exports.call($8a642d9521ce95b0$exports, String.prototype.replace);
var $c9eac16840c8f75d$var$$strSlice = $acdbd3c294de9ddc$exports.call($8a642d9521ce95b0$exports, String.prototype.slice);
var $c9eac16840c8f75d$var$$exec = $acdbd3c294de9ddc$exports.call($8a642d9521ce95b0$exports, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $c9eac16840c8f75d$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $c9eac16840c8f75d$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $c9eac16840c8f75d$var$stringToPath = function stringToPath(string) {
    var first = $c9eac16840c8f75d$var$$strSlice(string, 0, 1);
    var last = $c9eac16840c8f75d$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $8629a6899cc471af$exports('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $8629a6899cc471af$exports('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $c9eac16840c8f75d$var$$replace(string, $c9eac16840c8f75d$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $c9eac16840c8f75d$var$$replace(subString, $c9eac16840c8f75d$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $c9eac16840c8f75d$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($5f5a0fe320c1ef2a$exports($c9eac16840c8f75d$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $c9eac16840c8f75d$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($5f5a0fe320c1ef2a$exports($c9eac16840c8f75d$var$INTRINSICS, intrinsicName)) {
        var value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicName];
        if (value === $c9eac16840c8f75d$var$needsEval) value = $c9eac16840c8f75d$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $456db8ea475d5b38$exports('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $8629a6899cc471af$exports('intrinsic ' + name + ' does not exist!');
};
$c9eac16840c8f75d$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $456db8ea475d5b38$exports('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $456db8ea475d5b38$exports('"allowMissing" argument must be a boolean');
    if ($c9eac16840c8f75d$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $8629a6899cc471af$exports('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $c9eac16840c8f75d$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $c9eac16840c8f75d$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $c9eac16840c8f75d$var$$spliceApply(parts, $c9eac16840c8f75d$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $c9eac16840c8f75d$var$$strSlice(part, 0, 1);
        var last = $c9eac16840c8f75d$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $8629a6899cc471af$exports('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($5f5a0fe320c1ef2a$exports($c9eac16840c8f75d$var$INTRINSICS, intrinsicRealName)) value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $456db8ea475d5b38$exports('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($c3b59e512f612c17$exports && i + 1 >= parts.length) {
                var desc = $c3b59e512f612c17$exports(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $5f5a0fe320c1ef2a$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};


var $aa3764525413497a$exports = {};
'use strict';


/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $aa3764525413497a$var$$indexOf = $3bf04cffe190ee6b$exports([
    $c9eac16840c8f75d$exports('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ $aa3764525413497a$exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $c9eac16840c8f75d$exports(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $aa3764525413497a$var$$indexOf(name, '.prototype.') > -1) return $3bf04cffe190ee6b$exports(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};




var $7a4b2f671249ac2e$var$$Map = $c9eac16840c8f75d$exports('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $7a4b2f671249ac2e$var$$mapGet = $aa3764525413497a$exports('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $7a4b2f671249ac2e$var$$mapSet = $aa3764525413497a$exports('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $7a4b2f671249ac2e$var$$mapHas = $aa3764525413497a$exports('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $7a4b2f671249ac2e$var$$mapDelete = $aa3764525413497a$exports('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $7a4b2f671249ac2e$var$$mapSize = $aa3764525413497a$exports('Map.prototype.size', true);
/** @type {import('.')} */ $7a4b2f671249ac2e$exports = !!$7a4b2f671249ac2e$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $456db8ea475d5b38$exports('Side channel does not contain ' + $4c38295599b865d4$exports(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $7a4b2f671249ac2e$var$$mapDelete($m, key);
                if ($7a4b2f671249ac2e$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $7a4b2f671249ac2e$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $7a4b2f671249ac2e$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $7a4b2f671249ac2e$var$$Map();
            $7a4b2f671249ac2e$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};


var $1bb87b485acc2d8c$exports = {};
'use strict';





var $1bb87b485acc2d8c$var$$WeakMap = $c9eac16840c8f75d$exports('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $1bb87b485acc2d8c$var$$weakMapGet = $aa3764525413497a$exports('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $1bb87b485acc2d8c$var$$weakMapSet = $aa3764525413497a$exports('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $1bb87b485acc2d8c$var$$weakMapHas = $aa3764525413497a$exports('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $1bb87b485acc2d8c$var$$weakMapDelete = $aa3764525413497a$exports('WeakMap.prototype.delete', true);
/** @type {import('.')} */ $1bb87b485acc2d8c$exports = $1bb87b485acc2d8c$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $456db8ea475d5b38$exports('Side channel does not contain ' + $4c38295599b865d4$exports(key));
        },
        'delete': function(key) {
            if ($1bb87b485acc2d8c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $1bb87b485acc2d8c$var$$weakMapDelete($wm, key);
            } else if ($7a4b2f671249ac2e$exports) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($1bb87b485acc2d8c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $1bb87b485acc2d8c$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($1bb87b485acc2d8c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $1bb87b485acc2d8c$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($1bb87b485acc2d8c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $1bb87b485acc2d8c$var$$WeakMap();
                $1bb87b485acc2d8c$var$$weakMapSet($wm, key, value);
            } else if ($7a4b2f671249ac2e$exports) {
                if (!$m) $m = $7a4b2f671249ac2e$exports();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $7a4b2f671249ac2e$exports;


var $160fe4adf6e4e82c$var$makeChannel = $1bb87b485acc2d8c$exports || $7a4b2f671249ac2e$exports || $63ca8da40d4c4dfe$exports;
/** @type {import('.')} */ $160fe4adf6e4e82c$exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $456db8ea475d5b38$exports('Side channel does not contain ' + $4c38295599b865d4$exports(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $160fe4adf6e4e82c$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $1b97d0b055bc5f8c$exports = {};
'use strict';
var $8534d4a11448cf7e$exports = {};
'use strict';
var $8534d4a11448cf7e$var$replace = String.prototype.replace;
var $8534d4a11448cf7e$var$percentTwenties = /%20/g;
var $8534d4a11448cf7e$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
$8534d4a11448cf7e$exports = {
    'default': $8534d4a11448cf7e$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $8534d4a11448cf7e$var$replace.call(value, $8534d4a11448cf7e$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $8534d4a11448cf7e$var$Format.RFC1738,
    RFC3986: $8534d4a11448cf7e$var$Format.RFC3986
};


var $1b97d0b055bc5f8c$var$has = Object.prototype.hasOwnProperty;
var $1b97d0b055bc5f8c$var$isArray = Array.isArray;
var $1b97d0b055bc5f8c$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $1b97d0b055bc5f8c$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($1b97d0b055bc5f8c$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $1b97d0b055bc5f8c$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $1b97d0b055bc5f8c$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($1b97d0b055bc5f8c$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$1b97d0b055bc5f8c$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($1b97d0b055bc5f8c$var$isArray(target) && !$1b97d0b055bc5f8c$var$isArray(source)) mergeTarget = $1b97d0b055bc5f8c$var$arrayToObject(target, options);
    if ($1b97d0b055bc5f8c$var$isArray(target) && $1b97d0b055bc5f8c$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($1b97d0b055bc5f8c$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($1b97d0b055bc5f8c$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $1b97d0b055bc5f8c$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $1b97d0b055bc5f8c$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $1b97d0b055bc5f8c$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $1b97d0b055bc5f8c$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $1b97d0b055bc5f8c$var$limit){
        var segment = string.length >= $1b97d0b055bc5f8c$var$limit ? string.slice(j, j + $1b97d0b055bc5f8c$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $8534d4a11448cf7e$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $1b97d0b055bc5f8c$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $1b97d0b055bc5f8c$var$hexTable[0xC0 | c >> 6] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $1b97d0b055bc5f8c$var$hexTable[0xE0 | c >> 12] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c >> 6 & 0x3F] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $1b97d0b055bc5f8c$var$hexTable[0xF0 | c >> 18] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c >> 12 & 0x3F] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c >> 6 & 0x3F] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $1b97d0b055bc5f8c$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $1b97d0b055bc5f8c$var$compactQueue(queue);
    return value;
};
var $1b97d0b055bc5f8c$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $1b97d0b055bc5f8c$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $1b97d0b055bc5f8c$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $1b97d0b055bc5f8c$var$maybeMap = function maybeMap(val, fn) {
    if ($1b97d0b055bc5f8c$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$1b97d0b055bc5f8c$exports = {
    arrayToObject: $1b97d0b055bc5f8c$var$arrayToObject,
    assign: $1b97d0b055bc5f8c$var$assign,
    combine: $1b97d0b055bc5f8c$var$combine,
    compact: $1b97d0b055bc5f8c$var$compact,
    decode: $1b97d0b055bc5f8c$var$decode,
    encode: $1b97d0b055bc5f8c$var$encode,
    isBuffer: $1b97d0b055bc5f8c$var$isBuffer,
    isRegExp: $1b97d0b055bc5f8c$var$isRegExp,
    maybeMap: $1b97d0b055bc5f8c$var$maybeMap,
    merge: $1b97d0b055bc5f8c$var$merge
};



var $fdae59e8868608a5$var$has = Object.prototype.hasOwnProperty;
var $fdae59e8868608a5$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $fdae59e8868608a5$var$isArray = Array.isArray;
var $fdae59e8868608a5$var$push = Array.prototype.push;
var $fdae59e8868608a5$var$pushToArray = function(arr, valueOrArray) {
    $fdae59e8868608a5$var$push.apply(arr, $fdae59e8868608a5$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $fdae59e8868608a5$var$toISO = Date.prototype.toISOString;
var $fdae59e8868608a5$var$defaultFormat = $8534d4a11448cf7e$exports.default;
var $fdae59e8868608a5$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $1b97d0b055bc5f8c$exports.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $fdae59e8868608a5$var$defaultFormat,
    formatter: $8534d4a11448cf7e$exports.formatters[$fdae59e8868608a5$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $fdae59e8868608a5$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $fdae59e8868608a5$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $fdae59e8868608a5$var$sentinel = {};
var $fdae59e8868608a5$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($fdae59e8868608a5$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($fdae59e8868608a5$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $fdae59e8868608a5$var$isArray(obj)) obj = $1b97d0b055bc5f8c$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $fdae59e8868608a5$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($fdae59e8868608a5$var$isNonNullishPrimitive(obj) || $1b97d0b055bc5f8c$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $fdae59e8868608a5$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $fdae59e8868608a5$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $fdae59e8868608a5$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $1b97d0b055bc5f8c$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($fdae59e8868608a5$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $fdae59e8868608a5$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $fdae59e8868608a5$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $fdae59e8868608a5$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $160fe4adf6e4e82c$exports();
        valueSideChannel.set($fdae59e8868608a5$var$sentinel, sideChannel);
        $fdae59e8868608a5$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $fdae59e8868608a5$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $fdae59e8868608a5$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $fdae59e8868608a5$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $fdae59e8868608a5$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $8534d4a11448cf7e$exports.default;
    if (typeof opts.format !== 'undefined') {
        if (!$fdae59e8868608a5$var$has.call($8534d4a11448cf7e$exports.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $8534d4a11448cf7e$exports.formatters[format];
    var filter = $fdae59e8868608a5$var$defaults.filter;
    if (typeof opts.filter === 'function' || $fdae59e8868608a5$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $fdae59e8868608a5$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $fdae59e8868608a5$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $fdae59e8868608a5$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $fdae59e8868608a5$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $fdae59e8868608a5$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $fdae59e8868608a5$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $fdae59e8868608a5$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $fdae59e8868608a5$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $fdae59e8868608a5$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $fdae59e8868608a5$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $fdae59e8868608a5$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $fdae59e8868608a5$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $fdae59e8868608a5$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $fdae59e8868608a5$var$defaults.strictNullHandling
    };
};
$fdae59e8868608a5$exports = function(object, opts) {
    var obj = object;
    var options = $fdae59e8868608a5$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($fdae59e8868608a5$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $fdae59e8868608a5$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $160fe4adf6e4e82c$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $fdae59e8868608a5$var$pushToArray(keys, $fdae59e8868608a5$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};


var $3225be4cdfe13ac3$exports = {};
'use strict';

var $3225be4cdfe13ac3$var$has = Object.prototype.hasOwnProperty;
var $3225be4cdfe13ac3$var$isArray = Array.isArray;
var $3225be4cdfe13ac3$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $1b97d0b055bc5f8c$exports.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $3225be4cdfe13ac3$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $3225be4cdfe13ac3$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $3225be4cdfe13ac3$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $3225be4cdfe13ac3$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $3225be4cdfe13ac3$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $3225be4cdfe13ac3$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $3225be4cdfe13ac3$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $3225be4cdfe13ac3$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $3225be4cdfe13ac3$var$defaults.decoder, charset, 'key');
            val = $1b97d0b055bc5f8c$exports.maybeMap($3225be4cdfe13ac3$var$parseArrayValue(part.slice(pos + 1), options, $3225be4cdfe13ac3$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $3225be4cdfe13ac3$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $3225be4cdfe13ac3$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $3225be4cdfe13ac3$var$isArray(val) ? [
            val
        ] : val;
        var existing = $3225be4cdfe13ac3$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $1b97d0b055bc5f8c$exports.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $3225be4cdfe13ac3$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $3225be4cdfe13ac3$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $1b97d0b055bc5f8c$exports.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $3225be4cdfe13ac3$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $3225be4cdfe13ac3$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $3225be4cdfe13ac3$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $3225be4cdfe13ac3$var$parseObject(keys, val, options, valuesParsed);
};
var $3225be4cdfe13ac3$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $3225be4cdfe13ac3$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $3225be4cdfe13ac3$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $3225be4cdfe13ac3$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $3225be4cdfe13ac3$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $3225be4cdfe13ac3$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $3225be4cdfe13ac3$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $3225be4cdfe13ac3$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $3225be4cdfe13ac3$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $3225be4cdfe13ac3$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $3225be4cdfe13ac3$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $3225be4cdfe13ac3$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $3225be4cdfe13ac3$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $1b97d0b055bc5f8c$exports.isRegExp(opts.delimiter) ? opts.delimiter : $3225be4cdfe13ac3$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $3225be4cdfe13ac3$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $3225be4cdfe13ac3$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $3225be4cdfe13ac3$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $3225be4cdfe13ac3$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $3225be4cdfe13ac3$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $3225be4cdfe13ac3$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
$3225be4cdfe13ac3$exports = function(str, opts) {
    var options = $3225be4cdfe13ac3$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $3225be4cdfe13ac3$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $3225be4cdfe13ac3$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $1b97d0b055bc5f8c$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $1b97d0b055bc5f8c$exports.compact(obj);
};



$3cc271bb186f0140$exports = {
    formats: $8534d4a11448cf7e$exports,
    parse: $3225be4cdfe13ac3$exports,
    stringify: $fdae59e8868608a5$exports
};


var $c1e4a1336f2cb96e$exports = {};

$parcel$export($c1e4a1336f2cb96e$exports, "LOCAL", function () { return $c1e4a1336f2cb96e$export$2670cb7d5d4f7184; });
$parcel$export($c1e4a1336f2cb96e$exports, "DEV", function () { return $c1e4a1336f2cb96e$export$404582bc18fe4d9e; });
$parcel$export($c1e4a1336f2cb96e$exports, "STAGE", function () { return $c1e4a1336f2cb96e$export$f9865a0a7f208c15; });
$parcel$export($c1e4a1336f2cb96e$exports, "PROD", function () { return $c1e4a1336f2cb96e$export$e51cdc15d0c6bee2; });
const $c1e4a1336f2cb96e$export$2670cb7d5d4f7184 = 'local';
const $c1e4a1336f2cb96e$export$404582bc18fe4d9e = 'dev';
const $c1e4a1336f2cb96e$export$f9865a0a7f208c15 = 'stg';
const $c1e4a1336f2cb96e$export$e51cdc15d0c6bee2 = 'prod';


// Tech doc can be found here
// https://hello.atlassian.net/wiki/spaces/MARTECH/pages/159733334/ConsentHub+Application+Technical+Design

const $35a545355f14a0c7$var$localEnvironment = {
    name: $c1e4a1336f2cb96e$export$2670cb7d5d4f7184,
    url: 'http://localhost:8080'
};
const $35a545355f14a0c7$var$devEnvironment = {
    name: $c1e4a1336f2cb96e$export$404582bc18fe4d9e,
    url: 'https://preferences.dev.atlassian.com'
};
const $35a545355f14a0c7$var$stageEnvironment = {
    name: $c1e4a1336f2cb96e$export$f9865a0a7f208c15,
    url: 'https://preferences.stg.atlassian.com'
};
const $35a545355f14a0c7$var$prodEnvironment = {
    name: $c1e4a1336f2cb96e$export$e51cdc15d0c6bee2,
    url: 'https://preferences.atlassian.com'
};
const $35a545355f14a0c7$export$6bc7b24d4e862158 = ()=>{
    const { hostname: hostname } = window.location;
    if ([
        /\.prod\./,
        /preferences\.atlassian\.com/
    ].some((r)=>r.test(hostname))) return $35a545355f14a0c7$var$prodEnvironment;
    else if ([
        /\.staging\./,
        /\.stg\./
    ].some((r)=>r.test(hostname))) return $35a545355f14a0c7$var$stageEnvironment;
    else if ([
        /\.dev\./
    ].some((r)=>r.test(hostname))) return $35a545355f14a0c7$var$devEnvironment;
    else if ([
        /localhost/
    ].some((r)=>r.test(hostname))) return $35a545355f14a0c7$var$localEnvironment;
    else throw Error('Unable to determine environment');
};




const $1632e46edaa58de9$var$apiClient = (0, $747d656b899e6115$export$2e2bcd8739ae039).create({
    baseURL: `${(0, $35a545355f14a0c7$export$6bc7b24d4e862158)().url}/rest/preferences`,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json'
    },
    paramsSerializer: (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($3cc271bb186f0140$exports))).stringify(params)
});
$1632e46edaa58de9$var$apiClient.interceptors.response.use((response)=>response.data, (error)=>{
    var _error_response;
    return Promise.reject(((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data) || error.message);
});
var $1632e46edaa58de9$export$2e2bcd8739ae039 = $1632e46edaa58de9$var$apiClient;
const $1632e46edaa58de9$export$1addd41d999692aa = (0, $747d656b899e6115$export$2e2bcd8739ae039).create({
    baseURL: `${(0, $35a545355f14a0c7$export$6bc7b24d4e862158)().url}/rest/preferences`,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json'
    },
    paramsSerializer: (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($3cc271bb186f0140$exports))).stringify(params)
});



const $71fbb9240bd0b42c$export$fa5a5f9acf0b4757 = (hid)=>(0, $1632e46edaa58de9$export$2e2bcd8739ae039).get('/consentsAndSubscriptions', {
        params: {
            hid: hid
        }
    });
const $71fbb9240bd0b42c$export$c1cf1b7b7ca0c54c = async ()=>(0, $1632e46edaa58de9$export$1addd41d999692aa).get('/session/consentsAndSubscriptions');
const $71fbb9240bd0b42c$export$d12a00019f220cc1 = (hid, subscriptions)=>(0, $1632e46edaa58de9$export$2e2bcd8739ae039).put('/subscriptions', {
        subscriptions: subscriptions
    }, {
        params: {
            hid: hid,
            source: 'PREFERENCES_CENTER',
            action: 'UPDATE_PREFERENCES'
        }
    });
const $71fbb9240bd0b42c$export$e2a4d9289365ff88 = (hid)=>(0, $1632e46edaa58de9$export$2e2bcd8739ae039).delete('/subscriptions/all', {
        params: {
            hid: hid,
            source: 'PREFERENCES_CENTER',
            action: 'GLOBAL_UNSUBSCRIBE'
        }
    });
const $71fbb9240bd0b42c$export$a1e4533914e154bd = (hid, keys, jobId)=>{
    return (0, $1632e46edaa58de9$export$2e2bcd8739ae039).delete('/subscriptions', {
        params: {
            keys: keys,
            hid: hid,
            action: 'EMAIL_UNSUBSCRIBE_LINK',
            jobId: jobId,
            source: jobId != null ? 'SFMC_EMAIL' : undefined
        }
    });
};
const $71fbb9240bd0b42c$export$3ab4aed8562cb58d = (request)=>(0, $1632e46edaa58de9$export$2e2bcd8739ae039).post('/consent', request);


var $91cadcf42f447377$export$d460f747b73abb10 = /*#__PURE__*/ function(GroupType) {
    GroupType["SUBSCRIPTIONS"] = "SUBSCRIPTIONS";
    GroupType["CONSENTS"] = "CONSENTS";
    return GroupType;
}({});
var $91cadcf42f447377$export$3d4da522aa66ad7 = /*#__PURE__*/ function(ItemStatus) {
    ItemStatus["ON"] = "ON";
    ItemStatus["OFF"] = "OFF";
    ItemStatus["PENDING"] = "PENDING";
    return ItemStatus;
}({});




const $d5dda7b7f034addc$export$fcc75ec143a0a864 = (language)=>(0, $1632e46edaa58de9$export$2e2bcd8739ae039).get(`/translations/${language}`);
const $d5dda7b7f034addc$export$3ba5e2c74659a212 = ()=>(0, $1632e46edaa58de9$export$2e2bcd8739ae039).get(`/translations`);




var $8b55bd10a455ef8c$exports = {};

$parcel$export($8b55bd10a455ef8c$exports, "BUTTON_CLICK", function () { return $8b55bd10a455ef8c$export$965dbcaf9eaff519; });
$parcel$export($8b55bd10a455ef8c$exports, "LINK_CLICK", function () { return $8b55bd10a455ef8c$export$fcfaa09cc4161077; });
$parcel$export($8b55bd10a455ef8c$exports, "MESSAGE_TEXT", function () { return $8b55bd10a455ef8c$export$1a4b85c6feafd267; });
$parcel$export($8b55bd10a455ef8c$exports, "BANNER", function () { return $8b55bd10a455ef8c$export$238d30785c4bca84; });
$parcel$export($8b55bd10a455ef8c$exports, "ERROR_BANNER", function () { return $8b55bd10a455ef8c$export$73f887cc88cd3d43; });
$parcel$export($8b55bd10a455ef8c$exports, "CHECKBOX_CLICK", function () { return $8b55bd10a455ef8c$export$c8f6c7aa8a3372de; });
$parcel$export($8b55bd10a455ef8c$exports, "TOOGLE", function () { return $8b55bd10a455ef8c$export$feafb7048ba17092; });
const $8b55bd10a455ef8c$export$965dbcaf9eaff519 = 'button_click';
const $8b55bd10a455ef8c$export$fcfaa09cc4161077 = 'link_click';
const $8b55bd10a455ef8c$export$1a4b85c6feafd267 = 'message_text';
const $8b55bd10a455ef8c$export$238d30785c4bca84 = 'banner';
const $8b55bd10a455ef8c$export$73f887cc88cd3d43 = 'error_banner';
const $8b55bd10a455ef8c$export$c8f6c7aa8a3372de = 'checkbox_click';
const $8b55bd10a455ef8c$export$feafb7048ba17092 = 'toogle';


var $744732e0bd9719d8$exports = {};

$parcel$export($744732e0bd9719d8$exports, "UNSUBSCRIBE_ALL", function () { return $744732e0bd9719d8$export$199127a4a2058410; });
$parcel$export($744732e0bd9719d8$exports, "DECLINE_UNSUBSCRIBE_ALL", function () { return $744732e0bd9719d8$export$a4d07698a8bb1a95; });
$parcel$export($744732e0bd9719d8$exports, "DOWN_FOR_MAINTENANCE", function () { return $744732e0bd9719d8$export$95367dd33f34a448; });
$parcel$export($744732e0bd9719d8$exports, "EMPTY_SUB_LIST", function () { return $744732e0bd9719d8$export$dc3e3a7146a7071c; });
$parcel$export($744732e0bd9719d8$exports, "USER_NOT_FOUND", function () { return $744732e0bd9719d8$export$a8a3d6e2f6eeee03; });
$parcel$export($744732e0bd9719d8$exports, "FAILED_TO_UPDATE_PREFERENCES", function () { return $744732e0bd9719d8$export$3ba33fbdafc5be66; });
$parcel$export($744732e0bd9719d8$exports, "UPDATE_PREFERENCES", function () { return $744732e0bd9719d8$export$946e18e3873235d0; });
$parcel$export($744732e0bd9719d8$exports, "UNSUBSCRIBE", function () { return $744732e0bd9719d8$export$881b71df7abed909; });
$parcel$export($744732e0bd9719d8$exports, "SUBSCRIBE", function () { return $744732e0bd9719d8$export$f8db20b65b2d4fc4; });
$parcel$export($744732e0bd9719d8$exports, "PREFERENCES_CENTER_NAVIGATION", function () { return $744732e0bd9719d8$export$f7a90df9002e60a8; });
$parcel$export($744732e0bd9719d8$exports, "ACCEPT_CONSENT", function () { return $744732e0bd9719d8$export$cd0a3902626d26aa; });
$parcel$export($744732e0bd9719d8$exports, "DECLINE_CONSENT", function () { return $744732e0bd9719d8$export$4f67ce9f48d4cc97; });
$parcel$export($744732e0bd9719d8$exports, "CONFIRM_CONSENT_PR_UNSUB_CONSENT", function () { return $744732e0bd9719d8$export$e012f5121294da10; });
$parcel$export($744732e0bd9719d8$exports, "DECLINE_CONSENT_PR_UNSUB_CONSENT", function () { return $744732e0bd9719d8$export$681c07eab7dfb6f2; });
$parcel$export($744732e0bd9719d8$exports, "REVOKE_ALL_CONSENT", function () { return $744732e0bd9719d8$export$2a591ef5a2734d84; });
$parcel$export($744732e0bd9719d8$exports, "SUBSCRIBE_GROUP", function () { return $744732e0bd9719d8$export$e0dcfd31675866ee; });
$parcel$export($744732e0bd9719d8$exports, "UNSUBSCRIBE_GROUP", function () { return $744732e0bd9719d8$export$845502d739550ac8; });
$parcel$export($744732e0bd9719d8$exports, "SELECT_LANGUAGE", function () { return $744732e0bd9719d8$export$7648dfe09aa97505; });
$parcel$export($744732e0bd9719d8$exports, "REVOKE_CONSENT", function () { return $744732e0bd9719d8$export$805cd9f249ca61ad; });
$parcel$export($744732e0bd9719d8$exports, "SWITCH_TAB", function () { return $744732e0bd9719d8$export$59e75124cccac80d; });
$parcel$export($744732e0bd9719d8$exports, "CONFIRM_DOUBLE_OPT_IN", function () { return $744732e0bd9719d8$export$5bea899ee9b8b29f; });
$parcel$export($744732e0bd9719d8$exports, "SUBSCRIBE_PRODUCT_INVITATIONS_WARNING", function () { return $744732e0bd9719d8$export$b3df1c5423e656a2; });
const $744732e0bd9719d8$export$199127a4a2058410 = 'unsubscribe_all';
const $744732e0bd9719d8$export$a4d07698a8bb1a95 = 'decline_unsubscribe_all';
const $744732e0bd9719d8$export$95367dd33f34a448 = 'down_for_maintenance';
const $744732e0bd9719d8$export$dc3e3a7146a7071c = 'empty_sub_list';
const $744732e0bd9719d8$export$a8a3d6e2f6eeee03 = 'user_not_found';
const $744732e0bd9719d8$export$3ba33fbdafc5be66 = 'failed_to_update_preferences';
const $744732e0bd9719d8$export$946e18e3873235d0 = 'update_preferences';
const $744732e0bd9719d8$export$881b71df7abed909 = 'unsubscribe';
const $744732e0bd9719d8$export$f8db20b65b2d4fc4 = 'subscribe';
const $744732e0bd9719d8$export$f7a90df9002e60a8 = 'preferences_center_navigation';
const $744732e0bd9719d8$export$cd0a3902626d26aa = 'accept_consent';
const $744732e0bd9719d8$export$4f67ce9f48d4cc97 = 'decline_consent';
const $744732e0bd9719d8$export$e012f5121294da10 = 'confirm_consent_pr_unsub';
const $744732e0bd9719d8$export$681c07eab7dfb6f2 = 'decline_consent_pr_unsub';
const $744732e0bd9719d8$export$2a591ef5a2734d84 = 'revoke_all_consent';
const $744732e0bd9719d8$export$e0dcfd31675866ee = 'subscribe_group';
const $744732e0bd9719d8$export$845502d739550ac8 = 'unsubscribe_group';
const $744732e0bd9719d8$export$7648dfe09aa97505 = 'select_language';
const $744732e0bd9719d8$export$805cd9f249ca61ad = 'revoke_consent';
const $744732e0bd9719d8$export$59e75124cccac80d = 'switch_tab';
const $744732e0bd9719d8$export$5bea899ee9b8b29f = 'confirm_double_opt_in';
const $744732e0bd9719d8$export$b3df1c5423e656a2 = 'subscribe_product_invitations_warning';




const $275512fd46801a1e$var$PROD_SEGMENT_SOURCE_ID = '8tEfgRCivSBv7oqseie70PwBF8dEE0F7';
const $275512fd46801a1e$var$STAGE_SEGMENT_SOURCE_ID = 'tFFPMQDrOUOBmDWwOJrsZOO4epCn28ie';
const $275512fd46801a1e$var$ANALYTICS_WRAPPER = 'https://atl-global.atlassian.com/js/atl-global.min.js';
const $275512fd46801a1e$export$f2a39aaa42ea357a = ()=>{
    const { name: name } = (0, $35a545355f14a0c7$export$6bc7b24d4e862158)();
    const writeKey = name === (0, $c1e4a1336f2cb96e$exports).PROD ? $275512fd46801a1e$var$PROD_SEGMENT_SOURCE_ID : $275512fd46801a1e$var$STAGE_SEGMENT_SOURCE_ID;
    if (window.ace) window.ace.analytics.Initializer.initAnalytics(writeKey);
    else console.warn('Did not load analytics library');
};
const $275512fd46801a1e$export$d22535dc59b4c5d0 = ()=>{
    const script = document.createElement('script');
    script.src = $275512fd46801a1e$var$ANALYTICS_WRAPPER;
    script.type = 'text/javascript';
    script.id = 'atl-global';
    script.onload = $275512fd46801a1e$export$f2a39aaa42ea357a;
    document.body.appendChild(script);
};
const $275512fd46801a1e$export$bd13a0a8c0977b2f = (pageName, data)=>{
    if (window.ace) window.ace.analytics.Tracking.pageView(null, pageName, data);
    else console.warn('Did not load analytics library');
};
const $275512fd46801a1e$export$73d0a139caca1fee = (action, actionDesc, params)=>{
    const data = params ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        actionDesc: actionDesc
    }, params) : {
        actionDesc: actionDesc
    };
    if (window.ace) window.ace.analytics.Tracking.trackEvent(action, data);
    else console.warn('Did not load analytics library');
};





const $0e08eda71bb24540$export$e2ad6fafbc50701c = (hid, source, unsubscribe_keys, subscribe_keys)=>{
    (0, $275512fd46801a1e$export$bd13a0a8c0977b2f)('Preferences Center', {
        hid: hid,
        source: source,
        unsubscribe_keys: unsubscribe_keys,
        subscribe_keys: subscribe_keys
    });
};
const $0e08eda71bb24540$export$2661a9b7d6c9d40 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).UNSUBSCRIBE_ALL);
};
const $0e08eda71bb24540$export$11887f10ee02c881 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).DECLINE_UNSUBSCRIBE_ALL);
};
const $0e08eda71bb24540$export$b2d5c41c71279068 = (subscribed, params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).CHECKBOX_CLICK, subscribed ? (0, $744732e0bd9719d8$exports).SUBSCRIBE : (0, $744732e0bd9719d8$exports).UNSUBSCRIBE, params);
};
const $0e08eda71bb24540$export$6f7cca16e34ea87f = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).MESSAGE_TEXT, (0, $744732e0bd9719d8$exports).DOWN_FOR_MAINTENANCE);
};
const $0e08eda71bb24540$export$f1239e0c91a8acb6 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).MESSAGE_TEXT, (0, $744732e0bd9719d8$exports).EMPTY_SUB_LIST);
};
const $0e08eda71bb24540$export$df7ac42928b20388 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).MESSAGE_TEXT, (0, $744732e0bd9719d8$exports).USER_NOT_FOUND);
};
const $0e08eda71bb24540$export$24a9508d2a444047 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BANNER, (0, $744732e0bd9719d8$exports).UNSUBSCRIBE_ALL);
};
const $0e08eda71bb24540$export$a5babd368b9bd0a8 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BANNER, (0, $744732e0bd9719d8$exports).UPDATE_PREFERENCES);
};
const $0e08eda71bb24540$export$f508667310aad4a2 = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BANNER, (0, $744732e0bd9719d8$exports).UNSUBSCRIBE, params);
};
const $0e08eda71bb24540$export$3830a8576e3e4291 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BANNER, (0, $744732e0bd9719d8$exports).SUBSCRIBE);
};
const $0e08eda71bb24540$export$d6067dcb8ad24019 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).ERROR_BANNER, (0, $744732e0bd9719d8$exports).FAILED_TO_UPDATE_PREFERENCES);
};
const $0e08eda71bb24540$export$ac0c4a766e9f767e = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).PREFERENCES_CENTER_NAVIGATION);
};
const $0e08eda71bb24540$export$1ee474b7e28ef3c0 = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).ACCEPT_CONSENT, params);
};
const $0e08eda71bb24540$export$f9f36241b679fafe = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).DECLINE_CONSENT, params);
};
const $0e08eda71bb24540$export$46324d0949923406 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).ERROR_BANNER, (0, $744732e0bd9719d8$exports).DECLINE_CONSENT);
};
const $0e08eda71bb24540$export$ee3c89fcd945a704 = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).CONFIRM_CONSENT_PR_UNSUB_CONSENT, params);
};
const $0e08eda71bb24540$export$76b1ce7baa042b11 = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).DECLINE_CONSENT_PR_UNSUB_CONSENT, params);
};
const $0e08eda71bb24540$export$36e114c0305b5ce5 = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).TOOGLE, (0, $744732e0bd9719d8$exports).SELECT_LANGUAGE, params);
};
const $0e08eda71bb24540$export$c369c41080a75c3d = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).CHECKBOX_CLICK, (0, $744732e0bd9719d8$exports).REVOKE_CONSENT, params);
};
const $0e08eda71bb24540$export$1e7f31c83a73d717 = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).TOOGLE, (0, $744732e0bd9719d8$exports).SWITCH_TAB, params);
};
const $0e08eda71bb24540$export$19e5a6bca6f03118 = (subscribed, params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, subscribed ? (0, $744732e0bd9719d8$exports).SUBSCRIBE_GROUP : (0, $744732e0bd9719d8$exports).UNSUBSCRIBE_GROUP, params);
};
const $0e08eda71bb24540$export$f1757086d8a8d8f4 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).REVOKE_ALL_CONSENT);
};
const $0e08eda71bb24540$export$203cbc4ee16257d7 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).CONFIRM_DOUBLE_OPT_IN);
};
const $0e08eda71bb24540$export$e40784e30c403486 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).SUBSCRIBE_PRODUCT_INVITATIONS_WARNING);
};




const $6b30d0cc5ae6fbf1$export$e3f5ffe9a12f28f6 = 'localization';
const $6b30d0cc5ae6fbf1$export$d8883c30992bd0c2 = `${$6b30d0cc5ae6fbf1$export$e3f5ffe9a12f28f6}/loadTranslation`;
const $6b30d0cc5ae6fbf1$export$ed8c90bb5caf747 = `${$6b30d0cc5ae6fbf1$export$e3f5ffe9a12f28f6}/loadLanguages`;
const $6b30d0cc5ae6fbf1$export$30095ee86a883fad = `${$6b30d0cc5ae6fbf1$export$e3f5ffe9a12f28f6}/initialization`;
const $6b30d0cc5ae6fbf1$export$495eb7fb1401acaa = `${$6b30d0cc5ae6fbf1$export$e3f5ffe9a12f28f6}/switchLanguage`;


const $cc45bcc51bf95f36$var$extractSystemLanguage = ()=>window.navigator.languages[0].split('-')[0];
const $cc45bcc51bf95f36$var$FALLBACK_LANGUAGE = 'en';
const $cc45bcc51bf95f36$var$initialState = {
    language: $cc45bcc51bf95f36$var$FALLBACK_LANGUAGE,
    fallbackLanguage: $cc45bcc51bf95f36$var$FALLBACK_LANGUAGE,
    systemLanguage: $cc45bcc51bf95f36$var$extractSystemLanguage(),
    userLanguage: undefined,
    supportedLanguages: {
        en: 'English'
    },
    translations: {}
};
const $cc45bcc51bf95f36$export$85e084dbe857046b = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $6b30d0cc5ae6fbf1$export$d8883c30992bd0c2), async (language)=>{
    return await (0, $d5dda7b7f034addc$export$fcc75ec143a0a864)(language);
}, {
    condition: (language, { getState: getState })=>getState().localization.translations[language] == null
});
const $cc45bcc51bf95f36$export$8cd7e7a54fa865bc = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $6b30d0cc5ae6fbf1$export$ed8c90bb5caf747), async ()=>{
    return await (0, $d5dda7b7f034addc$export$3ba5e2c74659a212)();
}, {
});
const $cc45bcc51bf95f36$export$d1f0f8da0682c531 = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $6b30d0cc5ae6fbf1$export$30095ee86a883fad), async (_, { dispatch: dispatch })=>{
    await dispatch($cc45bcc51bf95f36$export$85e084dbe857046b($cc45bcc51bf95f36$var$FALLBACK_LANGUAGE));
    await dispatch($cc45bcc51bf95f36$export$8cd7e7a54fa865bc(null));
});
const $cc45bcc51bf95f36$export$fa43c961ec463ef0 = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $6b30d0cc5ae6fbf1$export$495eb7fb1401acaa), async (language, { dispatch: dispatch })=>{
    await dispatch($cc45bcc51bf95f36$export$85e084dbe857046b(language));
    (0, $0e08eda71bb24540$export$36e114c0305b5ce5)({
        lang: language
    });
    return language;
});
const $cc45bcc51bf95f36$var$localizationSlice = (0, $15d924278321bdfd$export$4d8d9bd83c24ae8b)({
    name: (0, $6b30d0cc5ae6fbf1$export$e3f5ffe9a12f28f6),
    initialState: $cc45bcc51bf95f36$var$initialState,
    reducers: {
        changeUserLanguage: (state, action)=>{
            state.userLanguage = action.payload;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($cc45bcc51bf95f36$export$85e084dbe857046b.fulfilled, (state, { payload: payload, meta: meta })=>{
            state.translations = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.translations), {
                [meta.arg]: payload
            });
        });
        builder.addCase($cc45bcc51bf95f36$export$8cd7e7a54fa865bc.fulfilled, (state, { payload: payload })=>{
            state.supportedLanguages = payload;
        });
        builder.addCase($cc45bcc51bf95f36$export$fa43c961ec463ef0.fulfilled, (state, { payload: payload })=>{
            state.language = payload;
        });
    }
});
const { changeUserLanguage: $cc45bcc51bf95f36$export$b403247a4bf8b780 } = $cc45bcc51bf95f36$var$localizationSlice.actions;
var $cc45bcc51bf95f36$export$2e2bcd8739ae039 = $cc45bcc51bf95f36$var$localizationSlice.reducer;





var $7fPBF = parcelRequire("7fPBF");

const $0ce633403190319b$export$20b36ebcfeb0a091 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.localization.language, (language)=>language);
const $0ce633403190319b$export$66e9475a9fd6dfbe = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.localization.language, (state)=>state.localization.userLanguage, (state)=>state.localization.systemLanguage, (state)=>state.localization.fallbackLanguage, (state)=>state.localization.supportedLanguages, (currentLanguage, userLanguage, systemLanguage, fallbackLanguage, supportedLanguages)=>{
    let proposedLanguage = fallbackLanguage;
    if (userLanguage && supportedLanguages[userLanguage] != null) proposedLanguage = userLanguage;
    else if (supportedLanguages[systemLanguage] != null) proposedLanguage = systemLanguage;
    return currentLanguage !== proposedLanguage ? proposedLanguage : undefined;
});
const $0ce633403190319b$export$2a9f106f311b16ff = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.localization.translations, (translations)=>Object.keys(translations).length !== 0);
const $0ce633403190319b$export$454c8e352dec47e6 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.localization.supportedLanguages, (supportedLanguages)=>supportedLanguages);
const $0ce633403190319b$export$77bdeabf29c9729a = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.localization.translations, (state)=>state.localization.language, (state)=>state.localization.fallbackLanguage, (translations, language, fallbackLanguage)=>{
    let languageTranslation = translations[language];
    if (languageTranslation == null) languageTranslation = translations[fallbackLanguage];
    return languageTranslation;
});
const $0ce633403190319b$export$9db941f9dac66123 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.localization.translations, (state)=>state.localization.fallbackLanguage, (translations, fallbackLanguage)=>translations[fallbackLanguage]);


const $c9cb1bee0dfb8876$export$f3b57b803065ff8a = (source, holder)=>{
    if (source == null) return source;
    const replacer = (substring, args)=>holder[args] || substring;
    return source.replace(/{([^{}]*)}/g, replacer);
};





const $7ef2374eddee6a70$export$f51d452c10d5b956 = (0, $f30b917334351296$export$8ad76b76a4c905f8).withTypes();
const $7ef2374eddee6a70$export$a7347740d65f620b = (0, $f30b917334351296$export$2105062e25df4afe).withTypes();


const $a69d01c0ea406f35$export$9fc83ad70ead8663 = ()=>{
    const translations = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$77bdeabf29c9729a));
    const fallbackTranslations = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$9db941f9dac66123));
    const keyWithTitle = (0, $7fPBF.useCallback)((key)=>`${key}.title`, []);
    const keyWithDescription = (0, $7fPBF.useCallback)((key)=>`${key}.description`, []);
    const keyWithCallout = (0, $7fPBF.useCallback)((key)=>`${key}.callout`, []);
    const translate = (0, $7fPBF.useCallback)((key, values)=>{
        let translation = translations[key];
        if (!translation) translation = fallbackTranslations[key];
        if (values != null) return (0, $c9cb1bee0dfb8876$export$f3b57b803065ff8a)(translation, values) || key;
        else return translation || key;
    }, [
        translations,
        fallbackTranslations
    ]);
    return {
        translate: translate,
        keyWithTitle: keyWithTitle,
        keyWithDescription: keyWithDescription,
        keyWithCallout: keyWithCallout
    };
};








var $d1cff7edaf95fc01$exports = {};
"use strict";
Object.defineProperty($d1cff7edaf95fc01$exports, "__esModule", {
    value: true
});
$d1cff7edaf95fc01$exports.default = void 0;

var $d1cff7edaf95fc01$var$_react = $d1cff7edaf95fc01$var$_interopRequireDefault((parcelRequire("7fPBF")));
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c51efbfa35fd135d$var$ATOMIC_GROUP_LENGTH = 5;
function $c51efbfa35fd135d$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $c51efbfa35fd135d$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


function $ab6305b9bfa57046$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab6305b9bfa57046$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab6305b9bfa57046$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab6305b9bfa57046$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $ab6305b9bfa57046$var$iconStyles = null;
var $ab6305b9bfa57046$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $ab6305b9bfa57046$var$baseHcmStyles = null;
var $ab6305b9bfa57046$var$primaryEqualsSecondaryHcmStyles = null;
var $ab6305b9bfa57046$var$secondaryTransparentHcmStyles = null;
var $ab6305b9bfa57046$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $7fPBF.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $ab6305b9bfa57046$var$_objectSpread($ab6305b9bfa57046$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $c51efbfa35fd135d$export$2e2bcd8739ae039)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $ab6305b9bfa57046$var$sizeStyles[size]
        ])
    }));
});
var $ab6305b9bfa57046$export$2e2bcd8739ae039 = $ab6305b9bfa57046$export$f04a61298a47a40f;


function $d1cff7edaf95fc01$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d1cff7edaf95fc01$var$WorldIcon = (props)=>/*#__PURE__*/ $d1cff7edaf95fc01$var$_react.default.createElement($ab6305b9bfa57046$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-.9-1.863A7.19 7.19 0 0 1 4.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8zm6.21-2.286A1.79 1.79 0 0 0 15.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851"/></svg>`
    }, props));
$d1cff7edaf95fc01$var$WorldIcon.displayName = 'WorldIcon';
var $d1cff7edaf95fc01$var$_default = $d1cff7edaf95fc01$exports.default = $d1cff7edaf95fc01$var$WorldIcon;


/* eslint-disable @repo/internal/react/require-jsdoc */ var $5819e7133c450b79$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};


var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
var $e476a2e3142aad46$var$_process$env;
var /// <reference types="node" />
$e476a2e3142aad46$export$2e2bcd8739ae039 = false;



var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
var $1bfc5778dcd4841a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$1bfc5778dcd4841a$exports = (parcelRequire("iDep4"))();



var $7fPBF = parcelRequire("7fPBF");
var $b7b652b4080c1da6$var$AnalyticsNextContext = (0, $7fPBF.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $b7b652b4080c1da6$export$2e2bcd8739ae039 = $b7b652b4080c1da6$var$AnalyticsNextContext;


var $e420dde09fb890a4$export$2e2bcd8739ae039 = (0, $b7b652b4080c1da6$export$2e2bcd8739ae039);


function $2925ce99e929899b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $2925ce99e929899b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $2925ce99e929899b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2925ce99e929899b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $2925ce99e929899b$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
};
var $2925ce99e929899b$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $2925ce99e929899b$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, AnalyticsContext);
        _this = $2925ce99e929899b$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $2925ce99e929899b$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $2925ce99e929899b$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e420dde09fb890a4$export$2e2bcd8739ae039).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $7fPBF.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($2925ce99e929899b$var$AnalyticsContext, "contextTypes", $2925ce99e929899b$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($2925ce99e929899b$var$AnalyticsContext, "childContextTypes", $2925ce99e929899b$var$ContextTypes);
var $2925ce99e929899b$export$2e2bcd8739ae039 = $2925ce99e929899b$var$AnalyticsContext;



var $j9spr = parcelRequire("j9spr");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $afe2f1cfd0fadbcf$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $7fPBF.useContext)((0, $e420dde09fb890a4$export$2e2bcd8739ae039));
};



var $7fPBF = parcelRequire("7fPBF");
var $8606d3c77a5913a9$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $7fPBF.useRef)(value);
    ref.current = value;
    return ref;
};


var $f751e275ea128696$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $8606d3c77a5913a9$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $afe2f1cfd0fadbcf$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $7fPBF.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $7fPBF.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e420dde09fb890a4$export$2e2bcd8739ae039).Provider, {
        value: value
    }, children);
};
var $f751e275ea128696$export$2e2bcd8739ae039 = $f751e275ea128696$var$AnalyticsContext;


var $3f9e6ff285b84928$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $e476a2e3142aad46$export$2e2bcd8739ae039) || (0, $137Lh.fg)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f751e275ea128696$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2925ce99e929899b$export$2e2bcd8739ae039), props);
};
var $3f9e6ff285b84928$export$2e2bcd8739ae039 = $3f9e6ff285b84928$var$ExportedAnalyticsContext;


var $4d25ac76de88d196$var$_excluded = [
    "analyticsContext"
];
function $4d25ac76de88d196$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4d25ac76de88d196$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4d25ac76de88d196$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4d25ac76de88d196$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4d25ac76de88d196$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $4d25ac76de88d196$var$_excluded);
            var analyticsData = (0, $7fPBF.useMemo)(function() {
                return $4d25ac76de88d196$var$_objectSpread($4d25ac76de88d196$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3f9e6ff285b84928$export$2e2bcd8739ae039), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $4d25ac76de88d196$export$2e2bcd8739ae039 = $4d25ac76de88d196$var$withAnalyticsContext;


var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
function $6ff1114199100bef$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $6ff1114199100bef$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $7fPBF.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $7fPBF.useRef)(true);
    var committed = (0, $7fPBF.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $6ff1114199100bef$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $7fPBF.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $6ff1114199100bef$export$33752cf3ee811995(callback, inputs) {
    return $6ff1114199100bef$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $6ff1114199100bef$export$1538c33de8887b59 = $6ff1114199100bef$export$b6feb8998cd9b342;
var $6ff1114199100bef$export$35808ee640e87ca7 = $6ff1114199100bef$export$33752cf3ee811995;



var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $eKeTJ = parcelRequire("eKeTJ");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");
function $d666a3ae7fbfd72e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d666a3ae7fbfd72e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d666a3ae7fbfd72e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d666a3ae7fbfd72e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d666a3ae7fbfd72e$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d666a3ae7fbfd72e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $d666a3ae7fbfd72e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $d666a3ae7fbfd72e$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(updater) === 'object') this.payload = $d666a3ae7fbfd72e$var$_objectSpread($d666a3ae7fbfd72e$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $1732f5d94ae24641$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $1732f5d94ae24641$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $1732f5d94ae24641$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1732f5d94ae24641$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1732f5d94ae24641$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($eKeTJ)))((0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1732f5d94ae24641$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $1732f5d94ae24641$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $1732f5d94ae24641$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, UIAnalyticsEvent);
        _this = $1732f5d94ae24641$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $1732f5d94ae24641$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $d666a3ae7fbfd72e$export$2e2bcd8739ae039));



function $8618b7ff1a86c099$export$5bf35293e545f20c() {
    var analyticsContext = (0, $afe2f1cfd0fadbcf$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6ff1114199100bef$export$33752cf3ee811995)(function(payload) {
        return new (0, $1732f5d94ae24641$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $8MJe2 = parcelRequire("8MJe2");

var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");

function $abb2b2a73fb99cad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $abb2b2a73fb99cad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $abb2b2a73fb99cad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $abb2b2a73fb99cad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $abb2b2a73fb99cad$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $8618b7ff1a86c099$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $7fPBF.useRef)({});
    var patchedProps = (0, $7fPBF.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $abb2b2a73fb99cad$var$_objectSpread($abb2b2a73fb99cad$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $abb2b2a73fb99cad$var$_objectSpread($abb2b2a73fb99cad$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


var $f8e03d3ef4b3dc3d$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $abb2b2a73fb99cad$export$9ebb5a84d17e5d18)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $8618b7ff1a86c099$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $f8e03d3ef4b3dc3d$export$2e2bcd8739ae039 = $f8e03d3ef4b3dc3d$var$withAnalyticsEvents;



var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $cvBp9 = parcelRequire("cvBp9");
var $2d4796af5a44921e$exports = {};
function $2d4796af5a44921e$var$_readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
$2d4796af5a44921e$exports = $2d4796af5a44921e$var$_readOnlyError, $2d4796af5a44921e$exports.__esModule = true, $2d4796af5a44921e$exports["default"] = $2d4796af5a44921e$exports;



var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $j9spr = parcelRequire("j9spr");

var $7fPBF = parcelRequire("7fPBF");
function $1d47d2fcfd20024b$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? //@ts-expect-error ignore userAgentData type issue
    re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $1d47d2fcfd20024b$var$isIPhone() {
    return $1d47d2fcfd20024b$var$testPlatform(/^iPhone/i);
}
function $1d47d2fcfd20024b$var$isMac() {
    return $1d47d2fcfd20024b$var$testPlatform(/^Mac/i);
}
function $1d47d2fcfd20024b$var$isIPad() {
    return $1d47d2fcfd20024b$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $1d47d2fcfd20024b$var$isMac() && navigator.maxTouchPoints > 1;
}
function $1d47d2fcfd20024b$var$isIOS() {
    return $1d47d2fcfd20024b$var$isIPhone() || $1d47d2fcfd20024b$var$isIPad();
}
function $1d47d2fcfd20024b$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use2;
        var ua = (_window$navigator$use2 = window.navigator.userAgent) === null || _window$navigator$use2 === void 0 ? void 0 : _window$navigator$use2.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $1d47d2fcfd20024b$export$e1865c3bedcd822b() {
    return $1d47d2fcfd20024b$var$isMac() || $1d47d2fcfd20024b$var$isIOS();
}



var $137Lh = parcelRequire("137Lh");
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $b2afea94242257b8$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};
var $b2afea94242257b8$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};
var $b2afea94242257b8$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};
var $b2afea94242257b8$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};



var $8MJe2 = parcelRequire("8MJe2");
/* containers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

var $fjFkG = parcelRequire("fjFkG");
const $1f114d76bc1ab81d$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $fjFkG.default)(actualStyles);
};



var $137Lh = parcelRequire("137Lh");

var $iKdEz = parcelRequire("iKdEz");

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $bRUy3 = parcelRequire("bRUy3");
var $c3eea1c9ec58844c$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $c3eea1c9ec58844c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c3eea1c9ec58844c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c3eea1c9ec58844c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c3eea1c9ec58844c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c3eea1c9ec58844c$export$8793edee2d425525 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $c3eea1c9ec58844c$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $c3eea1c9ec58844c$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($c3eea1c9ec58844c$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
var $c3eea1c9ec58844c$export$33f062f47f21a01 = function cleanValue(value) {
    if ($c3eea1c9ec58844c$var$isArray(value)) return value.filter(Boolean);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
var $c3eea1c9ec58844c$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $c3eea1c9ec58844c$var$_excluded);
    return $c3eea1c9ec58844c$var$_objectSpread({}, innerProps);
};
var $c3eea1c9ec58844c$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
function $c3eea1c9ec58844c$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $c3eea1c9ec58844c$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $c3eea1c9ec58844c$export$2e0654fad740d2e4(el) {
    if ($c3eea1c9ec58844c$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $c3eea1c9ec58844c$export$c4a223a8ba9e4ea5(el) {
    if ($c3eea1c9ec58844c$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $c3eea1c9ec58844c$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($c3eea1c9ec58844c$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $c3eea1c9ec58844c$export$cfa2225e87938781(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $c3eea1c9ec58844c$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $c3eea1c9ec58844c$export$858c30343199f3af(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $c3eea1c9ec58844c$export$8793edee2d425525;
    var start = $c3eea1c9ec58844c$export$c4a223a8ba9e4ea5(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $c3eea1c9ec58844c$var$easeOutCubic(currentTime, start, change, duration);
        $c3eea1c9ec58844c$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $c3eea1c9ec58844c$export$53a0910f038337bd(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $c3eea1c9ec58844c$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $c3eea1c9ec58844c$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $c3eea1c9ec58844c$export$7807c2a424c2f6d1(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $c3eea1c9ec58844c$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $c3eea1c9ec58844c$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $c3eea1c9ec58844c$var$passiveOptionAccessed = false;
var $c3eea1c9ec58844c$var$options = {
    get passive () {
        return $c3eea1c9ec58844c$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $c3eea1c9ec58844c$var$w = typeof window !== 'undefined' ? window : {};
if ($c3eea1c9ec58844c$var$w.addEventListener && $c3eea1c9ec58844c$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $c3eea1c9ec58844c$var$w.addEventListener('p', $c3eea1c9ec58844c$export$8793edee2d425525, $c3eea1c9ec58844c$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $c3eea1c9ec58844c$var$w.removeEventListener('p', $c3eea1c9ec58844c$export$8793edee2d425525, false);
}
var $c3eea1c9ec58844c$export$b0622a6911dbeaf5 = $c3eea1c9ec58844c$var$passiveOptionAccessed;
function $c3eea1c9ec58844c$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $c3eea1c9ec58844c$var$isArray(arg) {
    return Array.isArray(arg);
}
function $c3eea1c9ec58844c$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $c3eea1c9ec58844c$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $c3eea1c9ec58844c$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
var $c3eea1c9ec58844c$export$4213b25a1c4e877 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $c3eea1c9ec58844c$export$bf2eda47afa5f369 = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};


var $ffac923ac68814d3$export$949392aeaf7d2e3a = function containerCSS() {
    return {};
};
var $ffac923ac68814d3$var$containerStyles = {
    default: "_11c82smr _kqswh2mm _lcxv1rj4",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf",
    ff_safari_input_fix: "_11c81ixg _1tn22smr"
};
var $ffac923ac68814d3$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $ffac923ac68814d3$var$containerStyles.default,
            isRtl && $ffac923ac68814d3$var$containerStyles.rtl,
            isDisabled && $ffac923ac68814d3$var$containerStyles.disabled,
            (0, $137Lh.fg)('platform_design_system_team_safari_input_fix') && $ffac923ac68814d3$var$containerStyles.ff_safari_input_fix,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};
var $ffac923ac68814d3$export$47aec73c7aa6b9aa = function valueContainerCSS() {
    return {};
};
var $ffac923ac68814d3$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
};
var $ffac923ac68814d3$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps2 = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $ffac923ac68814d3$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $ffac923ac68814d3$var$valueContainerStyles.flex,
            isCompact && $ffac923ac68814d3$var$valueContainerStyles.compact,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};
var $ffac923ac68814d3$export$9d74e3c8b5868ad7 = function indicatorsContainerCSS() {
    return {};
};
var $ffac923ac68814d3$var$indicatorContainerStyles = null;
var $ffac923ac68814d3$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps3 = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};


/* control.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $8665919ac4a0fd0c$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkosqtm _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123byq51 _d0altlke _irr31d5g _1ogl1caj",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsq049",
    disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
    focused: "_1h6d1p6i _bfhkr01l _16qsq049 _1u6lq049 _4cvx1p6i _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $8665919ac4a0fd0c$export$dbf350e5966cf602 = function css() {
    return {};
};
var $8665919ac4a0fd0c$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        ref: innerRef,
        className: (0, $fjFkG.default)([
            $8665919ac4a0fd0c$var$styles.default,
            isDisabled && $8665919ac4a0fd0c$var$styles.disabled,
            isInvalid && $8665919ac4a0fd0c$var$styles.invalid,
            isCompact && $8665919ac4a0fd0c$var$styles.compact,
            appearance === 'subtle' && $8665919ac4a0fd0c$var$styles.subtle,
            appearance === 'subtle' && isFocused && $8665919ac4a0fd0c$var$styles.subtleFocused,
            isFocused && $8665919ac4a0fd0c$var$styles.focused,
            appearance === 'none' && $8665919ac4a0fd0c$var$styles.none,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8665919ac4a0fd0c$export$2e2bcd8739ae039 = $8665919ac4a0fd0c$var$Control;


/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $emuQy = parcelRequire("emuQy");

var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $d83249d96f66c520$var$_excluded = [
    "data"
];
var $d83249d96f66c520$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
var $d83249d96f66c520$export$b6794329c1460634 = function groupCSS() {
    return {};
};
var $d83249d96f66c520$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $d83249d96f66c520$var$styles.root,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $7fPBF.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $7fPBF.createElement("div", null, children));
};
var $d83249d96f66c520$var$headingStyles = null;
var $d83249d96f66c520$export$e5a7fbb542efcb7d = function groupHeadingCSS() {
    return {};
};
var $d83249d96f66c520$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $c3eea1c9ec58844c$export$8e9fd4287627890c)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_cleanCommonProps, $d83249d96f66c520$var$_excluded);
    var _getStyleProps2 = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            "_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d83249d96f66c520$export$2e2bcd8739ae039 = $d83249d96f66c520$var$Group;


/* indicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

var $a92c910cd101ed89$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b604d93f37780dd1b714089781bfee62>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($a92c910cd101ed89$exports, "__esModule", {
    value: true
});
$a92c910cd101ed89$exports.default = void 0;

var $a92c910cd101ed89$var$_react = $a92c910cd101ed89$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $a92c910cd101ed89$var$_chevronDown = $a92c910cd101ed89$var$_interopRequireDefault((parcelRequire("7DmNu")));

var $a92c910cd101ed89$var$_chevronDown2 = $a92c910cd101ed89$var$_interopRequireDefault((parcelRequire("eqAsb")));
function $a92c910cd101ed89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a92c910cd101ed89$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $a92c910cd101ed89$var$_react.default.createElement($a92c910cd101ed89$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $a92c910cd101ed89$var$_chevronDown2.default
    }, props));
$a92c910cd101ed89$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $a92c910cd101ed89$var$_default = $a92c910cd101ed89$exports.default = $a92c910cd101ed89$var$ChevronDownIcon;


var $42d3ab92356dda89$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32d605899e0518e58ac6527dead74482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($42d3ab92356dda89$exports, "__esModule", {
    value: true
});
$42d3ab92356dda89$exports.default = void 0;

var $42d3ab92356dda89$var$_react = $42d3ab92356dda89$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $42d3ab92356dda89$var$_crossCircle = $42d3ab92356dda89$var$_interopRequireDefault((parcelRequire("bWpDC")));

var $42d3ab92356dda89$var$_selectClear = $42d3ab92356dda89$var$_interopRequireDefault((parcelRequire("dWyuK")));
function $42d3ab92356dda89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42d3ab92356dda89$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $42d3ab92356dda89$var$_react.default.createElement($42d3ab92356dda89$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $42d3ab92356dda89$var$_selectClear.default
    }, props));
$42d3ab92356dda89$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $42d3ab92356dda89$var$_default = $42d3ab92356dda89$exports.default = $42d3ab92356dda89$var$CrossCircleIcon;


/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $ca1b8a586a841420$var$ATOMIC_GROUP_LENGTH = 5;
function $ca1b8a586a841420$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $ca1b8a586a841420$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("7fPBF");

const $b9d1c131a6494052$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $b9d1c131a6494052$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};


/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $89b549ac0d00b763$var$ATOMIC_GROUP_LENGTH = 5;
function $89b549ac0d00b763$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $89b549ac0d00b763$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


const $c16c43e7995db31e$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $89b549ac0d00b763$export$2e2bcd8739ae039)(actualStyles);
};


function $5f17e3270868ebf8$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $b9d1c131a6494052$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $b9d1c131a6494052$export$c4df1cb0c2b4d77c)();
        },
        cx: $c16c43e7995db31e$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $b9d1c131a6494052$export$c4df1cb0c2b4d77c)();
        }
    };
}


var $e636b2257db42c06$var$_createStrictAPI = (0, $5f17e3270868ebf8$export$39716b4af53f4ad)(), $e636b2257db42c06$var$XCSSProp = $e636b2257db42c06$var$_createStrictAPI.XCSSProp, $e636b2257db42c06$export$dbf350e5966cf602 = $e636b2257db42c06$var$_createStrictAPI.css, $e636b2257db42c06$export$eb1ecd84a24ee424 = $e636b2257db42c06$var$_createStrictAPI.cssMap, $e636b2257db42c06$export$a274e22fb40f762e = $e636b2257db42c06$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $48b35d6b88777ae0$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $48b35d6b88777ae0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $48b35d6b88777ae0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $48b35d6b88777ae0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $48b35d6b88777ae0$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $48b35d6b88777ae0$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $48b35d6b88777ae0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $48b35d6b88777ae0$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $48b35d6b88777ae0$var$Flex = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $48b35d6b88777ae0$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, ariaAttributes, {
        role: role,
        className: (0, $ca1b8a586a841420$export$2e2bcd8739ae039)([
            $48b35d6b88777ae0$var$styles.root,
            gap && $48b35d6b88777ae0$var$columnGapMap[gap],
            columnGap && $48b35d6b88777ae0$var$columnGapMap[columnGap],
            gap && $48b35d6b88777ae0$var$rowGapMap[gap],
            rowGap && $48b35d6b88777ae0$var$rowGapMap[rowGap],
            alignItems && $48b35d6b88777ae0$var$alignItemsMap[alignItems],
            direction && $48b35d6b88777ae0$var$flexDirectionMap[direction],
            justifyContent && $48b35d6b88777ae0$var$justifyContentMap[justifyContent],
            wrap && $48b35d6b88777ae0$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$48b35d6b88777ae0$var$Flex.displayName = 'Flex';
var $48b35d6b88777ae0$export$2e2bcd8739ae039 = $48b35d6b88777ae0$var$Flex;


var $5f5c616ec3c653f2$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $5f5c616ec3c653f2$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $5f5c616ec3c653f2$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $ca1b8a586a841420$export$2e2bcd8739ae039)([
            $5f5c616ec3c653f2$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $5f5c616ec3c653f2$var$Inline = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $5f5c616ec3c653f2$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $7fPBF.createElement($5f5c616ec3c653f2$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $7fPBF.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $7fPBF.createElement((0, $48b35d6b88777ae0$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)(grow === 'hug' && $5f5c616ec3c653f2$var$styles.hug, grow === 'fill' && $5f5c616ec3c653f2$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$5f5c616ec3c653f2$var$Inline.displayName = 'Inline';
var $5f5c616ec3c653f2$export$2e2bcd8739ae039 = $5f5c616ec3c653f2$var$Inline;

/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


const $625a2a0002b5c0da$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $ca1b8a586a841420$export$2e2bcd8739ae039)(actualStyles);
};



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


function $593ac790924c31ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $593ac790924c31ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $593ac790924c31ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $593ac790924c31ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $593ac790924c31ca$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8618b7ff1a86c099$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8606d3c77a5913a9$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $8606d3c77a5913a9$export$1d27a74659855e44)(fn);
    var handler = (0, $7fPBF.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $593ac790924c31ca$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


function $915173cc6d534745$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? //@ts-expect-error ignore userAgentData type issue
    re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $915173cc6d534745$var$isIPhone() {
    return $915173cc6d534745$var$testPlatform(/^iPhone/i);
}
function $915173cc6d534745$var$isMac() {
    return $915173cc6d534745$var$testPlatform(/^Mac/i);
}
function $915173cc6d534745$var$isIPad() {
    return $915173cc6d534745$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $915173cc6d534745$var$isMac() && navigator.maxTouchPoints > 1;
}
function $915173cc6d534745$var$isIOS() {
    return $915173cc6d534745$var$isIPhone() || $915173cc6d534745$var$isIPad();
}
function $915173cc6d534745$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use2;
        var ua = (_window$navigator$use2 = window.navigator.userAgent) === null || _window$navigator$use2 === void 0 ? void 0 : _window$navigator$use2.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $915173cc6d534745$export$e1865c3bedcd822b() {
    return $915173cc6d534745$var$isMac() || $915173cc6d534745$var$isIOS();
}


/**
 * An empty function which does nothing.
 */ function $27bc0e79b61c3ca3$export$2e2bcd8739ae039() {}



var $7fPBF = parcelRequire("7fPBF");
var $48ec410b84640600$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $f4b8e950b3afcde7$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}


var $141630e001aa18df$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $141630e001aa18df$var$_excluded2 = [
    "className"
];
function $141630e001aa18df$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $141630e001aa18df$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $141630e001aa18df$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $141630e001aa18df$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $141630e001aa18df$var$focusRingStyles = null;
var $141630e001aa18df$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $141630e001aa18df$var$Focusable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $141630e001aa18df$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $141630e001aa18df$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $ca1b8a586a841420$export$2e2bcd8739ae039)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $141630e001aa18df$var$_objectSpread($141630e001aa18df$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $f4b8e950b3afcde7$export$2e2bcd8739ae039)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $141630e001aa18df$export$2e2bcd8739ae039 = $141630e001aa18df$var$Focusable;


var $34bbe408102690e7$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $34bbe408102690e7$var$_excluded2 = [
    "className"
];
var $34bbe408102690e7$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $34bbe408102690e7$var$Pressable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $27bc0e79b61c3ca3$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $34bbe408102690e7$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.11.2",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $34bbe408102690e7$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement((0, $141630e001aa18df$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $915173cc6d534745$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $625a2a0002b5c0da$export$a274e22fb40f762e)($34bbe408102690e7$var$styles.root, isDisabled && $34bbe408102690e7$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $34bbe408102690e7$export$2e2bcd8739ae039 = $34bbe408102690e7$var$Pressable;


/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $79a41e9b219be9af$var$ATOMIC_GROUP_LENGTH = 5;
function $79a41e9b219be9af$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $79a41e9b219be9af$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $7fPBF = parcelRequire("7fPBF");

// Reds
var $afd82abd8d0b43c9$export$4b84fd0e2c617bd = '#FFEBE6';
var $afd82abd8d0b43c9$export$b34b069eff244586 = '#FFBDAD';
var $afd82abd8d0b43c9$export$be802dd0d8b57f35 = '#FF8F73';
var $afd82abd8d0b43c9$export$60847d42f9da92a6 = '#FF7452';
var $afd82abd8d0b43c9$export$4a7404f376229999 = '#FF5630';
var $afd82abd8d0b43c9$export$2010d0fb4295b346 = '#DE350B';
var $afd82abd8d0b43c9$export$2837b5a1a71d5c02 = '#BF2600';
var $afd82abd8d0b43c9$export$8d9596b529bbb9cf = '#FFFAE6';
var $afd82abd8d0b43c9$export$41060a744ab0b7ae = '#FFF0B3';
var $afd82abd8d0b43c9$export$1cc05bbbf340e559 = '#FFE380';
var $afd82abd8d0b43c9$export$5aae31392d72caaa = '#FFC400';
var $afd82abd8d0b43c9$export$c6930421db9fa514 = '#FFAB00';
var $afd82abd8d0b43c9$export$59619663aa6500fb = '#FF991F';
var $afd82abd8d0b43c9$export$874739ea9e379ab6 = '#FF8B00';
var $afd82abd8d0b43c9$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $afd82abd8d0b43c9$export$69a3bf21b9686c2b = '#ABF5D1';
var $afd82abd8d0b43c9$export$afbce1382ec95f73 = '#79F2C0';
var $afd82abd8d0b43c9$export$747d86715d4175de = '#57D9A3';
var $afd82abd8d0b43c9$export$940e1f69e873f202 = '#36B37E';
var $afd82abd8d0b43c9$export$a49394138f7b8e85 = '#00875A';
var $afd82abd8d0b43c9$export$6fa04827ac68a4fb = '#006644';
var $afd82abd8d0b43c9$export$226de0355ed012f8 = '#DEEBFF';
var $afd82abd8d0b43c9$export$8c13c2ee36917869 = '#B3D4FF';
var $afd82abd8d0b43c9$export$ecfc1dff386a3e7a = '#4C9AFF';
var $afd82abd8d0b43c9$export$215b7063051591f1 = '#2684FF';
var $afd82abd8d0b43c9$export$e62e8919cca44969 = '#0065FF';
var $afd82abd8d0b43c9$export$b3de0ae08da2ce64 = '#0052CC';
var $afd82abd8d0b43c9$export$a6ee3d71bc067634 = '#0747A6';
var $afd82abd8d0b43c9$export$67f15409e87642a1 = '#669DF1';
var $afd82abd8d0b43c9$export$f0539dbc42dbb067 = '#8FB8F6';
var $afd82abd8d0b43c9$export$363e4475840015bb = '#EAE6FF';
var $afd82abd8d0b43c9$export$4b0a4417ed59760f = '#C0B6F2';
var $afd82abd8d0b43c9$export$6011520a64d9a187 = '#998DD9';
var $afd82abd8d0b43c9$export$a7175d4e9206bc80 = '#8777D9';
var $afd82abd8d0b43c9$export$b48405b95304b5a1 = '#6554C0';
var $afd82abd8d0b43c9$export$c71e4279dd54a18d = '#5243AA';
var $afd82abd8d0b43c9$export$147899de772240ec = '#403294';
var $afd82abd8d0b43c9$export$2cf711fe14c66f06 = '#E6FCFF';
var $afd82abd8d0b43c9$export$7a8f4d33f6f9772c = '#B3F5FF';
var $afd82abd8d0b43c9$export$776c9c497ef08533 = '#79E2F2';
var $afd82abd8d0b43c9$export$69cb3ca10c1e330e = '#00C7E6';
var $afd82abd8d0b43c9$export$9dc1ef0f3f48059b = '#00B8D9';
var $afd82abd8d0b43c9$export$7c835c78b6fcdef8 = '#00A3BF';
var $afd82abd8d0b43c9$export$6036577f95c3877e = '#008DA6';
var $afd82abd8d0b43c9$export$29a4f05edc054374 = '#FFFFFF';
var $afd82abd8d0b43c9$export$e655ef011c4aa1a2 = '#FAFBFC';
var $afd82abd8d0b43c9$export$9fdfb749e33cdf97 = '#F4F5F7';
var $afd82abd8d0b43c9$export$3e51e8f1440314ba = '#EBECF0';
var $afd82abd8d0b43c9$export$1ce2d1575d444ceb = '#DFE1E6';
var $afd82abd8d0b43c9$export$8754fc7e6d8b3000 = '#C1C7D0';
var $afd82abd8d0b43c9$export$c2e91cbeada39b8b = '#B3BAC5';
var $afd82abd8d0b43c9$export$5f71e19f3a7ad9de = '#A5ADBA';
var $afd82abd8d0b43c9$export$eaa8c8a70ac22806 = '#97A0AF';
var $afd82abd8d0b43c9$export$7c87d337fb91a97d = '#8993A4';
var $afd82abd8d0b43c9$export$d6447c357493214f = '#7A869A';
var $afd82abd8d0b43c9$export$f563ee71e9ee74cd = '#6B778C';
var $afd82abd8d0b43c9$export$e2ef2124cf4024b1 = '#5E6C84';
var $afd82abd8d0b43c9$export$eece5f492e429f08 = '#505F79';
var $afd82abd8d0b43c9$export$c39c0fe0f26207ae = '#42526E';
var $afd82abd8d0b43c9$export$7090862dc3038a9f = '#344563';
var $afd82abd8d0b43c9$export$ad0bacf983b7ddaa = '#253858';
var $afd82abd8d0b43c9$export$7d61b15e0da132af = '#172B4D';
var $afd82abd8d0b43c9$export$fbda843f0a27fe96 = '#091E42';
var $afd82abd8d0b43c9$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $afd82abd8d0b43c9$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $afd82abd8d0b43c9$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $afd82abd8d0b43c9$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $afd82abd8d0b43c9$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $afd82abd8d0b43c9$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $afd82abd8d0b43c9$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $afd82abd8d0b43c9$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $afd82abd8d0b43c9$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $afd82abd8d0b43c9$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $afd82abd8d0b43c9$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $afd82abd8d0b43c9$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $afd82abd8d0b43c9$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $afd82abd8d0b43c9$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $afd82abd8d0b43c9$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $afd82abd8d0b43c9$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $afd82abd8d0b43c9$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $afd82abd8d0b43c9$export$2f6319cf7d736c2a = '#E6EDFA';
var $afd82abd8d0b43c9$export$95126bc8884d6634 = '#DCE5F5';
var $afd82abd8d0b43c9$export$8338d8c35d44ff1 = '#CED9EB';
var $afd82abd8d0b43c9$export$5368d76ae4fbbda7 = '#B8C7E0';
var $afd82abd8d0b43c9$export$9f0a771d16ec8d36 = '#ABBBD6';
var $afd82abd8d0b43c9$export$abcf8c38338b4aa5 = '#9FB0CC';
var $afd82abd8d0b43c9$export$97e81faa16a182c7 = '#8C9CB8';
var $afd82abd8d0b43c9$export$bfe21c59123ecf33 = '#7988A3';
var $afd82abd8d0b43c9$export$ee82aa2ea6a1558 = '#67758F';
var $afd82abd8d0b43c9$export$682927c6ed76be02 = '#56637A';
var $afd82abd8d0b43c9$export$91fd9994c5be9757 = '#455166';
var $afd82abd8d0b43c9$export$d281fbfe3cff2df6 = '#3B475C';
var $afd82abd8d0b43c9$export$3902c91d8b98a753 = '#313D52';
var $afd82abd8d0b43c9$export$8e8133c1ba5845b5 = '#283447';
var $afd82abd8d0b43c9$export$33ff357f6620b39 = '#202B3D';
var $afd82abd8d0b43c9$export$633847cf062b69e0 = '#1B2638';
var $afd82abd8d0b43c9$export$9776a6e503bdbf76 = '#121A29';
var $afd82abd8d0b43c9$export$6c813d5160dff5db = '#0E1624';
var $afd82abd8d0b43c9$export$3d4f271a500072a = '#0D1424';
var $afd82abd8d0b43c9$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $afd82abd8d0b43c9$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $afd82abd8d0b43c9$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $afd82abd8d0b43c9$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $afd82abd8d0b43c9$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $afd82abd8d0b43c9$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $afd82abd8d0b43c9$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $afd82abd8d0b43c9$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $afd82abd8d0b43c9$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $afd82abd8d0b43c9$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $afd82abd8d0b43c9$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $afd82abd8d0b43c9$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $afd82abd8d0b43c9$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $afd82abd8d0b43c9$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $afd82abd8d0b43c9$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $afd82abd8d0b43c9$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $afd82abd8d0b43c9$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $afd82abd8d0b43c9$export$d2adc5dedf09fced = '#292A2E';
var $afd82abd8d0b43c9$export$f51762073d2bb381 = '#94C748';
var $afd82abd8d0b43c9$export$95e26d54def96891 = '#B3DF72';


var $43f46bcc377fb1f0$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $aacfdd39b28e059d$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $afd82abd8d0b43c9$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $afd82abd8d0b43c9$export$29a4f05edc054374), ")");
}
var $aacfdd39b28e059d$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $aacfdd39b28e059d$var$loadIn = null;
var $aacfdd39b28e059d$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $aacfdd39b28e059d$var$useLayoutEffect = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $aacfdd39b28e059d$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $43f46bcc377fb1f0$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $aacfdd39b28e059d$var$getStrokeColor(appearance);
    var context = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    $aacfdd39b28e059d$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $79a41e9b219be9af$export$2e2bcd8739ae039)([
            $aacfdd39b28e059d$var$styles.wrapperStyles,
            $aacfdd39b28e059d$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $79a41e9b219be9af$export$2e2bcd8739ae039)([
            $aacfdd39b28e059d$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $79a41e9b219be9af$export$2e2bcd8739ae039)([
            $aacfdd39b28e059d$var$styles.circleStyles
        ])
    })));
}));
var $aacfdd39b28e059d$export$2e2bcd8739ae039 = $aacfdd39b28e059d$var$Spinner;



var $124ff7c12cb207ae$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $124ff7c12cb207ae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $124ff7c12cb207ae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $124ff7c12cb207ae$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $124ff7c12cb207ae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $124ff7c12cb207ae$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
var $124ff7c12cb207ae$var$dropdownWrapperStyles = {
    root: "_ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7"
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $124ff7c12cb207ae$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1gjq _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf",
    disabled: "_syaz1lh4"
};
var $124ff7c12cb207ae$export$e1687335805e1230 = function dropdownIndicatorCSS() {
    return {};
};
var $124ff7c12cb207ae$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var innerProps = props.innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $124ff7c12cb207ae$var$dropdownStyles.default,
            isDisabled && $124ff7c12cb207ae$var$dropdownStyles.disabled,
            isCompact && $124ff7c12cb207ae$var$dropdownStyles.compact,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), children ? children : /*#__PURE__*/ $7fPBF.createElement((0, $5f5c616ec3c653f2$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $124ff7c12cb207ae$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $7fPBF.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a92c910cd101ed89$exports))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)",
        size: "small"
    })));
};
var $124ff7c12cb207ae$export$9c0419fd944c1def = function clearIndicatorCSS() {
    return {};
};
var $124ff7c12cb207ae$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz131l _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf"
};
var $124ff7c12cb207ae$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps2 = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $124ff7c12cb207ae$var$clearIndicatorStyles.default,
            isCompact && $124ff7c12cb207ae$var$clearIndicatorStyles.compact,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $7fPBF.createElement((0, $34bbe408102690e7$export$2e2bcd8739ae039), {
        xcss: $124ff7c12cb207ae$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $7fPBF.createElement((0, (/*@__PURE__*/$parcel$interopDefault($42d3ab92356dda89$exports))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)",
        size: "small"
    })));
};
var $124ff7c12cb207ae$export$1d3f24cde248e6b5 = function loadingIndicatorCSS() {
    return {};
};
var $124ff7c12cb207ae$var$loadingIndicatorStyles = {
    default: "_ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc",
    compact: "_ca0qidpf _n3tdidpf"
};
var $124ff7c12cb207ae$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $124ff7c12cb207ae$var$_excluded);
    var _getStyleProps3 = (0, $c3eea1c9ec58844c$export$26417cabd806a658)($124ff7c12cb207ae$var$_objectSpread($124ff7c12cb207ae$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $124ff7c12cb207ae$var$loadingIndicatorStyles.default,
            isCompact && $124ff7c12cb207ae$var$loadingIndicatorStyles.compact,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $7fPBF.createElement((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {
        size: "small"
    }));
};


/* input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $af3cd8bd77342c6a$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $af3cd8bd77342c6a$export$14a7781d0ca7abea = function inputCSS() {
    return {};
};
var $af3cd8bd77342c6a$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $af3cd8bd77342c6a$var$nativeInnputStyles = null;
var $af3cd8bd77342c6a$var$hidden = null;
var $af3cd8bd77342c6a$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss;
    var _cleanCommonProps = (0, $c3eea1c9ec58844c$export$8e9fd4287627890c)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_cleanCommonProps, $af3cd8bd77342c6a$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $af3cd8bd77342c6a$var$inputStyles.root,
            isDisabled && $af3cd8bd77342c6a$var$inputStyles.disabled,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $7fPBF.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $fjFkG.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$af3cd8bd77342c6a$export$2e2bcd8739ae039 = $af3cd8bd77342c6a$var$Input;


/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $emuQy = parcelRequire("emuQy");

var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");





function $75dbb8f78ee65245$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $8901fc92b5563702$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $75dbb8f78ee65245$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ 
const $f56410848bcbe11b$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $f56410848bcbe11b$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $f56410848bcbe11b$export$803cd8101b6c182b = /*#__PURE__*/ $f56410848bcbe11b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $f56410848bcbe11b$export$27b07d8a310ed8b5[0], side + "-" + $f56410848bcbe11b$export$27b07d8a310ed8b5[1]), []);
const $f56410848bcbe11b$export$96ec731ed4dcb222 = Math.min;
const $f56410848bcbe11b$export$8960430cfd85939f = Math.max;
const $f56410848bcbe11b$export$2077e0241d6afd3c = Math.round;
const $f56410848bcbe11b$export$a3fe094919f356fd = Math.floor;
const $f56410848bcbe11b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $f56410848bcbe11b$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $f56410848bcbe11b$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $f56410848bcbe11b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $f56410848bcbe11b$export$8960430cfd85939f(start, $f56410848bcbe11b$export$96ec731ed4dcb222(value, end));
}
function $f56410848bcbe11b$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $f56410848bcbe11b$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $f56410848bcbe11b$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $f56410848bcbe11b$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $f56410848bcbe11b$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $f56410848bcbe11b$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($f56410848bcbe11b$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $f56410848bcbe11b$export$2b57e0052a6d6d4c(placement) {
    return $f56410848bcbe11b$export$8a000a963141ac32($f56410848bcbe11b$export$f28e8f882010718a(placement));
}
function $f56410848bcbe11b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $f56410848bcbe11b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $f56410848bcbe11b$export$2b57e0052a6d6d4c(placement);
    const length = $f56410848bcbe11b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $f56410848bcbe11b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $f56410848bcbe11b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $f56410848bcbe11b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $f56410848bcbe11b$export$9c5e28bad23365fa(placement);
    return [
        $f56410848bcbe11b$export$2b182c584985588b(placement),
        oppositePlacement,
        $f56410848bcbe11b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $f56410848bcbe11b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$f56410848bcbe11b$var$oppositeAlignmentMap[alignment]);
}
function $f56410848bcbe11b$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $f56410848bcbe11b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $f56410848bcbe11b$export$f0989780f32bfcda(placement);
    let list = $f56410848bcbe11b$var$getSideList($f56410848bcbe11b$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($f56410848bcbe11b$export$2b182c584985588b));
    }
    return list;
}
function $f56410848bcbe11b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$f56410848bcbe11b$var$oppositeSideMap[side]);
}
function $f56410848bcbe11b$export$1c66dbf1a9e34223(padding) {
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $f56410848bcbe11b$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $f56410848bcbe11b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $f56410848bcbe11b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $b8d321edac7a7d95$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $f56410848bcbe11b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $f56410848bcbe11b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $b8d321edac7a7d95$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $b8d321edac7a7d95$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, middlewareData), {
            [name]: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, middlewareData[name], data)
        });
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $b8d321edac7a7d95$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $b8d321edac7a7d95$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $f56410848bcbe11b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $b8d321edac7a7d95$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $f56410848bcbe11b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $f56410848bcbe11b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $f56410848bcbe11b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $f56410848bcbe11b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset
                }, shouldAddOffset && {
                    alignmentOffset: alignmentOffset
                }),
                reset: shouldAddOffset
            };
        }
    });
function $b8d321edac7a7d95$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $f56410848bcbe11b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $b8d321edac7a7d95$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $f56410848bcbe11b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "crossAxis",
                "alignment",
                "allowedPlacements",
                "autoAlignment"
            ]);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $f56410848bcbe11b$export$803cd8101b6c182b) ? $b8d321edac7a7d95$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $f56410848bcbe11b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $f56410848bcbe11b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $f56410848bcbe11b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $f56410848bcbe11b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $b8d321edac7a7d95$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $f56410848bcbe11b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $f56410848bcbe11b$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $f56410848bcbe11b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $f56410848bcbe11b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $b8d321edac7a7d95$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $b8d321edac7a7d95$var$isAnySideFullyClipped(overflow) {
    return (0, $f56410848bcbe11b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $b8d321edac7a7d95$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { strategy: strategy = 'referenceHidden' } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "strategy"
            ]);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, detectOverflowOptions), {
                            elementContext: 'reference'
                        }));
                        const offsets = $b8d321edac7a7d95$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $b8d321edac7a7d95$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, detectOverflowOptions), {
                            altBoundary: true
                        }));
                        const offsets = $b8d321edac7a7d95$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $b8d321edac7a7d95$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $b8d321edac7a7d95$var$getBoundingRect(rects) {
    const minX = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $f56410848bcbe11b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $f56410848bcbe11b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $b8d321edac7a7d95$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $f56410848bcbe11b$export$ee05aea0aeecbad4)($b8d321edac7a7d95$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $b8d321edac7a7d95$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $b8d321edac7a7d95$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)($b8d321edac7a7d95$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $f56410848bcbe11b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $f56410848bcbe11b$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $f56410848bcbe11b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $b8d321edac7a7d95$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $b8d321edac7a7d95$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $b8d321edac7a7d95$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, diffCoords), {
                    placement: placement
                })
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $b8d321edac7a7d95$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)((0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $f56410848bcbe11b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $f56410848bcbe11b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $f56410848bcbe11b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            }));
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, limitedCoords), {
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            });
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $b8d321edac7a7d95$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $f56410848bcbe11b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $b8d321edac7a7d95$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { apply: apply = ()=>{} } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "apply"
            ]);
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                availableWidth: availableWidth,
                availableHeight: availableHeight
            }));
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $d0eb1ce7e5ffa070$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $d0eb1ce7e5ffa070$export$651544f548703224(node) {
    if ($d0eb1ce7e5ffa070$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $d0eb1ce7e5ffa070$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($d0eb1ce7e5ffa070$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $d0eb1ce7e5ffa070$export$8ee0fc9ee280b4ee(value) {
    if (!$d0eb1ce7e5ffa070$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).Node;
}
function $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d(value) {
    if (!$d0eb1ce7e5ffa070$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).Element;
}
function $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa(value) {
    if (!$d0eb1ce7e5ffa070$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).HTMLElement;
}
function $d0eb1ce7e5ffa070$export$af51f0f06c0f328a(value) {
    if (!$d0eb1ce7e5ffa070$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $d0eb1ce7e5ffa070$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $d0eb1ce7e5ffa070$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $d0eb1ce7e5ffa070$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($d0eb1ce7e5ffa070$export$651544f548703224(element));
}
function $d0eb1ce7e5ffa070$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $d0eb1ce7e5ffa070$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $d0eb1ce7e5ffa070$export$78551043582a6a98();
    const css = $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d(elementOrCss) ? $d0eb1ce7e5ffa070$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $d0eb1ce7e5ffa070$export$940d8225183e1404(element) {
    let currentNode = $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(element);
    while($d0eb1ce7e5ffa070$export$1b3bfaa9684536aa(currentNode) && !$d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51(currentNode)){
        if ($d0eb1ce7e5ffa070$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($d0eb1ce7e5ffa070$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $d0eb1ce7e5ffa070$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($d0eb1ce7e5ffa070$export$651544f548703224(node));
}
function $d0eb1ce7e5ffa070$export$3735103072e4a80(element) {
    return $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $d0eb1ce7e5ffa070$export$dc8fc79fa2800137(element) {
    if ($d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(node) {
    if ($d0eb1ce7e5ffa070$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $d0eb1ce7e5ffa070$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $d0eb1ce7e5ffa070$export$e495491855dc5418(node);
    return $d0eb1ce7e5ffa070$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $d0eb1ce7e5ffa070$export$7cd01a57c8ca906c(node) {
    const parentNode = $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(node);
    if ($d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($d0eb1ce7e5ffa070$export$1b3bfaa9684536aa(parentNode) && $d0eb1ce7e5ffa070$export$989e911fa9af580a(parentNode)) return parentNode;
    return $d0eb1ce7e5ffa070$export$7cd01a57c8ca906c(parentNode);
}
function $d0eb1ce7e5ffa070$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $d0eb1ce7e5ffa070$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $d0eb1ce7e5ffa070$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $d0eb1ce7e5ffa070$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $d0eb1ce7e5ffa070$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $d0eb1ce7e5ffa070$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $d0eb1ce7e5ffa070$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $28b5c677ea6a5d8a$var$getCssDimensions(element) {
    const css = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $28b5c677ea6a5d8a$var$unwrapElement(element) {
    return !(0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $28b5c677ea6a5d8a$var$getScale(element) {
    const domElement = $28b5c677ea6a5d8a$var$unwrapElement(element);
    if (!(0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(domElement)) return (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $28b5c677ea6a5d8a$var$getCssDimensions(domElement);
    let x = ($ ? (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $28b5c677ea6a5d8a$var$noOffsets = /*#__PURE__*/ (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
function $28b5c677ea6a5d8a$var$getVisualOffsets(element) {
    const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element);
    if (!(0, $d0eb1ce7e5ffa070$export$78551043582a6a98)() || !win.visualViewport) return $28b5c677ea6a5d8a$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $28b5c677ea6a5d8a$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $28b5c677ea6a5d8a$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $28b5c677ea6a5d8a$var$unwrapElement(element);
    let scale = (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(offsetParent)) scale = $28b5c677ea6a5d8a$var$getScale(offsetParent);
        } else scale = $28b5c677ea6a5d8a$var$getScale(element);
    }
    const visualOffsets = $28b5c677ea6a5d8a$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $28b5c677ea6a5d8a$var$getVisualOffsets(domElement) : (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $d0eb1ce7e5ffa070$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $28b5c677ea6a5d8a$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $d0eb1ce7e5ffa070$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $28b5c677ea6a5d8a$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $28b5c677ea6a5d8a$var$getBoundingClientRect((0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $28b5c677ea6a5d8a$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $28b5c677ea6a5d8a$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $28b5c677ea6a5d8a$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $d0eb1ce7e5ffa070$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    const offsets = (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d0eb1ce7e5ffa070$export$651544f548703224)(offsetParent) !== 'body' || (0, $d0eb1ce7e5ffa070$export$989e911fa9af580a)(documentElement)) scroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(offsetParent);
            scale = $28b5c677ea6a5d8a$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $28b5c677ea6a5d8a$var$getHTMLOffset(documentElement, scroll, true) : (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $28b5c677ea6a5d8a$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $28b5c677ea6a5d8a$var$getDocumentRect(element) {
    const html = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element);
    const scroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $f56410848bcbe11b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $f56410848bcbe11b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $28b5c677ea6a5d8a$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $f56410848bcbe11b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $28b5c677ea6a5d8a$var$getViewportRect(element, strategy) {
    const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element);
    const html = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $d0eb1ce7e5ffa070$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $28b5c677ea6a5d8a$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element) ? $28b5c677ea6a5d8a$var$getScale(element) : (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $28b5c677ea6a5d8a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $28b5c677ea6a5d8a$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $28b5c677ea6a5d8a$var$getDocumentRect((0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element));
    else if ((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $28b5c677ea6a5d8a$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $28b5c677ea6a5d8a$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)(rect);
}
function $28b5c677ea6a5d8a$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(parentNode) || (0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(parentNode).position === 'fixed' || $28b5c677ea6a5d8a$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $28b5c677ea6a5d8a$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $d0eb1ce7e5ffa070$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(el) && (0, $d0eb1ce7e5ffa070$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(currentNode) && !(0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $d0eb1ce7e5ffa070$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $d0eb1ce7e5ffa070$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $28b5c677ea6a5d8a$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $28b5c677ea6a5d8a$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $d0eb1ce7e5ffa070$export$89e651af02346cd4)(element) ? [] : $28b5c677ea6a5d8a$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $28b5c677ea6a5d8a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $f56410848bcbe11b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $f56410848bcbe11b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $28b5c677ea6a5d8a$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $28b5c677ea6a5d8a$var$getDimensions(element) {
    const { width: width, height: height } = $28b5c677ea6a5d8a$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $28b5c677ea6a5d8a$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $28b5c677ea6a5d8a$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d0eb1ce7e5ffa070$export$651544f548703224)(offsetParent) !== 'body' || (0, $d0eb1ce7e5ffa070$export$989e911fa9af580a)(documentElement)) scroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $28b5c677ea6a5d8a$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $28b5c677ea6a5d8a$var$getHTMLOffset(documentElement, scroll) : (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $28b5c677ea6a5d8a$var$isStaticPositioned(element) {
    return (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).position === 'static';
}
function $28b5c677ea6a5d8a$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element) || (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $28b5c677ea6a5d8a$var$getOffsetParent(element, polyfill) {
    const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element);
    if ((0, $d0eb1ce7e5ffa070$export$89e651af02346cd4)(element)) return win;
    if (!(0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$28b5c677ea6a5d8a$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $28b5c677ea6a5d8a$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $d0eb1ce7e5ffa070$export$71535ffaa902797f)(offsetParent) && $28b5c677ea6a5d8a$var$isStaticPositioned(offsetParent))offsetParent = $28b5c677ea6a5d8a$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(offsetParent) && $28b5c677ea6a5d8a$var$isStaticPositioned(offsetParent) && !(0, $d0eb1ce7e5ffa070$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $d0eb1ce7e5ffa070$export$940d8225183e1404)(element) || win;
}
const $28b5c677ea6a5d8a$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $28b5c677ea6a5d8a$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $28b5c677ea6a5d8a$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $28b5c677ea6a5d8a$var$isRTL(element) {
    return (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).direction === 'rtl';
}
const $28b5c677ea6a5d8a$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $28b5c677ea6a5d8a$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $d0eb1ce7e5ffa070$export$e495491855dc5418,
    getClippingRect: $28b5c677ea6a5d8a$var$getClippingRect,
    getOffsetParent: $28b5c677ea6a5d8a$var$getOffsetParent,
    getElementRects: $28b5c677ea6a5d8a$var$getElementRects,
    getClientRects: $28b5c677ea6a5d8a$var$getClientRects,
    getDimensions: $28b5c677ea6a5d8a$var$getDimensions,
    getScale: $28b5c677ea6a5d8a$var$getScale,
    isElement: $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d,
    isRTL: $28b5c677ea6a5d8a$var$isRTL
};
function $28b5c677ea6a5d8a$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $28b5c677ea6a5d8a$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $f56410848bcbe11b$export$8960430cfd85939f)(0, (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$28b5c677ea6a5d8a$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $28b5c677ea6a5d8a$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $28b5c677ea6a5d8a$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $d0eb1ce7e5ffa070$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $d0eb1ce7e5ffa070$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $28b5c677ea6a5d8a$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $28b5c677ea6a5d8a$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(reference);
        if (prevRefRect && !$28b5c677ea6a5d8a$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $28b5c677ea6a5d8a$export$37b6bde19b108ecc = (0, $b8d321edac7a7d95$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $28b5c677ea6a5d8a$export$cc800923e997bb8 = (0, $b8d321edac7a7d95$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $28b5c677ea6a5d8a$export$91fb6ecbd551914 = (0, $b8d321edac7a7d95$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $28b5c677ea6a5d8a$export$fba63a578e423eb = (0, $b8d321edac7a7d95$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $28b5c677ea6a5d8a$export$8a83211c878a3f1f = (0, $b8d321edac7a7d95$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $28b5c677ea6a5d8a$export$346677f925de839c = (0, $b8d321edac7a7d95$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $28b5c677ea6a5d8a$export$fe8985bb6374093c = (0, $b8d321edac7a7d95$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $28b5c677ea6a5d8a$export$f2120bbfa5450bd2 = (0, $b8d321edac7a7d95$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $28b5c677ea6a5d8a$export$18c8ad048e32c7d5 = (0, $b8d321edac7a7d95$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $28b5c677ea6a5d8a$export$7bf07e38f3dc4b69 = (0, $b8d321edac7a7d95$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $28b5c677ea6a5d8a$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        platform: $28b5c677ea6a5d8a$export$722a64dea1b767dc
    }, options);
    const platformWithCache = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, $b8d321edac7a7d95$export$48a53dcb22e581d0)(reference, floating, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, mergedOptions), {
        platform: platformWithCache
    }));
};




var $7fPBF = parcelRequire("7fPBF");
var $e93368a04bf55514$export$2e2bcd8739ae039 = (0, $7fPBF.useLayoutEffect);


/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $80ee8fc99f5202eb$var$isProduction = true;
var $80ee8fc99f5202eb$var$prefix = 'Invariant failed';
function $80ee8fc99f5202eb$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($80ee8fc99f5202eb$var$isProduction) throw new Error($80ee8fc99f5202eb$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($80ee8fc99f5202eb$var$prefix, ": ").concat(provided) : $80ee8fc99f5202eb$var$prefix;
    throw new Error(value);
}



var $7fPBF = parcelRequire("7fPBF");
var $047c63fd47a9d222$var$HasTextAncestorContext = /*#__PURE__*/ (0, $7fPBF.createContext)(false);
var $047c63fd47a9d222$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $7fPBF.useContext)($047c63fd47a9d222$var$HasTextAncestorContext);
};
var $047c63fd47a9d222$export$ae933c6cbe5643ad = $047c63fd47a9d222$var$HasTextAncestorContext.Provider;



var $7fPBF = parcelRequire("7fPBF");
var $bd8fd1a07ee559ec$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $bd8fd1a07ee559ec$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($bd8fd1a07ee559ec$export$1ca2a26fecb070ae);
};
$bd8fd1a07ee559ec$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $21f3a93bd506b741$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $21f3a93bd506b741$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $bd8fd1a07ee559ec$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($21f3a93bd506b741$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $21f3a93bd506b741$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $21f3a93bd506b741$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pmoej",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $21f3a93bd506b741$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $21f3a93bd506b741$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $21f3a93bd506b741$var$textColorMap = {
    'color.text': "_syaz1fxt",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syaz1q28",
    'color.text.accent.orange.bolder': "_syaz1vps",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syazpnps",
    'color.text.accent.blue.bolder': "_syazsc1o",
    'color.text.accent.purple': "_syaz10m5",
    'color.text.accent.purple.bolder': "_syaz2ibx",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1dyx",
    'color.text.accent.gray.bolder': "_syaz1x9z",
    'color.text.disabled': "_syaz1lh4",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syazaqb7",
    'color.text.brand': "_syaz1e6v",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syazwx40",
    'color.text.warning.inverse': "_syazal3n",
    'color.text.success': "_syazy73q",
    'color.text.discovery': "_syazzjem",
    'color.text.information': "_syaze0os",
    'color.text.subtlest': "_syaz131l",
    'color.text.subtle': "_syaz1gjq",
    'color.link': "_syaz14q2",
    'color.link.pressed': "_syaz16c2",
    'color.link.visited': "_syazw7te",
    'color.link.visited.pressed': "_syazg3x0"
};
var $21f3a93bd506b741$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $21f3a93bd506b741$var$Text = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)($21f3a93bd506b741$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $047c63fd47a9d222$export$9322276ec105d055)();
    var color = $21f3a93bd506b741$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $7fPBF.createElement(Component, {
        id: id,
        className: (0, $ca1b8a586a841420$export$2e2bcd8739ae039)([
            $21f3a93bd506b741$var$styles.root,
            size && $21f3a93bd506b741$var$fontSizeMap[size],
            color && $21f3a93bd506b741$var$textColorMap[color],
            maxLines && $21f3a93bd506b741$var$styles.truncation,
            maxLines === 1 && $21f3a93bd506b741$var$styles.breakAll,
            align && $21f3a93bd506b741$var$styles["textAlign.".concat(align)],
            weight && $21f3a93bd506b741$var$fontWeightMap[weight],
            Component === 'em' && $21f3a93bd506b741$var$styles['as.em'],
            Component === 'strong' && $21f3a93bd506b741$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $7fPBF.createElement((0, $047c63fd47a9d222$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $21f3a93bd506b741$export$2e2bcd8739ae039 = $21f3a93bd506b741$var$Text;



var $701943b1660eb776$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
], $701943b1660eb776$var$_excluded2 = [
    "children",
    "innerProps",
    "xcss"
];
function $701943b1660eb776$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $701943b1660eb776$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $701943b1660eb776$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $701943b1660eb776$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Menu
// ==============================
// Get Menu Placement
// ------------------------------
function $701943b1660eb776$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = (0, $c3eea1c9ec58844c$export$cfa2225e87938781)(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : (0, $c3eea1c9ec58844c$export$2e0654fad740d2e4)(scrollParent);
    var scrollTop = (0, $c3eea1c9ec58844c$export$c4a223a8ba9e4ea5)(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $c3eea1c9ec58844c$export$858c30343199f3af)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $c3eea1c9ec58844c$export$858c30343199f3af)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $c3eea1c9ec58844c$export$3f99968195accfaf)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $c3eea1c9ec58844c$export$858c30343199f3af)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $c3eea1c9ec58844c$export$858c30343199f3af)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
var $701943b1660eb776$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $701943b1660eb776$var$menuStyles = {
    root: "_2rkoglpi _kqswstnw _1bsb1osq _1pbykb7n _otyru2gc _19pku2gc _bfhk1bhr _16qsd0yg",
    bottom: "_154i1osq",
    top: "_94n51osq"
};
var $701943b1660eb776$export$a228922d5ca42a79 = function menuCSS() {
    return {};
};
var $701943b1660eb776$var$PortalPlacementContext = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
var $701943b1660eb776$export$f32337f3a7617699 = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $7fPBF.useContext)($701943b1660eb776$var$PortalPlacementContext) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)(maxMenuHeight), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $e93368a04bf55514$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $701943b1660eb776$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $701943b1660eb776$var$_objectSpread($701943b1660eb776$var$_objectSpread({}, props), {}, {
            placement: placement || $701943b1660eb776$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $701943b1660eb776$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $701943b1660eb776$var$menuStyles.root,
            $701943b1660eb776$var$menuStyles[placement],
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$701943b1660eb776$export$2e2bcd8739ae039 = $701943b1660eb776$var$Menu;
var $701943b1660eb776$export$abafed69cff95d5e = function menuListCSS() {
    return {};
};
var $701943b1660eb776$var$menuListStyles = null;
var $701943b1660eb776$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps2 = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-MenuList')
        ]),
        style: $701943b1660eb776$var$_objectSpread($701943b1660eb776$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
// ==============================
// Menu Notices
// ==============================
var $701943b1660eb776$var$noticeCSS = function noticeCSS() {
    return {};
};
var $701943b1660eb776$var$noticeStyles = null;
var $701943b1660eb776$export$cf0e22534d8b0074 = $701943b1660eb776$var$noticeCSS;
var $701943b1660eb776$export$98ec46397a8cb3cd = $701943b1660eb776$var$noticeCSS;
var $701943b1660eb776$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref3) {
    var _ref3$children = _ref3.children, children = _ref3$children === void 0 ? 'No options' : _ref3$children, innerProps = _ref3.innerProps, xcss = _ref3.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref3, $701943b1660eb776$var$_excluded);
    var _getStyleProps3 = (0, $c3eea1c9ec58844c$export$26417cabd806a658)($701943b1660eb776$var$_objectSpread($701943b1660eb776$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $7fPBF.createElement((0, $21f3a93bd506b741$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};
var $701943b1660eb776$export$e928a71d039d3102 = function LoadingMessage(_ref4) {
    var _ref4$children = _ref4.children, children = _ref4$children === void 0 ? 'Loading...' : _ref4$children, innerProps = _ref4.innerProps, xcss = _ref4.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref4, $701943b1660eb776$var$_excluded2);
    var _getStyleProps4 = (0, $c3eea1c9ec58844c$export$26417cabd806a658)($701943b1660eb776$var$_objectSpread($701943b1660eb776$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps4.css, className = _getStyleProps4.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $7fPBF.createElement((0, $21f3a93bd506b741$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};
var $701943b1660eb776$export$1dbbeb9648d1fdc9 = function menuPortalCSS() {
    return {};
};
var $701943b1660eb776$var$menuPortalStyles = {
    root: "_1pbykb7n _1ltva1vk _kqswcp1v _154i1nmo _1bsb1qxj"
};
var $701943b1660eb776$export$793392f970497feb = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $7fPBF.useRef)(null);
    var cleanupRef = (0, $7fPBF.useRef)(null);
    var _useState5 = (0, $7fPBF.useState)($701943b1660eb776$var$coercePlacement(menuPlacement)), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $7fPBF.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $7fPBF.useState)(null), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $7fPBF.useCallback)(function() {
        if (!controlElement) return;
        var rect = (0, $c3eea1c9ec58844c$export$7807c2a424c2f6d1)(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $e93368a04bf55514$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $7fPBF.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $28b5c677ea6a5d8a$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $e93368a04bf55514$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $7fPBF.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps5 = (0, $c3eea1c9ec58844c$export$26417cabd806a658)($701943b1660eb776$var$_objectSpread($701943b1660eb776$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps5.css, className = _getStyleProps5.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $701943b1660eb776$var$menuPortalStyles.root,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $701943b1660eb776$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $7fPBF.createElement($701943b1660eb776$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $b4ba1c853f6e1116$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};


/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8MJe2 = parcelRequire("8MJe2");

var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

var $0fb0264f42f6755f$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::85cb292de644104b34b7dd23f5bdf435>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($0fb0264f42f6755f$exports, "__esModule", {
    value: true
});
$0fb0264f42f6755f$exports.default = void 0;

var $0fb0264f42f6755f$var$_react = $0fb0264f42f6755f$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $0fb0264f42f6755f$var$_baseNew = $0fb0264f42f6755f$var$_interopRequireDefault((parcelRequire("aUDbt")));
function $0fb0264f42f6755f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0fb0264f42f6755f$var$CrossIcon = (props)=>/*#__PURE__*/ $0fb0264f42f6755f$var$_react.default.createElement($0fb0264f42f6755f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$0fb0264f42f6755f$var$CrossIcon.displayName = 'CrossIcon';
var $0fb0264f42f6755f$var$_default = $0fb0264f42f6755f$exports.default = $0fb0264f42f6755f$var$CrossIcon;



var $dWyuK = parcelRequire("dWyuK");

var $137Lh = parcelRequire("137Lh");

function $e7fd529649ea4ccc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e7fd529649ea4ccc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e7fd529649ea4ccc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e7fd529649ea4ccc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e7fd529649ea4ccc$var$multiValueStyles = {
    root: "_2rkogqwt _1e0c1txw _1ul9ze3t _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _bfhkm7j4 _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1lh4 _bfhkm7j4",
    focused: "_syaz1wum _bfhkfg4m _16qs7ex6 _1aewe4h9 _6up51j28 _1xdnnqa1",
    refresh: "_2rkoiti9 _1h6d14je _1dqonqa1 _189ee4h9 _bfhk1j9a"
};
var $e7fd529649ea4ccc$export$23c213f7717186af = function multiValueCSS() {
    return {};
};
var $e7fd529649ea4ccc$export$f40612612e0af964 = function multiValueLabelCSS() {
    return {};
};
var $e7fd529649ea4ccc$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkogqwt _11c8dcr7 _o5721q9c _ca0qv77o _u5f3v77o _n3tdv77o _19bv12x7 _syaz1kw7",
    disabled: "_syaz1lh4",
    ellipsis: "_1bto1l2s",
    refresh: "_11c82smr _ca0qidpf _n3tdidpf _19bv1b66"
};
var $e7fd529649ea4ccc$export$283467f6c4ac142b = function multiValueRemoveCSS() {
    return {};
};
var $e7fd529649ea4ccc$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu1rrc",
    root: "_2rkovtp2 _4cvr1h6o _1e0c1txw _lswu1dx5 _19bvv77o _u5f3v77o _irr31yvi _13br1jjn _1di61io2 _i5f81jjn",
    refresh: "_19itglyw _2rkoglpi _bfhksm61 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _syaz1fxt _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _2hwxv77o _1ah312gs _irr3166n _1di61dty"
};
var $e7fd529649ea4ccc$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $e7fd529649ea4ccc$var$multiValueStyles.root,
            isDisabled && $e7fd529649ea4ccc$var$multiValueStyles.disabled,
            isFocused && $e7fd529649ea4ccc$var$multiValueStyles.focused,
            (0, $137Lh.fg)('platform-component-visual-refresh') && $e7fd529649ea4ccc$var$multiValueStyles.refresh,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-multiValue')
        ])
    }), children);
};
var $e7fd529649ea4ccc$export$544aeea2a5ce08ee = function MultiValueLabel(_ref2) {
    var children = _ref2.children, innerProps = _ref2.innerProps, isDisabled = _ref2.isDisabled, hasEllipsis = _ref2.hasEllipsis, className = _ref2.className, xcss = _ref2.xcss;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $e7fd529649ea4ccc$var$multiValueLabelStyles.root,
            isDisabled && $e7fd529649ea4ccc$var$multiValueLabelStyles.disabled,
            hasEllipsis && $e7fd529649ea4ccc$var$multiValueLabelStyles.ellipsis,
            (0, $137Lh.fg)('platform-component-visual-refresh') && $e7fd529649ea4ccc$var$multiValueLabelStyles.refresh,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};
var $e7fd529649ea4ccc$var$disabledStyles = null;
var $e7fd529649ea4ccc$var$enabledStyles = null;
function $e7fd529649ea4ccc$export$8e1fd1a40e7a2f4a(_ref3) {
    var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, innerProps = _ref3.innerProps, className = _ref3.className, xcss = _ref3.xcss;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $e7fd529649ea4ccc$var$multiValueRemoveStyles.root,
            isFocused && $e7fd529649ea4ccc$var$multiValueRemoveStyles.focused,
            (0, $137Lh.fg)('platform-component-visual-refresh') && $e7fd529649ea4ccc$var$multiValueRemoveStyles.refresh,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $7fPBF.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $fjFkG.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, (/*@__PURE__*/$parcel$interopDefault($0fb0264f42f6755f$exports))), {
        label: "",
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($dWyuK))),
        LEGACY_primaryColor: "transparent",
        LEGACY_secondaryColor: "inherit",
        LEGACY_size: "small",
        size: "small"
    })));
}
var $e7fd529649ea4ccc$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var ariaLabel = typeof children === 'string' ? children : data.label;
    var _getStyleProps = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    return /*#__PURE__*/ $7fPBF.createElement(Container, {
        data: data,
        innerProps: $e7fd529649ea4ccc$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $7fPBF.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $7fPBF.createElement(Remove, {
        data: data,
        innerProps: $e7fd529649ea4ccc$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(ariaLabel || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e7fd529649ea4ccc$export$2e2bcd8739ae039 = $e7fd529649ea4ccc$var$MultiValue;


/* option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $6966aa68e6cc290a$export$ef897119b7e920ba = function optionCSS() {
    return {};
};
var $6966aa68e6cc290a$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syaz1fxt _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di61dty",
    disabled: "_syaz1lh4 _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _1pknglyw",
    focused: "_bfhk166n _16qsu4to _1pkn1vrj",
    selected: "_syazaqb7 _bfhkfg4m _16qsu4to _1di619ru _1pkn1vrj",
    focusedSelected: "_bfhki1yw"
};
var $6966aa68e6cc290a$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $6966aa68e6cc290a$var$optionStyles.root,
            isFocused && $6966aa68e6cc290a$var$optionStyles.focused,
            isSelected && $6966aa68e6cc290a$var$optionStyles.selected,
            isFocused && isSelected && $6966aa68e6cc290a$var$optionStyles.focusedSelected,
            isDisabled && $6966aa68e6cc290a$var$optionStyles.disabled,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6966aa68e6cc290a$export$2e2bcd8739ae039 = $6966aa68e6cc290a$var$Option;


/* placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $35c8ae659c390b04$export$5f3ffacd6594d90f = function placeholderCSS() {
    return {};
};
var $35c8ae659c390b04$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz131l",
    disabled: "_syaz1lh4"
};
var $35c8ae659c390b04$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $35c8ae659c390b04$var$placeholderStyles.root,
            isDisabled && $35c8ae659c390b04$var$placeholderStyles.disabled,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$35c8ae659c390b04$export$2e2bcd8739ae039 = $35c8ae659c390b04$var$Placeholder;


/* single-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $f84debfada15a9f2$export$dbf350e5966cf602 = function css() {
    return {};
};
var $f84debfada15a9f2$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1fxt",
    disalbed: "_syaz1lh4"
};
var $f84debfada15a9f2$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $c3eea1c9ec58844c$export$26417cabd806a658)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $f84debfada15a9f2$var$styles.root,
            isDisabled && $f84debfada15a9f2$var$styles.disalbed,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f84debfada15a9f2$export$2e2bcd8739ae039 = $f84debfada15a9f2$var$SingleValue;


function $3b7b7f3751a34714$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b7b7f3751a34714$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b7b7f3751a34714$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b7b7f3751a34714$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b7b7f3751a34714$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $124ff7c12cb207ae$export$ecf9cf59142dd54a),
    Control: (0, $8665919ac4a0fd0c$export$2e2bcd8739ae039),
    DropdownIndicator: (0, $124ff7c12cb207ae$export$ec98719d3db7f2e4),
    Group: (0, $d83249d96f66c520$export$2e2bcd8739ae039),
    GroupHeading: (0, $d83249d96f66c520$export$85c8b41a3cd87edc),
    IndicatorsContainer: (0, $ffac923ac68814d3$export$d0ffd7e649cab6f),
    Input: (0, $af3cd8bd77342c6a$export$2e2bcd8739ae039),
    LoadingIndicator: (0, $124ff7c12cb207ae$export$7c20be4c1d342248),
    Menu: (0, $701943b1660eb776$export$2e2bcd8739ae039),
    MenuList: (0, $701943b1660eb776$export$d4c4e98c5044dc8),
    MenuPortal: (0, $701943b1660eb776$export$793392f970497feb),
    LoadingMessage: (0, $701943b1660eb776$export$e928a71d039d3102),
    NoOptionsMessage: (0, $701943b1660eb776$export$d58b72b7d3c4072c),
    MultiValue: (0, $e7fd529649ea4ccc$export$2e2bcd8739ae039),
    MultiValueContainer: (0, $e7fd529649ea4ccc$export$cf9cf2a30a59265c),
    MultiValueLabel: (0, $e7fd529649ea4ccc$export$544aeea2a5ce08ee),
    MultiValueRemove: (0, $e7fd529649ea4ccc$export$8e1fd1a40e7a2f4a),
    Option: (0, $6966aa68e6cc290a$export$2e2bcd8739ae039),
    Placeholder: (0, $35c8ae659c390b04$export$2e2bcd8739ae039),
    SelectContainer: (0, $ffac923ac68814d3$export$446eebadefe1123b),
    SingleValue: (0, $f84debfada15a9f2$export$2e2bcd8739ae039),
    ValueContainer: (0, $ffac923ac68814d3$export$4dc9f58ad9a1a000)
};
var $3b7b7f3751a34714$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $3b7b7f3751a34714$var$_objectSpread($3b7b7f3751a34714$var$_objectSpread({}, $3b7b7f3751a34714$export$9b5ac10f59f76296), props.components);
};


/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

var $f5b0d27774fa8135$var$_excluded = [
    "innerRef"
];
var $f5b0d27774fa8135$var$dummyInputStyles = null;
function $f5b0d27774fa8135$export$2e2bcd8739ae039(_ref) {
    var innerRef = _ref.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $f5b0d27774fa8135$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $c3eea1c9ec58844c$export$4213b25a1c4e877)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $7fPBF.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        ref: innerRef,
        className: (0, $fjFkG.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}

/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");
/**
 * An empty function which does nothing.
 */ function $fa2b89d216be3a70$export$2e2bcd8739ae039() {}


var $02a052b7c504f468$var$styles = null;
var $02a052b7c504f468$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $7fPBF.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $fjFkG.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _jqf61a21 _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $fa2b89d216be3a70$export$2e2bcd8739ae039)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$02a052b7c504f468$export$2e2bcd8739ae039 = $02a052b7c504f468$var$RequiredInput;


var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $5001a68470a4acc3$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $5001a68470a4acc3$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $7fPBF.useRef)(false);
    var isTop = (0, $7fPBF.useRef)(false);
    var touchStart = (0, $7fPBF.useRef)(0);
    var scrollTarget = (0, $7fPBF.useRef)(null);
    var handleEventDelta = (0, $7fPBF.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $5001a68470a4acc3$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $7fPBF.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $7fPBF.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $7fPBF.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $7fPBF.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $c3eea1c9ec58844c$export$b0622a6911dbeaf5) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $7fPBF.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}



var $7fPBF = parcelRequire("7fPBF");
var $d9070e9625bbb31c$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $d9070e9625bbb31c$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $d9070e9625bbb31c$var$preventTouchMove(e) {
    e.preventDefault();
}
function $d9070e9625bbb31c$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $d9070e9625bbb31c$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $d9070e9625bbb31c$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $d9070e9625bbb31c$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $d9070e9625bbb31c$var$activeScrollLocks = 0;
var $d9070e9625bbb31c$var$listenerOptions = {
    capture: false,
    passive: false
};
function $d9070e9625bbb31c$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $7fPBF.useRef)({});
    var scrollTarget = (0, $7fPBF.useRef)(null);
    var addScrollLock = (0, $7fPBF.useCallback)(function(touchScrollTarget) {
        if (!$d9070e9625bbb31c$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $d9070e9625bbb31c$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $d9070e9625bbb31c$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($d9070e9625bbb31c$var$LOCK_STYLES).forEach(function(key) {
                var val = $d9070e9625bbb31c$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $d9070e9625bbb31c$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $d9070e9625bbb31c$var$preventTouchMove, $d9070e9625bbb31c$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $d9070e9625bbb31c$var$preventInertiaScroll, $d9070e9625bbb31c$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $d9070e9625bbb31c$var$allowTouchMove, $d9070e9625bbb31c$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $d9070e9625bbb31c$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $7fPBF.useCallback)(function(touchScrollTarget) {
        if (!$d9070e9625bbb31c$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $d9070e9625bbb31c$var$activeScrollLocks = Math.max($d9070e9625bbb31c$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $d9070e9625bbb31c$var$activeScrollLocks < 1) $d9070e9625bbb31c$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $d9070e9625bbb31c$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $d9070e9625bbb31c$var$preventTouchMove, $d9070e9625bbb31c$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $d9070e9625bbb31c$var$preventInertiaScroll, $d9070e9625bbb31c$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $d9070e9625bbb31c$var$allowTouchMove, $d9070e9625bbb31c$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}


var $53f47bf228e2c17b$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $53f47bf228e2c17b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $5001a68470a4acc3$export$2e2bcd8739ae039)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $d9070e9625bbb31c$export$2e2bcd8739ae039)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        onClick: $53f47bf228e2c17b$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $a11b2f5cc98a750d$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $d325ee56965454b6$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


function $43314d593e5da9cc$export$1d57e79091cc3046() {
    var namespace = (0, $7fPBF.useContext)((0, $d325ee56965454b6$export$644a49f3b8c50fcd));
    return namespace;
}


function $e85233b93e6c09f0$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    var context = (0, $7fPBF.useContext)((0, $a11b2f5cc98a750d$export$5fbf4d7fae6cdc00));
    var namespace = (0, $43314d593e5da9cc$export$1d57e79091cc3046)();
    (0, $7fPBF.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}


function $fadc113176ef20dd$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    // @ts-ignore - hot-116676
    (0, $e85233b93e6c09f0$export$469bb693f11edc7f)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ var $3e80fd83f3ef2370$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? "option ".concat(label, ", deselected") : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : '';
            default:
                return '';
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : '';
    }
};


/* a11y-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");
// Assistive text to describe visual elements. Hidden for sighted users.
var $c4fab3b4a24ff190$var$styles = null;
var $c4fab3b4a24ff190$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $fjFkG.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _jqf6ydhy _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $c4fab3b4a24ff190$export$2e2bcd8739ae039 = $c4fab3b4a24ff190$var$A11yText;


function $f9ec643cf0e70261$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f9ec643cf0e70261$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f9ec643cf0e70261$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f9ec643cf0e70261$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $f9ec643cf0e70261$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $7fPBF.useMemo)(function() {
        return $f9ec643cf0e70261$var$_objectSpread($f9ec643cf0e70261$var$_objectSpread({}, (0, $3e80fd83f3ef2370$export$a7265767c78f9bae)), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $7fPBF.useMemo)(function() {
        var message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            var onChangeProps = $f9ec643cf0e70261$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $7fPBF.useMemo)(function() {
        var resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c4fab3b4a24ff190$export$2e2bcd8739ae039), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c4fab3b4a24ff190$export$2e2bcd8739ae039), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f9ec643cf0e70261$export$2e2bcd8739ae039 = $f9ec643cf0e70261$var$LiveRegion;




var $8MJe2 = parcelRequire("8MJe2");
var $859f0395401445ad$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $859f0395401445ad$var$isEqual(first, second) {
    if (first === second) return true;
    if ($859f0395401445ad$var$safeIsNaN(first) && $859f0395401445ad$var$safeIsNaN(second)) return true;
    return false;
}
function $859f0395401445ad$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$859f0395401445ad$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $859f0395401445ad$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $859f0395401445ad$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}


var $06939dd157d102ec$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $06939dd157d102ec$var$anyDiacritic = new RegExp('[' + $06939dd157d102ec$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $06939dd157d102ec$var$diacriticToBase = {};
for(var $06939dd157d102ec$var$i = 0; $06939dd157d102ec$var$i < $06939dd157d102ec$var$diacritics.length; $06939dd157d102ec$var$i++){
    var $06939dd157d102ec$var$diacritic = $06939dd157d102ec$var$diacritics[$06939dd157d102ec$var$i];
    for(var $06939dd157d102ec$var$j = 0; $06939dd157d102ec$var$j < $06939dd157d102ec$var$diacritic.letters.length; $06939dd157d102ec$var$j++)$06939dd157d102ec$var$diacriticToBase[$06939dd157d102ec$var$diacritic.letters[$06939dd157d102ec$var$j]] = $06939dd157d102ec$var$diacritic.base;
}
var $06939dd157d102ec$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($06939dd157d102ec$var$anyDiacritic, function(match) {
        return $06939dd157d102ec$var$diacriticToBase[match];
    });
};


function $186eac41796e35cc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $186eac41796e35cc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $186eac41796e35cc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $186eac41796e35cc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $186eac41796e35cc$var$memoizedStripDiacriticsForInput = (0, $859f0395401445ad$export$2e2bcd8739ae039)((0, $06939dd157d102ec$export$b5bee4b27048330b));
var $186eac41796e35cc$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $186eac41796e35cc$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $186eac41796e35cc$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $186eac41796e35cc$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $186eac41796e35cc$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $186eac41796e35cc$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $186eac41796e35cc$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $186eac41796e35cc$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $06939dd157d102ec$export$b5bee4b27048330b)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};



var $8MJe2 = parcelRequire("8MJe2");










function $5ea3581bad05c583$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5ea3581bad05c583$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5ea3581bad05c583$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5ea3581bad05c583$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5ea3581bad05c583$export$214b055320e0bf32 = {
    clearIndicator: (0, $124ff7c12cb207ae$export$9c0419fd944c1def),
    container: (0, $ffac923ac68814d3$export$949392aeaf7d2e3a),
    control: (0, $8665919ac4a0fd0c$export$dbf350e5966cf602),
    dropdownIndicator: (0, $124ff7c12cb207ae$export$e1687335805e1230),
    group: (0, $d83249d96f66c520$export$b6794329c1460634),
    groupHeading: (0, $d83249d96f66c520$export$e5a7fbb542efcb7d),
    indicatorsContainer: (0, $ffac923ac68814d3$export$9d74e3c8b5868ad7),
    input: (0, $af3cd8bd77342c6a$export$14a7781d0ca7abea),
    loadingIndicator: (0, $124ff7c12cb207ae$export$1d3f24cde248e6b5),
    loadingMessage: (0, $701943b1660eb776$export$98ec46397a8cb3cd),
    menu: (0, $701943b1660eb776$export$a228922d5ca42a79),
    menuList: (0, $701943b1660eb776$export$abafed69cff95d5e),
    menuPortal: (0, $701943b1660eb776$export$1dbbeb9648d1fdc9),
    multiValue: (0, $e7fd529649ea4ccc$export$23c213f7717186af),
    multiValueLabel: (0, $e7fd529649ea4ccc$export$f40612612e0af964),
    multiValueRemove: (0, $e7fd529649ea4ccc$export$283467f6c4ac142b),
    noOptionsMessage: (0, $701943b1660eb776$export$cf0e22534d8b0074),
    option: (0, $6966aa68e6cc290a$export$ef897119b7e920ba),
    placeholder: (0, $35c8ae659c390b04$export$5f3ffacd6594d90f),
    singleValue: (0, $f84debfada15a9f2$export$dbf350e5966cf602),
    valueContainer: (0, $ffac923ac68814d3$export$47aec73c7aa6b9aa)
};
function $5ea3581bad05c583$export$e618dc39ac9ad607(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = $5ea3581bad05c583$var$_objectSpread({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}



function $c647738a411ac32c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c647738a411ac32c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c647738a411ac32c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c647738a411ac32c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c647738a411ac32c$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $c647738a411ac32c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $c647738a411ac32c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c647738a411ac32c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c647738a411ac32c$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $c3eea1c9ec58844c$export$56963d77dbffdde7)(),
    captureMenuScroll: !(0, $c3eea1c9ec58844c$export$56963d77dbffdde7)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $186eac41796e35cc$export$5d81789ff4aeccdf)(),
    formatGroupLabel: (0, $b2afea94242257b8$export$f4da216a6ca54656),
    getOptionLabel: (0, $b2afea94242257b8$export$dac6ace3020563ca),
    getOptionValue: (0, $b2afea94242257b8$export$40be908210c5a79c),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    hasOtherFocusableElements: false,
    isOptionDisabled: (0, $b2afea94242257b8$export$56bd0c8d90db075),
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $c3eea1c9ec58844c$export$44f917bf91becd01)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $c647738a411ac32c$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $c647738a411ac32c$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $c647738a411ac32c$var$_isOptionSelected(props, option, selectValue);
    var label = $c647738a411ac32c$var$getOptionLabel(props, option);
    var value = $c647738a411ac32c$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $c647738a411ac32c$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $c647738a411ac32c$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $c647738a411ac32c$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $c647738a411ac32c$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $c647738a411ac32c$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $c3eea1c9ec58844c$export$aedb69ff3e31596c));
}
function $c647738a411ac32c$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $c647738a411ac32c$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $c647738a411ac32c$var$buildFocusableOptions(props, selectValue) {
    return $c647738a411ac32c$var$buildFocusableOptionsFromCategorizedOptions($c647738a411ac32c$var$buildCategorizedOptions(props, selectValue));
}
function $c647738a411ac32c$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$c647738a411ac32c$var$shouldHideSelectedOptions(props) || !isSelected) && $c647738a411ac32c$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $c647738a411ac32c$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $c647738a411ac32c$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $c647738a411ac32c$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $c647738a411ac32c$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $c647738a411ac32c$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $c647738a411ac32c$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $c647738a411ac32c$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $c647738a411ac32c$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $c647738a411ac32c$var$getOptionValue(props, i) === candidate;
    });
}
function $c647738a411ac32c$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $c647738a411ac32c$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $c647738a411ac32c$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components
var $c647738a411ac32c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, Select);
        _this = $c647738a411ac32c$var$_callSuper(this, Select, [
            _props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "blockOptionHover", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "isComposing", false);
        // TODO
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "initialTouchX", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "initialTouchY", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "openAfterFocus", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "scrollToFocusedOptionOnUpdate", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "lastPressedKey", '');
        // Refs
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "controlRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "focusedOptionRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "menuListRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "inputRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        // aliased for consumers
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "focus", _this.focusInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "blur", _this.blurInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $c3eea1c9ec58844c$export$d1ca752ec761b95b)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $c3eea1c9ec58844c$export$d1ca752ec761b95b)([].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $c3eea1c9ec58844c$export$dea4763e29237f4c)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $c3eea1c9ec58844c$export$dea4763e29237f4c)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $c3eea1c9ec58844c$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $c3eea1c9ec58844c$export$40fb9515c784cc3b)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $c3eea1c9ec58844c$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getFocusedOptionId", function(focusedOption) {
            return $c647738a411ac32c$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getFocusableOptionsWithIds", function() {
            return $c647738a411ac32c$var$buildFocusableOptionsWithIds($c647738a411ac32c$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $c3eea1c9ec58844c$export$ce4ab0c55987d1ff).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getOptionLabel", function(data) {
            return $c647738a411ac32c$var$getOptionLabel(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getOptionValue", function(data) {
            return $c647738a411ac32c$var$getOptionValue(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getStyles", function(key, props) {
            var base = (0, $5ea3581bad05c583$export$214b055320e0bf32)[key](props);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            if (!custom) return base;
            var customStyles = (0, $c3eea1c9ec58844c$export$bf2eda47afa5f369)(custom(base, props));
            return customStyles;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getComponents", function() {
            return (0, $3b7b7f3751a34714$export$71abc632aa29e6fe)(_this.props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "buildCategorizedOptions", function() {
            return $c647738a411ac32c$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "buildFocusableOptions", function() {
            return $c647738a411ac32c$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $c647738a411ac32c$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onMenuMouseMove", function(event) {
            _this.blockOptionHover = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $c3eea1c9ec58844c$export$d8a62a489b442872)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) {
                if (!_this.props.hasOtherFocusableElements || _this.props.hasOtherFocusableElements && _this.lastPressedKey !== 'Tab') _this.props.onBlur(event);
            }
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $137Lh.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "shouldHideSelectedOptions", function() {
            return $c647738a411ac32c$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            if (_this.props.hasOtherFocusableElements) _this.lastPressedKey = event.key;
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$c647738a411ac32c$var$instanceId);
        _this.state.selectValue = (0, $c3eea1c9ec58844c$export$33f062f47f21a01)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $c647738a411ac32c$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(Select, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $c3eea1c9ec58844c$export$53a0910f038337bd)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $c3eea1c9ec58844c$export$53a0910f038337bd)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                if (!this.props.hasOtherFocusableElements || this.props.hasOtherFocusableElements && this.lastPressedKey !== 'Tab') {
                    this.onInputChange('', {
                        action: 'menu-close',
                        prevInputValue: this.props.inputValue
                    });
                    this.props.onMenuClose();
                } else this.lastPressedKey = '';
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this2.onMenuOpen();
                });
                (0, $1d47d2fcfd20024b$export$95df08bae54cb4df)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this3 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this3.props['aria-label'] || _this3.props.label;
                        if (normalizedLabel) {
                            var _this3$inputRef;
                            (_this3$inputRef = _this3.inputRef) === null || _this3$inputRef === void 0 || _this3$inputRef.setAttribute('aria-label', normalizedLabel);
                        } else {
                            var _this3$inputRef2;
                            (_this3$inputRef2 = _this3.inputRef) === null || _this3$inputRef2 === void 0 || _this3$inputRef2.removeAttribute('aria-label');
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this4 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(obj) === 'object' && obj !== null && 'options' in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this4.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId('selected-value'), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $c647738a411ac32c$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $c647738a411ac32c$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $c647738a411ac32c$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    'aria-describedby': baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId('multi-message');
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    'aria-describedby': describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchstart', this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchmove', this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread({
                    'aria-autocomplete': 'both',
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-expanded': menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                    'aria-invalid': this.props['aria-invalid'] || isInvalid,
                    'aria-label': this.props['aria-label'] || label,
                    'aria-labelledby': this.props['aria-labelledby'] || labelId,
                    'aria-required': required || isRequired,
                    role: 'combobox',
                    'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.calculateDescription());
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f5b0d27774fa8135$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $c3eea1c9ec58844c$export$8793edee2d425525),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Input, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this5 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Placeholder, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $c647738a411ac32c$var$_objectSpread({
                        id: this.getElementId('placeholder')
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this5.getOptionLabel(opt), "-").concat(_this5.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(MultiValue, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: $c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread({
                            onClick: function onClick() {
                                return _this5.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this5.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: $c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index)
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index)
                        })
                    }), _this5.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(SingleValue, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: {
                        id: this.getElementId('single-value')
                    }
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $c647738a411ac32c$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    'data-testid': "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ClearIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === 'compact';
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(LoadingIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === 'compact';
                var innerProps = $c647738a411ac32c$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                }, testId && {
                    'data-testid': "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(DropdownIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this6 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this6.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this6.selectOption(data);
                    };
                    var optionId = "".concat(_this6.getElementId('option'), "-").concat(id);
                    var innerProps = $c647738a411ac32c$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this6.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                        'aria-selected': _this6.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        'aria-disabled': !isDisabled ? undefined : isDisabled,
                        'aria-describedby': headingId
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Option, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this6.getFocusedOptionRef : undefined
                    }), _this6.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === 'group') {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this6.getElementId('group'), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Group, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $c647738a411ac32c$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    'data-testid': "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this6.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === 'option') return render(item, "".concat(item.index));
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(NoOptionsMessage, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                        innerProps: $c647738a411ac32c$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $701943b1660eb776$export$f32337f3a7617699), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Menu, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $c647738a411ac32c$var$_objectSpread({
                            onMouseDown: _this6.onMenuMouseDown,
                            onMouseMove: _this6.onMenuMouseMove,
                            id: _this6.props.components.Menu ? _this6.getElementId('listbox') : undefined
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $53f47bf228e2c17b$export$2e2bcd8739ae039), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this6$inputRef, _this6$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(MenuList, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this6.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread({
                                role: _this6.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox'
                            }, _this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-labelledby': ((_this6$inputRef = _this6.inputRef) === null || _this6$inputRef === void 0 ? void 0 : _this6$inputRef.id) || _this6.getElementId('input')
                            }), {}, {
                                'aria-multiselectable': !commonProps.isMulti || _this6.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                id: _this6.getElementId('listbox')
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--listbox")
                            }), (0, $1d47d2fcfd20024b$export$95df08bae54cb4df)() && !_this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-describedby': ((_this6$inputRef2 = _this6.inputRef) === null || _this6$inputRef2 === void 0 ? void 0 : _this6$inputRef2.id) || _this6.getElementId('input')
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this6.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(MenuPortal, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this7 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $02a052b7c504f468$export$2e2bcd8739ae039), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this7.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this7.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f9ec643cf0e70261$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : '');
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    id: this.getElementId('multi-message'),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? 'default' : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? 'default' : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(SelectContainer, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $c647738a411ac32c$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        'data-testid': testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Control, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $c647738a411ac32c$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ValueContainer, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    innerProps: $c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $1d47d2fcfd20024b$export$e1865c3bedcd822b)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: 'application'
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(IndicatorsContainer, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $c647738a411ac32c$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $fadc113176ef20dd$export$17baa7c95b6ba1b8), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $c3eea1c9ec58844c$export$33f062f47f21a01)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $c647738a411ac32c$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $c647738a411ac32c$var$buildFocusableOptionsWithIds($c647738a411ac32c$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $c647738a411ac32c$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $c647738a411ac32c$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $c647738a411ac32c$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $c3eea1c9ec58844c$export$40fb9515c784cc3b)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return $c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
}((0, $7fPBF.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($c647738a411ac32c$export$2e2bcd8739ae039, "defaultProps", $c647738a411ac32c$export$9c21a3269931e1e6);



var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $d3b27b3269bc4670$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $d3b27b3269bc4670$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3b27b3269bc4670$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3b27b3269bc4670$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3b27b3269bc4670$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d3b27b3269bc4670$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $d3b27b3269bc4670$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $7fPBF.useRef)(undefined);
    var mounted = (0, $7fPBF.useRef)(false);
    var _useState = (0, $7fPBF.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(propsDefaultOptions === true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $7fPBF.useState)(undefined), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $7fPBF.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $7fPBF.useState)(false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $7fPBF.useState)({}), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $7fPBF.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $7fPBF.useState)(undefined), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $7fPBF.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $7fPBF.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $7fPBF.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $c3eea1c9ec58844c$export$2096bae78ecda911)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $d3b27b3269bc4670$var$_objectSpread($d3b27b3269bc4670$var$_objectSpread({}, optionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $d3b27b3269bc4670$var$_objectSpread($d3b27b3269bc4670$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}



var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
var $f8fa064e8c7bf643$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $f8fa064e8c7bf643$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f8fa064e8c7bf643$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f8fa064e8c7bf643$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f8fa064e8c7bf643$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f8fa064e8c7bf643$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $f8fa064e8c7bf643$var$_excluded);
    var _useState = (0, $7fPBF.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $7fPBF.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $7fPBF.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $7fPBF.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $7fPBF.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $f8fa064e8c7bf643$var$_objectSpread($f8fa064e8c7bf643$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}


var $f6919b9119b4aa1b$var$AsyncSelect = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $d3b27b3269bc4670$export$2e2bcd8739ae039)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $f8fa064e8c7bf643$export$2e2bcd8739ae039)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c647738a411ac32c$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f6919b9119b4aa1b$export$2e2bcd8739ae039 = $f6919b9119b4aa1b$var$AsyncSelect;



var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
var $3c5b40a3da42d98f$var$_excluded = [
    "ariaLiveMessages",
    "isInvalid",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $3c5b40a3da42d98f$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? 'default' : _props$validationStat, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $3c5b40a3da42d98f$var$_excluded);
        var internalSelectRef = (0, $7fPBF.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $7fPBF.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error'
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}


var $3735c09e1632df70$var$packageName = "@atlaskit/select";
var $3735c09e1632df70$var$packageVersion = "21.2.3";
var $3735c09e1632df70$export$d1de3b251ccaa8a3 = (0, $3c5b40a3da42d98f$export$2e2bcd8739ae039)((0, $f6919b9119b4aa1b$export$2e2bcd8739ae039));
var $3735c09e1632df70$var$createAndFireEventOnAtlaskit = (0, $5819e7133c450b79$export$2e2bcd8739ae039)('atlaskit');
var $3735c09e1632df70$var$Select = (0, $4d25ac76de88d196$export$2e2bcd8739ae039)({
    componentName: 'select',
    packageName: $3735c09e1632df70$var$packageName,
    packageVersion: $3735c09e1632df70$var$packageVersion
})((0, $f8e03d3ef4b3dc3d$export$2e2bcd8739ae039)({
    onChange: $3735c09e1632df70$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $3735c09e1632df70$var$packageName,
            packageVersion: $3735c09e1632df70$var$packageVersion
        }
    })
})($3735c09e1632df70$export$d1de3b251ccaa8a3));
var $3735c09e1632df70$export$2e2bcd8739ae039 = $3735c09e1632df70$var$Select;



var $7fPBF = parcelRequire("7fPBF");





var $mc37r = parcelRequire("mc37r");

var $8lLl9 = parcelRequire("8lLl9");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $727d537db95bcc31$var$token(path, fallback) {
    var token = (0, $mc37r.default)[path];
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $8lLl9.TOKEN_NOT_FOUND_CSS_VAR);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $727d537db95bcc31$export$2e2bcd8739ae039 = $727d537db95bcc31$var$token;



var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $3104ec53a35158ff$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $3104ec53a35158ff$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $3104ec53a35158ff$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $3104ec53a35158ff$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$3104ec53a35158ff$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($3104ec53a35158ff$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $3104ec53a35158ff$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 = "-ms-";
var $83f8df0fc4bef2f6$export$2c0f367103c8d01c = "-moz-";
var $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 = "-webkit-";
var $83f8df0fc4bef2f6$export$a29989082612d0d9 = "comm";
var $83f8df0fc4bef2f6$export$aa3a2e812ca8570d = "rule";
var $83f8df0fc4bef2f6$export$527d108ccf083c2b = "decl";
var $83f8df0fc4bef2f6$export$d3d35020fa5b54f0 = "@page";
var $83f8df0fc4bef2f6$export$500415a86c544f73 = "@media";
var $83f8df0fc4bef2f6$export$a763edbf796b780a = "@import";
var $83f8df0fc4bef2f6$export$2790aeb8b4e5c826 = "@charset";
var $83f8df0fc4bef2f6$export$1cc683e23b84b133 = "@viewport";
var $83f8df0fc4bef2f6$export$9447a5efea57e862 = "@supports";
var $83f8df0fc4bef2f6$export$ef011b4e114b1fba = "@document";
var $83f8df0fc4bef2f6$export$6aad947bda0f3f46 = "@namespace";
var $83f8df0fc4bef2f6$export$b44a8529a35fcb60 = "@keyframes";
var $83f8df0fc4bef2f6$export$2c16de31893252e6 = "@font-face";
var $83f8df0fc4bef2f6$export$3d846dd52e150c6f = "@counter-style";
var $83f8df0fc4bef2f6$export$22314bfbb57653fe = "@font-feature-values";
var $83f8df0fc4bef2f6$export$d773506282b3cfe6 = "@layer";
var $83f8df0fc4bef2f6$export$2335f513bbd82c6d = Math.abs;
var $83f8df0fc4bef2f6$export$6788812c4e6611e6 = String.fromCharCode;
var $83f8df0fc4bef2f6$export$e6e34fd1f2686227 = Object.assign;
function $83f8df0fc4bef2f6$export$d6af199866bfb566(e, r) {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 1)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 2)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 3) : 0;
}
function $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $83f8df0fc4bef2f6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $83f8df0fc4bef2f6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $83f8df0fc4bef2f6$export$36776f635604f274(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$f9084667e487ed46(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $83f8df0fc4bef2f6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = 1;
var $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1;
var $83f8df0fc4bef2f6$export$f24224f1c91d8156 = 0;
var $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0;
var $83f8df0fc4bef2f6$export$c0306caf338ac095 = 0;
var $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "";
function $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c,
        column: $83f8df0fc4bef2f6$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $83f8df0fc4bef2f6$export$784d13d8ee351f07(e, r) {
    return $83f8df0fc4bef2f6$export$e6e34fd1f2686227($83f8df0fc4bef2f6$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $83f8df0fc4bef2f6$export$eba6f6f03b0a92e7() {
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$232faf9add678146() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 > 0 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, --$83f8df0fc4bef2f6$export$5880b8b5730aff45) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3--, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c--;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 < $83f8df0fc4bef2f6$export$f24224f1c91d8156 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45++) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3++, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c++;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$e88cb2efb12ae807() {
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, r) {
    return $83f8df0fc4bef2f6$export$2f35ab04d2335697($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, e, r);
}
function $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $83f8df0fc4bef2f6$export$2de70f21292aac9e(e) {
    return $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$f24224f1c91d8156 = $83f8df0fc4bef2f6$export$36776f635604f274($83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = e), $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0, [];
}
function $83f8df0fc4bef2f6$export$45918ac1574455b1(e) {
    return $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "", e;
}
function $83f8df0fc4bef2f6$export$410ac95b9ec204b8(e) {
    return $83f8df0fc4bef2f6$export$87c2784dc9fc4ab($83f8df0fc4bef2f6$export$58adb3bec8346d0f($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1, $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1($83f8df0fc4bef2f6$export$2de70f21292aac9e(e)));
}
function $83f8df0fc4bef2f6$export$7af1228ff777d175(e) {
    while($83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 33) $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    else break;
    return $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) > 2 || $83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095)){
        case 0:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
            break;
        default:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
    }
    return e;
}
function $83f8df0fc4bef2f6$export$955ba06d119e085e(e, r) {
    while(--r && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 48 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 102 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 57 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 65 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 70 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 97) break;
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$e88cb2efb12ae807() + (r < 6 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() == 32 && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() == 32));
}
function $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$c0306caf338ac095){
        case e:
            return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12($83f8df0fc4bef2f6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
            break;
    }
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$4254d4e2b3745c4c(e, r) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 57) break;
    else if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 84 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $83f8df0fc4bef2f6$export$58adb3bec8346d0f(r, $83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1) + "*" + $83f8df0fc4bef2f6$export$6788812c4e6611e6(e === 47 ? e : $83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
}
function $83f8df0fc4bef2f6$export$c2ab62c7bf24634(e) {
    while(!$83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()))$83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$ef7acd7185315e22(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $83f8df0fc4bef2f6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $83f8df0fc4bef2f6$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($83f8df0fc4bef2f6$export$f8e21b1e77979a08(j += $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $83f8df0fc4bef2f6$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $83f8df0fc4bef2f6$export$955ba06d119e085e($83f8df0fc4bef2f6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$4a34f930e789283c($83f8df0fc4bef2f6$export$4254d4e2b3745c4c($83f8df0fc4bef2f6$export$48cfd1e771a65c4f(), $83f8df0fc4bef2f6$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $83f8df0fc4bef2f6$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $83f8df0fc4bef2f6$export$36776f635604f274(j) - l) $83f8df0fc4bef2f6$export$10d8903dec122b9d(p > 32 ? $83f8df0fc4bef2f6$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $83f8df0fc4bef2f6$export$f8483753829ec8f3($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d(y = $83f8df0fc4bef2f6$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, y, y, n && $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $83f8df0fc4bef2f6$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $83f8df0fc4bef2f6$export$232faf9add678146() == 125) continue;
            }
            switch(j += $83f8df0fc4bef2f6$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($83f8df0fc4bef2f6$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 45) j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
                    v = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e(), o = l = $83f8df0fc4bef2f6$export$36776f635604f274(g = j += $83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $83f8df0fc4bef2f6$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $83f8df0fc4bef2f6$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, v + 1, v = $83f8df0fc4bef2f6$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, s === 0 ? $83f8df0fc4bef2f6$export$aa3a2e812ca8570d : i, f, o, l);
}
function $83f8df0fc4bef2f6$export$4a34f930e789283c(e, r, a) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$a29989082612d0d9, $83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$eba6f6f03b0a92e7()), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $83f8df0fc4bef2f6$export$f8483753829ec8f3(e, r, a, n) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$527d108ccf083c2b, $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 0, n), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n, c, s) {
    switch($83f8df0fc4bef2f6$export$d6af199866bfb566(n, c)){
        case 5103:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-$1$2" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-item-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-line-pack" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-grow", "") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-pack:$3" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-column-align" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(s, "span") ? $83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) : +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) - +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($83f8df0fc4bef2f6$export$36776f635604f274(n) - 1 - c > 6) switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n, "stretch") ? $83f8df0fc4bef2f6$export$82e9f45cca5ba907($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 6) === 121) return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, $83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $83f8df0fc4bef2f6$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $83f8df0fc4bef2f6$export$a763edbf796b780a:
        case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $83f8df0fc4bef2f6$export$a29989082612d0d9:
            return "";
        case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $83f8df0fc4bef2f6$export$36776f635604f274(a = $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $83f8df0fc4bef2f6$export$5a7767152ae0305f(e) {
    var r = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $83f8df0fc4bef2f6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $83f8df0fc4bef2f6$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                n.return = $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                    $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                        value: $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (n.length) return $83f8df0fc4bef2f6$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($83f8df0fc4bef2f6$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $83f8df0fc4bef2f6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $83f8df0fc4bef2f6$export$1be1fc439b849fdf($83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($83f8df0fc4bef2f6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $83f8df0fc4bef2f6$export$2f35ab04d2335697(r, 1, $83f8df0fc4bef2f6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $83f8df0fc4bef2f6$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $83f8df0fc4bef2f6$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $fef3d59b736200bc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $3587f7e2ed7416b3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $273321b94be832ab$var$isBrowser = typeof document !== 'undefined';
var $273321b94be832ab$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $83f8df0fc4bef2f6$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $83f8df0fc4bef2f6$export$9e1725a4cfeada27)(character)) break;
        (0, $83f8df0fc4bef2f6$export$48cfd1e771a65c4f)();
    }
    return (0, $83f8df0fc4bef2f6$export$58adb3bec8346d0f)(begin, (0, $83f8df0fc4bef2f6$export$5880b8b5730aff45));
};
var $273321b94be832ab$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $83f8df0fc4bef2f6$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $83f8df0fc4bef2f6$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $273321b94be832ab$var$identifierWithPointTracking((0, $83f8df0fc4bef2f6$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $83f8df0fc4bef2f6$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $83f8df0fc4bef2f6$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $83f8df0fc4bef2f6$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $83f8df0fc4bef2f6$export$48cfd1e771a65c4f)());
    return parsed;
};
var $273321b94be832ab$var$getRules = function getRules(value, points) {
    return (0, $83f8df0fc4bef2f6$export$45918ac1574455b1)($273321b94be832ab$var$toRules((0, $83f8df0fc4bef2f6$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $273321b94be832ab$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $273321b94be832ab$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$273321b94be832ab$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $273321b94be832ab$var$fixedElements.set(element, true);
    var points = [];
    var rules = $273321b94be832ab$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $273321b94be832ab$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $273321b94be832ab$var$prefix(value, length) {
    switch((0, $83f8df0fc4bef2f6$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'box-' + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $83f8df0fc4bef2f6$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $83f8df0fc4bef2f6$export$f8e21b1e77979a08)(value, 'stretch') ? $273321b94be832ab$var$prefix((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, (0, $83f8df0fc4bef2f6$export$36776f635604f274)(value) - 3 - (~(0, $83f8df0fc4bef2f6$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $273321b94be832ab$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                element["return"] = $273321b94be832ab$var$prefix(element.value, element.length);
                break;
            case 0, $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)([
                    (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                        value: (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (element.length) return (0, $83f8df0fc4bef2f6$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $83f8df0fc4bef2f6$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)([
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)([
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $273321b94be832ab$var$getServerStylisCache = $273321b94be832ab$var$isBrowser ? undefined : (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function() {
    return (0, $3587f7e2ed7416b3$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $273321b94be832ab$var$defaultStylisPlugins = [
    $273321b94be832ab$var$prefixer
];
var $273321b94be832ab$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($273321b94be832ab$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $273321b94be832ab$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($273321b94be832ab$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $273321b94be832ab$var$compat,
        $273321b94be832ab$var$removeLabel
    ];
    if (!$273321b94be832ab$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $83f8df0fc4bef2f6$export$fac44ee5b035f737),
            (0, $83f8df0fc4bef2f6$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $83f8df0fc4bef2f6$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)((0, $83f8df0fc4bef2f6$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $83f8df0fc4bef2f6$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $83f8df0fc4bef2f6$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)((0, $83f8df0fc4bef2f6$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $273321b94be832ab$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $3104ec53a35158ff$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    return $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f43c50d92a19d876$export$2e2bcd8739ae039.apply(null, arguments);
}



var $63fc9407ef8fcdfe$exports = {};
'use strict';
var $dddaf6f84c717660$exports = {};
'use strict';

$dddaf6f84c717660$exports = (parcelRequire("45MkT"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dddaf6f84c717660$exports.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dddaf6f84c717660$exports.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($dddaf6f84c717660$exports.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component['$$typeof']] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$63fc9407ef8fcdfe$exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $0bc6489980e08e1c$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($63fc9407ef8fcdfe$exports)))(targetComponent, sourceComponent);
};


var $5d390c582efd47c3$var$isBrowser = typeof document !== 'undefined';
function $5d390c582efd47c3$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5d390c582efd47c3$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5d390c582efd47c3$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5d390c582efd47c3$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5d390c582efd47c3$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5d390c582efd47c3$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5d390c582efd47c3$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1529d79d9aa6f066$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $49fc6b0b9a1bf345$var$isDevelopment = false;
var $49fc6b0b9a1bf345$var$hyphenateRegex = /[A-Z]|^ms/g;
var $49fc6b0b9a1bf345$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $49fc6b0b9a1bf345$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $49fc6b0b9a1bf345$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $49fc6b0b9a1bf345$var$processStyleName = /* #__PURE__ */ (0, $3587f7e2ed7416b3$export$2e2bcd8739ae039)(function(styleName) {
    return $49fc6b0b9a1bf345$var$isCustomProperty(styleName) ? styleName : styleName.replace($49fc6b0b9a1bf345$var$hyphenateRegex, '-$&').toLowerCase();
});
var $49fc6b0b9a1bf345$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($49fc6b0b9a1bf345$var$animationRegex, function(match, p1, p2) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return p1;
            });
    }
    if ((0, $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039)[key] !== 1 && !$49fc6b0b9a1bf345$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $49fc6b0b9a1bf345$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $49fc6b0b9a1bf345$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $49fc6b0b9a1bf345$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $49fc6b0b9a1bf345$var$cursor;
                var result = interpolation(mergedProps);
                $49fc6b0b9a1bf345$var$cursor = previousCursor;
                return $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($49fc6b0b9a1bf345$var$isProcessableValue(asString)) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $49fc6b0b9a1bf345$var$isDevelopment) throw new Error($49fc6b0b9a1bf345$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($49fc6b0b9a1bf345$var$isProcessableValue(value[_i])) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $49fc6b0b9a1bf345$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $49fc6b0b9a1bf345$var$cursor;
function $49fc6b0b9a1bf345$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $49fc6b0b9a1bf345$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $49fc6b0b9a1bf345$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $49fc6b0b9a1bf345$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $1529d79d9aa6f066$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $49fc6b0b9a1bf345$var$cursor
    };
}



var $7fPBF = parcelRequire("7fPBF");
var $6ea4cfa701df259a$var$isBrowser = typeof document !== 'undefined';
var $6ea4cfa701df259a$var$syncFallback = function syncFallback(create) {
    return create();
};
var $6ea4cfa701df259a$var$useInsertionEffect = $7fPBF.useInsertionEffect ? $7fPBF.useInsertionEffect : false;
var $6ea4cfa701df259a$export$db21c7ffa21794e7 = !$6ea4cfa701df259a$var$isBrowser ? $6ea4cfa701df259a$var$syncFallback : $6ea4cfa701df259a$var$useInsertionEffect || $6ea4cfa701df259a$var$syncFallback;
var $6ea4cfa701df259a$export$811a713a7276cb9d = $6ea4cfa701df259a$var$useInsertionEffect || $7fPBF.useLayoutEffect;


var $4b604f9ff2f6f5b8$export$407448d2b89b1813 = false;
var $4b604f9ff2f6f5b8$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $4b604f9ff2f6f5b8$var$EmotionCacheContext = /* #__PURE__ */ $7fPBF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $273321b94be832ab$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $4b604f9ff2f6f5b8$export$e7094788287c5e9b = $4b604f9ff2f6f5b8$var$EmotionCacheContext.Provider;
var $4b604f9ff2f6f5b8$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
};
var $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$4b604f9ff2f6f5b8$export$23f2a1d2818174ef) $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $273321b94be832ab$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $4b604f9ff2f6f5b8$export$971d5caa766a69d7 = /* #__PURE__ */ $7fPBF.createContext({});
var $4b604f9ff2f6f5b8$export$3b14a55fb2447963 = function useTheme() {
    return $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
};
var $4b604f9ff2f6f5b8$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $4b604f9ff2f6f5b8$var$createCacheWithTheme = /* #__PURE__ */ (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function(theme) {
        return $4b604f9ff2f6f5b8$var$getTheme(outerTheme, theme);
    });
});
var $4b604f9ff2f6f5b8$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4b604f9ff2f6f5b8$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4b604f9ff2f6f5b8$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $7fPBF.forwardRef(function render(props, ref) {
        var theme = $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $0bc6489980e08e1c$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $4b604f9ff2f6f5b8$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4b604f9ff2f6f5b8$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4b604f9ff2f6f5b8$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($4b604f9ff2f6f5b8$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$4b604f9ff2f6f5b8$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $4b604f9ff2f6f5b8$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $5d390c582efd47c3$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $6ea4cfa701df259a$export$db21c7ffa21794e7)(function() {
        return (0, $5d390c582efd47c3$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$4b604f9ff2f6f5b8$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $4b604f9ff2f6f5b8$var$Emotion = /* #__PURE__ */ $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4b604f9ff2f6f5b8$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $5d390c582efd47c3$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(registeredStyles, undefined, $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($4b604f9ff2f6f5b8$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $4b604f9ff2f6f5b8$var$typePropName && !$4b604f9ff2f6f5b8$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $7fPBF.createElement(WrappedComponent, newProps));
});
var $4b604f9ff2f6f5b8$export$a9c23c6ac3fc3eca = $4b604f9ff2f6f5b8$var$Emotion;



var $7fPBF = parcelRequire("7fPBF");




parcelRequire("cvBp9");



var $3ebaaabf76fb5db5$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $4b604f9ff2f6f5b8$export$dda1d9f60106f0e9).call(props, 'css')) return $7fPBF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $4b604f9ff2f6f5b8$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $4b604f9ff2f6f5b8$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $7fPBF.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($3ebaaabf76fb5db5$export$c8a8987d4410bf2d || ($3ebaaabf76fb5db5$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $3ebaaabf76fb5db5$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)([
        styles
    ], undefined, $7fPBF.useContext((0, $4b604f9ff2f6f5b8$export$971d5caa766a69d7)));
    if (!(0, $4b604f9ff2f6f5b8$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7fPBF.useRef();
    (0, $6ea4cfa701df259a$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $6ea4cfa701df259a$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $5d390c582efd47c3$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $3ebaaabf76fb5db5$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args);
}
function $3ebaaabf76fb5db5$export$d25ddfdf17c3ad3e() {
    var insertable = $3ebaaabf76fb5db5$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $3ebaaabf76fb5db5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $3ebaaabf76fb5db5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $5d390c582efd47c3$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $3ebaaabf76fb5db5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $6ea4cfa701df259a$export$db21c7ffa21794e7)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $5d390c582efd47c3$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
            if (!(0, $4b604f9ff2f6f5b8$export$23f2a1d2818174ef) && res !== undefined) rules += res;
        }
        if (!(0, $4b604f9ff2f6f5b8$export$23f2a1d2818174ef)) return rules;
    });
    if (!(0, $4b604f9ff2f6f5b8$export$23f2a1d2818174ef) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $3ebaaabf76fb5db5$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $4b604f9ff2f6f5b8$export$407448d2b89b1813)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $5d390c582efd47c3$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $4b604f9ff2f6f5b8$export$407448d2b89b1813)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $3ebaaabf76fb5db5$var$merge(cache.registered, css, $3ebaaabf76fb5db5$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7fPBF.useContext((0, $4b604f9ff2f6f5b8$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($3ebaaabf76fb5db5$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});




var $8MJe2 = parcelRequire("8MJe2");


var $8lLl9 = parcelRequire("8lLl9");
function $f914dcb93d08bd27$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f914dcb93d08bd27$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f914dcb93d08bd27$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f914dcb93d08bd27$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f914dcb93d08bd27$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $f914dcb93d08bd27$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $f914dcb93d08bd27$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $f914dcb93d08bd27$export$632685d741f3dbbf = $f914dcb93d08bd27$var$_objectSpread($f914dcb93d08bd27$var$_objectSpread({}, $f914dcb93d08bd27$export$958d0ae7f2977ae4), $f914dcb93d08bd27$export$d2dc61f58390201c);
var $f914dcb93d08bd27$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $f914dcb93d08bd27$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $f914dcb93d08bd27$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $f914dcb93d08bd27$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $f914dcb93d08bd27$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $f914dcb93d08bd27$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $f914dcb93d08bd27$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $f914dcb93d08bd27$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $f914dcb93d08bd27$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $f914dcb93d08bd27$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $f914dcb93d08bd27$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $f914dcb93d08bd27$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $f914dcb93d08bd27$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $f914dcb93d08bd27$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $f914dcb93d08bd27$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $f914dcb93d08bd27$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $f914dcb93d08bd27$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $f914dcb93d08bd27$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $f914dcb93d08bd27$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $f914dcb93d08bd27$export$e615f061ca585a6c = $f914dcb93d08bd27$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $f914dcb93d08bd27$export$ca0f9c2de39ffed7(spacingProperty, $f914dcb93d08bd27$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $f914dcb93d08bd27$export$bf46c3f9eeafc71f = $f914dcb93d08bd27$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $f914dcb93d08bd27$export$ca0f9c2de39ffed7(spacingProperty, $f914dcb93d08bd27$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $f914dcb93d08bd27$export$e7af83bafe7f9e63 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('backgroundColor', $f914dcb93d08bd27$export$d1d79bf68ac056bd);
var $f914dcb93d08bd27$export$3a1bcba60b23d7f0 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('color', $f914dcb93d08bd27$export$8473307aa00d6ea1);
var $f914dcb93d08bd27$export$45f3f4fe16f9f7d5 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('fontWeight', $f914dcb93d08bd27$export$303e322c6b1ed114);
var $f914dcb93d08bd27$export$68cc305da27dbaa4 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('fontFamily', $f914dcb93d08bd27$export$3c7e9587132614b4);
var $f914dcb93d08bd27$export$128f10c238242f83 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('font', $f914dcb93d08bd27$export$6ffa317d5e70375);
var $f914dcb93d08bd27$export$219d364c0da35ae4 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('font', $f914dcb93d08bd27$export$236bfe3a33ef1292);
var $f914dcb93d08bd27$export$38845ca010b93505 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('fontWeight', $f914dcb93d08bd27$export$855cfd311192d666);
var $f914dcb93d08bd27$export$ff257d957d48c421 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7((0, $8lLl9.CURRENT_SURFACE_CSS_VAR), $f914dcb93d08bd27$export$41a358c9c2356760);
var $f914dcb93d08bd27$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $f914dcb93d08bd27$export$41a358c9c2356760[color] !== undefined;
};
var $f914dcb93d08bd27$export$7001ce64d9ff7c7f = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('font', $f914dcb93d08bd27$export$b805719bc8cb376);



var $j9spr = parcelRequire("j9spr");

var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $bRUy3 = parcelRequire("bRUy3");


function $3e5203791fd7c7fc$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $3e5203791fd7c7fc$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $3e5203791fd7c7fc$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3e5203791fd7c7fc$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3e5203791fd7c7fc$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3e5203791fd7c7fc$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $3e5203791fd7c7fc$export$9a199fbafee0014e = {
    backgroundColor: (0, $f914dcb93d08bd27$export$d1d79bf68ac056bd),
    blockSize: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderBottomColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderLeftColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    bottom: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    boxShadow: (0, $f914dcb93d08bd27$export$7aff6e7ba39bb774),
    color: (0, $f914dcb93d08bd27$export$8473307aa00d6ea1),
    columnGap: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    font: (0, $f914dcb93d08bd27$export$6ffa317d5e70375),
    fontFamily: (0, $f914dcb93d08bd27$export$3c7e9587132614b4),
    fontWeight: (0, $f914dcb93d08bd27$export$303e322c6b1ed114),
    gap: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    height: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    inlineSize: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    inset: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    insetBlock: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    insetBlockEnd: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    insetBlockStart: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    insetInline: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    insetInlineEnd: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    insetInlineStart: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    left: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    margin: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginBlock: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginBlockEnd: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginBlockStart: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginBottom: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginInline: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginInlineEnd: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginInlineStart: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginLeft: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginRight: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginTop: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    maxBlockSize: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    maxHeight: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    maxWidth: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    minBlockSize: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    minHeight: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    minInlineSize: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    minWidth: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    opacity: (0, $f914dcb93d08bd27$export$daf94a976c798b4f),
    outlineColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    outlineOffset: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    outlineWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    padding: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingBlock: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingBottom: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingInline: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingLeft: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingRight: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingTop: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    right: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    rowGap: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    top: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    width: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    zIndex: (0, $f914dcb93d08bd27$export$b5f31a7e431d2eab)
};
var $3e5203791fd7c7fc$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $3e5203791fd7c7fc$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return false;
};
var $3e5203791fd7c7fc$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $3e5203791fd7c7fc$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $3e5203791fd7c7fc$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($3e5203791fd7c7fc$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(value) === 'object' && $3e5203791fd7c7fc$var$safeSelectors.test(key)) {
            styleObj[key] = $3e5203791fd7c7fc$var$_transformStyles(value);
            return;
        }
        if ($3e5203791fd7c7fc$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($3e5203791fd7c7fc$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $3e5203791fd7c7fc$export$9a199fbafee0014e)) return;
        var tokenValue = $3e5203791fd7c7fc$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $3e5203791fd7c7fc$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $3e5203791fd7c7fc$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $3e5203791fd7c7fc$var$uniqueSymbol, (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $3e5203791fd7c7fc$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $3e5203791fd7c7fc$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $3e5203791fd7c7fc$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$3e5203791fd7c7fc$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $3e5203791fd7c7fc$export$f6c783d06584602c(style) {
    return $3e5203791fd7c7fc$var$baseXcss(style);
}


var $d245204bc35d9406$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $d245204bc35d9406$var$_excluded2 = [
    "className"
];
var $d245204bc35d9406$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $d245204bc35d9406$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $d245204bc35d9406$var$_excluded2);
    var resolvedStyles = (0, $3e5203791fd7c7fc$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $d245204bc35d9406$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $f914dcb93d08bd27$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $f914dcb93d08bd27$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $f914dcb93d08bd27$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $bd8fd1a07ee559ec$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $d245204bc35d9406$export$2e2bcd8739ae039 = $d245204bc35d9406$export$e71c4d32a2263218;
var $d245204bc35d9406$var$baseStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});


const $6718274fb1e241ce$var$languageSelectStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.025'
});
const $6718274fb1e241ce$var$LanguageSelect = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const selectLanguageHandler = (0, $7fPBF.useCallback)((option)=>{
        if (option) dispatch((0, $cc45bcc51bf95f36$export$fa43c961ec463ef0)(option.value));
    }, [
        dispatch
    ]);
    const currentLanguage = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$20b36ebcfeb0a091));
    const supportedLanguages = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$454c8e352dec47e6));
    const languageOptions = (0, $7fPBF.useMemo)(()=>Object.keys(supportedLanguages).map((key)=>({
                value: key,
                label: supportedLanguages[key]
            })), [
        supportedLanguages
    ]);
    const defaultLanguage = (0, $7fPBF.useMemo)(()=>({
            value: currentLanguage,
            label: supportedLanguages[currentLanguage]
        }), [
        currentLanguage,
        supportedLanguages
    ]);
    (0, $7fPBF.useEffect)(()=>{
        document.documentElement.lang = currentLanguage;
    }, [
        currentLanguage
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        xcss: $6718274fb1e241ce$var$languageSelectStyles,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d1cff7edaf95fc01$exports))), {
                label: 'Language Select',
                primaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.subtle'),
                secondaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.subtle')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3735c09e1632df70$export$2e2bcd8739ae039), {
                appearance: 'subtle',
                classNamePrefix: 'languageSelectWrapper',
                value: defaultLanguage,
                options: languageOptions,
                onChange: selectLanguageHandler,
                menuPlacement: 'top',
                blurInputOnSelect: true
            })
        ]
    });
};
var $6718274fb1e241ce$export$2e2bcd8739ae039 = $6718274fb1e241ce$var$LanguageSelect;






var $cvBp9 = parcelRequire("cvBp9");

var $bRUy3 = parcelRequire("bRUy3");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $a81a1e57cf0d6bff$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $7fPBF.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $a81a1e57cf0d6bff$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a81a1e57cf0d6bff$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $a81a1e57cf0d6bff$export$2e2bcd8739ae039 = $a81a1e57cf0d6bff$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $23195fc9470f6fd6$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $7fPBF.useContext)((0, $a81a1e57cf0d6bff$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $23195fc9470f6fd6$export$2e2bcd8739ae039 = $23195fc9470f6fd6$var$useRouterLink;




var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $8d229a0b9f3c696a$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $8d229a0b9f3c696a$export$e2a22331486dcca0 = $8d229a0b9f3c696a$export$bdbb4cbb3078e58d();


var $4e2083026e10ea19$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $8d229a0b9f3c696a$export$bdbb4cbb3078e58d)()
    };
};
var $4e2083026e10ea19$export$e575061ef2a070eb = $4e2083026e10ea19$export$1921362e86c73c88();
var $4e2083026e10ea19$export$b4d5da5f34fb77ad = $7fPBF.createContext($4e2083026e10ea19$export$1921362e86c73c88());
var $4e2083026e10ea19$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $4e2083026e10ea19$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};


var $e9144a1b4dc9c62e$var$generateUID = function(context) {
    var quartz = context || (0, $4e2083026e10ea19$export$e575061ef2a070eb);
    var prefix = (0, $4e2083026e10ea19$export$36e24695f02d4503)(quartz);
    var id = (0, $4e2083026e10ea19$export$218c8c3169c024d2)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $e9144a1b4dc9c62e$var$useUIDState = function() {
    var context = (0, $7fPBF.useContext)((0, $4e2083026e10ea19$export$b4d5da5f34fb77ad));
    var uid = (0, $7fPBF.useState)(function() {
        return $e9144a1b4dc9c62e$var$generateUID(context);
    })[0];
    return uid;
};
var $e9144a1b4dc9c62e$export$87d05f07e65211f1 = function() {
    var uid = $e9144a1b4dc9c62e$var$useUIDState().uid;
    return uid;
};
var $e9144a1b4dc9c62e$export$bb5ca5fba6fb4f1f = function() {
    var gen = $e9144a1b4dc9c62e$var$useUIDState().gen;
    return gen;
};



var $137Lh = parcelRequire("137Lh");
var $7be67eb736da6c4d$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $7be67eb736da6c4d$var$react18UseId = ($7be67eb736da6c4d$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId) !== null && $7be67eb736da6c4d$var$_React$useId !== void 0 ? $7be67eb736da6c4d$var$_React$useId : undefined;
function $7be67eb736da6c4d$export$f680877a34711e37() {
    if ($7be67eb736da6c4d$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) return $7be67eb736da6c4d$var$react18UseId();
    return "uid".concat((0, $e9144a1b4dc9c62e$export$87d05f07e65211f1)());
}
var $7be67eb736da6c4d$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($7be67eb736da6c4d$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $7be67eb736da6c4d$export$6ee17796e3d70de2() {
    if ($7be67eb736da6c4d$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) {
        var uid = $7be67eb736da6c4d$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $e9144a1b4dc9c62e$export$bb5ca5fba6fb4f1f)();
}




var $137Lh = parcelRequire("137Lh");
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $468e1031dfd834df$var$ATOMIC_GROUP_LENGTH = 5;
function $468e1031dfd834df$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $468e1031dfd834df$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $d1b9d01570e45f55$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $d1b9d01570e45f55$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $468e1031dfd834df$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
var $d1b9d01570e45f55$export$2e2bcd8739ae039 = $d1b9d01570e45f55$var$VisuallyHidden;




var $d675dd73cffce3dd$var$_excluded = [
    "href",
    "children",
    "backgroundColor",
    "newWindowLabel",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss"
], $d675dd73cffce3dd$var$_excluded2 = [
    "className"
];
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $d675dd73cffce3dd$var$focusRingStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $d675dd73cffce3dd$var$baseStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    boxSizing: 'border-box',
    textDecoration: 'underline'
});
var $d675dd73cffce3dd$var$positionStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    position: 'relative'
});
var $d675dd73cffce3dd$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $d675dd73cffce3dd$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
var $d675dd73cffce3dd$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $d675dd73cffce3dd$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, backgroundColor = _ref.backgroundColor, newWindowLabel = _ref.newWindowLabel, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $27bc0e79b61c3ca3$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $d675dd73cffce3dd$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $7be67eb736da6c4d$export$f680877a34711e37)();
    var onClick = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.11.2",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $d675dd73cffce3dd$var$_excluded2);
    var resolvedStyles = (0, $3e5203791fd7c7fc$export$a9c84988c8f81f2d)(xcss);
    var RouterLink = (0, $23195fc9470f6fd6$export$2e2bcd8739ae039)();
    var isExternal = typeof href === 'string' && $d675dd73cffce3dd$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $d675dd73cffce3dd$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(href) === 'object';
    (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel ? newWindowLabel : $d675dd73cffce3dd$var$OPENS_NEW_WINDOW_LABEL) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        css: [
            $d675dd73cffce3dd$var$baseStyles,
            (0, $137Lh.fg)('platform_design-system-team_anchor-positioning') ? $d675dd73cffce3dd$var$positionStyles : undefined,
            $d675dd73cffce3dd$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $f914dcb93d08bd27$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel ? newWindowLabel : $d675dd73cffce3dd$var$OPENS_NEW_WINDOW_LABEL)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $d675dd73cffce3dd$var$Anchor = /*#__PURE__*/ (0, $7fPBF.forwardRef)($d675dd73cffce3dd$var$AnchorNoRef);
var $d675dd73cffce3dd$export$2e2bcd8739ae039 = $d675dd73cffce3dd$var$Anchor;


var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");



var $650de54fef58c216$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
var $650de54fef58c216$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
var $650de54fef58c216$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
var $650de54fef58c216$var$justifyContentMap = {
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'start'
    }),
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'center'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'stretch'
    })
};
var $650de54fef58c216$var$justifyItemsMap = {
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyItems: 'start'
    }),
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyItems: 'center'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyItems: 'end'
    }),
    stretch: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyItems: 'stretch'
    })
};
var $650de54fef58c216$var$alignContentMap = {
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'start'
    }),
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'center'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'end'
    }),
    'space-between': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'space-between'
    }),
    'space-around': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'space-around'
    }),
    'space-evenly': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'space-evenly'
    }),
    stretch: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'stretch'
    })
};
var $650de54fef58c216$var$alignItemsMap = {
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'start'
    }),
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'center'
    }),
    baseline: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'baseline'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'end'
    })
};
var $650de54fef58c216$var$baseStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: "var(".concat($650de54fef58c216$var$gridTemplateAreasVar, ")"),
    gridTemplateColumns: "var(".concat($650de54fef58c216$var$gridTemplateColumnsVar, ")"),
    gridTemplateRows: "var(".concat($650de54fef58c216$var$gridTemplateRowsVar, ")")
});
var $650de54fef58c216$var$gridAutoFlowMap = {
    row: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        gridAutoFlow: 'row'
    }),
    column: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        gridAutoFlow: 'column'
    }),
    dense: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        gridAutoFlow: 'dense'
    }),
    'row dense': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        gridAutoFlow: 'row dense'
    }),
    'column dense': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        gridAutoFlow: 'column dense'
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ var $650de54fef58c216$var$Grid = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, gridTemplateAreas = _ref.templateAreas, gridTemplateRows = _ref.templateRows, gridTemplateColumns = _ref.templateColumns, xcss = _ref.xcss;
    var Component = as || 'div';
    var resolvedStyles = (0, $3e5203791fd7c7fc$export$a9c84988c8f81f2d)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ var style = (0, $7fPBF.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $650de54fef58c216$var$gridTemplateAreasVar, gridTemplateAreas ? gridTemplateAreas.map(function(str) {
            return "\"".concat(str, "\"");
        }).join('\n') || 'initial' : 'initial'), $650de54fef58c216$var$gridTemplateColumnsVar, gridTemplateColumns || 'initial'), $650de54fef58c216$var$gridTemplateRowsVar, gridTemplateRows || 'initial');
    }, [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, {
        id: id,
        role: role,
        style: style,
        className: resolvedStyles.static,
        css: [
            $650de54fef58c216$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $f914dcb93d08bd27$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $f914dcb93d08bd27$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $f914dcb93d08bd27$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $650de54fef58c216$var$alignItemsMap[alignItems],
            alignContent && $650de54fef58c216$var$alignContentMap[alignContent],
            justifyContent && $650de54fef58c216$var$justifyContentMap[justifyContent],
            autoFlow && $650de54fef58c216$var$gridAutoFlowMap[autoFlow],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$650de54fef58c216$var$Grid.displayName = 'Grid';
var $650de54fef58c216$export$2e2bcd8739ae039 = $650de54fef58c216$var$Grid;

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $8c23171a376c15ae$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $8c23171a376c15ae$export$c881183ca713c214 = $8c23171a376c15ae$export$987d49ffe1b0900f;



const $8bc21533085bc562$var$_6 = "._30l330cd:hover{color:var(--_bp2er6)}";
const $8bc21533085bc562$var$_5 = "._80omtlke{cursor:pointer}";
const $8bc21533085bc562$var$_4 = "._syaz30cd{color:var(--_bp2er6)}";
const $8bc21533085bc562$var$_3 = "._ajmmnqa1{text-decoration-style:solid}";
const $8bc21533085bc562$var$_2 = "._1hmsglyw{text-decoration-line:none}";
const $8bc21533085bc562$var$_ = "._4bfu1r31{text-decoration-color:currentColor}";
const $8bc21533085bc562$var$footerGridStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.xxs]: {
        gridTemplateColumns: 'repeat(1, minmax(0, max-content))',
        gap: 'space.200'
    },
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.md]: {
        gridTemplateColumns: 'repeat(auto-fit, minmax(0, max-content))',
        gap: 'space.600'
    }
});
const $8bc21533085bc562$var$footerLinkStylesCss = null;
const $8bc21533085bc562$var$footerLinkStylesXCss = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    color: 'color.text.subtle',
    textDecoration: 'none',
    cursor: 'pointer',
    ':hover': {
        color: 'color.text.subtle'
    }
});
const $8bc21533085bc562$var$footerTextStyles = null;
const $8bc21533085bc562$var$Footer = ()=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const currentLanguage = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$20b36ebcfeb0a091));
    (0, $7fPBF.useEffect)(()=>{
        var _window_AtlOneTrustWrapper_updatePolicyLinks, _window_AtlOneTrustWrapper;
        (_window_AtlOneTrustWrapper = window.AtlOneTrustWrapper) === null || _window_AtlOneTrustWrapper === void 0 ? void 0 : (_window_AtlOneTrustWrapper_updatePolicyLinks = _window_AtlOneTrustWrapper.updatePolicyLinks) === null || _window_AtlOneTrustWrapper_updatePolicyLinks === void 0 ? void 0 : _window_AtlOneTrustWrapper_updatePolicyLinks.call(_window_AtlOneTrustWrapper);
    }, [
        currentLanguage
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        as: 'footer',
        testId: 'footer-wrapper',
        padding: 'space.150',
        backgroundColor: 'color.background.neutral',
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $650de54fef58c216$export$2e2bcd8739ae039), {
            xcss: $8bc21533085bc562$var$footerGridStyles,
            alignItems: "center",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6718274fb1e241ce$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d675dd73cffce3dd$export$2e2bcd8739ae039), {
                    xcss: $8bc21533085bc562$var$footerLinkStylesXCss,
                    testId: "footer-privacy-policy",
                    href: "https://www.atlassian.com/legal/privacy-policy",
                    rel: "noreferrer",
                    target: "_blank",
                    children: translate((0, $447ba15143f7eed7$exports).PRIVACY_POLICY_BUTTON_LABEL)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                            children: [
                                $8bc21533085bc562$var$_,
                                $8bc21533085bc562$var$_2,
                                $8bc21533085bc562$var$_3,
                                $8bc21533085bc562$var$_4,
                                $8bc21533085bc562$var$_5,
                                $8bc21533085bc562$var$_6
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            "data-testId": "footer-policy-link",
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                            className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                                "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz30cd _80omtlke _30l330cd",
                                'atl-policy-link atl-policy-link-text'
                            ]),
                            rel: "noreferrer",
                            target: "_blank",
                            style: {
                                "--_bp2er6": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.text.subtle'))
                            },
                            children: "Notice at Collection"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d675dd73cffce3dd$export$2e2bcd8739ae039), {
                    xcss: $8bc21533085bc562$var$footerLinkStylesXCss,
                    testId: "footer-terms-of-use",
                    href: "https://www.atlassian.com/legal/customer-agreement",
                    rel: "noreferrer",
                    target: "_blank",
                    children: translate((0, $447ba15143f7eed7$exports).TERM_OF_USE_BUTTON_LABEL)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d675dd73cffce3dd$export$2e2bcd8739ae039), {
                    xcss: $8bc21533085bc562$var$footerLinkStylesXCss,
                    testId: "footer-trademark",
                    href: "https://www.atlassian.com/legal/trademark",
                    rel: "noreferrer",
                    target: "_blank",
                    children: translate((0, $447ba15143f7eed7$exports).TRADEMARK_BUTTON_LABEL)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                            children: [
                                $8bc21533085bc562$var$_4
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                                "_syaz30cd"
                            ]),
                            style: {
                                "--_bp2er6": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.text.subtle'))
                            },
                            children: `Atlassian \xa9 ${new Date().getFullYear()}`
                        })
                    ]
                })
            ]
        })
    });
};
var $8bc21533085bc562$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.memo)($8bc21533085bc562$var$Footer);





parcelRequire("7fPBF");

var $cvBp9 = parcelRequire("cvBp9");


var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
var $06e8fc615885301a$var$_process$env;
var /// <reference types="node" />
$06e8fc615885301a$export$2e2bcd8739ae039 = false;



var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


function $424f1f90d90f725a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $424f1f90d90f725a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $424f1f90d90f725a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($424f1f90d90f725a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $424f1f90d90f725a$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
};
var $424f1f90d90f725a$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $424f1f90d90f725a$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, AnalyticsContext);
        _this = $424f1f90d90f725a$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $424f1f90d90f725a$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $424f1f90d90f725a$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e420dde09fb890a4$export$2e2bcd8739ae039).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $7fPBF.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($424f1f90d90f725a$var$AnalyticsContext, "contextTypes", $424f1f90d90f725a$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($424f1f90d90f725a$var$AnalyticsContext, "childContextTypes", $424f1f90d90f725a$var$ContextTypes);
var $424f1f90d90f725a$export$2e2bcd8739ae039 = $424f1f90d90f725a$var$AnalyticsContext;



var $j9spr = parcelRequire("j9spr");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $744e9f235aae602f$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $7fPBF.useContext)((0, $e420dde09fb890a4$export$2e2bcd8739ae039));
};



var $7fPBF = parcelRequire("7fPBF");
var $778efa38d8433f71$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $7fPBF.useRef)(value);
    ref.current = value;
    return ref;
};


var $36232c276cc489da$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $778efa38d8433f71$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $744e9f235aae602f$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $7fPBF.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $7fPBF.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e420dde09fb890a4$export$2e2bcd8739ae039).Provider, {
        value: value
    }, children);
};
var $36232c276cc489da$export$2e2bcd8739ae039 = $36232c276cc489da$var$AnalyticsContext;


var $d1b3315ddbeb9ff3$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $06e8fc615885301a$export$2e2bcd8739ae039) || (0, $137Lh.fg)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36232c276cc489da$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $424f1f90d90f725a$export$2e2bcd8739ae039), props);
};
var $d1b3315ddbeb9ff3$export$2e2bcd8739ae039 = $d1b3315ddbeb9ff3$var$ExportedAnalyticsContext;


var $51b02fe1f88ea77f$var$createNamespaceContext = function createNamespaceContext(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NamespacedContext';
    var Component = function Component(props) {
        var newData = (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, namespace, props.data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d1b3315ddbeb9ff3$export$2e2bcd8739ae039), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $51b02fe1f88ea77f$export$2e2bcd8739ae039 = $51b02fe1f88ea77f$var$createNamespaceContext;


var $92449e234712a663$export$80450e0a84a5ede9 = 'fabricElementsCtx';
var $92449e234712a663$export$3fe25500478a635c = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($92449e234712a663$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');



var $75c91c4e13a5796f$export$1fd3aad76a7c6788 = 'navigationCtx';
var $75c91c4e13a5796f$export$d0a82da1a0b94929 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($75c91c4e13a5796f$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');



var $dece67ad20480118$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $dece67ad20480118$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
var $dece67ad20480118$export$629cada6c5e621e1 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($dece67ad20480118$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');


// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
var $06d3d62c85491d72$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx



var $2fc8b49ff098c068$export$b326383bee6cb993 = 'peopleTeamsCtx';
var $2fc8b49ff098c068$export$4119ddb38ccbfb87 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($2fc8b49ff098c068$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');



var $0cc0ff1d3627d52c$export$da1befb791e93c7e = 'NotificationsCtx';
var $0cc0ff1d3627d52c$export$6f8e7ff1e3feafd7 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($0cc0ff1d3627d52c$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');



var $ed34bad4a7536512$export$fc7a65795610cb71 = 'RecentWorkCtx';
var $ed34bad4a7536512$export$745926731087ebe2 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($ed34bad4a7536512$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');



var $8f85cfeb0afc43d1$export$4906017439f33fc0 = 'atlasCtx';
var $8f85cfeb0afc43d1$export$43ebbe41370d4543 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($8f85cfeb0afc43d1$export$4906017439f33fc0, 'AtlasAnalyticsContext');



var $351aeee377de9bdb$export$3240443bf2b83834 = 'linkingPlatformCtx';
var $351aeee377de9bdb$export$6d568da622ce0a08 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($351aeee377de9bdb$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');



var $9b125f9bd5397833$export$ef0c05448f0f8f9 = 'postOfficeCtx';
var $9b125f9bd5397833$export$dcd232f3be312f94 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($9b125f9bd5397833$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');



var $92180eac3dc28435$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
var $92180eac3dc28435$export$de3826c30468da26 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($92180eac3dc28435$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');



var $32512ad48756675a$export$c2a811a4e42f4af5 = 'avpCtx';
var $32512ad48756675a$export$da383e8879a25b03 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($32512ad48756675a$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');



var $599df8b65ae97955$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
var $599df8b65ae97955$export$84980182680018f = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($599df8b65ae97955$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');




/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $d7df1392c2cb1415$export$4b84fd0e2c617bd = '#FFEBE6';
var $d7df1392c2cb1415$export$b34b069eff244586 = '#FFBDAD';
var $d7df1392c2cb1415$export$be802dd0d8b57f35 = '#FF8F73';
var $d7df1392c2cb1415$export$60847d42f9da92a6 = '#FF7452';
var $d7df1392c2cb1415$export$4a7404f376229999 = '#FF5630';
var $d7df1392c2cb1415$export$2010d0fb4295b346 = '#DE350B';
var $d7df1392c2cb1415$export$2837b5a1a71d5c02 = '#BF2600';
var $d7df1392c2cb1415$export$8d9596b529bbb9cf = '#FFFAE6';
var $d7df1392c2cb1415$export$41060a744ab0b7ae = '#FFF0B3';
var $d7df1392c2cb1415$export$1cc05bbbf340e559 = '#FFE380';
var $d7df1392c2cb1415$export$5aae31392d72caaa = '#FFC400';
var $d7df1392c2cb1415$export$c6930421db9fa514 = '#FFAB00';
var $d7df1392c2cb1415$export$59619663aa6500fb = '#FF991F';
var $d7df1392c2cb1415$export$874739ea9e379ab6 = '#FF8B00';
var $d7df1392c2cb1415$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $d7df1392c2cb1415$export$69a3bf21b9686c2b = '#ABF5D1';
var $d7df1392c2cb1415$export$afbce1382ec95f73 = '#79F2C0';
var $d7df1392c2cb1415$export$747d86715d4175de = '#57D9A3';
var $d7df1392c2cb1415$export$940e1f69e873f202 = '#36B37E';
var $d7df1392c2cb1415$export$a49394138f7b8e85 = '#00875A';
var $d7df1392c2cb1415$export$6fa04827ac68a4fb = '#006644';
var $d7df1392c2cb1415$export$226de0355ed012f8 = '#DEEBFF';
var $d7df1392c2cb1415$export$8c13c2ee36917869 = '#B3D4FF';
var $d7df1392c2cb1415$export$ecfc1dff386a3e7a = '#4C9AFF';
var $d7df1392c2cb1415$export$215b7063051591f1 = '#2684FF';
var $d7df1392c2cb1415$export$e62e8919cca44969 = '#0065FF';
var $d7df1392c2cb1415$export$b3de0ae08da2ce64 = '#0052CC';
var $d7df1392c2cb1415$export$a6ee3d71bc067634 = '#0747A6';
var $d7df1392c2cb1415$export$67f15409e87642a1 = '#669DF1';
var $d7df1392c2cb1415$export$f0539dbc42dbb067 = '#8FB8F6';
var $d7df1392c2cb1415$export$363e4475840015bb = '#EAE6FF';
var $d7df1392c2cb1415$export$4b0a4417ed59760f = '#C0B6F2';
var $d7df1392c2cb1415$export$6011520a64d9a187 = '#998DD9';
var $d7df1392c2cb1415$export$a7175d4e9206bc80 = '#8777D9';
var $d7df1392c2cb1415$export$b48405b95304b5a1 = '#6554C0';
var $d7df1392c2cb1415$export$c71e4279dd54a18d = '#5243AA';
var $d7df1392c2cb1415$export$147899de772240ec = '#403294';
var $d7df1392c2cb1415$export$2cf711fe14c66f06 = '#E6FCFF';
var $d7df1392c2cb1415$export$7a8f4d33f6f9772c = '#B3F5FF';
var $d7df1392c2cb1415$export$776c9c497ef08533 = '#79E2F2';
var $d7df1392c2cb1415$export$69cb3ca10c1e330e = '#00C7E6';
var $d7df1392c2cb1415$export$9dc1ef0f3f48059b = '#00B8D9';
var $d7df1392c2cb1415$export$7c835c78b6fcdef8 = '#00A3BF';
var $d7df1392c2cb1415$export$6036577f95c3877e = '#008DA6';
var $d7df1392c2cb1415$export$29a4f05edc054374 = '#FFFFFF';
var $d7df1392c2cb1415$export$e655ef011c4aa1a2 = '#FAFBFC';
var $d7df1392c2cb1415$export$9fdfb749e33cdf97 = '#F4F5F7';
var $d7df1392c2cb1415$export$3e51e8f1440314ba = '#EBECF0';
var $d7df1392c2cb1415$export$1ce2d1575d444ceb = '#DFE1E6';
var $d7df1392c2cb1415$export$8754fc7e6d8b3000 = '#C1C7D0';
var $d7df1392c2cb1415$export$c2e91cbeada39b8b = '#B3BAC5';
var $d7df1392c2cb1415$export$5f71e19f3a7ad9de = '#A5ADBA';
var $d7df1392c2cb1415$export$eaa8c8a70ac22806 = '#97A0AF';
var $d7df1392c2cb1415$export$7c87d337fb91a97d = '#8993A4';
var $d7df1392c2cb1415$export$d6447c357493214f = '#7A869A';
var $d7df1392c2cb1415$export$f563ee71e9ee74cd = '#6B778C';
var $d7df1392c2cb1415$export$e2ef2124cf4024b1 = '#5E6C84';
var $d7df1392c2cb1415$export$eece5f492e429f08 = '#505F79';
var $d7df1392c2cb1415$export$c39c0fe0f26207ae = '#42526E';
var $d7df1392c2cb1415$export$7090862dc3038a9f = '#344563';
var $d7df1392c2cb1415$export$ad0bacf983b7ddaa = '#253858';
var $d7df1392c2cb1415$export$7d61b15e0da132af = '#172B4D';
var $d7df1392c2cb1415$export$fbda843f0a27fe96 = '#091E42';
var $d7df1392c2cb1415$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $d7df1392c2cb1415$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $d7df1392c2cb1415$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $d7df1392c2cb1415$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $d7df1392c2cb1415$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $d7df1392c2cb1415$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $d7df1392c2cb1415$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $d7df1392c2cb1415$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $d7df1392c2cb1415$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $d7df1392c2cb1415$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $d7df1392c2cb1415$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $d7df1392c2cb1415$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $d7df1392c2cb1415$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $d7df1392c2cb1415$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $d7df1392c2cb1415$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $d7df1392c2cb1415$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $d7df1392c2cb1415$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $d7df1392c2cb1415$export$2f6319cf7d736c2a = '#E6EDFA';
var $d7df1392c2cb1415$export$95126bc8884d6634 = '#DCE5F5';
var $d7df1392c2cb1415$export$8338d8c35d44ff1 = '#CED9EB';
var $d7df1392c2cb1415$export$5368d76ae4fbbda7 = '#B8C7E0';
var $d7df1392c2cb1415$export$9f0a771d16ec8d36 = '#ABBBD6';
var $d7df1392c2cb1415$export$abcf8c38338b4aa5 = '#9FB0CC';
var $d7df1392c2cb1415$export$97e81faa16a182c7 = '#8C9CB8';
var $d7df1392c2cb1415$export$bfe21c59123ecf33 = '#7988A3';
var $d7df1392c2cb1415$export$ee82aa2ea6a1558 = '#67758F';
var $d7df1392c2cb1415$export$682927c6ed76be02 = '#56637A';
var $d7df1392c2cb1415$export$91fd9994c5be9757 = '#455166';
var $d7df1392c2cb1415$export$d281fbfe3cff2df6 = '#3B475C';
var $d7df1392c2cb1415$export$3902c91d8b98a753 = '#313D52';
var $d7df1392c2cb1415$export$8e8133c1ba5845b5 = '#283447';
var $d7df1392c2cb1415$export$33ff357f6620b39 = '#202B3D';
var $d7df1392c2cb1415$export$633847cf062b69e0 = '#1B2638';
var $d7df1392c2cb1415$export$9776a6e503bdbf76 = '#121A29';
var $d7df1392c2cb1415$export$6c813d5160dff5db = '#0E1624';
var $d7df1392c2cb1415$export$3d4f271a500072a = '#0D1424';
var $d7df1392c2cb1415$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $d7df1392c2cb1415$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $d7df1392c2cb1415$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $d7df1392c2cb1415$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $d7df1392c2cb1415$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $d7df1392c2cb1415$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $d7df1392c2cb1415$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $d7df1392c2cb1415$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $d7df1392c2cb1415$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $d7df1392c2cb1415$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $d7df1392c2cb1415$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $d7df1392c2cb1415$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $d7df1392c2cb1415$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $d7df1392c2cb1415$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $d7df1392c2cb1415$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $d7df1392c2cb1415$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $d7df1392c2cb1415$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $d7df1392c2cb1415$export$d2adc5dedf09fced = '#292A2E';
var $d7df1392c2cb1415$export$f51762073d2bb381 = '#94C748';
var $d7df1392c2cb1415$export$95e26d54def96891 = '#B3DF72';


var $09cd32ac24fc7bec$export$30fa7cc5f2690a43 = 56;
var $09cd32ac24fc7bec$export$4033a111ca79977d = 1280;
var $09cd32ac24fc7bec$export$24ec62cee78b7042 = 1130;
var $09cd32ac24fc7bec$export$d8bde68ac946124f = '--ds--ans--fbc';
var $09cd32ac24fc7bec$export$73e44f54603a0964 = '--ds--ans--hbgc';
var $09cd32ac24fc7bec$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
var $09cd32ac24fc7bec$export$d81606c1fc5119bc = '--ds--ans--c';
var $09cd32ac24fc7bec$export$65f656ad520ea71 = '--ds--ans--bc';





var $j9spr = parcelRequire("j9spr");

var $8MJe2 = parcelRequire("8MJe2");
function $c48d08609c4efffc$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $c48d08609c4efffc$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $c48d08609c4efffc$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $c48d08609c4efffc$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $c48d08609c4efffc$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $c48d08609c4efffc$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $c48d08609c4efffc$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $c48d08609c4efffc$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $c48d08609c4efffc$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $c48d08609c4efffc$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $c48d08609c4efffc$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $c48d08609c4efffc$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $c48d08609c4efffc$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $c48d08609c4efffc$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $c48d08609c4efffc$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $c48d08609c4efffc$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $c48d08609c4efffc$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $c48d08609c4efffc$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $c48d08609c4efffc$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $c48d08609c4efffc$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $c48d08609c4efffc$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $c48d08609c4efffc$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $c48d08609c4efffc$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $c48d08609c4efffc$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $c48d08609c4efffc$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $c48d08609c4efffc$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $c48d08609c4efffc$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $c48d08609c4efffc$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $c48d08609c4efffc$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $c48d08609c4efffc$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $c48d08609c4efffc$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $c48d08609c4efffc$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $c48d08609c4efffc$var$fromHex_1 = $c48d08609c4efffc$var$fromHex, $c48d08609c4efffc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $c48d08609c4efffc$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $c48d08609c4efffc$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $c48d08609c4efffc$var$fromRgb_1 = $c48d08609c4efffc$var$fromRgb, $c48d08609c4efffc$var$fromCssRgb_1 = $c48d08609c4efffc$var$fromCssRgb, $c48d08609c4efffc$var$fromHsl_1 = $c48d08609c4efffc$var$fromHsl, $c48d08609c4efffc$var$fromCssHsl_1 = $c48d08609c4efffc$var$fromCssHsl, $c48d08609c4efffc$var$fromHsv_1 = $c48d08609c4efffc$var$fromHsv, $c48d08609c4efffc$var$fromCmyk_1 = $c48d08609c4efffc$var$fromCmyk, $c48d08609c4efffc$var$fromYiq_1 = $c48d08609c4efffc$var$fromYiq, $c48d08609c4efffc$var$fromXYZ_1 = $c48d08609c4efffc$var$fromXYZ, $c48d08609c4efffc$var$fromxyY_1 = $c48d08609c4efffc$var$fromxyY, $c48d08609c4efffc$var$fromLms_1 = $c48d08609c4efffc$var$fromLms, $c48d08609c4efffc$var$fromCieLab_1 = $c48d08609c4efffc$var$fromCieLab, $c48d08609c4efffc$var$fromCieLuv_1 = $c48d08609c4efffc$var$fromCieLuv, $c48d08609c4efffc$var$fromCieLch_1 = $c48d08609c4efffc$var$fromCieLch, $c48d08609c4efffc$var$fromHsluv = $c48d08609c4efffc$var$fromCieLch$1, $c48d08609c4efffc$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $c48d08609c4efffc$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $c48d08609c4efffc$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $c48d08609c4efffc$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromHsluv
    }
}, $c48d08609c4efffc$var$adapt_1 = $c48d08609c4efffc$var$adapt, $c48d08609c4efffc$var$adjacent_1 = $c48d08609c4efffc$var$adjacent, $c48d08609c4efffc$var$brightness_1 = $c48d08609c4efffc$var$brightness, $c48d08609c4efffc$var$complementary_1 = $c48d08609c4efffc$var$complementary, $c48d08609c4efffc$var$contrast_1 = $c48d08609c4efffc$var$contrast, $c48d08609c4efffc$var$contrastRatio_1 = $c48d08609c4efffc$var$contrastRatio, $c48d08609c4efffc$var$convert_1 = $c48d08609c4efffc$var$convert, $c48d08609c4efffc$var$difference_1 = $c48d08609c4efffc$var$difference, $c48d08609c4efffc$var$fade_1 = $c48d08609c4efffc$var$fade, $c48d08609c4efffc$var$greyscale_1 = $c48d08609c4efffc$var$greyscale, $c48d08609c4efffc$var$hue_1 = $c48d08609c4efffc$var$hue, $c48d08609c4efffc$var$invert_1 = $c48d08609c4efffc$var$invert, $c48d08609c4efffc$var$invertLightness_1 = $c48d08609c4efffc$var$invertLightness, $c48d08609c4efffc$var$mid_1 = $c48d08609c4efffc$var$mid, $c48d08609c4efffc$var$multiply_1 = $c48d08609c4efffc$var$multiply, $c48d08609c4efffc$var$saturation_1 = $c48d08609c4efffc$var$saturation, $c48d08609c4efffc$var$sepia_1 = $c48d08609c4efffc$var$sepia, $c48d08609c4efffc$var$shade_1 = $c48d08609c4efffc$var$shade, $c48d08609c4efffc$var$temperature_1 = $c48d08609c4efffc$var$temperature, $c48d08609c4efffc$var$tetrad_1 = $c48d08609c4efffc$var$tetrad, $c48d08609c4efffc$var$triad_1 = $c48d08609c4efffc$var$triad, $c48d08609c4efffc$var$index$2 = {
    adapt: $c48d08609c4efffc$var$adapt_1,
    adjacent: $c48d08609c4efffc$var$adjacent_1,
    brightness: $c48d08609c4efffc$var$brightness_1,
    complementary: $c48d08609c4efffc$var$complementary_1,
    contrast: $c48d08609c4efffc$var$contrast_1,
    contrastRatio: $c48d08609c4efffc$var$contrastRatio_1,
    convert: $c48d08609c4efffc$var$convert_1,
    difference: $c48d08609c4efffc$var$difference_1,
    fade: $c48d08609c4efffc$var$fade_1,
    greyscale: $c48d08609c4efffc$var$greyscale_1,
    hue: $c48d08609c4efffc$var$hue_1,
    invert: $c48d08609c4efffc$var$invert_1,
    invertLightness: $c48d08609c4efffc$var$invertLightness_1,
    mid: $c48d08609c4efffc$var$mid_1,
    multiply: $c48d08609c4efffc$var$multiply_1,
    saturation: $c48d08609c4efffc$var$saturation_1,
    sepia: $c48d08609c4efffc$var$sepia_1,
    shade: $c48d08609c4efffc$var$shade_1,
    temperature: $c48d08609c4efffc$var$temperature_1,
    tetrad: $c48d08609c4efffc$var$tetrad_1,
    triad: $c48d08609c4efffc$var$triad_1
}, $c48d08609c4efffc$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $c48d08609c4efffc$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $c48d08609c4efffc$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($c48d08609c4efffc$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $c48d08609c4efffc$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($c48d08609c4efffc$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $c48d08609c4efffc$var$api_1 = $c48d08609c4efffc$var$api, $c48d08609c4efffc$var$helpers = {
    getIlluminant: function(r) {
        return $c48d08609c4efffc$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $c48d08609c4efffc$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $c48d08609c4efffc$var$index)if ($c48d08609c4efffc$var$index.hasOwnProperty(e) && $c48d08609c4efffc$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $c48d08609c4efffc$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $c48d08609c4efffc$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $c48d08609c4efffc$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $c48d08609c4efffc$var$constants, s));
            default:
                return null;
        }
    }
}, $c48d08609c4efffc$var$helpers_1 = $c48d08609c4efffc$var$helpers, $c48d08609c4efffc$var$dependencies = {
    conversions: $c48d08609c4efffc$var$index,
    operations: $c48d08609c4efffc$var$index$2,
    helpers: $c48d08609c4efffc$var$helpers_1
}, $c48d08609c4efffc$var$entry = $c48d08609c4efffc$var$api_1($c48d08609c4efffc$var$dependencies, $c48d08609c4efffc$var$constants);
var $c48d08609c4efffc$export$2e2bcd8739ae039 = $c48d08609c4efffc$var$entry;


function $edabe14e35d9cc15$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $edabe14e35d9cc15$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $edabe14e35d9cc15$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $edabe14e35d9cc15$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $edabe14e35d9cc15$export$7229be6d7219ee6a = function hexToRGBA(hex) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var rgba = $edabe14e35d9cc15$var$_objectSpread($edabe14e35d9cc15$var$_objectSpread({}, (0, $c48d08609c4efffc$export$2e2bcd8739ae039).convert(hex).rgb), {
        a: opacity
    });
    return "rgba(".concat(Object.values(rgba).join(', '), ")");
};
var $edabe14e35d9cc15$export$bba5a971afe05444 = function getBoxShadow(color) {
    return "0 0 0 2px ".concat(color);
};
var $edabe14e35d9cc15$var$hex = '[a-z0-9]';
var $edabe14e35d9cc15$var$shortHandHexColorPattern = new RegExp("#(".concat($edabe14e35d9cc15$var$hex, ")(").concat($edabe14e35d9cc15$var$hex, ")(").concat($edabe14e35d9cc15$var$hex, ")"), 'i');
var $edabe14e35d9cc15$var$repeat = function repeat(str, times) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(Array(times)).map(function() {
        return str;
    }).join('');
};
var $edabe14e35d9cc15$var$isShortHexColor = function isShortHexColor(color) {
    return color && color.length === 4;
};
var $edabe14e35d9cc15$var$completeHexColor = function completeHexColor(colors) {
    var hex = colors.map(function(color) {
        return $edabe14e35d9cc15$var$repeat(color, 2);
    }).join('');
    return "#".concat(hex);
};
var $edabe14e35d9cc15$var$completeTriplet = function completeTriplet(colors) {
    return "#".concat($edabe14e35d9cc15$var$repeat(colors[1], 6));
};
var $edabe14e35d9cc15$var$isTriplet = function isTriplet(colors) {
    return colors[0] === colors[1] && colors[1] === colors[2];
};
var $edabe14e35d9cc15$export$db8d2130677f868c = function convertHexShorthand(color) {
    if ($edabe14e35d9cc15$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        var matches = color.match($edabe14e35d9cc15$var$shortHandHexColorPattern);
        if (matches) {
            var colors = matches.slice(1, 4);
            if ($edabe14e35d9cc15$var$isTriplet(colors)) return $edabe14e35d9cc15$var$completeTriplet(colors);
            else return $edabe14e35d9cc15$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
var $edabe14e35d9cc15$export$10a10e7cd1193377 = function generateTextColor(color) {
    var converted = $edabe14e35d9cc15$export$db8d2130677f868c(color);
    return (0, $c48d08609c4efffc$export$2e2bcd8739ae039).contrastRatio(converted).hex;
};
var $edabe14e35d9cc15$export$77a1051494882576 = function getContrastColor(contrastValue, opacityValue, color) {
    return $edabe14e35d9cc15$export$7229be6d7219ee6a((0, $c48d08609c4efffc$export$2e2bcd8739ae039).contrast(contrastValue, color).hex, opacityValue);
};


var $fb54c92546ddb49f$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, ".concat((0, $d7df1392c2cb1415$export$29a4f05edc054374), ")"),
                backgroundColor: "var(--ds-background-brand-bold-pressed, ".concat((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), 0.8), ")"),
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, ".concat((0, $d7df1392c2cb1415$export$29a4f05edc054374), ")"),
                backgroundColor: "var(--ds-background-brand-bold, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")"),
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, ".concat((0, $d7df1392c2cb1415$export$29a4f05edc054374), ")"),
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, ".concat((0, $d7df1392c2cb1415$export$29a4f05edc054374), ")"),
                backgroundColor: "var(--ds-background-brand-bold-hovered, ".concat((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), 0.9), ")"),
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)((0, $d7df1392c2cb1415$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $d7df1392c2cb1415$export$7090862dc3038a9f), ")"),
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $d7df1392c2cb1415$export$7090862dc3038a9f), ")"),
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)((0, $d7df1392c2cb1415$export$226de0355ed012f8), 0.9), ")"),
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)((0, $d7df1392c2cb1415$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)((0, $d7df1392c2cb1415$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, ".concat((0, $d7df1392c2cb1415$export$29a4f05edc054374), ")"),
            color: "var(--ds-text-subtlest, ".concat((0, $d7df1392c2cb1415$export$f563ee71e9ee74cd), ")")
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")"),
            color: "var(--ds-text, ".concat((0, $d7df1392c2cb1415$export$ad0bacf983b7ddaa), ")"),
            borderRight: "1px solid ".concat("var(--ds-border, ".concat((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)((0, $d7df1392c2cb1415$export$f563ee71e9ee74cd), 0.3), ")")),
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, ".concat((0, $d7df1392c2cb1415$export$ad0bacf983b7ddaa), ")")
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)((0, $d7df1392c2cb1415$export$226de0355ed012f8), 0.7), ")"),
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $d7df1392c2cb1415$export$7090862dc3038a9f), ")"),
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $d7df1392c2cb1415$export$7090862dc3038a9f), ")"),
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)((0, $d7df1392c2cb1415$export$226de0355ed012f8), 0.9), ")"),
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)((0, $d7df1392c2cb1415$export$226de0355ed012f8), 0.7), ")"),
                boxShadow: '',
                borderColor: "var(--ds-border-selected, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")")
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)((0, $d7df1392c2cb1415$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: '',
                borderColor: "var(--ds-border-selected, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")")
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, ".concat((0, $d7df1392c2cb1415$export$29a4f05edc054374), ")"),
                color: "var(--ds-text-subtlest, ".concat((0, $d7df1392c2cb1415$export$f563ee71e9ee74cd), ")"),
                borderColor: "var(--ds-border-input, ".concat((0, $d7df1392c2cb1415$export$d6447c357493214f), ")")
            },
            focus: {
                borderColor: "var(--ds-border-focused, ".concat((0, $d7df1392c2cb1415$export$215b7063051591f1), ")")
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, ".concat((0, $d7df1392c2cb1415$export$29a4f05edc054374), ")")
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, ".concat((0, $d7df1392c2cb1415$export$9fdfb749e33cdf97), ")"),
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
var $fb54c92546ddb49f$var$defaultThemeCopy = JSON.parse(JSON.stringify($fb54c92546ddb49f$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$fb54c92546ddb49f$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$fb54c92546ddb49f$var$defaultThemeCopy.mode.productHome.textColor = undefined;
var $fb54c92546ddb49f$export$77823bc9863eaa03 = $fb54c92546ddb49f$var$defaultThemeCopy;
var $fb54c92546ddb49f$export$2491e13b198e597d = 'atlassian';
var $fb54c92546ddb49f$export$2e2bcd8739ae039 = $fb54c92546ddb49f$var$defaultTheme;



var $8MJe2 = parcelRequire("8MJe2");

var $137Lh = parcelRequire("137Lh");


function $4217f8c937eca669$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4217f8c937eca669$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4217f8c937eca669$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4217f8c937eca669$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4217f8c937eca669$var$generateOpacityValue = function generateOpacityValue(color) {
    return color === '#000000' ? 0.3 : 0.6;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $4217f8c937eca669$var$generateButtonCSSStates = function generateButtonCSSStates(colors, buttonType) {
    var backgroundColor = colors.backgroundColor, color = colors.color, highlightColor = colors.highlightColor;
    // Add less opacity for white text so it is still legible.
    var opacityValue = $4217f8c937eca669$var$generateOpacityValue(color);
    var isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $edabe14e35d9cc15$export$7229be6d7219ee6a)(backgroundColor, 0.65) : (0, $edabe14e35d9cc15$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $edabe14e35d9cc15$export$bba5a971afe05444)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $edabe14e35d9cc15$export$bba5a971afe05444)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $edabe14e35d9cc15$export$7229be6d7219ee6a)(backgroundColor, 0.8) : (0, $edabe14e35d9cc15$export$77a1051494882576)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $edabe14e35d9cc15$export$bba5a971afe05444)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $edabe14e35d9cc15$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $edabe14e35d9cc15$export$bba5a971afe05444)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $edabe14e35d9cc15$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $edabe14e35d9cc15$export$bba5a971afe05444)('transparent')
        }
    };
};
var $4217f8c937eca669$var$generateCreateButtonColors = function generateCreateButtonColors(themeBackground, themeHighlight) {
    return {
        backgroundColor: themeHighlight,
        color: (0, $edabe14e35d9cc15$export$10a10e7cd1193377)(themeHighlight),
        highlightColor: themeHighlight
    };
};
var $4217f8c937eca669$export$2e4ecffaca289a18 = function generateTheme(themeColors) {
    var backgroundColor = themeColors.backgroundColor, highlightColor = themeColors.highlightColor, name = themeColors.name;
    var color = (0, $edabe14e35d9cc15$export$10a10e7cd1193377)(backgroundColor);
    var colors = $4217f8c937eca669$var$_objectSpread($4217f8c937eca669$var$_objectSpread({}, themeColors), {}, {
        color: color
    });
    if (name === (0, $fb54c92546ddb49f$export$2491e13b198e597d)) return (0, $137Lh.fg)('platform-team25-app-icon-tiles') ? (0, $fb54c92546ddb49f$export$77823bc9863eaa03) : (0, $fb54c92546ddb49f$export$2e2bcd8739ae039);
    return {
        mode: {
            create: $4217f8c937eca669$var$generateButtonCSSStates($4217f8c937eca669$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $4217f8c937eca669$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $4217f8c937eca669$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: (0, $137Lh.fg)('platform-team25-app-icon-tiles') ? color : undefined,
                textColor: (0, $137Lh.fg)('platform-team25-app-icon-tiles') ? color : undefined,
                backgroundColor: highlightColor,
                borderRight: "1px solid ".concat((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)(color, 0.5))
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $edabe14e35d9cc15$export$7229be6d7219ee6a)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $edabe14e35d9cc15$export$7229be6d7219ee6a)(highlightColor, 0.8),
                    boxShadow: (0, $edabe14e35d9cc15$export$bba5a971afe05444)((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $edabe14e35d9cc15$export$77a1051494882576)(0.1, $4217f8c937eca669$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};


var $2c11322889abbfcf$export$eeee8619e1b91cb0 = (0, $4217f8c937eca669$export$2e4ecffaca289a18)({
    name: (0, $fb54c92546ddb49f$export$2491e13b198e597d),
    backgroundColor: (0, $d7df1392c2cb1415$export$29a4f05edc054374),
    highlightColor: (0, $d7df1392c2cb1415$export$b3de0ae08da2ce64)
});
var $2c11322889abbfcf$export$164de7ab8df77ef0 = $2c11322889abbfcf$export$eeee8619e1b91cb0;


var $7fPBF = parcelRequire("7fPBF");

var $a2fb43746167a532$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $7fPBF.createContext)((0, $2c11322889abbfcf$export$164de7ab8df77ef0));
var $a2fb43746167a532$export$d8964aec282183a3 = $a2fb43746167a532$export$2c657da244d00bd6.Provider;



var $cvBp9 = parcelRequire("cvBp9");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

/* popup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");
var $d4d502868e612e1e$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $d4d502868e612e1e$var$react18UseId = ($d4d502868e612e1e$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId) !== null && $d4d502868e612e1e$var$_React$useId !== void 0 ? $d4d502868e612e1e$var$_React$useId : undefined;
function $d4d502868e612e1e$export$f680877a34711e37() {
    if ($d4d502868e612e1e$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $d4d502868e612e1e$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $e9144a1b4dc9c62e$export$87d05f07e65211f1)());
}
var $d4d502868e612e1e$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($d4d502868e612e1e$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $d4d502868e612e1e$export$6ee17796e3d70de2() {
    if ($d4d502868e612e1e$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $d4d502868e612e1e$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $e9144a1b4dc9c62e$export$bb5ca5fba6fb4f1f)();
}



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $f48d740006cf3f7d$export$2e2bcd8739ae039() {}



var $137Lh = parcelRequire("137Lh");
function $928dd3962972af3c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $928dd3962972af3c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $928dd3962972af3c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $928dd3962972af3c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $928dd3962972af3c$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $7fPBF.createContext)(0);
var $928dd3962972af3c$export$48b383b280e20440 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $928dd3962972af3c$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $7fPBF.useContext)($928dd3962972af3c$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $7fPBF.useRef)((0, $137Lh.fg)('layering-top-level-use-array') ? Math.random().toString(36) : '');
    if (!(0, $137Lh.fg)('layering-top-level-use-array')) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $137Lh.fg)('layering-top-level-use-array')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7fPBF.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $137Lh.fg)('layering-top-level-use-array')) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7fPBF.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($928dd3962972af3c$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $928dd3962972af3c$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $7fPBF.useRef)(0);
    var layerList = (0, $7fPBF.useRef)([]);
    var value = (0, $7fPBF.useMemo)(function() {
        return $928dd3962972af3c$var$_objectSpread({
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        }, (0, $137Lh.fg)('layering-top-level-use-array') ? {
            layerList: layerList
        } : {});
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($928dd3962972af3c$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $928dd3962972af3c$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $7fPBF.useContext)($928dd3962972af3c$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($928dd3962972af3c$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($928dd3962972af3c$var$LayeringProvider, null, content);
};



var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

var $7fPBF = parcelRequire("7fPBF");
var $3cb1561d4943fc60$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $3c61f8857d97b8d2$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


function $94e39b5e33fdb909$export$1d57e79091cc3046() {
    var namespace = (0, $7fPBF.useContext)((0, $3c61f8857d97b8d2$export$644a49f3b8c50fcd));
    return namespace;
}


function $0a30dd083eb527d5$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    var context = (0, $7fPBF.useContext)((0, $3cb1561d4943fc60$export$5fbf4d7fae6cdc00));
    var namespace = (0, $94e39b5e33fdb909$export$1d57e79091cc3046)();
    (0, $7fPBF.useEffect)(function() {
        if ((0, $137Lh.fg)('platform_dst_open_layer_observer_close_layers')) return;
        /**
     * Increments the layer count when the component mounts or becomes visible.
     *
     * Returns a cleanup function to decrement the layer count when the component unmounts or becomes hidden.
     */ if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function cleanup() {
            context.decrement();
        };
    }, [
        context,
        isOpen,
        namespace
    ]);
    (0, $7fPBF.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (!(0, $137Lh.fg)('platform_dst_open_layer_observer_close_layers')) return;
        if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}



var $137Lh = parcelRequire("137Lh");

var $7fPBF = parcelRequire("7fPBF");
var $946cf4462dcf0c84$export$3dbd3405086fec7b = $7fPBF.createContext();
var $946cf4462dcf0c84$export$cbabb21c2529b130 = $7fPBF.createContext();
function $946cf4462dcf0c84$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $7fPBF.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $7fPBF.useRef(false);
    $7fPBF.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $7fPBF.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $7fPBF.createElement($946cf4462dcf0c84$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $7fPBF.createElement($946cf4462dcf0c84$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}


var $7fPBF = parcelRequire("7fPBF");
var $4ceddc5ee7e9d694$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $4ceddc5ee7e9d694$var$__DEV__ = false;
var $4ceddc5ee7e9d694$var$warning = function() {};
if ($4ceddc5ee7e9d694$var$__DEV__) {
    var $4ceddc5ee7e9d694$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $4ceddc5ee7e9d694$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $4ceddc5ee7e9d694$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$4ceddc5ee7e9d694$exports = $4ceddc5ee7e9d694$var$warning;




var $7fPBF = parcelRequire("7fPBF");
var $102370a2b7376d38$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $102370a2b7376d38$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $102370a2b7376d38$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $102370a2b7376d38$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $102370a2b7376d38$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $102370a2b7376d38$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;


function $707082bb5d4c97c5$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $7fPBF.useContext((0, $946cf4462dcf0c84$export$cbabb21c2529b130));
    var refHandler = $7fPBF.useCallback(function(node) {
        (0, $102370a2b7376d38$export$4bb192c7cacf928f)(innerRef, node);
        (0, $102370a2b7376d38$export$3dfa7c28635fe028)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $7fPBF.useEffect(function() {
        return function() {
            return (0, $102370a2b7376d38$export$4bb192c7cacf928f)(innerRef, null);
        };
    }, []);
    $7fPBF.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4ceddc5ee7e9d694$exports)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $102370a2b7376d38$export$f52c55943429c8b6)(children)({
        ref: refHandler
    });
}



var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

var $7fPBF = parcelRequire("7fPBF");

var $75cdcdc2da9c0e51$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $75cdcdc2da9c0e51$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $75cdcdc2da9c0e51$export$13f57c02915787b3 = 'atlaskit-portal';


var $a9940fa8ae3de95c$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $75cdcdc2da9c0e51$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $a9940fa8ae3de95c$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $a9940fa8ae3de95c$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $75cdcdc2da9c0e51$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $75cdcdc2da9c0e51$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $a9940fa8ae3de95c$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $a9940fa8ae3de95c$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $a9940fa8ae3de95c$var$getPortalParent().removeChild(container);
};
var $a9940fa8ae3de95c$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $a9940fa8ae3de95c$var$getPortalParent().appendChild(container);
};
var $a9940fa8ae3de95c$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $a9940fa8ae3de95c$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($a9940fa8ae3de95c$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $75cdcdc2da9c0e51$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $a9940fa8ae3de95c$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($a9940fa8ae3de95c$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $75cdcdc2da9c0e51$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $75cdcdc2da9c0e51$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody2 = $a9940fa8ae3de95c$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};


function $7a24f4f7e30ca6e7$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $7fPBF.useMemo)(function() {
        return (0, $a9940fa8ae3de95c$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $a9940fa8ae3de95c$export$c582005add11e141)(container);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            (0, $a9940fa8ae3de95c$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $b4ba1c853f6e1116$exports.createPortal)(children, container);
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $9c7b910eca0a2995$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);



function $051996d2d7dfd8a9$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $7fPBF.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $9c7b910eca0a2995$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $a9940fa8ae3de95c$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $a9940fa8ae3de95c$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $b4ba1c853f6e1116$exports.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $c0e3c3d3c75daccd$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $9c7b910eca0a2995$export$700979bc83e7db82) : (0, $7fPBF.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $c0e3c3d3c75daccd$export$2e2bcd8739ae039 = $c0e3c3d3c75daccd$var$useIsSubsequentRender;



var $7fPBF = parcelRequire("7fPBF");
var $404700fa29e60b98$export$ed5835cc67e87f72 = 'akPortalMount';
var $404700fa29e60b98$export$80816bd900e5bd00 = 'akPortalUnmount';


var $d1aeab223da49d71$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $d1aeab223da49d71$var$getLayerName = function getLayerName(zIndex) {
    return $d1aeab223da49d71$var$zIndexToName.hasOwnProperty(zIndex) ? $d1aeab223da49d71$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $d1aeab223da49d71$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $d1aeab223da49d71$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $d1aeab223da49d71$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $d1aeab223da49d71$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $39fedc8ce04b3295$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $7fPBF.useEffect)(function() {
        (0, $d1aeab223da49d71$export$2e2bcd8739ae039)((0, $404700fa29e60b98$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $d1aeab223da49d71$export$2e2bcd8739ae039)((0, $404700fa29e60b98$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $39fedc8ce04b3295$export$2e2bcd8739ae039 = $39fedc8ce04b3295$var$useFirePortalEvent;


function $cd3bc8368572caba$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $c0e3c3d3c75daccd$export$2e2bcd8739ae039)(mountStrategy);
    (0, $39fedc8ce04b3295$export$2e2bcd8739ae039)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $137Lh.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7a24f4f7e30ca6e7$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $051996d2d7dfd8a9$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}


/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $b3ce7373d625f468$var$ATOMIC_GROUP_LENGTH = 5;
function $b3ce7373d625f468$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $b3ce7373d625f468$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $7fPBF = parcelRequire("7fPBF");
var $9d3c172a59d72956$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $9d3c172a59d72956$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($9d3c172a59d72956$export$1ca2a26fecb070ae);
};
$9d3c172a59d72956$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $ceaf414db493dd15$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $ceaf414db493dd15$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $ceaf414db493dd15$var$baseStyles = null;
var $ceaf414db493dd15$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $ceaf414db493dd15$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $ceaf414db493dd15$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
var $ceaf414db493dd15$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $ceaf414db493dd15$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $ceaf414db493dd15$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $ceaf414db493dd15$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $ceaf414db493dd15$var$Box = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $ceaf414db493dd15$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $ceaf414db493dd15$var$_excluded2);
    var node = /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        style: style,
        ref: ref,
        className: (0, $b3ce7373d625f468$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $ceaf414db493dd15$var$backgroundColorMap[backgroundColor],
            backgroundColor && $ceaf414db493dd15$var$isSurfaceToken(backgroundColor) && $ceaf414db493dd15$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $ceaf414db493dd15$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $ceaf414db493dd15$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $ceaf414db493dd15$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $ceaf414db493dd15$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $7fPBF.createElement((0, $9d3c172a59d72956$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $ceaf414db493dd15$export$2e2bcd8739ae039 = $ceaf414db493dd15$var$Box;
function $ceaf414db493dd15$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $ceaf414db493dd15$var$setSurfaceTokenMap;
}


/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $j9spr = parcelRequire("j9spr");

var $iKdEz = parcelRequire("iKdEz");

var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
var $a091c25729a976b1$exports = {};
"use strict";
Object.defineProperty($a091c25729a976b1$exports, "__esModule", {
    value: true
});
$a091c25729a976b1$exports.bindAll = $a091c25729a976b1$exports.bind = void 0;
var $f0ddb24ec1b772be$exports = {};
"use strict";
Object.defineProperty($f0ddb24ec1b772be$exports, "__esModule", {
    value: true
});
$f0ddb24ec1b772be$exports.bind = void 0;
function $f0ddb24ec1b772be$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
$f0ddb24ec1b772be$exports.bind = $f0ddb24ec1b772be$var$bind;


Object.defineProperty($a091c25729a976b1$exports, "bind", {
    enumerable: true,
    get: function() {
        return $f0ddb24ec1b772be$exports.bind;
    }
});
var $1057e213ed66a122$exports = {};
"use strict";
var $1057e213ed66a122$var$__assign = $1057e213ed66a122$exports && $1057e213ed66a122$exports.__assign || function() {
    $1057e213ed66a122$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1057e213ed66a122$var$__assign.apply(this, arguments);
};
Object.defineProperty($1057e213ed66a122$exports, "__esModule", {
    value: true
});
$1057e213ed66a122$exports.bindAll = void 0;

function $1057e213ed66a122$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $1057e213ed66a122$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $1057e213ed66a122$var$__assign($1057e213ed66a122$var$__assign({}, original), {
        options: $1057e213ed66a122$var$__assign($1057e213ed66a122$var$__assign({}, $1057e213ed66a122$var$toOptions(sharedOptions)), $1057e213ed66a122$var$toOptions(original.options))
    });
    return binding;
}
function $1057e213ed66a122$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $1057e213ed66a122$var$getBinding(original, sharedOptions);
        return (0, $f0ddb24ec1b772be$exports.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
$1057e213ed66a122$exports.bindAll = $1057e213ed66a122$var$bindAll;


Object.defineProperty($a091c25729a976b1$exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $1057e213ed66a122$exports.bindAll;
    }
});



var $137Lh = parcelRequire("137Lh");

function $d2a040b34e70682b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d2a040b34e70682b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d2a040b34e70682b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d2a040b34e70682b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d2a040b34e70682b$var$ESCAPE = 'Escape';
function $d2a040b34e70682b$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $7fPBF.useRef)(false);
    var _useLayering = $d2a040b34e70682b$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $7fPBF.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $d2a040b34e70682b$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $7fPBF.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $7fPBF.useEffect)(function() {
        return (0, $a091c25729a976b1$exports.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $d2a040b34e70682b$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $7fPBF.useContext)((0, $928dd3962972af3c$export$650d12d3c2ddb8fc));
    var _useContext = (0, $7fPBF.useContext)((0, $928dd3962972af3c$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var isLayerDisabled = (0, $7fPBF.useCallback)(function() {
        if ((0, $137Lh.fg)('layering-top-level-use-array')) {
            var _layerList$current$le, _layerList$current;
            return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
        }
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return $d2a040b34e70682b$var$_objectSpread({
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    }, (0, $137Lh.fg)('layering-top-level-use-array') ? {
        layerList: layerList
    } : {});
}



var $137Lh = parcelRequire("137Lh");

var $j9spr = parcelRequire("j9spr");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");

function $5a7577945ba4d648$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $f3e95cf60f991b3e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f3e95cf60f991b3e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f3e95cf60f991b3e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $cb70389d1b75072d$export$8960430cfd85939f = Math.max;
var $cb70389d1b75072d$export$96ec731ed4dcb222 = Math.min;
var $cb70389d1b75072d$export$2077e0241d6afd3c = Math.round;



function $c76403bd29ed319a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b48f13af3862f004$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
}


function $e7afd89efa353b85$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b48f13af3862f004$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $e95acb4acf5ee909$export$2e2bcd8739ae039(node) {
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $6923eaccf7a43aef$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $fa62512f527d34a4$export$2e2bcd8739ae039(node) {
    if (node === (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node) || !(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(node)) return (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(node);
    else return (0, $6923eaccf7a43aef$export$2e2bcd8739ae039)(node);
}


function $b8ce8e5214ef2302$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $7d9656f011992b2b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e0a76d77d33c9d6e$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $e7afd89efa353b85$export$2e2bcd8739ae039)((0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element)).left + (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $3e40145ffd569d9c$export$2e2bcd8739ae039(element) {
    return (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $998896b7349c78b7$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $585037a155f95873$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $585037a155f95873$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent) && $585037a155f95873$var$isElementScaled(offsetParent);
    var documentElement = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $998896b7349c78b7$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $fa62512f527d34a4$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $790f3bf845b39e8e$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $9906540837c752ea$export$2e2bcd8739ae039(element) {
    if ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $1d462f2c86b4c65a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(node) && (0, $998896b7349c78b7$export$2e2bcd8739ae039)(node)) return node;
    return $1d462f2c86b4c65a$export$2e2bcd8739ae039((0, $9906540837c752ea$export$2e2bcd8739ae039)(node));
}





function $3d1bbe7c8c599173$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $1d462f2c86b4c65a$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $998896b7349c78b7$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($3d1bbe7c8c599173$export$2e2bcd8739ae039((0, $9906540837c752ea$export$2e2bcd8739ae039)(target)));
}







function $08ccc1de57d53c59$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) >= 0;
}




function $6ebea87f6f98e49c$var$getTrueOffsetParent(element) {
    if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $6ebea87f6f98e49c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
    if (isIE && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $9906540837c752ea$export$2e2bcd8739ae039)(element);
    if ((0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $6ebea87f6f98e49c$export$2e2bcd8739ae039(element) {
    var window = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element);
    var offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $08ccc1de57d53c59$export$2e2bcd8739ae039)(offsetParent) && (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $6ebea87f6f98e49c$var$getContainingBlock(element) || window;
}


var $7c96f63dd602b579$export$1e95b668f3b82d = 'top';
var $7c96f63dd602b579$export$40e543e69a8b3fbb = 'bottom';
var $7c96f63dd602b579$export$79ffe56a765070d2 = 'right';
var $7c96f63dd602b579$export$eabcd2c8791e7bf4 = 'left';
var $7c96f63dd602b579$export$dfb5619354ba860 = 'auto';
var $7c96f63dd602b579$export$aec2ce47c367b8c3 = [
    $7c96f63dd602b579$export$1e95b668f3b82d,
    $7c96f63dd602b579$export$40e543e69a8b3fbb,
    $7c96f63dd602b579$export$79ffe56a765070d2,
    $7c96f63dd602b579$export$eabcd2c8791e7bf4
];
var $7c96f63dd602b579$export$b3571188c770cc5a = 'start';
var $7c96f63dd602b579$export$bd5df0f255a350f8 = 'end';
var $7c96f63dd602b579$export$390fd549c5303b4d = 'clippingParents';
var $7c96f63dd602b579$export$d7b7311ec04a3e8f = 'viewport';
var $7c96f63dd602b579$export$ae5ab1c730825774 = 'popper';
var $7c96f63dd602b579$export$ca50aac9f3ba507f = 'reference';
var $7c96f63dd602b579$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7c96f63dd602b579$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []);
var $7c96f63dd602b579$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7c96f63dd602b579$export$aec2ce47c367b8c3, [
    $7c96f63dd602b579$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7c96f63dd602b579$export$421679a7c3d56e = 'beforeRead';
var $7c96f63dd602b579$export$aafa59e2e03f2942 = 'read';
var $7c96f63dd602b579$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $7c96f63dd602b579$export$c65e99957a05207c = 'beforeMain';
var $7c96f63dd602b579$export$f22da7240b7add18 = 'main';
var $7c96f63dd602b579$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7c96f63dd602b579$export$8d4d2d70e7d46032 = 'beforeWrite';
var $7c96f63dd602b579$export$68d8715fc104d294 = 'write';
var $7c96f63dd602b579$export$70a6e5159acce2e6 = 'afterWrite';
var $7c96f63dd602b579$export$d087d3878fdf71d5 = [
    $7c96f63dd602b579$export$421679a7c3d56e,
    $7c96f63dd602b579$export$aafa59e2e03f2942,
    $7c96f63dd602b579$export$6964f6c886723980,
    $7c96f63dd602b579$export$c65e99957a05207c,
    $7c96f63dd602b579$export$f22da7240b7add18,
    $7c96f63dd602b579$export$bab79516f2d662fe,
    $7c96f63dd602b579$export$8d4d2d70e7d46032,
    $7c96f63dd602b579$export$68d8715fc104d294,
    $7c96f63dd602b579$export$70a6e5159acce2e6
];


function $13c27cceb4b24b2f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $13c27cceb4b24b2f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $13c27cceb4b24b2f$var$order(modifiers); // order based on phase
    return (0, $7c96f63dd602b579$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $4c8edc0cb4d5666b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $320e6f4d2835a922$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $879850b738b0fd85$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $879850b738b0fd85$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $879850b738b0fd85$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $879850b738b0fd85$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $879850b738b0fd85$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(reference) ? (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $13c27cceb4b24b2f$export$2e2bcd8739ae039)((0, $320e6f4d2835a922$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $585037a155f95873$export$2e2bcd8739ae039)(reference, (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4c8edc0cb4d5666b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $879850b738b0fd85$export$8f7491d57c8f97a9 = /*#__PURE__*/ $879850b738b0fd85$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $1564186ea0096528$var$passive = {
    passive: true
};
function $1564186ea0096528$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1564186ea0096528$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $1564186ea0096528$var$effect,
    data: {}
};



function $2e8856bdb677ff8e$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $cd593f453867f36a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $334987ecb6fc56c7$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $c2c9d9550c09d816$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $7c96f63dd602b579$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $7c96f63dd602b579$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $7c96f63dd602b579$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $7c96f63dd602b579$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $7c96f63dd602b579$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $7c96f63dd602b579$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e0848fa64ca744df$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c2c9d9550c09d816$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0848fa64ca744df$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e0848fa64ca744df$var$popperOffsets,
    data: {}
};










var $adff49e8d09ee1e5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $adff49e8d09ee1e5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $adff49e8d09ee1e5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
    var sideY = (0, $7c96f63dd602b579$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(popper);
            if ((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $7c96f63dd602b579$export$1e95b668f3b82d) || (placement === (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) || placement === (0, $7c96f63dd602b579$export$79ffe56a765070d2)) && variation === (0, $7c96f63dd602b579$export$bd5df0f255a350f8)) {
            sideY = (0, $7c96f63dd602b579$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) || (placement === (0, $7c96f63dd602b579$export$1e95b668f3b82d) || placement === (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)) && variation === (0, $7c96f63dd602b579$export$bd5df0f255a350f8)) {
            sideX = (0, $7c96f63dd602b579$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $adff49e8d09ee1e5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $adff49e8d09ee1e5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $adff49e8d09ee1e5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $cd593f453867f36a$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $adff49e8d09ee1e5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $adff49e8d09ee1e5$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $5bfb95a331f35baa$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || !(0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $5bfb95a331f35baa$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || !(0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $5bfb95a331f35baa$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $5bfb95a331f35baa$var$applyStyles,
    effect: $5bfb95a331f35baa$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a984b8b647b41eeb$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $7c96f63dd602b579$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a984b8b647b41eeb$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a984b8b647b41eeb$var$offset
};


var $690483208b9a3207$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $690483208b9a3207$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $690483208b9a3207$var$hash[matched];
    });
}



var $13515282412eb271$var$hash = {
    start: 'end',
    end: 'start'
};
function $13515282412eb271$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $13515282412eb271$var$hash[matched];
    });
}







function $05957f974ad3b041$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element);
    var html = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b48f13af3862f004$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $f2541b971d258cf0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $fa38ef77d76834a0$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $18107b7e48021ffa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $86796f3d3717fc99$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $7c96f63dd602b579$export$d7b7311ec04a3e8f) ? (0, $18107b7e48021ffa$export$2e2bcd8739ae039)((0, $05957f974ad3b041$export$2e2bcd8739ae039)(element, strategy)) : (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clippingParent) ? $86796f3d3717fc99$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $18107b7e48021ffa$export$2e2bcd8739ae039)((0, $f2541b971d258cf0$export$2e2bcd8739ae039)((0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $86796f3d3717fc99$var$getClippingParents(element) {
    var clippingParents = (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)((0, $9906540837c752ea$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) ? (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $fa38ef77d76834a0$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $86796f3d3717fc99$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $86796f3d3717fc99$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cb70389d1b75072d$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cb70389d1b75072d$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $86796f3d3717fc99$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $1e806166c2cdf48d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $ff6dcd1b0906e9b8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1e806166c2cdf48d$export$2e2bcd8739ae039)(), paddingObject);
}


function $c8d699eb93b3090c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $52693e6050d55014$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $7c96f63dd602b579$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $7c96f63dd602b579$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $7c96f63dd602b579$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $ff6dcd1b0906e9b8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c8d699eb93b3090c$export$2e2bcd8739ae039)(padding, (0, $7c96f63dd602b579$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) ? (0, $7c96f63dd602b579$export$ca50aac9f3ba507f) : (0, $7c96f63dd602b579$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $86796f3d3717fc99$export$2e2bcd8739ae039)((0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c2c9d9550c09d816$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $18107b7e48021ffa$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $7c96f63dd602b579$export$79ffe56a765070d2),
                (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $7c96f63dd602b579$export$1e95b668f3b82d),
                (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $a935996b3496591b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $7c96f63dd602b579$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $7c96f63dd602b579$export$368f9a87e87fa4e1) : (0, $7c96f63dd602b579$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $7c96f63dd602b579$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $a97241372b70cd07$var$getExpandedFallbackPlacements(placement) {
    if ((0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $690483208b9a3207$export$2e2bcd8739ae039)(placement);
    return [
        (0, $13515282412eb271$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $13515282412eb271$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $a97241372b70cd07$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $690483208b9a3207$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $a97241372b70cd07$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$dfb5619354ba860) ? (0, $a935996b3496591b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$b3571188c770cc5a);
        var isVertical = [
            (0, $7c96f63dd602b579$export$1e95b668f3b82d),
            (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $7c96f63dd602b579$export$79ffe56a765070d2) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $690483208b9a3207$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $690483208b9a3207$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a97241372b70cd07$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a97241372b70cd07$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $8d60439f259d6a8c$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max) {
    return (0, $cb70389d1b75072d$export$8960430cfd85939f)(min, (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(value, max));
}
function $14b5cb667dce379f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $cf968237b9d7dd4a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $8d60439f259d6a8c$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $7c96f63dd602b579$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $7c96f63dd602b579$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1e806166c2cdf48d$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(tether ? (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $cb70389d1b75072d$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $7c96f63dd602b579$export$1e95b668f3b82d),
            (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $14b5cb667dce379f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $14b5cb667dce379f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cf968237b9d7dd4a$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $cf968237b9d7dd4a$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $e7f3cf13e0769248$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $ff6dcd1b0906e9b8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c8d699eb93b3090c$export$2e2bcd8739ae039)(padding, (0, $7c96f63dd602b579$export$aec2ce47c367b8c3)));
};
function $e7f3cf13e0769248$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $e7f3cf13e0769248$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $e7f3cf13e0769248$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $fa38ef77d76834a0$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $e7f3cf13e0769248$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $e7f3cf13e0769248$var$arrow,
    effect: $e7f3cf13e0769248$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $74f12d998f890694$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $74f12d998f890694$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $7c96f63dd602b579$export$1e95b668f3b82d),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2),
        (0, $7c96f63dd602b579$export$40e543e69a8b3fbb),
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $74f12d998f890694$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $74f12d998f890694$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $74f12d998f890694$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $74f12d998f890694$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $74f12d998f890694$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $74f12d998f890694$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $74f12d998f890694$var$hide
};




var $a5ed26444bdb4d3e$export$d34966752335dd47 = [
    (0, $1564186ea0096528$export$2e2bcd8739ae039),
    (0, $e0848fa64ca744df$export$2e2bcd8739ae039),
    (0, $adff49e8d09ee1e5$export$2e2bcd8739ae039),
    (0, $5bfb95a331f35baa$export$2e2bcd8739ae039),
    (0, $a984b8b647b41eeb$export$2e2bcd8739ae039),
    (0, $a97241372b70cd07$export$2e2bcd8739ae039),
    (0, $cf968237b9d7dd4a$export$2e2bcd8739ae039),
    (0, $e7f3cf13e0769248$export$2e2bcd8739ae039),
    (0, $74f12d998f890694$export$2e2bcd8739ae039)
];
var $a5ed26444bdb4d3e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $879850b738b0fd85$export$ed5e13716264f202)({
    defaultModifiers: $a5ed26444bdb4d3e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $d8cf8ca5172c2b64$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $d8cf8ca5172c2b64$var$hasElementType = typeof Element !== 'undefined';
var $d8cf8ca5172c2b64$var$hasMap = typeof Map === 'function';
var $d8cf8ca5172c2b64$var$hasSet = typeof Set === 'function';
var $d8cf8ca5172c2b64$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $d8cf8ca5172c2b64$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$d8cf8ca5172c2b64$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($d8cf8ca5172c2b64$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$d8cf8ca5172c2b64$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($d8cf8ca5172c2b64$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($d8cf8ca5172c2b64$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($d8cf8ca5172c2b64$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$d8cf8ca5172c2b64$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$d8cf8ca5172c2b64$exports = function isEqual(a, b) {
    try {
        return $d8cf8ca5172c2b64$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $1ef5139d3c6891c9$var$EMPTY_MODIFIERS = [];
var $1ef5139d3c6891c9$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $7fPBF.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $1ef5139d3c6891c9$var$EMPTY_MODIFIERS
    };
    var _React$useState = $7fPBF.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $7fPBF.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $b4ba1c853f6e1116$exports.flushSync(function() {
                    setState({
                        styles: (0, $102370a2b7376d38$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $102370a2b7376d38$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $7fPBF.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($d8cf8ca5172c2b64$exports)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $7fPBF.useRef();
    (0, $102370a2b7376d38$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $102370a2b7376d38$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $a5ed26444bdb4d3e$export$8f7491d57c8f97a9);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};


var $00d767b55afb0685$var$NOOP = function NOOP() {
    return void 0;
};
var $00d767b55afb0685$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $00d767b55afb0685$var$EMPTY_MODIFIERS = [];
function $00d767b55afb0685$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $00d767b55afb0685$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $7fPBF.useContext((0, $946cf4462dcf0c84$export$3dbd3405086fec7b));
    var _React$useState = $7fPBF.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $7fPBF.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $7fPBF.useEffect(function() {
        (0, $102370a2b7376d38$export$4bb192c7cacf928f)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $7fPBF.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $1ef5139d3c6891c9$export$f4d5bf230a36dd6e)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $7fPBF.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $00d767b55afb0685$var$NOOP,
            update: update || $00d767b55afb0685$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $102370a2b7376d38$export$f52c55943429c8b6)(children)(childrenProps);
}



var $iKdEz = parcelRequire("iKdEz");
function $76724b68259c0316$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $e8027c477e280fef$var$viewportPadding = 5;
var $e8027c477e280fef$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $e8027c477e280fef$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $e8027c477e280fef$var$defaultChildrenFn() {
    return null;
}
var $e8027c477e280fef$var$defaultOffset = [
    0,
    8
];
function $e8027c477e280fef$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $e8027c477e280fef$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $e8027c477e280fef$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $7fPBF.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $e8027c477e280fef$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $76724b68259c0316$export$6d8c2b45c99d6e3f)({
            viewportPadding: $e8027c477e280fef$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($e8027c477e280fef$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $7fPBF.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $00d767b55afb0685$export$badac9ada3a0bdf9), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $7fPBF = parcelRequire("7fPBF");
var $374ceec9479fad9a$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, children);
};



var $7fPBF = parcelRequire("7fPBF");




var $137Lh = parcelRequire("137Lh");
var $c57e3ba830849183$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $c57e3ba830849183$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($c57e3ba830849183$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};



var $7fPBF = parcelRequire("7fPBF");
var $34a4f11347399562$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $7fPBF.useRef)([]);
    var requestFrame = (0, $7fPBF.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $7fPBF.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $7fPBF.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};


var $683bbd4362a00b1a$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $d2a040b34e70682b$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $34a4f11347399562$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $7fPBF.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $f48d740006cf3f7d$export$2e2bcd8739ae039;
        var inIframe = window && window.self !== window.top && (0, $137Lh.fg)('fix-dropdown-close-outside-iframe');
        var closePopup = function closePopup(event) {
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest;
                    _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-ds--level');
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                    if (layeredElement) {
                        var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $c57e3ba830849183$export$3dee5e4542c672d9)(document.activeElement) && (0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === 'Escape' || _key === 'Esc' || shouldCloseOnTab && _key === 'Tab') closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $a091c25729a976b1$exports.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $f48d740006cf3f7d$export$2e2bcd8739ae039);
        if ((0, $137Lh.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $a091c25729a976b1$exports.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                }
            ]);
        }, 0);
        else unbind = (0, $a091c25729a976b1$exports.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $f48d740006cf3f7d$export$2e2bcd8739ae039);
        unbindBlur = (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            if ((0, $137Lh.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};



var $7fPBF = parcelRequire("7fPBF");
var $08fd599bcf7f4689$exports = {};
var $bb1b0288a0cc47aa$exports = {};
$bb1b0288a0cc47aa$exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $bb1b0288a0cc47aa$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $bb1b0288a0cc47aa$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}


var $08fd599bcf7f4689$var$listeningFocusTrap = null;
function $08fd599bcf7f4689$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $08fd599bcf7f4689$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($08fd599bcf7f4689$var$listeningFocusTrap) $08fd599bcf7f4689$var$listeningFocusTrap.pause();
        $08fd599bcf7f4689$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $08fd599bcf7f4689$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $08fd599bcf7f4689$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $08fd599bcf7f4689$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $08fd599bcf7f4689$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $08fd599bcf7f4689$var$tryFocus(lastTabbableNode);
            return $08fd599bcf7f4689$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $08fd599bcf7f4689$var$tryFocus(firstTabbableNode);
        $08fd599bcf7f4689$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $bb1b0288a0cc47aa$exports(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $08fd599bcf7f4689$var$tryFocus(lastTabbableNode);
        $08fd599bcf7f4689$var$tryFocus(firstTabbableNode);
    }
}
function $08fd599bcf7f4689$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $08fd599bcf7f4689$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
$08fd599bcf7f4689$exports = $08fd599bcf7f4689$var$focusTrap;





var $137Lh = parcelRequire("137Lh");

var $e6a492461c861d8d$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $34a4f11347399562$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $d2a040b34e70682b$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    (0, $7fPBF.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $f48d740006cf3f7d$export$2e2bcd8739ae039;
        if (shouldDisableFocusTrap && (0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $f48d740006cf3f7d$export$2e2bcd8739ae039;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($08fd599bcf7f4689$exports)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};


var $980078ac860e7e7d$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className"
];
var $980078ac860e7e7d$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $980078ac860e7e7d$var$fullWidthStyles = null;
var $980078ac860e7e7d$var$wrapperStyles = {
    root: "_2rkoglpi _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _syaz1fxt _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36"
};
var $980078ac860e7e7d$var$scrollableStyles = null;
var $980078ac860e7e7d$var$blanketStyles = null;
var $980078ac860e7e7d$var$modalStyles = null;
var $980078ac860e7e7d$var$focusRingStyles = {
    root: "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y"
};
var $980078ac860e7e7d$var$DefaultPopupComponent = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $980078ac860e7e7d$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $b3ce7373d625f468$export$2e2bcd8739ae039)([
            $980078ac860e7e7d$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            !shouldRenderToParent && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $980078ac860e7e7d$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $980078ac860e7e7d$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $7fPBF.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $e6a492461c861d8d$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $683bbd4362a00b1a$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $d2a040b34e70682b$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $7fPBF.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $e8027c477e280fef$export$badac9ada3a0bdf9), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        var popupContainer = /*#__PURE__*/ $7fPBF.createElement(PopupContainer, {
            className: (0, $b3ce7373d625f468$export$2e2bcd8739ae039)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $137Lh.fg)('platform-design-system-apply-popup-wrapper-focus') && $980078ac860e7e7d$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer
        }, /*#__PURE__*/ $7fPBF.createElement((0, $374ceec9479fad9a$export$51eddd7655ca235a), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $7fPBF.createElement("div", {
            className: (0, $b3ce7373d625f468$export$2e2bcd8739ae039)([
                "_1r04idpf _kqsw1n9t _bfhk10xm"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$980078ac860e7e7d$export$2e2bcd8739ae039 = $980078ac860e7e7d$var$PopperWrapper;



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $44da1305c7733d9f$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};


var $6b34cccbc9004c67$var$_window, $6b34cccbc9004c67$var$_window$matchMedia, $6b34cccbc9004c67$var$_window2, $6b34cccbc9004c67$var$_window2$matchMedia, $6b34cccbc9004c67$var$_window3, $6b34cccbc9004c67$var$_window3$matchMedia, $6b34cccbc9004c67$var$_window4, $6b34cccbc9004c67$var$_window4$matchMedia, $6b34cccbc9004c67$var$_window5, $6b34cccbc9004c67$var$_window5$matchMedia, $6b34cccbc9004c67$var$_window6, $6b34cccbc9004c67$var$_window6$matchMedia, $6b34cccbc9004c67$var$_window7, $6b34cccbc9004c67$var$_window7$matchMedia, $6b34cccbc9004c67$var$_window8, $6b34cccbc9004c67$var$_window8$matchMedia, $6b34cccbc9004c67$var$_window9, $6b34cccbc9004c67$var$_window9$matchMedia, $6b34cccbc9004c67$var$_window10, $6b34cccbc9004c67$var$_window10$matchMedia, $6b34cccbc9004c67$var$_window11, $6b34cccbc9004c67$var$_window11$matchMedia;
var $6b34cccbc9004c67$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($6b34cccbc9004c67$var$_window = window) === null || $6b34cccbc9004c67$var$_window === void 0 || ($6b34cccbc9004c67$var$_window$matchMedia = $6b34cccbc9004c67$var$_window.matchMedia) === null || $6b34cccbc9004c67$var$_window$matchMedia === void 0 ? void 0 : $6b34cccbc9004c67$var$_window$matchMedia.call($6b34cccbc9004c67$var$_window, (0, $44da1305c7733d9f$export$987d49ffe1b0900f).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($6b34cccbc9004c67$var$_window2 = window) === null || $6b34cccbc9004c67$var$_window2 === void 0 || ($6b34cccbc9004c67$var$_window2$matchMedia = $6b34cccbc9004c67$var$_window2.matchMedia) === null || $6b34cccbc9004c67$var$_window2$matchMedia === void 0 ? void 0 : $6b34cccbc9004c67$var$_window2$matchMedia.call($6b34cccbc9004c67$var$_window2, (0, $44da1305c7733d9f$export$987d49ffe1b0900f).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($6b34cccbc9004c67$var$_window3 = window) === null || $6b34cccbc9004c67$var$_window3 === void 0 || ($6b34cccbc9004c67$var$_window3$matchMedia = $6b34cccbc9004c67$var$_window3.matchMedia) === null || $6b34cccbc9004c67$var$_window3$matchMedia === void 0 ? void 0 : $6b34cccbc9004c67$var$_window3$matchMedia.call($6b34cccbc9004c67$var$_window3, (0, $44da1305c7733d9f$export$987d49ffe1b0900f).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($6b34cccbc9004c67$var$_window4 = window) === null || $6b34cccbc9004c67$var$_window4 === void 0 || ($6b34cccbc9004c67$var$_window4$matchMedia = $6b34cccbc9004c67$var$_window4.matchMedia) === null || $6b34cccbc9004c67$var$_window4$matchMedia === void 0 ? void 0 : $6b34cccbc9004c67$var$_window4$matchMedia.call($6b34cccbc9004c67$var$_window4, (0, $44da1305c7733d9f$export$987d49ffe1b0900f).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($6b34cccbc9004c67$var$_window5 = window) === null || $6b34cccbc9004c67$var$_window5 === void 0 || ($6b34cccbc9004c67$var$_window5$matchMedia = $6b34cccbc9004c67$var$_window5.matchMedia) === null || $6b34cccbc9004c67$var$_window5$matchMedia === void 0 ? void 0 : $6b34cccbc9004c67$var$_window5$matchMedia.call($6b34cccbc9004c67$var$_window5, (0, $44da1305c7733d9f$export$987d49ffe1b0900f).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($6b34cccbc9004c67$var$_window6 = window) === null || $6b34cccbc9004c67$var$_window6 === void 0 || ($6b34cccbc9004c67$var$_window6$matchMedia = $6b34cccbc9004c67$var$_window6.matchMedia) === null || $6b34cccbc9004c67$var$_window6$matchMedia === void 0 ? void 0 : $6b34cccbc9004c67$var$_window6$matchMedia.call($6b34cccbc9004c67$var$_window6, (0, $44da1305c7733d9f$export$987d49ffe1b0900f).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($6b34cccbc9004c67$var$_window7 = window) === null || $6b34cccbc9004c67$var$_window7 === void 0 || ($6b34cccbc9004c67$var$_window7$matchMedia = $6b34cccbc9004c67$var$_window7.matchMedia) === null || $6b34cccbc9004c67$var$_window7$matchMedia === void 0 ? void 0 : $6b34cccbc9004c67$var$_window7$matchMedia.call($6b34cccbc9004c67$var$_window7, (0, $44da1305c7733d9f$export$987d49ffe1b0900f).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($6b34cccbc9004c67$var$_window8 = window) === null || $6b34cccbc9004c67$var$_window8 === void 0 || ($6b34cccbc9004c67$var$_window8$matchMedia = $6b34cccbc9004c67$var$_window8.matchMedia) === null || $6b34cccbc9004c67$var$_window8$matchMedia === void 0 ? void 0 : $6b34cccbc9004c67$var$_window8$matchMedia.call($6b34cccbc9004c67$var$_window8, (0, $44da1305c7733d9f$export$987d49ffe1b0900f).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($6b34cccbc9004c67$var$_window9 = window) === null || $6b34cccbc9004c67$var$_window9 === void 0 || ($6b34cccbc9004c67$var$_window9$matchMedia = $6b34cccbc9004c67$var$_window9.matchMedia) === null || $6b34cccbc9004c67$var$_window9$matchMedia === void 0 ? void 0 : $6b34cccbc9004c67$var$_window9$matchMedia.call($6b34cccbc9004c67$var$_window9, (0, $44da1305c7733d9f$export$987d49ffe1b0900f).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($6b34cccbc9004c67$var$_window10 = window) === null || $6b34cccbc9004c67$var$_window10 === void 0 || ($6b34cccbc9004c67$var$_window10$matchMedia = $6b34cccbc9004c67$var$_window10.matchMedia) === null || $6b34cccbc9004c67$var$_window10$matchMedia === void 0 ? void 0 : $6b34cccbc9004c67$var$_window10$matchMedia.call($6b34cccbc9004c67$var$_window10, (0, $44da1305c7733d9f$export$987d49ffe1b0900f).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($6b34cccbc9004c67$var$_window11 = window) === null || $6b34cccbc9004c67$var$_window11 === void 0 || ($6b34cccbc9004c67$var$_window11$matchMedia = $6b34cccbc9004c67$var$_window11.matchMedia) === null || $6b34cccbc9004c67$var$_window11$matchMedia === void 0 ? void 0 : $6b34cccbc9004c67$var$_window11$matchMedia.call($6b34cccbc9004c67$var$_window11, (0, $44da1305c7733d9f$export$987d49ffe1b0900f).below.xl.replace('@media ', '').trim())
};
var $6b34cccbc9004c67$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $7fPBF.useRef)(listener);
    (0, $7fPBF.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $6b34cccbc9004c67$var$queries[queryString];
    (0, $7fPBF.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $a091c25729a976b1$exports.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};


function $4a219ef45b6d3244$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $6b34cccbc9004c67$export$49e55ae2c03d6045)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $7fPBF.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $5a55a5f3b6574bfb$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $7fPBF.useState)(function() {
        return (0, $859f0395401445ad$export$2e2bcd8739ae039)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $56b5f08ac36f7b93$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $7fPBF.useState)(function() {
        return (0, $859f0395401445ad$export$2e2bcd8739ae039)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};


var $634277c72baa6a6b$var$defaultLayer = 400;
var $634277c72baa6a6b$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $634277c72baa6a6b$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $634277c72baa6a6b$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $7fPBF.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $5a55a5f3b6574bfb$export$7cc5c058dd769dff)();
    var getMergedTriggerRefNew = (0, $56b5f08ac36f7b93$export$5d3a2de79e07b376)();
    var generatedId = (0, $d4d502868e612e1e$export$f680877a34711e37)();
    var _usePopupAppearance = (0, $4a219ef45b6d3244$export$4065aef1d79a5730)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $7fPBF.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $0a30dd083eb527d5$export$469bb693f11edc7f)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    var renderPopperWrapper = /*#__PURE__*/ $7fPBF.createElement((0, $928dd3962972af3c$export$7c885f891c940977), {
        isDisabled: false
    }, /*#__PURE__*/ $7fPBF.createElement((0, $980078ac860e7e7d$export$2e2bcd8739ae039), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $7fPBF.createElement((0, $946cf4462dcf0c84$export$d0d38e7dec7a1a61), null, /*#__PURE__*/ $7fPBF.createElement((0, $707082bb5d4c97c5$export$e0be378c32fb70a7), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $137Lh.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $137Lh.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $7fPBF.createElement((0, $cd3bc8368572caba$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return /*#__PURE__*/ $7fPBF.createElement((0, $ceaf414db493dd15$export$2e2bcd8739ae039), {
        xcss: $634277c72baa6a6b$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
});


var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2c055187658302fb$export$2e2bcd8739ae039 = (0, $634277c72baa6a6b$export$129a32eedafa97c5);




var $7fPBF = parcelRequire("7fPBF");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
function $39f1f51c54808bc1$export$2f62ee6831462844() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_React$useState, 2), state = _React$useState2[0], setState = _React$useState2[1];
    var threshold = options.threshold, root = options.root, rootMargin = options.rootMargin;
    var setRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(function(node) {
        observerInstance.current = new IntersectionObserver(function(entries) {
            if (entries && entries.length) {
                var intersection = entries[0];
                var isIntersecting = intersection.isIntersecting, intersectionRatio = intersection.intersectionRatio;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    var numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    var inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        return function() {
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}


var $f34a516af4ebd831$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function(_ref) {
    var setWidth = _ref.setWidth, offscreen = _ref.offscreen;
    var _useInView = (0, $39f1f51c54808bc1$export$2f62ee6831462844)({
        /* Optional options */ threshold: 0
    }), _useInView2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useInView, 3), inViewRef = _useInView2[0], inView = _useInView2[1], target = _useInView2[2];
    var observer = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(function() {
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver(function(entries) {
            if (!Array.isArray(entries) || !entries.length) return;
            var width = entries[0].contentRect.width;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        var currentObserver = observer.current;
        var resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return function() {
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});


var $66ddca22d5092ead$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f34a516af4ebd831$export$ff983d2a2b6112ea), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $66ddca22d5092ead$export$2e2bcd8739ae039 = $66ddca22d5092ead$export$b2ad68b9bc407b80;



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
var $932a0672a1772507$exports = {};
var $26dbabe73f482390$exports = {};
var $f328ff7ee4fde81a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f328ff7ee4fde81a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$f328ff7ee4fde81a$exports = $f328ff7ee4fde81a$var$isObject;


var $f76380021e37252e$exports = {};
var $13147c93e8511c05$exports = {};
var $6845d21fa7e75b3b$exports = {};
/** Detect free variable `global` from Node.js. */ var $6845d21fa7e75b3b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$6845d21fa7e75b3b$exports = $6845d21fa7e75b3b$var$freeGlobal;


/** Detect free variable `self`. */ var $13147c93e8511c05$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $13147c93e8511c05$var$root = $6845d21fa7e75b3b$exports || $13147c93e8511c05$var$freeSelf || Function('return this')();
$13147c93e8511c05$exports = $13147c93e8511c05$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $f76380021e37252e$var$now = function() {
    return $13147c93e8511c05$exports.Date.now();
};
$f76380021e37252e$exports = $f76380021e37252e$var$now;


var $027fc05d9ba60754$exports = {};
var $f49ef2e63e1337d0$exports = {};
var $6abb93fe126bbf26$exports = {};
/** Used to match a single whitespace character. */ var $6abb93fe126bbf26$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $6abb93fe126bbf26$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $6abb93fe126bbf26$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$6abb93fe126bbf26$exports = $6abb93fe126bbf26$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $f49ef2e63e1337d0$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $f49ef2e63e1337d0$var$baseTrim(string) {
    return string ? string.slice(0, $6abb93fe126bbf26$exports(string) + 1).replace($f49ef2e63e1337d0$var$reTrimStart, '') : string;
}
$f49ef2e63e1337d0$exports = $f49ef2e63e1337d0$var$baseTrim;



var $2fffc1449db40502$exports = {};
var $ae3fe6c5950c122e$exports = {};
var $c9c36e86f7d6f497$exports = {};

/** Built-in value references. */ var $c9c36e86f7d6f497$var$Symbol = $13147c93e8511c05$exports.Symbol;
$c9c36e86f7d6f497$exports = $c9c36e86f7d6f497$var$Symbol;


var $76f84bdae49ee13c$exports = {};

/** Used for built-in method references. */ var $76f84bdae49ee13c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $76f84bdae49ee13c$var$hasOwnProperty = $76f84bdae49ee13c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $76f84bdae49ee13c$var$nativeObjectToString = $76f84bdae49ee13c$var$objectProto.toString;
/** Built-in value references. */ var $76f84bdae49ee13c$var$symToStringTag = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $76f84bdae49ee13c$var$getRawTag(value) {
    var isOwn = $76f84bdae49ee13c$var$hasOwnProperty.call(value, $76f84bdae49ee13c$var$symToStringTag), tag = value[$76f84bdae49ee13c$var$symToStringTag];
    try {
        value[$76f84bdae49ee13c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $76f84bdae49ee13c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$76f84bdae49ee13c$var$symToStringTag] = tag;
        else delete value[$76f84bdae49ee13c$var$symToStringTag];
    }
    return result;
}
$76f84bdae49ee13c$exports = $76f84bdae49ee13c$var$getRawTag;


var $77d9fbfccc3fe2a6$exports = {};
/** Used for built-in method references. */ var $77d9fbfccc3fe2a6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $77d9fbfccc3fe2a6$var$nativeObjectToString = $77d9fbfccc3fe2a6$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $77d9fbfccc3fe2a6$var$objectToString(value) {
    return $77d9fbfccc3fe2a6$var$nativeObjectToString.call(value);
}
$77d9fbfccc3fe2a6$exports = $77d9fbfccc3fe2a6$var$objectToString;


/** `Object#toString` result references. */ var $ae3fe6c5950c122e$var$nullTag = '[object Null]', $ae3fe6c5950c122e$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ae3fe6c5950c122e$var$symToStringTag = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ae3fe6c5950c122e$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ae3fe6c5950c122e$var$undefinedTag : $ae3fe6c5950c122e$var$nullTag;
    return $ae3fe6c5950c122e$var$symToStringTag && $ae3fe6c5950c122e$var$symToStringTag in Object(value) ? $76f84bdae49ee13c$exports(value) : $77d9fbfccc3fe2a6$exports(value);
}
$ae3fe6c5950c122e$exports = $ae3fe6c5950c122e$var$baseGetTag;


var $97dbbc1a069ce16a$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $97dbbc1a069ce16a$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$97dbbc1a069ce16a$exports = $97dbbc1a069ce16a$var$isObjectLike;


/** `Object#toString` result references. */ var $2fffc1449db40502$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2fffc1449db40502$var$isSymbol(value) {
    return typeof value == 'symbol' || $97dbbc1a069ce16a$exports(value) && $ae3fe6c5950c122e$exports(value) == $2fffc1449db40502$var$symbolTag;
}
$2fffc1449db40502$exports = $2fffc1449db40502$var$isSymbol;


/** Used as references for various `Number` constants. */ var $027fc05d9ba60754$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $027fc05d9ba60754$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $027fc05d9ba60754$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $027fc05d9ba60754$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $027fc05d9ba60754$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $027fc05d9ba60754$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($2fffc1449db40502$exports(value)) return $027fc05d9ba60754$var$NAN;
    if ($f328ff7ee4fde81a$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f328ff7ee4fde81a$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $f49ef2e63e1337d0$exports(value);
    var isBinary = $027fc05d9ba60754$var$reIsBinary.test(value);
    return isBinary || $027fc05d9ba60754$var$reIsOctal.test(value) ? $027fc05d9ba60754$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $027fc05d9ba60754$var$reIsBadHex.test(value) ? $027fc05d9ba60754$var$NAN : +value;
}
$027fc05d9ba60754$exports = $027fc05d9ba60754$var$toNumber;


/** Error message constants. */ var $26dbabe73f482390$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $26dbabe73f482390$var$nativeMax = Math.max, $26dbabe73f482390$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $26dbabe73f482390$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($26dbabe73f482390$var$FUNC_ERROR_TEXT);
    wait = $027fc05d9ba60754$exports(wait) || 0;
    if ($f328ff7ee4fde81a$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $26dbabe73f482390$var$nativeMax($027fc05d9ba60754$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $26dbabe73f482390$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $f76380021e37252e$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($f76380021e37252e$exports());
    }
    function debounced() {
        var time = $f76380021e37252e$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$26dbabe73f482390$exports = $26dbabe73f482390$var$debounce;



/** Error message constants. */ var $932a0672a1772507$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $932a0672a1772507$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($932a0672a1772507$var$FUNC_ERROR_TEXT);
    if ($f328ff7ee4fde81a$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $26dbabe73f482390$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$932a0672a1772507$exports = $932a0672a1772507$var$throttle;



// Prevent width detector from triggering too many re-renders
var $29a6ecad9d545dc1$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
var $29a6ecad9d545dc1$var$ITEM_APPROX_MINWIDTH = 70;
var $29a6ecad9d545dc1$var$calculateHash = function calculateHash(w, n) {
    return w + '#' + n;
};
var $29a6ecad9d545dc1$var$updateHashRef = function updateHashRef(currentRef, value) {
    currentRef.unshift(value);
    currentRef.length = 3;
};
var $29a6ecad9d545dc1$var$OverflowContext = /*#__PURE__*/ (0, $7fPBF.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039),
    closeOverflowMenu: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039)
});
var $29a6ecad9d545dc1$export$a3a2def3937905a0 = function OverflowProvider(_ref) {
    var children = _ref.children, isVisible = _ref.isVisible, openOverflowMenu = _ref.openOverflowMenu, closeOverflowMenu = _ref.closeOverflowMenu;
    var Provider = $29a6ecad9d545dc1$var$OverflowContext.Provider;
    var value = (0, $7fPBF.useMemo)(function() {
        return {
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        };
    }, [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Provider, {
        value: value
    }, children);
};
var $29a6ecad9d545dc1$export$3fcfc71fab3314f2 = function useOverflowStatus() {
    return (0, $7fPBF.useContext)($29a6ecad9d545dc1$var$OverflowContext);
};
var $29a6ecad9d545dc1$export$705aa66a39c35bf7 = function useOverflowController(nodes) {
    var items = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.toArray(nodes);
    var _useState = (0, $7fPBF.useState)(9999), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), width = _useState2[0], setWidth = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(items.length), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), itemsLimit = _useState4[0], setItemsLimit = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)({}), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), forceEffectValue = _useState6[0], triggerForceEffect = _useState6[1];
    // Storing items approximate width so we can try expanding when there is enough room
    var itemsWidths = (0, $7fPBF.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    var hashRef = (0, $7fPBF.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var throttleSetWidth = (0, $7fPBF.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($932a0672a1772507$exports)))(setWidth, $29a6ecad9d545dc1$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $7fPBF.useEffect)(function() {
        var lastItemWidth = itemsWidths[itemsLimit] || 0;
        var wasJustLimited = lastItemWidth < 0;
        var currentHash = $29a6ecad9d545dc1$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            var t = setTimeout(function() {
                $29a6ecad9d545dc1$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $29a6ecad9d545dc1$var$THROTTLE_INTERVAL * 1.5);
            return function() {
                return clearTimeout(t);
            };
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            var partialWidth = Math.max(Math.min(width + lastItemWidth, $29a6ecad9d545dc1$var$ITEM_APPROX_MINWIDTH * 2), $29a6ecad9d545dc1$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $29a6ecad9d545dc1$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            var nextHash = $29a6ecad9d545dc1$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $29a6ecad9d545dc1$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
     * This is not necessarily equal to `lastItemWidth` because the
     * ```js
     * if (wasJustLimited) {}
     * ```
     * branch above modifies `itemsWidths`.
     *
     * Using `lastItemWidth` here can cause collapsing behavior to fail,
     * such as the issue reported in DSP-7329.
     */ var currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $29a6ecad9d545dc1$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            var _nextHash = $29a6ecad9d545dc1$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(_nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $29a6ecad9d545dc1$var$updateHashRef(hashRef.current, _nextHash);
            }
            return;
        }
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line import/no-anonymous-default-export
$29a6ecad9d545dc1$export$2e2bcd8739ae039 = function(props) {};



var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $40649b4d91b6fedf$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a08e2cd9fd0eae78f18da4572f37370>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($40649b4d91b6fedf$exports, "__esModule", {
    value: true
});
$40649b4d91b6fedf$exports.default = void 0;

var $40649b4d91b6fedf$var$_react = $40649b4d91b6fedf$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $40649b4d91b6fedf$var$_chevronDown = $40649b4d91b6fedf$var$_interopRequireDefault((parcelRequire("4X8HT")));

var $40649b4d91b6fedf$var$_chevronDown2 = $40649b4d91b6fedf$var$_interopRequireDefault((parcelRequire("2Ef5E")));
function $40649b4d91b6fedf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $40649b4d91b6fedf$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $40649b4d91b6fedf$var$_react.default.createElement($40649b4d91b6fedf$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $40649b4d91b6fedf$var$_chevronDown2.default
    }, props));
$40649b4d91b6fedf$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $40649b4d91b6fedf$var$_default = $40649b4d91b6fedf$exports.default = $40649b4d91b6fedf$var$ChevronDownIcon;



var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


var $cvBp9 = parcelRequire("cvBp9");

var $iKdEz = parcelRequire("iKdEz");

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
var $14df6e03fac80ed6$var$_excluded = [
    "children"
];
function $14df6e03fac80ed6$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $7fPBF.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $7fPBF.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $14df6e03fac80ed6$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $7fPBF.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $7fPBF.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
var $034bea2d324ecf61$var$_createTheme = (0, $14df6e03fac80ed6$export$25d302a5b900a763)(function() {
    return {
        mode: 'light'
    };
}), $034bea2d324ecf61$var$Provider = $034bea2d324ecf61$var$_createTheme.Provider, $034bea2d324ecf61$var$Consumer = $034bea2d324ecf61$var$_createTheme.Consumer, $034bea2d324ecf61$export$7692396083754928 = $034bea2d324ecf61$var$_createTheme.useTheme;
var $034bea2d324ecf61$var$Theme = {
    Provider: $034bea2d324ecf61$var$Provider,
    Consumer: $034bea2d324ecf61$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$034bea2d324ecf61$export$2e2bcd8739ae039 = $034bea2d324ecf61$var$Theme;



var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $eKeTJ = parcelRequire("eKeTJ");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");
function $42e51477a9cc996a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $42e51477a9cc996a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $42e51477a9cc996a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $42e51477a9cc996a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $42e51477a9cc996a$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $42e51477a9cc996a$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $42e51477a9cc996a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $42e51477a9cc996a$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(updater) === 'object') this.payload = $42e51477a9cc996a$var$_objectSpread($42e51477a9cc996a$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $678a5d90a577f603$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $678a5d90a577f603$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $678a5d90a577f603$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($678a5d90a577f603$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $678a5d90a577f603$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($eKeTJ)))((0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $678a5d90a577f603$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $678a5d90a577f603$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $678a5d90a577f603$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, UIAnalyticsEvent);
        _this = $678a5d90a577f603$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $678a5d90a577f603$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $42e51477a9cc996a$export$2e2bcd8739ae039));



var $7fPBF = parcelRequire("7fPBF");

var $ca33900def42243a$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $7fPBF.useContext)((0, $e420dde09fb890a4$export$2e2bcd8739ae039));
};


function $f29082f3986cdd1a$export$5bf35293e545f20c() {
    var analyticsContext = (0, $ca33900def42243a$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6ff1114199100bef$export$33752cf3ee811995)(function(payload) {
        return new (0, $678a5d90a577f603$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $7fPBF = parcelRequire("7fPBF");
var $11344e0a4569d4cb$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $7fPBF.useRef)(value);
    ref.current = value;
    return ref;
};


function $f23f05798b36a8bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f23f05798b36a8bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f23f05798b36a8bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f23f05798b36a8bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f23f05798b36a8bc$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $f29082f3986cdd1a$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $11344e0a4569d4cb$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $11344e0a4569d4cb$export$1d27a74659855e44)(fn);
    var handler = (0, $7fPBF.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $f23f05798b36a8bc$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $7fPBF = parcelRequire("7fPBF");
function $7ef5eb1b79d03b33$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $7fPBF = parcelRequire("7fPBF");

var $1cc23763944a34fc$var$BORDER_WIDTH = 2;
var $1cc23763944a34fc$var$baseFocusOutsideStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    outline: "".concat($1cc23763944a34fc$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $1cc23763944a34fc$var$BORDER_WIDTH
});
var $1cc23763944a34fc$var$baseInsetStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$1cc23763944a34fc$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $1cc23763944a34fc$var$focusRingStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $1cc23763944a34fc$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $1cc23763944a34fc$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $1cc23763944a34fc$var$insetFocusRingStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $1cc23763944a34fc$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $1cc23763944a34fc$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $1cc23763944a34fc$var$FocusRing = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $1cc23763944a34fc$var$baseInsetStyles : $1cc23763944a34fc$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $1cc23763944a34fc$var$insetFocusRingStyles : $1cc23763944a34fc$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $3ebaaabf76fb5db5$export$9b9c0f9d9f3552b8), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $7fPBF.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $7fPBF.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$1cc23763944a34fc$var$FocusRing.displayName = 'FocusRing';
var $1cc23763944a34fc$export$2e2bcd8739ae039 = $1cc23763944a34fc$var$FocusRing;




function $9494dfb6fa4d8149$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $9494dfb6fa4d8149$var$tabKeyCode = 9;
function $9494dfb6fa4d8149$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $9494dfb6fa4d8149$var$tabKeyCode) return;
    $9494dfb6fa4d8149$var$abort(event);
}
var $9494dfb6fa4d8149$var$block = {
    onMouseDownCapture: $9494dfb6fa4d8149$var$abort,
    onMouseUpCapture: $9494dfb6fa4d8149$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $9494dfb6fa4d8149$var$onKey,
    onKeyUpCapture: $9494dfb6fa4d8149$var$onKey,
    onTouchStartCapture: $9494dfb6fa4d8149$var$abort,
    onTouchEndCapture: $9494dfb6fa4d8149$var$abort,
    onPointerDownCapture: $9494dfb6fa4d8149$var$abort,
    onPointerUpCapture: $9494dfb6fa4d8149$var$abort,
    onClickCapture: $9494dfb6fa4d8149$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $9494dfb6fa4d8149$var$abort
};
var $9494dfb6fa4d8149$var$doNotBlock = {};
function $9494dfb6fa4d8149$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $9494dfb6fa4d8149$var$doNotBlock : $9494dfb6fa4d8149$var$block;
}



var $8MJe2 = parcelRequire("8MJe2");


var $137Lh = parcelRequire("137Lh");
/* eslint-disable no-console */ var $bb6e9737a73b7581$var$printed = {};
function $bb6e9737a73b7581$export$2e2bcd8739ae039(message) {
    if ($bb6e9737a73b7581$var$printed[message]) return;
    $bb6e9737a73b7581$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $0440a7eded5169c8$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $bb6e9737a73b7581$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $0440a7eded5169c8$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {}



var $8f68627398411bfa$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $8f68627398411bfa$export$c93026a968943f95 = 'light';
var $8f68627398411bfa$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $8f68627398411bfa$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $8f68627398411bfa$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $8f68627398411bfa$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $d7df1392c2cb1415$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $8f68627398411bfa$export$6d8204c2cb2e06b8() / 4;
    (0, $0440a7eded5169c8$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $8f68627398411bfa$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $8f68627398411bfa$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $8f68627398411bfa$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $0440a7eded5169c8$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $8f68627398411bfa$export$ba1d834b86d72a09 = $8f68627398411bfa$export$a1b3edb637fb4f35;
var $8f68627398411bfa$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $d7df1392c2cb1415$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $d7df1392c2cb1415$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $d7df1392c2cb1415$export$920c0d5c49070351), ")")
            }
        }
    };
};



// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $f11dd91583712f4c$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
var $f11dd91583712f4c$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($d7df1392c2cb1415$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-neutral, ".concat($d7df1392c2cb1415$export$d281fbfe3cff2df6, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($d7df1392c2cb1415$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($d7df1392c2cb1415$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($f11dd91583712f4c$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($d7df1392c2cb1415$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($d7df1392c2cb1415$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($d7df1392c2cb1415$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$3d4f271a500072a, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($d7df1392c2cb1415$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($d7df1392c2cb1415$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($d7df1392c2cb1415$export$e62e8919cca44969, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($d7df1392c2cb1415$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($d7df1392c2cb1415$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($d7df1392c2cb1415$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($d7df1392c2cb1415$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($d7df1392c2cb1415$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$3d4f271a500072a, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($d7df1392c2cb1415$export$c6930421db9fa514, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($d7df1392c2cb1415$export$c6930421db9fa514, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($d7df1392c2cb1415$export$5aae31392d72caaa, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($d7df1392c2cb1415$export$5aae31392d72caaa, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($d7df1392c2cb1415$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($d7df1392c2cb1415$export$59619663aa6500fb, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($d7df1392c2cb1415$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($d7df1392c2cb1415$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$59619663aa6500fb, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$59619663aa6500fb, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($d7df1392c2cb1415$export$2010d0fb4295b346, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($d7df1392c2cb1415$export$2010d0fb4295b346, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($d7df1392c2cb1415$export$4a7404f376229999, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($d7df1392c2cb1415$export$4a7404f376229999, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($d7df1392c2cb1415$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($d7df1392c2cb1415$export$2837b5a1a71d5c02, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($d7df1392c2cb1415$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($d7df1392c2cb1415$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$2837b5a1a71d5c02, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$2837b5a1a71d5c02, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($d7df1392c2cb1415$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($d7df1392c2cb1415$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($f11dd91583712f4c$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($d7df1392c2cb1415$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$3d4f271a500072a, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($d7df1392c2cb1415$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($d7df1392c2cb1415$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($d7df1392c2cb1415$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($d7df1392c2cb1415$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$abcf8c38338b4aa5, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($d7df1392c2cb1415$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($d7df1392c2cb1415$export$633847cf062b69e0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$abcf8c38338b4aa5, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($d7df1392c2cb1415$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($d7df1392c2cb1415$export$7d61b15e0da132af, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$7d61b15e0da132af, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$7d61b15e0da132af, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($d7df1392c2cb1415$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($d7df1392c2cb1415$export$29a4f05edc054374, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$29a4f05edc054374, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$29a4f05edc054374, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($d7df1392c2cb1415$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-link, ".concat($d7df1392c2cb1415$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($d7df1392c2cb1415$export$e62e8919cca44969, ")"),
                dark: "var(--ds-link, ".concat($d7df1392c2cb1415$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($d7df1392c2cb1415$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-link-pressed, ".concat($d7df1392c2cb1415$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$ad0bacf983b7ddaa, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$ad0bacf983b7ddaa, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($d7df1392c2cb1415$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($d7df1392c2cb1415$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($d7df1392c2cb1415$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($d7df1392c2cb1415$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$abcf8c38338b4aa5, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-text-subtle, ".concat($d7df1392c2cb1415$export$f563ee71e9ee74cd, ")"),
                dark: "var(--ds-text-subtle, ".concat($d7df1392c2cb1415$export$abcf8c38338b4aa5, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($d7df1392c2cb1415$export$7c87d337fb91a97d, ")"),
                dark: "var(--ds-text-subtle, ".concat($d7df1392c2cb1415$export$226de0355ed012f8, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($d7df1392c2cb1415$export$eece5f492e429f08, ")"),
                dark: "var(--ds-text, ".concat($d7df1392c2cb1415$export$97e81faa16a182c7, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($d7df1392c2cb1415$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($d7df1392c2cb1415$export$abcf8c38338b4aa5, ")")
            }
        }
    }
};
var $f11dd91583712f4c$export$2e2bcd8739ae039 = $f11dd91583712f4c$var$values;


function $b6783fb02491ef91$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b6783fb02491ef91$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b6783fb02491ef91$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b6783fb02491ef91$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b6783fb02491ef91$var$gridSize = (0, $8f68627398411bfa$export$6d8204c2cb2e06b8)();
var $b6783fb02491ef91$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $b6783fb02491ef91$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $b6783fb02491ef91$var$lineHeights = {
    default: $b6783fb02491ef91$var$heights.default,
    compact: $b6783fb02491ef91$var$heights.compact,
    none: 'inherit'
};
var $b6783fb02491ef91$var$padding = {
    // 10px gutter
    default: "0 ".concat($b6783fb02491ef91$var$gridSize + $b6783fb02491ef91$var$gridSize / 4, "px"),
    compact: "0 ".concat($b6783fb02491ef91$var$gridSize + $b6783fb02491ef91$var$gridSize / 4, "px"),
    none: '0'
};
var $b6783fb02491ef91$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($b6783fb02491ef91$var$gridSize / 4, "px"),
    default: "0 ".concat($b6783fb02491ef91$var$gridSize / 4, "px"),
    none: '0'
};
var $b6783fb02491ef91$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $b6783fb02491ef91$var$innerMargin = {
    content: "0 ".concat($b6783fb02491ef91$var$gridSize / 4, "px"),
    icon: "0 ".concat($b6783fb02491ef91$var$gridSize / 4, "px")
};
var $b6783fb02491ef91$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $b6783fb02491ef91$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    '&:not([disabled])::after': $b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread({}, $b6783fb02491ef91$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $b6783fb02491ef91$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $b6783fb02491ef91$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #0C66E4)",
    '&:hover': {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: 'underline'
    }
};
var $b6783fb02491ef91$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $b6783fb02491ef91$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    }
};
var $b6783fb02491ef91$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $b6783fb02491ef91$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $b6783fb02491ef91$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    '&:not([disabled])::after': $b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread({}, $b6783fb02491ef91$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $b6783fb02491ef91$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $b6783fb02491ef91$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $b6783fb02491ef91$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $b6783fb02491ef91$var$getColor({
            group: (0, $f11dd91583712f4c$export$2e2bcd8739ae039).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($b6783fb02491ef91$var$getColor({
            group: (0, $f11dd91583712f4c$export$2e2bcd8739ae039).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $b6783fb02491ef91$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $b6783fb02491ef91$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return $b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap'
    }, !(0, $137Lh.fg)('platform-component-visual-refresh') && baseColors), {}, {
        cursor: 'pointer',
        height: $b6783fb02491ef91$var$heights[spacing],
        lineHeight: $b6783fb02491ef91$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $b6783fb02491ef91$var$singleIconPadding[spacing] : $b6783fb02491ef91$var$padding[spacing],
        verticalAlign: $b6783fb02491ef91$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, !(0, $137Lh.fg)('platform-component-visual-refresh') && $b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        '&:visited': $b6783fb02491ef91$var$_objectSpread({}, baseColors),
        '&:hover': $b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread({}, $b6783fb02491ef91$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'hover',
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
            // background, box-shadow
            transitionDuration: '0s, 0.15s'
        }),
        // giving active styles preference by listing them after focus
        '&:active': $b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread({}, $b6783fb02491ef91$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread({}, $b6783fb02491ef91$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        '&[disabled]': $b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread({}, $b6783fb02491ef91$var$getColors({
            appearance: appearance,
            key: 'disabled',
            mode: mode
        })), {}, {
            cursor: 'not-allowed',
            textDecoration: 'none'
        })
    }, $b6783fb02491ef91$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $b6783fb02491ef91$var$_objectSpread({}, $b6783fb02491ef91$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'default',
            mode: mode
        }))
    })), (0, $137Lh.fg)('platform-component-visual-refresh') && (isSelected ? $b6783fb02491ef91$var$selectedStyles : $b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread($b6783fb02491ef91$var$_objectSpread({}, appearance === 'default' && $b6783fb02491ef91$var$defaultStyles), appearance === 'primary' && $b6783fb02491ef91$var$primaryStyles), appearance === 'link' && $b6783fb02491ef91$var$linkStyles), appearance === 'subtle' && $b6783fb02491ef91$var$subtleStyles), appearance === 'subtle-link' && $b6783fb02491ef91$var$subtleLinkStyles), appearance === 'warning' && $b6783fb02491ef91$var$warningStyles), appearance === 'danger' && $b6783fb02491ef91$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $b6783fb02491ef91$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $b6783fb02491ef91$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $b6783fb02491ef91$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            }
        }
    }, $b6783fb02491ef91$var$hasOverlayStyles))), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $b6783fb02491ef91$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $b6783fb02491ef91$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $b6783fb02491ef91$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $b6783fb02491ef91$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $b6783fb02491ef91$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $b6783fb02491ef91$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};



var $7fPBF = parcelRequire("7fPBF");

var $290ddf8d29e3e9ea$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $7fPBF.isValidElement)(children) && children.type === (0, $d1b9d01570e45f55$export$2e2bcd8739ae039);
};


var $722abddf1d9775f8$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $722abddf1d9775f8$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $722abddf1d9775f8$var$iconBeforeSpacingFixStyle = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $722abddf1d9775f8$var$iconAfterSpacingFixStyle = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $722abddf1d9775f8$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $290ddf8d29e3e9ea$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $722abddf1d9775f8$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $290ddf8d29e3e9ea$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: childrenStyles
    }, children) : null;
};
var $722abddf1d9775f8$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $722abddf1d9775f8$var$_excluded);
    var ourRef = (0, $7fPBF.useRef)();
    var setRef = (0, $7fPBF.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $7ef5eb1b79d03b33$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $f23f05798b36a8bc$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "23.2.0",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $7fPBF.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $7fPBF.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, $b6783fb02491ef91$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $d7df1392c2cb1415$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $d7df1392c2cb1415$export$c39c0fe0f26207ae), ")"), " !important")
        }
    };
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $1cc23763944a34fc$export$2e2bcd8739ae039), null, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $722abddf1d9775f8$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $9494dfb6fa4d8149$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $b6783fb02491ef91$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $722abddf1d9775f8$var$getSpacingFix(children, $722abddf1d9775f8$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $722abddf1d9775f8$var$getChildren(children, [
        fadeStyles,
        (0, $b6783fb02491ef91$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $b6783fb02491ef91$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $722abddf1d9775f8$var$getSpacingFix(children, $722abddf1d9775f8$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: [
            (0, $b6783fb02491ef91$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$722abddf1d9775f8$export$2e2bcd8739ae039 = $722abddf1d9775f8$var$ButtonBase;



function $05e2ee02e5f3fcad$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $290ddf8d29e3e9ea$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}



var $7fPBF = parcelRequire("7fPBF");
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7c0nF = parcelRequire("7c0nF");

var $7fPBF = parcelRequire("7fPBF");


var $a9743bf0f7c41b9a$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $3894254f53c0c38b$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $d7df1392c2cb1415$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $d7df1392c2cb1415$export$29a4f05edc054374), ")");
}
var $3894254f53c0c38b$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $3894254f53c0c38b$var$loadIn = null;
var $3894254f53c0c38b$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $3894254f53c0c38b$var$useLayoutEffect = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $3894254f53c0c38b$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $a9743bf0f7c41b9a$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $3894254f53c0c38b$var$getStrokeColor(appearance);
    var context = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    $3894254f53c0c38b$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $7c0nF.default)([
            $3894254f53c0c38b$var$styles.wrapperStyles,
            $3894254f53c0c38b$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $7c0nF.default)([
            $3894254f53c0c38b$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $7c0nF.default)([
            $3894254f53c0c38b$var$styles.circleStyles
        ])
    })));
}));
var $3894254f53c0c38b$export$2e2bcd8739ae039 = $3894254f53c0c38b$var$Spinner;


function $64a94669fc66bac0$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $64a94669fc66bac0$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3894254f53c0c38b$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $64a94669fc66bac0$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}



var $8MJe2 = parcelRequire("8MJe2");


function $e02b97f25fb38934$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e02b97f25fb38934$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e02b97f25fb38934$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e02b97f25fb38934$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e02b97f25fb38934$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $e02b97f25fb38934$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'light' : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $b6783fb02491ef91$export$955358618f994a11)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    var selector = $e02b97f25fb38934$var$stateToSelectorMap[state];
    if (selector) result = $e02b97f25fb38934$var$_objectSpread($e02b97f25fb38934$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $e02b97f25fb38934$var$_objectSpread($e02b97f25fb38934$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $e02b97f25fb38934$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $e02b97f25fb38934$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $e02b97f25fb38934$var$Theme = (0, $14df6e03fac80ed6$export$25d302a5b900a763)(function(themeProps) {
    return {
        buttonStyles: $e02b97f25fb38934$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e02b97f25fb38934$export$2e2bcd8739ae039 = $e02b97f25fb38934$var$Theme;


var $fbbde01ccf9a12a8$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $fbbde01ccf9a12a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fbbde01ccf9a12a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fbbde01ccf9a12a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fbbde01ccf9a12a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fbbde01ccf9a12a8$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
var $fbbde01ccf9a12a8$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $fbbde01ccf9a12a8$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $e02b97f25fb38934$export$437a7f77d13d7916) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $fbbde01ccf9a12a8$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $fbbde01ccf9a12a8$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $7fPBF.useState)($fbbde01ccf9a12a8$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $fbbde01ccf9a12a8$var$_objectSpread($fbbde01ccf9a12a8$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $fbbde01ccf9a12a8$var$_objectSpread($fbbde01ccf9a12a8$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $fbbde01ccf9a12a8$var$_objectSpread($fbbde01ccf9a12a8$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $fbbde01ccf9a12a8$var$_objectSpread($fbbde01ccf9a12a8$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $fbbde01ccf9a12a8$var$_objectSpread($fbbde01ccf9a12a8$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $fbbde01ccf9a12a8$var$_objectSpread($fbbde01ccf9a12a8$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e02b97f25fb38934$export$2e2bcd8739ae039).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $034bea2d324ecf61$export$2e2bcd8739ae039).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e02b97f25fb38934$export$2e2bcd8739ae039).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
            mode: mode,
            state: $fbbde01ccf9a12a8$var$getInteractionState($fbbde01ccf9a12a8$var$_objectSpread($fbbde01ccf9a12a8$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $05e2ee02e5f3fcad$export$2e2bcd8739ae039)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $722abddf1d9775f8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $64a94669fc66bac0$export$2e2bcd8739ae039), restProps) : null,
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $e02b97f25fb38934$export$643db0b8d8778e)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$fbbde01ccf9a12a8$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $fbbde01ccf9a12a8$export$2e2bcd8739ae039 = $fbbde01ccf9a12a8$var$CustomThemeButton;



var $cvBp9 = parcelRequire("cvBp9");

var $iKdEz = parcelRequire("iKdEz");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


function $88158db3370365e9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $88158db3370365e9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $88158db3370365e9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $88158db3370365e9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $88158db3370365e9$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $f29082f3986cdd1a$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $11344e0a4569d4cb$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $11344e0a4569d4cb$export$1d27a74659855e44)(fn);
    var handler = (0, $7fPBF.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $88158db3370365e9$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $7fPBF = parcelRequire("7fPBF");

/**
 * Character key codes which can be used in keyboard events.
 */ var $8e49427eac361e67$export$390330c10ff2b9a1 = 'ArrowUp';
var $8e49427eac361e67$export$a80636c6f41931fe = 'ArrowDown';
var $8e49427eac361e67$export$4af703091671bc = 'Home';
var $8e49427eac361e67$export$e2bc30913faa5db7 = 'End';
var $8e49427eac361e67$export$10f6869ed0a7d75b = 'Tab';
var $8e49427eac361e67$export$8152f929a25a0ff4 = 'Enter';
var $8e49427eac361e67$export$e51a3576c045c8d5 = 'Space';
var $8e49427eac361e67$export$2bb790b9008907b4 = 'Escape';


function $7df57ff683b2c713$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $7fPBF.useRef)(false);
    var onKeyDown = (0, $7fPBF.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $8e49427eac361e67$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $7fPBF.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $7fPBF.useEffect)(function() {
        return (0, $a091c25729a976b1$exports.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}



var $7fPBF = parcelRequire("7fPBF");
function $fcc36874ed8a4956$export$2e2bcd8739ae039(value) {
    var ref = (0, $7fPBF.useRef)(value);
    (0, $7fPBF.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

var $7fPBF = parcelRequire("7fPBF");
var $61560c705e45c296$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $acc75caf7777a48d$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


function $d8b18d17afdece32$export$1d57e79091cc3046() {
    var namespace = (0, $7fPBF.useContext)((0, $acc75caf7777a48d$export$644a49f3b8c50fcd));
    return namespace;
}


function $ec007781e67f4551$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    var context = (0, $7fPBF.useContext)((0, $61560c705e45c296$export$5fbf4d7fae6cdc00));
    var namespace = (0, $d8b18d17afdece32$export$1d57e79091cc3046)();
    (0, $7fPBF.useEffect)(function() {
        if ((0, $137Lh.fg)('platform_dst_open_layer_observer_close_layers')) return;
        /**
     * Increments the layer count when the component mounts or becomes visible.
     *
     * Returns a cleanup function to decrement the layer count when the component unmounts or becomes hidden.
     */ if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function cleanup() {
            context.decrement();
        };
    }, [
        context,
        isOpen,
        namespace
    ]);
    (0, $7fPBF.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (!(0, $137Lh.fg)('platform_dst_open_layer_observer_close_layers')) return;
        if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $34452922263080f6$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $34452922263080f6$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$34452922263080f6$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $34452922263080f6$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $7fPBF.useState)($34452922263080f6$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        if (!$34452922263080f6$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $a091c25729a976b1$exports.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $34452922263080f6$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $34452922263080f6$export$ff7706047246b98b = function prefersReducedMotion() {
    return $34452922263080f6$export$f0f789643ba5a83c;
};


/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $a1ad98f67aabe587$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $a1ad98f67aabe587$var$ExitingContext = /*#__PURE__*/ (0, $7fPBF.createContext)($a1ad98f67aabe587$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $a1ad98f67aabe587$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a1ad98f67aabe587$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a1ad98f67aabe587$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $a1ad98f67aabe587$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $7fPBF.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $a1ad98f67aabe587$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $a1ad98f67aabe587$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $a1ad98f67aabe587$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $a1ad98f67aabe587$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $a1ad98f67aabe587$var$ExitingPersistence = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $7fPBF.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $7fPBF.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $34452922263080f6$export$b7baf7667a68d87c)() && !(0, $137Lh.fg)('platform_design_system_motion_on_finish_fix')) /**
     * We still want to use the `ExitingPersistence` with reduced motion,
     * otherwise the exiting `onFinish` is not called.
     */ return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $a1ad98f67aabe587$var$childrenToArray(previousChildren);
    var current = $a1ad98f67aabe587$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $a1ad98f67aabe587$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $a1ad98f67aabe587$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $a1ad98f67aabe587$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $a1ad98f67aabe587$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $a1ad98f67aabe587$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $7fPBF.useContext)($a1ad98f67aabe587$var$ExitingContext);
};
$a1ad98f67aabe587$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $a1ad98f67aabe587$export$2e2bcd8739ae039 = $a1ad98f67aabe587$var$ExitingPersistence;


var $7fPBF = parcelRequire("7fPBF");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $02d82b7bcc8cdbfd$var$ATOMIC_GROUP_LENGTH = 5;
function $02d82b7bcc8cdbfd$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $02d82b7bcc8cdbfd$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $137Lh = parcelRequire("137Lh");

/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $f71fbefa8f6c3895$export$368bacef0dacbe05 = 25;
var $f71fbefa8f6c3895$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $f71fbefa8f6c3895$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $f71fbefa8f6c3895$export$30fa1a2e62ae150c = {
    none: $f71fbefa8f6c3895$export$38b928a7167ce124.none,
    small: $f71fbefa8f6c3895$export$38b928a7167ce124.small * $f71fbefa8f6c3895$var$EXITING_MOTION_MULTIPLIER,
    medium: $f71fbefa8f6c3895$export$38b928a7167ce124.medium * $f71fbefa8f6c3895$var$EXITING_MOTION_MULTIPLIER,
    large: $f71fbefa8f6c3895$export$38b928a7167ce124.large * $f71fbefa8f6c3895$var$EXITING_MOTION_MULTIPLIER
};



var $7fPBF = parcelRequire("7fPBF");
var $27095c47a45ed928$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $27095c47a45ed928$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $27095c47a45ed928$var$getHookDeps(opts));
    return (0, $7fPBF.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $27095c47a45ed928$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $27095c47a45ed928$var$getHookDeps(opts));
    return (0, $7fPBF.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $33e380d2666a4ede$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $7fPBF = parcelRequire("7fPBF");
function $4541f9363ab5290d$export$c485849f2e393253() {
    var identifier = (0, $7fPBF.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $32695e8518f8b985$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $7fPBF.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039)
    };
});
var $32695e8518f8b985$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $4541f9363ab5290d$export$c485849f2e393253)();
    var context = (0, $7fPBF.useContext)($32695e8518f8b985$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $32695e8518f8b985$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $7fPBF.useRef)([]);
    var indexes = [];
    var _useState = (0, $7fPBF.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $33e380d2666a4ede$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($32695e8518f8b985$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $32695e8518f8b985$export$2e2bcd8739ae039 = $32695e8518f8b985$var$StaggeredEntrance;


var $a5b5d47be4518e83$var$zoomIn = null;
var $a5b5d47be4518e83$var$zoomOut = null;
var $a5b5d47be4518e83$var$fadeIn = null;
var $a5b5d47be4518e83$var$fadeOut = null;
var $a5b5d47be4518e83$var$fadeInFromTop = null;
var $a5b5d47be4518e83$var$fadeOutFromTop = null;
var $a5b5d47be4518e83$var$fadeInFromLeft = null;
var $a5b5d47be4518e83$var$fadeOutFromLeft = null;
var $a5b5d47be4518e83$var$fadeInFromBottom = null;
var $a5b5d47be4518e83$var$fadeOutFromBottom = null;
var $a5b5d47be4518e83$var$fadeInFromRight = null;
var $a5b5d47be4518e83$var$fadeOutFromRight = null;
var $a5b5d47be4518e83$var$fadeInFromTopConstant = null;
var $a5b5d47be4518e83$var$fadeOutFromTopConstant = null;
var $a5b5d47be4518e83$var$fadeInFromLeftConstant = null;
var $a5b5d47be4518e83$var$fadeOutFromLeftConstant = null;
var $a5b5d47be4518e83$var$fadeInFromBottomConstant = null;
var $a5b5d47be4518e83$var$fadeOutFromBottomConstant = null;
var $a5b5d47be4518e83$var$fadeInFromRightConstant = null;
var $a5b5d47be4518e83$var$fadeOutFromRightConstant = null;
var $a5b5d47be4518e83$var$slideInFromTop = null;
var $a5b5d47be4518e83$var$slideOutFromTop = null;
var $a5b5d47be4518e83$var$slideInFromRight = null;
var $a5b5d47be4518e83$var$slideOutFromRight = null;
var $a5b5d47be4518e83$var$slideInFromBottom = null;
var $a5b5d47be4518e83$var$slideOutFromBottom = null;
var $a5b5d47be4518e83$var$slideInFromLeft = null;
var $a5b5d47be4518e83$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $a5b5d47be4518e83$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $32695e8518f8b985$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $a1ad98f67aabe587$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $27095c47a45ed928$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $7fPBF.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $34452922263080f6$export$b7baf7667a68d87c)() && (0, $137Lh.fg)('platform_design_system_motion_on_finish_fix')) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $f71fbefa8f6c3895$export$30fa1a2e62ae150c)[duration] : (0, $f71fbefa8f6c3895$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
            (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $a5b5d47be4518e83$export$2e2bcd8739ae039 = $a5b5d47be4518e83$var$EnteringMotion;


var $a6c67c5a8158581e$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $a6c67c5a8158581e$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $a6c67c5a8158581e$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a5b5d47be4518e83$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $a6c67c5a8158581e$export$2e2bcd8739ae039 = $a6c67c5a8158581e$var$FadeIn;



var $137Lh = parcelRequire("137Lh");



/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $3e2602bfac11e80f$var$registrations = new Set();
var $3e2602bfac11e80f$var$cleanupEndEventListeners = null;
function $3e2602bfac11e80f$var$onDragStart() {
    if ($3e2602bfac11e80f$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $3e2602bfac11e80f$var$cleanupEndEventListeners = (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragend',
            listener: $3e2602bfac11e80f$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $3e2602bfac11e80f$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $3e2602bfac11e80f$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($3e2602bfac11e80f$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $3e2602bfac11e80f$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $3e2602bfac11e80f$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $3e2602bfac11e80f$var$cleanupEndEventListeners = null;
    var clone = Array.from($3e2602bfac11e80f$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $3e2602bfac11e80f$var$bindStartEvents() {
    return (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $3e2602bfac11e80f$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $3e2602bfac11e80f$var$onDragStart
        }
    ]);
}
var $3e2602bfac11e80f$var$cleanupStartEventListeners = null;
function $3e2602bfac11e80f$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$3e2602bfac11e80f$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $3e2602bfac11e80f$var$cleanupStartEventListeners = $3e2602bfac11e80f$var$bindStartEvents();
    $3e2602bfac11e80f$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $3e2602bfac11e80f$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $3e2602bfac11e80f$var$registrations.delete(registration);
        if ($3e2602bfac11e80f$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $3e2602bfac11e80f$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $3e2602bfac11e80f$var$cleanupStartEventListeners = null;
        }
    };
}


var $0c2c2be3ef6f60a8$var$delayId = null;
function $0c2c2be3ef6f60a8$export$eaf678f6f93f5250() {
    if ($0c2c2be3ef6f60a8$var$delayId != null) {
        window.clearTimeout($0c2c2be3ef6f60a8$var$delayId);
        $0c2c2be3ef6f60a8$var$delayId = null;
    }
}
function $0c2c2be3ef6f60a8$export$5f4d6617421d489b(fn, delay) {
    $0c2c2be3ef6f60a8$export$eaf678f6f93f5250();
    $0c2c2be3ef6f60a8$var$delayId = window.setTimeout(function() {
        $0c2c2be3ef6f60a8$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $ecef1be4a61e27c7$var$active = null;
function $ecef1be4a61e27c7$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($ecef1be4a61e27c7$var$active && $ecef1be4a61e27c7$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $0c2c2be3ef6f60a8$export$eaf678f6f93f5250)();
            $ecef1be4a61e27c7$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $0c2c2be3ef6f60a8$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $0c2c2be3ef6f60a8$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $0c2c2be3ef6f60a8$export$5f4d6617421d489b)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($ecef1be4a61e27c7$var$active && $ecef1be4a61e27c7$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($ecef1be4a61e27c7$var$active) {
            (0, $0c2c2be3ef6f60a8$export$eaf678f6f93f5250)();
            $ecef1be4a61e27c7$var$active.entry.hide({
                isImmediate: true
            });
            $ecef1be4a61e27c7$var$active.entry.done();
            $ecef1be4a61e27c7$var$active = null;
        }
        // this tooltip is now the active tooltip
        $ecef1be4a61e27c7$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $0c2c2be3ef6f60a8$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}



function $44c14f6d93a62e21$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $d4d502868e612e1e$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

var $7c0nF = parcelRequire("7c0nF");/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $ed47fa67431e1889$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}




var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


function $973c68b5d6a934f3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $973c68b5d6a934f3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $973c68b5d6a934f3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $973c68b5d6a934f3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $973c68b5d6a934f3$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
var $973c68b5d6a934f3$var$primitiveStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    zindex: "var(".concat($973c68b5d6a934f3$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $973c68b5d6a934f3$var$TooltipPrimitive = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $973c68b5d6a934f3$var$_objectSpread($973c68b5d6a934f3$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $973c68b5d6a934f3$var$VAR_PRIMITIVE_ZINDEX, (0, $8f68627398411bfa$export$7be255094ccdc533).tooltip()));
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $973c68b5d6a934f3$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$973c68b5d6a934f3$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $973c68b5d6a934f3$export$2e2bcd8739ae039 = $973c68b5d6a934f3$var$TooltipPrimitive;


function $719d62abeb5a1a67$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $719d62abeb5a1a67$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $719d62abeb5a1a67$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $719d62abeb5a1a67$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $719d62abeb5a1a67$var$baseStyles = null;
var $719d62abeb5a1a67$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $719d62abeb5a1a67$var$TooltipContainer = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $7fPBF.createElement((0, $973c68b5d6a934f3$export$2e2bcd8739ae039), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7c0nF.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $719d62abeb5a1a67$var$_objectSpread($719d62abeb5a1a67$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $ed47fa67431e1889$export$2e2bcd8739ae039)("var(--ds-background-neutral-bold, ".concat((0, $d7df1392c2cb1415$export$7d61b15e0da132af), ")")),
            "--_ywovvi": (0, $ed47fa67431e1889$export$2e2bcd8739ae039)("var(--ds-text-inverse, ".concat((0, $d7df1392c2cb1415$export$29a4f05edc054374), ")"))
        })
    }, children);
});
$719d62abeb5a1a67$var$TooltipContainer.displayName = 'TooltipContainer';
var $719d62abeb5a1a67$export$2e2bcd8739ae039 = $719d62abeb5a1a67$var$TooltipContainer;


function $8b45f3f99ba78a10$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $fcc0c712cfedad8f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fcc0c712cfedad8f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fcc0c712cfedad8f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fcc0c712cfedad8f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fcc0c712cfedad8f$var$tooltipZIndex = (0, $8f68627398411bfa$export$7be255094ccdc533).tooltip();
var $fcc0c712cfedad8f$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.0.6"
};
// Inverts motion direction
var $fcc0c712cfedad8f$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $fcc0c712cfedad8f$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $fcc0c712cfedad8f$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $719d62abeb5a1a67$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $88158db3370365e9$export$1a04351537078b55)($fcc0c712cfedad8f$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $fcc0c712cfedad8f$var$analyticsAttributes));
    var onHideHandler = (0, $88158db3370365e9$export$1a04351537078b55)($fcc0c712cfedad8f$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $fcc0c712cfedad8f$var$analyticsAttributes));
    var apiRef = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $7fPBF.useRef)(null);
    var containerRef = (0, $7fPBF.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $7fPBF.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $fcc36874ed8a4956$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $fcc36874ed8a4956$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $fcc36874ed8a4956$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $fcc36874ed8a4956$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $fcc36874ed8a4956$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $7fPBF.useRef)(false);
    var start = (0, $7fPBF.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $7fPBF.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $7fPBF.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $7fPBF.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(function() {
        return (0, $3e2602bfac11e80f$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $7fPBF.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $ecef1be4a61e27c7$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $7fPBF.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $7df57ff683b2c713$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $7fPBF.useEffect)(function() {
        if (state === 'hide') return 0, $f48d740006cf3f7d$export$2e2bcd8739ae039;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $7fPBF.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $7fPBF.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $7fPBF.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $8b45f3f99ba78a10$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $7fPBF.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $8b45f3f99ba78a10$export$642213d516a9b928)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $7fPBF.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $7fPBF.useCallback)(function() {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (targetRef.current && !targetRef.current.matches(':focus-visible') && (0, $137Lh.fg)('platform-tooltip-focus-visible')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $7fPBF.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $7fPBF.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $7fPBF.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $ec007781e67f4551$export$469bb693f11edc7f)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && ((0, $137Lh.fg)('platform_dst_open_layer_observer_close_layers') ? shouldRenderTooltipChildren : true),
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === 'mouse' && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $44c14f6d93a62e21$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $7fPBF.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children($fcc0c712cfedad8f$var$_objectSpread($fcc0c712cfedad8f$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd3bc8368572caba$export$2e2bcd8739ae039), {
        zIndex: $fcc0c712cfedad8f$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e8027c477e280fef$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $fcc0c712cfedad8f$var$invertedDirection[$fcc0c712cfedad8f$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a1ad98f67aabe587$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a6c67c5a8158581e$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $fcc0c712cfedad8f$var$_objectSpread($fcc0c712cfedad8f$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$fcc0c712cfedad8f$var$Tooltip.displayName = 'Tooltip';
var $fcc0c712cfedad8f$export$2e2bcd8739ae039 = $fcc0c712cfedad8f$var$Tooltip;



var $7fPBF = parcelRequire("7fPBF");

var $d480615bd38df9e9$export$93d4e7f90805808f = function useTheme() {
    return (0, $7fPBF.useContext)((0, $a2fb43746167a532$export$2c657da244d00bd6));
};



var $8MJe2 = parcelRequire("8MJe2");
function $d5fdedda4fc17def$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5fdedda4fc17def$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5fdedda4fc17def$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5fdedda4fc17def$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d5fdedda4fc17def$export$14dd6915caf431fe = function getPrimaryButtonTheme(_ref) {
    var primaryButton = _ref.mode.primaryButton;
    return function(current, props) {
        var _current = current(props), buttonStyles = _current.buttonStyles, spinnerStyles = _current.spinnerStyles;
        return {
            buttonStyles: $d5fdedda4fc17def$var$_objectSpread($d5fdedda4fc17def$var$_objectSpread($d5fdedda4fc17def$var$_objectSpread($d5fdedda4fc17def$var$_objectSpread({}, buttonStyles), primaryButton.default), props.isSelected && primaryButton.selected), {}, {
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: "0 ".concat("var(--ds-space-050, 4px)"),
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': $d5fdedda4fc17def$var$_objectSpread({}, props.state === 'active' && primaryButton.active)
            }),
            spinnerStyles: spinnerStyles
        };
    };
};


var $f5607a9546336e2a$var$_excluded = [
    "children",
    "component",
    "isHighlighted",
    "isLoading",
    "isSelected",
    "onClick",
    "testId",
    "theme",
    "tooltip"
];
var $f5607a9546336e2a$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
var $f5607a9546336e2a$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
var $f5607a9546336e2a$var$buttonBaseStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
});
var $f5607a9546336e2a$var$buttonHighlightedStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: "var(".concat($f5607a9546336e2a$var$VAR_BUTTON_SELECTED_COLOR, ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: "var(".concat($f5607a9546336e2a$var$VAR_BUTTON_SELECTED_BORDER_COLOR, ")"),
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
var $f5607a9546336e2a$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var children = props.children, component = props.component, isHighlighted = props.isHighlighted, isLoading = props.isLoading, isSelected = props.isSelected, onClick = props.onClick, testId = props.testId, theme = props.theme, tooltip = props.tooltip, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $f5607a9546336e2a$var$_excluded);
    var themeFromContext = (0, $d480615bd38df9e9$export$93d4e7f90805808f)();
    var button = (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $f5607a9546336e2a$var$VAR_BUTTON_SELECTED_COLOR, themeFromContext.mode.primaryButton.selected.color), $f5607a9546336e2a$var$VAR_BUTTON_SELECTED_BORDER_COLOR, themeFromContext.mode.primaryButton.selected.borderColor),
        css: [
            $f5607a9546336e2a$var$buttonBaseStyles,
            isHighlighted && $f5607a9546336e2a$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $fbbde01ccf9a12a8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        theme: theme || (0, $d5fdedda4fc17def$export$14dd6915caf431fe)(themeFromContext)
    }, rest), children));
    if (tooltip) return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $fcc0c712cfedad8f$export$2e2bcd8739ae039), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});


var $7d4930215a35439f$var$_excluded = [
    "component",
    "isHighlighted",
    "isLoading",
    "onClick",
    "testId",
    "theme",
    "tooltip"
];
var $7d4930215a35439f$export$bb3af89fb196520d = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var component = props.component, isHighlighted = props.isHighlighted, isLoading = props.isLoading, onClick = props.onClick, testId = props.testId, theme = props.theme, tooltip = props.tooltip, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $7d4930215a35439f$var$_excluded);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $f5607a9546336e2a$export$ac16a6a04d9b7c84), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        component: component,
        iconAfter: (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($40649b4d91b6fedf$exports))), {
            LEGACY_margin: "0 ".concat("var(--ds-space-negative-050, -4px)", " 0 ", "var(--ds-space-negative-100, -8px)"),
            color: "currentColor",
            label: ""
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        theme: theme,
        tooltip: tooltip
    }, rest));
});


var $ee25c17e75fc6a6b$var$containerStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        margin: "0 ".concat("var(--ds-space-050, 4px)"),
        flexShrink: 0
    }
});
var $ee25c17e75fc6a6b$var$widthObserverContainerStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    width: '100%',
    minWidth: '1px',
    margin: '0px',
    position: 'relative',
    flexShrink: 1
});
var $ee25c17e75fc6a6b$var$overflowItemsStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    color: "var(--ds-text, ".concat((0, $d7df1392c2cb1415$export$ad0bacf983b7ddaa), ")")
});
var $ee25c17e75fc6a6b$export$43e704064d596a9e = function PrimaryItemsContainer(_ref) {
    var moreLabel = _ref.moreLabel, items = _ref.items, Create = _ref.create, theme = _ref.theme, testId = _ref.testId;
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isMoreOpen = _useState2[0], setIsMoreOpen = _useState2[1];
    var _useOverflowControlle = (0, $29a6ecad9d545dc1$export$705aa66a39c35bf7)(items), updateWidth = _useOverflowControlle.updateWidth, visibleItems = _useOverflowControlle.visibleItems, overflowItems = _useOverflowControlle.overflowItems;
    var onMoreClick = (0, $7fPBF.useCallback)(function() {
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    var onMoreClose = (0, $7fPBF.useCallback)(function() {
        setIsMoreOpen(false);
    }, []);
    var openOverflowMenu = (0, $7fPBF.useCallback)(function() {
        setIsMoreOpen(true);
    }, []);
    var trigger = (0, $7fPBF.useCallback)(function(triggerProps) {
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $7d4930215a35439f$export$bb3af89fb196520d), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? "".concat(testId, "-overflow-menu-trigger") : 'overflow-menu-trigger'
        }, triggerProps), moreLabel);
    }, [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    var content = (0, $7fPBF.useCallback)(function() {
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $29a6ecad9d545dc1$export$a3a2def3937905a0), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
            css: $ee25c17e75fc6a6b$var$overflowItemsStyles
        }, overflowItems));
    }, // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        css: $ee25c17e75fc6a6b$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-primary-actions"),
        role: "list"
    }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $29a6ecad9d545dc1$export$a3a2def3937905a0), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $2c055187658302fb$export$2e2bcd8739ae039), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? "".concat(testId, "-overflow-menu-popup") : 'overflow-menu-popup'
    }), Create && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Create, null), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        css: $ee25c17e75fc6a6b$var$widthObserverContainerStyles
    }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $66ddca22d5092ead$export$b2ad68b9bc407b80), {
        offscreen: true,
        setWidth: updateWidth
    })));
};


var $436c212ddd6b0459$var$containerStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $09cd32ac24fc7bec$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: "1px solid ".concat("var(--ds-border, ".concat((0, $d7df1392c2cb1415$export$3e51e8f1440314ba), ")")),
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
var $436c212ddd6b0459$var$leftStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    minWidth: 0,
    height: 'inherit',
    alignItems: 'center',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        flexShrink: 0
    }
});
var $436c212ddd6b0459$var$rightStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        flexShrink: 0,
        marginInlineEnd: "var(--ds-space-050, 4px)"
    }
});
var $436c212ddd6b0459$var$noRightMarginStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    marginInlineEnd: 0
});
var $436c212ddd6b0459$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
var $436c212ddd6b0459$export$f66ccb39f60980e5 = function AtlassianNavigation(props) {
    var label = props.label, _props$primaryItems = props.primaryItems, primaryItems = _props$primaryItems === void 0 ? [] : _props$primaryItems, AppSwitcher = props.renderAppSwitcher, create = props.renderCreate, Help = props.renderHelp, Notifications = props.renderNotifications, ProductHome = props.renderProductHome, Profile = props.renderProfile, Search = props.renderSearch, SignIn = props.renderSignIn, Settings = props.renderSettings, _props$moreLabel = props.moreLabel, moreLabel = _props$moreLabel === void 0 ? "\u2026" : _props$moreLabel, _props$theme = props.theme, theme = _props$theme === void 0 ? (0, $2c11322889abbfcf$export$164de7ab8df77ef0) : _props$theme, testId = props.testId, _props$isServer = props.isServer, isServer = _props$isServer === void 0 ? false : _props$isServer, _props$isSSRPlacehold = props.isSSRPlaceholderEnabled, isSSRPlaceholderEnabled = _props$isSSRPlacehold === void 0 ? false : _props$isSSRPlacehold;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $a2fb43746167a532$export$d8964aec282183a3), {
        value: theme
    }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $75c91c4e13a5796f$export$d0a82da1a0b94929), {
        data: $436c212ddd6b0459$var$analyticsData
    }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("header", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $436c212ddd6b0459$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-header"),
        role: "banner",
        "data-vc": "atlassian-navigation".concat(isServer ? '-ssr' : '')
    }, isServer && isSSRPlaceholderEnabled && {
        'data-ssr-placeholder': 'atlassian-navigation-placeholder'
    }, !isServer && isSSRPlaceholderEnabled && {
        'data-ssr-placeholder-replace': 'atlassian-navigation-placeholder'
    }), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("nav", {
        css: $436c212ddd6b0459$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(AppSwitcher, null), ProductHome && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(ProductHome, null), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $ee25c17e75fc6a6b$export$43e704064d596a9e), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        theme: theme
    })), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        css: $436c212ddd6b0459$var$rightStyles,
        "data-testid": testId && "".concat(testId, "-secondary-actions")
    }, Search && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Search, null), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        role: "list",
        css: [
            $436c212ddd6b0459$var$rightStyles,
            $436c212ddd6b0459$var$noRightMarginStyles
        ],
        "data-vc": "atlassian-navigation-secondary-actions"
    }, Notifications && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Notifications, null), Help && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Help, null), Settings && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Settings, null), SignIn && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(SignIn, null), Profile && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Profile, null))))));
};



var $7fPBF = parcelRequire("7fPBF");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $8MJe2 = parcelRequire("8MJe2");

var $8lLl9 = parcelRequire("8lLl9");

var $5hU4u = parcelRequire("5hU4u");

var $bRUy3 = parcelRequire("bRUy3");

var $iKdEz = parcelRequire("iKdEz");

var $5hU4u = parcelRequire("5hU4u");
var $fda0d3ce6cabfedf$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
var $fda0d3ce6cabfedf$var$customThemeOptions = 'UNSAFE_themeOptions';
var $fda0d3ce6cabfedf$var$isThemeKind = function isThemeKind(themeKind) {
    return $fda0d3ce6cabfedf$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $fda0d3ce6cabfedf$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $5hU4u.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $fda0d3ce6cabfedf$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $fda0d3ce6cabfedf$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $fda0d3ce6cabfedf$var$isColorMode(id)) themeObject[kind] = id;
        if ($fda0d3ce6cabfedf$var$isThemeKind(kind) && $fda0d3ce6cabfedf$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $fda0d3ce6cabfedf$var$customThemeOptions) try {
            themeObject[$fda0d3ce6cabfedf$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $fda0d3ce6cabfedf$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $fda0d3ce6cabfedf$var$isColorMode(id) || // custom theme state
        kind === $fda0d3ce6cabfedf$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(id) === 'object' || // other theme states
        $fda0d3ce6cabfedf$var$isThemeKind(kind) && typeof id === 'string' && $fda0d3ce6cabfedf$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};


function $71e88d22ec4172d1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71e88d22ec4172d1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71e88d22ec4172d1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71e88d22ec4172d1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $71e88d22ec4172d1$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $5hU4u.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $71e88d22ec4172d1$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $8lLl9.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $8lLl9.THEME_DATA_ATTRIBUTE)) || '';
    return $71e88d22ec4172d1$var$_objectSpread($71e88d22ec4172d1$var$_objectSpread({}, (0, $fda0d3ce6cabfedf$export$f19b488f7c0547ee)(theme)), $71e88d22ec4172d1$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $71e88d22ec4172d1$export$2e2bcd8739ae039 = $71e88d22ec4172d1$var$getGlobalTheme;



var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");

var $8lLl9 = parcelRequire("8lLl9");

/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $1a1489ec931d4385$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $71e88d22ec4172d1$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $8lLl9.THEME_DATA_ATTRIBUTE),
                            (0, $8lLl9.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($1a1489ec931d4385$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($1a1489ec931d4385$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $a1474506d92c7d3c$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $7fPBF.useState)((0, $71e88d22ec4172d1$export$2e2bcd8739ae039)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        var observer = new (0, $1a1489ec931d4385$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $a1474506d92c7d3c$export$2e2bcd8739ae039 = $a1474506d92c7d3c$var$useThemeObserver;


/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $8eafb83749b35973$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $8eafb83749b35973$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 


/* wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $86ebb3b02603ea9e$var$ATOMIC_GROUP_LENGTH = 5;
function $86ebb3b02603ea9e$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $86ebb3b02603ea9e$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $458ceb8f9bc6ff8c$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $458ceb8f9bc6ff8c$var$CSS_VAR_COLOR = '--logo-color';
var $458ceb8f9bc6ff8c$var$CSS_VAR_FILL = '--logo-fill';
var $458ceb8f9bc6ff8c$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $458ceb8f9bc6ff8c$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $458ceb8f9bc6ff8c$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        "data-testid": testId,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $458ceb8f9bc6ff8c$var$CSS_VAR_COLOR, iconColor), $458ceb8f9bc6ff8c$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $86ebb3b02603ea9e$export$2e2bcd8739ae039)([
            $458ceb8f9bc6ff8c$var$styles.root,
            shouldApplyStopColor && $458ceb8f9bc6ff8c$var$styles.stop,
            size && $458ceb8f9bc6ff8c$var$styles[size]
        ])
    }));
};
var $458ceb8f9bc6ff8c$export$2e2bcd8739ae039 = $458ceb8f9bc6ff8c$var$Wrapper;


// Reds
var $eeaadfe7fe696d76$export$4b84fd0e2c617bd = '#FFEBE6';
var $eeaadfe7fe696d76$export$b34b069eff244586 = '#FFBDAD';
var $eeaadfe7fe696d76$export$be802dd0d8b57f35 = '#FF8F73';
var $eeaadfe7fe696d76$export$60847d42f9da92a6 = '#FF7452';
var $eeaadfe7fe696d76$export$4a7404f376229999 = '#FF5630';
var $eeaadfe7fe696d76$export$2010d0fb4295b346 = '#DE350B';
var $eeaadfe7fe696d76$export$2837b5a1a71d5c02 = '#BF2600';
var $eeaadfe7fe696d76$export$8d9596b529bbb9cf = '#FFFAE6';
var $eeaadfe7fe696d76$export$41060a744ab0b7ae = '#FFF0B3';
var $eeaadfe7fe696d76$export$1cc05bbbf340e559 = '#FFE380';
var $eeaadfe7fe696d76$export$5aae31392d72caaa = '#FFC400';
var $eeaadfe7fe696d76$export$c6930421db9fa514 = '#FFAB00';
var $eeaadfe7fe696d76$export$59619663aa6500fb = '#FF991F';
var $eeaadfe7fe696d76$export$874739ea9e379ab6 = '#FF8B00';
var $eeaadfe7fe696d76$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $eeaadfe7fe696d76$export$69a3bf21b9686c2b = '#ABF5D1';
var $eeaadfe7fe696d76$export$afbce1382ec95f73 = '#79F2C0';
var $eeaadfe7fe696d76$export$747d86715d4175de = '#57D9A3';
var $eeaadfe7fe696d76$export$940e1f69e873f202 = '#36B37E';
var $eeaadfe7fe696d76$export$a49394138f7b8e85 = '#00875A';
var $eeaadfe7fe696d76$export$6fa04827ac68a4fb = '#006644';
var $eeaadfe7fe696d76$export$226de0355ed012f8 = '#DEEBFF';
var $eeaadfe7fe696d76$export$8c13c2ee36917869 = '#B3D4FF';
var $eeaadfe7fe696d76$export$ecfc1dff386a3e7a = '#4C9AFF';
var $eeaadfe7fe696d76$export$215b7063051591f1 = '#2684FF';
var $eeaadfe7fe696d76$export$e62e8919cca44969 = '#0065FF';
var $eeaadfe7fe696d76$export$b3de0ae08da2ce64 = '#0052CC';
var $eeaadfe7fe696d76$export$a6ee3d71bc067634 = '#0747A6';
var $eeaadfe7fe696d76$export$67f15409e87642a1 = '#669DF1';
var $eeaadfe7fe696d76$export$f0539dbc42dbb067 = '#8FB8F6';
var $eeaadfe7fe696d76$export$363e4475840015bb = '#EAE6FF';
var $eeaadfe7fe696d76$export$4b0a4417ed59760f = '#C0B6F2';
var $eeaadfe7fe696d76$export$6011520a64d9a187 = '#998DD9';
var $eeaadfe7fe696d76$export$a7175d4e9206bc80 = '#8777D9';
var $eeaadfe7fe696d76$export$b48405b95304b5a1 = '#6554C0';
var $eeaadfe7fe696d76$export$c71e4279dd54a18d = '#5243AA';
var $eeaadfe7fe696d76$export$147899de772240ec = '#403294';
var $eeaadfe7fe696d76$export$2cf711fe14c66f06 = '#E6FCFF';
var $eeaadfe7fe696d76$export$7a8f4d33f6f9772c = '#B3F5FF';
var $eeaadfe7fe696d76$export$776c9c497ef08533 = '#79E2F2';
var $eeaadfe7fe696d76$export$69cb3ca10c1e330e = '#00C7E6';
var $eeaadfe7fe696d76$export$9dc1ef0f3f48059b = '#00B8D9';
var $eeaadfe7fe696d76$export$7c835c78b6fcdef8 = '#00A3BF';
var $eeaadfe7fe696d76$export$6036577f95c3877e = '#008DA6';
var $eeaadfe7fe696d76$export$29a4f05edc054374 = '#FFFFFF';
var $eeaadfe7fe696d76$export$e655ef011c4aa1a2 = '#FAFBFC';
var $eeaadfe7fe696d76$export$9fdfb749e33cdf97 = '#F4F5F7';
var $eeaadfe7fe696d76$export$3e51e8f1440314ba = '#EBECF0';
var $eeaadfe7fe696d76$export$1ce2d1575d444ceb = '#DFE1E6';
var $eeaadfe7fe696d76$export$8754fc7e6d8b3000 = '#C1C7D0';
var $eeaadfe7fe696d76$export$c2e91cbeada39b8b = '#B3BAC5';
var $eeaadfe7fe696d76$export$5f71e19f3a7ad9de = '#A5ADBA';
var $eeaadfe7fe696d76$export$eaa8c8a70ac22806 = '#97A0AF';
var $eeaadfe7fe696d76$export$7c87d337fb91a97d = '#8993A4';
var $eeaadfe7fe696d76$export$d6447c357493214f = '#7A869A';
var $eeaadfe7fe696d76$export$f563ee71e9ee74cd = '#6B778C';
var $eeaadfe7fe696d76$export$e2ef2124cf4024b1 = '#5E6C84';
var $eeaadfe7fe696d76$export$eece5f492e429f08 = '#505F79';
var $eeaadfe7fe696d76$export$c39c0fe0f26207ae = '#42526E';
var $eeaadfe7fe696d76$export$7090862dc3038a9f = '#344563';
var $eeaadfe7fe696d76$export$ad0bacf983b7ddaa = '#253858';
var $eeaadfe7fe696d76$export$7d61b15e0da132af = '#172B4D';
var $eeaadfe7fe696d76$export$fbda843f0a27fe96 = '#091E42';
var $eeaadfe7fe696d76$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $eeaadfe7fe696d76$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $eeaadfe7fe696d76$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $eeaadfe7fe696d76$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $eeaadfe7fe696d76$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $eeaadfe7fe696d76$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $eeaadfe7fe696d76$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $eeaadfe7fe696d76$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $eeaadfe7fe696d76$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $eeaadfe7fe696d76$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $eeaadfe7fe696d76$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $eeaadfe7fe696d76$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $eeaadfe7fe696d76$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $eeaadfe7fe696d76$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $eeaadfe7fe696d76$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $eeaadfe7fe696d76$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $eeaadfe7fe696d76$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $eeaadfe7fe696d76$export$2f6319cf7d736c2a = '#E6EDFA';
var $eeaadfe7fe696d76$export$95126bc8884d6634 = '#DCE5F5';
var $eeaadfe7fe696d76$export$8338d8c35d44ff1 = '#CED9EB';
var $eeaadfe7fe696d76$export$5368d76ae4fbbda7 = '#B8C7E0';
var $eeaadfe7fe696d76$export$9f0a771d16ec8d36 = '#ABBBD6';
var $eeaadfe7fe696d76$export$abcf8c38338b4aa5 = '#9FB0CC';
var $eeaadfe7fe696d76$export$97e81faa16a182c7 = '#8C9CB8';
var $eeaadfe7fe696d76$export$bfe21c59123ecf33 = '#7988A3';
var $eeaadfe7fe696d76$export$ee82aa2ea6a1558 = '#67758F';
var $eeaadfe7fe696d76$export$682927c6ed76be02 = '#56637A';
var $eeaadfe7fe696d76$export$91fd9994c5be9757 = '#455166';
var $eeaadfe7fe696d76$export$d281fbfe3cff2df6 = '#3B475C';
var $eeaadfe7fe696d76$export$3902c91d8b98a753 = '#313D52';
var $eeaadfe7fe696d76$export$8e8133c1ba5845b5 = '#283447';
var $eeaadfe7fe696d76$export$33ff357f6620b39 = '#202B3D';
var $eeaadfe7fe696d76$export$633847cf062b69e0 = '#1B2638';
var $eeaadfe7fe696d76$export$9776a6e503bdbf76 = '#121A29';
var $eeaadfe7fe696d76$export$6c813d5160dff5db = '#0E1624';
var $eeaadfe7fe696d76$export$3d4f271a500072a = '#0D1424';
var $eeaadfe7fe696d76$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $eeaadfe7fe696d76$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $eeaadfe7fe696d76$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $eeaadfe7fe696d76$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $eeaadfe7fe696d76$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $eeaadfe7fe696d76$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $eeaadfe7fe696d76$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $eeaadfe7fe696d76$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $eeaadfe7fe696d76$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $eeaadfe7fe696d76$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $eeaadfe7fe696d76$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $eeaadfe7fe696d76$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $eeaadfe7fe696d76$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $eeaadfe7fe696d76$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $eeaadfe7fe696d76$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $eeaadfe7fe696d76$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $eeaadfe7fe696d76$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $eeaadfe7fe696d76$export$d2adc5dedf09fced = '#292A2E';
var $eeaadfe7fe696d76$export$f51762073d2bb381 = '#94C748';
var $eeaadfe7fe696d76$export$95e26d54def96891 = '#B3DF72';


var $2871e4832ca4bd2f$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $eeaadfe7fe696d76$export$b3de0ae08da2ce64);
            iconGradientStop = (0, $eeaadfe7fe696d76$export$215b7063051591f1);
            iconColor = (0, $eeaadfe7fe696d76$export$215b7063051591f1);
            textColor = "var(--ds-text, ".concat((0, $eeaadfe7fe696d76$export$7d61b15e0da132af), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $eeaadfe7fe696d76$export$b3de0ae08da2ce64);
            break;
        case 'neutral':
            iconGradientStart = (0, $eeaadfe7fe696d76$export$7090862dc3038a9f);
            iconGradientStop = (0, $eeaadfe7fe696d76$export$d6447c357493214f);
            iconColor = (0, $eeaadfe7fe696d76$export$d6447c357493214f);
            textColor = (0, $eeaadfe7fe696d76$export$eece5f492e429f08);
            atlassianLogoTextColor = (0, $eeaadfe7fe696d76$export$eece5f492e429f08);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $2871e4832ca4bd2f$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $eeaadfe7fe696d76$export$29a4f05edc054374);
            textColor = (0, $eeaadfe7fe696d76$export$29a4f05edc054374);
            atlassianLogoTextColor = (0, $eeaadfe7fe696d76$export$29a4f05edc054374);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $2871e4832ca4bd2f$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $2871e4832ca4bd2f$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $2871e4832ca4bd2f$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};


var $fd94651bfb983298$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n    </svg>");
};
var $fd94651bfb983298$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $fd94651bfb983298$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $bfd88f1eb4dd979f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 198 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\">\n      <path fill=".concat(colors.iconColor, " d=\"M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"/>\n      <path fill=").concat(colors.atlassianLogoTextColor, " d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354\"/>\n    </svg>");
};
var $bfd88f1eb4dd979f$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $bfd88f1eb4dd979f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $j9spr = parcelRequire("j9spr");

var $7fPBF = parcelRequire("7fPBF");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $7fPBF = parcelRequire("7fPBF");



var $0a833860173a6d7c$var$justifyContentMap = {
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'start'
    }),
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'center'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'stretch'
    })
};
var $0a833860173a6d7c$var$flexDirectionMap = {
    column: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        flexDirection: 'column'
    }),
    row: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        flexDirection: 'row'
    })
};
var $0a833860173a6d7c$var$flexWrapMap = {
    wrap: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        flexWrap: 'nowrap'
    })
};
var $0a833860173a6d7c$var$alignItemsMap = {
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'start'
    }),
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'center'
    }),
    baseline: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'baseline'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'end'
    }),
    stretch: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'stretch'
    })
};
var $0a833860173a6d7c$var$baseStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $0a833860173a6d7c$var$Flex = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $3e5203791fd7c7fc$export$a9c84988c8f81f2d)(xcss);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $0a833860173a6d7c$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $f914dcb93d08bd27$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $f914dcb93d08bd27$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $f914dcb93d08bd27$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $0a833860173a6d7c$var$alignItemsMap[alignItems],
            direction && $0a833860173a6d7c$var$flexDirectionMap[direction],
            justifyContent && $0a833860173a6d7c$var$justifyContentMap[justifyContent],
            wrap && $0a833860173a6d7c$var$flexWrapMap[wrap],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$0a833860173a6d7c$var$Flex.displayName = 'Flex';
var $0a833860173a6d7c$export$2e2bcd8739ae039 = $0a833860173a6d7c$var$Flex;


var $067e8036161c713e$var$flexGrowMap = {
    hug: (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
var $067e8036161c713e$var$separatorStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $067e8036161c713e$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: $067e8036161c713e$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $067e8036161c713e$var$Inline = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)($067e8036161c713e$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $7fPBF.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $7fPBF.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $067e8036161c713e$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $0a833860173a6d7c$export$2e2bcd8739ae039), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$067e8036161c713e$var$Inline.displayName = 'Inline';
var $067e8036161c713e$export$2e2bcd8739ae039 = $067e8036161c713e$var$Inline;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $7fPBF = parcelRequire("7fPBF");





var $96a603e4012a3253$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $96a603e4012a3253$var$resetStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $96a603e4012a3253$var$strongStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
var $96a603e4012a3253$var$emStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    fontStyle: 'italic'
});
var $96a603e4012a3253$var$textAlignMap = {
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        textAlign: 'center'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        textAlign: 'end'
    }),
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        textAlign: 'start'
    })
};
var $96a603e4012a3253$var$truncationStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $96a603e4012a3253$var$wordBreakMap = {
    breakAll: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $96a603e4012a3253$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $bd8fd1a07ee559ec$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $f914dcb93d08bd27$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $f914dcb93d08bd27$export$2185ce37f9bdd963)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $96a603e4012a3253$var$Text = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)($96a603e4012a3253$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $047c63fd47a9d222$export$9322276ec105d055)();
    var color = $96a603e4012a3253$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, {
        ref: ref,
        css: [
            $96a603e4012a3253$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $f914dcb93d08bd27$export$219d364c0da35ae4)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $f914dcb93d08bd27$export$3a1bcba60b23d7f0)[color],
            maxLines && $96a603e4012a3253$var$truncationStyles,
            maxLines === 1 && $96a603e4012a3253$var$wordBreakMap.breakAll,
            align && $96a603e4012a3253$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $f914dcb93d08bd27$export$38845ca010b93505)[weight],
            Component === 'em' && $96a603e4012a3253$var$emStyles,
            Component === 'strong' && $96a603e4012a3253$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $047c63fd47a9d222$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $96a603e4012a3253$export$2e2bcd8739ae039 = $96a603e4012a3253$var$Text;


const $7092fc21e9894387$var$iconStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'none',
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.xs]: {
        display: 'flex'
    },
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.sm]: {
        display: 'none'
    }
});
const $7092fc21e9894387$var$logoStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'none',
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.sm]: {
        display: 'flex'
    }
});
const $7092fc21e9894387$var$headlineStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'none',
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.md]: {
        display: 'flex'
    }
});
const $7092fc21e9894387$var$CustomProductHome = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $067e8036161c713e$export$2e2bcd8739ae039), {
        space: 'space.150',
        alignBlock: 'center',
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d675dd73cffce3dd$export$2e2bcd8739ae039), {
                href: "https://atlassian.com",
                target: "_blank",
                rel: "noreferrer",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $7092fc21e9894387$var$iconStyles,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd94651bfb983298$export$8a485e2e7ed91e8f), {
                            size: "small",
                            appearance: "brand",
                            testId: "product-home-icon"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $7092fc21e9894387$var$logoStyles,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfd88f1eb4dd979f$export$765cacec8b0843f3), {
                            size: "small",
                            appearance: "brand",
                            testId: "product-home-logo"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                xcss: $7092fc21e9894387$var$headlineStyles,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                    size: 'large',
                    testId: 'product-home-title',
                    children: "Email and Privacy Preferences"
                })
            })
        ]
    });
const $7092fc21e9894387$var$Header = ({ headerContent: headerContent })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $436c212ddd6b0459$export$f66ccb39f60980e5), {
        label: "Email and Privacy Preferences",
        primaryItems: [],
        renderProductHome: $7092fc21e9894387$var$CustomProductHome,
        renderProfile: headerContent,
        testId: "preferences-center"
    });
};
var $7092fc21e9894387$export$2e2bcd8739ae039 = $7092fc21e9894387$var$Header;






/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

// dimension vars
var $e1bb1f20ef4efe28$export$cbfb0f5b2869b17b = 'leftPanelWidth';
var $e1bb1f20ef4efe28$export$a30f2e00489a8957 = 'leftSidebarWidth';
var $e1bb1f20ef4efe28$export$c103b605cd368aed = 'rightSidebarWidth';
var $e1bb1f20ef4efe28$export$fa34f417972d6341 = 'rightPanelWidth';
var $e1bb1f20ef4efe28$export$3a6a779d9181047c = 'topNavigationHeight';
var $e1bb1f20ef4efe28$export$bcd94a6a792e7f96 = 'bannerHeight';
var $e1bb1f20ef4efe28$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
var $e1bb1f20ef4efe28$export$344062f7cfc9528e = 'left-panel';
var $e1bb1f20ef4efe28$export$c7139cc2d6110b5f = 'right-panel';
var $e1bb1f20ef4efe28$export$238d30785c4bca84 = 'banner';
var $e1bb1f20ef4efe28$export$bec6dca2e63de4ae = 'top-navigation';
var $e1bb1f20ef4efe28$export$d1213e82613ff4df = 'content';
var $e1bb1f20ef4efe28$export$be83e7118304b28e = 56;
var $e1bb1f20ef4efe28$export$4a98ee0bd1ae362 = 56;
var $e1bb1f20ef4efe28$export$539e68c09584883a = 240;
var $e1bb1f20ef4efe28$export$b92df8810d2fcd01 = 280;
var $e1bb1f20ef4efe28$export$c3e41153b9288bcf = 368;
var $e1bb1f20ef4efe28$export$c4d6152f86ea28f6 = 368;
var $e1bb1f20ef4efe28$export$46acf8758e9e2636 = 20;
var $e1bb1f20ef4efe28$export$70740f5ad8360a78 = 16;
var $e1bb1f20ef4efe28$export$991d5285ad765a3d = 240;
var $e1bb1f20ef4efe28$export$6949d4f32b161684 = 200;
var $e1bb1f20ef4efe28$export$d6e7e8af042815bb = 350;
var $e1bb1f20ef4efe28$export$3749e1104328fde4 = 300;
var $e1bb1f20ef4efe28$export$1074d925b0b82be5 = 200;
var $e1bb1f20ef4efe28$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
var $e1bb1f20ef4efe28$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
var $e1bb1f20ef4efe28$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
var $e1bb1f20ef4efe28$export$70c702a8c5895f03 = 'data-grab-area-line';
var $e1bb1f20ef4efe28$export$48a43f91e4becf4e = 'data-grab-area';
var $e1bb1f20ef4efe28$export$dac2fb31a9f6844d = 'data-resize-button';
var $e1bb1f20ef4efe28$export$9ecd22db14e6c70e = 'data-resize-control';
var $e1bb1f20ef4efe28$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
var $e1bb1f20ef4efe28$export$206a08f7f8beb554 = 'Skip to:';
var $e1bb1f20ef4efe28$export$659ee746b31b360d = 'data-layout-container';
var $e1bb1f20ef4efe28$export$f963aecf2d4465bd = "var(--".concat($e1bb1f20ef4efe28$export$cbfb0f5b2869b17b, ", 0px)");
var $e1bb1f20ef4efe28$export$750459958906793 = "var(--".concat($e1bb1f20ef4efe28$export$fa34f417972d6341, ", 0px)");
var $e1bb1f20ef4efe28$export$f897e1ed9f8ed251 = "var(--".concat($e1bb1f20ef4efe28$export$a30f2e00489a8957, ", 0px)");
var $e1bb1f20ef4efe28$export$b44ab66843c05a69 = "var(--".concat($e1bb1f20ef4efe28$export$c103b605cd368aed, ", 0px)");
var $e1bb1f20ef4efe28$export$aeff86a16f13529 = "var(--".concat($e1bb1f20ef4efe28$export$3a6a779d9181047c, ", 0px)");
var $e1bb1f20ef4efe28$export$ed7cc0d417ee89e = "var(--".concat($e1bb1f20ef4efe28$export$bcd94a6a792e7f96, ", 0px)");
var $e1bb1f20ef4efe28$export$d2fa14f05b61e66 = "var(--".concat($e1bb1f20ef4efe28$export$b6744d31294864fd, ", ").concat($e1bb1f20ef4efe28$export$991d5285ad765a3d, "px)");


var $d3f7915c8afb3490$var$contentStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $e1bb1f20ef4efe28$export$d1213e82613ff4df)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ var $d3f7915c8afb3490$var$Content = function Content(props) {
    var children = props.children, testId = props.testId;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        "data-testid": testId,
        css: $d3f7915c8afb3490$var$contentStyles
    }, children);
};
var $d3f7915c8afb3490$export$2e2bcd8739ae039 = $d3f7915c8afb3490$var$Content;


var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");


var $a94201cbfcfbf04d$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $a94201cbfcfbf04d$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $a94201cbfcfbf04d$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $a94201cbfcfbf04d$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';




var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $c22154329a99fe14$var$getIsDragging = function getIsDragging() {
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $e1bb1f20ef4efe28$export$802bb2c050f3db5c)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
var $c22154329a99fe14$var$useIsSidebarDragging = function useIsSidebarDragging() {
    var _useState = (0, $7fPBF.useState)($c22154329a99fe14$var$getIsDragging), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isDragging = _useState2[0], setIsDragging = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        var observer = new MutationObserver(function() {
            setIsDragging($c22154329a99fe14$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $e1bb1f20ef4efe28$export$802bb2c050f3db5c)
            ]
        });
        return function() {
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $c22154329a99fe14$export$2e2bcd8739ae039 = $c22154329a99fe14$var$useIsSidebarDragging;



var $8MJe2 = parcelRequire("8MJe2");

var $bRUy3 = parcelRequire("bRUy3");

// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
var $54a9774f5a9436a2$var$isLocalStorageSupported = function isLocalStorageSupported() {
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var testKey = "__test_".concat(Date.now(), "__");
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
var $54a9774f5a9436a2$var$safeLocalStorage = function safeLocalStorage() {
    if ($54a9774f5a9436a2$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: function getItem(_key) {
            return null;
        },
        setItem: function setItem(_key, _value) {
            return null;
        },
        removeItem: function removeItem(_key) {
            return null;
        },
        clear: function clear() {
            return null;
        },
        key: function key(_index) {
            return null;
        },
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    var storageAPI = {
        getItem: function getItem(key) {
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: function setItem(key, value) {
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: function removeItem(key) {
            delete window.__localStorageFallback[key];
        },
        clear: function clear() {
            for(var key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $54a9774f5a9436a2$export$2e2bcd8739ae039 = $54a9774f5a9436a2$var$safeLocalStorage;


function $bc7ef42a2451ffb0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bc7ef42a2451ffb0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bc7ef42a2451ffb0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bc7ef42a2451ffb0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bc7ef42a2451ffb0$export$f8355a2df0f4a946 = function mergeGridStateIntoStorage(key, value) {
    var storageValue = JSON.parse((0, $54a9774f5a9436a2$export$2e2bcd8739ae039)().getItem((0, $e1bb1f20ef4efe28$export$451e84a45a9e4a75)) || '{}');
    if (value !== null && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(value) === 'object') storageValue[key] = $bc7ef42a2451ffb0$var$_objectSpread($bc7ef42a2451ffb0$var$_objectSpread({}, storageValue[key]), value);
    else storageValue[key] = value;
    (0, $54a9774f5a9436a2$export$2e2bcd8739ae039)().setItem((0, $e1bb1f20ef4efe28$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
var $bc7ef42a2451ffb0$export$d95e99d8116d17dc = function getGridStateFromStorage(key) {
    var storageValue = JSON.parse((0, $54a9774f5a9436a2$export$2e2bcd8739ae039)().getItem((0, $e1bb1f20ef4efe28$export$451e84a45a9e4a75)) || '{}');
    return storageValue[key];
};
var $bc7ef42a2451ffb0$export$17e3760e0b35f1cd = function removeFromGridStateInStorage(key, secondKey) {
    var storageValue = JSON.parse((0, $54a9774f5a9436a2$export$2e2bcd8739ae039)().getItem((0, $e1bb1f20ef4efe28$export$451e84a45a9e4a75)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $54a9774f5a9436a2$export$2e2bcd8739ae039)().setItem((0, $e1bb1f20ef4efe28$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
var $bc7ef42a2451ffb0$export$74732e47915c7839 = function resolveDimension(key) {
    var dimension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var shouldPersist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (shouldPersist) {
        var cachedGridState = $bc7ef42a2451ffb0$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
var $bc7ef42a2451ffb0$export$b089e01213f07bd = function getLeftPanelWidth() {
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue("--".concat((0, $e1bb1f20ef4efe28$export$f963aecf2d4465bd))), 10) || 0;
};
var $bc7ef42a2451ffb0$export$2bca58b6ee823bf7 = function getLeftSidebarPercentage(currentWidth, maxWidth) {
    var total = (currentWidth - (0, $e1bb1f20ef4efe28$export$539e68c09584883a)) / (maxWidth - (0, $e1bb1f20ef4efe28$export$539e68c09584883a));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
var $bc7ef42a2451ffb0$export$e895e3e8b708ae2a = function getPageLayoutSlotSelector(slotName) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $e1bb1f20ef4efe28$export$5253dd9707b8c3ba), slotName);
};
var $bc7ef42a2451ffb0$export$218ece2c32b7db0e = function getPageLayoutSlotCSSSelector(slotName) {
    return "[".concat((0, $e1bb1f20ef4efe28$export$5253dd9707b8c3ba), "='").concat(slotName, "']");
};



var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $ddf576c977c2e750$var$_excluded = [
    "setLeftSidebarState"
];
function $ddf576c977c2e750$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ddf576c977c2e750$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ddf576c977c2e750$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ddf576c977c2e750$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ddf576c977c2e750$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
var $ddf576c977c2e750$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039),
    collapseLeftSidebar: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039),
    leftSidebarState: $ddf576c977c2e750$var$leftSidebarState,
    setLeftSidebarState: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039),
    toggleLeftSidebar: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039)
});
var $ddf576c977c2e750$export$10c7104037a7af62 = function usePageLayoutResize() {
    var _useContext = (0, $7fPBF.useContext)($ddf576c977c2e750$export$aa5a712eea4c2ae8), setLeftSidebarState = _useContext.setLeftSidebarState, context = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_useContext, $ddf576c977c2e750$var$_excluded);
    return context;
};
var $ddf576c977c2e750$export$94561f6055639ef7 = function useLeftSidebarFlyoutLock() {
    var _useContext2 = (0, $7fPBF.useContext)($ddf576c977c2e750$export$aa5a712eea4c2ae8), setLeftSidebarState = _useContext2.setLeftSidebarState;
    (0, $7fPBF.useEffect)(function() {
        setLeftSidebarState(function(current) {
            return $ddf576c977c2e750$var$_objectSpread($ddf576c977c2e750$var$_objectSpread({}, current), {}, {
                flyoutLockCount: current.flyoutLockCount + 1
            });
        });
        return function() {
            setLeftSidebarState(function(current) {
                return $ddf576c977c2e750$var$_objectSpread($ddf576c977c2e750$var$_objectSpread({}, current), {}, {
                    flyoutLockCount: current.flyoutLockCount - 1
                });
            });
        };
    }, [
        setLeftSidebarState
    ]);
};


var $7fPBF = parcelRequire("7fPBF");

var $1e2b1573caccd841$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $7fPBF.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039),
    unregisterSkipLink: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039)
});
var $1e2b1573caccd841$export$c9d9cb2ee9590f87 = function useSkipLinks() {
    return (0, $7fPBF.useContext)($1e2b1573caccd841$export$4c5cc3b14c7678a);
};
var $1e2b1573caccd841$export$89d9323301efc7d6 = function useSkipLink(id, skipLinkTitle) {
    var _useSkipLinks = $1e2b1573caccd841$export$c9d9cb2ee9590f87(), registerSkipLink = _useSkipLinks.registerSkipLink, unregisterSkipLink = _useSkipLinks.unregisterSkipLink;
    (0, $7fPBF.useEffect)(function() {
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return function() {
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $c3c66c1bd34e39a4$var$focusStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: "0px 0px 0px 2px inset ".concat("var(--ds-border-focused, ".concat((0, $d7df1392c2cb1415$export$ecfc1dff386a3e7a), ")")),
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ var $c3c66c1bd34e39a4$var$sidebarFocusStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: "0px 0px 0px 2px inset ".concat("var(--ds-border-focused, ".concat((0, $d7df1392c2cb1415$export$ecfc1dff386a3e7a), ")")),
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ var $c3c66c1bd34e39a4$var$SlotFocusRing = function SlotFocusRing(_ref) {
    var children = _ref.children, _ref$isSidebar = _ref.isSidebar, isSidebar = _ref$isSidebar === void 0 ? false : _ref$isSidebar;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $3ebaaabf76fb5db5$export$9b9c0f9d9f3552b8), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            className: isSidebar ? css($c3c66c1bd34e39a4$var$sidebarFocusStyles) : css($c3c66c1bd34e39a4$var$focusStyles)
        });
    });
};
var $c3c66c1bd34e39a4$export$2e2bcd8739ae039 = $c3c66c1bd34e39a4$var$SlotFocusRing;


// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $9f06dd5f55f9dca6$var$prefersReducedMotionStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, $34452922263080f6$export$ff7706047246b98b)());
var $9f06dd5f55f9dca6$var$mainStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: "margin-left ".concat((0, $e1bb1f20ef4efe28$export$3749e1104328fde4), "ms ").concat((0, $a94201cbfcfbf04d$export$57636bb43b1ccbb0), " 0s")
});
var $9f06dd5f55f9dca6$var$draggingStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // Make sure drag to resize remains snappy.
    transition: 'none'
});
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ var $9f06dd5f55f9dca6$var$flyoutStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: "calc(-1 * var(--".concat((0, $e1bb1f20ef4efe28$export$b6744d31294864fd), ", ").concat((0, $e1bb1f20ef4efe28$export$991d5285ad765a3d), "px) + ").concat((0, $e1bb1f20ef4efe28$export$46acf8758e9e2636), "px)")
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ var $9f06dd5f55f9dca6$var$Main = function Main(props) {
    var children = props.children, testId = props.testId, id = props.id, skipLinkTitle = props.skipLinkTitle;
    (0, $1e2b1573caccd841$export$89d9323301efc7d6)(id, skipLinkTitle);
    var isDragging = (0, $c22154329a99fe14$export$2e2bcd8739ae039)();
    var _useContext = (0, $7fPBF.useContext)((0, $ddf576c977c2e750$export$aa5a712eea4c2ae8)), _useContext$leftSideb = _useContext.leftSidebarState, isFlyoutOpen = _useContext$leftSideb.isFlyoutOpen, isFixed = _useContext$leftSideb.isFixed;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $c3c66c1bd34e39a4$export$2e2bcd8739ae039), null, function(_ref) {
        var className = _ref.className;
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("main", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
            "data-testid": testId,
            css: [
                $9f06dd5f55f9dca6$var$mainStyles,
                isDragging && $9f06dd5f55f9dca6$var$draggingStyles,
                isFlyoutOpen && !isFixed && $9f06dd5f55f9dca6$var$flyoutStyles,
                $9f06dd5f55f9dca6$var$prefersReducedMotionStyles
            ],
            className: className,
            id: id
        }, (0, $bc7ef42a2451ffb0$export$e895e3e8b708ae2a)('main')), children);
    });
};
var $9f06dd5f55f9dca6$export$2e2bcd8739ae039 = $9f06dd5f55f9dca6$var$Main;


var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $7a3e63dc1837f7f4$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $7a3e63dc1837f7f4$export$c881183ca713c214 = $7a3e63dc1837f7f4$export$987d49ffe1b0900f;




var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $1ba769a1a0dcf52b$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);



var $d4a71a64adad918b$var$_window, $d4a71a64adad918b$var$_window$matchMedia, $d4a71a64adad918b$var$_window2, $d4a71a64adad918b$var$_window2$matchMedia, $d4a71a64adad918b$var$_window3, $d4a71a64adad918b$var$_window3$matchMedia, $d4a71a64adad918b$var$_window4, $d4a71a64adad918b$var$_window4$matchMedia, $d4a71a64adad918b$var$_window5, $d4a71a64adad918b$var$_window5$matchMedia, $d4a71a64adad918b$var$_window6, $d4a71a64adad918b$var$_window6$matchMedia, $d4a71a64adad918b$var$_window7, $d4a71a64adad918b$var$_window7$matchMedia, $d4a71a64adad918b$var$_window8, $d4a71a64adad918b$var$_window8$matchMedia, $d4a71a64adad918b$var$_window9, $d4a71a64adad918b$var$_window9$matchMedia, $d4a71a64adad918b$var$_window10, $d4a71a64adad918b$var$_window10$matchMedia, $d4a71a64adad918b$var$_window11, $d4a71a64adad918b$var$_window11$matchMedia;
var $d4a71a64adad918b$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window = window) === null || $d4a71a64adad918b$var$_window === void 0 || ($d4a71a64adad918b$var$_window$matchMedia = $d4a71a64adad918b$var$_window.matchMedia) === null || $d4a71a64adad918b$var$_window$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window$matchMedia.call($d4a71a64adad918b$var$_window, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window2 = window) === null || $d4a71a64adad918b$var$_window2 === void 0 || ($d4a71a64adad918b$var$_window2$matchMedia = $d4a71a64adad918b$var$_window2.matchMedia) === null || $d4a71a64adad918b$var$_window2$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window2$matchMedia.call($d4a71a64adad918b$var$_window2, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window3 = window) === null || $d4a71a64adad918b$var$_window3 === void 0 || ($d4a71a64adad918b$var$_window3$matchMedia = $d4a71a64adad918b$var$_window3.matchMedia) === null || $d4a71a64adad918b$var$_window3$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window3$matchMedia.call($d4a71a64adad918b$var$_window3, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window4 = window) === null || $d4a71a64adad918b$var$_window4 === void 0 || ($d4a71a64adad918b$var$_window4$matchMedia = $d4a71a64adad918b$var$_window4.matchMedia) === null || $d4a71a64adad918b$var$_window4$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window4$matchMedia.call($d4a71a64adad918b$var$_window4, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window5 = window) === null || $d4a71a64adad918b$var$_window5 === void 0 || ($d4a71a64adad918b$var$_window5$matchMedia = $d4a71a64adad918b$var$_window5.matchMedia) === null || $d4a71a64adad918b$var$_window5$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window5$matchMedia.call($d4a71a64adad918b$var$_window5, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window6 = window) === null || $d4a71a64adad918b$var$_window6 === void 0 || ($d4a71a64adad918b$var$_window6$matchMedia = $d4a71a64adad918b$var$_window6.matchMedia) === null || $d4a71a64adad918b$var$_window6$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window6$matchMedia.call($d4a71a64adad918b$var$_window6, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window7 = window) === null || $d4a71a64adad918b$var$_window7 === void 0 || ($d4a71a64adad918b$var$_window7$matchMedia = $d4a71a64adad918b$var$_window7.matchMedia) === null || $d4a71a64adad918b$var$_window7$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window7$matchMedia.call($d4a71a64adad918b$var$_window7, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window8 = window) === null || $d4a71a64adad918b$var$_window8 === void 0 || ($d4a71a64adad918b$var$_window8$matchMedia = $d4a71a64adad918b$var$_window8.matchMedia) === null || $d4a71a64adad918b$var$_window8$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window8$matchMedia.call($d4a71a64adad918b$var$_window8, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window9 = window) === null || $d4a71a64adad918b$var$_window9 === void 0 || ($d4a71a64adad918b$var$_window9$matchMedia = $d4a71a64adad918b$var$_window9.matchMedia) === null || $d4a71a64adad918b$var$_window9$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window9$matchMedia.call($d4a71a64adad918b$var$_window9, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window10 = window) === null || $d4a71a64adad918b$var$_window10 === void 0 || ($d4a71a64adad918b$var$_window10$matchMedia = $d4a71a64adad918b$var$_window10.matchMedia) === null || $d4a71a64adad918b$var$_window10$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window10$matchMedia.call($d4a71a64adad918b$var$_window10, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window11 = window) === null || $d4a71a64adad918b$var$_window11 === void 0 || ($d4a71a64adad918b$var$_window11$matchMedia = $d4a71a64adad918b$var$_window11.matchMedia) === null || $d4a71a64adad918b$var$_window11$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window11$matchMedia.call($d4a71a64adad918b$var$_window11, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.xl.replace('@media ', '').trim())
};
var $d4a71a64adad918b$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $7fPBF.useRef)(listener);
    (0, $7fPBF.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $d4a71a64adad918b$var$queries[queryString];
    (0, $1ba769a1a0dcf52b$export$e5c5a5f917a5871c)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $a091c25729a976b1$exports.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};





var $c6d9fbc0fb73f1cd$var$handleDataAttributesAndCb = function handleDataAttributesAndCb() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $f48d740006cf3f7d$export$2e2bcd8739ae039);
    var leftSidebarState = arguments.length > 1 ? arguments[1] : undefined;
    document.documentElement.removeAttribute((0, $e1bb1f20ef4efe28$export$5e5e1875c3fd8f4f));
    callback(leftSidebarState);
};
var $c6d9fbc0fb73f1cd$var$leftSidebarSelector = (0, $bc7ef42a2451ffb0$export$218ece2c32b7db0e)('left-sidebar');
var $c6d9fbc0fb73f1cd$export$850bd1bba41f1448 = function SidebarResizeController(_ref) {
    var children = _ref.children, onExpand = _ref.onLeftSidebarExpand, onCollapse = _ref.onLeftSidebarCollapse;
    var _useState = (0, $7fPBF.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), leftSidebarState = _useState2[0], setLeftSidebarState = _useState2[1];
    var leftSidebarWidth = leftSidebarState.leftSidebarWidth, lastLeftSidebarWidth = leftSidebarState.lastLeftSidebarWidth, isResizing = leftSidebarState.isResizing, flyoutLockCount = leftSidebarState.flyoutLockCount, isFixed = leftSidebarState.isFixed, isLeftSidebarCollapsed = leftSidebarState.isLeftSidebarCollapsed, isFlyoutOpen = leftSidebarState.isFlyoutOpen, hasInit = leftSidebarState.hasInit;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    var stableRef = (0, $7fPBF.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $7fPBF.useEffect)(function() {
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    var transition = (0, $7fPBF.useRef)(null);
    var mobileMediaQuery = (0, $d4a71a64adad918b$export$49e55ae2c03d6045)('below.sm');
    var isOpen = mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    var expandLeftSidebar = (0, $7fPBF.useCallback)(function() {
        var _transition$current2, _transition$current3;
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current;
            var flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $e1bb1f20ef4efe28$export$46acf8758e9e2636),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            (_transition$current = transition.current) === null || _transition$current === void 0 || _transition$current.complete();
            $c6d9fbc0fb73f1cd$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        ((_transition$current2 = transition.current) === null || _transition$current2 === void 0 ? void 0 : _transition$current2.action) === 'expand') return;
        // flush existing transition
        (_transition$current3 = transition.current) === null || _transition$current3 === void 0 || _transition$current3.complete();
        var width = Math.max(lastLeftSidebarWidth, (0, $e1bb1f20ef4efe28$export$539e68c09584883a));
        var updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $c6d9fbc0fb73f1cd$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        var sidebar = document.querySelector($c6d9fbc0fb73f1cd$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $34452922263080f6$export$b7baf7667a68d87c)() || !sidebar) {
            finish();
            return;
        }
        var unbindEvent = (0, $a091c25729a976b1$exports.bind)(sidebar, {
            type: 'transitionend',
            listener: function listener(event) {
                if (event.target === sidebar && event.propertyName === 'width') {
                    var _transition$current4;
                    (_transition$current4 = transition.current) === null || _transition$current4 === void 0 || _transition$current4.complete();
                }
            }
        });
        var value = {
            action: 'expand',
            complete: function complete() {
                value.abort();
                finish();
            },
            abort: function abort() {
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    var collapseLeftSidebar = (0, $7fPBF.useCallback)(function(event, collapseWithoutTransition) {
        var _transition$current6, _transition$current7;
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current5;
            var flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $e1bb1f20ef4efe28$export$46acf8758e9e2636),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            (_transition$current5 = transition.current) === null || _transition$current5 === void 0 || _transition$current5.complete();
            $c6d9fbc0fb73f1cd$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        ((_transition$current6 = transition.current) === null || _transition$current6 === void 0 ? void 0 : _transition$current6.action) === 'collapse') return;
        // flush existing transition
        (_transition$current7 = transition.current) === null || _transition$current7 === void 0 || _transition$current7.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $e1bb1f20ef4efe28$export$5e5e1875c3fd8f4f), 'true');
        var updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $e1bb1f20ef4efe28$export$46acf8758e9e2636),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $c6d9fbc0fb73f1cd$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        var sidebar = document.querySelector($c6d9fbc0fb73f1cd$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $34452922263080f6$export$b7baf7667a68d87c)() || !sidebar) {
            finish();
            return;
        }
        var unbindEvent = (0, $a091c25729a976b1$exports.bind)(sidebar, {
            type: 'transitionend',
            listener: function listener(event) {
                if (sidebar === event.target && event.propertyName === 'width') {
                    var _transition$current8;
                    (_transition$current8 = transition.current) === null || _transition$current8 === void 0 || _transition$current8.complete();
                }
            }
        });
        var value = {
            action: 'collapse',
            complete: function complete() {
                value.abort();
                finish();
            },
            abort: function abort() {
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
   * Conditionally toggle the expanding or collapsing the sidebars.
   * This supports our mobile flyout mode as well.
   */ var toggleLeftSidebar = (0, $7fPBF.useCallback)(function(event, collapseWithoutTransition) {
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $7fPBF.useEffect)(function mount() {
        return function unmount() {
            var _transition$current9;
            (_transition$current9 = transition.current) === null || _transition$current9 === void 0 || _transition$current9.abort();
        };
    }, []);
    var context = (0, $7fPBF.useMemo)(function() {
        return {
            isLeftSidebarCollapsed: !isOpen,
            // Technically this isn't quite true, but with mobile it's a bit safer if products are using this to roll their own collapse/expand
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        };
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ddf576c977c2e750$export$aa5a712eea4c2ae8).Provider, {
        value: context
    }, children);
};


var $j9spr = parcelRequire("j9spr");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $962ecee2c8b81f69$var$byDOMOrder = function byDOMOrder(a, b) {
    var _a$listIndex, _b$listIndex;
    var elems = Array.from(document.querySelectorAll("[".concat((0, $e1bb1f20ef4efe28$export$5253dd9707b8c3ba), "]")));
    var elemA = document.getElementById(a.id);
    var elemB = document.getElementById(b.id);
    var indexA = (_a$listIndex = a.listIndex) !== null && _a$listIndex !== void 0 ? _a$listIndex : elems.indexOf(elemA);
    var indexB = (_b$listIndex = b.listIndex) !== null && _b$listIndex !== void 0 ? _b$listIndex : elems.indexOf(elemB);
    /**
   * If they are tied it is because one (or both) is
   * a custom skiplink with a set index.
   *
   * Give the custom skiplink priority.
   */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
var $962ecee2c8b81f69$export$da7be99d6a868f3d = function SkipLinksController(_ref) {
    var children = _ref.children;
    var _useState = (0, $7fPBF.useState)([]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), links = _useState2[0], setLinks = _useState2[1];
    var registerSkipLink = (0, $7fPBF.useRef)(function(skipLinkData) {
        // Don't add duplicate SkipLinks
        setLinks(function(oldLinks) {
            if (oldLinks.some(function(_ref2) {
                var id = _ref2.id;
                return id === skipLinkData.id;
            })) return oldLinks;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(oldLinks), [
                skipLinkData
            ]).sort($962ecee2c8b81f69$var$byDOMOrder);
        });
    });
    var unregisterSkipLink = (0, $7fPBF.useRef)(function(id) {
        setLinks(function(links) {
            return links.filter(function(link) {
                return link.id !== id;
            });
        });
    });
    var context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1e2b1573caccd841$export$4c5cc3b14c7678a).Provider, {
        value: context
    }, children);
};



var $j9spr = parcelRequire("j9spr");

var $8MJe2 = parcelRequire("8MJe2");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $756eaadbe5c8c5b6$var$ATOMIC_GROUP_LENGTH = 5;
function $756eaadbe5c8c5b6$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $756eaadbe5c8c5b6$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("7fPBF");

const $c71aea928b8ce7d8$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $c71aea928b8ce7d8$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};



const $a715c670806f090b$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $756eaadbe5c8c5b6$export$2e2bcd8739ae039)(actualStyles);
};


function $24b71f043aa0935d$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $c71aea928b8ce7d8$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $c71aea928b8ce7d8$export$c4df1cb0c2b4d77c)();
        },
        cx: $a715c670806f090b$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $c71aea928b8ce7d8$export$c4df1cb0c2b4d77c)();
        }
    };
}


var $dd6ab634fa76e8c0$var$_createStrictAPI = (0, $24b71f043aa0935d$export$39716b4af53f4ad)(), $dd6ab634fa76e8c0$var$XCSSProp = $dd6ab634fa76e8c0$var$_createStrictAPI.XCSSProp, $dd6ab634fa76e8c0$export$dbf350e5966cf602 = $dd6ab634fa76e8c0$var$_createStrictAPI.css, $dd6ab634fa76e8c0$export$eb1ecd84a24ee424 = $dd6ab634fa76e8c0$var$_createStrictAPI.cssMap, $dd6ab634fa76e8c0$export$a274e22fb40f762e = $dd6ab634fa76e8c0$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 


var $137Lh = parcelRequire("137Lh");
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $bRUy3 = parcelRequire("bRUy3");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");




var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $eKeTJ = parcelRequire("eKeTJ");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");
function $ef76b23f00bdbc4f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef76b23f00bdbc4f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef76b23f00bdbc4f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef76b23f00bdbc4f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ef76b23f00bdbc4f$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ef76b23f00bdbc4f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $ef76b23f00bdbc4f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $ef76b23f00bdbc4f$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(updater) === 'object') this.payload = $ef76b23f00bdbc4f$var$_objectSpread($ef76b23f00bdbc4f$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $7b477340b8cde09f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $7b477340b8cde09f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $7b477340b8cde09f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7b477340b8cde09f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7b477340b8cde09f$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($eKeTJ)))((0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $7b477340b8cde09f$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $7b477340b8cde09f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $7b477340b8cde09f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, UIAnalyticsEvent);
        _this = $7b477340b8cde09f$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $7b477340b8cde09f$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $ef76b23f00bdbc4f$export$2e2bcd8739ae039));



var $7fPBF = parcelRequire("7fPBF");

var $fada7660f9c0c29a$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $7fPBF.useContext)((0, $e420dde09fb890a4$export$2e2bcd8739ae039));
};


function $235e9ca01f420540$export$5bf35293e545f20c() {
    var analyticsContext = (0, $fada7660f9c0c29a$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6ff1114199100bef$export$33752cf3ee811995)(function(payload) {
        return new (0, $7b477340b8cde09f$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $7fPBF = parcelRequire("7fPBF");
var $ee5d21cffcffc57f$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $7fPBF.useRef)(value);
    ref.current = value;
    return ref;
};


function $c42a1501753ca763$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c42a1501753ca763$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c42a1501753ca763$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c42a1501753ca763$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c42a1501753ca763$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $235e9ca01f420540$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $ee5d21cffcffc57f$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $ee5d21cffcffc57f$export$1d27a74659855e44)(fn);
    var handler = (0, $7fPBF.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c42a1501753ca763$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $278b06282f8962b1$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $7fPBF.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $278b06282f8962b1$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($278b06282f8962b1$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $278b06282f8962b1$export$2e2bcd8739ae039 = $278b06282f8962b1$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $d4047c55a9de058e$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $7fPBF.useContext)((0, $278b06282f8962b1$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $d4047c55a9de058e$export$2e2bcd8739ae039 = $d4047c55a9de058e$var$useRouterLink;






/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $465e3a2f746c4dff$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}


var $170003928167b932$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $170003928167b932$var$_excluded2 = [
    "className"
];
function $170003928167b932$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $170003928167b932$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $170003928167b932$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $170003928167b932$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $170003928167b932$var$focusRingStyles = null;
var $170003928167b932$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $170003928167b932$var$Focusable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $170003928167b932$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $170003928167b932$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $756eaadbe5c8c5b6$export$2e2bcd8739ae039)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $170003928167b932$var$_objectSpread($170003928167b932$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $465e3a2f746c4dff$export$2e2bcd8739ae039)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $170003928167b932$export$2e2bcd8739ae039 = $170003928167b932$var$Focusable;


var $2ef640405325383a$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $2ef640405325383a$var$_excluded2 = [
    "className"
];
var $2ef640405325383a$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi"
};
var $2ef640405325383a$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $2ef640405325383a$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $2ef640405325383a$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $2ef640405325383a$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $d4d502868e612e1e$export$f680877a34711e37)();
    var onClick = (0, $c42a1501753ca763$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.0",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $2ef640405325383a$var$_excluded2);
    var RouterLink = (0, $d4047c55a9de058e$export$2e2bcd8739ae039)();
    var isExternal = typeof href === 'string' && $2ef640405325383a$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $2ef640405325383a$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(href) === 'object';
    (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $7fPBF.createElement((0, $170003928167b932$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $a715c670806f090b$export$a274e22fb40f762e)($2ef640405325383a$var$styles.root, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $7fPBF.createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $2ef640405325383a$var$Anchor = /*#__PURE__*/ (0, $7fPBF.forwardRef)($2ef640405325383a$var$AnchorNoRef);
var $2ef640405325383a$export$2e2bcd8739ae039 = $2ef640405325383a$var$Anchor;

/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $1a1e19d151d51d68$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $1a1e19d151d51d68$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($1a1e19d151d51d68$export$1ca2a26fecb070ae);
};
$1a1e19d151d51d68$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $4df8c425f26ffe90$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $4df8c425f26ffe90$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $4df8c425f26ffe90$var$baseStyles = null;
var $4df8c425f26ffe90$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $4df8c425f26ffe90$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $4df8c425f26ffe90$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
var $4df8c425f26ffe90$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $4df8c425f26ffe90$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $4df8c425f26ffe90$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $4df8c425f26ffe90$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $4df8c425f26ffe90$var$Box = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $4df8c425f26ffe90$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $4df8c425f26ffe90$var$_excluded2);
    var node = /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        style: style,
        ref: ref,
        className: (0, $756eaadbe5c8c5b6$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $4df8c425f26ffe90$var$backgroundColorMap[backgroundColor],
            backgroundColor && $4df8c425f26ffe90$var$isSurfaceToken(backgroundColor) && $4df8c425f26ffe90$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $4df8c425f26ffe90$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $4df8c425f26ffe90$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $4df8c425f26ffe90$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $4df8c425f26ffe90$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $7fPBF.createElement((0, $1a1e19d151d51d68$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $4df8c425f26ffe90$export$2e2bcd8739ae039 = $4df8c425f26ffe90$var$Box;
function $4df8c425f26ffe90$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $4df8c425f26ffe90$var$setSurfaceTokenMap;
}


var $705b4fb71b2918ff$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $705b4fb71b2918ff$var$styles = {
    visitedLink: "_ect41gqc _1053w7te _1ienw7te _n0fxw7te _1vhvg3x0",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz14q2 _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj14q2 _9oik1r31 _1bnxglyw _jf4cnqa1 _30l314q2 _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h16c2",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syaz1gjq _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1gjq _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31gjq _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h1fxt",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n4jp4b _kqswh2mm _152ttb3r"
};
var $705b4fb71b2918ff$var$iconStyles = null;
var $705b4fb71b2918ff$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, preventedClassName = _ref.className, preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $705b4fb71b2918ff$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement((0, $2ef640405325383a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $dd6ab634fa76e8c0$export$a274e22fb40f762e)(appearance === 'default' && $705b4fb71b2918ff$var$styles.defaultAppearance, appearance === 'subtle' && $705b4fb71b2918ff$var$styles.subtleAppearance, appearance === 'inverse' && $705b4fb71b2918ff$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $705b4fb71b2918ff$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $7fPBF.createElement((0, $4df8c425f26ffe90$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $705b4fb71b2918ff$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", (0, $137Lh.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ $7fPBF.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $756eaadbe5c8c5b6$export$2e2bcd8739ae039)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    })) : /*#__PURE__*/ $7fPBF.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        className: (0, $756eaadbe5c8c5b6$export$2e2bcd8739ae039)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
    }), /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $705b4fb71b2918ff$var$Link = /*#__PURE__*/ (0, $7fPBF.forwardRef)($705b4fb71b2918ff$var$LinkWithoutRef);
var $705b4fb71b2918ff$export$2e2bcd8739ae039 = $705b4fb71b2918ff$var$Link;






function $a447a92c953a262c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a447a92c953a262c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a447a92c953a262c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a447a92c953a262c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a447a92c953a262c$var$prefersReducedMotionStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, $34452922263080f6$export$ff7706047246b98b)());
var $a447a92c953a262c$var$skipLinkStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $d7df1392c2cb1415$export$920c0d5c49070351), ", 0 2px 10px ").concat((0, $d7df1392c2cb1415$export$920c0d5c49070351), ", 0 0 20px -4px ").concat((0, $d7df1392c2cb1415$export$d2d3bedfb276cac0)), ")"),
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: "transform 0.3s ".concat((0, $a94201cbfcfbf04d$export$57636bb43b1ccbb0)),
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
var $a447a92c953a262c$var$skipLinkHeadingStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
var $a447a92c953a262c$var$skipLinkListStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    listStylePosition: 'outside',
    listStyleType: 'none',
    marginBlockStart: "var(--ds-space-050, 4px)",
    paddingInlineStart: 0
});
var $a447a92c953a262c$var$skipLinkListItemStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    marginBlockStart: 0
});
var $a447a92c953a262c$var$_assignIndex = function assignIndex(num, arr) {
    if (!arr.includes(num)) return num;
    return $a447a92c953a262c$var$_assignIndex(num + 1, arr);
};
var $a447a92c953a262c$export$4241a460557ba901 = function SkipLinkWrapper(_ref) {
    var skipLinksLabel = _ref.skipLinksLabel;
    var _useSkipLinks = (0, $1e2b1573caccd841$export$c9d9cb2ee9590f87)(), skipLinksData = _useSkipLinks.skipLinksData;
    if (skipLinksData.length === 0) return null;
    var sortSkipLinks = function sortSkipLinks(arr) {
        var customLinks = arr.filter(function(link) {
            return Number.isInteger(link.listIndex);
        });
        if (customLinks.length === 0) return arr;
        var usedIndexes = customLinks.map(function(a) {
            return a.listIndex;
        });
        var regularLinksWithIdx = arr.filter(function(link) {
            return link.listIndex === undefined;
        }).map(function(link, idx, currArr) {
            var listIndex = $a447a92c953a262c$var$_assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return $a447a92c953a262c$var$_objectSpread($a447a92c953a262c$var$_objectSpread({}, link), {}, {
                listIndex: listIndex
            });
        });
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(customLinks), (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(regularLinksWithIdx)).sort(function(a, b) {
            return a.listIndex - b.listIndex;
        });
    };
    var escapeHandler = function escapeHandler(event) {
        if (event.keyCode === 27) {
            var container = document.querySelector("[".concat((0, $e1bb1f20ef4efe28$export$659ee746b31b360d), "=\"true\"]"));
            if (container !== null) container.focus();
        }
    };
    var attachEscHandler = function attachEscHandler() {
        return window.addEventListener('keydown', escapeHandler, false);
    };
    var removeEscHandler = function removeEscHandler() {
        return window.removeEventListener('keydown', escapeHandler, false);
    };
    var emptyLabelOverride = !!(skipLinksLabel !== null && skipLinksLabel !== void 0 && skipLinksLabel.match(/^\s+$/));
    var label = skipLinksLabel || (0, $e1bb1f20ef4efe28$export$206a08f7f8beb554);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $a447a92c953a262c$var$skipLinkStyles,
            $a447a92c953a262c$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("p", {
        css: $a447a92c953a262c$var$skipLinkHeadingStyles
    }, label), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("ol", {
        css: $a447a92c953a262c$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(function(_ref2) {
        var id = _ref2.id, skipLinkTitle = _ref2.skipLinkTitle;
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)($a447a92c953a262c$export$ef95c37428582a65, {
            key: id,
            href: "#".concat(id),
            isFocusable: true
        }, skipLinkTitle);
    }))));
};
var $a447a92c953a262c$var$_handleBlur = function handleBlur(event) {
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $a447a92c953a262c$var$_handleBlur);
};
var $a447a92c953a262c$var$focusTargetRef = function focusTargetRef(href) {
    return function(event) {
        event.preventDefault();
        var targetRef = document.querySelector(href);
        // @ts-ignore
        var key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $a447a92c953a262c$var$_handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
};
var $a447a92c953a262c$export$ef95c37428582a65 = function SkipLink(_ref3) {
    var href = _ref3.href, children = _ref3.children, isFocusable = _ref3.isFocusable;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("li", {
        css: $a447a92c953a262c$var$skipLinkListItemStyles
    }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $705b4fb71b2918ff$export$2e2bcd8739ae039), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $a447a92c953a262c$var$focusTargetRef(href)
    }, children));
};


var $d0a14d7762364fd2$var$pageLayoutSelector = (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $e1bb1f20ef4efe28$export$659ee746b31b360d), true);
var $d0a14d7762364fd2$var$gridTemplateAreasMobile = "\n".concat("\n  \"", (0, $e1bb1f20ef4efe28$export$344062f7cfc9528e), " ").concat((0, $e1bb1f20ef4efe28$export$238d30785c4bca84), "\"\n  ", "\n  \"").concat((0, $e1bb1f20ef4efe28$export$344062f7cfc9528e), " ").concat((0, $e1bb1f20ef4efe28$export$bec6dca2e63de4ae), "\"\n  ", "\n  \"").concat((0, $e1bb1f20ef4efe28$export$344062f7cfc9528e), " ").concat((0, $e1bb1f20ef4efe28$export$d1213e82613ff4df), "\"\n ");
var $d0a14d7762364fd2$var$gridTemplateAreas = "\n".concat("\n  \"", (0, $e1bb1f20ef4efe28$export$344062f7cfc9528e), " ").concat((0, $e1bb1f20ef4efe28$export$238d30785c4bca84), " ").concat((0, $e1bb1f20ef4efe28$export$c7139cc2d6110b5f), "\"\n  ", "\n  \"").concat((0, $e1bb1f20ef4efe28$export$344062f7cfc9528e), " ").concat((0, $e1bb1f20ef4efe28$export$bec6dca2e63de4ae), " ").concat((0, $e1bb1f20ef4efe28$export$c7139cc2d6110b5f), "\"\n", "\n  \"").concat((0, $e1bb1f20ef4efe28$export$344062f7cfc9528e), " ").concat((0, $e1bb1f20ef4efe28$export$d1213e82613ff4df), " ").concat((0, $e1bb1f20ef4efe28$export$c7139cc2d6110b5f), "\"\n ");
var $d0a14d7762364fd2$var$gridStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $d0a14d7762364fd2$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: "".concat((0, $e1bb1f20ef4efe28$export$f963aecf2d4465bd), " minmax(0, 1fr) ").concat((0, $e1bb1f20ef4efe28$export$750459958906793)),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: "".concat((0, $e1bb1f20ef4efe28$export$ed7cc0d417ee89e), " ").concat((0, $e1bb1f20ef4efe28$export$aeff86a16f13529), " auto"),
    outline: 'none'
});
var $d0a14d7762364fd2$var$gridStylesMobileStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.sm, {
    gridTemplateAreas: $d0a14d7762364fd2$var$gridTemplateAreasMobile,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: "".concat((0, $e1bb1f20ef4efe28$export$f963aecf2d4465bd), " minmax(0, 1fr)")
}));
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ var $d0a14d7762364fd2$var$PageLayout = function PageLayout(_ref) {
    var _ref$skipLinksLabel = _ref.skipLinksLabel, skipLinksLabel = _ref$skipLinksLabel === void 0 ? (0, $e1bb1f20ef4efe28$export$206a08f7f8beb554) : _ref$skipLinksLabel, children = _ref.children, testId = _ref.testId, onLeftSidebarExpand = _ref.onLeftSidebarExpand, onLeftSidebarCollapse = _ref.onLeftSidebarCollapse;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $7fPBF.Fragment), null, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $962ecee2c8b81f69$export$da7be99d6a868f3d), null, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $a447a92c953a262c$export$4241a460557ba901), {
        skipLinksLabel: skipLinksLabel
    }), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, $d0a14d7762364fd2$var$pageLayoutSelector, {
        "data-testid": testId,
        css: [
            $d0a14d7762364fd2$var$gridStyles,
            $d0a14d7762364fd2$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $c6d9fbc0fb73f1cd$export$850bd1bba41f1448), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $d0a14d7762364fd2$export$2e2bcd8739ae039 = $d0a14d7762364fd2$var$PageLayout;


var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");




var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $cafe70309e49c2e7$var$publishGridState = function publishGridState(gridState) {
    Object.entries(gridState).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), slotName = _ref2[0], value = _ref2[1];
        if (!value) {
            document.documentElement.style.removeProperty("--".concat(slotName));
            (0, $bc7ef42a2451ffb0$export$17e3760e0b35f1cd)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty("--".concat(slotName), "".concat(value, "px"));
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $bc7ef42a2451ffb0$export$f8355a2df0f4a946)('gridState', (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, slotName, value));
    });
};
var $cafe70309e49c2e7$export$2e2bcd8739ae039 = $cafe70309e49c2e7$var$publishGridState;




var $7fPBF = parcelRequire("7fPBF");

/**
 * Hoists slot dimension styles to the root element.
 */ var $cfe85745364713cd$var$SlotDimensions = function SlotDimensions(_ref) {
    var variableName = _ref.variableName, value = _ref.value, mobileValue = _ref.mobileValue;
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ var style = ":root{--".concat(variableName, ":").concat(value, "px;}");
    if (mobileValue) style += " ".concat((0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.sm, " { :root{--").concat(variableName, ":").concat(mobileValue, "px;} }");
    return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("style", null, style));
};
var $cfe85745364713cd$export$2e2bcd8739ae039 = $cfe85745364713cd$var$SlotDimensions;


var $558934874537b23b$var$topNavigationStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $e1bb1f20ef4efe28$export$aeff86a16f13529),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $e1bb1f20ef4efe28$export$bec6dca2e63de4ae)
});
var $558934874537b23b$var$fixedStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $e1bb1f20ef4efe28$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $e1bb1f20ef4efe28$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $e1bb1f20ef4efe28$export$f963aecf2d4465bd)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ var $558934874537b23b$var$TopNavigation = function TopNavigation(props) {
    var children = props.children, _props$height = props.height, height = _props$height === void 0 ? (0, $e1bb1f20ef4efe28$export$4a98ee0bd1ae362) : _props$height, _props$isFixed = props.isFixed, isFixed = _props$isFixed === void 0 ? true : _props$isFixed, shouldPersistHeight = props.shouldPersistHeight, testId = props.testId, id = props.id, skipLinkTitle = props.skipLinkTitle;
    var topNavigationHeight = (0, $bc7ef42a2451ffb0$export$74732e47915c7839)((0, $e1bb1f20ef4efe28$export$3a6a779d9181047c), height, shouldPersistHeight);
    (0, $7fPBF.useEffect)(function() {
        (0, $cafe70309e49c2e7$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $e1bb1f20ef4efe28$export$3a6a779d9181047c), topNavigationHeight));
        return function() {
            (0, $cafe70309e49c2e7$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $e1bb1f20ef4efe28$export$3a6a779d9181047c), 0));
        };
    }, [
        topNavigationHeight
    ]);
    (0, $1e2b1573caccd841$export$89d9323301efc7d6)(id, skipLinkTitle);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $c3c66c1bd34e39a4$export$2e2bcd8739ae039), null, function(_ref) {
        var className = _ref.className;
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
            css: [
                $558934874537b23b$var$topNavigationStyles,
                isFixed && $558934874537b23b$var$fixedStyles
            ],
            className: className,
            "data-testid": testId,
            id: id
        }, (0, $bc7ef42a2451ffb0$export$e895e3e8b708ae2a)('top-navigation')), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $cfe85745364713cd$export$2e2bcd8739ae039), {
            variableName: (0, $e1bb1f20ef4efe28$export$3a6a779d9181047c),
            value: topNavigationHeight
        }), children);
    });
};
var $558934874537b23b$export$2e2bcd8739ae039 = $558934874537b23b$var$TopNavigation;


/* LanguageBar.tsx generated by @compiled/babel-plugin v0.38.1 */ 


var $7fPBF = parcelRequire("7fPBF");

var $cvBp9 = parcelRequire("cvBp9");

var $iKdEz = parcelRequire("iKdEz");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * An empty function which does nothing.
 */ function $ad2b03d971966243$export$2e2bcd8739ae039() {}



var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
var $d9d3aa9f0354c727$var$_excluded = [
    "children"
];
function $d9d3aa9f0354c727$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $7fPBF.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $7fPBF.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $d9d3aa9f0354c727$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $7fPBF.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $7fPBF.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
var $8e3d3e3ac4379509$var$_createTheme = (0, $d9d3aa9f0354c727$export$25d302a5b900a763)(function() {
    return {
        mode: 'light'
    };
}), $8e3d3e3ac4379509$var$Provider = $8e3d3e3ac4379509$var$_createTheme.Provider, $8e3d3e3ac4379509$var$Consumer = $8e3d3e3ac4379509$var$_createTheme.Consumer, $8e3d3e3ac4379509$export$7692396083754928 = $8e3d3e3ac4379509$var$_createTheme.useTheme;
var $8e3d3e3ac4379509$var$Theme = {
    Provider: $8e3d3e3ac4379509$var$Provider,
    Consumer: $8e3d3e3ac4379509$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8e3d3e3ac4379509$export$2e2bcd8739ae039 = $8e3d3e3ac4379509$var$Theme;



var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");
function $7295fdb42024c8a7$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}




// Reds
var $a60667c3f4f94146$export$4b84fd0e2c617bd = '#FFEBE6';
var $a60667c3f4f94146$export$b34b069eff244586 = '#FFBDAD';
var $a60667c3f4f94146$export$be802dd0d8b57f35 = '#FF8F73';
var $a60667c3f4f94146$export$60847d42f9da92a6 = '#FF7452';
var $a60667c3f4f94146$export$4a7404f376229999 = '#FF5630';
var $a60667c3f4f94146$export$2010d0fb4295b346 = '#DE350B';
var $a60667c3f4f94146$export$2837b5a1a71d5c02 = '#BF2600';
var $a60667c3f4f94146$export$8d9596b529bbb9cf = '#FFFAE6';
var $a60667c3f4f94146$export$41060a744ab0b7ae = '#FFF0B3';
var $a60667c3f4f94146$export$1cc05bbbf340e559 = '#FFE380';
var $a60667c3f4f94146$export$5aae31392d72caaa = '#FFC400';
var $a60667c3f4f94146$export$c6930421db9fa514 = '#FFAB00';
var $a60667c3f4f94146$export$59619663aa6500fb = '#FF991F';
var $a60667c3f4f94146$export$874739ea9e379ab6 = '#FF8B00';
var $a60667c3f4f94146$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $a60667c3f4f94146$export$69a3bf21b9686c2b = '#ABF5D1';
var $a60667c3f4f94146$export$afbce1382ec95f73 = '#79F2C0';
var $a60667c3f4f94146$export$747d86715d4175de = '#57D9A3';
var $a60667c3f4f94146$export$940e1f69e873f202 = '#36B37E';
var $a60667c3f4f94146$export$a49394138f7b8e85 = '#00875A';
var $a60667c3f4f94146$export$6fa04827ac68a4fb = '#006644';
var $a60667c3f4f94146$export$226de0355ed012f8 = '#DEEBFF';
var $a60667c3f4f94146$export$8c13c2ee36917869 = '#B3D4FF';
var $a60667c3f4f94146$export$ecfc1dff386a3e7a = '#4C9AFF';
var $a60667c3f4f94146$export$215b7063051591f1 = '#2684FF';
var $a60667c3f4f94146$export$e62e8919cca44969 = '#0065FF';
var $a60667c3f4f94146$export$b3de0ae08da2ce64 = '#0052CC';
var $a60667c3f4f94146$export$a6ee3d71bc067634 = '#0747A6';
var $a60667c3f4f94146$export$67f15409e87642a1 = '#669DF1';
var $a60667c3f4f94146$export$f0539dbc42dbb067 = '#8FB8F6';
var $a60667c3f4f94146$export$363e4475840015bb = '#EAE6FF';
var $a60667c3f4f94146$export$4b0a4417ed59760f = '#C0B6F2';
var $a60667c3f4f94146$export$6011520a64d9a187 = '#998DD9';
var $a60667c3f4f94146$export$a7175d4e9206bc80 = '#8777D9';
var $a60667c3f4f94146$export$b48405b95304b5a1 = '#6554C0';
var $a60667c3f4f94146$export$c71e4279dd54a18d = '#5243AA';
var $a60667c3f4f94146$export$147899de772240ec = '#403294';
var $a60667c3f4f94146$export$2cf711fe14c66f06 = '#E6FCFF';
var $a60667c3f4f94146$export$7a8f4d33f6f9772c = '#B3F5FF';
var $a60667c3f4f94146$export$776c9c497ef08533 = '#79E2F2';
var $a60667c3f4f94146$export$69cb3ca10c1e330e = '#00C7E6';
var $a60667c3f4f94146$export$9dc1ef0f3f48059b = '#00B8D9';
var $a60667c3f4f94146$export$7c835c78b6fcdef8 = '#00A3BF';
var $a60667c3f4f94146$export$6036577f95c3877e = '#008DA6';
var $a60667c3f4f94146$export$29a4f05edc054374 = '#FFFFFF';
var $a60667c3f4f94146$export$e655ef011c4aa1a2 = '#FAFBFC';
var $a60667c3f4f94146$export$9fdfb749e33cdf97 = '#F4F5F7';
var $a60667c3f4f94146$export$3e51e8f1440314ba = '#EBECF0';
var $a60667c3f4f94146$export$1ce2d1575d444ceb = '#DFE1E6';
var $a60667c3f4f94146$export$8754fc7e6d8b3000 = '#C1C7D0';
var $a60667c3f4f94146$export$c2e91cbeada39b8b = '#B3BAC5';
var $a60667c3f4f94146$export$5f71e19f3a7ad9de = '#A5ADBA';
var $a60667c3f4f94146$export$eaa8c8a70ac22806 = '#97A0AF';
var $a60667c3f4f94146$export$7c87d337fb91a97d = '#8993A4';
var $a60667c3f4f94146$export$d6447c357493214f = '#7A869A';
var $a60667c3f4f94146$export$f563ee71e9ee74cd = '#6B778C';
var $a60667c3f4f94146$export$e2ef2124cf4024b1 = '#5E6C84';
var $a60667c3f4f94146$export$eece5f492e429f08 = '#505F79';
var $a60667c3f4f94146$export$c39c0fe0f26207ae = '#42526E';
var $a60667c3f4f94146$export$7090862dc3038a9f = '#344563';
var $a60667c3f4f94146$export$ad0bacf983b7ddaa = '#253858';
var $a60667c3f4f94146$export$7d61b15e0da132af = '#172B4D';
var $a60667c3f4f94146$export$fbda843f0a27fe96 = '#091E42';
var $a60667c3f4f94146$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $a60667c3f4f94146$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $a60667c3f4f94146$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $a60667c3f4f94146$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $a60667c3f4f94146$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $a60667c3f4f94146$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $a60667c3f4f94146$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $a60667c3f4f94146$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $a60667c3f4f94146$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $a60667c3f4f94146$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $a60667c3f4f94146$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $a60667c3f4f94146$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $a60667c3f4f94146$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $a60667c3f4f94146$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $a60667c3f4f94146$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $a60667c3f4f94146$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $a60667c3f4f94146$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $a60667c3f4f94146$export$2f6319cf7d736c2a = '#E6EDFA';
var $a60667c3f4f94146$export$95126bc8884d6634 = '#DCE5F5';
var $a60667c3f4f94146$export$8338d8c35d44ff1 = '#CED9EB';
var $a60667c3f4f94146$export$5368d76ae4fbbda7 = '#B8C7E0';
var $a60667c3f4f94146$export$9f0a771d16ec8d36 = '#ABBBD6';
var $a60667c3f4f94146$export$abcf8c38338b4aa5 = '#9FB0CC';
var $a60667c3f4f94146$export$97e81faa16a182c7 = '#8C9CB8';
var $a60667c3f4f94146$export$bfe21c59123ecf33 = '#7988A3';
var $a60667c3f4f94146$export$ee82aa2ea6a1558 = '#67758F';
var $a60667c3f4f94146$export$682927c6ed76be02 = '#56637A';
var $a60667c3f4f94146$export$91fd9994c5be9757 = '#455166';
var $a60667c3f4f94146$export$d281fbfe3cff2df6 = '#3B475C';
var $a60667c3f4f94146$export$3902c91d8b98a753 = '#313D52';
var $a60667c3f4f94146$export$8e8133c1ba5845b5 = '#283447';
var $a60667c3f4f94146$export$33ff357f6620b39 = '#202B3D';
var $a60667c3f4f94146$export$633847cf062b69e0 = '#1B2638';
var $a60667c3f4f94146$export$9776a6e503bdbf76 = '#121A29';
var $a60667c3f4f94146$export$6c813d5160dff5db = '#0E1624';
var $a60667c3f4f94146$export$3d4f271a500072a = '#0D1424';
var $a60667c3f4f94146$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $a60667c3f4f94146$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $a60667c3f4f94146$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $a60667c3f4f94146$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $a60667c3f4f94146$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $a60667c3f4f94146$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $a60667c3f4f94146$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $a60667c3f4f94146$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $a60667c3f4f94146$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $a60667c3f4f94146$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $a60667c3f4f94146$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $a60667c3f4f94146$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $a60667c3f4f94146$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $a60667c3f4f94146$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $a60667c3f4f94146$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $a60667c3f4f94146$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $a60667c3f4f94146$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $a60667c3f4f94146$export$d2adc5dedf09fced = '#292A2E';
var $a60667c3f4f94146$export$f51762073d2bb381 = '#94C748';
var $a60667c3f4f94146$export$95e26d54def96891 = '#B3DF72';


function $7760ac857756d3d4$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $7760ac857756d3d4$var$tabKeyCode = 9;
function $7760ac857756d3d4$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $7760ac857756d3d4$var$tabKeyCode) return;
    $7760ac857756d3d4$var$abort(event);
}
var $7760ac857756d3d4$var$block = {
    onMouseDownCapture: $7760ac857756d3d4$var$abort,
    onMouseUpCapture: $7760ac857756d3d4$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $7760ac857756d3d4$var$onKey,
    onKeyUpCapture: $7760ac857756d3d4$var$onKey,
    onTouchStartCapture: $7760ac857756d3d4$var$abort,
    onTouchEndCapture: $7760ac857756d3d4$var$abort,
    onPointerDownCapture: $7760ac857756d3d4$var$abort,
    onPointerUpCapture: $7760ac857756d3d4$var$abort,
    onClickCapture: $7760ac857756d3d4$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $7760ac857756d3d4$var$abort
};
var $7760ac857756d3d4$var$doNotBlock = {};
function $7760ac857756d3d4$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $7760ac857756d3d4$var$doNotBlock : $7760ac857756d3d4$var$block;
}



var $8MJe2 = parcelRequire("8MJe2");


var $137Lh = parcelRequire("137Lh");
/* eslint-disable no-console */ var $5dea89930d476668$var$printed = {};
function $5dea89930d476668$export$2e2bcd8739ae039(message) {
    if ($5dea89930d476668$var$printed[message]) return;
    $5dea89930d476668$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $40b15c4bb074de2e$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $5dea89930d476668$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $40b15c4bb074de2e$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {}



var $630bd4b1970e9fd0$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $630bd4b1970e9fd0$export$c93026a968943f95 = 'light';
var $630bd4b1970e9fd0$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $630bd4b1970e9fd0$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $630bd4b1970e9fd0$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $630bd4b1970e9fd0$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $a60667c3f4f94146$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $630bd4b1970e9fd0$export$6d8204c2cb2e06b8() / 4;
    (0, $40b15c4bb074de2e$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $630bd4b1970e9fd0$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $630bd4b1970e9fd0$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $630bd4b1970e9fd0$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $40b15c4bb074de2e$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $630bd4b1970e9fd0$export$ba1d834b86d72a09 = $630bd4b1970e9fd0$export$a1b3edb637fb4f35;
var $630bd4b1970e9fd0$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $a60667c3f4f94146$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $a60667c3f4f94146$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $a60667c3f4f94146$export$920c0d5c49070351), ")")
            }
        }
    };
};



// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $36fb7abe9023a5cf$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
var $36fb7abe9023a5cf$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($a60667c3f4f94146$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-neutral, ".concat($a60667c3f4f94146$export$d281fbfe3cff2df6, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($a60667c3f4f94146$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($a60667c3f4f94146$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($36fb7abe9023a5cf$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($a60667c3f4f94146$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($a60667c3f4f94146$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($a60667c3f4f94146$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$3d4f271a500072a, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($a60667c3f4f94146$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($a60667c3f4f94146$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($a60667c3f4f94146$export$e62e8919cca44969, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($a60667c3f4f94146$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($a60667c3f4f94146$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($a60667c3f4f94146$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($a60667c3f4f94146$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($a60667c3f4f94146$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$3d4f271a500072a, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($a60667c3f4f94146$export$c6930421db9fa514, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($a60667c3f4f94146$export$c6930421db9fa514, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($a60667c3f4f94146$export$5aae31392d72caaa, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($a60667c3f4f94146$export$5aae31392d72caaa, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($a60667c3f4f94146$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($a60667c3f4f94146$export$59619663aa6500fb, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($a60667c3f4f94146$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($a60667c3f4f94146$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$59619663aa6500fb, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$59619663aa6500fb, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($a60667c3f4f94146$export$2010d0fb4295b346, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($a60667c3f4f94146$export$2010d0fb4295b346, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($a60667c3f4f94146$export$4a7404f376229999, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($a60667c3f4f94146$export$4a7404f376229999, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($a60667c3f4f94146$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($a60667c3f4f94146$export$2837b5a1a71d5c02, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($a60667c3f4f94146$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($a60667c3f4f94146$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$2837b5a1a71d5c02, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$2837b5a1a71d5c02, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($a60667c3f4f94146$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($a60667c3f4f94146$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($36fb7abe9023a5cf$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($a60667c3f4f94146$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$3d4f271a500072a, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($a60667c3f4f94146$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($a60667c3f4f94146$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($a60667c3f4f94146$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($a60667c3f4f94146$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$abcf8c38338b4aa5, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($a60667c3f4f94146$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($a60667c3f4f94146$export$633847cf062b69e0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$abcf8c38338b4aa5, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($a60667c3f4f94146$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($a60667c3f4f94146$export$7d61b15e0da132af, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$7d61b15e0da132af, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$7d61b15e0da132af, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($a60667c3f4f94146$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($a60667c3f4f94146$export$29a4f05edc054374, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$29a4f05edc054374, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$29a4f05edc054374, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($a60667c3f4f94146$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-link, ".concat($a60667c3f4f94146$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($a60667c3f4f94146$export$e62e8919cca44969, ")"),
                dark: "var(--ds-link, ".concat($a60667c3f4f94146$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($a60667c3f4f94146$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-link-pressed, ".concat($a60667c3f4f94146$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$ad0bacf983b7ddaa, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$ad0bacf983b7ddaa, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($a60667c3f4f94146$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($a60667c3f4f94146$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($a60667c3f4f94146$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($a60667c3f4f94146$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$abcf8c38338b4aa5, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-text-subtle, ".concat($a60667c3f4f94146$export$f563ee71e9ee74cd, ")"),
                dark: "var(--ds-text-subtle, ".concat($a60667c3f4f94146$export$abcf8c38338b4aa5, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($a60667c3f4f94146$export$7c87d337fb91a97d, ")"),
                dark: "var(--ds-text-subtle, ".concat($a60667c3f4f94146$export$226de0355ed012f8, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($a60667c3f4f94146$export$eece5f492e429f08, ")"),
                dark: "var(--ds-text, ".concat($a60667c3f4f94146$export$97e81faa16a182c7, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($a60667c3f4f94146$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($a60667c3f4f94146$export$abcf8c38338b4aa5, ")")
            }
        }
    }
};
var $36fb7abe9023a5cf$export$2e2bcd8739ae039 = $36fb7abe9023a5cf$var$values;


function $105297376983f077$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $105297376983f077$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $105297376983f077$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $105297376983f077$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $105297376983f077$var$gridSize = (0, $630bd4b1970e9fd0$export$6d8204c2cb2e06b8)();
var $105297376983f077$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $105297376983f077$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $105297376983f077$var$lineHeights = {
    default: $105297376983f077$var$heights.default,
    compact: $105297376983f077$var$heights.compact,
    none: 'inherit'
};
var $105297376983f077$var$padding = {
    // 10px gutter
    default: "0 ".concat($105297376983f077$var$gridSize + $105297376983f077$var$gridSize / 4, "px"),
    compact: "0 ".concat($105297376983f077$var$gridSize + $105297376983f077$var$gridSize / 4, "px"),
    none: '0'
};
var $105297376983f077$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($105297376983f077$var$gridSize / 4, "px"),
    default: "0 ".concat($105297376983f077$var$gridSize / 4, "px"),
    none: '0'
};
var $105297376983f077$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $105297376983f077$var$innerMargin = {
    content: "0 ".concat($105297376983f077$var$gridSize / 4, "px"),
    icon: "0 ".concat($105297376983f077$var$gridSize / 4, "px")
};
var $105297376983f077$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $105297376983f077$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    '&::after': $105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread({}, $105297376983f077$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $105297376983f077$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $105297376983f077$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #0C66E4)",
    '&:hover': {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: 'underline'
    }
};
var $105297376983f077$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $105297376983f077$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    }
};
var $105297376983f077$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $105297376983f077$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $105297376983f077$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    '&:not([disabled])::after': $105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread({}, $105297376983f077$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $105297376983f077$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $105297376983f077$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $105297376983f077$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $105297376983f077$var$getColor({
            group: (0, $36fb7abe9023a5cf$export$2e2bcd8739ae039).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($105297376983f077$var$getColor({
            group: (0, $36fb7abe9023a5cf$export$2e2bcd8739ae039).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $105297376983f077$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $105297376983f077$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return $105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap'
    }, !(0, $137Lh.fg)('platform-component-visual-refresh') && baseColors), {}, {
        cursor: 'pointer',
        height: $105297376983f077$var$heights[spacing],
        lineHeight: $105297376983f077$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $105297376983f077$var$singleIconPadding[spacing] : $105297376983f077$var$padding[spacing],
        verticalAlign: $105297376983f077$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, !(0, $137Lh.fg)('platform-component-visual-refresh') && $105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        '&:visited': $105297376983f077$var$_objectSpread({}, baseColors),
        '&:hover': $105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread({}, $105297376983f077$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'hover',
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
            // background, box-shadow
            transitionDuration: '0s, 0.15s'
        }),
        // giving active styles preference by listing them after focus
        '&:active': $105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread({}, $105297376983f077$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread({}, $105297376983f077$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        '&[disabled]': $105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread({}, $105297376983f077$var$getColors({
            appearance: appearance,
            key: 'disabled',
            mode: mode
        })), {}, {
            cursor: 'not-allowed',
            textDecoration: 'none'
        })
    }, $105297376983f077$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $105297376983f077$var$_objectSpread({}, $105297376983f077$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'default',
            mode: mode
        }))
    })), (0, $137Lh.fg)('platform-component-visual-refresh') && (isSelected ? $105297376983f077$var$selectedStyles : $105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread($105297376983f077$var$_objectSpread({}, appearance === 'default' && $105297376983f077$var$defaultStyles), appearance === 'primary' && $105297376983f077$var$primaryStyles), appearance === 'link' && $105297376983f077$var$linkStyles), appearance === 'subtle' && $105297376983f077$var$subtleStyles), appearance === 'subtle-link' && $105297376983f077$var$subtleLinkStyles), appearance === 'warning' && $105297376983f077$var$warningStyles), appearance === 'danger' && $105297376983f077$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $105297376983f077$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $105297376983f077$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $105297376983f077$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            }
        }
    }, $105297376983f077$var$hasOverlayStyles))), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $105297376983f077$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $105297376983f077$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $105297376983f077$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $105297376983f077$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $105297376983f077$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $105297376983f077$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};



var $7fPBF = parcelRequire("7fPBF");

var $9e9914169cfaa549$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $7fPBF.isValidElement)(children) && children.type === (0, $d1b9d01570e45f55$export$2e2bcd8739ae039);
};


var $3a147e18a4e384a4$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $3a147e18a4e384a4$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $3a147e18a4e384a4$var$iconBeforeSpacingFixStyle = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $3a147e18a4e384a4$var$iconAfterSpacingFixStyle = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $3a147e18a4e384a4$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $9e9914169cfaa549$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $3a147e18a4e384a4$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $9e9914169cfaa549$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: childrenStyles
    }, children) : null;
};
var $3a147e18a4e384a4$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $ad2b03d971966243$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $ad2b03d971966243$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $3a147e18a4e384a4$var$_excluded);
    var ourRef = (0, $7fPBF.useRef)();
    var setRef = (0, $7fPBF.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $7295fdb42024c8a7$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "23.3.1",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $7fPBF.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $7fPBF.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, $105297376983f077$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $a60667c3f4f94146$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $a60667c3f4f94146$export$c39c0fe0f26207ae), ")"), " !important")
        }
    };
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $1cc23763944a34fc$export$2e2bcd8739ae039), null, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $3a147e18a4e384a4$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $7760ac857756d3d4$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $105297376983f077$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $3a147e18a4e384a4$var$getSpacingFix(children, $3a147e18a4e384a4$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $3a147e18a4e384a4$var$getChildren(children, [
        fadeStyles,
        (0, $105297376983f077$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $105297376983f077$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $3a147e18a4e384a4$var$getSpacingFix(children, $3a147e18a4e384a4$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: [
            (0, $105297376983f077$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3a147e18a4e384a4$export$2e2bcd8739ae039 = $3a147e18a4e384a4$var$ButtonBase;




function $d988f83806b6fe3b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $9e9914169cfaa549$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}


var $317b0dc61223a332$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $317b0dc61223a332$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $317b0dc61223a332$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $ad2b03d971966243$export$2e2bcd8739ae039) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $ad2b03d971966243$export$2e2bcd8739ae039) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $317b0dc61223a332$var$_excluded);
    var _useGlobalTheme = (0, $8e3d3e3ac4379509$export$7692396083754928)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $d988f83806b6fe3b$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $7fPBF.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($317b0dc61223a332$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $7fPBF.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($317b0dc61223a332$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $7fPBF.useMemo)(function() {
        return (0, $105297376983f077$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3a147e18a4e384a4$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$317b0dc61223a332$var$Button.displayName = 'Button';
var $317b0dc61223a332$export$2e2bcd8739ae039 = $317b0dc61223a332$var$Button;



var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $f41f201ca78a311a$var$ATOMIC_GROUP_LENGTH = 5;
function $f41f201ca78a311a$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $f41f201ca78a311a$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $7fPBF = parcelRequire("7fPBF");

/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $ced3232b1b3ee4c7$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}




var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");
var $82699085d65442bf$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $82699085d65442bf$var$react18UseId = ($82699085d65442bf$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId) !== null && $82699085d65442bf$var$_React$useId !== void 0 ? $82699085d65442bf$var$_React$useId : undefined;
function $82699085d65442bf$export$f680877a34711e37() {
    if ($82699085d65442bf$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) return $82699085d65442bf$var$react18UseId();
    return "uid".concat((0, $e9144a1b4dc9c62e$export$87d05f07e65211f1)());
}
var $82699085d65442bf$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($82699085d65442bf$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $82699085d65442bf$export$6ee17796e3d70de2() {
    if ($82699085d65442bf$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) {
        var uid = $82699085d65442bf$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $e9144a1b4dc9c62e$export$bb5ca5fba6fb4f1f)();
}



var $137Lh = parcelRequire("137Lh");



var $7fPBF = parcelRequire("7fPBF");
var $74a8890cc9ccd165$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $74a8890cc9ccd165$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $7fPBF.useContext)($74a8890cc9ccd165$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $d5687ecff45b6a4f$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $d5687ecff45b6a4f$var$tabKeyCode = 9;
function $d5687ecff45b6a4f$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $d5687ecff45b6a4f$var$tabKeyCode) return;
    $d5687ecff45b6a4f$var$abort(event);
}
function $d5687ecff45b6a4f$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $d5687ecff45b6a4f$var$abort,
        onMouseUpCapture: $d5687ecff45b6a4f$var$abort,
        onKeyDownCapture: $d5687ecff45b6a4f$var$onKey,
        onKeyUpCapture: $d5687ecff45b6a4f$var$onKey,
        onTouchStartCapture: $d5687ecff45b6a4f$var$abort,
        onTouchEndCapture: $d5687ecff45b6a4f$var$abort,
        onPointerDownCapture: $d5687ecff45b6a4f$var$abort,
        onPointerUpCapture: $d5687ecff45b6a4f$var$abort,
        onClickCapture: $d5687ecff45b6a4f$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $d5687ecff45b6a4f$var$abort
    } : events;
}



var $7fPBF = parcelRequire("7fPBF");

function $c8ad3c74d065482c$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $c8ad3c74d065482c$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $c8ad3c74d065482c$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {
        size: $c8ad3c74d065482c$var$getIconSpacing(spacing),
        appearance: $c8ad3c74d065482c$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


var $2f27420929ef9635$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $2f27420929ef9635$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $2f27420929ef9635$var$LOADING_LABEL = ', Loading';
var $2f27420929ef9635$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1lh4 _30l31lh4 _9h8h1lh4",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $2f27420929ef9635$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $2f27420929ef9635$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $2f27420929ef9635$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $2f27420929ef9635$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $2f27420929ef9635$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $2f27420929ef9635$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $2f27420929ef9635$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $2f27420929ef9635$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $2f27420929ef9635$var$_excluded);
    var localRef = (0, $7fPBF.useRef)(null);
    var splitButtonContext = (0, $74a8890cc9ccd165$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $82699085d65442bf$export$f680877a34711e37)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton && (0, $137Lh.fg)('platform-component-visual-refresh') ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $7295fdb42024c8a7$export$2e2bcd8739ae039)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(unsafeRest, $2f27420929ef9635$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $34bbe408102690e7$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $ced3232b1b3ee4c7$export$2e2bcd8739ae039)([
            localRef,
            ref
        ]),
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($2f27420929ef9635$var$styles.base, appearance === 'default' && ((0, $137Lh.fg)('platform-component-visual-refresh') ? $2f27420929ef9635$var$defaultStyles.rootRefreshed : $2f27420929ef9635$var$defaultStyles.root), appearance === 'default' && isInteractive && ((0, $137Lh.fg)('platform-component-visual-refresh') ? $2f27420929ef9635$var$defaultStyles.interactiveRefreshed : $2f27420929ef9635$var$defaultStyles.interactive), appearance === 'primary' && $2f27420929ef9635$var$primaryStyles.root, appearance === 'primary' && isInteractive && $2f27420929ef9635$var$primaryStyles.interactive, appearance === 'warning' && $2f27420929ef9635$var$warningStyles.root, appearance === 'warning' && isInteractive && $2f27420929ef9635$var$warningStyles.interactive, appearance === 'danger' && $2f27420929ef9635$var$dangerStyles.root, appearance === 'danger' && isInteractive && $2f27420929ef9635$var$dangerStyles.interactive, appearance === 'discovery' && $2f27420929ef9635$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $2f27420929ef9635$var$discoveryStyles.interactive, appearance === 'subtle' && ((0, $137Lh.fg)('platform-component-visual-refresh') ? $2f27420929ef9635$var$subtleStyles.rootRefreshed : $2f27420929ef9635$var$subtleStyles.root), appearance === 'subtle' && isInteractive && ((0, $137Lh.fg)('platform-component-visual-refresh') ? $2f27420929ef9635$var$subtleStyles.interactiveRefreshed : $2f27420929ef9635$var$subtleStyles.interactive), $2f27420929ef9635$var$styles.linkDecorationUnset, isSelected && ((0, $137Lh.fg)('platform-component-visual-refresh') ? $2f27420929ef9635$var$selectedStyles.rootRefreshed : $2f27420929ef9635$var$selectedStyles.root), isSelected && isSplitButton && $2f27420929ef9635$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $2f27420929ef9635$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $2f27420929ef9635$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $2f27420929ef9635$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $2f27420929ef9635$var$selectedStyles.discovery, isDisabled && $2f27420929ef9635$var$styles.disabled, isDisabled && (!(0, $137Lh.fg)('platform-component-visual-refresh') || appearance !== 'default' && appearance !== 'subtle') && $2f27420929ef9635$var$styles.sharedDisabled, isDisabled && appearance === 'default' && ((0, $137Lh.fg)('platform-component-visual-refresh') ? $2f27420929ef9635$var$defaultStyles.disabledRefreshed : $2f27420929ef9635$var$defaultStyles.disabled), isCircle && !isSplitButton && $2f27420929ef9635$var$styles.circle, spacing === 'compact' && $2f27420929ef9635$var$styles.spacingCompact, hasIconBefore && $2f27420929ef9635$var$styles.buttonIconBefore, shouldFitContainer && $2f27420929ef9635$var$styles.fullWidth, hasIconAfter && $2f27420929ef9635$var$styles.buttonIconAfter, isIconButton && $2f27420929ef9635$var$styles.iconButton, isIconButton && spacing === 'compact' && $2f27420929ef9635$var$styles.iconButtonCompact, isLoading && $2f27420929ef9635$var$styles.loading, isSplitButton && $2f27420929ef9635$var$styles.splitButton, isNavigationSplitButton && $2f27420929ef9635$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($2f27420929ef9635$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $d5687ecff45b6a4f$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $74a8890cc9ccd165$export$4b86304b2c0d7e71).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        className: (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
            $2f27420929ef9635$var$styles.loadingOverlay
        ])
    }, (0, $c8ad3c74d065482c$export$2e2bcd8739ae039)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), {
        id: loadingLabelId
    }, $2f27420929ef9635$var$LOADING_LABEL)));
});
var $2f27420929ef9635$export$2e2bcd8739ae039 = $2f27420929ef9635$var$ButtonBase;


/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $7fPBF = parcelRequire("7fPBF");
var $bb87128a2cadd975$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $bb87128a2cadd975$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        className: (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
            $bb87128a2cadd975$var$styles.common,
            type === 'text' && $bb87128a2cadd975$var$styles.text,
            type === 'icon' && $bb87128a2cadd975$var$styles.icon,
            isLoading && $bb87128a2cadd975$var$styles.fade,
            position === 'before' && $bb87128a2cadd975$var$styles.beforeIcon,
            position === 'after' && $bb87128a2cadd975$var$styles.afterIcon
        ])
    }, children);
};
var $bb87128a2cadd975$export$2e2bcd8739ae039 = $bb87128a2cadd975$var$Content;



var $7fPBF = parcelRequire("7fPBF");
function $e3ca56ebdfbd43d2$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $e3ca56ebdfbd43d2$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, $e3ca56ebdfbd43d2$var$isIconRenderProp(Icon) ? Icon({
        label: '',
        color: 'currentColor'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, {
        label: "",
        color: 'currentColor'
    }));
};
var $e3ca56ebdfbd43d2$export$2e2bcd8739ae039 = $e3ca56ebdfbd43d2$var$IconRenderer;


var $33609f2058f20722$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $33609f2058f20722$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $33609f2058f20722$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $33609f2058f20722$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(unsafeRest, $33609f2058f20722$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2f27420929ef9635$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bb87128a2cadd975$export$2e2bcd8739ae039), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e3ca56ebdfbd43d2$export$2e2bcd8739ae039), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bb87128a2cadd975$export$2e2bcd8739ae039), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bb87128a2cadd975$export$2e2bcd8739ae039), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e3ca56ebdfbd43d2$export$2e2bcd8739ae039), {
        icon: iconAfter
    }))));
}));
$33609f2058f20722$var$Button.displayName = 'Button';
var $33609f2058f20722$export$2e2bcd8739ae039 = $33609f2058f20722$var$Button;


/**
 * Character key codes which can be used in keyboard events.
 */ var $fe366ce437c8f2df$export$390330c10ff2b9a1 = 'ArrowUp';
var $fe366ce437c8f2df$export$a80636c6f41931fe = 'ArrowDown';
var $fe366ce437c8f2df$export$4af703091671bc = 'Home';
var $fe366ce437c8f2df$export$e2bc30913faa5db7 = 'End';
var $fe366ce437c8f2df$export$10f6869ed0a7d75b = 'Tab';
var $fe366ce437c8f2df$export$8152f929a25a0ff4 = 'Enter';
var $fe366ce437c8f2df$export$e51a3576c045c8d5 = 'Space';
var $fe366ce437c8f2df$export$2bb790b9008907b4 = 'Escape';


/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $e5f53ec0aebc72ba$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}


/**
 * An empty function which does nothing.
 */ function $dca6c1d9b26ab4f1$export$2e2bcd8739ae039() {}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
function $37f0004c3fd3493f$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $7fPBF.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $7fPBF.useRef)(isControlled);
    (0, $7fPBF.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $7fPBF.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
function $5c864840253ea4c6$export$2e2bcd8739ae039() {
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $7fPBF.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $7fPBF.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}


var $d81a6ece99b002b5$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b604d93f37780dd1b714089781bfee62>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d81a6ece99b002b5$exports, "__esModule", {
    value: true
});
$d81a6ece99b002b5$exports.default = void 0;

var $d81a6ece99b002b5$var$_react = $d81a6ece99b002b5$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $d81a6ece99b002b5$var$_chevronDown = $d81a6ece99b002b5$var$_interopRequireDefault((parcelRequire("llyT9")));

var $d81a6ece99b002b5$var$_chevronDown2 = $d81a6ece99b002b5$var$_interopRequireDefault((parcelRequire("4K7uO")));
function $d81a6ece99b002b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d81a6ece99b002b5$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $d81a6ece99b002b5$var$_react.default.createElement($d81a6ece99b002b5$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $d81a6ece99b002b5$var$_chevronDown2.default
    }, props));
$d81a6ece99b002b5$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $d81a6ece99b002b5$var$_default = $d81a6ece99b002b5$exports.default = $d81a6ece99b002b5$var$ChevronDownIcon;


/* popup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");
var $beed2df52b723360$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $beed2df52b723360$var$react18UseId = ($beed2df52b723360$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId) !== null && $beed2df52b723360$var$_React$useId !== void 0 ? $beed2df52b723360$var$_React$useId : undefined;
function $beed2df52b723360$export$f680877a34711e37() {
    if ($beed2df52b723360$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $beed2df52b723360$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $e9144a1b4dc9c62e$export$87d05f07e65211f1)());
}
var $beed2df52b723360$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($beed2df52b723360$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $beed2df52b723360$export$6ee17796e3d70de2() {
    if ($beed2df52b723360$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $beed2df52b723360$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $e9144a1b4dc9c62e$export$bb5ca5fba6fb4f1f)();
}



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");
function $f18c7111ec24d6a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f18c7111ec24d6a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f18c7111ec24d6a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f18c7111ec24d6a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f18c7111ec24d6a2$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $7fPBF.createContext)(0);
var $f18c7111ec24d6a2$export$48b383b280e20440 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $f18c7111ec24d6a2$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $7fPBF.useContext)($f18c7111ec24d6a2$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $7fPBF.useRef)((0, $137Lh.fg)('layering-top-level-use-array') ? Math.random().toString(36) : '');
    if (!(0, $137Lh.fg)('layering-top-level-use-array')) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $137Lh.fg)('layering-top-level-use-array')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7fPBF.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $137Lh.fg)('layering-top-level-use-array')) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7fPBF.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($f18c7111ec24d6a2$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $f18c7111ec24d6a2$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $7fPBF.useRef)(0);
    var layerList = (0, $7fPBF.useRef)([]);
    var value = (0, $7fPBF.useMemo)(function() {
        return $f18c7111ec24d6a2$var$_objectSpread({
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        }, (0, $137Lh.fg)('layering-top-level-use-array') ? {
            layerList: layerList
        } : {});
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($f18c7111ec24d6a2$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $f18c7111ec24d6a2$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $7fPBF.useContext)($f18c7111ec24d6a2$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($f18c7111ec24d6a2$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($f18c7111ec24d6a2$var$LayeringProvider, null, content);
};




var $137Lh = parcelRequire("137Lh");


/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $6Lozc = parcelRequire("6Lozc");

var $7fPBF = parcelRequire("7fPBF");
var $bb019fd1c09caeb1$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $bb019fd1c09caeb1$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($bb019fd1c09caeb1$export$1ca2a26fecb070ae);
};
$bb019fd1c09caeb1$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $59fb32749dbc17f0$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $59fb32749dbc17f0$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $59fb32749dbc17f0$var$baseStyles = null;
var $59fb32749dbc17f0$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $59fb32749dbc17f0$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $59fb32749dbc17f0$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
var $59fb32749dbc17f0$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $59fb32749dbc17f0$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $59fb32749dbc17f0$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $59fb32749dbc17f0$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $59fb32749dbc17f0$var$Box = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $59fb32749dbc17f0$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $59fb32749dbc17f0$var$_excluded2);
    var node = /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        style: style,
        ref: ref,
        className: (0, $6Lozc.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $59fb32749dbc17f0$var$backgroundColorMap[backgroundColor],
            backgroundColor && $59fb32749dbc17f0$var$isSurfaceToken(backgroundColor) && $59fb32749dbc17f0$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $59fb32749dbc17f0$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $59fb32749dbc17f0$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $59fb32749dbc17f0$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $59fb32749dbc17f0$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $7fPBF.createElement((0, $bb019fd1c09caeb1$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $59fb32749dbc17f0$export$2e2bcd8739ae039 = $59fb32749dbc17f0$var$Box;
function $59fb32749dbc17f0$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $59fb32749dbc17f0$var$setSurfaceTokenMap;
}


/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $j9spr = parcelRequire("j9spr");

var $iKdEz = parcelRequire("iKdEz");

var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $6Lozc = parcelRequire("6Lozc");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");

function $9a1b26136f3a7f68$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9a1b26136f3a7f68$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9a1b26136f3a7f68$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9a1b26136f3a7f68$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9a1b26136f3a7f68$var$ESCAPE = 'Escape';
function $9a1b26136f3a7f68$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $7fPBF.useRef)(false);
    var _useLayering = $9a1b26136f3a7f68$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $7fPBF.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $9a1b26136f3a7f68$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $7fPBF.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $7fPBF.useEffect)(function() {
        return (0, $a091c25729a976b1$exports.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $9a1b26136f3a7f68$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $7fPBF.useContext)((0, $f18c7111ec24d6a2$export$650d12d3c2ddb8fc));
    var _useContext = (0, $7fPBF.useContext)((0, $f18c7111ec24d6a2$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var isLayerDisabled = (0, $7fPBF.useCallback)(function() {
        if ((0, $137Lh.fg)('layering-top-level-use-array')) {
            var _layerList$current$le, _layerList$current;
            return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
        }
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return $9a1b26136f3a7f68$var$_objectSpread({
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    }, (0, $137Lh.fg)('layering-top-level-use-array') ? {
        layerList: layerList
    } : {});
}



var $137Lh = parcelRequire("137Lh");


var $7fPBF = parcelRequire("7fPBF");
var $3426b06a39c1bfed$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, children);
};



var $7fPBF = parcelRequire("7fPBF");

/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $eae8f4c44fbcdba8$export$2e2bcd8739ae039() {}




var $137Lh = parcelRequire("137Lh");
var $6e4d9b3da5ed8c90$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $6e4d9b3da5ed8c90$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($6e4d9b3da5ed8c90$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};



var $7fPBF = parcelRequire("7fPBF");
var $219885ccd5b6fbf8$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $7fPBF.useRef)([]);
    var requestFrame = (0, $7fPBF.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $7fPBF.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $7fPBF.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};


var $6be887c8706278cd$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $9a1b26136f3a7f68$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $219885ccd5b6fbf8$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $7fPBF.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $eae8f4c44fbcdba8$export$2e2bcd8739ae039;
        var inIframe = window && window.self !== window.top && (0, $137Lh.fg)('fix-dropdown-close-outside-iframe');
        var closePopup = function closePopup(event) {
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest;
                    _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-ds--level');
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                    if (layeredElement) {
                        var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $6e4d9b3da5ed8c90$export$3dee5e4542c672d9)(document.activeElement) && (0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === 'Escape' || _key === 'Esc' || shouldCloseOnTab && _key === 'Tab') closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $a091c25729a976b1$exports.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $eae8f4c44fbcdba8$export$2e2bcd8739ae039);
        if ((0, $137Lh.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $a091c25729a976b1$exports.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                }
            ]);
        }, 0);
        else unbind = (0, $a091c25729a976b1$exports.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $eae8f4c44fbcdba8$export$2e2bcd8739ae039);
        unbindBlur = (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            if ((0, $137Lh.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};



var $7fPBF = parcelRequire("7fPBF");




var $137Lh = parcelRequire("137Lh");

var $0fdc7b9250fbf018$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $219885ccd5b6fbf8$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $9a1b26136f3a7f68$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    (0, $7fPBF.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $eae8f4c44fbcdba8$export$2e2bcd8739ae039;
        if (shouldDisableFocusTrap && (0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $eae8f4c44fbcdba8$export$2e2bcd8739ae039;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($08fd599bcf7f4689$exports)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};


var $15973a1591f27098$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden"
];
var $15973a1591f27098$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $15973a1591f27098$var$fullWidthStyles = null;
var $15973a1591f27098$var$wrapperStyles = {
    root: "_2rkoglpi _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _syaz1fxt _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36"
};
var $15973a1591f27098$var$scrollableStyles = null;
var $15973a1591f27098$var$blanketStyles = null;
var $15973a1591f27098$var$modalStyles = null;
var $15973a1591f27098$var$focusRingStyles = {
    root: "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y"
};
var $15973a1591f27098$var$DefaultPopupComponent = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, isReferenceHidden = props.isReferenceHidden, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $15973a1591f27098$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $6Lozc.default)([
            $15973a1591f27098$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            !shouldRenderToParent && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $15973a1591f27098$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $15973a1591f27098$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $7fPBF.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $0fdc7b9250fbf018$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $6be887c8706278cd$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $9a1b26136f3a7f68$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $7fPBF.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $e8027c477e280fef$export$badac9ada3a0bdf9), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $7fPBF.createElement(PopupContainer, {
            className: (0, $6Lozc.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $137Lh.fg)('platform-design-system-apply-popup-wrapper-focus') && $15973a1591f27098$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $7fPBF.createElement((0, $3426b06a39c1bfed$export$51eddd7655ca235a), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $7fPBF.createElement("div", {
            className: (0, $6Lozc.default)([
                "_1r04idpf _kqsw1n9t _bfhk10xm"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$15973a1591f27098$export$2e2bcd8739ae039 = $15973a1591f27098$var$PopperWrapper;



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $935640c6992dc385$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};


var $745f881e9d6548fe$var$_window, $745f881e9d6548fe$var$_window$matchMedia, $745f881e9d6548fe$var$_window2, $745f881e9d6548fe$var$_window2$matchMedia, $745f881e9d6548fe$var$_window3, $745f881e9d6548fe$var$_window3$matchMedia, $745f881e9d6548fe$var$_window4, $745f881e9d6548fe$var$_window4$matchMedia, $745f881e9d6548fe$var$_window5, $745f881e9d6548fe$var$_window5$matchMedia, $745f881e9d6548fe$var$_window6, $745f881e9d6548fe$var$_window6$matchMedia, $745f881e9d6548fe$var$_window7, $745f881e9d6548fe$var$_window7$matchMedia, $745f881e9d6548fe$var$_window8, $745f881e9d6548fe$var$_window8$matchMedia, $745f881e9d6548fe$var$_window9, $745f881e9d6548fe$var$_window9$matchMedia, $745f881e9d6548fe$var$_window0, $745f881e9d6548fe$var$_window0$matchMedia, $745f881e9d6548fe$var$_window1, $745f881e9d6548fe$var$_window1$matchMedia;
var $745f881e9d6548fe$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($745f881e9d6548fe$var$_window = window) === null || $745f881e9d6548fe$var$_window === void 0 || ($745f881e9d6548fe$var$_window$matchMedia = $745f881e9d6548fe$var$_window.matchMedia) === null || $745f881e9d6548fe$var$_window$matchMedia === void 0 ? void 0 : $745f881e9d6548fe$var$_window$matchMedia.call($745f881e9d6548fe$var$_window, (0, $935640c6992dc385$export$987d49ffe1b0900f).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($745f881e9d6548fe$var$_window2 = window) === null || $745f881e9d6548fe$var$_window2 === void 0 || ($745f881e9d6548fe$var$_window2$matchMedia = $745f881e9d6548fe$var$_window2.matchMedia) === null || $745f881e9d6548fe$var$_window2$matchMedia === void 0 ? void 0 : $745f881e9d6548fe$var$_window2$matchMedia.call($745f881e9d6548fe$var$_window2, (0, $935640c6992dc385$export$987d49ffe1b0900f).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($745f881e9d6548fe$var$_window3 = window) === null || $745f881e9d6548fe$var$_window3 === void 0 || ($745f881e9d6548fe$var$_window3$matchMedia = $745f881e9d6548fe$var$_window3.matchMedia) === null || $745f881e9d6548fe$var$_window3$matchMedia === void 0 ? void 0 : $745f881e9d6548fe$var$_window3$matchMedia.call($745f881e9d6548fe$var$_window3, (0, $935640c6992dc385$export$987d49ffe1b0900f).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($745f881e9d6548fe$var$_window4 = window) === null || $745f881e9d6548fe$var$_window4 === void 0 || ($745f881e9d6548fe$var$_window4$matchMedia = $745f881e9d6548fe$var$_window4.matchMedia) === null || $745f881e9d6548fe$var$_window4$matchMedia === void 0 ? void 0 : $745f881e9d6548fe$var$_window4$matchMedia.call($745f881e9d6548fe$var$_window4, (0, $935640c6992dc385$export$987d49ffe1b0900f).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($745f881e9d6548fe$var$_window5 = window) === null || $745f881e9d6548fe$var$_window5 === void 0 || ($745f881e9d6548fe$var$_window5$matchMedia = $745f881e9d6548fe$var$_window5.matchMedia) === null || $745f881e9d6548fe$var$_window5$matchMedia === void 0 ? void 0 : $745f881e9d6548fe$var$_window5$matchMedia.call($745f881e9d6548fe$var$_window5, (0, $935640c6992dc385$export$987d49ffe1b0900f).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($745f881e9d6548fe$var$_window6 = window) === null || $745f881e9d6548fe$var$_window6 === void 0 || ($745f881e9d6548fe$var$_window6$matchMedia = $745f881e9d6548fe$var$_window6.matchMedia) === null || $745f881e9d6548fe$var$_window6$matchMedia === void 0 ? void 0 : $745f881e9d6548fe$var$_window6$matchMedia.call($745f881e9d6548fe$var$_window6, (0, $935640c6992dc385$export$987d49ffe1b0900f).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($745f881e9d6548fe$var$_window7 = window) === null || $745f881e9d6548fe$var$_window7 === void 0 || ($745f881e9d6548fe$var$_window7$matchMedia = $745f881e9d6548fe$var$_window7.matchMedia) === null || $745f881e9d6548fe$var$_window7$matchMedia === void 0 ? void 0 : $745f881e9d6548fe$var$_window7$matchMedia.call($745f881e9d6548fe$var$_window7, (0, $935640c6992dc385$export$987d49ffe1b0900f).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($745f881e9d6548fe$var$_window8 = window) === null || $745f881e9d6548fe$var$_window8 === void 0 || ($745f881e9d6548fe$var$_window8$matchMedia = $745f881e9d6548fe$var$_window8.matchMedia) === null || $745f881e9d6548fe$var$_window8$matchMedia === void 0 ? void 0 : $745f881e9d6548fe$var$_window8$matchMedia.call($745f881e9d6548fe$var$_window8, (0, $935640c6992dc385$export$987d49ffe1b0900f).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($745f881e9d6548fe$var$_window9 = window) === null || $745f881e9d6548fe$var$_window9 === void 0 || ($745f881e9d6548fe$var$_window9$matchMedia = $745f881e9d6548fe$var$_window9.matchMedia) === null || $745f881e9d6548fe$var$_window9$matchMedia === void 0 ? void 0 : $745f881e9d6548fe$var$_window9$matchMedia.call($745f881e9d6548fe$var$_window9, (0, $935640c6992dc385$export$987d49ffe1b0900f).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($745f881e9d6548fe$var$_window0 = window) === null || $745f881e9d6548fe$var$_window0 === void 0 || ($745f881e9d6548fe$var$_window0$matchMedia = $745f881e9d6548fe$var$_window0.matchMedia) === null || $745f881e9d6548fe$var$_window0$matchMedia === void 0 ? void 0 : $745f881e9d6548fe$var$_window0$matchMedia.call($745f881e9d6548fe$var$_window0, (0, $935640c6992dc385$export$987d49ffe1b0900f).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($745f881e9d6548fe$var$_window1 = window) === null || $745f881e9d6548fe$var$_window1 === void 0 || ($745f881e9d6548fe$var$_window1$matchMedia = $745f881e9d6548fe$var$_window1.matchMedia) === null || $745f881e9d6548fe$var$_window1$matchMedia === void 0 ? void 0 : $745f881e9d6548fe$var$_window1$matchMedia.call($745f881e9d6548fe$var$_window1, (0, $935640c6992dc385$export$987d49ffe1b0900f).below.xl.replace('@media ', '').trim())
};
var $745f881e9d6548fe$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $7fPBF.useRef)(listener);
    (0, $7fPBF.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $745f881e9d6548fe$var$queries[queryString];
    (0, $7fPBF.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $a091c25729a976b1$exports.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};


function $abf485aad872b57e$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $745f881e9d6548fe$export$49e55ae2c03d6045)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $7fPBF.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $f7b94c43843f44d7$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $7fPBF.useState)(function() {
        return (0, $859f0395401445ad$export$2e2bcd8739ae039)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $46e9f164fda40e47$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $7fPBF.useState)(function() {
        return (0, $859f0395401445ad$export$2e2bcd8739ae039)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};


var $1744f9da5b49a41a$var$defaultLayer = 400;
var $1744f9da5b49a41a$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $1744f9da5b49a41a$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $1744f9da5b49a41a$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $7fPBF.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $f7b94c43843f44d7$export$7cc5c058dd769dff)();
    var getMergedTriggerRefNew = (0, $46e9f164fda40e47$export$5d3a2de79e07b376)();
    var generatedId = (0, $beed2df52b723360$export$f680877a34711e37)();
    var _usePopupAppearance = (0, $abf485aad872b57e$export$4065aef1d79a5730)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $7fPBF.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $e85233b93e6c09f0$export$469bb693f11edc7f)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    var renderPopperWrapper = /*#__PURE__*/ $7fPBF.createElement((0, $f18c7111ec24d6a2$export$7c885f891c940977), {
        isDisabled: false
    }, /*#__PURE__*/ $7fPBF.createElement((0, $15973a1591f27098$export$2e2bcd8739ae039), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $7fPBF.createElement((0, $946cf4462dcf0c84$export$d0d38e7dec7a1a61), null, /*#__PURE__*/ $7fPBF.createElement((0, $707082bb5d4c97c5$export$e0be378c32fb70a7), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $137Lh.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $137Lh.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $7fPBF.createElement((0, $cd3bc8368572caba$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return /*#__PURE__*/ $7fPBF.createElement((0, $59fb32749dbc17f0$export$2e2bcd8739ae039), {
        xcss: $1744f9da5b49a41a$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
});


var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bda07f55d909467c$export$2e2bcd8739ae039 = (0, $1744f9da5b49a41a$export$129a32eedafa97c5);


/* eslint-disable no-console */ var $279921e72476e04e$var$printed = {};
function $279921e72476e04e$export$2e2bcd8739ae039(message) {
    if ($279921e72476e04e$var$printed[message]) return;
    $279921e72476e04e$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $0bfb9019b372a22f$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $279921e72476e04e$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $0bfb9019b372a22f$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {}


// Reds
var $094b2769b1e0f195$export$4b84fd0e2c617bd = '#FFEBE6';
var $094b2769b1e0f195$export$b34b069eff244586 = '#FFBDAD';
var $094b2769b1e0f195$export$be802dd0d8b57f35 = '#FF8F73';
var $094b2769b1e0f195$export$60847d42f9da92a6 = '#FF7452';
var $094b2769b1e0f195$export$4a7404f376229999 = '#FF5630';
var $094b2769b1e0f195$export$2010d0fb4295b346 = '#DE350B';
var $094b2769b1e0f195$export$2837b5a1a71d5c02 = '#BF2600';
var $094b2769b1e0f195$export$8d9596b529bbb9cf = '#FFFAE6';
var $094b2769b1e0f195$export$41060a744ab0b7ae = '#FFF0B3';
var $094b2769b1e0f195$export$1cc05bbbf340e559 = '#FFE380';
var $094b2769b1e0f195$export$5aae31392d72caaa = '#FFC400';
var $094b2769b1e0f195$export$c6930421db9fa514 = '#FFAB00';
var $094b2769b1e0f195$export$59619663aa6500fb = '#FF991F';
var $094b2769b1e0f195$export$874739ea9e379ab6 = '#FF8B00';
var $094b2769b1e0f195$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $094b2769b1e0f195$export$69a3bf21b9686c2b = '#ABF5D1';
var $094b2769b1e0f195$export$afbce1382ec95f73 = '#79F2C0';
var $094b2769b1e0f195$export$747d86715d4175de = '#57D9A3';
var $094b2769b1e0f195$export$940e1f69e873f202 = '#36B37E';
var $094b2769b1e0f195$export$a49394138f7b8e85 = '#00875A';
var $094b2769b1e0f195$export$6fa04827ac68a4fb = '#006644';
var $094b2769b1e0f195$export$226de0355ed012f8 = '#DEEBFF';
var $094b2769b1e0f195$export$8c13c2ee36917869 = '#B3D4FF';
var $094b2769b1e0f195$export$ecfc1dff386a3e7a = '#4C9AFF';
var $094b2769b1e0f195$export$215b7063051591f1 = '#2684FF';
var $094b2769b1e0f195$export$e62e8919cca44969 = '#0065FF';
var $094b2769b1e0f195$export$b3de0ae08da2ce64 = '#0052CC';
var $094b2769b1e0f195$export$a6ee3d71bc067634 = '#0747A6';
var $094b2769b1e0f195$export$67f15409e87642a1 = '#669DF1';
var $094b2769b1e0f195$export$f0539dbc42dbb067 = '#8FB8F6';
var $094b2769b1e0f195$export$363e4475840015bb = '#EAE6FF';
var $094b2769b1e0f195$export$4b0a4417ed59760f = '#C0B6F2';
var $094b2769b1e0f195$export$6011520a64d9a187 = '#998DD9';
var $094b2769b1e0f195$export$a7175d4e9206bc80 = '#8777D9';
var $094b2769b1e0f195$export$b48405b95304b5a1 = '#6554C0';
var $094b2769b1e0f195$export$c71e4279dd54a18d = '#5243AA';
var $094b2769b1e0f195$export$147899de772240ec = '#403294';
var $094b2769b1e0f195$export$2cf711fe14c66f06 = '#E6FCFF';
var $094b2769b1e0f195$export$7a8f4d33f6f9772c = '#B3F5FF';
var $094b2769b1e0f195$export$776c9c497ef08533 = '#79E2F2';
var $094b2769b1e0f195$export$69cb3ca10c1e330e = '#00C7E6';
var $094b2769b1e0f195$export$9dc1ef0f3f48059b = '#00B8D9';
var $094b2769b1e0f195$export$7c835c78b6fcdef8 = '#00A3BF';
var $094b2769b1e0f195$export$6036577f95c3877e = '#008DA6';
var $094b2769b1e0f195$export$29a4f05edc054374 = '#FFFFFF';
var $094b2769b1e0f195$export$e655ef011c4aa1a2 = '#FAFBFC';
var $094b2769b1e0f195$export$9fdfb749e33cdf97 = '#F4F5F7';
var $094b2769b1e0f195$export$3e51e8f1440314ba = '#EBECF0';
var $094b2769b1e0f195$export$1ce2d1575d444ceb = '#DFE1E6';
var $094b2769b1e0f195$export$8754fc7e6d8b3000 = '#C1C7D0';
var $094b2769b1e0f195$export$c2e91cbeada39b8b = '#B3BAC5';
var $094b2769b1e0f195$export$5f71e19f3a7ad9de = '#A5ADBA';
var $094b2769b1e0f195$export$eaa8c8a70ac22806 = '#97A0AF';
var $094b2769b1e0f195$export$7c87d337fb91a97d = '#8993A4';
var $094b2769b1e0f195$export$d6447c357493214f = '#7A869A';
var $094b2769b1e0f195$export$f563ee71e9ee74cd = '#6B778C';
var $094b2769b1e0f195$export$e2ef2124cf4024b1 = '#5E6C84';
var $094b2769b1e0f195$export$eece5f492e429f08 = '#505F79';
var $094b2769b1e0f195$export$c39c0fe0f26207ae = '#42526E';
var $094b2769b1e0f195$export$7090862dc3038a9f = '#344563';
var $094b2769b1e0f195$export$ad0bacf983b7ddaa = '#253858';
var $094b2769b1e0f195$export$7d61b15e0da132af = '#172B4D';
var $094b2769b1e0f195$export$fbda843f0a27fe96 = '#091E42';
var $094b2769b1e0f195$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $094b2769b1e0f195$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $094b2769b1e0f195$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $094b2769b1e0f195$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $094b2769b1e0f195$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $094b2769b1e0f195$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $094b2769b1e0f195$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $094b2769b1e0f195$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $094b2769b1e0f195$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $094b2769b1e0f195$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $094b2769b1e0f195$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $094b2769b1e0f195$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $094b2769b1e0f195$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $094b2769b1e0f195$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $094b2769b1e0f195$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $094b2769b1e0f195$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $094b2769b1e0f195$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $094b2769b1e0f195$export$2f6319cf7d736c2a = '#E6EDFA';
var $094b2769b1e0f195$export$95126bc8884d6634 = '#DCE5F5';
var $094b2769b1e0f195$export$8338d8c35d44ff1 = '#CED9EB';
var $094b2769b1e0f195$export$5368d76ae4fbbda7 = '#B8C7E0';
var $094b2769b1e0f195$export$9f0a771d16ec8d36 = '#ABBBD6';
var $094b2769b1e0f195$export$abcf8c38338b4aa5 = '#9FB0CC';
var $094b2769b1e0f195$export$97e81faa16a182c7 = '#8C9CB8';
var $094b2769b1e0f195$export$bfe21c59123ecf33 = '#7988A3';
var $094b2769b1e0f195$export$ee82aa2ea6a1558 = '#67758F';
var $094b2769b1e0f195$export$682927c6ed76be02 = '#56637A';
var $094b2769b1e0f195$export$91fd9994c5be9757 = '#455166';
var $094b2769b1e0f195$export$d281fbfe3cff2df6 = '#3B475C';
var $094b2769b1e0f195$export$3902c91d8b98a753 = '#313D52';
var $094b2769b1e0f195$export$8e8133c1ba5845b5 = '#283447';
var $094b2769b1e0f195$export$33ff357f6620b39 = '#202B3D';
var $094b2769b1e0f195$export$633847cf062b69e0 = '#1B2638';
var $094b2769b1e0f195$export$9776a6e503bdbf76 = '#121A29';
var $094b2769b1e0f195$export$6c813d5160dff5db = '#0E1624';
var $094b2769b1e0f195$export$3d4f271a500072a = '#0D1424';
var $094b2769b1e0f195$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $094b2769b1e0f195$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $094b2769b1e0f195$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $094b2769b1e0f195$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $094b2769b1e0f195$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $094b2769b1e0f195$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $094b2769b1e0f195$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $094b2769b1e0f195$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $094b2769b1e0f195$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $094b2769b1e0f195$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $094b2769b1e0f195$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $094b2769b1e0f195$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $094b2769b1e0f195$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $094b2769b1e0f195$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $094b2769b1e0f195$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $094b2769b1e0f195$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $094b2769b1e0f195$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $094b2769b1e0f195$export$d2adc5dedf09fced = '#292A2E';
var $094b2769b1e0f195$export$f51762073d2bb381 = '#94C748';
var $094b2769b1e0f195$export$95e26d54def96891 = '#B3DF72';


var $0a0ec88cfd89a5bc$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $0a0ec88cfd89a5bc$export$c93026a968943f95 = 'light';
var $0a0ec88cfd89a5bc$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $0a0ec88cfd89a5bc$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $0a0ec88cfd89a5bc$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $0a0ec88cfd89a5bc$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $094b2769b1e0f195$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0a0ec88cfd89a5bc$export$6d8204c2cb2e06b8() / 4;
    (0, $0bfb9019b372a22f$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $0a0ec88cfd89a5bc$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $0a0ec88cfd89a5bc$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $0a0ec88cfd89a5bc$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $0bfb9019b372a22f$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $0a0ec88cfd89a5bc$export$ba1d834b86d72a09 = $0a0ec88cfd89a5bc$export$a1b3edb637fb4f35;
var $0a0ec88cfd89a5bc$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $094b2769b1e0f195$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $094b2769b1e0f195$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $094b2769b1e0f195$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");




var $8MJe2 = parcelRequire("8MJe2");


var $137Lh = parcelRequire("137Lh");

var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");
var $d625109a55dc7442$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $d625109a55dc7442$var$react18UseId = ($d625109a55dc7442$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId) !== null && $d625109a55dc7442$var$_React$useId !== void 0 ? $d625109a55dc7442$var$_React$useId : undefined;
function $d625109a55dc7442$export$f680877a34711e37() {
    if ($d625109a55dc7442$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) return $d625109a55dc7442$var$react18UseId();
    return "uid".concat((0, $e9144a1b4dc9c62e$export$87d05f07e65211f1)());
}
var $d625109a55dc7442$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($d625109a55dc7442$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $d625109a55dc7442$export$6ee17796e3d70de2() {
    if ($d625109a55dc7442$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) {
        var uid = $d625109a55dc7442$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $e9144a1b4dc9c62e$export$bb5ca5fba6fb4f1f)();
}


var $d4c90676fa20410d$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $d4c90676fa20410d$export$2e2bcd8739ae039() {
    var id = (0, $d625109a55dc7442$export$f680877a34711e37)();
    return "".concat($d4c90676fa20410d$export$8a682ae47622dbb9).concat(id);
}


var $47aae5df48d2fd70$var$actionMap = (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $fe366ce437c8f2df$export$a80636c6f41931fe), 'next'), (0, $fe366ce437c8f2df$export$390330c10ff2b9a1), 'prev'), (0, $fe366ce437c8f2df$export$4af703091671bc), 'first'), (0, $fe366ce437c8f2df$export$e2bc30913faa5db7), 'last');
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $47aae5df48d2fd70$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $47aae5df48d2fd70$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
function $47aae5df48d2fd70$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $d4c90676fa20410d$export$8a682ae47622dbb9), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $fe366ce437c8f2df$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $fe366ce437c8f2df$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $47aae5df48d2fd70$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var nextFocusableElement = $47aae5df48d2fd70$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var prevFocusableElement = $47aae5df48d2fd70$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var firstFocusableElement = $47aae5df48d2fd70$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var lastFocusableElement = $47aae5df48d2fd70$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}


var $eb6624b74b384c84$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    menuItemRefs: [],
    registerRef: (0, $dca6c1d9b26ab4f1$export$2e2bcd8739ae039)
});
/**
 * Focus manager logic.
 */ var $eb6624b74b384c84$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $7fPBF.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $7fPBF.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $7fPBF.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, $7fPBF.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $9a1b26136f3a7f68$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $7fPBF.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $7fPBF.useEffect)(function() {
        return (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'keydown',
            listener: (0, $47aae5df48d2fd70$export$2e2bcd8739ae039)(menuItemRefs, isLayerDisabled, onClose)
        });
    }, [
        isLayerDisabled,
        onClose
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($eb6624b74b384c84$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $eb6624b74b384c84$export$2e2bcd8739ae039 = $eb6624b74b384c84$var$FocusManager;


/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

/* menu-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $6Lozc = parcelRequire("6Lozc");

var $7fPBF = parcelRequire("7fPBF");
var $3fd46dd48ab010d9$export$443076ec7ebce042 = /*#__PURE__*/ (0, $7fPBF.createContext)('cozy');
var $3fd46dd48ab010d9$export$9ca534b70725964d = /*#__PURE__*/ (0, $7fPBF.createContext)('border');


var $255cd1fdf75ab2a4$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "menuLabel",
    "className"
];
var $255cd1fdf75ab2a4$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $255cd1fdf75ab2a4$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, menuLabel = _ref.menuLabel, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $255cd1fdf75ab2a4$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement((0, $3fd46dd48ab010d9$export$443076ec7ebce042).Provider, {
        value: spacing
    }, /*#__PURE__*/ $7fPBF.createElement((0, $3fd46dd48ab010d9$export$9ca534b70725964d).Provider, {
        value: "border"
    }, /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $6Lozc.default)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel
    }, rest))));
};
var $255cd1fdf75ab2a4$export$2e2bcd8739ae039 = $255cd1fdf75ab2a4$var$MenuGroup;


/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


var $2ecd6aa4c91a6f66$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $2ecd6aa4c91a6f66$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $2ecd6aa4c91a6f66$var$baseStyles = null;
var $2ecd6aa4c91a6f66$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $2ecd6aa4c91a6f66$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $2ecd6aa4c91a6f66$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
var $2ecd6aa4c91a6f66$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $2ecd6aa4c91a6f66$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $2ecd6aa4c91a6f66$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $2ecd6aa4c91a6f66$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $2ecd6aa4c91a6f66$var$Box = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $2ecd6aa4c91a6f66$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $2ecd6aa4c91a6f66$var$_excluded2);
    var node = /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        style: style,
        ref: ref,
        className: (0, $ca1b8a586a841420$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $2ecd6aa4c91a6f66$var$backgroundColorMap[backgroundColor],
            backgroundColor && $2ecd6aa4c91a6f66$var$isSurfaceToken(backgroundColor) && $2ecd6aa4c91a6f66$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $2ecd6aa4c91a6f66$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $2ecd6aa4c91a6f66$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $2ecd6aa4c91a6f66$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $2ecd6aa4c91a6f66$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $7fPBF.createElement((0, $bd8fd1a07ee559ec$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $2ecd6aa4c91a6f66$export$2e2bcd8739ae039 = $2ecd6aa4c91a6f66$var$Box;
function $2ecd6aa4c91a6f66$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $2ecd6aa4c91a6f66$var$setSurfaceTokenMap;
}



function $98bcc16954bd5289$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}


function $213629e3ea3ffef6$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}



var $ff9f70b371fd0152$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k"
};
var $ff9f70b371fd0152$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return /*#__PURE__*/ $7fPBF.createElement((0, $2ecd6aa4c91a6f66$export$2e2bcd8739ae039), {
        xcss: $ff9f70b371fd0152$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $7fPBF.createElement((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $ff9f70b371fd0152$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus, menuLabel = _ref2.menuLabel;
    var _useContext = (0, $7fPBF.useContext)((0, $eb6624b74b384c84$export$f18c1d4fc7326096)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $98bcc16954bd5289$export$2e2bcd8739ae039)(menuItem) || (0, $213629e3ea3ffef6$export$2e2bcd8739ae039)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $7fPBF.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $7fPBF.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $255cd1fdf75ab2a4$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group"),
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $7fPBF.createElement($ff9f70b371fd0152$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $ff9f70b371fd0152$export$2e2bcd8739ae039 = $ff9f70b371fd0152$var$MenuWrapper;



var $7fPBF = parcelRequire("7fPBF");

var $8f867eaee5479db0$export$756f795847463ebd = /*#__PURE__*/ (0, $7fPBF.createContext)({
    setItemState: (0, $dca6c1d9b26ab4f1$export$2e2bcd8739ae039),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $dca6c1d9b26ab4f1$export$2e2bcd8739ae039),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $8f867eaee5479db0$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $7fPBF.useRef)({});
    var context = (0, $7fPBF.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($8f867eaee5479db0$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $8f867eaee5479db0$export$2e2bcd8739ae039 = $8f867eaee5479db0$var$SelectionStore;



var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $fab79f5a132f918b$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $7fPBF.useContext)((0, $eb6624b74b384c84$export$f18c1d4fc7326096)), registerRef = _useContext.registerRef;
    var itemRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(function() {
        if (hasPopup && (0, $137Lh.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $fab79f5a132f918b$export$2e2bcd8739ae039 = $fab79f5a132f918b$var$useRegisterItemWithFocusManager;



var $a675d37d7e8f2ee4$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $a675d37d7e8f2ee4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a675d37d7e8f2ee4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a675d37d7e8f2ee4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a675d37d7e8f2ee4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a675d37d7e8f2ee4$var$gridSize = (0, $0a0ec88cfd89a5bc$export$6d8204c2cb2e06b8)();
var $a675d37d7e8f2ee4$var$MAX_HEIGHT = "calc(100vh - ".concat($a675d37d7e8f2ee4$var$gridSize * 2, "px)");
var $a675d37d7e8f2ee4$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $a675d37d7e8f2ee4$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($a675d37d7e8f2ee4$var$opposites[crossAxis]),
            "".concat($a675d37d7e8f2ee4$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($a675d37d7e8f2ee4$var$opposites[mainAxis]),
            "".concat($a675d37d7e8f2ee4$var$opposites[mainAxis], "-").concat($a675d37d7e8f2ee4$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($a675d37d7e8f2ee4$var$opposites[mainAxis]),
        "".concat($a675d37d7e8f2ee4$var$opposites[mainAxis], "-start"),
        "".concat($a675d37d7e8f2ee4$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
function $a675d37d7e8f2ee4$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $a675d37d7e8f2ee4$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $dca6c1d9b26ab4f1$export$2e2bcd8739ae039) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $0a0ec88cfd89a5bc$export$7be255094ccdc533).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy, menuLabel = _ref.menuLabel;
    var _useControlledState = (0, $37f0004c3fd3493f$export$2e2bcd8739ae039)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $d4c90676fa20410d$export$2e2bcd8739ae039)();
    var itemRef = (0, $fab79f5a132f918b$export$2e2bcd8739ae039)();
    var fallbackPlacements = (0, $7fPBF.useMemo)(function() {
        return $a675d37d7e8f2ee4$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $7fPBF.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $7fPBF.useCallback)(function(event, currentLevel) {
        var _event$target$closest, _event$target;
        var isTabOrEscapeKey = $a675d37d7e8f2ee4$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape');
        if (event !== null && !isTabOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $d4c90676fa20410d$export$8a682ae47622dbb9), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($a675d37d7e8f2ee4$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape')) requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            var isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            var shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(function() {
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    var _useFocus = (0, $5c864840253ea4c6$export$2e2bcd8739ae039)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $7fPBF.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $dca6c1d9b26ab4f1$export$2e2bcd8739ae039;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $dca6c1d9b26ab4f1$export$2e2bcd8739ae039;
        return (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $d4c90676fa20410d$export$8a682ae47622dbb9), "] [aria-haspopup]"));
                if (e.key === (0, $fe366ce437c8f2df$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $fe366ce437c8f2df$export$e51a3576c045c8d5) || e.key === (0, $fe366ce437c8f2df$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $fe366ce437c8f2df$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8f867eaee5479db0$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bda07f55d909467c$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $a675d37d7e8f2ee4$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($a675d37d7e8f2ee4$var$_objectSpread($a675d37d7e8f2ee4$var$_objectSpread($a675d37d7e8f2ee4$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $e5f53ec0aebc72ba$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $33609f2058f20722$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, bindFocus, {
                ref: (0, $e5f53ec0aebc72ba$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: function iconAfter(iconProps) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d81a6ece99b002b5$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, iconProps, {
                        size: "small"
                    }));
                },
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label,
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $eb6624b74b384c84$export$2e2bcd8739ae039), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ff9f70b371fd0152$export$2e2bcd8739ae039), {
                spacing: spacing,
                maxHeight: $a675d37d7e8f2ee4$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper"),
                menuLabel: menuLabel
            }, children));
        }
    })));
};
var $a675d37d7e8f2ee4$export$2e2bcd8739ae039 = $a675d37d7e8f2ee4$var$DropdownMenu;


var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


/* menu-item-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $6Lozc = parcelRequire("6Lozc");

var $137Lh = parcelRequire("137Lh");


var $c920716421c0064d$var$renderTitle = function renderTitle(Component, props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    $7fPBF.createElement(Component, props));
};
var $c920716421c0064d$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt75194a _mizu194a _1bg411pw _1ah311pw _49pcnqa1 _ra3xnqa1 _1hvw1bk5 _128m1bk5 _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c82smr",
    wordBreak: "_1nmz1hna",
    description: "_11c8dcr7 _syaz1wmz",
    disabledDescription: "_syaz2oi6",
    unselected: "_bfhkqtfy _syaz1r31 _10531r31 _irr31dko _30l31r31 _1di61dko _9h8h1r31",
    disabled: "_80om13gf _bfhkqtfy _syaz2oi6 _irr3qtfy _30l32oi6 _1di6qtfy _9h8h2oi6",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rus67is _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx315o9 _1mp41y44 _1cs8stnw _1rus67is _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk1q4k _syazhu5v _1053hu5v _irr32seo _30l316ov _1di6guph _9h8hhu5v",
    selectedOld: "_30l3hu5v"
};
var $c920716421c0064d$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var $c920716421c0064d$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $c920716421c0064d$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, testId = _ref.testId;
    var spacing = (0, $7fPBF.useContext)((0, $3fd46dd48ab010d9$export$443076ec7ebce042));
    var selectionStyle = (0, $7fPBF.useContext)((0, $3fd46dd48ab010d9$export$9ca534b70725964d));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, $6Lozc.default)([
                (0, $6Lozc.default)([
                    $c920716421c0064d$var$styles.root,
                    $c920716421c0064d$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $c920716421c0064d$var$styles.unselected,
                    !isDisabled && isSelected && $c920716421c0064d$var$styles.selected,
                    !(0, $137Lh.fg)('platform_fix_a11y_selected_and_hovered_state_color') && !isDisabled && isSelected && $c920716421c0064d$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $c920716421c0064d$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $c920716421c0064d$var$styles.selectedNotch,
                    isDisabled && $c920716421c0064d$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $7fPBF.createElement((0, $5f5c616ec3c653f2$export$2e2bcd8739ae039), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $c920716421c0064d$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && /*#__PURE__*/ $7fPBF.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && "".concat(testId, "--icon-before"),
                className: (0, $6Lozc.default)([
                    $c920716421c0064d$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $7fPBF.createElement("div", {
                className: (0, $6Lozc.default)([
                    $c920716421c0064d$var$styles.content
                ])
            }, $c920716421c0064d$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $6Lozc.default)([
                    $c920716421c0064d$var$styles.title,
                    shouldTitleWrap ? $c920716421c0064d$var$styles.wordBreak : $c920716421c0064d$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $7fPBF.createElement("span", {
                "data-item-description": true,
                className: (0, $6Lozc.default)([
                    $c920716421c0064d$var$styles.description,
                    isDisabled && $c920716421c0064d$var$styles.disabledDescription,
                    shouldDescriptionWrap && $c920716421c0064d$var$styles.wordBreak,
                    !shouldDescriptionWrap && $c920716421c0064d$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $7fPBF.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && "".concat(testId, "--icon-after"),
                className: (0, $6Lozc.default)([
                    $c920716421c0064d$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    }();
};
var $c920716421c0064d$export$2e2bcd8739ae039 = $c920716421c0064d$var$MenuItemPrimitive;


var $d43d870fe2269526$var$_excluded = [
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $d43d870fe2269526$var$ButtonItem = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $d43d870fe2269526$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $7fPBF.createElement((0, $c920716421c0064d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        className: UNSAFE_className
    }, rest, {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $7fPBF.createElement("button", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $d43d870fe2269526$export$2e2bcd8739ae039 = $d43d870fe2269526$var$ButtonItem;


/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");



var $733aa530fb88758c$var$_excluded = [
    "component",
    "isDisabled",
    "isSelected",
    "isTitleHeading",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $733aa530fb88758c$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $733aa530fb88758c$var$CustomItem = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $733aa530fb88758c$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $7fPBF.createElement((0, $c920716421c0064d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        className: UNSAFE_className
    }, rest, {
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $733aa530fb88758c$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $733aa530fb88758c$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $733aa530fb88758c$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $733aa530fb88758c$export$2e2bcd8739ae039 = $733aa530fb88758c$var$CustomItem;


/* link-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");




var $7832dd9a16da1710$var$_excluded = [
    "children",
    "href",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $7832dd9a16da1710$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $7832dd9a16da1710$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $7832dd9a16da1710$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $7832dd9a16da1710$var$LinkItem = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var children = props.children, href = props.href, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $7832dd9a16da1710$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $23195fc9470f6fd6$export$2e2bcd8739ae039)();
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $7832dd9a16da1710$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $7832dd9a16da1710$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $7fPBF.createElement((0, $c920716421c0064d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $7832dd9a16da1710$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $7832dd9a16da1710$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $7832dd9a16da1710$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $7832dd9a16da1710$export$2e2bcd8739ae039 = $7832dd9a16da1710$var$LinkItem;



var $6b89ae5977a3bc2b$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName",
    "role"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $6b89ae5977a3bc2b$var$DropdownMenuItem = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, role = _ref.role, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $6b89ae5977a3bc2b$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var itemRef = (0, $fab79f5a132f918b$export$2e2bcd8739ae039)(!!rest['aria-haspopup']);
    var handleItemClick = (0, $7fPBF.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $733aa530fb88758c$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $e5f53ec0aebc72ba$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7832dd9a16da1710$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $e5f53ec0aebc72ba$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d43d870fe2269526$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $e5f53ec0aebc72ba$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
});
var $6b89ae5977a3bc2b$export$2e2bcd8739ae039 = $6b89ae5977a3bc2b$var$DropdownMenuItem;


var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

/* section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $6Lozc = parcelRequire("6Lozc");
/* heading-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $6Lozc = parcelRequire("6Lozc");/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $272fe9d1205ac0e3$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}



var $f6a6a058efc17278$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "className"
];
var $f6a6a058efc17278$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $f6a6a058efc17278$var$HeadingItem = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $f6a6a058efc17278$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $6Lozc.default)([
            "_11c81vhk _1rjcze3t _18zrpxbi _syaz1vvm",
            UNSAFE_className
        ])
    }, rest, {
        style: {
            "--_bbz764": (0, $272fe9d1205ac0e3$export$2e2bcd8739ae039)("var(--ds-text-subtle, ".concat((0, $094b2769b1e0f195$export$e2ef2124cf4024b1), ")"))
        }
    }), children);
});
var $f6a6a058efc17278$export$2e2bcd8739ae039 = $f6a6a058efc17278$var$HeadingItem;


var $b0acc52461bf699e$var$_excluded = [
    "children",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "isSideNavSection",
    "className"
];
var $b0acc52461bf699e$var$itemHeadingTopMargin = 20;
var $b0acc52461bf699e$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $b0acc52461bf699e$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $b0acc52461bf699e$var$skeletonHeadingHeight = 8;
var $b0acc52461bf699e$var$skeletonHeadingMarginOffset = 3;
var $b0acc52461bf699e$var$skeletonHeadingTopMargin = $b0acc52461bf699e$var$itemHeadingTopMargin + ($b0acc52461bf699e$var$itemHeadingContentHeight - $b0acc52461bf699e$var$skeletonHeadingHeight) - $b0acc52461bf699e$var$skeletonHeadingMarginOffset;
var $b0acc52461bf699e$var$sectionPaddingTopBottom = 6;
var $b0acc52461bf699e$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm21imm",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $b0acc52461bf699e$var$Section = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, _ref$isSideNavSection = _ref.isSideNavSection, isSideNavSection = _ref$isSideNavSection === void 0 ? false : _ref$isSideNavSection, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $b0acc52461bf699e$var$_excluded);
    var content = isList ? /*#__PURE__*/ $7fPBF.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $7fPBF.Children).map((0, $7fPBF.Children).toArray(children), function(child, index) {
        return /*#__PURE__*/ $7fPBF.createElement("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), null, /*#__PURE__*/ $7fPBF.createElement((0, $f6a6a058efc17278$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true,
        className: (0, $6Lozc.default)([
            isSideNavSection && $b0acc52461bf699e$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), null, content);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6Lozc.default)([
            $b0acc52461bf699e$var$styles.root,
            isScrollable ? $b0acc52461bf699e$var$styles.scrollable : $b0acc52461bf699e$var$styles.unscrollable,
            hasSeparator ? $b0acc52461bf699e$var$styles.thinSeparator : $b0acc52461bf699e$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $b0acc52461bf699e$export$2e2bcd8739ae039 = $b0acc52461bf699e$var$Section;


/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $c916906649ee7db1$var$styles = {
    heading: "_11c81vhk _1rjcze3t _18zrpxbi _syaz1gjq"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $c916906649ee7db1$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2ecd6aa4c91a6f66$export$2e2bcd8739ae039), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $c916906649ee7db1$var$styles.heading
    }, title);
};
var $c916906649ee7db1$export$2e2bcd8739ae039 = $c916906649ee7db1$var$GroupTitle;


var $32a43cba63b7739d$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $32a43cba63b7739d$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $32a43cba63b7739d$var$_excluded);
    var uid = (0, $d625109a55dc7442$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b0acc52461bf699e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c916906649ee7db1$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children);
});
var $32a43cba63b7739d$export$2e2bcd8739ae039 = $32a43cba63b7739d$var$DropdownMenuItemGroup;


var $10928464378da1cb$exports = {};
"use strict";
Object.defineProperty($10928464378da1cb$exports, "__esModule", {
    value: true
});
$10928464378da1cb$exports.default = void 0;

var $10928464378da1cb$var$_react = $10928464378da1cb$var$_interopRequireDefault((parcelRequire("7fPBF")));

function $10928464378da1cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $10928464378da1cb$var$CheckIcon = (props)=>/*#__PURE__*/ $10928464378da1cb$var$_react.default.createElement($ab6305b9bfa57046$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props));
$10928464378da1cb$var$CheckIcon.displayName = 'CheckIcon';
var $10928464378da1cb$var$_default = $10928464378da1cb$exports.default = $10928464378da1cb$var$CheckIcon;


var $020eea4ffe14fc1b$exports = {};
"use strict";
Object.defineProperty($020eea4ffe14fc1b$exports, "__esModule", {
    value: true
});
$020eea4ffe14fc1b$exports.default = void 0;

var $020eea4ffe14fc1b$var$_react = $020eea4ffe14fc1b$var$_interopRequireDefault((parcelRequire("7fPBF")));

function $020eea4ffe14fc1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $020eea4ffe14fc1b$var$CrossIcon = (props)=>/*#__PURE__*/ $020eea4ffe14fc1b$var$_react.default.createElement($ab6305b9bfa57046$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$020eea4ffe14fc1b$var$CrossIcon.displayName = 'CrossIcon';
var $020eea4ffe14fc1b$var$_default = $020eea4ffe14fc1b$exports.default = $020eea4ffe14fc1b$var$CrossIcon;







/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



var $8MJe2 = parcelRequire("8MJe2");

/**
 * Our internal configuration for breakpoints configuration.
 *
 * We explicitly use `-0.01rem` for "max" values to both ensure we do not overlap our media queries, but also don't skip any fractional pixels.  There is a chance this is not safe in some browsers, eg. Safari has weird rounding.
 * @see: https://tzi.fr/css/prevent-double-breakpoint/
 *
 * @experimental Unsafe for direct consumption outside of the design system itself; please use our `media` export instead for media queries.
 */ var $e938e4b54d7876cd$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
var $e938e4b54d7876cd$export$2d293d9871c38e91 = Object.keys($e938e4b54d7876cd$export$e5ee4fe8b989fd09);
var $e938e4b54d7876cd$export$b7ed752a57b4177b = $e938e4b54d7876cd$export$2d293d9871c38e91[0];



function $516d1a824acbd75a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $516d1a824acbd75a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $516d1a824acbd75a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $516d1a824acbd75a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $516d1a824acbd75a$export$918f8818cfbbeb2c = function UNSAFE_buildAboveMediaQueryCSS(input) {
    return (0, $e938e4b54d7876cd$export$2d293d9871c38e91).reduce(function(acc, breakpoint) {
        return $516d1a824acbd75a$var$_objectSpread($516d1a824acbd75a$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, breakpoint, (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $8c23171a376c15ae$export$987d49ffe1b0900f).above[breakpoint], typeof input === 'function' ? input(breakpoint) : input))));
    }, {});
};
var $516d1a824acbd75a$export$b2a4e2b0c6417297 = function UNSAFE_buildBelowMediaQueryCSS(input) {
    return (0, $e938e4b54d7876cd$export$2d293d9871c38e91).reduce(function(acc, breakpoint) {
        if (breakpoint === 'xxs') return acc;
        return $516d1a824acbd75a$var$_objectSpread($516d1a824acbd75a$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, breakpoint, (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $8c23171a376c15ae$export$c881183ca713c214).below[breakpoint], typeof input === 'function' ? input(breakpoint) : input))));
    }, {});
};


var $4857edc649d32625$var$hideAboveQueries = (0, $516d1a824acbd75a$export$918f8818cfbbeb2c)({
    display: 'none'
});
var $4857edc649d32625$var$hideBelowQueries = (0, $516d1a824acbd75a$export$b2a4e2b0c6417297)({
    display: 'none'
});
var $4857edc649d32625$export$bed28288a051538 = function Hide(_ref) {
    var above = _ref.above, below = _ref.below, children = _ref.children, _ref$as = _ref.as, AsElement = _ref$as === void 0 ? 'div' : _ref$as, xcss = _ref.xcss;
    var resolvedStyles = (0, $3e5203791fd7c7fc$export$a9c84988c8f81f2d)(xcss);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(AsElement, {
        className: resolvedStyles.static,
        css: [
            above && $4857edc649d32625$var$hideAboveQueries[above],
            below && $4857edc649d32625$var$hideBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};


const $a8ecf42811a16d58$var$_19 = "._irr36fiy:hover{background-color:var(--_1w39xns)}";
const $a8ecf42811a16d58$var$_18 = "._bfhk1fns{background-color:var(--_11n6snt)}";
const $a8ecf42811a16d58$var$_17 = "._1bah1h6o{justify-content:center}";
const $a8ecf42811a16d58$var$_16 = "._1hfk13x8:after{background-color:var(--_1dobpwl)}";
const $a8ecf42811a16d58$var$_15 = "._1qdggktf:after{height:20px}";
const $a8ecf42811a16d58$var$_14 = "._z0ait94y:after{width:1px}";
const $a8ecf42811a16d58$var$_13 = "._1ywu1ule:after{display:block}";
const $a8ecf42811a16d58$var$_12 = "._aetrb3bt:after{content:\"\"}";
const $a8ecf42811a16d58$var$_11 = "._4t3igktf{height:20px}";
const $a8ecf42811a16d58$var$_10 = "._1bsbt94y{width:1px}";
const $a8ecf42811a16d58$var$_9 = "._16qs1255{box-shadow:0 2px 6px 0 var(--_a4hxpt)}";
const $a8ecf42811a16d58$var$_8 = "._bfhk13x8{background-color:var(--_1dobpwl)}";
const $a8ecf42811a16d58$var$_7 = "._1bsboza4{width:510px}";
const $a8ecf42811a16d58$var$_6 = "._4cvr1h6o{align-items:center}";
const $a8ecf42811a16d58$var$_5 = "._1bah1b1v{justify-content:space-around}";
const $a8ecf42811a16d58$var$_4 = "._1e0c1txw{display:flex}";
const $a8ecf42811a16d58$var$_3 = "._2rko1l7b{border-radius:3px}";
const $a8ecf42811a16d58$var$_2 = "._1yt41ul9{padding:var(--_18cq338)}";
const $a8ecf42811a16d58$var$_ = "._18s8249t{margin:var(--_x2w6pa) auto}";
const $a8ecf42811a16d58$var$languageBarWrapperStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    position: 'fixed',
    top: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.800'),
    left: '0',
    width: '100%',
    textAlign: 'center',
    zIndex: 'navigation'
});
const $a8ecf42811a16d58$var$barContentStyles = null;
const $a8ecf42811a16d58$var$contentDelimiterStyles = null;
const $a8ecf42811a16d58$var$closeButtonStyles = null;
const $a8ecf42811a16d58$var$LanguageBar = ()=>{
    const [show, setShow] = (0, $7fPBF.useState)(true);
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const proposedLanguage = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$66e9475a9fd6dfbe));
    const currentLanguage = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$20b36ebcfeb0a091));
    const supportedLanguages = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$454c8e352dec47e6));
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const selectLanguageHandler = (0, $7fPBF.useCallback)((language)=>()=>{
            dispatch((0, $cc45bcc51bf95f36$export$fa43c961ec463ef0)(language));
            setShow(false);
        }, [
        dispatch
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (proposedLanguage == null) setShow(true);
    }, [
        proposedLanguage
    ]);
    if (proposedLanguage == null || !show) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4857edc649d32625$export$bed28288a051538), {
        below: "sm",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
            as: "div",
            testId: "language-bar-wrapper",
            xcss: $a8ecf42811a16d58$var$languageBarWrapperStyles,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                        children: [
                            $a8ecf42811a16d58$var$_,
                            $a8ecf42811a16d58$var$_2,
                            $a8ecf42811a16d58$var$_3,
                            $a8ecf42811a16d58$var$_4,
                            $a8ecf42811a16d58$var$_5,
                            $a8ecf42811a16d58$var$_6,
                            $a8ecf42811a16d58$var$_7,
                            $a8ecf42811a16d58$var$_8,
                            $a8ecf42811a16d58$var$_9
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                            "_18s8249t _1yt41ul9 _2rko1l7b _1e0c1txw _1bah1b1v _4cvr1h6o _1bsboza4 _bfhk13x8 _16qs1255"
                        ]),
                        style: {
                            "--_x2w6pa": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.050')),
                            "--_18cq338": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.100')),
                            "--_1dobpwl": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.inverse')),
                            "--_a4hxpt": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.background.accent.gray.subtler'))
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d1cff7edaf95fc01$exports))), {
                                label: 'header-world-icon',
                                primaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.accent.gray'),
                                secondaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.accent.gray'),
                                size: 'large'
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                                appearance: 'link',
                                onClick: selectLanguageHandler(proposedLanguage),
                                testId: "proposed-language-bar-button",
                                children: translate((0, $447ba15143f7eed7$exports).PROPOSED_LANGUAGE_MESSAGE, {
                                    language: supportedLanguages[proposedLanguage]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                                        children: [
                                            $a8ecf42811a16d58$var$_10,
                                            $a8ecf42811a16d58$var$_11,
                                            $a8ecf42811a16d58$var$_12,
                                            $a8ecf42811a16d58$var$_13,
                                            $a8ecf42811a16d58$var$_14,
                                            $a8ecf42811a16d58$var$_15,
                                            $a8ecf42811a16d58$var$_16
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                                            "_1bsbt94y _4t3igktf _aetrb3bt _1ywu1ule _z0ait94y _1qdggktf _1hfk13x8"
                                        ]),
                                        style: {
                                            "--_1dobpwl": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.inverse'))
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a675d37d7e8f2ee4$export$2e2bcd8739ae039), {
                                    testId: "language-bar-dropdown",
                                    trigger: translate((0, $447ba15143f7eed7$exports).ALL_LANGUAGES_MESSAGE),
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32a43cba63b7739d$export$2e2bcd8739ae039), {
                                        children: Object.keys(supportedLanguages).map((language)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b89ae5977a3bc2b$export$2e2bcd8739ae039), {
                                                elemBefore: language === currentLanguage ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($10928464378da1cb$exports))), {
                                                    label: 'check-icon',
                                                    size: 'small'
                                                }) : undefined,
                                                onClick: selectLanguageHandler(language),
                                                title: `language-bar-dropdown-item-${language}`,
                                                children: supportedLanguages[language]
                                            }, language))
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                                        children: [
                                            $a8ecf42811a16d58$var$_3,
                                            $a8ecf42811a16d58$var$_4,
                                            $a8ecf42811a16d58$var$_17,
                                            $a8ecf42811a16d58$var$_6,
                                            $a8ecf42811a16d58$var$_18,
                                            $a8ecf42811a16d58$var$_19
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        onClick: ()=>setShow(false),
                                        "data-testid": "language-bar-close-button",
                                        className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                                            "_2rko1l7b _1e0c1txw _1bah1h6o _4cvr1h6o _bfhk1fns _irr36fiy"
                                        ]),
                                        style: {
                                            "--_11n6snt": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.background.neutral.subtle')),
                                            "--_1w39xns": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.background.neutral.subtle.hovered'))
                                        },
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($020eea4ffe14fc1b$exports))), {
                                            size: "medium",
                                            label: 'message-close-icon',
                                            primaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.accent.gray'),
                                            secondaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.accent.gray')
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $a8ecf42811a16d58$export$2e2bcd8739ae039 = $a8ecf42811a16d58$var$LanguageBar;





parcelRequire("7fPBF");
var $782188f667f9d0f5$exports = {};
"use strict";
Object.defineProperty($782188f667f9d0f5$exports, "__esModule", {
    value: true
});
$782188f667f9d0f5$exports.default = void 0;

var $782188f667f9d0f5$var$_react = $782188f667f9d0f5$var$_interopRequireDefault((parcelRequire("7fPBF")));

function $782188f667f9d0f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $782188f667f9d0f5$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $782188f667f9d0f5$var$_react.default.createElement($ab6305b9bfa57046$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$782188f667f9d0f5$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $782188f667f9d0f5$var$_default = $782188f667f9d0f5$exports.default = $782188f667f9d0f5$var$CheckCircleIcon;


var $8ad5e43bebed238e$exports = {};
"use strict";
Object.defineProperty($8ad5e43bebed238e$exports, "__esModule", {
    value: true
});
$8ad5e43bebed238e$exports.default = void 0;

var $8ad5e43bebed238e$var$_react = $8ad5e43bebed238e$var$_interopRequireDefault((parcelRequire("7fPBF")));

function $8ad5e43bebed238e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8ad5e43bebed238e$var$ErrorIcon = (props)=>/*#__PURE__*/ $8ad5e43bebed238e$var$_react.default.createElement($ab6305b9bfa57046$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$8ad5e43bebed238e$var$ErrorIcon.displayName = 'ErrorIcon';
var $8ad5e43bebed238e$var$_default = $8ad5e43bebed238e$exports.default = $8ad5e43bebed238e$var$ErrorIcon;





var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

/**
 * An empty function which does nothing.
 */ function $52f470cb635d3d64$export$2e2bcd8739ae039() {}


/* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $heZxp = parcelRequire("heZxp");/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $4059c65560b999b3$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}




/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $353cb8d07893398b$var$ATOMIC_GROUP_LENGTH = 5;
function $353cb8d07893398b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $353cb8d07893398b$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $8MJe2 = parcelRequire("8MJe2");

var $736fbd9eff2a6168$export$4ef52930e33717cd = 'data-theme';
var $736fbd9eff2a6168$export$a00eac3f8684bcd0 = 'data-color-mode';
var $736fbd9eff2a6168$export$2112803007239c61 = 'data-contrast-mode';
var $736fbd9eff2a6168$export$352e418ed5b6193a = 'data-custom-theme';
var $736fbd9eff2a6168$export$6f0c6fb8c80fcc92 = 'ds';
var $736fbd9eff2a6168$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $736fbd9eff2a6168$export$dddac1532e822863 = "--".concat($736fbd9eff2a6168$export$6f0c6fb8c80fcc92, "-token-not-found");
var $736fbd9eff2a6168$export$9d7b58831ae93caa = "--".concat($736fbd9eff2a6168$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $3b15dd48580ded12$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b15dd48580ded12$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b15dd48580ded12$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b15dd48580ded12$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b15dd48580ded12$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $3b15dd48580ded12$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $3b15dd48580ded12$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $3b15dd48580ded12$export$632685d741f3dbbf = $3b15dd48580ded12$var$_objectSpread($3b15dd48580ded12$var$_objectSpread({}, $3b15dd48580ded12$export$958d0ae7f2977ae4), $3b15dd48580ded12$export$d2dc61f58390201c);
var $3b15dd48580ded12$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $3b15dd48580ded12$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $3b15dd48580ded12$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $3b15dd48580ded12$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $3b15dd48580ded12$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $3b15dd48580ded12$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $3b15dd48580ded12$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $3b15dd48580ded12$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $3b15dd48580ded12$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $3b15dd48580ded12$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $3b15dd48580ded12$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $3b15dd48580ded12$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $3b15dd48580ded12$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $3b15dd48580ded12$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $3b15dd48580ded12$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $3b15dd48580ded12$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $3b15dd48580ded12$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $3b15dd48580ded12$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $3b15dd48580ded12$export$e615f061ca585a6c = $3b15dd48580ded12$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $3b15dd48580ded12$export$ca0f9c2de39ffed7(spacingProperty, $3b15dd48580ded12$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $3b15dd48580ded12$export$bf46c3f9eeafc71f = $3b15dd48580ded12$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $3b15dd48580ded12$export$ca0f9c2de39ffed7(spacingProperty, $3b15dd48580ded12$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $3b15dd48580ded12$export$e7af83bafe7f9e63 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('backgroundColor', $3b15dd48580ded12$export$d1d79bf68ac056bd);
var $3b15dd48580ded12$export$3a1bcba60b23d7f0 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('color', $3b15dd48580ded12$export$8473307aa00d6ea1);
var $3b15dd48580ded12$export$45f3f4fe16f9f7d5 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('fontWeight', $3b15dd48580ded12$export$303e322c6b1ed114);
var $3b15dd48580ded12$export$68cc305da27dbaa4 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('fontFamily', $3b15dd48580ded12$export$3c7e9587132614b4);
var $3b15dd48580ded12$export$128f10c238242f83 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('font', $3b15dd48580ded12$export$6ffa317d5e70375);
var $3b15dd48580ded12$export$219d364c0da35ae4 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('font', $3b15dd48580ded12$export$236bfe3a33ef1292);
var $3b15dd48580ded12$export$38845ca010b93505 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('fontWeight', $3b15dd48580ded12$export$855cfd311192d666);
var $3b15dd48580ded12$export$ff257d957d48c421 = $3b15dd48580ded12$export$ca0f9c2de39ffed7((0, $736fbd9eff2a6168$export$9d7b58831ae93caa), $3b15dd48580ded12$export$41a358c9c2356760);
var $3b15dd48580ded12$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $3b15dd48580ded12$export$41a358c9c2356760[color] !== undefined;
};



var $7fPBF = parcelRequire("7fPBF");
var $4968213a33496c33$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $4968213a33496c33$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($4968213a33496c33$export$1ca2a26fecb070ae);
};
$4968213a33496c33$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';



var $7fPBF = parcelRequire("7fPBF");
// Allows support for heading levels 1-9 via aria-level
var $0a2b27cebf08410d$var$HeadingLevelContext = /*#__PURE__*/ (0, $7fPBF.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $0a2b27cebf08410d$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $7fPBF.useContext)($0a2b27cebf08410d$var$HeadingLevelContext);
};
var $0a2b27cebf08410d$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $0a2b27cebf08410d$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $0a2b27cebf08410d$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $0a2b27cebf08410d$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($0a2b27cebf08410d$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $0a2b27cebf08410d$export$2e2bcd8739ae039 = $0a2b27cebf08410d$var$HeadingLevelContextProvider;


var $efe9521807dea491$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
var $efe9521807dea491$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var $efe9521807dea491$var$headingColorStylesMap = {
    'color.text': "_syaz1fxt",
    'color.text.inverse': "_syaz15cr",
    'color.text.warning.inverse': "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $efe9521807dea491$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ var $efe9521807dea491$var$useColor = function useColor(colorProp) {
    var surface = (0, $4968213a33496c33$export$1aeb4f6b93c4540d)();
    if (colorProp) return colorProp;
    if ((0, $3b15dd48580ded12$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $3b15dd48580ded12$export$2185ce37f9bdd963)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $efe9521807dea491$var$Heading = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    var _useHeading = (0, $0a2b27cebf08410d$export$97a37b1befbbf9b1)($efe9521807dea491$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $efe9521807dea491$var$useColor(colorProp);
    return /*#__PURE__*/ $7fPBF.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $353cb8d07893398b$export$2e2bcd8739ae039)([
            $efe9521807dea491$var$styles.reset,
            size && $efe9521807dea491$var$headingSizeStylesMap[size],
            $efe9521807dea491$var$headingColorStylesMap[color]
        ])
    }, children);
});
var $efe9521807dea491$export$2e2bcd8739ae039 = $efe9521807dea491$var$Heading;



var $137Lh = parcelRequire("137Lh");
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");



var $5b763611458a249e$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $5b763611458a249e$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $5b763611458a249e$var$Stack = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $5b763611458a249e$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement((0, $48b35d6b88777ae0$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)(grow === 'hug' && $5b763611458a249e$var$styles.hug, grow === 'fill' && $5b763611458a249e$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$5b763611458a249e$var$Stack.displayName = 'Stack';
var $5b763611458a249e$export$2e2bcd8739ae039 = $5b763611458a249e$var$Stack;



var $94c19706695d9a55$export$d6830277b06edd6 = 'normal';


/* flag-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

var $heZxp = parcelRequire("heZxp");

var $cvBp9 = parcelRequire("cvBp9");

var $iKdEz = parcelRequire("iKdEz");

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

function $17284fc89b8fb309$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $17284fc89b8fb309$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $17284fc89b8fb309$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}



var $8MJe2 = parcelRequire("8MJe2");


function $148be58b0a5259f9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $148be58b0a5259f9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $148be58b0a5259f9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $148be58b0a5259f9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $148be58b0a5259f9$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $148be58b0a5259f9$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'light' : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $105297376983f077$export$955358618f994a11)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    var selector = $148be58b0a5259f9$var$stateToSelectorMap[state];
    if (selector) result = $148be58b0a5259f9$var$_objectSpread($148be58b0a5259f9$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $148be58b0a5259f9$var$_objectSpread($148be58b0a5259f9$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $148be58b0a5259f9$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $148be58b0a5259f9$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $148be58b0a5259f9$var$Theme = (0, $d9d3aa9f0354c727$export$25d302a5b900a763)(function(themeProps) {
    return {
        buttonStyles: $148be58b0a5259f9$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$148be58b0a5259f9$export$2e2bcd8739ae039 = $148be58b0a5259f9$var$Theme;


var $b6738ae824ea86e7$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $b6738ae824ea86e7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b6738ae824ea86e7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b6738ae824ea86e7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b6738ae824ea86e7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b6738ae824ea86e7$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
var $b6738ae824ea86e7$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $b6738ae824ea86e7$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $148be58b0a5259f9$export$437a7f77d13d7916) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $b6738ae824ea86e7$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $b6738ae824ea86e7$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $7fPBF.useState)($b6738ae824ea86e7$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $148be58b0a5259f9$export$2e2bcd8739ae039).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8e3d3e3ac4379509$export$2e2bcd8739ae039).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $148be58b0a5259f9$export$2e2bcd8739ae039).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
            mode: mode,
            state: $b6738ae824ea86e7$var$getInteractionState($b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $d988f83806b6fe3b$export$2e2bcd8739ae039)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3a147e18a4e384a4$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $17284fc89b8fb309$export$2e2bcd8739ae039), restProps) : null,
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $148be58b0a5259f9$export$643db0b8d8778e)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$b6738ae824ea86e7$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $b6738ae824ea86e7$export$2e2bcd8739ae039 = $b6738ae824ea86e7$var$CustomThemeButton;



var $137Lh = parcelRequire("137Lh");



var $7fPBF = parcelRequire("7fPBF");
var $ba560ce620634f46$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8687bcf05df783ceffe46d3fd0178463>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($ba560ce620634f46$exports, "__esModule", {
    value: true
});
$ba560ce620634f46$exports.default = void 0;

var $ba560ce620634f46$var$_react = $ba560ce620634f46$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $ba560ce620634f46$var$_statusError = $ba560ce620634f46$var$_interopRequireDefault((parcelRequire("264Or")));

var $ba560ce620634f46$var$_error = $ba560ce620634f46$var$_interopRequireDefault((parcelRequire("2cGKh")));
function $ba560ce620634f46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba560ce620634f46$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $ba560ce620634f46$var$_react.default.createElement($ba560ce620634f46$var$_statusError.default, Object.assign({
        LEGACY_fallbackIcon: $ba560ce620634f46$var$_error.default
    }, props));
$ba560ce620634f46$var$StatusErrorIcon.Name = 'StatusErrorIconMigration';
var $ba560ce620634f46$var$_default = $ba560ce620634f46$exports.default = $ba560ce620634f46$var$StatusErrorIcon;


var $1d5e097acb565049$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e3974ad0608437b58ea5a455fd9f640>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($1d5e097acb565049$exports, "__esModule", {
    value: true
});
$1d5e097acb565049$exports.default = void 0;

var $1d5e097acb565049$var$_react = $1d5e097acb565049$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $1d5e097acb565049$var$_statusInformation = $1d5e097acb565049$var$_interopRequireDefault((parcelRequire("luGLu")));

var $1d5e097acb565049$var$_info = $1d5e097acb565049$var$_interopRequireDefault((parcelRequire("hPfJq")));
function $1d5e097acb565049$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1d5e097acb565049$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $1d5e097acb565049$var$_react.default.createElement($1d5e097acb565049$var$_statusInformation.default, Object.assign({
        LEGACY_fallbackIcon: $1d5e097acb565049$var$_info.default
    }, props));
$1d5e097acb565049$var$StatusInformationIcon.Name = 'StatusInformationIconMigration';
var $1d5e097acb565049$var$_default = $1d5e097acb565049$exports.default = $1d5e097acb565049$var$StatusInformationIcon;


var $1bc9e99765e40e90$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79d87fd54ca549401aa2a870cdd2f3b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($1bc9e99765e40e90$exports, "__esModule", {
    value: true
});
$1bc9e99765e40e90$exports.default = void 0;

var $1bc9e99765e40e90$var$_react = $1bc9e99765e40e90$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $1bc9e99765e40e90$var$_statusSuccess = $1bc9e99765e40e90$var$_interopRequireDefault((parcelRequire("8tDnM")));

var $1bc9e99765e40e90$var$_checkCircle = $1bc9e99765e40e90$var$_interopRequireDefault((parcelRequire("7hr2m")));
function $1bc9e99765e40e90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1bc9e99765e40e90$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $1bc9e99765e40e90$var$_react.default.createElement($1bc9e99765e40e90$var$_statusSuccess.default, Object.assign({
        LEGACY_fallbackIcon: $1bc9e99765e40e90$var$_checkCircle.default
    }, props));
$1bc9e99765e40e90$var$StatusSuccessIcon.Name = 'StatusSuccessIconMigration';
var $1bc9e99765e40e90$var$_default = $1bc9e99765e40e90$exports.default = $1bc9e99765e40e90$var$StatusSuccessIcon;


var $4cab42f5c0289403$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c4f87fa6bbdffcdd6698ec12cc5fa12>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($4cab42f5c0289403$exports, "__esModule", {
    value: true
});
$4cab42f5c0289403$exports.default = void 0;

var $4cab42f5c0289403$var$_react = $4cab42f5c0289403$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $4cab42f5c0289403$var$_statusWarning = $4cab42f5c0289403$var$_interopRequireDefault((parcelRequire("gU0Nr")));

var $4cab42f5c0289403$var$_warning = $4cab42f5c0289403$var$_interopRequireDefault((parcelRequire("4QU9n")));
function $4cab42f5c0289403$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4cab42f5c0289403$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $4cab42f5c0289403$var$_react.default.createElement($4cab42f5c0289403$var$_statusWarning.default, Object.assign({
        LEGACY_fallbackIcon: $4cab42f5c0289403$var$_warning.default
    }, props));
$4cab42f5c0289403$var$StatusWarningIcon.Name = 'StatusWarningIconMigration';
var $4cab42f5c0289403$var$_default = $4cab42f5c0289403$exports.default = $4cab42f5c0289403$var$StatusWarningIcon;


// Reds
var $1e59b99ff7ac2bd1$export$4b84fd0e2c617bd = '#FFEBE6';
var $1e59b99ff7ac2bd1$export$b34b069eff244586 = '#FFBDAD';
var $1e59b99ff7ac2bd1$export$be802dd0d8b57f35 = '#FF8F73';
var $1e59b99ff7ac2bd1$export$60847d42f9da92a6 = '#FF7452';
var $1e59b99ff7ac2bd1$export$4a7404f376229999 = '#FF5630';
var $1e59b99ff7ac2bd1$export$2010d0fb4295b346 = '#DE350B';
var $1e59b99ff7ac2bd1$export$2837b5a1a71d5c02 = '#BF2600';
var $1e59b99ff7ac2bd1$export$8d9596b529bbb9cf = '#FFFAE6';
var $1e59b99ff7ac2bd1$export$41060a744ab0b7ae = '#FFF0B3';
var $1e59b99ff7ac2bd1$export$1cc05bbbf340e559 = '#FFE380';
var $1e59b99ff7ac2bd1$export$5aae31392d72caaa = '#FFC400';
var $1e59b99ff7ac2bd1$export$c6930421db9fa514 = '#FFAB00';
var $1e59b99ff7ac2bd1$export$59619663aa6500fb = '#FF991F';
var $1e59b99ff7ac2bd1$export$874739ea9e379ab6 = '#FF8B00';
var $1e59b99ff7ac2bd1$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1e59b99ff7ac2bd1$export$69a3bf21b9686c2b = '#ABF5D1';
var $1e59b99ff7ac2bd1$export$afbce1382ec95f73 = '#79F2C0';
var $1e59b99ff7ac2bd1$export$747d86715d4175de = '#57D9A3';
var $1e59b99ff7ac2bd1$export$940e1f69e873f202 = '#36B37E';
var $1e59b99ff7ac2bd1$export$a49394138f7b8e85 = '#00875A';
var $1e59b99ff7ac2bd1$export$6fa04827ac68a4fb = '#006644';
var $1e59b99ff7ac2bd1$export$226de0355ed012f8 = '#DEEBFF';
var $1e59b99ff7ac2bd1$export$8c13c2ee36917869 = '#B3D4FF';
var $1e59b99ff7ac2bd1$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1e59b99ff7ac2bd1$export$215b7063051591f1 = '#2684FF';
var $1e59b99ff7ac2bd1$export$e62e8919cca44969 = '#0065FF';
var $1e59b99ff7ac2bd1$export$b3de0ae08da2ce64 = '#0052CC';
var $1e59b99ff7ac2bd1$export$a6ee3d71bc067634 = '#0747A6';
var $1e59b99ff7ac2bd1$export$67f15409e87642a1 = '#669DF1';
var $1e59b99ff7ac2bd1$export$f0539dbc42dbb067 = '#8FB8F6';
var $1e59b99ff7ac2bd1$export$363e4475840015bb = '#EAE6FF';
var $1e59b99ff7ac2bd1$export$4b0a4417ed59760f = '#C0B6F2';
var $1e59b99ff7ac2bd1$export$6011520a64d9a187 = '#998DD9';
var $1e59b99ff7ac2bd1$export$a7175d4e9206bc80 = '#8777D9';
var $1e59b99ff7ac2bd1$export$b48405b95304b5a1 = '#6554C0';
var $1e59b99ff7ac2bd1$export$c71e4279dd54a18d = '#5243AA';
var $1e59b99ff7ac2bd1$export$147899de772240ec = '#403294';
var $1e59b99ff7ac2bd1$export$2cf711fe14c66f06 = '#E6FCFF';
var $1e59b99ff7ac2bd1$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1e59b99ff7ac2bd1$export$776c9c497ef08533 = '#79E2F2';
var $1e59b99ff7ac2bd1$export$69cb3ca10c1e330e = '#00C7E6';
var $1e59b99ff7ac2bd1$export$9dc1ef0f3f48059b = '#00B8D9';
var $1e59b99ff7ac2bd1$export$7c835c78b6fcdef8 = '#00A3BF';
var $1e59b99ff7ac2bd1$export$6036577f95c3877e = '#008DA6';
var $1e59b99ff7ac2bd1$export$29a4f05edc054374 = '#FFFFFF';
var $1e59b99ff7ac2bd1$export$e655ef011c4aa1a2 = '#FAFBFC';
var $1e59b99ff7ac2bd1$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1e59b99ff7ac2bd1$export$3e51e8f1440314ba = '#EBECF0';
var $1e59b99ff7ac2bd1$export$1ce2d1575d444ceb = '#DFE1E6';
var $1e59b99ff7ac2bd1$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1e59b99ff7ac2bd1$export$c2e91cbeada39b8b = '#B3BAC5';
var $1e59b99ff7ac2bd1$export$5f71e19f3a7ad9de = '#A5ADBA';
var $1e59b99ff7ac2bd1$export$eaa8c8a70ac22806 = '#97A0AF';
var $1e59b99ff7ac2bd1$export$7c87d337fb91a97d = '#8993A4';
var $1e59b99ff7ac2bd1$export$d6447c357493214f = '#7A869A';
var $1e59b99ff7ac2bd1$export$f563ee71e9ee74cd = '#6B778C';
var $1e59b99ff7ac2bd1$export$e2ef2124cf4024b1 = '#5E6C84';
var $1e59b99ff7ac2bd1$export$eece5f492e429f08 = '#505F79';
var $1e59b99ff7ac2bd1$export$c39c0fe0f26207ae = '#42526E';
var $1e59b99ff7ac2bd1$export$7090862dc3038a9f = '#344563';
var $1e59b99ff7ac2bd1$export$ad0bacf983b7ddaa = '#253858';
var $1e59b99ff7ac2bd1$export$7d61b15e0da132af = '#172B4D';
var $1e59b99ff7ac2bd1$export$fbda843f0a27fe96 = '#091E42';
var $1e59b99ff7ac2bd1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $1e59b99ff7ac2bd1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $1e59b99ff7ac2bd1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $1e59b99ff7ac2bd1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $1e59b99ff7ac2bd1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $1e59b99ff7ac2bd1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $1e59b99ff7ac2bd1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $1e59b99ff7ac2bd1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $1e59b99ff7ac2bd1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $1e59b99ff7ac2bd1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $1e59b99ff7ac2bd1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $1e59b99ff7ac2bd1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $1e59b99ff7ac2bd1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $1e59b99ff7ac2bd1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $1e59b99ff7ac2bd1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $1e59b99ff7ac2bd1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $1e59b99ff7ac2bd1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $1e59b99ff7ac2bd1$export$2f6319cf7d736c2a = '#E6EDFA';
var $1e59b99ff7ac2bd1$export$95126bc8884d6634 = '#DCE5F5';
var $1e59b99ff7ac2bd1$export$8338d8c35d44ff1 = '#CED9EB';
var $1e59b99ff7ac2bd1$export$5368d76ae4fbbda7 = '#B8C7E0';
var $1e59b99ff7ac2bd1$export$9f0a771d16ec8d36 = '#ABBBD6';
var $1e59b99ff7ac2bd1$export$abcf8c38338b4aa5 = '#9FB0CC';
var $1e59b99ff7ac2bd1$export$97e81faa16a182c7 = '#8C9CB8';
var $1e59b99ff7ac2bd1$export$bfe21c59123ecf33 = '#7988A3';
var $1e59b99ff7ac2bd1$export$ee82aa2ea6a1558 = '#67758F';
var $1e59b99ff7ac2bd1$export$682927c6ed76be02 = '#56637A';
var $1e59b99ff7ac2bd1$export$91fd9994c5be9757 = '#455166';
var $1e59b99ff7ac2bd1$export$d281fbfe3cff2df6 = '#3B475C';
var $1e59b99ff7ac2bd1$export$3902c91d8b98a753 = '#313D52';
var $1e59b99ff7ac2bd1$export$8e8133c1ba5845b5 = '#283447';
var $1e59b99ff7ac2bd1$export$33ff357f6620b39 = '#202B3D';
var $1e59b99ff7ac2bd1$export$633847cf062b69e0 = '#1B2638';
var $1e59b99ff7ac2bd1$export$9776a6e503bdbf76 = '#121A29';
var $1e59b99ff7ac2bd1$export$6c813d5160dff5db = '#0E1624';
var $1e59b99ff7ac2bd1$export$3d4f271a500072a = '#0D1424';
var $1e59b99ff7ac2bd1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $1e59b99ff7ac2bd1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $1e59b99ff7ac2bd1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $1e59b99ff7ac2bd1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $1e59b99ff7ac2bd1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $1e59b99ff7ac2bd1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $1e59b99ff7ac2bd1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $1e59b99ff7ac2bd1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $1e59b99ff7ac2bd1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $1e59b99ff7ac2bd1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $1e59b99ff7ac2bd1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $1e59b99ff7ac2bd1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $1e59b99ff7ac2bd1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $1e59b99ff7ac2bd1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $1e59b99ff7ac2bd1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $1e59b99ff7ac2bd1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $1e59b99ff7ac2bd1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $1e59b99ff7ac2bd1$export$d2adc5dedf09fced = '#292A2E';
var $1e59b99ff7ac2bd1$export$f51762073d2bb381 = '#94C748';
var $1e59b99ff7ac2bd1$export$95e26d54def96891 = '#B3DF72';


var $f75e92ad396a7ed0$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};
var $f75e92ad396a7ed0$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #626F86)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #172B4D)"
};
var $f75e92ad396a7ed0$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ba560ce620634f46$exports))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $1e59b99ff7ac2bd1$export$29a4f05edc054374), ")"),
        LEGACY_secondaryColor: "var(--ds-background-danger-bold, #C9372C)"
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1d5e097acb565049$exports))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $1e59b99ff7ac2bd1$export$29a4f05edc054374), ")"),
        LEGACY_secondaryColor: "var(--ds-background-neutral-bold, #44546F)"
    }),
    normal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1d5e097acb565049$exports))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-subtle, ".concat((0, $1e59b99ff7ac2bd1$export$c39c0fe0f26207ae), ")"),
        LEGACY_secondaryColor: "var(--ds-surface-overlay, #FFFFFF)"
    }),
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bc9e99765e40e90$exports))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $1e59b99ff7ac2bd1$export$29a4f05edc054374), ")"),
        LEGACY_secondaryColor: "var(--ds-background-success-bold, #1F845A)"
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4cab42f5c0289403$exports))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-warning-inverse, ".concat((0, $1e59b99ff7ac2bd1$export$ad0bacf983b7ddaa), ")"),
        LEGACY_secondaryColor: "var(--ds-background-warning-bold, #F5CD47)"
    })
};
var $f75e92ad396a7ed0$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};
var $f75e92ad396a7ed0$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, ".concat((0, $1e59b99ff7ac2bd1$export$29a4f05edc054374), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $1e59b99ff7ac2bd1$export$29a4f05edc054374), ")"),
    normal: "var(--ds-text, ".concat((0, $1e59b99ff7ac2bd1$export$7d61b15e0da132af), ")"),
    success: "var(--ds-text-inverse, ".concat((0, $1e59b99ff7ac2bd1$export$29a4f05edc054374), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $1e59b99ff7ac2bd1$export$ad0bacf983b7ddaa), ")")
};
var $f75e92ad396a7ed0$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $1e59b99ff7ac2bd1$export$920c0d5c49070351), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $1e59b99ff7ac2bd1$export$920c0d5c49070351), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $1e59b99ff7ac2bd1$export$920c0d5c49070351), ")")
    },
    info: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $1e59b99ff7ac2bd1$export$920c0d5c49070351), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $1e59b99ff7ac2bd1$export$920c0d5c49070351), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $1e59b99ff7ac2bd1$export$920c0d5c49070351), ")")
    },
    error: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $1e59b99ff7ac2bd1$export$920c0d5c49070351), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $1e59b99ff7ac2bd1$export$920c0d5c49070351), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $1e59b99ff7ac2bd1$export$920c0d5c49070351), ")")
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $1e59b99ff7ac2bd1$export$920c0d5c49070351), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $1e59b99ff7ac2bd1$export$920c0d5c49070351), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $1e59b99ff7ac2bd1$export$920c0d5c49070351), ")")
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};
var $f75e92ad396a7ed0$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, ".concat((0, $1e59b99ff7ac2bd1$export$29a4f05edc054374), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $1e59b99ff7ac2bd1$export$29a4f05edc054374), ")"),
    error: "var(--ds-text-inverse, ".concat((0, $1e59b99ff7ac2bd1$export$29a4f05edc054374), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $1e59b99ff7ac2bd1$export$ad0bacf983b7ddaa), ")"),
    normal: "var(--ds-link, ".concat((0, $1e59b99ff7ac2bd1$export$b3de0ae08da2ce64), ")")
};


function $3f065ac35d50ec42$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f065ac35d50ec42$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f065ac35d50ec42$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f065ac35d50ec42$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f065ac35d50ec42$var$buttonStyles = null;
var $3f065ac35d50ec42$var$fontStyles = null;
var $3f065ac35d50ec42$var$appearanceNormalButtonStyles = null;
var $3f065ac35d50ec42$var$appearanceNormalActionsContainerStyles = null;
var $3f065ac35d50ec42$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $94c19706695d9a55$export$d6830277b06edd6) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $94c19706695d9a55$export$d6830277b06edd6);
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $heZxp.default)([
            !isBold && "_1g4l107e _y8dn107e",
            (0, $137Lh.fg)('platform_ads_explicit_font_styles') && "_11c82smr"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $5f5c616ec3c653f2$export$2e2bcd8739ae039), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        return /*#__PURE__*/ $7fPBF.createElement((0, $b6738ae824ea86e7$export$2e2bcd8739ae039), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? 'default' : 'link',
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            className: (0, $heZxp.default)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk69tn6 _1wy69tn6 _b3g39tn6 _eqps9tn6 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                appearance === (0, $94c19706695d9a55$export$d6830277b06edd6) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ]),
            style: $3f065ac35d50ec42$var$_objectSpread($3f065ac35d50ec42$var$_objectSpread({}, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                '--color': (0, $f75e92ad396a7ed0$export$7bcfe3cca4dd78b6)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color': (0, $f75e92ad396a7ed0$export$81ba6b63eedb299f)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-hover': (0, $f75e92ad396a7ed0$export$81ba6b63eedb299f)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-active': (0, $f75e92ad396a7ed0$export$81ba6b63eedb299f)[appearance].active
            }), {}, {
                "--_zkfc5e": (0, $4059c65560b999b3$export$2e2bcd8739ae039)("var(--ds-space-100, 8px)".concat(" !important"))
            })
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3f065ac35d50ec42$export$2e2bcd8739ae039 = $3f065ac35d50ec42$var$FlagActions;


/* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");

var $heZxp = parcelRequire("heZxp");


var $7fPBF = parcelRequire("7fPBF");

/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $40f3b8b015f253a5$var$SlideIn = function SlideIn(_ref) {
    var children = _ref.children, enterFrom = _ref.enterFrom, exitTo = _ref.exitTo, _ref$fade = _ref.fade, fade = _ref$fade === void 0 ? 'none' : _ref$fade, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'medium' : _ref$duration, isPaused = _ref.isPaused, onFinish = _ref.onFinish, _ref$animationTimingF = _ref.animationTimingFunction, animationTimingFunction = _ref$animationTimingF === void 0 ? 'ease-out' : _ref$animationTimingF, _ref$animationTimingF2 = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF2 === void 0 ? 'ease-in' : _ref$animationTimingF2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a5b5d47be4518e83$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: "slide-in-from-".concat(enterFrom),
        exitingAnimation: "slide-out-from-".concat(exitTo || enterFrom),
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $40f3b8b015f253a5$export$2e2bcd8739ae039 = $40f3b8b015f253a5$var$SlideIn;



/* eslint-disable no-console */ var $c01d23719f915889$var$printed = {};
function $c01d23719f915889$export$2e2bcd8739ae039(message) {
    if ($c01d23719f915889$var$printed[message]) return;
    $c01d23719f915889$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $8cab29fa70bc8cb6$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $c01d23719f915889$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $8cab29fa70bc8cb6$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {}



var $c163cd89b0fadc16$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $c163cd89b0fadc16$export$c93026a968943f95 = 'light';
var $c163cd89b0fadc16$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $c163cd89b0fadc16$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $c163cd89b0fadc16$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $c163cd89b0fadc16$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $1e59b99ff7ac2bd1$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $c163cd89b0fadc16$export$6d8204c2cb2e06b8() / 4;
    (0, $8cab29fa70bc8cb6$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $c163cd89b0fadc16$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $c163cd89b0fadc16$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $c163cd89b0fadc16$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $8cab29fa70bc8cb6$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $c163cd89b0fadc16$export$ba1d834b86d72a09 = $c163cd89b0fadc16$export$a1b3edb637fb4f35;
var $c163cd89b0fadc16$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $1e59b99ff7ac2bd1$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $1e59b99ff7ac2bd1$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $1e59b99ff7ac2bd1$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $99322f445ba7cde3$export$1eee5ddc4f6d41c5 = 400;
var $99322f445ba7cde3$var$defaultFlagGroupContext = {
    onDismissed: (0, $52f470cb635d3d64$export$2e2bcd8739ae039),
    isDismissAllowed: false
};
var $99322f445ba7cde3$export$c57ba665aaa722be = /*#__PURE__*/ (0, $7fPBF.createContext)($99322f445ba7cde3$var$defaultFlagGroupContext);
function $99322f445ba7cde3$export$e91ea202abb66350() {
    return (0, $7fPBF.useContext)($99322f445ba7cde3$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $99322f445ba7cde3$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $99322f445ba7cde3$var$dismissAllowedStyles = null;
var $99322f445ba7cde3$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var $99322f445ba7cde3$var$FlagGroup = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? 'Flag notifications' : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? 'h2' : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $52f470cb635d3d64$export$2e2bcd8739ae039) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $7fPBF.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(children) === 'object' ? (0, $7fPBF.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return /*#__PURE__*/ $7fPBF.createElement((0, $40f3b8b015f253a5$export$2e2bcd8739ae039), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in"
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return /*#__PURE__*/ $7fPBF.createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $heZxp.default)([
                        $99322f445ba7cde3$var$groupStyles.root,
                        index === 0 && $99322f445ba7cde3$var$groupStyles.first,
                        index === 1 && $99322f445ba7cde3$var$groupStyles.second,
                        index >= 1 && $99322f445ba7cde3$var$groupStyles.nth,
                        index >= 2 && $99322f445ba7cde3$var$groupStyles.hidden,
                        isDismissAllowed && "_12a7luct",
                        className
                    ]),
                    ref: ref
                }, /*#__PURE__*/ $7fPBF.createElement($99322f445ba7cde3$export$c57ba665aaa722be.Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : $99322f445ba7cde3$var$defaultFlagGroupContext
                }, flag));
            });
        }) : false;
    };
    var flags = /*#__PURE__*/ $7fPBF.createElement("div", {
        id: id,
        className: (0, $heZxp.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ])
    }, hasFlags ? /*#__PURE__*/ $7fPBF.createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), null, /*#__PURE__*/ $7fPBF.createElement(LabelTag, null, label)) : null, /*#__PURE__*/ $7fPBF.createElement((0, $a1ad98f67aabe587$export$2e2bcd8739ae039), {
        appear: false
    }, renderChildren()));
    return shouldRenderToParent ? flags : /*#__PURE__*/ $7fPBF.createElement((0, $cd3bc8368572caba$export$2e2bcd8739ae039), {
        zIndex: (0, $c163cd89b0fadc16$export$7be255094ccdc533).flag()
    }, flags);
};
var $99322f445ba7cde3$export$2e2bcd8739ae039 = $99322f445ba7cde3$var$FlagGroup;



var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


var $cvBp9 = parcelRequire("cvBp9");

var $iKdEz = parcelRequire("iKdEz");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


function $bf339b74c053cf86$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bf339b74c053cf86$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bf339b74c053cf86$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bf339b74c053cf86$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bf339b74c053cf86$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8618b7ff1a86c099$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8606d3c77a5913a9$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $8606d3c77a5913a9$export$1d27a74659855e44)(fn);
    var handler = (0, $7fPBF.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $bf339b74c053cf86$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ function $873031a7bbfe1762$export$2e2bcd8739ae039() {}



var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");
/**
 * Character key codes which can be used in keyboard events.
 */ var $f4ff392f9436b71d$export$390330c10ff2b9a1 = 'ArrowUp';
var $f4ff392f9436b71d$export$a80636c6f41931fe = 'ArrowDown';
var $f4ff392f9436b71d$export$4af703091671bc = 'Home';
var $f4ff392f9436b71d$export$e2bc30913faa5db7 = 'End';
var $f4ff392f9436b71d$export$10f6869ed0a7d75b = 'Tab';
var $f4ff392f9436b71d$export$8152f929a25a0ff4 = 'Enter';
var $f4ff392f9436b71d$export$e51a3576c045c8d5 = 'Space';
var $f4ff392f9436b71d$export$2bb790b9008907b4 = 'Escape';


function $8572b60f4747f10f$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $7fPBF.useRef)(false);
    var onKeyDown = (0, $7fPBF.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $f4ff392f9436b71d$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $7fPBF.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $7fPBF.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled && (0, $137Lh.fg)('platform_only_attach_escape_handler_on_view')) return;
        return (0, $a091c25729a976b1$exports.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}



var $7fPBF = parcelRequire("7fPBF");
function $8145971a2fce910e$export$2e2bcd8739ae039(value) {
    var ref = (0, $7fPBF.useRef)(value);
    (0, $7fPBF.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}





var $137Lh = parcelRequire("137Lh");

var $j9spr = parcelRequire("j9spr");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $iKdEz = parcelRequire("iKdEz");
function $376b77374090c7b9$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $847ce031d2d8d783$var$viewportPadding = 5;
var $847ce031d2d8d783$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $847ce031d2d8d783$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $847ce031d2d8d783$var$defaultChildrenFn() {
    return null;
}
var $847ce031d2d8d783$var$defaultOffset = [
    0,
    8
];
function $847ce031d2d8d783$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $847ce031d2d8d783$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $847ce031d2d8d783$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $7fPBF.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $847ce031d2d8d783$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $376b77374090c7b9$export$6d8c2b45c99d6e3f)({
            viewportPadding: $847ce031d2d8d783$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($847ce031d2d8d783$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $7fPBF.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $00d767b55afb0685$export$badac9ada3a0bdf9), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



/* eslint-disable no-console */ var $15a51b98b6352dbd$var$printed = {};
function $15a51b98b6352dbd$export$2e2bcd8739ae039(message) {
    if ($15a51b98b6352dbd$var$printed[message]) return;
    $15a51b98b6352dbd$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $cae9eddc5f1c5357$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $15a51b98b6352dbd$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $cae9eddc5f1c5357$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {}


// Reds
var $1b120e63c9fb8d1e$export$4b84fd0e2c617bd = '#FFEBE6';
var $1b120e63c9fb8d1e$export$b34b069eff244586 = '#FFBDAD';
var $1b120e63c9fb8d1e$export$be802dd0d8b57f35 = '#FF8F73';
var $1b120e63c9fb8d1e$export$60847d42f9da92a6 = '#FF7452';
var $1b120e63c9fb8d1e$export$4a7404f376229999 = '#FF5630';
var $1b120e63c9fb8d1e$export$2010d0fb4295b346 = '#DE350B';
var $1b120e63c9fb8d1e$export$2837b5a1a71d5c02 = '#BF2600';
var $1b120e63c9fb8d1e$export$8d9596b529bbb9cf = '#FFFAE6';
var $1b120e63c9fb8d1e$export$41060a744ab0b7ae = '#FFF0B3';
var $1b120e63c9fb8d1e$export$1cc05bbbf340e559 = '#FFE380';
var $1b120e63c9fb8d1e$export$5aae31392d72caaa = '#FFC400';
var $1b120e63c9fb8d1e$export$c6930421db9fa514 = '#FFAB00';
var $1b120e63c9fb8d1e$export$59619663aa6500fb = '#FF991F';
var $1b120e63c9fb8d1e$export$874739ea9e379ab6 = '#FF8B00';
var $1b120e63c9fb8d1e$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1b120e63c9fb8d1e$export$69a3bf21b9686c2b = '#ABF5D1';
var $1b120e63c9fb8d1e$export$afbce1382ec95f73 = '#79F2C0';
var $1b120e63c9fb8d1e$export$747d86715d4175de = '#57D9A3';
var $1b120e63c9fb8d1e$export$940e1f69e873f202 = '#36B37E';
var $1b120e63c9fb8d1e$export$a49394138f7b8e85 = '#00875A';
var $1b120e63c9fb8d1e$export$6fa04827ac68a4fb = '#006644';
var $1b120e63c9fb8d1e$export$226de0355ed012f8 = '#DEEBFF';
var $1b120e63c9fb8d1e$export$8c13c2ee36917869 = '#B3D4FF';
var $1b120e63c9fb8d1e$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1b120e63c9fb8d1e$export$215b7063051591f1 = '#2684FF';
var $1b120e63c9fb8d1e$export$e62e8919cca44969 = '#0065FF';
var $1b120e63c9fb8d1e$export$b3de0ae08da2ce64 = '#0052CC';
var $1b120e63c9fb8d1e$export$a6ee3d71bc067634 = '#0747A6';
var $1b120e63c9fb8d1e$export$67f15409e87642a1 = '#669DF1';
var $1b120e63c9fb8d1e$export$f0539dbc42dbb067 = '#8FB8F6';
var $1b120e63c9fb8d1e$export$363e4475840015bb = '#EAE6FF';
var $1b120e63c9fb8d1e$export$4b0a4417ed59760f = '#C0B6F2';
var $1b120e63c9fb8d1e$export$6011520a64d9a187 = '#998DD9';
var $1b120e63c9fb8d1e$export$a7175d4e9206bc80 = '#8777D9';
var $1b120e63c9fb8d1e$export$b48405b95304b5a1 = '#6554C0';
var $1b120e63c9fb8d1e$export$c71e4279dd54a18d = '#5243AA';
var $1b120e63c9fb8d1e$export$147899de772240ec = '#403294';
var $1b120e63c9fb8d1e$export$2cf711fe14c66f06 = '#E6FCFF';
var $1b120e63c9fb8d1e$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1b120e63c9fb8d1e$export$776c9c497ef08533 = '#79E2F2';
var $1b120e63c9fb8d1e$export$69cb3ca10c1e330e = '#00C7E6';
var $1b120e63c9fb8d1e$export$9dc1ef0f3f48059b = '#00B8D9';
var $1b120e63c9fb8d1e$export$7c835c78b6fcdef8 = '#00A3BF';
var $1b120e63c9fb8d1e$export$6036577f95c3877e = '#008DA6';
var $1b120e63c9fb8d1e$export$29a4f05edc054374 = '#FFFFFF';
var $1b120e63c9fb8d1e$export$e655ef011c4aa1a2 = '#FAFBFC';
var $1b120e63c9fb8d1e$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1b120e63c9fb8d1e$export$3e51e8f1440314ba = '#EBECF0';
var $1b120e63c9fb8d1e$export$1ce2d1575d444ceb = '#DFE1E6';
var $1b120e63c9fb8d1e$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1b120e63c9fb8d1e$export$c2e91cbeada39b8b = '#B3BAC5';
var $1b120e63c9fb8d1e$export$5f71e19f3a7ad9de = '#A5ADBA';
var $1b120e63c9fb8d1e$export$eaa8c8a70ac22806 = '#97A0AF';
var $1b120e63c9fb8d1e$export$7c87d337fb91a97d = '#8993A4';
var $1b120e63c9fb8d1e$export$d6447c357493214f = '#7A869A';
var $1b120e63c9fb8d1e$export$f563ee71e9ee74cd = '#6B778C';
var $1b120e63c9fb8d1e$export$e2ef2124cf4024b1 = '#5E6C84';
var $1b120e63c9fb8d1e$export$eece5f492e429f08 = '#505F79';
var $1b120e63c9fb8d1e$export$c39c0fe0f26207ae = '#42526E';
var $1b120e63c9fb8d1e$export$7090862dc3038a9f = '#344563';
var $1b120e63c9fb8d1e$export$ad0bacf983b7ddaa = '#253858';
var $1b120e63c9fb8d1e$export$7d61b15e0da132af = '#172B4D';
var $1b120e63c9fb8d1e$export$fbda843f0a27fe96 = '#091E42';
var $1b120e63c9fb8d1e$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $1b120e63c9fb8d1e$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $1b120e63c9fb8d1e$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $1b120e63c9fb8d1e$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $1b120e63c9fb8d1e$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $1b120e63c9fb8d1e$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $1b120e63c9fb8d1e$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $1b120e63c9fb8d1e$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $1b120e63c9fb8d1e$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $1b120e63c9fb8d1e$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $1b120e63c9fb8d1e$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $1b120e63c9fb8d1e$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $1b120e63c9fb8d1e$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $1b120e63c9fb8d1e$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $1b120e63c9fb8d1e$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $1b120e63c9fb8d1e$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $1b120e63c9fb8d1e$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $1b120e63c9fb8d1e$export$2f6319cf7d736c2a = '#E6EDFA';
var $1b120e63c9fb8d1e$export$95126bc8884d6634 = '#DCE5F5';
var $1b120e63c9fb8d1e$export$8338d8c35d44ff1 = '#CED9EB';
var $1b120e63c9fb8d1e$export$5368d76ae4fbbda7 = '#B8C7E0';
var $1b120e63c9fb8d1e$export$9f0a771d16ec8d36 = '#ABBBD6';
var $1b120e63c9fb8d1e$export$abcf8c38338b4aa5 = '#9FB0CC';
var $1b120e63c9fb8d1e$export$97e81faa16a182c7 = '#8C9CB8';
var $1b120e63c9fb8d1e$export$bfe21c59123ecf33 = '#7988A3';
var $1b120e63c9fb8d1e$export$ee82aa2ea6a1558 = '#67758F';
var $1b120e63c9fb8d1e$export$682927c6ed76be02 = '#56637A';
var $1b120e63c9fb8d1e$export$91fd9994c5be9757 = '#455166';
var $1b120e63c9fb8d1e$export$d281fbfe3cff2df6 = '#3B475C';
var $1b120e63c9fb8d1e$export$3902c91d8b98a753 = '#313D52';
var $1b120e63c9fb8d1e$export$8e8133c1ba5845b5 = '#283447';
var $1b120e63c9fb8d1e$export$33ff357f6620b39 = '#202B3D';
var $1b120e63c9fb8d1e$export$633847cf062b69e0 = '#1B2638';
var $1b120e63c9fb8d1e$export$9776a6e503bdbf76 = '#121A29';
var $1b120e63c9fb8d1e$export$6c813d5160dff5db = '#0E1624';
var $1b120e63c9fb8d1e$export$3d4f271a500072a = '#0D1424';
var $1b120e63c9fb8d1e$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $1b120e63c9fb8d1e$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $1b120e63c9fb8d1e$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $1b120e63c9fb8d1e$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $1b120e63c9fb8d1e$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $1b120e63c9fb8d1e$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $1b120e63c9fb8d1e$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $1b120e63c9fb8d1e$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $1b120e63c9fb8d1e$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $1b120e63c9fb8d1e$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $1b120e63c9fb8d1e$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $1b120e63c9fb8d1e$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $1b120e63c9fb8d1e$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $1b120e63c9fb8d1e$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $1b120e63c9fb8d1e$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $1b120e63c9fb8d1e$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $1b120e63c9fb8d1e$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $1b120e63c9fb8d1e$export$d2adc5dedf09fced = '#292A2E';
var $1b120e63c9fb8d1e$export$f51762073d2bb381 = '#94C748';
var $1b120e63c9fb8d1e$export$95e26d54def96891 = '#B3DF72';


var $b2267258dd23b289$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $b2267258dd23b289$export$c93026a968943f95 = 'light';
var $b2267258dd23b289$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $b2267258dd23b289$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $b2267258dd23b289$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $b2267258dd23b289$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $1b120e63c9fb8d1e$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b2267258dd23b289$export$6d8204c2cb2e06b8() / 4;
    (0, $cae9eddc5f1c5357$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $b2267258dd23b289$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $b2267258dd23b289$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $b2267258dd23b289$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $cae9eddc5f1c5357$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $b2267258dd23b289$export$ba1d834b86d72a09 = $b2267258dd23b289$export$a1b3edb637fb4f35;
var $b2267258dd23b289$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $1b120e63c9fb8d1e$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $1b120e63c9fb8d1e$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $1b120e63c9fb8d1e$export$920c0d5c49070351), ")")
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $3cfe7b01c6f0c991$var$registrations = new Set();
var $3cfe7b01c6f0c991$var$cleanupEndEventListeners = null;
function $3cfe7b01c6f0c991$var$onDragStart() {
    if ($3cfe7b01c6f0c991$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $3cfe7b01c6f0c991$var$cleanupEndEventListeners = (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragend',
            listener: $3cfe7b01c6f0c991$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $3cfe7b01c6f0c991$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $3cfe7b01c6f0c991$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($3cfe7b01c6f0c991$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $3cfe7b01c6f0c991$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $3cfe7b01c6f0c991$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $3cfe7b01c6f0c991$var$cleanupEndEventListeners = null;
    var clone = Array.from($3cfe7b01c6f0c991$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $3cfe7b01c6f0c991$var$bindStartEvents() {
    return (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $3cfe7b01c6f0c991$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $3cfe7b01c6f0c991$var$onDragStart
        }
    ]);
}
var $3cfe7b01c6f0c991$var$cleanupStartEventListeners = null;
function $3cfe7b01c6f0c991$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$3cfe7b01c6f0c991$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $3cfe7b01c6f0c991$var$cleanupStartEventListeners = $3cfe7b01c6f0c991$var$bindStartEvents();
    $3cfe7b01c6f0c991$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $3cfe7b01c6f0c991$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $3cfe7b01c6f0c991$var$registrations.delete(registration);
        if ($3cfe7b01c6f0c991$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $3cfe7b01c6f0c991$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $3cfe7b01c6f0c991$var$cleanupStartEventListeners = null;
        }
    };
}


var $9c992e13dca77c71$var$delayId = null;
function $9c992e13dca77c71$export$eaf678f6f93f5250() {
    if ($9c992e13dca77c71$var$delayId != null) {
        window.clearTimeout($9c992e13dca77c71$var$delayId);
        $9c992e13dca77c71$var$delayId = null;
    }
}
function $9c992e13dca77c71$export$5f4d6617421d489b(fn, delay) {
    $9c992e13dca77c71$export$eaf678f6f93f5250();
    $9c992e13dca77c71$var$delayId = window.setTimeout(function() {
        $9c992e13dca77c71$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $3578842e096a878d$var$active = null;
function $3578842e096a878d$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($3578842e096a878d$var$active && $3578842e096a878d$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $9c992e13dca77c71$export$eaf678f6f93f5250)();
            $3578842e096a878d$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $9c992e13dca77c71$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $9c992e13dca77c71$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $9c992e13dca77c71$export$5f4d6617421d489b)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($3578842e096a878d$var$active && $3578842e096a878d$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($3578842e096a878d$var$active) {
            (0, $9c992e13dca77c71$export$eaf678f6f93f5250)();
            $3578842e096a878d$var$active.entry.hide({
                isImmediate: true
            });
            $3578842e096a878d$var$active.entry.done();
            $3578842e096a878d$var$active = null;
        }
        // this tooltip is now the active tooltip
        $3578842e096a878d$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $9c992e13dca77c71$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}



var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");
var $1d818456ab22a219$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $1d818456ab22a219$var$react18UseId = ($1d818456ab22a219$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId) !== null && $1d818456ab22a219$var$_React$useId !== void 0 ? $1d818456ab22a219$var$_React$useId : undefined;
function $1d818456ab22a219$export$f680877a34711e37() {
    if ($1d818456ab22a219$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) return $1d818456ab22a219$var$react18UseId();
    return "uid".concat((0, $e9144a1b4dc9c62e$export$87d05f07e65211f1)());
}
var $1d818456ab22a219$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($1d818456ab22a219$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $1d818456ab22a219$export$6ee17796e3d70de2() {
    if ($1d818456ab22a219$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) {
        var uid = $1d818456ab22a219$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $e9144a1b4dc9c62e$export$bb5ca5fba6fb4f1f)();
}


function $dc3e6a72de006682$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $1d818456ab22a219$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $bd9f8ed4bc0f1d8b$var$ATOMIC_GROUP_LENGTH = 5;
function $bd9f8ed4bc0f1d8b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $bd9f8ed4bc0f1d8b$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $f4583b5e66246824$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}



/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $c8acd05b3aa7f96b$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $c8acd05b3aa7f96b$var$TooltipPrimitive = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        role: "tooltip",
        className: (0, $bd9f8ed4bc0f1d8b$export$2e2bcd8739ae039)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$c8acd05b3aa7f96b$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $c8acd05b3aa7f96b$export$2e2bcd8739ae039 = $c8acd05b3aa7f96b$var$TooltipPrimitive;


function $b2a3cb92d05a29d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b2a3cb92d05a29d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b2a3cb92d05a29d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b2a3cb92d05a29d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b2a3cb92d05a29d0$var$baseStyles = null;
var $b2a3cb92d05a29d0$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $b2a3cb92d05a29d0$var$TooltipContainer = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $7fPBF.createElement((0, $c8acd05b3aa7f96b$export$2e2bcd8739ae039), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bd9f8ed4bc0f1d8b$export$2e2bcd8739ae039)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $b2a3cb92d05a29d0$var$_objectSpread($b2a3cb92d05a29d0$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $f4583b5e66246824$export$2e2bcd8739ae039)("var(--ds-background-neutral-bold, ".concat((0, $1b120e63c9fb8d1e$export$7d61b15e0da132af), ")")),
            "--_ywovvi": (0, $f4583b5e66246824$export$2e2bcd8739ae039)("var(--ds-text-inverse, ".concat((0, $1b120e63c9fb8d1e$export$29a4f05edc054374), ")"))
        })
    }, children);
});
$b2a3cb92d05a29d0$var$TooltipContainer.displayName = 'TooltipContainer';
var $b2a3cb92d05a29d0$export$2e2bcd8739ae039 = $b2a3cb92d05a29d0$var$TooltipContainer;


function $72f01056c02feb53$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $5645981c356a41bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5645981c356a41bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5645981c356a41bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5645981c356a41bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5645981c356a41bc$var$tooltipZIndex = (0, $b2267258dd23b289$export$7be255094ccdc533).tooltip();
var $5645981c356a41bc$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.4.0"
};
// Inverts motion direction
var $5645981c356a41bc$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $5645981c356a41bc$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $5645981c356a41bc$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $b2a3cb92d05a29d0$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $873031a7bbfe1762$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $873031a7bbfe1762$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $bf339b74c053cf86$export$1a04351537078b55)($5645981c356a41bc$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $5645981c356a41bc$var$analyticsAttributes));
    var onHideHandler = (0, $bf339b74c053cf86$export$1a04351537078b55)($5645981c356a41bc$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $5645981c356a41bc$var$analyticsAttributes));
    var apiRef = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $7fPBF.useRef)(null);
    var containerRef = (0, $7fPBF.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $7fPBF.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $8145971a2fce910e$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $8145971a2fce910e$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $8145971a2fce910e$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $8145971a2fce910e$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $8145971a2fce910e$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $7fPBF.useRef)(false);
    var start = (0, $7fPBF.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $7fPBF.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $7fPBF.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $7fPBF.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(function() {
        return (0, $3cfe7b01c6f0c991$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $7fPBF.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $3578842e096a878d$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $7fPBF.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $8572b60f4747f10f$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $7fPBF.useEffect)(function() {
        if (state === 'hide') return 0, $873031a7bbfe1762$export$2e2bcd8739ae039;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $7fPBF.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $7fPBF.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $7fPBF.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $72f01056c02feb53$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $7fPBF.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $72f01056c02feb53$export$642213d516a9b928)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $7fPBF.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $7fPBF.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible') && (0, $137Lh.fg)('platform-tooltip-focus-visible-new')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $7fPBF.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $7fPBF.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $7fPBF.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $e85233b93e6c09f0$export$469bb693f11edc7f)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === 'mouse' && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $dc3e6a72de006682$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $7fPBF.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children($5645981c356a41bc$var$_objectSpread($5645981c356a41bc$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd3bc8368572caba$export$2e2bcd8739ae039), {
        zIndex: $5645981c356a41bc$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $847ce031d2d8d783$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $5645981c356a41bc$var$invertedDirection[$5645981c356a41bc$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a1ad98f67aabe587$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a6c67c5a8158581e$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $5645981c356a41bc$var$_objectSpread($5645981c356a41bc$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $5645981c356a41bc$export$2e2bcd8739ae039 = $5645981c356a41bc$var$Tooltip;






var $729d339602a97fd3$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $729d339602a97fd3$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $729d339602a97fd3$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $729d339602a97fd3$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(unsafeRest, $729d339602a97fd3$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2f27420929ef9635$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bb87128a2cadd975$export$2e2bcd8739ae039), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e3ca56ebdfbd43d2$export$2e2bcd8739ae039), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5645981c356a41bc$export$2e2bcd8739ae039), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2f27420929ef9635$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $ced3232b1b3ee4c7$export$2e2bcd8739ae039)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bb87128a2cadd975$export$2e2bcd8739ae039), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e3ca56ebdfbd43d2$export$2e2bcd8739ae039), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), null, label)));
    });
}));
$729d339602a97fd3$var$IconButton.displayName = 'IconButton';
var $729d339602a97fd3$export$2e2bcd8739ae039 = $729d339602a97fd3$var$IconButton;


var $6860aed87331d54d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e7cd534c00fe7f264597ee666bf617f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($6860aed87331d54d$exports, "__esModule", {
    value: true
});
$6860aed87331d54d$exports.default = void 0;

var $6860aed87331d54d$var$_react = $6860aed87331d54d$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $6860aed87331d54d$var$_chevronDown = $6860aed87331d54d$var$_interopRequireDefault((parcelRequire("hu3zC")));

var $6860aed87331d54d$var$_chevronDown2 = $6860aed87331d54d$var$_interopRequireDefault((parcelRequire("8KEcT")));
function $6860aed87331d54d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6860aed87331d54d$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $6860aed87331d54d$var$_react.default.createElement($6860aed87331d54d$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $6860aed87331d54d$var$_chevronDown2.default
    }, props));
$6860aed87331d54d$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $6860aed87331d54d$var$_default = $6860aed87331d54d$exports.default = $6860aed87331d54d$var$ChevronDownIcon;


var $dac962a580d8e1c6$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e591300488a0b21b4d41dc998cb671a7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($dac962a580d8e1c6$exports, "__esModule", {
    value: true
});
$dac962a580d8e1c6$exports.default = void 0;

var $dac962a580d8e1c6$var$_react = $dac962a580d8e1c6$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $dac962a580d8e1c6$var$_chevronUp = $dac962a580d8e1c6$var$_interopRequireDefault((parcelRequire("3hgRg")));

var $dac962a580d8e1c6$var$_chevronUp2 = $dac962a580d8e1c6$var$_interopRequireDefault((parcelRequire("cJGmK")));
function $dac962a580d8e1c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dac962a580d8e1c6$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $dac962a580d8e1c6$var$_react.default.createElement($dac962a580d8e1c6$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $dac962a580d8e1c6$var$_chevronUp2.default
    }, props));
$dac962a580d8e1c6$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $dac962a580d8e1c6$var$_default = $dac962a580d8e1c6$exports.default = $dac962a580d8e1c6$var$ChevronUpIcon;


var $d58d6f1c8ace2f24$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40d49d14e43276e4147396a05e9540f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d58d6f1c8ace2f24$exports, "__esModule", {
    value: true
});
$d58d6f1c8ace2f24$exports.default = void 0;

var $d58d6f1c8ace2f24$var$_react = $d58d6f1c8ace2f24$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $d58d6f1c8ace2f24$var$_cross = $d58d6f1c8ace2f24$var$_interopRequireDefault((parcelRequire("lXchJ")));

var $d58d6f1c8ace2f24$var$_cross2 = $d58d6f1c8ace2f24$var$_interopRequireDefault((parcelRequire("emdez")));
function $d58d6f1c8ace2f24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d58d6f1c8ace2f24$var$CrossIcon = (props)=>/*#__PURE__*/ $d58d6f1c8ace2f24$var$_react.default.createElement($d58d6f1c8ace2f24$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $d58d6f1c8ace2f24$var$_cross2.default
    }, props));
$d58d6f1c8ace2f24$var$CrossIcon.Name = 'CrossIconMigration';
var $d58d6f1c8ace2f24$var$_default = $d58d6f1c8ace2f24$exports.default = $d58d6f1c8ace2f24$var$CrossIcon;



var $cb1074cf62da3033$var$DismissButtonComponent = function DismissButtonComponent(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($d58d6f1c8ace2f24$exports)));
    var buttonLabel = 'Dismiss';
    var size = 'small';
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($dac962a580d8e1c6$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($6860aed87331d54d$exports)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        size = 'medium';
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $729d339602a97fd3$export$2e2bcd8739ae039), {
        icon: function icon(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ButtonIcon, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, iconProps, {
                LEGACY_size: size,
                size: "small",
                label: "",
                color: (0, $f75e92ad396a7ed0$export$13b42cd9d596bfe0)[appearance]
            }));
        },
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
var $cb1074cf62da3033$var$DismissButton = /*#__PURE__*/ (0, $7fPBF.memo)($cb1074cf62da3033$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb1074cf62da3033$export$2e2bcd8739ae039 = $cb1074cf62da3033$var$DismissButton;

/* expander.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");



var $c11bc3509ee19ee7$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
var $c11bc3509ee19ee7$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ $7fPBF.createElement((0, $2ecd6aa4c91a6f66$export$2e2bcd8739ae039), {
        xcss: $c11bc3509ee19ee7$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ $7fPBF.createElement((0, $a1ad98f67aabe587$export$2e2bcd8739ae039), {
        appear: true
    }, isExpanded && /*#__PURE__*/ $7fPBF.createElement((0, $a6c67c5a8158581e$export$2e2bcd8739ae039), null, function(props) {
        return /*#__PURE__*/ $7fPBF.createElement((0, $2ecd6aa4c91a6f66$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
            xcss: $c11bc3509ee19ee7$var$styles.container
        }, props), /*#__PURE__*/ $7fPBF.createElement((0, $5b763611458a249e$export$2e2bcd8739ae039), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c11bc3509ee19ee7$export$2e2bcd8739ae039 = $c11bc3509ee19ee7$var$Expander;



function $374f1491cdd22e01$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $374f1491cdd22e01$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $374f1491cdd22e01$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $374f1491cdd22e01$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $374f1491cdd22e01$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkosqtm _1reo15vq _18m915vq _v564z97a _16qs8sq4 _1pbyni7l _1bsb1osq"
};
var $374f1491cdd22e01$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
var $374f1491cdd22e01$var$oldDescriptionStyles = null;
var $374f1491cdd22e01$var$descriptionStyles = null;
var $374f1491cdd22e01$var$iconWrapperStyles = null;
var $374f1491cdd22e01$var$flagWrapperStyles = null;
var $374f1491cdd22e01$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "@atlaskit/flag",
    packageVersion: "17.3.0"
};
var $374f1491cdd22e01$var$transitionStyles = null;
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $374f1491cdd22e01$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $94c19706695d9a55$export$d6830277b06edd6) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $52f470cb635d3d64$export$2e2bcd8739ae039) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $52f470cb635d3d64$export$2e2bcd8739ae039) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $52f470cb635d3d64$export$2e2bcd8739ae039) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props$headingLevel = props.headingLevel, headingLevel = _props$headingLevel === void 0 ? 2 : _props$headingLevel;
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isDelayToAnnounce = _useState2[0], setIsDelayToAnnounce = _useState2[1];
    var _useFlagGroup = (0, $99322f445ba7cde3$export$e91ea202abb66350)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $7fPBF.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState3 = (0, $7fPBF.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var onDismissedAnalytics = (0, $593ac790924c31ca$export$a4687b0234b40e28)($374f1491cdd22e01$var$_objectSpread({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext
    }, $374f1491cdd22e01$var$analyticsAttributes));
    var isBold = appearance !== (0, $94c19706695d9a55$export$d6830277b06edd6);
    var toggleExpand = (0, $7fPBF.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $7fPBF.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $7fPBF.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, $593ac790924c31ca$export$a4687b0234b40e28)($374f1491cdd22e01$var$_objectSpread({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext
    }, $374f1491cdd22e01$var$analyticsAttributes));
    var onBlurAnalytics = (0, $593ac790924c31ca$export$a4687b0234b40e28)($374f1491cdd22e01$var$_objectSpread({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext
    }, $374f1491cdd22e01$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $f75e92ad396a7ed0$export$f50075b2584087f)[appearance];
    var iconColor = (0, $f75e92ad396a7ed0$export$7f70afe2167f8235)[appearance];
    var iconGlyph = (0, $f75e92ad396a7ed0$export$73f08aee70487cd4)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ $7fPBF.createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), null, title, description) : undefined;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        role: "alert",
        "data-testid": testId
    }, autoDismissProps, {
        className: (0, $heZxp.default)([
            "_1bsb1osq"
        ])
    }), /*#__PURE__*/ $7fPBF.createElement((0, $2ecd6aa4c91a6f66$export$2e2bcd8739ae039), {
        padding: "space.200",
        backgroundColor: (0, $f75e92ad396a7ed0$export$59e42969c95d314)[appearance],
        xcss: $374f1491cdd22e01$var$styles.flag
    }, /*#__PURE__*/ $7fPBF.createElement((0, $5f5c616ec3c653f2$export$2e2bcd8739ae039), {
        alignBlock: "start",
        space: "space.200"
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        "data-testid": testId && "".concat(testId, "-icon-container"),
        className: (0, $heZxp.default)([
            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz16r9"
        ]),
        style: $374f1491cdd22e01$var$_objectSpread($374f1491cdd22e01$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $374f1491cdd22e01$var$CSS_VAR_ICON_COLOR, iconColor)), {}, {
            "--_11v68d2": (0, $4059c65560b999b3$export$2e2bcd8739ae039)("var(".concat($374f1491cdd22e01$var$CSS_VAR_ICON_COLOR, ")"))
        })
    }, icon || iconGlyph), /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $heZxp.default)([
            "_v5641hdc _16jlkb7n"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $5b763611458a249e$export$2e2bcd8739ae039), {
        space: shouldRenderGap ? 'space.100' : 'space.0' // Gap exists even when not expanded due to Expander internals always being in the DOM
    }, isDelayToAnnounce && delayedAnnouncement, /*#__PURE__*/ $7fPBF.createElement((0, $5f5c616ec3c653f2$export$2e2bcd8739ae039), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ $7fPBF.createElement((0, $2ecd6aa4c91a6f66$export$2e2bcd8739ae039), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $374f1491cdd22e01$var$styles.overflowWrap
    }, /*#__PURE__*/ $7fPBF.createElement((0, $efe9521807dea491$export$2e2bcd8739ae039), {
        as: "h".concat(headingLevel),
        size: "xsmall",
        color: textColor
    }, /*#__PURE__*/ $7fPBF.createElement("span", {
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce
    }, title))), isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ $7fPBF.createElement((0, $cb1074cf62da3033$export$2e2bcd8739ae039), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), /*#__PURE__*/ $7fPBF.createElement((0, $c11bc3509ee19ee7$export$2e2bcd8739ae039), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && /*#__PURE__*/ $7fPBF.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $f75e92ad396a7ed0$export$13b42cd9d596bfe0)[appearance]
        },
        "data-testid": testId && "".concat(testId, "-description"),
        "aria-hidden": isDelayToAnnounce,
        className: (0, $heZxp.default)([
            (0, $137Lh.fg)('platform_ads_explicit_font_styles') ? "_11c82smr _1reo1wug _18m91wug _c71l53f4 _1i4qfg65" : "_1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
        ])
    }, description), /*#__PURE__*/ $7fPBF.createElement((0, $3f065ac35d50ec42$export$2e2bcd8739ae039), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $374f1491cdd22e01$export$2e2bcd8739ae039 = $374f1491cdd22e01$var$Flag;



var $a254ace60a4a8d45$var$packageName = "@atlaskit/flag";
var $a254ace60a4a8d45$var$packageVersion = "17.3.0";
var $a254ace60a4a8d45$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ var $a254ace60a4a8d45$var$AutoDismissFlag = function AutoDismissFlag(props) {
    var id = props.id, analyticsContext = props.analyticsContext, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $52f470cb635d3d64$export$2e2bcd8739ae039) : _props$onDismissed;
    var autoDismissTimer = (0, $7fPBF.useRef)(null);
    var _useFlagGroup = (0, $99322f445ba7cde3$export$e91ea202abb66350)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $7fPBF.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var onDismissedAnalytics = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $a254ace60a4a8d45$var$packageName,
        packageVersion: $a254ace60a4a8d45$var$packageVersion
    });
    var isAutoDismissAllowed = isDismissAllowed && onDismissed;
    var dismissFlag = (0, $7fPBF.useCallback)(function() {
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    var stopAutoDismissTimer = (0, $7fPBF.useCallback)(function() {
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    var startAutoDismissTimer = (0, $7fPBF.useCallback)(function() {
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $a254ace60a4a8d45$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $7fPBF.useEffect)(function() {
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $374f1491cdd22e01$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    }));
};
var $a254ace60a4a8d45$export$2e2bcd8739ae039 = $a254ace60a4a8d45$var$AutoDismissFlag;






const $edcf2f5ac8c95255$var$fullUser = {
    email: 'v**********@atlassian.com',
    groups: {
        newsletters: {
            key: 'newsletters',
            title: 'Newsletters & Digests',
            description: 'From IT to DevOps, these emails will keep you up to date with the latest Industry trends and best practices.',
            type: (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS,
            tabs: {
                root: {
                    items: {
                        atlassianTeamPlaybook: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        industryBestPractices: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianBlog: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        jiraInsidersNewsletter: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        jiraServerNewsletter: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        jiraOps: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        confluenceInsidersNewsletter: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        gitInsidersNewsletter: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianUniversity: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        devOpsDigest: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        jiraMacApp: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianCommunity: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        developerEcosystemNewsletter: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        productSurveys: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                }
            }
        },
        product_recommendations: {
            key: 'product_recommendations',
            title: 'Product Recommendations',
            description: 'Discover how Atlassian products work better together. Sign up for useful product suggestions that boost productivity and collaboration.',
            type: (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS,
            tabs: {
                cloud: {
                    key: 'cloud',
                    title: 'Atlassian Cloud',
                    items: {
                        jiraSoftwareProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraCoreProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        confluenceProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        bitbucketProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        atlassianAccessProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianCloudAppsProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        trelloProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        trelloPowerUpsProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        statuspageProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        opsgenieProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraAlignProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        automationForJiraProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        generalProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                },
                server: {
                    key: 'server',
                    title: 'Atlassian Server / Data Center',
                    items: {
                        jiraSoftwareProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraCoreProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        confluenceProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        bitbucketProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        crowdProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        sourcetreeProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        bambooProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        fisheyeProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        crucibleProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianServerAppsProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        analyticsForConfluenceAppProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        automationForJiraProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        iconsForJiraProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                }
            }
        },
        product_upgrades: {
            key: 'product_upgrades',
            title: 'Product Upgrades',
            description: 'Upgrade your product experience. Learn about the different features available in our product tiers and deployments to make the right choice for your company.',
            type: (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS,
            tabs: {
                cloud: {
                    key: 'cloud',
                    title: 'Atlassian Cloud',
                    items: {
                        jiraSoftwareProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraCoreProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        confluenceProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        bitbucketProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        atlassianAccessProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianCloudAppsProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        trelloProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        trelloPowerUpsProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        statuspageProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        opsgenieProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraAlignProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        automationForJiraProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        generalProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                },
                server: {
                    key: 'server',
                    title: 'Atlassian Server / Data Center',
                    items: {
                        jiraSoftwareProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraCoreProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        confluenceProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        bitbucketProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        crowdProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        sourcetreeProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        bambooProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        fisheyeProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        crucibleProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianServerAppsProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        analyticsForConfluenceAppProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        automationForJiraProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        iconsForJiraProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                }
            }
        },
        tips_and_tricks: {
            key: 'tips_and_tricks',
            title: 'Tips & Tricks',
            description: 'Get the most out of your tools. Sign up to receive the latest announcements about your favorite products.',
            type: (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS,
            tabs: {
                cloud: {
                    key: 'cloud',
                    title: 'Atlassian Cloud',
                    items: {
                        jiraSoftwareProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        confluenceProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        bitbucketProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        sourcetreeProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        bambooProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        crucibleProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        atlassianServerAppsProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        automationForJiraProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        iconsForJiraProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                },
                server: {
                    key: 'server',
                    title: 'Atlassian Server / Data Center',
                    items: {
                        jiraSoftwareTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        confluenceTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        bitbucketTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        sourcetreeTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        bambooTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        crucibleTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        atlassianServerAppsTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        automationForJiraTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        iconsForJiraTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                }
            }
        },
        tech_alerts: {
            key: 'tech_alerts',
            title: 'Tech Alerts',
            description: 'Stay up-to-date on security advisories, maintenance notifications, and pricing updates that affect your account. Note: if you are a tech administrator, you will always receive these notifications.',
            type: (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS,
            tabs: {
                root: {
                    items: {
                        jiraSoftwareTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraCoreTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        hipchatTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        confluenceTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        fisheyeTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        bambooTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        crucibleTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        crowdTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        cloverTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        bitbucketTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON
                    }
                }
            }
        }
    }
};
const $edcf2f5ac8c95255$var$emptyUser = {
    email: 'e**********@atlassian.com',
    groups: {}
};
const $edcf2f5ac8c95255$var$downForMaintenance = {
    downForMaintenanceMessage: 'down_for_maintenance.message'
};
const $edcf2f5ac8c95255$var$dataStore = new Map();
$edcf2f5ac8c95255$var$dataStore.set('1', $edcf2f5ac8c95255$var$fullUser);
$edcf2f5ac8c95255$var$dataStore.set('2', $edcf2f5ac8c95255$var$emptyUser);
$edcf2f5ac8c95255$var$dataStore.set('3', $edcf2f5ac8c95255$var$downForMaintenance);
$edcf2f5ac8c95255$var$dataStore.set('4', $edcf2f5ac8c95255$var$fullUser);
const $edcf2f5ac8c95255$export$12b1f9d03b823a51 = (hid)=>{
    if (hid) return $edcf2f5ac8c95255$var$dataStore.get(hid);
};



const $e845741c6335a85b$var$parseUrlQueryString = (query)=>(0, (/*@__PURE__*/$parcel$interopDefault($3cc271bb186f0140$exports))).parse(query, {
        ignoreQueryPrefix: true,
        allowDots: true
    });
var $e845741c6335a85b$export$2e2bcd8739ae039 = $e845741c6335a85b$var$parseUrlQueryString;


const $524c694f3271f0de$var$listIdToKeyMap = {
    219880: [
        'all'
    ],
    287489: [
        'productAnnouncements'
    ],
    287490: [
        'events',
        'generalEvents',
        'summitUserConference',
        'atlasCampDeveloperConference'
    ],
    287491: [
        'tipsTricksAndBestPractices',
        'productRecommendations',
        'specialOffers',
        'marketplaceNewsletter'
    ],
    1081095: [
        'jiraTechAlerts'
    ],
    1081282: [
        'confluenceTechAlerts'
    ],
    1081343: [
        'bambooTechAlerts'
    ],
    1081388: [
        'crucibleTechAlerts'
    ],
    1081451: [
        'cloverTechAlerts'
    ],
    1081489: [
        'fisheyeTechAlerts'
    ],
    1081543: [
        'crowdTechAlerts'
    ],
    1231860: [
        'bitbucketPromotions'
    ],
    1239131: [
        'jiraInsidersNewsletter'
    ],
    1243499: [
        'developerEcosystemNewsletter'
    ],
    1246925: [
        'confluenceInsidersNewsletter'
    ],
    1267986: [
        'events',
        'generalEvents',
        'summitUserConference',
        'atlasCampDeveloperConference'
    ],
    1275007: [
        'gitInsidersNewsletter'
    ],
    1370882: [
        'productSurveys'
    ],
    1370962: [
        'jiraInsidersNewsletter'
    ],
    1370965: [
        'gitInsidersNewsletter'
    ],
    1370967: [
        'bitbucketTechAlerts'
    ],
    1370968: [
        'hipchatTechAlerts'
    ],
    1370971: [
        'jiraCoreTechAlerts'
    ],
    1370973: [
        'jiraServiceDeskTechAlerts'
    ],
    1370974: [
        'jiraSoftwareTechAlerts'
    ],
    1382366: [
        'tipsTricksAndBestPractices'
    ],
    1382367: [
        'tipsTricksAndBestPractices'
    ],
    1382368: [
        'tipsTricksAndBestPractices'
    ],
    1382369: [
        'tipsTricksAndBestPractices'
    ],
    1382370: [
        'tipsTricksAndBestPractices'
    ],
    1382371: [
        'tipsTricksAndBestPractices'
    ],
    1382372: [
        'tipsTricksAndBestPractices'
    ],
    1382373: [
        'tipsTricksAndBestPractices'
    ],
    1382374: [
        'tipsTricksAndBestPractices'
    ],
    1382375: [
        'tipsTricksAndBestPractices'
    ],
    1382376: [
        'tipsTricksAndBestPractices'
    ],
    1382377: [
        'tipsTricksAndBestPractices'
    ],
    1382378: [
        'tipsTricksAndBestPractices'
    ],
    1382379: [
        'tipsTricksAndBestPractices'
    ],
    1382380: [
        'tipsTricksAndBestPractices'
    ],
    1382381: [
        'tipsTricksAndBestPractices'
    ],
    1395680: [
        'atlassianTeamPlaybook'
    ],
    1397949: [
        'summitUserConference'
    ],
    1401671: [
        'jiraServerNewsletter'
    ],
    1402390: [
        'atlassianBlog'
    ],
    1406704: [
        'summitUserConference'
    ],
    1412633: [
        'developerEcosystemNewsletter'
    ],
    1412722: [
        'devOpsDigest'
    ],
    1412810: [
        'tipsTricksAndBestPractices'
    ],
    1413519: [
        'atlassianCommunity'
    ],
    1416115: [
        'atlassianCommunity'
    ],
    1420843: [
        'atlasCampDeveloperConference'
    ],
    1423233: [
        'tipsTricksAndBestPractices'
    ],
    1423442: [
        'generalEvents'
    ],
    1423449: [
        'atlassianTeamPlaybook'
    ],
    1423487: [
        'productRecommendations'
    ],
    1432855: [
        'jiraOps'
    ]
};
const $524c694f3271f0de$export$c3b1ee5e50dbae17 = (source, keys, listId)=>{
    if (source == null || source !== 'mc' || listId == null) return keys;
    const keysSet = keys == null ? new Set() : new Set(keys.split(','));
    const keyArray = $524c694f3271f0de$var$listIdToKeyMap[listId];
    if (keyArray != null) keyArray.forEach((keyElement)=>{
        keysSet.add(keyElement);
    });
    return Array.from(keysSet).join(',');
};




const $a87b710a60abd11e$export$a52d76f06c2d44c0 = (query)=>{
    const { hid: hid, key: key, source: source, lid: lid, subscribeKeys: subscribeKeys, jobId: jobId } = (0, $e845741c6335a85b$export$2e2bcd8739ae039)(query);
    const unsubscribeKeys = (0, $524c694f3271f0de$export$c3b1ee5e50dbae17)(source, key, Number(lid));
    const decodeSubscribeKeys = subscribeKeys === null || subscribeKeys === void 0 ? void 0 : subscribeKeys.replace('+', '').replace('%20', '');
    return {
        hid: hid,
        source: source,
        unsubscribeKeys: unsubscribeKeys,
        subscribeKeys: decodeSubscribeKeys,
        jobId: jobId
    };
};





var $e11fceb31fd1a0cb$export$e743037aea74f514 = /*#__PURE__*/ function(TriState) {
    TriState[TriState["false"] = 0] = "false";
    TriState[TriState["true"] = 1] = "true";
    TriState[TriState["busy"] = 2] = "busy";
    return TriState;
}({});


const $8bebd03d19fe43b4$export$3f0ed83b7cd726b4 = (id, description)=>{
    return {
        description: description,
        iconType: 'success',
        id: id,
        key: id,
        title: 'Success',
        isAutoDismissFlag: true
    };
};
const $8bebd03d19fe43b4$export$4be607b64c8e8c80 = (id, description)=>{
    return {
        description: description,
        iconType: 'error',
        id: id,
        key: id,
        title: 'Error',
        isAutoDismissFlag: false
    };
};


const $80022746ba8cd68a$export$67da628992e8bb92 = 'preferences';
const $80022746ba8cd68a$export$6871e08c9c3b9797 = `${$80022746ba8cd68a$export$67da628992e8bb92}/loadUser`;
const $80022746ba8cd68a$export$3ba8a56dc6b23d2b = `${$80022746ba8cd68a$export$67da628992e8bb92}/unsubscribeAll`;
const $80022746ba8cd68a$export$1a788c0d2586d018 = `${$80022746ba8cd68a$export$67da628992e8bb92}/unsubscribe`;
const $80022746ba8cd68a$export$30f55fa357ca2ae5 = `${$80022746ba8cd68a$export$67da628992e8bb92}/subscribe`;
const $80022746ba8cd68a$export$f03e0b4dc877be9a = `${$80022746ba8cd68a$export$67da628992e8bb92}/initialization`;
const $80022746ba8cd68a$export$22260131648f9419 = `${$80022746ba8cd68a$export$67da628992e8bb92}/sendItemFromUI`;



const $3d2cac913f314860$var$initialState = {
    urlQueryParams: undefined,
    hid: undefined,
    email: undefined,
    groups: {},
    initialStates: {},
    status: {
        status: 'ok'
    },
    filter: {
        groupKey: 'all'
    },
    actionResult: undefined,
    consentDialog: {
        showDialog: false,
        update: undefined
    },
    consentDeclinePrDialog: {
        showDialog: false,
        update: undefined
    },
    globalUnsubscribeDialog: {
        showDialog: false,
        update: undefined
    },
    doubleOptInDialog: {
        showDialog: false,
        update: undefined
    },
    notifications: []
};
const $3d2cac913f314860$export$ffa1c39529f5195b = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $80022746ba8cd68a$export$6871e08c9c3b9797), async (hid, { rejectWithValue: rejectWithValue })=>{
    const mockUserPreferences = (0, $edcf2f5ac8c95255$export$12b1f9d03b823a51)(hid);
    if (mockUserPreferences) return mockUserPreferences;
    try {
        if (hid) return await (0, $71fbb9240bd0b42c$export$fa5a5f9acf0b4757)(hid);
        else return (await (0, $71fbb9240bd0b42c$export$c1cf1b7b7ca0c54c)()).data;
    } catch (e) {
        if ((0, $747d656b899e6115$export$2e2bcd8739ae039).isAxiosError(e)) return rejectWithValue(e.status);
        else throw e;
    }
});
const $3d2cac913f314860$export$34ae4e8891fc3f3d = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $80022746ba8cd68a$export$3ba8a56dc6b23d2b), async (_, { getState: getState, rejectWithValue: rejectWithValue, dispatch: dispatch })=>{
    var _getState_preferences;
    const hid = (_getState_preferences = getState().preferences) === null || _getState_preferences === void 0 ? void 0 : _getState_preferences.hid;
    if (!hid) return rejectWithValue(null);
    const userPreferences = (0, $edcf2f5ac8c95255$export$12b1f9d03b823a51)(hid);
    if (userPreferences == null) {
        const groups = getState().preferences.groups;
        await (0, $71fbb9240bd0b42c$export$e2a4d9289365ff88)(hid);
        // mark all subscriptions as unsubscribed and revoke all consents
        Object.keys(groups).forEach((groupKey)=>{
            if (groups[groupKey].type === (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS || groups[groupKey].type === (0, $91cadcf42f447377$export$d460f747b73abb10).CONSENTS) Object.keys(groups[groupKey].tabs).forEach((tabKey)=>{
                Object.keys(groups[groupKey].tabs[tabKey].items).forEach((itemKey)=>{
                    dispatch($3d2cac913f314860$export$b7f4ae9cfec1a518({
                        groupKey: groupKey,
                        tabKey: tabKey,
                        itemKey: itemKey,
                        state: (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false
                    }));
                });
            });
        });
    } else if (hid === '5') return rejectWithValue(null);
});
const $3d2cac913f314860$var$findKey = (state, targetKey)=>{
    for (const groupKey of Object.keys(state.groups)){
        for (const tabKey of Object.keys(state.groups[groupKey].tabs))for (const itemKey of Object.keys(state.groups[groupKey].tabs[tabKey].items)){
            if (itemKey === targetKey) return {
                groupKey: groupKey,
                tabKey: tabKey,
                itemKey: itemKey
            };
        }
    }
    throw new Error("Item key '" + targetKey + "' not found.");
};
const $3d2cac913f314860$export$f500693cef883ffd = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $80022746ba8cd68a$export$1a788c0d2586d018), async (_, { dispatch: dispatch, getState: getState, rejectWithValue: rejectWithValue })=>{
    var _getState_preferences;
    const { urlQueryParams: urlQueryParams } = getState().preferences;
    const hid = (_getState_preferences = getState().preferences) === null || _getState_preferences === void 0 ? void 0 : _getState_preferences.hid;
    if (urlQueryParams == null || !hid) return rejectWithValue(null);
    const { unsubscribeKeys: unsubscribeKeys, jobId: jobId } = urlQueryParams;
    if (unsubscribeKeys === 'all') {
        dispatch($3d2cac913f314860$export$34ae4e8891fc3f3d());
        return [
            unsubscribeKeys
        ];
    } else if (unsubscribeKeys) {
        await (0, $71fbb9240bd0b42c$export$a1e4533914e154bd)(hid, unsubscribeKeys, jobId);
        // uncheck all unsubscribed items
        const subscriptionKeys = unsubscribeKeys.split(',');
        const emptyGroupKey = '';
        const keysWithGroup = [];
        subscriptionKeys.forEach((subscriptionKey)=>{
            try {
                const { groupKey: groupKey, tabKey: tabKey, itemKey: itemKey } = $3d2cac913f314860$var$findKey(getState().preferences, subscriptionKey);
                keysWithGroup.push(groupKey + ':' + subscriptionKey);
                dispatch($3d2cac913f314860$export$b7f4ae9cfec1a518({
                    groupKey: groupKey,
                    tabKey: tabKey,
                    itemKey: itemKey,
                    state: (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false
                }));
            } catch (e) {
                // This can occur if the subscription is not listed in the UI
                keysWithGroup.push(emptyGroupKey + ':' + subscriptionKey);
            }
        });
        return keysWithGroup;
    } else return [];
}, {
    condition: (_, { getState: getState })=>{
        const { urlQueryParams: urlQueryParams, status: status } = getState().preferences;
        return status.status === 'ok' && (urlQueryParams === null || urlQueryParams === void 0 ? void 0 : urlQueryParams.unsubscribeKeys) != null;
    }
});
const $3d2cac913f314860$export$ec068583843480e7 = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $80022746ba8cd68a$export$30f55fa357ca2ae5), async (_, { dispatch: dispatch, getState: getState, rejectWithValue: rejectWithValue })=>{
    const { urlQueryParams: urlQueryParams } = getState().preferences;
    const hid = getState().preferences.hid;
    if (urlQueryParams == null || !hid) return rejectWithValue(null);
    const { subscribeKeys: subscribeKeys } = urlQueryParams;
    if (subscribeKeys == null) return [];
    // check all subscribed items
    const keys = subscribeKeys.split(',');
    const keysWithGroup = [];
    keys.forEach((key)=>{
        const { groupKey: groupKey, tabKey: tabKey, itemKey: itemKey } = $3d2cac913f314860$var$findKey(getState().preferences, key);
        keysWithGroup.push(groupKey + ':' + itemKey);
        dispatch($3d2cac913f314860$export$b7f4ae9cfec1a518({
            groupKey: groupKey,
            tabKey: tabKey,
            itemKey: itemKey,
            state: (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true
        }));
    });
    const subscriptions = keys.map((key)=>({
            key: key,
            subscribed: true
        }));
    await (0, $71fbb9240bd0b42c$export$d12a00019f220cc1)(hid, subscriptions);
    return keysWithGroup;
}, {
    condition: (_, { getState: getState })=>{
        const { urlQueryParams: urlQueryParams, status: status } = getState().preferences;
        return status.status === 'ok' && (urlQueryParams === null || urlQueryParams === void 0 ? void 0 : urlQueryParams.subscribeKeys) != null;
    }
});
const $3d2cac913f314860$export$a3910a3548679a09 = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $80022746ba8cd68a$export$f03e0b4dc877be9a), async (args, { dispatch: dispatch, getState: getState })=>{
    const { urlQueryParams: urlQueryParams } = getState().preferences;
    if (urlQueryParams == null) return;
    const { hid: hid, source: source, unsubscribeKeys: unsubscribeKeys, subscribeKeys: subscribeKeys } = urlQueryParams;
    (0, $0e08eda71bb24540$export$e2ad6fafbc50701c)(hid, source, unsubscribeKeys, subscribeKeys);
    // initialize all structures w/info from ConsentHub
    await dispatch($3d2cac913f314860$export$ffa1c39529f5195b(hid));
    (0, $f30b917334351296$export$712ea50be43a7858)(()=>{
        dispatch($3d2cac913f314860$export$f500693cef883ffd());
        dispatch($3d2cac913f314860$export$ec068583843480e7());
    });
});
const $3d2cac913f314860$var$requestConsentConfirmation = (update, preferenceState)=>{
    if (preferenceState.groups['consents'] === undefined) return false;
    const gmoi = preferenceState.groups['consents'].tabs['root'].items['generalMarketingOptIn'];
    if (update.bypassConsentCheck) return false;
    // only check consent if they are consenting or subscribing, not revoking or unsubscribing
    if (update.state !== (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true) return false;
    const needsGmoi = gmoi !== undefined && (gmoi == null || gmoi !== (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON);
    for (const item of update.keys){
        const { groupKey: groupKey } = $3d2cac913f314860$var$findKey(preferenceState, item);
        // Show consent modal if:
        // - Group is 'product_recommendations' OR item is 'generalMarketingOptIn'
        // - AND generalMarketingOptIn currently is null or false.
        // - AND consent modal isn't open
        if ((groupKey === 'product_recommendations' || item === 'generalMarketingOptIn') && needsGmoi && !preferenceState.consentDialog.showDialog) return true;
    }
    return false;
};
// Worst name for a function ever
const $3d2cac913f314860$var$requestConfirmationForPrUnsub = (update, preferenceState)=>{
    let anyPrSubbed = false;
    try {
        for (const tabKey of Object.keys(preferenceState.groups['product_recommendations'].tabs)){
            for (const itemKey of Object.keys(preferenceState.groups['product_recommendations'].tabs[tabKey].items))if (preferenceState.groups['product_recommendations'].tabs[tabKey].items[itemKey] === (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON) {
                anyPrSubbed = true;
                break;
            }
            if (anyPrSubbed) break;
        }
    } catch (e) {
    // No issue here. Just means PR group is missing.
    }
    if (update.bypassConsentDeclinePrCheck) return false;
    // only request confirmation if they are revoking consent
    if (update.state !== (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false) return false;
    for (const item of update.keys){
        // Show confirmation modal if:
        // - Item is 'generalMarketingOptIn'
        // - AND any product recommendation is subscribed
        // - AND confirmation modal isn't open
        if (item === 'generalMarketingOptIn' && anyPrSubbed && !preferenceState.consentDeclinePrDialog.showDialog) return true;
    }
    return false;
};
const $3d2cac913f314860$var$requestGlobalUnsubscribe = (preferenceState)=>{
    for (const groupKey of Object.keys(preferenceState.groups)){
        for (const tabKey of Object.keys(preferenceState.groups[groupKey].tabs))for (const itemKey of Object.keys(preferenceState.groups[groupKey].tabs[tabKey].items)){
            const itemStatus = preferenceState.groups[groupKey].tabs[tabKey].items[itemKey];
            if (itemStatus === (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON || itemStatus === (0, $91cadcf42f447377$export$3d4da522aa66ad7).PENDING) return false;
        }
    }
    return true;
};
const $3d2cac913f314860$var$showDoubleOptIn = (update, response)=>{
    return !!(update.keys.includes('generalMarketingOptIn') && response.groups && response.groups['consents'].tabs['root'].items['generalMarketingOptIn'] === (0, $91cadcf42f447377$export$3d4da522aa66ad7).PENDING);
};
const $3d2cac913f314860$var$generateConsentsPayload = (prefState, update)=>{
    if (update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).busy) throw new Error('Attempting to generate ConsentHub consents payload with invalid consent state.');
    const payload = [];
    for (const item of update.keys){
        const { groupKey: groupKey, itemKey: itemKey } = $3d2cac913f314860$var$findKey(prefState, item);
        const type = prefState.groups[groupKey].type;
        if (type === (0, $91cadcf42f447377$export$d460f747b73abb10).CONSENTS) {
            let targetState = false;
            if (update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true) targetState = true;
            payload.push({
                key: itemKey,
                displayedText: 'Changed via Pref. Center UI',
                granted: targetState
            });
        }
    }
    return payload;
};
const $3d2cac913f314860$var$generateSubscriptionsPayload = (prefState, update)=>{
    if (update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).busy) throw new Error('Attempting to generate ConsentHub subscriptions payload with invalid subscription state.');
    const payload = [];
    for (const item of update.keys){
        const { groupKey: groupKey, itemKey: itemKey } = $3d2cac913f314860$var$findKey(prefState, item);
        const type = prefState.groups[groupKey].type;
        if (type === (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS) {
            let targetState = false;
            if (update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true) targetState = true;
            payload.push({
                key: itemKey,
                subscribed: targetState
            });
        }
    }
    return payload;
};
const $3d2cac913f314860$var$setStates = (prefState, update, dispatch, targetState)=>{
    for (const item of Object.values(update.keys)){
        const { groupKey: groupKey, tabKey: tabKey, itemKey: itemKey } = $3d2cac913f314860$var$findKey(prefState, item);
        dispatch($3d2cac913f314860$export$b7f4ae9cfec1a518({
            groupKey: groupKey,
            tabKey: tabKey,
            itemKey: itemKey,
            state: targetState
        }));
    }
};
const $3d2cac913f314860$export$807cff22f0457821 = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $80022746ba8cd68a$export$22260131648f9419), async (update, { dispatch: dispatch, getState: getState, rejectWithValue: rejectWithValue })=>{
    var _getState_preferences;
    const hid = (_getState_preferences = getState().preferences) === null || _getState_preferences === void 0 ? void 0 : _getState_preferences.hid;
    if (!hid) return rejectWithValue(null);
    if ($3d2cac913f314860$var$requestConsentConfirmation(update, getState().preferences)) {
        dispatch($3d2cac913f314860$export$6b7ef6c2de46cbd4({
            showDialog: true,
            update: update
        }));
        return rejectWithValue(null);
    } else if (update.sourceGroup === 'product_recommendations' && update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true) {
        if (update.sourceComponent === 'ItemCard') (0, $0e08eda71bb24540$export$b2d5c41c71279068)(true, {
            source: update.sourceItem
        });
        else if (update.sourceComponent === 'GroupContent') (0, $0e08eda71bb24540$export$19e5a6bca6f03118)(true, {
            groupName: update.sourceGroup,
            tabName: update.sourceTab
        });
    }
    if ($3d2cac913f314860$var$requestConfirmationForPrUnsub(update, getState().preferences)) {
        dispatch($3d2cac913f314860$export$cab60deb7aecd81e({
            showDialog: true,
            update: update
        }));
        return rejectWithValue(null);
    } else if (update.sourceGroup === 'consents' && update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false) {
        if (update.sourceComponent === 'ItemCard') (0, $0e08eda71bb24540$export$c369c41080a75c3d)({
            source: update.sourceItem
        });
        else if (update.sourceComponent === 'GroupContent') (0, $0e08eda71bb24540$export$f1757086d8a8d8f4)();
    }
    const request = {
        hid: hid,
        formUrl: window.location.href,
        site: 'atlassian',
        consents: $3d2cac913f314860$var$generateConsentsPayload(getState().preferences, update),
        subscriptions: $3d2cac913f314860$var$generateSubscriptionsPayload(getState().preferences, update),
        source: 'PREFERENCES_CENTER',
        action: 'UPDATE_PREFERENCES'
    };
    try {
        // update checkbox(es) w/spinner for all items in consent/subscription payloads
        $3d2cac913f314860$var$setStates(getState().preferences, update, dispatch, (0, $e11fceb31fd1a0cb$export$e743037aea74f514).busy);
        const response = await (0, $71fbb9240bd0b42c$export$3ab4aed8562cb58d)(request);
        if (response.downForMaintenanceMessage != null) // don't show the modal error, just refresh for a proper DFM page.
        window.location.reload();
        if ($3d2cac913f314860$var$showDoubleOptIn(update, response)) dispatch($3d2cac913f314860$export$71d5718099bcf953({
            showDialog: true
        }));
        else if (!update.skipNotification) dispatch($3d2cac913f314860$export$6ee970972faf5a9e());
        return response;
    } catch (e) {
        // reset checkbox(es)
        let targetState = (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false;
        if (update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false) targetState = (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true;
        $3d2cac913f314860$var$setStates(getState().preferences, update, dispatch, targetState);
        dispatch($3d2cac913f314860$export$40aa0bed012fe51a());
    }
});
const $3d2cac913f314860$var$findSubscriptionGroup = (keys, state)=>{
    if (keys == null || keys === 'all' || keys.includes(',')) return undefined;
    if (state.groups == null) return undefined;
    try {
        const { groupKey: groupKey, tabKey: tabKey } = $3d2cac913f314860$var$findKey(state, keys);
        return {
            groupKey: groupKey,
            tabKey: tabKey
        };
    } catch (e) {
        // If we can't find the key, show them all.
        return undefined;
    }
};
const $3d2cac913f314860$var$preferencesSlice = (0, $15d924278321bdfd$export$4d8d9bd83c24ae8b)({
    name: (0, $80022746ba8cd68a$export$67da628992e8bb92),
    initialState: $3d2cac913f314860$var$initialState,
    reducers: {
        logSuccessNotification: (state)=>{
            const newFlagId = state.notifications.length + 1;
            const newFlagData = (0, $8bebd03d19fe43b4$export$3f0ed83b7cd726b4)(newFlagId, 'Your preferences were updated. Please be patient, as it can take up to 5 business days for these changes to go into effect.');
            state.notifications.unshift(newFlagData);
        },
        logErrorNotification: (state)=>{
            const newFlagId = state.notifications.length + 1;
            const newFlagData = (0, $8bebd03d19fe43b4$export$4be607b64c8e8c80)(newFlagId, 'There was an error while updating your preferences. Please try again.');
            state.notifications.unshift(newFlagData);
        },
        removeNotification (state) {
            state.notifications.shift();
        },
        setItemState: (state, action)=>{
            const { groupKey: groupKey, tabKey: tabKey, itemKey: itemKey, state: targetState } = action.payload;
            switch(targetState){
                case (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true:
                    state.groups[groupKey].tabs[tabKey].items[itemKey] = (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON;
                    break;
                case (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false:
                    state.groups[groupKey].tabs[tabKey].items[itemKey] = (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF;
                    break;
                case (0, $e11fceb31fd1a0cb$export$e743037aea74f514).busy:
                    state.groups[groupKey].tabs[tabKey].items[itemKey] = undefined;
                    break;
            }
        },
        closeNotification: (state)=>{
            state.actionResult = $3d2cac913f314860$var$initialState.actionResult;
        },
        showAllGroups: (state)=>{
            state.filter = $3d2cac913f314860$var$initialState.filter;
            state.actionResult = $3d2cac913f314860$var$initialState.actionResult;
        },
        showConsentDialog: (state, action)=>{
            state.consentDialog = action.payload;
        },
        showConsentDeclinePrDialog: (state, action)=>{
            state.consentDeclinePrDialog = action.payload;
        },
        showGlobalUnsubscribeDialog: (state, action)=>{
            state.globalUnsubscribeDialog = action.payload;
        },
        showDoubleOptInDialog: (state, action)=>{
            state.doubleOptInDialog = action.payload;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($3d2cac913f314860$export$a3910a3548679a09.pending, (state, { meta: meta })=>{
            const subscriptionReferralUrlParams = (0, $a87b710a60abd11e$export$a52d76f06c2d44c0)(meta.arg.query);
            if (subscriptionReferralUrlParams.hid || meta.arg.useSso) state.urlQueryParams = subscriptionReferralUrlParams;
            else state.status = {
                status: 'not-found'
            };
        });
        builder.addCase($3d2cac913f314860$export$ffa1c39529f5195b.fulfilled, (state, { payload: payload })=>{
            const { downForMaintenanceMessage: downForMaintenanceMessage, email: email, groups: groups, hid: hid } = payload;
            if (downForMaintenanceMessage != null) state.status = {
                status: 'down-for-maintenance',
                message: downForMaintenanceMessage
            };
            else if (email == null || hid == null) state.status = {
                status: 'not-found'
            };
            else if (groups == null || Object.keys(groups).length === 0) {
                state.email = email;
                state.hid = hid;
                state.status = {
                    status: 'empty'
                };
            } else {
                var _state_urlQueryParams;
                state.status = $3d2cac913f314860$var$initialState.status;
                state.email = email;
                state.hid = hid;
                state.groups = groups;
                state.filter = $3d2cac913f314860$var$findSubscriptionGroup((_state_urlQueryParams = state.urlQueryParams) === null || _state_urlQueryParams === void 0 ? void 0 : _state_urlQueryParams.unsubscribeKeys, state) || $3d2cac913f314860$var$initialState.filter;
                const initialStates = {};
                Object.keys(groups).forEach((groupKey)=>{
                    Object.keys(groups[groupKey].tabs).forEach((tabKey)=>{
                        Object.keys(groups[groupKey].tabs[tabKey].items).forEach((itemKey)=>{
                            initialStates[itemKey] = groups[groupKey].tabs[tabKey].items[itemKey];
                        });
                    });
                });
                state.initialStates = initialStates;
            }
        });
        builder.addCase($3d2cac913f314860$export$807cff22f0457821.fulfilled, (state, { payload: payload })=>{
            if (payload === undefined || payload.groups === undefined) return;
            state.groups = payload.groups;
            // Given the received data, determine if GlobalUnsubscribeDialog Modal should be shown.
            if ($3d2cac913f314860$var$requestGlobalUnsubscribe(state)) state.globalUnsubscribeDialog = {
                showDialog: true
            };
        });
        builder.addCase($3d2cac913f314860$export$ffa1c39529f5195b.rejected, (state, action)=>{
            if (action.payload === 401) state.status = {
                status: 'login-required'
            };
            else state.status = {
                status: 'not-found'
            };
        });
        builder.addCase($3d2cac913f314860$export$34ae4e8891fc3f3d.pending, (state)=>{
            state.actionResult = $3d2cac913f314860$var$initialState.actionResult;
        });
        builder.addCase($3d2cac913f314860$export$34ae4e8891fc3f3d.fulfilled, (state)=>{
            state.actionResult = {
                key: 'unsubscribeAll',
                status: 'success'
            };
            window.scrollTo(0, 0);
        });
        builder.addCase($3d2cac913f314860$export$34ae4e8891fc3f3d.rejected, (state)=>{
            state.actionResult = {
                key: 'request',
                status: 'error'
            };
            window.scrollTo(0, 0);
        });
        builder.addCase($3d2cac913f314860$export$f500693cef883ffd.fulfilled, (state, { payload: payload })=>{
            if (payload.length === 1 && payload[0] === 'all') state.actionResult = {
                key: 'unsubscribeAll',
                status: 'success'
            };
            else state.actionResult = {
                key: 'unsubscribeKeys',
                status: 'success',
                data: payload
            };
            window.scrollTo(0, 0);
        });
        builder.addCase($3d2cac913f314860$export$f500693cef883ffd.rejected, (state)=>{
            state.actionResult = {
                key: 'request',
                status: 'error'
            };
            window.scrollTo(0, 0);
        });
        builder.addCase($3d2cac913f314860$export$ec068583843480e7.fulfilled, (state, { payload: payload })=>{
            state.actionResult = {
                key: 'subscribeKeys',
                status: 'success',
                data: payload
            };
            window.scrollTo(0, 0);
        });
    }
});
const { closeNotification: $3d2cac913f314860$export$d684d3158aada635, setItemState: $3d2cac913f314860$export$b7f4ae9cfec1a518, showAllGroups: $3d2cac913f314860$export$923ce4fee941073a, showConsentDialog: $3d2cac913f314860$export$6b7ef6c2de46cbd4, showConsentDeclinePrDialog: $3d2cac913f314860$export$cab60deb7aecd81e, showGlobalUnsubscribeDialog: $3d2cac913f314860$export$3bb76b2ce1d4f171, showDoubleOptInDialog: $3d2cac913f314860$export$71d5718099bcf953, logSuccessNotification: $3d2cac913f314860$export$6ee970972faf5a9e, logErrorNotification: $3d2cac913f314860$export$40aa0bed012fe51a, removeNotification: $3d2cac913f314860$export$92eb0ea44f8c9242 } = $3d2cac913f314860$var$preferencesSlice.actions;
var $3d2cac913f314860$export$2e2bcd8739ae039 = $3d2cac913f314860$var$preferencesSlice.reducer;



const $a3651c3b6b796a9d$var$NotificationFlagGroup = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const notifications = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((state)=>state.preferences.notifications);
    const handleDismiss = ()=>{
        dispatch((0, $3d2cac913f314860$export$92eb0ea44f8c9242)());
    };
    const getIcon = (iconType)=>{
        switch(iconType){
            case 'success':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($782188f667f9d0f5$exports))), {
                    label: "Success",
                    primaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.success')
                });
            case 'error':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8ad5e43bebed238e$exports))), {
                    label: "Error",
                    primaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.danger')
                });
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $99322f445ba7cde3$export$2e2bcd8739ae039), {
            onDismissed: handleDismiss,
            children: notifications.map((notification)=>notification.isAutoDismissFlag ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a254ace60a4a8d45$export$2e2bcd8739ae039), {
                    id: notification.id,
                    icon: getIcon(notification.iconType),
                    title: notification.title,
                    description: notification.description
                }, notification.key) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $374f1491cdd22e01$export$2e2bcd8739ae039), {
                    id: notification.id,
                    icon: getIcon(notification.iconType),
                    title: notification.title,
                    description: notification.description
                }, notification.key))
        })
    });
};
var $a3651c3b6b796a9d$export$2e2bcd8739ae039 = $a3651c3b6b796a9d$var$NotificationFlagGroup;



const $ef58838c74859603$var$layoutContentStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    width: '100%',
    minHeight: 'calc(100vh - var(--topNavigationHeight, 56px))',
    display: 'grid',
    gridTemplateRows: '1fr auto',
    gridTemplateColumns: '100%'
});
const $ef58838c74859603$var$mainStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin: '0 auto',
    maxWidth: '1200px',
    padding: 'space.200',
    paddingTop: 'space.400'
});
const $ef58838c74859603$var$LayoutWrapper = ({ headerContent: headerContent, children: children })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a8ecf42811a16d58$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a3651c3b6b796a9d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d0a14d7762364fd2$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $558934874537b23b$export$2e2bcd8739ae039), {
                        testId: "top-navigation",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7092fc21e9894387$export$2e2bcd8739ae039), {
                            headerContent: headerContent
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d3f7915c8afb3490$export$2e2bcd8739ae039), {
                        testId: "content",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                            xcss: $ef58838c74859603$var$layoutContentStyles,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9f06dd5f55f9dca6$export$2e2bcd8739ae039), {
                                    testId: "main",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                                        xcss: $ef58838c74859603$var$mainStyles,
                                        children: children
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8bc21533085bc562$export$2e2bcd8739ae039), {})
                            ]
                        })
                    })
                ]
            })
        ]
    });
var $ef58838c74859603$export$2e2bcd8739ae039 = $ef58838c74859603$var$LayoutWrapper;




/* NavigationButton.tsx generated by @compiled/babel-plugin v0.38.1 */ 


var $ffab31738995aac3$exports = {};
"use strict";
Object.defineProperty($ffab31738995aac3$exports, "__esModule", {
    value: true
});
$ffab31738995aac3$exports.default = void 0;

var $ffab31738995aac3$var$_react = $ffab31738995aac3$var$_interopRequireDefault((parcelRequire("7fPBF")));

function $ffab31738995aac3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ffab31738995aac3$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $ffab31738995aac3$var$_react.default.createElement($ab6305b9bfa57046$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props));
$ffab31738995aac3$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $ffab31738995aac3$var$_default = $ffab31738995aac3$exports.default = $ffab31738995aac3$var$ArrowRightIcon;


parcelRequire("7fPBF");


const $6125038cd8bf4a75$var$_5 = "._otyr14lv{margin-bottom:var(--_cpuyf2)}";
const $6125038cd8bf4a75$var$_4 = "._19pkebsi{margin-top:var(--_1ldm4z7)}";
const $6125038cd8bf4a75$var$_3 = "._1bahesu3{justify-content:flex-end}";
const $6125038cd8bf4a75$var$_2 = "._1e0c1txw{display:flex}";
const $6125038cd8bf4a75$var$_ = "._1yt411xh{padding:0 var(--_fhuf0z)}";
const $6125038cd8bf4a75$var$styles = null;
const $6125038cd8bf4a75$var$NavigationButton = ({ isVisible: isVisible, appearance: appearance, onClick: onClick })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $6125038cd8bf4a75$var$_,
                    $6125038cd8bf4a75$var$_2,
                    $6125038cd8bf4a75$var$_3,
                    $6125038cd8bf4a75$var$_4,
                    $6125038cd8bf4a75$var$_5
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1yt411xh _1e0c1txw _1bahesu3 _19pkebsi _otyr14lv"
                ]),
                style: {
                    "--_fhuf0z": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.300')),
                    "--_1ldm4z7": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.negative.200')),
                    "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200'))
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                    appearance: appearance,
                    iconAfter: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ffab31738995aac3$exports))), {
                        label: 'arrow-right-icon',
                        size: 'small'
                    }),
                    onClick: onClick,
                    testId: "navigation-button",
                    children: translate((0, $447ba15143f7eed7$exports).GOTO_PREFERENCES_CENTER_BUTTON_LABEL)
                })
            })
        ]
    });
};
var $6125038cd8bf4a75$export$2e2bcd8739ae039 = $6125038cd8bf4a75$var$NavigationButton;





/* ActionNotification.tsx generated by @compiled/babel-plugin v0.38.1 */ 

parcelRequire("7fPBF");

const $e745f2f77eae858d$export$a2262118789c43db = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.consent.actionResult, (actionResult)=>actionResult);
const $e745f2f77eae858d$export$f4442397935fb087 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.consent.status, (status)=>status);
const $e745f2f77eae858d$export$e4521e30be8f0d13 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.consent.urlQueryParams, (urlQueryParams)=>urlQueryParams === null || urlQueryParams === void 0 ? void 0 : urlQueryParams.hid);



/* Notification.tsx generated by @compiled/babel-plugin v0.38.1 */ 


parcelRequire("7fPBF");
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $euWUS = parcelRequire("euWUS");


var $100e10ca1c1b1069$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40d49d14e43276e4147396a05e9540f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($100e10ca1c1b1069$exports, "__esModule", {
    value: true
});
$100e10ca1c1b1069$exports.default = void 0;

var $100e10ca1c1b1069$var$_react = $100e10ca1c1b1069$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $100e10ca1c1b1069$var$_cross = $100e10ca1c1b1069$var$_interopRequireDefault((parcelRequire("3B4Ta")));

var $100e10ca1c1b1069$var$_cross2 = $100e10ca1c1b1069$var$_interopRequireDefault((parcelRequire("fHEud")));
function $100e10ca1c1b1069$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $100e10ca1c1b1069$var$CrossIcon = (props)=>/*#__PURE__*/ $100e10ca1c1b1069$var$_react.default.createElement($100e10ca1c1b1069$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $100e10ca1c1b1069$var$_cross2.default
    }, props));
$100e10ca1c1b1069$var$CrossIcon.Name = 'CrossIconMigration';
var $100e10ca1c1b1069$var$_default = $100e10ca1c1b1069$exports.default = $100e10ca1c1b1069$var$CrossIcon;



var $137Lh = parcelRequire("137Lh");


var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
var $b8e83f7611d60a05$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79b7b06346630e2a8502fd6db80f47e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b8e83f7611d60a05$exports, "__esModule", {
    value: true
});
$b8e83f7611d60a05$exports.default = void 0;

var $b8e83f7611d60a05$var$_react = $b8e83f7611d60a05$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $b8e83f7611d60a05$var$_discovery = $b8e83f7611d60a05$var$_interopRequireDefault((parcelRequire("6nN1q")));

var $b8e83f7611d60a05$var$_note = $b8e83f7611d60a05$var$_interopRequireDefault((parcelRequire("cUujz")));
function $b8e83f7611d60a05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b8e83f7611d60a05$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $b8e83f7611d60a05$var$_react.default.createElement($b8e83f7611d60a05$var$_discovery.default, Object.assign({
        LEGACY_fallbackIcon: $b8e83f7611d60a05$var$_note.default
    }, props));
$b8e83f7611d60a05$var$DiscoveryIcon.Name = 'DiscoveryIconMigration';
var $b8e83f7611d60a05$var$_default = $b8e83f7611d60a05$exports.default = $b8e83f7611d60a05$var$DiscoveryIcon;


var $53eb762d5885402b$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b4f7ab8b5658b8ac17876b86421aa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($53eb762d5885402b$exports, "__esModule", {
    value: true
});
$53eb762d5885402b$exports.default = void 0;

var $53eb762d5885402b$var$_react = $53eb762d5885402b$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $53eb762d5885402b$var$_questionCircle = $53eb762d5885402b$var$_interopRequireDefault((parcelRequire("iT7j6")));

var $53eb762d5885402b$var$_questionCircle2 = $53eb762d5885402b$var$_interopRequireDefault((parcelRequire("1IZVR")));
function $53eb762d5885402b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $53eb762d5885402b$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $53eb762d5885402b$var$_react.default.createElement($53eb762d5885402b$var$_questionCircle.default, Object.assign({
        LEGACY_fallbackIcon: $53eb762d5885402b$var$_questionCircle2.default
    }, props));
$53eb762d5885402b$var$QuestionCircleIcon.Name = 'QuestionCircleIconMigration';
var $53eb762d5885402b$var$_default = $53eb762d5885402b$exports.default = $53eb762d5885402b$var$QuestionCircleIcon;


var $0c377184595f609b$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8687bcf05df783ceffe46d3fd0178463>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($0c377184595f609b$exports, "__esModule", {
    value: true
});
$0c377184595f609b$exports.default = void 0;

var $0c377184595f609b$var$_react = $0c377184595f609b$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $0c377184595f609b$var$_statusError = $0c377184595f609b$var$_interopRequireDefault((parcelRequire("ealUj")));

var $0c377184595f609b$var$_error = $0c377184595f609b$var$_interopRequireDefault((parcelRequire("kTrDZ")));
function $0c377184595f609b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c377184595f609b$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $0c377184595f609b$var$_react.default.createElement($0c377184595f609b$var$_statusError.default, Object.assign({
        LEGACY_fallbackIcon: $0c377184595f609b$var$_error.default
    }, props));
$0c377184595f609b$var$StatusErrorIcon.Name = 'StatusErrorIconMigration';
var $0c377184595f609b$var$_default = $0c377184595f609b$exports.default = $0c377184595f609b$var$StatusErrorIcon;


var $55263bb58c458b53$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e3974ad0608437b58ea5a455fd9f640>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($55263bb58c458b53$exports, "__esModule", {
    value: true
});
$55263bb58c458b53$exports.default = void 0;

var $55263bb58c458b53$var$_react = $55263bb58c458b53$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $55263bb58c458b53$var$_statusInformation = $55263bb58c458b53$var$_interopRequireDefault((parcelRequire("a6Ah9")));

var $55263bb58c458b53$var$_info = $55263bb58c458b53$var$_interopRequireDefault((parcelRequire("iLRpF")));
function $55263bb58c458b53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $55263bb58c458b53$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $55263bb58c458b53$var$_react.default.createElement($55263bb58c458b53$var$_statusInformation.default, Object.assign({
        LEGACY_fallbackIcon: $55263bb58c458b53$var$_info.default
    }, props));
$55263bb58c458b53$var$StatusInformationIcon.Name = 'StatusInformationIconMigration';
var $55263bb58c458b53$var$_default = $55263bb58c458b53$exports.default = $55263bb58c458b53$var$StatusInformationIcon;


var $e441054e5d9bfb0d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79d87fd54ca549401aa2a870cdd2f3b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e441054e5d9bfb0d$exports, "__esModule", {
    value: true
});
$e441054e5d9bfb0d$exports.default = void 0;

var $e441054e5d9bfb0d$var$_react = $e441054e5d9bfb0d$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $e441054e5d9bfb0d$var$_statusSuccess = $e441054e5d9bfb0d$var$_interopRequireDefault((parcelRequire("2RIHD")));

var $e441054e5d9bfb0d$var$_checkCircle = $e441054e5d9bfb0d$var$_interopRequireDefault((parcelRequire("eGV7J")));
function $e441054e5d9bfb0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e441054e5d9bfb0d$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $e441054e5d9bfb0d$var$_react.default.createElement($e441054e5d9bfb0d$var$_statusSuccess.default, Object.assign({
        LEGACY_fallbackIcon: $e441054e5d9bfb0d$var$_checkCircle.default
    }, props));
$e441054e5d9bfb0d$var$StatusSuccessIcon.Name = 'StatusSuccessIconMigration';
var $e441054e5d9bfb0d$var$_default = $e441054e5d9bfb0d$exports.default = $e441054e5d9bfb0d$var$StatusSuccessIcon;


var $0adf38b92bdac530$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c4f87fa6bbdffcdd6698ec12cc5fa12>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($0adf38b92bdac530$exports, "__esModule", {
    value: true
});
$0adf38b92bdac530$exports.default = void 0;

var $0adf38b92bdac530$var$_react = $0adf38b92bdac530$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $0adf38b92bdac530$var$_statusWarning = $0adf38b92bdac530$var$_interopRequireDefault((parcelRequire("esxeA")));

var $0adf38b92bdac530$var$_warning = $0adf38b92bdac530$var$_interopRequireDefault((parcelRequire("24VLH")));
function $0adf38b92bdac530$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0adf38b92bdac530$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $0adf38b92bdac530$var$_react.default.createElement($0adf38b92bdac530$var$_statusWarning.default, Object.assign({
        LEGACY_fallbackIcon: $0adf38b92bdac530$var$_warning.default
    }, props));
$0adf38b92bdac530$var$StatusWarningIcon.Name = 'StatusWarningIconMigration';
var $0adf38b92bdac530$var$_default = $0adf38b92bdac530$exports.default = $0adf38b92bdac530$var$StatusWarningIcon;



var $137Lh = parcelRequire("137Lh");
// Reds
var $124dde5a9655fe76$export$4b84fd0e2c617bd = '#FFEBE6';
var $124dde5a9655fe76$export$b34b069eff244586 = '#FFBDAD';
var $124dde5a9655fe76$export$be802dd0d8b57f35 = '#FF8F73';
var $124dde5a9655fe76$export$60847d42f9da92a6 = '#FF7452';
var $124dde5a9655fe76$export$4a7404f376229999 = '#FF5630';
var $124dde5a9655fe76$export$2010d0fb4295b346 = '#DE350B';
var $124dde5a9655fe76$export$2837b5a1a71d5c02 = '#BF2600';
var $124dde5a9655fe76$export$8d9596b529bbb9cf = '#FFFAE6';
var $124dde5a9655fe76$export$41060a744ab0b7ae = '#FFF0B3';
var $124dde5a9655fe76$export$1cc05bbbf340e559 = '#FFE380';
var $124dde5a9655fe76$export$5aae31392d72caaa = '#FFC400';
var $124dde5a9655fe76$export$c6930421db9fa514 = '#FFAB00';
var $124dde5a9655fe76$export$59619663aa6500fb = '#FF991F';
var $124dde5a9655fe76$export$874739ea9e379ab6 = '#FF8B00';
var $124dde5a9655fe76$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $124dde5a9655fe76$export$69a3bf21b9686c2b = '#ABF5D1';
var $124dde5a9655fe76$export$afbce1382ec95f73 = '#79F2C0';
var $124dde5a9655fe76$export$747d86715d4175de = '#57D9A3';
var $124dde5a9655fe76$export$940e1f69e873f202 = '#36B37E';
var $124dde5a9655fe76$export$a49394138f7b8e85 = '#00875A';
var $124dde5a9655fe76$export$6fa04827ac68a4fb = '#006644';
var $124dde5a9655fe76$export$226de0355ed012f8 = '#DEEBFF';
var $124dde5a9655fe76$export$8c13c2ee36917869 = '#B3D4FF';
var $124dde5a9655fe76$export$ecfc1dff386a3e7a = '#4C9AFF';
var $124dde5a9655fe76$export$215b7063051591f1 = '#2684FF';
var $124dde5a9655fe76$export$e62e8919cca44969 = '#0065FF';
var $124dde5a9655fe76$export$b3de0ae08da2ce64 = '#0052CC';
var $124dde5a9655fe76$export$a6ee3d71bc067634 = '#0747A6';
var $124dde5a9655fe76$export$67f15409e87642a1 = '#669DF1';
var $124dde5a9655fe76$export$f0539dbc42dbb067 = '#8FB8F6';
var $124dde5a9655fe76$export$363e4475840015bb = '#EAE6FF';
var $124dde5a9655fe76$export$4b0a4417ed59760f = '#C0B6F2';
var $124dde5a9655fe76$export$6011520a64d9a187 = '#998DD9';
var $124dde5a9655fe76$export$a7175d4e9206bc80 = '#8777D9';
var $124dde5a9655fe76$export$b48405b95304b5a1 = '#6554C0';
var $124dde5a9655fe76$export$c71e4279dd54a18d = '#5243AA';
var $124dde5a9655fe76$export$147899de772240ec = '#403294';
var $124dde5a9655fe76$export$2cf711fe14c66f06 = '#E6FCFF';
var $124dde5a9655fe76$export$7a8f4d33f6f9772c = '#B3F5FF';
var $124dde5a9655fe76$export$776c9c497ef08533 = '#79E2F2';
var $124dde5a9655fe76$export$69cb3ca10c1e330e = '#00C7E6';
var $124dde5a9655fe76$export$9dc1ef0f3f48059b = '#00B8D9';
var $124dde5a9655fe76$export$7c835c78b6fcdef8 = '#00A3BF';
var $124dde5a9655fe76$export$6036577f95c3877e = '#008DA6';
var $124dde5a9655fe76$export$29a4f05edc054374 = '#FFFFFF';
var $124dde5a9655fe76$export$e655ef011c4aa1a2 = '#FAFBFC';
var $124dde5a9655fe76$export$9fdfb749e33cdf97 = '#F4F5F7';
var $124dde5a9655fe76$export$3e51e8f1440314ba = '#EBECF0';
var $124dde5a9655fe76$export$1ce2d1575d444ceb = '#DFE1E6';
var $124dde5a9655fe76$export$8754fc7e6d8b3000 = '#C1C7D0';
var $124dde5a9655fe76$export$c2e91cbeada39b8b = '#B3BAC5';
var $124dde5a9655fe76$export$5f71e19f3a7ad9de = '#A5ADBA';
var $124dde5a9655fe76$export$eaa8c8a70ac22806 = '#97A0AF';
var $124dde5a9655fe76$export$7c87d337fb91a97d = '#8993A4';
var $124dde5a9655fe76$export$d6447c357493214f = '#7A869A';
var $124dde5a9655fe76$export$f563ee71e9ee74cd = '#6B778C';
var $124dde5a9655fe76$export$e2ef2124cf4024b1 = '#5E6C84';
var $124dde5a9655fe76$export$eece5f492e429f08 = '#505F79';
var $124dde5a9655fe76$export$c39c0fe0f26207ae = '#42526E';
var $124dde5a9655fe76$export$7090862dc3038a9f = '#344563';
var $124dde5a9655fe76$export$ad0bacf983b7ddaa = '#253858';
var $124dde5a9655fe76$export$7d61b15e0da132af = '#172B4D';
var $124dde5a9655fe76$export$fbda843f0a27fe96 = '#091E42';
var $124dde5a9655fe76$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $124dde5a9655fe76$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $124dde5a9655fe76$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $124dde5a9655fe76$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $124dde5a9655fe76$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $124dde5a9655fe76$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $124dde5a9655fe76$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $124dde5a9655fe76$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $124dde5a9655fe76$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $124dde5a9655fe76$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $124dde5a9655fe76$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $124dde5a9655fe76$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $124dde5a9655fe76$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $124dde5a9655fe76$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $124dde5a9655fe76$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $124dde5a9655fe76$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $124dde5a9655fe76$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $124dde5a9655fe76$export$2f6319cf7d736c2a = '#E6EDFA';
var $124dde5a9655fe76$export$95126bc8884d6634 = '#DCE5F5';
var $124dde5a9655fe76$export$8338d8c35d44ff1 = '#CED9EB';
var $124dde5a9655fe76$export$5368d76ae4fbbda7 = '#B8C7E0';
var $124dde5a9655fe76$export$9f0a771d16ec8d36 = '#ABBBD6';
var $124dde5a9655fe76$export$abcf8c38338b4aa5 = '#9FB0CC';
var $124dde5a9655fe76$export$97e81faa16a182c7 = '#8C9CB8';
var $124dde5a9655fe76$export$bfe21c59123ecf33 = '#7988A3';
var $124dde5a9655fe76$export$ee82aa2ea6a1558 = '#67758F';
var $124dde5a9655fe76$export$682927c6ed76be02 = '#56637A';
var $124dde5a9655fe76$export$91fd9994c5be9757 = '#455166';
var $124dde5a9655fe76$export$d281fbfe3cff2df6 = '#3B475C';
var $124dde5a9655fe76$export$3902c91d8b98a753 = '#313D52';
var $124dde5a9655fe76$export$8e8133c1ba5845b5 = '#283447';
var $124dde5a9655fe76$export$33ff357f6620b39 = '#202B3D';
var $124dde5a9655fe76$export$633847cf062b69e0 = '#1B2638';
var $124dde5a9655fe76$export$9776a6e503bdbf76 = '#121A29';
var $124dde5a9655fe76$export$6c813d5160dff5db = '#0E1624';
var $124dde5a9655fe76$export$3d4f271a500072a = '#0D1424';
var $124dde5a9655fe76$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $124dde5a9655fe76$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $124dde5a9655fe76$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $124dde5a9655fe76$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $124dde5a9655fe76$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $124dde5a9655fe76$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $124dde5a9655fe76$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $124dde5a9655fe76$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $124dde5a9655fe76$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $124dde5a9655fe76$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $124dde5a9655fe76$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $124dde5a9655fe76$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $124dde5a9655fe76$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $124dde5a9655fe76$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $124dde5a9655fe76$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $124dde5a9655fe76$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $124dde5a9655fe76$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $124dde5a9655fe76$export$d2adc5dedf09fced = '#292A2E';
var $124dde5a9655fe76$export$f51762073d2bb381 = '#94C748';
var $124dde5a9655fe76$export$95e26d54def96891 = '#B3DF72';


function $cff6e30d40c26c68$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cff6e30d40c26c68$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cff6e30d40c26c68$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cff6e30d40c26c68$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cff6e30d40c26c68$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $124dde5a9655fe76$export$226de0355ed012f8), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($55263bb58c458b53$exports))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $124dde5a9655fe76$export$a6ee3d71bc067634), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $124dde5a9655fe76$export$8d9596b529bbb9cf), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($0adf38b92bdac530$exports))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $124dde5a9655fe76$export$874739ea9e379ab6), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $124dde5a9655fe76$export$4b84fd0e2c617bd), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($0c377184595f609b$exports))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $124dde5a9655fe76$export$2837b5a1a71d5c02), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $124dde5a9655fe76$export$8a6341c32b6a3ee6), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($e441054e5d9bfb0d$exports))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $124dde5a9655fe76$export$6fa04827ac68a4fb), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $124dde5a9655fe76$export$363e4475840015bb), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($53eb762d5885402b$exports))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $124dde5a9655fe76$export$147899de772240ec), ")")
    },
    discoveryUpdated: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $124dde5a9655fe76$export$363e4475840015bb), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($b8e83f7611d60a05$exports))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $124dde5a9655fe76$export$147899de772240ec), ")")
    }
};
function $cff6e30d40c26c68$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $cff6e30d40c26c68$var$appearanceIconSchema[appearance === 'discovery' && (0, $137Lh.fg)('platform_dst_section_message_discovery_icon') ? 'discoveryUpdated' : appearance] || $cff6e30d40c26c68$var$appearanceIconSchema.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $cff6e30d40c26c68$var$_objectSpread($cff6e30d40c26c68$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}


var $91a181e7dea5ded3$var$sectionMessageStyles = {
    container: "_2rkoglpi _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_19pk1i6y"
};
var $91a181e7dea5ded3$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $91a181e7dea5ded3$var$SectionMessage = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'information' : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, isDismissible = _ref.isDismissible, testId = _ref.testId;
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), dismissed = _useState2[0], setDismissed = _useState2[1];
    var handleDismiss = (0, $7fPBF.useCallback)(function() {
        setDismissed(true);
    }, []);
    var _getAppearanceIconSty = (0, $cff6e30d40c26c68$export$e9b82d2e21ac0c1f)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, $7fPBF.Fragment) ? actions.props.children : actions;
    var actionsArray = (0, $7fPBF.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $7fPBF.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $euWUS.default)([
            $91a181e7dea5ded3$var$sectionMessageStyles.container,
            $91a181e7dea5ded3$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $5f5c616ec3c653f2$export$2e2bcd8739ae039), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $euWUS.default)([
            $91a181e7dea5ded3$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $7fPBF.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        LEGACY_size: "medium",
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $7fPBF.createElement((0, $5b763611458a249e$export$2e2bcd8739ae039), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content"),
        xcss: $91a181e7dea5ded3$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $7fPBF.createElement((0, $efe9521807dea491$export$2e2bcd8739ae039), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $euWUS.default)([
            $91a181e7dea5ded3$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $7fPBF.createElement((0, $5f5c616ec3c653f2$export$2e2bcd8739ae039), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xB7",
        space: "space.100",
        rowSpace: "space.0",
        role: actionsArray.length > 1 ? 'list' : undefined,
        xcss: (0, $137Lh.fg)('platform_ads_explicit_font_styles') && $91a181e7dea5ded3$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map(function(action, id) {
        return(/*#__PURE__*/ // Only use a listitem role if more than one action is present
        $7fPBF.createElement((0, $5f5c616ec3c653f2$export$2e2bcd8739ae039), {
            role: actionsArray.length > 1 ? 'listitem' : undefined,
            key: id
        }, action));
    }))), isDismissible && /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $euWUS.default)([
            $91a181e7dea5ded3$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $729d339602a97fd3$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "--dismiss-button"),
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($100e10ca1c1b1069$exports))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$91a181e7dea5ded3$var$SectionMessage.displayName = 'SectionMessage';
var $91a181e7dea5ded3$export$2e2bcd8739ae039 = $91a181e7dea5ded3$var$SectionMessage;

/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $euWUS = parcelRequire("euWUS");




var $137Lh = parcelRequire("137Lh");
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $bRUy3 = parcelRequire("bRUy3");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");









var $137Lh = parcelRequire("137Lh");


var $72d640da03f40fdc$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $72d640da03f40fdc$var$_excluded2 = [
    "className"
];
var $72d640da03f40fdc$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $72d640da03f40fdc$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $72d640da03f40fdc$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $72d640da03f40fdc$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $27bc0e79b61c3ca3$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $72d640da03f40fdc$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $7be67eb736da6c4d$export$f680877a34711e37)();
    var onClick = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.11.2",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $72d640da03f40fdc$var$_excluded2);
    var RouterLink = (0, $23195fc9470f6fd6$export$2e2bcd8739ae039)();
    var isExternal = typeof href === 'string' && $72d640da03f40fdc$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $72d640da03f40fdc$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(href) === 'object';
    (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $7fPBF.createElement((0, $141630e001aa18df$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $625a2a0002b5c0da$export$a274e22fb40f762e)($72d640da03f40fdc$var$styles.root, (0, $137Lh.fg)('platform_design-system-team_anchor-positioning') ? $72d640da03f40fdc$var$styles.position : undefined, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $7fPBF.createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $72d640da03f40fdc$var$Anchor = /*#__PURE__*/ (0, $7fPBF.forwardRef)($72d640da03f40fdc$var$AnchorNoRef);
var $72d640da03f40fdc$export$2e2bcd8739ae039 = $72d640da03f40fdc$var$Anchor;


var $c5afab4d5c610ba2$var$stylesOld = {
    common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik1r31 _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1"
};
var $c5afab4d5c610ba2$var$styles = {
    common: "_11c82smr",
    anchor: "_k48pi7a9",
    pressable: "_syaz14q2 _k48p1wq8 _bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ var $c5afab4d5c610ba2$var$SectionMessageAction = /*#__PURE__*/ (0, $7fPBF.memo)(function SectionMessageAction(_ref) {
    var children = _ref.children, onClick = _ref.onClick, href = _ref.href, testId = _ref.testId, linkComponent = _ref.linkComponent, target = _ref.target;
    if (!linkComponent && (0, $137Lh.fg)('platform_section_message_action_migration')) {
        if (href) {
            if ((0, $137Lh.fg)('platform_dst_section_message_actions_as_link')) return /*#__PURE__*/ $7fPBF.createElement("span", {
                className: (0, $euWUS.default)([
                    $c5afab4d5c610ba2$var$styles.common,
                    $c5afab4d5c610ba2$var$styles.anchor
                ])
            }, /*#__PURE__*/ $7fPBF.createElement((0, $705b4fb71b2918ff$export$2e2bcd8739ae039), {
                testId: testId,
                onClick: onClick,
                href: href,
                target: target
            }, children));
            return /*#__PURE__*/ $7fPBF.createElement((0, $72d640da03f40fdc$export$2e2bcd8739ae039), {
                testId: testId,
                onClick: onClick,
                href: href,
                xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($c5afab4d5c610ba2$var$stylesOld.common, $c5afab4d5c610ba2$var$stylesOld.anchor)
            }, children);
        }
        if (onClick) return /*#__PURE__*/ $7fPBF.createElement((0, $34bbe408102690e7$export$2e2bcd8739ae039), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)((0, $137Lh.fg)('platform_dst_section_message_actions_as_link') ? $c5afab4d5c610ba2$var$styles.common : $c5afab4d5c610ba2$var$stylesOld.common, (0, $137Lh.fg)('platform_dst_section_message_actions_as_link') ? $c5afab4d5c610ba2$var$styles.pressable : $c5afab4d5c610ba2$var$stylesOld.pressable)
        }, children);
        return /*#__PURE__*/ $7fPBF.createElement((0, $2ecd6aa4c91a6f66$export$2e2bcd8739ae039), {
            as: "span",
            testId: testId,
            xcss: (0, $137Lh.fg)('platform_dst_section_message_actions_as_link') && $c5afab4d5c610ba2$var$styles.common
        }, children);
    }
    return onClick || href ? /*#__PURE__*/ $7fPBF.createElement((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), null, children);
});
var $c5afab4d5c610ba2$export$2e2bcd8739ae039 = $c5afab4d5c610ba2$var$SectionMessageAction;



const $548d2678bd231d64$var$_ = "._p12f5o3v{max-width:900px}";
const $548d2678bd231d64$var$styles = null;
const $548d2678bd231d64$var$Notification = ({ title: title, appearance: appearance, onClose: onClose, children: children, actions: actions })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const actionsArray = [];
    if (actions) actionsArray.push(...actions);
    if (onClose) actionsArray.push(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c5afab4d5c610ba2$export$2e2bcd8739ae039), {
        testId: 'notification-dismiss-button',
        onClick: onClose,
        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_DISMISS_BUTTON_LABEL)
    }, 'notification-dismiss-button'));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $548d2678bd231d64$var$_
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_p12f5o3v"
                ]),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91a181e7dea5ded3$export$2e2bcd8739ae039), {
                    appearance: appearance,
                    title: title,
                    actions: actionsArray.length > 0 ? actionsArray : undefined,
                    children: children
                })
            })
        ]
    });
};
const $548d2678bd231d64$export$3e68361a3d3e7b9f = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($548d2678bd231d64$var$Notification, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        appearance: 'error'
    }, props));
const $548d2678bd231d64$export$e80deec18a12daba = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($548d2678bd231d64$var$Notification, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        appearance: 'success'
    }, props));
const $548d2678bd231d64$export$8cc5afb04fcb8e07 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($548d2678bd231d64$var$Notification, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        appearance: 'warning'
    }, props));





parcelRequire("7fPBF");
const $01a16cfcd495a436$export$b29f828819edca8d = (value, start, end)=>{
    const source = value.split(' ');
    const target = source.slice(start, end).join(' ');
    let before = [];
    if (start < 0) before = source.slice(0, source.length + start);
    else if (start > 0) before = source.slice(0, start);
    let after = [];
    if (end != null && end < 0) after = source.slice(source.length + end);
    else if (end != null && end > 0) after = source.slice(end);
    return {
        before: before.join(' '),
        target: target,
        after: after.join(' ')
    };
};




const $8773d15fad8814a3$var$WrapStrong = ({ value: value, start: start, end: end })=>{
    const { before: before, target: target, after: after } = (0, $01a16cfcd495a436$export$b29f828819edca8d)(value, start, end);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            before,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("strong", {
                children: [
                    " ",
                    target,
                    " "
                ]
            }),
            after
        ]
    });
};
var $8773d15fad8814a3$export$2e2bcd8739ae039 = $8773d15fad8814a3$var$WrapStrong;




parcelRequire("7fPBF");

const $aabac7154905f978$var$ErrorRequest = ()=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $548d2678bd231d64$export$3e68361a3d3e7b9f), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_ERROR_MESSAGE_TITLE),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8773d15fad8814a3$export$2e2bcd8739ae039), {
                value: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_ERROR_MESSAGE_DESCRIPTION),
                start: -4
            })
        })
    });
};
var $aabac7154905f978$export$2e2bcd8739ae039 = $aabac7154905f978$var$ErrorRequest;







parcelRequire("7fPBF");

const $b022cce77af6b4bc$var$SuccessUpdateConsent = ({ data: data })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    let content = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UPDATE_SUCCESS_MESSAGE_DESCRIPTION)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("small", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8773d15fad8814a3$export$2e2bcd8739ae039), {
                    value: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_NOTE_MESSAGE),
                    start: 0,
                    end: 2
                })
            })
        ]
    });
    if (data === 'DOUBLE_OPT_IN') content = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UPDATE_CONSENT_DOUBLE_OPT_IN_MESSAGE)
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $548d2678bd231d64$export$e80deec18a12daba), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UPDATE_SUCCESS_MESSAGE_TITLE),
        children: content
    });
};
var $b022cce77af6b4bc$export$2e2bcd8739ae039 = $b022cce77af6b4bc$var$SuccessUpdateConsent;









parcelRequire("7fPBF");

const $7551ffa32d2a4800$var$styles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    height: '100%',
    marginTop: '0',
    marginBottom: '0',
    marginLeft: 'space.0',
    marginRight: 'space.0',
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.sm]: {
        marginLeft: 'space.400',
        marginRight: 'space.400'
    },
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.md]: {
        marginLeft: 'space.800',
        marginRight: 'space.800'
    },
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.lg]: {
        marginLeft: 'space.1000',
        marginRight: 'space.1000'
    }
});
const $7551ffa32d2a4800$export$3a31c848ced7e406 = (attributes)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: "div"
    }, attributes), {
        xcss: $7551ffa32d2a4800$var$styles
    }));
$7551ffa32d2a4800$export$3a31c848ced7e406.displayName = 'PageWrapper';




const $cccf8465b61394af$var$_5 = "._otyr14lv{margin-bottom:var(--_cpuyf2)}";
const $cccf8465b61394af$var$_4 = "._19pk1ul9{margin-top:var(--_18cq338)}";
const $cccf8465b61394af$var$_3 = "._1bah1h6o{justify-content:center}";
const $cccf8465b61394af$var$_2 = "._1e0c1txw{display:flex}";
const $cccf8465b61394af$var$_ = "._1yt44uxf{padding:0 var(--_r6pg4u) var(--_cpuyf2)}";
const $cccf8465b61394af$var$styles = null;
const $cccf8465b61394af$var$resolveActionResultStatus = (status, data)=>{
    switch(status){
        case 'success':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b022cce77af6b4bc$export$2e2bcd8739ae039), {
                data: data
            });
        case 'error':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aabac7154905f978$export$2e2bcd8739ae039), {});
    }
};
const $cccf8465b61394af$var$ActionNotification = ()=>{
    const actionResult = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $e745f2f77eae858d$export$a2262118789c43db));
    if (actionResult == null) return null;
    const notification = $cccf8465b61394af$var$resolveActionResultStatus(actionResult.status, actionResult.action);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                    children: [
                        $cccf8465b61394af$var$_,
                        $cccf8465b61394af$var$_2,
                        $cccf8465b61394af$var$_3,
                        $cccf8465b61394af$var$_4,
                        $cccf8465b61394af$var$_5
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    "data-testid": "consent-action-notification",
                    className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                        "_1yt44uxf _1e0c1txw _1bah1h6o _19pk1ul9 _otyr14lv"
                    ]),
                    style: {
                        "--_r6pg4u": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.400')),
                        "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200')),
                        "--_18cq338": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.100'))
                    },
                    children: notification
                })
            ]
        })
    });
};
var $cccf8465b61394af$export$2e2bcd8739ae039 = $cccf8465b61394af$var$ActionNotification;






parcelRequire("7fPBF");
/* InfoView.tsx generated by @compiled/babel-plugin v0.38.1 */ 



parcelRequire("7fPBF");
const $63d0fb3ee0a87d37$var$LinkButton = ({ appearance: appearance, href: href, target: target, iconAfter: iconAfter, onClick: onClick, children: children })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b6738ae824ea86e7$export$2e2bcd8739ae039), {
        appearance: appearance !== null && appearance !== void 0 ? appearance : 'subtle-link',
        href: href,
        target: target,
        rel: 'noreferrer',
        iconAfter: iconAfter,
        onClick: onClick,
        children: children
    });
var $63d0fb3ee0a87d37$export$2e2bcd8739ae039 = $63d0fb3ee0a87d37$var$LinkButton;




parcelRequire("7fPBF");



const $9bbee8e48028edce$var$_5 = "._4cvr1h6o{align-items:center}";
const $9bbee8e48028edce$var$_4 = "._1bah1h6o{justify-content:center}";
const $9bbee8e48028edce$var$_3 = "._2lx21bp4{flex-direction:column}";
const $9bbee8e48028edce$var$_2 = "._1e0c1txw{display:flex}";
const $9bbee8e48028edce$var$_ = "._1yt414lv{padding:var(--_cpuyf2)}";
const $9bbee8e48028edce$var$infoViewWrapperStyle = null;
const $9bbee8e48028edce$var$infoViewTitleWrapperStyle = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    textAlign: 'center',
    marginTop: 'space.300',
    marginBottom: 'space.300',
    marginLeft: '0',
    marginRight: '0'
});
const $9bbee8e48028edce$var$InfoView = ({ title: title, hero: hero })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $9bbee8e48028edce$var$_,
                    $9bbee8e48028edce$var$_2,
                    $9bbee8e48028edce$var$_3,
                    $9bbee8e48028edce$var$_4,
                    $9bbee8e48028edce$var$_5
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1yt414lv _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"
                ]),
                style: {
                    "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200'))
                },
                children: [
                    hero,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        as: "h3",
                        xcss: $9bbee8e48028edce$var$infoViewTitleWrapperStyle,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d0fb3ee0a87d37$export$2e2bcd8739ae039), {
                        appearance: 'primary',
                        href: 'https://www.atlassian.com',
                        children: translate((0, $447ba15143f7eed7$exports).GOTO_ATLASSIAN_BUTTON_LABEL)
                    })
                ]
            })
        ]
    });
};
var $9bbee8e48028edce$export$2e2bcd8739ae039 = $9bbee8e48028edce$var$InfoView;





/* BuildingImage.tsx generated by @compiled/babel-plugin v0.38.1 */ 



parcelRequire("7fPBF");




parcelRequire("7fPBF");
const $6a6ffc0befe8bbd7$var$SvgBuildingFunctionality = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 468.37 558.91"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: 197.53,
                        y1: 106.01,
                        x2: 230.87,
                        y2: 106.01,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.52,
                                stopColor: "#172b4d"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: 186.82,
                        y1: 92.83,
                        x2: 186.82,
                        y2: 83.27,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#a17f68"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#916d5a"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-3",
                        x1: 148.3,
                        y1: 103.48,
                        x2: 181.59,
                        y2: 103.48,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.52,
                                stopColor: "#091e42"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-4",
                        x1: 168.5,
                        y1: 114.03,
                        x2: 187.15,
                        y2: 95.38,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.48,
                                stopColor: "#172b4d"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#344563"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "linear-gradient-5",
                        x1: 198.76,
                        y1: 119.43,
                        x2: 198.76,
                        y2: 89.34,
                        xlinkHref: "#linear-gradient-4"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "N75",
                        x1: -513.46,
                        y1: 9361.18,
                        x2: -394.06,
                        y2: 9361.18,
                        gradientTransform: "rotate(99.68 3603.132 5129.663)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#e5e8ec"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#e5e8ec",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "N75-2",
                        x1: -585.26,
                        y1: 9005.02,
                        x2: -465.85,
                        y2: 9005.02,
                        gradientTransform: "rotate(99.68 3500.572 5043.116)",
                        xlinkHref: "#N75"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-6",
                        x1: 309.05,
                        y1: 443.4,
                        x2: 393.51,
                        y2: 358.95,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#dfe1e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "New_Gradient_Swatch_12",
                        x1: 294.7,
                        y1: 429.05,
                        x2: 379.15,
                        y2: 344.6,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "N75-3",
                        x1: -629.11,
                        y1: 9518.35,
                        x2: -509.71,
                        y2: 9518.35,
                        gradientTransform: "rotate(99.68 3710.337 5220.13)",
                        xlinkHref: "#N75"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "linear-gradient-7",
                        x1: 230.99,
                        y1: 307.64,
                        x2: 315.44,
                        y2: 223.19,
                        xlinkHref: "#linear-gradient-6"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "N75-4",
                        x1: -445.12,
                        y1: 9221.13,
                        x2: -325.71,
                        y2: 9221.13,
                        gradientTransform: "rotate(99.68 3500.572 5043.116)",
                        xlinkHref: "#N75"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "N75-5",
                        x1: -402.42,
                        y1: 9471.56,
                        x2: -283.01,
                        y2: 9471.56,
                        gradientTransform: "rotate(99.68 3705.697 5216.214)",
                        xlinkHref: "#N75"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "N75-6",
                        x1: -361.89,
                        y1: 9709.41,
                        x2: -242.49,
                        y2: 9709.41,
                        gradientTransform: "rotate(99.68 3904.497 5383.976)",
                        xlinkHref: "#N75"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "New_Gradient_Swatch_15",
                        x1: 429.34,
                        y1: 537.44,
                        x2: 429.34,
                        y2: 446.6,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#4c9aff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-8",
                        x1: 326.37,
                        y1: 320.21,
                        x2: 371.48,
                        y2: 320.21,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#fff0b2"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ffc400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "linear-gradient-9",
                        x1: 324.1,
                        y1: 302.17,
                        x2: 338.02,
                        y2: 302.17,
                        xlinkHref: "#linear-gradient-8"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "New_Gradient_Swatch_7",
                        x1: 103.18,
                        y1: 322.47,
                        x2: 147.53,
                        y2: 322.47,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#ffc400"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#fff0b2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-10",
                        x1: 234.19,
                        y1: 117.42,
                        x2: 234.19,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.54,
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.71,
                                stopColor: "#c1c7d0",
                                stopOpacity: 0.61
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.91,
                                stopColor: "#c1c7d0",
                                stopOpacity: 0.17
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#c1c7d0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "New_Gradient_Swatch_5",
                        x1: 361.32,
                        y1: 500.83,
                        x2: 361.32,
                        y2: 447.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#ff991f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ffc400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_5-2",
                        x1: 341.8,
                        y1: 473.94,
                        x2: 379.72,
                        y2: 473.94,
                        xlinkHref: "#New_Gradient_Swatch_5"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "linear-gradient-11",
                        x1: 320.88,
                        y1: 390.86,
                        x2: 382.38,
                        y2: 452.37,
                        xlinkHref: "#linear-gradient-8"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("radialGradient", {
                        id: "radial-gradient",
                        cx: 231.33,
                        cy: 317.71,
                        r: 96.52,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#fff0b2"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.16,
                                stopColor: "#ffe587",
                                stopOpacity: 0.76
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.32,
                                stopColor: "#ffdb5f",
                                stopOpacity: 0.53
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#ffd33d",
                                stopOpacity: 0.34
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.64,
                                stopColor: "#ffcd22",
                                stopOpacity: 0.19
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.78,
                                stopColor: "#ffc810",
                                stopOpacity: 0.09
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.9,
                                stopColor: "#ffc504",
                                stopOpacity: 0.02
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ffc400",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: ".bcls-2{fill:#a17f68}.bcls-4{fill:#172b4d}.bcls-6{fill:#091e42}.bcls-9{fill:#2684ff}.bcls-10,.bcls-34,.bcls-35{fill:none}.bcls-10,.bcls-34{stroke:#dfe1e5}.bcls-10{stroke-miterlimit:10;stroke-width:.48px}.bcls-34,.bcls-35{stroke-linecap:round}.bcls-15{fill:#0052cc}.bcls-17{fill:#0065ff}.bcls-22{fill:#c1c7d0}.bcls-26{fill:#00c7e5}.bcls-34,.bcls-35{stroke-width:4.85px;stroke-linejoin:round}.bcls-35{stroke:#0065ff;stroke-width:4.02px}.bcls-38{fill:#72594b}.bcls-44{fill:#dfe1e5}.bcls-45{fill:#b3bac5}.bcls-46{fill:#42526e}"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    isolation: "isolate"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                    id: "Layer_2",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                        id: "Layer_1-2",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-2",
                                d: "M229.69 103.77c-.94 0-1.63-1.48-1.81-2.48a4.17 4.17 0 0 1 .69-3.15c.89-1.17 1.74-.83 3.29-2.14s1.89-2.62 2.32-2.51.41 1.17.19 2.07c-.41 1.68-1.51 1.76-2.21 3.51-.56 1.39-.06 1.85-.83 3.17-.27.47-.88 1.5-1.64 1.53Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-2",
                                d: "M229.52 97.75s5.66-.72 6.68-1.82 1.15-2.18 1.76-2.05-.09 2.25.16 2.57.72.17.63.84a5.64 5.64 0 0 1-.52 2.2c-.42.71-3.12 3.26-4.43 3.66s-4 1.37-5.3.86.31-5.28.31-5.28Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M201.23 92.91c.92 1.45 1.85 2.91 2.79 4.36q3.66 5.72 7.34 11.34l16.48-10 3 7.4c-2.66 2.05-6.6 5-11.61 8.19s-7.35 5.46-10.38 4.83c-1.66-.34-2.7-1.3-4.54-3a31.42 31.42 0 0 1-6.81-9.58q1.89-6.79 3.73-13.54Z",
                                style: {
                                    fill: "url(#linear-gradient)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-4",
                                d: "M205.17 149.6h-36.28l5-30.17h25.28l6 30.17z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M192.42 89.78a7 7 0 0 1-11.2.52 4.52 4.52 0 0 0 1-1 5.44 5.44 0 0 0 .51-.87 8.6 8.6 0 0 0 0-4.62l8.94-.58c-.1.83-.23 2-.38 3.4a3.49 3.49 0 0 0 .21 2.09 2.75 2.75 0 0 0 .92 1.06Z",
                                style: {
                                    fill: "url(#linear-gradient-2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-6",
                                d: "m186.89 223.28.43-1.58a36.06 36.06 0 0 0 6.51-3.56 36.79 36.79 0 0 0 5-4.08l5.67.4a33.67 33.67 0 0 1 .73 3.7 34.47 34.47 0 0 1 .3 3.68h-3.48c-.33-.21-.65-.43-1-.65-.23.26-.46.53-.7.79a41.22 41.22 0 0 1-8.73 1.33 42.82 42.82 0 0 1-4.73-.03ZM163.06 220.4l.62-1.56a29.29 29.29 0 0 0 11.32-7.66l5.43.82a17.86 17.86 0 0 1 1.27 7.66l-3.41.35-1-1.13-1.23 1-3.23.44h-3.85c-1.98.04-3.98.06-5.92.08Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M181.59 89.39a13.62 13.62 0 0 0-6.05 2.53 14.28 14.28 0 0 0-3.93 4.85 66.41 66.41 0 0 1-9 12.15l-8.23-7.07q-3 5-6.1 10a24.18 24.18 0 0 0 6.93 4.23c2.35.92 4.53 1.79 7.24 1.39 1-.14 2.71-.43 6.42-3.41a69.36 69.36 0 0 0 7.89-7.45Z",
                                style: {
                                    fill: "url(#linear-gradient-3)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M177.08 117.53c-.27 1.72-.67 4.32-1.05 7.5a216 216 0 0 0-1.31 35.51c.37 10.64.45 26.74-.76 51.29h2.37a60.07 60.07 0 0 0 11-1l.57-54.42q3.67 28.95 7.36 57.91a23.6 23.6 0 0 0 13.84 0q-1-15.49-2.82-32-1-9.36-2.27-18.35c-.16-4.26-.4-7.75-.6-10.13a165 165 0 0 0-4.88-30.53c-.71-2.68-1.37-4.83-1.77-6.14-6.47.23-13.17.22-19.68.36Z",
                                style: {
                                    fill: "#0049b0"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-9",
                                d: "M191.24 87.78a5.84 5.84 0 0 1-8.39.22l-.66 1.34a5.62 5.62 0 0 0 10 0Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-9",
                                d: "M178.62 90.15a11.29 11.29 0 0 1 3.57-.81 5.55 5.55 0 0 0 9.91 0c.72.09 2.62.92 4.11 1.13a8.23 8.23 0 0 1 1.83.42 7.45 7.45 0 0 1 3.49 2.46c1.65 2.1 1.37 6.31-1.27 10-1.28 4-3.57 5.94-4.86 9.91.53 1.39 1.06 2.78 1.6 4.17q-5.56.07-11.22.1h-8.7c-.69-4.49-.85-5.1-1.84-6.67a22.15 22.15 0 0 1-2.17-5.36 6.75 6.75 0 0 1-.17-1.47c-.06-3.2 1.48-3.48 1.79-8.16.09-1.41 0-2.54.85-3.67a6.6 6.6 0 0 1 3.08-2.05Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-6",
                                d: "M163.49 109.21h-11.55a2.26 2.26 0 0 1-2.12-1.49l-5.56-15.5a1.12 1.12 0 0 1 1.05-1.51h11.56A2.24 2.24 0 0 1 159 92.2l5.57 15.51a1.12 1.12 0 0 1-1.08 1.5Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-2",
                                d: "M150.62 102.77c-.19 1.15-1.28 2.39-2.14 2.23a1.6 1.6 0 0 1-1-1.1c-.15-.47.06-.63-.13-1.06s-.6-.47-.76-1c-.09-.26 0-.31 0-.94 0-.83-.16-.87-.08-1.17a1.77 1.77 0 0 1 2-1c.26.08.21.18.64.38.67.33 1 .18 1.22.43s.15.55.15 1.3c-.04 1.35.19 1.34.1 1.93Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-4",
                                d: "M201.35 119.43c.43.86.85 1.74 1.25 2.65a59.16 59.16 0 0 1 4.63 27.52h-13.07l-1.95-30.17Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-2",
                                d: "M190.3 84.41c.72-.38 1.28-.74 1.66-1a7.58 7.58 0 0 0 2.43-4.2 7.39 7.39 0 0 0-.06-3l-.18-.87a8.15 8.15 0 0 0-5.1-6l-.18-.08a8 8 0 0 0-2.36-.51 8.19 8.19 0 0 0-2.41.19c-1.45.35-4.09 1.56-5 4a29.6 29.6 0 0 0-.8 4.74 14.66 14.66 0 0 1-.28 1.45 13.49 13.49 0 0 1-.6 1.83l1.23.54a11.07 11.07 0 0 0 .79 3.5 3.22 3.22 0 0 0 .9 1.47c.49.38 1.19.55 3.57.09a20.61 20.61 0 0 0 6.39-2.15Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-6",
                                d: "M177.3 74.5c1.4.2 2.89.36 4.46.47 2.1.15 4.07.19 5.89.15q.09 7.71.19 15.41c1.19-.73 6.28-4.07 7.51-10.31.28-1.47 1.19-6.1-1.67-9.66a9.51 9.51 0 0 0-4-2.85c-.92-.35-5.45-2-9.09.79a9 9 0 0 0-3.29 6Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ellipse", {
                                className: "bcls-10",
                                cx: 177.46,
                                cy: 76.95,
                                rx: 1.1,
                                ry: 1.53
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ellipse", {
                                className: "bcls-10",
                                cx: 181.37,
                                cy: 76.95,
                                rx: 1.1,
                                ry: 1.53
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-10",
                                d: "M178.56 76.95h1.71"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                style: {
                                    strokeWidth: ".48px",
                                    strokeLinecap: "round",
                                    strokeMiterlimit: 10,
                                    stroke: "#dfe1e5",
                                    fill: "none"
                                },
                                d: "M182.48 76.95h6.21"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M171.83 96.1c-1.11 2-2.54 4.24-4.56 7.24q3.31 8 6.62 16.09c.45.09.92.17 1.41.25.92.13 1.79.21 2.6.25a43.12 43.12 0 0 0 1.09-7c.35-4.78-.27-7.33-.32-10.69a32.24 32.24 0 0 1 2.55-12.78c-.37.07-.76.16-1.16.27s-.92.26-1.44.44a12.56 12.56 0 0 0-2.12.88l-.3.17c-1.34.78-4.2 4.65-4.37 4.88Z",
                                style: {
                                    fill: "url(#linear-gradient-4)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M206.35 102.22c-1.28 3.15-4.87 15.19-5 17.21h-9.14a29.17 29.17 0 0 1-.56-12.94c.61-3.17 1.64-5.26 1.71-9.1a23.76 23.76 0 0 0-1.26-8c.74.08 1.51.2 2.31.32a17.46 17.46 0 0 1 2.59.49 19.64 19.64 0 0 1 3.39 1.71c1.15.72 5.25 8.15 5.96 10.31Z",
                                style: {
                                    fill: "url(#linear-gradient-5)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-4",
                                d: "m170.34 149.6 5.69-.1c.62-9.86 1.87-29.57 1.87-29.57l-2.6-.25Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                                cx: 231.33,
                                cy: 317.71,
                                r: 96.52,
                                style: {
                                    opacity: 0.38,
                                    fill: "url(#radial-gradient)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Rectangle_",
                                className: "bcls-15",
                                d: "M78.06 355.76h78.06v90.84H78.06z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M128.73 419.35c-8.89-16.26-4.13-23.6-14.16-38.4a76.14 76.14 0 0 0-29.81-25.19h-6.7v90.84H156c-9.79-5.75-20.08-14.09-27.27-27.25Z",
                                style: {
                                    fill: "url(#N75)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Rectangle_2",
                                className: "bcls-17",
                                d: "M156.12 355.76h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Rectangle_3",
                                style: {
                                    fill: "#00b8d9"
                                },
                                d: "M234.19 355.76h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M312.25 440.5c-12.62-5.5-31.72-14.28-43.07-35.05-8.88-16.26-4.13-23.6-14.15-38.4a70.47 70.47 0 0 0-9.66-11.29h-11.18v90.84h78.06Z",
                                style: {
                                    fill: "url(#N75-2)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                style: {
                                    fill: "url(#linear-gradient-6)"
                                },
                                d: "M312.25 355.76h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M342.58 390.39c0 6.73.28 13.45.63 20.17 4.92-.08 13.48-.11 21.62-.11.05-7 .22-14 .23-21 0-.2 13-.27 25.25-.26v-33.43h-78.06v34.38c13.43-.05 30.33.02 30.33.25Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_12)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Rectangle_4",
                                className: "bcls-22",
                                d: "M156.12 220h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M234.19 309.71c-12.19-5.66-27.95-14.65-37.82-32.71-8.88-16.26-4.13-23.6-14.15-38.39A75.1 75.1 0 0 0 163.69 220h-7.57v90.84h78.07Z",
                                style: {
                                    fill: "url(#N75-3)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                style: {
                                    fill: "url(#linear-gradient-7)"
                                },
                                d: "M234.19 220h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-15",
                                d: "M90.39 340.13h30.04v15.63H90.39zM141.11 340.13h30.04v15.63h-30.04zM191.82 340.13h30.04v15.63h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Rectangle_5",
                                className: "bcls-15",
                                d: "M0 446.6h78.06v90.84H0z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M49.71 510.19c-8.88-16.26-4.13-23.6-14.15-38.4A76.21 76.21 0 0 0 5.75 446.6H0v90.84h77c-9.8-5.75-20.1-14.09-27.29-27.25Z",
                                style: {
                                    fill: "url(#N75-4)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Rectangle_6",
                                className: "bcls-17",
                                d: "M78.06 446.6h78.06v90.84H78.06z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-15",
                                d: "M12.33 430.97h30.04v15.63H12.33zM63.04 430.97h30.04v15.63H63.04zM113.76 430.97h30.04v15.63h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-26",
                                d: "M246.52 340.13h30.04v15.63h-30.04zM297.23 340.13h30.04v15.63h-30.04zM347.94 340.13h30.04v15.63h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Rectangle_7",
                                className: "bcls-15",
                                d: "M156.12 446.6h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M206 510.19c-8.88-16.26-4.13-23.6-14.16-38.4A76.14 76.14 0 0 0 162 446.6h-5.9v90.84h77.15c-9.77-5.75-20.07-14.09-27.25-27.25Z",
                                style: {
                                    fill: "url(#N75-5)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Rectangle_8",
                                className: "bcls-17",
                                d: "M234.19 446.6h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Rectangle_9",
                                className: "bcls-15",
                                d: "M312.25 446.6h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M362.51 510.19c-8.88-16.26-4.13-23.6-14.16-38.4a76.14 76.14 0 0 0-29.81-25.19h-6.29v90.84h77.54c-9.79-5.75-20.09-14.09-27.28-27.25Z",
                                style: {
                                    fill: "url(#N75-6)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                style: {
                                    fill: "url(#New_Gradient_Swatch_15)"
                                },
                                d: "M390.31 446.6h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-15",
                                d: "M168.45 430.97h30.04v15.63h-30.04zM219.17 430.97h30.04v15.63h-30.04zM269.88 430.97h30.04v15.63h-30.04zM324.58 430.97h30.04v15.63h-30.04zM375.29 430.97h30.04v15.63h-30.04zM426.01 430.97h30.04v15.63h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-22",
                                d: "M219.17 204.37h30.04V220h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M350.56 328.76 371.23 316a.54.54 0 0 0-.34-1l-22.26 2.24-.52-5.14a.54.54 0 0 0-.82-.4l-20.66 12.79a.54.54 0 0 0 .33 1l22.27-2.24.52 5.15a.54.54 0 0 0 .81.36Z",
                                style: {
                                    fill: "url(#linear-gradient-8)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "m334.41 304.86 3.6-11.58a.24.24 0 0 0-.4-.23l-7.63 8.1-1.89-1.78a.23.23 0 0 0-.38.11l-3.6 11.58a.23.23 0 0 0 .39.23l7.64-8.1L334 305a.24.24 0 0 0 .41-.14Z",
                                style: {
                                    fill: "url(#linear-gradient-9)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "m128 314.16-24.26 1.54a.54.54 0 0 0-.17 1l20.69 8.52-2 4.79a.53.53 0 0 0 .53.73l24.21-1.51a.53.53 0 0 0 .17-1l-20.7-8.53 2-4.78a.53.53 0 0 0-.47-.76Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_7)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                style: {
                                    stroke: "url(#linear-gradient-10)",
                                    strokeWidth: "4.85px",
                                    strokeMiterlimit: 10,
                                    fill: "none"
                                },
                                d: "M234.19 117.42V0"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-34",
                                d: "M234.19 166.27 156.12 220v88.56"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-35",
                                d: "M225.59 162.93a8.6 8.6 0 1 0 10.41-8.41 2.24 2.24 0 0 1-1.78-2.19v-7.18"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                                className: "bcls-35",
                                cx: 234.19,
                                cy: 123.8,
                                r: 6.38
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-17",
                                d: "M235.88 146.1h-3.38a4.2 4.2 0 0 1-4.18-3.77l-1.14-10.89a4.21 4.21 0 0 1 4.18-4.64H237a4.21 4.21 0 0 1 4.18 4.64l-1.13 10.89a4.21 4.21 0 0 1-4.17 3.77Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-22",
                                d: "M168.45 204.37h30.04V220h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-34",
                                d: "M312.25 308.56V220l-78.06-53.73"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-22",
                                d: "M269.88 204.37h30.04V220h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                style: {
                                    stroke: "#cfd4db",
                                    strokeWidth: "2.13px",
                                    strokeLinejoin: "round",
                                    strokeLinecap: "round",
                                    fill: "none"
                                },
                                d: "M325.66 384.85v-9.02h-9.91v-6.32h23.95"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                x: 317.73,
                                y: 366.76,
                                width: 21.88,
                                height: 6.06,
                                rx: 1.97,
                                ry: 1.97,
                                style: {
                                    fill: "#344563"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-38",
                                d: "M325.26 389.78a3.63 3.63 0 0 0 3-.61c3-2.25.3-11.06-.66-10.94-.15 0-2.1-.27-2.25-.25a19.56 19.56 0 0 0-2.25 1.22c-.75.68-.67 2.08-.73 3.32a6.39 6.39 0 0 0 .77 3.35Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M383.89 424.57c.13.41.31 1 .51 1.81.56 2.22.91 4.51 1.21 10.86.25 5.34 0 3.73.19 6.43.19 2.88.48 4.83-.57 7a7.61 7.61 0 0 1-1.2 1.76l-18.48 17.26-4.77-3.2 17.87-19.51-3-22.44 4.29-1.14Z",
                                style: {
                                    fill: "#ffab00"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-38",
                                d: "M377.94 454a18.16 18.16 0 0 0-1.8-4.69 20 20 0 0 1-2.15.55c-.8.16-1.43.22-1.76.26-1.9.28-5.52.71-15.28 1.46a27.43 27.43 0 0 0-1.84 2.57 30.56 30.56 0 0 0-3.87 9.31c-6.62 27.24-7.1 28.16-7.1 28.16q-1.38 7.86-2.67 15.93c-1.68 10.64-4 30.8-5.24 41a4.21 4.21 0 0 0 1.23 1.82 4.33 4.33 0 0 0 2 .89c2.51.35 6.89-12.86 6.89-12.86 3.61-10.88 4.6-25.23 4.62-26.73a40.91 40.91 0 0 0-.47-6.8q4.29-8.13 8.57-16.37 3.33-6.39 6.61-12.76-.09 15.3 0 31 .15 19.09.6 37.67a3.19 3.19 0 0 0 1.22.63 3.6 3.6 0 0 0 2.19-.23 6.27 6.27 0 0 0 3-1.79 189.17 189.17 0 0 0 2.95-23.29c.7-11.06-.32-10.28.29-19.22.94-13.57 4.55-32.9 3.6-39.18-.21-1.07-1.07-5.05-1.59-7.33Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-4",
                                d: "M367 398.91c-.73-1.12-1.67-2.82-1.06-3.67s1.82-.23 5-.11c4.49.17 5-.6 7.26.13a8.61 8.61 0 0 1 4.51 3.13c2.17 3.07 1.17 6.92.86 8.08a12.89 12.89 0 0 1-5.85 7.45l-2.45 1.56-6.89-11.89Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M374.87 419.65h-9.32a17.22 17.22 0 0 0 1-10.5l5.69-.28c.07.34.17.82.33 1.4a3.82 3.82 0 0 0 .62 1.58c.65.61 1.89.25 2.26.13-.19 2.56-.39 5.12-.58 7.67Z",
                                style: {
                                    fill: "#543e36"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M376.9 500.47v-.53c.37-5.41 1.17-11.71 1.94-17.81 1.15-9.1 2.24-17.69 1.65-21.6-.17-1.09-1-5.15-1.56-7.36a19.41 19.41 0 0 0-.71-2.36 19.63 19.63 0 0 0-1.19-2.6l-.41-.75-.82.25a17.93 17.93 0 0 1-2 .52c-.58.11-1.06.18-1.4.22h-.31c-1.79.26-5.31.69-15.21 1.44h-.46l-.28.35a30.28 30.28 0 0 0-5.91 12.3c-5.9 24.29-6.9 27.57-7 28v.25c-.39 2.2-.77 4.43-1.15 6.67 3 2.43 7.37 3.13 11.72 2.85l6.27-12q2.32-4.45 4.61-8.89v19.74a22.27 22.27 0 0 0 12.22 1.31Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_5)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M376.43 467.67a14.4 14.4 0 0 0 3.05-6.39 19.33 19.33 0 0 0-.52-8.11 22.29 22.29 0 0 0-.71-2.36 19.63 19.63 0 0 0-1.19-2.6l-.41-.75-.82.25a17.93 17.93 0 0 1-2 .52c-.58.11-1.06.18-1.4.22h-.31c-1.79.26-5.31.69-15.21 1.44h-.46l-.28.35a31.55 31.55 0 0 0-1.91 2.67c-3.41 5.41-4.6 12.53-6.26 18.68q-1.86 6.9-3.5 13.86c-.27 1.16-3.39 11.25-2.5 12 3 2.43 7.37 3.13 11.72 2.85l6.27-12c2.53-4.86 4.68-9.46 8.74-13.25 2.55-2.34 5.5-4.61 7.7-7.38Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_5-2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-38",
                                d: "m367 398.91-1.37 3.09-4 2.45c.32.56.64 1.13 1 1.69-.12 2-.23 4.07-.35 6.11a15.24 15.24 0 0 0 3.9 2c.54.19.77.19 5.55.36 2.05.07 3.08.09 3.54-.47a2.7 2.7 0 0 0 .17-2.53c-.32-.76-.7-.69-1.06-1.43-.55-1.16.14-1.84-.21-2.93s-1.17-.86-2.45-2.2c-1.45-1.51-1.16-2.5-2.6-4.29a8 8 0 0 0-2.12-1.85Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M332.07 419.64a77.13 77.13 0 0 0 23 9.95c0 2.72-.12 5.58-.35 8.57a129.63 129.63 0 0 1-1.91 14.52 39.4 39.4 0 0 0 27.2 2.08 95.5 95.5 0 0 1 2.8-20.76q.63-2.52 1.35-4.86a6.36 6.36 0 0 0-2.52-7.19h-.05s-.39-.26-1-.62c0 0-1.1-.65-2.24-1.22-4.79-2.39-13.54-3.2-13.54-3.2-11.95-1.12-11.54-.91-13.85-1.28a58.44 58.44 0 0 1-12.6-3.52q-4.17-12.7-8.35-25.41l-6.62 1.73c1.07 5.43 2.43 11.25 4.17 17.37 1.44 4.87 2.95 9.51 4.51 13.84Z",
                                style: {
                                    fill: "url(#linear-gradient-11)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-44",
                                d: "M373.05 547.23h-7.21c.1-1.24.17-2.55.19-3.93v-2.51a18.86 18.86 0 0 1 3.6-.27 18.22 18.22 0 0 1 3.24.34 20 20 0 0 0 .2 6.37ZM342.15 552.52h-7.21c.06-1.28 1.23-5.19 1.29-6.47 1.3-.14 2.63-.3 4-.47s2.37-.31 3.54-.48q-.48 1.77-.9 3.72c-.31 1.28-.53 2.52-.72 3.7Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-45",
                                d: "M371.73 550a3.67 3.67 0 0 0-3.67 3.6h3.76V550Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-45",
                                d: "M371.46 550a3.68 3.68 0 0 1 3.67 3.6h-3.77V550Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Path_",
                                className: "bcls-46",
                                d: "M367.33 546.71s-.51-1.12-1-1.36c-1-.46-.09 2.6-2.37 4.58a8.42 8.42 0 0 1-2.84 1.65.89.89 0 0 0-.51.87v.85h13.79a15.66 15.66 0 0 0-1.23-6.62Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-45",
                                d: "M343.34 555.31a3.66 3.66 0 0 0-3.66 3.6h3.76v-3.59Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Path_2",
                                className: "bcls-46",
                                d: "M336.43 552c-.14.06-.52-1.13-1.05-1.36-1-.46-2.72 2.6-5.72 4.58a12.8 12.8 0 0 1-3.76 1.65.9.9 0 0 0-.68.87v.85h18.23a15.51 15.51 0 0 0-.4-4.08 16.27 16.27 0 0 0-.83-2.55Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "bcls-4",
                                d: "M362.64 406.12a1.5 1.5 0 0 0-.51.68 1.6 1.6 0 0 0 0 .94 6.21 6.21 0 0 0 1.54.53 6.05 6.05 0 0 0 1.19.12c0 .32-.08.74-.15 1.24-.18 1.33-.29 1.46-.4 1.52-.42.24-1.3-.26-1.64-1a1.77 1.77 0 0 1-.18-.82 2.86 2.86 0 0 0-.9 1.45 2.67 2.67 0 0 0 .36 2.09 4.57 4.57 0 0 0 2.72 1.64h.38c5.19.26 5.54.26 5.86.16 2.93-.88 2.73-9.85 2.72-10.23l-3.26-2a4.25 4.25 0 0 1 .41 3.66c-.11.27-.71 1.79-1.93 2s-1.92-1.13-4.37-1.82a8.94 8.94 0 0 0-1.84-.16Z"
                            })
                        ]
                    })
                })
            })
        ]
    }));
var $6a6ffc0befe8bbd7$export$2e2bcd8739ae039 = $6a6ffc0befe8bbd7$var$SvgBuildingFunctionality;


const $139978517f0651d4$var$_2 = "._c71lr0r7{max-height:250px}";
const $139978517f0651d4$var$_ = "._1yt414lv{padding:var(--_cpuyf2)}";
const $139978517f0651d4$var$styles = null;
const $139978517f0651d4$export$fe8dceec803a025 = (attributes)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $139978517f0651d4$var$_,
                    $139978517f0651d4$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a6ffc0befe8bbd7$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1yt414lv _c71lr0r7"
                ]),
                style: {
                    "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200'))
                }
            }))
        ]
    });
$139978517f0651d4$export$fe8dceec803a025.displayName = 'BuildingImage';


const $69541c48b8b26100$var$DownForMaintenanceView = ({ message: message })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9bbee8e48028edce$export$2e2bcd8739ae039), {
        title: translate(message),
        hero: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $139978517f0651d4$export$fe8dceec803a025), {})
    });
};
var $69541c48b8b26100$export$2e2bcd8739ae039 = $69541c48b8b26100$var$DownForMaintenanceView;





parcelRequire("7fPBF");


const $2a77727daa1ec115$var$StatusView = ()=>{
    const { status: status, message: message } = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $e745f2f77eae858d$export$f4442397935fb087));
    if (status === 'down-for-maintenance') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69541c48b8b26100$export$2e2bcd8739ae039), {
            message: message
        })
    });
    else return null;
};
var $2a77727daa1ec115$export$2e2bcd8739ae039 = $2a77727daa1ec115$var$StatusView;









const $cebbc76cf001488c$var$requireString = (value)=>value != null && (typeof value === 'string' || typeof value === 'number') ? `${value}` : undefined;
const $cebbc76cf001488c$var$createConsents = (grant, revoke)=>{
    let consents = [];
    consents = consents.concat($cebbc76cf001488c$var$setConsentStates(grant, true));
    consents = consents.concat($cebbc76cf001488c$var$setConsentStates(revoke, false));
    return consents;
};
const $cebbc76cf001488c$var$setConsentStates = (source, targetState)=>{
    const consents = [];
    if (source == null) return consents;
    Object.keys(source).forEach((key)=>{
        consents.push({
            key: key,
            granted: targetState,
            displayedText: source[key]
        });
    });
    return consents;
};
const $cebbc76cf001488c$var$createSubscriptions = (subscribe)=>{
    const value = $cebbc76cf001488c$var$requireString(subscribe);
    if (!value) return undefined;
    return value.split(',').map((item)=>({
            key: item,
            subscribed: true
        }));
};
const $cebbc76cf001488c$export$491adab2bc41e40 = (query)=>{
    const { hid: hid, site: site, formUrl: formUrl, subscribe: subscribe, grant: grant, action: action, source: source, revoke: revoke } = (0, $e845741c6335a85b$export$2e2bcd8739ae039)(query);
    return {
        hid: $cebbc76cf001488c$var$requireString(hid),
        site: $cebbc76cf001488c$var$requireString(site),
        formUrl: $cebbc76cf001488c$var$requireString(formUrl),
        action: $cebbc76cf001488c$var$requireString(action),
        source: $cebbc76cf001488c$var$requireString(source),
        consents: $cebbc76cf001488c$var$createConsents(grant, revoke),
        subscriptions: $cebbc76cf001488c$var$createSubscriptions(subscribe)
    };
};





const $29d5400afff223b9$export$7b4c03a439536a80 = 'consent';
const $29d5400afff223b9$export$184c143ba6f02162 = `${$29d5400afff223b9$export$7b4c03a439536a80}/sendConsentFromLink`;
const $29d5400afff223b9$export$e941224c3d280b02 = `${$29d5400afff223b9$export$7b4c03a439536a80}/updateConsentFromLink`;


const $cdfa88e4a0cef872$var$initialState = {
    urlQueryParams: undefined,
    status: {
        status: 'ok'
    },
    actionResult: undefined
};
const $cdfa88e4a0cef872$export$8dafef78dd350222 = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $29d5400afff223b9$export$184c143ba6f02162), async (_, { getState: getState, rejectWithValue: rejectWithValue })=>{
    const { urlQueryParams: urlQueryParams } = getState().consent;
    if (urlQueryParams == null) return rejectWithValue(null);
    const response = await (0, $71fbb9240bd0b42c$export$3ab4aed8562cb58d)(urlQueryParams);
    if (response.downForMaintenanceMessage != null) return rejectWithValue(response.downForMaintenanceMessage);
}, {
    condition: (arg, { getState: getState })=>getState().consent.urlQueryParams != null
});
const $cdfa88e4a0cef872$export$6486b849b39045bb = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $29d5400afff223b9$export$e941224c3d280b02), async (_, { dispatch: dispatch })=>{
    await dispatch($cdfa88e4a0cef872$export$8dafef78dd350222());
});
const $cdfa88e4a0cef872$var$consentSlice = (0, $15d924278321bdfd$export$4d8d9bd83c24ae8b)({
    name: (0, $29d5400afff223b9$export$7b4c03a439536a80),
    initialState: $cdfa88e4a0cef872$var$initialState,
    reducers: {
        empty: ()=>{}
    },
    extraReducers: (builder)=>{
        builder.addCase($cdfa88e4a0cef872$export$6486b849b39045bb.pending, (state, { meta: meta })=>{
            const consentReferralUrlParams = (0, $cebbc76cf001488c$export$491adab2bc41e40)(meta.arg);
            if (consentReferralUrlParams.hid) state.urlQueryParams = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, consentReferralUrlParams), {
                hid: consentReferralUrlParams.hid
            });
            else state.actionResult = {
                status: 'error'
            };
        });
        builder.addCase($cdfa88e4a0cef872$export$8dafef78dd350222.fulfilled, (state)=>{
            var _state_urlQueryParams;
            state.actionResult = {
                status: 'success',
                action: (_state_urlQueryParams = state.urlQueryParams) === null || _state_urlQueryParams === void 0 ? void 0 : _state_urlQueryParams.action
            };
        });
        builder.addCase($cdfa88e4a0cef872$export$8dafef78dd350222.rejected, (state, action)=>{
            if (action.payload != null) state.status = {
                status: 'down-for-maintenance',
                message: action.payload
            };
            else state.actionResult = {
                status: 'error'
            };
        });
    }
});
var $cdfa88e4a0cef872$export$2e2bcd8739ae039 = $cdfa88e4a0cef872$var$consentSlice.reducer;







const $100065b339a92676$var$_4 = "._1bah1h6o{justify-content:center}";
const $100065b339a92676$var$_3 = "._4cvr1h6o{align-items:center}";
const $100065b339a92676$var$_2 = "._2lx21bp4{flex-direction:column}";
const $100065b339a92676$var$_ = "._1e0c1txw{display:flex}";
const $100065b339a92676$var$styles = null;
const $100065b339a92676$var$Consent = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $cdfa88e4a0cef872$export$6486b849b39045bb)(location.search));
    }, [
        dispatch,
        location
    ]);
    const isPending = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $7a501a2d8adab3c3$export$9d56a93b8e84b384)([
        (0, $29d5400afff223b9$export$e941224c3d280b02)
    ]));
    const status = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $e745f2f77eae858d$export$f4442397935fb087));
    const hid = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $e745f2f77eae858d$export$e4521e30be8f0d13));
    const navigationClickHandler = (0, $7fPBF.useCallback)(()=>navigate(`/?hid=${hid}`), [
        navigate,
        hid
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ef58838c74859603$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2a77727daa1ec115$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                            children: [
                                $100065b339a92676$var$_,
                                $100065b339a92676$var$_2,
                                $100065b339a92676$var$_3,
                                $100065b339a92676$var$_4
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                                "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                            ]),
                            children: isPending ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {
                                size: "large",
                                label: "Loading",
                                testId: "loading-spinner"
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cccf8465b61394af$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6125038cd8bf4a75$export$2e2bcd8739ae039), {
                                        appearance: 'primary',
                                        isVisible: status.status === 'ok' && hid != null,
                                        onClick: navigationClickHandler
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $100065b339a92676$export$2e2bcd8739ae039 = $100065b339a92676$var$Consent;







/* NotFoundView.tsx generated by @compiled/babel-plugin v0.38.1 */ 

parcelRequire("7fPBF");






parcelRequire("7fPBF");
const $38c55a02ec9b8a11$var$SvgMoving = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 581.46 278.83"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: 487.37,
                        y1: 255.77,
                        x2: 549.17,
                        y2: 193.96,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        y1: 2064.73,
                        x2: 581.46,
                        y2: 2064.73,
                        gradientTransform: "matrix(1 0 0 -2.47 0 5364.37)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#172b4d",
                                stopOpacity: 0.1
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.02,
                                stopColor: "#172b4d",
                                stopOpacity: 0.23
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#172b4d",
                                stopOpacity: 0.51
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.15,
                                stopColor: "#172b4d",
                                stopOpacity: 0.73
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.24,
                                stopColor: "#172b4d",
                                stopOpacity: 0.89
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#172b4d",
                                stopOpacity: 0.98
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.7,
                                stopColor: "#172b4d"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-3",
                        x1: 352.14,
                        y1: 237.25,
                        x2: 468.8,
                        y2: 120.6,
                        gradientTransform: "rotate(-90 410.47 178.93)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.26,
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.89,
                                stopColor: "#dfe1e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-5",
                        x1: 191.16,
                        y1: 263.67,
                        x2: 337.31,
                        y2: 263.67,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.74,
                                stopColor: "#a5adba"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "linear-gradient-6",
                        x1: 191.16,
                        y1: 261.81,
                        x2: 337.31,
                        y2: 261.81,
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-7",
                        x1: 7621.51,
                        y1: 133.78,
                        x2: 7582.74,
                        y2: 66.63,
                        gradientTransform: "matrix(-1 0 0 1 8014.38 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.26,
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#c7ccd4"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.79,
                                stopColor: "#d7dadf"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.89,
                                stopColor: "#dfe1e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-8",
                        x1: 7565.51,
                        y1: 232.66,
                        x2: 7497.92,
                        y2: 115.6,
                        gradientTransform: "matrix(-1 0 0 1 8014.38 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.26,
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.89,
                                stopColor: "#ebecf0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_11",
                        x1: 113.14,
                        y1: 197.29,
                        x2: 162.34,
                        y2: 148.09,
                        gradientTransform: "translate(-51.44 51.13)",
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-9",
                        x1: 284.38,
                        y1: 112.68,
                        x2: 398.7,
                        y2: -1.64,
                        gradientTransform: "rotate(-8.14 1039.08 480.808)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#dfe1e5"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.21,
                                stopColor: "#e9eaed"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.66,
                                stopColor: "#f9fafa"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#fff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "linear-gradient-10",
                        x1: 38.67,
                        y1: 260.31,
                        x2: 156.62,
                        y2: 260.31,
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "clip-path",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            id: "_Clipping_Path_",
                            className: "mcls-1",
                            d: "M485.28 171.09h31.52c12.14 0 22 9.25 22 20.66a20.66 20.66 0 0 0 13.2 18.94l11.1 4.56a20.67 20.67 0 0 1 13.18 18.94v19.49h-91Z"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "clip-path-2",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-2",
                            d: "M171.03 108.84h166.28v115.77H171.03z"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: ".mcls-1{fill:url(#linear-gradient)}.mcls-2,.mcls-39{fill:none}.mcls-4{fill:#dfe1e5}.mcls-6{fill:#97a0af}.mcls-7{fill:#253858}.mcls-8{fill:#a5adba}.mcls-39{stroke-miterlimit:10}.mcls-11{fill:#c1c7d0}.mcls-12{fill:#5e6c84}.mcls-14{fill:#79e2f2}.mcls-16{fill:#fff}.mcls-17{fill:#72594b}.mcls-18{fill:#344563}.mcls-23{fill:#b3bac5}.mcls-26{fill:#42526e}.mcls-27{fill:#e1c5b6}.mcls-28{fill:#00a3bf}.mcls-29{fill:#0065ff}.mcls-31{fill:#e6fcff}.mcls-32{fill:#091e42;opacity:.1}.mcls-33{fill:#b2d4ff}.mcls-39{stroke:#2684ff;stroke-width:5.13px;opacity:.4}.mcls-40{fill:#4c9aff}.mcls-41{fill:#b5917c}.mcls-43{fill:#162b4c}.mcls-44{fill:#172b4d}"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                id: "Layer_2",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "Layer_1-2",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M2.69 267.21h574.18a4.58 4.58 0 0 1 4.58 4.58v2.27a4.58 4.58 0 0 1-4.58 4.58H2.69A2.69 2.69 0 0 1 0 276v-6a2.69 2.69 0 0 1 2.69-2.69Z",
                            style: {
                                opacity: 0.05,
                                fill: "url(#linear-gradient-2)"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 269.43,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 269.6,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 269.77,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 269.94,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 270.11,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 270.28,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 270.46,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 270.63,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 270.8,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 270.97,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 271.14,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 271.31,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 271.48,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 271.65,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 271.82,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 271.99,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 272.16,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 272.33,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 272.51,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 272.68,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 272.85,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 273.02,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 273.19,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 273.36,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 273.53,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 273.7,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 273.87,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 274.04,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 274.21,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 274.38,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 274.56,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 274.73,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 274.9,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 275.07,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 275.24,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 275.41,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 275.58,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 275.75,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 275.92,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 276.09,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 276.26,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 276.43,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 276.61,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 276.78,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 276.95,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 277.12,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 277.29,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 277.46,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 277.63,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 277.8,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 277.97,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 278.14,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 278.31,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 278.48,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 278.66,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 278.83,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 279,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 279.17,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 279.34,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 279.51,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 279.68,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 279.85,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 280.02,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 280.19,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 280.36,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 280.53,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 280.71,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 280.88,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 281.05,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 281.22,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 281.39,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 281.56,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 281.73,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 281.9,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 282.07,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 282.24,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 282.41,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 282.58,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 282.76,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 282.93,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 283.1,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 283.27,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 283.44,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 283.61,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 283.78,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 283.95,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 284.12,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 284.29,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 284.46,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 284.63,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 284.81,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 284.98,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 285.15,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 285.32,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 285.49,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 285.66,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 285.83,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 286,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 286.17,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 286.34,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 286.51,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 286.68,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 286.86,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 287.03,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 287.2,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 287.37,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 287.54,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 287.71,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 287.88,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 288.05,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-4",
                            cx: 288.22,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            cx: 288.22,
                            cy: 260.61,
                            r: 17.97,
                            style: {
                                fill: "#505f79"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-6",
                            d: "M288.22 260.61H572a5.08 5.08 0 0 1-5.08 5.08H293.3a5.08 5.08 0 0 1-5.08-5.08Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-7",
                            d: "M269 260.61a23.44 23.44 0 0 1 46.87 0"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            id: "_Rectangle_",
                            className: "mcls-8",
                            transform: "rotate(-180 413.76 175.635)",
                            d: "M342.25 97.6h143.03v156.08H342.25z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            transform: "rotate(90 410.47 178.93)",
                            style: {
                                fill: "url(#linear-gradient-3)"
                            },
                            d: "M348.88 123.86h123.18v110.13H348.88z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            style: {
                                strokeWidth: "2.56px",
                                strokeMiterlimit: 10,
                                stroke: "#ebecf0",
                                fill: "none"
                            },
                            d: "m357.46 1.28-58.16 98.86"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            id: "_Rectangle_2",
                            className: "mcls-11",
                            transform: "rotate(-180 286.3 175.635)",
                            d: "M230.35 97.6h111.89v156.08H230.35z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-12",
                            transform: "rotate(90 286.3 175.64)",
                            d: "M213.2 124.63h146.21v102.02H213.2z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            id: "_Clipping_Path_2",
                            className: "mcls-1",
                            d: "M485.28 171.09h31.52c12.14 0 22 9.25 22 20.66a20.66 20.66 0 0 0 13.2 18.94l11.1 4.56a20.67 20.67 0 0 1 13.18 18.94v19.49h-91Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                            style: {
                                clipPath: "url(#clip-path)"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                                    className: "mcls-14",
                                    cx: 573.38,
                                    cy: 225.37,
                                    r: 8.06
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    id: "_Rectangle_3",
                                    d: "M489.17 175.61h29.76a16.59 16.59 0 0 1 16.59 16.59v20.18h-46.35v-36.77Z",
                                    style: {
                                        fill: "#b3f5ff"
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-2",
                                    d: "m515.51 203.64-.53-.3a3.5 3.5 0 0 1-.28.39l-3.2.12a18.51 18.51 0 0 1 1.12 2.66c1.44.82 3.06 1.66 4.84 2.47.73.33 1.45.63 2.15.91a12.7 12.7 0 0 1-2-5.85 3.33 3.33 0 0 1-2.1-.4ZM520.28 200.28l1.57-.12.06 1.34a1.8 1.8 0 0 1-.89 1.63 2.25 2.25 0 0 1-.45.19l-.48.12c.28 4 2.5 7.28 5.1 7.28a3.92 3.92 0 0 0 2.88-1.46l-3.61-6.26a.84.84 0 0 1 1.46-.85l3.21 5.56a11.16 11.16 0 0 0 1.19-5.13c0-4.41-2.35-8.13-5.13-8.13-2 0-3.82 2-4.65 4.77a1.2 1.2 0 0 1-.17.67Z"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-16",
                                    d: "M492.46 194.51V193.73a4.76 4.76 0 0 1-2.46-1.53 5.2 5.2 0 0 1-.79-1v2.51a8 8 0 0 1 1.82 1.14q.65-.2 1.43-.34ZM498.35 193.74a4 4 0 0 0 .09.87h.27v-1.95l-.19.07a3.61 3.61 0 0 0-.17 1.01ZM490.62 180a3 3 0 0 1 1.62 1.8 5.34 5.34 0 0 1 2.52-.38 16.48 16.48 0 0 0-5.6-4.29v2.54a3.22 3.22 0 0 1 1.46.33ZM531.82 212.38l-1.26-2.18a8 8 0 0 1-1.19 1.32l.5.86ZM524.77 201.86a.83.83 0 0 0-.31 1.15l3.61 6.25a7.46 7.46 0 0 0 1.06-1.54l-3.21-5.56a.84.84 0 0 0-1.15-.3Z"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-17",
                                    d: "M521 203.13a1.8 1.8 0 0 0 .89-1.63l-.06-1.34-1.57.12a12.4 12.4 0 0 0-.22 2.31v.85l.48-.12a2.25 2.25 0 0 0 .48-.19Z"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-18",
                                    d: "M530.56 210.2a13 13 0 0 0 2.26-7.61c0-6-3.35-10.63-7.63-10.63-3.48 0-6.34 3.07-7.29 7.42l2.65-.24v.09c.83-2.79 2.62-4.77 4.65-4.77 2.78 0 5.13 3.72 5.13 8.13a11.16 11.16 0 0 1-1.19 5.13 7.46 7.46 0 0 1-1.06 1.54 3.92 3.92 0 0 1-2.88 1.46c-2.6 0-4.82-3.26-5.1-7.28v-.85a12.4 12.4 0 0 1 .22-2.31l.09-.38a1.15 1.15 0 0 1-.61.47l-.46.16-.72.64a3.78 3.78 0 0 1-1 .61v.81c0 .49 0 1 .07 1.45a12.7 12.7 0 0 0 2 5.85c1.12.45 2.2.85 3.22 1.2l-.68 1.28h6.05a7.32 7.32 0 0 0 1.17-.86 8 8 0 0 0 1.11-1.31Z"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-17",
                                    d: "M515.35 201.51a2.51 2.51 0 0 1-.37 1.83l.53.3a3.33 3.33 0 0 0 2.12.4c0-.47-.07-1-.07-1.45v-.81a3.78 3.78 0 0 0 1-.61l.72-.64.46-.16a1.15 1.15 0 0 0 .61-.47 1.2 1.2 0 0 0 .17-.67s0-.06 0-.09l-2.65.24-1.19.12-1.81 1a2.37 2.37 0 0 1 .48 1.01Z"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-18",
                                    d: "M503.93 204.11h.68c-.41-.61-.8-1.22-1.13-1.79a4.55 4.55 0 0 1 .45 1.79ZM511.5 203.85l3.2-.12a3.5 3.5 0 0 0 .28-.39 2.51 2.51 0 0 0 .37-1.83 2.37 2.37 0 0 0-.45-1l-5.93-.34c.14.16.28.31.41.47a17.32 17.32 0 0 1 2.12 3.21Z"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-7",
                                    d: "M519.61 209.89c-.7-.28-1.42-.58-2.15-.91-1.78-.81-3.4-1.65-4.84-2.47a18.51 18.51 0 0 0-1.12-2.66 17.32 17.32 0 0 0-2.14-3.21c-.13-.16-.27-.31-.41-.47a18.21 18.21 0 0 0-10.24-5.51h-.27a19.66 19.66 0 0 0-3.82-.31 20 20 0 0 0-2.16.21q-.78.13-1.47.3a8.11 8.11 0 0 1 2.95 6.26v11.31h8.87c-.76-2.89-.38-4.51.2-5.47a5 5 0 0 0 .93-2.59 1.48 1.48 0 0 0 0-.21 4.55 4.55 0 0 0-.45-1.81c.33.57.72 1.18 1.13 1.79a38 38 0 0 0 2.34 3.15c.85 1 1.69 1.91 2.5 2.7a25.31 25.31 0 0 0 5.75 2.44h6.95l.68-1.28c-1.03-.41-2.11-.81-3.23-1.26Z"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-17",
                                    d: "M497.8 188.35c-.19 0-.38-.68-.66-.66s-.45.73-.52 1.22a9.47 9.47 0 0 0 .14 2c-.06 1.31-1.76 2.8-3.56 2.86a2.8 2.8 0 0 1-.72-.06V194.49a20 20 0 0 1 2.16-.21 19.66 19.66 0 0 1 3.82.31 4 4 0 0 1-.09-.87 3.61 3.61 0 0 1 .17-1l.19-.07.29-.12 1.3-.51-.44-3.22c.05-.2.51-.51.59-.74s-.34-.3-.65-.47-.33-.24-.39-.39a15.69 15.69 0 0 0-1.22-2.2 7.57 7.57 0 0 0-.22 2c.01.53.01 1.31-.19 1.35Z"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-7",
                                    d: "M492.48 193.73a2.8 2.8 0 0 0 .72.06c1.8-.06 3.5-1.55 3.56-2.86a9.47 9.47 0 0 1-.14-2c.07-.49.25-1.2.52-1.22s.47.7.66.66.17-.82.17-1.27a7.57 7.57 0 0 1 .22-2 1.81 1.81 0 0 0 0-.84 4 4 0 0 0-2.16-2.4 4 4 0 0 0-1.29-.35 5.34 5.34 0 0 0-2.52.38 3 3 0 0 0-1.62-1.8 3.22 3.22 0 0 0-1.45-.28v11.44a5.2 5.2 0 0 0 .79 1 4.76 4.76 0 0 0 2.54 1.48Z"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-12",
                                    d: "M493.94 201.07a8.11 8.11 0 0 0-2.95-6.26 8 8 0 0 0-1.82-1.14v18.71h4.77Z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-6",
                            d: "M352 260.61a23.44 23.44 0 0 1 46.87 0"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            style: {
                                fill: "#00c7e5"
                            },
                            d: "M485.28 242.64h90.95v11.04h-90.95z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-6",
                            d: "M434.41 260.61a23.44 23.44 0 0 1 46.87 0"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M246.79 253.68h333.07a1.59 1.59 0 0 1 1.59 1.59V259a1.59 1.59 0 0 1-1.59 1.59H246.79v-6.94.03Z",
                            style: {
                                fill: "#ebecf0"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-11",
                            d: "M512.09 260.61a23.44 23.44 0 0 1 46.87 0"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            style: {
                                fill: "url(#linear-gradient-5)"
                            },
                            d: "M293.16 278.58h-102l50.45-29.82h95.7v3.72l-44.15 26.1z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            style: {
                                fill: "url(#linear-gradient-6)"
                            },
                            d: "M293.16 274.86h-102l44.15-26.1h102l-44.15 26.1z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-11",
                            d: "M191.16 274.86h102v3.72h-102z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-11",
                            transform: "rotate(42.67 414.96 179.009)",
                            d: "M403.47 91.72h22.94v174.57h-22.94z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-23",
                            transform: "rotate(42.67 418.016 180.072)",
                            d: "M406.53 92.78h22.94v174.57h-22.94z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-6",
                            d: "M358.7 114.05v123.17l-16.45 16.46V97.6l16.45 16.45z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            style: {
                                fill: "url(#linear-gradient-7)"
                            },
                            d: "M468.82 114.05H358.7L342.25 97.6h143.03l-16.46 16.45z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            style: {
                                fill: "url(#linear-gradient-8)"
                            },
                            d: "M468.82 114.05v123.17l16.46 16.46V97.6l-16.46 16.45z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-6",
                            d: "M468.82 237.22H358.7l-16.45 16.46h143.03l-16.46-16.46z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-7",
                            d: "M375.43 242.64h-10.12a18 18 0 1 0 0 35.94h10.12a18 18 0 0 0 0-35.94ZM457.84 242.64h-10.12a18 18 0 0 0 0 35.94h10.12a18 18 0 1 0 0-35.94ZM547.14 242.64H537a18 18 0 1 0 0 35.94h10.12a18 18 0 1 0 0-35.94Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-26",
                            cx: 375.43,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-27",
                            d: "m174.35 237.28 2.43-.77 2.16-3.46.47-3.61h-1.76l-4.33 6.24 1.03 1.6z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-26",
                            cx: 457.84,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-26",
                            cx: 547.14,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-28",
                            cx: 375.43,
                            cy: 260.61,
                            r: 10.27
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                            className: "mcls-29",
                            x: 28.95,
                            y: 223.66,
                            width: 33.77,
                            height: 33.96,
                            rx: 2.11,
                            ry: 2.11
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                            x: 69.41,
                            y: 190.27,
                            width: 33.77,
                            height: 67.09,
                            rx: 2.11,
                            ry: 2.11,
                            transform: "translate(-9.48 3.89)",
                            style: {
                                fill: "url(#New_Gradient_Swatch_11)"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                            className: "mcls-7",
                            x: 113.23,
                            y: 160.1,
                            width: 33.77,
                            height: 95.87,
                            rx: 2.11,
                            ry: 2.11,
                            transform: "rotate(3.37 130.137 208.135)"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-28",
                            cx: 457.84,
                            cy: 260.61,
                            r: 10.27
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-28",
                            cx: 547.14,
                            cy: 260.61,
                            r: 10.27
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            id: "_Ellipse_",
                            className: "mcls-14",
                            cx: 357.46,
                            cy: 49.43,
                            r: 48.15
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-31",
                            d: "M352.31 53.17 341.9 42.76a1.29 1.29 0 0 0-1.83 0l-9 9a1.3 1.3 0 0 0 0 1.84L351.4 74a1.3 1.3 0 0 0 1.83 0L380 47.26l-8-13.78ZM387.49 39.74a1.3 1.3 0 0 0 0-1.83l-9-9a1.3 1.3 0 0 0-1.84 0l-2.73 2.73 8 13.79Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-32",
                            d: "M383 90.22a48.08 48.08 0 0 0 22.53-38.65h-20.12l-3.57-6.18-1.84 1.87 3.2 5.55a2.19 2.19 0 0 0-.14.72ZM356.39 1.31c-.93 0-1.85.06-2.77.14a1.63 1.63 0 0 0 .16.47L372 33.48l1.88-1.88Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-31",
                            d: "M373.88 31.6 372 33.48l7.96 13.78 1.88-1.87-7.96-13.79z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-32",
                            d: "M373.88 31.6 372 33.48l7.96 13.78 1.88-1.87-7.96-13.79z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                            className: "mcls-29",
                            x: 394.56,
                            y: 56.69,
                            width: 40.9,
                            height: 40.9,
                            rx: 1.97,
                            ry: 1.97
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-33",
                            d: "m423 88.66-7.36-5.85-7.36 5.85a1.59 1.59 0 0 1-2.54-1.41V68.68a1.68 1.68 0 0 1 1.6-1.75H424a1.68 1.68 0 0 1 1.6 1.75v18.57a1.59 1.59 0 0 1-2.6 1.41Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            style: {
                                strokeLinecap: "round",
                                strokeWidth: "2.56px",
                                strokeMiterlimit: 10,
                                stroke: "#ebecf0",
                                fill: "none"
                            },
                            d: "m357.46 1.28 55.59 96.3v156.1"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            style: {
                                stroke: "#c1c7d0",
                                strokeWidth: "2.56px",
                                strokeMiterlimit: 10,
                                fill: "none"
                            },
                            d: "m143.68 266.28 32.01-32.01"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-11",
                            cx: 109.28,
                            cy: 267.4,
                            r: 8.68
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-11",
                            cx: 30.11,
                            cy: 267.4,
                            r: 8.68
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-8",
                            cx: 30.3,
                            cy: 267.4,
                            r: 4.19
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-8",
                            cx: 109.48,
                            cy: 267.4,
                            r: 4.19
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                            style: {
                                clipPath: "url(#clip-path-2)"
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-7",
                                    d: "m274.31 192.47 12.58.92 11-4.63 1.88 3.33-13.19 5.21-13.25 2c.35-2.3.67-4.57.98-6.83Z"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                    id: "_Rectangle_4",
                                    x: 198.04,
                                    y: 123.84,
                                    width: 180.62,
                                    height: 69.51,
                                    rx: 2.87,
                                    ry: 2.87,
                                    transform: "rotate(7.47 288.498 158.695)",
                                    style: {
                                        fill: "url(#linear-gradient-9)"
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-32",
                                    d: "m327.55 198.79 36.44 4.78v-70.1l-36.44-4.78v70.1z"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                                    cx: 355.25,
                                    cy: 182.61,
                                    r: 11.6,
                                    style: {
                                        opacity: 0.8,
                                        fill: "#2684ff"
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                    className: "mcls-29",
                                    x: 205.98,
                                    y: 152.89,
                                    width: 22.41,
                                    height: 22.41,
                                    rx: 3.36,
                                    ry: 3.36,
                                    transform: "rotate(7.47 217.246 164.193)"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-39",
                                    d: "m210.91 125.77 160.73 21.08M209.25 138.46l100.28 13.16M238.36 165.64l67.68 8.87"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    className: "mcls-40",
                                    d: "m214.59 170.1-4.82-6.27 2.55-1.95 2.86 3.72 7.75-5.95 1.95 2.54-10.29 7.91z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ellipse", {
                            className: "mcls-32",
                            cx: 260.19,
                            cy: 267.4,
                            rx: 29.83,
                            ry: 5.59
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-18",
                            d: "M254.09 263.06a7.56 7.56 0 0 0-1.79 1.17 7.77 7.77 0 0 0-1.4 1.62c.15.29.31.59.5.89a12.89 12.89 0 0 0 3.37 3.61l3.79-.44a1 1 0 0 0 0-.31c-.28-1-2-1.1-2.15-1.11a4.74 4.74 0 0 1-.71-2 4.88 4.88 0 0 1 .21-2.08Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-7",
                            cx: 261.38,
                            cy: 200.79,
                            r: 7.54
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-18",
                            d: "M265 211.41c2.26-2.42 8.22-2.15 10.36.63s.21 8.46-2.2 15c-.67 1.8-1.7 4.44-6.54 14.8-2.69 5.76-3.25 6.83-4.95 10.54-2.42 5.3-4.26 9.66-5.42 12.46l-3.44-1.12c1.12-3.88 1.91-7.07 2.41-9.23 1.06-4.57 1.43-7 2.68-11 .83-2.6 1.66-4.67 2.22-6q.65-3.12 1.25-6.33 1.19-6.24 2.11-12.23a9.78 9.78 0 0 1 0-4 7.79 7.79 0 0 1 1.52-3.52ZM277.66 262.84c-.08.54-.15 1.13-.19 1.74a20.28 20.28 0 0 0 0 2.32.63.63 0 0 0 .69.59l7.82-1a1.47 1.47 0 0 0-.39-1c-.36-.33-.82-.24-1.39-.27a6.1 6.1 0 0 1-3.09-1.16 4.81 4.81 0 0 1-1.3-1.55Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-26",
                            d: "M269.26 207.65a6.69 6.69 0 0 1 5.19.12c2.08 1.07 3.29 3.54 4.36 13.19.53 4.8.87 10 1 17.94.1 5.94 0 7.35.15 12.61.16 4.9.44 8.9.65 11.54l-3.86.7a207.77 207.77 0 0 1-3.28-11.85 30.68 30.68 0 0 1-1.2-7.56 38.52 38.52 0 0 1 .52-6.15c.11-.63.23-1.22.35-1.76-.4-1.27-1-3.25-1.91-5.66-1.07-3-2-5.62-3.42-8.9-2.37-5.51-3.13-6-2.95-8a7.6 7.6 0 0 1 4.4-6.22Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-7",
                            d: "M275 186a6.23 6.23 0 0 1 .67 4.22 5.31 5.31 0 0 1-1.87 3.09 3.83 3.83 0 0 1-1.37.65 2.82 2.82 0 0 1-1.39.08c-1.65-.65-.72-7.43 1.31-9.35a1.43 1.43 0 0 1 1-.48c.79.06 1.32 1.16 1.65 1.79Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-18",
                            d: "M263.21 215.59a13.12 13.12 0 0 0 16.4-2.26 11.43 11.43 0 0 1-1.52-2.32 11.92 11.92 0 0 1-1-7.18c.32-1.67.8-1.92.66-3.17a2.34 2.34 0 0 0 0-.26 13.39 13.39 0 0 0-1.23-3.15c-.47-.81-1.06-1.92-1.81-3.47a22.44 22.44 0 0 0-11.86 3.35 53.76 53.76 0 0 0 1.53 5.55c1 2.92 1.67 4.12 1.3 6a20.7 20.7 0 0 1-1.13 2.89 34.84 34.84 0 0 0-1.34 4.02Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            id: "_Path_",
                            className: "mcls-41",
                            d: "M275.13 188.51c0 .06-.11.14-.28.31a3.72 3.72 0 0 1-.35.31c0 .26.06.54.07.84a13.63 13.63 0 0 1 0 1.56 10.66 10.66 0 0 1-1.57.47 8.24 8.24 0 0 1-2.94.25 5.37 5.37 0 0 1-1.95-.51 4.34 4.34 0 0 1 3.06-8.07 3.67 3.67 0 0 1 2.1 1.5c.27.47.17.54.62 1.32a7.84 7.84 0 0 0 .45.73c.52.78.89 1.01.79 1.29Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-41",
                            d: "M267.69 190.41a4.74 4.74 0 0 1 .72 4.33c.79.39 1.59.8 2.4 1.24 1.16.62 2.28 1.25 3.35 1.87l-1.7-3.15c0-.36-.09-.75-.11-1.17a13 13 0 0 1 0-1.45ZM260.34 172.25l.43-3.23a12.75 12.75 0 0 0-.4-1.81c-.14-.45-.28-.82-.61-.94a.66.66 0 0 0-.35-.05.49.49 0 0 0-.18-.47.47.47 0 0 0-.51-.05.45.45 0 0 0-.22.44.52.52 0 0 0-.34 0c-.42.2-.47 1.14-.16 2.34-.43-.51-.93-.74-1.23-.59a.41.41 0 0 0-.19.2l.94 1.37a3.73 3.73 0 0 0 .27 1 3.66 3.66 0 0 0 1.1 1.4Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-7",
                            d: "M272.14 187.6c-.37.59-.63.35-1 .88-.76 1.11.28 2.27-.42 3.3-.34.49-.77.23-1 .7-.39.69.44 1.3.3 2.42a2.63 2.63 0 0 1-1.49 2c-.91.38-1.42-.25-2.09.1-1 .51-.33 2.11-1.2 3.22-1.15 1.47-4.19 1.95-6.39.59a5.84 5.84 0 0 1-2.39-5.71 6.5 6.5 0 0 1 2.43-4.16c1.26-1 2.12-.77 3.28-2a6.32 6.32 0 0 0 1.44-2.33 8.33 8.33 0 0 1 2.4-3.21 6.17 6.17 0 0 1 3.81-1c.87 0 2.52 0 3.21 1.08a1.85 1.85 0 0 1 .28 1.5c-.08.22-.17.26-.35.5-.64.76-.35 1.36-.82 2.12Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-18",
                            d: "m268.7 198.6-4.56-12.6q-1.81-7.42-3.64-14.84l-2.26.38a126.52 126.52 0 0 0 5.66 30ZM264.63 184.62a4.56 4.56 0 0 1 9.12 0Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-18",
                            d: "M269.06 182.72h6.26a1.9 1.9 0 0 1 1.9 1.9h-8.16v-1.9Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M38.67 253.22h118v11.87a2.31 2.31 0 0 1-2.31 2.31H38.67v-14.18Z",
                            style: {
                                fill: "url(#linear-gradient-10)"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-4",
                            d: "M15.56 253.22h35.2v14.18H17.87a2.31 2.31 0 0 1-2.31-2.31v-11.87Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-16",
                            cx: 64.77,
                            cy: 267.4,
                            r: 8.68
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-16",
                            cx: 143.95,
                            cy: 267.4,
                            r: 8.68
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-23",
                            cx: 64.77,
                            cy: 267.4,
                            r: 4.19
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "mcls-23",
                            cx: 143.95,
                            cy: 267.4,
                            r: 4.19
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-27",
                            d: "m177.09 228.98-2.01 1.55-2.63 3.74h1.18l2.06-1.19 2.43-1.06.82-3.04h-1.85z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-7",
                            d: "m196.64 204.47-13.36 9.62a4.61 4.61 0 0 0-1.58 2l-5.6 13.36 3.11 1.79 7.51-12.63 10.1-4.79Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            id: "_Clipping_Path_12",
                            className: "mcls-43",
                            d: "m188.18 278.83-8.41-.52.34-5.32 2.69.86a3.58 3.58 0 0 0 1.33 2.3c1.18.84 2.55.33 3.46 1.33a2.43 2.43 0 0 1 .59 1.35Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            id: "_Clipping_Path_13",
                            className: "mcls-43",
                            d: "m219.2 271.38-9.31-.52.33-5.92 3 .3c.21 2 .9 2.81 1.48 3.2 1.26.9 2.83.32 3.85 1.46a2.6 2.6 0 0 1 .65 1.48Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-27",
                            d: "M204.77 206.24a6.45 6.45 0 0 1-6.2-.82 10.47 10.47 0 0 0 2.1-6l5.21.66Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-27",
                            d: "M209 195.1c.12.76.29 1.58.5 2.45s.42 1.53.64 2.21l-1.16.17-.52 3.12a8.24 8.24 0 0 1-3.53.31c-1.13-.08-2.28-.15-2.87-1a4.45 4.45 0 0 1-.43-.91 4 4 0 0 0-.26-.56c-.11-.23-.28-.55-.5-.94a2.78 2.78 0 0 0 1.27.22 1.58 1.58 0 0 0 1.18-.38 2.71 2.71 0 0 1-1.11-1.55 3.07 3.07 0 0 1 1.76-3.21c.22-.1.54-.22 3.61-.06Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-44",
                            d: "M191.51 224.66c-.77 1.53-1.43 3.15-2.1 4.86a73 73 0 0 0-4.58 19.75c-.88 2.28-1.72 4.72-2.52 7.29a107.38 107.38 0 0 0-3.73 17.2l4.46.83 7.51-23.32c.41-1 1-2.38 1.72-4.11 5.19-12.58 5.65-14.8 4.9-17-.45-1.29-1.65-3.55-5.66-5.5Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-44",
                            d: "M200.48 225.05a3.11 3.11 0 0 1 .52 0c1.36.21 3.67 1.42 9 8.09 1.49 1.87 3.38 4.38 5.42 7.48a3 3 0 0 1 .49 1.83q-.27 5-.77 10.27c-.43 4.5-1 8.82-1.55 12.95a5.88 5.88 0 0 1-2.56.67 6 6 0 0 1-3.25-.86 52.3 52.3 0 0 0 .43-5.84c.06-3.45-.25-5.19-.36-8.61a68 68 0 0 1 .19-8 271.76 271.76 0 0 1-10.49-3.8c-5.18-2-6.54-2.72-7.41-4.21-1.95-3.32.1-7.78.84-9.24 4 .8 5.78.49 6.64 0a5.59 5.59 0 0 1 2.86-.73Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-18",
                            d: "M194.82 207.44a5 5 0 0 1 5.54-3.9l7.26 1 1.52 10.55q-1.71 6.72-3.43 13.42l-5.39.78a13.8 13.8 0 0 1-10-2.42l-.81-.57 4.7-16Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-27",
                            d: "m225.19 230.62 1.05 1.83.78.65-.16 1.8.76.43.82-.87v1.06h.75l1.18-2.98-1.38-2.39-2.59-1.79-1.21 2.26z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-18",
                            d: "m203.21 205.09 6.89 15.3a8.49 8.49 0 0 0 3.23 3.71l11.88 7.47 2.39-2.69-11.87-9.81a47.79 47.79 0 0 1-2.22-6.94c-.6-2.57-.67-3.92-1.92-5.33a7.19 7.19 0 0 0-8.38-1.71Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-44",
                            d: "M200.48 201.12h2.61a1.35 1.35 0 0 0 .92-.64c.26-.61-.48-1.1-.43-2s.92-1.9 1.4-1.79c.12 0 .34.16.5.83h1a3.08 3.08 0 0 1 1.41-1.93c1-.5 1.74-.06 2.41-.53.46-.33.88-1.15.57-3.3-.91-.05-2.12-.11-3.55-.16-4.43-.16-5.06 0-5.71.38a4.75 4.75 0 0 0-2.12 4.23c.14 1 .76 1.56 1 3.28a7.56 7.56 0 0 1-.01 1.63Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            style: {
                                stroke: "#c1c7d0",
                                strokeLinecap: "round",
                                strokeWidth: "2.56px",
                                strokeMiterlimit: 10,
                                fill: "none"
                            },
                            d: "M171.41 234.27h8.57"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-18",
                            d: "M199.63 197.05a4.56 4.56 0 1 1 7.79-4.73Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-18",
                            d: "M202.33 190.88h6.26a1.9 1.9 0 0 1 1.9 1.9h-8.16v-1.9Z",
                            transform: "rotate(-31.25 206.405 191.831)"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            id: "_Rectangle_5",
                            className: "mcls-40",
                            d: "M303.04 72.42h21.97v25.57h-21.97z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-40",
                            d: "M299.85 69.1h6.39v3.33h-6.39zM287.79 69.1h6.39v3.33h-6.39zM311.9 69.1h6.39v3.33h-6.39z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            id: "_Rectangle_6",
                            style: {
                                fill: "#2684ff"
                            },
                            d: "M281.07 72.42h21.97v25.57h-21.97z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-33",
                            d: "M310.89 88h6.58v10h-6.58z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-29",
                            d: "M288.76 88h6.58v10h-6.58z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "mcls-32",
                            d: "M485.28 171.09h3.93v82.58h-3.93z"
                        })
                    ]
                })
            })
        ]
    }));
var $38c55a02ec9b8a11$export$2e2bcd8739ae039 = $38c55a02ec9b8a11$var$SvgMoving;


const $c90d30f66179d2c0$var$_2 = "._p12f1kdj{max-width:25pc}";
const $c90d30f66179d2c0$var$_ = "._1yt414lv{padding:var(--_cpuyf2)}";
const $c90d30f66179d2c0$var$styles = null;
const $c90d30f66179d2c0$var$NotFoundView = ()=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9bbee8e48028edce$export$2e2bcd8739ae039), {
        title: translate((0, $447ba15143f7eed7$exports).USER_NOT_FOUND_MESSAGE),
        hero: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                    children: [
                        $c90d30f66179d2c0$var$_,
                        $c90d30f66179d2c0$var$_2
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $38c55a02ec9b8a11$export$2e2bcd8739ae039), {
                    className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                        "_1yt414lv _p12f1kdj"
                    ]),
                    style: {
                        "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200'))
                    }
                })
            ]
        })
    });
};
var $c90d30f66179d2c0$export$2e2bcd8739ae039 = $c90d30f66179d2c0$var$NotFoundView;





var $7fPBF = parcelRequire("7fPBF");

const $24b14210ebbca78e$var$NotFound = ()=>{
    (0, $7fPBF.useEffect)(()=>{
        (0, $275512fd46801a1e$export$bd13a0a8c0977b2f)('Not Found');
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef58838c74859603$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c90d30f66179d2c0$export$2e2bcd8739ae039), {})
    });
};
var $24b14210ebbca78e$export$2e2bcd8739ae039 = $24b14210ebbca78e$var$NotFound;






var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

const $84c3e18687517729$export$99bb917aa12beaf8 = (values)=>{
    if (values == null || values.length === 0) return '';
    else if (values.length === 1) return values[0];
    else return `${values.slice(0, -1).join(', ')} and ${values.slice(-1)}`;
};





const $603bd90c46957049$export$faf42b3a43b63a45 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.email, (email)=>email);
const $603bd90c46957049$export$cd62b380406677c3 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state, groupKey)=>state.preferences.groups[groupKey], (group)=>group);
const $603bd90c46957049$export$d2800e0e69cd41a5 = (groupKey, tabKey)=>(0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.groups, (groups)=>{
        return Object.keys(groups[groupKey].tabs[tabKey].items);
    });
const $603bd90c46957049$export$48df6acab50c159b = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.groups, (state)=>state.preferences.filter, (groups, filter)=>{
    let groupKeys = Object.keys(groups);
    if (filter.groupKey !== 'all') groupKeys = groupKeys.filter((key)=>key === filter.groupKey);
    return groupKeys;
});
const $603bd90c46957049$export$c5a1c46e828bfb34 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.filter, (filter)=>filter);
const $603bd90c46957049$export$43d45db6467effac = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.filter, (subscriptionGroupForView)=>subscriptionGroupForView.groupKey === 'all');
const $603bd90c46957049$export$f26c97331adc89d5 = (groupKey, itemKey, tabKey)=>(0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.groups, (groups)=>{
        try {
            return groups[groupKey].tabs[tabKey !== null && tabKey !== void 0 ? tabKey : 'root'].items[itemKey];
        } catch (e) {
            return undefined;
        }
    });
const $603bd90c46957049$export$d3a73181b80e0de7 = (itemKey)=>(0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.initialStates, (initialStates)=>initialStates[itemKey]);
const $603bd90c46957049$export$a2262118789c43db = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.actionResult, (actionResult)=>actionResult);
const $603bd90c46957049$export$b4f431af37c9cd8b = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.status, (status)=>status);
const $603bd90c46957049$export$5bb16d4fc4eb5b53 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.consentDialog, (consentDialog)=>consentDialog);
const $603bd90c46957049$export$e15e41f6dd0733a8 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.consentDeclinePrDialog, (consentDeclinePrDialog)=>consentDeclinePrDialog);
const $603bd90c46957049$export$4c4595253c03ba56 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.globalUnsubscribeDialog, (globalUnsubscribeDialog)=>globalUnsubscribeDialog);
const $603bd90c46957049$export$aa0ab7810228523b = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.doubleOptInDialog, (doubleOptInDialog)=>doubleOptInDialog);
const $603bd90c46957049$export$5eb6bff4dfa33c8a = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>{
    var _state_preferences;
    return (_state_preferences = state.preferences) === null || _state_preferences === void 0 ? void 0 : _state_preferences.hid;
}, (hid)=>hid);






var $7fPBF = parcelRequire("7fPBF");


const $8c30ca0181fdf91d$var$ErrorAcceptGmoi = ({ onClose: onClose })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        (0, $0e08eda71bb24540$export$46324d0949923406)();
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $548d2678bd231d64$export$3e68361a3d3e7b9f), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_ERROR_MESSAGE_TITLE),
        onClose: onClose,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            children: translate((0, $447ba15143f7eed7$exports).GMOI_REQUEST_ERROR_MESSAGE)
        })
    });
};
var $8c30ca0181fdf91d$export$2e2bcd8739ae039 = $8c30ca0181fdf91d$var$ErrorAcceptGmoi;








var $7fPBF = parcelRequire("7fPBF");


const $3b522bd925217c58$var$ErrorRequest = ({ onClose: onClose })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        (0, $0e08eda71bb24540$export$d6067dcb8ad24019)();
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $548d2678bd231d64$export$3e68361a3d3e7b9f), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_ERROR_MESSAGE_TITLE),
        onClose: onClose,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8773d15fad8814a3$export$2e2bcd8739ae039), {
                value: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_ERROR_MESSAGE_DESCRIPTION),
                start: -4
            })
        })
    });
};
var $3b522bd925217c58$export$2e2bcd8739ae039 = $3b522bd925217c58$var$ErrorRequest;







var $7fPBF = parcelRequire("7fPBF");



var $j9spr = parcelRequire("j9spr");

var $7fPBF = parcelRequire("7fPBF");



var $e994e5e247638dae$var$flexGrowMap = {
    hug: (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $e994e5e247638dae$var$Stack = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, id = _ref.id;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $e994e5e247638dae$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $0a833860173a6d7c$export$2e2bcd8739ae039), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$e994e5e247638dae$var$Stack.displayName = 'Stack';
var $e994e5e247638dae$export$2e2bcd8739ae039 = $e994e5e247638dae$var$Stack;




parcelRequire("7fPBF");


const $00311d30dbeb7c25$export$8bf0c85141e34136 = ()=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c5afab4d5c610ba2$export$2e2bcd8739ae039), {
        onClick: ()=>window.open('https://support.atlassian.com/atlassian-account/docs/manage-your-email-and-notification-preferences/', '_blank'),
        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_LEARN_MORE_BUTTON_LABEL)
    });
};
const $00311d30dbeb7c25$export$97c812ea8115c82b = (props)=>{
    const { translate: translate, keyWithTitle: keyWithTitle } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const href = (0, $d9fd026bfea79ab9$export$b66bb29c5006f12f)('/');
    const subscribeToCallback = ()=>{
        var _props_onSubscribeCallback;
        const params = new URLSearchParams({
            hid: props.hid,
            subscribeKeys: props.subscriptionKey
        });
        window.location.href = `${href}?${params.toString()}`;
        (_props_onSubscribeCallback = props.onSubscribeCallback) === null || _props_onSubscribeCallback === void 0 ? void 0 : _props_onSubscribeCallback.call(props);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c5afab4d5c610ba2$export$2e2bcd8739ae039), {
        onClick: subscribeToCallback,
        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_SUBSCRIBE_TO_BUTTON_LABEL, {
            subscription: translate(keyWithTitle(props.subscriptionKey)) || ''
        })
    });
};


const $8a0e3720aadb081f$var$SuccessGlobalUnsubscribe = ({ onClose: onClose })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        (0, $0e08eda71bb24540$export$24a9508d2a444047)();
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $548d2678bd231d64$export$e80deec18a12daba), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_GLOBAL_UNSUBSCRIBE_MESSAGE_TITLE),
        onClose: onClose,
        actions: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00311d30dbeb7c25$export$8bf0c85141e34136), {}, 'learn-more')
        ],
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e994e5e247638dae$export$2e2bcd8739ae039), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                        as: "p",
                        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_PRIMARY)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                        as: "p",
                        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_SECONDARY)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                size: "small",
                children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_TERTIARY)
            })
        ]
    });
};
var $8a0e3720aadb081f$export$2e2bcd8739ae039 = $8a0e3720aadb081f$var$SuccessGlobalUnsubscribe;







var $7fPBF = parcelRequire("7fPBF");




const $b2aa151dc8a94c41$var$SuccessSubscribeKeys = ({ data: data, onClose: onClose })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        (0, $0e08eda71bb24540$export$3830a8576e3e4291)();
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $548d2678bd231d64$export$e80deec18a12daba), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_SUBSCRIBE_MESSAGE_TITLE, {
            subscriptions: data || ''
        }),
        onClose: onClose,
        actions: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00311d30dbeb7c25$export$8bf0c85141e34136), {}, 'learn-more')
        ],
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e994e5e247638dae$export$2e2bcd8739ae039), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                        as: "p",
                        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_PRIMARY)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                        as: "p",
                        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_SECONDARY)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                size: "small",
                children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_TERTIARY)
            })
        ]
    });
};
var $b2aa151dc8a94c41$export$2e2bcd8739ae039 = $b2aa151dc8a94c41$var$SuccessSubscribeKeys;







var $7fPBF = parcelRequire("7fPBF");




const $63f6bb9c35df9152$var$SuccessUnsubscribeKeys = ({ data: data, onClose: onClose })=>{
    var _searchParams_get;
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    // get list of subscriptions the user unsubscribed from by parsing the query params
    const searchParams = new URLSearchParams(window.location.search);
    const subscriptions = (_searchParams_get = searchParams.get('key')) === null || _searchParams_get === void 0 ? void 0 : _searchParams_get.split(',');
    (0, $7fPBF.useEffect)(()=>{
        subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.map((subscription)=>(0, $0e08eda71bb24540$export$f508667310aad4a2)({
                source: subscription
            }));
    }, [
        subscriptions
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        "data-testid": 'unsubscribe-key-success',
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $548d2678bd231d64$export$e80deec18a12daba), {
            title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_TITLE, {
                subscriptions: data || ''
            }),
            onClose: onClose,
            actions: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00311d30dbeb7c25$export$8bf0c85141e34136), {}, 'learn-more')
            ],
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e994e5e247638dae$export$2e2bcd8739ae039), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                            as: "p",
                            children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_PRIMARY)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                            as: "p",
                            children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_SECONDARY)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                    size: "small",
                    children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_TERTIARY)
                })
            ]
        })
    });
};
var $63f6bb9c35df9152$export$2e2bcd8739ae039 = $63f6bb9c35df9152$var$SuccessUnsubscribeKeys;







var $7fPBF = parcelRequire("7fPBF");



const $0ad4fbc82d36f8fc$var$SuccessUpdatePreferences = ({ onClose: onClose })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        (0, $0e08eda71bb24540$export$a5babd368b9bd0a8)();
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $548d2678bd231d64$export$e80deec18a12daba), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UPDATE_SUCCESS_MESSAGE_TITLE),
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e994e5e247638dae$export$2e2bcd8739ae039), {
                space: "space.100",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                    as: "p",
                    children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UPDATE_SUCCESS_MESSAGE_DESCRIPTION)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                size: "small",
                children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_NOTE_MESSAGE)
            })
        ]
    });
};
var $0ad4fbc82d36f8fc$export$2e2bcd8739ae039 = $0ad4fbc82d36f8fc$var$SuccessUpdatePreferences;








var $7fPBF = parcelRequire("7fPBF");

const $bce5319e3dfe5388$var$SuccessWithWarning = ({ success: Success, warning: Warning, onClose: onClose })=>{
    const [successIsVisible, setSuccessIsVisible] = (0, $7fPBF.useState)(true);
    const [warningIsVisible, setWarningIsVisible] = (0, $7fPBF.useState)(true);
    (0, $7fPBF.useEffect)(()=>{
        if (!successIsVisible && !warningIsVisible) onClose();
    }, [
        successIsVisible,
        warningIsVisible
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e994e5e247638dae$export$2e2bcd8739ae039), {
        space: "space.100",
        children: [
            successIsVisible && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Success, {
                onClose: ()=>setSuccessIsVisible(false)
            }),
            warningIsVisible && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Warning, {
                onClose: ()=>setWarningIsVisible(false)
            })
        ]
    });
};
var $bce5319e3dfe5388$export$2e2bcd8739ae039 = $bce5319e3dfe5388$var$SuccessWithWarning;











parcelRequire("7fPBF");

const $1b587718cdc002ab$var$productInvitationsKey = 'productInvitations';
const $1b587718cdc002ab$var$ProductInvitationsWarning = ({ onClose: onClose })=>{
    const { translate: translate, keyWithTitle: keyWithTitle } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const hid = (0, $f30b917334351296$export$2105062e25df4afe)((0, $603bd90c46957049$export$5eb6bff4dfa33c8a));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $548d2678bd231d64$export$8cc5afb04fcb8e07), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_PRODUCT_INVITATIONS_WARNING_TITLE),
        onClose: onClose,
        actions: hid ? [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00311d30dbeb7c25$export$97c812ea8115c82b), {
                hid: hid,
                subscriptionKey: $1b587718cdc002ab$var$productInvitationsKey,
                onSubscribeCallback: (0, $0e08eda71bb24540$export$e40784e30c403486)
            }, 'subscribe-to-product-invitations')
        ] : undefined,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e994e5e247638dae$export$2e2bcd8739ae039), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                    as: "p",
                    children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_PRODUCT_INVITATIONS_WARNING_BODY_PRIMARY, {
                        subscription: translate(keyWithTitle($1b587718cdc002ab$var$productInvitationsKey))
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                    as: "p",
                    children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_PRODUCT_INVITATIONS_WARNING_BODY_SECONDARY, {
                        section: translate(keyWithTitle('product_surveys'))
                    })
                })
            ]
        })
    });
};
var $1b587718cdc002ab$export$2e2bcd8739ae039 = $1b587718cdc002ab$var$ProductInvitationsWarning;




const $6b41785aa38675ed$var$actionNotificationStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'flex',
    justifyContent: 'center',
    marginTop: 'space.100',
    marginBottom: 'space.200'
});
const $6b41785aa38675ed$var$resolveSuccessActionResult = (key, onClose, data)=>{
    switch(key){
        case 'unsubscribeAll':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bce5319e3dfe5388$export$2e2bcd8739ae039), {
                success: (0, $8a0e3720aadb081f$export$2e2bcd8739ae039),
                warning: (0, $1b587718cdc002ab$export$2e2bcd8739ae039),
                onClose: onClose
            });
        case 'updatePreferences':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0ad4fbc82d36f8fc$export$2e2bcd8739ae039), {
                onClose: onClose
            });
        case 'unsubscribeKeys':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63f6bb9c35df9152$export$2e2bcd8739ae039), {
                onClose: onClose,
                data: data
            });
        case 'subscribeKeys':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b2aa151dc8a94c41$export$2e2bcd8739ae039), {
                onClose: onClose,
                data: data
            });
        default:
            return null;
    }
};
const $6b41785aa38675ed$var$resolveErrorActionResult = (key, onClose)=>{
    switch(key){
        case 'acceptGmoi':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c30ca0181fdf91d$export$2e2bcd8739ae039), {
                onClose: onClose
            });
        case 'request':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b522bd925217c58$export$2e2bcd8739ae039), {
                onClose: onClose
            });
        default:
            return null;
    }
};
const $6b41785aa38675ed$var$resolveActionResultStatus = (status)=>{
    switch(status){
        case 'success':
            return $6b41785aa38675ed$var$resolveSuccessActionResult;
        case 'error':
            return $6b41785aa38675ed$var$resolveErrorActionResult;
    }
};
const $6b41785aa38675ed$var$ActionNotification = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const messageCloseHandler = (0, $7fPBF.useCallback)(()=>dispatch((0, $3d2cac913f314860$export$d684d3158aada635)()), [
        dispatch
    ]);
    const actionResult = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$a2262118789c43db));
    const { translate: translate, keyWithTitle: keyWithTitle } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    if (actionResult == null) return null;
    const subscriptionsWithGroup = [];
    const actionResultData = actionResult.data;
    if (actionResultData !== null && actionResultData !== undefined) {
        for (const subscriptions of actionResultData)// Subscriptions will be in the format ['groupKey1:subscriptionKey1', 'groupKey2:subscriptionKey2', ...]
        // groupKey will be empty for the hidden subscriptions
        for (const subscription of subscriptions.split(',')){
            const groupAndSubscriptionKey = subscription.split(':');
            const groupKey = groupAndSubscriptionKey[0];
            const subscriptionKey = groupAndSubscriptionKey[1];
            // For hidden subscriptions only use the subscriptionKey for the message
            if (groupKey) subscriptionsWithGroup.push(translate(keyWithTitle(groupKey)) + ': ' + translate(keyWithTitle(subscriptionKey)));
            else subscriptionsWithGroup.push(translate(keyWithTitle(subscriptionKey)));
        }
    }
    const notification = $6b41785aa38675ed$var$resolveActionResultStatus(actionResult.status)(actionResult.key, messageCloseHandler, (0, $84c3e18687517729$export$99bb917aa12beaf8)(subscriptionsWithGroup));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        xcss: $6b41785aa38675ed$var$actionNotificationStyles,
        testId: "preferences-center-action-notification",
        children: notification
    });
};
var $6b41785aa38675ed$export$2e2bcd8739ae039 = $6b41785aa38675ed$var$ActionNotification;




/* Skeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ 

parcelRequire("7fPBF");
/* skeleton-heading-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $fa75feeaa55cf7b8$var$ATOMIC_GROUP_LENGTH = 5;
function $fa75feeaa55cf7b8$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $fa75feeaa55cf7b8$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $e34416589fe02ab7$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}


function $effa30ea74c01e92$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $effa30ea74c01e92$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $effa30ea74c01e92$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $effa30ea74c01e92$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $effa30ea74c01e92$var$N20A = 'rgba(9, 30, 66, 0.04)';
var $effa30ea74c01e92$var$N30A = 'rgba(9, 30, 66, 0.08)';
var $effa30ea74c01e92$var$styles = {
    skeleton: "_1rjcze3t _18zrpxbi _14mj53f4 _1ywu1ule _z0ai1r5k _1qdgu2gc _1hfklbf8 _aetrb3bt",
    customWidth: "_z0airzut"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-item.tsx
 *
 * Please update both.
 */ var $effa30ea74c01e92$var$shimmerKeyframes = null;
/**
 * These styles are defined using `css` rather than `cssMap` as there is a
 * bug when using `cssMap` that causes a build failure due to the use of keyframes.
 */ var $effa30ea74c01e92$var$shimmerStyles = null;
/**
 * __Skeleton heading item__
 *
 * A skeleton heading item is used in place of a heading item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $effa30ea74c01e92$var$SkeletonHeadingItem = function SkeletonHeadingItem(_ref) {
    var _ref$isShimmering = _ref.isShimmering, isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering, testId = _ref.testId, width = _ref.width, xcss = _ref.xcss;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $fa75feeaa55cf7b8$export$2e2bcd8739ae039)([
            $effa30ea74c01e92$var$styles.skeleton,
            width && $effa30ea74c01e92$var$styles.customWidth,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1hno _10881hno _18lgp3kn _zo24p3kn _1hfk3yfp _1rus3yfp",
            xcss
        ]),
        "data-ds--menu--skeleton-heading-item": true,
        "data-testid": testId,
        style: $effa30ea74c01e92$var$_objectSpread($effa30ea74c01e92$var$_objectSpread({}, {
            '--width': width
        }), {}, {
            "--_1j9jaml": (0, $e34416589fe02ab7$export$2e2bcd8739ae039)("var(--ds-skeleton, ".concat($effa30ea74c01e92$var$N20A, ")")),
            "--_wb902m": (0, $e34416589fe02ab7$export$2e2bcd8739ae039)("var(--ds-skeleton-subtle, ".concat($effa30ea74c01e92$var$N30A, ")"))
        })
    });
};
var $effa30ea74c01e92$export$2e2bcd8739ae039 = $effa30ea74c01e92$var$SkeletonHeadingItem;

/* skeleton-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

function $2fc3df4631a6889f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2fc3df4631a6889f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2fc3df4631a6889f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2fc3df4631a6889f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2fc3df4631a6889f$var$skeletonItemElemSize = 20;
var $2fc3df4631a6889f$var$N20A = 'rgba(9, 30, 66, 0.04)';
var $2fc3df4631a6889f$var$N30A = 'rgba(9, 30, 66, 0.08)';
var $2fc3df4631a6889f$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfklbf8 _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1ruslbf8 _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx314q2",
    icon: "_rfx3sqtm",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ var $2fc3df4631a6889f$var$shimmerKeyframes = null;
/**
 * These styles are defined using `css` rather than `cssMap` as there is a bug when using
 * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
 */ var $2fc3df4631a6889f$var$shimmerStyles = null;
/**
 * __Skeleton item__
 *
 * A skeleton item is used in place of an item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $2fc3df4631a6889f$var$SkeletonItem = function SkeletonItem(_ref) {
    var hasAvatar = _ref.hasAvatar, hasIcon = _ref.hasIcon, _ref$isShimmering = _ref.isShimmering, isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering, _ref$isSideNavSkeleto = _ref.isSideNavSkeleton, isSideNavSkeleton = _ref$isSideNavSkeleto === void 0 ? false : _ref$isSideNavSkeleto, testId = _ref.testId, width = _ref.width, xcss = _ref.xcss;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $fa75feeaa55cf7b8$export$2e2bcd8739ae039)([
            $2fc3df4631a6889f$var$styles.root,
            (hasAvatar || hasIcon) && $2fc3df4631a6889f$var$styles.beforeElement,
            hasAvatar && $2fc3df4631a6889f$var$styles.avatar,
            hasIcon && $2fc3df4631a6889f$var$styles.icon,
            width ? $2fc3df4631a6889f$var$styles.customWidth : $2fc3df4631a6889f$var$styles.defaultWidth,
            isSideNavSkeleton && $2fc3df4631a6889f$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1hno _10881hno _18lgp3kn _zo24p3kn _1hfk3yfp _1rus3yfp",
            xcss
        ]),
        "data-testid": testId,
        style: $2fc3df4631a6889f$var$_objectSpread($2fc3df4631a6889f$var$_objectSpread({}, {
            '--width': width
        }), {}, {
            "--_1j9jaml": (0, $e34416589fe02ab7$export$2e2bcd8739ae039)("var(--ds-skeleton, ".concat($2fc3df4631a6889f$var$N20A, ")")),
            "--_wb902m": (0, $e34416589fe02ab7$export$2e2bcd8739ae039)("var(--ds-skeleton-subtle, ".concat($2fc3df4631a6889f$var$N30A, ")"))
        })
    });
};
var $2fc3df4631a6889f$export$2e2bcd8739ae039 = $2fc3df4631a6889f$var$SkeletonItem;






const $6b7c307e3b08d158$var$_5 = "._67531crf>div:first-of-type:after{height:9pt}";
const $6b7c307e3b08d158$var$_4 = "._p12f1w8u{max-width:80%}";
const $6b7c307e3b08d158$var$_3 = "._2lx21bp4{flex-direction:column}";
const $6b7c307e3b08d158$var$_2 = "._1e0c1txw{display:flex}";
const $6b7c307e3b08d158$var$_ = "._1yt41ul9{padding:var(--_18cq338)}";
const $6b7c307e3b08d158$var$styles = null;
const $6b7c307e3b08d158$var$Skeleton = ()=>{
    const isPending = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $7a501a2d8adab3c3$export$6a1923cb7c064699));
    if (!isPending) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                    children: [
                        $6b7c307e3b08d158$var$_,
                        $6b7c307e3b08d158$var$_2,
                        $6b7c307e3b08d158$var$_3,
                        $6b7c307e3b08d158$var$_4,
                        $6b7c307e3b08d158$var$_5
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    "data-testid": "skeleton-wrapper",
                    className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                        "_1yt41ul9 _1e0c1txw _2lx21bp4 _p12f1w8u _67531crf"
                    ]),
                    style: {
                        "--_18cq338": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.100'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $effa30ea74c01e92$export$2e2bcd8739ae039), {
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2fc3df4631a6889f$export$2e2bcd8739ae039), {
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2fc3df4631a6889f$export$2e2bcd8739ae039), {
                            isShimmering: true,
                            hasIcon: true
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2fc3df4631a6889f$export$2e2bcd8739ae039), {
                            isShimmering: true,
                            hasIcon: true
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2fc3df4631a6889f$export$2e2bcd8739ae039), {
                            isShimmering: true,
                            hasIcon: true
                        })
                    ]
                })
            ]
        })
    });
};
var $6b7c307e3b08d158$export$2e2bcd8739ae039 = $6b7c307e3b08d158$var$Skeleton;







parcelRequire("7fPBF");


/* EmptyView.tsx generated by @compiled/babel-plugin v0.38.1 */ 

parcelRequire("7fPBF");






parcelRequire("7fPBF");
const $5317b8d7579cfa5a$var$SvgIncomingMessage = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 535.538 474.071"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: -136.716,
                        y1: 85.338,
                        x2: 4.399,
                        y2: 85.338,
                        gradientTransform: "matrix(.818 -.355 0 1 88.514 172.44)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.121,
                                stopColor: "#fff",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#bbd6ff",
                                stopOpacity: 0.332
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.816,
                                stopColor: "#5a9cff",
                                stopOpacity: 0.809
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#3384ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: 292.375,
                        y1: 66.313,
                        x2: 311.681,
                        y2: 66.313,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.657,
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.756,
                                stopColor: "#0060f0"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.937,
                                stopColor: "#0052cc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "linear-gradient-4",
                        x1: -158.115,
                        y1: 294.262,
                        x2: 51.105,
                        y2: 294.262,
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "linear-gradient-5",
                        x1: -158.115,
                        y1: 309.083,
                        x2: 51.105,
                        y2: 309.083,
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "linear-gradient-6",
                        x1: -158.115,
                        y1: 301.206,
                        x2: 51.105,
                        y2: 301.206,
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-7",
                        x1: 376.152,
                        y1: 474.071,
                        x2: 376.152,
                        y2: 246.333,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#0065ff",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.661,
                                stopColor: "#0065ff",
                                stopOpacity: 0.673
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0065ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-8",
                        x1: 381.752,
                        y1: 248.741,
                        x2: 319.155,
                        y2: 35.582,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#6bd5e5"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.203,
                                stopColor: "#67d4e4"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.394,
                                stopColor: "#5cd0e2"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.579,
                                stopColor: "#49c9de"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.759,
                                stopColor: "#2fbfd8"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.857,
                                stopColor: "#1db9d4"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-9",
                        x1: 297.786,
                        y1: 271.526,
                        x2: 297.786,
                        y2: 100.805,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.818,
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-10",
                        x1: 242.54,
                        y1: 73.753,
                        x2: 473.423,
                        y2: 304.635,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.119,
                                stopColor: "#7a869a",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7a869a"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-11",
                        x1: 22.116,
                        y1: 169.947,
                        x2: 173.833,
                        y2: 18.23,
                        gradientTransform: "matrix(.818 -.355 0 1 88.514 172.44)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.818,
                                stopColor: "#3384ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-12",
                        x1: 287.083,
                        y1: 124.032,
                        x2: 287.083,
                        y2: 77.423,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.547,
                                stopColor: "#0052cc"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.902,
                                stopColor: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.933,
                                stopColor: "#2481fc"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.958,
                                stopColor: "#1c77f2"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.98,
                                stopColor: "#1067e1"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0052cc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-13",
                        x1: 298.353,
                        y1: 125.998,
                        x2: 298.353,
                        y2: 77.25,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.481,
                                stopColor: "#0052cc"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.926,
                                stopColor: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.945,
                                stopColor: "#227ffa"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.969,
                                stopColor: "#1771eb"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.994,
                                stopColor: "#0559d3"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0052cc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-14",
                        x1: 274.475,
                        y1: 59.599,
                        x2: 295.653,
                        y2: 59.599,
                        gradientTransform: "rotate(37.942 286.848 58.43)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.628,
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.765,
                                stopColor: "#005ae1"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.852,
                                stopColor: "#0052cc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "New_Gradient_Swatch_13",
                        x1: -40.95,
                        y1: -1059.962,
                        x2: -36.771,
                        y2: -1064.142,
                        gradientTransform: "matrix(1 0 0 -1.522 312.893 -1573.203)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#00c7e5"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13-2",
                        x1: -40.594,
                        y1: -1065.291,
                        x2: -37.128,
                        y2: -1068.757,
                        gradientTransform: "matrix(1 0 0 -1.522 320.464 -1580.944)",
                        xlinkHref: "#New_Gradient_Swatch_13"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13-3",
                        x1: -40.185,
                        y1: -1070.019,
                        x2: -37.537,
                        y2: -1072.667,
                        gradientTransform: "matrix(1 0 0 -1.522 326.899 -1587.525)",
                        xlinkHref: "#New_Gradient_Swatch_13"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-16",
                        x1: 295.563,
                        y1: 77.114,
                        x2: 319.051,
                        y2: 62.939,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.279,
                                stopColor: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.56,
                                stopColor: "#086cff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.628,
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.765,
                                stopColor: "#005ae1"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.852,
                                stopColor: "#0052cc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "New_Gradient_Swatch_11",
                        x1: 310.986,
                        y1: 194.755,
                        x2: 363.199,
                        y2: 194.755,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "New_Gradient_Swatch_2",
                        x1: 330.492,
                        y1: 219.33,
                        x2: 330.492,
                        y2: 191.873,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#ff5630"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ff8f73"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_2-2",
                        x1: 343.475,
                        y1: 219.534,
                        x2: 343.475,
                        y2: 191.768,
                        xlinkHref: "#New_Gradient_Swatch_2"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient-17",
                        x1: 116.917,
                        y1: -2418.323,
                        x2: 110.364,
                        y2: -2429.673,
                        gradientTransform: "matrix(.912 -.365 -.022 -1.088 -45.115 -2378.143)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#fff",
                                stopOpacity: 0.4
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#fff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("radialGradient", {
                        id: "radial-gradient",
                        cx: 333.607,
                        cy: 227.537,
                        r: 18.393,
                        gradientTransform: "rotate(81.59 311.98 208.873) scale(1 .836)",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.164,
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.363,
                                stopColor: "#00b5d6"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.525,
                                stopColor: "#00adcc"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.642,
                                stopColor: "#00a3bf"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("radialGradient", {
                        id: "radial-gradient-2",
                        cx: 336.354,
                        cy: 227.33,
                        r: 22.804,
                        gradientTransform: "matrix(.032 .999 -.663 .021 476.454 -113.664)",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#00c7e5"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.398,
                                stopColor: "#00c4e2"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.741,
                                stopColor: "#00b9da"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.765,
                                stopColor: "#00b8d9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "clip-path",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            id: "_Clipping_Path_",
                            d: "M103.743 321.455 0 366.224V225.881l103.743-33.508v129.082z"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "clip-path-2",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            id: "_Clipping_Path_2",
                            className: "cls-2",
                            d: "M309.714 54.989c2.04 1.878 2.36 5.189 1.57 8.535-.382 1.62-.347 2.447-.557 3.721a28.089 28.089 0 0 0 .471 10.876c-.47.12-1.175.287-2.04.446a42.432 42.432 0 0 1-5.06.528c-2.593.185-3.9.282-4.588.244a21.493 21.493 0 0 1-3.845-.563c.732-5.805-.342-9.334-1.546-11.525-.741-1.349-2.216-3.436-1.6-5.588.234-.812.749-1.575 1.206-3.334a16.269 16.269 0 0 0 .423-2.3l1.942-1.586a4.353 4.353 0 0 0 7.127-1.082 8.549 8.549 0 0 1 1.19-.086c.445.003 3.478.031 5.307 1.714Z"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: ".cls-2{fill:url(#linear-gradient-2)}.cls-33,.cls-9{fill:#00c7e5}.cls-9{opacity:.3}.cls-22,.cls-43,.cls-45{fill:none}.cls-43{stroke-miterlimit:10}.cls-12{fill:#9ce3ee}.cls-16{fill:#1db9d4}.cls-18{fill:#3384ff}.cls-21{fill:#fff}.cls-22{stroke:#ff5230;stroke-width:2.321px}.cls-23{fill:#e0ada6}.cls-24{fill:#253858}.cls-36{fill:#344563}.cls-37{fill:#b5917c}.cls-43{stroke:#ff5630;stroke-width:2px}"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    isolation: "isolate"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                    id: "Layer_2",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                        id: "Layer_1-2",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                                style: {
                                    mixBlendMode: "multiply",
                                    opacity: 0.19
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                        id: "_Clipping_Path_3",
                                        style: {
                                            fill: "url(#linear-gradient)"
                                        },
                                        d: "M103.743 321.455 0 366.224V225.881l103.743-33.508v129.082z"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                                        style: {
                                            clipPath: "url(#clip-path)"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                                style: {
                                                    fill: "url(#linear-gradient-4)"
                                                },
                                                d: "m5.398 302.743 39.117-16.962"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                                style: {
                                                    fill: "url(#linear-gradient-5)"
                                                },
                                                d: "m5.398 317.564 39.117-16.962"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                                style: {
                                                    fill: "url(#linear-gradient-6)"
                                                },
                                                d: "m5.398 309.687 39.117-16.962"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-9",
                                d: "M151.657 108.409c8.351.127 7.9 4.325 14.51 3.148 7.577-1.348 8.567-11.762 19.038-11.762 17.342 0 17.333 18.018 17.333 18.018s2.945 8.756 9.98 9.083a1.288 1.288 0 0 1 .287.025c0 .219-68.3.082-91.323.036-6.854-.014-20.048-.044-26.595-.062 10.939-4.014 16.046-4.736 18.487-4.09 5.563 1.472 2.827-6.3 12.407-8.45 7.553-1.694 8.888 1.251 12.952 1.251 7.198.001 2.781-6.215 12.924-7.197ZM474.391 8.614c8.351.127 7.9 4.325 14.51 3.148C496.477 10.413 497.468 0 507.938 0c17.342 0 17.333 18.018 17.333 18.018s2.945 8.756 9.98 9.083a1.288 1.288 0 0 1 .287.025c0 .219-68.3.082-91.323.036-6.854-.014-20.048-.044-26.595-.062 10.939-4.014 16.046-4.736 18.487-4.09 5.563 1.472 2.827-6.3 12.407-8.45 7.553-1.694 8.888 1.251 12.952 1.251 7.199.001 2.781-6.211 12.925-7.197Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                style: {
                                    strokeWidth: "19.44px",
                                    stroke: "url(#linear-gradient-7)",
                                    strokeMiterlimit: 10,
                                    fill: "none"
                                },
                                d: "M376.152 246.333v227.738"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-9",
                                d: "M508.348 292.622c-1.236-12.277-4.055-16.728-14.045-16.8s-10.56 3.127-13.713 5.658-5.688 1.941-9.706 1.224-8.655-1.181-12.673 1.434-4.637 3.8-10.077 3.333c-4.73-.4-5.955-.353-8.172.27a16.478 16.478 0 0 0-3.05 1.34c-5.09 2.58-6.065 4.342-9.4 5.643a17.024 17.024 0 0 1-6.146 1.1l86.984.4Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Path_",
                                d: "M427.644 49.459a58.919 58.919 0 0 0-18.08 2.828c-.288.088-128.712 40.5-129 40.6a58.992 58.992 0 0 0-41.748 56.411v122.321h117.939l129.858-44.872V104.422c0-32.567-26.402-54.963-58.969-54.963Z",
                                style: {
                                    fill: "url(#linear-gradient-8)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-12",
                                d: "m486.613 211.789-.006-.017-129.378 43.646.777 2.303 128.607-43.386v-2.546zM486.607 203.459l-129.378 43.645.777 2.303 128.607-43.385v-2.546l-.006-.017zM486.607 118.245l-129.378 43.647.777 2.302 128.607-43.386v-2.546l-.006-.017zM486.607 109.932l-129.378 43.646.777 2.303 128.607-43.386v-2.547l-.006-.016z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M373.347 256.707v-126.15a58.977 58.977 0 0 0-37.716-55.005l-5.756 1.812a58.988 58.988 0 0 1 38.925 55.468v122.73Z",
                                style: {
                                    fill: "#ebecf0",
                                    opacity: 0.62,
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Path_2",
                                d: "M297.786 90.325a58.969 58.969 0 0 0-58.969 58.969v122.325h117.938V149.294a58.969 58.969 0 0 0-58.969-58.969Z",
                                style: {
                                    fill: "#0065ff"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "m356.755 224.881-16.42 6.494c-22.883-13.854-38.335-39.285-38.371-65.094a75.843 75.843 0 0 0-37.723-65.476 58.891 58.891 0 0 0-25.423 48.446v122.275l93.075-36.811Z",
                                style: {
                                    fill: "url(#linear-gradient-9)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-16",
                                d: "M297.786 90.325c-1.346 0-2.676.061-4 .15h8a60.186 60.186 0 0 0-4-.15Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-16",
                                d: "M301.964 166.281c.038 25.809 15.488 51.24 38.371 65.094l16.42-6.494v-75.587a58.961 58.961 0 0 0-54.969-58.819h-8a58.628 58.628 0 0 0-29.546 10.33 75.843 75.843 0 0 1 37.724 65.476Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M301.964 166.281c.038 25.809 15.488 51.24 38.371 65.094l16.42-6.494v-75.587a58.961 58.961 0 0 0-54.969-58.819h-8a58.628 58.628 0 0 0-29.546 10.33 75.843 75.843 0 0 1 37.724 65.476Z",
                                style: {
                                    fill: "url(#linear-gradient-10)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Clipping_Path_4",
                                className: "cls-18",
                                d: "M297.917 433.7c-32.568 0-58.969-23.636-58.969-52.792V271.393h117.937v109.512c0 29.157-26.401 52.795-58.968 52.795Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Path_3",
                                style: {
                                    fill: "url(#linear-gradient-11)"
                                },
                                d: "M248.699 258.602 94.887 325.299V194.551l153.812-51.335v115.386z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                style: {
                                    fill: "#ff5230"
                                },
                                d: "m378.124 72.088-4.777 1.853v182.757l4.777-1.853V98.244l29.21-10.698V62.231l-29.21 9.857z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-21",
                                d: "m241.831 179.947-21.375 9.269v-27.067l21.375-8.336v26.134z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-22",
                                d: "M184.7 192.47c3.309-1.435 3.309 1.722 6.617.288s3.31-4.592 6.619-6.027 3.309 1.722 6.617.288 3.311-4.593 6.622-6.028a3.993 3.993 0 0 1 1.624-.384M184.7 204.221c3.309-1.435 3.309 1.722 6.617.288s3.31-4.592 6.619-6.027 3.309 1.722 6.617.288 3.311-4.593 6.622-6.028a3.677 3.677 0 0 1 1.9-.367M184.7 198.346c3.309-1.435 3.309 1.722 6.617.288s3.31-4.592 6.619-6.027 3.309 1.722 6.617.288 3.311-4.593 6.622-6.028a5.342 5.342 0 0 1 .731-.26"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Path_4",
                                className: "cls-22",
                                d: "M233.332 177.632c0 7.232-4.8 15.175-10.711 17.74s-10.711-1.218-10.711-8.451 4.8-15.175 10.711-17.74 10.711 1.219 10.711 8.451Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-23",
                                d: "M294.376 79.076c-12.172 4.071-18.2 6.466-20.009 10.37-.934 2.015-.583 2.9-.54 9.438a145.2 145.2 0 0 1-.868 16.945 8.264 8.264 0 0 1-.512 1.669c-1.59 3.715-5.3 4.673-5.027 5.717.2.75 2.316 1.016 3.925.662 1.025-.226 2.276-1.3 4.777-3.452.867-.746 1.486-1.243 1.649-2.123a9.087 9.087 0 0 0-.216-2.337 9.486 9.486 0 0 1-.162-1.872c-.244-1.455 4.407-10.288 5.368-16.663a21.635 21.635 0 0 0 .239-3.257 74.506 74.506 0 0 0 15.765-4.81 10.342 10.342 0 0 0 2.226-8.013 9.3 9.3 0 0 0-1.742-3.927c-1.226.394-2.886.988-4.873 1.653Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-23",
                                d: "M284.676 102.975c-.15-2.27-.348-4.542-.351-6.817 0-2.691.171-4.973.361-7.719a3.957 3.957 0 0 1 2.007-3.143l16.747-8.046 5 .235a4.429 4.429 0 0 1 2.162.986c1.229 1.065 1.552 3.11 1.667 3.892a10.032 10.032 0 0 1 .042 2.741c-.439 2.713-6.071 3.573-14.672 6.366l-3.6 1.242a42.646 42.646 0 0 1-.166 7.178 43.081 43.081 0 0 1-3.518 12.958c-1.654 2.708-1.723 4.592-1.445 5.84a3.774 3.774 0 0 1 .246 2.152c-.316 1-1.2 1.254-3.072 2.489-2.366 1.562-2.107 1.92-3.223 2.32-1.95.7-4.671.3-5.036-.775-.508-1.49 4.153-2.421 6.481-6.73 1.224-2.272.939-6.571.37-15.169Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-24",
                                d: "M294.6 45.948c-.676.278.958 3.069-.149 5.954-1.095 2.853-3.733 2.834-4.242 5.507-.274 1.44.13 3.338 1.3 3.907 1.513.735 3.614-1.081 3.87-1.3 3.012-2.6 3.435-7.77 1.712-11.312-.738-1.528-1.982-2.964-2.491-2.756Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-23",
                                d: "M296.717 49.781a7.179 7.179 0 0 1 .278 2.366 7.255 7.255 0 0 1-.948 3.218 9.468 9.468 0 0 0 6.548-.574 9.161 9.161 0 0 1 1.247-7.191Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M300.99 81.349a9.3 9.3 0 0 0-1.742-3.927c-1.225.394-2.884.989-4.872 1.653-12.172 4.071-18.2 6.466-20.009 10.37-.934 2.015-.583 2.9-.54 9.438a145.1 145.1 0 0 1-.791 16.22 7.846 7.846 0 0 1 4.366-1.337c.269-2.135 4.453-10.326 5.359-16.338a21.635 21.635 0 0 0 .239-3.255 74.506 74.506 0 0 0 15.765-4.81 10.342 10.342 0 0 0 2.225-8.014Z",
                                style: {
                                    fill: "url(#linear-gradient-12)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M312.266 82.363c-.115-.782-.438-2.828-1.667-3.892a4.429 4.429 0 0 0-2.162-.986l-5-.235-16.745 8.05a3.957 3.957 0 0 0-2.007 3.143c-.19 2.746-.365 5.029-.361 7.719 0 2.275.2 4.547.351 6.817.48 7.25.754 11.437.094 13.936a8.371 8.371 0 0 1 3.371-.667c.266 0 .52.018.772.038a10.68 10.68 0 0 1 1.438-3.433 43.081 43.081 0 0 0 3.518-12.958 42.646 42.646 0 0 0 .166-7.178l3.6-1.242c8.6-2.793 14.233-3.653 14.672-6.366a10.032 10.032 0 0 0-.04-2.746Z",
                                style: {
                                    fill: "url(#linear-gradient-13)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-23",
                                d: "M294.891 55.53a28.349 28.349 0 0 1-5.13 3.058 34.548 34.548 0 0 0-4.955 2.559c-.483.308-.873.576-1.136.761 0-.683-.016-1.722-.095-2.987-.132-2.1-.35-3.4-.763-6.434-.147-1.079-.356-2.66-.594-4.6l-2.557-.357a58.4 58.4 0 0 0-.907 7.629 33.021 33.021 0 0 0 .21 7.41 28.43 28.43 0 0 0 .655 3.071 1.507 1.507 0 0 0 1.548 1.116 30.456 30.456 0 0 0 4.025-.522c2.936-.582 8.66-1.718 11.341-5.974.441-.7 1.615-2.565.85-3.762a3.022 3.022 0 0 0-2.492-.968Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M296.532 60.256c.441-.7 1.615-2.565.85-3.762a3.022 3.022 0 0 0-2.491-.964 28.349 28.349 0 0 1-5.13 3.058 34.548 34.548 0 0 0-4.955 2.559c-.483.308-.873.576-1.136.761 0-.683-.016-1.722-.095-2.987-.132-2.1-.35-3.4-.763-6.434-.068-.5-.15-1.114-.241-1.812a7.146 7.146 0 0 1-3.4.032 58.706 58.706 0 0 0-.414 4.449 33.021 33.021 0 0 0 .21 7.41 28.43 28.43 0 0 0 .655 3.071 1.507 1.507 0 0 0 1.548 1.116 30.456 30.456 0 0 0 4.025-.522c2.932-.583 8.656-1.719 11.337-5.975Z",
                                style: {
                                    fill: "url(#linear-gradient-14)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                id: "_Clipping_Path_5",
                                className: "cls-2",
                                d: "M309.714 54.989c2.04 1.878 2.36 5.189 1.57 8.535-.382 1.62-.347 2.447-.557 3.721a28.089 28.089 0 0 0 .471 10.876c-.47.12-1.175.287-2.04.446a42.432 42.432 0 0 1-5.06.528c-2.593.185-3.9.282-4.588.244a21.493 21.493 0 0 1-3.845-.563c.732-5.805-.342-9.334-1.546-11.525-.741-1.349-2.216-3.436-1.6-5.588.234-.812.749-1.575 1.206-3.334a16.269 16.269 0 0 0 .423-2.3l1.942-1.586a4.353 4.353 0 0 0 7.127-1.082 8.549 8.549 0 0 1 1.19-.086c.445.003 3.478.031 5.307 1.714Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-18",
                                d: "m292.038 65.434.114-3.497",
                                style: {
                                    clipPath: "url(#clip-path-2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-23",
                                d: "M294.322 39.432a4.769 4.769 0 0 0-1.3 3.069l-.022.659s.032.373-.871 1.615c-.279.384 1.2.782 1.2.782a5.74 5.74 0 0 0 .12 1.793c.06.255.1.32.217.8a9.069 9.069 0 0 0 .325 1.35c.2.327.768.627 2.47.4a10.764 10.764 0 0 1 4.46-.637 2.55 2.55 0 0 0 2.923-1.657 6.142 6.142 0 0 0 1.085-1.827 6.281 6.281 0 0 0-.518-5.645 6.913 6.913 0 0 0-.9-1.112 5.019 5.019 0 0 0-4.3-1.345l-2.123.319a4.775 4.775 0 0 0-2.766 1.436Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-24",
                                d: "M292.259 41.751q1.318.089 2.7.219t2.7.3a15.394 15.394 0 0 0-.161 2.507 25.653 25.653 0 0 0 1.034 4.752 7.074 7.074 0 0 1-.183 4.769c-.8 1.6-1.192 1.914-1.152 3.041a3.906 3.906 0 0 0 2.839 3.482c2.047.417 4.018-1.722 4.846-2.621 1.688-1.832 2.029-3.546 3.36-3.68a2.322 2.322 0 0 1 1.623.592 8.665 8.665 0 0 0 .721-5.071 8.354 8.354 0 0 0-.988-2.728A17.917 17.917 0 0 0 307.682 45a12.717 12.717 0 0 1-1.636-3.761 6.357 6.357 0 0 0-2.2-3.4 6.505 6.505 0 0 0-2.4-.837 11.92 11.92 0 0 0-4.553-.179 5.665 5.665 0 0 0-4.635 4.925Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-23",
                                d: "M282.515 46.878a3.58 3.58 0 0 1-.829.9 2.138 2.138 0 0 1-.906.3c-.713.106-.937.763-1.194.647s.063-.816-.2-1.957c-.149-.656-.325-.716-.331-1.241a3.367 3.367 0 0 1 .36-1.366c.277-.69.469-.769.575-.785a.6.6 0 0 1 .462.189c.112-.526.281-.691.429-.73.276-.074.728.223.728.223.052-.072.38-.523.631-.448.086.026.135.1.292.469.293.681.244.69.335.785.312.324.765.08.995.393a.765.765 0 0 1 .065.595c-.065.373-.266.528-.72 1.1-.334.413-.24.348-.692.926Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-23",
                                d: "M280.112 47.633c-.11-.3.2-.677.857-1.362a4.23 4.23 0 0 1 1.506-1.11c.726-.3.8-.039 1.521-.364.6-.267.817-.56 1.313-.529.284.018.629.141.65.312s-.24.3-.452.426a9.5 9.5 0 0 0-1.456 1.088 2.133 2.133 0 0 1-.5 1.134 2.231 2.231 0 0 1-1.091.654c-.882.275-2.165.247-2.348-.249Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M272.4 39.873h3.271V47.5a.39.39 0 0 1-.39.39h-2.492a.39.39 0 0 1-.39-.39v-7.627Z",
                                transform: "rotate(-91.278 274.03 43.883)",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_13)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M280.384 40.15h2.434v6.729a.4.4 0 0 1-.4.4h-1.64a.4.4 0 0 1-.4-.4V40.15h.006Z",
                                transform: "rotate(-91.278 281.6 43.714)",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_13-2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                transform: "rotate(-91.26 288.056 43.493)",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_13-3)"
                                },
                                d: "M287.277 40.696h1.52v5.748h-1.52z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                className: "cls-33",
                                x: 289.992,
                                y: 43.2,
                                width: 2.421,
                                height: 0.586,
                                rx: 0.237,
                                ry: 0.237,
                                transform: "rotate(-91.278 291.202 43.494)"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                className: "cls-33",
                                x: 267.587,
                                y: 43.501,
                                width: 3.922,
                                height: 0.949,
                                rx: 0.385,
                                ry: 0.385,
                                transform: "rotate(-91.278 269.547 43.976)"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-23",
                                d: "M282.441 43.68a.511.511 0 0 1-.354-.086c-.264-.172-.25-.509-.359-.513-.132 0-.144.492-.427.586a.459.459 0 0 1-.4-.1c-.206-.165-.129-.4-.26-.467-.23-.119-.605.532-.906.45-.268-.073-.447-.706-.272-1.2.248-.7 1.13-.907 1.431-.979a3.717 3.717 0 0 1 2 .233c.6.166.8.308.914.5a1.365 1.365 0 0 1 .128.823c-.015.2-.034.452-.155.493-.2.066-.42-.509-.7-.467s-.281.655-.64.727Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-24",
                                d: "M277.555 115.964a8.1 8.1 0 0 1-.121-.83 9.138 9.138 0 0 1-.036-.633 25.65 25.65 0 0 0-.911 1.442c-1.244 2.12-1.339 2.969-2.118 3.4-.5.276-1.337.419-2.832-.262-.6.483-1.456 1.2-2.457 2.128-1.6 1.482-1.72 1.778-1.66 2 .19.716 2.212 1.039 3.925.662 1.025-.226 2.276-1.3 4.777-3.452 1.074-.923 1.554-1.4 1.649-2.123a9.413 9.413 0 0 0-.216-2.332ZM288.791 117.2a6.228 6.228 0 0 0-1.162.927c-1.453 1.478-1.133 2.67-2.387 3.627a3.564 3.564 0 0 1-2.465.693 3.36 3.36 0 0 1-1.656-.7c-1.9 1.469-3.619 2.186-3.3 3.121.366 1.074 3.086 1.474 5.036.775.76-.272.883-.525 1.631-1.152a13.559 13.559 0 0 1 1.592-1.167c.914-.588 1.36-.72 1.865-1.074a4.044 4.044 0 0 0 .492-.4 3.451 3.451 0 0 0 .834-1.011c.225-.513 0-.872-.256-2.152a16.404 16.404 0 0 1-.224-1.487Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-23",
                                d: "M308.174 54.517a2.986 2.986 0 0 1 2.27 1.081c.757.81 1.031 1.843 1.132 3.558a21.578 21.578 0 0 1-.393 5.566c-.4 1.93-.964 4.7-1.7 8.559a47.38 47.38 0 0 1-6.229 15.759l-2.512-.842c.383-1.091.653-1.973.809-2.5 1.577-5.334 1.393-7.84 3.206-11.717.363-.776.7-1.375.878-1.688q-.089-1.532-.148-3.1c-.151-4.062-.128-7.965.029-11.694a3.4 3.4 0 0 1 2.658-2.982Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-23",
                                d: "M299.05 89.428a7.251 7.251 0 0 0-1.69.948 8.338 8.338 0 0 0 .352 3.753.533.533 0 0 0 .276.162.438.438 0 0 1 .769.2.686.686 0 0 0 .806-.306.651.651 0 0 0 .5.658.635.635 0 0 0 .61-.247l.171-3.151a1.783 1.783 0 0 1 .53-.3c.413-.147.645-.047 1.084-.2a1.66 1.66 0 0 0 .482-.253c.8-.646.544-2.44.544-2.44l-2.6-.379a3.486 3.486 0 0 1-.755 1.231 7.2 7.2 0 0 0-1.079.324Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M311.576 59.157c-.1-1.716-.374-2.748-1.132-3.558a2.986 2.986 0 0 0-2.27-1.081 3.4 3.4 0 0 0-2.655 2.979c-.157 3.728-.18 7.632-.029 11.694q.058 1.57.148 3.1c-.18.313-.515.912-.878 1.688-1.8 3.839-1.635 6.338-3.163 11.564a7.265 7.265 0 0 1 2.859 1.449 47.251 47.251 0 0 0 5.029-13.711c.733-3.861 1.295-6.63 1.7-8.559a21.578 21.578 0 0 0 .391-5.565Z",
                                style: {
                                    fill: "url(#linear-gradient-16)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M333.718 191.873a3.834 3.834 0 0 0 6.334-.1 4.47 4.47 0 0 1-.469-1.168 5.684 5.684 0 0 1-.107-1.561 11.506 11.506 0 0 1 .256-2.04L334 188.516Z",
                                style: {
                                    fill: "#9c7761"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-36",
                                d: "m339.54 187.134 1.371-.959a2.9 2.9 0 0 0 1.176-1.755l.121-.553a17.7 17.7 0 0 0 .405-4.114 2.4 2.4 0 0 0-1.314-2.081l-.215-.11a13.483 13.483 0 0 0-5.015-1.438l-3.42-.291a1.692 1.692 0 0 0-1.689-.668c-.778.24-.926 1.316-.736 2a2.23 2.23 0 0 0 1.08 1.279l2.891 5.979Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-37",
                                d: "M331.946 178.316a19.268 19.268 0 0 0-1.106 4.642 7.76 7.76 0 0 1-.393.674c-.576.883-1.171 1.407-1.009 1.624.014.019.693.28.809.372.243.193.1 2.253.573 3.094.951 1.707 6.531 2.087 8.322-.46a3.492 3.492 0 0 0 .59-2.073 2.378 2.378 0 0 1-.3-.113 2.509 2.509 0 0 1-1.187-1.136c-.453-.961.281-1.735-.191-2.117a.812.812 0 0 0-.754-.089c-.69.27-.79 1.7-.79 1.7h-.022c-.012 0-.269-.058-1.041-.242-.011-2.5-.663-3.433-1.3-3.8a5.411 5.411 0 0 1-1.259-.824 4.432 4.432 0 0 1-.942-1.252Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M329.07 215.784c.2 2.652.5 6.55.938 11.278.561 6.079.854 9.118 1.054 10.139 1.068 5.443 3.8 14.295 4.627 19.139a6.489 6.489 0 0 1-.049 2.661 7.59 7.59 0 0 1-2.434 3.818c-1.275 1.057-2.5 1.284-2.431 1.7.067.4 1.248.673 2.307.49 1.192-.207 1.256-.828 3.018-1.794a13.534 13.534 0 0 0 2.535-1.394 2.048 2.048 0 0 0 .224-.33 4.092 4.092 0 0 0 .114-3.182l-3.011-43.223Z",
                                style: {
                                    fill: "url(#radial-gradient)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M335.257 215.317c1.026 13.008 1.433 18.1 1.459 18.314v.021c.271 2.312.56 2.64.592 3.636.028.864-.19.6-.378 2.58-.074.781-.091 1.4-.1 1.754-.012.4-.01.879.02 1.57.2 4.669.978 5.03 1.568 10.766a65.067 65.067 0 0 1 .42 8.672 59.428 59.428 0 0 1-.194 3.628 3.236 3.236 0 0 1 .787 1.068c.419.935.11 1.578.6 2.031a1.9 1.9 0 0 0 1.342.346c.727.019 2.108-.151 2.316-.822.155-.5-.437-.954-.886-1.607-.863-1.252-.821-2.682-.658-4.721.42-5.239 1.431-11.831 1.715-14.466.194-1.806.347-3.664.347-3.664.041-.489.082-1.017.129-1.7.346-4.964.405-9.217.524-17.724.052-3.737.067-6.821.071-8.909a1.083 1.083 0 0 0-.089-.727c-.451-.8-2.123-.6-4.2-.418-1.227.108-3.066.255-5.385.372Z",
                                style: {
                                    fill: "url(#radial-gradient-2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-36",
                                d: "M338.967 258.206a8.031 8.031 0 0 1-2.8.528c-.154 0-.3-.015-.455-.023-.024.1-.039.193-.069.291 0 0-.062.231-.151.467a6.588 6.588 0 0 1-2.046 2.941 3.243 3.243 0 0 0-2.538 1.536 2.2 2.2 0 0 0-.193.813 4.151 4.151 0 0 0 2.371.253 4.29 4.29 0 0 0 .63-.185 7.609 7.609 0 0 0 2.425-1.478 7.891 7.891 0 0 0 2.889-1.265q0-.453-.01-.908-.02-1.494-.053-2.97Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-36",
                                d: "m342.141 262.552.054-.633a17.023 17.023 0 0 1-3.352.274v.436a59.428 59.428 0 0 1-.194 3.628 3.236 3.236 0 0 1 .787 1.068c.419.935.11 1.578.6 2.031a1.9 1.9 0 0 0 1.342.346c.727.019 2.108-.151 2.316-.822.155-.5-.437-.954-.886-1.607-.872-1.251-.831-2.682-.667-4.721Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M360.073 172.63a40.724 40.724 0 0 1-1.923 4.724c-1.283 2.656-2.315 4.035-3.09 6.734a19.522 19.522 0 0 0-.559 2.6 42.566 42.566 0 0 0-5.741 4.041q-.238.2-.468.4a4.361 4.361 0 0 1-1.76.921 4.479 4.479 0 0 1-1.313.131c-1.961-.062-4.655-.357-5.167-.414a4.278 4.278 0 0 1-3.468 1.6 4.149 4.149 0 0 1-2.866-1.5c-.652.062-2.82.264-4.72.323a4.516 4.516 0 0 1-1.368-.141 4.357 4.357 0 0 1-1.719-.91q-.24-.207-.487-.413a42.559 42.559 0 0 0-5.741-4.041 19.546 19.546 0 0 0-.559-2.6c-.775-2.7-1.807-4.078-3.09-6.734a40.768 40.768 0 0 1-1.923-4.724l-3.126.817a65.794 65.794 0 0 0 2.847 12.148 65.737 65.737 0 0 0 1.7 4.487 26.549 26.549 0 0 0 4.452 5.052 38.819 38.819 0 0 1 4.927 4.369 20.523 20.523 0 0 1 2.226 3.123c.014.182.028.365.046.548a55.569 55.569 0 0 0 2.754 12.653 28.651 28.651 0 0 0 16.961-.489c-.1-4.405-.093-9.01.056-13.8a59.959 59.959 0 0 1 3.48-3.619c4.619-4.411 7.285-5.523 8.969-9.247a21.013 21.013 0 0 0 .948-3.08 179.594 179.594 0 0 0 2.847-12.148Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_11)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M333.91 203.121q-.024-5.737-.192-11.248l-4.32.229a14.847 14.847 0 0 1-2.256 10.629l-.071 14.929a24.162 24.162 0 0 0 6.606 1.67q.259-7.866.233-16.209Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "m345.14 192.084-5.088-.316-.057 27.766a8.089 8.089 0 0 0 5.7-2.373 6.914 6.914 0 0 0 1.206-1.821l.056-13.8a16.043 16.043 0 0 1-1.814-9.457Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_2-2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-37",
                                d: "M311.945 173.192a1.731 1.731 0 0 0 1.685.105 2.571 2.571 0 0 0 1.342-2.216c.053-.913-.4-1.176-.528-2.452a5.9 5.9 0 0 1 .072-1.632 1.556 1.556 0 0 0-.829.4 1.792 1.792 0 0 0-.35 1.882 2.688 2.688 0 0 0-1.239.847c-.707.886-.934 2.442-.153 3.066Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-43",
                                d: "m313.526 172.494-3.155-12.467"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-37",
                                d: "M311.1 174.071a153.312 153.312 0 0 0-.886-3.729 1.64 1.64 0 0 1-.047-.682 2.727 2.727 0 0 1 2.754-1.911c.109.017.4.063.475.25s-.138.368-.049.61c.071.19.236.164.281.334.066.251-.26.439-.177.637.054.129.214.1.293.238.1.175-.034.421-.085.517a1.581 1.581 0 0 1-1.053.689 1.307 1.307 0 0 1 .771.618c.321.678-.273 1.527-.761 1.925a2.38 2.38 0 0 1-1.516.504ZM362.227 172.866a1.731 1.731 0 0 1-1.685.105 2.571 2.571 0 0 1-1.342-2.216c-.053-.913.4-1.176.528-2.452a5.9 5.9 0 0 0-.072-1.632 1.556 1.556 0 0 1 .829.4 1.792 1.792 0 0 1 .35 1.882 2.688 2.688 0 0 1 1.239.847c.708.885.934 2.442.153 3.066Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-43",
                                d: "m360.646 172.168 3.156-12.467"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-37",
                                d: "M363.074 173.745c.351-1.545.633-2.733.886-3.729a1.64 1.64 0 0 0 .047-.682 2.727 2.727 0 0 0-2.754-1.911c-.109.017-.4.063-.475.25s.138.368.049.61c-.071.19-.236.164-.281.334-.066.251.26.439.177.637-.054.129-.214.1-.293.238-.1.175.034.421.085.517a1.581 1.581 0 0 0 1.053.689 1.307 1.307 0 0 0-.771.618c-.321.678.273 1.527.761 1.925a2.38 2.38 0 0 0 1.516.504Z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-45",
                                d: "m193.431 225.452-35.068 13.455v5.37l35.068-14.103v-4.722zM193.431 233.407l-35.068 14.103v4.877l35.068-14.331v-4.649z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-33",
                                d: "M193.431 223.845 158.363 237.3v1.607l35.068-13.455v-1.607z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-33",
                                d: "M193.431 223.845v-1.606l-35.068 13.455v1.606l35.068-13.455zM193.431 239.676v-1.62l-35.068 14.331v1.62l35.068-14.331zM158.363 254.007v1.621l35.068-14.331v-1.621l-35.068 14.331zM193.431 231.791l-35.068 14.102v1.617l35.068-14.103v-1.616z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                className: "cls-33",
                                d: "M193.431 231.791v-1.617l-35.068 14.103v1.616l35.068-14.102z"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                id: "Layer_2-2",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                                    id: "Blue",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                            d: "M112.683 209.117c-.354-.3-.9-.06-1.114.6l-5.381 15.769c-.159.466-.014.9.324.962a.542.542 0 0 0 .305-.036l7.882-3.159a1.1 1.1 0 0 0 .6-.7c1.609-4.864.448-10.827-2.616-13.436Z",
                                            style: {
                                                fill: "url(#linear-gradient-17)"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                            className: "cls-21",
                                            d: "M116.582 195.167c-3.043 7.254-2.7 13.8-.508 17.938l3.987 7.545a.458.458 0 0 0 .615.211l7.882-3.159a1.2 1.2 0 0 0 .66-1.078.745.745 0 0 0-.079-.333s-11.126-21.066-11.4-21.592c-.257-.468-.863-.238-1.157.468Z"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    }));
var $5317b8d7579cfa5a$export$2e2bcd8739ae039 = $5317b8d7579cfa5a$var$SvgIncomingMessage;


const $8b4253205fa0e537$var$_2 = "._c71lr0r7{max-height:250px}";
const $8b4253205fa0e537$var$_ = "._1yt414lv{padding:var(--_cpuyf2)}";
const $8b4253205fa0e537$var$styles = null;
const $8b4253205fa0e537$var$EmptyView = ()=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9bbee8e48028edce$export$2e2bcd8739ae039), {
        title: translate((0, $447ba15143f7eed7$exports).EMPTY_USER_SUBSCRIPTIONS_MESSAGE),
        hero: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                    children: [
                        $8b4253205fa0e537$var$_,
                        $8b4253205fa0e537$var$_2
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5317b8d7579cfa5a$export$2e2bcd8739ae039), {
                    className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                        "_1yt414lv _c71lr0r7"
                    ]),
                    style: {
                        "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200'))
                    }
                })
            ]
        })
    });
};
var $8b4253205fa0e537$export$2e2bcd8739ae039 = $8b4253205fa0e537$var$EmptyView;




/* LoginRedirect.tsx generated by @compiled/babel-plugin v0.38.1 */ 


parcelRequire("7fPBF");


const $f56c96ad0de33be2$var$_ = "._18s8115o{margin:var(--_fhuf0z) 0}";
const $f56c96ad0de33be2$var$loginRedirectStyles = null;
function $f56c96ad0de33be2$export$d4318c1a3847aad() {
    if ((0, $35a545355f14a0c7$export$6bc7b24d4e862158)().name === (0, $c1e4a1336f2cb96e$exports).PROD) window.location.href = 'https://id.atlassian.com/login?continue=' + (0, $35a545355f14a0c7$export$6bc7b24d4e862158)().url;
    else window.location.href = 'https://id.stg.internal.atlassian.com/login?continue=' + (0, $35a545355f14a0c7$export$6bc7b24d4e862158)().url;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $f56c96ad0de33be2$var$_
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_18s8115o"
                ]),
                style: {
                    "--_fhuf0z": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.300'))
                },
                children: [
                    "Please wait... ",
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}





/* MyAtlassianRedirect.tsx generated by @compiled/babel-plugin v0.38.1 */ 


parcelRequire("7fPBF");


const $23d1d3647ccb7078$var$_ = "._18s8115o{margin:var(--_fhuf0z) 0}";
const $23d1d3647ccb7078$var$myAtlassianRedirectStyles = null;
function $23d1d3647ccb7078$export$e3fd8340be658180() {
    if ((0, $35a545355f14a0c7$export$6bc7b24d4e862158)().name === (0, $c1e4a1336f2cb96e$exports).PROD) window.location.href = 'https://id.atlassian.com/manage-profile/email';
    else window.location.href = 'https://id.stg.internal.atlassian.com/manage-profile/email';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $23d1d3647ccb7078$var$_
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_18s8115o"
                ]),
                style: {
                    "--_fhuf0z": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.300'))
                },
                children: [
                    "Please wait... ",
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}




const $85d7791daea50a70$var$StatusView = ()=>{
    const { status: status, message: message } = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$b4f431af37c9cd8b));
    switch(status){
        case 'login-required':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f56c96ad0de33be2$export$d4318c1a3847aad), {})
            });
        case 'not-found':
            (0, $0e08eda71bb24540$export$df7ac42928b20388)();
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $23d1d3647ccb7078$export$e3fd8340be658180), {})
            });
        case 'down-for-maintenance':
            (0, $0e08eda71bb24540$export$6f7cca16e34ea87f)();
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69541c48b8b26100$export$2e2bcd8739ae039), {
                    message: message
                })
            });
        case 'empty':
            (0, $0e08eda71bb24540$export$f1239e0c91a8acb6)();
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8b4253205fa0e537$export$2e2bcd8739ae039), {})
            });
        default:
            return null;
    }
};
var $85d7791daea50a70$export$2e2bcd8739ae039 = $85d7791daea50a70$var$StatusView;








var $7fPBF = parcelRequire("7fPBF");





parcelRequire("7fPBF");

const $6bf45c7456588943$var$GlobalUnsubscribeButton = ({ isDisabled: isDisabled, onClick: onClick })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5645981c356a41bc$export$2e2bcd8739ae039), {
        content: translate((0, $447ba15143f7eed7$exports).UNSUBSCRIBE_ALL_TOOLTIP_LABEL),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $33609f2058f20722$export$2e2bcd8739ae039), {
            onClick: onClick,
            isDisabled: isDisabled,
            testId: "global-unsubscribe-button",
            children: translate((0, $447ba15143f7eed7$exports).UNSUBSCRIBE_ALL_BUTTON_LABEL)
        })
    });
};
var $6bf45c7456588943$export$2e2bcd8739ae039 = $6bf45c7456588943$var$GlobalUnsubscribeButton;







const $788f88bb6ebc19d1$var$ActionsBar = ({ email: email, onUnsubscribeClick: onUnsubscribeClick })=>{
    const status = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$b4f431af37c9cd8b));
    const isPending = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $7a501a2d8adab3c3$export$9d56a93b8e84b384)([
        (0, $80022746ba8cd68a$export$6871e08c9c3b9797)
    ]));
    if (isPending || email == null) return null;
    const statusNotOk = status.status !== 'ok';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $067e8036161c713e$export$2e2bcd8739ae039), {
        testId: "actions-bar",
        space: "space.150",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6bf45c7456588943$export$2e2bcd8739ae039), {
                isDisabled: statusNotOk,
                onClick: onUnsubscribeClick
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                maxLines: 1,
                color: 'color.text.subtlest',
                children: email
            })
        ]
    });
};
var $788f88bb6ebc19d1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.memo)($788f88bb6ebc19d1$var$ActionsBar);






var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

parcelRequire("7fPBF");

const $37732ea9e62e519b$var$accordionSectionStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    paddingBottom: 'space.300',
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.xs]: {
        paddingBottom: 'space.600'
    }
});
const $37732ea9e62e519b$var$accordionHeaderStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 'space.200',
    gap: 'space.100'
});
const $37732ea9e62e519b$var$AccordionSection = ({ isOpen: isOpen, showMarker: showMarker, title: title, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        xcss: $37732ea9e62e519b$var$accordionSectionStyles,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                xcss: $37732ea9e62e519b$var$accordionHeaderStyles,
                testId: "accordion-section-header",
                onClick: onClick,
                children: [
                    title,
                    showMarker && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        testId: "accordion-section-marker",
                        children: isOpen ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: "\u25BC"
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: "\u25B2"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                "data-testid": "accordion-section-content",
                children: children
            })
        ]
    });
};
var $37732ea9e62e519b$export$2e2bcd8739ae039 = $37732ea9e62e519b$var$AccordionSection;


const $bbdf7a0d01a379ab$var$Accordion = ({ sections: sections, showMarker: showMarker, alwaysOpen: alwaysOpen })=>{
    const [openSections, changeOpenSection] = (0, $7fPBF.useState)({
        0: true
    });
    const onClickHandler = (0, $7fPBF.useCallback)((id)=>()=>{
            const currentSectionOpenState = openSections[id];
            changeOpenSection((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, openSections), {
                [id]: !currentSectionOpenState
            }));
        }, [
        openSections,
        changeOpenSection
    ]);
    const isOpen = (index)=>alwaysOpen || openSections[index];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: sections.map((section, index)=>{
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37732ea9e62e519b$export$2e2bcd8739ae039), {
                isOpen: isOpen(index),
                showMarker: !!showMarker,
                title: section.title,
                onClick: onClickHandler(index),
                children: section.content
            }, index);
        })
    });
};
var $bbdf7a0d01a379ab$export$2e2bcd8739ae039 = $bbdf7a0d01a379ab$var$Accordion;













var $7fPBF = parcelRequire("7fPBF");



parcelRequire("7fPBF");


/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8MJe2 = parcelRequire("8MJe2");
var $bd53982ab96faaf8$exports = {};

var $hJ0zT = parcelRequire("hJ0zT");

var $4Qso2 = parcelRequire("4Qso2");

var $5ng8R = parcelRequire("5ng8R");

var $gPUQJ = parcelRequire("gPUQJ");
function $bd53982ab96faaf8$var$_toArray(r) {
    return $hJ0zT(r) || $4Qso2(r) || $5ng8R(r) || $gPUQJ();
}
$bd53982ab96faaf8$exports = $bd53982ab96faaf8$var$_toArray, $bd53982ab96faaf8$exports.__esModule = true, $bd53982ab96faaf8$exports["default"] = $bd53982ab96faaf8$exports;



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $26688c0f6e4f2dff$var$ATOMIC_GROUP_LENGTH = 5;
function $26688c0f6e4f2dff$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $26688c0f6e4f2dff$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $eKeTJ = parcelRequire("eKeTJ");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");
function $b00ab4f17ad2c9bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b00ab4f17ad2c9bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b00ab4f17ad2c9bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b00ab4f17ad2c9bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b00ab4f17ad2c9bf$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $b00ab4f17ad2c9bf$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $b00ab4f17ad2c9bf$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $b00ab4f17ad2c9bf$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(updater) === 'object') this.payload = $b00ab4f17ad2c9bf$var$_objectSpread($b00ab4f17ad2c9bf$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $1eb8d509c9a9d227$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $1eb8d509c9a9d227$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $1eb8d509c9a9d227$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1eb8d509c9a9d227$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1eb8d509c9a9d227$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($eKeTJ)))((0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1eb8d509c9a9d227$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $1eb8d509c9a9d227$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $1eb8d509c9a9d227$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, UIAnalyticsEvent);
        _this = $1eb8d509c9a9d227$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $1eb8d509c9a9d227$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $b00ab4f17ad2c9bf$export$2e2bcd8739ae039));



var $7fPBF = parcelRequire("7fPBF");

var $43462fd5b3cb88bc$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $7fPBF.useContext)((0, $e420dde09fb890a4$export$2e2bcd8739ae039));
};


function $61f48a73b3df398e$export$5bf35293e545f20c() {
    var analyticsContext = (0, $43462fd5b3cb88bc$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6ff1114199100bef$export$33752cf3ee811995)(function(payload) {
        return new (0, $1eb8d509c9a9d227$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $7fPBF = parcelRequire("7fPBF");
var $f2e32e83167573a9$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $7fPBF.useRef)(value);
    ref.current = value;
    return ref;
};


function $8e9b339cf30fdfd9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e9b339cf30fdfd9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e9b339cf30fdfd9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e9b339cf30fdfd9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8e9b339cf30fdfd9$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $61f48a73b3df398e$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $f2e32e83167573a9$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $f2e32e83167573a9$export$1d27a74659855e44)(fn);
    var handler = (0, $7fPBF.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $8e9b339cf30fdfd9$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $7fPBF = parcelRequire("7fPBF");
var $196d8249f70c2f07$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
var $196d8249f70c2f07$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
var $196d8249f70c2f07$export$2054129d247c3102 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


function $37ee778e4e8d27bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37ee778e4e8d27bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37ee778e4e8d27bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37ee778e4e8d27bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $37ee778e4e8d27bc$var$baseStyles = null;
var $37ee778e4e8d27bc$var$tabsStyles = null;
var $37ee778e4e8d27bc$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "@atlaskit/tabs",
    packageVersion: "18.1.0"
};
var $37ee778e4e8d27bc$var$getTabPanelWithContext = function getTabPanelWithContext(_ref) {
    var tabPanel = _ref.tabPanel, index = _ref.index, isSelected = _ref.isSelected, tabsId = _ref.tabsId;
    return(// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ $7fPBF.createElement((0, $196d8249f70c2f07$export$2054129d247c3102).Provider, {
        value: {
            role: 'tabpanel',
            id: "".concat(tabsId, "-").concat(index, "-tab"),
            hidden: isSelected ? undefined : true,
            'aria-labelledby': "".concat(tabsId, "-").concat(index),
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel));
};
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $37ee778e4e8d27bc$var$Tabs = function Tabs(props) {
    var _props$shouldUnmountT = props.shouldUnmountTabPanelOnChange, shouldUnmountTabPanelOnChange = _props$shouldUnmountT === void 0 ? false : _props$shouldUnmountT, SelectedType = props.selected, defaultSelected = props.defaultSelected, onChangeProp = props.onChange, id = props.id, analyticsContext = props.analyticsContext, children = props.children, testId = props.testId;
    var _useState = (0, $7fPBF.useState)(SelectedType || defaultSelected || 0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), selectedState = _useState2[0], setSelected = _useState2[1];
    var selected = SelectedType === undefined ? selectedState : SelectedType;
    var childrenArray = (0, $7fPBF.Children).toArray(children)// Don't include any conditional children
    .filter(function(child) {
        return Boolean(child);
    });
    // First child should be a tabList followed by tab panels
    var _childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($bd53982ab96faaf8$exports)))(childrenArray), tabList = _childrenArray[0], tabPanels = _childrenArray.slice(1);
    // Keep track of visited and add to a set
    var visited = (0, $7fPBF.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    var onChange = (0, $7fPBF.useCallback)(function(index, analyticsEvent) {
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    var onChangeAnalytics = (0, $8e9b339cf30fdfd9$export$a4687b0234b40e28)($37ee778e4e8d27bc$var$_objectSpread({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $37ee778e4e8d27bc$var$analyticsAttributes));
    var tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $37ee778e4e8d27bc$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map(function(tabIndex) {
        return $37ee778e4e8d27bc$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        });
    });
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        "data-testid": testId,
        className: (0, $26688c0f6e4f2dff$export$2e2bcd8739ae039)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $196d8249f70c2f07$export$aa6907f9fd69e93b).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), null, tabPanelsWithContext));
};
var $37ee778e4e8d27bc$export$2e2bcd8739ae039 = $37ee778e4e8d27bc$var$Tabs;

/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $fcb9f2a277ff7445$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}



var $137Lh = parcelRequire("137Lh");


var $7fPBF = parcelRequire("7fPBF");

var $c8ed6ff97679b666$export$fdf4756d5b8ef90a = function useTab() {
    var tabData = (0, $7fPBF.useContext)((0, $196d8249f70c2f07$export$5a5d356ca5f10a0a));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
var $c8ed6ff97679b666$export$773e389e644c5874 = function useTabList() {
    var tabListData = (0, $7fPBF.useContext)((0, $196d8249f70c2f07$export$aa6907f9fd69e93b));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
var $c8ed6ff97679b666$export$fae0121b5afe572d = function useTabPanel() {
    var tabPanelData = (0, $7fPBF.useContext)((0, $196d8249f70c2f07$export$2054129d247c3102));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};



var $6ac5c86c95d2529e$var$baseStyles = null;
var $6ac5c86c95d2529e$var$tabListStyles = null;
var $6ac5c86c95d2529e$var$tabListStylesOld = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $6ac5c86c95d2529e$var$TabList = function TabList(_ref) {
    var children = _ref.children;
    var _useTabList = (0, $c8ed6ff97679b666$export$773e389e644c5874)(), tabsId = _useTabList.tabsId, selected = _useTabList.selected, onChange = _useTabList.onChange;
    var ref = /*#__PURE__*/ (0, $7fPBF.createRef)();
    // Don't include any conditional children
    var childrenArray = (0, $7fPBF.Children).toArray(children).filter(Boolean);
    var length = childrenArray.length;
    var selectTabByIndex = (0, $7fPBF.useCallback)(function(index) {
        var _ref$current;
        var newSelectedNode = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector("[id='".concat(tabsId, "-").concat(index, "']"));
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    var onKeyDown = (0, $7fPBF.useCallback)(function(e) {
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        var lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            var _newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(_newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        var selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        var modifier = e.key === 'ArrowRight' ? 1 : -1;
        var newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    var getTabWithContext = (0, $7fPBF.useCallback)(function(_ref2) {
        var tab = _ref2.tab, isSelected = _ref2.isSelected, index = _ref2.index;
        return /*#__PURE__*/ $7fPBF.createElement((0, $196d8249f70c2f07$export$5a5d356ca5f10a0a).Provider, {
            value: {
                onClick: function onClick() {
                    return onChange(index);
                },
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: "".concat(tabsId, "-").concat(index),
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': "".concat(tabsId, "-").concat(index, "-tab"),
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab);
    }, [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        role: "tablist",
        ref: ref,
        className: (0, $26688c0f6e4f2dff$export$2e2bcd8739ae039)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $137Lh.fg)('platform-component-visual-refresh') ? "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quz1425 _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu1hjo _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oaz1fgx _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d1hjo _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i2072d1 _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmzmfou _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiemln51 _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1russudh _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc" : "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quz1425 _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _17hygqwt _1lzupl7t _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oaz1fgx _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1jakgqwt _1b8dpl7t _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i2072d1 _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _9r9ugqwt _rsmz8hos _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiemln51 _pascidpf _eid3idpf _zr3eidpf _fntnidpf _rfx3gqwt _1mp41kw7 _kfgt1bk5 _1cs8stnw _1russudh _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        style: {
            "--_13a5t4u": (0, $fcb9f2a277ff7445$export$2e2bcd8739ae039)("var(--ds-text-subtle, ".concat((0, $d7df1392c2cb1415$export$c39c0fe0f26207ae), ")")),
            "--_kkbq40": (0, $fcb9f2a277ff7445$export$2e2bcd8739ae039)("var(--ds-text-subtle, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")")),
            "--_1nddtxm": (0, $fcb9f2a277ff7445$export$2e2bcd8739ae039)("var(--ds-border-width-indicator, 3px)".concat(" solid ", "var(--ds-border, transparent)")),
            "--_71dbsd": (0, $fcb9f2a277ff7445$export$2e2bcd8739ae039)("var(--ds-text, ".concat((0, $d7df1392c2cb1415$export$a6ee3d71bc067634), ")")),
            "--_1hfkvbo": (0, $fcb9f2a277ff7445$export$2e2bcd8739ae039)("var(--ds-text-selected, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")")),
            "--_hdabma": (0, $fcb9f2a277ff7445$export$2e2bcd8739ae039)("var(--ds-border-width-indicator, 3px)".concat(" solid ", "var(--ds-border-selected, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")"))),
            "--_lvpq93": (0, $fcb9f2a277ff7445$export$2e2bcd8739ae039)("var(--ds-border, ".concat((0, $d7df1392c2cb1415$export$3e51e8f1440314ba), ")")),
            "--_1b4y4br": (0, $fcb9f2a277ff7445$export$2e2bcd8739ae039)("var(--ds-border-width-outline, 2px)".concat(" solid ", "var(--ds-border, transparent)")),
            "--_1rlpysg": (0, $fcb9f2a277ff7445$export$2e2bcd8739ae039)("var(--ds-border-width-outline, 2px)".concat(" solid ", "var(--ds-border-selected, ".concat((0, $d7df1392c2cb1415$export$b3de0ae08da2ce64), ")")))
        }
    }, childrenArray.map(function(child, index) {
        return getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        });
    }));
};
var $6ac5c86c95d2529e$export$2e2bcd8739ae039 = $6ac5c86c95d2529e$var$TabList;


const $d5fd265980f256d2$var$tabsStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    paddingBottom: 'space.200'
});
const $d5fd265980f256d2$var$Tab = (props)=>{
    const tabAttributes = (0, $c8ed6ff97679b666$export$fdf4756d5b8ef90a)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, tabAttributes, props));
};
const $d5fd265980f256d2$var$Tabs = ({ tabKeys: tabKeys, groupKey: groupKey, onChange: onChange })=>{
    const { translate: translate, keyWithTitle: keyWithTitle } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    if (tabKeys.length < 2) return null;
    const sortedTabsMeta = [
        ...tabKeys
    ].sort((left, right)=>left.localeCompare(right));
    const groupTabsTestId = 'groupTabsTestId';
    function handleOnChange(index) {
        onChange(sortedTabsMeta[index], groupKey || '');
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        xcss: $d5fd265980f256d2$var$tabsStyles,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37ee778e4e8d27bc$export$2e2bcd8739ae039), {
            onChange: handleOnChange,
            id: (groupKey || 'default') + '_tabs',
            testId: groupTabsTestId,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ac5c86c95d2529e$export$2e2bcd8739ae039), {
                children: sortedTabsMeta.map((key)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d5fd265980f256d2$var$Tab, {
                        testId: groupTabsTestId + `-${key}-tab`,
                        children: translate(keyWithTitle(key))
                    }, key))
            })
        })
    });
};
var $d5fd265980f256d2$export$2e2bcd8739ae039 = $d5fd265980f256d2$var$Tabs;






var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");

/* lozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $7c3e37df435d76d1$var$ATOMIC_GROUP_LENGTH = 5;
function $7c3e37df435d76d1$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $7c3e37df435d76d1$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $137Lh = parcelRequire("137Lh");
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $bbbfca73e75f834e$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $bbbfca73e75f834e$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($bbbfca73e75f834e$export$1ca2a26fecb070ae);
};
$bbbfca73e75f834e$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $a1b6e8ffae0f0cbd$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $a1b6e8ffae0f0cbd$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $a1b6e8ffae0f0cbd$var$baseStyles = null;
var $a1b6e8ffae0f0cbd$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $a1b6e8ffae0f0cbd$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $a1b6e8ffae0f0cbd$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
var $a1b6e8ffae0f0cbd$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $a1b6e8ffae0f0cbd$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $a1b6e8ffae0f0cbd$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $a1b6e8ffae0f0cbd$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $a1b6e8ffae0f0cbd$var$Box = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $a1b6e8ffae0f0cbd$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $a1b6e8ffae0f0cbd$var$_excluded2);
    var node = /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        style: style,
        ref: ref,
        className: (0, $7c3e37df435d76d1$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $a1b6e8ffae0f0cbd$var$backgroundColorMap[backgroundColor],
            backgroundColor && $a1b6e8ffae0f0cbd$var$isSurfaceToken(backgroundColor) && $a1b6e8ffae0f0cbd$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $a1b6e8ffae0f0cbd$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $a1b6e8ffae0f0cbd$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $a1b6e8ffae0f0cbd$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $a1b6e8ffae0f0cbd$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $7fPBF.createElement((0, $bbbfca73e75f834e$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $a1b6e8ffae0f0cbd$export$2e2bcd8739ae039 = $a1b6e8ffae0f0cbd$var$Box;
function $a1b6e8ffae0f0cbd$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $a1b6e8ffae0f0cbd$var$setSurfaceTokenMap;
}


var $35a55e0507ba7e43$var$stylesOld = {
    container: "_2rkoglpi _1reo15vq _18m915vq _18zr1b66 _1e0c116y _1kz6184x _kqswpfqs _vchhusvi",
    'text.bold.default': "_syaz15cr",
    'text.bold.inprogress': "_syaz15cr",
    'text.bold.moved': "_syazal3n",
    'text.bold.new': "_syaz15cr",
    'text.bold.removed': "_syaz15cr",
    'text.bold.success': "_syaz15cr",
    'text.subtle.default': "_syazjjyb",
    'text.subtle.inprogress': "_syaz1lpn",
    'text.subtle.moved': "_syaz1tm6",
    'text.subtle.new': "_syaz1mvf",
    'text.subtle.removed': "_syaz1ick",
    'text.subtle.success': "_syaz17fi"
};
// NOTE: This is isolated to avoid breaking the bounded `stylesOld` interface as they do not fall within the Design System.
var $35a55e0507ba7e43$var$stylesOldUnbounded = {
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi"
};
var $35a55e0507ba7e43$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $35a55e0507ba7e43$var$stylesNew = {
    container: "_2rko1l7b _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'border.subtle.default': "_19it14mp",
    'border.subtle.inprogress': "_19it1cy7",
    'border.subtle.moved': "_19itzi1n",
    'border.subtle.new': "_19it1apr",
    'border.subtle.removed': "_19itoa5t",
    'border.subtle.success': "_19it1am1",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syaz1fxt",
    'text.bold': "_syazwwip"
};
var $35a55e0507ba7e43$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $35a55e0507ba7e43$var$Lozenge = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = (0, $7fPBF.useMemo)(function() {
        return $35a55e0507ba7e43$var$appearanceTypes.includes(appearance) ? appearance : 'default';
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $137Lh.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ $7fPBF.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $7c3e37df435d76d1$export$2e2bcd8739ae039)([
            $35a55e0507ba7e43$var$stylesNew.container,
            $35a55e0507ba7e43$var$stylesNew["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === 'subtle' && !(0, $137Lh.fg)('visual-refresh_drop_5') && $35a55e0507ba7e43$var$stylesNew["border.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && (0, $137Lh.fg)('visual-refresh_drop_5') && $35a55e0507ba7e43$var$stylesNew["outline.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && (0, $137Lh.fg)('visual-refresh_drop_5') && $35a55e0507ba7e43$var$stylesNew.containerSubtle
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $7c3e37df435d76d1$export$2e2bcd8739ae039)([
            $35a55e0507ba7e43$var$stylesNew.text,
            (0, $137Lh.fg)('platform-lozenge-custom-letterspacing') && $35a55e0507ba7e43$var$stylesNew.customLetterspacing,
            $35a55e0507ba7e43$var$stylesNew["text.".concat(appearanceStyle)]
        ])
    }, children));
    return /*#__PURE__*/ $7fPBF.createElement((0, $a1b6e8ffae0f0cbd$export$2e2bcd8739ae039), {
        as: "span",
        backgroundColor: $35a55e0507ba7e43$var$backgroundColorsOld[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $35a55e0507ba7e43$var$stylesOld.container,
        testId: testId
    }, /*#__PURE__*/ $7fPBF.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $7c3e37df435d76d1$export$2e2bcd8739ae039)([
            $35a55e0507ba7e43$var$stylesOldUnbounded.text,
            (0, $137Lh.fg)('platform-lozenge-custom-letterspacing') && $35a55e0507ba7e43$var$stylesOldUnbounded.customLetterspacing,
            $35a55e0507ba7e43$var$stylesOld["text.".concat(appearanceStyle, ".").concat(appearanceType)]
        ])
    }, children));
});
$35a55e0507ba7e43$var$Lozenge.displayName = 'Lozenge';
var $35a55e0507ba7e43$export$2e2bcd8739ae039 = $35a55e0507ba7e43$var$Lozenge;



const $5fd605fd49ab1b9b$var$contentHeaderStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    paddingBottom: 'space.200'
});
const $5fd605fd49ab1b9b$var$descriptionStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'none',
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.xs]: {
        display: 'flex'
    }
});
const $5fd605fd49ab1b9b$var$selectLabelStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    color: 'color.text.subtle',
    whiteSpace: 'nowrap'
});
const $5fd605fd49ab1b9b$var$ContentHeader = ({ text: text, onClickAll: onClickAll, onClickNone: onClickNone, groupKey: groupKey })=>{
    const { translate: translate, keyWithCallout: keyWithCallout } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const calloutText = translate(keyWithCallout(groupKey));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $067e8036161c713e$export$2e2bcd8739ae039), {
        xcss: $5fd605fd49ab1b9b$var$contentHeaderStyles,
        space: 'space.200',
        spread: 'space-between',
        alignBlock: 'baseline',
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                    xcss: $5fd605fd49ab1b9b$var$descriptionStyles,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                        size: 'large',
                        children: [
                            !calloutText.startsWith(groupKey) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $35a55e0507ba7e43$export$2e2bcd8739ae039), {
                                        isBold: true,
                                        children: calloutText
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        children: " "
                                    })
                                ]
                            }) : null,
                            translate(text || '')
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $067e8036161c713e$export$2e2bcd8739ae039), {
                space: 'space.100',
                alignBlock: 'baseline',
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $5fd605fd49ab1b9b$var$selectLabelStyles,
                        children: translate((0, $447ba15143f7eed7$exports).SELECT_LABEL)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                        testId: 'dynamicConfigElementsGroupSelectAllButton',
                        appearance: 'subtle',
                        onClick: onClickAll,
                        children: translate((0, $447ba15143f7eed7$exports).SELECT_ALL_BUTTON_LABEL)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                        testId: 'dynamicConfigElementsGroupSelectNoneButton',
                        appearance: 'subtle',
                        onClick: onClickNone,
                        children: translate((0, $447ba15143f7eed7$exports).SELECT_NONE_BUTTON_LABEL)
                    })
                ]
            })
        ]
    });
};
var $5fd605fd49ab1b9b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.memo)($5fd605fd49ab1b9b$var$ContentHeader);




/* ItemCard.tsx generated by @compiled/babel-plugin v0.38.1 */ 


var $7fPBF = parcelRequire("7fPBF");





parcelRequire("7fPBF");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b4c2b482d26b1be8309fdd18226deba>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $6af84b285cc7ab3c$var$ATOMIC_GROUP_LENGTH = 5;
function $6af84b285cc7ab3c$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $6af84b285cc7ab3c$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $2b33f813f916c85b$var$styles = {
    root: "_1e0c1o8l"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $2b33f813f916c85b$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $2b33f813f916c85b$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $2b33f813f916c85b$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $2b33f813f916c85b$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $2b33f813f916c85b$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $2b33f813f916c85b$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isDataCenter = _ref.isDataCenter, isDataCenter = _ref$isDataCenter === void 0 ? false : _ref$isDataCenter;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $6af84b285cc7ab3c$export$2e2bcd8739ae039)([
            $2b33f813f916c85b$var$styles.root,
            $2b33f813f916c85b$var$sizeMap[size],
            isDataCenter ? colorMode === 'dark' ? $2b33f813f916c85b$var$dataCenterDarkAppearanceMap[appearance] : $2b33f813f916c85b$var$dataCenterLightAppearanceMap[appearance] : colorMode === 'dark' ? $2b33f813f916c85b$var$cloudDarkAppearanceMap[appearance] : $2b33f813f916c85b$var$cloudLightAppearanceMap[appearance]
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
var $4880006783b144cd$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4880006783b144cd$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $4880006783b144cd$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ecce23f80806781db9edeff944632b7>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $7fPBF = parcelRequire("7fPBF");


var $270382e78be2fdf9$var$styles = {
    root: "_1e0c1o8l _vwz4idpf"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $270382e78be2fdf9$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $270382e78be2fdf9$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $270382e78be2fdf9$var$textLightAppearanceMap = {
    brand: "_1wyc1fxt",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $270382e78be2fdf9$var$textDarkAppearanceMap = {
    brand: "_1wyc1fxt",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $270382e78be2fdf9$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $270382e78be2fdf9$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $270382e78be2fdf9$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $270382e78be2fdf9$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
function $270382e78be2fdf9$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isDataCenter = _ref.isDataCenter, isDataCenter = _ref$isDataCenter === void 0 ? false : _ref$isDataCenter;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $6af84b285cc7ab3c$export$2e2bcd8739ae039)([
            $270382e78be2fdf9$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $270382e78be2fdf9$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $270382e78be2fdf9$var$sizeMap[size],
            colorMode === 'dark' ? $270382e78be2fdf9$var$textDarkAppearanceMap[appearance] : $270382e78be2fdf9$var$textLightAppearanceMap[appearance],
            isDataCenter ? colorMode === 'dark' ? $270382e78be2fdf9$var$dataCenterDarkAppearanceMap[appearance] : $270382e78be2fdf9$var$dataCenterLightAppearanceMap[appearance] : colorMode === 'dark' ? $270382e78be2fdf9$var$cloudDarkAppearanceMap[appearance] : $270382e78be2fdf9$var$cloudLightAppearanceMap[appearance]
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3e40fcb2146c4dbe$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $3e40fcb2146c4dbe$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $3e40fcb2146c4dbe$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::267cad59c76b16aeee5f58cfa4a1f733>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $523eca9193a68fc2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $523eca9193a68fc2$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $523eca9193a68fc2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56bacfcde6f81799eb41bc2261641230>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $16381b5c9298fc87$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $16381b5c9298fc87$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $16381b5c9298fc87$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62d7ed5486f2fde4ab85bad091e6130c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $04a4bbefebd8e7e4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $04a4bbefebd8e7e4$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $04a4bbefebd8e7e4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c346421b23be4892d11f5300b3f9b8f0>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1d418877717652b8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $1d418877717652b8$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $1d418877717652b8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7e353680649504e5005ac163dde6655>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0ac2f3357bba670e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $0ac2f3357bba670e$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $0ac2f3357bba670e$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $0ac2f3357bba670e$var$svg,
        customThemeSvg: $0ac2f3357bba670e$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b2c2f81dcecc713953841df3ebcde68>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b8f26846418a2bb2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $b8f26846418a2bb2$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $b8f26846418a2bb2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e235764598011d7e6fcb75b2257be900>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $42be5e881a53f5ff$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $42be5e881a53f5ff$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $42be5e881a53f5ff$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4be588a359814839f3a38a10b8622b63>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $212a1346d19659ec$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $212a1346d19659ec$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $212a1346d19659ec$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a48cd0ac1ce9dea97cb133dca9e33de4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0175a469435a05be$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $0175a469435a05be$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $0175a469435a05be$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $0175a469435a05be$var$svg,
        customThemeSvg: $0175a469435a05be$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d54637b0b2f479c52492d2d0abf8bb82>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8cfaa1ce1c1a4a51$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $8cfaa1ce1c1a4a51$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $8cfaa1ce1c1a4a51$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b1a960d2db34ca3f44ef8828b3815ae>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $b225b413d373bfb2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $b225b413d373bfb2$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $b225b413d373bfb2$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d6df504ec1dfd9f26a50f8d7e45924c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a734f03efa211a18$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $a734f03efa211a18$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $a734f03efa211a18$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae2d6061a51a6b69522551138415fa2a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $03180751fccdc506$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.125 16.5h8.125V6H5.75v13zM12 12.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m4-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-7.125.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $03180751fccdc506$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $03180751fccdc506$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f10c9ed117b987aa620e842ad4c67da2>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $554bfe0ddb0f1fb0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.65m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.167 21.834h-10.5l-5.833 3.5v-17.5h16.333zm-12.25-5.833a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M16 16a1.167 1.167 0 1 0 0-2.334A1.167 1.167 0 0 0 16 16m5.25-1.167a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $554bfe0ddb0f1fb0$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $554bfe0ddb0f1fb0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec19b3c26d91498312286db03f0eb4ea>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $dd20ad7fb8a444a3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $dd20ad7fb8a444a3$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $dd20ad7fb8a444a3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5bc93a13860fb0293d95e675d91c82c4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8add615c1a1a6082$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $8add615c1a1a6082$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $8add615c1a1a6082$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d74d7ecef16716d9233a75661d1c4ae>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $e8addf3946725bb7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $e8addf3946725bb7$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $e8addf3946725bb7$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $e8addf3946725bb7$var$svg,
        customThemeSvg: $e8addf3946725bb7$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dddd2bd68cfa97eb485c03553f4e24d7>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7d108de4bac90c4a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $7d108de4bac90c4a$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $7d108de4bac90c4a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a14a00c887df7cd127b285246b99735>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $2ad508f22b1f7913$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $2ad508f22b1f7913$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $2ad508f22b1f7913$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::247f612d885273d5ec9340d29cd5314f>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $99228cb46155dfd3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $99228cb46155dfd3$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $99228cb46155dfd3$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::737475caba8467007ea15db78e7ae272>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $76350cbdd63b9a1a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $76350cbdd63b9a1a$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $76350cbdd63b9a1a$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c40fab6689e9bdd9624e2a214b20ab71>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $959663811a6fadba$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $959663811a6fadba$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $959663811a6fadba$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf714453512d29992419d0b1472039ec>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $d0399399b5e3bcff$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $d0399399b5e3bcff$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $d0399399b5e3bcff$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $d0399399b5e3bcff$var$svg,
        customThemeSvg: $d0399399b5e3bcff$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8071dd02178137151c85fefeeccfbf6a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $83bfd21c6ef94938$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $83bfd21c6ef94938$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $83bfd21c6ef94938$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc3eeb7d4cfaf5ff93494f75e1a18082>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $a4646aa917cf9e3b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $a4646aa917cf9e3b$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $a4646aa917cf9e3b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fde58bf2e05397b9d002acff853fdc38>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $eb2c9f401968d219$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $eb2c9f401968d219$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $eb2c9f401968d219$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::396f70864944722c3ba43a8857b797aa>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $2600f4570e8f8aa3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $2600f4570e8f8aa3$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $2600f4570e8f8aa3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0681058b5d17f20f830a057d776b5aa3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $78ec99dd8648524d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $78ec99dd8648524d$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $78ec99dd8648524d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9cb16fe47b2bb06a618d6f42235f4d0b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $65f82ef729dbd31f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $65f82ef729dbd31f$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $65f82ef729dbd31f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f601744ebb3feb381ec2bc379ecb922e>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $94c53b60cf3bf6db$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $94c53b60cf3bf6db$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $94c53b60cf3bf6db$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4789b6ef9b66e17e85ce46edd0e20b5>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $3c64cf09ca1c1117$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $3c64cf09ca1c1117$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $3c64cf09ca1c1117$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f31fca5cffff624ab8dfe2f380f4c6a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a4687df259ed67a6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $a4687df259ed67a6$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $a4687df259ed67a6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::826142130c83ecce3a55557ab8c9ff78>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $b1d32697de4bd873$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $b1d32697de4bd873$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $b1d32697de4bd873$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::742f94652f61dfd860aacb3fafe2261c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8facf67472cfb8b3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $8facf67472cfb8b3$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $8facf67472cfb8b3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::349400291f8d779d7f120565198fb274>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $572b84fa8fec13d5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $572b84fa8fec13d5$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $572b84fa8fec13d5$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $572b84fa8fec13d5$var$svg,
        customThemeSvg: $572b84fa8fec13d5$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e76e8b0984e9a10157b3a2965f276eb>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9ecbbdbe70d19b32$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $9ecbbdbe70d19b32$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $9ecbbdbe70d19b32$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be11a29c939ff0f2a727a12285a62df7>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $023c00c9ee738e91$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $023c00c9ee738e91$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $023c00c9ee738e91$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2149e3bf372f0515252a5e78dec7c590>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6538b05ab3d32bd0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $6538b05ab3d32bd0$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $6538b05ab3d32bd0$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4986587aa74e2199c5aaa284b753e478>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $57a54c69c6c92229$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $57a54c69c6c92229$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $57a54c69c6c92229$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $57a54c69c6c92229$var$svg,
        customThemeSvg: $57a54c69c6c92229$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21e7556cd73294fd9a2b8ada6433a2bb>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $36ebcdbc423aa46c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $36ebcdbc423aa46c$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $36ebcdbc423aa46c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a167626b0cdea243238150a218b626f1>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0f2f8ae0e90e9926$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $0f2f8ae0e90e9926$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $0f2f8ae0e90e9926$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $0f2f8ae0e90e9926$var$svg,
        customThemeSvg: $0f2f8ae0e90e9926$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e9309f3b1cc7fb1643e1f60f1ab07da>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $828de5dfeeb81d72$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $828de5dfeeb81d72$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $828de5dfeeb81d72$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::785b520448be5254a616c00701ca6073>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ff1c6132dc941e13$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $ff1c6132dc941e13$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $ff1c6132dc941e13$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf181e1edfa57dcb5b7463f70781d820>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $37bcbb4019e8e020$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $37bcbb4019e8e020$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $37bcbb4019e8e020$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55187565d76d0ab70107b394d5174d9a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ea5f31681e9695cd$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $ea5f31681e9695cd$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $ea5f31681e9695cd$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad3119cedd34de3d960e5ccfcb794468>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a3f5784d21b0fc66$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $a3f5784d21b0fc66$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $a3f5784d21b0fc66$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e1ee46dc9ada114b6751598218ceaa3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d5171a561a513b41$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $d5171a561a513b41$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $d5171a561a513b41$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3dabecb5c666d4b59916374e96299a4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $970b111866c09a60$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $970b111866c09a60$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $970b111866c09a60$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa2c5f0b3386bcf846320a0b87a8366d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cd40320e26c0da3f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $cd40320e26c0da3f$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $cd40320e26c0da3f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::579928a7702ff0666940203a9d4c2681>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $2131d8f1ef8ecc46$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $2131d8f1ef8ecc46$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $2131d8f1ef8ecc46$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a5a07e9eb7981952db2c58f3810afe1d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $989da254b6fac915$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $989da254b6fac915$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $989da254b6fac915$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae4772cca6d16bf931ca75f21c37faa7>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $331804a167e7dd21$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $331804a167e7dd21$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $331804a167e7dd21$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c130a24674470d1e95cd4899b5e3ca4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $bec4556b12c77a86$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $bec4556b12c77a86$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $bec4556b12c77a86$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07c05c6e89f5723f7d7ed853987d71b5>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $897c33b460a3d900$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $897c33b460a3d900$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $897c33b460a3d900$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f364ea0f6c471d2cbba8f708f2339a3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cffb74ce0b50ed4c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $cffb74ce0b50ed4c$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $cffb74ce0b50ed4c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71c7de2e30885b9e09669c8ade78e25c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $d92c10f2a6e9e78c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M5 10.688a5.69 5.69 0 0 0 5.697 5.687c1.01 0 1.958-.262 2.78-.723L16.832 19 19 16.834l-3.347-3.341c.471-.828.74-1.785.74-2.806A5.69 5.69 0 0 0 10.697 5 5.69 5.69 0 0 0 5 10.688m2.191 0c0 1.932 1.57 3.5 3.506 3.5a3.503 3.503 0 0 0 3.505-3.5c0-1.933-1.57-3.5-3.505-3.5a3.503 3.503 0 0 0-3.506 3.5\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d92c10f2a6e9e78c$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $d92c10f2a6e9e78c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::517d90ad09bfbbd541d369d01d058e01>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $52709947373b6dcf$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.04 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10H88v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M7.127 14.833a7.583 7.583 0 0 0 11.286 6.62l4.464 4.464 2.887-2.888-4.455-4.455a7.583 7.583 0 1 0-14.181-3.74m2.917 0a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $52709947373b6dcf$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $52709947373b6dcf$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d9b6abfb98a7cc46c15cd5bb68394677>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $283443bece6d8862$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $283443bece6d8862$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $283443bece6d8862$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::336995adb994a3066957c7690d8c9207>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e3d0626f3b42a8a4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $e3d0626f3b42a8a4$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $e3d0626f3b42a8a4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44318da2d694177bf3151a9c722c2f2d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $2d7aefc14cfa3b62$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.7 11.222V19h7.8v-7.778z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.6 7.609 10.05 5 5.5 7.609v5.217l3.64 2.087V9.667h5.46z\"/>\n</svg>\n";
function $2d7aefc14cfa3b62$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $2d7aefc14cfa3b62$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a3132618c94e271e59382f742ada531>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e793f1b93656fe4b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.17 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.125 14.125V24.75H24.75V14.125z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $e793f1b93656fe4b$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $e793f1b93656fe4b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46e5325ca16a481422af5c181121030b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $6d5766bad4ba867c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $6d5766bad4ba867c$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $6d5766bad4ba867c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8453468a68143782cf5c56d6264718dc>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $2206699866c18c7b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $2206699866c18c7b$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $2206699866c18c7b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46ca108d2593b6c24c5abbf971640ec4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $03fdb902f9365af3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $03fdb902f9365af3$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $03fdb902f9365af3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a85bb219158de09803b052bf9eb845b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b1a57392113869cb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $b1a57392113869cb$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $b1a57392113869cb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::05385a6d8a6e0950a657f507588ba895>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $53e5ffc67a53e87d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $53e5ffc67a53e87d$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $53e5ffc67a53e87d$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2b33f813f916c85b$export$be58b4326e23250f), {
        svg: $53e5ffc67a53e87d$var$svg,
        customThemeSvg: $53e5ffc67a53e87d$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1b148b0e17835d1d6cc0b45cfa57fe0>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c588329ac49c83d5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $c588329ac49c83d5$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $270382e78be2fdf9$export$f827d3c5a9c3f644), {
        svg: $c588329ac49c83d5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}



var $7fPBF = parcelRequire("7fPBF");




var $3095db0c6f9e13d4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $3095db0c6f9e13d4$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $3095db0c6f9e13d4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $51de8758bdd5f267$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $51de8758bdd5f267$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $51de8758bdd5f267$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $c08b60f1d1bd7b7d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $c08b60f1d1bd7b7d$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $c08b60f1d1bd7b7d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $4dba799d2db29a7e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $4dba799d2db29a7e$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $4dba799d2db29a7e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");

var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");
var $5e365994c35e24b2$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $5e365994c35e24b2$var$react18UseId = ($5e365994c35e24b2$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId) !== null && $5e365994c35e24b2$var$_React$useId !== void 0 ? $5e365994c35e24b2$var$_React$useId : undefined;
function $5e365994c35e24b2$export$f680877a34711e37() {
    if ($5e365994c35e24b2$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) return $5e365994c35e24b2$var$react18UseId();
    return "uid".concat((0, $e9144a1b4dc9c62e$export$87d05f07e65211f1)());
}
var $5e365994c35e24b2$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($5e365994c35e24b2$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $5e365994c35e24b2$export$6ee17796e3d70de2() {
    if ($5e365994c35e24b2$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) {
        var uid = $5e365994c35e24b2$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $e9144a1b4dc9c62e$export$bb5ca5fba6fb4f1f)();
}






var $c12d9aedd79d3ec5$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$362a25f017e2bc8a)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $c12d9aedd79d3ec5$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $5e365994c35e24b2$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $c12d9aedd79d3ec5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};


var $7fPBF = parcelRequire("7fPBF");





var $2339c88bd283994c$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $2339c88bd283994c$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $5e365994c35e24b2$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $2339c88bd283994c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $72fbb20ba78b51dd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $72fbb20ba78b51dd$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $72fbb20ba78b51dd$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $aa7454de44a5fb3c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $aa7454de44a5fb3c$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $aa7454de44a5fb3c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $a0118ca7eeda4998$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $a0118ca7eeda4998$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $a0118ca7eeda4998$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $c6ad4536c7c96f69$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $c6ad4536c7c96f69$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c6ad4536c7c96f69$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $9b739d594c5ba755$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $9b739d594c5ba755$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $9b739d594c5ba755$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $9ad33901574c9200$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $9ad33901574c9200$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $9ad33901574c9200$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $8002a6a9ba672835$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $8002a6a9ba672835$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $8002a6a9ba672835$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $01930ff09b14dd01$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $01930ff09b14dd01$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $01930ff09b14dd01$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $10c744883a107350$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $10c744883a107350$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $10c744883a107350$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $d26e7488354657e1$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $d26e7488354657e1$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $d26e7488354657e1$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $89badb7e09bd7da5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $89badb7e09bd7da5$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $89badb7e09bd7da5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $bfb325ecf6215374$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $bfb325ecf6215374$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $bfb325ecf6215374$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $c0174fcd83e30e01$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $c0174fcd83e30e01$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $c0174fcd83e30e01$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $7f0e665c95c08e80$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $7f0e665c95c08e80$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $7f0e665c95c08e80$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $0220eebb07adb628$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $0220eebb07adb628$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $0220eebb07adb628$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $36b7889fefdc48ff$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $36b7889fefdc48ff$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $36b7889fefdc48ff$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $8b020727b1a17434$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $8b020727b1a17434$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $8b020727b1a17434$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $c8663250dd0ec80d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $c8663250dd0ec80d$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c8663250dd0ec80d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $a3a19e092ee56f24$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $a3a19e092ee56f24$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $a3a19e092ee56f24$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $e3bd7e3f84bc76d5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $e3bd7e3f84bc76d5$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $e3bd7e3f84bc76d5$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");


var $ea868076f062db5f$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a3a19e092ee56f24$export$8d789f76fde3e05), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $851d611d31971793$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $851d611d31971793$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $851d611d31971793$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $a1db71cc771d6df3$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $a1db71cc771d6df3$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $a1db71cc771d6df3$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $a647b5a9c71c8c53$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $a647b5a9c71c8c53$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $a647b5a9c71c8c53$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $42e930e74f9f8683$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $42e930e74f9f8683$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $42e930e74f9f8683$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $8423a59c6edc0a50$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $8423a59c6edc0a50$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $8423a59c6edc0a50$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $f3a9f3796143f630$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $f3a9f3796143f630$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $f3a9f3796143f630$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $d6020ef477dc54c9$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $d6020ef477dc54c9$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d6020ef477dc54c9$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $1766ce248ff1f309$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $1766ce248ff1f309$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $1766ce248ff1f309$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $8520bd5de24d7beb$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $8520bd5de24d7beb$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $8520bd5de24d7beb$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};






var $7fPBF = parcelRequire("7fPBF");





var $13d098ef7b3474f3$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: (0, $8eafb83749b35973$export$793fba32aed8942a).iconGradientStart,
        iconGradientStop: (0, $8eafb83749b35973$export$793fba32aed8942a).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n    <svg\n      fill=\"none\"\n      height=\"32\"\n      viewBox=\"0 0 32 32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n    >\n      <linearGradient\n        id=\"".concat(id, "\"\n        gradientUnits=\"userSpaceOnUse\"\n        x1=\"13.9485\"\n        x2=\"20.7792\"\n        y1=\"20.2388\"\n        y2=\"11.8277\"\n      >\n        <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " />\n        <stop offset=\"100%\" stop-color=\"").concat(colors.iconGradientStop, "\" />\n      </linearGradient>\n      <path\n        d=\"m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z\"\n        fill=\"url(#").concat(id, ")\"\n      />\n      <path\n      fill=\"").concat(colors.iconColor, "\"\n      d=\"m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z\"\n      />\n    </svg>");
};
var $13d098ef7b3474f3$export$7330b9fc5718fd30 = function JiraWorkManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Work Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $5e365994c35e24b2$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $13d098ef7b3474f3$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};




var $7fPBF = parcelRequire("7fPBF");





var $e0f53c3cd3766619$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: (0, $8eafb83749b35973$export$793fba32aed8942a).iconGradientStart,
        iconGradientStop: (0, $8eafb83749b35973$export$793fba32aed8942a).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n  <svg viewBox=\"0 0 32 32\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"108.695%\" x2=\"12.439%\" y1=\"-14.936%\" y2=\"45.215%\" id=\"".concat(id, "-1\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n      <linearGradient x1=\"0%\" x2=\"91.029%\" y1=\"118.55%\" y2=\"63.971%\" id=\"").concat(id, "-2\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path fill=\"").concat(colors.iconColor, "\" d=\"M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z\" />\n      <path fill=\"url(#").concat(id, "-1\" d=\"M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z\" />\n      <path fill=\"url(#").concat(id, "-2\" d=\"M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z\" />\n    </g>\n  </svg>");
};
var $e0f53c3cd3766619$export$c3835feba2a66e67 = function JiraSoftwareIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Software' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a1474506d92c7d3c$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $5e365994c35e24b2$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $e0f53c3cd3766619$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
var $e2efc7f4b69fbe2b$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
], $e2efc7f4b69fbe2b$var$_excluded2 = [
    "size"
];
var $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $e2efc7f4b69fbe2b$var$_excluded);
        if ((0, $137Lh.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
            size: size
        }, props));
    };
};
var $e2efc7f4b69fbe2b$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref2) {
        var size = _ref2.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $e2efc7f4b69fbe2b$var$_excluded2);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
            size: size || 'medium'
        }, props));
    };
};
var $e2efc7f4b69fbe2b$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'rovo',
        type: 'migration',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
var $e2efc7f4b69fbe2b$export$62e1212796a86b1b = $e2efc7f4b69fbe2b$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'program' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $e2efc7f4b69fbe2b$export$e0dee4a765830f4d = $e2efc7f4b69fbe2b$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'app' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $e2efc7f4b69fbe2b$export$516fce44c502c1d3 = $e2efc7f4b69fbe2b$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'legacy';
});
var $e2efc7f4b69fbe2b$export$b805fae8e798ed39 = $e2efc7f4b69fbe2b$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'migration';
});
var $e2efc7f4b69fbe2b$export$3f9abd26214cd85f = $e2efc7f4b69fbe2b$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'new';
});


var $541f1648413af912$export$ef8e5f836dd989d3 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $4880006783b144cd$export$ef8e5f836dd989d3));
var $541f1648413af912$export$ebcd30672e67406 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $3e40fcb2146c4dbe$export$61afcb38c001e19));
var $541f1648413af912$export$af3460f51ce3602a = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $04a4bbefebd8e7e4$export$af3460f51ce3602a));
var $541f1648413af912$export$c8415b6abe4a8587 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $1d418877717652b8$export$f0bac2b7ac3e3504));
var $541f1648413af912$export$d89497e7f33ca6f5 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $0ac2f3357bba670e$export$d89497e7f33ca6f5));
var $541f1648413af912$export$48ca930f3071e3e4 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $b8f26846418a2bb2$export$81c47abe19675c4c));
var $541f1648413af912$export$52cd484a7ef4f2b9 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $03180751fccdc506$export$52cd484a7ef4f2b9));
var $541f1648413af912$export$9ca9881809919df8 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $554bfe0ddb0f1fb0$export$a529e78951cd6709));
var $541f1648413af912$export$6da5aa77c402ba0f = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $d0399399b5e3bcff$export$6da5aa77c402ba0f));
var $541f1648413af912$export$abc95e6180bb1d88 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $83bfd21c6ef94938$export$f597f0f7fadce0b9));
var $541f1648413af912$export$9eb74917ea768ed4 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $2600f4570e8f8aa3$export$9eb74917ea768ed4));
var $541f1648413af912$export$d2577aa28451395f = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $78ec99dd8648524d$export$c527a545aa426db3));
var $541f1648413af912$export$92c8767b874048d = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $3c64cf09ca1c1117$export$92c8767b874048d));
var $541f1648413af912$export$d5648119d5b68e90 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $a4687df259ed67a6$export$8b6b7f1b1b2367d3));
var $541f1648413af912$export$80b8b269d8b5014e = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $b1d32697de4bd873$export$80b8b269d8b5014e));
var $541f1648413af912$export$fc9bd6687b80fe3b = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $8facf67472cfb8b3$export$7a38180641471460));
var $541f1648413af912$export$5ed3e1bb3b04fc02 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $331804a167e7dd21$export$5ed3e1bb3b04fc02));
var $541f1648413af912$export$aeefab651bcf2338 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $bec4556b12c77a86$export$e3d1678155aaab99));
var $541f1648413af912$export$82eafebb825fc23f = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $d92c10f2a6e9e78c$export$82eafebb825fc23f));
var $541f1648413af912$export$e4c5487c9a8ae3b1 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $52709947373b6dcf$export$fa08cbfe393f2a68));
var $541f1648413af912$export$290a0f24614cde9f = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $2d7aefc14cfa3b62$export$290a0f24614cde9f));
var $541f1648413af912$export$8aceb78c659789b6 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $e793f1b93656fe4b$export$273fd56580e523ae));
var $541f1648413af912$export$4b05688514531169 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $6d5766bad4ba867c$export$4b05688514531169));
var $541f1648413af912$export$4f6453e012279f89 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $2206699866c18c7b$export$1b3979d995ebbc6e));
var $541f1648413af912$export$1bcbc9c337da86da = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $03fdb902f9365af3$export$1bcbc9c337da86da));
var $541f1648413af912$export$9b1a0a0c574cec2a = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $b1a57392113869cb$export$bfd8d1c4da84ce71));
var $541f1648413af912$export$e812398311cab9a3 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $42be5e881a53f5ff$export$e812398311cab9a3));
var $541f1648413af912$export$765f5afcc1a5a7e3 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $212a1346d19659ec$export$7c51958462d750e));
var $541f1648413af912$export$d3ab16bbf4f954ee = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $b225b413d373bfb2$export$d3ab16bbf4f954ee));
var $541f1648413af912$export$36044946916e84a0 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $a734f03efa211a18$export$cc55e2a4c4b40552));
var $541f1648413af912$export$53305f1f2855d3be = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $2ad508f22b1f7913$export$53305f1f2855d3be));
var $541f1648413af912$export$5e06396bce773a3 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $99228cb46155dfd3$export$b3e508cb103e1f93));
var $541f1648413af912$export$eaf73f391f7103bd = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $76350cbdd63b9a1a$export$eaf73f391f7103bd));
var $541f1648413af912$export$6128b385660fd3c6 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $959663811a6fadba$export$3c371bdbcdfcdce));
var $541f1648413af912$export$f8455b5667a3ee0c = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $023c00c9ee738e91$export$f8455b5667a3ee0c));
var $541f1648413af912$export$eb152ab3801b2ae3 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $6538b05ab3d32bd0$export$3224b07bc93ef23e));
var $541f1648413af912$export$65fae0eaf343f2ca = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $ff1c6132dc941e13$export$65fae0eaf343f2ca));
var $541f1648413af912$export$fffc0d480fb1ebf1 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $37bcbb4019e8e020$export$f64bc7a7f04428d0));
var $541f1648413af912$export$74517ed253186308 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $c08b60f1d1bd7b7d$export$74517ed253186308), (0, $4880006783b144cd$export$ef8e5f836dd989d3));
var $541f1648413af912$export$833abe6c2ce5ebfd = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $4dba799d2db29a7e$export$833abe6c2ce5ebfd), (0, $3e40fcb2146c4dbe$export$61afcb38c001e19));
var $541f1648413af912$export$84109e099492cb5f = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $3095db0c6f9e13d4$export$84109e099492cb5f), (0, $4880006783b144cd$export$ef8e5f836dd989d3));
var $541f1648413af912$export$f845d9b9254f0541 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $51de8758bdd5f267$export$f845d9b9254f0541), (0, $3e40fcb2146c4dbe$export$61afcb38c001e19));
var $541f1648413af912$export$c42ad8a0b925c762 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $c12d9aedd79d3ec5$export$c42ad8a0b925c762), (0, $04a4bbefebd8e7e4$export$af3460f51ce3602a));
var $541f1648413af912$export$e6470bfc39010cc4 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $2339c88bd283994c$export$e6470bfc39010cc4), (0, $1d418877717652b8$export$f0bac2b7ac3e3504));
var $541f1648413af912$export$5fc1066e677788d4 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $72fbb20ba78b51dd$export$5fc1066e677788d4), (0, $0175a469435a05be$export$5fc1066e677788d4));
var $541f1648413af912$export$bd40525f5333524b = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $aa7454de44a5fb3c$export$bd40525f5333524b), (0, $8cfaa1ce1c1a4a51$export$f7ef5e5488e4b430));
var $541f1648413af912$export$f7857fe64d7161d9 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $a0118ca7eeda4998$export$f7857fe64d7161d9), (0, $dd20ad7fb8a444a3$export$f7857fe64d7161d9));
var $541f1648413af912$export$eb7d748e4f9c9676 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $c6ad4536c7c96f69$export$eb7d748e4f9c9676), (0, $8add615c1a1a6082$export$a16f50a81d183ce));
var $541f1648413af912$export$68f3db7f6af48bcb = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $9b739d594c5ba755$export$68f3db7f6af48bcb), (0, $e8addf3946725bb7$export$68f3db7f6af48bcb));
var $541f1648413af912$export$1b2e4fe6ef471556 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $9ad33901574c9200$export$1b2e4fe6ef471556), (0, $7d108de4bac90c4a$export$a88b0b0da9ef63ce));
var $541f1648413af912$export$70a0c2f5862937b6 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $523eca9193a68fc2$export$70a0c2f5862937b6));
var $541f1648413af912$export$1b8596b4b0ef673b = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $16381b5c9298fc87$export$8b5103382c06639c));
var $541f1648413af912$export$407687b2dd89cc68 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $c0174fcd83e30e01$export$407687b2dd89cc68), (0, $523eca9193a68fc2$export$70a0c2f5862937b6));
var $541f1648413af912$export$ee11e928d3d045fd = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $7f0e665c95c08e80$export$ee11e928d3d045fd), (0, $16381b5c9298fc87$export$8b5103382c06639c));
var $541f1648413af912$export$c4b5b1f965d8b3eb = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $89badb7e09bd7da5$export$c4b5b1f965d8b3eb), (0, $572b84fa8fec13d5$export$c4b5b1f965d8b3eb));
var $541f1648413af912$export$17d3acb0b4379d02 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $bfb325ecf6215374$export$17d3acb0b4379d02), (0, $9ecbbdbe70d19b32$export$bf4c5f97b468e8d6));
var $541f1648413af912$export$21bfbeb62fdcce8d = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $0220eebb07adb628$export$21bfbeb62fdcce8d), (0, $57a54c69c6c92229$export$21bfbeb62fdcce8d));
var $541f1648413af912$export$c49a2b642fe9eef4 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $36b7889fefdc48ff$export$c49a2b642fe9eef4), (0, $36ebcdbc423aa46c$export$602140a6a10b02bf));
var $541f1648413af912$export$3c6158790f5e01c4 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $8b020727b1a17434$export$3c6158790f5e01c4), (0, $0f2f8ae0e90e9926$export$3c6158790f5e01c4));
var $541f1648413af912$export$dabef2be6cd28c20 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $c8663250dd0ec80d$export$dabef2be6cd28c20), (0, $828de5dfeeb81d72$export$de148263c75d2bc1));
var $541f1648413af912$export$8d789f76fde3e05 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $a3a19e092ee56f24$export$8d789f76fde3e05), (0, $ea5f31681e9695cd$export$8d789f76fde3e05));
var $541f1648413af912$export$94e206806e36c2ec = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $e3bd7e3f84bc76d5$export$94e206806e36c2ec), (0, $a3f5784d21b0fc66$export$78c0b4d8be34c9b2));
var $541f1648413af912$export$1bf47cdade1a9fcb = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $ea868076f062db5f$export$1bf47cdade1a9fcb), (0, $ea5f31681e9695cd$export$8d789f76fde3e05));
var $541f1648413af912$export$6e87ce8d41eda665 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $851d611d31971793$export$6e87ce8d41eda665), (0, $d5171a561a513b41$export$68d7391318cdef11));
var $541f1648413af912$export$e84e925618e0e5bc = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $cd40320e26c0da3f$export$71743a944cb62e48));
var $541f1648413af912$export$1940ba72c868b663 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $970b111866c09a60$export$38c7b37a3e5e8d70));
var $541f1648413af912$export$eeccc49dc7a12d9f = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $a1db71cc771d6df3$export$eeccc49dc7a12d9f), (0, $2131d8f1ef8ecc46$export$eeccc49dc7a12d9f));
var $541f1648413af912$export$a1c6484cdecc2c4b = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $a647b5a9c71c8c53$export$a1c6484cdecc2c4b), (0, $989da254b6fac915$export$a5b9122e89b32ad3));
var $541f1648413af912$export$f3f5aa321d88adf9 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $f3a9f3796143f630$export$f3f5aa321d88adf9), (0, $283443bece6d8862$export$f3f5aa321d88adf9));
var $541f1648413af912$export$bb4ae5b41b43be04 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $d6020ef477dc54c9$export$bb4ae5b41b43be04), (0, $e3d0626f3b42a8a4$export$2bc88a281410ffa7));
var $541f1648413af912$export$4384da9b8b140bf4 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $1766ce248ff1f309$export$4384da9b8b140bf4), (0, $53e5ffc67a53e87d$export$4384da9b8b140bf4));
var $541f1648413af912$export$60e26212f3b61a28 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $8520bd5de24d7beb$export$60e26212f3b61a28), (0, $c588329ac49c83d5$export$1b13139dfc0336af));
var $541f1648413af912$export$e23ae35269442b4f = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $42e930e74f9f8683$export$e23ae35269442b4f), (0, $897c33b460a3d900$export$e23ae35269442b4f));
var $541f1648413af912$export$a0f6cb8061290bbb = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $8423a59c6edc0a50$export$a0f6cb8061290bbb), (0, $cffb74ce0b50ed4c$export$b0e15f0a1c9f4c55));
var $541f1648413af912$export$3f95fcfdc25a741d = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $10c744883a107350$export$3f95fcfdc25a741d), (0, $65f82ef729dbd31f$export$3f95fcfdc25a741d));
var $541f1648413af912$export$a4a891d202775deb = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $d26e7488354657e1$export$a4a891d202775deb), (0, $94c53b60cf3bf6db$export$2b896c4d595a4331));
var $541f1648413af912$export$1e02e7298035a77c = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $8002a6a9ba672835$export$1e02e7298035a77c), (0, $a4646aa917cf9e3b$export$1e02e7298035a77c));
var $541f1648413af912$export$33908560ea1b226d = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $01930ff09b14dd01$export$33908560ea1b226d), (0, $eb2c9f401968d219$export$3a6e8b37e069a69d));


/* icons.tsx generated by @compiled/babel-plugin v0.38.1 */ 



parcelRequire("7fPBF");



parcelRequire("7fPBF");
const $a6c7856c904df030$var$SvgAtlas = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "aA",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 19.6 19.6"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "dA",
                        x1: 5.77,
                        y1: -814.36,
                        x2: 5.08,
                        y2: -796.18,
                        gradientTransform: "matrix(1 0 0 -1 0 -795.31)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0052cc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "eA",
                        x1: 19.05,
                        y1: -805.91,
                        x2: 10.99,
                        y2: -814.24,
                        gradientTransform: "matrix(1 0 0 -1 0 -795.31)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#0e65df"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0052cc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "fA",
                        x1: 14.35,
                        y1: -796.01,
                        x2: 14.35,
                        y2: -805.11,
                        gradientTransform: "matrix(1 0 0 -1 0 -795.31)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.59,
                                stopColor: "#156ee8"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0e65df"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "gA",
                        x1: 0.78,
                        y1: -805.53,
                        x2: 13.96,
                        y2: -805.53,
                        gradientTransform: "matrix(1 0 0 -1 0 -795.31)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.26,
                                stopColor: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0e65df"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "hA",
                        x1: 15.17,
                        y1: -807.71,
                        x2: 18.05,
                        y2: -804.65,
                        gradientTransform: "matrix(1 0 0 -1 0 -795.31)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#0052cc"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0e65df"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "iA",
                        x1: 11.9,
                        y1: -814.21,
                        x2: 11.9,
                        y2: -796.82,
                        gradientTransform: "matrix(1 0 0 -1 0 -795.31)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0052cc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "jA",
                        x1: -5135.73,
                        y1: -814.21,
                        x2: -5135.73,
                        y2: -796.83,
                        gradientTransform: "rotate(-180 -2564.05 -397.655)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.58,
                                stopColor: "#0052cc"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#2684ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: ".kA{fill:#2684ff}"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                id: "bA",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "cA",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            style: {
                                fill: "none"
                            },
                            d: "M0 0h19.6v19.6H0z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M9.8 18.9C4.76 18.9.7 14.84.7 9.8S4.76.7 9.8.7v1.47c-4.2 0-7.63 3.43-7.63 7.63s3.43 7.63 7.63 7.63v1.47Z",
                            style: {
                                fill: "url(#dA)"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M9.8 18.9v-1.47c4.2 0 7.63-3.43 7.63-7.63h1.47c0 5.04-4.06 9.1-9.1 9.1Z",
                            style: {
                                fill: "url(#eA)"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M18.9 9.8h-1.47c0-4.2-3.43-7.63-7.63-7.63V.7c5.04 0 9.1 4.06 9.1 9.1Z",
                            style: {
                                fill: "url(#fA)"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M13.65 12.6c-.98-.21-1.75-.56-3.01-1.12-.35-.14-.77-.35-1.19-.56-.28-.14-.49-.21-.77-.35-1.89-.84-2.94-1.33-4.27-1.33-.91 0-1.61.28-1.96.7-.28.28-.35.7-.28 1.12l-1.4.28c-.07-.77.14-1.61.63-2.24.49-.56 1.4-1.26 3.08-1.26s2.87.56 4.83 1.47c.21.07.49.21.77.35.42.21.84.35 1.19.56 1.19.56 1.89.84 2.66.98l-.28 1.4Z",
                            style: {
                                fill: "url(#gA)"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M15.12 12.74c-.49 0-.98-.07-1.4-.14l.28-1.4c.35.07.77.14 1.12.14.91 0 1.54-.21 1.96-.63.42-.42.42-.98.35-1.19l1.47-.14c.07.91-.21 1.68-.77 2.31-.49.42-1.4 1.05-3.01 1.05Z",
                            style: {
                                fill: "url(#hA)"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M9.8 18.9v-1.47c2.1 0 3.29-2.1 3.29-5.67s-1.26-6.51-3.85-9.24l1.05-.98c2.87 3.01 4.27 6.37 4.27 10.29 0 4.34-1.82 7.07-4.76 7.07Z",
                            style: {
                                fill: "url(#iA)"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M9.8 18.9c-3.15 0-4.9-2.52-4.9-7 0-5.18 2.24-8.05 4.34-10.36l1.12.98C7.84 5.18 6.3 7.7 6.3 11.9c0 4.62 1.89 5.53 3.5 5.53v1.47Z",
                            style: {
                                fill: "url(#jA)"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "kA",
                            cx: 5.95,
                            cy: 8.89,
                            r: 1.68
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "kA",
                            cx: 13.72,
                            cy: 11.76,
                            r: 1.68
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            className: "kA",
                            cx: 9.8,
                            cy: 1.68,
                            r: 1.68
                        })
                    ]
                })
            })
        ]
    }));
var $a6c7856c904df030$export$2e2bcd8739ae039 = $a6c7856c904df030$var$SvgAtlas;





parcelRequire("7fPBF");
const $172e5ffac0286fdb$var$SvgBamboo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "aB",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        viewBox: "0 0 18.8 21.9",
        style: {
            enableBackground: "new 0 0 18.8 21.9"
        },
        xmlSpace: "preserve"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                children: ".st0{fill:#2684ff}"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                className: "st0",
                d: "M16.4 12.2h-3.6c-.2 0-.4.2-.4.4-.2 1.5-1.5 2.6-3 2.6l1 4.5c3.5-.4 6.3-3.4 6.6-6.9-.1-.4-.3-.6-.6-.6zM10.2 12l5.2-4.5c.2-.2.2-.5 0-.7l-5.2-4.5c-.3-.3-.8 0-.8.4v9c0 .4.5.6.8.3z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                id: "SVGID_1_BAMBOO",
                gradientUnits: "userSpaceOnUse",
                x1: 5.685,
                y1: -792.848,
                x2: 5.685,
                y2: -803.129,
                gradientTransform: "matrix(1 0 0 -1 0 -788.11)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M1.9 13.1c.4 3.7 3.6 6.6 7.5 6.6v-4.5c-1.6 0-3-1.3-3-3l-4.5.9z",
                style: {
                    fill: "url(#SVGID_1_BAMBOO)"
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                id: "SVGID_00000075140605837118608660000007201214756016021145_",
                gradientUnits: "userSpaceOnUse",
                x1: 5.629,
                y1: -792.848,
                x2: 5.629,
                y2: -803.129,
                gradientTransform: "matrix(1 0 0 -1 0 -788.11)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                style: {
                    fill: "url(#SVGID_00000075140605837118608660000007201214756016021145_)"
                },
                d: "m1.9 12.1 4.5.1c0-1.6 1.3-3 3-3l-1-4.5c-3.6.5-6.5 3.6-6.5 7.4z"
            })
        ]
    }));
var $172e5ffac0286fdb$export$2e2bcd8739ae039 = $172e5ffac0286fdb$var$SvgBamboo;





parcelRequire("7fPBF");
const $bdef5a6280d082f4$var$SvgClover = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "aCL",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        viewBox: "0 0 21.8 21.8",
        style: {
            enableBackground: "new 0 0 21.8 21.8"
        },
        xmlSpace: "preserve"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M15.1 6.6h.2c0-2.4-2-4.4-4.4-4.4s-4.4 2-4.4 4.4c-2.4 0-4.4 2-4.4 4.4s2 4.4 4.4 4.4c0 2.4 2 4.4 4.4 4.4s4.4-2 4.4-4.4c2.5 0 4.4-2 4.4-4.4-.1-2.6-2.1-4.4-4.6-4.4zm.2 5h-1.5c-1.2 0-2.1 1-2.1 2.1v1.5h-1.5v-1.5c0-1.2-1-2.1-2.1-2.1H6.6v-1.5h1.5c1.2 0 2.1-1 2.1-2.1V6.6h1.5v1.5c0 1.2 1 2.1 2.1 2.1h1.5v1.4z",
                style: {
                    fill: "#2684ff"
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                id: "SVGID_1_CL",
                gradientUnits: "userSpaceOnUse",
                x1: 9.238,
                y1: -807.725,
                x2: 15.326,
                y2: -798.005,
                gradientTransform: "matrix(1 0 0 -1 0 -788.11)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M15.1 6.6h-3.5v1.5c0 1.2 1 2.1 2.1 2.1h1.5v1.5h-1.5c-1.2 0-2.1 1-2.1 2.1v1.5h-5c0 2.4 2 4.4 4.4 4.4s4.4-2 4.4-4.4c2.5 0 4.4-2 4.4-4.4-.2-2.5-2.2-4.3-4.7-4.3z",
                style: {
                    fill: "url(#SVGID_1_CL)"
                }
            })
        ]
    }));
var $bdef5a6280d082f4$export$2e2bcd8739ae039 = $bdef5a6280d082f4$var$SvgClover;





parcelRequire("7fPBF");
const $9f6fc30370c7e9d3$var$SvgCrowd = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "aCRO",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        viewBox: "0 0 22.2 21.8",
        style: {
            enableBackground: "new 0 0 22.2 21.8"
        },
        xmlSpace: "preserve"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "m19.6 5.3-8.5-3.1-8.5 3.1c-.2 0-.4.2-.4.5l.2 4.8c.1 3.9 2.1 6.9 5.3 8.8.3.2.7.1.8-.3l1.8-4.3c.1-.2-.1-.3-.2-.4-1.3-.4-2.4-1.6-2.4-3.1 0-1.8 1.5-3.2 3.2-3.2s3.2 1.5 3.2 3.2c0 1.5-1 2.7-2.4 3.1-.2.1-.2.2-.2.4l1.8 4.3c.2.3.5.4.8.3 3.1-1.9 5.2-4.8 5.3-8.8l.6-4.8c0-.2-.1-.5-.4-.5z",
                style: {
                    fill: "#2684ff"
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                id: "SVGID_1_CRO",
                gradientUnits: "userSpaceOnUse",
                x1: 15.588,
                y1: -796.346,
                x2: 17.131,
                y2: -806.618,
                gradientTransform: "matrix(1 0 0 -1 0 -788.11)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#2684ff"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#0052cc"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M11.1 8.2c1.8 0 3.2 1.5 3.2 3.2 0 1.5-1 2.7-2.4 3.1-.2.1-.2.2-.2.4l1.8 4.3c.2.3.5.4.8.3 3.1-1.9 5.2-4.9 5.3-8.9l.4-4.8c0-.2-.2-.4-.4-.6l-8.5-3.1v6.1z",
                style: {
                    fill: "url(#SVGID_1_CRO)"
                }
            })
        ]
    }));
var $9f6fc30370c7e9d3$export$2e2bcd8739ae039 = $9f6fc30370c7e9d3$var$SvgCrowd;





parcelRequire("7fPBF");
const $db9f7800feb56c06$var$SvgCrucible = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "aCRU",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        viewBox: "0 0 21.3 21.8",
        style: {
            enableBackground: "new 0 0 21.3 21.8"
        },
        xmlSpace: "preserve"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M10.6 2.3C6 2.3 2.2 3.9 2.2 5.8v.3l1.5 7.8c.6 3.3 3.5 5.7 6.9 5.7s6.3-2.4 6.9-5.7L19 6.1v-.3c0-1.9-3.7-3.5-8.4-3.5zm0 12.9c-2.5 0-2.2-5.7-5-6.5-.2-.1-.4-.1-.6-.3 1.5-.6 3.4-.9 5.6-.9s4.1.3 5.6.9c-.2.1-.4.2-.7.2-2.6 1-2.4 6.6-4.9 6.6z",
                style: {
                    fill: "#2684ff"
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                id: "SVGID_1_CRU",
                gradientUnits: "userSpaceOnUse",
                x1: 10.64,
                y1: -796.535,
                x2: 10.64,
                y2: -790.407,
                gradientTransform: "matrix(1 0 0 -1 0 -788.11)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M5 8.4c1.5-.6 3.5-.9 5.7-.9s4.2.3 5.7.9c1.7-.7 2.9-1.6 2.9-2.7 0-2-3.8-3.6-8.5-3.6S2.1 3.8 2.1 5.8c0 1.1 1.1 2 2.9 2.6z",
                style: {
                    fill: "url(#SVGID_1_CRU)"
                }
            })
        ]
    }));
var $db9f7800feb56c06$export$2e2bcd8739ae039 = $db9f7800feb56c06$var$SvgCrucible;





parcelRequire("7fPBF");
const $b10660c430ad3d66$var$SvgFisheye = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "aF",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        viewBox: "0 0 21.8 18.9",
        style: {
            enableBackground: "new 0 0 21.8 18.9"
        },
        xmlSpace: "preserve"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M10.4 1.9c-2.7 0-4.9 2-4.9 4.4 0 1.9 1.3 3.2 2.8 3.2 1.6 0 2.7-1.2 2.7-2.6 0-.2 0-.4-.1-.5 1.2.7 2.5 1.7 3.2 2.7-.8 1.5-2.2 3.1-4.1 3.1-1.5 0-2.8-1.2-3-2.7 0-.2-.2-.4-.5-.4H2.8c-.3 0-.5.2-.5.5.3 4.2 3.5 7.4 7.7 7.4 4.6 0 7.4-3.4 9.5-7.7.1-.2.1-.3 0-.4-.6-1.2-3.9-7-9.1-7z",
                style: {
                    fill: "#2684ff"
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                id: "SVGID_1_F",
                gradientUnits: "userSpaceOnUse",
                x1: 2.22,
                y1: -799.562,
                x2: 13.476,
                y2: -802.946,
                gradientTransform: "matrix(1 0 0 -1 0 -790.11)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0.18,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M19.7 9.1h-5.4c-.8 1.5-2.2 3.1-4.2 3.1-1.5 0-2.9-1.2-3.1-2.7 0-.2-.2-.4-.5-.4H2.7c-.3 0-.5.2-.5.6.3 4.1 3.6 7.3 7.8 7.3 4.7 0 7.5-3.4 9.6-7.7.1-.1.1-.1.1-.2z",
                style: {
                    fill: "url(#SVGID_1_F)"
                }
            })
        ]
    }));
var $b10660c430ad3d66$export$2e2bcd8739ae039 = $b10660c430ad3d66$var$SvgFisheye;





parcelRequire("7fPBF");
const $75b10d06578c05f6$var$SvgSourcetree = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "aST",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17.36 21.91"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                    id: "bST",
                    x1: 12.124,
                    y1: -802.581,
                    x2: 12.124,
                    y2: -795.229,
                    gradientTransform: "matrix(1 0 0 -1 0 -788.11)",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 0.18,
                            stopColor: "#0052cc"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 1,
                            stopColor: "#2684ff"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M15.624 9.135c0-3.808-3.08-6.944-6.944-6.944-3.808 0-6.944 3.08-6.944 6.944 0 3.08 2.016 5.656 4.76 6.608v3.472c0 .28.224.504.504.504h3.304c.28 0 .504-.224.504-.504v-3.472a6.944 6.944 0 0 0 4.816-6.608ZM8.68 11.487c-1.288 0-2.352-1.064-2.352-2.352S7.392 6.783 8.68 6.783s2.352 1.064 2.352 2.352-1.064 2.352-2.352 2.352Z",
                style: {
                    fill: "#2684ff"
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M8.68 2.191v4.592c1.288 0 2.352 1.064 2.352 2.352s-1.064 2.352-2.352 2.352c1.176 0 2.128.952 2.128 2.128v2.072c2.744-.896 4.76-3.528 4.76-6.608.056-3.752-3.08-6.888-6.888-6.888Z",
                style: {
                    fill: "url(#bST)"
                }
            })
        ]
    }));
var $75b10d06578c05f6$export$2e2bcd8739ae039 = $75b10d06578c05f6$var$SvgSourcetree;





parcelRequire("7fPBF");
const $141a6681c14de602$var$SvgHalp = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "aH",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        viewBox: "0 0 19.8 19.8",
        style: {
            enableBackground: "new 0 0 19.8 19.8"
        },
        xmlSpace: "preserve"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("radialGradient", {
                id: "SVGID_1_HALP",
                cx: 9.912,
                cy: 2459.23,
                r: 7.968,
                gradientTransform: "translate(0 -2449.33)",
                gradientUnits: "userSpaceOnUse",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0.43,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0.84,
                        style: {
                            stopColor: "#1b75f0"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M15.5 4.2c1.1 1.1 1.9 2.6 2.2 4.1.2 1.5.2 3.1-.5 4.6-.6 1.4-1.6 2.7-2.9 3.6-1.4.9-2.9 1.4-4.4 1.4s-3.1-.5-4.4-1.4c-1.4-.9-2.3-2.1-2.9-3.6-.6-1.4-.8-3-.5-4.6s1-3 2.2-4.1c.7-.7 1.6-1.3 2.6-1.7 1-.4 2-.6 3-.6s2.1.2 3 .6c1.1.4 1.9 1.1 2.6 1.7zm-9.8 10zm6.2-7.5L13.5 5c-1-.8-2.3-1.2-3.6-1.2S7.3 4.2 6.3 5L8 6.6 6.6 7.8 5 6.3c-.8 1-1.2 2.3-1.2 3.6s.4 2.6 1.2 3.6L6.5 12l1.2 1.2-1.4 1.6c1 .8 2.3 1.2 3.6 1.2s2.6-.4 3.6-1.2L11.7 13l1.1-1.1 1.7 1.7c.8-1 1.2-2.3 1.2-3.6s-.4-2.6-1.2-3.6L13 8c.1-.1-1.1-1.3-1.1-1.3z",
                style: {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    fill: "url(#SVGID_1_HALP)"
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M9.9 5.9c-.8 0-1.6.2-2.2.6-.5.4-1.2 1.2-1.5 1.9-.3.7-.3 1.5-.2 2.3.2.8.5 1.4 1 2 .6.6 1.3.9 2 1 .8.2 1.6.1 2.3-.2.7-.2 1.4-.8 1.8-1.4.5-.6.6-1.4.6-2.2 0-1-.4-2.1-1.2-2.8-.5-.7-1.5-1.2-2.6-1.2zm0 6.2c-.5 0-.9-.2-1.2-.3-.3-.2-.6-.6-.8-1s-.2-.9-.2-1.3c.1-.5.4-.8.7-1.1.3-.3.7-.5 1.1-.6.5-.1.9-.1 1.3.1s.8.5 1 .8c.2.3.3.8.3 1.2 0 .3-.1.6-.2.9-.1.2-.2.5-.5.7-.2.2-.5.3-.7.5-.2.1-.5.1-.8.1z",
                style: {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    fill: "#2684ff"
                }
            })
        ]
    }));
var $141a6681c14de602$export$2e2bcd8739ae039 = $141a6681c14de602$var$SvgHalp;





parcelRequire("7fPBF");
const $e6b3e8d1849ac31b$var$SvgAgileNewsletter = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 237.56 180.29"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "N300",
                        x1: 25.88,
                        y1: 140.49,
                        x2: 186.16,
                        y2: 140.49,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#6c798f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#6c798f",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        y1: 160.25,
                        x2: 104.4,
                        y2: 160.25,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#99c1ff",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.01,
                                stopColor: "#93beff",
                                stopOpacity: 0.04
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.05,
                                stopColor: "#78adff",
                                stopOpacity: 0.22
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#5e9eff",
                                stopOpacity: 0.38
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.14,
                                stopColor: "#4790ff",
                                stopOpacity: 0.53
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#3484ff",
                                stopOpacity: 0.66
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.25,
                                stopColor: "#247aff",
                                stopOpacity: 0.77
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.32,
                                stopColor: "#1672ff",
                                stopOpacity: 0.85
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#0c6cff",
                                stopOpacity: 0.92
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#0568ff",
                                stopOpacity: 0.97
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.63,
                                stopColor: "#0166ff",
                                stopOpacity: 0.99
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0065ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: 0,
                        y1: 140.49,
                        x2: 104.4,
                        y2: 140.49,
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                        id: "linear-gradient-3",
                        x1: 0,
                        y1: 140.49,
                        x2: 104.4,
                        y2: 140.49,
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: ".cls-3{fill:#0065ff}"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "Software",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "m236.54 138-36.33-36.33a3.47 3.47 0 0 0-5.92 2.45v16.54h-91.44v39.57h91.45v16.54a3.47 3.47 0 0 0 5.92 2.45l36.33-36.33a3.47 3.47 0 0 0-.01-4.89Z",
                            style: {
                                fill: "#64e6a4"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M127.94 120.71a40.32 40.32 0 0 1-21.94 6.46v33.11h31.5a80.62 80.62 0 0 0 41-39.57Z",
                            style: {
                                fill: "url(#N300)"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "cls-3",
                            d: "M102.85 160.27v-39.56a40.57 40.57 0 1 0-40.57-40.57H22.71a80.14 80.14 0 1 1 80.14 80.14Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "cls-3",
                            d: "M183 80.14a80.14 80.14 0 0 0-159.87-8.26L9.75 70.67a3.06 3.06 0 0 0-2.62 5l30.56 36.63c1.08 1.3 3 1.47 3.4.39l36.63-30.57c3-1.75 1.93-5.15-.78-5.4l-14.38-1.3a40.57 40.57 0 1 1 40.29 45.27h1.55v39.53A80.21 80.21 0 0 0 183 80.14Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M104.4 160.27h-1.55Z",
                            style: {
                                fill: "url(#linear-gradient)"
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            style: {
                                fill: "url(#linear-gradient-2)"
                            },
                            d: "M0 120.71h102.85v39.57H0z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            className: "cls-3",
                            d: "M102.85 120.71v39.57h1.55v-39.57Z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M102.85 120.71v39.57h1.55v-39.57Z",
                            style: {
                                fill: "url(#linear-gradient-3)"
                            }
                        })
                    ]
                })
            })
        ]
    }));
var $e6b3e8d1849ac31b$export$2e2bcd8739ae039 = $e6b3e8d1849ac31b$var$SvgAgileNewsletter;





parcelRequire("7fPBF");
const $182aba92a4459745$var$SvgGit = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "aGIT",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        viewBox: "0 0 64.3 64.3",
        style: {
            enableBackground: "new 0 0 64.3 64.3"
        },
        xmlSpace: "preserve"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                id: "SVGID_1_GIT",
                gradientUnits: "userSpaceOnUse",
                x1: 31.971,
                y1: 783.236,
                x2: 32.331,
                y2: 834.67,
                gradientTransform: "translate(0 -776.71)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#2684ff"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0.99,
                        style: {
                            stopColor: "#0052cc"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M56.9 29.9 34.4 7.4a3.32 3.32 0 0 0-4.7 0L25.1 12l5.9 6c1.4-.4 3-.2 4 1 1.1 1.1 1.4 2.7 1 4.1l5.7 5.7c1.4-.4 3-.2 4.1 1 1.6 1.6 1.6 4 0 5.6s-4 1.6-5.6 0c-1.2-1.2-1.5-2.9-.8-4.3l-5.3-5.3v14c.4.2.7.4 1.1.7 1.6 1.6 1.6 4 0 5.6-1.6 1.5-4 1.5-5.6 0-1.6-1.6-1.6-4 0-5.6.4-.4.8-.7 1.3-.8V25.4c-.4-.2-.9-.5-1.3-.8-1.2-1.2-1.5-2.9-.8-4.3l-5.9-5.9L7.4 29.7a3.32 3.32 0 0 0 0 4.7l22.5 22.5c1.3 1.3 3.4 1.3 4.7 0l22.3-22.3c1.3-1.3 1.3-3.5 0-4.7z",
                style: {
                    fill: "url(#SVGID_1_GIT)"
                }
            })
        ]
    }));
var $182aba92a4459745$export$2e2bcd8739ae039 = $182aba92a4459745$var$SvgGit;





parcelRequire("7fPBF");
const $e2f8cedcfded7cdc$var$SvgGeneralMarketingOptIn = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "aG",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        viewBox: "0 0 172.9 128.6",
        style: {
            enableBackground: "new 0 0 172.9 128.6"
        },
        xmlSpace: "preserve"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                children: ".st1G{fill:url(#SVGID_00000029012837056082208560000011312880847900416384_)}.st2G{fill:url(#SVGID_00000093866359683467538180000002566768084245135011_)}.st3G{fill:url(#SVGID_00000132075466675391807810000017507509499009587351_)}"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                id: "SVGID_1_GMOI",
                gradientUnits: "userSpaceOnUse",
                x1: 75.272,
                y1: -581.805,
                x2: 75.272,
                y2: -478.965,
                gradientTransform: "matrix(1 0 0 -1 0 -466.11)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M107.2 15.8c-.3-1.1-1.1-2-2.1-2.5s-2.1-.6-3.2-.3l-17.6 5.7c-2.2.7-3.4 3.1-2.7 5.3l.9 2.7-44.6 32.9-17.7 5.8c-1.1.3-2 1.1-2.5 2.1s-.6 2.1-.2 3.2l10.7 33c.6 1.8 2.2 2.9 4 2.9.4 0 .8-.1 1.3-.2l17.6-5.7 9.1.1c1.8 8.6 9.5 15.1 18.6 15.1s16.6-6.4 18.5-14.8l9.3.1.9 2.7c.3 1.1 1.1 2 2.1 2.5.6.3 1.2.4 1.9.4.4 0 .9-.1 1.3-.2l17.6-5.7c2.2-.7 3.4-3.1 2.7-5.3l-25.9-79.8zM34.9 97l-8.1-25 10.3-3.4 8.1 25c0 .1-10.3 3.4-10.3 3.4zm43.9 10.3c-4.4 0-8.2-2.7-9.8-6.6l19.6.1c-1.6 3.8-5.4 6.5-9.8 6.5zM53.5 92.2l-4.4-13.6L44.7 65l40.5-29.8 12.4 38.2 6.2 19c0 .1-50.3-.2-50.3-.2zm60.7 4.8-.5-1.6-11.1-34.2L91 25.5l9.6-3.1 23.2 71.5-9.6 3.1z",
                style: {
                    fill: "url(#SVGID_1_GMOI)"
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                id: "SVGID_00000027600303583147959230000014547028643630307720_",
                gradientUnits: "userSpaceOnUse",
                x1: 122.356,
                y1: -500.219,
                x2: 132.348,
                y2: -480.93,
                gradientTransform: "matrix(1 0 0 -1 0 -466.11)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                style: {
                    fill: "url(#SVGID_00000027600303583147959230000014547028643630307720_)"
                },
                d: "M121.3 36.2c.6.3 1.3.4 1.9.4 1.5 0 3-.8 3.8-2.3l7.6-14.8c1.1-2.1.2-4.6-1.8-5.7s-4.6-.2-5.7 1.8l-7.6 14.8c-1.1 2.2-.2 4.8 1.8 5.8z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                id: "SVGID_00000088117863559892969280000004110498432163659143_",
                gradientUnits: "userSpaceOnUse",
                x1: 134.193,
                y1: -537.748,
                x2: 153.345,
                y2: -546.868,
                gradientTransform: "matrix(1 0 0 -1 0 -466.11)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                style: {
                    fill: "url(#SVGID_00000088117863559892969280000004110498432163659143_)"
                },
                d: "m152.9 76.2-14.8-7.6c-2.1-1.1-4.6-.2-5.7 1.8-1.1 2.1-.2 4.6 1.8 5.7l14.8 7.6c.6.3 1.3.4 1.9.4 1.5 0 3-.8 3.8-2.3 1.1-2.1.3-4.6-1.8-5.6z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                id: "SVGID_00000145751960127603169490000018030763481166983320_",
                gradientUnits: "userSpaceOnUse",
                x1: 133.223,
                y1: -517.617,
                x2: 154.015,
                y2: -510.329,
                gradientTransform: "matrix(1 0 0 -1 0 -466.11)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                style: {
                    fill: "url(#SVGID_00000145751960127603169490000018030763481166983320_)"
                },
                d: "M131.6 51.8c.6 1.8 2.2 2.9 4 2.9.4 0 .9-.1 1.3-.2l15.8-5.2c2.2-.7 3.4-3.1 2.7-5.3-.7-2.2-3.1-3.4-5.3-2.7l-15.8 5.2c-2.1.7-3.3 3.1-2.7 5.3z"
            })
        ]
    }));
var $e2f8cedcfded7cdc$export$2e2bcd8739ae039 = $e2f8cedcfded7cdc$var$SvgGeneralMarketingOptIn;


const $22f1cdb487390d65$var$_2 = "._4t3ickbl{height:3pc}";
const $22f1cdb487390d65$var$_ = "._1bsbckbl{width:3pc}";
const $22f1cdb487390d65$var$styles = null;
const $22f1cdb487390d65$export$9d0b19639662f94b = (attributes)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $22f1cdb487390d65$var$_,
                    $22f1cdb487390d65$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a6c7856c904df030$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1bsbckbl _4t3ickbl"
                ])
            }))
        ]
    });
const $22f1cdb487390d65$export$e812398311cab9a3 = (attributes)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $22f1cdb487390d65$var$_,
                    $22f1cdb487390d65$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $172e5ffac0286fdb$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1bsbckbl _4t3ickbl"
                ])
            }))
        ]
    });
const $22f1cdb487390d65$export$fbdddb9a1c3b4e6 = (attributes)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $22f1cdb487390d65$var$_,
                    $22f1cdb487390d65$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bdef5a6280d082f4$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1bsbckbl _4t3ickbl"
                ])
            }))
        ]
    });
const $22f1cdb487390d65$export$eaf73f391f7103bd = (attributes)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $22f1cdb487390d65$var$_,
                    $22f1cdb487390d65$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9f6fc30370c7e9d3$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1bsbckbl _4t3ickbl"
                ])
            }))
        ]
    });
const $22f1cdb487390d65$export$16670a2a8849f51 = (attributes)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $22f1cdb487390d65$var$_,
                    $22f1cdb487390d65$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db9f7800feb56c06$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1bsbckbl _4t3ickbl"
                ])
            }))
        ]
    });
const $22f1cdb487390d65$export$70f0855587d72507 = (attributes)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $22f1cdb487390d65$var$_,
                    $22f1cdb487390d65$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b10660c430ad3d66$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1bsbckbl _4t3ickbl"
                ])
            }))
        ]
    });
const $22f1cdb487390d65$export$733ebb4ad83a1d45 = (attributes)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $22f1cdb487390d65$var$_,
                    $22f1cdb487390d65$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $75b10d06578c05f6$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1bsbckbl _4t3ickbl"
                ])
            }))
        ]
    });
const $22f1cdb487390d65$export$d1fd6f4b233951a9 = (attributes)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $22f1cdb487390d65$var$_,
                    $22f1cdb487390d65$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $141a6681c14de602$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1bsbckbl _4t3ickbl"
                ])
            }))
        ]
    });
const $22f1cdb487390d65$export$664fa484b9ce23b6 = (attributes)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $22f1cdb487390d65$var$_,
                    $22f1cdb487390d65$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $182aba92a4459745$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1bsbckbl _4t3ickbl"
                ])
            }))
        ]
    });
const $22f1cdb487390d65$export$ddb421af37c7fad5 = (attributes)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $22f1cdb487390d65$var$_,
                    $22f1cdb487390d65$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e2f8cedcfded7cdc$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1bsbckbl _4t3ickbl"
                ])
            }))
        ]
    });
const $22f1cdb487390d65$export$3b3e0936cbb04517 = (attributes)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $22f1cdb487390d65$var$_,
                    $22f1cdb487390d65$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e6b3e8d1849ac31b$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1bsbckbl _4t3ickbl"
                ])
            }))
        ]
    });
$22f1cdb487390d65$export$e812398311cab9a3.displayName = 'BambooIcon';
$22f1cdb487390d65$export$fbdddb9a1c3b4e6.displayName = 'CloverIcon';
$22f1cdb487390d65$export$eaf73f391f7103bd.displayName = 'CrowdIcon';
$22f1cdb487390d65$export$16670a2a8849f51.displayName = 'CrucibleIcon';
$22f1cdb487390d65$export$70f0855587d72507.displayName = 'FisheyeIcon';
$22f1cdb487390d65$export$733ebb4ad83a1d45.displayName = 'SourcetreeIcon';
$22f1cdb487390d65$export$d1fd6f4b233951a9.displayName = 'HalpIcon';
$22f1cdb487390d65$export$664fa484b9ce23b6.displayName = 'GitIcon';
$22f1cdb487390d65$export$ddb421af37c7fad5.displayName = 'MarketingIcon';
$22f1cdb487390d65$export$3b3e0936cbb04517.displayName = 'AgileInsidersNewsletterIcon';


const $1c3aade99c91fb27$var$ItemIcon = ({ title: title })=>{
    const defaultProps = {
        size: 'xlarge',
        appearance: 'brand'
    };
    switch(title){
        case 'jiraMacApp':
        case 'automationForJiraProductRecommendationsCloud':
        case 'automationForJiraProductUpgradesCloud':
        case 'automationForJiraTipsAndTricksCloud':
        case 'automationForJiraProductRecommendationsServer':
        case 'iconsForJiraProductRecommendationsServer':
        case 'automationForJiraProductUpgradesServer':
        case 'iconsForJiraProductUpgradesServer':
        case 'automationForJiraTipsAndTricksServer':
        case 'iconsForJiraTipsAndTricksServer':
        case 'productRecommendationsAdvancedRoadmapsForJiraCloud':
        case 'productRecommendationsJiraSoftwareCloud':
        case 'productUpgradesAdvancedRoadmapsForJiraCloud':
        case 'productUpgradesJiraSoftwareCloud':
        case 'jiraSoftwareTechAlerts':
        case 'jiraCloudCSComms':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $541f1648413af912$export$c4b5b1f965d8b3eb), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "jira-icon"
            }));
        case 'jiraServerNewsletter':
        case 'jiraSoftwareProductRecommendationsCloud':
        case 'jiraSoftwareProductRecommendationsServer':
        case 'jiraSoftwareProductUpgradesCloud':
        case 'jiraSoftwareProductUpgradesServer':
        case 'jiraSoftwareTipsAndTricksCloud':
        case 'jiraSoftwareTipsAndTricksServer':
        case 'productUpgradesJiraSoftwareDataCenter':
        case 'productUpgradesJiraSoftwareServer':
        case 'productRecommendationsJiraSoftwareDataCenter':
        case 'productRecommendationsJiraSoftwareServer':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0f53c3cd3766619$export$c3835feba2a66e67), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "jira-software-icon"
            }));
        case 'jiraServiceDeskTechAlerts':
        case 'jiraServiceDeskProductRecommendationsCloud':
        case 'jiraServiceDeskProductRecommendationsServer':
        case 'jiraServiceDeskProductUpgradesCloud':
        case 'jiraServiceDeskProductUpgradesServer':
        case 'jiraServiceDeskTipsAndTricksCloud':
        case 'jiraServiceDeskTipsAndTricksServer':
        case 'jsmCloudCSComms':
        case 'productRecommendationsJiraServiceDeskCloud':
        case 'productRecommendationsJiraServiceDeskDataCenter':
        case 'productRecommendationsJiraServiceDeskServer':
        case 'productUpgradesJiraServiceDeskCloud':
        case 'productUpgradesJiraServiceDeskDataCenter':
        case 'productUpgradesJiraServiceDeskServer':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $541f1648413af912$export$3c6158790f5e01c4), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "jira-service-management-icon"
            }));
        case 'jiraOps':
        case 'jiraCoreTechAlerts':
        case 'jiraCoreProductRecommendationsCloud':
        case 'jiraCoreProductRecommendationsServer':
        case 'jiraCoreProductUpgradesCloud':
        case 'jiraCoreTipsAndTricksCloud':
        case 'productRecommendationsJiraCoreCloud':
        case 'productRecommendationsJiraCoreDataCenter':
        case 'productRecommendationsJiraCoreServer':
        case 'productUpgradesJiraCoreCloud':
        case 'productUpgradesJiraCoreDataCenter':
        case 'productUpgradesJiraCoreServer':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $13d098ef7b3474f3$export$7330b9fc5718fd30), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "jira-work-management-icon"
            }));
        case 'confluenceCloudCSComms':
        case 'confluenceInsidersNewsletter':
        case 'confluenceTechAlerts':
        case 'confluenceProductRecommendationsCloud':
        case 'confluenceProductRecommendationsServer':
        case 'confluenceProductUpgradesCloud':
        case 'confluenceProductUpgradesServer':
        case 'confluenceTipsAndTricksCloud':
        case 'confluenceTipsAndTricksServer':
        case 'analyticsForConfluenceAppProductRecommendationsServer':
        case 'productRecommendationsConfluenceCloud':
        case 'productRecommendationsConfluenceDataCenter':
        case 'productRecommendationsConfluenceServer':
        case 'productUpgradesConfluenceCloud':
        case 'productUpgradesConfluenceDataCenter':
        case 'productUpgradesConfluenceServer':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $541f1648413af912$export$68f3db7f6af48bcb), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "confluence-icon"
            }));
        case 'bitbucketTechAlerts':
        case 'bitbucketProductRecommendationsCloud':
        case 'bitbucketProductRecommendationsServer':
        case 'bitbucketProductUpgradesCloud':
        case 'bitbucketProductUpgradesServer':
        case 'bitbucketTipsAndTricksCloud':
        case 'bitbucketTipsAndTricksServer':
        case 'productUpgradesBitbucketCloud':
        case 'productUpgradesBitbucketDataCenter':
        case 'productUpgradesBitbucketServer':
        case 'productRecommendationsBitbucketCloud':
        case 'productRecommendationsBitbucketDataCenter':
        case 'productRecommendationsBitbucketServer':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $541f1648413af912$export$5fc1066e677788d4), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "bitbucket-icon"
            }));
        case 'trelloCSComms':
        case 'trelloProductRecommendationsCloud':
        case 'trelloPowerUpsProductRecommendationsCloud':
        case 'trelloProductUpgradesCloud':
        case 'trelloPowerUpsProductUpgradesCloud':
        case 'trelloTipsAndTricksCloud':
        case 'trelloPowerUpsTipsAndTricksCloud':
        case 'productUpgradesTrello':
        case 'productRecommendationsTrello':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $541f1648413af912$export$4384da9b8b140bf4), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "trello-icon"
            }));
        case 'statuspageProductRecommendationsCloud':
        case 'statuspageProductUpgradesCloud':
        case 'statuspageTipsAndTricksCloud':
        case 'productRecommendationsStatuspageCloud':
        case 'productUpgradesStatuspageCloud':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $541f1648413af912$export$f3f5aa321d88adf9), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "statuspage-icon"
            }));
        case 'opsgenieProductRecommendationsCloud':
        case 'opsgenieProductUpgradesCloud':
        case 'opsgenieTipsAndTricksCloud':
        case 'opsgenieOnboarding':
        case 'productRecommendationsOpsgenieCloud':
        case 'productUpgradesOpsgenieCloud':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $541f1648413af912$export$eeccc49dc7a12d9f), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "opsgenie-icon"
            }));
        case 'bambooTechAlerts':
        case 'bambooProductRecommendationsServer':
        case 'bambooProductUpgradesServer':
        case 'bambooTipsAndTricksServer':
        case 'productRecommendationsBambooServer':
        case 'productUpgradesBambooServer':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22f1cdb487390d65$export$e812398311cab9a3), {
                "data-testid": "bamboo-icon"
            });
        case 'cloverTechAlerts':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22f1cdb487390d65$export$fbdddb9a1c3b4e6), {
                "data-testid": "clover-icon"
            });
        case 'crowdTechAlerts':
        case 'crowdProductRecommendationsServer':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22f1cdb487390d65$export$eaf73f391f7103bd), {
                "data-testid": "crowd-icon"
            });
        case 'crucibleTechAlerts':
        case 'crucibleProductRecommendationsServer':
        case 'crucibleProductUpgradesServer':
        case 'crucibleTipsAndTricksServer':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22f1cdb487390d65$export$16670a2a8849f51), {
                "data-testid": "crucible-icon"
            });
        case 'fisheyeTechAlerts':
        case 'fisheyeProductRecommendationsServer':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22f1cdb487390d65$export$70f0855587d72507), {
                "data-testid": "fisheye-icon"
            });
        case 'sourcetreeProductRecommendationsServer':
        case 'sourcetreeProductUpgradesServer':
        case 'sourcetreeTipsAndTricksServer':
        case 'productRecommendationsSourcetree':
        case 'productUpgradesSourcetree':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22f1cdb487390d65$export$733ebb4ad83a1d45), {
                "data-testid": "sourcetree-icon"
            });
        case 'productRecommendationsHalp':
        case 'productUpgradesHalp':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22f1cdb487390d65$export$d1fd6f4b233951a9), {
                "data-testid": "halp-icon"
            });
        case 'jiraAlignProductRecommendationsCloud':
        case 'jiraAlignProductUpgradesCloud':
        case 'jiraAlignTipsAndTricksCloud':
        case 'productRecommendationsJiraAlignCloud':
        case 'productRecommendationsJiraAlignDataCenter':
        case 'productRecommendationsJiraAlignServer':
        case 'productUpgradesJiraAlignCloud':
        case 'productUpgradesJiraAlignDataCenter':
        case 'productUpgradesJiraAlignServer':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $541f1648413af912$export$407687b2dd89cc68), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "jira-align-icon"
            }));
        case 'compassDigest':
        case 'compassNewsletter':
        case 'productRecommendationsCompassCloud':
        case 'productUpgradesCompassCloud':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $541f1648413af912$export$f7857fe64d7161d9), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "compass-icon"
            }));
        case 'gitInsidersNewsletter':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22f1cdb487390d65$export$664fa484b9ce23b6), {
                "data-testid": "git-icon"
            });
        case 'generalMarketingOptIn':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22f1cdb487390d65$export$ddb421af37c7fad5), {
                "data-testid": "marketing-icon"
            });
        case 'productRecommendationsTeamCentralCloud':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22f1cdb487390d65$export$9d0b19639662f94b), {
                "data-testid": "atlas-icon"
            });
        case 'jiraInsidersNewsletter':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22f1cdb487390d65$export$3b3e0936cbb04517), {
                "data-testid": "agile-insiders-newsletter-icon"
            });
        case 'beaconNewsletter':
        case 'productRecommendationsAtlassianAccess':
        case 'productUpgradesAtlassianAccess':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $541f1648413af912$export$3f95fcfdc25a741d), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "atlassian-guard-icon"
            }));
        case 'loomProductEngagements':
        case 'loomReplayNewsletter':
        case 'productRecommendationsLoomCloud':
        case 'productUpgradesLoomCloud':
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $541f1648413af912$export$8d789f76fde3e05), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "loom-icon"
            }));
        default:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd94651bfb983298$export$8a485e2e7ed91e8f), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
                testId: "atlassian-icon"
            }));
    }
};
var $1c3aade99c91fb27$export$2e2bcd8739ae039 = $1c3aade99c91fb27$var$ItemIcon;















parcelRequire("7fPBF");
const $6409f46430b0ad10$var$SvgChecked = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        width: 24,
        height: 24,
        viewBox: "0 0 474.8 474.801",
        style: {
            enableBackground: "new 0 0 474.8 474.801"
        },
        xmlSpace: "preserve"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M396.283 257.097c-1.14-.575-2.282-.862-3.433-.862-2.478 0-4.661.951-6.563 2.857l-18.274 18.271c-1.708 1.715-2.566 3.806-2.566 6.283v72.513c0 12.565-4.463 23.314-13.415 32.264-8.945 8.945-19.701 13.418-32.264 13.418H82.226c-12.564 0-23.319-4.473-32.264-13.418-8.947-8.949-13.418-19.698-13.418-32.264V118.622c0-12.562 4.471-23.316 13.418-32.264 8.945-8.946 19.7-13.418 32.264-13.418H319.77c4.188 0 8.47.571 12.847 1.714 1.143.378 1.999.571 2.563.571 2.478 0 4.668-.949 6.57-2.852l13.99-13.99c2.282-2.281 3.142-5.043 2.566-8.276-.571-3.046-2.286-5.236-5.141-6.567-10.272-4.752-21.412-7.139-33.403-7.139H82.226c-22.65 0-42.018 8.042-58.102 24.126C8.042 76.613 0 95.978 0 118.629v237.543c0 22.647 8.042 42.014 24.125 58.098 16.084 16.088 35.452 24.13 58.102 24.13h237.541c22.647 0 42.017-8.042 58.101-24.13 16.085-16.084 24.134-35.45 24.134-58.098v-90.797c-.002-3.994-1.915-6.752-5.72-8.278z"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "m467.95 93.216-31.409-31.409c-4.568-4.567-9.996-6.851-16.279-6.851-6.275 0-11.707 2.284-16.271 6.851L219.265 246.532l-75.084-75.089c-4.569-4.57-9.995-6.851-16.274-6.851-6.28 0-11.704 2.281-16.274 6.851l-31.405 31.405c-4.568 4.568-6.854 9.994-6.854 16.277 0 6.28 2.286 11.704 6.854 16.274l122.767 122.767c4.569 4.571 9.995 6.851 16.274 6.851 6.279 0 11.704-2.279 16.274-6.851l232.404-232.403c4.565-4.567 6.854-9.994 6.854-16.274s-2.283-11.706-6.851-16.273z"
                })
            ]
        })
    }));
var $6409f46430b0ad10$export$2e2bcd8739ae039 = $6409f46430b0ad10$var$SvgChecked;





parcelRequire("7fPBF");
const $9b78ef673cff192c$var$SvgUnchecked = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        width: 20,
        height: 20,
        viewBox: "0 0 401.998 401.998",
        style: {
            enableBackground: "new 0 0 401.998 401.998"
        },
        xmlSpace: "preserve"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M377.87 24.126C361.786 8.042 342.417 0 319.769 0H82.227C59.579 0 40.211 8.042 24.125 24.126 8.044 40.212.002 59.576.002 82.228v237.543c0 22.647 8.042 42.014 24.123 58.101 16.086 16.085 35.454 24.127 58.102 24.127h237.542c22.648 0 42.011-8.042 58.102-24.127 16.085-16.087 24.126-35.453 24.126-58.101V82.228c-.004-22.648-8.046-42.016-24.127-58.102zm-12.422 295.645c0 12.559-4.47 23.314-13.415 32.264-8.945 8.945-19.698 13.411-32.265 13.411H82.227c-12.563 0-23.317-4.466-32.264-13.411-8.945-8.949-13.418-19.705-13.418-32.264V82.228c0-12.562 4.473-23.316 13.418-32.264 8.947-8.946 19.701-13.418 32.264-13.418h237.542c12.566 0 23.319 4.473 32.265 13.418 8.945 8.947 13.415 19.701 13.415 32.264v237.543h-.001z"
        })
    }));
var $9b78ef673cff192c$export$2e2bcd8739ae039 = $9b78ef673cff192c$var$SvgUnchecked;




const $302c88871644c20a$var$_17 = "@media (min-width:64rem){._1e3cg31l{grid-column:span 2}}";
const $302c88871644c20a$var$_16 = "._irr393m5:hover{background-color:var(--_1svj906)}";
const $302c88871644c20a$var$_15 = "._1bah1yb4{justify-content:space-between}";
const $302c88871644c20a$var$_14 = "._4cvr1h6o{align-items:center}";
const $302c88871644c20a$var$_13 = "._1e0c1txw{display:flex}";
const $302c88871644c20a$var$_12 = "._syaz1prm{color:var(--_540bhb)}";
const $302c88871644c20a$var$_11 = "._80omtlke{cursor:pointer}";
const $302c88871644c20a$var$_10 = "._u5f314lv{padding-right:var(--_cpuyf2)}";
const $302c88871644c20a$var$_9 = "._19bv14lv{padding-left:var(--_cpuyf2)}";
const $302c88871644c20a$var$_8 = "._n3td1ul9{padding-bottom:var(--_18cq338)}";
const $302c88871644c20a$var$_7 = "._ca0q1ul9{padding-top:var(--_18cq338)}";
const $302c88871644c20a$var$_6 = "._bfhk1qb5{background-color:var(--_p1xkbi)}";
const $302c88871644c20a$var$_5 = "._1h6d1nw4{border-color:var(--_lnnecg)}";
const $302c88871644c20a$var$_4 = "._1dqonqa1{border-style:solid}";
const $302c88871644c20a$var$_3 = "._189et94y{border-width:1px}";
const $302c88871644c20a$var$_2 = "._zulp7cul{gap:var(--_1wcbtwk)}";
const $302c88871644c20a$var$_ = "._2rko1l7b{border-radius:3px}";
const $302c88871644c20a$var$cardStyles = null;
const $302c88871644c20a$var$largeCardStyles = null;
const $302c88871644c20a$var$largeCardHeaderStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    paddingBottom: 'space.100',
    cursor: 'pointer',
    color: 'color.text',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'space.150'
});
const $302c88871644c20a$var$largeCardDescriptionStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    margin: '0'
});
const $302c88871644c20a$var$cardTitleStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    flexGrow: 1
});
const $302c88871644c20a$var$cardCheckboxStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    minHeight: '32px',
    minWidth: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start'
});
const $302c88871644c20a$var$ItemCard = ({ type: type, itemKey: itemKey, groupKey: groupKey, tabKey: tabKey })=>{
    const { translate: translate, keyWithTitle: keyWithTitle, keyWithDescription: keyWithDescription } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const state = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$f26c97331adc89d5)(groupKey, itemKey, tabKey));
    const initialState = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$d3a73181b80e0de7)(itemKey));
    const titleTranslated = translate(keyWithTitle(itemKey));
    const descriptionTranslated = translate(keyWithDescription(itemKey));
    const changed = state !== initialState;
    const cardClickHandler = (0, $7fPBF.useCallback)(()=>{
        let targetState = (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false;
        if (state !== (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON) targetState = (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true;
        if (type === (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS && (groupKey !== 'product_recommendations' || targetState === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false)) (0, $0e08eda71bb24540$export$b2d5c41c71279068)(Boolean(targetState), {
            source: itemKey
        });
        dispatch((0, $3d2cac913f314860$export$807cff22f0457821)({
            keys: [
                itemKey
            ],
            state: targetState,
            bypassConsentCheck: false,
            bypassConsentDeclinePrCheck: false,
            skipNotification: false,
            sourceGroup: groupKey,
            sourceItem: itemKey,
            sourceComponent: 'ItemCard'
        }));
    }, [
        dispatch,
        groupKey,
        itemKey,
        state,
        type
    ]);
    let element = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {});
    if (state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON && !changed) element = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab6305b9bfa57046$export$2e2bcd8739ae039), {
        primaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.selected'),
        glyph: (0, $6409f46430b0ad10$export$2e2bcd8739ae039),
        label: 'Checked',
        testId: 'checkedSvgIcon'
    });
    else if (state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON && changed) element = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab6305b9bfa57046$export$2e2bcd8739ae039), {
        primaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.success'),
        glyph: (0, $6409f46430b0ad10$export$2e2bcd8739ae039),
        label: 'Checked',
        testId: 'checked-icon-changed'
    });
    else if ((state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF || state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).PENDING) && !changed) element = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab6305b9bfa57046$export$2e2bcd8739ae039), {
        primaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.selected'),
        glyph: (0, $9b78ef673cff192c$export$2e2bcd8739ae039),
        label: 'Unchecked',
        testId: 'uncheckedSvgIcon'
    });
    else if ((state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF || state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).PENDING) && changed) element = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab6305b9bfa57046$export$2e2bcd8739ae039), {
        primaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.success'),
        glyph: (0, $9b78ef673cff192c$export$2e2bcd8739ae039),
        label: 'Unchecked',
        testId: 'unchecked-icon-changed'
    });
    if (type === (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $302c88871644c20a$var$_,
                    $302c88871644c20a$var$_2,
                    $302c88871644c20a$var$_3,
                    $302c88871644c20a$var$_4,
                    $302c88871644c20a$var$_5,
                    $302c88871644c20a$var$_6,
                    $302c88871644c20a$var$_7,
                    $302c88871644c20a$var$_8,
                    $302c88871644c20a$var$_9,
                    $302c88871644c20a$var$_10,
                    $302c88871644c20a$var$_11,
                    $302c88871644c20a$var$_12,
                    $302c88871644c20a$var$_13,
                    $302c88871644c20a$var$_14,
                    $302c88871644c20a$var$_15,
                    $302c88871644c20a$var$_16
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                onClick: cardClickHandler,
                "data-test-item-key": itemKey,
                "data-test-is-checked": state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                "data-testid": 'dynamicConfigElementWrapper',
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_2rko1l7b _zulp7cul _189et94y _1dqonqa1 _1h6d1nw4 _bfhk1qb5 _ca0q1ul9 _n3td1ul9 _19bv14lv _u5f314lv _80omtlke _syaz1prm _1e0c1txw _4cvr1h6o _1bah1yb4 _irr393m5"
                ]),
                style: {
                    "--_p1xkbi": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('elevation.surface.raised')),
                    "--_18cq338": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.100')),
                    "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200')),
                    "--_lnnecg": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.border')),
                    "--_540bhb": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.text')),
                    "--_1wcbtwk": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.150')),
                    "--_1svj906": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('elevation.surface.raised.hovered'))
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1c3aade99c91fb27$export$2e2bcd8739ae039), {
                        title: itemKey
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $302c88871644c20a$var$cardTitleStyles,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $efe9521807dea491$export$2e2bcd8739ae039), {
                            size: 'small',
                            children: titleTranslated
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $302c88871644c20a$var$cardCheckboxStyles,
                        children: element
                    })
                ]
            })
        ]
    });
    else return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $302c88871644c20a$var$_,
                    $302c88871644c20a$var$_3,
                    $302c88871644c20a$var$_4,
                    $302c88871644c20a$var$_5,
                    $302c88871644c20a$var$_6,
                    $302c88871644c20a$var$_7,
                    $302c88871644c20a$var$_8,
                    $302c88871644c20a$var$_9,
                    $302c88871644c20a$var$_10,
                    $302c88871644c20a$var$_11,
                    $302c88871644c20a$var$_12,
                    $302c88871644c20a$var$_16,
                    $302c88871644c20a$var$_17
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                onClick: cardClickHandler,
                "data-test-item-key": itemKey,
                "data-test-is-checked": state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                "data-testid": 'largeDynamicConfigElementWrapper',
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_2rko1l7b _189et94y _1dqonqa1 _1h6d1nw4 _bfhk1qb5 _ca0q1ul9 _n3td1ul9 _19bv14lv _u5f314lv _80omtlke _syaz1prm _irr393m5 _1e3cg31l"
                ]),
                style: {
                    "--_p1xkbi": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('elevation.surface.raised')),
                    "--_18cq338": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.100')),
                    "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200')),
                    "--_lnnecg": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.border')),
                    "--_540bhb": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.text')),
                    "--_1svj906": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('elevation.surface.raised.hovered'))
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $302c88871644c20a$var$largeCardHeaderStyles,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1c3aade99c91fb27$export$2e2bcd8739ae039), {
                                title: itemKey
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                                xcss: $302c88871644c20a$var$cardTitleStyles,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $efe9521807dea491$export$2e2bcd8739ae039), {
                                    size: 'small',
                                    children: titleTranslated
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                                xcss: $302c88871644c20a$var$cardCheckboxStyles,
                                children: element
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $302c88871644c20a$var$largeCardDescriptionStyles,
                        children: descriptionTranslated
                    })
                ]
            })
        ]
    });
};
var $302c88871644c20a$export$2e2bcd8739ae039 = $302c88871644c20a$var$ItemCard;









const $d2783296604b3204$var$itemCardGridStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.xxs]: {
        gridTemplateColumns: 'repeat(1, 1fr)'
    },
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.sm]: {
        gridTemplateColumns: 'repeat(2, 1fr)'
    },
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.md]: {
        gridTemplateColumns: 'repeat(4, 1fr)'
    }
});
const $d2783296604b3204$var$GroupContent = ({ type: type, groupKey: groupKey, tabKey: tabKey })=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const { translate: translate, keyWithTitle: keyWithTitle, keyWithDescription: keyWithDescription } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const items = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$d2800e0e69cd41a5)(groupKey, tabKey));
    const handleSelectAll = (0, $7fPBF.useCallback)(()=>{
        if (type === (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS && groupKey !== 'product_recommendations') (0, $0e08eda71bb24540$export$19e5a6bca6f03118)(true, {
            groupName: groupKey,
            tabName: tabKey
        });
        dispatch((0, $3d2cac913f314860$export$807cff22f0457821)({
            keys: items,
            state: (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true,
            bypassConsentCheck: false,
            bypassConsentDeclinePrCheck: false,
            skipNotification: false,
            sourceGroup: groupKey,
            sourceTab: tabKey,
            sourceComponent: 'GroupContent'
        }));
    }, [
        dispatch,
        items,
        groupKey,
        type,
        tabKey
    ]);
    const handleSelectNone = (0, $7fPBF.useCallback)(()=>{
        if (type === (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS) (0, $0e08eda71bb24540$export$19e5a6bca6f03118)(false, {
            groupName: groupKey,
            tabName: tabKey
        });
        dispatch((0, $3d2cac913f314860$export$807cff22f0457821)({
            keys: items,
            state: (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false,
            bypassConsentCheck: false,
            bypassConsentDeclinePrCheck: false,
            skipNotification: false,
            sourceGroup: groupKey,
            sourceComponent: 'GroupContent'
        }));
    }, [
        dispatch,
        items,
        type,
        groupKey,
        tabKey
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5fd605fd49ab1b9b$export$2e2bcd8739ae039), {
                text: translate(keyWithDescription(groupKey)),
                onClickAll: handleSelectAll,
                onClickNone: handleSelectNone,
                groupKey: groupKey
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $650de54fef58c216$export$2e2bcd8739ae039), {
                xcss: $d2783296604b3204$var$itemCardGridStyles,
                gap: 'space.200',
                children: [
                    ...items
                ].sort((left, right)=>{
                    return translate(keyWithTitle(left)).localeCompare(translate(keyWithTitle(right)));
                }).map((itemKey)=>{
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302c88871644c20a$export$2e2bcd8739ae039), {
                        type: type,
                        itemKey: itemKey,
                        groupKey: groupKey,
                        tabKey: tabKey
                    }, itemKey);
                })
            })
        ]
    });
};
var $d2783296604b3204$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.memo)($d2783296604b3204$var$GroupContent);






const $02759c0d95d5e37e$var$GroupView = ({ groupKey: groupKey })=>{
    const [selectedTab, setTab] = (0, $7fPBF.useState)();
    const group = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((state)=>(0, $603bd90c46957049$export$cd62b380406677c3)(state, groupKey));
    const visibleGroup = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$c5a1c46e828bfb34));
    const switchTab = (tab, group)=>{
        (0, $0e08eda71bb24540$export$1e7f31c83a73d717)({
            tabName: tab,
            groupName: group
        });
        setTab(tab);
    };
    if (group == null) return null;
    let tabKeys = Object.keys(group.tabs);
    if (visibleGroup.groupKey !== 'all') tabKeys = tabKeys.filter((tabKey)=>tabKey === visibleGroup.tabKey);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        "data-test-group-key": groupKey,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5fd265980f256d2$export$2e2bcd8739ae039), {
                tabKeys: tabKeys,
                onChange: switchTab,
                groupKey: groupKey
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d2783296604b3204$export$2e2bcd8739ae039), {
                type: group.type,
                groupKey: groupKey,
                tabKey: selectedTab !== null && selectedTab !== void 0 ? selectedTab : tabKeys[0]
            })
        ]
    });
};
var $02759c0d95d5e37e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.memo)($02759c0d95d5e37e$var$GroupView);





var $7fPBF = parcelRequire("7fPBF");
const $1cebaa730be84287$export$2b1363e3b7173105 = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 576,
    tablet: 768,
    laptopS: 1024,
    laptopM: 1280,
    laptopL: 1440,
    desktopS: 2560,
    desktopM: 3200,
    desktopL: 3440,
    uhd4k: 3840,
    dci4k: 4096
};




const $765c94124ed861f4$export$de363e709c412c8a = (callback, limit = 1000)=>{
    let lastFunc;
    let lastRan;
    return function() {
        if (!lastRan) {
            callback.apply(this);
            lastRan = Date.now();
        } else {
            if (lastFunc) clearTimeout(lastFunc);
            lastFunc = setTimeout(()=>{
                if (Date.now() - lastRan >= limit) {
                    callback.apply(this);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
};
const $765c94124ed861f4$export$478ddf13a1b06431 = ()=>{
    const [isMobile, setMobile] = (0, $7fPBF.useState)(window.innerWidth <= (0, $1cebaa730be84287$export$2b1363e3b7173105).mobileL);
    (0, $7fPBF.useEffect)(()=>{
        const handleResize = ()=>{
            setMobile(window.innerWidth <= (0, $1cebaa730be84287$export$2b1363e3b7173105).mobileL);
        };
        const throttledHandleResize = $765c94124ed861f4$export$de363e709c412c8a(handleResize);
        window.addEventListener('resize', throttledHandleResize);
        return ()=>window.removeEventListener('resize', throttledHandleResize);
    }, []);
    return isMobile;
};






const $88ea1b053c235b63$var$PreferenceGroup = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const { translate: translate, keyWithTitle: keyWithTitle } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const isPending = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $7a501a2d8adab3c3$export$6a1923cb7c064699));
    const groupKeys = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$48df6acab50c159b));
    const visibleGroup = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$c5a1c46e828bfb34));
    const isAllGroups = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$43d45db6467effac));
    const { status: status } = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$b4f431af37c9cd8b));
    const isMobile = (0, $765c94124ed861f4$export$478ddf13a1b06431)();
    const navigationClickHandler = (0, $7fPBF.useCallback)(()=>{
        (0, $0e08eda71bb24540$export$ac0c4a766e9f767e)();
        dispatch((0, $3d2cac913f314860$export$923ce4fee941073a)());
    }, [
        dispatch
    ]);
    if (isPending || groupKeys.length === 0 || status !== 'ok') return null;
    const tabTitle = visibleGroup.tabKey != null && visibleGroup.tabKey !== 'root' ? `${translate(keyWithTitle(visibleGroup.tabKey))} - ` : '';
    const sections = groupKeys.map((key)=>{
        const groupTitle = `${tabTitle} ${translate(keyWithTitle(key))}`;
        return {
            title: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $efe9521807dea491$export$2e2bcd8739ae039), {
                size: 'large',
                children: groupTitle
            }),
            content: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $02759c0d95d5e37e$export$2e2bcd8739ae039), {
                groupKey: key
            }),
            groupKey: key
        };
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        testId: "preference-group-container",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbdf7a0d01a379ab$export$2e2bcd8739ae039), {
                alwaysOpen: groupKeys.length === 1 || !isMobile,
                showMarker: isMobile && groupKeys.length !== 1,
                sections: sections
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6125038cd8bf4a75$export$2e2bcd8739ae039), {
                isVisible: !isAllGroups,
                onClick: navigationClickHandler
            })
        ]
    });
};
var $88ea1b053c235b63$export$2e2bcd8739ae039 = $88ea1b053c235b63$var$PreferenceGroup;







var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");
function $939dffaddf93a85b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $fa189bd1dd0951d2$exports = {};

$parcel$export($fa189bd1dd0951d2$exports, "FOCUS_GROUP", function () { return $fa189bd1dd0951d2$export$4f9a06cb7441a087; });
$parcel$export($fa189bd1dd0951d2$exports, "FOCUS_DISABLED", function () { return $fa189bd1dd0951d2$export$aeda8252e54b50f7; });
$parcel$export($fa189bd1dd0951d2$exports, "FOCUS_ALLOW", function () { return $fa189bd1dd0951d2$export$54ecf528c58f9ef6; });
$parcel$export($fa189bd1dd0951d2$exports, "FOCUS_AUTO", function () { return $fa189bd1dd0951d2$export$70e9b4a1820af101; });
$parcel$export($fa189bd1dd0951d2$exports, "FOCUS_NO_AUTOFOCUS", function () { return $fa189bd1dd0951d2$export$134ebef29fd94853; });
/**
 * defines a focus group
 */ var $fa189bd1dd0951d2$export$4f9a06cb7441a087 = 'data-focus-lock';
var $fa189bd1dd0951d2$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $fa189bd1dd0951d2$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $fa189bd1dd0951d2$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $fa189bd1dd0951d2$export$134ebef29fd94853 = 'data-no-autofocus';



var $7fPBF = parcelRequire("7fPBF");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $b92e63d00f44a32a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");
function $9852bc1860f56139$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $7fPBF.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $3aa02bc85fadbfb9$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $3aa02bc85fadbfb9$var$currentValues = new WeakMap();
function $3aa02bc85fadbfb9$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $9852bc1860f56139$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $b92e63d00f44a32a$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $3aa02bc85fadbfb9$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $3aa02bc85fadbfb9$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $b92e63d00f44a32a$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $b92e63d00f44a32a$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $3aa02bc85fadbfb9$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



var $7fPBF = parcelRequire("7fPBF");

var $f38eebd6dad36293$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $f38eebd6dad36293$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f38eebd6dad36293$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f38eebd6dad36293$export$b8c7b07253306600
    }));
};
$f38eebd6dad36293$var$InFocusGuard.propTypes = {};
var $f38eebd6dad36293$export$2e2bcd8739ae039 = $f38eebd6dad36293$var$InFocusGuard;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $1e2082910c54650f$var$extendStatics = function(d, b) {
    $1e2082910c54650f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1e2082910c54650f$var$extendStatics(d, b);
};
function $1e2082910c54650f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1e2082910c54650f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1e2082910c54650f$export$18ce0697a983be9b = function() {
    $1e2082910c54650f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e2082910c54650f$export$18ce0697a983be9b.apply(this, arguments);
};
function $1e2082910c54650f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1e2082910c54650f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1e2082910c54650f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1e2082910c54650f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1e2082910c54650f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1e2082910c54650f$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $1e2082910c54650f$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1e2082910c54650f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1e2082910c54650f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1e2082910c54650f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1e2082910c54650f$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1e2082910c54650f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1e2082910c54650f$export$45d3717a4c69092e(o, m, p);
}
function $1e2082910c54650f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1e2082910c54650f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1e2082910c54650f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1e2082910c54650f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1e2082910c54650f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1e2082910c54650f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1e2082910c54650f$export$10c90e4f7922046c(v) {
    return this instanceof $1e2082910c54650f$export$10c90e4f7922046c ? (this.v = v, this) : new $1e2082910c54650f$export$10c90e4f7922046c(v);
}
function $1e2082910c54650f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1e2082910c54650f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1e2082910c54650f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1e2082910c54650f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1e2082910c54650f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1e2082910c54650f$export$19a8beecd37a4c45 === "function" ? $1e2082910c54650f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1e2082910c54650f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1e2082910c54650f$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $1e2082910c54650f$var$ownKeys = function(o) {
    $1e2082910c54650f$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $1e2082910c54650f$var$ownKeys(o);
};
function $1e2082910c54650f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $1e2082910c54650f$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $1e2082910c54650f$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $1e2082910c54650f$var$__setModuleDefault(result, mod);
    return result;
}
function $1e2082910c54650f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1e2082910c54650f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1e2082910c54650f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1e2082910c54650f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $1e2082910c54650f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $1e2082910c54650f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $1e2082910c54650f$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $1e2082910c54650f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $1e2082910c54650f$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $1e2082910c54650f$export$2e2bcd8739ae039 = {
    __extends: $1e2082910c54650f$export$a8ba968b8961cb8a,
    __assign: $1e2082910c54650f$export$18ce0697a983be9b,
    __rest: $1e2082910c54650f$export$3c9a16f847548506,
    __decorate: $1e2082910c54650f$export$29e00dfd3077644b,
    __param: $1e2082910c54650f$export$d5ad3fd78186038f,
    __esDecorate: $1e2082910c54650f$export$3a84e1ae4e97e9b0,
    __runInitializers: $1e2082910c54650f$export$d831c04e792af3d,
    __propKey: $1e2082910c54650f$export$6a2a36740a146cb8,
    __setFunctionName: $1e2082910c54650f$export$d1a06452d3489bc7,
    __metadata: $1e2082910c54650f$export$f1db080c865becb9,
    __awaiter: $1e2082910c54650f$export$1050f835b63b671e,
    __generator: $1e2082910c54650f$export$67ebef60e6f28a6,
    __createBinding: $1e2082910c54650f$export$45d3717a4c69092e,
    __exportStar: $1e2082910c54650f$export$f33643c0debef087,
    __values: $1e2082910c54650f$export$19a8beecd37a4c45,
    __read: $1e2082910c54650f$export$8d051b38c9118094,
    __spread: $1e2082910c54650f$export$afc72e2116322959,
    __spreadArrays: $1e2082910c54650f$export$6388937ca91ccae8,
    __spreadArray: $1e2082910c54650f$export$1216008129fb82ed,
    __await: $1e2082910c54650f$export$10c90e4f7922046c,
    __asyncGenerator: $1e2082910c54650f$export$e427f37a30a4de9b,
    __asyncDelegator: $1e2082910c54650f$export$bbd80228419bb833,
    __asyncValues: $1e2082910c54650f$export$e3b29a3d6162315f,
    __makeTemplateObject: $1e2082910c54650f$export$4fb47efe1390b86f,
    __importStar: $1e2082910c54650f$export$c21735bcef00d192,
    __importDefault: $1e2082910c54650f$export$da59b14a69baef04,
    __classPrivateFieldGet: $1e2082910c54650f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $1e2082910c54650f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $1e2082910c54650f$export$81fdc39f203e4e04,
    __addDisposableResource: $1e2082910c54650f$export$88ac25d8e944e405,
    __disposeResources: $1e2082910c54650f$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $1e2082910c54650f$export$889dfb5d17574b0b
};


function $efceb32ecd78f18d$var$ItoI(a) {
    return a;
}
function $efceb32ecd78f18d$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $efceb32ecd78f18d$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $efceb32ecd78f18d$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $efceb32ecd78f18d$var$ItoI;
    return $efceb32ecd78f18d$var$innerCreateMedium(defaults, middleware);
}
function $efceb32ecd78f18d$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $efceb32ecd78f18d$var$innerCreateMedium(null);
    medium.options = (0, $1e2082910c54650f$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $4b5bcfe03091b424$export$5733e022b1d538cb = (0, $efceb32ecd78f18d$export$9ffbfcaf067b02c6)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $4b5bcfe03091b424$export$b3e9a9312f73723c = (0, $efceb32ecd78f18d$export$9ffbfcaf067b02c6)();
var $4b5bcfe03091b424$export$3a1d52767cbc07b8 = (0, $efceb32ecd78f18d$export$9ffbfcaf067b02c6)();
var $4b5bcfe03091b424$export$892cbf28e5518020 = (0, $efceb32ecd78f18d$export$e13ec7dd7a14088d)({
    async: true,
    ssr: typeof document !== 'undefined'
});



var $7fPBF = parcelRequire("7fPBF");
var $3cd45ad9294a7063$export$f5272e9b1168239c = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);


var $e17e6ac998763caf$var$emptyArray = [];
var $e17e6ac998763caf$var$FocusLock = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = (0, $7fPBF.useState)(), realObserved = _useState[0], setObserved = _useState[1];
    var observed = (0, $7fPBF.useRef)();
    var isActive = (0, $7fPBF.useRef)(false);
    var originalFocusedElement = (0, $7fPBF.useRef)(null);
    var _useState2 = (0, $7fPBF.useState)({}), update = _useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $e17e6ac998763caf$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _useState3 = (0, $7fPBF.useState)({}), id = _useState3[0];
    var onActivation = (0, $7fPBF.useCallback)(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = (0, $7fPBF.useCallback)(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = (0, $7fPBF.useCallback)(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = (0, $7fPBF.useCallback)(function(event) {
        if (isActive.current) (0, $4b5bcfe03091b424$export$5733e022b1d538cb).useMedium(event);
    }, []);
    var onBlur = (0, $4b5bcfe03091b424$export$b3e9a9312f73723c).useMedium;
    var setObserveNode = (0, $7fPBF.useCallback)(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[0, $fa189bd1dd0951d2$export$aeda8252e54b50f7] = disabled && 'disabled', _extends2[0, $fa189bd1dd0951d2$export$4f9a06cb7441a087] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $3aa02bc85fadbfb9$export$74665b213cb5c4cf)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = (0, $7fPBF.useMemo)(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, hasLeadingGuards && [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $f38eebd6dad36293$export$b8c7b07253306600)
        }),
        hasPositiveIndices ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $f38eebd6dad36293$export$b8c7b07253306600)
        }) : null
    ], !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(SideCar, {
        id: id,
        sideCar: (0, $4b5bcfe03091b424$export$892cbf28e5518020),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Container, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3cd45ad9294a7063$export$f5272e9b1168239c).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $f38eebd6dad36293$export$b8c7b07253306600)
    }));
});
$e17e6ac998763caf$var$FocusLock.propTypes = {};
var $e17e6ac998763caf$export$2e2bcd8739ae039 = $e17e6ac998763caf$var$FocusLock;



var $7fPBF = parcelRequire("7fPBF");

function $b106bdebf5664d73$export$2e2bcd8739ae039(t, e) {
    return $b106bdebf5664d73$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b106bdebf5664d73$export$2e2bcd8739ae039(t, e);
}


function $8a816d5676e4c4a3$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $b106bdebf5664d73$export$2e2bcd8739ae039)(t, o);
}


function $fdc11dc7c710e893$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $fdc11dc7c710e893$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fdc11dc7c710e893$export$2e2bcd8739ae039(o);
}



function $2e1e524cd9f35d24$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fdc11dc7c710e893$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fdc11dc7c710e893$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $888901748170578d$export$2e2bcd8739ae039(t) {
    var i = (0, $2e1e524cd9f35d24$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $fdc11dc7c710e893$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $0244b1b9113fb618$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $888901748170578d$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $7fPBF = parcelRequire("7fPBF");
function $a2ab6f3d408e39f4$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $8a816d5676e4c4a3$export$2e2bcd8739ae039)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $7fPBF.PureComponent));
        (0, $0244b1b9113fb618$export$2e2bcd8739ae039)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $a2ab6f3d408e39f4$export$2e2bcd8739ae039 = $a2ab6f3d408e39f4$var$withSideEffect;


/*
IE11 support
 */ var $64c6313292c996c0$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $64c6313292c996c0$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $64c6313292c996c0$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};



var $547637f472749193$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $547637f472749193$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $547637f472749193$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $547637f472749193$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $547637f472749193$var$isVisibleUncached = function(node, checkParent) {
    return !node || $547637f472749193$var$isTopNode(node) || !$547637f472749193$var$isElementHidden(node) && !$547637f472749193$var$isInert(node) && checkParent($547637f472749193$var$getParentNode(node));
};
var $547637f472749193$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $547637f472749193$var$isVisibleUncached(node, $547637f472749193$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $547637f472749193$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$547637f472749193$var$isTopNode(node) ? $547637f472749193$export$b8550e27de209d85(node) ? checkParent($547637f472749193$var$getParentNode(node)) : false : true;
};
var $547637f472749193$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $547637f472749193$var$isAutoFocusAllowedUncached(node, $547637f472749193$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $547637f472749193$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $547637f472749193$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $547637f472749193$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $547637f472749193$export$9d74f6fbc6f469d0 = function(node) {
    return $547637f472749193$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $547637f472749193$export$8197b0ea56b3b055 = function(node) {
    return !(($547637f472749193$export$88a6ceeed5737ba3(node) || $547637f472749193$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $547637f472749193$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $fa189bd1dd0951d2$export$134ebef29fd94853));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $547637f472749193$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $547637f472749193$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $547637f472749193$export$602e5a0d338d7750 = function(node) {
    return !$547637f472749193$export$d94b8b58ec2f30eb(node);
};
var $547637f472749193$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};



var $abeb253dfaf92653$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $abeb253dfaf92653$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $abeb253dfaf92653$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $64c6313292c996c0$export$45b10814cc054894)(nodes).map(function(node, index) {
        var tabIndex = $abeb253dfaf92653$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($abeb253dfaf92653$export$350ee6c095d98996);
};




/**
 * list of the object to be considered as focusable
 */ var $af200ddb1312cc2b$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];


var $25f7971b265ebd60$var$queryTabbables = (0, $af200ddb1312cc2b$export$8555f4622e95784).join(',');
var $25f7971b265ebd60$var$queryGuardTabbables = "".concat($25f7971b265ebd60$var$queryTabbables, ", [data-focus-guard]");
var $25f7971b265ebd60$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $64c6313292c996c0$export$45b10814cc054894)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $25f7971b265ebd60$var$queryGuardTabbables : $25f7971b265ebd60$var$queryTabbables) ? [
            child
        ] : [], $25f7971b265ebd60$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $25f7971b265ebd60$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $25f7971b265ebd60$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $25f7971b265ebd60$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $25f7971b265ebd60$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $25f7971b265ebd60$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $64c6313292c996c0$export$45b10814cc054894)(parent.parentNode.querySelectorAll($25f7971b265ebd60$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $25f7971b265ebd60$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $fa189bd1dd0951d2$export$70e9b4a1820af101), "]"));
    return (0, $64c6313292c996c0$export$45b10814cc054894)(parentFocus).map(function(node) {
        return $25f7971b265ebd60$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};


var $47993c2562b99895$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $64c6313292c996c0$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $547637f472749193$export$3c9dc299685ad160)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $547637f472749193$export$8197b0ea56b3b055)(node);
    });
};
var $47993c2562b99895$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $64c6313292c996c0$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $547637f472749193$export$bcaa50628f6a736e)(cache, node);
    });
};
var $47993c2562b99895$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $abeb253dfaf92653$export$cb40ee071f0d5226)($47993c2562b99895$export$6266a5cd5915dc33((0, $25f7971b265ebd60$export$f6768025e418420e)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $47993c2562b99895$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $abeb253dfaf92653$export$cb40ee071f0d5226)($47993c2562b99895$export$6266a5cd5915dc33((0, $25f7971b265ebd60$export$f6768025e418420e)(topNodes), visibilityCache), false);
};
var $47993c2562b99895$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $47993c2562b99895$export$6266a5cd5915dc33((0, $25f7971b265ebd60$export$853fa94d922e78b9)(topNode), visibilityCache);
};
var $47993c2562b99895$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $47993c2562b99895$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $64c6313292c996c0$export$45b10814cc054894)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $47993c2562b99895$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $47993c2562b99895$export$2344b14b097df817(child, element);
        });
    }
};


function $576094e59912fd4a$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $576094e59912fd4a$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $576094e59912fd4a$var$weakRef(currentElement),
            parent: $576094e59912fd4a$var$weakRef(currentElement.parentElement),
            left: $576094e59912fd4a$var$weakRef(currentElement.previousElementSibling),
            right: $576094e59912fd4a$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $576094e59912fd4a$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $576094e59912fd4a$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $47993c2562b99895$export$3738e313571e2ad2)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $576094e59912fd4a$export$d357db6e554ff59a = function(targetElement) {
    var location = $576094e59912fd4a$export$5061a7725be48ff9(targetElement);
    return function() {
        return $576094e59912fd4a$var$restoreFocusTo(location);
    };
};



/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $a60e58db6a2c2b86$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $a60e58db6a2c2b86$var$getTopParent = function(node) {
    return node.parentNode ? $a60e58db6a2c2b86$var$getTopParent(node.parentNode) : node;
};
var $a60e58db6a2c2b86$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $64c6313292c996c0$export$75093a47a9fa838d)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $fa189bd1dd0951d2$export$4f9a06cb7441a087));
        acc.push.apply(acc, group ? $a60e58db6a2c2b86$var$filterNested((0, $64c6313292c996c0$export$45b10814cc054894)($a60e58db6a2c2b86$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $fa189bd1dd0951d2$export$4f9a06cb7441a087), "=\"").concat(group, "\"]:not([").concat((0, $fa189bd1dd0951d2$export$aeda8252e54b50f7), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};





var $588912932a813bc4$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $588912932a813bc4$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $588912932a813bc4$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $588912932a813bc4$var$getParents(nodeA);
    var parentsB = $588912932a813bc4$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $588912932a813bc4$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $64c6313292c996c0$export$75093a47a9fa838d)(baseActiveElement);
    var leftEntries = (0, $64c6313292c996c0$export$75093a47a9fa838d)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $588912932a813bc4$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $588912932a813bc4$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $47993c2562b99895$export$2344b14b097df817)(common, topCommon)) topCommon = common;
                else topCommon = $588912932a813bc4$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $588912932a813bc4$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $47993c2562b99895$export$dc26309a71d1ce47)(node, visibilityCache));
    }, []);
};




var $253f6a637ee87d7a$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $a60e58db6a2c2b86$export$7e87c4720b9b279b)(topNode).filter((0, $547637f472749193$export$602e5a0d338d7750));
    var commonParent = (0, $588912932a813bc4$export$a9a7252b5f2e280e)(topNode, topNode, entries);
    var outerNodes = (0, $abeb253dfaf92653$export$cb40ee071f0d5226)((0, $25f7971b265ebd60$export$f6768025e418420e)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $25f7971b265ebd60$export$f6768025e418420e)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $547637f472749193$export$d94b8b58ec2f30eb)(node)
        };
    });
};

var $eb3698ab71ab4cb2$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};




var $64ebddb8bb3b2b77$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $64c6313292c996c0$export$75093a47a9fa838d)(scope);
    if (shards.every(function(shard) {
        return !(0, $47993c2562b99895$export$2344b14b097df817)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $47993c2562b99895$export$3738e313571e2ad2)(shards, new Map()) : (0, $47993c2562b99895$export$493d05a3a8e6532d)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $64ebddb8bb3b2b77$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $47993c2562b99895$export$3738e313571e2ad2)((0, $64c6313292c996c0$export$75093a47a9fa838d)(shards), new Map()) : (0, $47993c2562b99895$export$493d05a3a8e6532d)((0, $64c6313292c996c0$export$75093a47a9fa838d)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $64ebddb8bb3b2b77$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $64ebddb8bb3b2b77$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $64ebddb8bb3b2b77$var$defaultOptions(options);
    var solution = $64ebddb8bb3b2b77$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $eb3698ab71ab4cb2$export$c12b3da842c43a8)(target.node, newOptions.focusOptions);
};
var $64ebddb8bb3b2b77$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $64ebddb8bb3b2b77$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $64ebddb8bb3b2b77$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $64ebddb8bb3b2b77$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $64ebddb8bb3b2b77$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $64ebddb8bb3b2b77$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $eb3698ab71ab4cb2$export$c12b3da842c43a8)(node.node, options.focusOptions);
};
var $64ebddb8bb3b2b77$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $64ebddb8bb3b2b77$var$pickBoundary(scope, options, 'first');
};
var $64ebddb8bb3b2b77$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $64ebddb8bb3b2b77$var$pickBoundary(scope, options, 'last');
};




/**
 * returns active element from document or from nested shadowdoms
 */ var $119b6a97cad53c72$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};


var $959530f54ab600d9$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $959530f54ab600d9$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $119b6a97cad53c72$export$78d20aae35adef88)(function() {
        return activeElement.contentWindow.document;
    }) ? $959530f54ab600d9$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};


var $d07a703fa09abac5$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $d07a703fa09abac5$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $64c6313292c996c0$export$45b10814cc054894)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $d07a703fa09abac5$var$focusInFrame(node, activeElement);
    }));
};
var $d07a703fa09abac5$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $959530f54ab600d9$export$cd4e5573fbe2b576)((0, $64c6313292c996c0$export$bcd7afcd904dce14)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $a60e58db6a2c2b86$export$7e87c4720b9b279b)(topNode).some(function(node) {
        return (0, $47993c2562b99895$export$2344b14b097df817)(node, activeElement) || $d07a703fa09abac5$var$focusInsideIframe(node, activeElement);
    });
};





var $a97e568617aa70ca$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $959530f54ab600d9$export$cd4e5573fbe2b576)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $64c6313292c996c0$export$45b10814cc054894)(inDocument.querySelectorAll("[".concat((0, $fa189bd1dd0951d2$export$54ecf528c58f9ef6), "]"))).some(function(node) {
        return (0, $47993c2562b99895$export$2344b14b097df817)(node, activeElement);
    });
};








var $bd831ddde50e963f$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $547637f472749193$export$9d74f6fbc6f469d0)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $bd831ddde50e963f$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $547637f472749193$export$9d74f6fbc6f469d0)(node) && node.name) return $bd831ddde50e963f$var$findSelectedRadio(node, nodes);
    return node;
};
var $bd831ddde50e963f$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($bd831ddde50e963f$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};



var $8b19cf57210745e9$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $bd831ddde50e963f$export$5261662167ad7ced)(nodes[0], nodes);
    return nodes[0];
};
var $8b19cf57210745e9$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $bd831ddde50e963f$export$5261662167ad7ced)(node, nodes));
};



var $3ebc112684578f24$export$85710b12cf912438 = 'NEW_FOCUS';
var $3ebc112684578f24$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $547637f472749193$export$d94b8b58ec2f30eb)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $3ebc112684578f24$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $3ebc112684578f24$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $bd831ddde50e963f$export$4a5a72a7124e45f9)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $8b19cf57210745e9$export$e06728ee87c96122)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $8b19cf57210745e9$export$e06728ee87c96122)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};








var $0b3e04baa5c9ad06$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $547637f472749193$export$698b339b0c8edae3)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $0b3e04baa5c9ad06$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $47993c2562b99895$export$2f70373d403a5d2b)(nodes.filter($0b3e04baa5c9ad06$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $8b19cf57210745e9$export$f4e86cfa0679b9cc)(autoFocusable);
    return (0, $8b19cf57210745e9$export$f4e86cfa0679b9cc)((0, $47993c2562b99895$export$2f70373d403a5d2b)(orderedNodes));
};





var $c48dba24faa76008$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $547637f472749193$export$4e62c701997796c1));
};
var $c48dba24faa76008$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $959530f54ab600d9$export$cd4e5573fbe2b576)((0, $64c6313292c996c0$export$75093a47a9fa838d)(topNode).length > 0 ? document : (0, $64c6313292c996c0$export$bcd7afcd904dce14)(topNode).ownerDocument);
    var entries = (0, $a60e58db6a2c2b86$export$7e87c4720b9b279b)(topNode).filter((0, $547637f472749193$export$602e5a0d338d7750));
    var commonParent = (0, $588912932a813bc4$export$a9a7252b5f2e280e)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $47993c2562b99895$export$493d05a3a8e6532d)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $547637f472749193$export$602e5a0d338d7750)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $47993c2562b99895$export$493d05a3a8e6532d)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $c48dba24faa76008$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $3ebc112684578f24$export$65842178e9bb4205)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $3ebc112684578f24$export$85710b12cf912438)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $0b3e04baa5c9ad06$export$cfb742983e257555)(anyFocusable, innerTabbable, (0, $588912932a813bc4$export$8f99714c70a37db1)(entries, visibilityCache)) || (0, $0b3e04baa5c9ad06$export$cfb742983e257555)(anyFocusable, innerFocusables, (0, $588912932a813bc4$export$8f99714c70a37db1)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};


var $d1bc10d32209a709$var$guardCount = 0;
var $d1bc10d32209a709$var$lockDisabled = false;
var $d1bc10d32209a709$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $c48dba24faa76008$export$305758c744b57f6f)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($d1bc10d32209a709$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($d1bc10d32209a709$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $d1bc10d32209a709$var$lockDisabled = true;
            setTimeout(function() {
                $d1bc10d32209a709$var$lockDisabled = false;
            }, 1);
            return;
        }
        $d1bc10d32209a709$var$guardCount++;
        (0, $eb3698ab71ab4cb2$export$c12b3da842c43a8)(focusable.node, options.focusOptions);
        $d1bc10d32209a709$var$guardCount--;
    }
};





/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $60b760cce460b4f8$export$1a988e7317c65621 = $fa189bd1dd0951d2$exports;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $60b760cce460b4f8$var$deprecated_default_moveFocusInside = (0, $d1bc10d32209a709$export$cd599851e879a025);
var $60b760cce460b4f8$export$2e2bcd8739ae039 //
 = $60b760cce460b4f8$var$deprecated_default_moveFocusInside;


function $2d6186134c60e3e5$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $2d6186134c60e3e5$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $2d6186134c60e3e5$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};



var $aaf28cf1dce384e3$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $aaf28cf1dce384e3$var$isFreeFocus = function isFreeFocus() {
    return $aaf28cf1dce384e3$var$focusOnBody() || (0, $a97e568617aa70ca$export$be6b21806d3fd485)();
};
var $aaf28cf1dce384e3$var$lastActiveTrap = null;
var $aaf28cf1dce384e3$var$lastActiveFocus = null;
var $aaf28cf1dce384e3$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $aaf28cf1dce384e3$var$lastPortaledElement = null;
var $aaf28cf1dce384e3$var$focusWasOutsideWindow = false;
var $aaf28cf1dce384e3$var$windowFocused = false;
var $aaf28cf1dce384e3$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $aaf28cf1dce384e3$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($aaf28cf1dce384e3$var$lastActiveTrap.whiteList || $aaf28cf1dce384e3$var$defaultWhitelist)(activeElement);
};
var $aaf28cf1dce384e3$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $aaf28cf1dce384e3$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $aaf28cf1dce384e3$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $aaf28cf1dce384e3$var$lastPortaledElement && $aaf28cf1dce384e3$var$lastPortaledElement.portaledElement === element;
};
function $aaf28cf1dce384e3$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $aaf28cf1dce384e3$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($aaf28cf1dce384e3$var$focusWasOutsideWindow);
    return $aaf28cf1dce384e3$var$focusWasOutsideWindow === 'meanwhile';
};
var $aaf28cf1dce384e3$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $aaf28cf1dce384e3$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $aaf28cf1dce384e3$var$checkInHost(activeElement, area, area);
    });
};
var $aaf28cf1dce384e3$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $47993c2562b99895$export$493d05a3a8e6532d)(nodes, new Map());
};
var $aaf28cf1dce384e3$var$isNotFocusable = function isNotFocusable(node) {
    return !$aaf28cf1dce384e3$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $aaf28cf1dce384e3$var$activateTrap = function activateTrap() {
    var result = false;
    if ($aaf28cf1dce384e3$var$lastActiveTrap) {
        var _lastActiveTrap = $aaf28cf1dce384e3$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $aaf28cf1dce384e3$var$lastPortaledElement && $aaf28cf1dce384e3$var$lastPortaledElement.portaledElement;
        if ($aaf28cf1dce384e3$var$focusOnBody() && $aaf28cf1dce384e3$var$lastActiveFocus && $aaf28cf1dce384e3$var$lastActiveFocus !== document.body) {
            if (!document.body.contains($aaf28cf1dce384e3$var$lastActiveFocus) || $aaf28cf1dce384e3$var$isNotFocusable($aaf28cf1dce384e3$var$lastActiveFocus)) {
                var newTarget = $aaf28cf1dce384e3$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $2d6186134c60e3e5$export$c613fed06e332533)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$aaf28cf1dce384e3$var$focusWasOutside(crossFrame) || !noFocusGuards || !$aaf28cf1dce384e3$var$lastActiveFocus || $aaf28cf1dce384e3$var$windowFocused) return false;
                var nodes = $aaf28cf1dce384e3$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $aaf28cf1dce384e3$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $aaf28cf1dce384e3$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$aaf28cf1dce384e3$var$isFreeFocus() || !$aaf28cf1dce384e3$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $d07a703fa09abac5$export$20115f8da7baa6fa)(workingArea) || activeElement && $aaf28cf1dce384e3$var$withinHost(activeElement, workingArea) || $aaf28cf1dce384e3$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$aaf28cf1dce384e3$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $d1bc10d32209a709$export$cd599851e879a025)(workingArea, $aaf28cf1dce384e3$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $aaf28cf1dce384e3$var$lastPortaledElement = {};
                        }
                    }
                    $aaf28cf1dce384e3$var$lastActiveFocus = document && document.activeElement;
                    if ($aaf28cf1dce384e3$var$lastActiveFocus !== document.body) $aaf28cf1dce384e3$var$tryRestoreFocus = (0, $576094e59912fd4a$export$d357db6e554ff59a)($aaf28cf1dce384e3$var$lastActiveFocus);
                    $aaf28cf1dce384e3$var$focusWasOutsideWindow = false;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $253f6a637ee87d7a$export$f89ac71e91767111)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $aaf28cf1dce384e3$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $aaf28cf1dce384e3$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $aaf28cf1dce384e3$var$onTrap = function onTrap(event) {
    if ($aaf28cf1dce384e3$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $aaf28cf1dce384e3$var$onBlur = function onBlur() {
    return (0, $2d6186134c60e3e5$export$6523025722806278)($aaf28cf1dce384e3$var$activateTrap);
};
var $aaf28cf1dce384e3$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $aaf28cf1dce384e3$var$recordPortal(currentNode, source);
};
var $aaf28cf1dce384e3$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $aaf28cf1dce384e3$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        onBlur: $aaf28cf1dce384e3$var$onBlur,
        onFocus: $aaf28cf1dce384e3$var$onFocus
    }, children);
};
$aaf28cf1dce384e3$var$FocusTrap.propTypes = {};
var $aaf28cf1dce384e3$var$onWindowFocus = function onWindowFocus() {
    $aaf28cf1dce384e3$var$windowFocused = true;
};
var $aaf28cf1dce384e3$var$onWindowBlur = function onWindowBlur() {
    $aaf28cf1dce384e3$var$windowFocused = false;
    $aaf28cf1dce384e3$var$focusWasOutsideWindow = 'just';
    (0, $2d6186134c60e3e5$export$6523025722806278)(function() {
        $aaf28cf1dce384e3$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $aaf28cf1dce384e3$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $aaf28cf1dce384e3$var$onTrap);
    document.addEventListener('focusout', $aaf28cf1dce384e3$var$onBlur);
    window.addEventListener('focus', $aaf28cf1dce384e3$var$onWindowFocus);
    window.addEventListener('blur', $aaf28cf1dce384e3$var$onWindowBlur);
};
var $aaf28cf1dce384e3$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $aaf28cf1dce384e3$var$onTrap);
    document.removeEventListener('focusout', $aaf28cf1dce384e3$var$onBlur);
    window.removeEventListener('focus', $aaf28cf1dce384e3$var$onWindowFocus);
    window.removeEventListener('blur', $aaf28cf1dce384e3$var$onWindowBlur);
};
function $aaf28cf1dce384e3$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $aaf28cf1dce384e3$var$focusLockAPI = {
    moveFocusInside: (0, $d1bc10d32209a709$export$cd599851e879a025),
    focusInside: (0, $d07a703fa09abac5$export$20115f8da7baa6fa),
    focusNextElement: (0, $64ebddb8bb3b2b77$export$3b0237e8566c8d65),
    focusPrevElement: (0, $64ebddb8bb3b2b77$export$33b47db07a82b2fb),
    focusFirstElement: (0, $64ebddb8bb3b2b77$export$2a791d8097a66406),
    focusLastElement: (0, $64ebddb8bb3b2b77$export$6a79073ddabfd6c3),
    captureFocusRestore: (0, $576094e59912fd4a$export$d357db6e554ff59a)
};
function $aaf28cf1dce384e3$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$aaf28cf1dce384e3$var$lastActiveTrap) $aaf28cf1dce384e3$var$attachHandler();
    var lastTrap = $aaf28cf1dce384e3$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $aaf28cf1dce384e3$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $aaf28cf1dce384e3$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($aaf28cf1dce384e3$var$focusLockAPI);
        $aaf28cf1dce384e3$var$activateTrap(true);
        (0, $2d6186134c60e3e5$export$6523025722806278)($aaf28cf1dce384e3$var$activateTrap);
    } else {
        $aaf28cf1dce384e3$var$detachHandler();
        $aaf28cf1dce384e3$var$lastActiveFocus = null;
    }
}
(0, $4b5bcfe03091b424$export$5733e022b1d538cb).assignSyncMedium($aaf28cf1dce384e3$var$onFocus);
(0, $4b5bcfe03091b424$export$b3e9a9312f73723c).assignMedium($aaf28cf1dce384e3$var$onBlur);
(0, $4b5bcfe03091b424$export$3a1d52767cbc07b8).assignMedium(function(cb) {
    return cb($aaf28cf1dce384e3$var$focusLockAPI);
});
var $aaf28cf1dce384e3$export$2e2bcd8739ae039 = (0, $a2ab6f3d408e39f4$export$2e2bcd8739ae039)($aaf28cf1dce384e3$var$reducePropsToState, $aaf28cf1dce384e3$var$handleStateChangeOnClient)($aaf28cf1dce384e3$var$FocusWatcher);


var $b301888438efb0fe$var$FocusLockCombination = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e17e6ac998763caf$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        sideCar: (0, $aaf28cf1dce384e3$export$2e2bcd8739ae039),
        ref: ref
    }, props));
});
var $b301888438efb0fe$var$_ref = (0, $e17e6ac998763caf$export$2e2bcd8739ae039).propTypes || {}, $b301888438efb0fe$var$sideCar = $b301888438efb0fe$var$_ref.sideCar, $b301888438efb0fe$var$propTypes = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)($b301888438efb0fe$var$_ref, [
    "sideCar"
]);
$b301888438efb0fe$var$FocusLockCombination.propTypes = {};
var $b301888438efb0fe$export$2e2bcd8739ae039 = $b301888438efb0fe$var$FocusLockCombination;



var $2cb7353992a884b7$export$2e2bcd8739ae039 = (0, $b301888438efb0fe$export$2e2bcd8739ae039);


var $eefcbb4433f6e9f3$exports = {};
'use strict';
Object.defineProperty($eefcbb4433f6e9f3$exports, "__esModule", {
    value: true
});
var $6708ffe7bd9e8461$exports = {};
'use strict';
Object.defineProperty($6708ffe7bd9e8461$exports, "__esModule", {
    value: true
});
var $6708ffe7bd9e8461$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7fPBF = parcelRequire("7fPBF");
var $6708ffe7bd9e8461$var$_react2 = $6708ffe7bd9e8461$var$_interopRequireDefault($7fPBF);
var $913ab7e52a911d58$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if ($913ab7e52a911d58$exports) $913ab7e52a911d58$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $d70035f4e2813f1f$exports = {};
'use strict';
Object.defineProperty($d70035f4e2813f1f$exports, "__esModule", {
    value: true
});
$d70035f4e2813f1f$exports.TouchScrollable = undefined;
var $d70035f4e2813f1f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d70035f4e2813f1f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7fPBF = parcelRequire("7fPBF");

var $ff3334bd4206e4db$exports = {};
'use strict';
Object.defineProperty($ff3334bd4206e4db$exports, "__esModule", {
    value: true
});
$ff3334bd4206e4db$exports.pipe = $ff3334bd4206e4db$exports.listenerOptions = undefined;
$ff3334bd4206e4db$exports.preventTouchMove = $ff3334bd4206e4db$var$preventTouchMove;
$ff3334bd4206e4db$exports.allowTouchMove = $ff3334bd4206e4db$var$allowTouchMove;
$ff3334bd4206e4db$exports.preventInertiaScroll = $ff3334bd4206e4db$var$preventInertiaScroll;
$ff3334bd4206e4db$exports.isTouchDevice = $ff3334bd4206e4db$var$isTouchDevice;
$ff3334bd4206e4db$exports.camelToKebab = $ff3334bd4206e4db$var$camelToKebab;
$ff3334bd4206e4db$exports.parse = $ff3334bd4206e4db$var$parse;
$ff3334bd4206e4db$exports.getPadding = $ff3334bd4206e4db$var$getPadding;
$ff3334bd4206e4db$exports.getWindowHeight = $ff3334bd4206e4db$var$getWindowHeight;
$ff3334bd4206e4db$exports.getDocumentHeight = $ff3334bd4206e4db$var$getDocumentHeight;
$ff3334bd4206e4db$exports.makeStyleTag = $ff3334bd4206e4db$var$makeStyleTag;
$ff3334bd4206e4db$exports.injectStyles = $ff3334bd4206e4db$var$injectStyles;
$ff3334bd4206e4db$exports.insertStyleTag = $ff3334bd4206e4db$var$insertStyleTag;

var $ff3334bd4206e4db$var$listenerOptions = $ff3334bd4206e4db$exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $ff3334bd4206e4db$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $ff3334bd4206e4db$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $ff3334bd4206e4db$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $ff3334bd4206e4db$var$isTouchDevice() {
    if (!$913ab7e52a911d58$exports.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $ff3334bd4206e4db$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $ff3334bd4206e4db$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $ff3334bd4206e4db$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $ff3334bd4206e4db$var$pipe = $ff3334bd4206e4db$exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($ff3334bd4206e4db$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $ff3334bd4206e4db$var$getPadding() {
    if (!$913ab7e52a911d58$exports.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $ff3334bd4206e4db$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($913ab7e52a911d58$exports.canUseDOM) return window.innerHeight * multiplier;
}
function $ff3334bd4206e4db$var$getDocumentHeight() {
    if ($913ab7e52a911d58$exports.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $ff3334bd4206e4db$var$makeStyleTag() {
    if (!$913ab7e52a911d58$exports.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $ff3334bd4206e4db$var$injectStyles(tag, css) {
    if (!$913ab7e52a911d58$exports.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $ff3334bd4206e4db$var$insertStyleTag(tag) {
    if (!$913ab7e52a911d58$exports.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}


function $d70035f4e2813f1f$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $d70035f4e2813f1f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d70035f4e2813f1f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d70035f4e2813f1f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d70035f4e2813f1f$var$TouchScrollable = $d70035f4e2813f1f$exports.TouchScrollable = function(_PureComponent) {
    $d70035f4e2813f1f$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $d70035f4e2813f1f$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $d70035f4e2813f1f$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $d70035f4e2813f1f$var$_possibleConstructorReturn(_this, _ret);
    }
    $d70035f4e2813f1f$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$913ab7e52a911d58$exports.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $ff3334bd4206e4db$exports.preventInertiaScroll, $ff3334bd4206e4db$exports.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $ff3334bd4206e4db$exports.allowTouchMove, $ff3334bd4206e4db$exports.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$913ab7e52a911d58$exports.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $ff3334bd4206e4db$exports.preventInertiaScroll, $ff3334bd4206e4db$exports.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $ff3334bd4206e4db$exports.allowTouchMove, $ff3334bd4206e4db$exports.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $d70035f4e2813f1f$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $7fPBF.cloneElement)(children, $d70035f4e2813f1f$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($7fPBF.PureComponent);


var $a052f3204f708fdc$exports = {};
'use strict';
Object.defineProperty($a052f3204f708fdc$exports, "__esModule", {
    value: true
});
var $a052f3204f708fdc$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$a052f3204f708fdc$exports.default = $a052f3204f708fdc$var$withLockSheet;

var $7fPBF = parcelRequire("7fPBF");
var $a052f3204f708fdc$var$_react2 = $a052f3204f708fdc$var$_interopRequireDefault($7fPBF);

function $a052f3204f708fdc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a052f3204f708fdc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a052f3204f708fdc$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a052f3204f708fdc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $a052f3204f708fdc$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $a052f3204f708fdc$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $a052f3204f708fdc$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $a052f3204f708fdc$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $ff3334bd4206e4db$exports.makeStyleTag)();
                if (!sheet) return;
                (0, $ff3334bd4206e4db$exports.injectStyles)(sheet, styles);
                (0, $ff3334bd4206e4db$exports.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $ff3334bd4206e4db$exports.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $ff3334bd4206e4db$exports.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $a052f3204f708fdc$var$_possibleConstructorReturn(_this, _ret);
        }
        $a052f3204f708fdc$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $a052f3204f708fdc$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($7fPBF.PureComponent);
}


var $6708ffe7bd9e8461$var$_withLockSheet2 = $6708ffe7bd9e8461$var$_interopRequireDefault($a052f3204f708fdc$exports);
var $ae9ffb51564bedce$exports = {};
'use strict';
Object.defineProperty($ae9ffb51564bedce$exports, "__esModule", {
    value: true
});
var $ae9ffb51564bedce$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$ae9ffb51564bedce$exports.default = $ae9ffb51564bedce$var$withTouchListeners;

var $7fPBF = parcelRequire("7fPBF");
var $ae9ffb51564bedce$var$_react2 = $ae9ffb51564bedce$var$_interopRequireDefault($7fPBF);


function $ae9ffb51564bedce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ae9ffb51564bedce$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ae9ffb51564bedce$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ae9ffb51564bedce$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $ae9ffb51564bedce$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $ae9ffb51564bedce$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $ae9ffb51564bedce$var$_classCallCheck(this, TouchProvider);
            return $ae9ffb51564bedce$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $ae9ffb51564bedce$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$913ab7e52a911d58$exports.canUseDOM || !(0, $ff3334bd4206e4db$exports.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $ff3334bd4206e4db$exports.preventTouchMove, $ff3334bd4206e4db$exports.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$913ab7e52a911d58$exports.canUseDOM || !(0, $ff3334bd4206e4db$exports.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $ff3334bd4206e4db$exports.preventTouchMove, $ff3334bd4206e4db$exports.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $ae9ffb51564bedce$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($7fPBF.PureComponent);
}


var $6708ffe7bd9e8461$var$_withTouchListeners2 = $6708ffe7bd9e8461$var$_interopRequireDefault($ae9ffb51564bedce$exports);

function $6708ffe7bd9e8461$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6708ffe7bd9e8461$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6708ffe7bd9e8461$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $6708ffe7bd9e8461$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $6708ffe7bd9e8461$var$ScrollLock = function(_PureComponent) {
    $6708ffe7bd9e8461$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $6708ffe7bd9e8461$var$_classCallCheck(this, ScrollLock);
        return $6708ffe7bd9e8461$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $6708ffe7bd9e8461$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$913ab7e52a911d58$exports.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $6708ffe7bd9e8461$var$_react2.default.createElement($d70035f4e2813f1f$exports.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($7fPBF.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $6708ffe7bd9e8461$var$compose = (0, $ff3334bd4206e4db$exports.pipe)($6708ffe7bd9e8461$var$_withTouchListeners2.default, $6708ffe7bd9e8461$var$_withLockSheet2.default);
var $6708ffe7bd9e8461$var$SheetLock = $6708ffe7bd9e8461$var$compose($6708ffe7bd9e8461$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $6708ffe7bd9e8461$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $6708ffe7bd9e8461$var$_react2.default.createElement($6708ffe7bd9e8461$var$SheetLock, props) : props.children;
};
$6708ffe7bd9e8461$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
$6708ffe7bd9e8461$exports.default = $6708ffe7bd9e8461$var$LockToggle;


Object.defineProperty($eefcbb4433f6e9f3$exports, 'default', {
    enumerable: true,
    get: function get() {
        return $eefcbb4433f6e9f3$var$_interopRequireDefault($6708ffe7bd9e8461$exports).default;
    }
});

Object.defineProperty($eefcbb4433f6e9f3$exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $d70035f4e2813f1f$exports.TouchScrollable;
    }
});
function $eefcbb4433f6e9f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}



/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $eKeTJ = parcelRequire("eKeTJ");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");
function $294720a8d6604d4a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $294720a8d6604d4a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $294720a8d6604d4a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $294720a8d6604d4a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $294720a8d6604d4a$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $294720a8d6604d4a$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $294720a8d6604d4a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $294720a8d6604d4a$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(updater) === 'object') this.payload = $294720a8d6604d4a$var$_objectSpread($294720a8d6604d4a$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $770e64262e583ed8$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $770e64262e583ed8$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $770e64262e583ed8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($770e64262e583ed8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $770e64262e583ed8$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($eKeTJ)))((0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $770e64262e583ed8$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $770e64262e583ed8$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $770e64262e583ed8$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, UIAnalyticsEvent);
        _this = $770e64262e583ed8$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $770e64262e583ed8$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $294720a8d6604d4a$export$2e2bcd8739ae039));



var $7fPBF = parcelRequire("7fPBF");

var $f125197a22118c89$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $7fPBF.useContext)((0, $e420dde09fb890a4$export$2e2bcd8739ae039));
};


function $3cac21e71ca99dc8$export$5bf35293e545f20c() {
    var analyticsContext = (0, $f125197a22118c89$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6ff1114199100bef$export$33752cf3ee811995)(function(payload) {
        return new (0, $770e64262e583ed8$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $7fPBF = parcelRequire("7fPBF");
var $c335bb3ddd37fe3b$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $7fPBF.useRef)(value);
    ref.current = value;
    return ref;
};


function $e75ff324315e680c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e75ff324315e680c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e75ff324315e680c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e75ff324315e680c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e75ff324315e680c$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $3cac21e71ca99dc8$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $c335bb3ddd37fe3b$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $c335bb3ddd37fe3b$export$1d27a74659855e44)(fn);
    var handler = (0, $7fPBF.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e75ff324315e680c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $cc5d95c5b888d6a5$export$4b84fd0e2c617bd = '#FFEBE6';
var $cc5d95c5b888d6a5$export$b34b069eff244586 = '#FFBDAD';
var $cc5d95c5b888d6a5$export$be802dd0d8b57f35 = '#FF8F73';
var $cc5d95c5b888d6a5$export$60847d42f9da92a6 = '#FF7452';
var $cc5d95c5b888d6a5$export$4a7404f376229999 = '#FF5630';
var $cc5d95c5b888d6a5$export$2010d0fb4295b346 = '#DE350B';
var $cc5d95c5b888d6a5$export$2837b5a1a71d5c02 = '#BF2600';
var $cc5d95c5b888d6a5$export$8d9596b529bbb9cf = '#FFFAE6';
var $cc5d95c5b888d6a5$export$41060a744ab0b7ae = '#FFF0B3';
var $cc5d95c5b888d6a5$export$1cc05bbbf340e559 = '#FFE380';
var $cc5d95c5b888d6a5$export$5aae31392d72caaa = '#FFC400';
var $cc5d95c5b888d6a5$export$c6930421db9fa514 = '#FFAB00';
var $cc5d95c5b888d6a5$export$59619663aa6500fb = '#FF991F';
var $cc5d95c5b888d6a5$export$874739ea9e379ab6 = '#FF8B00';
var $cc5d95c5b888d6a5$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $cc5d95c5b888d6a5$export$69a3bf21b9686c2b = '#ABF5D1';
var $cc5d95c5b888d6a5$export$afbce1382ec95f73 = '#79F2C0';
var $cc5d95c5b888d6a5$export$747d86715d4175de = '#57D9A3';
var $cc5d95c5b888d6a5$export$940e1f69e873f202 = '#36B37E';
var $cc5d95c5b888d6a5$export$a49394138f7b8e85 = '#00875A';
var $cc5d95c5b888d6a5$export$6fa04827ac68a4fb = '#006644';
var $cc5d95c5b888d6a5$export$226de0355ed012f8 = '#DEEBFF';
var $cc5d95c5b888d6a5$export$8c13c2ee36917869 = '#B3D4FF';
var $cc5d95c5b888d6a5$export$ecfc1dff386a3e7a = '#4C9AFF';
var $cc5d95c5b888d6a5$export$215b7063051591f1 = '#2684FF';
var $cc5d95c5b888d6a5$export$e62e8919cca44969 = '#0065FF';
var $cc5d95c5b888d6a5$export$b3de0ae08da2ce64 = '#0052CC';
var $cc5d95c5b888d6a5$export$a6ee3d71bc067634 = '#0747A6';
var $cc5d95c5b888d6a5$export$67f15409e87642a1 = '#669DF1';
var $cc5d95c5b888d6a5$export$f0539dbc42dbb067 = '#8FB8F6';
var $cc5d95c5b888d6a5$export$363e4475840015bb = '#EAE6FF';
var $cc5d95c5b888d6a5$export$4b0a4417ed59760f = '#C0B6F2';
var $cc5d95c5b888d6a5$export$6011520a64d9a187 = '#998DD9';
var $cc5d95c5b888d6a5$export$a7175d4e9206bc80 = '#8777D9';
var $cc5d95c5b888d6a5$export$b48405b95304b5a1 = '#6554C0';
var $cc5d95c5b888d6a5$export$c71e4279dd54a18d = '#5243AA';
var $cc5d95c5b888d6a5$export$147899de772240ec = '#403294';
var $cc5d95c5b888d6a5$export$2cf711fe14c66f06 = '#E6FCFF';
var $cc5d95c5b888d6a5$export$7a8f4d33f6f9772c = '#B3F5FF';
var $cc5d95c5b888d6a5$export$776c9c497ef08533 = '#79E2F2';
var $cc5d95c5b888d6a5$export$69cb3ca10c1e330e = '#00C7E6';
var $cc5d95c5b888d6a5$export$9dc1ef0f3f48059b = '#00B8D9';
var $cc5d95c5b888d6a5$export$7c835c78b6fcdef8 = '#00A3BF';
var $cc5d95c5b888d6a5$export$6036577f95c3877e = '#008DA6';
var $cc5d95c5b888d6a5$export$29a4f05edc054374 = '#FFFFFF';
var $cc5d95c5b888d6a5$export$e655ef011c4aa1a2 = '#FAFBFC';
var $cc5d95c5b888d6a5$export$9fdfb749e33cdf97 = '#F4F5F7';
var $cc5d95c5b888d6a5$export$3e51e8f1440314ba = '#EBECF0';
var $cc5d95c5b888d6a5$export$1ce2d1575d444ceb = '#DFE1E6';
var $cc5d95c5b888d6a5$export$8754fc7e6d8b3000 = '#C1C7D0';
var $cc5d95c5b888d6a5$export$c2e91cbeada39b8b = '#B3BAC5';
var $cc5d95c5b888d6a5$export$5f71e19f3a7ad9de = '#A5ADBA';
var $cc5d95c5b888d6a5$export$eaa8c8a70ac22806 = '#97A0AF';
var $cc5d95c5b888d6a5$export$7c87d337fb91a97d = '#8993A4';
var $cc5d95c5b888d6a5$export$d6447c357493214f = '#7A869A';
var $cc5d95c5b888d6a5$export$f563ee71e9ee74cd = '#6B778C';
var $cc5d95c5b888d6a5$export$e2ef2124cf4024b1 = '#5E6C84';
var $cc5d95c5b888d6a5$export$eece5f492e429f08 = '#505F79';
var $cc5d95c5b888d6a5$export$c39c0fe0f26207ae = '#42526E';
var $cc5d95c5b888d6a5$export$7090862dc3038a9f = '#344563';
var $cc5d95c5b888d6a5$export$ad0bacf983b7ddaa = '#253858';
var $cc5d95c5b888d6a5$export$7d61b15e0da132af = '#172B4D';
var $cc5d95c5b888d6a5$export$fbda843f0a27fe96 = '#091E42';
var $cc5d95c5b888d6a5$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $cc5d95c5b888d6a5$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $cc5d95c5b888d6a5$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $cc5d95c5b888d6a5$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $cc5d95c5b888d6a5$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $cc5d95c5b888d6a5$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $cc5d95c5b888d6a5$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $cc5d95c5b888d6a5$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $cc5d95c5b888d6a5$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $cc5d95c5b888d6a5$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $cc5d95c5b888d6a5$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $cc5d95c5b888d6a5$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $cc5d95c5b888d6a5$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $cc5d95c5b888d6a5$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $cc5d95c5b888d6a5$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $cc5d95c5b888d6a5$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $cc5d95c5b888d6a5$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $cc5d95c5b888d6a5$export$2f6319cf7d736c2a = '#E6EDFA';
var $cc5d95c5b888d6a5$export$95126bc8884d6634 = '#DCE5F5';
var $cc5d95c5b888d6a5$export$8338d8c35d44ff1 = '#CED9EB';
var $cc5d95c5b888d6a5$export$5368d76ae4fbbda7 = '#B8C7E0';
var $cc5d95c5b888d6a5$export$9f0a771d16ec8d36 = '#ABBBD6';
var $cc5d95c5b888d6a5$export$abcf8c38338b4aa5 = '#9FB0CC';
var $cc5d95c5b888d6a5$export$97e81faa16a182c7 = '#8C9CB8';
var $cc5d95c5b888d6a5$export$bfe21c59123ecf33 = '#7988A3';
var $cc5d95c5b888d6a5$export$ee82aa2ea6a1558 = '#67758F';
var $cc5d95c5b888d6a5$export$682927c6ed76be02 = '#56637A';
var $cc5d95c5b888d6a5$export$91fd9994c5be9757 = '#455166';
var $cc5d95c5b888d6a5$export$d281fbfe3cff2df6 = '#3B475C';
var $cc5d95c5b888d6a5$export$3902c91d8b98a753 = '#313D52';
var $cc5d95c5b888d6a5$export$8e8133c1ba5845b5 = '#283447';
var $cc5d95c5b888d6a5$export$33ff357f6620b39 = '#202B3D';
var $cc5d95c5b888d6a5$export$633847cf062b69e0 = '#1B2638';
var $cc5d95c5b888d6a5$export$9776a6e503bdbf76 = '#121A29';
var $cc5d95c5b888d6a5$export$6c813d5160dff5db = '#0E1624';
var $cc5d95c5b888d6a5$export$3d4f271a500072a = '#0D1424';
var $cc5d95c5b888d6a5$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $cc5d95c5b888d6a5$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $cc5d95c5b888d6a5$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $cc5d95c5b888d6a5$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $cc5d95c5b888d6a5$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $cc5d95c5b888d6a5$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $cc5d95c5b888d6a5$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $cc5d95c5b888d6a5$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $cc5d95c5b888d6a5$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $cc5d95c5b888d6a5$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $cc5d95c5b888d6a5$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $cc5d95c5b888d6a5$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $cc5d95c5b888d6a5$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $cc5d95c5b888d6a5$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $cc5d95c5b888d6a5$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $cc5d95c5b888d6a5$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $cc5d95c5b888d6a5$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $cc5d95c5b888d6a5$export$d2adc5dedf09fced = '#292A2E';
var $cc5d95c5b888d6a5$export$f51762073d2bb381 = '#94C748';
var $cc5d95c5b888d6a5$export$95e26d54def96891 = '#B3DF72';



function $7fc59c5c15274b69$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7fc59c5c15274b69$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7fc59c5c15274b69$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7fc59c5c15274b69$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7fc59c5c15274b69$var$packageName = "@atlaskit/blanket";
var $7fc59c5c15274b69$var$packageVersion = "15.0.0";
var $7fc59c5c15274b69$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $7fc59c5c15274b69$var$packageName,
    packageVersion: $7fc59c5c15274b69$var$packageVersion
};
var $7fc59c5c15274b69$var$baseStyles = null;
var $7fc59c5c15274b69$var$shouldAllowClickThroughStyles = null;
var $7fc59c5c15274b69$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $7fc59c5c15274b69$var$Blanket = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $7fPBF.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $e75ff324315e680c$export$a4687b0234b40e28)($7fc59c5c15274b69$var$_objectSpread({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $7fc59c5c15274b69$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $7fPBF.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $7fPBF.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)("var(--ds-blanket, ".concat((0, $cc5d95c5b888d6a5$export$486ab785e4bac3c6), ")"))
        }
    }, children);
}));
$7fc59c5c15274b69$var$Blanket.displayName = 'Blanket';
var $7fc59c5c15274b69$export$2e2bcd8739ae039 = $7fc59c5c15274b69$var$Blanket;


/**
 * An empty function which does nothing.
 */ function $0001fe0198273632$export$2e2bcd8739ae039() {}





/* eslint-disable no-console */ var $60b90b73e03cc415$var$printed = {};
function $60b90b73e03cc415$export$2e2bcd8739ae039(message) {
    if ($60b90b73e03cc415$var$printed[message]) return;
    $60b90b73e03cc415$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $5447a7688eb066b7$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $60b90b73e03cc415$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $5447a7688eb066b7$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {}


// Reds
var $eb5a74535af41be5$export$4b84fd0e2c617bd = '#FFEBE6';
var $eb5a74535af41be5$export$b34b069eff244586 = '#FFBDAD';
var $eb5a74535af41be5$export$be802dd0d8b57f35 = '#FF8F73';
var $eb5a74535af41be5$export$60847d42f9da92a6 = '#FF7452';
var $eb5a74535af41be5$export$4a7404f376229999 = '#FF5630';
var $eb5a74535af41be5$export$2010d0fb4295b346 = '#DE350B';
var $eb5a74535af41be5$export$2837b5a1a71d5c02 = '#BF2600';
var $eb5a74535af41be5$export$8d9596b529bbb9cf = '#FFFAE6';
var $eb5a74535af41be5$export$41060a744ab0b7ae = '#FFF0B3';
var $eb5a74535af41be5$export$1cc05bbbf340e559 = '#FFE380';
var $eb5a74535af41be5$export$5aae31392d72caaa = '#FFC400';
var $eb5a74535af41be5$export$c6930421db9fa514 = '#FFAB00';
var $eb5a74535af41be5$export$59619663aa6500fb = '#FF991F';
var $eb5a74535af41be5$export$874739ea9e379ab6 = '#FF8B00';
var $eb5a74535af41be5$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $eb5a74535af41be5$export$69a3bf21b9686c2b = '#ABF5D1';
var $eb5a74535af41be5$export$afbce1382ec95f73 = '#79F2C0';
var $eb5a74535af41be5$export$747d86715d4175de = '#57D9A3';
var $eb5a74535af41be5$export$940e1f69e873f202 = '#36B37E';
var $eb5a74535af41be5$export$a49394138f7b8e85 = '#00875A';
var $eb5a74535af41be5$export$6fa04827ac68a4fb = '#006644';
var $eb5a74535af41be5$export$226de0355ed012f8 = '#DEEBFF';
var $eb5a74535af41be5$export$8c13c2ee36917869 = '#B3D4FF';
var $eb5a74535af41be5$export$ecfc1dff386a3e7a = '#4C9AFF';
var $eb5a74535af41be5$export$215b7063051591f1 = '#2684FF';
var $eb5a74535af41be5$export$e62e8919cca44969 = '#0065FF';
var $eb5a74535af41be5$export$b3de0ae08da2ce64 = '#0052CC';
var $eb5a74535af41be5$export$a6ee3d71bc067634 = '#0747A6';
var $eb5a74535af41be5$export$67f15409e87642a1 = '#669DF1';
var $eb5a74535af41be5$export$f0539dbc42dbb067 = '#8FB8F6';
var $eb5a74535af41be5$export$363e4475840015bb = '#EAE6FF';
var $eb5a74535af41be5$export$4b0a4417ed59760f = '#C0B6F2';
var $eb5a74535af41be5$export$6011520a64d9a187 = '#998DD9';
var $eb5a74535af41be5$export$a7175d4e9206bc80 = '#8777D9';
var $eb5a74535af41be5$export$b48405b95304b5a1 = '#6554C0';
var $eb5a74535af41be5$export$c71e4279dd54a18d = '#5243AA';
var $eb5a74535af41be5$export$147899de772240ec = '#403294';
var $eb5a74535af41be5$export$2cf711fe14c66f06 = '#E6FCFF';
var $eb5a74535af41be5$export$7a8f4d33f6f9772c = '#B3F5FF';
var $eb5a74535af41be5$export$776c9c497ef08533 = '#79E2F2';
var $eb5a74535af41be5$export$69cb3ca10c1e330e = '#00C7E6';
var $eb5a74535af41be5$export$9dc1ef0f3f48059b = '#00B8D9';
var $eb5a74535af41be5$export$7c835c78b6fcdef8 = '#00A3BF';
var $eb5a74535af41be5$export$6036577f95c3877e = '#008DA6';
var $eb5a74535af41be5$export$29a4f05edc054374 = '#FFFFFF';
var $eb5a74535af41be5$export$e655ef011c4aa1a2 = '#FAFBFC';
var $eb5a74535af41be5$export$9fdfb749e33cdf97 = '#F4F5F7';
var $eb5a74535af41be5$export$3e51e8f1440314ba = '#EBECF0';
var $eb5a74535af41be5$export$1ce2d1575d444ceb = '#DFE1E6';
var $eb5a74535af41be5$export$8754fc7e6d8b3000 = '#C1C7D0';
var $eb5a74535af41be5$export$c2e91cbeada39b8b = '#B3BAC5';
var $eb5a74535af41be5$export$5f71e19f3a7ad9de = '#A5ADBA';
var $eb5a74535af41be5$export$eaa8c8a70ac22806 = '#97A0AF';
var $eb5a74535af41be5$export$7c87d337fb91a97d = '#8993A4';
var $eb5a74535af41be5$export$d6447c357493214f = '#7A869A';
var $eb5a74535af41be5$export$f563ee71e9ee74cd = '#6B778C';
var $eb5a74535af41be5$export$e2ef2124cf4024b1 = '#5E6C84';
var $eb5a74535af41be5$export$eece5f492e429f08 = '#505F79';
var $eb5a74535af41be5$export$c39c0fe0f26207ae = '#42526E';
var $eb5a74535af41be5$export$7090862dc3038a9f = '#344563';
var $eb5a74535af41be5$export$ad0bacf983b7ddaa = '#253858';
var $eb5a74535af41be5$export$7d61b15e0da132af = '#172B4D';
var $eb5a74535af41be5$export$fbda843f0a27fe96 = '#091E42';
var $eb5a74535af41be5$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $eb5a74535af41be5$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $eb5a74535af41be5$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $eb5a74535af41be5$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $eb5a74535af41be5$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $eb5a74535af41be5$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $eb5a74535af41be5$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $eb5a74535af41be5$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $eb5a74535af41be5$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $eb5a74535af41be5$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $eb5a74535af41be5$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $eb5a74535af41be5$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $eb5a74535af41be5$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $eb5a74535af41be5$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $eb5a74535af41be5$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $eb5a74535af41be5$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $eb5a74535af41be5$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $eb5a74535af41be5$export$2f6319cf7d736c2a = '#E6EDFA';
var $eb5a74535af41be5$export$95126bc8884d6634 = '#DCE5F5';
var $eb5a74535af41be5$export$8338d8c35d44ff1 = '#CED9EB';
var $eb5a74535af41be5$export$5368d76ae4fbbda7 = '#B8C7E0';
var $eb5a74535af41be5$export$9f0a771d16ec8d36 = '#ABBBD6';
var $eb5a74535af41be5$export$abcf8c38338b4aa5 = '#9FB0CC';
var $eb5a74535af41be5$export$97e81faa16a182c7 = '#8C9CB8';
var $eb5a74535af41be5$export$bfe21c59123ecf33 = '#7988A3';
var $eb5a74535af41be5$export$ee82aa2ea6a1558 = '#67758F';
var $eb5a74535af41be5$export$682927c6ed76be02 = '#56637A';
var $eb5a74535af41be5$export$91fd9994c5be9757 = '#455166';
var $eb5a74535af41be5$export$d281fbfe3cff2df6 = '#3B475C';
var $eb5a74535af41be5$export$3902c91d8b98a753 = '#313D52';
var $eb5a74535af41be5$export$8e8133c1ba5845b5 = '#283447';
var $eb5a74535af41be5$export$33ff357f6620b39 = '#202B3D';
var $eb5a74535af41be5$export$633847cf062b69e0 = '#1B2638';
var $eb5a74535af41be5$export$9776a6e503bdbf76 = '#121A29';
var $eb5a74535af41be5$export$6c813d5160dff5db = '#0E1624';
var $eb5a74535af41be5$export$3d4f271a500072a = '#0D1424';
var $eb5a74535af41be5$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $eb5a74535af41be5$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $eb5a74535af41be5$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $eb5a74535af41be5$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $eb5a74535af41be5$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $eb5a74535af41be5$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $eb5a74535af41be5$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $eb5a74535af41be5$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $eb5a74535af41be5$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $eb5a74535af41be5$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $eb5a74535af41be5$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $eb5a74535af41be5$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $eb5a74535af41be5$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $eb5a74535af41be5$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $eb5a74535af41be5$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $eb5a74535af41be5$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $eb5a74535af41be5$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $eb5a74535af41be5$export$d2adc5dedf09fced = '#292A2E';
var $eb5a74535af41be5$export$f51762073d2bb381 = '#94C748';
var $eb5a74535af41be5$export$95e26d54def96891 = '#B3DF72';


var $efca76a44a24c722$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $efca76a44a24c722$export$c93026a968943f95 = 'light';
var $efca76a44a24c722$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $efca76a44a24c722$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $efca76a44a24c722$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $efca76a44a24c722$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $eb5a74535af41be5$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $efca76a44a24c722$export$6d8204c2cb2e06b8() / 4;
    (0, $5447a7688eb066b7$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $efca76a44a24c722$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $efca76a44a24c722$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $efca76a44a24c722$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5447a7688eb066b7$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $efca76a44a24c722$export$ba1d834b86d72a09 = $efca76a44a24c722$export$a1b3edb637fb4f35;
var $efca76a44a24c722$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $eb5a74535af41be5$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $eb5a74535af41be5$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $eb5a74535af41be5$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $47d73fe8135ce29e$var$uniqueReferencedValue = {};
function $47d73fe8135ce29e$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $7fPBF.useRef)($47d73fe8135ce29e$var$uniqueReferencedValue);
    if (ref.current === $47d73fe8135ce29e$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}


function $5953b46bd91d7ca5$export$2e2bcd8739ae039(callback) {
    var ref = (0, $47d73fe8135ce29e$export$2e2bcd8739ae039)(function() {
        return callback;
    });
    return ref.current;
}



var $7fPBF = parcelRequire("7fPBF");
function $8ed0a1f1864244d9$export$2e2bcd8739ae039(value) {
    var ref = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
function $0e46e5d682fced23$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $7fPBF.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $7fPBF.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}



/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $395dcebe8a28322c$var$modalStackRegister = [];
function $395dcebe8a28322c$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $a1ad98f67aabe587$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $0e46e5d682fced23$export$2e2bcd8739ae039)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $8ed0a1f1864244d9$export$2e2bcd8739ae039)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $5953b46bd91d7ca5$export$2e2bcd8739ae039)(function() {
        var newStackIndex = $395dcebe8a28322c$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $7fPBF.useEffect)(function() {
        var currentStackIndex = $395dcebe8a28322c$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $395dcebe8a28322c$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $395dcebe8a28322c$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $395dcebe8a28322c$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $395dcebe8a28322c$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $395dcebe8a28322c$var$modalStackRegister.splice(currentStackIndex, 1);
                $395dcebe8a28322c$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $a082a6b1512440da$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $a082a6b1512440da$export$2e2bcd8739ae039() {
    var _useState = (0, $7fPBF.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $7fPBF.useLayoutEffect)(function() {
        setScrollTopOffset($a082a6b1512440da$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $7fPBF.useCallback)(function() {
        if ($a082a6b1512440da$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $7fPBF.useEffect)(function() {
        return (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}


/* modal-dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $iKdEz = parcelRequire("iKdEz");

var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $bc755350ce759ded$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}



var $7fPBF = parcelRequire("7fPBF");
function $c76f10011ac9e76d$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}



var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");
var $80f2fc4a83a6b777$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $80f2fc4a83a6b777$var$react18UseId = ($80f2fc4a83a6b777$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId) !== null && $80f2fc4a83a6b777$var$_React$useId !== void 0 ? $80f2fc4a83a6b777$var$_React$useId : undefined;
function $80f2fc4a83a6b777$export$f680877a34711e37() {
    if ($80f2fc4a83a6b777$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) return $80f2fc4a83a6b777$var$react18UseId();
    return "uid".concat((0, $e9144a1b4dc9c62e$export$87d05f07e65211f1)());
}
var $80f2fc4a83a6b777$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($80f2fc4a83a6b777$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $80f2fc4a83a6b777$export$6ee17796e3d70de2() {
    if ($80f2fc4a83a6b777$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) {
        var uid = $80f2fc4a83a6b777$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $e9144a1b4dc9c62e$export$bb5ca5fba6fb4f1f)();
}




/** Create a new combined function that will call all the provided functions */ function $8847aab58ded244d$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}





var $7fPBF = parcelRequire("7fPBF");
var $e531343e66f94fe5$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
var $e531343e66f94fe5$export$dece24112a937f92 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");
function $6d635366f5fb15d1$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $7fPBF.useRef)(null);
    var onMotionFinish = (0, $7fPBF.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}





var $iKdEz = parcelRequire("iKdEz");


var $iKdEz = parcelRequire("iKdEz");
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $bc71d1a75f4b886f$export$6eafea55f7947469 = 'data-pdnd-honey-pot';


function $b28717be80d270e6$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $bc71d1a75f4b886f$export$6eafea55f7947469));
}


function $f9d1fd311d4d59fd$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $b28717be80d270e6$export$821bdcd739a2706b)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}



var $8MJe2 = parcelRequire("8MJe2");

// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $6501d511685a84e4$export$7d0a15ee70427305 = 2147483647;



function $193d546856b964fc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $193d546856b964fc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $193d546856b964fc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $193d546856b964fc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $193d546856b964fc$var$honeyPotSize = 2;
var $193d546856b964fc$var$halfHoneyPotSize = $193d546856b964fc$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $193d546856b964fc$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $193d546856b964fc$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $193d546856b964fc$var$halfHoneyPotSize,
        y: point.y - $193d546856b964fc$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $193d546856b964fc$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $193d546856b964fc$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $193d546856b964fc$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $193d546856b964fc$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $193d546856b964fc$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $193d546856b964fc$var$preventGoingForwardsOffScreen($193d546856b964fc$var$preventGoingBackwardsOffScreen($193d546856b964fc$var$pullBackByHalfHoneyPotSize($193d546856b964fc$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $193d546856b964fc$var$honeyPotSize,
        height: $193d546856b964fc$var$honeyPotSize
    });
}
function $193d546856b964fc$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $193d546856b964fc$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $193d546856b964fc$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement('div');
    element.setAttribute((0, $bc71d1a75f4b886f$export$6eafea55f7947469), 'true');
    // can shift during the drag thanks to Firefox
    var clientRect = $193d546856b964fc$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $193d546856b964fc$var$_objectSpread($193d546856b964fc$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box'
    }, $193d546856b964fc$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $6501d511685a84e4$export$7d0a15ee70427305)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $a091c25729a976b1$exports.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $193d546856b964fc$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $193d546856b964fc$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($193d546856b964fc$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $a091c25729a976b1$exports.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $193d546856b964fc$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $193d546856b964fc$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}



var $j9spr = parcelRequire("j9spr");



/** Provide a function that you only ever want to be called a single time */ function $68e346ba3911f1c2$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}


var $b749e65f3d5c9991$export$b7d78993b74f766d = (0, $68e346ba3911f1c2$export$d2de3aaeafa91619)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});



var $1e42c1bc9239c98e$export$95df08bae54cb4df = (0, $68e346ba3911f1c2$export$d2de3aaeafa91619)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});




/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $17cf273859fa5ad7$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $17cf273859fa5ad7$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $1e42c1bc9239c98e$export$95df08bae54cb4df)()) return false;
    return dragEnter.hasOwnProperty($17cf273859fa5ad7$var$symbols.isEnteringWindow);
}
function $17cf273859fa5ad7$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $1e42c1bc9239c98e$export$95df08bae54cb4df)()) return false;
    return dragLeave.hasOwnProperty($17cf273859fa5ad7$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $1e42c1bc9239c98e$export$95df08bae54cb4df)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$17cf273859fa5ad7$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$17cf273859fa5ad7$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();


/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $3619bfcf994fa6a6$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $3619bfcf994fa6a6$export$e46810fef53b5b0e(eventTarget) {
    return $3619bfcf994fa6a6$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}


function $d9ba60099687cc3c$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, $1e42c1bc9239c98e$export$95df08bae54cb4df)()) return (0, $17cf273859fa5ad7$export$f21837c338005454)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $b749e65f3d5c9991$export$b7d78993b74f766d)()) return (0, $3619bfcf994fa6a6$export$e46810fef53b5b0e)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}


function $0b2b9d5d1129a1ca$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}


function $2675101a3ff07002$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}


var $c15db151bfb9ee49$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $c15db151bfb9ee49$export$2e2bcd8739ae039 = $c15db151bfb9ee49$var$rafSchd;


var $f003e67bc5e20f24$var$scheduleOnDrag = (0, $c15db151bfb9ee49$export$2e2bcd8739ae039)(function(fn) {
    return fn();
});
var $f003e67bc5e20f24$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $f003e67bc5e20f24$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $f003e67bc5e20f24$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $f003e67bc5e20f24$var$dragStart.flush();
            $f003e67bc5e20f24$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $f003e67bc5e20f24$var$scheduleOnDrag(function() {
                $f003e67bc5e20f24$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $f003e67bc5e20f24$var$dragStart.flush();
            $f003e67bc5e20f24$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}


var $b1bf1305423c2f0a$var$globalState = {
    isActive: false
};
function $b1bf1305423c2f0a$var$canStart() {
    return !$b1bf1305423c2f0a$var$globalState.isActive;
}
function $b1bf1305423c2f0a$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $b1bf1305423c2f0a$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $b1bf1305423c2f0a$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$b1bf1305423c2f0a$var$canStart()) return;
    var initial = $b1bf1305423c2f0a$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $b1bf1305423c2f0a$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $b1bf1305423c2f0a$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $f003e67bc5e20f24$export$9f13ecc44e83d682)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $b1bf1305423c2f0a$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $2675101a3ff07002$export$7c112ceec8941e67)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $b28717be80d270e6$export$821bdcd739a2706b)(event.target) ? (0, $f9d1fd311d4d59fd$export$81d0353f25f5dd)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $b1bf1305423c2f0a$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $b1bf1305423c2f0a$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, $d9ba60099687cc3c$export$57d220c74e84a273)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $2675101a3ff07002$export$7c112ceec8941e67)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $b1bf1305423c2f0a$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $2675101a3ff07002$export$7c112ceec8941e67)(event)
                };
                cancel();
            }
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))((0, $0b2b9d5d1129a1ca$export$ac5e5b0daf997b2)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $b1bf1305423c2f0a$var$getNativeSetDragImage(event)
    });
}
function $b1bf1305423c2f0a$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $b1bf1305423c2f0a$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $2675101a3ff07002$export$7c112ceec8941e67)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $b1bf1305423c2f0a$export$3efdceeb8ca25c51 = {
    canStart: $b1bf1305423c2f0a$var$canStart,
    start: $b1bf1305423c2f0a$var$start
};


// Extending `Map` to allow us to link Key and Values together
var $6bece9ac86ae72a6$var$ledger = new Map();
function $6bece9ac86ae72a6$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $6bece9ac86ae72a6$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $6bece9ac86ae72a6$var$ledger.set(typeKey, initial);
    return initial;
}
function $6bece9ac86ae72a6$export$6503ec6e8aabbaf(args) {
    var entry = $6bece9ac86ae72a6$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $6bece9ac86ae72a6$var$ledger.delete(args.typeKey);
    };
}



var $8MJe2 = parcelRequire("8MJe2");

var $j9spr = parcelRequire("j9spr");

function $0d06b6a30f917978$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}


function $d5b19bf156af47c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5b19bf156af47c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5b19bf156af47c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5b19bf156af47c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d5b19bf156af47c8$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $d5b19bf156af47c8$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $d5b19bf156af47c8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d5b19bf156af47c8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d5b19bf156af47c8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d5b19bf156af47c8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $d5b19bf156af47c8$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $d5b19bf156af47c8$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        return (0, $8847aab58ded244d$export$1be1fc439b849fdf)((0, $0d06b6a30f917978$export$5dcb5c23b6ba980a)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $d5b19bf156af47c8$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $d5b19bf156af47c8$var$_objectSpread($d5b19bf156af47c8$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $d5b19bf156af47c8$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $d5b19bf156af47c8$var$_objectSpread($d5b19bf156af47c8$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $d5b19bf156af47c8$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $d5b19bf156af47c8$var$_objectSpread($d5b19bf156af47c8$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $d5b19bf156af47c8$var$copyReverse(current);
        var actualCaptureOrdered = $d5b19bf156af47c8$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($d5b19bf156af47c8$var$_objectSpread($d5b19bf156af47c8$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $d5b19bf156af47c8$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}



var $8MJe2 = parcelRequire("8MJe2");
function $2b12e329680e6a0e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $2b12e329680e6a0e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $2b12e329680e6a0e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2b12e329680e6a0e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2b12e329680e6a0e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2b12e329680e6a0e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $2b12e329680e6a0e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b12e329680e6a0e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b12e329680e6a0e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b12e329680e6a0e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2b12e329680e6a0e$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $2b12e329680e6a0e$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        return function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        };
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $2b12e329680e6a0e$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}


function $5122e0d0088f4b41$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $2b12e329680e6a0e$export$5dd4ed888d5b12ca)();
    var dropTargetAPI = (0, $d5b19bf156af47c8$export$47d10e7bd9c81890)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $b1bf1305423c2f0a$export$3efdceeb8ca25c51).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $b1bf1305423c2f0a$export$3efdceeb8ca25c51).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $6bece9ac86ae72a6$export$6503ec6e8aabbaf)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}





var $01bac06922e89b20$export$a11b0059900ceec8 = (0, $68e346ba3911f1c2$export$d2de3aaeafa91619)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var $01bac06922e89b20$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';



// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $4c8d3d867b71c91e$export$fd3d00026297c0ad = 'text/plain';


// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $f29473ed1a3cd5be$export$4c44a460f123106 = 'text/uri-list';


/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $f77bfd9efc16c1d5$export$c9c4cc54e73b125d = 'application/vnd.pdnd';


var $8ed119f46b74ba61$var$draggableRegistry = new WeakMap();
function $8ed119f46b74ba61$var$addToRegistry(args) {
    $8ed119f46b74ba61$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $8ed119f46b74ba61$var$draggableRegistry.delete(args.element);
    };
}
var $8ed119f46b74ba61$var$honeyPotFix = (0, $193d546856b964fc$export$8ecad27c959e89e0)();
var $8ed119f46b74ba61$var$adapter = (0, $5122e0d0088f4b41$export$2aa3a33160990d96)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $8847aab58ded244d$export$1be1fc439b849fdf)($8ed119f46b74ba61$var$honeyPotFix.bindEvents(), (0, $a091c25729a976b1$exports.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                var entry = $8ed119f46b74ba61$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $2675101a3ff07002$export$7c112ceec8941e67)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $f9d1fd311d4d59fd$export$81d0353f25f5dd)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $01bac06922e89b20$export$a11b0059900ceec8)() && !event.dataTransfer.types.includes((0, $4c8d3d867b71c91e$export$fd3d00026297c0ad)) && !event.dataTransfer.types.includes((0, $f29473ed1a3cd5be$export$4c44a460f123106))) event.dataTransfer.setData((0, $4c8d3d867b71c91e$export$fd3d00026297c0ad), (0, $01bac06922e89b20$export$aceb3ed8b7f7bd2c));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $f77bfd9efc16c1d5$export$c9c4cc54e73b125d), '');
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $8ed119f46b74ba61$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $8ed119f46b74ba61$var$honeyPotFix.getOnPostDispatch()
});
var $8ed119f46b74ba61$export$e7140b68045b5036 = $8ed119f46b74ba61$var$adapter.dropTarget;
var $8ed119f46b74ba61$export$59a074bac4c54f54 = $8ed119f46b74ba61$var$adapter.monitor;
function $8ed119f46b74ba61$export$c746a5152d4ba26c(args) {
    var existing;
    return (0, $8847aab58ded244d$export$1be1fc439b849fdf)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $8ed119f46b74ba61$var$adapter.registerUsage(), $8ed119f46b74ba61$var$addToRegistry(args), (0, $0d06b6a30f917978$export$5dcb5c23b6ba980a)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 


 // Payload for the draggable being dragged



var $j9spr = parcelRequire("j9spr");

/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $09d4f4c67999ed78$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $09d4f4c67999ed78$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $09d4f4c67999ed78$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$09d4f4c67999ed78$var$hasSameOrigin(window.location.href, iframe.src);
}
var $09d4f4c67999ed78$var$registry = new Map();
function $09d4f4c67999ed78$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($09d4f4c67999ed78$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $09d4f4c67999ed78$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $09d4f4c67999ed78$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $09d4f4c67999ed78$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $09d4f4c67999ed78$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $8847aab58ded244d$export$1be1fc439b849fdf).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $09d4f4c67999ed78$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $09d4f4c67999ed78$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}


function $907c8937691d0a6f$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $8ed119f46b74ba61$export$59a074bac4c54f54)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $8847aab58ded244d$export$1be1fc439b849fdf)(unbindEvents, unbindMonitor);
}
function $907c8937691d0a6f$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $a091c25729a976b1$exports.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $907c8937691d0a6f$var$api = (0, $09d4f4c67999ed78$export$a74bff2507e6126b)({
    watchForInteractionStart: $907c8937691d0a6f$var$watchForInteractionStart,
    watchForInteractionEnd: $907c8937691d0a6f$var$watchForInteractionEnd
});
function $907c8937691d0a6f$export$ec28e97c7d8b1b35() {
    return $907c8937691d0a6f$var$api.registerUsage();
}



var $j9spr = parcelRequire("j9spr");







function $562864d65a169a18$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== 'dragenter') return false;
    if ((0, $1e42c1bc9239c98e$export$95df08bae54cb4df)()) return (0, $17cf273859fa5ad7$export$de68634bd94ed596)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $b749e65f3d5c9991$export$b7d78993b74f766d)()) return (0, $3619bfcf994fa6a6$export$e46810fef53b5b0e)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}





function $f8b583d741e0f6c3$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $f77bfd9efc16c1d5$export$c9c4cc54e73b125d)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $4c8d3d867b71c91e$export$fd3d00026297c0ad) && value === (0, $01bac06922e89b20$export$aceb3ed8b7f7bd2c)) return false;
    return true;
}
function $f8b583d741e0f6c3$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $f8b583d741e0f6c3$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $f8b583d741e0f6c3$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === 'file' || $f8b583d741e0f6c3$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $f8b583d741e0f6c3$var$didDragStartLocally = false;
var $f8b583d741e0f6c3$var$adapter = (0, $5122e0d0088f4b41$export$2aa3a33160990d96)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'dragenter',
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($f8b583d741e0f6c3$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $562864d65a169a18$export$d1c6f249e893cdf4)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $f8b583d741e0f6c3$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $f8b583d741e0f6c3$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$f8b583d741e0f6c3$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $f8b583d741e0f6c3$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $f8b583d741e0f6c3$var$adapter.dropTarget(args);
}
function $f8b583d741e0f6c3$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $f8b583d741e0f6c3$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $f8b583d741e0f6c3$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: 'idle'
    };
    var state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $f8b583d741e0f6c3$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $a091c25729a976b1$exports.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))((0, $0b2b9d5d1129a1ca$export$ac5e5b0daf997b2)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $a091c25729a976b1$exports.bind)(window, {
        type: 'dragstart',
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $f8b583d741e0f6c3$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 


 // The data that is being dragged



function $12c5d7db9c9fd030$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $f8b583d741e0f6c3$export$bb1740f3194979c1)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $12c5d7db9c9fd030$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $f8b583d741e0f6c3$export$bb1740f3194979c1)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $12c5d7db9c9fd030$var$api = (0, $09d4f4c67999ed78$export$a74bff2507e6126b)({
    watchForInteractionStart: $12c5d7db9c9fd030$var$watchForInteractionStart,
    watchForInteractionEnd: $12c5d7db9c9fd030$var$watchForInteractionEnd
});
function $12c5d7db9c9fd030$export$27d79116d3a4e7d5() {
    return $12c5d7db9c9fd030$var$api.registerUsage();
}









// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $019a2a9d86291703$export$338a9f6c7a1f02b0 = 'text/html';




function $f7e69e03886a92e0$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $1e42c1bc9239c98e$export$95df08bae54cb4df)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $4c8d3d867b71c91e$export$fd3d00026297c0ad)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $f7e69e03886a92e0$var$honeyPotFix = (0, $193d546856b964fc$export$8ecad27c959e89e0)();
var $f7e69e03886a92e0$var$adapter = (0, $5122e0d0088f4b41$export$2aa3a33160990d96)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $8847aab58ded244d$export$1be1fc439b849fdf)($f7e69e03886a92e0$var$honeyPotFix.bindEvents(), (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'dragstart',
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $f77bfd9efc16c1d5$export$c9c4cc54e73b125d))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $4c8d3d867b71c91e$export$fd3d00026297c0ad))) return;
                var target = $f7e69e03886a92e0$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $4c8d3d867b71c91e$export$fd3d00026297c0ad)),
                    HTML: event.dataTransfer.getData((0, $019a2a9d86291703$export$338a9f6c7a1f02b0))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $f7e69e03886a92e0$var$honeyPotFix.getOnPostDispatch()
});
function $f7e69e03886a92e0$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $f7e69e03886a92e0$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $f7e69e03886a92e0$var$adapter.registerUsage();
})();
function $f7e69e03886a92e0$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $f7e69e03886a92e0$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 


 // Payload for the text selection being dragged



function $778617bf987e527d$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $f7e69e03886a92e0$export$2e178e3647f5e6e9)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $8847aab58ded244d$export$1be1fc439b849fdf)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $778617bf987e527d$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $a091c25729a976b1$exports.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $778617bf987e527d$var$api = (0, $09d4f4c67999ed78$export$a74bff2507e6126b)({
    watchForInteractionStart: $778617bf987e527d$var$watchForInteractionStart,
    watchForInteractionEnd: $778617bf987e527d$var$watchForInteractionEnd
});
function $778617bf987e527d$export$9c0606fcefb5d1e2() {
    return $778617bf987e527d$var$api.registerUsage();
}


var $cbcf78e148f57656$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
var $cbcf78e148f57656$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = $cbcf78e148f57656$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($cbcf78e148f57656$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $cbcf78e148f57656$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};


/* positioner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");



var $14b3e8fade42555c$var$gutter = 60;
var $14b3e8fade42555c$var$maxWidthDimensions = "calc(100vw - ".concat($14b3e8fade42555c$var$gutter * 2, "px)");
var $14b3e8fade42555c$var$maxHeightDimensions = "calc(100vh - ".concat($14b3e8fade42555c$var$gutter * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $14b3e8fade42555c$var$positionerStyles = null;
var $14b3e8fade42555c$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41wqb _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
var $14b3e8fade42555c$var$stackTransitionStyles = null;
var $14b3e8fade42555c$var$stackTransformStyles = null;
var $14b3e8fade42555c$var$stackIdleStyles = null;
function $14b3e8fade42555c$var$getScrollBehavior(_ref) {
    var isFullScreen = _ref.isFullScreen, shouldScrollInViewport = _ref.shouldScrollInViewport;
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
var $14b3e8fade42555c$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId, isFullScreen = props.isFullScreen;
    var scrollBehavior = $14b3e8fade42555c$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        style: {
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: "".concat((0, $f71fbefa8f6c3895$export$38b928a7167ce124).medium, "ms"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $a94201cbfcfbf04d$export$c07234257a03d5e9)
        },
        "data-testid": testId && "".concat(testId, "--positioner"),
        className: (0, $iRmtv.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            "_k8m01e03 _1bumglyw _sedtglyw",
            stackIndex > 0 ? "_t9ec1b95" : "_t9ecglyw",
            $14b3e8fade42555c$var$scrollStyles[scrollBehavior]
        ])
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$14b3e8fade42555c$export$2e2bcd8739ae039 = $14b3e8fade42555c$var$Positioner;


var $2461feae78b6999a$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $2461feae78b6999a$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syaz1fxt _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1p6i _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p1cd0 _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkx1sit"
};
var $2461feae78b6999a$var$viewportScrollStyles = null;
var $2461feae78b6999a$var$bodyScrollStyles = null;
var $2461feae78b6999a$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId, _props$isFullScreen = props.isFullScreen, isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen;
    var id = (0, $80f2fc4a83a6b777$export$f680877a34711e37)();
    var titleId = "modal-dialog-title-".concat(id);
    var defaultTestId = testId || 'modal-dialog';
    (0, $7fPBF.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $8847aab58ded244d$export$1be1fc439b849fdf)((0, $907c8937691d0a6f$export$ec28e97c7d8b1b35)(), (0, $778617bf987e527d$export$9c0606fcefb5d1e2)(), (0, $12c5d7db9c9fd030$export$27d79116d3a4e7d5)());
    }, []);
    (0, $c76f10011ac9e76d$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(autoFocus) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $6d635366f5fb15d1$export$2e2bcd8739ae039)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $7fPBF.useMemo)(function() {
        return {
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        };
    }, [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $9a1b26136f3a7f68$export$4a4bf067ea9e7886)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $9a1b26136f3a7f68$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    return /*#__PURE__*/ $7fPBF.createElement((0, $14b3e8fade42555c$export$2e2bcd8739ae039), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen
    }, /*#__PURE__*/ $7fPBF.createElement((0, $e531343e66f94fe5$export$ab57792b9b6974a6).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $e531343e66f94fe5$export$dece24112a937f92).Provider, {
        value: shouldScrollInViewport
    }, /*#__PURE__*/ $7fPBF.createElement((0, $a6c67c5a8158581e$export$2e2bcd8739ae039), {
        entranceDirection: isFullScreen ? undefined : 'bottom',
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return /*#__PURE__*/ $7fPBF.createElement("section", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $bc755350ce759ded$export$2e2bcd8739ae039)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $cbcf78e148f57656$export$a3da89b899389ed8)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $cbcf78e148f57656$export$ceba93bf0bdd16f2)(height)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $iRmtv.default)([
                $2461feae78b6999a$var$dialogStyles.root,
                !isFullScreen && $2461feae78b6999a$var$dialogStyles.borderRadius,
                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                bottomFadeInProps.className
            ]),
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children);
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2461feae78b6999a$export$2e2bcd8739ae039 = $2461feae78b6999a$var$ModalDialog;


var $adfcc25ee31e4e47$var$fillScreenStyles = null;
var $adfcc25ee31e4e47$var$allowlistElements = function allowlistElements(element, callback) {
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $adfcc25ee31e4e47$var$InternalModalWrapper = function InternalModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $0001fe0198273632$export$2e2bcd8739ae039) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId, isFullScreen = props.isFullScreen;
    var calculatedStackIndex = (0, $395dcebe8a28322c$export$2e2bcd8739ae039)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    var onCloseHandler = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: providedOnClose || (0, $0001fe0198273632$export$2e2bcd8739ae039),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "14.3.3"
    });
    var onBlanketClicked = (0, $7fPBF.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $7fPBF.useCallback)(function(element) {
        return $adfcc25ee31e4e47$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $a082a6b1512440da$export$2e2bcd8739ae039)();
    var modalDialogWithBlanket = /*#__PURE__*/ $7fPBF.createElement((0, $7fc59c5c15274b69$export$2e2bcd8739ae039), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, /*#__PURE__*/ $7fPBF.createElement((0, $2461feae78b6999a$export$2e2bcd8739ae039), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose),
        isFullScreen: isFullScreen
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ $7fPBF.createElement((0, $f18c7111ec24d6a2$export$7c885f891c940977), {
        isDisabled: false
    }, /*#__PURE__*/ $7fPBF.createElement((0, $cd3bc8368572caba$export$2e2bcd8739ae039), {
        zIndex: (0, $efca76a44a24c722$export$7be255094ccdc533).modal()
    }, /*#__PURE__*/ $7fPBF.createElement((0, $a6c67c5a8158581e$export$2e2bcd8739ae039), null, function(fadeInProps) {
        return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, fadeInProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $iRmtv.default)([
                "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                fadeInProps.className
            ]),
            "aria-hidden": !isForeground
        }), /*#__PURE__*/ $7fPBF.createElement((0, $2cb7353992a884b7$export$2e2bcd8739ae039), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ $7fPBF.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eefcbb4433f6e9f3$exports))), null), shouldScrollInViewport ? /*#__PURE__*/ $7fPBF.createElement((0, $eefcbb4433f6e9f3$exports.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $adfcc25ee31e4e47$export$2e2bcd8739ae039 = $adfcc25ee31e4e47$var$InternalModalWrapper;


function $95611d2ac5b62126$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $adfcc25ee31e4e47$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
        isFullScreen: false
    }));
}

/* modal-body.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iRmtv = parcelRequire("iRmtv");

var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");

var $7fPBF = parcelRequire("7fPBF");

var $007dd3816635191b$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $7fPBF.useContext)((0, $e531343e66f94fe5$export$ab57792b9b6974a6));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};


/* scroll-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iKdEz = parcelRequire("iKdEz");


var $7fPBF = parcelRequire("7fPBF");







var $171cde25fbd921b6$var$keylineColor = "var(--ds-border, #091E4224)";
var $171cde25fbd921b6$var$styles = {
    base: "_16jlkb7n _1o9zkb7n _i0dl1kw7 _1e0c1kw7 _2lx21kw7 _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm2v2xi",
    bottomKeyline: "_179rv2xi"
};
var $171cde25fbd921b6$var$keylineHeight = 2;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $171cde25fbd921b6$var$ScrollContainer = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $7fPBF.useEffect)(function() {
        var schedule = (0, $c15db151bfb9ee49$export$2e2bcd8739ae039)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $5953b46bd91d7ca5$export$2e2bcd8739ae039)((0, $c15db151bfb9ee49$export$2e2bcd8739ae039)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $171cde25fbd921b6$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $171cde25fbd921b6$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $7fPBF.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $a091c25729a976b1$exports.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $0001fe0198273632$export$2e2bcd8739ae039);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $141630e001aa18df$export$2e2bcd8739ae039), {
        as: "div",
        isInset: true,
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && "".concat(testId, "--scrollable"),
        ref: (0, $bc755350ce759ded$export$2e2bcd8739ae039)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($171cde25fbd921b6$var$styles.base, showTopKeyline && $171cde25fbd921b6$var$styles.topKeyline, showBottomKeyline && $171cde25fbd921b6$var$styles.bottomKeyline)
    }, children);
});
$171cde25fbd921b6$var$ScrollContainer.displayName = 'ScrollContainer';
var $171cde25fbd921b6$export$2e2bcd8739ae039 = $171cde25fbd921b6$var$ScrollContainer;



var $7fPBF = parcelRequire("7fPBF");

function $7b74817fdec7e710$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $7fPBF.useContext)((0, $e531343e66f94fe5$export$dece24112a937f92));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}


var $b3739a2c2476e4e5$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug",
    font: "_11c82smr",
    paddingBlock: "_1rjc1bk5",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $b3739a2c2476e4e5$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasInlinePaddi = props.hasInlinePadding, hasInlinePadding = _props$hasInlinePaddi === void 0 ? true : _props$hasInlinePaddi;
    var _useModal = (0, $007dd3816635191b$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $7b74817fdec7e710$export$2e2bcd8739ae039)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        "data-testid": testId,
        className: (0, $iRmtv.default)([
            $b3739a2c2476e4e5$var$styles.root,
            hasInlinePadding && $b3739a2c2476e4e5$var$styles.paddingInline,
            (0, $137Lh.fg)('platform_ads_explicit_font_styles') && $b3739a2c2476e4e5$var$styles.font
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $eefcbb4433f6e9f3$exports.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $171cde25fbd921b6$export$2e2bcd8739ae039), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        "data-testid": testId,
        className: (0, $iRmtv.default)([
            $b3739a2c2476e4e5$var$styles.root,
            /**
     * Adding block padding for scroll keylines, which are only shown when the scrolling
     * is on the container.
     */ $b3739a2c2476e4e5$var$styles.paddingBlock,
            hasInlinePadding && $b3739a2c2476e4e5$var$styles.paddingInline,
            (0, $137Lh.fg)('platform_ads_explicit_font_styles') && $b3739a2c2476e4e5$var$styles.font
        ])
    }, children)));
};
var $b3739a2c2476e4e5$export$2e2bcd8739ae039 = $b3739a2c2476e4e5$var$ModalBody;

/* modal-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $c6756c60cc176ecd$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}



var $845716ea19676e23$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $845716ea19676e23$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $007dd3816635191b$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        "data-testid": testId,
        className: (0, $iRmtv.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfhmufe _85i51ejb _1q51pxbi"
        ]),
        style: {
            "--_t7lu6v": (0, $c6756c60cc176ecd$export$2e2bcd8739ae039)("calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"))
        }
    }, children);
};
var $845716ea19676e23$export$2e2bcd8739ae039 = $845716ea19676e23$var$ModalFooter;

/* modal-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iRmtv = parcelRequire("iRmtv");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $1a098a2f041f8946$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40d49d14e43276e4147396a05e9540f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($1a098a2f041f8946$exports, "__esModule", {
    value: true
});
$1a098a2f041f8946$exports.default = void 0;

var $1a098a2f041f8946$var$_react = $1a098a2f041f8946$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $1a098a2f041f8946$var$_cross = $1a098a2f041f8946$var$_interopRequireDefault((parcelRequire("18Jal")));

var $1a098a2f041f8946$var$_cross2 = $1a098a2f041f8946$var$_interopRequireDefault((parcelRequire("c0dBm")));
function $1a098a2f041f8946$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1a098a2f041f8946$var$CrossIcon = (props)=>/*#__PURE__*/ $1a098a2f041f8946$var$_react.default.createElement($1a098a2f041f8946$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $1a098a2f041f8946$var$_cross2.default
    }, props));
$1a098a2f041f8946$var$CrossIcon.Name = 'CrossIconMigration';
var $1a098a2f041f8946$var$_default = $1a098a2f041f8946$exports.default = $1a098a2f041f8946$var$CrossIcon;


var $6df3aa8eabe874e9$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $729d339602a97fd3$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1a098a2f041f8946$exports))),
        label: label || 'Close Modal',
        onClick: onClick
    });
};



var $78ffec079aff50d9$var$headerStyles = null;
var $78ffec079aff50d9$var$flexStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    flexDirection: 'row-reverse',
    width: '100%'
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $78ffec079aff50d9$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $007dd3816635191b$export$33ffd74ebf07f060)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        "data-testid": testId,
        className: (0, $iRmtv.default)([
            "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rthmufe _85i5pxbi _1q511ejb"
        ]),
        style: {
            "--_t7lu6v": (0, $c6756c60cc176ecd$export$2e2bcd8739ae039)("calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"))
        }
    }, shouldShowCloseButton ? /*#__PURE__*/ // The reason we are putting the close button first in the DOM and then
    // reordering them is to ensure that users of assistive technology get
    // all the context of a modal when initial focus is placed on the close
    // button, since it's the first interactive element.
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0a833860173a6d7c$export$2e2bcd8739ae039), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $78ffec079aff50d9$var$flexStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0a833860173a6d7c$export$2e2bcd8739ae039), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $6df3aa8eabe874e9$export$de65de8213222d10), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0a833860173a6d7c$export$2e2bcd8739ae039), {
        justifyContent: "start",
        alignItems: "center"
    }, children)) : children);
};
var $78ffec079aff50d9$export$2e2bcd8739ae039 = $78ffec079aff50d9$var$ModalHeader;

/* modal-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");
var $4fc1653ce3318864$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8687bcf05df783ceffe46d3fd0178463>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($4fc1653ce3318864$exports, "__esModule", {
    value: true
});
$4fc1653ce3318864$exports.default = void 0;

var $4fc1653ce3318864$var$_react = $4fc1653ce3318864$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $4fc1653ce3318864$var$_statusError = $4fc1653ce3318864$var$_interopRequireDefault((parcelRequire("ctZOH")));

var $4fc1653ce3318864$var$_error = $4fc1653ce3318864$var$_interopRequireDefault((parcelRequire("7aNfw")));
function $4fc1653ce3318864$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4fc1653ce3318864$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $4fc1653ce3318864$var$_react.default.createElement($4fc1653ce3318864$var$_statusError.default, Object.assign({
        LEGACY_fallbackIcon: $4fc1653ce3318864$var$_error.default
    }, props));
$4fc1653ce3318864$var$StatusErrorIcon.Name = 'StatusErrorIconMigration';
var $4fc1653ce3318864$var$_default = $4fc1653ce3318864$exports.default = $4fc1653ce3318864$var$StatusErrorIcon;


var $3e782882bdbdb208$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c4f87fa6bbdffcdd6698ec12cc5fa12>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($3e782882bdbdb208$exports, "__esModule", {
    value: true
});
$3e782882bdbdb208$exports.default = void 0;

var $3e782882bdbdb208$var$_react = $3e782882bdbdb208$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $3e782882bdbdb208$var$_statusWarning = $3e782882bdbdb208$var$_interopRequireDefault((parcelRequire("3i1H6")));

var $3e782882bdbdb208$var$_warning = $3e782882bdbdb208$var$_interopRequireDefault((parcelRequire("47SDm")));
function $3e782882bdbdb208$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e782882bdbdb208$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $3e782882bdbdb208$var$_react.default.createElement($3e782882bdbdb208$var$_statusWarning.default, Object.assign({
        LEGACY_fallbackIcon: $3e782882bdbdb208$var$_warning.default
    }, props));
$3e782882bdbdb208$var$StatusWarningIcon.Name = 'StatusWarningIconMigration';
var $3e782882bdbdb208$var$_default = $3e782882bdbdb208$exports.default = $3e782882bdbdb208$var$StatusWarningIcon;



var $643b6d5cc9e6a567$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E56910)"
};
var $643b6d5cc9e6a567$var$iconStyles = null;
var $643b6d5cc9e6a567$var$titleStyles = null;
var $643b6d5cc9e6a567$var$textStyles = null;
var $643b6d5cc9e6a567$var$truncatedTextStyles = null;
var $643b6d5cc9e6a567$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($4fc1653ce3318864$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($3e782882bdbdb208$exports)));
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $iRmtv.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement(Icon, {
        label: appearance,
        color: $643b6d5cc9e6a567$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $643b6d5cc9e6a567$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $007dd3816635191b$export$33ffd74ebf07f060)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return /*#__PURE__*/ $7fPBF.createElement("h1", {
        "data-testid": testId,
        className: (0, $iRmtv.default)([
            "_zulpu2gc _11c8lodh _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ])
    }, appearance && /*#__PURE__*/ $7fPBF.createElement($643b6d5cc9e6a567$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ $7fPBF.createElement("span", {
        id: titleId,
        "data-testid": testId && "".concat(testId, "-text"),
        className: (0, $iRmtv.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _slp31hna",
            !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
var $643b6d5cc9e6a567$export$2e2bcd8739ae039 = $643b6d5cc9e6a567$var$ModalTitle;


var $7fPBF = parcelRequire("7fPBF");

/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $61dd53007c997406$var$ModalTransition = function ModalTransition(props) {
    var _props$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a1ad98f67aabe587$export$2e2bcd8739ae039), {
        appear: true
    }, (_props$children = props.children) !== null && _props$children !== void 0 ? _props$children : null);
};
var $61dd53007c997406$export$2e2bcd8739ae039 = $61dd53007c997406$var$ModalTransition;



var $7fPBF = parcelRequire("7fPBF");






const $ab16c582615dabed$var$ConsentDeclinePrDialog = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const dialogPayload = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$e15e41f6dd0733a8));
    const acceptHandler = (0, $7fPBF.useCallback)(async ()=>{
        var _dialogPayload_update;
        (0, $0e08eda71bb24540$export$ee3c89fcd945a704)({
            source: (_dialogPayload_update = dialogPayload.update) === null || _dialogPayload_update === void 0 ? void 0 : _dialogPayload_update.sourceItem,
            componentName: 'modal'
        });
        // send originating request
        if (dialogPayload.update !== null) dispatch((0, $3d2cac913f314860$export$807cff22f0457821)(dialogPayload.update));
        // close dialog
        dispatch((0, $3d2cac913f314860$export$cab60deb7aecd81e)({
            showDialog: false
        }));
    }, [
        dispatch,
        dialogPayload
    ]);
    const cancelHandler = (0, $7fPBF.useCallback)(()=>{
        var _dialogPayload_update;
        (0, $0e08eda71bb24540$export$76b1ce7baa042b11)({
            source: (_dialogPayload_update = dialogPayload.update) === null || _dialogPayload_update === void 0 ? void 0 : _dialogPayload_update.sourceItem,
            componentName: 'modal'
        });
        // close dialog
        dispatch((0, $3d2cac913f314860$export$cab60deb7aecd81e)({
            showDialog: false
        }));
    }, [
        dispatch,
        dialogPayload
    ]);
    const actions = [
        {
            text: translate((0, $447ba15143f7eed7$exports).CONSENT_DECLINE_PR_ACCEPT_BUTTON_LABEL),
            onClick: acceptHandler,
            autoFocus: true,
            appearance: 'warning',
            testId: 'consent-decline-pr-accept-button'
        },
        {
            text: translate((0, $447ba15143f7eed7$exports).CONSENT_DECLINE_PR_CANCEL_BUTTON_LABEL),
            onClick: cancelHandler,
            appearance: 'subtle',
            testId: 'consent-decline-pr-cancel-button'
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $61dd53007c997406$export$2e2bcd8739ae039), {
        children: dialogPayload.showDialog && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $95611d2ac5b62126$export$2e2bcd8739ae039), {
            onClose: cancelHandler,
            testId: "consentDeclinePr",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $78ffec079aff50d9$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $643b6d5cc9e6a567$export$2e2bcd8739ae039), {
                        appearance: 'warning',
                        children: translate((0, $447ba15143f7eed7$exports).CONSENT_DECLINE_PR_DIALOG_LABEL)
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b3739a2c2476e4e5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        dangerouslySetInnerHTML: {
                            __html: translate((0, $447ba15143f7eed7$exports).CONSENT_DECLINE_PR_DIALOG_MESSAGE)
                        }
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $845716ea19676e23$export$2e2bcd8739ae039), {
                    children: actions.map((a)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                            appearance: a.appearance,
                            onClick: a.onClick,
                            autoFocus: a.autoFocus,
                            testId: a.testId,
                            children: a.text
                        }, a.testId))
                })
            ]
        })
    });
};
var $ab16c582615dabed$export$2e2bcd8739ae039 = $ab16c582615dabed$var$ConsentDeclinePrDialog;







var $7fPBF = parcelRequire("7fPBF");








const $b9140ff8d659df65$var$ConsentDialog = ()=>{
    var _dialogPayload_update, _dialogPayload_update1;
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const dialogPayload = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$5bb16d4fc4eb5b53));
    const currentGmoi = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$f26c97331adc89d5)('consents', 'generalMarketingOptIn'));
    const updateKeys = (0, $7fPBF.useMemo)(()=>[], []);
    let message = '';
    if (((_dialogPayload_update = dialogPayload.update) === null || _dialogPayload_update === void 0 ? void 0 : _dialogPayload_update.sourceGroup) === 'product_recommendations') {
        if (currentGmoi !== (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON) {
            message = translate((0, $447ba15143f7eed7$exports).CONSENT_DIALOG_GMOI_MESSAGE);
            updateKeys.push('generalMarketingOptIn');
        }
    } else if (((_dialogPayload_update1 = dialogPayload.update) === null || _dialogPayload_update1 === void 0 ? void 0 : _dialogPayload_update1.sourceGroup) === 'consents') {
        if (dialogPayload.update.sourceItem === 'generalMarketingOptIn') {
            message = translate((0, $447ba15143f7eed7$exports).CONSENT_DIALOG_GMOI_MESSAGE);
            updateKeys.push('generalMarketingOptIn');
        } else if (dialogPayload.update.sourceItem === undefined) {
            if (dialogPayload.update.keys.length === 1 && dialogPayload.update.keys[0] === 'generalMarketingOptIn') message = translate((0, $447ba15143f7eed7$exports).CONSENT_DIALOG_GMOI_MESSAGE);
            for (const item of dialogPayload.update.keys)updateKeys.push(item);
        }
    }
    const acceptHandler = (0, $7fPBF.useCallback)(async ()=>{
        var _dialogPayload_update, _dialogPayload_update1, _dialogPayload_update2, _dialogPayload_update3, _dialogPayload_update4;
        const sourceItem = (_dialogPayload_update = dialogPayload.update) === null || _dialogPayload_update === void 0 ? void 0 : _dialogPayload_update.sourceItem;
        const sourceGroup = (_dialogPayload_update1 = dialogPayload.update) === null || _dialogPayload_update1 === void 0 ? void 0 : _dialogPayload_update1.sourceGroup;
        const sourceTab = (_dialogPayload_update2 = dialogPayload.update) === null || _dialogPayload_update2 === void 0 ? void 0 : _dialogPayload_update2.sourceTab;
        (0, $0e08eda71bb24540$export$1ee474b7e28ef3c0)({
            source: sourceItem,
            groupName: sourceGroup,
            componentName: 'modal'
        });
        if (sourceGroup === 'product_recommendations') {
            if (sourceItem) (0, $0e08eda71bb24540$export$b2d5c41c71279068)(true, {
                source: sourceItem
            });
            else (0, $0e08eda71bb24540$export$19e5a6bca6f03118)(true, {
                groupName: sourceGroup,
                tabName: sourceTab
            });
        }
        // accept consents and originating request
        const keys = [];
        keys.push(...updateKeys);
        if (dialogPayload.update !== undefined && dialogPayload.update !== null) keys.push(...dialogPayload.update.keys);
        dispatch((0, $3d2cac913f314860$export$807cff22f0457821)({
            keys: keys,
            state: (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true,
            bypassConsentCheck: false,
            bypassConsentDeclinePrCheck: false,
            skipNotification: false,
            sourceGroup: (_dialogPayload_update3 = dialogPayload.update) === null || _dialogPayload_update3 === void 0 ? void 0 : _dialogPayload_update3.sourceGroup,
            sourceItem: (_dialogPayload_update4 = dialogPayload.update) === null || _dialogPayload_update4 === void 0 ? void 0 : _dialogPayload_update4.sourceItem
        }));
        // close dialog
        dispatch((0, $3d2cac913f314860$export$6b7ef6c2de46cbd4)({
            showDialog: false
        }));
    }, [
        dispatch,
        dialogPayload,
        updateKeys
    ]);
    const cancelHandler = (0, $7fPBF.useCallback)(()=>{
        var _dialogPayload_update, _dialogPayload_update1;
        (0, $0e08eda71bb24540$export$f9f36241b679fafe)({
            source: (_dialogPayload_update = dialogPayload.update) === null || _dialogPayload_update === void 0 ? void 0 : _dialogPayload_update.sourceItem,
            groupName: (_dialogPayload_update1 = dialogPayload.update) === null || _dialogPayload_update1 === void 0 ? void 0 : _dialogPayload_update1.sourceGroup,
            componentName: 'modal'
        });
        // close dialog
        dispatch((0, $3d2cac913f314860$export$6b7ef6c2de46cbd4)({
            showDialog: false
        }));
    }, [
        dispatch,
        dialogPayload
    ]);
    const actions = [
        {
            text: translate((0, $447ba15143f7eed7$exports).CONSENT_DIALOG_ACCEPT_BUTTON_LABEL),
            onClick: acceptHandler,
            autoFocus: true,
            appearance: 'primary',
            testId: 'consent-dialog-accept-button'
        },
        {
            text: translate((0, $447ba15143f7eed7$exports).CONSENT_DIALOG_DECLINE_BUTTON_LABEL),
            onClick: cancelHandler,
            appearance: 'subtle',
            testId: 'consent-dialog-cancel-button'
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $61dd53007c997406$export$2e2bcd8739ae039), {
        children: dialogPayload.showDialog && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $95611d2ac5b62126$export$2e2bcd8739ae039), {
            onClose: cancelHandler,
            testId: "consentDialog",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $78ffec079aff50d9$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $643b6d5cc9e6a567$export$2e2bcd8739ae039), {
                        children: translate((0, $447ba15143f7eed7$exports).CONSENT_DIALOG_LABEL)
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b3739a2c2476e4e5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        dangerouslySetInnerHTML: {
                            __html: message
                        }
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $845716ea19676e23$export$2e2bcd8739ae039), {
                    children: actions.map((a)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                            appearance: a.appearance,
                            onClick: a.onClick,
                            autoFocus: a.autoFocus,
                            testId: a.testId,
                            children: a.text
                        }, a.testId))
                })
            ]
        })
    });
};
var $b9140ff8d659df65$export$2e2bcd8739ae039 = $b9140ff8d659df65$var$ConsentDialog;







var $7fPBF = parcelRequire("7fPBF");







const $68c6614e902c1d6d$var$GlobalUnsubscribeDialog = ({ onUnsubscribeClick: onUnsubscribeClick })=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const dialogPayload = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$4c4595253c03ba56));
    const acceptHandler = (0, $7fPBF.useCallback)(async ()=>{
        onUnsubscribeClick();
        // Close dialog
        dispatch((0, $3d2cac913f314860$export$3bb76b2ce1d4f171)({
            showDialog: false
        }));
    }, [
        dispatch,
        onUnsubscribeClick
    ]);
    const cancelHandler = (0, $7fPBF.useCallback)(()=>{
        (0, $0e08eda71bb24540$export$11887f10ee02c881)();
        // Close dialog
        dispatch((0, $3d2cac913f314860$export$3bb76b2ce1d4f171)({
            showDialog: false
        }));
    }, [
        dispatch
    ]);
    const actions = [
        {
            text: translate((0, $447ba15143f7eed7$exports).GLOBAL_UNSUBSCRIBE_DIALOG_ACCEPT_BUTTON_LABEL),
            onClick: acceptHandler,
            autoFocus: true,
            appearance: 'primary',
            testId: 'global-unsubscribe-dialog-accept-button'
        },
        {
            text: translate((0, $447ba15143f7eed7$exports).GLOBAL_UNSUBSCRIBE_DIALOG_DECLINE_BUTTON_LABEL),
            onClick: cancelHandler,
            appearance: 'subtle',
            testId: 'global-unsubscribe-dialog-cancel-button'
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $61dd53007c997406$export$2e2bcd8739ae039), {
        children: dialogPayload.showDialog && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $95611d2ac5b62126$export$2e2bcd8739ae039), {
            onClose: cancelHandler,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $78ffec079aff50d9$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $643b6d5cc9e6a567$export$2e2bcd8739ae039), {
                        children: translate((0, $447ba15143f7eed7$exports).GLOBAL_UNSUBSCRIBE_DIALOG_LABEL)
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b3739a2c2476e4e5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        dangerouslySetInnerHTML: {
                            __html: translate((0, $447ba15143f7eed7$exports).GLOBAL_UNSUBSCRIBE_DIALOG_MESSAGE)
                        }
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $845716ea19676e23$export$2e2bcd8739ae039), {
                    children: actions.map((a)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                            appearance: a.appearance,
                            onClick: a.onClick,
                            autoFocus: a.autoFocus,
                            testId: a.testId,
                            children: a.text
                        }, a.testId))
                })
            ]
        })
    });
};
var $68c6614e902c1d6d$export$2e2bcd8739ae039 = $68c6614e902c1d6d$var$GlobalUnsubscribeDialog;






var $7fPBF = parcelRequire("7fPBF");







const $8e2882318f59e87f$var$DoubleOptInDialog = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const dialogPayload = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$aa0ab7810228523b));
    const acceptHandler = (0, $7fPBF.useCallback)(async ()=>{
        (0, $0e08eda71bb24540$export$203cbc4ee16257d7)();
        // Close dialog
        dispatch((0, $3d2cac913f314860$export$71d5718099bcf953)({
            showDialog: false
        }));
    }, [
        dispatch
    ]);
    const actions = [
        {
            text: translate((0, $447ba15143f7eed7$exports).DOUBLE_OPT_IN_DIALOG_ACCEPT_BUTTON_LABEL),
            onClick: acceptHandler,
            autoFocus: true,
            appearance: 'primary',
            testId: 'double-opt-in-dialog-accept-button'
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $61dd53007c997406$export$2e2bcd8739ae039), {
        children: dialogPayload.showDialog && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $95611d2ac5b62126$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $78ffec079aff50d9$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $643b6d5cc9e6a567$export$2e2bcd8739ae039), {
                        children: translate((0, $447ba15143f7eed7$exports).DOUBLE_OPT_IN_DIALOG_LABEL)
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b3739a2c2476e4e5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        dangerouslySetInnerHTML: {
                            __html: translate((0, $447ba15143f7eed7$exports).DOUBLE_OPT_IN_DIALOG_MESSAGE)
                        }
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $845716ea19676e23$export$2e2bcd8739ae039), {
                    children: actions.map((a)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                            appearance: a.appearance,
                            onClick: a.onClick,
                            autoFocus: a.autoFocus,
                            testId: a.testId,
                            children: a.text
                        }, a.testId))
                })
            ]
        })
    });
};
var $8e2882318f59e87f$export$2e2bcd8739ae039 = $8e2882318f59e87f$var$DoubleOptInDialog;






var $7fPBF = parcelRequire("7fPBF");
var $e5f7b614fbcf0ffb$exports = {};
"use strict";
Object.defineProperty($e5f7b614fbcf0ffb$exports, "__esModule", {
    value: true
});
$e5f7b614fbcf0ffb$exports.ConfigMapSchema = $e5f7b614fbcf0ffb$exports.ConfigError = $e5f7b614fbcf0ffb$exports.ConfigCollection = $e5f7b614fbcf0ffb$exports.ConfigClient = void 0;
var $e3102180980df047$exports = {};
"use strict";
Object.defineProperty($e3102180980df047$exports, "__esModule", {
    value: true
});
$e3102180980df047$exports.ConfigClient = void 0;
var $4983e8507bb0e9f6$exports = {};
"use strict";
Object.defineProperty($4983e8507bb0e9f6$exports, "__esModule", {
    value: true
});
$4983e8507bb0e9f6$exports.standardToMap = $4983e8507bb0e9f6$exports.minimalToMap = $4983e8507bb0e9f6$exports.StandardConfigSchema = $4983e8507bb0e9f6$exports.MinimalConfigSchema = $4983e8507bb0e9f6$exports.ConfigMapSchema = $4983e8507bb0e9f6$exports.AnyConfigSchema = $4983e8507bb0e9f6$exports.ConfigError = $4983e8507bb0e9f6$exports.ConfigCollection = void 0;
var $f101546a3944c6b9$exports = {};
"use strict";
Object.defineProperty($f101546a3944c6b9$exports, "__esModule", {
    value: true
});
$f101546a3944c6b9$exports.ConfigCollection = $f101546a3944c6b9$exports.ParseError = void 0;
var $0dd09485e7441d3b$exports = {};
"use strict";
Object.defineProperty($0dd09485e7441d3b$exports, "__esModule", {
    value: true
});
$0dd09485e7441d3b$exports.ConfigMapSchema = $0dd09485e7441d3b$exports.AnyConfigSchema = $0dd09485e7441d3b$exports.MinimalConfigSchema = $0dd09485e7441d3b$exports.StandardConfigSchema = $0dd09485e7441d3b$exports.ConfigError = void 0;
$0dd09485e7441d3b$exports.minimalToMap = $0dd09485e7441d3b$var$minimalToMap;
$0dd09485e7441d3b$exports.standardToMap = $0dd09485e7441d3b$var$standardToMap;
$0dd09485e7441d3b$exports.mapToMinimal = $0dd09485e7441d3b$var$mapToMinimal;
$0dd09485e7441d3b$exports.mapToStandard = $0dd09485e7441d3b$var$mapToStandard;


var $f40331732e852e18$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($f40331732e852e18$export$7debb50ef11d5e0b || ($f40331732e852e18$export$7debb50ef11d5e0b = {}));
var $f40331732e852e18$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, first, second);
    };
})($f40331732e852e18$export$4aa2142c225fd5c7 || ($f40331732e852e18$export$4aa2142c225fd5c7 = {}));
const $f40331732e852e18$export$5716da67bfaa244d = $f40331732e852e18$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $f40331732e852e18$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $f40331732e852e18$export$5716da67bfaa244d.undefined;
        case "string":
            return $f40331732e852e18$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $f40331732e852e18$export$5716da67bfaa244d.nan : $f40331732e852e18$export$5716da67bfaa244d.number;
        case "boolean":
            return $f40331732e852e18$export$5716da67bfaa244d.boolean;
        case "function":
            return $f40331732e852e18$export$5716da67bfaa244d.function;
        case "bigint":
            return $f40331732e852e18$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $f40331732e852e18$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $f40331732e852e18$export$5716da67bfaa244d.array;
            if (data === null) return $f40331732e852e18$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $f40331732e852e18$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $f40331732e852e18$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $f40331732e852e18$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $f40331732e852e18$export$5716da67bfaa244d.date;
            return $f40331732e852e18$export$5716da67bfaa244d.object;
        default:
            return $f40331732e852e18$export$5716da67bfaa244d.unknown;
    }
};
const $f40331732e852e18$export$5ba560653e4a1035 = $f40331732e852e18$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $f40331732e852e18$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $f40331732e852e18$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $f40331732e852e18$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $f40331732e852e18$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
}
$f40331732e852e18$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $f40331732e852e18$export$f98dac4b251ab333(issues);
    return error;
};
const $f40331732e852e18$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $f40331732e852e18$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $f40331732e852e18$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$f40331732e852e18$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$f40331732e852e18$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$f40331732e852e18$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $f40331732e852e18$var$overrideErrorMap = $f40331732e852e18$export$341b0b6e0a6f5099;
function $f40331732e852e18$export$1097a8289cfd22d7(map) {
    $f40331732e852e18$var$overrideErrorMap = map;
}
function $f40331732e852e18$export$32f27c719778d4c4() {
    return $f40331732e852e18$var$overrideErrorMap;
}
const $f40331732e852e18$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, issueData), {
        path: fullPath
    });
    if (issueData.message !== undefined) return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, issueData), {
        path: fullPath,
        message: issueData.message
    });
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, issueData), {
        path: fullPath,
        message: errorMessage
    });
};
const $f40331732e852e18$export$1526d2e05f74572 = [];
function $f40331732e852e18$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $f40331732e852e18$export$32f27c719778d4c4();
    const issue = $f40331732e852e18$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $f40331732e852e18$export$341b0b6e0a6f5099 ? undefined : $f40331732e852e18$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $f40331732e852e18$export$5b20a5c3d05c1f6f {
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
    constructor(){
        this.value = "valid";
    }
}
const $f40331732e852e18$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $f40331732e852e18$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $f40331732e852e18$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $f40331732e852e18$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $f40331732e852e18$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $f40331732e852e18$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $f40331732e852e18$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $f40331732e852e18$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f40331732e852e18$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $f40331732e852e18$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($f40331732e852e18$var$errorUtil || ($f40331732e852e18$var$errorUtil = {}));
var $f40331732e852e18$var$_ZodEnum_cache, $f40331732e852e18$var$_ZodNativeEnum_cache;
class $f40331732e852e18$var$ParseInputLazyPath {
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
}
const $f40331732e852e18$var$handleResult = (ctx, result)=>{
    if ($f40331732e852e18$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $f40331732e852e18$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $f40331732e852e18$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $f40331732e852e18$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $f40331732e852e18$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $f40331732e852e18$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $f40331732e852e18$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $f40331732e852e18$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($f40331732e852e18$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $f40331732e852e18$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $f40331732e852e18$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        var _a, _b;
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $f40331732e852e18$export$3e9057828ebd5c7a(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return $f40331732e852e18$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if ((_b = (_a = err === null || err === void 0 ? void 0 : err.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>$f40331732e852e18$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $f40331732e852e18$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($f40331732e852e18$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $f40331732e852e18$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    code: $f40331732e852e18$export$5ba560653e4a1035.custom
                }, getIssueProperties(val)));
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $f40331732e852e18$export$a60af00cc0ce2582({
            schema: this,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $f40331732e852e18$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $f40331732e852e18$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $f40331732e852e18$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $f40331732e852e18$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $f40331732e852e18$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $f40331732e852e18$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $f40331732e852e18$export$a60af00cc0ce2582((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $f40331732e852e18$var$processCreateParams(this._def)), {
            schema: this,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        }));
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $f40331732e852e18$export$bb19b37874861e7e((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $f40331732e852e18$var$processCreateParams(this._def)), {
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodDefault
        }));
    }
    brand() {
        return new $f40331732e852e18$export$66b0c798a395271f((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodBranded,
            type: this
        }, $f40331732e852e18$var$processCreateParams(this._def)));
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $f40331732e852e18$export$75a44ec6249ac76b((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $f40331732e852e18$var$processCreateParams(this._def)), {
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodCatch
        }));
    }
    describe(description) {
        const This = this.constructor;
        return new This((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            description: description
        }));
    }
    pipe(target) {
        return $f40331732e852e18$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $f40331732e852e18$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
}
const $f40331732e852e18$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $f40331732e852e18$var$cuid2Regex = /^[0-9a-z]+$/;
const $f40331732e852e18$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $f40331732e852e18$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $f40331732e852e18$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $f40331732e852e18$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $f40331732e852e18$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $f40331732e852e18$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $f40331732e852e18$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $f40331732e852e18$var$emojiRegex;
// faster, simpler, safer
const $f40331732e852e18$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $f40331732e852e18$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $f40331732e852e18$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $f40331732e852e18$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $f40331732e852e18$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $f40331732e852e18$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $f40331732e852e18$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $f40331732e852e18$var$dateRegex = new RegExp(`^${$f40331732e852e18$var$dateRegexSource}$`);
function $f40331732e852e18$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $f40331732e852e18$var$timeRegex(args) {
    return new RegExp(`^${$f40331732e852e18$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $f40331732e852e18$export$a4b563879add27a(args) {
    let regex = `${$f40331732e852e18$var$dateRegexSource}T${$f40331732e852e18$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $f40331732e852e18$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $f40331732e852e18$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $f40331732e852e18$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $f40331732e852e18$var$isValidJWT(jwt, alg) {
    if (!$f40331732e852e18$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if (!decoded.typ || !decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch (_a) {
        return false;
    }
}
function $f40331732e852e18$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $f40331732e852e18$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $f40331732e852e18$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $f40331732e852e18$export$1230eb29b8d3b502 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const status = new $f40331732e852e18$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$f40331732e852e18$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$f40331732e852e18$var$emojiRegex) $f40331732e852e18$var$emojiRegex = new RegExp($f40331732e852e18$var$_emojiRegex, "u");
                if (!$f40331732e852e18$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$f40331732e852e18$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$f40331732e852e18$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$f40331732e852e18$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$f40331732e852e18$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$f40331732e852e18$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $f40331732e852e18$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $f40331732e852e18$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $f40331732e852e18$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$f40331732e852e18$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$f40331732e852e18$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$f40331732e852e18$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "jwt",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$f40331732e852e18$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "cidr",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$f40331732e852e18$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$f40331732e852e18$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "base64url",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            validation: validation,
            code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    _addCheck(check) {
        return new $f40331732e852e18$export$1230eb29b8d3b502((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    email(message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "email"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    url(message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "url"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    emoji(message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "emoji"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    uuid(message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "uuid"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    nanoid(message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "nanoid"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    cuid(message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "cuid"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    cuid2(message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "cuid2"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    ulid(message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "ulid"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    base64(message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "base64"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "base64url"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    jwt(options) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "jwt"
        }, $f40331732e852e18$var$errorUtil.errToObj(options)));
    }
    ip(options) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "ip"
        }, $f40331732e852e18$var$errorUtil.errToObj(options)));
    }
    cidr(options) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "cidr"
        }, $f40331732e852e18$var$errorUtil.errToObj(options)));
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false
        }, $f40331732e852e18$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision
        }, $f40331732e852e18$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    duration(message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "duration"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    regex(regex, message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "regex",
            regex: regex
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    includes(value, options) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position
        }, $f40331732e852e18$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    startsWith(value, message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "startsWith",
            value: value
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    endsWith(value, message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "endsWith",
            value: value
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    min(minLength, message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "min",
            value: minLength
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    max(maxLength, message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "max",
            value: maxLength
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    length(len, message) {
        return this._addCheck((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            kind: "length",
            value: len
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, $f40331732e852e18$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $f40331732e852e18$export$1230eb29b8d3b502((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        }));
    }
    toLowerCase() {
        return new $f40331732e852e18$export$1230eb29b8d3b502((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        }));
    }
    toUpperCase() {
        return new $f40331732e852e18$export$1230eb29b8d3b502((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        }));
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$f40331732e852e18$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $f40331732e852e18$export$1230eb29b8d3b502((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        checks: [],
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $f40331732e852e18$var$processCreateParams(params)));
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $f40331732e852e18$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $f40331732e852e18$export$5b070a55c0c43e09 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $f40331732e852e18$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$f40331732e852e18$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($f40331732e852e18$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $f40331732e852e18$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $f40331732e852e18$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $f40331732e852e18$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $f40331732e852e18$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $f40331732e852e18$export$5b070a55c0c43e09((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $f40331732e852e18$var$errorUtil.toString(message)
                }
            ]
        }));
    }
    _addCheck(check) {
        return new $f40331732e852e18$export$5b070a55c0c43e09((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $f40331732e852e18$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
}
$f40331732e852e18$export$5b070a55c0c43e09.create = (params)=>{
    return new $f40331732e852e18$export$5b070a55c0c43e09((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        checks: [],
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$67d741fd70ff98f4 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch (_a) {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new $f40331732e852e18$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        $f40331732e852e18$export$db7caee60e5d514d(ctx, {
            code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
            expected: $f40331732e852e18$export$5716da67bfaa244d.bigint,
            received: ctx.parsedType
        });
        return $f40331732e852e18$export$9a105a556e65c2c0;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $f40331732e852e18$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $f40331732e852e18$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $f40331732e852e18$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $f40331732e852e18$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $f40331732e852e18$export$67d741fd70ff98f4((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $f40331732e852e18$var$errorUtil.toString(message)
                }
            ]
        }));
    }
    _addCheck(check) {
        return new $f40331732e852e18$export$67d741fd70ff98f4((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
}
$f40331732e852e18$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $f40331732e852e18$export$67d741fd70ff98f4((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        checks: [],
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$723d146f80596191 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
}
$f40331732e852e18$export$723d146f80596191.create = (params)=>{
    return new $f40331732e852e18$export$723d146f80596191((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$e974be33bdc55521 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_date
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const status = new $f40331732e852e18$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $f40331732e852e18$export$e974be33bdc55521((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$f40331732e852e18$export$e974be33bdc55521.create = (params)=>{
    return new $f40331732e852e18$export$e974be33bdc55521((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodDate
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$bcc3b40f6b638044 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
}
$f40331732e852e18$export$bcc3b40f6b638044.create = (params)=>{
    return new $f40331732e852e18$export$bcc3b40f6b638044((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodSymbol
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$4e780e961c30340d extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
}
$f40331732e852e18$export$4e780e961c30340d.create = (params)=>{
    return new $f40331732e852e18$export$4e780e961c30340d((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodUndefined
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$a96281f914484f2d extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
}
$f40331732e852e18$export$a96281f914484f2d.create = (params)=>{
    return new $f40331732e852e18$export$a96281f914484f2d((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodNull
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$b9d1edb536b4e4eb extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
}
$f40331732e852e18$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $f40331732e852e18$export$b9d1edb536b4e4eb((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodAny
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$ef3b1bb1630977ae extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
}
$f40331732e852e18$export$ef3b1bb1630977ae.create = (params)=>{
    return new $f40331732e852e18$export$ef3b1bb1630977ae((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodUnknown
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$1e576a20c3ce9fb5 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $f40331732e852e18$export$db7caee60e5d514d(ctx, {
            code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
            expected: $f40331732e852e18$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $f40331732e852e18$export$9a105a556e65c2c0;
    }
}
$f40331732e852e18$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $f40331732e852e18$export$1e576a20c3ce9fb5((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodNever
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$7d39f5df85f21031 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
}
$f40331732e852e18$export$7d39f5df85f21031.create = (params)=>{
    return new $f40331732e852e18$export$7d39f5df85f21031((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodVoid
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$7acfc3e64785411 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.array) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $f40331732e852e18$export$5ba560653e4a1035.too_big : $f40331732e852e18$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $f40331732e852e18$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $f40331732e852e18$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $f40331732e852e18$export$7acfc3e64785411((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            minLength: {
                value: minLength,
                message: $f40331732e852e18$var$errorUtil.toString(message)
            }
        }));
    }
    max(maxLength, message) {
        return new $f40331732e852e18$export$7acfc3e64785411((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            maxLength: {
                value: maxLength,
                message: $f40331732e852e18$var$errorUtil.toString(message)
            }
        }));
    }
    length(len, message) {
        return new $f40331732e852e18$export$7acfc3e64785411((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            exactLength: {
                value: len,
                message: $f40331732e852e18$var$errorUtil.toString(message)
            }
        }));
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$f40331732e852e18$export$7acfc3e64785411.create = (schema, params)=>{
    return new $f40331732e852e18$export$7acfc3e64785411((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodArray
    }, $f40331732e852e18$var$processCreateParams(params)));
};
function $f40331732e852e18$var$deepPartialify(schema) {
    if (schema instanceof $f40331732e852e18$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $f40331732e852e18$export$aa56fec1e9d629b8.create($f40331732e852e18$var$deepPartialify(fieldSchema));
        }
        return new $f40331732e852e18$export$736315c5b55efbad((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, schema._def), {
            shape: ()=>newShape
        }));
    } else if (schema instanceof $f40331732e852e18$export$7acfc3e64785411) return new $f40331732e852e18$export$7acfc3e64785411((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, schema._def), {
        type: $f40331732e852e18$var$deepPartialify(schema.element)
    }));
    else if (schema instanceof $f40331732e852e18$export$aa56fec1e9d629b8) return $f40331732e852e18$export$aa56fec1e9d629b8.create($f40331732e852e18$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $f40331732e852e18$export$aaac0b8b429cef5) return $f40331732e852e18$export$aaac0b8b429cef5.create($f40331732e852e18$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $f40331732e852e18$export$e2a18bb771d8e6a3) return $f40331732e852e18$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$f40331732e852e18$var$deepPartialify(item)));
    else return schema;
}
class $f40331732e852e18$export$736315c5b55efbad extends $f40331732e852e18$export$19342e026b58ebb7 {
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $f40331732e852e18$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $f40331732e852e18$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $f40331732e852e18$var$errorUtil.errToObj;
        return new $f40331732e852e18$export$736315c5b55efbad((0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            unknownKeys: "strict"
        }), message !== undefined ? {
            errorMap: (issue, ctx)=>{
                var _a, _b, _c, _d;
                const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                if (issue.code === "unrecognized_keys") return {
                    message: (_d = $f40331732e852e18$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                };
                return {
                    message: defaultError
                };
            }
        } : {}));
    }
    strip() {
        return new $f40331732e852e18$export$736315c5b55efbad((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            unknownKeys: "strip"
        }));
    }
    passthrough() {
        return new $f40331732e852e18$export$736315c5b55efbad((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            unknownKeys: "passthrough"
        }));
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $f40331732e852e18$export$736315c5b55efbad((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            shape: ()=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def.shape(), augmentation)
        }));
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $f40331732e852e18$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def.shape(), merging._def.shape()),
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $f40331732e852e18$export$736315c5b55efbad((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            catchall: index
        }));
    }
    pick(mask) {
        const shape = {};
        $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $f40331732e852e18$export$736315c5b55efbad((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            shape: ()=>shape
        }));
    }
    omit(mask) {
        const shape = {};
        $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $f40331732e852e18$export$736315c5b55efbad((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            shape: ()=>shape
        }));
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $f40331732e852e18$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $f40331732e852e18$export$736315c5b55efbad((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            shape: ()=>newShape
        }));
    }
    required(mask) {
        const newShape = {};
        $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $f40331732e852e18$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $f40331732e852e18$export$736315c5b55efbad((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            shape: ()=>newShape
        }));
    }
    keyof() {
        return $f40331732e852e18$var$createZodEnum($f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
}
$f40331732e852e18$export$736315c5b55efbad.create = (shape, params)=>{
    return new $f40331732e852e18$export$736315c5b55efbad((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $f40331732e852e18$export$1e576a20c3ce9fb5.create(),
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodObject
    }, $f40331732e852e18$var$processCreateParams(params)));
};
$f40331732e852e18$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $f40331732e852e18$export$736315c5b55efbad((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $f40331732e852e18$export$1e576a20c3ce9fb5.create(),
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodObject
    }, $f40331732e852e18$var$processCreateParams(params)));
};
$f40331732e852e18$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $f40331732e852e18$export$736315c5b55efbad((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        shape: shape,
        unknownKeys: "strip",
        catchall: $f40331732e852e18$export$1e576a20c3ce9fb5.create(),
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodObject
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$a8b236cb5070a311 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $f40331732e852e18$export$f98dac4b251ab333(result.ctx.common.issues));
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ctx), {
                common: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ctx.common), {
                    issues: []
                }),
                parent: null
            });
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ctx), {
                    common: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ctx.common), {
                        issues: []
                    }),
                    parent: null
                });
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $f40331732e852e18$export$f98dac4b251ab333(issues));
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$f40331732e852e18$export$a8b236cb5070a311.create = (types, params)=>{
    return new $f40331732e852e18$export$a8b236cb5070a311((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        options: types,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodUnion
    }, $f40331732e852e18$var$processCreateParams(params)));
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $f40331732e852e18$var$getDiscriminator = (type)=>{
    if (type instanceof $f40331732e852e18$export$378d0cfce37406e6) return $f40331732e852e18$var$getDiscriminator(type.schema);
    else if (type instanceof $f40331732e852e18$export$a60af00cc0ce2582) return $f40331732e852e18$var$getDiscriminator(type.innerType());
    else if (type instanceof $f40331732e852e18$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $f40331732e852e18$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $f40331732e852e18$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $f40331732e852e18$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $f40331732e852e18$export$bb19b37874861e7e) return $f40331732e852e18$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $f40331732e852e18$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $f40331732e852e18$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $f40331732e852e18$export$aa56fec1e9d629b8) return [
        undefined,
        ...$f40331732e852e18$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $f40331732e852e18$export$aaac0b8b429cef5) return [
        null,
        ...$f40331732e852e18$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $f40331732e852e18$export$66b0c798a395271f) return $f40331732e852e18$var$getDiscriminator(type.unwrap());
    else if (type instanceof $f40331732e852e18$export$5d1f7ef05c4e493a) return $f40331732e852e18$var$getDiscriminator(type.unwrap());
    else if (type instanceof $f40331732e852e18$export$75a44ec6249ac76b) return $f40331732e852e18$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $f40331732e852e18$export$5ef2424805ac76a3 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.object) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $f40331732e852e18$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $f40331732e852e18$export$5ef2424805ac76a3((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap
        }, $f40331732e852e18$var$processCreateParams(params)));
    }
}
function $f40331732e852e18$var$mergeValues(a, b) {
    const aType = $f40331732e852e18$export$3e9057828ebd5c7a(a);
    const bType = $f40331732e852e18$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $f40331732e852e18$export$5716da67bfaa244d.object && bType === $f40331732e852e18$export$5716da67bfaa244d.object) {
        const bKeys = $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, a, b);
        for (const key of sharedKeys){
            const sharedValue = $f40331732e852e18$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $f40331732e852e18$export$5716da67bfaa244d.array && bType === $f40331732e852e18$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $f40331732e852e18$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $f40331732e852e18$export$5716da67bfaa244d.date && bType === $f40331732e852e18$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $f40331732e852e18$export$c02deaf0bb5203d4 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($f40331732e852e18$export$afa861e3c5730743(parsedLeft) || $f40331732e852e18$export$afa861e3c5730743(parsedRight)) return $f40331732e852e18$export$9a105a556e65c2c0;
            const merged = $f40331732e852e18$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    code: $f40331732e852e18$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $f40331732e852e18$export$9a105a556e65c2c0;
            }
            if ($f40331732e852e18$export$910b6cdd390341b3(parsedLeft) || $f40331732e852e18$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$f40331732e852e18$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $f40331732e852e18$export$c02deaf0bb5203d4((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        left: left,
        right: right,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodIntersection
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$e2a18bb771d8e6a3 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.array) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $f40331732e852e18$export$e2a18bb771d8e6a3((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            rest: rest
        }));
    }
}
$f40331732e852e18$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $f40331732e852e18$export$e2a18bb771d8e6a3((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        items: schemas,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodTuple,
        rest: null
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$a2acc09968cb4b7f extends $f40331732e852e18$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.object) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $f40331732e852e18$export$19342e026b58ebb7) return new $f40331732e852e18$export$a2acc09968cb4b7f((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            keyType: first,
            valueType: second,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodRecord
        }, $f40331732e852e18$var$processCreateParams(third)));
        return new $f40331732e852e18$export$a2acc09968cb4b7f((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            keyType: $f40331732e852e18$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodRecord
        }, $f40331732e852e18$var$processCreateParams(second)));
    }
}
class $f40331732e852e18$export$163b6a2b712d9542 extends $f40331732e852e18$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.map) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$f40331732e852e18$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $f40331732e852e18$export$163b6a2b712d9542((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        valueType: valueType,
        keyType: keyType,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodMap
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$977057706f816712 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.set) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $f40331732e852e18$export$977057706f816712((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            minSize: {
                value: minSize,
                message: $f40331732e852e18$var$errorUtil.toString(message)
            }
        }));
    }
    max(maxSize, message) {
        return new $f40331732e852e18$export$977057706f816712((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            maxSize: {
                value: maxSize,
                message: $f40331732e852e18$var$errorUtil.toString(message)
            }
        }));
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$f40331732e852e18$export$977057706f816712.create = (valueType, params)=>{
    return new $f40331732e852e18$export$977057706f816712((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodSet
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$d4602ba55673f53c extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.function) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $f40331732e852e18$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $f40331732e852e18$export$32f27c719778d4c4(),
                    $f40331732e852e18$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $f40331732e852e18$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $f40331732e852e18$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $f40331732e852e18$export$32f27c719778d4c4(),
                    $f40331732e852e18$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $f40331732e852e18$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $f40331732e852e18$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $f40331732e852e18$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $f40331732e852e18$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $f40331732e852e18$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $f40331732e852e18$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $f40331732e852e18$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $f40331732e852e18$export$d4602ba55673f53c((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            args: $f40331732e852e18$export$e2a18bb771d8e6a3.create(items).rest($f40331732e852e18$export$ef3b1bb1630977ae.create())
        }));
    }
    returns(returnType) {
        return new $f40331732e852e18$export$d4602ba55673f53c((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def), {
            returns: returnType
        }));
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $f40331732e852e18$export$d4602ba55673f53c((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            args: args ? args : $f40331732e852e18$export$e2a18bb771d8e6a3.create([]).rest($f40331732e852e18$export$ef3b1bb1630977ae.create()),
            returns: returns || $f40331732e852e18$export$ef3b1bb1630977ae.create(),
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodFunction
        }, $f40331732e852e18$var$processCreateParams(params)));
    }
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
}
class $f40331732e852e18$export$378d0cfce37406e6 extends $f40331732e852e18$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$f40331732e852e18$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $f40331732e852e18$export$378d0cfce37406e6((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        getter: getter,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodLazy
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$7e44096782a165d3 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$f40331732e852e18$export$7e44096782a165d3.create = (value, params)=>{
    return new $f40331732e852e18$export$7e44096782a165d3((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        value: value,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodLiteral
    }, $f40331732e852e18$var$processCreateParams(params)));
};
function $f40331732e852e18$var$createZodEnum(values, params) {
    return new $f40331732e852e18$export$d325d1f0e1c20179((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        values: values,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodEnum
    }, $f40331732e852e18$var$processCreateParams(params)));
}
class $f40331732e852e18$export$d325d1f0e1c20179 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                expected: $f40331732e852e18$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (!$f40331732e852e18$var$__classPrivateFieldGet(this, $f40331732e852e18$var$_ZodEnum_cache, "f")) $f40331732e852e18$var$__classPrivateFieldSet(this, $f40331732e852e18$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$f40331732e852e18$var$__classPrivateFieldGet(this, $f40331732e852e18$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $f40331732e852e18$export$d325d1f0e1c20179.create(values, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def, newDef));
    }
    exclude(values, newDef = this._def) {
        return $f40331732e852e18$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._def, newDef));
    }
    constructor(){
        super(...arguments);
        $f40331732e852e18$var$_ZodEnum_cache.set(this, void 0);
    }
}
$f40331732e852e18$var$_ZodEnum_cache = new WeakMap();
$f40331732e852e18$export$d325d1f0e1c20179.create = $f40331732e852e18$var$createZodEnum;
class $f40331732e852e18$export$370b2e8d6d6f5c56 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $f40331732e852e18$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.string && ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.number) {
            const expectedValues = $f40331732e852e18$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                expected: $f40331732e852e18$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (!$f40331732e852e18$var$__classPrivateFieldGet(this, $f40331732e852e18$var$_ZodNativeEnum_cache, "f")) $f40331732e852e18$var$__classPrivateFieldSet(this, $f40331732e852e18$var$_ZodNativeEnum_cache, new Set($f40331732e852e18$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$f40331732e852e18$var$__classPrivateFieldGet(this, $f40331732e852e18$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $f40331732e852e18$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
    constructor(){
        super(...arguments);
        $f40331732e852e18$var$_ZodNativeEnum_cache.set(this, void 0);
    }
}
$f40331732e852e18$var$_ZodNativeEnum_cache = new WeakMap();
$f40331732e852e18$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $f40331732e852e18$export$370b2e8d6d6f5c56((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        values: values,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodNativeEnum
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$3f196b0127d6e50a extends $f40331732e852e18$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $f40331732e852e18$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $f40331732e852e18$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$f40331732e852e18$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $f40331732e852e18$export$3f196b0127d6e50a((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        type: schema,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodPromise
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$a60af00cc0ce2582 extends $f40331732e852e18$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $f40331732e852e18$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $f40331732e852e18$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $f40331732e852e18$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $f40331732e852e18$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $f40331732e852e18$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $f40331732e852e18$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$f40331732e852e18$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$f40331732e852e18$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$f40331732e852e18$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $f40331732e852e18$export$a60af00cc0ce2582((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        schema: schema,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodEffects,
        effect: effect
    }, $f40331732e852e18$var$processCreateParams(params)));
};
$f40331732e852e18$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $f40331732e852e18$export$a60af00cc0ce2582((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodEffects
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$aa56fec1e9d629b8 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $f40331732e852e18$export$5716da67bfaa244d.undefined) return $f40331732e852e18$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f40331732e852e18$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $f40331732e852e18$export$aa56fec1e9d629b8((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        innerType: type,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodOptional
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$aaac0b8b429cef5 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $f40331732e852e18$export$5716da67bfaa244d.null) return $f40331732e852e18$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f40331732e852e18$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $f40331732e852e18$export$aaac0b8b429cef5((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        innerType: type,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodNullable
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$bb19b37874861e7e extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $f40331732e852e18$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$f40331732e852e18$export$bb19b37874861e7e.create = (type, params)=>{
    return new $f40331732e852e18$export$bb19b37874861e7e((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        innerType: type,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$75a44ec6249ac76b extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ctx), {
            common: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ctx.common), {
                issues: []
            })
        });
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, newCtx)
        });
        if ($f40331732e852e18$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $f40331732e852e18$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $f40331732e852e18$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$f40331732e852e18$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $f40331732e852e18$export$75a44ec6249ac76b((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        innerType: type,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$26ccfa0145e8511f extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$f40331732e852e18$export$26ccfa0145e8511f.create = (params)=>{
    return new $f40331732e852e18$export$26ccfa0145e8511f((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodNaN
    }, $f40331732e852e18$var$processCreateParams(params)));
};
const $f40331732e852e18$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $f40331732e852e18$export$66b0c798a395271f extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $f40331732e852e18$export$a3c3ef8a0e95c6da extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $f40331732e852e18$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $f40331732e852e18$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $f40331732e852e18$export$5d1f7ef05c4e493a extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($f40331732e852e18$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $f40331732e852e18$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f40331732e852e18$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $f40331732e852e18$export$5d1f7ef05c4e493a((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        innerType: type,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodReadonly
    }, $f40331732e852e18$var$processCreateParams(params)));
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $f40331732e852e18$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $f40331732e852e18$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $f40331732e852e18$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            var _a, _b;
            if (!r) {
                const params = $f40331732e852e18$var$cleanParams(_params, data);
                const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                ctx.addIssue((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    code: "custom"
                }, params), {
                    fatal: _fatal
                }));
            }
        });
        if (!r) {
            const params = $f40331732e852e18$var$cleanParams(_params, data);
            const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            ctx.addIssue((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                code: "custom"
            }, params), {
                fatal: _fatal
            }));
        }
        return;
    });
    return $f40331732e852e18$export$b9d1edb536b4e4eb.create();
}
const $f40331732e852e18$export$1ee8ee30835eab8b = {
    object: $f40331732e852e18$export$736315c5b55efbad.lazycreate
};
var $f40331732e852e18$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($f40331732e852e18$export$558106ce543bd011 || ($f40331732e852e18$export$558106ce543bd011 = {}));
const $f40331732e852e18$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$f40331732e852e18$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $f40331732e852e18$export$22b082955e083ec3 = $f40331732e852e18$export$1230eb29b8d3b502.create;
const $f40331732e852e18$export$98e628dec113755e = $f40331732e852e18$export$5b070a55c0c43e09.create;
const $f40331732e852e18$export$9e06de0973666692 = $f40331732e852e18$export$26ccfa0145e8511f.create;
const $f40331732e852e18$export$a0f65b52274bcc00 = $f40331732e852e18$export$67d741fd70ff98f4.create;
const $f40331732e852e18$export$4a21f16c33752377 = $f40331732e852e18$export$723d146f80596191.create;
const $f40331732e852e18$export$324d90190a8b822a = $f40331732e852e18$export$e974be33bdc55521.create;
const $f40331732e852e18$export$8f701197936bc2a6 = $f40331732e852e18$export$bcc3b40f6b638044.create;
const $f40331732e852e18$export$1db45310990710a5 = $f40331732e852e18$export$4e780e961c30340d.create;
const $f40331732e852e18$export$7b1b591b262c240 = $f40331732e852e18$export$a96281f914484f2d.create;
const $f40331732e852e18$export$4154a199d7d90455 = $f40331732e852e18$export$b9d1edb536b4e4eb.create;
const $f40331732e852e18$export$19282c40b967aec6 = $f40331732e852e18$export$ef3b1bb1630977ae.create;
const $f40331732e852e18$export$b3e22bcfd64c1022 = $f40331732e852e18$export$1e576a20c3ce9fb5.create;
const $f40331732e852e18$export$490e536ee7389aeb = $f40331732e852e18$export$7d39f5df85f21031.create;
const $f40331732e852e18$export$2f23118c22fb2630 = $f40331732e852e18$export$7acfc3e64785411.create;
const $f40331732e852e18$export$be5493f9613cbbe = $f40331732e852e18$export$736315c5b55efbad.create;
const $f40331732e852e18$export$8fb0df5f40d0b477 = $f40331732e852e18$export$736315c5b55efbad.strictCreate;
const $f40331732e852e18$export$971dd5b0dfd021b6 = $f40331732e852e18$export$a8b236cb5070a311.create;
const $f40331732e852e18$export$4b888e40c4ee26dd = $f40331732e852e18$export$5ef2424805ac76a3.create;
const $f40331732e852e18$export$bc86dfbf7795668c = $f40331732e852e18$export$c02deaf0bb5203d4.create;
const $f40331732e852e18$export$65e3907585753458 = $f40331732e852e18$export$e2a18bb771d8e6a3.create;
const $f40331732e852e18$export$e5185e241753e543 = $f40331732e852e18$export$a2acc09968cb4b7f.create;
const $f40331732e852e18$export$871de8747c9eaa88 = $f40331732e852e18$export$163b6a2b712d9542.create;
const $f40331732e852e18$export$adaa4cf7ef1b65be = $f40331732e852e18$export$977057706f816712.create;
const $f40331732e852e18$export$44e51c8aac7c2deb = $f40331732e852e18$export$d4602ba55673f53c.create;
const $f40331732e852e18$export$488013bae63b21da = $f40331732e852e18$export$378d0cfce37406e6.create;
const $f40331732e852e18$export$c8ec6e1ec9fefcb0 = $f40331732e852e18$export$7e44096782a165d3.create;
const $f40331732e852e18$export$78a99c8d44d72635 = $f40331732e852e18$export$d325d1f0e1c20179.create;
const $f40331732e852e18$export$6fe7eca19ebe5199 = $f40331732e852e18$export$370b2e8d6d6f5c56.create;
const $f40331732e852e18$export$c957ef27a0ebfd4 = $f40331732e852e18$export$3f196b0127d6e50a.create;
const $f40331732e852e18$export$dc573d8a6576cdb3 = $f40331732e852e18$export$a60af00cc0ce2582.create;
const $f40331732e852e18$export$516e28dec6a4b6d4 = $f40331732e852e18$export$aa56fec1e9d629b8.create;
const $f40331732e852e18$export$133fc36489ac9add = $f40331732e852e18$export$aaac0b8b429cef5.create;
const $f40331732e852e18$export$fc37fe19dfda43ee = $f40331732e852e18$export$a60af00cc0ce2582.createWithPreprocess;
const $f40331732e852e18$export$43f28b24e1eb8181 = $f40331732e852e18$export$a3c3ef8a0e95c6da.create;
const $f40331732e852e18$export$3b3d07727c5b702c = ()=>$f40331732e852e18$export$22b082955e083ec3().optional();
const $f40331732e852e18$export$eb150471a61fced6 = ()=>$f40331732e852e18$export$98e628dec113755e().optional();
const $f40331732e852e18$export$269251733cdcbbf1 = ()=>$f40331732e852e18$export$4a21f16c33752377().optional();
const $f40331732e852e18$export$8c14e57e778d3873 = {
    string: (arg)=>$f40331732e852e18$export$1230eb29b8d3b502.create((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg), {
            coerce: true
        })),
    number: (arg)=>$f40331732e852e18$export$5b070a55c0c43e09.create((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg), {
            coerce: true
        })),
    boolean: (arg)=>$f40331732e852e18$export$723d146f80596191.create((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg), {
            coerce: true
        })),
    bigint: (arg)=>$f40331732e852e18$export$67d741fd70ff98f4.create((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg), {
            coerce: true
        })),
    date: (arg)=>$f40331732e852e18$export$e974be33bdc55521.create((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg), {
            coerce: true
        }))
};
const $f40331732e852e18$export$96c94437c95d7862 = $f40331732e852e18$export$9a105a556e65c2c0;
var $f40331732e852e18$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $f40331732e852e18$export$341b0b6e0a6f5099,
    setErrorMap: $f40331732e852e18$export$1097a8289cfd22d7,
    getErrorMap: $f40331732e852e18$export$32f27c719778d4c4,
    makeIssue: $f40331732e852e18$export$244a85fde9c419ed,
    EMPTY_PATH: $f40331732e852e18$export$1526d2e05f74572,
    addIssueToContext: $f40331732e852e18$export$db7caee60e5d514d,
    ParseStatus: $f40331732e852e18$export$5b20a5c3d05c1f6f,
    INVALID: $f40331732e852e18$export$9a105a556e65c2c0,
    DIRTY: $f40331732e852e18$export$325a211da9693fcf,
    OK: $f40331732e852e18$export$c6813a8d51f77eaf,
    isAborted: $f40331732e852e18$export$afa861e3c5730743,
    isDirty: $f40331732e852e18$export$910b6cdd390341b3,
    isValid: $f40331732e852e18$export$1ea939691cdc45b8,
    isAsync: $f40331732e852e18$export$aefee5ebe1dcfd9e,
    get util () {
        return $f40331732e852e18$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $f40331732e852e18$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $f40331732e852e18$export$5716da67bfaa244d,
    getParsedType: $f40331732e852e18$export$3e9057828ebd5c7a,
    ZodType: $f40331732e852e18$export$19342e026b58ebb7,
    datetimeRegex: $f40331732e852e18$export$a4b563879add27a,
    ZodString: $f40331732e852e18$export$1230eb29b8d3b502,
    ZodNumber: $f40331732e852e18$export$5b070a55c0c43e09,
    ZodBigInt: $f40331732e852e18$export$67d741fd70ff98f4,
    ZodBoolean: $f40331732e852e18$export$723d146f80596191,
    ZodDate: $f40331732e852e18$export$e974be33bdc55521,
    ZodSymbol: $f40331732e852e18$export$bcc3b40f6b638044,
    ZodUndefined: $f40331732e852e18$export$4e780e961c30340d,
    ZodNull: $f40331732e852e18$export$a96281f914484f2d,
    ZodAny: $f40331732e852e18$export$b9d1edb536b4e4eb,
    ZodUnknown: $f40331732e852e18$export$ef3b1bb1630977ae,
    ZodNever: $f40331732e852e18$export$1e576a20c3ce9fb5,
    ZodVoid: $f40331732e852e18$export$7d39f5df85f21031,
    ZodArray: $f40331732e852e18$export$7acfc3e64785411,
    ZodObject: $f40331732e852e18$export$736315c5b55efbad,
    ZodUnion: $f40331732e852e18$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $f40331732e852e18$export$5ef2424805ac76a3,
    ZodIntersection: $f40331732e852e18$export$c02deaf0bb5203d4,
    ZodTuple: $f40331732e852e18$export$e2a18bb771d8e6a3,
    ZodRecord: $f40331732e852e18$export$a2acc09968cb4b7f,
    ZodMap: $f40331732e852e18$export$163b6a2b712d9542,
    ZodSet: $f40331732e852e18$export$977057706f816712,
    ZodFunction: $f40331732e852e18$export$d4602ba55673f53c,
    ZodLazy: $f40331732e852e18$export$378d0cfce37406e6,
    ZodLiteral: $f40331732e852e18$export$7e44096782a165d3,
    ZodEnum: $f40331732e852e18$export$d325d1f0e1c20179,
    ZodNativeEnum: $f40331732e852e18$export$370b2e8d6d6f5c56,
    ZodPromise: $f40331732e852e18$export$3f196b0127d6e50a,
    ZodEffects: $f40331732e852e18$export$a60af00cc0ce2582,
    ZodTransformer: $f40331732e852e18$export$a60af00cc0ce2582,
    ZodOptional: $f40331732e852e18$export$aa56fec1e9d629b8,
    ZodNullable: $f40331732e852e18$export$aaac0b8b429cef5,
    ZodDefault: $f40331732e852e18$export$bb19b37874861e7e,
    ZodCatch: $f40331732e852e18$export$75a44ec6249ac76b,
    ZodNaN: $f40331732e852e18$export$26ccfa0145e8511f,
    BRAND: $f40331732e852e18$export$cf2deea74cde46b4,
    ZodBranded: $f40331732e852e18$export$66b0c798a395271f,
    ZodPipeline: $f40331732e852e18$export$a3c3ef8a0e95c6da,
    ZodReadonly: $f40331732e852e18$export$5d1f7ef05c4e493a,
    custom: $f40331732e852e18$export$4c00f665f0d4b443,
    Schema: $f40331732e852e18$export$19342e026b58ebb7,
    ZodSchema: $f40331732e852e18$export$19342e026b58ebb7,
    late: $f40331732e852e18$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $f40331732e852e18$export$558106ce543bd011;
    },
    coerce: $f40331732e852e18$export$8c14e57e778d3873,
    any: $f40331732e852e18$export$4154a199d7d90455,
    array: $f40331732e852e18$export$2f23118c22fb2630,
    bigint: $f40331732e852e18$export$a0f65b52274bcc00,
    boolean: $f40331732e852e18$export$4a21f16c33752377,
    date: $f40331732e852e18$export$324d90190a8b822a,
    discriminatedUnion: $f40331732e852e18$export$4b888e40c4ee26dd,
    effect: $f40331732e852e18$export$dc573d8a6576cdb3,
    'enum': $f40331732e852e18$export$78a99c8d44d72635,
    'function': $f40331732e852e18$export$44e51c8aac7c2deb,
    'instanceof': $f40331732e852e18$export$3d916e7c22dbd8b5,
    intersection: $f40331732e852e18$export$bc86dfbf7795668c,
    lazy: $f40331732e852e18$export$488013bae63b21da,
    literal: $f40331732e852e18$export$c8ec6e1ec9fefcb0,
    map: $f40331732e852e18$export$871de8747c9eaa88,
    nan: $f40331732e852e18$export$9e06de0973666692,
    nativeEnum: $f40331732e852e18$export$6fe7eca19ebe5199,
    never: $f40331732e852e18$export$b3e22bcfd64c1022,
    'null': $f40331732e852e18$export$7b1b591b262c240,
    nullable: $f40331732e852e18$export$133fc36489ac9add,
    number: $f40331732e852e18$export$98e628dec113755e,
    object: $f40331732e852e18$export$be5493f9613cbbe,
    oboolean: $f40331732e852e18$export$269251733cdcbbf1,
    onumber: $f40331732e852e18$export$eb150471a61fced6,
    optional: $f40331732e852e18$export$516e28dec6a4b6d4,
    ostring: $f40331732e852e18$export$3b3d07727c5b702c,
    pipeline: $f40331732e852e18$export$43f28b24e1eb8181,
    preprocess: $f40331732e852e18$export$fc37fe19dfda43ee,
    promise: $f40331732e852e18$export$c957ef27a0ebfd4,
    record: $f40331732e852e18$export$e5185e241753e543,
    set: $f40331732e852e18$export$adaa4cf7ef1b65be,
    strictObject: $f40331732e852e18$export$8fb0df5f40d0b477,
    string: $f40331732e852e18$export$22b082955e083ec3,
    symbol: $f40331732e852e18$export$8f701197936bc2a6,
    transformer: $f40331732e852e18$export$dc573d8a6576cdb3,
    tuple: $f40331732e852e18$export$65e3907585753458,
    'undefined': $f40331732e852e18$export$1db45310990710a5,
    union: $f40331732e852e18$export$971dd5b0dfd021b6,
    unknown: $f40331732e852e18$export$19282c40b967aec6,
    'void': $f40331732e852e18$export$490e536ee7389aeb,
    NEVER: $f40331732e852e18$export$96c94437c95d7862,
    ZodIssueCode: $f40331732e852e18$export$5ba560653e4a1035,
    quotelessJson: $f40331732e852e18$export$913eddeaf297cfea,
    ZodError: $f40331732e852e18$export$f98dac4b251ab333
});


var $0dd09485e7441d3b$var$ConfigError;
(function(ConfigError) {
    ConfigError["NotFound"] = "not_found";
    ConfigError["InvalidState"] = "state_invalid";
    ConfigError["IncorrectType"] = "incorrect_type";
})($0dd09485e7441d3b$var$ConfigError || ($0dd09485e7441d3b$exports.ConfigError = $0dd09485e7441d3b$var$ConfigError = {}));
$0dd09485e7441d3b$exports.StandardConfigSchema = $f40331732e852e18$export$2e2bcd8739ae039.record($f40331732e852e18$export$2e2bcd8739ae039.string(), $f40331732e852e18$export$2e2bcd8739ae039.object({
    value: $f40331732e852e18$export$2e2bcd8739ae039.union([
        $f40331732e852e18$export$2e2bcd8739ae039.boolean(),
        $f40331732e852e18$export$2e2bcd8739ae039.string(),
        $f40331732e852e18$export$2e2bcd8739ae039.number(),
        $f40331732e852e18$export$2e2bcd8739ae039.string().array(),
        $f40331732e852e18$export$2e2bcd8739ae039.number().array()
    ])
}));
$0dd09485e7441d3b$exports.MinimalConfigSchema = $f40331732e852e18$export$2e2bcd8739ae039.tuple([
    // list of boolean configs which are on
    $f40331732e852e18$export$2e2bcd8739ae039.string().array(),
    // list of string config tuples
    $f40331732e852e18$export$2e2bcd8739ae039.array($f40331732e852e18$export$2e2bcd8739ae039.string()).refine((arr)=>arr.length % 2 === 0),
    // list of number config tuples
    $f40331732e852e18$export$2e2bcd8739ae039.array($f40331732e852e18$export$2e2bcd8739ae039.union([
        $f40331732e852e18$export$2e2bcd8739ae039.string(),
        $f40331732e852e18$export$2e2bcd8739ae039.number()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== "string") return false;
            if (typeof arr[i + 1] !== "number") return false;
        }
        return true;
    }),
    // list of string list config tuples
    $f40331732e852e18$export$2e2bcd8739ae039.array($f40331732e852e18$export$2e2bcd8739ae039.union([
        $f40331732e852e18$export$2e2bcd8739ae039.string(),
        $f40331732e852e18$export$2e2bcd8739ae039.string().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== "string") return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === "string")) return false;
        }
        return true;
    }),
    // list of number list config tuples
    $f40331732e852e18$export$2e2bcd8739ae039.array($f40331732e852e18$export$2e2bcd8739ae039.union([
        $f40331732e852e18$export$2e2bcd8739ae039.string(),
        $f40331732e852e18$export$2e2bcd8739ae039.number().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== "string") return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === "number")) return false;
        }
        return true;
    })
]);
$0dd09485e7441d3b$exports.AnyConfigSchema = $f40331732e852e18$export$2e2bcd8739ae039.union([
    $0dd09485e7441d3b$exports.StandardConfigSchema,
    $0dd09485e7441d3b$exports.MinimalConfigSchema
]);
$0dd09485e7441d3b$exports.ConfigMapSchema = $f40331732e852e18$export$2e2bcd8739ae039.map($f40331732e852e18$export$2e2bcd8739ae039.string(), $f40331732e852e18$export$2e2bcd8739ae039.object({
    value: $f40331732e852e18$export$2e2bcd8739ae039.union([
        $f40331732e852e18$export$2e2bcd8739ae039.boolean(),
        $f40331732e852e18$export$2e2bcd8739ae039.string(),
        $f40331732e852e18$export$2e2bcd8739ae039.number(),
        $f40331732e852e18$export$2e2bcd8739ae039.string().array(),
        $f40331732e852e18$export$2e2bcd8739ae039.number().array()
    ])
}));
function $0dd09485e7441d3b$var$pairs(arr, fn) {
    for(let i = 0; i < arr.length; i += 2){
        const key = arr[i];
        const val = arr[i + 1];
        if (typeof key !== "string") throw new Error(`Expected a string while iterating pairs, got: ${arr[i]}`);
        fn(key, val);
    }
}
function $0dd09485e7441d3b$var$minimalToMap(minimal) {
    const map = new Map();
    minimal[0].forEach((boolean)=>map.set(boolean, {
            value: true
        }));
    $0dd09485e7441d3b$var$pairs(minimal[1], (a, b)=>map.set(a, {
            value: b
        }));
    $0dd09485e7441d3b$var$pairs(minimal[2], (a, b)=>map.set(a, {
            value: b
        }));
    $0dd09485e7441d3b$var$pairs(minimal[3], (a, b)=>map.set(a, {
            value: b
        }));
    $0dd09485e7441d3b$var$pairs(minimal[4], (a, b)=>map.set(a, {
            value: b
        }));
    return map;
}
function $0dd09485e7441d3b$var$standardToMap(standard) {
    const map = new Map();
    Object.entries(standard).forEach(([key, value])=>map.set(key, value));
    return map;
}
function $0dd09485e7441d3b$var$mapToMinimal(map) {
    const minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    for (const [key, { value: value }] of map.entries())switch(typeof value){
        case "boolean":
            if (value) minimal[0].push(key);
            break;
        case "string":
            minimal[1].push(key, value);
            break;
        case "number":
            minimal[2].push(key, value);
            break;
        default:
            if (!Array.isArray(value)) throw new Error(`Unexpected configuration value: ${value}`);
            const allStrings = value.every((x)=>typeof x === "string");
            if (allStrings) {
                minimal[3].push(key, value);
                break;
            }
            const allNumbers = value.every((x)=>typeof x === "number");
            if (allNumbers) {
                minimal[4].push(key, value);
                break;
            }
            throw new Error(`Unexpected configuration value: ${value}`);
    }
    return minimal;
}
function $0dd09485e7441d3b$var$mapToStandard(map) {
    return Object.fromEntries(map.entries());
}


class $f101546a3944c6b9$var$ParseError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
$f101546a3944c6b9$exports.ParseError = $f101546a3944c6b9$var$ParseError;
function $f101546a3944c6b9$var$safeParse(json) {
    try {
        return {
            data: $0dd09485e7441d3b$exports.AnyConfigSchema.parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $f101546a3944c6b9$var$ParseError("An unknown error occurred during parsing", error)
        };
    }
}
class $f101546a3944c6b9$var$ConfigCollection {
    static fromValues(values, options) {
        const result = $f101546a3944c6b9$var$safeParse(values);
        if (!result.success) {
            const parseError = new $f101546a3944c6b9$var$ParseError("Failed to deserialize config", result.error);
            if (options === null || options === void 0 ? void 0 : options.throw) throw parseError;
            console.error(parseError);
            return $f101546a3944c6b9$var$ConfigCollection.empty();
        }
        return new $f101546a3944c6b9$var$ConfigCollection(Array.isArray(result.data) ? (0, $0dd09485e7441d3b$exports.minimalToMap)(result.data) : (0, $0dd09485e7441d3b$exports.standardToMap)(result.data));
    }
    static empty() {
        return new $f101546a3944c6b9$var$ConfigCollection(new Map());
    }
    toJson(format) {
        switch(format){
            case "standard":
                return JSON.stringify((0, $0dd09485e7441d3b$exports.mapToStandard)(this.config));
            case "minimal":
                return JSON.stringify((0, $0dd09485e7441d3b$exports.mapToMinimal)(this.config));
        }
    }
    getBoolean(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: $0dd09485e7441d3b$exports.ConfigError.NotFound
        };
        const { value: value } = config;
        if (typeof value !== "boolean") return {
            error: $0dd09485e7441d3b$exports.ConfigError.IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getString(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: $0dd09485e7441d3b$exports.ConfigError.NotFound
        };
        const { value: value } = config;
        if (typeof value !== "string") return {
            error: $0dd09485e7441d3b$exports.ConfigError.IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumber(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: $0dd09485e7441d3b$exports.ConfigError.NotFound
        };
        const { value: value } = config;
        if (typeof value !== "number") return {
            error: $0dd09485e7441d3b$exports.ConfigError.IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getStringList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: $0dd09485e7441d3b$exports.ConfigError.NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === "string")) return {
            error: $0dd09485e7441d3b$exports.ConfigError.IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumberList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: $0dd09485e7441d3b$exports.ConfigError.NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === "number")) return {
            error: $0dd09485e7441d3b$exports.ConfigError.IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    constructor(config){
        this.config = config;
    }
}
$f101546a3944c6b9$exports.ConfigCollection = $f101546a3944c6b9$var$ConfigCollection;


Object.defineProperty($4983e8507bb0e9f6$exports, "ConfigCollection", {
    enumerable: true,
    get: function() {
        return $f101546a3944c6b9$exports.ConfigCollection;
    }
});

Object.defineProperty($4983e8507bb0e9f6$exports, "ConfigError", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.ConfigError;
    }
});
Object.defineProperty($4983e8507bb0e9f6$exports, "AnyConfigSchema", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.AnyConfigSchema;
    }
});
Object.defineProperty($4983e8507bb0e9f6$exports, "ConfigMapSchema", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.ConfigMapSchema;
    }
});
Object.defineProperty($4983e8507bb0e9f6$exports, "MinimalConfigSchema", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.MinimalConfigSchema;
    }
});
Object.defineProperty($4983e8507bb0e9f6$exports, "StandardConfigSchema", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.StandardConfigSchema;
    }
});
Object.defineProperty($4983e8507bb0e9f6$exports, "minimalToMap", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.minimalToMap;
    }
});
Object.defineProperty($4983e8507bb0e9f6$exports, "standardToMap", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.standardToMap;
    }
});


class $e3102180980df047$var$ConfigClient {
    static async fetch(options) {
        var _a;
        const fetch = (_a = options.fetch) !== null && _a !== void 0 ? _a : globalThis.fetch;
        const response = await fetch(`${options.ffsBaseUrl}/api/v2/configurations`, {
            method: "POST",
            body: JSON.stringify(options.context),
            headers: {
                "content-type": "application/json",
                "x-api-key": options.ffsApiKey
            }
        });
        if (!response.ok) throw new Error(`Unexpected response ${response.status}: ${await response.text()}`);
        const valuesPayload = await response.text();
        return $4983e8507bb0e9f6$exports.ConfigCollection.fromValues(valuesPayload);
    }
}
$e3102180980df047$exports.ConfigClient = $e3102180980df047$var$ConfigClient;


Object.defineProperty($e5f7b614fbcf0ffb$exports, "ConfigClient", {
    enumerable: true,
    get: function() {
        return $e3102180980df047$exports.ConfigClient;
    }
});

Object.defineProperty($e5f7b614fbcf0ffb$exports, "ConfigCollection", {
    enumerable: true,
    get: function() {
        return $4983e8507bb0e9f6$exports.ConfigCollection;
    }
});
Object.defineProperty($e5f7b614fbcf0ffb$exports, "ConfigError", {
    enumerable: true,
    get: function() {
        return $4983e8507bb0e9f6$exports.ConfigError;
    }
});
Object.defineProperty($e5f7b614fbcf0ffb$exports, "ConfigMapSchema", {
    enumerable: true,
    get: function() {
        return $4983e8507bb0e9f6$exports.ConfigMapSchema;
    }
});



const $fadcf04f5e0ec6ac$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $fadcf04f5e0ec6ac$export$2e2bcd8739ae039 = {
    randomUUID: $fadcf04f5e0ec6ac$var$randomUUID
};


let $2bcaa466815aa8a5$var$getRandomValues;
const $2bcaa466815aa8a5$var$rnds8 = new Uint8Array(16);
function $2bcaa466815aa8a5$export$2e2bcd8739ae039() {
    if (!$2bcaa466815aa8a5$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $2bcaa466815aa8a5$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $2bcaa466815aa8a5$var$getRandomValues($2bcaa466815aa8a5$var$rnds8);
}


var $7709510a2fca9f72$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $8df89a4d60889f85$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $7709510a2fca9f72$export$2e2bcd8739ae039).test(uuid);
}
var $8df89a4d60889f85$export$2e2bcd8739ae039 = $8df89a4d60889f85$var$validate;


const $ee13ceee8d9f46c4$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$ee13ceee8d9f46c4$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $ee13ceee8d9f46c4$export$8fb373d660548968(arr, offset = 0) {
    return ($ee13ceee8d9f46c4$var$byteToHex[arr[offset + 0]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 1]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 2]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 3]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 4]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 5]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 6]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 7]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 8]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 9]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 10]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 11]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 12]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 13]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 14]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $ee13ceee8d9f46c4$var$stringify(arr, offset = 0) {
    const uuid = $ee13ceee8d9f46c4$export$8fb373d660548968(arr, offset);
    if (!(0, $8df89a4d60889f85$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $ee13ceee8d9f46c4$export$2e2bcd8739ae039 = $ee13ceee8d9f46c4$var$stringify;


function $6810e10b84975c3e$var$v4(options, buf, offset) {
    var _options_rng;
    if ((0, $fadcf04f5e0ec6ac$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $fadcf04f5e0ec6ac$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var _options_random, _ref;
    const rnds = (_ref = (_options_random = options.random) !== null && _options_random !== void 0 ? _options_random : (_options_rng = options.rng) === null || _options_rng === void 0 ? void 0 : _options_rng.call(options)) !== null && _ref !== void 0 ? _ref : (0, $2bcaa466815aa8a5$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $ee13ceee8d9f46c4$export$8fb373d660548968)(rnds);
}
var $6810e10b84975c3e$export$2e2bcd8739ae039 = $6810e10b84975c3e$var$v4;


const $d377413f5e2ec9d9$var$defaultFeatureFlags = {
    'pc-frontend-down-for-maintenance': false,
    'pc-frontend-use-sso': false
};
const $d377413f5e2ec9d9$var$FeatureFlagProviderContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext($d377413f5e2ec9d9$var$defaultFeatureFlags);
const $d377413f5e2ec9d9$var$getFfsConfig = ()=>{
    switch((0, $35a545355f14a0c7$export$6bc7b24d4e862158)().name){
        case (0, $c1e4a1336f2cb96e$exports).STAGE:
            return {
                apiKey: '4fe8b2e3-2652-4c3b-ae74-a68f018b02c1',
                baseUrl: 'https://api.stg.atlassian.com/flags'
            };
        case (0, $c1e4a1336f2cb96e$exports).PROD:
            return {
                apiKey: 'f7e6ffcd-c5c4-476d-b870-5fe4dc7903e8',
                baseUrl: 'https://api.atlassian.com/flags'
            };
        default:
            return {
                apiKey: '3d7da3c9-0e4a-4e84-bb50-0e85faeb1f11',
                baseUrl: 'https://api.dev.atlassian.com/flags'
            };
    }
};
const $d377413f5e2ec9d9$var$readBoolean = (configCollection, flag, defaultValue)=>{
    const configValue = configCollection.getBoolean(flag);
    if (!configValue || 'error' in configValue) return defaultValue;
    return configValue.value;
};
const $d377413f5e2ec9d9$export$90335b3ff08f335 = ()=>(0, $7fPBF.useContext)($d377413f5e2ec9d9$var$FeatureFlagProviderContext);
const $d377413f5e2ec9d9$export$ec0c43a58fca1a2 = (props)=>{
    const [featureFlagsLoaded, setFeatureFlagsLoaded] = (0, $7fPBF.useState)(false);
    const [featureFlags, setFeatureFlags] = (0, $7fPBF.useState)($d377413f5e2ec9d9$var$defaultFeatureFlags);
    (0, $7fPBF.useEffect)(()=>{
        async function fetchConfig() {
            try {
                const ffsConfig = $d377413f5e2ec9d9$var$getFfsConfig();
                const config = await (0, $e5f7b614fbcf0ffb$exports.ConfigClient).fetch({
                    ffsBaseUrl: ffsConfig.baseUrl,
                    ffsApiKey: ffsConfig.apiKey,
                    context: {
                        namespace: 'atl-preferences-center_web',
                        identifiers: {
                            randomizationId: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)()
                        },
                        metadata: {}
                    }
                });
                setFeatureFlags({
                    ['pc-frontend-down-for-maintenance']: $d377413f5e2ec9d9$var$readBoolean(config, 'pc-frontend-down-for-maintenance', $d377413f5e2ec9d9$var$defaultFeatureFlags['pc-frontend-down-for-maintenance']),
                    ['pc-frontend-use-sso']: $d377413f5e2ec9d9$var$readBoolean(config, 'pc-frontend-use-sso', $d377413f5e2ec9d9$var$defaultFeatureFlags['pc-frontend-use-sso'])
                });
            } catch (e) {
                console.error('Failed to fetch feature flags', e);
            }
            setFeatureFlagsLoaded(true);
        }
        fetchConfig();
    }, []);
    if (!featureFlagsLoaded) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {}); // show blank page while feature flags are loading
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d377413f5e2ec9d9$var$FeatureFlagProviderContext.Provider, {
        value: featureFlags,
        children: props.children
    });
};


const $49ba1be7e4639afe$var$PreferencesCenter = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const email = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$faf42b3a43b63a45));
    const featureFlags = (0, $d377413f5e2ec9d9$export$90335b3ff08f335)();
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $3d2cac913f314860$export$a3910a3548679a09)({
            query: location.search,
            useSso: featureFlags['pc-frontend-use-sso']
        }));
    }, [
        dispatch,
        location,
        featureFlags
    ]);
    const unsubscribeHandler = (0, $7fPBF.useCallback)(()=>{
        (0, $0e08eda71bb24540$export$2661a9b7d6c9d40)();
        dispatch((0, $3d2cac913f314860$export$34ae4e8891fc3f3d)());
    }, [
        dispatch
    ]);
    const actionBarHandler = (0, $7fPBF.useCallback)(()=>email == null ? null : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $788f88bb6ebc19d1$export$2e2bcd8739ae039), {
            email: email,
            onUnsubscribeClick: unsubscribeHandler
        }), [
        email,
        unsubscribeHandler
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef58838c74859603$export$2e2bcd8739ae039), {
        headerContent: actionBarHandler,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b41785aa38675ed$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b7c307e3b08d158$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $88ea1b053c235b63$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $85d7791daea50a70$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b9140ff8d659df65$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab16c582615dabed$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68c6614e902c1d6d$export$2e2bcd8739ae039), {
                    onUnsubscribeClick: unsubscribeHandler
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e2882318f59e87f$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $49ba1be7e4639afe$export$2e2bcd8739ae039 = $49ba1be7e4639afe$var$PreferencesCenter;









const $6c559b868a542118$var$App = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $cc45bcc51bf95f36$export$d1f0f8da0682c531)());
    }, [
        dispatch
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const script = document.createElement('script');
        const environment = (0, $35a545355f14a0c7$export$6bc7b24d4e862158)().name;
        script.dataset.domain = '01964a8b-758a-751f-b483-0ec1e112bff6';
        if (environment === (0, $c1e4a1336f2cb96e$exports).PROD) {
            script.src = 'https://atl-onetrust-wrapper.atlassian.com/assets/atl-onetrust-wrapper.min.js';
            script.dataset.domain = '01964ae5-b19b-70b7-9a2d-f40c3cdc5ead';
        } else if (environment === (0, $c1e4a1336f2cb96e$exports).STAGE) script.src = 'https://atl-onetrust-wrapper.stg-east.frontend.public.atl-paas.net/assets/atl-onetrust-wrapper.min.js';
        else script.src = 'https://atl-onetrust-wrapper.adev.frontend.public.atl-paas.net/assets/atl-onetrust-wrapper.min.js';
        script.dataset.sync = 'false';
        script.dataset.test = (environment !== (0, $c1e4a1336f2cb96e$exports).PROD).toString();
        script.dataset.geofence = 'true';
        document.head.appendChild(script);
        return ()=>{
            document.head.removeChild(script);
        };
    }, []);
    const translationsInitialized = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$2a9f106f311b16ff));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: translationsInitialized && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d9fd026bfea79ab9$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                    path: '/',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $49ba1be7e4639afe$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                    path: '/consent',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $100065b339a92676$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                    path: '/not-found',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24b14210ebbca78e$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                    path: '*',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
                        to: '/not-found',
                        replace: true
                    })
                })
            ]
        })
    });
};
var $6c559b868a542118$export$2e2bcd8739ae039 = $6c559b868a542118$var$App;



const $39e0699b89d33240$var$initialState = {
    loading: {},
    env: 'local'
};
const $39e0699b89d33240$var$typePrefixRegex = /^(.*)\//;
const $39e0699b89d33240$var$setLoadingState = (state, action, loadingType)=>{
    var _action_type_match;
    const typePrefix = (_action_type_match = action.type.match($39e0699b89d33240$var$typePrefixRegex)) === null || _action_type_match === void 0 ? void 0 : _action_type_match[1];
    if (typePrefix) state.loading[typePrefix] = loadingType;
};
const $39e0699b89d33240$var$appSlice = (0, $15d924278321bdfd$export$4d8d9bd83c24ae8b)({
    name: 'requestStatus',
    initialState: $39e0699b89d33240$var$initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addMatcher((action)=>action.type.endsWith('/pending'), (state, action)=>$39e0699b89d33240$var$setLoadingState(state, action, 'pending'));
        builder.addMatcher((action)=>action.type.endsWith('/fulfilled'), (state, action)=>$39e0699b89d33240$var$setLoadingState(state, action, 'idle'));
        builder.addMatcher((action)=>action.type.endsWith('/rejected'), (state, action)=>$39e0699b89d33240$var$setLoadingState(state, action, 'idle'));
    }
});
const { reducer: $39e0699b89d33240$var$reducer } = $39e0699b89d33240$var$appSlice;
var $39e0699b89d33240$export$2e2bcd8739ae039 = $39e0699b89d33240$var$reducer;




const $7a501a2d8adab3c3$export$9d56a93b8e84b384 = (actions)=>(0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.app.loading, (loading)=>actions.some((action)=>loading[action] === 'pending'));
const $7a501a2d8adab3c3$export$6a1923cb7c064699 = $7a501a2d8adab3c3$export$9d56a93b8e84b384([
    (0, $80022746ba8cd68a$export$6871e08c9c3b9797),
    (0, $80022746ba8cd68a$export$30f55fa357ca2ae5),
    (0, $80022746ba8cd68a$export$1a788c0d2586d018)
]);










const $b91bb6c1ec048c06$export$a8a69c316169e623 = (0, $78916fc80cd27125$export$66e4520cdb265d18)({
    app: (0, $39e0699b89d33240$export$2e2bcd8739ae039),
    preferences: (0, $3d2cac913f314860$export$2e2bcd8739ae039),
    consent: (0, $cdfa88e4a0cef872$export$2e2bcd8739ae039),
    localization: (0, $cc45bcc51bf95f36$export$2e2bcd8739ae039)
});
const $b91bb6c1ec048c06$var$store = (0, $15d924278321bdfd$export$7d8a5b498da695ac)({
    reducer: $b91bb6c1ec048c06$export$a8a69c316169e623,
    devTools: false
});
var $b91bb6c1ec048c06$export$2e2bcd8739ae039 = $b91bb6c1ec048c06$var$store;





/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $37b03cd1fa6d4fb8$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


// eslint-disable-next-line @typescript-eslint/unbound-method
const $85e272e760900bb9$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$e6127cc7fe7395c3(wat) {
    switch($85e272e760900bb9$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $85e272e760900bb9$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$var$isBuiltin(wat, className) {
    return $85e272e760900bb9$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$9f9636d330b71954(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$ef9e2056653f0c8e(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$12e869b2a583f783(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$844ec244b1367d54(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$c3825b437cbdea5c(wat) {
    return wat === null || $85e272e760900bb9$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$53b83ca8eaab0383(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $85e272e760900bb9$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $85e272e760900bb9$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$49841c62b9eff15(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $85e272e760900bb9$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean((wat === null || wat === void 0 ? void 0 : wat.then) && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$bc2894c7158efbac(wat) {
    return $85e272e760900bb9$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $85e272e760900bb9$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $85e272e760900bb9$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $85e272e760900bb9$export$49034edbe6b62415(request, Request);
}


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $df8678217e707dd5$export$f1a6cdb1459e81d1 = globalThis;


const $0ff4a1c827ec052f$var$WINDOW = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
const $0ff4a1c827ec052f$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $0ff4a1c827ec052f$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $0ff4a1c827ec052f$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $0ff4a1c827ec052f$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (e) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $0ff4a1c827ec052f$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!(elem === null || elem === void 0 ? void 0 : elem.tagName)) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($0ff4a1c827ec052f$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = (keyAttrs === null || keyAttrs === void 0 ? void 0 : keyAttrs.length) ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs === null || keyAttrPairs === void 0 ? void 0 : keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $85e272e760900bb9$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $0ff4a1c827ec052f$export$1cfafeee2987818b() {
    try {
        return $0ff4a1c827ec052f$var$WINDOW.document.location.href;
    } catch (e) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $0ff4a1c827ec052f$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$0ff4a1c827ec052f$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


// This is a magic string replaced by rollup
const $961dedfff8dbd514$export$31499a9cd224b78c = "10.11.0";



/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $3d29ea41beb10247$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $3d29ea41beb10247$export$c8bfa33e4e8ae492((0, $df8678217e707dd5$export$f1a6cdb1459e81d1));
    return 0, $df8678217e707dd5$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $3d29ea41beb10247$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $961dedfff8dbd514$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $961dedfff8dbd514$export$31499a9cd224b78c] = __SENTRY__[0, $961dedfff8dbd514$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $3d29ea41beb10247$export$7e223ec222791509(name, creator, obj = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $961dedfff8dbd514$export$31499a9cd224b78c] = __SENTRY__[0, $961dedfff8dbd514$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}




const $d8898b8567c29ee9$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ const $d8898b8567c29ee9$var$PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ const $d8898b8567c29ee9$export$77c4ce905194557b = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $d8898b8567c29ee9$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $df8678217e707dd5$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($d8898b8567c29ee9$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $d8898b8567c29ee9$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $d8898b8567c29ee9$var$enable() {
    $d8898b8567c29ee9$var$_getLoggerSettings().enabled = true;
}
function $d8898b8567c29ee9$var$disable() {
    $d8898b8567c29ee9$var$_getLoggerSettings().enabled = false;
}
function $d8898b8567c29ee9$var$isEnabled() {
    return $d8898b8567c29ee9$var$_getLoggerSettings().enabled;
}
function $d8898b8567c29ee9$var$log(...args) {
    $d8898b8567c29ee9$var$_maybeLog('log', ...args);
}
function $d8898b8567c29ee9$var$warn(...args) {
    $d8898b8567c29ee9$var$_maybeLog('warn', ...args);
}
function $d8898b8567c29ee9$var$error(...args) {
    $d8898b8567c29ee9$var$_maybeLog('error', ...args);
}
function $d8898b8567c29ee9$var$_maybeLog(level, ...args) {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return;
    if ($d8898b8567c29ee9$var$isEnabled()) $d8898b8567c29ee9$export$cda52e2a8927a2ca(()=>{
        (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).console[level](`${$d8898b8567c29ee9$var$PREFIX}[${level}]:`, ...args);
    });
}
function $d8898b8567c29ee9$var$_getLoggerSettings() {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $3d29ea41beb10247$export$7e223ec222791509)('loggerSettings', ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $d8898b8567c29ee9$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $d8898b8567c29ee9$var$enable,
    disable: /** Disable logging. */ $d8898b8567c29ee9$var$disable,
    isEnabled: /** Check if logging is enabled. */ $d8898b8567c29ee9$var$isEnabled,
    log: /** Log a message. */ $d8898b8567c29ee9$var$log,
    warn: /** Log a warning. */ $d8898b8567c29ee9$var$warn,
    error: /** Log an error. */ $d8898b8567c29ee9$var$error
};




/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $6c937b4b236937d4$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $6c937b4b236937d4$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $6c937b4b236937d4$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $85e272e760900bb9$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $6c937b4b236937d4$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $85e272e760900bb9$export$844ec244b1367d54)(value)) return false;
    if ((0, $85e272e760900bb9$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $85e272e760900bb9$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $6c937b4b236937d4$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$6c937b4b236937d4$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $85a434b6cfc19e37$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $85a434b6cfc19e37$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $85a434b6cfc19e37$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (e) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $85a434b6cfc19e37$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $85a434b6cfc19e37$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (e) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $85a434b6cfc19e37$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $85a434b6cfc19e37$export$62ff257738bf57f5(value) {
    if ((0, $85e272e760900bb9$export$e6127cc7fe7395c3)(value)) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $85a434b6cfc19e37$var$getOwnProperties(value));
    else if ((0, $85e272e760900bb9$export$9671ea99bd126ace)(value)) {
        const newObj = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            type: value.type,
            target: $85a434b6cfc19e37$var$serializeEventTarget(value.target),
            currentTarget: $85a434b6cfc19e37$var$serializeEventTarget(value.currentTarget)
        }, $85a434b6cfc19e37$var$getOwnProperties(value));
        if (typeof CustomEvent !== 'undefined' && (0, $85e272e760900bb9$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $85a434b6cfc19e37$var$serializeEventTarget(target) {
    try {
        return (0, $85e272e760900bb9$export$45a5e7f76e0caa8d)(target) ? (0, $0ff4a1c827ec052f$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (e) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $85a434b6cfc19e37$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $85a434b6cfc19e37$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($85a434b6cfc19e37$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $6c937b4b236937d4$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $6c937b4b236937d4$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $85a434b6cfc19e37$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $85a434b6cfc19e37$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $85a434b6cfc19e37$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($85a434b6cfc19e37$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($85a434b6cfc19e37$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $85a434b6cfc19e37$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $85a434b6cfc19e37$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $85a434b6cfc19e37$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $85e272e760900bb9$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}


const $b007b72e24b33b62$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $b007b72e24b33b62$export$7740643b9eeaf0c4() {
    return Date.now() / $b007b72e24b33b62$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $b007b72e24b33b62$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!(performance === null || performance === void 0 ? void 0 : performance.now) || !performance.timeOrigin) return $b007b72e24b33b62$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $b007b72e24b33b62$var$ONE_SECOND_IN_MS;
    };
}
let $b007b72e24b33b62$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $b007b72e24b33b62$export$ee52dced521e3e18() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $b007b72e24b33b62$var$_cachedTimestampInSeconds !== null && $b007b72e24b33b62$var$_cachedTimestampInSeconds !== void 0 ? $b007b72e24b33b62$var$_cachedTimestampInSeconds : $b007b72e24b33b62$var$_cachedTimestampInSeconds = $b007b72e24b33b62$var$createUnixTimestampInSecondsFunc();
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $b007b72e24b33b62$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $b007b72e24b33b62$var$getBrowserTimeOrigin() {
    var _performance_timing;
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
    if (!(performance === null || performance === void 0 ? void 0 : performance.now)) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = (_performance_timing = performance.timing) === null || _performance_timing === void 0 ? void 0 : _performance_timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $b007b72e24b33b62$export$baf075a948ffc0bf() {
    if (!$b007b72e24b33b62$var$cachedTimeOrigin) $b007b72e24b33b62$var$cachedTimeOrigin = $b007b72e24b33b62$var$getBrowserTimeOrigin();
    return $b007b72e24b33b62$var$cachedTimeOrigin[0];
}





function $df365b8ef5885c2b$var$getCrypto() {
    const gbl = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $df365b8ef5885c2b$export$19f53698e68b2496(crypto = $df365b8ef5885c2b$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto === null || crypto === void 0 ? void 0 : crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (e) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $df365b8ef5885c2b$var$getFirstException(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $df365b8ef5885c2b$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $df365b8ef5885c2b$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $df365b8ef5885c2b$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $df365b8ef5885c2b$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $df365b8ef5885c2b$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentMechanism === null || currentMechanism === void 0 ? void 0 : currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $df365b8ef5885c2b$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $df365b8ef5885c2b$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $df365b8ef5885c2b$export$d364f2020ab30578(input) {
    const match = input.match($df365b8ef5885c2b$var$SEMVER_REGEXP) || [];
    const major = $df365b8ef5885c2b$var$_parseInt(match[1]);
    const minor = $df365b8ef5885c2b$var$_parseInt(match[2]);
    const patch = $df365b8ef5885c2b$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $df365b8ef5885c2b$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $6c937b4b236937d4$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $6c937b4b236937d4$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $6c937b4b236937d4$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $df365b8ef5885c2b$export$6de4ffac6a2f1098(exception) {
    if ($df365b8ef5885c2b$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (e) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $df365b8ef5885c2b$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}


/**
 * Generate a random, valid trace ID.
 */ function $f56fc4041ba3a369$export$dc6d7ea554bcce10() {
    return (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $f56fc4041ba3a369$export$295213bc4d0c54ad() {
    return (0, $df365b8ef5885c2b$export$19f53698e68b2496)().substring(16);
}








/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $4ea28bfd5ee93486$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $df365b8ef5885c2b$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$4ea28bfd5ee93486$var$sessionToJSON(session)
    };
    if (context) $4ea28bfd5ee93486$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $4ea28bfd5ee93486$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $4ea28bfd5ee93486$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $4ea28bfd5ee93486$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $4ea28bfd5ee93486$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ 
function $6758701f8e924183$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, initialObj);
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $6758701f8e924183$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}





const $9f9cfe5727c3ad26$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $9f9cfe5727c3ad26$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(scope, $9f9cfe5727c3ad26$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$9f9cfe5727c3ad26$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $9f9cfe5727c3ad26$export$91f063ebb8eff307(scope) {
    return scope[$9f9cfe5727c3ad26$var$SCOPE_SPAN_FIELD];
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $88388f6b019104ff$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $88388f6b019104ff$export$775b6bb06e53a214 {
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $88388f6b019104ff$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._tags);
        newScope._extra = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._extra);
        newScope._contexts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._contexts);
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._sdkProcessingMetadata);
        newScope._propagationContext = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._propagationContext);
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(newScope, (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $4ea28bfd5ee93486$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._tags, tags);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._tags), {
            [key]: value
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._extra, extras);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._extra), {
            [key]: extra
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $88388f6b019104ff$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $85e272e760900bb9$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._tags, tags);
        this._extra = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._extra, extra);
        this._contexts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._contexts, contexts);
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $88388f6b019104ff$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            timestamp: (0, $b007b72e24b33b62$export$7740643b9eeaf0c4)()
        }, breadcrumb), {
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $6c937b4b236937d4$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        });
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            var _this__client;
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            (_this__client = this._client) === null || _this__client === void 0 ? void 0 : _this__client.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $6758701f8e924183$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            originalException: exception,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            originalException: message,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        };
    }
}


/** Get the default current scope. */ function $303b3b8942f870bd$export$6f1b9191db9c4d5() {
    return (0, $3d29ea41beb10247$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $88388f6b019104ff$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $303b3b8942f870bd$export$de9862929b76bf57() {
    return (0, $3d29ea41beb10247$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $88388f6b019104ff$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $349a8e27b595687d$export$d36ec451f120cfba {
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $88388f6b019104ff$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $88388f6b019104ff$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $349a8e27b595687d$var$getAsyncContextStack() {
    const registry = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const sentry = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $349a8e27b595687d$export$d36ec451f120cfba((0, $303b3b8942f870bd$export$6f1b9191db9c4d5)(), (0, $303b3b8942f870bd$export$de9862929b76bf57)());
}
function $349a8e27b595687d$var$withScope(callback) {
    return $349a8e27b595687d$var$getAsyncContextStack().withScope(callback);
}
function $349a8e27b595687d$var$withSetScope(scope, callback) {
    const stack = $349a8e27b595687d$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $349a8e27b595687d$var$withIsolationScope(callback) {
    return $349a8e27b595687d$var$getAsyncContextStack().withScope(()=>{
        return callback($349a8e27b595687d$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $349a8e27b595687d$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $349a8e27b595687d$var$withIsolationScope,
        withScope: $349a8e27b595687d$var$withScope,
        withSetScope: $349a8e27b595687d$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $349a8e27b595687d$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$349a8e27b595687d$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$349a8e27b595687d$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $e26a4b07a4ad38af$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const sentry = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $e26a4b07a4ad38af$export$f639b0c2752203be(carrier) {
    const sentry = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $349a8e27b595687d$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $6486f3d311605b78$export$c7be4b0125a10cba() {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $6486f3d311605b78$export$68f3af03034c9e90() {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $6486f3d311605b78$export$aa55d5ab8e05984f() {
    return (0, $3d29ea41beb10247$export$7e223ec222791509)('globalScope', ()=>new (0, $88388f6b019104ff$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $6486f3d311605b78$export$ec58d9285c204497(...rest) {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $6486f3d311605b78$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $6486f3d311605b78$export$6bb76d6eba7e258c() {
    return $6486f3d311605b78$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $6486f3d311605b78$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

const $370456451b52ff1d$export$849dbeeeda01ae98 = 'production';



/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $fdf17a1e56d9d4ca$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $fdf17a1e56d9d4ca$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $fdf17a1e56d9d4ca$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $fdf17a1e56d9d4ca$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $fdf17a1e56d9d4ca$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $fdf17a1e56d9d4ca$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $fdf17a1e56d9d4ca$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $fdf17a1e56d9d4ca$export$1efec95406bbe327 = 'sentry.profile_id';
const $fdf17a1e56d9d4ca$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $fdf17a1e56d9d4ca$export$b016f89ac1066ec = 'cache.hit';
const $fdf17a1e56d9d4ca$export$3110e4c3f4386399 = 'cache.key';
const $fdf17a1e56d9d4ca$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $fdf17a1e56d9d4ca$export$be7a251980e7e946 = 'http.request.method';
const $fdf17a1e56d9d4ca$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $fdf17a1e56d9d4ca$export$ff77b5fd5b2d627b = 'sentry.link.type';





const $4d0fefb7946dcfa7$export$6e69537d67fa20f = 'sentry-';
const $4d0fefb7946dcfa7$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $4d0fefb7946dcfa7$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $4d0fefb7946dcfa7$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $4d0fefb7946dcfa7$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($4d0fefb7946dcfa7$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($4d0fefb7946dcfa7$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $4d0fefb7946dcfa7$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$4d0fefb7946dcfa7$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $4d0fefb7946dcfa7$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $4d0fefb7946dcfa7$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $85e272e760900bb9$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $4d0fefb7946dcfa7$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $4d0fefb7946dcfa7$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $4d0fefb7946dcfa7$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch (e) {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        })).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $4d0fefb7946dcfa7$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $4d0fefb7946dcfa7$export$bdd844ddb2def819) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}




/** Regular expression used to extract org ID from a DSN host. */ const $94fe38c0afc4d11c$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $94fe38c0afc4d11c$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $94fe38c0afc4d11c$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $94fe38c0afc4d11c$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $94fe38c0afc4d11c$export$b892860177f70a30(str) {
    const match = $94fe38c0afc4d11c$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $94fe38c0afc4d11c$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $94fe38c0afc4d11c$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $94fe38c0afc4d11c$var$validateDsn(dsn) {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$94fe38c0afc4d11c$var$isValidProtocol(protocol)) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $94fe38c0afc4d11c$export$5914f4e7748c29c9(host) {
    const match = host.match($94fe38c0afc4d11c$var$ORG_ID_REGEX);
    return match === null || match === void 0 ? void 0 : match[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function $94fe38c0afc4d11c$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $94fe38c0afc4d11c$export$5914f4e7748c29c9(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $94fe38c0afc4d11c$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $94fe38c0afc4d11c$export$b892860177f70a30(from) : $94fe38c0afc4d11c$var$dsnFromComponents(from);
    if (!components || !$94fe38c0afc4d11c$var$validateDsn(components)) return undefined;
    return components;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $8540c501196729c9$export$1f70765132c3c225(maybeOptions) {
    var _getClient;
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || ((_getClient = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)()) === null || _getClient === void 0 ? void 0 : _getClient.getOptions());
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}









const $f217ebe7a0a6fc3c$export$136e25984ba4a383 = 0;
const $f217ebe7a0a6fc3c$export$58f7963109c806fc = 1;
const $f217ebe7a0a6fc3c$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $f217ebe7a0a6fc3c$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $f217ebe7a0a6fc3c$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $f217ebe7a0a6fc3c$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $f217ebe7a0a6fc3c$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}



const $f7bbc910493e6179$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $f7bbc910493e6179$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $f7bbc910493e6179$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(span, $f7bbc910493e6179$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(span, $f7bbc910493e6179$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $f7bbc910493e6179$export$c08fbc656a245d03(span) {
    return {
        scope: span[$f7bbc910493e6179$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$f7bbc910493e6179$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}








/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $ab7c7053b878f035$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $ae017cc8b57317cd$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $ae017cc8b57317cd$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($ae017cc8b57317cd$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $ae017cc8b57317cd$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $ae017cc8b57317cd$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $4d0fefb7946dcfa7$export$5b96ee2c8421f107)(baggage);
    if (!(traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.traceId)) return {
        traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
        sampleRand: Math.random()
    };
    const sampleRand = $ae017cc8b57317cd$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $ae017cc8b57317cd$export$f35d907436da45cf(traceId = (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(), spanId = (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $ae017cc8b57317cd$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $ab7c7053b878f035$export$a5bd2d81656d9546)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $ab7c7053b878f035$export$a5bd2d81656d9546)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rate);
    if (parsedSampleRate && (traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.parentSampled) !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function $ae017cc8b57317cd$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $94fe38c0afc4d11c$export$b7ac9b8efa4bb595)(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




// These are aligned with OpenTelemetry trace flags
const $cac16f6eada858e7$export$208d5b368507fb8b = 0x0;
const $cac16f6eada858e7$export$eb571cd9b5d98de8 = 0x1;
let $cac16f6eada858e7$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $cac16f6eada858e7$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $cac16f6eada858e7$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $cac16f6eada858e7$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $cac16f6eada858e7$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? (scope === null || scope === void 0 ? void 0 : scope.getPropagationContext().propagationSpanId) || (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $cac16f6eada858e7$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $cac16f6eada858e7$export$5caecac1caaf3a71(span);
    return (0, $ae017cc8b57317cd$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $cac16f6eada858e7$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map((_param)=>{
        var { context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes } = _param, restContext = (0, $8901fc92b5563702$export$71511d61b312f219)(_param.context, [
            "spanId",
            "traceId",
            "traceFlags"
        ]);
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $cac16f6eada858e7$export$eb571cd9b5d98de8,
            attributes: attributes
        }, restContext);
    });
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $cac16f6eada858e7$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $cac16f6eada858e7$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $cac16f6eada858e7$var$ensureTimestampInSeconds(input.getTime());
    return (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $cac16f6eada858e7$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $cac16f6eada858e7$export$92d8c23565496537(span) {
    if ($cac16f6eada858e7$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($cac16f6eada858e7$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        var _span_parentSpanContext;
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? (_span_parentSpanContext = span.parentSpanContext) === null || _span_parentSpanContext === void 0 ? void 0 : _span_parentSpanContext.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $cac16f6eada858e7$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $cac16f6eada858e7$export$3f7581298f56c6d7(endTime) || undefined,
            status: $cac16f6eada858e7$export$e238a77ea3a8cd66(status),
            op: attributes[0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09],
            origin: attributes[0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e],
            links: $cac16f6eada858e7$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $cac16f6eada858e7$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $cac16f6eada858e7$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $cac16f6eada858e7$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $cac16f6eada858e7$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $cac16f6eada858e7$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $f217ebe7a0a6fc3c$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $f217ebe7a0a6fc3c$export$58f7963109c806fc)) return 'ok';
    return status.message || 'unknown_error';
}
const $cac16f6eada858e7$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $cac16f6eada858e7$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $cac16f6eada858e7$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$cac16f6eada858e7$var$ROOT_SPAN_FIELD] || span;
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(childSpan, $cac16f6eada858e7$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD]) span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(span, $cac16f6eada858e7$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $cac16f6eada858e7$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD]) span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $cac16f6eada858e7$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($cac16f6eada858e7$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD] ? Array.from(span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $cac16f6eada858e7$export$c4c6a79b1260ca1b(span) {
    return span[$cac16f6eada858e7$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $cac16f6eada858e7$export$1be426a8e585c83e() {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)((0, $6486f3d311605b78$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $cac16f6eada858e7$export$d11691ff45a3e535() {
    if (!$cac16f6eada858e7$var$hasShownSpanDropWarning) {
        (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $cac16f6eada858e7$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $cac16f6eada858e7$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405)]: 'custom',
        [(0, $fdf17a1e56d9d4ca$export$165ce9a229f6f050)]: name
    });
}



/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $5c79f8c2b5cb59fa$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $5c79f8c2b5cb59fa$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(spanWithMaybeDsc, $5c79f8c2b5cb59fa$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $5c79f8c2b5cb59fa$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $370456451b52ff1d$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $94fe38c0afc4d11c$export$b7ac9b8efa4bb595)(client)
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $5c79f8c2b5cb59fa$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $5c79f8c2b5cb59fa$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $5c79f8c2b5cb59fa$export$a117f995597e25df(span) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $cac16f6eada858e7$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    var _traceState_get, _ref;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = (_ref = (_traceState_get = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.sample_rate')) !== null && _traceState_get !== void 0 ? _traceState_get : rootSpanAttributes[0, $fdf17a1e56d9d4ca$export$ccfe0a40627cc34b]) !== null && _ref !== void 0 ? _ref : rootSpanAttributes[0, $fdf17a1e56d9d4ca$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$5c79f8c2b5cb59fa$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $4d0fefb7946dcfa7$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $5c79f8c2b5cb59fa$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $8540c501196729c9$export$1f70765132c3c225)()) {
        var // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        _getCapturedScopesOnSpan_scope;
        dsc.sampled = String((0, $cac16f6eada858e7$export$5caecac1caaf3a71)(rootSpan));
        var // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        _traceState_get1;
        dsc.sample_rand = (_traceState_get1 = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.sample_rand')) !== null && _traceState_get1 !== void 0 ? _traceState_get1 : (_getCapturedScopesOnSpan_scope = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(rootSpan).scope) === null || _getCapturedScopesOnSpan_scope === void 0 ? void 0 : _getCapturedScopesOnSpan_scope.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $5c79f8c2b5cb59fa$export$95cf936fdacaff7b(span) {
    const dsc = $5c79f8c2b5cb59fa$export$a117f995597e25df(span);
    return (0, $4d0fefb7946dcfa7$export$56766feef403f365)(dsc);
}


// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $e3f8d2d1d7c51bd6$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $e3f8d2d1d7c51bd6$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $e3f8d2d1d7c51bd6$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase !== null && urlBase !== void 0 ? urlBase : isRelative ? $e3f8d2d1d7c51bd6$var$DEFAULT_BASE_URL : undefined;
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch (e) {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $e3f8d2d1d7c51bd6$export$5339fcdc8e2a427c(url) {
    if ($e3f8d2d1d7c51bd6$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $e3f8d2d1d7c51bd6$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    var _request_method;
    var _request_method_toUpperCase;
    const method = (_request_method_toUpperCase = request === null || request === void 0 ? void 0 : (_request_method = request.method) === null || _request_method === void 0 ? void 0 : _request_method.toUpperCase()) !== null && _request_method_toUpperCase !== void 0 ? _request_method_toUpperCase : 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $e3f8d2d1d7c51bd6$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $e3f8d2d1d7c51bd6$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405] = 'route';
    }
    if (request === null || request === void 0 ? void 0 : request.method) attributes[0, $fdf17a1e56d9d4ca$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405] = 'route';
        }
        if (!$e3f8d2d1d7c51bd6$export$e258e13805402ba7(urlObject)) {
            attributes[0, $fdf17a1e56d9d4ca$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $e3f8d2d1d7c51bd6$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $e3f8d2d1d7c51bd6$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $e3f8d2d1d7c51bd6$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = (host === null || host === void 0 ? void 0 : host.replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '')) || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}







const $a6df8b9dd4ca405a$var$STACKTRACE_FRAME_LIMIT = 50;
const $a6df8b9dd4ca405a$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $a6df8b9dd4ca405a$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $a6df8b9dd4ca405a$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $a6df8b9dd4ca405a$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $a6df8b9dd4ca405a$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($a6df8b9dd4ca405a$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $a6df8b9dd4ca405a$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $a6df8b9dd4ca405a$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $a6df8b9dd4ca405a$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $a6df8b9dd4ca405a$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $a6df8b9dd4ca405a$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($a6df8b9dd4ca405a$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($a6df8b9dd4ca405a$var$STRIP_FRAME_REGEXP.test($a6df8b9dd4ca405a$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($a6df8b9dd4ca405a$var$STRIP_FRAME_REGEXP.test($a6df8b9dd4ca405a$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $a6df8b9dd4ca405a$var$STACKTRACE_FRAME_LIMIT).map((frame)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, frame), {
            filename: frame.filename || $a6df8b9dd4ca405a$var$getLastStackFrame(localStack).filename,
            function: frame.function || $a6df8b9dd4ca405a$export$27c7e15d453fc0ac
        }));
}
function $a6df8b9dd4ca405a$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $a6df8b9dd4ca405a$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $a6df8b9dd4ca405a$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $a6df8b9dd4ca405a$var$defaultFunctionName;
        return fn.name || $a6df8b9dd4ca405a$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $a6df8b9dd4ca405a$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $a6df8b9dd4ca405a$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (e) {
            return undefined;
        }
    }
    return undefined;
}


// We keep the handlers globally
const $53b768e21077af87$var$handlers = {};
const $53b768e21077af87$var$instrumented = {};
/** Add a handler function. */ function $53b768e21077af87$export$a4e09611e30da72e(type, handler) {
    $53b768e21077af87$var$handlers[type] = $53b768e21077af87$var$handlers[type] || [];
    $53b768e21077af87$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $53b768e21077af87$export$b17eab759a1cb5fe() {
    Object.keys($53b768e21077af87$var$handlers).forEach((key)=>{
        $53b768e21077af87$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $53b768e21077af87$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$53b768e21077af87$var$instrumented[type]) {
        $53b768e21077af87$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $53b768e21077af87$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $53b768e21077af87$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


let $9d033d1e0336d65c$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $9d033d1e0336d65c$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $9d033d1e0336d65c$var$instrumentError);
}
function $9d033d1e0336d65c$var$instrumentError() {
    $9d033d1e0336d65c$var$_oldOnErrorHandler = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $53b768e21077af87$export$b18c893e424d3127)('error', handlerData);
        if ($9d033d1e0336d65c$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $9d033d1e0336d65c$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}




let $2c547f3d9d7242c6$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2c547f3d9d7242c6$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $2c547f3d9d7242c6$var$instrumentUnhandledRejection);
}
function $2c547f3d9d7242c6$var$instrumentUnhandledRejection() {
    $2c547f3d9d7242c6$var$_oldOnUnhandledRejectionHandler = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $53b768e21077af87$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($2c547f3d9d7242c6$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $2c547f3d9d7242c6$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





let $b345cce51c800673$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $b345cce51c800673$export$b0914730ee1f6c80() {
    if ($b345cce51c800673$var$errorsInstrumented) return;
    /**
   * If an error or unhandled promise occurs, we mark the active root span as failed
   */ function errorCallback() {
        const activeSpan = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(activeSpan);
        if (rootSpan) {
            const message = 'internal_error';
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: (0, $f217ebe7a0a6fc3c$export$f966a0446ece71e),
                message: message
            });
        }
    }
    // The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
    // node.js default exit behaviour
    errorCallback.tag = 'sentry_tracingErrorCallback';
    $b345cce51c800673$var$errorsInstrumented = true;
    (0, $9d033d1e0336d65c$export$55b5c3ba2194f0c6)(errorCallback);
    (0, $2c547f3d9d7242c6$export$8bf4fc6858821a4e)(errorCallback);
}













/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $ca20a23f2fb66f57$export$d6636b700b76c516 {
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $cac16f6eada858e7$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)();
    }
}















/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7879d292a118e15d$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $7879d292a118e15d$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $7879d292a118e15d$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $7879d292a118e15d$export$a3295358bff77e(object, depth);
    if ($7879d292a118e15d$var$jsonSize(normalized) > maxSize) return $7879d292a118e15d$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $7879d292a118e15d$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $7879d292a118e15d$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $7879d292a118e15d$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $7879d292a118e15d$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (e) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $85a434b6cfc19e37$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $7879d292a118e15d$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $7879d292a118e15d$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $85e272e760900bb9$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $85e272e760900bb9$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $7879d292a118e15d$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $7879d292a118e15d$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === void 0 ? void 0 : prototype.constructor) ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $7879d292a118e15d$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7879d292a118e15d$var$jsonSize(value) {
    return $7879d292a118e15d$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $7879d292a118e15d$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (e) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $7879d292a118e15d$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $5e31f551d021d379$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $5e31f551d021d379$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $5e31f551d021d379$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $5e31f551d021d379$export$604a45d95a155e2b(envelope, types) {
    return $5e31f551d021d379$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $5e31f551d021d379$var$encodeUTF8(input) {
    const carrier = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)((0, $df8678217e707dd5$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $5e31f551d021d379$var$decodeUTF8(input) {
    const carrier = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)((0, $df8678217e707dd5$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $5e31f551d021d379$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $5e31f551d021d379$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $5e31f551d021d379$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $7879d292a118e15d$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $5e31f551d021d379$var$concatBuffers(parts);
}
function $5e31f551d021d379$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $5e31f551d021d379$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $5e31f551d021d379$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($5e31f551d021d379$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $5e31f551d021d379$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $5e31f551d021d379$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $5e31f551d021d379$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $5e31f551d021d379$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $5e31f551d021d379$export$b11169581eeaf237(type) {
    return $5e31f551d021d379$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $5e31f551d021d379$export$d369f3b2758f6743(metadataOrEvent) {
    if (!(metadataOrEvent === null || metadataOrEvent === void 0 ? void 0 : metadataOrEvent.sdk)) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $5e31f551d021d379$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    var _event_sdkProcessingMetadata;
    const dynamicSamplingContext = (_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.dynamicSamplingContext;
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn)
    }, dynamicSamplingContext && {
        trace: dynamicSamplingContext
    });
}



/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */ function $3ba72cc613510e20$export$5d569ac97c389400(span, ignoreSpans) {
    if (!(ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) || !span.description) return false;
    for (const pattern of ignoreSpans){
        if ($3ba72cc613510e20$var$isStringOrRegExp(pattern)) {
            if ((0, $6c937b4b236937d4$export$cdded5b28a5f8c6d)(span.description, pattern)) return true;
            continue;
        }
        if (!pattern.name && !pattern.op) continue;
        const nameMatches = pattern.name ? (0, $6c937b4b236937d4$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $6c937b4b236937d4$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
        // for at least one of `nameMatches` and `opMatches`. So in contrary to how this looks,
        // not both op and name actually have to match. This is the most efficient way to check
        // for all combinations of name and op patterns.
        if (nameMatches && opMatches) return true;
    }
    return false;
}
/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */ function $3ba72cc613510e20$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    // This should generally not happen, as we do not apply this on root spans
    // but to be safe, we just bail in this case
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $3ba72cc613510e20$var$isStringOrRegExp(value) {
    return typeof value === 'string' || value instanceof RegExp;
}



/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 *
 * @internal, exported only for testing
 **/ function $0ca80a3f5337ad93$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    var _event_sdk, _event_sdk1, _event_sdk2, _event_sdk3;
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, eventSdkInfo), {
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...((_event_sdk = event.sdk) === null || _event_sdk === void 0 ? void 0 : _event_sdk.integrations) || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...((_event_sdk1 = event.sdk) === null || _event_sdk1 === void 0 ? void 0 : _event_sdk1.packages) || [],
            ...newSdkInfo.packages || []
        ],
        settings: ((_event_sdk2 = event.sdk) === null || _event_sdk2 === void 0 ? void 0 : _event_sdk2.settings) || newSdkInfo.settings ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (_event_sdk3 = event.sdk) === null || _event_sdk3 === void 0 ? void 0 : _event_sdk3.settings, newSdkInfo.settings) : undefined
    });
    return event;
}
/** Creates an envelope from a Session */ function $0ca80a3f5337ad93$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $5e31f551d021d379$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn)
    });
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $0ca80a3f5337ad93$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $5e31f551d021d379$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $0ca80a3f5337ad93$export$8a6cdb6116a9fd2b(event, metadata === null || metadata === void 0 ? void 0 : metadata.sdk);
    const envelopeHeaders = (0, $5e31f551d021d379$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $0ca80a3f5337ad93$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(spans[0]);
    const dsn = client === null || client === void 0 ? void 0 : client.getDsn();
    const tunnel = client === null || client === void 0 ? void 0 : client.getOptions().tunnel;
    const headers = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        sent_at: new Date().toISOString()
    }, dscHasRequiredProps(dsc) && {
        trace: dsc
    }, !!tunnel && dsn && {
        dsn: (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn)
    });
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = (client === null || client === void 0 ? void 0 : client.getOptions()) || {};
    const filteredSpans = (ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) ? spans.filter((span)=>!(0, $3ba72cc613510e20$export$5d569ac97c389400)((0, $cac16f6eada858e7$export$92d8c23565496537)(span), ignoreSpans)) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client === null || client === void 0 ? void 0 : client.recordDroppedEvent('before_send', 'span', droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $cac16f6eada858e7$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $cac16f6eada858e7$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $5e31f551d021d379$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(headers, items);
}











/**
 * Print a log message for a started span.
 */ function $ac09a37575b310ba$export$2f3d84e767c9592b(span) {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $cac16f6eada858e7$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $cac16f6eada858e7$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $ac09a37575b310ba$export$b77c830667a4d630(span) {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(msg);
}






/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $293a838d63649350$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $cac16f6eada858e7$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a)]: value,
            [(0, $fdf17a1e56d9d4ca$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $293a838d63649350$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $fdf17a1e56d9d4ca$export$f5f95cff026507b5];
        const value = attributes[0, $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



const $4c5fac8529c371f2$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $4c5fac8529c371f2$export$a92149b045260d9f {
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $cac16f6eada858e7$export$eb571cd9b5d98de8) : (0, $cac16f6eada858e7$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $cac16f6eada858e7$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $cac16f6eada858e7$export$3f7581298f56c6d7)(endTimestamp);
        (0, $ac09a37575b310ba$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $cac16f6eada858e7$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $fdf17a1e56d9d4ca$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879],
            measurements: (0, $293a838d63649350$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined,
            links: (0, $cac16f6eada858e7$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log('[Tracing] Adding an event to span:', name);
        const time = $4c5fac8529c371f2$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
        const attributes = $4c5fac8529c371f2$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $cac16f6eada858e7$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
        if (client) client.emit('spanEnd', this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $4c5fac8529c371f2$var$sendSpanEnvelope((0, $0ca80a3f5337ad93$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(this).scope || (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        var _capturedSpanScope_getScopeData_sdkProcessingMetadata;
        // We can only convert finished spans
        if (!$4c5fac8529c371f2$var$isFullFinishedSpan((0, $cac16f6eada858e7$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope === null || capturedSpanScope === void 0 ? void 0 : (_capturedSpanScope_getScopeData_sdkProcessingMetadata = capturedSpanScope.getScopeData().sdkProcessingMetadata) === null || _capturedSpanScope_getScopeData_sdkProcessingMetadata === void 0 ? void 0 : _capturedSpanScope_getScopeData_sdkProcessingMetadata.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $cac16f6eada858e7$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$4c5fac8529c371f2$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $cac16f6eada858e7$export$92d8c23565496537)(span)).filter($4c5fac8529c371f2$var$isFullFinishedSpan);
        const source = this._attributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $fdf17a1e56d9d4ca$export$165ce9a229f6f050];
        spans.forEach((span)=>{
            delete span.data[0, $fdf17a1e56d9d4ca$export$165ce9a229f6f050];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            contexts: {
                trace: (0, $cac16f6eada858e7$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $4c5fac8529c371f2$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $4c5fac8529c371f2$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(this)
            },
            request: normalizedRequest
        }, source && {
            transaction_info: {
                source: source
            }
        });
        const measurements = (0, $293a838d63649350$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'manual',
            [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: spanContext.op
        }, spanContext.attributes));
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
}
function $4c5fac8529c371f2$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $4c5fac8529c371f2$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $4c5fac8529c371f2$var$isStandaloneSpan(span) {
    return span instanceof $4c5fac8529c371f2$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $4c5fac8529c371f2$var$sendSpanEnvelope(envelope) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}













/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $e47550d94a838770$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $e47550d94a838770$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $e47550d94a838770$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}
















/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $c763fd1ae3ee0fd4$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $8540c501196729c9$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, samplingContext), {
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        }));
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $ab7c7053b878f035$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}






/* eslint-disable max-lines */ const $93c45d57befd4356$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $93c45d57befd4356$export$a1bd95187356f372(options, callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $93c45d57befd4356$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return (0, $6486f3d311605b78$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $93c45d57befd4356$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
            const parentSpan = $93c45d57befd4356$var$getParentSpan(scope, customParentSpan);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)() : $93c45d57befd4356$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $e47550d94a838770$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $cac16f6eada858e7$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $f217ebe7a0a6fc3c$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $93c45d57befd4356$export$c10292ad04b92aea(options, callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $93c45d57befd4356$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return (0, $6486f3d311605b78$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $93c45d57befd4356$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
            const parentSpan = $93c45d57befd4356$var$getParentSpan(scope, customParentSpan);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)() : $93c45d57befd4356$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $e47550d94a838770$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $cac16f6eada858e7$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $f217ebe7a0a6fc3c$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $93c45d57befd4356$export$63dbba021a6b4047(options) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $93c45d57befd4356$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $6486f3d311605b78$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$93c45d57befd4356$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
        const parentSpan = $93c45d57befd4356$var$getParentSpan(scope, customParentSpan);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)();
        return $93c45d57befd4356$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $93c45d57befd4356$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $4d0fefb7946dcfa7$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $ae017cc8b57317cd$export$18811bc99eefceaa)(client, incomingDsc === null || incomingDsc === void 0 ? void 0 : incomingDsc.org_id)) return $93c45d57befd4356$export$f90b03291402f553(callback);
    return (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $ae017cc8b57317cd$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $93c45d57befd4356$export$e57ac09b143d92a2(span, callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
        (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $93c45d57befd4356$export$869298f9835abc68(callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [$93c45d57befd4356$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$93c45d57befd4356$var$SUPPRESS_TRACING_KEY]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $93c45d57befd4356$export$f90b03291402f553(callback) {
    return (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $93c45d57befd4356$export$e57ac09b143d92a2(null, callback);
    });
}
function $93c45d57befd4356$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $8540c501196729c9$export$1f70765132c3c225)()) {
        const span = new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name
            }, (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(span));
            (0, $5c79f8c2b5cb59fa$export$7398c93e763ca9fd)(span, dsc);
        }
        return span;
    }
    const isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $93c45d57befd4356$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $cac16f6eada858e7$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $cac16f6eada858e7$export$5caecac1caaf3a71)(parentSpan);
        span = $93c45d57befd4356$var$_startRootSpan((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            traceId: traceId,
            parentSpanId: parentSpanId
        }, spanArguments), scope, parentSampled);
        (0, $5c79f8c2b5cb59fa$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, isolationScope.getPropagationContext(), scope.getPropagationContext());
        span = $93c45d57befd4356$var$_startRootSpan((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            traceId: traceId,
            parentSpanId: parentSpanId
        }, spanArguments), scope, parentSampled);
        if (dsc) (0, $5c79f8c2b5cb59fa$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $ac09a37575b310ba$export$2f3d84e767c9592b)(span);
    (0, $f7bbc910493e6179$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $93c45d57befd4356$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        isStandalone: exp.standalone
    }, options);
    if (options.startTime) {
        const ctx = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, initialCtx);
        ctx.startTimestamp = (0, $cac16f6eada858e7$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $93c45d57befd4356$var$getAcs() {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    return (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
}
function $93c45d57befd4356$var$_startRootSpan(spanArguments, scope, parentSampled) {
    var _currentPropagationContext_dsc;
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {};
    const { name: name = '' } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, spanArguments.attributes),
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client === null || client === void 0 ? void 0 : client.emit('beforeSampling', mutableSpanSamplingData, {
        decision: false
    });
    var _mutableSpanSamplingData_parentSampled;
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = (_mutableSpanSamplingData_parentSampled = mutableSpanSamplingData.parentSampled) !== null && _mutableSpanSamplingData_parentSampled !== void 0 ? _mutableSpanSamplingData_parentSampled : parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const [sampled, sampleRate, localSampleRateWasApplied] = scope.getScopeData().sdkProcessingMetadata[$93c45d57befd4356$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $c763fd1ae3ee0fd4$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $ab7c7053b878f035$export$a5bd2d81656d9546)((_currentPropagationContext_dsc = currentPropagationContext.dsc) === null || _currentPropagationContext_dsc === void 0 ? void 0 : _currentPropagationContext_dsc.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $4c5fac8529c371f2$export$a92149b045260d9f)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, spanArguments), {
        attributes: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            [(0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405)]: 'custom',
            [(0, $fdf17a1e56d9d4ca$export$ccfe0a40627cc34b)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined
        }, finalAttributes),
        sampled: sampled
    }));
    if (!sampled && client) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $93c45d57befd4356$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$93c45d57befd4356$var$SUPPRESS_TRACING_KEY] ? false : (0, $cac16f6eada858e7$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $4c5fac8529c371f2$export$a92149b045260d9f)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, spanArguments), {
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    })) : new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $cac16f6eada858e7$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function $93c45d57befd4356$var$getParentSpan(scope, customParentSpan) {
    // always use the passed in span directly
    if (customParentSpan) return customParentSpan;
    // This is different from `undefined` as it means the user explicitly wants no parent span
    if (customParentSpan === null) return undefined;
    const span = (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $93c45d57befd4356$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $93c45d57befd4356$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}


const $3ca6d74f6f135b05$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $3ca6d74f6f135b05$var$FINISH_REASON_HEARTBEAT_FAILED = 'heartbeatFailed';
const $3ca6d74f6f135b05$var$FINISH_REASON_IDLE_TIMEOUT = 'idleTimeout';
const $3ca6d74f6f135b05$var$FINISH_REASON_FINAL_TIMEOUT = 'finalTimeout';
const $3ca6d74f6f135b05$var$FINISH_REASON_EXTERNAL_FINISH = 'externalFinish';
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $3ca6d74f6f135b05$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $3ca6d74f6f135b05$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $3ca6d74f6f135b05$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $3ca6d74f6f135b05$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $3ca6d74f6f135b05$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client || !(0, $8540c501196729c9$export$1f70765132c3c225)()) {
        const span = new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)();
        const dsc = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            sample_rate: '0',
            sampled: 'false'
        }, (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(span));
        (0, $5c79f8c2b5cb59fa$export$7398c93e763ca9fd)(span, dsc);
        return span;
    }
    const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
    const previousActiveSpan = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
    const span = $3ca6d74f6f135b05$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // If the span is non-recording, nothing more to do here...
            // This is the case if tracing is enabled but this specific span was not sampled
            if (thisArg instanceof (0, $ca20a23f2fb66f57$export$d6636b700b76c516)) return;
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
            const spanEndTimestamp = (0, $cac16f6eada858e7$export$3f7581298f56c6d7)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $cac16f6eada858e7$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
            // If we have no spans, we just end, nothing else to do here
            if (!spans.length) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const childEndTimestamps = spans.map((span)=>(0, $cac16f6eada858e7$export$92d8c23565496537)(span).timestamp).filter((timestamp)=>!!timestamp);
            const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = (0, $cac16f6eada858e7$export$92d8c23565496537)(span).start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $3ca6d74f6f135b05$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $3ca6d74f6f135b05$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(scope, previousActiveSpan);
        const spanJSON = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[0, $fdf17a1e56d9d4ca$export$ba73f34502b7a3b3]) span.setAttribute((0, $fdf17a1e56d9d4ca$export$ba73f34502b7a3b3), _finishReason);
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $cac16f6eada858e7$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $f217ebe7a0a6fc3c$export$f966a0446ece71e),
                    message: 'cancelled'
                });
                childSpan.end(endTimestamp);
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log('[Tracing] Cancelling span since span ended early', JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $cac16f6eada858e7$export$92d8c23565496537)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $d8898b8567c29ee9$export$1c9f709888824e05).log('[Tracing] Discarding span since it happened after idle span was finished', stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $d8898b8567c29ee9$export$1c9f709888824e05).log('[Tracing] Discarding span since it finished after idle span final timeout', stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $cac16f6eada858e7$export$c2a0c9438bb89d91)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute('sentry.idle_span_discarded_spans', discardedSpans);
    }
    _cleanupHooks.push(client.on('spanStart', (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $cac16f6eada858e7$export$92d8c23565496537)(startedSpan).timestamp || startedSpan instanceof (0, $4c5fac8529c371f2$export$a92149b045260d9f) && startedSpan.isStandaloneSpan()) return;
        const allSpans = (0, $cac16f6eada858e7$export$340c5c8a13ffc680)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('spanEnd', (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('idleSpanEnableAutoFinish', (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $f217ebe7a0a6fc3c$export$f966a0446ece71e),
                message: 'deadline_exceeded'
            });
            _finishReason = $3ca6d74f6f135b05$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $3ca6d74f6f135b05$var$_startIdleSpan(options) {
    const span = (0, $93c45d57befd4356$export$63dbba021a6b4047)(options);
    (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)((0, $6486f3d311605b78$export$c7be4b0125a10cba)(), span);
    (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log('[Tracing] Started span is an idle span');
    return span;
}





const $ed8e12a1b26c7e3d$var$WINDOW = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $ed8e12a1b26c7e3d$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $ed8e12a1b26c7e3d$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $ed8e12a1b26c7e3d$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $ed8e12a1b26c7e3d$export$67fc34576016d6ec() {
    return 'history' in $ed8e12a1b26c7e3d$var$WINDOW && !!$ed8e12a1b26c7e3d$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $ed8e12a1b26c7e3d$export$edf3cb81fd7d2a3e = $ed8e12a1b26c7e3d$var$_isFetchSupported;
function $ed8e12a1b26c7e3d$var$_isFetchSupported() {
    if (!('fetch' in $ed8e12a1b26c7e3d$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $ed8e12a1b26c7e3d$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $ed8e12a1b26c7e3d$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$ed8e12a1b26c7e3d$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($ed8e12a1b26c7e3d$export$d5f608b368e73f38($ed8e12a1b26c7e3d$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $ed8e12a1b26c7e3d$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var _sandbox_contentWindow;
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if ((_sandbox_contentWindow = sandbox.contentWindow) === null || _sandbox_contentWindow === void 0 ? void 0 : _sandbox_contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $ed8e12a1b26c7e3d$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $ed8e12a1b26c7e3d$export$531055a6c684a70a() {
    return 'ReportingObserver' in $ed8e12a1b26c7e3d$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $ed8e12a1b26c7e3d$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$ed8e12a1b26c7e3d$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}



const $7d1289196f39c6a9$export$56d8a8a25bd48b81 = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);


let $e55a4cd758ef581a$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $e55a4cd758ef581a$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $e55a4cd758ef581a$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $e55a4cd758ef581a$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).addEventListener('popstate', ()=>{
        const to = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $e55a4cd758ef581a$var$lastHref;
        $e55a4cd758ef581a$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $53b768e21077af87$export$b18c893e424d3127)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $ed8e12a1b26c7e3d$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $e55a4cd758ef581a$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $e55a4cd758ef581a$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $e55a4cd758ef581a$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $53b768e21077af87$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}
function $e55a4cd758ef581a$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch (e) {
        // fallback, just do nothing
        return urlOrPath;
    }
}





/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $dc183d0716dee61a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





const $3050c05d7c0075db$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return 'poor';
    if (value > thresholds[0]) return 'needs-improvement';
    return 'good';
};
const $3050c05d7c0075db$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue !== null && prevValue !== void 0 ? prevValue : 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $3050c05d7c0075db$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $8f09f817d2635fa1$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const $e0c3ee5a80e7db0e$export$6431553786c94949 = (checkResponseStart = true)=>{
    var _WINDOW_performance_getEntriesByType, _WINDOW_performance;
    const navigationEntry = (_WINDOW_performance = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).performance) === null || _WINDOW_performance === void 0 ? void 0 : (_WINDOW_performance_getEntriesByType = _WINDOW_performance.getEntriesByType) === null || _WINDOW_performance_getEntriesByType === void 0 ? void 0 : _WINDOW_performance_getEntriesByType.call(_WINDOW_performance, 'navigation')[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases a zero value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // - https://github.com/GoogleChrome/web-vitals/issues/137
    // - https://github.com/GoogleChrome/web-vitals/issues/162
    // - https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $05a9b03c9273a992$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $e0c3ee5a80e7db0e$export$6431553786c94949)();
    var _navEntry_activationStart;
    return (_navEntry_activationStart = navEntry === null || navEntry === void 0 ? void 0 : navEntry.activationStart) !== null && _navEntry_activationStart !== void 0 ? _navEntry_activationStart : 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $af151b44a6156a67$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $e0c3ee5a80e7db0e$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        var _WINDOW_document, _WINDOW_document1;
        if (((_WINDOW_document = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.prerendering) || (0, $05a9b03c9273a992$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else if ((_WINDOW_document1 = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) === null || _WINDOW_document1 === void 0 ? void 0 : _WINDOW_document1.wasDiscarded) navigationType = 'restore';
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, '-');
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: value,
        rating: 'good',
        delta: 0,
        entries: entries,
        id: (0, $8f09f817d2635fa1$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $72ced19dc0357494$var$instanceMap = new WeakMap();
/**
 * A function that accepts and identity object and a class object and returns
 * either a new instance of that class or an existing instance, if the
 * identity object was previously used.
 */ function $72ced19dc0357494$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    if (!$72ced19dc0357494$var$instanceMap.get(identityObj)) $72ced19dc0357494$var$instanceMap.set(identityObj, new ClassObj());
    return $72ced19dc0357494$var$instanceMap.get(identityObj);
}


/* eslint-disable jsdoc/require-jsdoc */ /*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e9708f13be58dc28$export$4050f7f955e19aa0 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
    __init() {
        this._sessionValue = 0;
    }
    // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
    __init2() {
        this._sessionEntries = [];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        var _this__onAfterProcessingUnexpectedShift, _this;
        // Only count layout shifts without recent user input.
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        // This previously used `this._sessionEntries.at(-1)` but that is ES2022. We support ES2021 and earlier.
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        // If the entry occurred less than 1 second after the previous entry
        // and less than 5 seconds after the first entry in the session,
        // include the entry in the current session. Otherwise, start a new
        // session.
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        (_this__onAfterProcessingUnexpectedShift = (_this = this)._onAfterProcessingUnexpectedShift) === null || _this__onAfterProcessingUnexpectedShift === void 0 ? void 0 : _this__onAfterProcessingUnexpectedShift.call(_this, entry);
    }
    constructor(){
        $e9708f13be58dc28$export$4050f7f955e19aa0.prototype.__init.call(this);
        $e9708f13be58dc28$export$4050f7f955e19aa0.prototype.__init2.call(this);
    }
}


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ 
const $e7cae261c9f19358$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                type: type,
                buffered: true
            }, opts));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $69bf802cd2b540ff$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $1f8e3ba3cab7c7ba$var$firstHiddenTime = -1;
const $1f8e3ba3cab7c7ba$var$initHiddenTime = ()=>{
    var _WINDOW_document, _WINDOW_document1;
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return ((_WINDOW_document = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === 'hidden' && !((_WINDOW_document1 = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) === null || _WINDOW_document1 === void 0 ? void 0 : _WINDOW_document1.prerendering) ? 0 : Infinity;
};
const $1f8e3ba3cab7c7ba$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && $1f8e3ba3cab7c7ba$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $1f8e3ba3cab7c7ba$var$firstHiddenTime = event.type === 'visibilitychange' ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        $1f8e3ba3cab7c7ba$var$removeChangeListeners();
    }
};
const $1f8e3ba3cab7c7ba$var$addChangeListeners = ()=>{
    addEventListener('visibilitychange', $1f8e3ba3cab7c7ba$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener('prerenderingchange', $1f8e3ba3cab7c7ba$var$onVisibilityUpdate, true);
};
const $1f8e3ba3cab7c7ba$var$removeChangeListeners = ()=>{
    removeEventListener('visibilitychange', $1f8e3ba3cab7c7ba$var$onVisibilityUpdate, true);
    removeEventListener('prerenderingchange', $1f8e3ba3cab7c7ba$var$onVisibilityUpdate, true);
};
const $1f8e3ba3cab7c7ba$export$443f86b2c77012c4 = ()=>{
    if ((0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document && $1f8e3ba3cab7c7ba$var$firstHiddenTime < 0) {
        var _globalThis_performance_getEntriesByType_filter_;
        // Check if we have a previous hidden `visibility-state` performance entry.
        const activationStart = (0, $05a9b03c9273a992$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document.prerendering ? (_globalThis_performance_getEntriesByType_filter_ = globalThis.performance.getEntriesByType('visibility-state').filter((e)=>e.name === 'hidden' && e.startTime > activationStart)[0]) === null || _globalThis_performance_getEntriesByType_filter_ === void 0 ? void 0 : _globalThis_performance_getEntriesByType_filter_.startTime : undefined;
        // Prefer that, but if it's not available and the document is hidden when
        // this code runs, assume it was hidden since navigation start. This isn't
        // a perfect heuristic, but it's the best we can do until the
        // `visibility-state` performance entry becomes available in all browsers.
        $1f8e3ba3cab7c7ba$var$firstHiddenTime = firstVisibilityStateHiddenTime !== null && firstVisibilityStateHiddenTime !== void 0 ? firstVisibilityStateHiddenTime : $1f8e3ba3cab7c7ba$var$initHiddenTime();
        // We're still going to listen to for changes so we can handle things like
        // bfcache restores and/or prerender without having to examine individual
        // timestamps in detail.
        $1f8e3ba3cab7c7ba$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $1f8e3ba3cab7c7ba$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b0609e939debeb04$export$8bdb38a5671b594e = (callback)=>{
    var _WINDOW_document;
    if ((_WINDOW_document = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.prerendering) addEventListener('prerenderingchange', ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $2d006361d4145a24$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $2d006361d4145a24$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $b0609e939debeb04$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $1f8e3ba3cab7c7ba$export$443f86b2c77012c4)();
        const metric = (0, $af151b44a6156a67$export$3c29b44508a0612b)('FCP');
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === 'first-contentful-paint') {
                po.disconnect();
                // Only report if the page wasn't hidden prior to the first paint.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The activationStart reference is used because FCP should be
                    // relative to page activation rather than navigation start if the
                    // page was prerendered. But in cases where `activationStart` occurs
                    // after the FCP, this time should be clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $05a9b03c9273a992$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $e7cae261c9f19358$export$d1203567a167490e)('paint', handleEntries);
        if (po) report = (0, $3050c05d7c0075db$export$17679dccdd551979)(onReport, metric, $2d006361d4145a24$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $09d4f436374eb328$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $09d4f436374eb328$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $2d006361d4145a24$export$fe3c86b74e15d5de)((0, $69bf802cd2b540ff$export$b841d51e31c12bab)(()=>{
        const metric = (0, $af151b44a6156a67$export$3c29b44508a0612b)('CLS', 0);
        let report;
        const layoutShiftManager = (0, $72ced19dc0357494$export$7c74c9b2462ddb3c)(opts, (0, $e9708f13be58dc28$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $e7cae261c9f19358$export$d1203567a167490e)('layout-shift', handleEntries);
        if (po) {
            var _WINDOW_document, // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            _WINDOW_setTimeout;
            report = (0, $3050c05d7c0075db$export$17679dccdd551979)(onReport, metric, $09d4f436374eb328$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (_WINDOW_document = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.addEventListener('visibilitychange', ()=>{
                var _WINDOW_document;
                if (((_WINDOW_document = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === 'hidden') {
                    handleEntries(po.takeRecords());
                    report(true);
                }
            });
            (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81) === null || (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81) === void 0 ? void 0 : (_WINDOW_setTimeout = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).setTimeout) === null || _WINDOW_setTimeout === void 0 ? void 0 : _WINDOW_setTimeout.call((0, $7d1289196f39c6a9$export$56d8a8a25bd48b81), report);
        }
    }));
};






/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9f3fb447c3190736$var$interactionCountEstimate = 0;
let $9f3fb447c3190736$var$minKnownInteractionId = Infinity;
let $9f3fb447c3190736$var$maxKnownInteractionId = 0;
const $9f3fb447c3190736$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $9f3fb447c3190736$var$minKnownInteractionId = Math.min($9f3fb447c3190736$var$minKnownInteractionId, e.interactionId);
            $9f3fb447c3190736$var$maxKnownInteractionId = Math.max($9f3fb447c3190736$var$maxKnownInteractionId, e.interactionId);
            $9f3fb447c3190736$var$interactionCountEstimate = $9f3fb447c3190736$var$maxKnownInteractionId ? ($9f3fb447c3190736$var$maxKnownInteractionId - $9f3fb447c3190736$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $9f3fb447c3190736$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $9f3fb447c3190736$export$8a962f2683a476d1 = ()=>{
    return $9f3fb447c3190736$var$po ? $9f3fb447c3190736$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $9f3fb447c3190736$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $9f3fb447c3190736$var$po) return;
    $9f3fb447c3190736$var$po = (0, $e7cae261c9f19358$export$d1203567a167490e)('event', $9f3fb447c3190736$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $1f19317ceced8cd7$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let $1f19317ceced8cd7$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $1f19317ceced8cd7$var$getInteractionCountForNavigation = ()=>{
    return (0, $9f3fb447c3190736$export$8a962f2683a476d1)() - $1f19317ceced8cd7$var$prevInteractionCount;
};
/**
 *
 */ class $1f19317ceced8cd7$export$aaa80641d584351c {
    /**
   * A list of longest interactions on the page (by latency) sorted so the
   * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
   * long.
   */ // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
    __init() {
        this._longestInteractionList = [];
    }
    /**
   * A mapping of longest interactions by their interaction ID.
   * This is used for faster lookup.
   */ // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
    __init2() {
        this._longestInteractionMap = new Map();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $1f19317ceced8cd7$var$prevInteractionCount = (0, $9f3fb447c3190736$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($1f19317ceced8cd7$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        var _this__onBeforeProcessingEntry, _this;
        (_this__onBeforeProcessingEntry = (_this = this)._onBeforeProcessingEntry) === null || _this__onBeforeProcessingEntry === void 0 ? void 0 : _this__onBeforeProcessingEntry.call(_this, entry);
        // Skip further processing for entries that cannot be INP candidates.
        if (!(entry.interactionId || entry.entryType === 'first-input')) return;
        // The least-long of the 10 longest interactions.
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        // Only process the entry if it's possibly one of the ten longest,
        // or if it's part of an existing interaction.
        if (interaction || this._longestInteractionList.length < $1f19317ceced8cd7$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            var // Call any post-processing on the interaction
            _this__onAfterProcessingINPCandidate, _this1;
            // If the interaction already exists, update it. Otherwise create one.
            if (interaction) {
                // If the new entry has a longer duration, replace the old entries,
                // otherwise add to the array.
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            // Sort the entries by latency (descending) and keep only the top ten.
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $1f19317ceced8cd7$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($1f19317ceced8cd7$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction of removedInteractions)this._longestInteractionMap.delete(interaction.id);
            }
            (_this__onAfterProcessingINPCandidate = (_this1 = this)._onAfterProcessingINPCandidate) === null || _this__onAfterProcessingINPCandidate === void 0 ? void 0 : _this__onAfterProcessingINPCandidate.call(_this1, interaction);
        }
    }
    constructor(){
        $1f19317ceced8cd7$export$aaa80641d584351c.prototype.__init.call(this);
        $1f19317ceced8cd7$export$aaa80641d584351c.prototype.__init2.call(this);
    }
}




/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Sentry-specific change:
// This function's logic was NOT updated to web-vitals 4.2.4 or 5.x but we continue
// to use the web-vitals 3.5.2 versiondue to us having stricter browser support.
// PR with context that made the changes: https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
// The PR removed listening to the `pagehide` event, in favour of only listening to `visibilitychange` event.
// This is "more correct" but some browsers we still support (Safari <14.4) don't fully support `visibilitychange`
// or have known bugs w.r.t the `visibilitychange` event.
// TODO (v11): If we decide to drop support for Safari 14.4, we can use the logic from web-vitals 4.2.4
// In this case, we also need to update the integration tests that currently trigger the `pagehide` event to
// simulate the page being hidden.
const $8587abb60cb2b1dc$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        var _WINDOW_document;
        if (event.type === 'pagehide' || ((_WINDOW_document = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === 'hidden') cb(event);
    };
    if ((0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};







/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ const $628fdc349eaa1f23$export$d3314d5863fc1fef = (cb)=>{
    var _WINDOW_document;
    const rIC = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).requestIdleCallback || (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).setTimeout;
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if (((_WINDOW_document = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === 'hidden') cb();
    else {
        // eslint-disable-next-line no-param-reassign
        cb = (0, $69bf802cd2b540ff$export$b841d51e31c12bab)(cb);
        rIC(cb);
        // sentry: we use onHidden instead of directly listening to visibilitychange
        // because some browsers we still support (Safari <14.4) don't fully support
        // `visibilitychange` or have known bugs w.r.t the `visibilitychange` event.
        (0, $8587abb60cb2b1dc$export$91ec2be6fdd8f1b4)(cb);
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $31193fd176392a13$export$7f4cb060ded9173c = [
    200,
    500
];
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const $31193fd176392a13$var$DEFAULT_DURATION_THRESHOLD = 40;
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed
 * to control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 will not
 * be reported. To avoid reporting no interactions in these cases, the library
 * will fall back to the input delay of the first interaction. Note that this
 * will not affect your 75th percentile INP value unless that value is also
 * less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $31193fd176392a13$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!(globalThis.PerformanceEventTiming && 'interactionId' in PerformanceEventTiming.prototype)) return;
    (0, $b0609e939debeb04$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $9f3fb447c3190736$export$67d90cda6b78a2eb)();
        const metric = (0, $af151b44a6156a67$export$3c29b44508a0612b)('INP');
        // eslint-disable-next-line prefer-const
        let report;
        const interactionManager = (0, $72ced19dc0357494$export$7c74c9b2462ddb3c)(opts, (0, $1f19317ceced8cd7$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, $628fdc349eaa1f23$export$d3314d5863fc1fef)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        var _opts_durationThreshold;
        const po = (0, $e7cae261c9f19358$export$d1203567a167490e)('event', handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: (_opts_durationThreshold = opts.durationThreshold) !== null && _opts_durationThreshold !== void 0 ? _opts_durationThreshold : $31193fd176392a13$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $3050c05d7c0075db$export$17679dccdd551979)(onReport, metric, $31193fd176392a13$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: 'first-input',
                buffered: true
            });
            // sentry: we use onHidden instead of directly listening to visibilitychange
            // because some browsers we still support (Safari <14.4) don't fully support
            // `visibilitychange` or have known bugs w.r.t the `visibilitychange` event.
            (0, $8587abb60cb2b1dc$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};








/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // eslint-disable-next-line jsdoc/require-jsdoc
class $a57f293d638a1a27$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        var _this__onBeforeProcessingEntry, _this;
        (_this__onBeforeProcessingEntry = (_this = this)._onBeforeProcessingEntry) === null || _this__onBeforeProcessingEntry === void 0 ? void 0 : _this__onBeforeProcessingEntry.call(_this, entry);
    }
}






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $f964e257509f7c07$export$948521ca5b0e1b17 = [
    2500,
    4000
];
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $f964e257509f7c07$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $b0609e939debeb04$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $1f8e3ba3cab7c7ba$export$443f86b2c77012c4)();
        const metric = (0, $af151b44a6156a67$export$3c29b44508a0612b)('LCP');
        let report;
        const lcpEntryManager = (0, $72ced19dc0357494$export$7c74c9b2462ddb3c)(opts, (0, $a57f293d638a1a27$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            for (const entry of entries){
                lcpEntryManager._processEntry(entry);
                // Only report if the page wasn't hidden prior to LCP.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was prerendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $05a9b03c9273a992$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $e7cae261c9f19358$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
        if (po) {
            report = (0, $3050c05d7c0075db$export$17679dccdd551979)(onReport, metric, $f964e257509f7c07$export$948521ca5b0e1b17, opts.reportAllChanges);
            // Ensure this logic only runs once, since it can be triggered from
            // any of three different event listeners below.
            const stopListening = (0, $69bf802cd2b540ff$export$b841d51e31c12bab)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            // Stop listening after input or visibilitychange.
            // Note: while scrolling is an input that stops LCP observation, it's
            // unreliable since it can be programmatically generated.
            // See: https://github.com/GoogleChrome/web-vitals/issues/75
            for (const type of [
                'keydown',
                'click',
                'visibilitychange'
            ])// Wrap the listener in an idle callback so it's run in a separate
            // task to reduce potential INP impact.
            // https://github.com/GoogleChrome/web-vitals/issues/383
            if ((0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) addEventListener(type, ()=>(0, $628fdc349eaa1f23$export$d3314d5863fc1fef)(stopListening), {
                capture: true,
                once: true
            });
        }
    });
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $34371a49c0d65c4e$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $34371a49c0d65c4e$var$whenReady = (callback)=>{
    var _WINDOW_document, _WINDOW_document1;
    if ((_WINDOW_document = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.prerendering) (0, $b0609e939debeb04$export$8bdb38a5671b594e)(()=>$34371a49c0d65c4e$var$whenReady(callback));
    else if (((_WINDOW_document1 = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) === null || _WINDOW_document1 === void 0 ? void 0 : _WINDOW_document1.readyState) !== 'complete') addEventListener('load', ()=>$34371a49c0d65c4e$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $34371a49c0d65c4e$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $af151b44a6156a67$export$3c29b44508a0612b)('TTFB');
    const report = (0, $3050c05d7c0075db$export$17679dccdd551979)(onReport, metric, $34371a49c0d65c4e$export$65c59ea8064668fc, opts.reportAllChanges);
    $34371a49c0d65c4e$var$whenReady(()=>{
        const navigationEntry = (0, $e0c3ee5a80e7db0e$export$6431553786c94949)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, $05a9b03c9273a992$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $cbce24faa829d9d7$var$handlers = {};
const $cbce24faa829d9d7$var$instrumented = {};
let $cbce24faa829d9d7$var$_previousCls;
let $cbce24faa829d9d7$var$_previousLcp;
let $cbce24faa829d9d7$var$_previousTtfb;
let $cbce24faa829d9d7$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $cbce24faa829d9d7$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $cbce24faa829d9d7$var$addMetricObserver('cls', callback, $cbce24faa829d9d7$var$instrumentCls, $cbce24faa829d9d7$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $cbce24faa829d9d7$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $cbce24faa829d9d7$var$addMetricObserver('lcp', callback, $cbce24faa829d9d7$var$instrumentLcp, $cbce24faa829d9d7$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a TTFD metric is available.
 */ function $cbce24faa829d9d7$export$699d9529c099a797(callback) {
    return $cbce24faa829d9d7$var$addMetricObserver('ttfb', callback, $cbce24faa829d9d7$var$instrumentTtfb, $cbce24faa829d9d7$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $cbce24faa829d9d7$export$da3b76aa2022cbd7(callback) {
    return $cbce24faa829d9d7$var$addMetricObserver('inp', callback, $cbce24faa829d9d7$var$instrumentInp, $cbce24faa829d9d7$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $cbce24faa829d9d7$export$69816c1a049f8db6(type, callback) {
    $cbce24faa829d9d7$var$addHandler(type, callback);
    if (!$cbce24faa829d9d7$var$instrumented[type]) {
        $cbce24faa829d9d7$var$instrumentPerformanceObserver(type);
        $cbce24faa829d9d7$var$instrumented[type] = true;
    }
    return $cbce24faa829d9d7$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $cbce24faa829d9d7$var$triggerHandlers(type, data) {
    const typeHandlers = $cbce24faa829d9d7$var$handlers[type];
    if (!(typeHandlers === null || typeHandlers === void 0 ? void 0 : typeHandlers.length)) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $dc183d0716dee61a$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $cbce24faa829d9d7$var$instrumentCls() {
    return (0, $09d4f436374eb328$export$a7873055838e5ad8)((metric)=>{
        $cbce24faa829d9d7$var$triggerHandlers('cls', {
            metric: metric
        });
        $cbce24faa829d9d7$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $cbce24faa829d9d7$var$instrumentLcp() {
    return (0, $f964e257509f7c07$export$947b1626ab8d5632)((metric)=>{
        $cbce24faa829d9d7$var$triggerHandlers('lcp', {
            metric: metric
        });
        $cbce24faa829d9d7$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $cbce24faa829d9d7$var$instrumentTtfb() {
    return (0, $34371a49c0d65c4e$export$33a01e6c5f2c7e33)((metric)=>{
        $cbce24faa829d9d7$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $cbce24faa829d9d7$var$_previousTtfb = metric;
    });
}
function $cbce24faa829d9d7$var$instrumentInp() {
    return (0, $31193fd176392a13$export$7df4b36ecaed99e1)((metric)=>{
        $cbce24faa829d9d7$var$triggerHandlers('inp', {
            metric: metric
        });
        $cbce24faa829d9d7$var$_previousInp = metric;
    });
}
function $cbce24faa829d9d7$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $cbce24faa829d9d7$var$addHandler(type, callback);
    let stopListening;
    if (!$cbce24faa829d9d7$var$instrumented[type]) {
        stopListening = instrumentFn();
        $cbce24faa829d9d7$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $cbce24faa829d9d7$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $cbce24faa829d9d7$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $e7cae261c9f19358$export$d1203567a167490e)(type, (entries)=>{
        $cbce24faa829d9d7$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $cbce24faa829d9d7$var$addHandler(type, handler) {
    $cbce24faa829d9d7$var$handlers[type] = $cbce24faa829d9d7$var$handlers[type] || [];
    $cbce24faa829d9d7$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $cbce24faa829d9d7$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $cbce24faa829d9d7$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $cbce24faa829d9d7$export$7affb50b622d8714(entry) {
    return 'duration' in entry;
}


function $8d60f2ee7fd1c983$export$71511d61b312f219() {
    $8d60f2ee7fd1c983$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8d60f2ee7fd1c983$export$71511d61b312f219.apply(this, arguments);
}


function $7ae6b455e4a352e9$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}






/**
 * Checks if a given value is a valid measurement value.
 */ function $fb660f39aac35743$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $fb660f39aac35743$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, _param) {
    var ctx = (0, $8d60f2ee7fd1c983$export$71511d61b312f219)({}, (0, $7ae6b455e4a352e9$export$71511d61b312f219)(_param));
    const parentStartTime = (0, $cac16f6eada858e7$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === 'function') parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $93c45d57befd4356$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $93c45d57befd4356$export$63dbba021a6b4047)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            startTime: startTimeInSeconds
        }, ctx));
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $fb660f39aac35743$export$b71b9c7b60c5a4aa(options) {
    var _WINDOW_navigator;
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment, sendDefaultPii: sendDefaultPii } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay === null || replay === void 0 ? void 0 : replay.getReplayId();
    const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch (e) {
    // do nothing
    }
    const attributes = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        'user_agent.original': (_WINDOW_navigator = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).navigator) === null || _WINDOW_navigator === void 0 ? void 0 : _WINDOW_navigator.userAgent,
        // This tells Sentry to infer the IP address from the request
        'client.address': sendDefaultPii ? '{{auto}}' : undefined
    }, passedAttributes);
    return (0, $93c45d57befd4356$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $fb660f39aac35743$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).addEventListener && (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $fb660f39aac35743$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $fb660f39aac35743$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
/**
 * Generic support check for web vitals
 */ function $fb660f39aac35743$export$c7533a7b4a9f2e94(entryType) {
    try {
        return PerformanceObserver.supportedEntryTypes.includes(entryType);
    } catch (e) {
        return false;
    }
}
/**
 * Listens for events on which we want to collect a previously accumulated web vital value.
 * Currently, this includes:
 *
 * - pagehide (i.e. user minimizes browser window, hides tab, etc)
 * - soft navigation (we only care about the vital of the initially loaded route)
 *
 * As a "side-effect", this function will also collect the span id of the pageload span.
 *
 * @param collectorCallback the callback to be called when the first of these events is triggered. Parameters:
 * - event: the event that triggered the reporting of the web vital value.
 * - pageloadSpanId: the span id of the pageload span. This is used to link the web vital span to the pageload span.
 */ function $fb660f39aac35743$export$382ad360b45665ab(client, collectorCallback) {
    let pageloadSpanId;
    let collected = false;
    function _runCollectorCallbackOnce(event) {
        if (!collected && pageloadSpanId) collectorCallback(event, pageloadSpanId);
        collected = true;
    }
    (0, $8587abb60cb2b1dc$export$91ec2be6fdd8f1b4)(()=>{
        _runCollectorCallbackOnce('pagehide');
    });
    const unsubscribeStartNavigation = client.on('beforeStartNavigationSpan', (_, options)=>{
        // we only want to collect LCP if we actually navigate. Redirects should be ignored.
        if (!(options === null || options === void 0 ? void 0 : options.isRedirect)) {
            _runCollectorCallbackOnce('navigation');
            $fb660f39aac35743$var$safeUnsubscribe(unsubscribeStartNavigation, unsubscribeAfterStartPageLoadSpan);
        }
    });
    const unsubscribeAfterStartPageLoadSpan = client.on('afterStartPageLoadSpan', (span)=>{
        pageloadSpanId = span.spanContext().spanId;
        $fb660f39aac35743$var$safeUnsubscribe(unsubscribeAfterStartPageLoadSpan);
    });
}
/**
 * Invoke a list of unsubscribers in a safe way, by deferring the invocation to the next tick.
 * This is necessary because unsubscribing in sync can lead to other callbacks no longer being invoked
 * due to in-place array mutation of the subscribers array on the client.
 */ function $fb660f39aac35743$var$safeUnsubscribe(...unsubscribers) {
    unsubscribers.forEach((u)=>u && setTimeout(u, 0));
}


/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $27c8107f56dec97a$export$585bab03c6c18c45(client) {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    if (!(0, $fb660f39aac35743$export$c7533a7b4a9f2e94)('layout-shift')) return;
    const cleanupClsHandler = (0, $cbce24faa829d9d7$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    (0, $fb660f39aac35743$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $27c8107f56dec97a$var$sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
        cleanupClsHandler();
    });
}
function $27c8107f56dec97a$var$sendStandaloneClsSpan(clsValue, entry, pageloadSpanId, reportEvent) {
    var _entry_sources_;
    (0, $dc183d0716dee61a$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() || 0) + ((entry === null || entry === void 0 ? void 0 : entry.startTime) || 0));
    const routeName = (0, $6486f3d311605b78$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $0ff4a1c827ec052f$export$5647df6b7814ac86)((_entry_sources_ = entry.sources[0]) === null || _entry_sources_ === void 0 ? void 0 : _entry_sources_.node) : 'Layout shift';
    const attributes = {
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.http.browser.cls',
        [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: 'ui.webvital.cls',
        [(0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879)]: (entry === null || entry === void 0 ? void 0 : entry.duration) || 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        'sentry.pageload.span_id': pageloadSpanId,
        // describes what triggered the web vital to be reported
        'sentry.report_event': reportEvent
    };
    // Add CLS sources as span attributes to help with debugging layout shifts
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift/sources
    if (entry === null || entry === void 0 ? void 0 : entry.sources) entry.sources.forEach((source, index)=>{
        attributes[`cls.source.${index + 1}`] = (0, $0ff4a1c827ec052f$export$5647df6b7814ac86)(source.node);
    });
    const span = (0, $fb660f39aac35743$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('cls', {
            [(0, $fdf17a1e56d9d4ca$export$f5f95cff026507b5)]: '',
            [(0, $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a)]: clsValue
        });
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}







/**
 * Starts tracking the Largest Contentful Paint on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop LCP measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the LCP value is sent as a standalone span and we stop
 * measuring LCP for subsequent routes.
 */ function $2ee1793a6978b5cd$export$485112b2cb5f79dc(client) {
    let standaloneLcpValue = 0;
    let standaloneLcpEntry;
    if (!(0, $fb660f39aac35743$export$c7533a7b4a9f2e94)('largest-contentful-paint')) return;
    const cleanupLcpHandler = (0, $cbce24faa829d9d7$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneLcpValue = metric.value;
        standaloneLcpEntry = entry;
    }, true);
    (0, $fb660f39aac35743$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $2ee1793a6978b5cd$export$1c28dab7ad4ec937(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
        cleanupLcpHandler();
    });
}
/**
 * Exported only for testing!
 */ function $2ee1793a6978b5cd$export$1c28dab7ad4ec937(lcpValue, entry, pageloadSpanId, reportEvent) {
    (0, $dc183d0716dee61a$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const startTime = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() || 0) + ((entry === null || entry === void 0 ? void 0 : entry.startTime) || 0));
    const routeName = (0, $6486f3d311605b78$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $0ff4a1c827ec052f$export$5647df6b7814ac86)(entry.element) : 'Largest contentful paint';
    const attributes = {
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.http.browser.lcp',
        [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: 'ui.webvital.lcp',
        [(0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879)]: 0,
        // attach the pageload span id to the LCP span so that we can link them in the UI
        'sentry.pageload.span_id': pageloadSpanId,
        // describes what triggered the web vital to be reported
        'sentry.report_event': reportEvent
    };
    if (entry) {
        entry.element && (attributes['lcp.element'] = (0, $0ff4a1c827ec052f$export$5647df6b7814ac86)(entry.element));
        entry.id && (attributes['lcp.id'] = entry.id);
        // Trim URL to the first 200 characters.
        entry.url && (attributes['lcp.url'] = entry.url.trim().slice(0, 200));
        // loadTime is the time of LCP that's related to receiving the LCP element response..
        entry.loadTime != null && (attributes['lcp.loadTime'] = entry.loadTime);
        // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        entry.renderTime != null && (attributes['lcp.renderTime'] = entry.renderTime);
        entry.size != null && (attributes['lcp.size'] = entry.size);
    }
    const span = (0, $fb660f39aac35743$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('lcp', {
            [(0, $fdf17a1e56d9d4ca$export$f5f95cff026507b5)]: 'millisecond',
            [(0, $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a)]: lcpValue
        });
        // LCP is a point-in-time metric, so we end the span immediately
        span.end(startTime);
    }
}






const $c2c9b47952c4cf6c$var$MAX_INT_AS_BYTES = 2147483647;
let $c2c9b47952c4cf6c$var$_performanceCursor = 0;
let $c2c9b47952c4cf6c$var$_measurements = {};
let $c2c9b47952c4cf6c$var$_lcpEntry;
let $c2c9b47952c4cf6c$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $c2c9b47952c4cf6c$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans, recordLcpStandaloneSpans: recordLcpStandaloneSpans, client: client }) {
    const performance = (0, $fb660f39aac35743$export$f72a13c439a30cab)();
    if (performance && (0, $b007b72e24b33b62$export$baf075a948ffc0bf)()) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        const lcpCleanupCallback = recordLcpStandaloneSpans ? (0, $2ee1793a6978b5cd$export$485112b2cb5f79dc)(client) : $c2c9b47952c4cf6c$var$_trackLCP();
        const ttfbCleanupCallback = $c2c9b47952c4cf6c$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $27c8107f56dec97a$export$585bab03c6c18c45)(client) : $c2c9b47952c4cf6c$var$_trackCLS();
        return ()=>{
            lcpCleanupCallback === null || lcpCleanupCallback === void 0 ? void 0 : lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback === null || clsCleanupCallback === void 0 ? void 0 : clsCleanupCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $c2c9b47952c4cf6c$export$f396d19077034ad2() {
    (0, $cbce24faa829d9d7$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        const parent = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $cac16f6eada858e7$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $fb660f39aac35743$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-task',
                attributes: {
                    [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $c2c9b47952c4cf6c$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $cac16f6eada858e7$export$92d8c23565496537)(parent);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes['browser.script.invoker'] = invoker;
            attributes['browser.script.invoker_type'] = invokerType;
            if (sourceURL) attributes['code.filepath'] = sourceURL;
            if (sourceFunctionName) attributes['code.function'] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes['browser.script.source_char_position'] = sourceCharPosition;
            (0, $fb660f39aac35743$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-animation-frame',
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: 'long-animation-frame',
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $c2c9b47952c4cf6c$export$e27543e0976315e4() {
    (0, $cbce24faa829d9d7$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        const parent = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === 'click') {
            const startTime = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $0ff4a1c827ec052f$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            };
            const componentName = (0, $0ff4a1c827ec052f$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes['ui.component_name'] = componentName;
            (0, $fb660f39aac35743$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $c2c9b47952c4cf6c$var$_trackCLS() {
    return (0, $cbce24faa829d9d7$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $c2c9b47952c4cf6c$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $c2c9b47952c4cf6c$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $c2c9b47952c4cf6c$var$_trackLCP() {
    return (0, $cbce24faa829d9d7$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $c2c9b47952c4cf6c$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $c2c9b47952c4cf6c$var$_lcpEntry = entry;
    }, true);
}
function $c2c9b47952c4cf6c$var$_trackTtfb() {
    return (0, $cbce24faa829d9d7$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $c2c9b47952c4cf6c$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
/** Add performance related spans to a transaction */ function $c2c9b47952c4cf6c$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $fb660f39aac35743$export$f72a13c439a30cab)();
    const origin = (0, $b007b72e24b33b62$export$baf075a948ffc0bf)();
    if (!(performance === null || performance === void 0 ? void 0 : performance.getEntries) || !origin) // Gatekeeper if performance API not available
    return;
    const timeOrigin = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
    performanceEntries.slice($c2c9b47952c4cf6c$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $c2c9b47952c4cf6c$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $c2c9b47952c4cf6c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, options.ignorePerformanceApiSpans);
                    // capture web vitals
                    const firstHidden = (0, $1f8e3ba3cab7c7ba$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) $c2c9b47952c4cf6c$var$_measurements['fp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    if (entry.name === 'first-contentful-paint' && shouldRecord) $c2c9b47952c4cf6c$var$_measurements['fcp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    break;
                }
            case 'resource':
                $c2c9b47952c4cf6c$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, options.ignoreResourceSpans);
                break;
        }
    });
    $c2c9b47952c4cf6c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $c2c9b47952c4cf6c$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $c2c9b47952c4cf6c$var$_addTtfbRequestTimeToMeasurements($c2c9b47952c4cf6c$var$_measurements);
        // If CLS standalone spans are enabled, don't record CLS as a measurement
        if (!options.recordClsOnPageloadSpan) delete $c2c9b47952c4cf6c$var$_measurements.cls;
        // If LCP standalone spans are enabled, don't record LCP as a measurement
        if (!options.recordLcpOnPageloadSpan) delete $c2c9b47952c4cf6c$var$_measurements.lcp;
        Object.entries($c2c9b47952c4cf6c$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $293a838d63649350$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute('performance.timeOrigin', timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute('performance.activationStart', (0, $05a9b03c9273a992$export$d3e828b3c7b5b845)());
        $c2c9b47952c4cf6c$var$_setWebVitalAttributes(span, options);
    }
    $c2c9b47952c4cf6c$var$_lcpEntry = undefined;
    $c2c9b47952c4cf6c$var$_clsEntry = undefined;
    $c2c9b47952c4cf6c$var$_measurements = {};
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function $c2c9b47952c4cf6c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ([
        'mark',
        'measure'
    ].includes(entry.entryType) && (0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(entry.name, ignorePerformanceApiSpans)) return;
    const navEntry = (0, $e0c3ee5a80e7db0e$export$6431553786c94949)(false);
    const requestTime = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes['sentry.browser.measure_happened_before_request'] = true;
        attributes['sentry.browser.measure_start_time'] = measureStartTimestamp;
    }
    $c2c9b47952c4cf6c$var$_addDetailToSpanAttributes(attributes, entry);
    // Measurements from third parties can be off, which would create invalid spans, dropping transactions in the process.
    if (measureStartTimestamp <= measureEndTimestamp) (0, $fb660f39aac35743$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function $c2c9b47952c4cf6c$var$_addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        // Accessing detail might throw in some browsers (e.g., Firefox) due to security restrictions
        const detail = performanceMeasure.detail;
        if (!detail) return;
        // Process detail based on its type
        if (typeof detail === 'object') {
            // Handle object details
            for (const [key, value] of Object.entries(detail)){
                if (value && (0, $85e272e760900bb9$export$c3825b437cbdea5c)(value)) attributes[`sentry.browser.measure.detail.${key}`] = value;
                else if (value !== undefined) try {
                    // This is user defined so we can't guarantee it's serializable
                    attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
                } catch (e) {
                // Skip values that can't be stringified
                }
            }
            return;
        }
        if ((0, $85e272e760900bb9$export$c3825b437cbdea5c)(detail)) {
            // Handle primitive details
            attributes['sentry.browser.measure.detail'] = detail;
            return;
        }
        try {
            attributes['sentry.browser.measure.detail'] = JSON.stringify(detail);
        } catch (e) {
        // Skip if stringification fails
        }
    } catch (e) {
    // Silently ignore any errors when accessing detail
    // This handles the Firefox "Permission denied to access object" error
    }
}
/**
 * Instrument navigation entries
 * exported only for tests
 */ function $c2c9b47952c4cf6c$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $c2c9b47952c4cf6c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $c2c9b47952c4cf6c$var$_addPerformanceNavigationTiming(span, entry, 'secureConnection', timeOrigin, 'TLS/SSL');
    $c2c9b47952c4cf6c$var$_addPerformanceNavigationTiming(span, entry, 'fetch', timeOrigin, 'cache');
    $c2c9b47952c4cf6c$var$_addPerformanceNavigationTiming(span, entry, 'domainLookup', timeOrigin, 'DNS');
    $c2c9b47952c4cf6c$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $c2c9b47952c4cf6c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $c2c9b47952c4cf6c$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $fb660f39aac35743$export$7567a67bdb69a23d)(span, timeOrigin + (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
        }, event === 'redirect' && entry.redirectCount != null ? {
            'http.redirect_count': entry.redirectCount
        } : {})
    });
}
function $c2c9b47952c4cf6c$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === 'secureConnection') return 'connectEnd';
    if (event === 'fetch') return 'domainLookupStart';
    return `${event}End`;
}
/** Create request and response related spans */ function $c2c9b47952c4cf6c$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $fb660f39aac35743$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: 'browser.request',
            name: entry.name,
            attributes: {
                [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
        (0, $fb660f39aac35743$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: 'browser.response',
            name: entry.name,
            attributes: {
                [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function $c2c9b47952c4cf6c$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoreResourceSpans) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const op = entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other';
    if (ignoreResourceSpans === null || ignoreResourceSpans === void 0 ? void 0 : ignoreResourceSpans.includes(op)) return;
    const parsedUrl = (0, $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150)(resourceUrl);
    const attributes = {
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
    };
    $c2c9b47952c4cf6c$var$setResourceEntrySizeData(attributes, entry, 'transferSize', 'http.response_transfer_size');
    $c2c9b47952c4cf6c$var$setResourceEntrySizeData(attributes, entry, 'encodedBodySize', 'http.response_content_length');
    $c2c9b47952c4cf6c$var$setResourceEntrySizeData(attributes, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    // `deliveryType` is experimental and does not exist everywhere
    const deliveryType = entry.deliveryType;
    if (deliveryType != null) attributes['http.response_delivery_type'] = deliveryType;
    // Types do not reflect this property yet
    const renderBlockingStatus = entry.renderBlockingStatus;
    if (renderBlockingStatus) attributes['resource.render_blocking_status'] = renderBlockingStatus;
    if (parsedUrl.protocol) attributes['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes['server.address'] = parsedUrl.host;
    attributes['url.same_origin'] = resourceUrl.includes((0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).location.origin);
    // Checking for only `undefined` and `null` is intentional because it's
    // valid for `nextHopProtocol` to be an empty string.
    if (entry.nextHopProtocol != null) {
        const { name: name, version: version } = (0, $fb660f39aac35743$export$57c6f824442f9fe1)(entry.nextHopProtocol);
        attributes['network.protocol.name'] = name;
        attributes['network.protocol.version'] = version;
    }
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $fb660f39aac35743$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).location.origin, ''),
        op: op,
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $c2c9b47952c4cf6c$var$_trackNavigator(span) {
    const navigator = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute('effectiveConnectionType', connection.effectiveType);
        if (connection.type) span.setAttribute('connectionType', connection.type);
        if ((0, $fb660f39aac35743$export$27169ccae1b439e3)(connection.rtt)) $c2c9b47952c4cf6c$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $fb660f39aac35743$export$27169ccae1b439e3)(navigator.deviceMemory)) span.setAttribute('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $fb660f39aac35743$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) span.setAttribute('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $c2c9b47952c4cf6c$var$_setWebVitalAttributes(span, options) {
    // Only add LCP attributes if LCP is being recorded on the pageload span
    if ($c2c9b47952c4cf6c$var$_lcpEntry && options.recordLcpOnPageloadSpan) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($c2c9b47952c4cf6c$var$_lcpEntry.element) span.setAttribute('lcp.element', (0, $0ff4a1c827ec052f$export$5647df6b7814ac86)($c2c9b47952c4cf6c$var$_lcpEntry.element));
        if ($c2c9b47952c4cf6c$var$_lcpEntry.id) span.setAttribute('lcp.id', $c2c9b47952c4cf6c$var$_lcpEntry.id);
        if ($c2c9b47952c4cf6c$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute('lcp.url', $c2c9b47952c4cf6c$var$_lcpEntry.url.trim().slice(0, 200));
        if ($c2c9b47952c4cf6c$var$_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute('lcp.loadTime', $c2c9b47952c4cf6c$var$_lcpEntry.loadTime);
        if ($c2c9b47952c4cf6c$var$_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute('lcp.renderTime', $c2c9b47952c4cf6c$var$_lcpEntry.renderTime);
        span.setAttribute('lcp.size', $c2c9b47952c4cf6c$var$_lcpEntry.size);
    }
    // Only add CLS attributes if CLS is being recorded on the pageload span
    if (($c2c9b47952c4cf6c$var$_clsEntry === null || $c2c9b47952c4cf6c$var$_clsEntry === void 0 ? void 0 : $c2c9b47952c4cf6c$var$_clsEntry.sources) && options.recordClsOnPageloadSpan) $c2c9b47952c4cf6c$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $0ff4a1c827ec052f$export$5647df6b7814ac86)(source.node)));
}
function $c2c9b47952c4cf6c$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $c2c9b47952c4cf6c$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $c2c9b47952c4cf6c$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $e0c3ee5a80e7db0e$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements['ttfb.requestTime'] = {
        value: responseStart - requestStart,
        unit: 'millisecond'
    };
}




const $9db25b656bbcb042$var$LAST_INTERACTIONS = [];
const $9db25b656bbcb042$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * 60 seconds is the maximum for a plausible INP value
 * (source: Me)
 */ const $9db25b656bbcb042$var$MAX_PLAUSIBLE_INP_DURATION = 60;
/**
 * Start tracking INP webvital events.
 */ function $9db25b656bbcb042$export$f17d06681a4744a3() {
    const performance = (0, $fb660f39aac35743$export$f72a13c439a30cab)();
    if (performance && (0, $b007b72e24b33b62$export$baf075a948ffc0bf)()) {
        const inpCallback = $9db25b656bbcb042$export$eeab203db0ed99a9();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $9db25b656bbcb042$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. #
 * exported only for testing
 */ function $9db25b656bbcb042$export$eeab203db0ed99a9() {
    return (0, $cbce24faa829d9d7$export$da3b76aa2022cbd7)($9db25b656bbcb042$export$7bcb98fe01441521);
}
/**
 * exported only for testing
 */ const $9db25b656bbcb042$export$7bcb98fe01441521 = ({ metric: metric })=>{
    if (metric.value == undefined) return;
    const duration = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(metric.value);
    // We received occasional reports of hour-long INP values.
    // Therefore, we add a sanity check to avoid creating spans for
    // unrealistically long INP durations.
    if (duration > $9db25b656bbcb042$var$MAX_PLAUSIBLE_INP_DURATION) return;
    const entry = metric.entries.find((entry)=>entry.duration === metric.value && $9db25b656bbcb042$var$INP_ENTRY_MAP[entry.name]);
    if (!entry) return;
    const { interactionId: interactionId } = entry;
    const interactionType = $9db25b656bbcb042$var$INP_ENTRY_MAP[entry.name];
    /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $fb660f39aac35743$export$b4785dbd4a81b33f)((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() + entry.startTime);
    const activeSpan = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
    // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
    // where we cache the route per interactionId
    const cachedSpan = interactionId != null ? $9db25b656bbcb042$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
    const spanToUse = cachedSpan || rootSpan;
    // Else, we try to use the active span.
    // Finally, we fall back to look at the transactionName on the scope
    const routeName = spanToUse ? (0, $cac16f6eada858e7$export$92d8c23565496537)(spanToUse).description : (0, $6486f3d311605b78$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = (0, $0ff4a1c827ec052f$export$5647df6b7814ac86)(entry.target);
    const attributes = {
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.http.browser.inp',
        [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
        [(0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879)]: entry.duration
    };
    const span = (0, $fb660f39aac35743$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('inp', {
            [(0, $fdf17a1e56d9d4ca$export$f5f95cff026507b5)]: 'millisecond',
            [(0, $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a)]: metric.value
        });
        span.end(startTime + duration);
    }
};
/**
 * Register a listener to cache route information for INP interactions.
 */ function $9db25b656bbcb042$export$e4e04d43e223cce2() {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $cbce24faa829d9d7$export$7affb50b622d8714)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($9db25b656bbcb042$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($9db25b656bbcb042$var$LAST_INTERACTIONS.length > 10) {
                const last = $9db25b656bbcb042$var$LAST_INTERACTIONS.shift();
                $9db25b656bbcb042$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $9db25b656bbcb042$var$LAST_INTERACTIONS.push(interactionId);
            $9db25b656bbcb042$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $cbce24faa829d9d7$export$69816c1a049f8db6)('event', handleEntries);
    (0, $cbce24faa829d9d7$export$69816c1a049f8db6)('first-input', handleEntries);
}




// ElementTiming interface based on the W3C spec
/**
 * Start tracking ElementTiming performance entries.
 */ function $91d07149e056164e$export$c9ffcf7e2b5ec1b3() {
    const performance = (0, $fb660f39aac35743$export$f72a13c439a30cab)();
    if (performance && (0, $b007b72e24b33b62$export$baf075a948ffc0bf)()) return (0, $cbce24faa829d9d7$export$69816c1a049f8db6)('element', $91d07149e056164e$export$2f1fb99ea19ed53a);
    return ()=>undefined;
}
/**
 * exported only for testing
 */ const $91d07149e056164e$export$2f1fb99ea19ed53a = ({ entries: entries })=>{
    const activeSpan = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
    const transactionName = rootSpan ? (0, $cac16f6eada858e7$export$92d8c23565496537)(rootSpan).description : (0, $6486f3d311605b78$export$c7be4b0125a10cba)().getScopeData().transactionName;
    entries.forEach((entry)=>{
        var _elementEntry_element_tagName, _elementEntry_element;
        const elementEntry = entry;
        // Skip entries without identifier (elementtiming attribute)
        if (!elementEntry.identifier) return;
        // `name` contains the type of the element paint. Can be `'image-paint'` or `'text-paint'`.
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceElementTiming#instance_properties
        const paintType = elementEntry.name;
        const renderTime = elementEntry.renderTime;
        const loadTime = elementEntry.loadTime;
        // starting the span at:
        // - `loadTime` if available (should be available for all "image-paint" entries, 0 otherwise)
        // - `renderTime` if available (available for all entries, except 3rd party images, but these should be covered by `loadTime`, 0 otherwise)
        // - `timestampInSeconds()` as a safeguard
        // see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceElementTiming/renderTime#cross-origin_image_render_time
        const [spanStartTime, spanStartTimeSource] = loadTime ? [
            (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(loadTime),
            'load-time'
        ] : renderTime ? [
            (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(renderTime),
            'render-time'
        ] : [
            (0, $b007b72e24b33b62$export$ee52dced521e3e18)(),
            'entry-emission'
        ];
        const duration = paintType === 'image-paint' ? // and `renderTime`. `loadTime` is the time when the image finished loading and `renderTime` is the
        // time when the image finished rendering.
        (0, $fb660f39aac35743$export$b4785dbd4a81b33f)(Math.max(0, (renderTime !== null && renderTime !== void 0 ? renderTime : 0) - (loadTime !== null && loadTime !== void 0 ? loadTime : 0))) : 0;
        const attributes = {
            [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.ui.browser.elementtiming',
            [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: 'ui.elementtiming',
            // name must be user-entered, so we can assume low cardinality
            [(0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405)]: 'component',
            // recording the source of the span start time, as it varies depending on available data
            'sentry.span_start_time_source': spanStartTimeSource,
            'sentry.transaction_name': transactionName,
            'element.id': elementEntry.id,
            'element.type': ((_elementEntry_element = elementEntry.element) === null || _elementEntry_element === void 0 ? void 0 : (_elementEntry_element_tagName = _elementEntry_element.tagName) === null || _elementEntry_element_tagName === void 0 ? void 0 : _elementEntry_element_tagName.toLowerCase()) || 'unknown',
            'element.size': elementEntry.naturalWidth && elementEntry.naturalHeight ? `${elementEntry.naturalWidth}x${elementEntry.naturalHeight}` : undefined,
            'element.render_time': renderTime,
            'element.load_time': loadTime,
            // `url` is `0`(number) for text paints (hence we fall back to undefined)
            'element.url': elementEntry.url || undefined,
            'element.identifier': elementEntry.identifier,
            'element.paint_type': paintType
        };
        (0, $93c45d57befd4356$export$a1bd95187356f372)({
            name: `element[${elementEntry.identifier}]`,
            attributes: attributes,
            startTime: spanStartTime,
            onlyIfParent: true
        }, (span)=>{
            span.end(spanStartTime + duration);
        });
    });
};


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0e18e4f00372f41d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;




















/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ const $29c1921438eb1933$var$STATE_PENDING = 0;
const $29c1921438eb1933$var$STATE_RESOLVED = 1;
const $29c1921438eb1933$var$STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $29c1921438eb1933$export$1fda8aa4d135f8aa(value) {
    return new $29c1921438eb1933$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $29c1921438eb1933$export$78e43115b553f358(reason) {
    return new $29c1921438eb1933$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $29c1921438eb1933$export$6f292d4960313241 {
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $29c1921438eb1933$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $29c1921438eb1933$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $29c1921438eb1933$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $29c1921438eb1933$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $29c1921438eb1933$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $29c1921438eb1933$var$STATE_PENDING) return;
            if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($29c1921438eb1933$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($29c1921438eb1933$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
    constructor(executor){
        this._state = $29c1921438eb1933$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $769941f266d7f5f1$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $29c1921438eb1933$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), hint);
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && processor.id && result === null && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(result)) result.then((final)=>$769941f266d7f5f1$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $769941f266d7f5f1$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}







/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $ac282f0a7b601ec0$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $ac282f0a7b601ec0$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $ac282f0a7b601ec0$var$applySpanToEvent(event, span);
    $ac282f0a7b601ec0$var$applyFingerprintToEvent(event, fingerprint);
    $ac282f0a7b601ec0$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $ac282f0a7b601ec0$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $ac282f0a7b601ec0$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $ac282f0a7b601ec0$export$b1a120a2871faa46(data, 'extra', extra);
    $ac282f0a7b601ec0$export$b1a120a2871faa46(data, 'tags', tags);
    $ac282f0a7b601ec0$export$b1a120a2871faa46(data, 'user', user);
    $ac282f0a7b601ec0$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $6758701f8e924183$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, data.propagationContext, propagationContext);
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $ac282f0a7b601ec0$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $6758701f8e924183$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $ac282f0a7b601ec0$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, extra, event.extra);
    if (Object.keys(tags).length) event.tags = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, tags, event.tags);
    if (Object.keys(user).length) event.user = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, user, event.user);
    if (Object.keys(contexts).length) event.contexts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, contexts, event.contexts);
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $ac282f0a7b601ec0$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $ac282f0a7b601ec0$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function $ac282f0a7b601ec0$var$applySpanToEvent(event, span) {
    event.contexts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        trace: (0, $cac16f6eada858e7$export$46c6fbd1d265ebf0)(span)
    }, event.contexts);
    event.sdkProcessingMetadata = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        dynamicSamplingContext: (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(span)
    }, event.sdkProcessingMetadata);
    const rootSpan = (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $cac16f6eada858e7$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $ac282f0a7b601ec0$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}



let $1e2af912048c6c6b$var$parsedStackResults;
let $1e2af912048c6c6b$var$lastKeysCount;
let $1e2af912048c6c6b$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $1e2af912048c6c6b$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($1e2af912048c6c6b$var$cachedFilenameDebugIds && debugIdKeys.length === $1e2af912048c6c6b$var$lastKeysCount) return $1e2af912048c6c6b$var$cachedFilenameDebugIds;
    $1e2af912048c6c6b$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $1e2af912048c6c6b$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$1e2af912048c6c6b$var$parsedStackResults) $1e2af912048c6c6b$var$parsedStackResults = {};
        const result = $1e2af912048c6c6b$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame === null || stackFrame === void 0 ? void 0 : stackFrame.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $1e2af912048c6c6b$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $1e2af912048c6c6b$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $1e2af912048c6c6b$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $1e2af912048c6c6b$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}






/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $670d18f27a56af80$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
        event_id: event.event_id || hint.event_id || (0, $df365b8ef5885c2b$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $b007b72e24b33b62$export$7740643b9eeaf0c4)()
    });
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $670d18f27a56af80$export$d7e04067a6fbc882(prepared, options);
    $670d18f27a56af80$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $670d18f27a56af80$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $670d18f27a56af80$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $6486f3d311605b78$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $ac282f0a7b601ec0$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $ac282f0a7b601ec0$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $ac282f0a7b601ec0$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $769941f266d7f5f1$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $670d18f27a56af80$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $670d18f27a56af80$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $670d18f27a56af80$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $370456451b52ff1d$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request === null || request === void 0 ? void 0 : request.url) request.url = (0, $6c937b4b236937d4$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $670d18f27a56af80$export$63042efc86f043e7(event, stackParser) {
    var _event_exception_values, _event_exception;
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $1e2af912048c6c6b$export$e069fee9c632ed00)(stackParser);
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $670d18f27a56af80$export$1be657ba8ef44ff0(event) {
    var _event_exception_values, _event_exception;
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $670d18f27a56af80$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $670d18f27a56af80$var$normalizeEvent(event, depth, maxBreadth) {
    var _event_contexts, _event_contexts1;
    if (!event) return null;
    const normalized = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map((b)=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, b, b.data && {
                data: (0, $7879d292a118e15d$export$a3295358bff77e)(b.data, depth, maxBreadth)
            }))
    }, event.user && {
        user: (0, $7879d292a118e15d$export$a3295358bff77e)(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: (0, $7879d292a118e15d$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: (0, $7879d292a118e15d$export$a3295358bff77e)(event.extra, depth, maxBreadth)
    });
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (((_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $7879d292a118e15d$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, span, span.data && {
            data: (0, $7879d292a118e15d$export$a3295358bff77e)(span.data, depth, maxBreadth)
        });
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (((_event_contexts1 = event.contexts) === null || _event_contexts1 === void 0 ? void 0 : _event_contexts1.flags) && normalized.contexts) normalized.contexts.flags = (0, $7879d292a118e15d$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $670d18f27a56af80$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $88388f6b019104ff$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $670d18f27a56af80$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($670d18f27a56af80$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($670d18f27a56af80$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $670d18f27a56af80$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $88388f6b019104ff$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $670d18f27a56af80$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $670d18f27a56af80$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$670d18f27a56af80$var$captureContextKeys.includes(key));
}




/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $bb3616fd55b6cdc0$export$f5282963edea4a68(exception, hint) {
    return (0, $6486f3d311605b78$export$c7be4b0125a10cba)().captureException(exception, (0, $670d18f27a56af80$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $bb3616fd55b6cdc0$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $6486f3d311605b78$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $bb3616fd55b6cdc0$export$1462b974fdcf6ba2(event, hint) {
    return (0, $6486f3d311605b78$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $bb3616fd55b6cdc0$export$2f04de43fe27971a(name, context) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $bb3616fd55b6cdc0$export$bb4922da0dd51b92(extras) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $bb3616fd55b6cdc0$export$8e8e7789d42ed61d(key, extra) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $bb3616fd55b6cdc0$export$74a8fb34822092e6(tags) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $bb3616fd55b6cdc0$export$a37d07ee78eb4569(key, value) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $bb3616fd55b6cdc0$export$8b6bb3dd62a01be2(user) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $bb3616fd55b6cdc0$export$5d4e9fd7fac8e617() {
    return (0, $6486f3d311605b78$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $bb3616fd55b6cdc0$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $bb3616fd55b6cdc0$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $bb3616fd55b6cdc0$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $bb3616fd55b6cdc0$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $6486f3d311605b78$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn('ok');
            return r;
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $bb3616fd55b6cdc0$export$4909b86c8034bf73(timeout) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $bb3616fd55b6cdc0$export$8360e631d277ea4d(timeout) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $bb3616fd55b6cdc0$export$3f95c6f800b78024() {
    return !!(0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $bb3616fd55b6cdc0$export$3b029eb57ac4d562() {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    return (client === null || client === void 0 ? void 0 : client.getOptions().enabled) !== false && !!(client === null || client === void 0 ? void 0 : client.getTransport());
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $bb3616fd55b6cdc0$export$9aac0b9f77928fbf(callback) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $bb3616fd55b6cdc0$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)();
    const currentScope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $4ea28bfd5ee93486$export$14a186326edbb264)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        user: currentScope.getUser() || isolationScope.getUser()
    }, userAgent && {
        userAgent: userAgent
    }, context));
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if ((currentSession === null || currentSession === void 0 ? void 0 : currentSession.status) === 'ok') (0, $4ea28bfd5ee93486$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $bb3616fd55b6cdc0$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $bb3616fd55b6cdc0$export$17a5be43989a0bc1() {
    const isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)();
    const currentScope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $4ea28bfd5ee93486$export$56521d9ba90f62ee)(session);
    $bb3616fd55b6cdc0$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $bb3616fd55b6cdc0$var$_sendSessionUpdate() {
    const isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)();
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $bb3616fd55b6cdc0$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $bb3616fd55b6cdc0$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $bb3616fd55b6cdc0$var$_sendSessionUpdate();
}


const $25b8da85f1f3a684$export$56d8a8a25bd48b81 = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
let $25b8da85f1f3a684$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $25b8da85f1f3a684$export$b79738ab10c590b2() {
    return $25b8da85f1f3a684$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $25b8da85f1f3a684$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $25b8da85f1f3a684$var$ignoreOnError++;
    setTimeout(()=>{
        $25b8da85f1f3a684$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $25b8da85f1f3a684$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $85a434b6cfc19e37$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$25b8da85f1f3a684$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $25b8da85f1f3a684$export$1265a142ff5ba165();
            (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $df365b8ef5885c2b$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                // no need to add a mechanism here, we already add it via an event processor above
                (0, $bb3616fd55b6cdc0$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e) {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $85a434b6cfc19e37$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch (e) {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $25b8da85f1f3a684$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $0ff4a1c827ec052f$export$1cfafeee2987818b)();
    const { referrer: referrer } = $25b8da85f1f3a684$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $25b8da85f1f3a684$export$56d8a8a25bd48b81.navigator || {};
    const headers = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, referrer && {
        Referer: referrer
    }, userAgent && {
        'User-Agent': userAgent
    });
    const request = {
        url: url,
        headers: headers
    };
    return request;
}





/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $02cdae82443d06b6$export$6f18f55521af71a1() {
    if ((0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).document) (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        const activeSpan = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
        if (!activeSpan) return;
        const rootSpan = (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(activeSpan);
        if ((0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = 'cancelled';
            const { op: op, status: status } = (0, $cac16f6eada858e7$export$92d8c23565496537)(rootSpan);
            if (0, $0e18e4f00372f41d$export$16a28057038b10ef) (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $f217ebe7a0a6fc3c$export$f966a0446ece71e),
                message: cancelledStatus
            });
            rootSpan.setAttribute('sentry.cancellation_reason', 'document.hidden');
            rootSpan.end();
        }
    });
    else (0, $0e18e4f00372f41d$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}















// 1h in seconds
const $af2276d1327a4141$export$c8d616af96ac729f = 3600;
// session storage key
const $af2276d1327a4141$export$16b6aa13b3c0f075 = 'sentry_previous_trace';
const $af2276d1327a4141$export$237518aee8726f02 = 'sentry.previous_trace';
/**
 * Takes care of linking traces and applying the (consistent) sampling behavoiour based on the passed options
 * @param options - options for linking traces and consistent trace sampling (@see BrowserTracingOptions)
 * @param client - Sentry client
 */ function $af2276d1327a4141$export$830d9ee659c6e4c4(client, { linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling }) {
    const useSessionStorage = linkPreviousTrace === 'session-storage';
    let inMemoryPreviousTraceInfo = useSessionStorage ? $af2276d1327a4141$export$ef546bba8a402d99() : undefined;
    client.on('spanStart', (span)=>{
        if ((0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span) !== span) return;
        const oldPropagationContext = (0, $6486f3d311605b78$export$c7be4b0125a10cba)().getPropagationContext();
        inMemoryPreviousTraceInfo = $af2276d1327a4141$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $af2276d1327a4141$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    let isFirstTraceOnPageload = true;
    if (consistentTraceSampling) /*
    When users opt into `consistentTraceSampling`, we need to ensure that we propagate
    the previous trace's sample rate and rand to the current trace. This is necessary because otherwise, span
    metric extrapolation is inaccurate, as we'd propagate too high of a sample rate for the subsequent traces.

    So therefore, we pretend that the previous trace was the parent trace of the newly started trace. To do that,
    we mutate the propagation context of the current trace and set the sample rate and sample rand of the previous trace.
    Timing-wise, it is fine because it happens before we even sample the root span.

    @see https://github.com/getsentry/sentry-javascript/issues/15754
    */ client.on('beforeSampling', (mutableSamplingContextData)=>{
        if (!inMemoryPreviousTraceInfo) return;
        const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
        const currentPropagationContext = scope.getPropagationContext();
        // We do not want to force-continue the sampling decision if we continue a trace
        // that was started on the backend. Most prominently, this will happen in MPAs where
        // users hard-navigate between pages. In this case, the sampling decision of a potentially
        // started trace on the server takes precedence.
        // Why? We want to prioritize inter-trace consistency over intra-trace consistency.
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentPropagationContext), {
            dsc: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentPropagationContext.dsc), {
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($af2276d1327a4141$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            }),
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        }));
        mutableSamplingContextData.parentSampled = $af2276d1327a4141$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, mutableSamplingContextData.spanAttributes), {
            [(0, $fdf17a1e56d9d4ca$export$889fb736668e1ecc)]: inMemoryPreviousTraceInfo.sampleRate
        });
    });
}
/**
 * Adds a previous_trace span link to the passed span if the passed
 * previousTraceInfo is still valid.
 *
 * @returns the updated previous trace info (based on the current span/trace) to
 * be used on the next call
 */ function $af2276d1327a4141$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    const spanJson = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
    function getSampleRate() {
        try {
            var _oldPropagationContext_dsc, _spanJson_data;
            var _Number;
            return (_Number = Number((_oldPropagationContext_dsc = oldPropagationContext.dsc) === null || _oldPropagationContext_dsc === void 0 ? void 0 : _oldPropagationContext_dsc.sample_rate)) !== null && _Number !== void 0 ? _Number : Number((_spanJson_data = spanJson.data) === null || _spanJson_data === void 0 ? void 0 : _spanJson_data[0, $fdf17a1e56d9d4ca$export$ccfe0a40627cc34b]);
        } catch (e) {
            return 0;
        }
    }
    const updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) // This means, we're still in the same trace so let's not update the previous trace info
    // or add a link to the current span.
    // Once we move away from the long-lived, route-based trace model, we can remove this cases
    return previousTraceInfo;
    // Only add the link if the startTimeStamp of the previous trace's root span is within
    // PREVIOUS_TRACE_MAX_DURATION (1h) of the current root span's startTimestamp
    // This is done to
    // - avoid adding links to "stale" traces
    // - enable more efficient querying for previous/next traces in Sentry
    if (Date.now() / 1000 - previousTraceInfo.startTimestamp <= $af2276d1327a4141$export$c8d616af96ac729f) {
        if (0, $0e18e4f00372f41d$export$16a28057038b10ef) (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Adding previous_trace ${previousTraceSpanCtx} link to span ${(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            op: spanJson.op
        }, span.spanContext())}`);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $fdf17a1e56d9d4ca$export$ff77b5fd5b2d627b)]: 'previous_trace'
            }
        });
        // TODO: Remove this once EAP can store span links. We currently only set this attribute so that we
        // can obtain the previous trace information from the EAP store. Long-term, EAP will handle
        // span links and then we should remove this again. Also throwing in a TODO(v11), to remind us
        // to check this at v11 time :)
        span.setAttribute($af2276d1327a4141$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${$af2276d1327a4141$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0}`);
    }
    return updatedPreviousTraceInfo;
}
/**
 * Stores @param previousTraceInfo in sessionStorage.
 */ function $af2276d1327a4141$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).sessionStorage.setItem($af2276d1327a4141$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        // Ignore potential errors (e.g. if sessionStorage is not available)
        (0, $0e18e4f00372f41d$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('Could not store previous trace in sessionStorage', e);
    }
}
/**
 * Retrieves the previous trace from sessionStorage if available.
 */ function $af2276d1327a4141$export$ef546bba8a402d99() {
    try {
        var _WINDOW_sessionStorage;
        const previousTraceInfo = (_WINDOW_sessionStorage = (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).sessionStorage) === null || _WINDOW_sessionStorage === void 0 ? void 0 : _WINDOW_sessionStorage.getItem($af2276d1327a4141$export$16b6aa13b3c0f075);
        // @ts-expect-error - intentionally risking JSON.parse throwing when previousTraceInfo is null to save bundle size
        return JSON.parse(previousTraceInfo);
    } catch (e) {
        return undefined;
    }
}
/**
 * see {@link import('@sentry/core').spanIsSampled}
 */ function $af2276d1327a4141$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 0x1;
}











/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2676de91bc47760e$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, ()=>$2676de91bc47760e$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $2676de91bc47760e$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, ()=>$2676de91bc47760e$var$instrumentFetch($2676de91bc47760e$var$streamHandler));
}
function $2676de91bc47760e$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $ed8e12a1b26c7e3d$export$c82d238e23c40b21)()) return;
    (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $df8678217e707dd5$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $2676de91bc47760e$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $2676de91bc47760e$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $53b768e21077af87$export$b18c893e424d3127)('fetch', (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $df8678217e707dd5$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $53b768e21077af87$export$b18c893e424d3127)('fetch', (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlerData), {
                    endTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1000,
                    response: response
                }));
                return response;
            }, (error)=>{
                (0, $53b768e21077af87$export$b18c893e424d3127)('fetch', (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlerData), {
                    endTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1000,
                    error: error
                }));
                if ((0, $85e272e760900bb9$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch (e) {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $2676de91bc47760e$var$resolveResponse(res, onFinishedResolving) {
    if (res === null || res === void 0 ? void 0 : res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (e) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $2676de91bc47760e$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $2676de91bc47760e$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $53b768e21077af87$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $2676de91bc47760e$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $2676de91bc47760e$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($2676de91bc47760e$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $2676de91bc47760e$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $2676de91bc47760e$var$getUrlFromResource(url),
            method: $2676de91bc47760e$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $2676de91bc47760e$var$getUrlFromResource(arg),
        method: $2676de91bc47760e$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $2676de91bc47760e$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $85e272e760900bb9$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch (e) {
    // noop
    }
    return;
}










/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * If (@param options.propagateTraceparent) is `true`, the function will also generate a `traceparent` value,
 * following the W3C traceparent header format.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $bdafc812dacdfe1d$export$dec8f001b9d982cb(options = {}) {
    const client = options.client || (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!(0, $bb3616fd55b6cdc0$export$3b029eb57ac4d562)() || !client) return {};
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
    const span = options.span || (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
    const sentryTrace = span ? (0, $cac16f6eada858e7$export$7e9f8ae9e4a328ab)(span) : $bdafc812dacdfe1d$var$scopeToTraceHeader(scope);
    const dsc = span ? (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(span) : (0, $5c79f8c2b5cb59fa$export$89ef1736f08c6b2b)(client, scope);
    const baggage = (0, $4d0fefb7946dcfa7$export$56766feef403f365)(dsc);
    const isValidSentryTraceHeader = (0, $ae017cc8b57317cd$export$394a210812ba3012).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('Invalid sentry-trace data. Cannot generate trace data');
        return {};
    }
    const traceData = {
        'sentry-trace': sentryTrace,
        baggage: baggage
    };
    if (options.propagateTraceparent) {
        const traceparent = $bdafc812dacdfe1d$export$fb73a238adc5a092(sentryTrace);
        if (traceparent) traceData.traceparent = traceparent;
    }
    return traceData;
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $bdafc812dacdfe1d$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return (0, $ae017cc8b57317cd$export$f35d907436da45cf)(traceId, propagationSpanId, sampled);
}
/**
 * Builds a W3C traceparent header from the given sentry-trace header.
 *
 * Why parse that header and not create traceparent from primitives?
 * We want these two headers to always have the same ids. The easiest way to do this is to take
 * one of them as the source of truth (sentry-trace) and derive the other from it.
 *
 * Most importantly, this guarantees parentSpanId consistency between sentry-trace and traceparent
 * in tracing without performance (TwP) mode, where we always generate a random parentSpanId.
 *
 * Exported for testing
 */ function $bdafc812dacdfe1d$export$fb73a238adc5a092(sentryTrace) {
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = (0, $ae017cc8b57317cd$export$8e9a29865c0a1226)(sentryTrace) || {};
    if (!traceId || !parentSpanId) return undefined;
    return `00-${traceId}-${parentSpanId}-${parentSampled ? '01' : '00'}`;
}














/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $f1c8a6927cdacb2f$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return undefined;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = (0, $8540c501196729c9$export$1f70765132c3c225)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $f1c8a6927cdacb2f$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    // Backwards-compatible with the old signature. Needed to introduce the combined optional parameter
    // to avoid API breakage for anyone calling this function with the optional spanOrigin parameter
    // TODO (v11): remove this backwards-compatible code and only accept the options parameter
    const { spanOrigin: spanOrigin = 'auto.http.browser', propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === 'object' ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const hasParent = !!(0, $cac16f6eada858e7$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $93c45d57befd4356$export$63dbba021a6b4047)($f1c8a6927cdacb2f$var$getSpanStartOptions(url, method, spanOrigin)) : new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = handlerData.args[1] || {};
        const headers = $f1c8a6927cdacb2f$export$eab8901e1b084464(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $8540c501196729c9$export$1f70765132c3c225)() && hasParent ? span : undefined, propagateTraceparent);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit('beforeOutgoingRequestSpan', span, fetchHint);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 * exported only for testing purposes
 *
 * When we determine if we should add a baggage header, there are 3 cases:
 * 1. No previous baggage header -> add baggage
 * 2. Previous baggage header has no sentry baggage values -> add our baggage
 * 3. Previous baggage header has sentry baggage values -> do nothing (might have been added manually by users)
 */ // eslint-disable-next-line complexity -- yup it's this complicated :(
function $f1c8a6927cdacb2f$export$eab8901e1b084464(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = (0, $bdafc812dacdfe1d$export$dec8f001b9d982cb)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders['sentry-trace'];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const originalHeaders = fetchOptionsObj.headers || ((0, $85e272e760900bb9$export$6d3d1f317d7cda57)(request) ? request.headers : undefined);
    if (!originalHeaders) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, traceHeaders);
    else if ($f1c8a6927cdacb2f$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        // We don't want to override manually added sentry headers
        if (!newHeaders.get('sentry-trace')) newHeaders.set('sentry-trace', sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get('traceparent')) newHeaders.set('traceparent', traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get('baggage');
            if (!prevBaggageHeader) newHeaders.set('baggage', baggage);
            else if (!$f1c8a6927cdacb2f$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set('baggage', `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if (Array.isArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!originalHeaders.find((header)=>header[0] === 'sentry-trace')) newHeaders.push([
            'sentry-trace',
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !originalHeaders.find((header)=>header[0] === 'traceparent')) newHeaders.push([
            'traceparent',
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === 'baggage' && $f1c8a6927cdacb2f$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            'baggage',
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = 'sentry-trace' in originalHeaders ? originalHeaders['sentry-trace'] : undefined;
        const existingTraceparentHeader = 'traceparent' in originalHeaders ? originalHeaders.traceparent : undefined;
        const existingBaggageHeader = 'baggage' in originalHeaders ? originalHeaders.baggage : undefined;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$f1c8a6927cdacb2f$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $f1c8a6927cdacb2f$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, originalHeaders), {
            'sentry-trace': existingSentryTraceHeader !== null && existingSentryTraceHeader !== void 0 ? existingSentryTraceHeader : sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $f1c8a6927cdacb2f$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        var _handlerData_response_headers, _handlerData_response;
        (0, $f217ebe7a0a6fc3c$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = (_handlerData_response = handlerData.response) === null || _handlerData_response === void 0 ? void 0 : (_handlerData_response_headers = _handlerData_response.headers) === null || _handlerData_response_headers === void 0 ? void 0 : _handlerData_response_headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $f217ebe7a0a6fc3c$export$f966a0446ece71e),
        message: 'internal_error'
    });
    span.end();
}
function $f1c8a6927cdacb2f$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(',').some((baggageEntry)=>baggageEntry.trim().startsWith((0, $4d0fefb7946dcfa7$export$6e69537d67fa20f)));
}
function $f1c8a6927cdacb2f$var$isHeaders(headers) {
    return typeof Headers !== 'undefined' && (0, $85e272e760900bb9$export$49034edbe6b62415)(headers, Headers);
}
function $f1c8a6927cdacb2f$var$getSpanStartOptions(url, method, spanOrigin) {
    const parsedUrl = (0, $e3f8d2d1d7c51bd6$export$2004d912a9ead694)(url);
    return {
        name: parsedUrl ? `${method} ${(0, $e3f8d2d1d7c51bd6$export$5339fcdc8e2a427c)(parsedUrl)}` : method,
        attributes: $f1c8a6927cdacb2f$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin)
    };
}
function $f1c8a6927cdacb2f$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: url,
        type: 'fetch',
        'http.method': method,
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: 'http.client'
    };
    if (parsedUrl) {
        if (!(0, $e3f8d2d1d7c51bd6$export$e258e13805402ba7)(parsedUrl)) {
            attributes['http.url'] = parsedUrl.href;
            attributes['server.address'] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes['http.query'] = parsedUrl.search;
        if (parsedUrl.hash) attributes['http.fragment'] = parsedUrl.hash;
    }
    return attributes;
}




const $9081af7ea0d74469$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $9081af7ea0d74469$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $9081af7ea0d74469$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $9081af7ea0d74469$export$c67d533bf77cbf54() {
    if (!(0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $85e272e760900bb9$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $9081af7ea0d74469$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$9081af7ea0d74469$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$9081af7ea0d74469$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $53b768e21077af87$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$9081af7ea0d74469$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $85e272e760900bb9$export$844ec244b1367d54)(header) && (0, $85e272e760900bb9$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$9081af7ea0d74469$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $53b768e21077af87$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $9081af7ea0d74469$var$parseXhrUrlArg(url) {
    if ((0, $85e272e760900bb9$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch (e) {} // eslint-disable-line no-empty
    return undefined;
}





function $3bc9f3f02f60a862$var$getAbsoluteTime(time = 0) {
    return (((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() || performance.timeOrigin) + time) / 1000;
}
/**
 * Converts a PerformanceResourceTiming entry to span data for the resource span.
 *
 * @param resourceTiming
 * @returns An array where the first element is the attribute name and the second element is the attribute value.
 */ function $3bc9f3f02f60a862$export$ec50b091612e7e00(resourceTiming) {
    const timingSpanData = [];
    // Checking for only `undefined` and `null` is intentional because it's
    // valid for `nextHopProtocol` to be an empty string.
    if (resourceTiming.nextHopProtocol != undefined) {
        const { name: name, version: version } = (0, $fb660f39aac35743$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
        timingSpanData.push([
            'network.protocol.version',
            version
        ], [
            'network.protocol.name',
            name
        ]);
    }
    if (!(0, $b007b72e24b33b62$export$baf075a948ffc0bf)()) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $3bc9f3f02f60a862$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $3bc9f3f02f60a862$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $3bc9f3f02f60a862$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $3bc9f3f02f60a862$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $3bc9f3f02f60a862$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $3bc9f3f02f60a862$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $3bc9f3f02f60a862$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $3bc9f3f02f60a862$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $3bc9f3f02f60a862$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $3bc9f3f02f60a862$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}


/** Options for Request Instrumentation */ const $68672e01a2c8f414$var$responseToSpanId = new WeakMap();
const $68672e01a2c8f414$var$spanIdToEndTimestamp = new Map();
const $68672e01a2c8f414$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $68672e01a2c8f414$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart } = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $68672e01a2c8f414$export$cc17fb3c0bc95cd7, _options);
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$68672e01a2c8f414$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    const propagateTraceparent = client.getOptions().propagateTraceparent;
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === 'transaction' && event.spans) event.spans.forEach((span)=>{
                if (span.op === 'http.client') {
                    const updatedTimestamp = $68672e01a2c8f414$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $68672e01a2c8f414$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $2676de91bc47760e$export$1a79663eb318fe6a)((handlerData)=>{
            if (handlerData.response) {
                const span = $68672e01a2c8f414$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $68672e01a2c8f414$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $2676de91bc47760e$export$f75d3c772c923df0)((handlerData)=>{
            const createdSpan = (0, $f1c8a6927cdacb2f$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
                propagateTraceparent: propagateTraceparent
            });
            if (handlerData.response && handlerData.fetchData.__span) $68672e01a2c8f414$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = $68672e01a2c8f414$var$getFullURL(handlerData.fetchData.url);
                const host = fullUrl ? (0, $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    'http.url': fullUrl,
                    'server.address': host
                });
                if (enableHTTPTimings) $68672e01a2c8f414$var$addHTTPTimings(createdSpan);
                onRequestSpanStart === null || onRequestSpanStart === void 0 ? void 0 : onRequestSpanStart(createdSpan, {
                    headers: handlerData.headers
                });
            }
        });
    }
    if (traceXHR) (0, $9081af7ea0d74469$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $68672e01a2c8f414$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, propagateTraceparent);
        if (createdSpan) {
            if (enableHTTPTimings) $68672e01a2c8f414$var$addHTTPTimings(createdSpan);
            let headers;
            try {
                var _handlerData_xhr___sentry_xhr_v3__;
                headers = new Headers((_handlerData_xhr___sentry_xhr_v3__ = handlerData.xhr.__sentry_xhr_v3__) === null || _handlerData_xhr___sentry_xhr_v3__ === void 0 ? void 0 : _handlerData_xhr___sentry_xhr_v3__.request_headers);
            } catch (e) {
            // noop
            }
            onRequestSpanStart === null || onRequestSpanStart === void 0 ? void 0 : onRequestSpanStart(createdSpan, {
                headers: headers
            });
        }
    });
}
function $68672e01a2c8f414$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $68672e01a2c8f414$var$addHTTPTimings(span) {
    const { url: url } = (0, $cac16f6eada858e7$export$92d8c23565496537)(span).data;
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $cbce24faa829d9d7$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($68672e01a2c8f414$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanAttributes = (0, $3bc9f3f02f60a862$export$ec50b091612e7e00)(entry);
                spanAttributes.forEach((attributeArray)=>span.setAttribute(...attributeArray));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $68672e01a2c8f414$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $0ff4a1c827ec052f$export$1cfafeee2987818b)();
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $68672e01a2c8f414$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, propagateTraceparent) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr === null || xhr === void 0 ? void 0 : xhr[0, $9081af7ea0d74469$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $8540c501196729c9$export$1f70765132c3c225)() && shouldCreateSpan(url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $f217ebe7a0a6fc3c$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $68672e01a2c8f414$var$getFullURL(url);
    const parsedUrl = fullUrl ? (0, $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150)(fullUrl) : (0, $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150)(url);
    const urlForSpanName = (0, $e3f8d2d1d7c51bd6$export$ce084c78234bd35)(url);
    const hasParent = !!(0, $cac16f6eada858e7$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $93c45d57befd4356$export$63dbba021a6b4047)({
        name: `${method} ${urlForSpanName}`,
        attributes: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            url: url,
            type: 'xhr',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.host,
            [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.http.browser',
            [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: 'http.client'
        }, (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.search) && {
            'http.query': parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.search
        }, (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.hash) && {
            'http.fragment': parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.hash
        })
    }) : new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders(url)) $68672e01a2c8f414$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $8540c501196729c9$export$1f70765132c3c225)() && hasParent ? span : undefined, propagateTraceparent);
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (client) client.emit('beforeOutgoingRequestSpan', span, handlerData);
    return span;
}
function $68672e01a2c8f414$var$addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
    const { 'sentry-trace': sentryTrace, baggage: baggage, traceparent: traceparent } = (0, $bdafc812dacdfe1d$export$dec8f001b9d982cb)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    if (sentryTrace) $68672e01a2c8f414$var$setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
}
function $68672e01a2c8f414$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
    var _xhr___sentry_xhr_v3__;
    const originalHeaders = (_xhr___sentry_xhr_v3__ = xhr.__sentry_xhr_v3__) === null || _xhr___sentry_xhr_v3__ === void 0 ? void 0 : _xhr___sentry_xhr_v3__.request_headers;
    if ((originalHeaders === null || originalHeaders === void 0 ? void 0 : originalHeaders['sentry-trace']) || !xhr.setRequestHeader) // bail if a sentry-trace header is already set
    return;
    try {
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (traceparentHeader && !(originalHeaders === null || originalHeaders === void 0 ? void 0 : originalHeaders['traceparent'])) xhr.setRequestHeader('traceparent', traceparentHeader);
        if (sentryBaggageHeader) {
            // only add our headers if
            // - no pre-existing baggage header exists
            // - or it is set and doesn't yet contain sentry values
            const originalBaggageHeader = originalHeaders === null || originalHeaders === void 0 ? void 0 : originalHeaders['baggage'];
            if (!originalBaggageHeader || !$68672e01a2c8f414$var$baggageHeaderHasSentryValues(originalBaggageHeader)) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
            // We can therefore simply set a baggage header without checking what was there before
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
            xhr.setRequestHeader('baggage', sentryBaggageHeader);
        }
    } catch (e) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $68672e01a2c8f414$var$baggageHeaderHasSentryValues(baggageHeader) {
    return baggageHeader.split(',').some((value)=>value.trim().startsWith('sentry-'));
}
function $68672e01a2c8f414$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}


const $807ffb187a79a074$export$bbd2089f30bd3708 = 'BrowserTracing';
const $807ffb187a79a074$var$DEFAULT_BROWSER_TRACING_OPTIONS = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $3ca6d74f6f135b05$export$809a2b7987fd5306)), {
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    enableElementTiming: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    detectRedirects: true,
    linkPreviousTrace: 'in-memory',
    consistentTraceSampling: false,
    _experiments: {}
}), (0, $68672e01a2c8f414$export$cc17fb3c0bc95cd7));
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $807ffb187a79a074$export$b4109253475213e9 = (_options = {})=>{
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).document;
    const { enableInp: enableInp, enableElementTiming: enableElementTiming, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, ignoreResourceSpans: ignoreResourceSpans, ignorePerformanceApiSpans: ignorePerformanceApiSpans, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, detectRedirects: detectRedirects, linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling, onRequestSpanStart: onRequestSpanStart } = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $807ffb187a79a074$var$DEFAULT_BROWSER_TRACING_OPTIONS, _options);
    let _collectWebVitals;
    let lastInteractionTimestamp;
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions, makeActive = true) {
        const isPageloadTransaction = startSpanOptions.op === 'pageload';
        const initialSpanName = startSpanOptions.name;
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (initialSpanName !== finalStartSpanOptions.name) {
            attributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405] = 'custom';
            finalStartSpanOptions.attributes = attributes;
        }
        if (!makeActive) {
            // We want to ensure this has 0s duration
            const now = (0, $b007b72e24b33b62$export$7740643b9eeaf0c4)();
            (0, $93c45d57befd4356$export$63dbba021a6b4047)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, finalStartSpanOptions), {
                startTime: now
            })).end(now);
            return;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405];
        const idleSpan = (0, $3ca6d74f6f135b05$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                // This will generally always be defined here, because it is set in `setup()` of the integration
                // but technically, it is optional, so we guard here to be extra safe
                _collectWebVitals === null || _collectWebVitals === void 0 ? void 0 : _collectWebVitals();
                (0, $c2c9b47952c4cf6c$export$5f8fa6b3467a7443)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans,
                    recordLcpOnPageloadSpan: !enableStandaloneLcpSpans,
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans
                });
                $807ffb187a79a074$var$setActiveIdleSpan(client, undefined);
                // A trace should stay consistent over the entire timespan of one route - even after the pageload/navigation ended.
                // Only when another navigation happens, we want to create a new trace.
                // This way, e.g. errors that occur after the pageload span ended are still associated to the pageload trace.
                const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, oldPropagationContext), {
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $cac16f6eada858e7$export$5caecac1caaf3a71)(idleSpan),
                    dsc: (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(span)
                }));
            }
        });
        $807ffb187a79a074$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                'interactive',
                'complete'
            ].includes(optionalWindowDocument.readyState)) client.emit('idleSpanEnableAutoFinish', idleSpan);
        }
        if (isPageloadTransaction && optionalWindowDocument) {
            optionalWindowDocument.addEventListener('readystatechange', ()=>{
                emitFinish();
            });
            emitFinish();
        }
    }
    return {
        name: $807ffb187a79a074$export$bbd2089f30bd3708,
        setup (client) {
            (0, $b345cce51c800673$export$b0914730ee1f6c80)();
            _collectWebVitals = (0, $c2c9b47952c4cf6c$export$7c69f0412d101b88)({
                recordClsStandaloneSpans: enableStandaloneClsSpans || false,
                recordLcpStandaloneSpans: enableStandaloneLcpSpans || false,
                client: client
            });
            if (enableInp) (0, $9db25b656bbcb042$export$f17d06681a4744a3)();
            if (enableElementTiming) (0, $91d07149e056164e$export$c9ffcf7e2b5ec1b3)();
            if (enableLongAnimationFrame && (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) (0, $c2c9b47952c4cf6c$export$5b823ab2ccbc801d)();
            else if (enableLongTask) (0, $c2c9b47952c4cf6c$export$f396d19077034ad2)();
            if (enableInteractions) (0, $c2c9b47952c4cf6c$export$e27543e0976315e4)();
            if (detectRedirects && optionalWindowDocument) {
                const interactionHandler = ()=>{
                    lastInteractionTimestamp = (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
                };
                addEventListener('click', interactionHandler, {
                    capture: true
                });
                addEventListener('keydown', interactionHandler, {
                    capture: true,
                    passive: true
                });
            }
            function maybeEndActiveSpan() {
                const activeSpan = $807ffb187a79a074$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $cac16f6eada858e7$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $0e18e4f00372f41d$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`[Tracing] Finishing current active span with op: ${(0, $cac16f6eada858e7$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.setAttribute((0, $fdf17a1e56d9d4ca$export$ba73f34502b7a3b3), 'cancelled');
                    activeSpan.end();
                }
            }
            client.on('startNavigationSpan', (startSpanOptions, navigationOptions)=>{
                if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
                if (navigationOptions === null || navigationOptions === void 0 ? void 0 : navigationOptions.isRedirect) {
                    (0, $0e18e4f00372f41d$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('[Tracing] Detected redirect, navigation span will not be the root span, but a child span.');
                    _createRouteSpan(client, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        op: 'navigation.redirect'
                    }, startSpanOptions), false);
                    return;
                }
                // Reset the last interaction timestamp since we now start a new navigation.
                // Any subsequent navigation span starts could again be a redirect, so we
                // should reset our heuristic detectors.
                lastInteractionTimestamp = undefined;
                maybeEndActiveSpan();
                (0, $6486f3d311605b78$export$68f3af03034c9e90)().setPropagationContext({
                    traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
                    sampleRand: Math.random()
                });
                const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
                scope.setPropagationContext({
                    traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
                    sampleRand: Math.random()
                });
                // We reset this to ensure we do not have lingering incorrect data here
                // places that call this hook may set this where appropriate - else, the URL at span sending time is used
                scope.setSDKProcessingMetadata({
                    normalizedRequest: undefined
                });
                _createRouteSpan(client, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    op: 'navigation'
                }, startSpanOptions));
            });
            client.on('startPageLoadSpan', (startSpanOptions, traceOptions = {})=>{
                if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $807ffb187a79a074$export$f147b32b03c9cf11('sentry-trace');
                const baggage = traceOptions.baggage || $807ffb187a79a074$export$f147b32b03c9cf11('baggage');
                const propagationContext = (0, $ae017cc8b57317cd$export$261f383d16a93e39)(sentryTrace, baggage);
                const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
                scope.setPropagationContext(propagationContext);
                // We store the normalized request data on the scope, so we get the request data at time of span creation
                // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $25b8da85f1f3a684$export$a3c4a8453e8936f0)()
                });
                _createRouteSpan(client, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    op: 'pageload'
                }, startSpanOptions));
            });
        },
        afterAllSetup (client) {
            let startingUrl = (0, $0ff4a1c827ec052f$export$1cfafeee2987818b)();
            if (linkPreviousTrace !== 'off') (0, $af2276d1327a4141$export$830d9ee659c6e4c4)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $b007b72e24b33b62$export$baf075a948ffc0bf)();
                    $807ffb187a79a074$export$aa44a07f82af519f(client, {
                        name: (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1000 : undefined,
                        attributes: {
                            [(0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405)]: 'url',
                            [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.pageload.browser'
                        }
                    });
                }
                if (instrumentNavigation) (0, $e55a4cd758ef581a$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && (startingUrl === null || startingUrl === void 0 ? void 0 : startingUrl.indexOf(to)) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    startingUrl = undefined;
                    const parsed = (0, $e3f8d2d1d7c51bd6$export$2004d912a9ead694)(to);
                    const activeSpan = $807ffb187a79a074$var$getActiveIdleSpan(client);
                    const navigationIsRedirect = activeSpan && detectRedirects && $807ffb187a79a074$var$isRedirect(activeSpan, lastInteractionTimestamp);
                    $807ffb187a79a074$export$7d159749bd9969ad(client, {
                        name: (parsed === null || parsed === void 0 ? void 0 : parsed.pathname) || (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).location.pathname,
                        attributes: {
                            [(0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405)]: 'url',
                            [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: 'auto.navigation.browser'
                        }
                    }, {
                        url: to,
                        isRedirect: navigationIsRedirect
                    });
                });
            }
            if (markBackgroundSpan) (0, $02cdae82443d06b6$export$6f18f55521af71a1)();
            if (enableInteractions) $807ffb187a79a074$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $9db25b656bbcb042$export$e4e04d43e223cce2)();
            (0, $68672e01a2c8f414$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $807ffb187a79a074$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit('startPageLoadSpan', spanOptions, traceOptions);
    (0, $6486f3d311605b78$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const pageloadSpan = $807ffb187a79a074$var$getActiveIdleSpan(client);
    if (pageloadSpan) client.emit('afterStartPageLoadSpan', pageloadSpan);
    return pageloadSpan;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $807ffb187a79a074$export$7d159749bd9969ad(client, spanOptions, options) {
    const { url: url, isRedirect: isRedirect } = options || {};
    client.emit('beforeStartNavigationSpan', spanOptions, {
        isRedirect: isRedirect
    });
    client.emit('startNavigationSpan', spanOptions, {
        isRedirect: isRedirect
    });
    const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
    scope.setTransactionName(spanOptions.name);
    // We store the normalized request data on the scope, so we get the request data at time of span creation
    // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
    if (url && !isRedirect) scope.setSDKProcessingMetadata({
        normalizedRequest: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $25b8da85f1f3a684$export$a3c4a8453e8936f0)()), {
            url: url
        })
    });
    return $807ffb187a79a074$var$getActiveIdleSpan(client);
}
/** Returns the value of a meta tag */ function $807ffb187a79a074$export$f147b32b03c9cf11(metaName) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).document;
    const metaTag = optionalWindowDocument === null || optionalWindowDocument === void 0 ? void 0 : optionalWindowDocument.querySelector(`meta[name=${metaName}]`);
    return (metaTag === null || metaTag === void 0 ? void 0 : metaTag.getAttribute('content')) || undefined;
}
/** Start listener for interaction transactions */ function $807ffb187a79a074$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = 'ui.action.click';
        const activeIdleSpan = $807ffb187a79a074$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $cac16f6eada858e7$export$92d8c23565496537)(activeIdleSpan).op;
            if ([
                'navigation',
                'pageload'
            ].includes(currentRootSpanOp)) {
                (0, $0e18e4f00372f41d$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $fdf17a1e56d9d4ca$export$ba73f34502b7a3b3), 'interactionInterrupted');
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $0e18e4f00372f41d$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $3ca6d74f6f135b05$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405)]: latestRoute.source || 'url'
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener('click', registerInteractionTransaction, {
        capture: true
    });
}
// We store the active idle span on the client object, so we can access it from exported functions
const $807ffb187a79a074$var$ACTIVE_IDLE_SPAN_PROPERTY = '_sentry_idleSpan';
function $807ffb187a79a074$var$getActiveIdleSpan(client) {
    return client[$807ffb187a79a074$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $807ffb187a79a074$var$setActiveIdleSpan(client, span) {
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(client, $807ffb187a79a074$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}
// The max. time in seconds between two pageload/navigation spans that makes us consider the second one a redirect
const $807ffb187a79a074$var$REDIRECT_THRESHOLD = 1.5;
function $807ffb187a79a074$var$isRedirect(activeSpan, lastInteractionTimestamp) {
    const spanData = (0, $cac16f6eada858e7$export$92d8c23565496537)(activeSpan);
    const now = (0, $b007b72e24b33b62$export$7740643b9eeaf0c4)();
    // More than REDIRECT_THRESHOLD seconds since last navigation/pageload span?
    // --> never consider this a redirect
    const startTimestamp = spanData.start_timestamp;
    if (now - startTimestamp > $807ffb187a79a074$var$REDIRECT_THRESHOLD) return false;
    // A click happened in the last REDIRECT_THRESHOLD seconds?
    // --> never consider this a redirect
    if (lastInteractionTimestamp && now - lastInteractionTimestamp <= $807ffb187a79a074$var$REDIRECT_THRESHOLD) return false;
    return true;
}








const $425e0f9c169ee798$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $425e0f9c169ee798$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $425e0f9c169ee798$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $425e0f9c169ee798$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $425e0f9c169ee798$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $425e0f9c169ee798$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $425e0f9c169ee798$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration === null || integration === void 0 ? void 0 : integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $425e0f9c169ee798$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($425e0f9c169ee798$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $425e0f9c169ee798$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $425e0f9c169ee798$export$2d8f5188773bcddd(integration) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $425e0f9c169ee798$export$2323046b9414659f(fn) {
    return fn;
}




const $ba9fe14e35164f86$var$INTEGRATION_NAME = 'Dedupe';
const $ba9fe14e35164f86$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $ba9fe14e35164f86$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($ba9fe14e35164f86$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (e) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $ba9fe14e35164f86$export$6d39aa44cd0c7567 = (0, $425e0f9c169ee798$export$2323046b9414659f)($ba9fe14e35164f86$var$_dedupeIntegration);
/** only exported for tests. */ function $ba9fe14e35164f86$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($ba9fe14e35164f86$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($ba9fe14e35164f86$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $ba9fe14e35164f86$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$ba9fe14e35164f86$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$ba9fe14e35164f86$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $ba9fe14e35164f86$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $ba9fe14e35164f86$var$_getExceptionFromEvent(previousEvent);
    const currentException = $ba9fe14e35164f86$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$ba9fe14e35164f86$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$ba9fe14e35164f86$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $ba9fe14e35164f86$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $a6df8b9dd4ca405a$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $a6df8b9dd4ca405a$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $ba9fe14e35164f86$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (e) {
        return false;
    }
}
function $ba9fe14e35164f86$var$_getExceptionFromEvent(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}




let $af5076b22b0f565c$var$originalFunctionToString;
const $af5076b22b0f565c$var$INTEGRATION_NAME = 'FunctionToString';
const $af5076b22b0f565c$var$SETUP_CLIENTS = new WeakMap();
const $af5076b22b0f565c$var$_functionToStringIntegration = ()=>{
    return {
        name: $af5076b22b0f565c$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $af5076b22b0f565c$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $85a434b6cfc19e37$export$e6cc1e135e2092e5)(this);
                    const context = $af5076b22b0f565c$var$SETUP_CLIENTS.has((0, $6486f3d311605b78$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $af5076b22b0f565c$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $af5076b22b0f565c$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $af5076b22b0f565c$export$7918117e9202e4fb = (0, $425e0f9c169ee798$export$2323046b9414659f)($af5076b22b0f565c$var$_functionToStringIntegration);






/**
 * Get a list of possible event messages from a Sentry event.
 */ function $6fb56feda9bd3e8a$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException === null || lastException === void 0 ? void 0 : lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $cc458e21b964fdb2$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $cc458e21b964fdb2$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $cc458e21b964fdb2$export$9a84f518c163c552 = (0, $425e0f9c169ee798$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $cc458e21b964fdb2$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $cc458e21b964fdb2$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $cc458e21b964fdb2$var$_mergeOptions(options, clientOptions);
            }
            return $cc458e21b964fdb2$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $cc458e21b964fdb2$export$cb3c5c2ceb9818ba = (0, $425e0f9c169ee798$export$2323046b9414659f)((options = {})=>{
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $cc458e21b964fdb2$export$9a84f518c163c552(options)), {
        name: 'InboundFilters'
    });
});
function $cc458e21b964fdb2$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $cc458e21b964fdb2$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $cc458e21b964fdb2$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($cc458e21b964fdb2$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $df365b8ef5885c2b$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($cc458e21b964fdb2$var$_isUselessError(event)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $df365b8ef5885c2b$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($cc458e21b964fdb2$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $df365b8ef5885c2b$export$4157119e2b157127)(event)}.\nUrl: ${$cc458e21b964fdb2$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$cc458e21b964fdb2$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $df365b8ef5885c2b$export$4157119e2b157127)(event)}.\nUrl: ${$cc458e21b964fdb2$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($cc458e21b964fdb2$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $df365b8ef5885c2b$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $cc458e21b964fdb2$var$_isIgnoredError(event, ignoreErrors) {
    if (!(ignoreErrors === null || ignoreErrors === void 0 ? void 0 : ignoreErrors.length)) return false;
    return (0, $6fb56feda9bd3e8a$export$d55a97c329cacfcc)(event).some((message)=>(0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $cc458e21b964fdb2$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!(ignoreTransactions === null || ignoreTransactions === void 0 ? void 0 : ignoreTransactions.length)) return false;
    const name = event.transaction;
    return name ? (0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $cc458e21b964fdb2$var$_isDeniedUrl(event, denyUrls) {
    if (!(denyUrls === null || denyUrls === void 0 ? void 0 : denyUrls.length)) return false;
    const url = $cc458e21b964fdb2$var$_getEventFilterUrl(event);
    return !url ? false : (0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $cc458e21b964fdb2$var$_isAllowedUrl(event, allowUrls) {
    if (!(allowUrls === null || allowUrls === void 0 ? void 0 : allowUrls.length)) return true;
    const url = $cc458e21b964fdb2$var$_getEventFilterUrl(event);
    return !url ? true : (0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $cc458e21b964fdb2$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $cc458e21b964fdb2$var$_getEventFilterUrl(event) {
    try {
        var _event_exception, _rootException_stacktrace;
        var _event_exception_values;
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...(_event_exception_values = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) !== null && _event_exception_values !== void 0 ? _event_exception_values : []
        ].reverse().find((value)=>{
            var _value_mechanism, _value_stacktrace_frames, _value_stacktrace;
            return ((_value_mechanism = value.mechanism) === null || _value_mechanism === void 0 ? void 0 : _value_mechanism.parent_id) === undefined && ((_value_stacktrace = value.stacktrace) === null || _value_stacktrace === void 0 ? void 0 : (_value_stacktrace_frames = _value_stacktrace.frames) === null || _value_stacktrace_frames === void 0 ? void 0 : _value_stacktrace_frames.length);
        });
        const frames = rootException === null || rootException === void 0 ? void 0 : (_rootException_stacktrace = rootException.stacktrace) === null || _rootException_stacktrace === void 0 ? void 0 : _rootException_stacktrace.frames;
        return frames ? $cc458e21b964fdb2$var$_getLastValidUrl(frames) : null;
    } catch (e) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Cannot extract url for event ${(0, $df365b8ef5885c2b$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $cc458e21b964fdb2$var$_isUselessError(event) {
    var _event_exception_values, _event_exception;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.length)) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $5adaab7f928cd880$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) (0, $d8898b8567c29ee9$export$1c9f709888824e05).enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $5adaab7f928cd880$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $5adaab7f928cd880$export$ecb76f41d43c0e43(client) {
    (0, $6486f3d311605b78$export$c7be4b0125a10cba)().setClient(client);
}









const $8c0899c4b9f5d22e$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $8c0899c4b9f5d22e$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $8c0899c4b9f5d22e$var$_getIngestEndpoint(dsn) {
    return `${$8c0899c4b9f5d22e$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $8c0899c4b9f5d22e$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $8c0899c4b9f5d22e$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $8c0899c4b9f5d22e$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$8c0899c4b9f5d22e$var$_getIngestEndpoint(dsn)}?${$8c0899c4b9f5d22e$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $8c0899c4b9f5d22e$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $94fe38c0afc4d11c$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$8c0899c4b9f5d22e$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}











/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $cf3e39e4079becde$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $b007b72e24b33b62$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
















/**
 * Converts a transaction event to a span JSON object.
 */ function $86741795a2158fb1$export$d9c6b2464b0a687e(event) {
    var _event_contexts;
    var _event_contexts_trace;
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = (_event_contexts_trace = (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) !== null && _event_contexts_trace !== void 0 ? _event_contexts_trace : {};
    var _event_start_timestamp;
    return {
        data: data !== null && data !== void 0 ? data : {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id !== null && span_id !== void 0 ? span_id : '',
        start_timestamp: (_event_start_timestamp = event.start_timestamp) !== null && _event_start_timestamp !== void 0 ? _event_start_timestamp : 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id !== null && trace_id !== void 0 ? trace_id : '',
        origin: origin,
        profile_id: data === null || data === void 0 ? void 0 : data[0, $fdf17a1e56d9d4ca$export$1efec95406bbe327],
        exclusive_time: data === null || data === void 0 ? void 0 : data[0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $86741795a2158fb1$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, span.data, span.profile_id && {
                    [(0, $fdf17a1e56d9d4ca$export$1efec95406bbe327)]: span.profile_id
                }, span.exclusive_time && {
                    [(0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879)]: span.exclusive_time
                })
            }
        },
        measurements: span.measurements
    };
}


/* eslint-disable max-lines */ const $4b79de9c25a3b1c8$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $4b79de9c25a3b1c8$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $4b79de9c25a3b1c8$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $4b79de9c25a3b1c8$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function $4b79de9c25a3b1c8$var$_makeInternalError(message) {
    return {
        message: message,
        [$4b79de9c25a3b1c8$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $4b79de9c25a3b1c8$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$4b79de9c25a3b1c8$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $4b79de9c25a3b1c8$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $4b79de9c25a3b1c8$var$INTERNAL_ERROR_SYMBOL in error;
}
function $4b79de9c25a3b1c8$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $4b79de9c25a3b1c8$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $4b79de9c25a3b1c8$export$1f2bb630327ac4b6 {
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $df365b8ef5885c2b$export$6de4ffac6a2f1098)(exception)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log($4b79de9c25a3b1c8$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            event_id: eventId
        }, hint);
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            event_id: (0, $df365b8ef5885c2b$export$19f53698e68b2496)()
        }, hint);
        const eventMessage = (0, $85e272e760900bb9$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $85e272e760900bb9$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((hint === null || hint === void 0 ? void 0 : hint.originalException) && (0, $df365b8ef5885c2b$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log($4b79de9c25a3b1c8$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            event_id: eventId
        }, hint);
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $4ea28bfd5ee93486$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $29c1921438eb1933$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $425e0f9c169ee798$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $425e0f9c169ee798$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $0ca80a3f5337ad93$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $5e31f551d021d379$export$d650323442802f6f)(env, (0, $5e31f551d021d379$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $370456451b52ff1d$export$849dbeeeda01ae98) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn($4b79de9c25a3b1c8$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn($4b79de9c25a3b1c8$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $0ca80a3f5337ad93$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error('Transport disabled');
        return (0, $29c1921438eb1933$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $425e0f9c169ee798$export$51abed9797baa598)(this, integrations);
        (0, $425e0f9c169ee798$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        var _event_exception;
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if ((mechanism === null || mechanism === void 0 ? void 0 : mechanism.handled) === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $4ea28bfd5ee93486$export$531818e825e774db)(session, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $29c1921438eb1933$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && (integrations === null || integrations === void 0 ? void 0 : integrations.length)) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $670d18f27a56af80$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                trace: (0, $6486f3d311605b78$export$1e83db7ee4876dc4)(currentScope)
            }, evt.contexts);
            const dynamicSamplingContext = (0, $5c79f8c2b5cb59fa$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                dynamicSamplingContext: dynamicSamplingContext
            }, evt.sdkProcessingMetadata);
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)(), isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)()) {
        if ((0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && $4b79de9c25a3b1c8$var$isErrorEvent(event)) (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Captured error event \`${(0, $6fb56feda9bd3e8a$export$d55a97c329cacfcc)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) {
                if ($4b79de9c25a3b1c8$var$_isDoNotSendEventError(reason)) (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(reason.message);
                else if ($4b79de9c25a3b1c8$var$_isInternalError(reason)) (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(reason.message);
                else (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $4b79de9c25a3b1c8$var$isTransactionEvent(event);
        const isError = $4b79de9c25a3b1c8$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $ab7c7053b878f035$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $29c1921438eb1933$export$78e43115b553f358)($4b79de9c25a3b1c8$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $4b79de9c25a3b1c8$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $4b79de9c25a3b1c8$var$processBeforeSend(this, options, prepared, hint);
            return $4b79de9c25a3b1c8$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $4b79de9c25a3b1c8$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                var _processedEvent_sdkProcessingMetadata;
                const spanCountBefore = ((_processedEvent_sdkProcessingMetadata = processedEvent.sdkProcessingMetadata) === null || _processedEvent_sdkProcessingMetadata === void 0 ? void 0 : _processedEvent_sdkProcessingMetadata.spanCountBeforeProcessing) || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, transactionInfo), {
                    source: source
                });
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($4b79de9c25a3b1c8$var$_isDoNotSendEventError(reason) || $4b79de9c25a3b1c8$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: 'internal'
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $4b79de9c25a3b1c8$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log('Sending outcomes:', outcomes);
        const envelope = (0, $cf3e39e4079becde$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $94fe38c0afc4d11c$export$128827c3562ec0cb)(options.dsn);
        else (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $8c0899c4b9f5d22e$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this)
            }, options.transportOptions), {
                url: url
            }));
        }
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $4b79de9c25a3b1c8$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $85e272e760900bb9$export$53b83ca8eaab0383)(event) && event !== null) throw $4b79de9c25a3b1c8$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $4b79de9c25a3b1c8$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $85e272e760900bb9$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $4b79de9c25a3b1c8$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $4b79de9c25a3b1c8$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = options;
    let processedEvent = event;
    if ($4b79de9c25a3b1c8$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($4b79de9c25a3b1c8$var$isTransactionEvent(processedEvent)) {
        // Avoid processing if we don't have to
        if (beforeSendSpan || ignoreSpans) {
            // 1. Process root span
            const rootSpanJson = (0, $86741795a2158fb1$export$d9c6b2464b0a687e)(processedEvent);
            // 1.1 If the root span should be ignored, drop the whole transaction
            if ((ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) && (0, $3ba72cc613510e20$export$5d569ac97c389400)(rootSpanJson, ignoreSpans)) // dropping the whole transaction!
            return null;
            // 1.2 If a `beforeSendSpan` callback is defined, process the root span
            if (beforeSendSpan) {
                const processedRootSpanJson = beforeSendSpan(rootSpanJson);
                if (!processedRootSpanJson) (0, $cac16f6eada858e7$export$d11691ff45a3e535)();
                else // update event with processed root span values
                processedEvent = (0, $6758701f8e924183$export$4950aa0f605343fb)(event, (0, $86741795a2158fb1$export$f2d8fce5ae150e92)(processedRootSpanJson));
            }
            // 2. Process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    // 2.a If the child span should be ignored, reparent it to the root span
                    if ((ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) && (0, $3ba72cc613510e20$export$5d569ac97c389400)(span, ignoreSpans)) {
                        (0, $3ba72cc613510e20$export$ddf57376e818b444)(initialSpans, span);
                        continue;
                    }
                    // 2.b If a `beforeSendSpan` callback is defined, process the child span
                    if (beforeSendSpan) {
                        const processedSpan = beforeSendSpan(span);
                        if (!processedSpan) {
                            (0, $cac16f6eada858e7$export$d11691ff45a3e535)();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent('before_send', 'span', droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event.sdkProcessingMetadata), {
                    spanCountBeforeProcessing: spanCountBefore
                });
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $4b79de9c25a3b1c8$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $4b79de9c25a3b1c8$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** Extract trace information from scope */ function $4b79de9c25a3b1c8$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $6486f3d311605b78$export$ec58d9285c204497)(scope, ()=>{
        const span = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
        const traceContext = span ? (0, $cac16f6eada858e7$export$46c6fbd1d265ebf0)(span) : (0, $6486f3d311605b78$export$1e83db7ee4876dc4)(scope);
        const dynamicSamplingContext = span ? (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(span) : (0, $5c79f8c2b5cb59fa$export$89ef1736f08c6b2b)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}









/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $779462112850bb95$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};




/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $c172ea6c14583c3d$export$efdf3b13edb1118e(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $c172ea6c14583c3d$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn);
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(headers, [
        $c172ea6c14583c3d$export$efdf3b13edb1118e(logs)
    ]);
}


const $3d330c92795c098f$var$MAX_LOG_BUFFER_SIZE = 100;
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $3d330c92795c098f$export$84cb46f4adfc5d14(value) {
    switch(typeof value){
        case 'number':
            if (Number.isInteger(value)) return {
                value: value,
                type: 'integer'
            };
            return {
                value: value,
                type: 'double'
            };
        case 'boolean':
            return {
                value: value,
                type: 'boolean'
            };
        case 'string':
            return {
                value: value,
                type: 'string'
            };
        default:
            {
                let stringValue = '';
                try {
                    var _JSON_stringify;
                    stringValue = (_JSON_stringify = JSON.stringify(value)) !== null && _JSON_stringify !== void 0 ? _JSON_stringify : '';
                } catch (e) {
                // Do nothing
                }
                return {
                    value: stringValue,
                    type: 'string'
                };
            }
    }
}
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $3d330c92795c098f$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $3d330c92795c098f$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $3d330c92795c098f$var$_getBufferMap();
    const logBuffer = $3d330c92795c098f$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else {
        bufferMap.set(client, [
            ...logBuffer,
            serializedLog
        ]);
        if (logBuffer.length >= $3d330c92795c098f$var$MAX_LOG_BUFFER_SIZE) $3d330c92795c098f$export$f8ed83d3b6a0b504(client, logBuffer);
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $3d330c92795c098f$export$3ab3d16b9eebd986(beforeLog, client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)(), currentScope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)(), captureSerializedLog = $3d330c92795c098f$export$743ba6f7ec19225f) {
    var _client_getSdkMetadata;
    if (!client) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('No client available to capture log.');
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $4b79de9c25a3b1c8$export$fb7d833b3fdedf5f)(client, currentScope);
    const processedLogAttributes = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, beforeLog.attributes);
    const { user: { id: id, email: email, username: username } } = $3d330c92795c098f$var$getMergedScopeData(currentScope);
    $3d330c92795c098f$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
    $3d330c92795c098f$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
    $3d330c92795c098f$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    $3d330c92795c098f$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $3d330c92795c098f$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    var _client_getSdkMetadata_sdk;
    const { name: name, version: version } = (_client_getSdkMetadata_sdk = (_client_getSdkMetadata = client.getSdkMetadata()) === null || _client_getSdkMetadata === void 0 ? void 0 : _client_getSdkMetadata.sdk) !== null && _client_getSdkMetadata_sdk !== void 0 ? _client_getSdkMetadata_sdk : {};
    $3d330c92795c098f$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $3d330c92795c098f$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const replay = client.getIntegrationByName('Replay');
    $3d330c92795c098f$var$setLogAttribute(processedLogAttributes, 'sentry.replay_id', replay === null || replay === void 0 ? void 0 : replay.getReplayId());
    const beforeLogMessage = beforeLog.message;
    if ((0, $85e272e760900bb9$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__ === null || __sentry_template_values__ === void 0 ? void 0 : __sentry_template_values__.length) processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $3d330c92795c098f$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span === null || span === void 0 ? void 0 : span.spanContext().spanId);
    const processedLog = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, beforeLog), {
        attributes: processedLogAttributes
    });
    client.emit('beforeCaptureLog', processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    const log = beforeSendLog ? (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        timestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)(),
        level: level,
        body: message,
        trace_id: traceContext === null || traceContext === void 0 ? void 0 : traceContext.trace_id,
        severity_number: severityNumber !== null && severityNumber !== void 0 ? severityNumber : (0, $779462112850bb95$export$4fb50c0840d636d1)[level],
        attributes: Object.keys(attributes).reduce((acc, key)=>{
            acc[key] = $3d330c92795c098f$export$84cb46f4adfc5d14(attributes[key]);
            return acc;
        }, {})
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $3d330c92795c098f$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    var _ref;
    const logBuffer = (_ref = maybeLogBuffer !== null && maybeLogBuffer !== void 0 ? maybeLogBuffer : $3d330c92795c098f$export$5365c9902fb9e770(client)) !== null && _ref !== void 0 ? _ref : [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $c172ea6c14583c3d$export$cdcd668e6516443f)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    $3d330c92795c098f$var$_getBufferMap().set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $3d330c92795c098f$export$5365c9902fb9e770(client) {
    return $3d330c92795c098f$var$_getBufferMap().get(client);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $3d330c92795c098f$var$getMergedScopeData(currentScope) {
    const scopeData = (0, $6486f3d311605b78$export$aa55d5ab8e05984f)().getScopeData();
    (0, $ac282f0a7b601ec0$export$25ac7e259a513db4)(scopeData, (0, $6486f3d311605b78$export$68f3af03034c9e90)().getScopeData());
    (0, $ac282f0a7b601ec0$export$25ac7e259a513db4)(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $3d330c92795c098f$var$_getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return (0, $3d29ea41beb10247$export$7e223ec222791509)('clientToLogBufferMap', ()=>new WeakMap());
}

// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 * @deprecated -- set ip inferral via via SDK metadata options on client instead.
 */ 

function $5e2903ba91c783d2$export$3e12ad68afa434ac(objWithMaybeUser) {
    var _objWithMaybeUser_user;
    if (((_objWithMaybeUser_user = objWithMaybeUser.user) === null || _objWithMaybeUser_user === void 0 ? void 0 : _objWithMaybeUser_user.ip_address) === undefined) objWithMaybeUser.user = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objWithMaybeUser.user), {
        ip_address: '{{auto}}'
    });
}
/**
 * @internal
 */ function $5e2903ba91c783d2$export$e8e2d07ba63e2b6c(session) {
    var _session_attrs;
    if ('aggregates' in session) {
        if (((_session_attrs = session.attrs) === null || _session_attrs === void 0 ? void 0 : _session_attrs['ip_address']) === undefined) session.attrs = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, session.attrs), {
            ip_address: '{{auto}}'
        });
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $1ca02136df3c52aa$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $961dedfff8dbd514$export$31499a9cd224b78c)
            })),
        version: (0, $961dedfff8dbd514$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $db66a870e5b08f0d$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $db66a870e5b08f0d$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}





/**
 * This function creates an exception from a JavaScript Error
 */ function $232ad06e7df30921$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $232ad06e7df30921$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $232ad06e7df30921$export$2e9ae379995d99e3(ex),
        value: $232ad06e7df30921$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $232ad06e7df30921$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const normalizeDepth = client === null || client === void 0 ? void 0 : client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $232ad06e7df30921$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $7879d292a118e15d$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $232ad06e7df30921$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $85e272e760900bb9$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $232ad06e7df30921$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $232ad06e7df30921$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $232ad06e7df30921$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $232ad06e7df30921$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $232ad06e7df30921$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $232ad06e7df30921$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $232ad06e7df30921$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $232ad06e7df30921$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $232ad06e7df30921$var$getSkipFirstStackStringLines(ex) {
    if (ex && $232ad06e7df30921$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $232ad06e7df30921$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $232ad06e7df30921$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $232ad06e7df30921$export$2e9ae379995d99e3(ex) {
    const name = ex === null || ex === void 0 ? void 0 : ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $232ad06e7df30921$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $232ad06e7df30921$export$86005d1b62804363(ex) {
    const message = ex === null || ex === void 0 ? void 0 : ex.message;
    if ($232ad06e7df30921$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $232ad06e7df30921$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || undefined;
    const event = $232ad06e7df30921$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, $29c1921438eb1933$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $232ad06e7df30921$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || undefined;
    const event = $232ad06e7df30921$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, $29c1921438eb1933$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $232ad06e7df30921$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $85e272e760900bb9$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $232ad06e7df30921$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $85e272e760900bb9$export$ef9e2056653f0c8e)(exception) || (0, $85e272e760900bb9$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $232ad06e7df30921$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $85e272e760900bb9$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $232ad06e7df30921$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $df365b8ef5885c2b$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event.tags), {
            'DOMException.code': `${domException.code}`
        });
        return event;
    }
    if ((0, $85e272e760900bb9$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $232ad06e7df30921$var$eventFromError(stackParser, exception);
    if ((0, $85e272e760900bb9$export$53b83ca8eaab0383)(exception) || (0, $85e272e760900bb9$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $232ad06e7df30921$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $232ad06e7df30921$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $df365b8ef5885c2b$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $232ad06e7df30921$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $232ad06e7df30921$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $85e272e760900bb9$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $232ad06e7df30921$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $85a434b6cfc19e37$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $85e272e760900bb9$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $85e272e760900bb9$export$9671ea99bd126ace)(exception)) {
        const className = $232ad06e7df30921$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $232ad06e7df30921$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $232ad06e7df30921$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}



/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ const $513bb5325d521226$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $513bb5325d521226$export$1df9218a526d318d extends (0, $4b79de9c25a3b1c8$export$1f2bb630327ac4b6) {
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $232ad06e7df30921$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $232ad06e7df30921$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        var _opts__metadata;
        const opts = $513bb5325d521226$export$4e107b20a7f977(options);
        const sdkSource = (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $db66a870e5b08f0d$export$8ad33f488b1ab046)();
        (0, $1ca02136df3c52aa$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        // Only allow IP inferral by Relay if sendDefaultPii is true
        if ((_opts__metadata = opts._metadata) === null || _opts__metadata === void 0 ? void 0 : _opts__metadata.sdk) opts._metadata.sdk.settings = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            infer_ip: opts.sendDefaultPii ? 'auto' : 'never'
        }, opts._metadata.sdk.settings);
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, enableLogs: enableLogs } = this._options;
        if ((0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs)) (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $3d330c92795c098f$export$f8ed83d3b6a0b504)(this);
            }
        });
        if (enableLogs) {
            this.on('flush', ()=>{
                (0, $3d330c92795c098f$export$f8ed83d3b6a0b504)(this);
            });
            this.on('afterCaptureLog', ()=>{
                if (this._logFlushIdleTimeout) clearTimeout(this._logFlushIdleTimeout);
                this._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $3d330c92795c098f$export$f8ed83d3b6a0b504)(this);
                }, $513bb5325d521226$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) this.on('beforeSendSession', (0, $5e2903ba91c783d2$export$e8e2d07ba63e2b6c));
    }
}
/** Exported only for tests. */ function $513bb5325d521226$export$4e107b20a7f977(optionsArg) {
    var _WINDOW_SENTRY_RELEASE;
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (_WINDOW_SENTRY_RELEASE = (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).SENTRY_RELEASE) === null || _WINDOW_SENTRY_RELEASE === void 0 ? void 0 : _WINDOW_SENTRY_RELEASE.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true
    }, optionsArg);
}








/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $26248f9dbcbb9359$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $26248f9dbcbb9359$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $26248f9dbcbb9359$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $b007b72e24b33b62$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        timestamp: timestamp
    }, breadcrumb);
    const finalBreadcrumb = beforeBreadcrumb ? (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f058fa0fdfb21014$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $f058fa0fdfb21014$var$instrumentConsole);
}
function $f058fa0fdfb21014$var$instrumentConsole() {
    if (!('console' in (0, $df8678217e707dd5$export$f1a6cdb1459e81d1))) return;
    (0, $d8898b8567c29ee9$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).console)) return;
        (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $df8678217e707dd5$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $d8898b8567c29ee9$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $53b768e21077af87$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $d8898b8567c29ee9$export$77c4ce905194557b)[level];
                log === null || log === void 0 ? void 0 : log.apply((0, $df8678217e707dd5$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $7648c008ec662140$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $bff673aa5089d0b2$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}




const $defd8aa19a230a71$var$DEBOUNCE_DURATION = 1000;
let $defd8aa19a230a71$var$debounceTimerID;
let $defd8aa19a230a71$var$lastCapturedEventType;
let $defd8aa19a230a71$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $defd8aa19a230a71$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $defd8aa19a230a71$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $defd8aa19a230a71$export$3014bbf0af0e1d4a() {
    if (!(0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $53b768e21077af87$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $defd8aa19a230a71$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        var _globalObject_target, _proto_hasOwnProperty;
        const globalObject = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81);
        const proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, 'addEventListener'))) return;
        (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $defd8aa19a230a71$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $defd8aa19a230a71$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $defd8aa19a230a71$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $defd8aa19a230a71$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $defd8aa19a230a71$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!(target === null || target === void 0 ? void 0 : target.tagName)) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $defd8aa19a230a71$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $defd8aa19a230a71$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($defd8aa19a230a71$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(target, '_sentryId', (0, $df365b8ef5885c2b$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$defd8aa19a230a71$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $defd8aa19a230a71$var$lastCapturedEventType = event.type;
            $defd8aa19a230a71$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($defd8aa19a230a71$var$debounceTimerID);
        $defd8aa19a230a71$var$debounceTimerID = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).setTimeout(()=>{
            $defd8aa19a230a71$var$lastCapturedEventTargetId = undefined;
            $defd8aa19a230a71$var$lastCapturedEventType = undefined;
        }, $defd8aa19a230a71$var$DEBOUNCE_DURATION);
    };
}
function $defd8aa19a230a71$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}




/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $5d5ee1de09f6864e$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $5d5ee1de09f6864e$var$INTEGRATION_NAME = 'Breadcrumbs';
const $5d5ee1de09f6864e$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true
    }, options);
    return {
        name: $5d5ee1de09f6864e$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v11): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $f058fa0fdfb21014$export$1d6e0d073f9e6723)($5d5ee1de09f6864e$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $defd8aa19a230a71$export$5aeffd3db2cf9df7)($5d5ee1de09f6864e$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $9081af7ea0d74469$export$26ace48dd54c9aea)($5d5ee1de09f6864e$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $2676de91bc47760e$export$f75d3c772c923df0)($5d5ee1de09f6864e$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $e55a4cd758ef581a$export$3f18c56c58114e75)($5d5ee1de09f6864e$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $5d5ee1de09f6864e$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $5d5ee1de09f6864e$export$c079d904b326663a = (0, $425e0f9c169ee798$export$2323046b9414659f)($5d5ee1de09f6864e$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $5d5ee1de09f6864e$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
        (0, $26248f9dbcbb9359$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $df365b8ef5885c2b$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $5d5ee1de09f6864e$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $5d5ee1de09f6864e$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $0e18e4f00372f41d$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`\`dom.maxStringLength\` cannot exceed ${$5d5ee1de09f6864e$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$5d5ee1de09f6864e$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $5d5ee1de09f6864e$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $5d5ee1de09f6864e$var$_isEvent(event) ? event.target : event;
            target = (0, $0ff4a1c827ec052f$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $0ff4a1c827ec052f$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $26248f9dbcbb9359$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $5d5ee1de09f6864e$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $bff673aa5089d0b2$export$d771ef054122c30a)(handlerData.level),
            message: (0, $6c937b4b236937d4$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $6c937b4b236937d4$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $26248f9dbcbb9359$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $5d5ee1de09f6864e$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $9081af7ea0d74469$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $7648c008ec662140$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $26248f9dbcbb9359$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $5d5ee1de09f6864e$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $26248f9dbcbb9359$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlerData.fetchData), {
                status_code: response === null || response === void 0 ? void 0 : response.status
            });
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response === null || response === void 0 ? void 0 : response.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $7648c008ec662140$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $26248f9dbcbb9359$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $5d5ee1de09f6864e$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150)((0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!(parsedFrom === null || parsedFrom === void 0 ? void 0 : parsedFrom.path)) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $26248f9dbcbb9359$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $5d5ee1de09f6864e$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $471b9c9f09863ac2$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $471b9c9f09863ac2$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $471b9c9f09863ac2$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false
    }, options);
    return {
        name: $471b9c9f09863ac2$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $25b8da85f1f3a684$export$56d8a8a25bd48b81), 'setTimeout', $471b9c9f09863ac2$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $25b8da85f1f3a684$export$56d8a8a25bd48b81), 'setInterval', $471b9c9f09863ac2$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $25b8da85f1f3a684$export$56d8a8a25bd48b81), 'requestAnimationFrame', $471b9c9f09863ac2$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81)) (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $471b9c9f09863ac2$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $471b9c9f09863ac2$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$471b9c9f09863ac2$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $471b9c9f09863ac2$export$59bfe9f1c76150e = (0, $425e0f9c169ee798$export$2323046b9414659f)($471b9c9f09863ac2$var$_browserApiErrorsIntegration);
function $471b9c9f09863ac2$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $25b8da85f1f3a684$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $471b9c9f09863ac2$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $25b8da85f1f3a684$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'auto.browser.browserapierrors.requestAnimationFrame'
                }
            })
        ]);
    };
}
function $471b9c9f09863ac2$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $85a434b6cfc19e37$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $25b8da85f1f3a684$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $471b9c9f09863ac2$var$_wrapEventTarget(target, integrationOptions) {
    var _globalObject_target, _proto_hasOwnProperty;
    const globalObject = (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81);
    const proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, 'addEventListener'))) return;
    (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($471b9c9f09863ac2$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $25b8da85f1f3a684$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.handleEvent'
                    }
                });
            } catch (e) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $471b9c9f09863ac2$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $25b8da85f1f3a684$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.addEventListener'
                    }
                }),
                options
            ]);
        };
    });
    (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $471b9c9f09863ac2$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $471b9c9f09863ac2$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $450f2f09c71b9ef4$export$1baa7880e357371c = (0, $425e0f9c169ee798$export$2323046b9414659f)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $0e18e4f00372f41d$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $bb3616fd55b6cdc0$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $bb3616fd55b6cdc0$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $e55a4cd758ef581a$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $bb3616fd55b6cdc0$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $bb3616fd55b6cdc0$export$667e7b4d445d566b)();
                }
            });
        }
    };
});







const $3cc5df047cc4dd51$var$INTEGRATION_NAME = 'GlobalHandlers';
const $3cc5df047cc4dd51$var$_globalHandlersIntegration = (options = {})=>{
    const _options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        onerror: true,
        onunhandledrejection: true
    }, options);
    return {
        name: $3cc5df047cc4dd51$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $3cc5df047cc4dd51$var$_installGlobalOnErrorHandler(client);
                $3cc5df047cc4dd51$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $3cc5df047cc4dd51$var$_installGlobalOnUnhandledRejectionHandler(client);
                $3cc5df047cc4dd51$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $3cc5df047cc4dd51$export$66acc70e8cf2b71a = (0, $425e0f9c169ee798$export$2323046b9414659f)($3cc5df047cc4dd51$var$_globalHandlersIntegration);
function $3cc5df047cc4dd51$var$_installGlobalOnErrorHandler(client) {
    (0, $9d033d1e0336d65c$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3cc5df047cc4dd51$var$getOptions();
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client || (0, $25b8da85f1f3a684$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $3cc5df047cc4dd51$var$_enhanceEventWithInitialFrame((0, $232ad06e7df30921$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $bb3616fd55b6cdc0$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onerror'
            }
        });
    });
}
function $3cc5df047cc4dd51$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $2c547f3d9d7242c6$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3cc5df047cc4dd51$var$getOptions();
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client || (0, $25b8da85f1f3a684$export$b79738ab10c590b2)()) return;
        const error = $3cc5df047cc4dd51$var$_getUnhandledRejectionError(e);
        const event = (0, $85e272e760900bb9$export$c3825b437cbdea5c)(error) ? $3cc5df047cc4dd51$var$_eventFromRejectionWithPrimitive(error) : (0, $232ad06e7df30921$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $bb3616fd55b6cdc0$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onunhandledrejection'
            }
        });
    });
}
function $3cc5df047cc4dd51$var$_getUnhandledRejectionError(error) {
    if ((0, $85e272e760900bb9$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch (e) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $3cc5df047cc4dd51$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $3cc5df047cc4dd51$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    var _getFilenameFromUrl;
    const filename = (_getFilenameFromUrl = $3cc5df047cc4dd51$var$getFilenameFromUrl(url)) !== null && _getFilenameFromUrl !== void 0 ? _getFilenameFromUrl : (0, $0ff4a1c827ec052f$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $3cc5df047cc4dd51$var$globalHandlerLog(type) {
    (0, $0e18e4f00372f41d$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Global Handler attached: ${type}`);
}
function $3cc5df047cc4dd51$var$getOptions() {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $3cc5df047cc4dd51$var$getFilenameFromUrl(url) {
    if (!(0, $85e272e760900bb9$export$844ec244b1367d54)(url) || url.length === 0) return undefined;
    // stack frame urls can be data urls, for example when initializing a Worker with a base64 encoded script
    // in this case we just show the data prefix and mime type to avoid too long raw data urls
    if (url.startsWith('data:')) {
        const match = url.match(/^data:([^;]+)/);
        const mimeType = match ? match[1] : 'text/javascript';
        const isBase64 = url.includes('base64,');
        return `<data:${mimeType}${isBase64 ? ',base64' : ''}>`;
    }
    return url.slice(0, 1024);
}






/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $19bd0dd66bc2e0a8$export$1378794447170364 = (0, $425e0f9c169ee798$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            var _event_request;
            // if none of the information we want exists, don't bother
            if (!(0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).navigator && !(0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).location && !(0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $25b8da85f1f3a684$export$a3c4a8453e8936f0)();
            const headers = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, reqData.headers, (_event_request = event.request) === null || _event_request === void 0 ? void 0 : _event_request.headers);
            event.request = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, reqData, event.request), {
                headers: headers
            });
        }
    };
});





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $3b6f7235b5d38fbd$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    var _event_exception;
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) || !hint || !(0, $85e272e760900bb9$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $3b6f7235b5d38fbd$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $3b6f7235b5d38fbd$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $85e272e760900bb9$export$49034edbe6b62415)(error[key], Error)) {
        $3b6f7235b5d38fbd$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $3b6f7235b5d38fbd$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $3b6f7235b5d38fbd$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $85e272e760900bb9$export$49034edbe6b62415)(childError, Error)) {
            $3b6f7235b5d38fbd$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $3b6f7235b5d38fbd$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $3b6f7235b5d38fbd$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $3b6f7235b5d38fbd$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, exception.mechanism, exception.type === 'AggregateError' && {
        is_exception_group: true
    }), {
        exception_id: exceptionId
    });
}
function $3b6f7235b5d38fbd$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, exception.mechanism), {
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}



const $9f0f82d37cced613$var$DEFAULT_KEY = 'cause';
const $9f0f82d37cced613$var$DEFAULT_LIMIT = 5;
const $9f0f82d37cced613$var$INTEGRATION_NAME = 'LinkedErrors';
const $9f0f82d37cced613$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $9f0f82d37cced613$var$DEFAULT_LIMIT;
    const key = options.key || $9f0f82d37cced613$var$DEFAULT_KEY;
    return {
        name: $9f0f82d37cced613$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $3b6f7235b5d38fbd$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $232ad06e7df30921$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $9f0f82d37cced613$export$ebabb00eb7f3a395 = (0, $425e0f9c169ee798$export$2323046b9414659f)($9f0f82d37cced613$var$_linkedErrorsIntegration);



const $71a27512b0444216$var$OPERA10_PRIORITY = 10;
const $71a27512b0444216$var$OPERA11_PRIORITY = 20;
const $71a27512b0444216$var$CHROME_PRIORITY = 30;
const $71a27512b0444216$var$WINJS_PRIORITY = 40;
const $71a27512b0444216$var$GECKO_PRIORITY = 50;
function $71a27512b0444216$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $71a27512b0444216$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $71a27512b0444216$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $71a27512b0444216$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Matches stack frames with data URIs instead of filename so we can still get the function name
// Example: "at dynamicFn (data:application/javascript,export function dynamicFn() {..."
const $71a27512b0444216$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $71a27512b0444216$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($71a27512b0444216$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $71a27512b0444216$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $71a27512b0444216$var$createFrame(filename, (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $71a27512b0444216$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $71a27512b0444216$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $71a27512b0444216$var$extractSafariExtensionDetails(parts[1] || (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac), parts[2]);
        return $71a27512b0444216$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $71a27512b0444216$export$263a749fff749872 = [
    $71a27512b0444216$var$CHROME_PRIORITY,
    $71a27512b0444216$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $71a27512b0444216$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $71a27512b0444216$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $71a27512b0444216$var$gecko = (line)=>{
    const parts = $71a27512b0444216$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $71a27512b0444216$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac);
        [func, filename] = $71a27512b0444216$var$extractSafariExtensionDetails(func, filename);
        return $71a27512b0444216$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $71a27512b0444216$export$cdba47a5dd2804d = [
    $71a27512b0444216$var$GECKO_PRIORITY,
    $71a27512b0444216$var$gecko
];
const $71a27512b0444216$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $71a27512b0444216$var$winjs = (line)=>{
    const parts = $71a27512b0444216$var$winjsRegex.exec(line);
    return parts ? $71a27512b0444216$var$createFrame(parts[2], parts[1] || (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $71a27512b0444216$export$179460296da408e8 = [
    $71a27512b0444216$var$WINJS_PRIORITY,
    $71a27512b0444216$var$winjs
];
const $71a27512b0444216$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $71a27512b0444216$var$opera10 = (line)=>{
    const parts = $71a27512b0444216$var$opera10Regex.exec(line);
    return parts ? $71a27512b0444216$var$createFrame(parts[2], parts[3] || (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $71a27512b0444216$export$f892b52c880ffc7a = [
    $71a27512b0444216$var$OPERA10_PRIORITY,
    $71a27512b0444216$var$opera10
];
const $71a27512b0444216$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $71a27512b0444216$var$opera11 = (line)=>{
    const parts = $71a27512b0444216$var$opera11Regex.exec(line);
    return parts ? $71a27512b0444216$var$createFrame(parts[5], parts[3] || parts[4] || (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $71a27512b0444216$export$af11af13f09fb0dc = [
    $71a27512b0444216$var$OPERA11_PRIORITY,
    $71a27512b0444216$var$opera11
];
const $71a27512b0444216$export$7197c0fe6554c079 = [
    $71a27512b0444216$export$263a749fff749872,
    $71a27512b0444216$export$cdba47a5dd2804d
];
const $71a27512b0444216$export$2b2b997d81bf3907 = (0, $a6df8b9dd4ca405a$export$a5739666fb2d03d4)(...$71a27512b0444216$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $71a27512b0444216$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};







const $37fe8c4357879c39$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $37fe8c4357879c39$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $29c1921438eb1933$export$78e43115b553f358)($37fe8c4357879c39$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $29c1921438eb1933$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $29c1921438eb1933$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const $b20b411e20ea6eb5$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $b20b411e20ea6eb5$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $b20b411e20ea6eb5$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $b20b411e20ea6eb5$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $b20b411e20ea6eb5$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $b20b411e20ea6eb5$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $b20b411e20ea6eb5$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers === null || headers === void 0 ? void 0 : headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers === null || headers === void 0 ? void 0 : headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $b20b411e20ea6eb5$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $fd4b80e45f21271b$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $fd4b80e45f21271b$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $37fe8c4357879c39$export$85a4f67f852183e6)(options.bufferSize || $fd4b80e45f21271b$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $5e31f551d021d379$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $5e31f551d021d379$export$b11169581eeaf237)(type);
            if ((0, $b20b411e20ea6eb5$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $29c1921438eb1933$export$1fda8aa4d135f8aa)({});
        const filteredEnvelope = (0, $5e31f551d021d379$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $5e31f551d021d379$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $5e31f551d021d379$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $5e31f551d021d379$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $b20b411e20ea6eb5$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $37fe8c4357879c39$export$c8667f1887a128dc)) {
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $29c1921438eb1933$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}





/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $73e5242b9d890bbe$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $73e5242b9d890bbe$export$e464f4a514ac28a8(name) {
    const cached = $73e5242b9d890bbe$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $ed8e12a1b26c7e3d$export$d5f608b368e73f38)(impl)) return $73e5242b9d890bbe$var$cachedImplementations[name] = impl.bind((0, $7d1289196f39c6a9$export$56d8a8a25bd48b81));
    const document = (0, $7d1289196f39c6a9$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow === null || contentWindow === void 0 ? void 0 : contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $dc183d0716dee61a$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $73e5242b9d890bbe$var$cachedImplementations[name] = impl.bind((0, $7d1289196f39c6a9$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $73e5242b9d890bbe$export$8aa36702e8c8978(name) {
    $73e5242b9d890bbe$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $73e5242b9d890bbe$export$e7aa7bc5c1b3cfb3(...rest) {
    return $73e5242b9d890bbe$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $73e5242b9d890bbe$export$831dc9f2ab0a617b(...rest) {
    return $73e5242b9d890bbe$export$e464f4a514ac28a8('setTimeout')(...rest);
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $9d566d0fa5f35ce3$export$b2311068c46d7cc8(options, nativeFetch = (0, $73e5242b9d890bbe$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15
        }, options.fetchOptions);
        if (!nativeFetch) {
            (0, $73e5242b9d890bbe$export$8aa36702e8c8978)('fetch');
            return (0, $29c1921438eb1933$export$78e43115b553f358)('No fetch implementation available');
        }
        try {
            // Note: We do not need to suppress tracing here, becasue we are using the native fetch, instead of our wrapped one.
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $73e5242b9d890bbe$export$8aa36702e8c8978)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $29c1921438eb1933$export$78e43115b553f358)(e);
        }
    }
    return (0, $fd4b80e45f21271b$export$d09f50d9ab7f7b69)(options, makeRequest);
}





/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $50490acbe852f5bc$export$dc236a86065879fc() {
    if ($50490acbe852f5bc$var$_isEmbeddedBrowserExtension()) {
        if (0, $0e18e4f00372f41d$export$16a28057038b10ef) (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $50490acbe852f5bc$var$_isEmbeddedBrowserExtension() {
    var _extensionObject_runtime;
    if (typeof (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!(extensionObject === null || extensionObject === void 0 ? void 0 : (_extensionObject_runtime = extensionObject.runtime) === null || _extensionObject_runtime === void 0 ? void 0 : _extensionObject_runtime.id)) return false;
    const href = (0, $0ff4a1c827ec052f$export$1cfafeee2987818b)();
    const extensionProtocols = [
        'chrome-extension',
        'moz-extension',
        'ms-browser-extension',
        'safari-web-extension'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81) === (0, $25b8da85f1f3a684$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}://`));
    return !isDedicatedExtensionPage;
}


/** Get the default integrations for the browser SDK. */ function $c8336408d1a05d1b$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $cc458e21b964fdb2$export$cb3c5c2ceb9818ba)(),
        (0, $af5076b22b0f565c$export$7918117e9202e4fb)(),
        (0, $471b9c9f09863ac2$export$59bfe9f1c76150e)(),
        (0, $5d5ee1de09f6864e$export$c079d904b326663a)(),
        (0, $3cc5df047cc4dd51$export$66acc70e8cf2b71a)(),
        (0, $9f0f82d37cced613$export$ebabb00eb7f3a395)(),
        (0, $ba9fe14e35164f86$export$6d39aa44cd0c7567)(),
        (0, $19bd0dd66bc2e0a8$export$1378794447170364)(),
        (0, $450f2f09c71b9ef4$export$1baa7880e357371c)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $c8336408d1a05d1b$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $50490acbe852f5bc$export$dc236a86065879fc)();
    const clientOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $a6df8b9dd4ca405a$export$1d5cf88b347146d4)(options.stackParser || (0, $71a27512b0444216$export$2b2b997d81bf3907)),
        integrations: (0, $425e0f9c169ee798$export$68bc4c01ab8ae766)({
            integrations: options.integrations,
            defaultIntegrations: options.defaultIntegrations == null ? $c8336408d1a05d1b$export$5783b2920b1d62b9() : options.defaultIntegrations
        }),
        transport: options.transport || (0, $9d566d0fa5f35ce3$export$b2311068c46d7cc8)
    });
    return (0, $5adaab7f928cd880$export$5333c3f1c58d9bc1)((0, $513bb5325d521226$export$1df9218a526d318d), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $c8336408d1a05d1b$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $c8336408d1a05d1b$export$4e4d8b287d028b6b(callback) {
    callback();
}




var $7fPBF = parcelRequire("7fPBF");
/**
 * Inits the React SDK
 */ function $df844ac72233cdc3$export$2cd8252107eb640b(options) {
    const opts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options);
    (0, $1ca02136df3c52aa$export$b9f95b027256052c)(opts, 'react');
    (0, $bb3616fd55b6cdc0$export$2f04de43fe27971a)('react', {
        version: $7fPBF.version
    });
    return (0, $c8336408d1a05d1b$export$2cd8252107eb640b)(opts);
}





parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $7fPBF = parcelRequire("7fPBF");

var $b570be4f7973e5d0$var$buttonGroupStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'inline-flex',
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> *': {
        flex: '1 0 auto'
    }
});
function $b570be4f7973e5d0$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, testId = _ref.testId, label = _ref.label, titleId = _ref.titleId;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        css: $b570be4f7973e5d0$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $7fPBF.Fragment), {
            key: idx
        }, child);
    }));
}



/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cvBp9 = parcelRequire("cvBp9");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $9fd322d8762e074f$var$ATOMIC_GROUP_LENGTH = 5;
function $9fd322d8762e074f$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $9fd322d8762e074f$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $7fPBF = parcelRequire("7fPBF");
var $6424294a5ce7a4c7$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $6424294a5ce7a4c7$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($6424294a5ce7a4c7$export$1ca2a26fecb070ae);
};
$6424294a5ce7a4c7$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $d89fd2308dabe801$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $d89fd2308dabe801$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $d89fd2308dabe801$var$baseStyles = null;
var $d89fd2308dabe801$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $d89fd2308dabe801$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $d89fd2308dabe801$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
var $d89fd2308dabe801$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $d89fd2308dabe801$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $d89fd2308dabe801$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $d89fd2308dabe801$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $d89fd2308dabe801$var$Box = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $d89fd2308dabe801$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $d89fd2308dabe801$var$_excluded2);
    var node = /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({
        style: style,
        ref: ref,
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $d89fd2308dabe801$var$backgroundColorMap[backgroundColor],
            backgroundColor && $d89fd2308dabe801$var$isSurfaceToken(backgroundColor) && $d89fd2308dabe801$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $d89fd2308dabe801$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $d89fd2308dabe801$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $d89fd2308dabe801$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $d89fd2308dabe801$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $7fPBF.createElement((0, $6424294a5ce7a4c7$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $d89fd2308dabe801$export$2e2bcd8739ae039 = $d89fd2308dabe801$var$Box;
function $d89fd2308dabe801$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $d89fd2308dabe801$var$setSurfaceTokenMap;
}

/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
var $5f872c67e71f8803$var$HasTextAncestorContext = /*#__PURE__*/ (0, $7fPBF.createContext)(false);
var $5f872c67e71f8803$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $7fPBF.useContext)($5f872c67e71f8803$var$HasTextAncestorContext);
};
var $5f872c67e71f8803$export$ae933c6cbe5643ad = $5f872c67e71f8803$var$HasTextAncestorContext.Provider;



var $c5c9cd1c8226b7c0$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $c5c9cd1c8226b7c0$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $6424294a5ce7a4c7$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($c5c9cd1c8226b7c0$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $c5c9cd1c8226b7c0$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $c5c9cd1c8226b7c0$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pmoej",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $c5c9cd1c8226b7c0$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $c5c9cd1c8226b7c0$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $c5c9cd1c8226b7c0$var$textColorMap = {
    'color.text': "_syaz1fxt",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syaz1q28",
    'color.text.accent.orange.bolder': "_syaz1vps",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syazpnps",
    'color.text.accent.blue.bolder': "_syazsc1o",
    'color.text.accent.purple': "_syaz10m5",
    'color.text.accent.purple.bolder': "_syaz2ibx",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1dyx",
    'color.text.accent.gray.bolder': "_syaz1x9z",
    'color.text.disabled': "_syaz1lh4",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syazaqb7",
    'color.text.brand': "_syaz1e6v",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syazwx40",
    'color.text.warning.inverse': "_syazal3n",
    'color.text.success': "_syazy73q",
    'color.text.discovery': "_syazzjem",
    'color.text.information': "_syaze0os",
    'color.text.subtlest': "_syaz131l",
    'color.text.subtle': "_syaz1gjq",
    'color.link': "_syaz14q2",
    'color.link.pressed': "_syaz16c2",
    'color.link.visited': "_syazw7te",
    'color.link.visited.pressed': "_syazg3x0"
};
var $c5c9cd1c8226b7c0$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $c5c9cd1c8226b7c0$var$Text = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)($c5c9cd1c8226b7c0$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $5f872c67e71f8803$export$9322276ec105d055)();
    var color = $c5c9cd1c8226b7c0$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $7fPBF.createElement(Component, {
        id: id,
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            $c5c9cd1c8226b7c0$var$styles.root,
            size && $c5c9cd1c8226b7c0$var$fontSizeMap[size],
            color && $c5c9cd1c8226b7c0$var$textColorMap[color],
            maxLines && $c5c9cd1c8226b7c0$var$styles.truncation,
            maxLines === 1 && $c5c9cd1c8226b7c0$var$styles.breakAll,
            align && $c5c9cd1c8226b7c0$var$styles["textAlign.".concat(align)],
            weight && $c5c9cd1c8226b7c0$var$fontWeightMap[weight],
            Component === 'em' && $c5c9cd1c8226b7c0$var$styles['as.em'],
            Component === 'strong' && $c5c9cd1c8226b7c0$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $7fPBF.createElement((0, $5f872c67e71f8803$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $c5c9cd1c8226b7c0$export$2e2bcd8739ae039 = $c5c9cd1c8226b7c0$var$Text;


/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $7fPBF = parcelRequire("7fPBF");


var $ea7cfe19d2765de9$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $d31d35ca40a2d1d8$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $d7df1392c2cb1415$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $d7df1392c2cb1415$export$29a4f05edc054374), ")");
}
var $d31d35ca40a2d1d8$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $d31d35ca40a2d1d8$var$loadIn = null;
var $d31d35ca40a2d1d8$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $d31d35ca40a2d1d8$var$useLayoutEffect = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $d31d35ca40a2d1d8$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $ea7cfe19d2765de9$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $d31d35ca40a2d1d8$var$getStrokeColor(appearance);
    var context = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    $d31d35ca40a2d1d8$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            $d31d35ca40a2d1d8$var$styles.wrapperStyles,
            $d31d35ca40a2d1d8$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            $d31d35ca40a2d1d8$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            $d31d35ca40a2d1d8$var$styles.circleStyles
        ])
    })));
}));
var $d31d35ca40a2d1d8$export$2e2bcd8739ae039 = $d31d35ca40a2d1d8$var$Spinner;


/* actions-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $a058909fb1289e14$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ var $a058909fb1289e14$var$ActionsContainer = function ActionsContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ])
    }, children);
};
var $a058909fb1289e14$export$2e2bcd8739ae039 = $a058909fb1289e14$var$ActionsContainer;

/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $b1141898838d800e$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ var $b1141898838d800e$var$wideContainerStyles = null;
var $b1141898838d800e$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ var $b1141898838d800e$var$Container = function Container(_ref) {
    var children = _ref.children, width = _ref.width, testId = _ref.testId;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        "data-testid": testId,
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ])
    }, children);
};
var $b1141898838d800e$export$2e2bcd8739ae039 = $b1141898838d800e$var$Container;

/* image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $21f7ae35321213df$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}


function $efa4825531c33c20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $efa4825531c33c20$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $efa4825531c33c20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $efa4825531c33c20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $efa4825531c33c20$var$CSS_VAR_MAX_WIDTH = '--max-width';
var $efa4825531c33c20$var$CSS_VAR_MAX_HEIGHT = '--max-height';
var $efa4825531c33c20$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ var $efa4825531c33c20$var$Image = function Image(_ref) {
    var maxHeight = _ref.maxHeight, maxWidth = _ref.maxWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? 'auto' : _ref$height, _ref$width = _ref.width, width = _ref$width === void 0 ? 'auto' : _ref$width, src = _ref.src;
    return /*#__PURE__*/ $7fPBF.createElement("img", {
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            "_1e0c1ule _p12f163m _c71l649k _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ]),
        style: $efa4825531c33c20$var$_objectSpread($efa4825531c33c20$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $efa4825531c33c20$var$CSS_VAR_MAX_WIDTH, "".concat(maxWidth, "px")), $efa4825531c33c20$var$CSS_VAR_MAX_HEIGHT, "".concat(maxHeight, "px"))), {}, {
            "--_11x3y0": (0, $21f7ae35321213df$export$2e2bcd8739ae039)("var(".concat($efa4825531c33c20$var$CSS_VAR_MAX_WIDTH, ")")),
            "--_zsxb2b": (0, $21f7ae35321213df$export$2e2bcd8739ae039)("var(".concat($efa4825531c33c20$var$CSS_VAR_MAX_HEIGHT, ")"))
        })
    });
};
var $efa4825531c33c20$export$2e2bcd8739ae039 = $efa4825531c33c20$var$Image;

/* spinner-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $a4729c54663a3829$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ var $a4729c54663a3829$var$SpinnerContainer = function SpinnerContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            "_1bsb1ejb _ahbqpxbi"
        ])
    }, children);
};
var $a4729c54663a3829$export$2e2bcd8739ae039 = $a4729c54663a3829$var$SpinnerContainer;


/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ var $6f1c722987558d89$var$EmptyState = function EmptyState(_ref) {
    var buttonGroupLabel = _ref.buttonGroupLabel, description = _ref.description, header = _ref.header, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 4 : _ref$headingLevel, _ref$headingSize = _ref.headingSize, headingSize = _ref$headingSize === void 0 ? 'medium' : _ref$headingSize, imageHeight = _ref.imageHeight, imageUrl = _ref.imageUrl, imageWidth = _ref.imageWidth, isLoading = _ref.isLoading, _ref$maxImageHeight = _ref.maxImageHeight, maxImageHeight = _ref$maxImageHeight === void 0 ? 160 : _ref$maxImageHeight, _ref$maxImageWidth = _ref.maxImageWidth, maxImageWidth = _ref$maxImageWidth === void 0 ? 160 : _ref$maxImageWidth, primaryAction = _ref.primaryAction, renderImage = _ref.renderImage, secondaryAction = _ref.secondaryAction, width = _ref.width, tertiaryAction = _ref.tertiaryAction, testId = _ref.testId;
    var actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a058909fb1289e14$export$2e2bcd8739ae039), null, primaryAction && secondaryAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b570be4f7973e5d0$export$2e2bcd8739ae039), {
        label: buttonGroupLabel || 'Button group',
        testId: testId && "".concat(testId, "-button-group")
    }, secondaryAction, primaryAction) : primaryAction || secondaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a4729c54663a3829$export$2e2bcd8739ae039), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d31d35ca40a2d1d8$export$2e2bcd8739ae039), {
        testId: "empty-state-spinner"
    }))) : null;
    var tag = "h".concat(headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b1141898838d800e$export$2e2bcd8739ae039), {
        testId: testId,
        width: width || 'wide'
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $efa4825531c33c20$export$2e2bcd8739ae039), {
        src: imageUrl,
        maxWidth: maxImageWidth,
        maxHeight: maxImageHeight,
        width: imageWidth,
        height: imageHeight
    }) : renderImage && renderImage({
        maxImageWidth: maxImageWidth,
        maxImageHeight: maxImageHeight,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d89fd2308dabe801$export$2e2bcd8739ae039), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $efe9521807dea491$export$2e2bcd8739ae039), {
        size: headingSize,
        as: tag
    }, header)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d89fd2308dabe801$export$2e2bcd8739ae039), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c5c9cd1c8226b7c0$export$2e2bcd8739ae039), {
        as: "p"
    }, description)), actionsContainer, tertiaryAction);
};
var $6f1c722987558d89$export$2e2bcd8739ae039 = $6f1c722987558d89$var$EmptyState;




function $20fa494c41263167$export$f7170715618fd2f9(props) {
    const featureFlags = (0, $d377413f5e2ec9d9$export$90335b3ff08f335)();
    if (featureFlags['pc-frontend-down-for-maintenance']) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6f1c722987558d89$export$2e2bcd8739ae039), {
        renderImage: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $139978517f0651d4$export$fe8dceec803a025), {}),
        header: "Down For Maintenance",
        description: "Preferences Center is currently down for maintenance. Please try again in a few minutes."
    });
    else return props.children;
}








var $7fPBF = parcelRequire("7fPBF");


var $1uJLd = parcelRequire("1uJLd");

var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $iQsIh = parcelRequire("iQsIh");

var $7fPBF = parcelRequire("7fPBF");


var $1uJLd = parcelRequire("1uJLd");

var $iQsIh = parcelRequire("iQsIh");

var $137Lh = parcelRequire("137Lh");

var $5hU4u = parcelRequire("5hU4u");

var $jOXxA = parcelRequire("jOXxA");

var $iKdEz = parcelRequire("iKdEz");

var $137Lh = parcelRequire("137Lh");

var $8MJe2 = parcelRequire("8MJe2");

var $137Lh = parcelRequire("137Lh");

var $8lLl9 = parcelRequire("8lLl9");

var $5hU4u = parcelRequire("5hU4u");


var $jOXxA = parcelRequire("jOXxA");

var $aKhos = parcelRequire("aKhos");
function $0946477f89db2672$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0946477f89db2672$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0946477f89db2672$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0946477f89db2672$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0946477f89db2672$var$defaultColorMode = 'light';
var $0946477f89db2672$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $0946477f89db2672$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $5hU4u.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $5hU4u.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $5hU4u.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $5hU4u.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $5hU4u.themeStateDefaults)['shape'] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $5hU4u.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $5hU4u.themeStateDefaults)['typography']() : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $5hU4u.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $fda0d3ce6cabfedf$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $8lLl9.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $8lLl9.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $0946477f89db2672$var$defaultColorMode : colorMode);
    if ((0, $137Lh.fg)('platform_increased-contrast-themes')) result = $0946477f89db2672$var$_objectSpread($0946477f89db2672$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $8lLl9.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $0946477f89db2672$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $jOXxA.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $aKhos.hash)(optionString);
        result[0, $8lLl9.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $0946477f89db2672$export$2e2bcd8739ae039 = $0946477f89db2672$var$getThemeHtmlAttrs;



var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");


var $8lLl9 = parcelRequire("8lLl9");

var $1uJLd = parcelRequire("1uJLd");

var $iQsIh = parcelRequire("iQsIh");

var $137Lh = parcelRequire("137Lh");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::4131829e60733a1a5e513dcc84af81de>>
 * @codegenCommand yarn build tokens
 */ 















var $fe7ae66a01d1078f$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("bz8Ps"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("eGQ21"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("gU9qf"));
    },
    'dark': function dark() {
        return (parcelRequire("tYGmt"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("5odVw"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("lEc7H"));
    },
    'legacy-light': function legacyLight() {
        return (parcelRequire("7jEDe"));
    },
    'legacy-dark': function legacyDark() {
        return (parcelRequire("iwfb1"));
    },
    'spacing': function spacing() {
        return (parcelRequire("l25Vt"));
    },
    'typography': function typography() {
        return (parcelRequire("5pkn0"));
    },
    'typography-adg3': function typographyAdg3() {
        return (parcelRequire("a0cHd"));
    },
    'shape': function shape() {
        return (parcelRequire("cxyww"));
    },
    'typography-modernized': function typographyModernized() {
        return (parcelRequire("3QI2a"));
    },
    'typography-refreshed': function typographyRefreshed() {
        return (parcelRequire("OArPy"));
    },
    'light-brand-refresh': function lightBrandRefresh() {
        return (parcelRequire("5qswd"));
    },
    'dark-brand-refresh': function darkBrandRefresh() {
        return (parcelRequire("6ELYd"));
    }
};
var $fe7ae66a01d1078f$export$2e2bcd8739ae039 = $fe7ae66a01d1078f$var$themeImportsMap;



var $8lLl9 = parcelRequire("8lLl9");
var $0ccb751562b9e12b$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $8lLl9.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $8lLl9.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $0ccb751562b9e12b$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $0ccb751562b9e12b$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((themeId === 'light' || themeId === 'dark') && (0, $137Lh.fg)('platform-component-visual-refresh')) themeId += '-brand-refresh';
                    _context2.next = 3;
                    return (0, $fe7ae66a01d1078f$export$2e2bcd8739ae039)[themeId]();
                case 3:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $0ccb751562b9e12b$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $0ccb751562b9e12b$export$8662df6937d86fcb = '(prefers-contrast: more)';


var $ea7d3cf8cd8044d4$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $ea7d3cf8cd8044d4$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $8lLl9.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $ea7d3cf8cd8044d4$var$darkModeMql = $ea7d3cf8cd8044d4$var$isMatchMediaAvailable && window.matchMedia((0, $0ccb751562b9e12b$export$bb1e815119d30f8b));
var $ea7d3cf8cd8044d4$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$ea7d3cf8cd8044d4$var$darkModeMql) return 'light';
                return $ea7d3cf8cd8044d4$var$darkModeMql !== null && $ea7d3cf8cd8044d4$var$darkModeMql !== void 0 && $ea7d3cf8cd8044d4$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($ea7d3cf8cd8044d4$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $a091c25729a976b1$exports.bind)($ea7d3cf8cd8044d4$var$darkModeMql, {
                    type: 'change',
                    listener: $ea7d3cf8cd8044d4$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $ea7d3cf8cd8044d4$var$SingletonColorModeObserver = new $ea7d3cf8cd8044d4$var$ColorModeObserver();
var $ea7d3cf8cd8044d4$export$2e2bcd8739ae039 = $ea7d3cf8cd8044d4$var$SingletonColorModeObserver;



var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");


var $8lLl9 = parcelRequire("8lLl9");

var $024947183d41b922$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $024947183d41b922$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $8lLl9.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $024947183d41b922$var$contrastModeMql = $024947183d41b922$var$isMatchMediaAvailable && window.matchMedia((0, $0ccb751562b9e12b$export$8662df6937d86fcb));
var $024947183d41b922$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$024947183d41b922$var$contrastModeMql) return 'no-preference';
                return $024947183d41b922$var$contrastModeMql !== null && $024947183d41b922$var$contrastModeMql !== void 0 && $024947183d41b922$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($024947183d41b922$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $a091c25729a976b1$exports.bind)($024947183d41b922$var$contrastModeMql, {
                    type: 'change',
                    listener: $024947183d41b922$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $024947183d41b922$var$SingletonContrastModeObserver = new $024947183d41b922$var$ContrastModeObserver();
var $024947183d41b922$export$2e2bcd8739ae039 = $024947183d41b922$var$SingletonContrastModeObserver;


function $383e197ef5124f58$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $ea7d3cf8cd8044d4$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $ea7d3cf8cd8044d4$export$2e2bcd8739ae039).bind();
    } else (0, $ea7d3cf8cd8044d4$export$2e2bcd8739ae039).unbind();
    if ((0, $137Lh.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $024947183d41b922$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $024947183d41b922$export$2e2bcd8739ae039).bind();
        } else (0, $024947183d41b922$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $0946477f89db2672$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $ea7d3cf8cd8044d4$export$2e2bcd8739ae039).unbind();
        if ((0, $137Lh.fg)('platform_increased-contrast-themes')) (0, $024947183d41b922$export$2e2bcd8739ae039).unbind();
    };
}



var $kkUFX = parcelRequire("kkUFX");

var $j9spr = parcelRequire("j9spr");

var $137Lh = parcelRequire("137Lh");

var $iKdEz = parcelRequire("iKdEz");

var $5hU4u = parcelRequire("5hU4u");
function $47cf3bce0b40e6a5$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $5hU4u.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $8750517eb0ffd190$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $137Lh.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $47cf3bce0b40e6a5$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $137Lh.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $47cf3bce0b40e6a5$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(new Set(themePreferences));
};
var $8750517eb0ffd190$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(new Set(themeOverridePreferences));
};



function $def7573dfbb35534$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $def7573dfbb35534$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $def7573dfbb35534$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $def7573dfbb35534$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $def7573dfbb35534$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $def7573dfbb35534$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $def7573dfbb35534$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee3() {
        var _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeLoader, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _ref2 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $5hU4u.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $5hU4u.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $5hU4u.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $5hU4u.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $5hU4u.themeStateDefaults)['shape'] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $5hU4u.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $5hU4u.themeStateDefaults)['typography']() : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $5hU4u.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt;
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $137Lh.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $8750517eb0ffd190$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $0ccb751562b9e12b$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $jOXxA.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $5hU4u.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $kkUFX.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("4EwZ6"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 10;
                    return Promise.all(loadingTasks);
                case 10:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $8750517eb0ffd190$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $def7573dfbb35534$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 12;
                    _iterator.s();
                case 14:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 20;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 18;
                    return loadingStrategy(themeId);
                case 18:
                    _context3.next = 14;
                    break;
                case 20:
                    _context3.next = 25;
                    break;
                case 22:
                    _context3.prev = 22;
                    _context3.t0 = _context3["catch"](12);
                    _iterator.e(_context3.t0);
                case 25:
                    _context3.prev = 25;
                    _iterator.f();
                    return _context3.finish(25);
                case 28:
                    autoUnbind = (0, $383e197ef5124f58$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 30:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                12,
                22,
                25,
                28
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $def7573dfbb35534$export$2e2bcd8739ae039 = $def7573dfbb35534$var$setGlobalTheme;


function $b97a8d3b72d6dceb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b97a8d3b72d6dceb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b97a8d3b72d6dceb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b97a8d3b72d6dceb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b97a8d3b72d6dceb$var$defaultThemeSettings = function defaultThemeSettings() {
    return {
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: 'typography'
    };
};
var $b97a8d3b72d6dceb$var$ColorModeContext = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $b97a8d3b72d6dceb$var$SetColorModeContext = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $b97a8d3b72d6dceb$var$ThemeContext = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $b97a8d3b72d6dceb$var$SetThemeContext = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
function $b97a8d3b72d6dceb$export$ce91654eb9fea460() {
    var value = (0, $7fPBF.useContext)($b97a8d3b72d6dceb$var$ColorModeContext);
    return value;
}
function $b97a8d3b72d6dceb$export$20f3076712c8dfa() {
    var value = (0, $7fPBF.useContext)($b97a8d3b72d6dceb$var$ColorModeContext);
    var _getGlobalTheme = (0, $71e88d22ec4172d1$export$2e2bcd8739ae039)(), colorMode = _getGlobalTheme.colorMode;
    var _useState = (0, $7fPBF.useState)(colorMode || 'light'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $1a1489ec931d4385$export$2e2bcd8739ae039)(function(theme) {
            setResolvedColorMode(theme.colorMode || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}
function $b97a8d3b72d6dceb$export$e2afe7397c3d11c7() {
    var value = (0, $7fPBF.useContext)($b97a8d3b72d6dceb$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $b97a8d3b72d6dceb$export$93d4e7f90805808f() {
    var theme = (0, $7fPBF.useContext)($b97a8d3b72d6dceb$var$ThemeContext);
    var _useState3 = (0, $7fPBF.useState)(theme || (0, $71e88d22ec4172d1$export$2e2bcd8739ae039)()), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), resolvedTheme = _useState4[0], setResolvedTheme = _useState4[1];
    (0, $7fPBF.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        var observer = new (0, $1a1489ec931d4385$export$2e2bcd8739ae039)(setResolvedTheme);
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        theme
    ]);
    return theme ? theme : resolvedTheme;
}
function $b97a8d3b72d6dceb$export$501aa0dcd5527a48() {
    var value = (0, $7fPBF.useContext)($b97a8d3b72d6dceb$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
var $b97a8d3b72d6dceb$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $b97a8d3b72d6dceb$var$prefersDarkModeMql = $b97a8d3b72d6dceb$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $b97a8d3b72d6dceb$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $b97a8d3b72d6dceb$var$prefersDarkModeMql !== null && $b97a8d3b72d6dceb$var$prefersDarkModeMql !== void 0 && $b97a8d3b72d6dceb$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 *
 * @internal
 */ function $b97a8d3b72d6dceb$var$ThemeProvider(_ref) {
    var children = _ref.children, defaultColorMode = _ref.defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState5 = (0, $7fPBF.useState)(defaultColorMode), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), chosenColorMode = _useState6[0], setChosenColorMode = _useState6[1];
    var _useState7 = (0, $7fPBF.useState)($b97a8d3b72d6dceb$var$getReconciledColorMode(defaultColorMode)), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState7, 2), reconciledColorMode = _useState8[0], setReconciledColorMode = _useState8[1];
    var _useState9 = (0, $7fPBF.useState)(function() {
        return $b97a8d3b72d6dceb$var$_objectSpread($b97a8d3b72d6dceb$var$_objectSpread({}, $b97a8d3b72d6dceb$var$defaultThemeSettings()), defaultTheme);
    }), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState9, 2), theme = _useState0[0], setTheme = _useState0[1];
    var setColorMode = (0, $7fPBF.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($b97a8d3b72d6dceb$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $7fPBF.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $b97a8d3b72d6dceb$var$_objectSpread($b97a8d3b72d6dceb$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(function() {
        /**
     * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
     * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
     * `data-color-mode` attribute on the root element).
     *
     * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
     * applying the new theme.
     *
     * Without this, we can end up in the following scenario:
     * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
     * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
     * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
     * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
     */ var cleanupLastFnCall = /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee() {
                var unbindFn;
                return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!lastSetGlobalThemePromiseRef.current) {
                                _context.next = 6;
                                break;
                            }
                            _context.next = 3;
                            return lastSetGlobalThemePromiseRef.current;
                        case 3:
                            unbindFn = _context.sent;
                            unbindFn();
                            lastSetGlobalThemePromiseRef.current = null;
                        case 6:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function cleanupLastFnCall() {
                return _ref2.apply(this, arguments);
            };
        }();
        var safelySetGlobalTheme = /*#__PURE__*/ function() {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2() {
                var promise;
                return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _context2.next = 2;
                            return cleanupLastFnCall();
                        case 2:
                            promise = (0, $def7573dfbb35534$export$2e2bcd8739ae039)($b97a8d3b72d6dceb$var$_objectSpread($b97a8d3b72d6dceb$var$_objectSpread({}, theme), {}, {
                                colorMode: reconciledColorMode
                            }));
                            lastSetGlobalThemePromiseRef.current = promise;
                        case 4:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function safelySetGlobalTheme() {
                return _ref3.apply(this, arguments);
            };
        }();
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (!$b97a8d3b72d6dceb$var$prefersDarkModeMql) return;
        var unbindListener = (0, $a091c25729a976b1$exports.bind)($b97a8d3b72d6dceb$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($b97a8d3b72d6dceb$var$ColorModeContext.Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($b97a8d3b72d6dceb$var$SetColorModeContext.Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($b97a8d3b72d6dceb$var$ThemeContext.Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($b97a8d3b72d6dceb$var$SetThemeContext.Provider, {
        value: setPartialTheme
    }, children))));
}
var $b97a8d3b72d6dceb$export$2e2bcd8739ae039 = $b97a8d3b72d6dceb$var$ThemeProvider;


var $f107ccf41cbc2985$var$InsideAppProviderContext = /*#__PURE__*/ (0, $7fPBF.createContext)(false);
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $f107ccf41cbc2985$var$AppProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'light' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme, routerLinkComponent = _ref.routerLinkComponent, UNSAFE_isThemingDisabled = _ref.UNSAFE_isThemingDisabled;
    var isInsideAppProvider = (0, $7fPBF.useContext)($f107ccf41cbc2985$var$InsideAppProviderContext);
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    var routerLinkProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a81a1e57cf0d6bff$export$2e2bcd8739ae039), {
        routerLinkComponent: routerLinkComponent
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($f107ccf41cbc2985$var$InsideAppProviderContext.Provider, {
        value: true
    }, UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b97a8d3b72d6dceb$export$2e2bcd8739ae039), {
        defaultColorMode: defaultColorMode,
        defaultTheme: defaultTheme
    }, routerLinkProvider));
}
var $f107ccf41cbc2985$export$2e2bcd8739ae039 = $f107ccf41cbc2985$var$AppProvider;


const $d7ff3ee147cb4273$var$BASE_URL = '/main';
const $d7ff3ee147cb4273$var$environment = (0, $35a545355f14a0c7$export$6bc7b24d4e862158)().name;
const $d7ff3ee147cb4273$var$release = "";
window.loadAnalyticsWrapper = (0, $275512fd46801a1e$export$d22535dc59b4c5d0);
const $d7ff3ee147cb4273$var$container = document.getElementById('com-atlassian-preferences-center');
const $d7ff3ee147cb4273$var$root = (0, $f11ec298ebcca059$export$882461b6382ed46c)($d7ff3ee147cb4273$var$container);
$d7ff3ee147cb4273$var$root.render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f107ccf41cbc2985$export$2e2bcd8739ae039), {
    defaultColorMode: 'light',
    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d377413f5e2ec9d9$export$ec0c43a58fca1a2), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f30b917334351296$export$2881499e37b75b9a), {
            store: (0, $b91bb6c1ec048c06$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54), {
                basename: $d7ff3ee147cb4273$var$BASE_URL,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $20fa494c41263167$export$f7170715618fd2f9), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6c559b868a542118$export$2e2bcd8739ae039), {})
                })
            })
        })
    })
}));
// Redirect to "/main" if navigating to "/"
if ($d7ff3ee147cb4273$var$BASE_URL !== '/' && window.location.pathname === '/') window.location.replace($d7ff3ee147cb4273$var$BASE_URL);
if ($d7ff3ee147cb4273$var$environment !== $c1e4a1336f2cb96e$export$2670cb7d5d4f7184) $df844ac72233cdc3$export$2cd8252107eb640b({
    dsn: 'https://76f2b7bbaa484ed582798df767d23325@o55978.ingest.sentry.io/4504554119102464',
    integrations: [
        $807ffb187a79a074$export$b4109253475213e9()
    ],
    tracesSampleRate: 1.0,
    environment: $d7ff3ee147cb4273$var$environment,
    release: $d7ff3ee147cb4273$var$release,
    ignoreErrors: [
        'Non-Error exception captured',
        'Non-Error promise rejection captured',
        'Network request failed',
        'NetworkError'
    ]
});


//# sourceMappingURL=react.2a5b546a.js.map
